import * as Types from '../types'
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  EsportSlug: { input: Types.EsportSlug; output: Types.EsportSlug; }
  JSON: { input: any; output: any; }
  ObjectID: { input: string; output: string; }
  UUID: { input: string; output: string; }
  Upload: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AcceptQueueInput = {
  placeId: Scalars['String']['input'];
};

export type AcceptQueueResponse = {
  __typename?: 'AcceptQueueResponse';
  placeId: Scalars['String']['output'];
};

export type AddChildToSchoolInput = {
  gradYear?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type AddGameAssistantSelectionOptionPayload = {
  __typename?: 'AddGameAssistantSelectionOptionPayload';
  selectionOption: Maybe<GameAssistantSelectionOption>;
  success: Scalars['Boolean']['output'];
};

export type AddLeagueBulkPayload = {
  __typename?: 'AddLeagueBulkPayload';
  league: Maybe<League>;
  leagueId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
  total: Maybe<Scalars['Int']['output']>;
};

export type AddPlayerToTeamOptions = {
  isSubstitute?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddSchoolVarsityAssociationInput = {
  firstEffectiveMetaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
  varsityAssociationSlug: Scalars['String']['input'];
};

export type AddSchoolsToVarsityAssociationInput = {
  schools: Array<AddSchoolVarsityAssociationInput>;
};

export type AddTeamToLeagueOptions = {
  ignoreSchoolLeagueGroups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddUserToChatInput = {
  chatId: Scalars['String']['input'];
  chatRole: ChatRole;
  userId: Scalars['UUID']['input'];
};

export type AddUserToChatPayload = {
  __typename?: 'AddUserToChatPayload';
  errors: Array<Maybe<Scalars['String']['output']>>;
  results: AddUserToChatResults;
  success: Scalars['Boolean']['output'];
};

export type AddUserToChatResults = {
  __typename?: 'AddUserToChatResults';
  chatId: Scalars['String']['output'];
  userId: Scalars['UUID']['output'];
};

export type AddUserToExistingMatchChatInput = {
  id: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
};

export type AddUserToExistingMatchChatPayload = {
  __typename?: 'AddUserToExistingMatchChatPayload';
  errors: Array<Maybe<Scalars['String']['output']>>;
  payload: Maybe<UserAddedToMatchChatMetadata>;
  success: Scalars['Boolean']['output'];
};

export type AddUserToSchoolInput = {
  roleNameToRequest: UserRoleName;
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  userPersonalEmail?: InputMaybe<Scalars['String']['input']>;
  userSchoolEmail?: InputMaybe<Scalars['String']['input']>;
};

export type AddUserToSchoolResult = {
  __typename?: 'AddUserToSchoolResult';
  school: Maybe<School>;
  schoolId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type AddedToBenchEvent = IRosterEvent & {
  __typename?: 'AddedToBenchEvent';
  player: Maybe<User>;
  playerId: Scalars['UUID']['output'];
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Scalars['UUID']['output'];
};

export type AddedToRosterEvent = IRosterEvent & {
  __typename?: 'AddedToRosterEvent';
  player: Maybe<User>;
  playerId: Scalars['UUID']['output'];
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Scalars['UUID']['output'];
};

export type AdminAllForfeitMatchInput = {
  forfeitReason?: InputMaybe<ForfeitReason>;
  losingTeamIds: Array<Scalars['UUID']['input']>;
  matchId: Scalars['UUID']['input'];
};

export type AdminForfeitGameInput = {
  gameId: Scalars['UUID']['input'];
  losingTeamId: Scalars['UUID']['input'];
  winningTeamId: Scalars['UUID']['input'];
};

export type AdminForfeitMatchInput = {
  forfeitDetail?: InputMaybe<Scalars['String']['input']>;
  forfeitReason?: InputMaybe<ForfeitReason>;
  forfeitedBy?: InputMaybe<Scalars['UUID']['input']>;
  losingTeamId: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
  winningTeamId: Scalars['UUID']['input'];
};

export enum AdminMatchRescheduleReason {
  CovidSchoolClosure = 'covidSchoolClosure',
  NotEnoughPlayers = 'notEnoughPlayers',
  Other = 'other',
  PlatformIssues = 'platformIssues',
  SchoolClosed = 'schoolClosed',
  TechIssues = 'techIssues'
}

export type AdminSaveGameResultInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  gameOrdinalNumber: Scalars['Int']['input'];
  incompleteReason?: InputMaybe<GameIncompleteReason>;
  isIncomplete: Scalars['Boolean']['input'];
  losingPlayerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  losingTeamId: Scalars['UUID']['input'];
  losingTeamScore?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['UUID']['input'];
  requestRosterChangeForNextGame?: InputMaybe<Scalars['Boolean']['input']>;
  requestedById: Scalars['UUID']['input'];
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
  seriesOrdinalNumber?: InputMaybe<Scalars['Int']['input']>;
  winningPlayerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  winningTeamId: Scalars['UUID']['input'];
  winningTeamScore?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminSubmitLeaderboardMatchGameResultsInput = {
  games: Array<LeaderboardMatchGameResultInput>;
  matchId: Scalars['UUID']['input'];
};

export type AdvisorDetail = {
  __typename?: 'AdvisorDetail';
  esportsExp: Maybe<Scalars['String']['output']>;
  facrole: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type AdvisorDetailInput = {
  esportsExp?: InputMaybe<Scalars['String']['input']>;
  facrole?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AllLeagueGroupsResult = {
  __typename?: 'AllLeagueGroupsResult';
  result: Maybe<Array<LeagueGroup>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type AllLeaguesResult = {
  __typename?: 'AllLeaguesResult';
  result: Maybe<Array<League>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type AllMatchesByPlayerIdInput = {
  isScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
  phaseType?: InputMaybe<PhaseType>;
  playerId: Scalars['UUID']['input'];
};

export type AllTeamsForLeagueResult = {
  __typename?: 'AllTeamsForLeagueResult';
  results: Maybe<Array<Team>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type AllottedSeasonPass = ISeasonPassProduct & {
  __typename?: 'AllottedSeasonPass';
  allotmentPerBundle: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  internalName: Maybe<Scalars['String']['output']>;
  isAdminOnly: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceUsd: Scalars['Float']['output'];
  seatCount: Maybe<Scalars['Int']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  type: ProductType;
};

export type AnnualPassInstance = {
  __typename?: 'AnnualPassInstance';
  id: Scalars['UUID']['output'];
  metaseason: Maybe<Metaseason>;
  metaseasonId: Scalars['UUID']['output'];
  product: Maybe<AnnualPassProduct>;
  productId: Maybe<Scalars['UUID']['output']>;
  productInstanceInfo: AnnualPassInstanceInfo;
  seasonPassBundles: Maybe<Array<SeasonPassBundle>>;
  seatCountOverride: Maybe<Scalars['Int']['output']>;
};

export type AnnualPassInstanceInfo = {
  __typename?: 'AnnualPassInstanceInfo';
  initialMetaseasonId: Scalars['UUID']['output'];
};

export type AnnualPassMigrationOptions = {
  discountNotesExternal?: InputMaybe<Scalars['String']['input']>;
  discountNotesInternal?: InputMaybe<Scalars['String']['input']>;
  discountReasonExternal?: InputMaybe<Scalars['String']['input']>;
  discountReasonInternal?: InputMaybe<Scalars['String']['input']>;
  priceUsd?: InputMaybe<Scalars['Int']['input']>;
};

export type AnnualPassPayload = {
  __typename?: 'AnnualPassPayload';
  annualPassInstance: Maybe<AnnualPassInstance>;
  annualPassInstanceId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type AnnualPassProduct = IProduct & {
  __typename?: 'AnnualPassProduct';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  internalName: Maybe<Scalars['String']['output']>;
  isAdminOnly: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceUsd: Scalars['Float']['output'];
  seasonPassesAllotted: Maybe<Array<AllottedSeasonPass>>;
  seatCount: Maybe<Scalars['Int']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  type: ProductType;
};

/** Annual Plan type. */
export enum AnnualPassType {
  PayPerSeat = 'payPerSeat',
  Unknown = 'unknown',
  Unlimited = 'unlimited'
}

export type ApplyForSchoolFacultyInput = {
  facultyIsCoaching: Scalars['Boolean']['input'];
  facultyPhone: Scalars['String']['input'];
  facultyRoleSurvey: Scalars['String']['input'];
};

export type ApplyForSchoolInput = {
  facultyInput?: InputMaybe<ApplyForSchoolFacultyInput>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  requestedRole: UserRoleName;
  schoolEmail: Scalars['String']['input'];
  schoolId: Scalars['UUID']['input'];
  studentInput?: InputMaybe<ApplyForSchoolStudentInput>;
  suggestedSchool?: InputMaybe<SuggestedSchoolInput>;
};

export type ApplyForSchoolResult = {
  __typename?: 'ApplyForSchoolResult';
  school: Maybe<School>;
  schoolId: Scalars['UUID']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type ApplyForSchoolStudentInput = {
  studentGradYear: Scalars['Int']['input'];
};

/** An asset uploaded to S3 */
export type Asset = {
  __typename?: 'Asset';
  bucket: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['UUID']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  fileType: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  signedUrl: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AssignMatchAssignmentInput = {
  assigneeId: Scalars['UUID']['input'];
  assignerId: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type AssignSeasonalPlayerAwardInput = {
  awardTypeId: Scalars['UUID']['input'];
  coachId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type AssignWeeklyPlayerAwardInput = {
  beginningOfWeekTime: Scalars['DateTime']['input'];
  userId: Scalars['UUID']['input'];
};

export type AssignedSeasonalPlayerAward = {
  __typename?: 'AssignedSeasonalPlayerAward';
  awardType: Maybe<SeasonalPlayerAwardType>;
  awardTypeId: Scalars['UUID']['output'];
  coachId: Scalars['UUID']['output'];
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  metaseasonId: Scalars['UUID']['output'];
  teamId: Scalars['UUID']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['UUID']['output'];
};

export type AssignedSeasonalPlayerAwardPayload = {
  __typename?: 'AssignedSeasonalPlayerAwardPayload';
  assignedSeasonalPlayerAward: Maybe<AssignedSeasonalPlayerAward>;
};

export type AssignedWeeklyPlayerAward = {
  __typename?: 'AssignedWeeklyPlayerAward';
  awardWeekOption: AwardWeekOption;
  beginningOfWeekTime: Scalars['DateTime']['output'];
  coachId: Scalars['UUID']['output'];
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  schoolId: Scalars['UUID']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['UUID']['output'];
};

export type AssignedWeeklyPlayerAwardPayload = {
  __typename?: 'AssignedWeeklyPlayerAwardPayload';
  assignedWeeklyPlayerAward: AssignedWeeklyPlayerAward;
};

export type AutoSeedInput = {
  sourcePhaseType: PhaseType;
};

export type AvailableSeasonalPlayerAwardTypesPayload = {
  __typename?: 'AvailableSeasonalPlayerAwardTypesPayload';
  availablePlayerAwardTypes: Array<Maybe<SeasonalPlayerAwardType>>;
};

export type AvailableSpectatorsPayload = {
  __typename?: 'AvailableSpectatorsPayload';
  spectators: Maybe<Array<User>>;
};

export type AvailableWeeklyAwardPlayersInput = {
  beginningOfWeekTime: Scalars['DateTime']['input'];
};

export type AvailableWeeklyAwardPlayersPayload = {
  __typename?: 'AvailableWeeklyAwardPlayersPayload';
  availablePlayers: Array<Maybe<User>>;
};

export type AvailableWeeklyAwardWeeksPayload = {
  __typename?: 'AvailableWeeklyAwardWeeksPayload';
  availableWeeks: Array<Maybe<AwardWeekOption>>;
};

export type AwardWeekOption = {
  __typename?: 'AwardWeekOption';
  assignedAwardId: Maybe<Scalars['UUID']['output']>;
  assignedUserId: Maybe<Scalars['UUID']['output']>;
  beginningOfWeekTime: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  player: Maybe<User>;
  startDate: Scalars['DateTime']['output'];
};

export type BackfillIndexInput = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  indexKey: SearchIndex;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BackfillMatchesInput = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BackfillPayload = {
  __typename?: 'BackfillPayload';
  jobId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BackfillSchoolEnrollmentPayload = {
  __typename?: 'BackfillSchoolEnrollmentPayload';
  ids: Array<Scalars['UUID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type BillingPeriodUsage = Node & {
  __typename?: 'BillingPeriodUsage';
  consumedAt: Scalars['DateTime']['output'];
  esport: Maybe<Esport>;
  esportId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  match: Maybe<Match>;
  matchId: Maybe<Scalars['String']['output']>;
  metaseason: Maybe<Metaseason>;
  metaseasonId: Scalars['String']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type BillingPeriodUsageEdge = Edge & {
  __typename?: 'BillingPeriodUsageEdge';
  cursor: Scalars['String']['output'];
  node: BillingPeriodUsage;
};

export type BillingPeriodUsagePayload = PaginatedResults & {
  __typename?: 'BillingPeriodUsagePayload';
  edges: Array<BillingPeriodUsageEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type BillingSummaryForDateRangePayload = {
  __typename?: 'BillingSummaryForDateRangePayload';
  passUsageByEsport: Maybe<Array<EsportPassUsage>>;
  summaryByPass: Maybe<Array<PassSummary>>;
  totalSeasonPassesBilled: Scalars['Int']['output'];
  totalSeasonPassesUsed: Scalars['Int']['output'];
};

export type BillingUser = {
  __typename?: 'BillingUser';
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  phoneExt: Maybe<Scalars['String']['output']>;
};

export type Bracket = {
  __typename?: 'Bracket';
  bracketMatches: Array<BracketMatch>;
  id: Scalars['UUID']['output'];
  phaseId: Scalars['UUID']['output'];
  /** @deprecated use bracketMatches instead */
  results: Array<Array<BracketMatch>>;
  type: BracketType;
};

export type BracketMatch = {
  __typename?: 'BracketMatch';
  bracketId: Scalars['UUID']['output'];
  bracketIndex: Scalars['String']['output'];
  bracketTeams: Array<BracketTeam>;
  id: Scalars['UUID']['output'];
  isAFinalsMatch: Scalars['Boolean']['output'];
  match: Maybe<Match>;
  matchCompleted: Scalars['Boolean']['output'];
  matchId: Maybe<Scalars['UUID']['output']>;
  nextBracketIndex: Maybe<Scalars['String']['output']>;
  ordinalNumber: Scalars['Int']['output'];
  roundNumber: Scalars['Int']['output'];
  roundType: BracketRoundType;
  slot: Maybe<Slot>;
  slotType: Maybe<BracketSlotType>;
};

export type BracketMatchTeam = {
  __typename?: 'BracketMatchTeam';
  avatarUrl: Maybe<Scalars['String']['output']>;
  captain: Maybe<User>;
  coaches: Maybe<Array<TeamCoach>>;
  competitionGroup: Maybe<CompetitionGroup>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Scalars['UUID']['output']>;
  createdByUser: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  deletedById: Maybe<Scalars['UUID']['output']>;
  esportId: Scalars['UUID']['output'];
  eventSeasonId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  isPlayerLed: Maybe<Scalars['Boolean']['output']>;
  isPrivateRoster: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  owners: Maybe<Array<User>>;
  rallySchool: Maybe<School>;
  result: Maybe<MatchResult>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  seed: Scalars['Int']['output'];
  slug: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  teamFormat: Maybe<Scalars['Int']['output']>;
  teamSlotId: Scalars['UUID']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type BracketMatchTeamAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

export enum BracketRoundType {
  Final = 'Final',
  GrandFinal = 'GrandFinal',
  LowerFinal = 'LowerFinal',
  SemiFinal = 'SemiFinal',
  StandardRound = 'StandardRound',
  UpperFinal = 'UpperFinal'
}

export enum BracketSlotType {
  Lower = 'lower',
  Upper = 'upper'
}

export type BracketTeam = {
  __typename?: 'BracketTeam';
  id: Scalars['UUID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  matchStatus: BracketTeamMatchStatus;
  schoolId: Maybe<Scalars['UUID']['output']>;
  seed: Maybe<Scalars['Int']['output']>;
  team: Maybe<Team>;
  teamId: Maybe<Scalars['UUID']['output']>;
};

export enum BracketTeamMatchStatus {
  Bye = 'bye',
  Loss = 'loss',
  Pending = 'pending',
  Tbd = 'tbd',
  Unknown = 'unknown',
  Win = 'win'
}

export enum BracketType {
  DoubleElimination = 'doubleElimination',
  SingleElimination = 'singleElimination'
}

export type BulkActionCount = {
  errorCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type BulkActionError = {
  __typename?: 'BulkActionError';
  message: Maybe<Scalars['String']['output']>;
  stack: Maybe<Scalars['String']['output']>;
};

export type BulkActionJobPayload = {
  __typename?: 'BulkActionJobPayload';
  jobId: Scalars['UUID']['output'];
  status: Maybe<Scalars['String']['output']>;
  statusReason: Maybe<Scalars['String']['output']>;
};

export enum BulkActionOption {
  AddCoachRoleToUser = 'addCoachRoleToUser',
  AddLeagueToLeagueGroup = 'addLeagueToLeagueGroup',
  AddLeaguesToSchools = 'addLeaguesToSchools',
  AddSchoolLeagueGroupExclusion = 'addSchoolLeagueGroupExclusion',
  AddSchoolToVarsityAssociation = 'addSchoolToVarsityAssociation',
  AddTeamToLeague = 'addTeamToLeague',
  AutoSeed = 'autoSeed',
  CancelMatch = 'cancelMatch',
  CancelSlot = 'cancelSlot',
  CreateLeague = 'createLeague',
  CreateLeagueGroup = 'createLeagueGroup',
  CreatePhase = 'createPhase',
  CreateSlot = 'createSlot',
  CreateVarsityAssociation = 'createVarsityAssociation',
  DeleteMatch = 'deleteMatch',
  DeleteSlot = 'deleteSlot',
  ManualSeed = 'manualSeed',
  MoveSchoolToLeague = 'moveSchoolToLeague',
  RedoSlot = 'redoSlot',
  RemoveCoachRoleFromUser = 'removeCoachRoleFromUser',
  RemoveLeagueFromLeagueGroup = 'removeLeagueFromLeagueGroup',
  RemoveLeaguesFromSchools = 'removeLeaguesFromSchools',
  RemoveSchoolFromVarsityAssociation = 'removeSchoolFromVarsityAssociation',
  RemoveSchoolLeagueGroupExclusion = 'removeSchoolLeagueGroupExclusion',
  RemoveTeamFromLeague = 'removeTeamFromLeague',
  RescheduleMatch = 'rescheduleMatch',
  RescheduleSlot = 'rescheduleSlot',
  ScheduleMatch = 'scheduleMatch',
  ScheduleScrimmage = 'scheduleScrimmage',
  ScheduleSlot = 'scheduleSlot',
  TransferTeamToSeason = 'transferTeamToSeason',
  UpdateLeague = 'updateLeague',
  UpdateLeagueGroup = 'updateLeagueGroup',
  UpdateMatch = 'updateMatch',
  UpdatePhase = 'updatePhase',
  UpdateSeason = 'updateSeason',
  UpdateSlot = 'updateSlot',
  UpdateVarsityAssociation = 'updateVarsityAssociation'
}

export type BulkEditSeasonInput = {
  autoSeedInput?: InputMaybe<AutoSeedInput>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  phases?: InputMaybe<Array<BulkSeasonPhaseScheduleInput>>;
  playerDeregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  playerRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  playvsScoreEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  rostersLockAt?: InputMaybe<Scalars['DateTime']['input']>;
  seasonIds: Array<Scalars['UUID']['input']>;
  slotExclusionRangeConfigurations?: InputMaybe<Array<SeasonUpdateOrCreateSlotExclusionRangeConfigurationInput>>;
  some?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  suggestedRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamDeregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BulkSeasonCreateInput = {
  areBreakWeekSlotExclusionWindowsEnabled: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['DateTime']['input'];
  leagueIds: Array<Scalars['UUID']['input']>;
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  phases?: InputMaybe<Array<BulkSeasonPhaseScheduleInput>>;
  playerDeregistrationEndsAt: Scalars['DateTime']['input'];
  playerRegistrationEndsAt: Scalars['DateTime']['input'];
  playvsScoreEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStartsAt: Scalars['DateTime']['input'];
  rostersLockAt: Scalars['DateTime']['input'];
  slotExclusionRangeConfigurations?: InputMaybe<Array<SeasonUpdateOrCreateSlotExclusionRangeConfigurationInput>>;
  startsAt: Scalars['DateTime']['input'];
  status: SeasonStatus;
  suggestedRegistrationEndsAt: Scalars['DateTime']['input'];
  teamDeregistrationEndsAt: Scalars['DateTime']['input'];
  teamRegistrationEndsAt: Scalars['DateTime']['input'];
  type: SeasonType;
};

export type BulkSeasonPhaseScheduleInput = {
  autoScheduleBracket?: InputMaybe<Scalars['Boolean']['input']>;
  bestOf: Scalars['Int']['input'];
  bracketSize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['DateTime']['input'];
  format: PhaseFormat;
  fortniteEventId?: InputMaybe<Scalars['String']['input']>;
  maxSlotParticipation?: InputMaybe<Scalars['Int']['input']>;
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  minSlotParticipation?: InputMaybe<Scalars['Int']['input']>;
  minutesBeforeMatchToLockInSeries?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  shouldSendPlayoffNotification?: InputMaybe<Scalars['Boolean']['input']>;
  slots?: InputMaybe<Array<SlotScheduleInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['DateTime']['input'];
  status?: InputMaybe<PhaseStatus>;
  survivalAdvancementCount?: InputMaybe<Scalars['Int']['input']>;
  survivalAdvancementPercentage?: InputMaybe<Scalars['Int']['input']>;
  type: PhaseType;
};

export type ByeMatchInput = {
  matchId: Scalars['UUID']['input'];
};

export enum ByeMatchType {
  ByeWin = 'byeWin',
  ForfeitLoss = 'forfeitLoss',
  ForfeitWin = 'forfeitWin'
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CachedOrdinalsPayload = {
  __typename?: 'CachedOrdinalsPayload';
  gameOrdinal: Scalars['Int']['output'];
  seriesOrdinal: Scalars['Int']['output'];
  stepOrdinal: Scalars['Int']['output'];
};

export type CanEditAccountResult = {
  __typename?: 'CanEditAccountResult';
  success: Scalars['Boolean']['output'];
};

export type CancelGameInput = {
  gameId: Scalars['UUID']['input'];
};

export type CancelMatchError = {
  __typename?: 'CancelMatchError';
  error: BulkActionError;
  row: Scalars['UUID']['output'];
};

export type CancelMatchInput = {
  matchId: Scalars['UUID']['input'];
};

export type CancelMatchRescheduleInput = {
  matchRescheduleRequestId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type CancelMatchResult = {
  __typename?: 'CancelMatchResult';
  result: MatchJobPayload;
  row: Scalars['UUID']['output'];
};

export type CancelMatchesInput = {
  matchIds: Array<Scalars['UUID']['input']>;
};

export type CancelMatchesPayload = BulkActionCount & {
  __typename?: 'CancelMatchesPayload';
  errorCount: Scalars['Int']['output'];
  errors: Maybe<Array<Maybe<CancelMatchError>>>;
  results: Maybe<Array<Maybe<CancelMatchResult>>>;
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CancelScrimmageByMatchIdInput = {
  matchId: Scalars['UUID']['input'];
};

export type CancelScrimmageError = {
  __typename?: 'CancelScrimmageError';
  error: BulkActionError;
  row: Scalars['UUID']['output'];
};

export type CancelScrimmageInput = {
  id: Scalars['UUID']['input'];
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CancelScrimmageResult = {
  __typename?: 'CancelScrimmageResult';
  result: Scalars['Boolean']['output'];
  row: Scalars['UUID']['output'];
};

export type CancelScrimmagesInput = {
  ids: Array<Scalars['UUID']['input']>;
};

export type CancelScrimmagesPayload = {
  __typename?: 'CancelScrimmagesPayload';
  canceledScrimmageIds: Array<Scalars['UUID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CancelScrimmagesResponse = BulkActionCount & {
  __typename?: 'CancelScrimmagesResponse';
  errorCount: Scalars['Int']['output'];
  errors: Maybe<Array<Maybe<CancelScrimmageError>>>;
  results: Maybe<Array<Maybe<CancelScrimmageResult>>>;
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CancelSlotInput = {
  deleteMatches?: InputMaybe<Scalars['Boolean']['input']>;
  slotId: Scalars['UUID']['input'];
};

export type CancelTeamRivalInput = {
  requestingTeamId: Scalars['UUID']['input'];
  teamRivalId: Scalars['UUID']['input'];
};

export type CaptchaVerificationInput = {
  token: Scalars['String']['input'];
  version: CaptchaVersion;
};

export enum CaptchaVersion {
  V2 = 'v2',
  V3 = 'v3'
}

export type Champion = {
  __typename?: 'Champion';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type ChangeChildPasswordInput = {
  newPassword: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

export type ChangeMyPasswordInput = {
  newPassword: Scalars['String']['input'];
};

export type Chat = {
  __typename?: 'Chat';
  matchId: Scalars['String']['output'];
  sid: Scalars['String']['output'];
  state: ChatState;
};

export type ChatMetadata = {
  __typename?: 'ChatMetadata';
  chatId: Scalars['String']['output'];
};

export type ChatParticipant = {
  __typename?: 'ChatParticipant';
  avatarUrl: Maybe<Scalars['String']['output']>;
  chatId: Maybe<Scalars['String']['output']>;
  chatRole: Maybe<Scalars['String']['output']>;
  chatUser: Maybe<ChatUser>;
  friendlyName: Maybe<Scalars['String']['output']>;
  participantId: Maybe<Scalars['String']['output']>;
};

export enum ChatRole {
  Admin = 'admin',
  Captain = 'captain',
  Coach = 'coach',
  Player = 'player'
}

export enum ChatState {
  Active = 'active',
  Closed = 'closed',
  Inactive = 'inactive'
}

export type ChatUser = {
  __typename?: 'ChatUser';
  avatarUrl: Maybe<Scalars['String']['output']>;
  chatRole: Maybe<Scalars['String']['output']>;
  friendlyName: Maybe<Scalars['String']['output']>;
  userId: Scalars['UUID']['output'];
};

export type CheckPlaceInPreseasonQueuePayload = {
  __typename?: 'CheckPlaceInPreseasonQueuePayload';
  errors: Maybe<Array<Scalars['String']['output']>>;
  inQueue: Scalars['Boolean']['output'];
  matchId: Maybe<Scalars['String']['output']>;
  mostRecentPairing: Maybe<Scalars['DateTime']['output']>;
  nextScheduledPairing: Maybe<Scalars['DateTime']['output']>;
  numTeamsInQueue: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type CheckPlaceInQueueInput = {
  placeId: Scalars['String']['input'];
};

export type CheckPlaceInQueueResponse = {
  __typename?: 'CheckPlaceInQueueResponse';
  matchId: Maybe<Scalars['String']['output']>;
  opponentTeamId: Maybe<Scalars['String']['output']>;
  status: QueueStatus;
};

export type CheckPlaceInSmartQueueInput = {
  slotId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

export type CheckValidPlayerOnPlatformResponse = {
  __typename?: 'CheckValidPlayerOnPlatformResponse';
  accounts: Maybe<Array<ValidPlayerOnPlatform>>;
};

export type CheckValidPlayersResponse = {
  __typename?: 'CheckValidPlayersResponse';
  accounts: Maybe<Array<ValidPlayerResponse>>;
};

export type ChecklistGroupPayload = {
  __typename?: 'ChecklistGroupPayload';
  group: Scalars['String']['output'];
  items: Array<ChecklistItemPayload>;
};

export type ChecklistItemPayload = {
  __typename?: 'ChecklistItemPayload';
  completedAt: Maybe<Scalars['DateTime']['output']>;
  completedById: Maybe<Scalars['String']['output']>;
  cta: Scalars['String']['output'];
  label: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  urls: Array<ChecklistUrl>;
};

export type ChecklistPayload = {
  __typename?: 'ChecklistPayload';
  groups: Array<ChecklistGroupPayload>;
};

export type ChecklistUrl = {
  __typename?: 'ChecklistUrl';
  label: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ChildAccountSettingsInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gradYear?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ClearMatchChatQueueInput = {
  queueStatus: JobQueueStatus;
};

export type ClearMatchChatQueuePayload = {
  __typename?: 'ClearMatchChatQueuePayload';
  count: Scalars['Int']['output'];
};

export type ClearSmartQueueSlotInput = {
  slotId: Scalars['String']['input'];
};

export type ClearSmartQueueTeamsInput = {
  teamIds: Array<Scalars['String']['input']>;
};

export type ClosedSlotLobbyDetails = {
  __typename?: 'ClosedSlotLobbyDetails';
  lobbyClosedAt: Maybe<Scalars['DateTime']['output']>;
};

export type CoachAssignedEvent = IRosterEvent & {
  __typename?: 'CoachAssignedEvent';
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Scalars['UUID']['output'];
};

export type CoachUnassignedEvent = IRosterEvent & {
  __typename?: 'CoachUnassignedEvent';
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Scalars['UUID']['output'];
};

export type CommonLeaguesForTeamsInput = {
  metaseasonId: Scalars['UUID']['input'];
  teamIds: Array<Scalars['UUID']['input']>;
};

export enum CompetitionGroup {
  College = 'college',
  HighSchool = 'high_school',
  MiddleSchool = 'middle_school',
  Open = 'open',
  Stadium = 'stadium',
  Youth = 'youth'
}

export type CompetitionInterval = {
  __typename?: 'CompetitionInterval';
  endsAt: Scalars['DateTime']['output'];
  enrolledSeasons: Maybe<Array<Season>>;
  enrollmentOpensAt: Maybe<Scalars['DateTime']['output']>;
  firstDay: DateComponents;
  lastDay: DateComponents;
  name: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  tense: IntervalTense;
};


export type CompetitionIntervalEnrolledSeasonsArgs = {
  input: CompetitionIntervalsForOrganizationQueryInput;
};


export type CompetitionIntervalEnrollmentOpensAtArgs = {
  input: CompetitionIntervalsForOrganizationQueryInput;
};

export type CompetitionIntervalForOrganizationResult = {
  __typename?: 'CompetitionIntervalForOrganizationResult';
  interval: CompetitionInterval;
  metaseasonsForOrganization: Array<Metaseason>;
};

export type CompetitionIntervalsForOrganizationQueryInput = {
  organizationId: Scalars['UUID']['input'];
};

export type CompetitionIntervalsForOrganizationQueryPayload = {
  __typename?: 'CompetitionIntervalsForOrganizationQueryPayload';
  results: Array<CompetitionIntervalForOrganizationResult>;
};

export enum CompetitionModel {
  Rec = 'rec'
}

export type CompleteChecklistItemPlayload = {
  __typename?: 'CompleteChecklistItemPlayload';
  success: Scalars['Boolean']['output'];
};

export type CompleteMatchInput = {
  matchId: Scalars['UUID']['input'];
  reviewGames?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompleteQueuePlaceInput = {
  id: Scalars['UUID']['input'];
};

export type CompleteQueuePlaceResponse = {
  __typename?: 'CompleteQueuePlaceResponse';
  place: Maybe<MatchQueuePlace>;
};

export type CompleteScrimmageInput = {
  matchId: Scalars['UUID']['input'];
};

export type ConsolidateLeagueInput = {
  metaseasonId: Scalars['UUID']['input'];
  newLeagueId: Scalars['UUID']['input'];
  oldLeagueId: Scalars['UUID']['input'];
  teamIdsToMove: Array<Scalars['UUID']['input']>;
};

export type Content = {
  __typename?: 'Content';
  features: Array<ContentFeature>;
};

export type ContentFeature = {
  __typename?: 'ContentFeature';
  sections: Array<ContentSection>;
  slug: Scalars['String']['output'];
  variant: Maybe<Scalars['String']['output']>;
};

export type ContentItem = {
  __typename?: 'ContentItem';
  read: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
};

export type ContentPayload = {
  __typename?: 'ContentPayload';
  contentSlugs: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ContentSection = {
  __typename?: 'ContentSection';
  items: Maybe<Array<ContentItem>>;
  slug: Scalars['String']['output'];
};

export type ContentSlugs = {
  featureSlug: Scalars['String']['input'];
  itemSlug: Scalars['String']['input'];
  sectionSlug: Scalars['String']['input'];
};

export type ConversationMetadata = {
  __typename?: 'ConversationMetadata';
  conversationSid: Scalars['String']['output'];
  matchId: Scalars['UUID']['output'];
};

export type CreateAnnualPassAttributes = {
  description: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  isAdminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailable: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  numberOfMetaseasons: Scalars['Int']['input'];
  priceUsd: Scalars['Int']['input'];
  seasonPassesAllotted: Array<SeasonPassAllotmentInput>;
  seatCount?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateDemoInput = {
  scheduledAt: Scalars['DateTime']['input'];
  schoolName: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  varsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEsportGroupAttributes = {
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateGameHighlightPayload = {
  __typename?: 'CreateGameHighlightPayload';
  gameHighlight: GameHighlight;
};

export type CreateGameInput = {
  entryCode?: InputMaybe<Scalars['String']['input']>;
  matchId?: InputMaybe<Scalars['UUID']['input']>;
  ordinalNumber?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<GameStatus>;
};

export type CreateGamePayload = {
  __typename?: 'CreateGamePayload';
  game: Maybe<Game>;
};

export type CreateGameResultInput = {
  gameId: Scalars['UUID']['input'];
  placing?: InputMaybe<Scalars['Int']['input']>;
  sidePlayed?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['UUID']['input'];
};

export type CreateGameResultPayload = {
  __typename?: 'CreateGameResultPayload';
  gameResult: Maybe<GameResult>;
};

export type CreateLeagueGroupInput = {
  competitionGroup: CompetitionGroup;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  stateAssociationSlug?: InputMaybe<Scalars['String']['input']>;
  type: LeagueType;
  varsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLeagueGroupPayload = {
  __typename?: 'CreateLeagueGroupPayload';
  leagueGroup: Maybe<LeagueGroup>;
};

export type CreateLeagueInput = {
  canHaveMultipleTeamsWithSamePlayers?: InputMaybe<Scalars['Boolean']['input']>;
  canRemovePlayersFromTeams?: InputMaybe<Scalars['Boolean']['input']>;
  competitionGroup: CompetitionGroup;
  competitionModel: CompetitionModel;
  displayName: Scalars['String']['input'];
  esportId: Scalars['UUID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  lockTeamsToSchool?: InputMaybe<Scalars['Boolean']['input']>;
  maxTeamsPerPlayer?: InputMaybe<Scalars['Int']['input']>;
  minutesBeforeMatchToLockInSeries?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  publicSlug?: InputMaybe<Scalars['String']['input']>;
  requirePrivateRoster?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  teamFormat?: InputMaybe<Scalars['Int']['input']>;
  teamMaxSize?: InputMaybe<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
  type?: InputMaybe<LeagueType>;
  varsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLeaguePayload = {
  __typename?: 'CreateLeaguePayload';
  league: Maybe<League>;
};

export type CreateLinkInput = {
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateMatchChatEventInput = {
  changesTo: Scalars['String']['input'];
  description: Scalars['String']['input'];
  esportId?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  name: Scalars['String']['input'];
  object: Scalars['String']['input'];
  sendMessage: Scalars['String']['input'];
};

export type CreateMatchChatInput = {
  matchId: Scalars['UUID']['input'];
  teamIds: Array<Scalars['UUID']['input']>;
};

export type CreateMatchChatPayload = {
  __typename?: 'CreateMatchChatPayload';
  errors: Array<Maybe<Scalars['String']['output']>>;
  results: CreateMatchChatResults;
  success: Scalars['Boolean']['output'];
};

export type CreateMatchChatResults = {
  __typename?: 'CreateMatchChatResults';
  matchChatId: Scalars['String']['output'];
  matchId: Scalars['UUID']['output'];
};

export type CreateMatchInput = {
  bestOf?: InputMaybe<Scalars['Int']['input']>;
  disqualifyAfter?: InputMaybe<Scalars['Int']['input']>;
  esportId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  scheduledStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  slotId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<MatchStatus>;
};

export type CreateMatchPayload = {
  __typename?: 'CreateMatchPayload';
  match: Maybe<Match>;
};

export type CreateMatchResultInput = {
  gamesLost?: InputMaybe<Scalars['Int']['input']>;
  gamesLostByForfeit?: InputMaybe<Scalars['Int']['input']>;
  gamesPlayed?: InputMaybe<Scalars['Int']['input']>;
  gamesTied?: InputMaybe<Scalars['Int']['input']>;
  gamesWon?: InputMaybe<Scalars['Int']['input']>;
  gamesWonByForfeit?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['UUID']['input'];
  seriesLost?: InputMaybe<Scalars['Int']['input']>;
  seriesLostByForfeit?: InputMaybe<Scalars['Int']['input']>;
  seriesPlayed?: InputMaybe<Scalars['Int']['input']>;
  seriesTied?: InputMaybe<Scalars['Int']['input']>;
  seriesWon?: InputMaybe<Scalars['Int']['input']>;
  seriesWonByForfeit?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['UUID']['input'];
};

export type CreateMatchResultPayload = {
  __typename?: 'CreateMatchResultPayload';
  matchResult: Maybe<MatchResult>;
};

export type CreateMetaseasonConfig = {
  coachOffboardingTriggersAt?: InputMaybe<Scalars['DateTime']['input']>;
  competitionGroup: CompetitionGroup;
  endsAt: Scalars['DateTime']['input'];
  isInitialMetaseason?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  offboardingEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  playerOffboardingTriggersAt?: InputMaybe<Scalars['DateTime']['input']>;
  previousMetaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  promotionEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  promotionStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  startsAt: Scalars['DateTime']['input'];
  status: SeasonStatus;
};

export type CreateNoteInput = {
  entityId: Scalars['UUID']['input'];
  entityType: EntityType;
  textContent: Scalars['String']['input'];
};

export type CreateNotificationInput = {
  buttonText: Scalars['String']['input'];
  description: Scalars['String']['input'];
  href: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<NotificationStatus>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreatePastByeMatchInput = {
  scheduleAt?: InputMaybe<Scalars['DateTime']['input']>;
  slotId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
  type: ByeMatchType;
};

export type CreatePhaseAttributes = {
  bestOf: Scalars['Int']['input'];
  bracketSize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  format: PhaseFormat;
  introText?: InputMaybe<Scalars['String']['input']>;
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name: PhaseName;
  rescheduleBeforeMatchOpenIntervalMinutes: Scalars['Int']['input'];
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  shouldSendPlayoffNotification?: InputMaybe<Scalars['Boolean']['input']>;
  slotConfig?: InputMaybe<SlotConfig>;
  slotDates?: InputMaybe<Array<SlotDateConfig>>;
  startDate: Scalars['String']['input'];
  status?: InputMaybe<PhaseStatus>;
  type: PhaseType;
};

export type CreatePhaseInput = {
  autoScheduleBracket?: InputMaybe<Scalars['Boolean']['input']>;
  bestOf: Scalars['Int']['input'];
  bracketSize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['DateTime']['input'];
  format: PhaseFormat;
  fortniteEventId?: InputMaybe<Scalars['String']['input']>;
  maxSlotParticipation?: InputMaybe<Scalars['Int']['input']>;
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  minSlotParticipation?: InputMaybe<Scalars['Int']['input']>;
  minutesBeforeMatchToLockInSeries?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  seasonId?: InputMaybe<Scalars['String']['input']>;
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  shouldSendPlayoffNotification?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['DateTime']['input'];
  status?: InputMaybe<PhaseStatus>;
  survivalAdvancementCount?: InputMaybe<Scalars['Int']['input']>;
  survivalAdvancementPercentage?: InputMaybe<Scalars['Int']['input']>;
  type: PhaseType;
};

export type CreatePhasePayload = {
  __typename?: 'CreatePhasePayload';
  phase: Phase;
};

export type CreatePhaseResultInput = {
  gameStreak?: InputMaybe<Scalars['Int']['input']>;
  gamesLost?: InputMaybe<Scalars['Int']['input']>;
  gamesLostByForfeit?: InputMaybe<Scalars['Int']['input']>;
  gamesPlayed?: InputMaybe<Scalars['Int']['input']>;
  gamesTied?: InputMaybe<Scalars['Int']['input']>;
  gamesWon?: InputMaybe<Scalars['Int']['input']>;
  gamesWonByForfeit?: InputMaybe<Scalars['Int']['input']>;
  matchStreak?: InputMaybe<Scalars['Int']['input']>;
  matchesLost?: InputMaybe<Scalars['Int']['input']>;
  matchesLostByForfeit?: InputMaybe<Scalars['Int']['input']>;
  matchesPlayed?: InputMaybe<Scalars['Int']['input']>;
  matchesTied?: InputMaybe<Scalars['Int']['input']>;
  matchesWon?: InputMaybe<Scalars['Int']['input']>;
  matchesWonByBye?: InputMaybe<Scalars['Int']['input']>;
  matchesWonByForfeit?: InputMaybe<Scalars['Int']['input']>;
  phaseId: Scalars['UUID']['input'];
  phasePoints?: InputMaybe<Scalars['Int']['input']>;
  phaseTiebreakerPoints?: InputMaybe<Scalars['Int']['input']>;
  seriesLost?: InputMaybe<Scalars['Int']['input']>;
  seriesLostByForfeit?: InputMaybe<Scalars['Int']['input']>;
  seriesPlayed?: InputMaybe<Scalars['Int']['input']>;
  seriesTied?: InputMaybe<Scalars['Int']['input']>;
  seriesWon?: InputMaybe<Scalars['Int']['input']>;
  seriesWonByForfeit?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['UUID']['input'];
};

export type CreatePhaseResultPayload = {
  __typename?: 'CreatePhaseResultPayload';
  phaseResult: Maybe<PhaseResult>;
};

export type CreateRoleInviteCodeInput = {
  resourceId: Scalars['UUID']['input'];
  resourceType: Scalars['String']['input'];
  roleName: UserRoleName;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateSchoolAttributes = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  gradeHigh?: InputMaybe<Scalars['String']['input']>;
  gradeLow?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  mascotName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ncesId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  showCoachEmails?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  type: SchoolType;
  varsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  whoPays?: InputMaybe<WhoPays>;
  zip: Scalars['String']['input'];
};

export type CreateSeasonPassAttributes = {
  description: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  isAdminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailable: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priceUsd: Scalars['Float']['input'];
  slug: Scalars['String']['input'];
};

export type CreateSeasonalPlayerAwardTypeInput = {
  description: Scalars['String']['input'];
  templatePdfUrl: Scalars['String']['input'];
  templateSharableImageUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateSeasonalPlayerAwardTypePayload = {
  __typename?: 'CreateSeasonalPlayerAwardTypePayload';
  seasonalPlayerAwardType: Maybe<SeasonalPlayerAwardType>;
};

export type CreateSlotExclusionRangeConfigurationInput = {
  competitionGroup: CompetitionGroup;
  defaultsAppliedAt: Scalars['DateTime']['input'];
  maxSlotExclusions?: InputMaybe<Scalars['Int']['input']>;
  metaseasonId: Scalars['UUID']['input'];
  minSlotExclusions?: InputMaybe<Scalars['Int']['input']>;
  range: SlotExclusionRangeConfigurationDateRangeInput;
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
  resourceType: SlotExclusionRangeConfigurationResourceType;
};

export type CreateSlotExclusionRangeConfigurationResult = {
  __typename?: 'CreateSlotExclusionRangeConfigurationResult';
  configuration: SlotExclusionRangeConfiguration;
};

export type CreateSlotInput = {
  bestOf: Scalars['Int']['input'];
  fortniteEventWindowId?: InputMaybe<Scalars['String']['input']>;
  isStartsAtHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  phaseId: Scalars['String']['input'];
  scheduleMatchesAt?: InputMaybe<Scalars['DateTime']['input']>;
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  startsAt: Scalars['DateTime']['input'];
  status?: InputMaybe<SlotStatus>;
};

export type CreateSlotPayload = {
  __typename?: 'CreateSlotPayload';
  slot: Slot;
};

export type CreateTeamForEventInput = {
  eventSeasonId: Scalars['UUID']['input'];
  isPrivateRoster?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTeamInput = {
  esportId: Scalars['UUID']['input'];
  isPrivateRoster: Scalars['Boolean']['input'];
  leagueId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateTeamV2Input = {
  esportV2Id: Scalars['UUID']['input'];
  isPrivateRoster?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  teamFormat: Scalars['Int']['input'];
};

export type CreateUserEmailOptions = {
  overwriteExisting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUserNotificationInput = {
  notificationId: Scalars['String']['input'];
  statusEnum?: InputMaybe<UserNotificationStatus>;
  userId: Scalars['UUID']['input'];
  validOn?: InputMaybe<Scalars['DateTime']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateVarsityAssociationAttributes = {
  abbreviation: Scalars['String']['input'];
  competitionGroup: CompetitionGroup;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CurrentGameAssistantStateInput = {
  matchId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type DateComponents = {
  __typename?: 'DateComponents';
  dayOfMonth: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type DateRange = {
  __typename?: 'DateRange';
  endsAt: Scalars['DateTime']['output'];
  startsAt: Scalars['DateTime']['output'];
};

export type DateRangeInput = {
  endsAt: Scalars['DateTime']['input'];
  startsAt: Scalars['DateTime']['input'];
};

export type DayOfWeek = {
  day: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};

export type DeckSelection = {
  __typename?: 'DeckSelection';
  decks: Array<HearthstoneDeck>;
};

export type DeclineQueueInput = {
  placeId: Scalars['String']['input'];
};

export type DeclineQueueResponse = {
  __typename?: 'DeclineQueueResponse';
  placeId: Scalars['String']['output'];
};

export type DecreaseReputationInput = {
  seasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type DeleteEsportOfferingDescriptor = {
  esportOfferingId: Scalars['UUID']['input'];
};

export type DeleteEsportOfferingPayload = {
  __typename?: 'DeleteEsportOfferingPayload';
  deletedEsportGroupId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteEsportPositionPayload = {
  __typename?: 'DeleteEsportPositionPayload';
  deletedId: Scalars['UUID']['output'];
};

export type DeleteGameHighlightInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteGameHighlightInputPayload = {
  __typename?: 'DeleteGameHighlightInputPayload';
  deletedId: Scalars['UUID']['output'];
};

export type DeleteMatchChatEventInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteMatchDisputePayload = {
  __typename?: 'DeleteMatchDisputePayload';
  deletedMatchDisputeId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteMatchInput = {
  matchId: Scalars['UUID']['input'];
};

export type DeleteMatchPayload = {
  __typename?: 'DeleteMatchPayload';
  deletedMatchId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteMatchResultPayload = {
  __typename?: 'DeleteMatchResultPayload';
  deletedEntityId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteNotePayload = {
  __typename?: 'DeleteNotePayload';
  deletedNoteId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeletePartnerPayload = {
  __typename?: 'DeletePartnerPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteSchoolMessagePayload = {
  __typename?: 'DeleteSchoolMessagePayload';
  deletedSchoolMessageId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteSchoolPayload = {
  __typename?: 'DeleteSchoolPayload';
  deletedSchoolId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteSeasonalPlayerAwardInput = {
  assignedSeasonalPlayerAwardId: Scalars['UUID']['input'];
};

export type DeleteSeasonalPlayerAwardPayload = {
  __typename?: 'DeleteSeasonalPlayerAwardPayload';
  deletedId: Scalars['UUID']['output'];
};

export type DeleteSeasonalPlayerAwardTypeInput = {
  seasonalPlayerAwardTypeId: Scalars['UUID']['input'];
};

export type DeleteSeasonalPlayerAwardTypePayload = {
  __typename?: 'DeleteSeasonalPlayerAwardTypePayload';
  deletedId: Scalars['UUID']['output'];
};

export type DeleteSlotExclusionRangeConfigurationInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteSlotExclusionRangeConfigurationPayload = {
  __typename?: 'DeleteSlotExclusionRangeConfigurationPayload';
  deletedSlotExclusionRangeConfigurationIds: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteSlotPayload = {
  __typename?: 'DeleteSlotPayload';
  deletedSlotId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteSponsorshipCampaignPayload = {
  __typename?: 'DeleteSponsorshipCampaignPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteSponsorshipComponentPayload = {
  __typename?: 'DeleteSponsorshipComponentPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteTaskQueuePayload = {
  __typename?: 'DeleteTaskQueuePayload';
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type DeleteTeamPayload = {
  __typename?: 'DeleteTeamPayload';
  deletedTeamId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  deletedUserId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteWeeklyAssignedPlayerAwardInput = {
  assignedWeeklyPlayerAwardId: Scalars['UUID']['input'];
};

export type DeleteWeeklyAssignedPlayerAwardPayload = {
  __typename?: 'DeleteWeeklyAssignedPlayerAwardPayload';
  deletedId: Scalars['UUID']['output'];
};

export type DeletedMatchSettleRequestPayload = {
  __typename?: 'DeletedMatchSettleRequestPayload';
  deletedMatchSettleRequestId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type Demo = {
  __typename?: 'Demo';
  createdAt: Scalars['DateTime']['output'];
  password: Scalars['String']['output'];
  scheduledAt: Scalars['DateTime']['output'];
  school: Maybe<School>;
  schoolId: Scalars['UUID']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
  username: Scalars['String']['output'];
};

export type DemoJobPayload = {
  __typename?: 'DemoJobPayload';
  jobId: Scalars['UUID']['output'];
};

export type DiscordConnectedToGuildPayload = {
  __typename?: 'DiscordConnectedToGuildPayload';
  discordId: Scalars['UUID']['output'];
  isGuildMember: Scalars['Boolean']['output'];
  username: Maybe<Scalars['String']['output']>;
};

export type DismissNotificationResult = {
  __typename?: 'DismissNotificationResult';
  deletedUserNotificationId: Scalars['ObjectID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DisputeEvidenceMap = {
  assetId: Scalars['UUID']['input'];
};

export type DownloadSchoolInvoiceInput = {
  invoiceReferenceId: Scalars['String']['input'];
  schoolId: Scalars['UUID']['input'];
};

export type DownloadSchoolInvoicePayload = {
  __typename?: 'DownloadSchoolInvoicePayload';
  encodedFile: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export type EffectiveAtRange = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EligiblePlayer = {
  __typename?: 'EligiblePlayer';
  disabled: Scalars['Boolean']['output'];
  disabledReason: Maybe<EligiblePlayerDisabledReason>;
  user: User;
};

export enum EligiblePlayerDisabledReason {
  Underage = 'underage'
}

export type EligibleProductsResponse = {
  __typename?: 'EligibleProductsResponse';
  AnnualPass: Maybe<Array<RankedAnnualPassProduct>>;
  SeasonPass: Maybe<Array<SeasonPassProduct>>;
};

export type EligibleTeamsForSubstituteTransferResult = {
  __typename?: 'EligibleTeamsForSubstituteTransferResult';
  destinations: Array<SubstituteTransferDestination>;
};

export type EmailConflictPayload = {
  __typename?: 'EmailConflictPayload';
  success: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  userEmails: Array<UserEmail>;
};

export type EmailUpdateRequest = {
  __typename?: 'EmailUpdateRequest';
  expiresAt: Scalars['DateTime']['output'];
  newEmail: Scalars['String']['output'];
};

export type EnqueueNotificationForAllUsersInput = {
  filters?: InputMaybe<UserFiltersInput>;
  notificationId: Scalars['UUID']['input'];
  validOn: Scalars['DateTime']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type EnqueueUpcomingSlotScheduleJobsInput = {
  rangeInMinutes: Scalars['Int']['input'];
};

export type EnqueueUserNotificationsJobInput = {
  notificationId: Scalars['UUID']['input'];
  schoolIds: Array<Scalars['UUID']['input']>;
  validOn: Scalars['DateTime']['input'];
  validUntil: Scalars['DateTime']['input'];
};

export type EnrollmentConfirmationPayload = {
  __typename?: 'EnrollmentConfirmationPayload';
  success: Scalars['Boolean']['output'];
};

export enum EntityType {
  School = 'School',
  Team = 'Team',
  User = 'User'
}

export type EpicFortniteEventInfo = {
  __typename?: 'EpicFortniteEventInfo';
  announcementTime: Maybe<Scalars['DateTime']['output']>;
  appId: Maybe<Scalars['String']['output']>;
  displayDataId: Scalars['String']['output'];
  environment: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  eventWindows: Maybe<Array<EpicFortniteEventWindowInfo>>;
  gameId: Scalars['String']['output'];
  platforms: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  regions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EpicFortniteEventWindowInfo = {
  __typename?: 'EpicFortniteEventWindowInfo';
  additionalRequirements: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  beginTime: Maybe<Scalars['DateTime']['output']>;
  blackoutPeriods: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  countdownBeginTime: Maybe<Scalars['DateTime']['output']>;
  endTime: Maybe<Scalars['DateTime']['output']>;
  eventTemplateId: Maybe<Scalars['String']['output']>;
  eventWindowId: Maybe<Scalars['String']['output']>;
  isTBD: Maybe<Scalars['Boolean']['output']>;
  leaderboardId: Maybe<Scalars['String']['output']>;
  payoutDelay: Maybe<Scalars['Int']['output']>;
  requireAllTokens: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requireAllTokensCaller: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requireAnyTokens: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requireAnyTokensCaller: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requireNoneTokensCaller: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  round: Maybe<Scalars['Int']['output']>;
  teammateEligibility: Maybe<Scalars['String']['output']>;
  visibility: Maybe<Scalars['String']['output']>;
};

export type EpicPlatformSelectionOptionsByUserIdsPayload = {
  __typename?: 'EpicPlatformSelectionOptionsByUserIdsPayload';
  selectionOptions: Array<EpicPlatformSelectionOptionsForUser>;
};

export type EpicPlatformSelectionOptionsForUser = {
  __typename?: 'EpicPlatformSelectionOptionsForUser';
  selectionOptions: Array<GameAssistantSelectionOption>;
  userId: Scalars['UUID']['output'];
};

export enum ErrorCode {
  AgeRequirementNotMet = 'AGE_REQUIREMENT_NOT_MET',
  AuthorizationError = 'AUTHORIZATION_ERROR',
  EmailAlreadyRegistered = 'EMAIL_ALREADY_REGISTERED',
  EmailNotRegistered = 'EMAIL_NOT_REGISTERED',
  EmailNotVerified = 'EMAIL_NOT_VERIFIED',
  EnrollmentError = 'ENROLLMENT_ERROR',
  EnrollmentNotOpen = 'ENROLLMENT_NOT_OPEN',
  EntityNotFound = 'ENTITY_NOT_FOUND',
  ExpiredToken = 'EXPIRED_TOKEN',
  FileUpload = 'FILE_UPLOAD',
  ForbiddenUser = 'FORBIDDEN_USER',
  GoogleOauthError = 'GOOGLE_OAUTH_ERROR',
  GraphqlValidationFailed = 'GRAPHQL_VALIDATION_FAILED',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  InvalidToken = 'INVALID_TOKEN',
  MaxNumberOfTeamsReached = 'MAX_NUMBER_OF_TEAMS_REACHED',
  PersistedQueryNotFound = 'PERSISTED_QUERY_NOT_FOUND',
  PlayoffTemplateError = 'PLAYOFF_TEMPLATE_ERROR',
  PromotionalEmailServiceError = 'PROMOTIONAL_EMAIL_SERVICE_ERROR',
  ProviderAccountError = 'PROVIDER_ACCOUNT_ERROR',
  RiotApiError = 'RIOT_API_ERROR',
  RoleRequestError = 'ROLE_REQUEST_ERROR',
  TeamActionError = 'TEAM_ACTION_ERROR',
  TeamExisted = 'TEAM_EXISTED',
  TeamNameExisted = 'TEAM_NAME_EXISTED',
  Unauthenticated = 'UNAUTHENTICATED',
  UserBanned = 'USER_BANNED',
  ValidationError = 'VALIDATION_ERROR',
  VerificationError = 'VERIFICATION_ERROR'
}

/** An esport for which we play leagues e.g. Rocket League */
export type Esport = {
  __typename?: 'Esport';
  colors: Maybe<EsportColors>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  details: Maybe<EsportDetails>;
  eligibleLeaguesCount: Maybe<Scalars['Int']['output']>;
  esportGroupId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  inactiveLeaguesCount: Maybe<Scalars['Int']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  isPromoted: Maybe<Scalars['Boolean']['output']>;
  isUnderageEnabled: Scalars['Boolean']['output'];
  leagueDefaults: EsportLeagueDefaults;
  leaguesWithSeasonCount: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  platform: Maybe<Scalars['String']['output']>;
  rating: EsportRating;
  slug: Scalars['EsportSlug']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


/** An esport for which we play leagues e.g. Rocket League */
export type EsportEligibleLeaguesCountArgs = {
  competitionGroup: CompetitionGroup;
};


/** An esport for which we play leagues e.g. Rocket League */
export type EsportInactiveLeaguesCountArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


/** An esport for which we play leagues e.g. Rocket League */
export type EsportLeaguesWithSeasonCountArgs = {
  metaseasonId: Scalars['UUID']['input'];
};

export type EsportAssets = {
  __typename?: 'EsportAssets';
  avatarLogoUrl: Maybe<Scalars['String']['output']>;
  blackAndWhiteSvgIcon: Maybe<Scalars['String']['output']>;
  disabledAvatarLogoUrl: Maybe<Scalars['String']['output']>;
  iconComponent: Maybe<Scalars['String']['output']>;
};

export type EsportAssetsAttributes = {
  avatarLogoUrl?: InputMaybe<Scalars['String']['input']>;
  blackAndWhiteSvgIcon?: InputMaybe<Scalars['String']['input']>;
  disabledAvatarLogoUrl?: InputMaybe<Scalars['String']['input']>;
  iconComponent?: InputMaybe<Scalars['String']['input']>;
};

export type EsportAttributes = {
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  esportGroupId?: InputMaybe<Scalars['UUID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPromoted?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<EsportRating>;
  slug: Scalars['EsportSlug']['input'];
};

export type EsportColors = {
  __typename?: 'EsportColors';
  color1: Maybe<Scalars['String']['output']>;
  color2: Maybe<Scalars['String']['output']>;
  color3: Maybe<Scalars['String']['output']>;
  color4: Maybe<Scalars['String']['output']>;
  color5: Maybe<Scalars['String']['output']>;
  color6: Maybe<Scalars['String']['output']>;
  gradientEnd: Maybe<Scalars['String']['output']>;
  gradientStart: Maybe<Scalars['String']['output']>;
  mainColor: Maybe<Scalars['String']['output']>;
};

export type EsportColorsAttributes = {
  color1?: InputMaybe<Scalars['String']['input']>;
  color2?: InputMaybe<Scalars['String']['input']>;
  color3?: InputMaybe<Scalars['String']['input']>;
  color4?: InputMaybe<Scalars['String']['input']>;
  color5?: InputMaybe<Scalars['String']['input']>;
  color6?: InputMaybe<Scalars['String']['input']>;
  color7?: InputMaybe<Scalars['String']['input']>;
  color8?: InputMaybe<Scalars['String']['input']>;
  gradientEnd?: InputMaybe<Scalars['String']['input']>;
  gradientStart?: InputMaybe<Scalars['String']['input']>;
  mainColor?: InputMaybe<Scalars['String']['input']>;
};

export type EsportDetails = {
  __typename?: 'EsportDetails';
  abbreviation: Maybe<Scalars['String']['output']>;
  accountProviders: Maybe<Array<Provider>>;
  assets: Maybe<EsportAssets>;
  competitionGroups: Maybe<Array<CompetitionGroup>>;
  defaultBestOf: Scalars['Int']['output'];
  defaultSeriesBestOf: Scalars['Int']['output'];
  esportId: Scalars['UUID']['output'];
  features: Maybe<EsportFeatures>;
  gameType: Maybe<Scalars['String']['output']>;
  matchAssistantVideoSrc: Maybe<Scalars['String']['output']>;
  matchFormat: Maybe<MatchFormat>;
  matchInstructionsArticleId: Maybe<Scalars['String']['output']>;
  matchOverviewFormat: Maybe<Scalars['String']['output']>;
  missingConnectionCopy: Maybe<EsportMissingConnectionCopy>;
  platforms: Maybe<Array<Platform>>;
  playerStatRankCategory: Maybe<Scalars['String']['output']>;
  positions: Maybe<Array<Array<Scalars['String']['output']>>>;
  positionsArray: Maybe<Array<EsportPositions>>;
  rankingInfoCopy: Maybe<Scalars['String']['output']>;
  rulebookUrl: Maybe<Scalars['String']['output']>;
  scoreDisplayName: Maybe<Scalars['String']['output']>;
  teamMinStarterSize: Scalars['Int']['output'];
};

export type EsportDetailsAttributes = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  accountProviders?: InputMaybe<Array<Provider>>;
  assets?: InputMaybe<EsportAssetsAttributes>;
  competitionGroups?: InputMaybe<Array<CompetitionGroup>>;
  defaultBestOf?: InputMaybe<Scalars['Int']['input']>;
  defaultSeriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  features?: InputMaybe<EsportFeaturesAttributes>;
  gameType?: InputMaybe<Scalars['String']['input']>;
  matchAssistantVideoSrc?: InputMaybe<Scalars['String']['input']>;
  matchInstructionsArticleId?: InputMaybe<Scalars['String']['input']>;
  matchOverviewFormat?: InputMaybe<Scalars['String']['input']>;
  missingConnectionCopy?: InputMaybe<EsportMissingConnectionCopyAttributes>;
  platforms?: InputMaybe<Array<Platform>>;
  playerStatRankCategory?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Array<EsportPositionsAttributes>>;
  rankingInfoCopy?: InputMaybe<Scalars['String']['input']>;
  scoreDisplayName?: InputMaybe<Scalars['String']['input']>;
  teamMinStarterSize?: InputMaybe<Scalars['Int']['input']>;
};

export type EsportFeatures = {
  __typename?: 'EsportFeatures';
  hasApiIntegration: Scalars['Boolean']['output'];
  hasMatchAssistantScore: Scalars['Boolean']['output'];
  hasOauthIntegration: Scalars['Boolean']['output'];
  hasSeries: Scalars['Boolean']['output'];
  hasSubstitutesEnabled: Scalars['Boolean']['output'];
  /** @deprecated Discord is no longer used for managing matches */
  isDiscordEnabled: Maybe<Scalars['Boolean']['output']>;
  isPlayerLedTeamEnabled: Scalars['Boolean']['output'];
  isScrimmageEnabled: Scalars['Boolean']['output'];
  matchAssistantEnabled: Scalars['Boolean']['output'];
};

export type EsportFeaturesAttributes = {
  hasApiIntegration: Scalars['Boolean']['input'];
  hasMatchAssistantScore?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeries: Scalars['Boolean']['input'];
  hasSubstitutesEnabled: Scalars['Boolean']['input'];
  isPlayerLedTeamEnabled: Scalars['Boolean']['input'];
  isScrimmageEnabled: Scalars['Boolean']['input'];
  matchAssistantEnabled: Scalars['Boolean']['input'];
};

export type EsportFilters = {
  slug?: InputMaybe<Scalars['EsportSlug']['input']>;
  status?: InputMaybe<EsportStatus>;
};

export type EsportLeagueDefaults = {
  __typename?: 'EsportLeagueDefaults';
  canHaveMultipleTeamsWithSamePlayers: Maybe<Scalars['Boolean']['output']>;
  canRemovePlayersFromTeams: Maybe<Scalars['Boolean']['output']>;
  maxTeamsPerPlayer: Maybe<Scalars['Int']['output']>;
  teamFormat: Maybe<Scalars['Int']['output']>;
  teamMaxSize: Maybe<Scalars['Int']['output']>;
};

export type EsportLeagueDefaultsAttributes = {
  canHaveMultipleTeamsWithSamePlayers?: InputMaybe<Scalars['Boolean']['input']>;
  canRemovePlayersFromTeams?: InputMaybe<Scalars['Boolean']['input']>;
  maxTeamsPerPlayer?: InputMaybe<Scalars['Int']['input']>;
  teamFormat?: InputMaybe<Scalars['Int']['input']>;
  teamMaxSize?: InputMaybe<Scalars['Int']['input']>;
};

export type EsportLeaguesPreview = {
  __typename?: 'EsportLeaguesPreview';
  esport: Esport;
  leaguePreviews: Array<LeaguePreview>;
  rulebook: Maybe<EsportRulebook>;
};

export type EsportMissingConnectionCopy = {
  __typename?: 'EsportMissingConnectionCopy';
  match: Maybe<MissingConnectionCopyBody>;
  overview: Maybe<MissingConnectionCopyBody>;
};

export type EsportMissingConnectionCopyAttributes = {
  match: MissingConnectionCopyBodyAttributes;
  overview: MissingConnectionCopyBodyAttributes;
};

export type EsportOffering = {
  __typename?: 'EsportOffering';
  competitionGroup: CompetitionGroup;
  esportId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  platform: PlatformInfo;
  teamFormat: TeamFormat;
};

export type EsportOfferingDescriptor = {
  competitionGroup: CompetitionGroup;
  esportGroupId: Scalars['UUID']['input'];
  esportOfferingId?: InputMaybe<Scalars['UUID']['input']>;
  platform?: InputMaybe<Platform>;
  teamFormat: Scalars['Int']['input'];
};

export type EsportOfferingUpdateDescriptor = {
  competitionGroup?: InputMaybe<CompetitionGroup>;
  platform?: InputMaybe<Platform>;
  teamFormat?: InputMaybe<Scalars['Int']['input']>;
};

export type EsportOfferingsPayload = {
  __typename?: 'EsportOfferingsPayload';
  esportOfferings: Array<Maybe<EsportOffering>>;
};

export type EsportPassUsage = {
  __typename?: 'EsportPassUsage';
  esport: Esport;
  passUsageByMetaseason: Array<MetaseasonPassUsageSummaryPayload>;
  seasonPassesUsed: Scalars['Int']['output'];
};

export type EsportPayload = {
  __typename?: 'EsportPayload';
  esport: Maybe<Esport>;
  esportId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type EsportPlatform = {
  __typename?: 'EsportPlatform';
  esportId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  platform: Platform;
};

export type EsportPosition = {
  __typename?: 'EsportPosition';
  abbreviation: Scalars['String']['output'];
  colloquial: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EsportPositions = {
  __typename?: 'EsportPositions';
  abbreviation: Maybe<Scalars['String']['output']>;
  colloquial: Maybe<Scalars['String']['output']>;
  esportId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
};

export type EsportPositionsAttributes = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  colloquial?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
};

export enum EsportRating {
  General = 'General',
  Restricted = 'Restricted'
}

export type EsportRulebook = {
  __typename?: 'EsportRulebook';
  competitionGroup: CompetitionGroup;
  esportId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum EsportStatus {
  All = 'all',
  Disabled = 'disabled',
  Enabled = 'enabled'
}

export type EsportV2 = {
  __typename?: 'EsportV2';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  offerings: Maybe<Array<EsportOffering>>;
  rating: Maybe<EsportRating>;
};

/**
 * Generates a quote that calculates number of season passes
 * needed for enrollment.
 *
 * totalSeasonPassesNeeded - Number of season passes that'll be needed
 * totalBillableSeasonPassesNeeded - Number of season passes that'll be billed
 *
 * Note: this number will be 0 for Unlimited plans.
 */
export type EstimateSchoolSeasonPassUsageResult = {
  __typename?: 'EstimateSchoolSeasonPassUsageResult';
  annualPassType: AnnualPassType;
  totalBillableSeasonPassesNeeded: Scalars['Int']['output'];
  totalSeasonPassesNeeded: Scalars['Int']['output'];
};

export type EventConfig = {
  __typename?: 'EventConfig';
  eventBestOf: Maybe<Scalars['Int']['output']>;
  eventDetails: Maybe<Scalars['String']['output']>;
  eventStatus: Maybe<EventStatus>;
  id: Scalars['UUID']['output'];
  isHidden: Scalars['Boolean']['output'];
  isUserAbleToJoinEvent: Maybe<IsUserAbleToJoinEventResponse>;
  maxAge: Maybe<Scalars['Int']['output']>;
  maxTeamsAllowed: Maybe<Scalars['Int']['output']>;
  minAge: Maybe<Scalars['Int']['output']>;
  prizeDetails: Maybe<Scalars['String']['output']>;
  seasonId: Scalars['UUID']['output'];
  surveyId: Maybe<Scalars['String']['output']>;
  userEventTeam: Maybe<Team>;
};

export type EventConfigInput = {
  eventDetails?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  maxTeamsAllowed?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  prizeDetails?: InputMaybe<Scalars['String']['input']>;
  surveyId?: InputMaybe<Scalars['String']['input']>;
};

export enum EventStatus {
  Confirmed = 'confirmed',
  Finished = 'finished',
  InProgress = 'inProgress',
  RegistrationOpen = 'registrationOpen'
}

export type ExcludedSlotEvent = ScheduleEvent & ScheduleEventWithSlot & {
  __typename?: 'ExcludedSlotEvent';
  slot: Slot;
  startsAt: Scalars['DateTime']['output'];
  type: ScheduleEventType;
};

export type ExpireQueuePlaceInput = {
  id: Scalars['UUID']['input'];
};

export type ExpireQueuePlaceResponse = {
  __typename?: 'ExpireQueuePlaceResponse';
  place: Maybe<MatchQueuePlace>;
};

export type FeatureUpdate = {
  slug: Scalars['String']['input'];
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type FetchMatchChatEventByEsportIdsInput = {
  esportIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type FetchMatchSettleRequestInput = {
  matchId?: InputMaybe<Scalars['UUID']['input']>;
  requestedById?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<MatchSettleRequestStatus>;
  statuses?: InputMaybe<Array<MatchSettleRequestStatus>>;
};

export type File = {
  __typename?: 'File';
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
};

export type FindDeniedUsers = {
  name?: InputMaybe<Scalars['String']['input']>;
  options: SearchOptions;
  roleName: UserRoleName;
  schoolId: Scalars['String']['input'];
};

export type FindEligibleTeamsForSubstituteTransferInput = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  options?: InputMaybe<SubstituteTransferOptions>;
  originTeamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type FindNotesResult = {
  __typename?: 'FindNotesResult';
  count: Maybe<Scalars['Int']['output']>;
  notes: Maybe<Array<Note>>;
};

export type FindSlotExclusionRangeConfigurationsInput = {
  bounds: SlotExclusionRangeConfigurationDateRangeInput;
  competitionGroup?: InputMaybe<CompetitionGroup>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
  resourceType?: InputMaybe<SlotExclusionRangeConfigurationResourceType>;
};

export type FindTeamsInSeasonInput = {
  enrollmentStatus?: InputMaybe<SeasonEnrollmentStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nameQuery?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  schoolNameQuery?: InputMaybe<Scalars['String']['input']>;
  schoolVarsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
  seasonId: Scalars['UUID']['input'];
  sortFields?: InputMaybe<Array<TeamSortSpec>>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type FindTeamsInSeasonResult = {
  __typename?: 'FindTeamsInSeasonResult';
  teams: Array<Team>;
  totalCount: Scalars['Int']['output'];
};

export type FindUsers = {
  filters: FindUsersFilters;
  options?: InputMaybe<SearchOptions>;
};

export type FindUsersFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<RoleFilters>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
};

export type FinishGameInput = {
  gameId: Scalars['UUID']['input'];
};

export type ForceValidPlayerGameStatsInput = {
  gameId: Scalars['UUID']['input'];
  publisherAccountIds: Array<Scalars['String']['input']>;
};

export type ForfeitMatchResponse = {
  __typename?: 'ForfeitMatchResponse';
  forfeitDetail: Maybe<Scalars['String']['output']>;
  forfeitReason: Maybe<ForfeitReason>;
  forfeitedBy: Maybe<Scalars['UUID']['output']>;
  losingTeamId: Scalars['UUID']['output'];
  matchId: Scalars['UUID']['output'];
  teamId: Scalars['UUID']['output'];
  winningTeamId: Scalars['UUID']['output'];
};

export enum ForfeitReason {
  Abandonment = 'abandonment',
  CovidSchoolClosure = 'covidSchoolClosure',
  ForfeitAllTeams = 'forfeitAllTeams',
  InvalidRoster = 'invalidRoster',
  LateEnrollment = 'lateEnrollment',
  NoShow = 'noShow',
  NotEnoughPlayers = 'notEnoughPlayers',
  Other = 'other',
  SchoolClosure = 'schoolClosure',
  TeamUnenrolled = 'teamUnenrolled',
  TechnologyIssues = 'technologyIssues'
}

export type FortniteEventsResponse = {
  __typename?: 'FortniteEventsResponse';
  events: Maybe<Array<EpicFortniteEventInfo>>;
};

export type FortniteTeamMatchStats = {
  __typename?: 'FortniteTeamMatchStats';
  avgEliminationsPerSession: Scalars['Float']['output'];
  avgPlacementPerSession: Scalars['Float']['output'];
  avgPointsPerSession: Scalars['Float']['output'];
  clutched: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eliminationPoints: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  placementPoints: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  sessionsPlayed: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  totalSecondsSurvived: Scalars['Int']['output'];
  totalVictoryRoyales: Scalars['Int']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type FortniteTeamMatchStatsResult = {
  __typename?: 'FortniteTeamMatchStatsResult';
  leaderboard: Maybe<Array<TeamMatchStats>>;
  myTeams: Maybe<Array<TeamMatchStats>>;
  schoolTeams: Maybe<Array<TeamMatchStats>>;
  total: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type FortniteTeamPhaseStats = {
  __typename?: 'FortniteTeamPhaseStats';
  avgEliminationsPerSession: Scalars['Float']['output'];
  avgPlacementPerSession: Scalars['Float']['output'];
  avgPointsPerMatch: Scalars['Float']['output'];
  avgPointsPerSession: Scalars['Float']['output'];
  avgRankPerMatch: Scalars['Float']['output'];
  clutched: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eliminationPoints: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  matchesPlayed: Scalars['Int']['output'];
  placementPoints: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  sessionsPlayed: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  totalSecondsSurvived: Scalars['Int']['output'];
  totalVictoryRoyales: Scalars['Int']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type FortniteTeamPhaseStatsResult = {
  __typename?: 'FortniteTeamPhaseStatsResult';
  leaderboard: Maybe<Array<TeamPhaseStats>>;
  myTeams: Maybe<Array<TeamPhaseStats>>;
  schoolTeams: Maybe<Array<TeamPhaseStats>>;
  total: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type FortniteTeamRecord = {
  __typename?: 'FortniteTeamRecord';
  avgPlacementPerSeason: Maybe<Scalars['Float']['output']>;
  placementPointRank: Maybe<Scalars['Int']['output']>;
};

export type Game = {
  __typename?: 'Game';
  entryCode: Maybe<Scalars['String']['output']>;
  externalGameId: Maybe<Scalars['String']['output']>;
  gameResults: Maybe<Array<GameResult>>;
  id: Scalars['UUID']['output'];
  leagueOfLegendsPlayerStats: Maybe<Array<LeagueOfLegendsPlayerGameStats>>;
  leagueOfLegendsTeamStats: Maybe<LeagueOfLegendsTeamGameStatsExtended>;
  losingTeam: Maybe<GameTeam>;
  match: Maybe<Match>;
  matchId: Maybe<Scalars['UUID']['output']>;
  ordinalNumber: Maybe<Scalars['Int']['output']>;
  placing: Maybe<Scalars['Int']['output']>;
  playerGameStats: Maybe<Array<PlayerGameStats>>;
  rocketLeagueTeamStats: Maybe<RocketLeagueTeamGameStatsWithSp>;
  scores: Maybe<Array<Maybe<Score>>>;
  seriesId: Maybe<Scalars['UUID']['output']>;
  smiteTeamStats: Maybe<SmiteTeamGameStats>;
  status: GameStatus;
  teamContext: GameTeamContext;
  teamGameStats: Maybe<Array<TeamGameStats>>;
  winningTeam: Maybe<GameTeam>;
};


export type GameGameResultsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type GameLeagueOfLegendsPlayerStatsArgs = {
  teamId: Scalars['UUID']['input'];
};


export type GameLeagueOfLegendsTeamStatsArgs = {
  teamId: Scalars['UUID']['input'];
};


export type GamePlacingArgs = {
  teamId: Scalars['UUID']['input'];
};


export type GameRocketLeagueTeamStatsArgs = {
  teamId: Scalars['UUID']['input'];
};


export type GameSmiteTeamStatsArgs = {
  teamId: Scalars['UUID']['input'];
};

export type GameAssets = {
  assetIds: Array<Scalars['UUID']['input']>;
  ordinalNumber: Scalars['Int']['input'];
};

export type GameAssistantConfigrationsInput = {
  esportId: Scalars['UUID']['input'];
  gameOrdinals?: InputMaybe<Array<Scalars['Int']['input']>>;
  stepOrdinals?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GameAssistantGameDetails = {
  __typename?: 'GameAssistantGameDetails';
  gameOrdinal: Scalars['Int']['output'];
  scores: Maybe<Array<GameAssistantTeamScore>>;
  timeRemainingInSeconds: Scalars['Int']['output'];
};

export type GameAssistantMatchDetails = {
  __typename?: 'GameAssistantMatchDetails';
  games: Maybe<Array<GameAssistantGameDetails>>;
  isComplete: Maybe<Scalars['Boolean']['output']>;
  matchSettledByTimer: Maybe<Scalars['Boolean']['output']>;
};

export type GameAssistantSelection = {
  __typename?: 'GameAssistantSelection';
  gameAssistantStep: Maybe<GameAssistantStep>;
  id: Scalars['UUID']['output'];
  selectionOption: Maybe<GameAssistantSelectionOption>;
  selectionOptionId: Maybe<Scalars['UUID']['output']>;
  stepId: Scalars['UUID']['output'];
  team: Maybe<Team>;
  teamId: Maybe<Scalars['UUID']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']['output']>;
};

export type GameAssistantSelectionOption = {
  __typename?: 'GameAssistantSelectionOption';
  assetUri: Maybe<Scalars['String']['output']>;
  displayCategory: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  earliestGameOrdinal: Maybe<Scalars['Int']['output']>;
  esport: Maybe<Esport>;
  esportId: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  slug: Scalars['String']['output'];
  type: GameAssistantSelectionOptionType;
  unique: Maybe<Scalars['Boolean']['output']>;
};

export type GameAssistantSelectionOptionInsert = {
  assetUri?: InputMaybe<Scalars['String']['input']>;
  displayCategory?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  earliestGameOrdinal?: InputMaybe<Scalars['Int']['input']>;
  esportId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  type: GameAssistantSelectionOptionType;
};

export enum GameAssistantSelectionOptionType {
  Character = 'character',
  Confirm = 'confirm',
  Map = 'map',
  Platform = 'platform',
  Player = 'player',
  Spectator = 'spectator',
  Team = 'team',
  YesNo = 'yesNo'
}

export type GameAssistantSelectionOptionsByGameOrdinal = {
  __typename?: 'GameAssistantSelectionOptionsByGameOrdinal';
  gameOrdinal: Maybe<Scalars['Int']['output']>;
  selectionOptions: Array<GameAssistantSelectionOption>;
};

export type GameAssistantSelectionOptionsPayload = {
  __typename?: 'GameAssistantSelectionOptionsPayload';
  selectionOptions: Array<GameAssistantSelectionOptionsByGameOrdinal>;
};

export type GameAssistantStatePayload = {
  __typename?: 'GameAssistantStatePayload';
  characterBans: Maybe<Array<GameAssistantSelection>>;
  characterPicks: Maybe<Array<GameAssistantSelection>>;
  currentSeries: Maybe<Series>;
  freeStrikeMaps: Maybe<Array<GameAssistantSelection>>;
  lolGameCode: Maybe<Scalars['String']['output']>;
  mapBans: Maybe<Array<GameAssistantSelection>>;
  mapPicks: Maybe<Array<GameAssistantSelection>>;
  matchDetails: Maybe<GameAssistantMatchDetails>;
  nextGameRosterChangeRequested: Maybe<Scalars['Boolean']['output']>;
  opponentRoster: Maybe<TeamRoster>;
  playerPicks: Maybe<Array<GameAssistantSelection>>;
  roster: Maybe<TeamRoster>;
  showMatchAssistant: Scalars['Boolean']['output'];
  spectatorPicks: Maybe<Array<GameAssistantSelection>>;
  splatoonGameMode: Maybe<Scalars['String']['output']>;
  step: Maybe<GameAssistantStep>;
};

export type GameAssistantStep = {
  __typename?: 'GameAssistantStep';
  game: Maybe<Game>;
  gameId: Maybe<Scalars['UUID']['output']>;
  gameOrdinal: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  match: Maybe<Match>;
  matchId: Scalars['UUID']['output'];
  revertible: Scalars['Boolean']['output'];
  selectionOptionType: Maybe<GameAssistantSelectionOptionType>;
  selections: Array<GameAssistantSelection>;
  series: Maybe<Series>;
  seriesId: Maybe<Scalars['UUID']['output']>;
  seriesOrdinal: Maybe<Scalars['Int']['output']>;
  stepOrdinal: Scalars['Int']['output'];
  submitted: Scalars['Boolean']['output'];
  submittedByUserId: Maybe<Scalars['UUID']['output']>;
  team: Maybe<Team>;
  teamId: Maybe<Scalars['UUID']['output']>;
  totalSelections: Scalars['Int']['output'];
  turn: GameAssistantTurnType;
  type: GameAssistantStepType;
};

export type GameAssistantStepByGameOrdinal = {
  __typename?: 'GameAssistantStepByGameOrdinal';
  gameOrdinal: Scalars['Int']['output'];
  step: GameAssistantStep;
};

export enum GameAssistantStepType {
  Ban = 'ban',
  BetaOptIn = 'betaOptIn',
  OpponentRoster = 'opponentRoster',
  Pick = 'pick',
  ReadyForInvite = 'readyForInvite',
  ReadyUp = 'readyUp',
  Report = 'report',
  Roster = 'roster',
  Scoreboard = 'scoreboard'
}

export type GameAssistantStepUpdatedSubscribeInput = {
  lastStepIdSeenByTeam?: InputMaybe<Scalars['UUID']['input']>;
  matchId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type GameAssistantStepUpdatedSubscribePayload = {
  __typename?: 'GameAssistantStepUpdatedSubscribePayload';
  currentState: GameAssistantStatePayload;
};

export type GameAssistantStepsBySeries = {
  __typename?: 'GameAssistantStepsBySeries';
  seriesId: Scalars['String']['output'];
  steps: Array<GameAssistantStepByGameOrdinal>;
};

export type GameAssistantStepsBySeriesPayload = {
  __typename?: 'GameAssistantStepsBySeriesPayload';
  steps: Array<Maybe<GameAssistantStepsBySeries>>;
};

export type GameAssistantTeamScore = {
  __typename?: 'GameAssistantTeamScore';
  score: Scalars['Int']['output'];
  teamId: Scalars['UUID']['output'];
};

export enum GameAssistantTurnType {
  All = 'all',
  Away = 'away',
  Home = 'home',
  PreviousLoser = 'previousLoser',
  PreviousWinner = 'previousWinner',
  SeriesLoser = 'seriesLoser',
  SeriesWinner = 'seriesWinner',
  Team1 = 'team1',
  Team2 = 'team2'
}

export type GameHighlight = {
  __typename?: 'GameHighlight';
  createdAt: Scalars['DateTime']['output'];
  esportId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  match: Maybe<Match>;
  matchId: Maybe<Scalars['String']['output']>;
  source: GameHighlightSource;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
};


export type GameHighlightThumbnailUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type GameHighlightFilters = {
  endsAt?: InputMaybe<Scalars['String']['input']>;
  esportId?: InputMaybe<Scalars['UUID']['input']>;
  esportIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  matchId?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GameHighlightInput = {
  matchId?: InputMaybe<Scalars['String']['input']>;
  source: GameHighlightSource;
  title: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  videoUrl: Scalars['String']['input'];
};

export enum GameHighlightSource {
  Twitch = 'Twitch',
  Youtube = 'Youtube'
}

export type GameHighlightsResult = {
  __typename?: 'GameHighlightsResult';
  endCursor: Maybe<Scalars['String']['output']>;
  gameHighlights: Maybe<Array<GameHighlight>>;
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
};

export enum GameIncompleteReason {
  PlayerNoShow = 'playerNoShow',
  TechnologyIssues = 'technologyIssues'
}

export type GameJobPayload = {
  __typename?: 'GameJobPayload';
  jobId: Maybe<Scalars['String']['output']>;
};

export type GamePlayer = {
  __typename?: 'GamePlayer';
  age: Maybe<Scalars['Int']['output']>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  /** The US state within which the user resides */
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  gameId: Scalars['UUID']['output'];
  /** The year that a user will graduate from high school */
  gradYear: Maybe<Scalars['Int']['output']>;
  gradYears: Array<UserGradYear>;
  id: Scalars['UUID']['output'];
  isCaptain: Scalars['Boolean']['output'];
  isUnderage: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  lastSeen: Maybe<Scalars['DateTime']['output']>;
  name: Maybe<Scalars['String']['output']>;
  onlineStatus: Maybe<OnlineStatus>;
  publisherAccountName: Maybe<Scalars['String']['output']>;
  shortName: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  /** The user's preferred time zone for date/time localization, e.g. 'Africa/Johannesburg' */
  timeZone: Maybe<Scalars['String']['output']>;
  tosAcceptedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  username: Maybe<Scalars['String']['output']>;
};


export type GamePlayerAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type GamePlayerGradYearArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GameResult = {
  __typename?: 'GameResult';
  game: Maybe<Game>;
  gameId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  placing: Maybe<Scalars['Int']['output']>;
  rosterId: Maybe<Scalars['UUID']['output']>;
  score: Maybe<Scalars['Int']['output']>;
  sidePlayed: Maybe<Scalars['Int']['output']>;
  team: Maybe<Team>;
  teamId: Maybe<Scalars['UUID']['output']>;
};

export type GameResultRequest = {
  __typename?: 'GameResultRequest';
  approvedByTeamIds: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  assetIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assets: Maybe<Array<Asset>>;
  gameRejected: Maybe<Scalars['Boolean']['output']>;
  incompleteReason: Maybe<GameIncompleteReason>;
  losingPlayerIds: Maybe<Array<Scalars['UUID']['output']>>;
  losingTeamId: Scalars['UUID']['output'];
  losingTeamScore: Maybe<Scalars['Int']['output']>;
  ordinalNumber: Scalars['Int']['output'];
  requestedById: Maybe<Scalars['UUID']['output']>;
  teamPlacements: Maybe<Array<TeamPlacement>>;
  winningPlayerIds: Maybe<Array<Scalars['UUID']['output']>>;
  winningTeam: Maybe<Team>;
  winningTeamId: Scalars['UUID']['output'];
  winningTeamScore: Maybe<Scalars['Int']['output']>;
};

export enum GameStatus {
  Bye = 'bye',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Forfeited = 'forfeited',
  Live = 'live',
  Open = 'open',
  Quarantined = 'quarantined',
  Reviewed = 'reviewed',
  Scheduled = 'scheduled',
  Settled = 'settled'
}

export type GameTeam = {
  __typename?: 'GameTeam';
  avatarUrl: Maybe<Scalars['String']['output']>;
  captain: Maybe<User>;
  coaches: Maybe<Array<TeamCoach>>;
  competitionGroup: Maybe<CompetitionGroup>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Scalars['UUID']['output']>;
  createdByUser: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  deletedById: Maybe<Scalars['UUID']['output']>;
  esportId: Scalars['UUID']['output'];
  eventSeasonId: Maybe<Scalars['UUID']['output']>;
  gameId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isPlayerLed: Maybe<Scalars['Boolean']['output']>;
  isPrivateRoster: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  owners: Maybe<Array<User>>;
  result: Maybe<GameResult>;
  roster: Maybe<Array<GamePlayer>>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  teamFormat: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type GameTeamAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type GameTeamContext = {
  __typename?: 'GameTeamContext';
  gameId: Scalars['UUID']['output'];
  myTeamGameResults: Array<GameResult>;
  myTeams: Array<GameTeam>;
  numberOfTeamsInGame: Scalars['Int']['output'];
  otherTeamGameResults: Array<GameResult>;
  otherTeams: Array<GameTeam>;
  teams: Array<GameTeam>;
};

export enum Gender {
  DifferentIdentity = 'DifferentIdentity',
  Female = 'Female',
  Male = 'Male',
  PreferNotToAnswer = 'PreferNotToAnswer'
}

export type GenerateSeasonScheduleResponse = {
  __typename?: 'GenerateSeasonScheduleResponse';
  isValid: SeasonValidityResult;
  season: SeasonSchedule;
};

export type GenerateSeasonalPlayerAwardCertificateInput = {
  id: Scalars['UUID']['input'];
};

export type GenerateSeasonalPlayerAwardCertificatePayload = {
  __typename?: 'GenerateSeasonalPlayerAwardCertificatePayload';
  signedUrl: Scalars['String']['output'];
};

export type GenerateSeasonalPlayerAwardSocialMediaImageInput = {
  id: Scalars['UUID']['input'];
};

export type GenerateSeasonalPlayerAwardSocialMediaImagePayload = {
  __typename?: 'GenerateSeasonalPlayerAwardSocialMediaImagePayload';
  signedUrl: Scalars['String']['output'];
};

export type GenerateTwilioAccessTokenByUserIdInput = {
  id: Scalars['UUID']['input'];
};

export type GenerateTwilioAccessTokenByUserIdPayload = {
  __typename?: 'GenerateTwilioAccessTokenByUserIdPayload';
  payload: TwilioAccessTokenMetadata;
  success: Scalars['Boolean']['output'];
};

export type GenericMatchSettleRequestPayload = {
  __typename?: 'GenericMatchSettleRequestPayload';
  errors: Maybe<Array<Scalars['String']['output']>>;
  matchSettleRequest: Maybe<MatchSettleRequestModel>;
  success: Scalars['Boolean']['output'];
};

export type GenericQueuePayload = {
  __typename?: 'GenericQueuePayload';
  errors: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type GenericTeamReputationPayload = {
  __typename?: 'GenericTeamReputationPayload';
  reputations: Maybe<Array<Maybe<TeamReputation>>>;
};

export type Geolocation = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  miles: Scalars['Int']['input'];
};

export type GetJobInput = {
  jobId: Scalars['UUID']['input'];
};

export type GetLeagueMetadataBySchoolIdInput = {
  schoolId: Scalars['UUID']['input'];
};

export type GetLeagueMetadataByTeamIdsInput = {
  teamIds: Array<Scalars['UUID']['input']>;
};

export type GetLeagueMetadataGenericPayload = {
  __typename?: 'GetLeagueMetadataGenericPayload';
  error: Maybe<Array<Scalars['String']['output']>>;
  payload: Maybe<Array<StandingsPageLeagueMetadata>>;
  success: Scalars['Boolean']['output'];
};

export type GetMaddenMostPlayedStatsByPlayerIdResults = {
  __typename?: 'GetMaddenMostPlayedStatsByPlayerIdResults';
  players: Array<MaddenMostPlayedStatsByPlayerId>;
};

export type GetMaddenMostPlayedStatsByPlayerIdsInput = {
  playerIds: Array<Scalars['UUID']['input']>;
  seasonId: Scalars['UUID']['input'];
};

export type GetMaddenPlayerStatsByGameIdsInput = {
  gameId: Scalars['UUID']['input'];
  playerIds: Array<Scalars['UUID']['input']>;
};

export type GetMaddenPlayerStatsByGameIdsResults = {
  __typename?: 'GetMaddenPlayerStatsByGameIdsResults';
  results: Array<MaddenGameStats>;
};

export type GetMatchChatByUniqueIdInput = {
  uniqueNameOrSid: Scalars['String']['input'];
};

export type GetMatchChatByUniqueIdResults = {
  __typename?: 'GetMatchChatByUniqueIdResults';
  chat: Chat;
};

export type GetNba2kMostPlayedStatsByPlayerIdResults = {
  __typename?: 'GetNBA2kMostPlayedStatsByPlayerIdResults';
  players: Array<Nba2kMostPlayedStatsByPlayerId>;
};

export type GetNba2kMostPlayedStatsByPlayerIdsInput = {
  playerIds: Array<Scalars['UUID']['input']>;
  seasonId: Scalars['UUID']['input'];
};

export type GetNba2kPlayerStatsByGameIdsInput = {
  gameId: Scalars['UUID']['input'];
  playerIds: Array<Scalars['UUID']['input']>;
};

export type GetNba2kPlayerStatsByGameIdsResults = {
  __typename?: 'GetNBA2kPlayerStatsByGameIdsResults';
  results: Array<Nba2kGameStats>;
};

export type GetNoteAuthorsInput = {
  entityId: Scalars['UUID']['input'];
  entityType: EntityType;
};

export type GetPhasesFilter = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  phaseStatuses?: InputMaybe<Array<PhaseStatus>>;
  seasonId?: InputMaybe<Scalars['String']['input']>;
};

export type GetPhasesResult = {
  __typename?: 'GetPhasesResult';
  result: Maybe<Array<Phase>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type GetPlayerLinkedAccountPlatformsResponse = {
  __typename?: 'GetPlayerLinkedAccountPlatformsResponse';
  playerLinkedAccounts: Array<PlayerLinkedAccount>;
};

export type GetPossibleTeamRivalsInput = {
  seasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type GetPossibleTeamRivalsResult = {
  __typename?: 'GetPossibleTeamRivalsResult';
  results: Maybe<Array<PossibleTeamRivalPayload>>;
  seasonId: Scalars['UUID']['output'];
};

export type GetPracticeDaySchedulesInput = {
  schoolId: Scalars['UUID']['input'];
};

export type GetPracticeDaySchedulesPayload = {
  __typename?: 'GetPracticeDaySchedulesPayload';
  errors: Maybe<Array<Scalars['String']['output']>>;
  payload: PracticeDaySchedule;
  success: Scalars['Boolean']['output'];
};

export type GetQualifiedTeamCountInput = {
  phaseId: Scalars['UUID']['input'];
  requiredWins: Scalars['Int']['input'];
};

export type GetSeasonDatesTemplateResult = {
  __typename?: 'GetSeasonDatesTemplateResult';
  seasonDatesTemplates: Maybe<Array<SeasonDatesTemplate>>;
};

export type GetSeasonsFilter = {
  hasMostRecentFailedPhaseSeeding?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  leagueId?: InputMaybe<Scalars['String']['input']>;
  metaseasonIds?: InputMaybe<Array<Scalars['String']['input']>>;
  seasonStatuses?: InputMaybe<Array<SeasonStatus>>;
};

export type GetSeasonsResult = {
  __typename?: 'GetSeasonsResult';
  result: Maybe<Array<Season>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type GetSlotLobbyError = {
  __typename?: 'GetSlotLobbyError';
  message: Scalars['String']['output'];
};

export type GetSmashUltimateMostPlayedStatsByPlayerIdResults = {
  __typename?: 'GetSmashUltimateMostPlayedStatsByPlayerIdResults';
  players: Array<MostPlayedStatsByPlayerId>;
};

export type GetSmashUltimateMostPlayedStatsByPlayerIdsInput = {
  playerIds: Array<Scalars['UUID']['input']>;
  seasonId: Scalars['UUID']['input'];
};

export type GetSmashUltimatePlayerStatsByGameIdsInput = {
  gameId: Scalars['UUID']['input'];
  playerIds: Array<Scalars['UUID']['input']>;
};

export type GetSmashUltimatePlayerStatsByGameIdsResults = {
  __typename?: 'GetSmashUltimatePlayerStatsByGameIdsResults';
  results: Array<SmashUltimateGameStats>;
};

export type GetSplatoonMostPlayedStatsByPlayerIdResults = {
  __typename?: 'GetSplatoonMostPlayedStatsByPlayerIdResults';
  players: Array<SplatoonMostPlayedStatsByPlayerId>;
};

export type GetSplatoonMostPlayedStatsByPlayerIdsInput = {
  playerIds: Array<Scalars['UUID']['input']>;
  seasonId: Scalars['UUID']['input'];
};

export type GetSplatoonPlayerStatsByGameIdsInput = {
  gameId: Scalars['UUID']['input'];
  playerIds: Array<Scalars['UUID']['input']>;
};

export type GetSplatoonPlayerStatsByGameIdsResults = {
  __typename?: 'GetSplatoonPlayerStatsByGameIdsResults';
  results: Array<SplatoonGameStats>;
};

export type GetUsersOnlineStatusInput = {
  userIds: Array<Scalars['String']['input']>;
};

export type GetUsersOnlineStatusPayload = {
  __typename?: 'GetUsersOnlineStatusPayload';
  errors: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
  usersOnlineStatus: Array<UserWithOnlineStatus>;
};

export type GetVarsityAssociationsInput = {
  filters?: InputMaybe<VarsityAssociationFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GetVarsityAssociationsResult = {
  __typename?: 'GetVarsityAssociationsResult';
  filters: Maybe<VarsityAssociationFiltersResult>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  result: Maybe<Array<VarsityAssociation>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type GraduatePlayerInput = {
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type HeadToHeadMatchTeamScores = {
  __typename?: 'HeadToHeadMatchTeamScores';
  matchId: Scalars['UUID']['output'];
  /** Score for team 1 in a head v head match. In a series match, this is the series score. In a non-series match, this is the game score. */
  team1Score: Maybe<Scalars['Int']['output']>;
  /** Score for team 2 in a head v head match. In a series match, this is the series score. In a non-series match, this is the game score. */
  team2Score: Maybe<Scalars['Int']['output']>;
};

export enum HearthstoneDeck {
  DemonHunter = 'DemonHunter',
  Druid = 'Druid',
  Hunter = 'Hunter',
  Mage = 'Mage',
  Paladin = 'Paladin',
  Priest = 'Priest',
  Rogue = 'Rogue',
  Shaman = 'Shaman',
  Warlock = 'Warlock',
  Warrior = 'Warrior'
}

export type HearthstonePlayerDeckSelection = {
  __typename?: 'HearthstonePlayerDeckSelection';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deckSelection: DeckSelection;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  isDefault: Scalars['Boolean']['output'];
  matchId: Scalars['UUID']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['UUID']['output'];
};

export type IPhase = {
  autoScheduleBracket: Maybe<Scalars['Boolean']['output']>;
  bestOf: Maybe<Scalars['Int']['output']>;
  bracketSize: Maybe<Scalars['Int']['output']>;
  defaultSlots: Maybe<Array<Slot>>;
  description: Maybe<Scalars['String']['output']>;
  endsAt: Scalars['DateTime']['output'];
  esport: Maybe<Esport>;
  format: PhaseFormat;
  fortniteEventId: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  introText: Maybe<Scalars['String']['output']>;
  matchRescheduleEndsAt: Maybe<Scalars['DateTime']['output']>;
  maxSlotParticipation: Maybe<Scalars['Int']['output']>;
  maxTeamsPerSchool: Maybe<Scalars['Int']['output']>;
  minSlotParticipation: Maybe<Scalars['Int']['output']>;
  minutesBeforeMatchToLockInSeries: Maybe<Scalars['Int']['output']>;
  mode: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phaseResults: Maybe<Array<PhaseResult>>;
  rules: Maybe<Scalars['String']['output']>;
  season: Maybe<Season>;
  seasonId: Scalars['String']['output'];
  seriesBestOf: Maybe<Scalars['Int']['output']>;
  shouldSendPlayoffNotification: Maybe<Scalars['Boolean']['output']>;
  slots: Maybe<Array<Slot>>;
  slug: Maybe<Scalars['String']['output']>;
  startsAt: Scalars['DateTime']['output'];
  status: PhaseStatus;
  survivalAdvancementCount: Maybe<Scalars['Int']['output']>;
  survivalAdvancementPercentage: Maybe<Scalars['Int']['output']>;
  teamMatchCount: Maybe<Scalars['Int']['output']>;
  teams: Maybe<Array<SeededTeam>>;
  type: PhaseType;
};


export type IPhaseDefaultSlotsArgs = {
  maxStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  minStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type IPhaseTeamMatchCountArgs = {
  teamId: Scalars['UUID']['input'];
};

export type IProduct = {
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  internalName: Maybe<Scalars['String']['output']>;
  isAdminOnly: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceUsd: Scalars['Float']['output'];
  seatCount: Maybe<Scalars['Int']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  type: ProductType;
};

export type IRankedProduct = {
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  internalName: Maybe<Scalars['String']['output']>;
  isAdminOnly: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  isRecommended: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  priceUsd: Scalars['Float']['output'];
  seatCount: Maybe<Scalars['Int']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  type: ProductType;
};

export type IRosterEvent = {
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Scalars['UUID']['output'];
};

export type ISchoolMessage = {
  createdAt: Maybe<Scalars['DateTime']['output']>;
  isPinned: Maybe<Scalars['Boolean']['output']>;
  linkImageUrl: Maybe<Scalars['String']['output']>;
  linkTitle: Maybe<Scalars['String']['output']>;
  linkUrl: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  school: Maybe<School>;
  title: Maybe<Scalars['String']['output']>;
};

export type ISeasonPassProduct = {
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  internalName: Maybe<Scalars['String']['output']>;
  isAdminOnly: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceUsd: Scalars['Float']['output'];
  seatCount: Maybe<Scalars['Int']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  type: ProductType;
};

export type ItDetails = {
  __typename?: 'ITDetails';
  agreeToDoPatchUpdates: Maybe<Scalars['Boolean']['output']>;
  agreeToInstallGames: Maybe<Scalars['Boolean']['output']>;
  agreeToWhitelistPorts: Maybe<Scalars['Boolean']['output']>;
  hasDedicatedLab: Maybe<Scalars['Boolean']['output']>;
  numStudentComps: Maybe<Scalars['String']['output']>;
  osType: Maybe<Scalars['String']['output']>;
  publicIP: Maybe<Scalars['String']['output']>;
  suppStaff: Maybe<SupportStaff>;
  suppStaffOnCampus: Maybe<Scalars['Boolean']['output']>;
};

export type ItDetailsInput = {
  agreeToDoPatchUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  agreeToInstallGames?: InputMaybe<Scalars['Boolean']['input']>;
  agreeToWhitelistPorts?: InputMaybe<Scalars['Boolean']['input']>;
  hasDedicatedLab?: InputMaybe<Scalars['Boolean']['input']>;
  numStudentComps?: InputMaybe<Scalars['String']['input']>;
  osType?: InputMaybe<Scalars['String']['input']>;
  publicIP?: InputMaybe<Scalars['String']['input']>;
  suppStaff?: InputMaybe<SupportStaffInput>;
  suppStaffOnCampus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ITeam = {
  /** @deprecated use enrolledSeasons */
  allSeasons: Maybe<Array<Season>>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  captain: Maybe<User>;
  coaches: Maybe<Array<TeamCoach>>;
  competitionGroup: Maybe<CompetitionGroup>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Scalars['UUID']['output']>;
  createdByUser: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  deletedById: Maybe<Scalars['UUID']['output']>;
  enrolledSeasons: Maybe<Array<Season>>;
  enrollmentStatus: SeasonEnrollmentStatus;
  esport: Esport;
  esportId: Scalars['UUID']['output'];
  eventSeasonId: Maybe<Scalars['UUID']['output']>;
  getEligiblePlayers: Maybe<Array<EligiblePlayer>>;
  globalStats: Maybe<TeamGlobalStats>;
  id: Scalars['UUID']['output'];
  inviteUrl: Maybe<Scalars['String']['output']>;
  isEnrolledInCurrentMetaseason: Maybe<Scalars['Boolean']['output']>;
  isFixedRoster: Maybe<Scalars['Boolean']['output']>;
  isMyTeam: Maybe<Scalars['Boolean']['output']>;
  isPlayerLed: Maybe<Scalars['Boolean']['output']>;
  isPrivateRoster: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  league: Maybe<League>;
  leagues: Maybe<Array<League>>;
  /** @deprecated use Team.roster instead */
  members: Maybe<Array<TeamMember>>;
  name: Maybe<Scalars['String']['output']>;
  nextOpponent: Maybe<Team>;
  owners: Maybe<Array<User>>;
  phaseMatches: Maybe<Array<Match>>;
  phaseResult: Maybe<PhaseResult>;
  phases: Maybe<Array<PhaseTeam>>;
  rallySchool: Maybe<School>;
  recommendationPercent: Maybe<Scalars['Float']['output']>;
  recommendationScore: Maybe<Scalars['Int']['output']>;
  roster: Maybe<TeamRoster>;
  rosterHistory: Maybe<Array<IRosterEvent>>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  seasonTeams: Maybe<Array<SeasonTeam>>;
  /** @deprecated use enrolledSeasons */
  seasons: Maybe<Array<Season>>;
  slotExclusionWindows: Maybe<Array<SlotExclusionWindow>>;
  slotIdsWithSmartQueueMatches: Maybe<Array<Scalars['UUID']['output']>>;
  slug: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  teamFormat: Maybe<Scalars['Int']['output']>;
  teamHistory: Maybe<Array<ITeamEvent>>;
  teamPhaseSummary: Maybe<TeamPhaseSummary>;
  teamPhaseSummaryByMetaseasonAndPhaseType: Maybe<TeamPhaseSummary>;
  unconnectedMembers: Maybe<Array<TeamMember>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type ITeamAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type ITeamEnrollmentStatusArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type ITeamLeaguesArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ITeamMembersArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtRange?: InputMaybe<EffectiveAtRange>;
};


export type ITeamNextOpponentArgs = {
  includeScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ITeamPhaseMatchesArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type ITeamRecommendationPercentArgs = {
  teamId: Scalars['UUID']['input'];
};


export type ITeamRecommendationScoreArgs = {
  teamId: Scalars['UUID']['input'];
};


export type ITeamRosterArgs = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtRange?: InputMaybe<DateRangeInput>;
};


export type ITeamRosterHistoryArgs = {
  dateRange: DateRangeInput;
};


export type ITeamSlotExclusionWindowsArgs = {
  bounds?: InputMaybe<DateRangeInput>;
};


export type ITeamSlotIdsWithSmartQueueMatchesArgs = {
  slotIds: Array<Scalars['UUID']['input']>;
};


export type ITeamTeamPhaseSummaryArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type ITeamTeamPhaseSummaryByMetaseasonAndPhaseTypeArgs = {
  metaseasonId: Scalars['UUID']['input'];
  phaseType: PhaseType;
};

export type ITeamEvent = {
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Maybe<Scalars['UUID']['output']>;
};

export type IUser = {
  activatedLeagues: Maybe<Array<League>>;
  additionalInfo: Maybe<Scalars['String']['output']>;
  age: Maybe<Scalars['Int']['output']>;
  assignedSeasonalAwards: Maybe<Array<AssignedSeasonalPlayerAward>>;
  assignedWeeklyAwards: Maybe<Array<Maybe<AssignedWeeklyPlayerAward>>>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  banned: Maybe<Scalars['Boolean']['output']>;
  chatUserId: Maybe<Scalars['UUID']['output']>;
  content: Content;
  /** The US state within which the user resides */
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  currentVerification: Maybe<Verification>;
  dateOfBirth: Maybe<Scalars['String']['output']>;
  detail: Maybe<UserDetail>;
  /** @deprecated Use roles instead, the caching will take care of performance issues */
  directRoles: Maybe<Array<UserRole>>;
  /** @deprecated https://playvs.atlassian.net/browse/ID-1709 */
  email: Maybe<Scalars['String']['output']>;
  /** @deprecated https://playvs.atlassian.net/browse/ID-1709 */
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  emails: Maybe<Array<UserEmail>>;
  enrolledAt: Maybe<Scalars['DateTime']['output']>;
  enrolledTeamsByMetaseasonId: Maybe<Array<Team>>;
  esportInterests: Maybe<Array<Esport>>;
  firstName: Maybe<Scalars['String']['output']>;
  gameHighlights: Maybe<Array<Maybe<GameHighlight>>>;
  /** The year that a user will graduate from high school */
  gradYear: Maybe<Scalars['Int']['output']>;
  gradYears: Array<UserGradYear>;
  /** @deprecated needs to be refactored */
  hasScholasticTeamsAtSchool: Maybe<Scalars['Boolean']['output']>;
  hmac: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isNotCoaching: Maybe<Scalars['Boolean']['output']>;
  isPhoneNumberVisible: Maybe<Scalars['Boolean']['output']>;
  isUnderage: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  lastSeen: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated No longer supported */
  league: Maybe<League>;
  leagueScope: Maybe<AllLeaguesResult>;
  leagues: Maybe<Array<League>>;
  managedTeams: Maybe<Array<Team>>;
  name: Maybe<Scalars['String']['output']>;
  onlineStatus: Maybe<OnlineStatus>;
  phaseStats: Maybe<Array<PlayerPhaseStats>>;
  phone: Maybe<Scalars['String']['output']>;
  phoneExt: Maybe<Scalars['String']['output']>;
  playerProfileSnapshot: Maybe<PlayerProfileSnapshot>;
  promotionalEmail: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  referralLinks: Maybe<UserReferralLinks>;
  referralToken: Scalars['String']['output'];
  referredUsers: Maybe<Array<User>>;
  referringUser: Maybe<User>;
  roleRequests: Maybe<Array<RoleRequest>>;
  /** @deprecated No longer supported */
  roleReviews: Maybe<Array<RoleReview>>;
  roles: Maybe<Array<UserRole>>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  schoolRoleStatus: Maybe<Array<RoleStatus>>;
  seasonPasses: Maybe<Array<UserSeasonPass>>;
  shortName: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  submissions: Maybe<Array<UserSchoolSubmission>>;
  team: Maybe<Team>;
  teams: Maybe<Array<Team>>;
  teamsWherePrimaryCoach: Array<Team>;
  /** The user's preferred time zone for date/time localization, e.g. 'Africa/Johannesburg' */
  timeZone: Maybe<Scalars['String']['output']>;
  tosAcceptedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userDemographics: Maybe<UserDemographics>;
  userEsportPlatforms: Maybe<Array<UserEsportPlatform>>;
  userProviderAccounts: Maybe<Array<UserProviderAccount>>;
  userValidation: Maybe<UserValidation>;
  username: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  workEmail: Maybe<Scalars['String']['output']>;
};


export type IUserAssignedSeasonalAwardsArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type IUserAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type IUserEnrolledTeamsByMetaseasonIdArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type IUserGradYearArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type IUserHasScholasticTeamsAtSchoolArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type IUserLeagueArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


export type IUserLeagueScopeArgs = {
  filters?: InputMaybe<LeagueFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type IUserLeaguesArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


export type IUserManagedTeamsArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type IUserPhaseStatsArgs = {
  phaseId?: InputMaybe<Scalars['UUID']['input']>;
};


export type IUserRoleRequestsArgs = {
  filters?: InputMaybe<RoleRequestFilters>;
};


export type IUserSchoolRoleStatusArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type IUserTeamArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type IUserTeamsArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type IUserTeamsWherePrimaryCoachArgs = {
  schoolId: Scalars['UUID']['input'];
};

export type Image = {
  __typename?: 'Image';
  src: Scalars['String']['output'];
};

export type IncreaseReputationInput = {
  seasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type IndexPayload = {
  __typename?: 'IndexPayload';
  body: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type InitializeTaskQueuePayload = {
  __typename?: 'InitializeTaskQueuePayload';
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export enum IntegrationType {
  OAuth2 = 'OAuth2',
  OpenId = 'OpenId',
  Self = 'Self'
}

export enum IntervalTense {
  Current = 'current',
  Future = 'future',
  Past = 'past'
}

export enum InvoicePayStatus {
  Credited = 'Credited',
  Paid = 'Paid',
  PartiallyPaid = 'PartiallyPaid',
  Unpaid = 'Unpaid'
}

export enum InvoiceStatus {
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Error = 'Error',
  Initiated = 'Initiated',
  PostInProgress = 'PostInProgress',
  Posted = 'Posted',
  Rebilled = 'Rebilled'
}

export type IsUserAbleToJoinEventResponse = {
  __typename?: 'IsUserAbleToJoinEventResponse';
  reason: Maybe<UserUnableToJoinEventReason>;
  result: Scalars['Boolean']['output'];
};

export type JobPayload = {
  __typename?: 'JobPayload';
  jobNames: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export enum JobQueueStatus {
  Active = 'active',
  Delayed = 'delayed',
  Paused = 'paused',
  Wait = 'wait'
}

export type JobResult = {
  __typename?: 'JobResult';
  id: Scalars['String']['output'];
  isHighestPriority: Scalars['Boolean']['output'];
};

export type JoinQueueInput = {
  teamId: Scalars['String']['input'];
};

export type JoinQueueResponse = {
  __typename?: 'JoinQueueResponse';
  placeId: Maybe<Scalars['String']['output']>;
};

export type JoinScrimmageInput = {
  id: Scalars['UUID']['input'];
  opposingTeamId: Scalars['UUID']['input'];
};

export type JoinScrimmageResponse = {
  __typename?: 'JoinScrimmageResponse';
  cancelledScrimmageRequests: Maybe<Array<ScrimmageRequest>>;
  success: Scalars['Boolean']['output'];
};

export type JoinSmartQueueInput = {
  slotId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

export type JoinTeamOptions = {
  roleInviteCode?: InputMaybe<Scalars['String']['input']>;
};

export type LeaderboardMatchGameResultInput = {
  gameOrdinal: Scalars['Int']['input'];
  teamPlacements: Array<LeaderboardMatchTeamPlacementInput>;
};

export type LeaderboardMatchTeamPlacementInput = {
  placing: Scalars['Int']['input'];
  teamId: Scalars['UUID']['input'];
};

export type LeaderboardMetric = {
  __typename?: 'LeaderboardMetric';
  rank: Maybe<LeaderboardRankGroup>;
  value: Maybe<Scalars['Float']['output']>;
};

export type LeaderboardRankGroup = {
  __typename?: 'LeaderboardRankGroup';
  league: Maybe<Scalars['Int']['output']>;
  overall: Maybe<Scalars['Int']['output']>;
  state: Maybe<Scalars['Int']['output']>;
};

/**
 * A bounded competition format within which people play a particular
 * esport in a particular manner. Actual match play occurs in Seasons
 */
export type League = {
  __typename?: 'League';
  allSeasons: Maybe<Array<Season>>;
  canHaveMultipleTeamsWithSamePlayers: Maybe<Scalars['Boolean']['output']>;
  canRemovePlayersFromTeams: Maybe<Scalars['Boolean']['output']>;
  checkInCloseTimeOffsetMilliseconds: Maybe<Scalars['Int']['output']>;
  checkInOpenDaysBefore: Maybe<Scalars['Int']['output']>;
  checkInOpenTime: Maybe<Scalars['String']['output']>;
  competitionGroup: CompetitionGroup;
  competitionModel: CompetitionModel;
  displayName: Maybe<Scalars['String']['output']>;
  enrolledAt: Maybe<Scalars['DateTime']['output']>;
  esport: Esport;
  esportId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  isCheckInEnabled: Maybe<Scalars['Boolean']['output']>;
  isHidden: Maybe<Scalars['Boolean']['output']>;
  leagueGroups: Maybe<Array<LeagueGroup>>;
  lockTeamsToSchool: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  numberOfPossibleTeamsAndPlayers: Maybe<NumberOfPossibleTeamsAndPlayersResult>;
  publicSlug: Maybe<Scalars['String']['output']>;
  requirePrivateRoster: Scalars['Boolean']['output'];
  resources: Maybe<Array<Resource>>;
  rulebook: Maybe<EsportRulebook>;
  seasonByMetaseasonId: Maybe<Season>;
  /** Get all active seasons */
  seasons: Maybe<Array<Season>>;
  slug: Maybe<Scalars['String']['output']>;
  sponsorshipComponents: Maybe<Array<SponsorshipComponent>>;
  state: Maybe<Scalars['String']['output']>;
  teamFormat: Scalars['Int']['output'];
  teamMaxSize: Scalars['Int']['output'];
  teamMinimumStarterSize: Scalars['Int']['output'];
  teams: Maybe<Array<Team>>;
  timezone: Maybe<Scalars['String']['output']>;
  type: Maybe<LeagueType>;
  unconnectedUsers: Maybe<Array<User>>;
  upcomingMatches: Maybe<UpcomingMatchResult>;
  users: Maybe<Array<User>>;
  varsityAssociation: Maybe<VarsityAssociation>;
  varsityAssociationSlug: Maybe<Scalars['String']['output']>;
};


/**
 * A bounded competition format within which people play a particular
 * esport in a particular manner. Actual match play occurs in Seasons
 */
export type LeagueNumberOfPossibleTeamsAndPlayersArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


/**
 * A bounded competition format within which people play a particular
 * esport in a particular manner. Actual match play occurs in Seasons
 */
export type LeagueSeasonByMetaseasonIdArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


/**
 * A bounded competition format within which people play a particular
 * esport in a particular manner. Actual match play occurs in Seasons
 */
export type LeagueTeamsArgs = {
  metaseasonId: Scalars['UUID']['input'];
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


/**
 * A bounded competition format within which people play a particular
 * esport in a particular manner. Actual match play occurs in Seasons
 */
export type LeagueUnconnectedUsersArgs = {
  metaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
};


/**
 * A bounded competition format within which people play a particular
 * esport in a particular manner. Actual match play occurs in Seasons
 */
export type LeagueUpcomingMatchesArgs = {
  filters?: InputMaybe<UpcomingMatchInput>;
};


/**
 * A bounded competition format within which people play a particular
 * esport in a particular manner. Actual match play occurs in Seasons
 */
export type LeagueUsersArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};

export type LeagueFilters = {
  activatedMetaseasonId?: InputMaybe<Scalars['String']['input']>;
  competitionGroup?: InputMaybe<CompetitionGroup>;
  competitionGroups?: InputMaybe<Array<CompetitionGroup>>;
  competitionModel?: InputMaybe<Scalars['String']['input']>;
  enrollmentStatus?: InputMaybe<SeasonEnrollmentStatus>;
  esportIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedMetaseasonIds?: InputMaybe<Array<Scalars['String']['input']>>;
  healthStatus?: InputMaybe<LeagueHealthStatusType>;
  healthThreshold?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  inactivatedMetaseasonId?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  lastActiveMetaseasonId?: InputMaybe<Scalars['String']['input']>;
  leagueGroupId?: InputMaybe<Scalars['String']['input']>;
  metaseasonIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyHidden?: InputMaybe<Scalars['Boolean']['input']>;
  phaseTypes?: InputMaybe<Array<PhaseTypeFilter>>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  schoolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  varsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
  varsityAssociationSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LeagueFiltersInput = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A League Group */
export type LeagueGroup = {
  __typename?: 'LeagueGroup';
  competitionGroup: CompetitionGroup;
  id: Scalars['UUID']['output'];
  isHidden: Maybe<Scalars['Boolean']['output']>;
  leagues: Maybe<Array<League>>;
  name: Scalars['String']['output'];
  schools: Maybe<Array<School>>;
  state: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  stateAssociationSlug: Maybe<Scalars['String']['output']>;
  type: Maybe<LeagueType>;
  varsityAssociation: Maybe<VarsityAssociation>;
  varsityAssociationSlug: Maybe<Scalars['String']['output']>;
};

export type LeagueGroupFiltersInput = {
  competitionGroup?: InputMaybe<CompetitionGroup>;
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  leagueId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  varsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
};

export type LeagueGroupPayload = {
  __typename?: 'LeagueGroupPayload';
  league: Maybe<League>;
  leagueGroup: Maybe<LeagueGroup>;
  leagueGroupId: Scalars['UUID']['output'];
  leagueId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type LeagueGroupScope = {
  __typename?: 'LeagueGroupScope';
  leagueGroup: LeagueGroup;
  status: LeagueGroupScopeStatus;
};

export enum LeagueGroupScopeStatus {
  Approved = 'approved',
  Pending = 'pending'
}

export enum LeagueHealthStatusType {
  Healthy = 'healthy',
  Unhealthy = 'unhealthy'
}

export type LeagueOfLegendsBan = {
  __typename?: 'LeagueOfLegendsBan';
  champion: Maybe<LeagueOfLegendsChampion>;
  championId: Scalars['Int']['output'];
};

export type LeagueOfLegendsChampion = {
  __typename?: 'LeagueOfLegendsChampion';
  id: Scalars['UUID']['output'];
  image: Image;
  loadScreenImage: Image;
  name: Maybe<Scalars['String']['output']>;
};

export type LeagueOfLegendsGameDetail = {
  __typename?: 'LeagueOfLegendsGameDetail';
  bans: Maybe<Array<LeagueOfLegendsBan>>;
  itemIds: Maybe<Array<Scalars['Int']['output']>>;
  items: Maybe<Array<LeagueOfLegendsItem>>;
};

export type LeagueOfLegendsItem = {
  __typename?: 'LeagueOfLegendsItem';
  id: Scalars['UUID']['output'];
  image: Image;
};

export type LeagueOfLegendsMatchDetail = {
  __typename?: 'LeagueOfLegendsMatchDetail';
  championIds: Maybe<Array<Scalars['Int']['output']>>;
};

export type LeagueOfLegendsPlayer = {
  __typename?: 'LeagueOfLegendsPlayer';
  name: Maybe<Scalars['String']['output']>;
  summonerName: Scalars['String']['output'];
};

/** The League of Legends player stats for a game */
export type LeagueOfLegendsPlayerGameStats = LeagueOfLegendsStats & {
  __typename?: 'LeagueOfLegendsPlayerGameStats';
  assists: Scalars['Int']['output'];
  champion: Maybe<LeagueOfLegendsChampion>;
  championDamageDealt: Scalars['Int']['output'];
  championId: Scalars['Int']['output'];
  creepScore: Scalars['Int']['output'];
  detail: Maybe<LeagueOfLegendsGameDetail>;
  eliminationParticipation: Scalars['Float']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstElimination: Scalars['Boolean']['output'];
  firstEliminationAssist: Scalars['Boolean']['output'];
  firstInhibitor: Scalars['Boolean']['output'];
  firstTower: Scalars['Boolean']['output'];
  goldEarned: Scalars['Int']['output'];
  goldPerMinute: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  inhibitorsDestroyed: Scalars['Int']['output'];
  player: Maybe<LeagueOfLegendsPlayer>;
  respawns: Scalars['Int']['output'];
  rosterPosition: LeagueOfLegendsRosterPosition;
  totalDamageDealt: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
  visionScore: Scalars['Int']['output'];
  wardsDestroyed: Scalars['Int']['output'];
  wardsPlaced: Scalars['Int']['output'];
};

/** The League of Legends player stats for a match */
export type LeagueOfLegendsPlayerMatchStats = LeagueOfLegendsStats & {
  __typename?: 'LeagueOfLegendsPlayerMatchStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageCreepScore: Scalars['Float']['output'];
  averageEliminations: Scalars['Float']['output'];
  averageGoldEarned: Scalars['Float']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  averageInhibitorsDestroyed: Scalars['Float']['output'];
  averageRespawns: Scalars['Float']['output'];
  averageTowersDestroyed: Scalars['Float']['output'];
  averageWardsDestroyed: Scalars['Float']['output'];
  championDamageDealt: Scalars['Int']['output'];
  champions: Maybe<Array<LeagueOfLegendsChampion>>;
  creepScore: Scalars['Int']['output'];
  detail: Maybe<LeagueOfLegendsMatchDetail>;
  eliminationParticipation: Scalars['Float']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstTowers: Scalars['Int']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  inhibitorsDestroyed: Scalars['Int']['output'];
  respawns: Scalars['Int']['output'];
  totalDamageDealt: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
  wardsDestroyed: Scalars['Int']['output'];
  wardsPlaced: Scalars['Int']['output'];
};

/** The League of Legends player stats for a phase */
export type LeagueOfLegendsPlayerPhaseStats = LeagueOfLegendsStats & {
  __typename?: 'LeagueOfLegendsPlayerPhaseStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageCreepScore: Scalars['Float']['output'];
  averageEliminations: Scalars['Float']['output'];
  averageGoldEarned: Scalars['Float']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  averageInhibitorsDestroyed: Scalars['Float']['output'];
  averageRespawns: Scalars['Float']['output'];
  averageTowersDestroyed: Scalars['Float']['output'];
  averageWardsDestroyed: Scalars['Float']['output'];
  championDamageDealt: Scalars['Int']['output'];
  creepScore: Scalars['Int']['output'];
  eliminationParticipation: Scalars['Float']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstTowers: Scalars['Int']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  inhibitorsDestroyed: Scalars['Int']['output'];
  mostPickedChampion: Maybe<LeagueOfLegendsChampion>;
  mostPickedChampionId: Scalars['Int']['output'];
  respawns: Scalars['Int']['output'];
  totalDamageDealt: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
  wardsDestroyed: Scalars['Int']['output'];
  wardsPlaced: Scalars['Int']['output'];
};

export enum LeagueOfLegendsRosterPosition {
  Adc = 'adc',
  Jungler = 'jungler',
  Middle = 'middle',
  Support = 'support',
  Top = 'top'
}

export type LeagueOfLegendsStats = {
  assists: Scalars['Int']['output'];
  championDamageDealt: Scalars['Int']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  inhibitorsDestroyed: Scalars['Int']['output'];
  respawns: Scalars['Int']['output'];
  totalDamageDealt: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
  wardsDestroyed: Scalars['Int']['output'];
  wardsPlaced: Scalars['Int']['output'];
};

/** The League of Legends team stats for a game */
export type LeagueOfLegendsTeamGameStats = LeagueOfLegendsStats & {
  __typename?: 'LeagueOfLegendsTeamGameStats';
  assists: Scalars['Int']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  baronEliminations: Scalars['Int']['output'];
  championDamageDealt: Scalars['Int']['output'];
  creepScore: Scalars['Int']['output'];
  detail: Maybe<LeagueOfLegendsGameDetail>;
  dragonEliminations: Scalars['Int']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstElimination: Scalars['Boolean']['output'];
  firstInhibitor: Scalars['Boolean']['output'];
  firstTower: Scalars['Boolean']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  inhibitorsDestroyed: Scalars['Int']['output'];
  respawns: Scalars['Int']['output'];
  totalDamageDealt: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
  wardsDestroyed: Scalars['Int']['output'];
  wardsPlaced: Scalars['Int']['output'];
};

export type LeagueOfLegendsTeamGameStatsExtended = LeagueOfLegendsStats & {
  __typename?: 'LeagueOfLegendsTeamGameStatsExtended';
  assists: Scalars['Int']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  baronEliminations: Scalars['Int']['output'];
  championDamageDealt: Scalars['Int']['output'];
  champions: Maybe<Array<LeagueOfLegendsChampion>>;
  creepScore: Scalars['Int']['output'];
  detail: Maybe<LeagueOfLegendsGameDetail>;
  dragonEliminations: Scalars['Int']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstElimination: Scalars['Boolean']['output'];
  firstInhibitor: Scalars['Boolean']['output'];
  firstTower: Scalars['Boolean']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  inhibitorsDestroyed: Scalars['Int']['output'];
  respawns: Scalars['Int']['output'];
  totalDamageDealt: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
  wardsDestroyed: Scalars['Int']['output'];
  wardsPlaced: Scalars['Int']['output'];
};

/** The League of Legends team stats for a match */
export type LeagueOfLegendsTeamMatchStats = LeagueOfLegendsStats & {
  __typename?: 'LeagueOfLegendsTeamMatchStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageBaronEliminations: Scalars['Float']['output'];
  averageCreepScore: Scalars['Float']['output'];
  averageEliminations: Scalars['Float']['output'];
  averageGoldEarned: Scalars['Float']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  averageInhibitorsDestroyed: Scalars['Float']['output'];
  averageRespawns: Scalars['Float']['output'];
  averageTowersDestroyed: Scalars['Float']['output'];
  averageWardsDestroyed: Scalars['Float']['output'];
  baronEliminations: Scalars['Int']['output'];
  championDamageDealt: Scalars['Int']['output'];
  champions: Maybe<Array<LeagueOfLegendsChampion>>;
  dragonEliminations: Scalars['Int']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstEliminationRate: Scalars['Float']['output'];
  firstTowerRate: Scalars['Float']['output'];
  firstTowers: Scalars['Int']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  inhibitorsDestroyed: Scalars['Int']['output'];
  respawns: Scalars['Int']['output'];
  totalDamageDealt: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
  wardsDestroyed: Scalars['Int']['output'];
  wardsPlaced: Scalars['Int']['output'];
};

/** The League of Legends team stats for a phase */
export type LeagueOfLegendsTeamPhaseStats = LeagueOfLegendsStats & {
  __typename?: 'LeagueOfLegendsTeamPhaseStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageBaronEliminations: Scalars['Float']['output'];
  averageCreepScore: Scalars['Float']['output'];
  averageEliminations: Scalars['Float']['output'];
  averageGoldEarned: Scalars['Float']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  averageInhibitorsDestroyed: Scalars['Float']['output'];
  averageRespawns: Scalars['Float']['output'];
  averageTowersDestroyed: Scalars['Float']['output'];
  averageWardsDestroyed: Scalars['Float']['output'];
  baronEliminations: Scalars['Int']['output'];
  championDamageDealt: Scalars['Int']['output'];
  champions: Maybe<Array<LeagueOfLegendsChampion>>;
  dragonEliminations: Scalars['Int']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstEliminationRate: Scalars['Float']['output'];
  firstTowerRate: Scalars['Float']['output'];
  firstTowers: Scalars['Int']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  inhibitorsDestroyed: Scalars['Int']['output'];
  respawns: Scalars['Int']['output'];
  totalDamageDealt: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
  wardsDestroyed: Scalars['Int']['output'];
  wardsPlaced: Scalars['Int']['output'];
};

export type LeaguePayload = {
  __typename?: 'LeaguePayload';
  league: Maybe<League>;
  leagueId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type LeaguePlayerData = {
  __typename?: 'LeaguePlayerData';
  leagueId: Scalars['String']['output'];
  leagueName: Scalars['String']['output'];
  playerId: Scalars['UUID']['output'];
  teamId: Scalars['UUID']['output'];
};

export type LeaguePreview = {
  __typename?: 'LeaguePreview';
  league: League;
  nextSeason: Maybe<Season>;
  nextSlot: Maybe<Slot>;
};

/** A classification on whether or not a league is officially recognized by the sports association */
export enum LeagueType {
  Sanctioned = 'sanctioned',
  Unsanctioned = 'unsanctioned'
}

export type LeaguesPayload = {
  __typename?: 'LeaguesPayload';
  leagueIds: Array<Scalars['UUID']['output']>;
  leagues: Maybe<Array<Maybe<League>>>;
  success: Scalars['Boolean']['output'];
};

export type LeaveQueueInput = {
  placeId: Scalars['String']['input'];
};

export type LeaveQueueResponse = {
  __typename?: 'LeaveQueueResponse';
  success: Maybe<Scalars['Boolean']['output']>;
};

export type LeaveSmartQueueInput = {
  slotId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

/** Available base notification types */
export type LegacyNotification = {
  __typename?: 'LegacyNotification';
  buttonText: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  href: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: NotificationStatus;
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** User scoped notifications */
export type LegacyUserNotification = {
  __typename?: 'LegacyUserNotification';
  id: Scalars['UUID']['output'];
  notification: LegacyNotification;
  rescheduleMatchId: Maybe<Scalars['UUID']['output']>;
  scrimmageRequestId: Maybe<Scalars['UUID']['output']>;
  status: UserNotificationStatus;
  surveyMatchId: Maybe<Scalars['UUID']['output']>;
  total: Maybe<Scalars['Int']['output']>;
  userId: Scalars['UUID']['output'];
  validOn: Scalars['DateTime']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export type Link = {
  __typename?: 'Link';
  id: Scalars['UUID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LinkEpicAccountInput = {
  accountId: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
};

export type LinkEpicGamesAccountInput = {
  accountId: Scalars['UUID']['input'];
  displayName: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

export type LinkManualAccountInput = {
  displayName: Scalars['String']['input'];
  provider: Provider;
};

export type LinkNintendoAccountInput = {
  displayName: Scalars['String']['input'];
};

export type LinkPlayStationNetworkAccountInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  playStationId?: InputMaybe<Scalars['String']['input']>;
  psnUsername: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

export type LinkSmiteAccountInput = {
  smitePlayerName: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

export type ListUserSeasonsResult = {
  __typename?: 'ListUserSeasonsResult';
  enrolledSeasonIds: Array<Scalars['UUID']['output']>;
  enrolledSeasons: UserSeasonsResult;
  ongoingSeasonIds: Array<Scalars['UUID']['output']>;
  ongoingSeasons: UserSeasonsResult;
  pastSeasonIds: Array<Scalars['UUID']['output']>;
  pastSeasons: UserSeasonsResult;
  upcomingSeasonIds: Array<Scalars['UUID']['output']>;
  upcomingSeasons: UserSeasonsResult;
};

export type LobbyEvent = {
  __typename?: 'LobbyEvent';
  eventType: Scalars['String']['output'];
  summonerId: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
};

export type LobbyEventsResponse = {
  __typename?: 'LobbyEventsResponse';
  events: Maybe<Array<LobbyEvent>>;
};

export type LobbyInfoResponse = {
  __typename?: 'LobbyInfoResponse';
  code: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  lobbyName: Maybe<Scalars['String']['output']>;
  map: Maybe<Scalars['String']['output']>;
  metaData: Maybe<Scalars['String']['output']>;
  participants: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  password: Maybe<Scalars['String']['output']>;
  pickType: Maybe<Scalars['String']['output']>;
  providerId: Maybe<Scalars['Int']['output']>;
  region: Maybe<Scalars['String']['output']>;
  spectators: Maybe<Scalars['String']['output']>;
  teamSize: Maybe<Scalars['Int']['output']>;
  tournamentId: Maybe<Scalars['Int']['output']>;
};

export type LoginUserInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginUserResponse = {
  __typename?: 'LoginUserResponse';
  token: Maybe<Scalars['String']['output']>;
  user: User;
};

export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  success: Scalars['Boolean']['output'];
};

export type MaddenGameStats = {
  __typename?: 'MaddenGameStats';
  gameId: Scalars['UUID']['output'];
  players: Array<MaddenPlayerGameStats>;
  winner: Scalars['UUID']['output'];
};

export type MaddenMostPlayedStatsByPlayerId = {
  __typename?: 'MaddenMostPlayedStatsByPlayerId';
  averageScore: Scalars['Float']['output'];
  mostPlayedDefensivePlaybooks: Array<Maybe<MaddenPlayedWinRate>>;
  mostPlayedOffensivePlaybooks: Array<Maybe<MaddenPlayedWinRate>>;
  mostPlayedTeams: Array<Maybe<MaddenPlayedWinRate>>;
  playerId: Scalars['UUID']['output'];
};

export type MaddenPlayedWinRate = {
  __typename?: 'MaddenPlayedWinRate';
  assetUri: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  played: Scalars['Float']['output'];
  winRate: Scalars['Float']['output'];
};

export type MaddenPlayerGameStats = {
  __typename?: 'MaddenPlayerGameStats';
  defensivePlaybookPlayed: Scalars['String']['output'];
  offensivePlaybookPlayed: Scalars['String']['output'];
  playerId: Scalars['UUID']['output'];
  score: Scalars['Int']['output'];
  teamId: Scalars['UUID']['output'];
  teamPlayed: Scalars['String']['output'];
};

export type ManuallySeedPlayoffPhasesInput = {
  leagues: Array<ManuallySeedPlayoffPhasesLeagueInput>;
};

export type ManuallySeedPlayoffPhasesLeagueInput = {
  bracketSize: Scalars['Int']['input'];
  leagueId: Scalars['UUID']['input'];
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  phaseId?: InputMaybe<Scalars['UUID']['input']>;
  teams: Array<ManuallySeedPlayoffPhasesTeamInput>;
};

export type ManuallySeedPlayoffPhasesTeamInput = {
  rankingPointsOverride?: InputMaybe<Scalars['Float']['input']>;
  teamId: Scalars['UUID']['input'];
};

export type MarkAllUserNotificationsOpenedResult = {
  __typename?: 'MarkAllUserNotificationsOpenedResult';
  success: Scalars['Boolean']['output'];
};

export type MarkAllUserNotificationsReadInput = {
  lastReadNotificationId: Scalars['ObjectID']['input'];
};

export type MarkAllUserNotificationsReadResult = {
  __typename?: 'MarkAllUserNotificationsReadResult';
  success: Scalars['Boolean']['output'];
  userNotificationsId: Scalars['UUID']['output'];
};

export type MarkUserNotificationCompletedInput = {
  userNotificationId: Scalars['ObjectID']['input'];
};

export type MarkUserNotificationCompletedResult = {
  __typename?: 'MarkUserNotificationCompletedResult';
  success: Scalars['Boolean']['output'];
  userNotificationId: Scalars['ObjectID']['output'];
};

export type MarkUserNotificationOpenedInput = {
  userNotificationId: Scalars['ObjectID']['input'];
};

export type MarkUserNotificationOpenedResult = {
  __typename?: 'MarkUserNotificationOpenedResult';
  success: Scalars['Boolean']['output'];
  userNotification: Maybe<UserNotification>;
  userNotificationId: Scalars['ObjectID']['output'];
};

export type MarkUserNotificationTaskOpenedResult = {
  __typename?: 'MarkUserNotificationTaskOpenedResult';
  success: Scalars['Boolean']['output'];
  userNotification: Maybe<UserNotification>;
  userNotificationId: Scalars['ObjectID']['output'];
};

export type Match = {
  __typename?: 'Match';
  archivedAt: Maybe<Scalars['DateTime']['output']>;
  autoForfeited: Maybe<Scalars['Boolean']['output']>;
  bestOf: Maybe<Scalars['Int']['output']>;
  canBeRescheduledByAdmin: Maybe<Scalars['Boolean']['output']>;
  chatMetadata: Maybe<ChatMetadata>;
  chatUrl: Maybe<Scalars['String']['output']>;
  checkInClosesAt: Maybe<Scalars['DateTime']['output']>;
  checkInOpensAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Discord is no longer used for managing matches */
  discordLink: Maybe<Scalars['String']['output']>;
  disqualifyAfter: Maybe<Scalars['Int']['output']>;
  esport: Esport;
  esportId: Scalars['UUID']['output'];
  forfeitDetail: Maybe<Scalars['String']['output']>;
  forfeitReason: Maybe<ForfeitReason>;
  forfeitedBy: Maybe<Scalars['UUID']['output']>;
  forfeitedByUser: Maybe<User>;
  format: Maybe<MatchFormat>;
  fortniteTeamMatchStats: Maybe<FortniteTeamMatchStatsResult>;
  games: Maybe<Array<Game>>;
  gamesNotCancelled: Maybe<Array<Game>>;
  headToHeadMatchScores: Maybe<HeadToHeadMatchTeamScores>;
  hearthstonePlayerDefaultDeckSelection: Maybe<Array<HearthstoneDeck>>;
  hearthstonePlayerMatchDeckSelection: Maybe<Array<HearthstoneDeck>>;
  id: Scalars['UUID']['output'];
  isScrimmage: Maybe<Scalars['Boolean']['output']>;
  isSettleable: Scalars['Boolean']['output'];
  isSettleableByACoach: Scalars['Boolean']['output'];
  isUnderReview: Maybe<Scalars['Boolean']['output']>;
  league: Maybe<League>;
  matchAssignment: Maybe<MatchAssignment>;
  matchAssignmentHistory: Maybe<Array<MatchAssignment>>;
  matchAssistantEnabled: Maybe<Scalars['Boolean']['output']>;
  matchCheckIns: Array<MatchCheckIn>;
  matchDisputeRequests: Maybe<Array<MatchDisputeRequest>>;
  matchForfeitedEvents: Maybe<Array<MatchLedgerEvent>>;
  matchRescheduleRequests: Maybe<Array<MatchRescheduleRequest>>;
  matchResults: Maybe<Array<MatchResult>>;
  matchSettleRequests: Maybe<Array<MatchSettleRequestModel>>;
  matchStatusChangeEvents: Maybe<Array<MatchLedgerEvent>>;
  metaseasonId: Maybe<Scalars['UUID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  opponent: Maybe<Team>;
  playerMatchStats: Maybe<Array<PlayerMatchStats>>;
  scheduleContext: Maybe<MatchScheduleContext>;
  scheduledStartsAt: Maybe<Scalars['DateTime']['output']>;
  scrimmageRequest: Maybe<ScrimmageRequest>;
  series: Maybe<Array<Series>>;
  seriesBestOf: Maybe<Scalars['Int']['output']>;
  slot: Maybe<Slot>;
  slotId: Maybe<Scalars['UUID']['output']>;
  status: MatchStatus;
  /** @deprecated use Match.teamContext instead */
  team1: Maybe<MatchTeam>;
  /** @deprecated use Match.headToHeadMatchScores for Head v Head matches instead */
  team1Score: Maybe<Scalars['Int']['output']>;
  /** @deprecated use Match.teamContext instead */
  team2: Maybe<MatchTeam>;
  /** @deprecated use Match.headToHeadMatchScores for Head v Head matches instead */
  team2Score: Maybe<Scalars['Int']['output']>;
  teamContext: MatchTeamContext;
  teamMatchStats: Maybe<Array<TeamMatchStats>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  week: Maybe<Scalars['Int']['output']>;
  /** Designates the winning team. If the match is not completed, this field will be null. */
  winningTeamId: Maybe<Scalars['UUID']['output']>;
};


export type MatchFortniteTeamMatchStatsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MatchOpponentArgs = {
  teamId: Scalars['String']['input'];
};

export type MatchAssignment = {
  __typename?: 'MatchAssignment';
  assignee: Maybe<User>;
  assigneeId: Maybe<Scalars['UUID']['output']>;
  assigner: Maybe<User>;
  assignerId: Scalars['UUID']['output'];
  assignmentStatus: MatchAssignmentStatus;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  matchId: Scalars['UUID']['output'];
  notes: Maybe<Scalars['String']['output']>;
};

export enum MatchAssignmentStatus {
  Assigned = 'assigned',
  Unassigned = 'unassigned'
}

export type MatchChatEvent = {
  __typename?: 'MatchChatEvent';
  changesTo: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  esportId: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  object: Scalars['String']['output'];
  sendMessage: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MatchChatEventResults = {
  __typename?: 'MatchChatEventResults';
  matchChatEvent: MatchChatEvent;
};

export type MatchChatEventsResults = {
  __typename?: 'MatchChatEventsResults';
  matchChatEvents: Array<MatchChatEvent>;
};

export type MatchChatJobResults = {
  __typename?: 'MatchChatJobResults';
  jobs: Array<JobResult>;
  nextJob: Maybe<JobResult>;
};

export type MatchCheckIn = {
  __typename?: 'MatchCheckIn';
  id: Scalars['UUID']['output'];
  match: Maybe<Match>;
  matchId: Scalars['UUID']['output'];
  status: Maybe<Scalars['String']['output']>;
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type MatchCheckInFilters = {
  matchIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export enum MatchCheckInStatus {
  Completed = 'completed',
  Started = 'started'
}

export type MatchCheckInUpsertParams = {
  matchId: Scalars['UUID']['input'];
  status?: InputMaybe<MatchCheckInStatus>;
  teamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type MatchDateRange = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum MatchDisputeFeedback {
  Negative = 'negative',
  Positive = 'positive'
}

export type MatchDisputeFeedbackInput = {
  feedback: MatchDisputeFeedback;
  feedbackDetail: Scalars['String']['input'];
  matchDisputeRequestId: Scalars['UUID']['input'];
};

export enum MatchDisputeReason {
  Completed = 'completed',
  Incorrect = 'incorrect',
  Other = 'other',
  Unplayed = 'unplayed'
}

export type MatchDisputeRequest = {
  __typename?: 'MatchDisputeRequest';
  asset: Maybe<Asset>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  feedback: Maybe<Scalars['String']['output']>;
  feedbackDetail: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  match: Maybe<Match>;
  matchId: Scalars['UUID']['output'];
  notes: Maybe<Scalars['String']['output']>;
  reason: Maybe<MatchDisputeReason>;
  requestedBy: Maybe<User>;
  requestedById: Scalars['UUID']['output'];
  status: MatchDisputeStatus;
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type MatchDisputeRequestInput = {
  matchDisputeRequestId: Scalars['UUID']['input'];
};

export enum MatchDisputeStatus {
  Dismissed = 'dismissed',
  Pending = 'pending',
  Resolved = 'resolved'
}

export type MatchFiltersInput = {
  assigneeIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  checkInIsOpen?: InputMaybe<Scalars['Boolean']['input']>;
  competitionGroup?: InputMaybe<CompetitionGroup>;
  createdAt?: InputMaybe<MatchDateRange>;
  esport?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  esportSlug?: InputMaybe<Array<Scalars['String']['input']>>;
  gameStatus?: InputMaybe<Array<InputMaybe<GameStatus>>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
  isUnderReview?: InputMaybe<Scalars['Boolean']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  leagueName?: InputMaybe<Scalars['String']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  metaseasonIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  needAttention?: InputMaybe<Scalars['Boolean']['input']>;
  phaseIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  phaseNames?: InputMaybe<Array<Scalars['String']['input']>>;
  phaseStatuses?: InputMaybe<Array<PhaseStatus>>;
  phaseTypes?: InputMaybe<Array<PhaseType>>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<Scalars['String']['input']>;
  seasonIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  slotId?: InputMaybe<Scalars['UUID']['input']>;
  startsAt?: InputMaybe<MatchDateRange>;
  status?: InputMaybe<Array<MatchStatus>>;
  teamIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  unassignedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<MatchDateRange>;
};

export enum MatchFormat {
  HeadToHead = 'head_to_head',
  Leaderboard = 'leaderboard'
}

export type MatchJobPayload = {
  __typename?: 'MatchJobPayload';
  jobId: Scalars['UUID']['output'];
};

export type MatchLedgerEvent = {
  __typename?: 'MatchLedgerEvent';
  actedById: Maybe<Scalars['String']['output']>;
  actedByName: Maybe<Scalars['String']['output']>;
  details: Maybe<Scalars['String']['output']>;
  eventType: Maybe<MatchLedgerEventType>;
  matchId: Scalars['UUID']['output'];
  occurAt: Maybe<Scalars['DateTime']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  status: Maybe<MatchStatus>;
};

export enum MatchLedgerEventType {
  MatchForfeited = 'match_forfeited',
  StatusChange = 'status_change'
}

export type MatchPayload = {
  __typename?: 'MatchPayload';
  match: Maybe<Match>;
  matchId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type MatchQueuePlace = {
  __typename?: 'MatchQueuePlace';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  match: Maybe<Match>;
  status: QueueStatus;
  team: Maybe<Team>;
  teamId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MatchRescheduleDateRange = {
  __typename?: 'MatchRescheduleDateRange';
  after: Maybe<Scalars['DateTime']['output']>;
  before: Maybe<Scalars['DateTime']['output']>;
};

export type MatchRescheduleRequest = {
  __typename?: 'MatchRescheduleRequest';
  approvedBy: Maybe<User>;
  approvedById: Maybe<Scalars['UUID']['output']>;
  canceledBy: Maybe<User>;
  canceledById: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deniedBy: Maybe<User>;
  deniedById: Maybe<Scalars['UUID']['output']>;
  denyNotes: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  matchId: Scalars['UUID']['output'];
  proposedTimes: Maybe<Array<Scalars['DateTime']['output']>>;
  requestedBy: Maybe<User>;
  requestedById: Maybe<Scalars['UUID']['output']>;
  rescheduleNotes: Maybe<Scalars['String']['output']>;
  rescheduleReason: Maybe<MatchRescheduleRequestReason>;
  status: Maybe<MatchRescheduleRequestStatus>;
  teamId: Scalars['UUID']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  updatedStartsAt: Maybe<Scalars['DateTime']['output']>;
};

export enum MatchRescheduleRequestReason {
  CovidSchoolClosure = 'covidSchoolClosure',
  NotEnoughPlayers = 'notEnoughPlayers',
  Other = 'other',
  PlatformIssues = 'platformIssues',
  SchoolClosed = 'schoolClosed',
  TechIssues = 'techIssues'
}

export enum MatchRescheduleRequestStatus {
  Approved = 'approved',
  Cancelled = 'cancelled',
  Denied = 'denied',
  Expired = 'expired',
  Pending = 'pending',
  Processed = 'processed'
}

export enum MatchRescheduleResponse {
  Approved = 'approved',
  Denied = 'denied',
  Resubmitted = 'resubmitted'
}

export type MatchResult = {
  __typename?: 'MatchResult';
  avgPlacement: Maybe<Scalars['Float']['output']>;
  gamesLost: Maybe<Scalars['Int']['output']>;
  gamesLostByForfeit: Maybe<Scalars['Int']['output']>;
  gamesPlayed: Maybe<Scalars['Int']['output']>;
  gamesTied: Maybe<Scalars['Int']['output']>;
  gamesWon: Maybe<Scalars['Int']['output']>;
  gamesWonByForfeit: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  match: Maybe<Match>;
  matchId: Scalars['UUID']['output'];
  metaseasonId: Maybe<Scalars['UUID']['output']>;
  numOfFirstPlace: Maybe<Scalars['Int']['output']>;
  numOfTopFourPlace: Maybe<Scalars['Int']['output']>;
  placing: Maybe<Scalars['Int']['output']>;
  seriesLost: Maybe<Scalars['Int']['output']>;
  seriesLostByForfeit: Maybe<Scalars['Int']['output']>;
  seriesPlayed: Maybe<Scalars['Int']['output']>;
  seriesTied: Maybe<Scalars['Int']['output']>;
  seriesWon: Maybe<Scalars['Int']['output']>;
  seriesWonByForfeit: Maybe<Scalars['Int']['output']>;
  team: Maybe<Team>;
  teamId: Maybe<Scalars['UUID']['output']>;
  teamSide: Maybe<Scalars['Int']['output']>;
};

export enum MatchScheduleContext {
  Admin = 'admin',
  AdminReschedule = 'admin_reschedule',
  /** @deprecated No longer supported */
  BracketAutoSchedule = 'bracket_auto_schedule',
  /** @deprecated No longer supported */
  BreakWeekBye = 'break_week_bye',
  BulkAction = 'bulk_action',
  DemoData = 'demo_data',
  DoubleEliminationPairingMatch = 'double_elimination_pairing_match',
  /** @deprecated No longer supported */
  PhaseScheduler = 'phase_scheduler',
  PreseasonQueueMatch = 'preseason_queue_match',
  Reschedule = 'reschedule',
  RoundRobinPairingBye = 'round_robin_pairing_bye',
  RoundRobinPairingMatch = 'round_robin_pairing_match',
  ScrimmageCreator = 'scrimmage_creator',
  ScrimmageQueue = 'scrimmage_queue',
  SingleEliminationPairingBye = 'single_elimination_pairing_bye',
  SingleEliminationPairingMatch = 'single_elimination_pairing_match',
  SmartScheduleBreakWeekBye = 'smart_schedule_break_week_bye',
  SmartScheduleMatch = 'smart_schedule_match',
  SmartSchedulePairingBye = 'smart_schedule_pairing_bye',
  SmartScheduleScheduledMatch = 'smart_schedule_scheduled_match',
  /** @deprecated No longer supported */
  SmartSchedulerPrescheduled = 'smart_scheduler_prescheduled',
  SmartSchedulerQueue = 'smart_scheduler_queue',
  SwissBreakWeekBye = 'swiss_break_week_bye',
  SwissPairingBye = 'swiss_pairing_bye',
  SwissPairingMatch = 'swiss_pairing_match'
}

export enum MatchSettleIncompleteReason {
  IssueJoiningGame = 'issueJoiningGame',
  MyTeamQuit = 'myTeamQuit',
  OpposingTeamQuit = 'opposingTeamQuit',
  Other = 'other',
  TechnologyIssues = 'technologyIssues'
}

export type MatchSettleRequestAssetsUpdatedSubscribeInput = {
  matchSettleRequestId: Scalars['String']['input'];
};

export type MatchSettleRequestModel = {
  __typename?: 'MatchSettleRequestModel';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  forfeitReason: Maybe<ForfeitReason>;
  id: Scalars['UUID']['output'];
  incompleteNotes: Maybe<Scalars['String']['output']>;
  incompleteReason: Maybe<MatchSettleIncompleteReason>;
  isReadyForReview: Maybe<Scalars['Boolean']['output']>;
  match: Maybe<Match>;
  matchId: Scalars['UUID']['output'];
  requestedBy: Maybe<User>;
  requestedById: Maybe<Scalars['UUID']['output']>;
  results: Maybe<MatchSettleRequestResults>;
  status: Maybe<MatchSettleRequestStatus>;
  team: Maybe<Team>;
  teamId: Maybe<Scalars['UUID']['output']>;
  type: Maybe<MatchSettleRequestType>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type MatchSettleRequestResults = {
  __typename?: 'MatchSettleRequestResults';
  seriesResults: Maybe<Array<SeriesResultRequest>>;
};

export enum MatchSettleRequestStatus {
  Approved = 'approved',
  Dismissed = 'dismissed',
  Incomplete = 'incomplete',
  Requested = 'requested',
  Settled = 'settled'
}

export type MatchSettleRequestSubmittedSubscribeInput = {
  matchSettleRequestId: Scalars['String']['input'];
};

export type MatchSettleRequestTeam = {
  __typename?: 'MatchSettleRequestTeam';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export enum MatchSettleRequestType {
  Admin = 'admin',
  Coach = 'coach',
  Player = 'player'
}

export type MatchSettleRequestUpdatedSubscribeInput = {
  matchId: Scalars['String']['input'];
};

export type MatchSettleRequestWithWinningTeamPayload = {
  __typename?: 'MatchSettleRequestWithWinningTeamPayload';
  errors: Maybe<Array<Scalars['String']['output']>>;
  gameAssistantStepHasBeenUpdated: Scalars['Boolean']['output'];
  gameRejected: Scalars['Boolean']['output'];
  match: Maybe<Match>;
  matchHasBeenAutoSettled: Scalars['Boolean']['output'];
  matchSettleRequest: Maybe<MatchSettleRequestModel>;
  success: Scalars['Boolean']['output'];
  winningTeam: Maybe<Team>;
  winningTeamId: Maybe<Scalars['UUID']['output']>;
};

export type MatchSlot = {
  __typename?: 'MatchSlot';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  match: Maybe<Match>;
  name: Maybe<Scalars['String']['output']>;
  ordinal: Scalars['Int']['output'];
  slotId: Scalars['UUID']['output'];
  startsAt: Maybe<Scalars['DateTime']['output']>;
  teamSlots: Maybe<Array<TeamSlot>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type MatchSortSpec = {
  fieldName: Scalars['String']['input'];
  fieldSortDir: Scalars['String']['input'];
};

export enum MatchStatus {
  Bye = 'bye',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Forfeited = 'forfeited',
  Live = 'live',
  Open = 'open',
  Quarantined = 'quarantined',
  Rescheduled = 'rescheduled',
  Rescheduling = 'rescheduling',
  Reviewed = 'reviewed',
  Scheduled = 'scheduled'
}

export type MatchSurvey = {
  __typename?: 'MatchSurvey';
  funRating: Maybe<Scalars['Int']['output']>;
  matchId: Scalars['UUID']['output'];
  matchSetupRating: Maybe<Scalars['Int']['output']>;
  opponentCompetitivenessRating: Maybe<Scalars['Int']['output']>;
  shouldContact: Maybe<Scalars['Boolean']['output']>;
  surveyComment: Maybe<Scalars['String']['output']>;
  userId: Scalars['UUID']['output'];
};

export type MatchSurveyInput = {
  funRating?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['UUID']['input'];
  matchSetupRating?: InputMaybe<Scalars['Int']['input']>;
  opponentCompetitivenessRating?: InputMaybe<Scalars['Int']['input']>;
  shouldContact?: InputMaybe<Scalars['Boolean']['input']>;
  surveyComment?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};

export type MatchTeam = ITeam & {
  __typename?: 'MatchTeam';
  /** @deprecated use enrolledSeasons */
  allSeasons: Maybe<Array<Season>>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  captain: Maybe<User>;
  coaches: Maybe<Array<TeamCoach>>;
  competitionGroup: Maybe<CompetitionGroup>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Scalars['UUID']['output']>;
  createdByUser: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  deletedById: Maybe<Scalars['UUID']['output']>;
  enrolledSeasons: Maybe<Array<Season>>;
  enrollmentStatus: SeasonEnrollmentStatus;
  esport: Esport;
  esportId: Scalars['UUID']['output'];
  eventSeasonId: Maybe<Scalars['UUID']['output']>;
  getEligiblePlayers: Maybe<Array<EligiblePlayer>>;
  globalStats: Maybe<TeamGlobalStats>;
  id: Scalars['UUID']['output'];
  inviteUrl: Maybe<Scalars['String']['output']>;
  isEnrolledInCurrentMetaseason: Maybe<Scalars['Boolean']['output']>;
  isFixedRoster: Maybe<Scalars['Boolean']['output']>;
  isMyTeam: Maybe<Scalars['Boolean']['output']>;
  isPlayerLed: Maybe<Scalars['Boolean']['output']>;
  isPrivateRoster: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  league: Maybe<League>;
  leagues: Maybe<Array<League>>;
  matchId: Maybe<Scalars['String']['output']>;
  /** @deprecated use Team.roster instead */
  members: Maybe<Array<TeamMember>>;
  name: Maybe<Scalars['String']['output']>;
  nextOpponent: Maybe<Team>;
  owners: Maybe<Array<User>>;
  phaseMatches: Maybe<Array<Match>>;
  phaseResult: Maybe<PhaseResult>;
  phases: Maybe<Array<PhaseTeam>>;
  rallySchool: Maybe<School>;
  recommendationPercent: Maybe<Scalars['Float']['output']>;
  recommendationScore: Maybe<Scalars['Int']['output']>;
  regularSeasonTeamPhaseStandings: Maybe<TeamRegSeasonPhaseStandings>;
  roster: Maybe<TeamRoster>;
  rosterHistory: Maybe<Array<IRosterEvent>>;
  scheduledStartsAt: Maybe<Scalars['DateTime']['output']>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  seasonTeams: Maybe<Array<SeasonTeam>>;
  /** @deprecated use enrolledSeasons */
  seasons: Maybe<Array<Season>>;
  slotExclusionWindows: Maybe<Array<SlotExclusionWindow>>;
  slotIdsWithSmartQueueMatches: Maybe<Array<Scalars['UUID']['output']>>;
  slug: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  teamFormat: Maybe<Scalars['Int']['output']>;
  teamHistory: Maybe<Array<ITeamEvent>>;
  teamPhaseSummary: Maybe<TeamPhaseSummary>;
  teamPhaseSummaryByMetaseasonAndPhaseType: Maybe<TeamPhaseSummary>;
  unconnectedMembers: Maybe<Array<TeamMember>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type MatchTeamAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type MatchTeamEnrollmentStatusArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type MatchTeamLeaguesArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MatchTeamMembersArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtRange?: InputMaybe<EffectiveAtRange>;
};


export type MatchTeamNextOpponentArgs = {
  includeScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MatchTeamPhaseMatchesArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type MatchTeamRecommendationPercentArgs = {
  teamId: Scalars['UUID']['input'];
};


export type MatchTeamRecommendationScoreArgs = {
  teamId: Scalars['UUID']['input'];
};


export type MatchTeamRosterArgs = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtRange?: InputMaybe<DateRangeInput>;
};


export type MatchTeamRosterHistoryArgs = {
  dateRange: DateRangeInput;
};


export type MatchTeamSlotExclusionWindowsArgs = {
  bounds?: InputMaybe<DateRangeInput>;
};


export type MatchTeamSlotIdsWithSmartQueueMatchesArgs = {
  slotIds: Array<Scalars['UUID']['input']>;
};


export type MatchTeamTeamPhaseSummaryArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type MatchTeamTeamPhaseSummaryByMetaseasonAndPhaseTypeArgs = {
  metaseasonId: Scalars['UUID']['input'];
  phaseType: PhaseType;
};

export type MatchTeamContext = {
  __typename?: 'MatchTeamContext';
  matchId: Scalars['UUID']['output'];
  myTeamMatchResults: Array<MatchResult>;
  myTeams: Array<MatchTeam>;
  numberOfTeamsInMatch: Scalars['Int']['output'];
  otherTeamMatchResults: Array<MatchResult>;
  otherTeams: Array<MatchTeam>;
  teams: Array<MatchTeam>;
};

export enum MatchType {
  All = 'all',
  Match = 'match',
  Scrimmage = 'scrimmage'
}

export type MatchUserToLeadInput = {
  email: Array<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  schoolId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MatchUserToLeadPayload = {
  __typename?: 'MatchUserToLeadPayload';
  success: Scalars['Boolean']['output'];
  userLead: Maybe<UserLead>;
  userLeadId: Maybe<Scalars['UUID']['output']>;
};

export type MatchesByTeamIdsInput = {
  scheduledStartsAtRange?: InputMaybe<MatchDateRange>;
  teamIds: Array<Scalars['UUID']['input']>;
};

export type MatchesPayload = {
  __typename?: 'MatchesPayload';
  matchIds: Array<Scalars['UUID']['output']>;
  matches: Maybe<Array<Maybe<Match>>>;
  success: Scalars['Boolean']['output'];
};

export type MatchesResult = {
  __typename?: 'MatchesResult';
  filters: Maybe<MatchesResultsFilters>;
  limit: Maybe<Scalars['Int']['output']>;
  matches: Maybe<Array<Match>>;
  offset: Maybe<Scalars['Int']['output']>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type MatchesResultsFilters = {
  __typename?: 'MatchesResultsFilters';
  assigneeIds: Maybe<Array<Scalars['UUID']['output']>>;
  checkInIsOpen: Maybe<Scalars['Boolean']['output']>;
  competitionGroup: Maybe<CompetitionGroup>;
  esport: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  esportSlug: Maybe<Array<Scalars['String']['output']>>;
  gameStatus: Maybe<Array<Maybe<GameStatus>>>;
  isArchived: Maybe<Scalars['Boolean']['output']>;
  isScrimmage: Maybe<Scalars['Boolean']['output']>;
  isUnderReview: Maybe<Scalars['Boolean']['output']>;
  leagueIds: Maybe<Array<Scalars['UUID']['output']>>;
  leagueName: Maybe<Scalars['String']['output']>;
  metaseasonId: Maybe<Scalars['UUID']['output']>;
  metaseasonIds: Maybe<Array<Scalars['UUID']['output']>>;
  needAttention: Maybe<Scalars['Boolean']['output']>;
  phaseIds: Maybe<Array<Scalars['UUID']['output']>>;
  phaseNames: Maybe<Array<Scalars['String']['output']>>;
  phaseStatuses: Maybe<Array<PhaseStatus>>;
  phaseTypes: Maybe<Array<PhaseType>>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  schoolName: Maybe<Scalars['String']['output']>;
  schoolType: Maybe<Scalars['String']['output']>;
  seasonIds: Maybe<Array<Scalars['UUID']['output']>>;
  slotId: Maybe<Scalars['UUID']['output']>;
  status: Maybe<Array<MatchStatus>>;
  teamIds: Maybe<Array<Scalars['UUID']['output']>>;
  teamName: Maybe<Scalars['String']['output']>;
  unassignedOnly: Maybe<Scalars['Boolean']['output']>;
};

export type MergeMatchesInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  matchIds: Array<Scalars['UUID']['input']>;
};

export type Metaseason = {
  __typename?: 'Metaseason';
  competitionGroup: CompetitionGroup;
  earliestEnrollmentDate: Maybe<Scalars['DateTime']['output']>;
  /** The point in time when the meta season roughly ends - usually close to the end time of all linked seasons */
  endsAt: Maybe<Scalars['DateTime']['output']>;
  enrollmentEndsAt: Maybe<Scalars['DateTime']['output']>;
  enrollmentStartsAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  inactiveLeaguesCount: Maybe<Scalars['Int']['output']>;
  initialMetaseason: Metaseason;
  initialMetaseasonId: Scalars['UUID']['output'];
  isInitialMetaseason: Scalars['Boolean']['output'];
  isPromoted: Scalars['Boolean']['output'];
  isPromotionWindowOverlap: Maybe<Scalars['Boolean']['output']>;
  leaguesWithSeasonCount: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nextMetaseason: Maybe<Metaseason>;
  nextMetaseasonId: Maybe<Scalars['UUID']['output']>;
  previousMetaseason: Maybe<Metaseason>;
  previousMetaseasonId: Maybe<Scalars['UUID']['output']>;
  promotionEndsAt: Maybe<Scalars['DateTime']['output']>;
  promotionStartsAt: Maybe<Scalars['DateTime']['output']>;
  /** A unique, URL-safe idenentifier for this season */
  slug: Maybe<Scalars['String']['output']>;
  /** The point in time when the meta season roughly starts - usually close to the start time of all linked seasons */
  startsAt: Maybe<Scalars['DateTime']['output']>;
  status: Maybe<SeasonStatus>;
};


export type MetaseasonEarliestEnrollmentDateArgs = {
  schoolId: Scalars['UUID']['input'];
};

export type MetaseasonAttributes = {
  name: Scalars['String']['input'];
};

export type MetaseasonPassUsageSummaryPayload = {
  __typename?: 'MetaseasonPassUsageSummaryPayload';
  metaseason: Metaseason;
  seasonPassesUsed: Scalars['Int']['output'];
};

export type MetaseasonSchoolPayload = {
  __typename?: 'MetaseasonSchoolPayload';
  metaseason: Maybe<Metaseason>;
  metaseasonId: Scalars['UUID']['output'];
  school: Maybe<School>;
  schoolId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type MetaseasonsFilters = {
  competitionGroups?: InputMaybe<Array<CompetitionGroup>>;
  status?: InputMaybe<SeasonStatus>;
};

export type MetaseasonsOptions = {
  filters?: InputMaybe<MetaseasonsFilters>;
  sort?: InputMaybe<SeasonTeamMatchSort>;
};

export type MigrateSchoolToAnnualPayPayload = {
  __typename?: 'MigrateSchoolToAnnualPayPayload';
  annualPassInstance: Maybe<AnnualPassInstance>;
  annualPassInstanceId: Scalars['UUID']['output'];
  school: Maybe<School>;
  schoolId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type MissingConnectionCopyBody = {
  __typename?: 'MissingConnectionCopyBody';
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type MissingConnectionCopyBodyAttributes = {
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type MostPlayedStatsByPlayerId = {
  __typename?: 'MostPlayedStatsByPlayerId';
  mostPlayedCharacters: Array<Maybe<PlayedWinRate>>;
  mostPlayedStages: Array<Maybe<PlayedWinRate>>;
  playerId: Scalars['UUID']['output'];
};

export type MoveSchoolToLeagueResult = {
  __typename?: 'MoveSchoolToLeagueResult';
  numFreePlayers: Scalars['Int']['output'];
  numTeams: Scalars['Int']['output'];
};

export type MoveUserToSchoolInput = {
  roleNameToRequest: UserRoleName;
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  userPersonalEmail?: InputMaybe<Scalars['String']['input']>;
  userSchoolEmail?: InputMaybe<Scalars['String']['input']>;
};

export type MoveUserToSchoolResult = {
  __typename?: 'MoveUserToSchoolResult';
  school: Maybe<School>;
  schoolId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type MovedToBenchEvent = IRosterEvent & {
  __typename?: 'MovedToBenchEvent';
  player: Maybe<User>;
  playerId: Scalars['UUID']['output'];
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Scalars['UUID']['output'];
};

export type MovedToRosterEvent = IRosterEvent & {
  __typename?: 'MovedToRosterEvent';
  player: Maybe<User>;
  playerId: Scalars['UUID']['output'];
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Scalars['UUID']['output'];
};

export type MultipleMatchSettleRequestsPayload = {
  __typename?: 'MultipleMatchSettleRequestsPayload';
  errors: Maybe<Array<Scalars['String']['output']>>;
  matchSettleRequest: Maybe<Array<MatchSettleRequestModel>>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _: Maybe<Scalars['Boolean']['output']>;
  acceptQueue: Maybe<AcceptQueueResponse>;
  acceptScrimmageQueueOpponent: Maybe<ScrimmageQueueStatePayload>;
  acceptTeamRival: TeamRival;
  /** @deprecated Use acceptTosPrivacyPolicy instead */
  acceptTos: Maybe<Scalars['Boolean']['output']>;
  acceptTosPrivacyPolicy: UserPayload;
  ackAllPendingNotifications: UserPayload;
  ackPendingNotification: UserNotificationsPayload;
  addAdditionalCoachRoleToUser: UserPayload;
  addAnnualPassToSchool: AnnualPassInstance;
  addChildToSchool: AddUserToSchoolResult;
  addLeagueToLeagueGroup: LeagueGroupPayload;
  addLeagueToLeagueGroups: Maybe<AddLeagueBulkPayload>;
  addLeagueToSchool: Maybe<LeaguePayload>;
  addLeagueToSchoolsBulk: Maybe<AddLeagueBulkPayload>;
  addMissingTasksForUser: Array<UserTaskPayload>;
  addPlatformsToEsport: PlatformPayload;
  addPlayerToTeam: TeamMutationPayload;
  addSchoolLeagueGroupExclusion: SchoolLeagueGroupsPayload;
  addSchoolToVarsityAssociation: Maybe<SchoolPayload>;
  addSchoolsToVarsityAssociation: BulkActionJobPayload;
  addTeamToLeague: TeamLeaguePayload;
  addUserRole: Maybe<Array<UserRole>>;
  addUserToChat: AddUserToChatPayload;
  addUserToSchool: AddUserToSchoolResult;
  adjustAnnualPass: AnnualPassInstance;
  adminAllForfeitMatch: MatchJobPayload;
  adminForfeitGame: GameJobPayload;
  adminForfeitMatch: MatchJobPayload;
  adminSaveGameResultLive: MatchSettleRequestWithWinningTeamPayload;
  adminSubmitLeaderboardMatchGameResults: Scalars['Boolean']['output'];
  applyForSchool: Maybe<ApplyForSchoolResult>;
  /** @deprecated use assignTeamCaptainRole */
  assignCaptainToTeam: TeamMutationPayload;
  assignMatchAssignment: MatchAssignment;
  assignSeasonalPlayerAward: AssignedSeasonalPlayerAwardPayload;
  assignTeamCaptainRole: TeamUserPayload;
  assignTeamCoach: TeamUserPayload;
  assignWeeklyPlayerAward: AssignedWeeklyPlayerAwardPayload;
  /** @deprecated Use backfillSearchIndex instead */
  backfillMatchesIndex: BackfillPayload;
  backfillSchoolEnrollment: BackfillSchoolEnrollmentPayload;
  backfillSearchIndex: BackfillPayload;
  banUser: UserPayload;
  bulkAssignMatches: MatchesPayload;
  bulkCreateSeason: SeasonJobPayload;
  bulkEditSeason: SeasonJobPayload;
  bulkUnassignMatches: MatchesPayload;
  byeMatch: MatchJobPayload;
  cancelGame: GameJobPayload;
  cancelMatch: MatchJobPayload;
  cancelMatchRescheduleRequest: MatchRescheduleRequest;
  cancelMatches: CancelMatchesPayload;
  cancelScrimmage: CancelScrimmagesPayload;
  cancelScrimmageByMatchId: DeleteMatchPayload;
  cancelScrimmages: CancelScrimmagesResponse;
  cancelSlot: DeleteSlotPayload;
  cancelTeamRival: TeamRival;
  changeChildPassword: UserPayload;
  changeMyPassword: UserPayload;
  changeSchoolIdForUser: UserPayload;
  checkPlaceInQueue: Maybe<CheckPlaceInQueueResponse>;
  cleanSchoolSearchIndex: JobPayload;
  clearMatchChatQueue: ClearMatchChatQueuePayload;
  clearSmartQueueSlot: Maybe<GenericQueuePayload>;
  clearSmartQueueTeams: Maybe<GenericQueuePayload>;
  completeChecklistItem: CompleteChecklistItemPlayload;
  completeMatch: MatchJobPayload;
  completeQueuePlace: Maybe<CompleteQueuePlaceResponse>;
  completeScrimmage: Maybe<ScrimmageRequest>;
  confirmPhoneVerification: UserPayload;
  consolidateLeague: Maybe<LeaguePayload>;
  createAnnualPassProduct: Maybe<AnnualPassProduct>;
  createBracketSlots: Array<Slot>;
  createDemo: Maybe<DemoJobPayload>;
  createEsport: Maybe<Esport>;
  createEsportGroup: EsportV2;
  createEsportOffering: EsportOffering;
  createGame: CreateGamePayload;
  createGameAssistantSelectionOptions: GameAssistantSelectionOption;
  createGameHighlight: CreateGameHighlightPayload;
  createGameResult: CreateGameResultPayload;
  createLeague: CreateLeaguePayload;
  createLeagueGroup: CreateLeagueGroupPayload;
  createLegacyNotification: Maybe<LegacyNotification>;
  createLegacyUserNotification: Maybe<LegacyUserNotification>;
  createLink: Link;
  createMatch: CreateMatchPayload;
  createMatchChat: CreateMatchChatPayload;
  createMatchChatEvent: MatchChatEventResults;
  createMatchDisputeFeedback: MatchDisputeRequest;
  createMatchDisputeRequest: MatchDisputeRequest;
  createMatchResult: CreateMatchResultPayload;
  createMatchSurveyResponse: MatchSurvey;
  createMetaseason: Metaseason;
  createNote: Note;
  createPartner: Partner;
  createPastByeMatch: MatchJobPayload;
  createPhase: CreatePhasePayload;
  createPhaseResult: CreatePhaseResultPayload;
  createRoleInvite: RoleInvite;
  createRoleInviteCode: Maybe<RoleInviteCode>;
  createRoleRequest: RoleRequest;
  /** @deprecated No longer supported */
  createRoleReview: Maybe<RoleReview>;
  createSchool: Maybe<School>;
  createSchoolMessage: Maybe<SchoolMessage>;
  createScrimmage: RequestScrimmageResponse;
  createSeason: Maybe<Season>;
  createSeasonDatesTemplate: Maybe<SeasonDatesTemplate>;
  createSeasonPassProduct: Maybe<Product>;
  createSeasonPlayoffTemplate: SeasonPlayoffTemplate;
  createSeasonalPlayerAwardType: CreateSeasonalPlayerAwardTypePayload;
  createSlot: CreateSlotPayload;
  createSlotExclusionRangeConfiguration: CreateSlotExclusionRangeConfigurationResult;
  createSlotExclusionWindow: SlotExclusionWindowMutationPayload;
  /** @deprecated Discord is no longer used to manage matches. To be removed in MATCH-6755. */
  createSmashDiscordChannel: MatchPayload;
  createSponsorshipCampaign: SponsorshipCampaign;
  createSponsorshipComponent: SponsorshipComponent;
  createTeamForEvent: TeamMutationPayload;
  createTeamV2: TeamMutationPayload;
  createUserConsent: UserConsent;
  createUserEmail: Maybe<UserEmail>;
  createUserLead: UserLeadPayload;
  createVarsityAssociation: VarsityAssociation;
  declineQueue: Maybe<DeclineQueueResponse>;
  declineScrimmage: CancelScrimmagesPayload;
  declineScrimmageQueueOpponent: Maybe<ScrimmageQueueStatePayload>;
  decreaseSeasonReputationForTeam: Maybe<GenericTeamReputationPayload>;
  deleteEsportOffering: DeleteEsportOfferingPayload;
  deleteEsportPosition: DeleteEsportPositionPayload;
  deleteGameHighlight: DeleteGameHighlightInputPayload;
  deleteMatch: DeleteMatchPayload;
  deleteMatchChatEvent: MatchChatEventResults;
  deleteMatchDisputeRequestAsset: DeleteMatchDisputePayload;
  deleteMatchResult: DeleteMatchResultPayload;
  deleteMatchSettleRequestAsset: DeletedMatchSettleRequestPayload;
  deleteNote: DeleteNotePayload;
  deletePartner: DeletePartnerPayload;
  deleteSchool: DeleteSchoolPayload;
  deleteSchoolMessage: DeleteSchoolMessagePayload;
  deleteSeasonalPlayerAward: DeleteSeasonalPlayerAwardPayload;
  deleteSeasonalPlayerAwardType: DeleteSeasonalPlayerAwardTypePayload;
  deleteSlot: DeleteSlotPayload;
  deleteSlotExclusionRangeConfiguration: DeleteSlotExclusionRangeConfigurationPayload;
  deleteSlotExclusionWindow: SlotExclusionWindowMutationPayload;
  deleteSponsorshipCampaign: DeleteSponsorshipCampaignPayload;
  deleteSponsorshipComponent: DeleteSponsorshipComponentPayload;
  deleteStadiumTeam: DeleteTeamPayload;
  deleteSurveySchema: SurveyPayload;
  deleteTeam: DeleteTeamPayload;
  deleteUser: Maybe<DeleteUserPayload>;
  deleteUserEmail: User;
  deleteUserTaskQueue: DeleteTaskQueuePayload;
  deleteUsersPromotionalEmailAccount: UsersPayload;
  deleteWeeklyAssignedPlayerAward: DeleteWeeklyAssignedPlayerAwardPayload;
  denyCoach: Maybe<User>;
  denyPlayer: Maybe<User>;
  denyTeamRival: TeamRival;
  denyUserForOrganization: UserPayload;
  denyVerifiedCoach: UserPayload;
  denyVerifiedPlayer: UserPayload;
  dismissMatchDisputeRequest: MatchDisputeRequest;
  dismissMatchSurvey: MatchPayload;
  enqueueClearUserNotificationsJob: JobPayload;
  enqueueNotificationForAllUsers: JobPayload;
  enqueueUpcomingSlotScheduleJobs: JobPayload;
  enqueueUserNotificationsJob: JobPayload;
  enrollTeamInSeason: TeamSeasonPayload;
  expireQueuePlace: Maybe<ExpireQueuePlaceResponse>;
  finishGame: GameJobPayload;
  forceDeactivateTeams: TeamPayload;
  forceValidPlayerGameStats: GameJobPayload;
  forfeitMatch: ForfeitMatchResponse;
  fullFillPasswordReset: UserPayload;
  generateReferralLink: Scalars['String']['output'];
  generateSeasonSchedule: Maybe<GenerateSeasonScheduleResponse>;
  generateSeasonalPlayerAwardCertificate: GenerateSeasonalPlayerAwardCertificatePayload;
  generateSeasonalPlayerAwardSocialMediaImage: GenerateSeasonalPlayerAwardSocialMediaImagePayload;
  generateTwilioAccessTokenByUserId: GenerateTwilioAccessTokenByUserIdPayload;
  getPasswordResetToken: Maybe<Scalars['String']['output']>;
  graduatePlayer: UserPayload;
  grantAnnualPassToSchool: AnnualPassInstance;
  grantSeasonPassToUser: UserSeasonPass;
  handbookViewed: TaskCompletePayload;
  hardDeleteSchool: DeleteSchoolPayload;
  increaseSeasonReputationForTeam: Maybe<GenericTeamReputationPayload>;
  indexMatch: IndexPayload;
  initializeUserTaskQueue: InitializeTaskQueuePayload;
  joinPreseasonQueue: Maybe<GenericQueuePayload>;
  joinQueue: Maybe<JoinQueueResponse>;
  joinScrimmage: JoinScrimmageResponse;
  joinScrimmageQueue: Maybe<ScrimmageQueueStatePayload>;
  joinSmartQueue: Maybe<GenericQueuePayload>;
  joinTeam: TeamMutationPayload;
  leavePreseasonQueue: Maybe<GenericQueuePayload>;
  leaveQueue: Maybe<LeaveQueueResponse>;
  leaveScrimmageQueue: Maybe<ScrimmageQueueStatePayload>;
  leaveSmartQueue: Maybe<GenericQueuePayload>;
  leaveTeam: UserPayload;
  linkManualAccount: UserProviderAccount;
  linkNintendoAccount: UserProviderAccount;
  linkPlayStationNetworkAccount: UserProviderAccount;
  linkSmiteAccount: UserProviderAccount;
  loginUser: LoginUserResponse;
  logoutUser: LogoutPayload;
  manuallySeedPlayoffPhases: LeaguesPayload;
  markAllUserNotificationsOpened: MarkAllUserNotificationsOpenedResult;
  markAllUserNotificationsRead: MarkAllUserNotificationsReadResult;
  markContentAsRead: ContentPayload;
  markTeamLockedInForPhase: TeamPayload;
  markTeamNotLockedInForPhase: TeamPayload;
  markUserNotificationOpened: MarkUserNotificationOpenedResult;
  markUserNotificationTaskCompleted: MarkUserNotificationCompletedResult;
  markUserNotificationTaskCompletedByUser: MarkUserNotificationCompletedResult;
  markUserNotificationTaskOpened: MarkUserNotificationTaskOpenedResult;
  matchUserToLead: MatchUserToLeadPayload;
  mergeMatches: MatchJobPayload;
  migrateSchoolToAnnualPay: MigrateSchoolToAnnualPayPayload;
  mockConnectEpicAccount: UserProviderAccount;
  mockFortniteTeamMatchStats: MatchPayload;
  moveSchoolToLeague: Maybe<MoveSchoolToLeagueResult>;
  moveUserToSchool: MoveUserToSchoolResult;
  openMatch: MatchJobPayload;
  patchFortniteTeamMatchStats: Maybe<FortniteTeamMatchStats>;
  patchLegacyNotification: Maybe<LegacyNotification>;
  patchMatchSettleRequest: GenericMatchSettleRequestPayload;
  patchTeamMatchStats: Maybe<TeamMatchStats>;
  processBackupEvents: ProcessBackupEventsPayload;
  /** @deprecated Use backfillSearchIndex instead */
  rebuildSchoolSearchIndex: BackfillPayload;
  recheckNotificationTaskStatus: RecheckNotificationTaskStatusResult;
  recreateBracket: Maybe<Bracket>;
  redoPlayerGameStatsForGame: Array<PlayerGameStats>;
  redoSchedulePhaseMatches: PhasePayload;
  referByEmail: Maybe<ReferralPayload>;
  referCoachEmail: ReferEmailPayload;
  referParentByEmail: Maybe<ReferralPayload>;
  refreshFortniteMatch: Maybe<Array<MatchResult>>;
  refreshSchoolLeagueGroups: SchoolLeagueGroupsPayload;
  registerUser: RegisterUserResponse;
  registerUserWithUsername: RegisterUserResponse;
  removeAnnualPass: AnnualPassPayload;
  removeLeagueFromLeagueGroup: LeagueGroupPayload;
  removeLeagueFromLeagueGroups: Maybe<LeaguePayload>;
  removeLeagueFromSchool: Maybe<LeaguePayload>;
  removeLeagueFromSchoolsBulk: Maybe<LeaguePayload>;
  removePlatformsFromEsport: PlatformPayload;
  removePlayerFromTeam: TeamMutationPayload;
  removeProviderAccount: RemoveUserProviderAccountSuccussPayload;
  removeSchoolFromVarsityAssociation: Maybe<SchoolPayload>;
  removeSchoolLeagueGroupExclusion: SchoolLeagueGroupsPayload;
  removeSchoolsFromVarsityAssociation: BulkActionJobPayload;
  removeSelectionOptionById: RemoveSelectionOptionPayload;
  removeSponsorshipImage: SponsorshipRemovePayload;
  removeTeamCoach: TeamUserPayload;
  removeTeamFromLeague: TeamPayload;
  removeTeamRival: TeamRival;
  removeUserEsportPlatform: Maybe<RemoveUserEsportPayload>;
  removeUserFromSchool: User;
  removeUserRole: Maybe<Array<UserRole>>;
  replaceTeamCoach: TeamUserPayload;
  repositionPlayersInTeam: TeamMutationPayload;
  reprocessFortniteMatchStats: MatchJobPayload;
  reprocessFortnitePlayerTeamMatch: MatchPayload;
  requestAccountEdit: RequestAccountEditResult;
  requestEmailUpdate: RequestEmailUpdateResult;
  requestEmailVerification: SuccessPayload;
  requestGameReset: RequestGameResetPayload;
  requestMatchAssistantBypass: RequestMatchAssistantBypassPayload;
  requestMatchReschedule: MatchRescheduleRequest;
  requestMatchRescheduleWithinSchool: MatchRescheduleRequest;
  requestNextGameRosterChangeForRocketLeague: RequestNextGameRosterChangeForRocketLeaguePayload;
  requestPasswordReset: SuccessPayload;
  requestScrimmage: RequestScrimmageResponse;
  requestTeamRival: TeamRival;
  rescheduleMatch: MatchPayload;
  rescheduleMatches: RescheduleMatchesPayload;
  rescheduleSlot: SlotPayload;
  resetGameAssistantStepsForGame: ResetStepPayload;
  resetGameAssistantStepsForMatch: ResetStepPayload;
  resetGameAssistantStepsForSeries: ResetStepPayload;
  resetUserForVerification: UserPayload;
  resetUserSeasonPassConsumed: UserSeasonPassPayload;
  resizeAsset: Array<ResourceImage>;
  resolveUnknownPlayerGameStats: GameJobPayload;
  respondToMatchRescheduleRequest: MatchRescheduleRequest;
  respondToRoleInvite: UserPayload;
  respondToRoleRequest: UserPayload;
  resurrectDuplicateDeletedTeam: TeamMutationPayload;
  resurrectSchool: SchoolPayload;
  resurrectStadiumTeam: TeamMutationPayload;
  resurrectTeam: TeamMutationPayload;
  rollupAllPhaseResults: PhaseJobsPayload;
  rollupFortnitePhaseStats: RollupFortnitePhaseStatsPayload;
  rollupPhaseResults: PhaseJobPayload;
  rollupPlayerPhaseStats: Maybe<Scalars['Boolean']['output']>;
  runBulkAction: BulkActionJobPayload;
  runPhaseGeneration: Phase;
  saveGameResultLive: MatchSettleRequestWithWinningTeamPayload;
  saveMatchNotesLive: GenericMatchSettleRequestPayload;
  saveSurvey: SurveyPayload;
  saveSurveyResponse: SurveyPayload;
  saveSurveySchema: SurveyPayload;
  saveUpdateBracket: Maybe<Bracket>;
  scheduleConsultationEmail: ScheduleConsultationEmailPayload;
  scheduleMatch: MatchJobPayload;
  scheduleMatches: ScheduleMatchesPayload;
  scheduleNextBracketMatch: Maybe<Scalars['Boolean']['output']>;
  schedulePhaseMatches: PhaseJobPayload;
  schedulePhaseMatchesMocked: PhaseJobPayload;
  seedFortnitePlayoffTeams: Maybe<Array<MatchResult>>;
  seedPhaseTeams: PhaseJobPayload;
  sendAnnouncement: SendAnnouncementPayload;
  sendAnnouncementByMatchIds: SendAnnouncementPayload;
  sendEnrollmentConfirmation: EnrollmentConfirmationPayload;
  sendFirstMessageNotificationIfNecessary: SendFirstMessageNotificationIfNecessaryPayload;
  sendParentVerificationEmail: ParentVerificationPayload;
  setChildAccountSettings: UserPayload;
  setChildParent: UpdateParentPayload;
  setContentForUser: ContentPayload;
  setEsportColors: EsportPayload;
  setEsportLeagueDefaults: EsportPayload;
  setEsportRulebook: Maybe<Esport>;
  setGameOrdinal: Maybe<SetOrdinalPayload>;
  setHearthstonePlayerMatchDeckSelection: Maybe<HearthstonePlayerDeckSelection>;
  /** @deprecated No longer supported */
  setIsEnabledEsport: Maybe<Esport>;
  setLeaguesActiveForMetaseason: LeaguesPayload;
  setLeaguesInactiveForMetaseason: LeaguesPayload;
  setMatchSeries: MatchPayload;
  setMyAccountSettings: UserPayload;
  setMyEsportInterests: UserPayload;
  setMyFacultyInformation: UserPayload;
  setMyFacultyRole: UserPayload;
  setMySchoolSubmission: SchoolPayload;
  setMyUserDemographics: UserPayload;
  setPlayerLeagues: UserPayload;
  setSchoolBillingContact: School;
  setSchoolLogo: SchoolPayload;
  setSchoolsForCampaign: SetSponsorshipCampaignSchoolsPayload;
  setSeasonReputationForTeam: Maybe<GenericTeamReputationPayload>;
  setSeasonReputationForTeams: Maybe<GenericTeamReputationPayload>;
  setSeriesOrdinal: Maybe<SetOrdinalPayload>;
  setSlotExclusionRangeDefaultWindows: SetSlotExclusionRangeDefaultWindowsPayload;
  setStepOrdinal: Maybe<SetOrdinalPayload>;
  setTeamIsPlayerLed: Maybe<TeamMutationPayload>;
  setUserAccountSettings: UserPayload;
  setUserAsParent: UpdateParentPayload;
  setUserAvatarImage: Array<ResourceImage>;
  setUserEsportInterests: UserPayload;
  setUserEsportPlatform: UserEsportPlatform;
  setUserEsportProvider: UserProviderAccountPayload;
  setUserGradYear: UserPayload;
  setUserNotificationEnabled: SetUserNotificationEnabledPayload;
  setUserNotificationIsPersonal: SetUserNotificationIsPersonalPayload;
  setUserNotificationScope: SetUserNotificationScopePayload;
  setUserOnline: SetUserOnlinePayload;
  setUserSeasonPass: UserSeasonPassPayload;
  setUsersSeasonPassConsumed: UsersSeasonPassConsumedPayload;
  startGame: GameJobPayload;
  startPhoneVerification: UserPayload;
  stopChildNoLongerUnderageJob: JobPayload;
  stopExpireCoachVerificationJob: JobPayload;
  stopExpireRescheduleRequests: JobPayload;
  stopGraduateUserJob: JobPayload;
  stopPracticeDayEmail: JobPayload;
  stopPracticeDayReminderJob: JobPayload;
  stopRepeatSlotSchedulerJob: JobPayload;
  stopStartOfCalendarYearJob: JobPayload;
  stopStartOfCompetitionYearJob: JobPayload;
  stopStartOfMonthJob: JobPayload;
  submitAdminMatchSettleRequestLive: SubmitMatchSettleRequestPayload;
  submitGameAssistantStepSelections: SubmitGameAssistantStepSelectionsPayload;
  submitLeaderboardGameResultLive: SubmitLeaderboardGameResultLivePayload;
  submitMatchSettleRequestAssetsLive: GenericMatchSettleRequestPayload;
  submitMatchSettleRequestLive: SubmitMatchSettleRequestPayload;
  submitUserSchoolSurvey: UserPayload;
  togglePlayvsScore: Maybe<Season>;
  tourViewed: TourViewedPayload;
  transferPlayer: UserPayload;
  transferSubstituteToTeam: TransferSubstituteToTeamResult;
  transferTeamToSeason: TeamSeasonPayload;
  transferTeamsToSeason: BulkActionJobPayload;
  triggerChildNoLongerUnderageJob: JobPayload;
  triggerExpireCoachVerificationJob: JobPayload;
  triggerExpireRescheduleRequests: JobPayload;
  triggerFinishRocketLeagueCallbackHandler: TriggerRocketLeagueCallbackResult;
  triggerGraduateUserJob: JobPayload;
  triggerImmediateChildNoLongerUnderageJob: JobPayload;
  triggerImmediateExpireCoachVerificationJob: JobPayload;
  triggerImmediateGraduateUserJob: JobPayload;
  triggerImmediateStartOfCalendarYearJob: JobPayload;
  triggerImmediateStartOfCompetitionYearJob: JobPayload;
  triggerImmediateStartOfMonthJob: JobPayload;
  triggerPracticeDayEmail: JobPayload;
  triggerPracticeDayReminderJob: JobPayload;
  triggerRepeatSlotSchedulerJob: JobPayload;
  triggerStartOfCalendarYearJob: JobPayload;
  triggerStartOfCompetitionYearJob: JobPayload;
  triggerStartOfMonthJob: JobPayload;
  triggerUpdateRocketLeagueCallbackHandler: TriggerRocketLeagueCallbackResult;
  unSetUserEsportProvider: UserPayload;
  /** @deprecated use unassignTeamCaptainRole */
  unassignCaptainFromTeam: TeamMutationPayload;
  unassignMatchAssignment: MatchAssignment;
  unassignTeamCaptainRole: TeamUserPayload;
  unbanUser: UserPayload;
  uncompleteChecklistItem: CompleteChecklistItemPlayload;
  unenrollTeamFromSeason: TeamPayload;
  unenrollTeamsFromSeason: BulkActionJobPayload;
  unlinkParentFromChild: UpdateParentPayload;
  unlinkRiotAccount: UnlinkRiotAccountPayload;
  unlinkSchoolProviderAccount: UnlinkSchoolProviderAccountSuccussPayload;
  unlinkUserProviderAccount: RemoveUserProviderAccountSuccussPayload;
  unlockLeague: Maybe<LeaguePayload>;
  updateAllowCaptainEnrollment: Maybe<School>;
  updateAllowPlayerLedTeams: Maybe<School>;
  updateChannelMembers: UserPayload;
  updateCurrentAnnualPassBySchoolId: Array<AnnualPassPayload>;
  updateEsport: Maybe<Esport>;
  updateEsportDetails: EsportDetails;
  updateEsportGroup: EsportV2;
  updateEsportOffering: EsportOfferingsPayload;
  updateGame: UpdateGamePayload;
  updateGameHighlight: UpdateGameHighlightPayload;
  updateGameResult: UpdateGameResultPayload;
  updateLeague: UpdateLeaguePayload;
  updateLeagueGroup: LeagueGroup;
  updateLink: Link;
  updateLobby: UpdateLobbyPayload;
  updateMatch: UpdateMatchPayload;
  updateMatchChatEvent: MatchChatEventResults;
  updateMatchResult: UpdateMatchResultPayload;
  /** @deprecated Discord is no longer used to manage matches. To be removed in MATCH-6755. */
  updateMemberDiscordRoles: TeamLeaguePayload;
  updateMetaseason: Metaseason;
  updatePartner: Partner;
  updatePhase: UpdatePhasePayload;
  updatePhaseResult: UpdatePhaseResultPayload;
  updateProduct: ProductPayload;
  updateReferralBountySchools: UpdateSchoolsPayload;
  updateRiotAccount: UserProviderAccount;
  updateRiotAccountByPuuid: UpdateRiotAccountPayload;
  updateRoleMembers: UserPayload;
  updateSchoolAddress: School;
  updateSchoolDetail: Maybe<School>;
  updateSchoolEnrollment: Array<SchoolEnrollment>;
  updateSchoolMessage: Maybe<SchoolMessage>;
  updateSchoolProfile: Maybe<School>;
  updateSchoolSearchIndex: SchoolPayload;
  updateSchoolSheerId: Maybe<SchoolPayload>;
  updateSchoolSlug: Maybe<SchoolPayload>;
  updateSeason: Maybe<Season>;
  updateSeasonDatesTemplate: Maybe<SeasonDatesTemplate>;
  updateSeasonPlayoffTemplate: SeasonPlayoffTemplate;
  updateSeasonalPlayerAward: AssignedSeasonalPlayerAwardPayload;
  updateSeasonalPlayerAwardType: CreateSeasonalPlayerAwardTypePayload;
  updateShowCoachEmails: Maybe<School>;
  updateSlot: UpdateSlotPayload;
  updateSlotExclusionRangeConfiguration: UpdateSlotExclusionRangeConfigurationResult;
  updateSlotExclusionWindow: UpdateSlotExclusionWindowPayload;
  updateSpinAccount: UpdateProviderPayload;
  updateSpinSchool: UpdateSpinSchoolPayload;
  updateSponsorshipCampaign: SponsorshipCampaign;
  updateSponsorshipComponent: SponsorshipComponent;
  updateTeam: Maybe<TeamMutationPayload>;
  updateTeamGlobalStats: TeamPayload;
  updateUserRoleStatus: UserPayload;
  updateUserTaskQueue: Array<UserTaskPayload>;
  updateVarsityAssociation: VarsityAssociation;
  updateWeeklyAssignedPlayerAward: AssignedWeeklyPlayerAwardPayload;
  uploadEsportFile: UploadEsportFileResult;
  uploadMatchDisputeRequestAsset: Asset;
  uploadMatchSettleRequestAsset: Asset;
  uploadSelectionOptionAsset: UploadSelectionOptionAssetPayload;
  uploadSponsorshipImage: SponsorshipImage;
  uploadTeamAvatar: TeamMutationPayload;
  upsertMatchCheckIn: MatchCheckIn;
  upsertSponsorshipImage: SponsorshipImage;
  validateScholasticRole: UserValidation;
  verifyArchivedPlayer: UserPayload;
  verifyCoach: UserPayload;
  verifyCoachUsingSheerId: VerifyCoachUsingSheerIdPayload;
  verifyCommunicationWithOverride: UserPayload;
  verifyDeniedCoach: UserPayload;
  verifyDeniedPlayer: UserPayload;
  verifyGame: GameJobPayload;
  verifyPlayer: Maybe<User>;
  verifyUserForOrganization: UserPayload;
};


export type MutationAcceptQueueArgs = {
  input: AcceptQueueInput;
};


export type MutationAcceptScrimmageQueueOpponentArgs = {
  teamId: Scalars['String']['input'];
};


export type MutationAcceptTeamRivalArgs = {
  input: ResponseTeamRivalInput;
};


export type MutationAcceptTosPrivacyPolicyArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationAckAllPendingNotificationsArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationAckPendingNotificationArgs = {
  id: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationAddAdditionalCoachRoleToUserArgs = {
  input: UserRoleUpdateInput;
};


export type MutationAddAnnualPassToSchoolArgs = {
  initialMetaseasonId: Scalars['UUID']['input'];
  productId?: InputMaybe<Scalars['UUID']['input']>;
  schoolId: Scalars['UUID']['input'];
};


export type MutationAddChildToSchoolArgs = {
  input: AddChildToSchoolInput;
};


export type MutationAddLeagueToLeagueGroupArgs = {
  leagueGroupId: Scalars['UUID']['input'];
  leagueId: Scalars['UUID']['input'];
};


export type MutationAddLeagueToLeagueGroupsArgs = {
  leagueId: Scalars['UUID']['input'];
  states: Array<Scalars['String']['input']>;
  varsityAssociationSlugs: Array<Scalars['String']['input']>;
};


export type MutationAddLeagueToSchoolArgs = {
  leagueId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type MutationAddLeagueToSchoolsBulkArgs = {
  leagueId: Scalars['UUID']['input'];
  states: Array<Scalars['String']['input']>;
  varsityAssociationSlugs: Array<Scalars['String']['input']>;
};


export type MutationAddMissingTasksForUserArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationAddPlatformsToEsportArgs = {
  esportId: Scalars['UUID']['input'];
  platforms?: InputMaybe<Array<Platform>>;
};


export type MutationAddPlayerToTeamArgs = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  hideTeamInRequestIfDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  options?: InputMaybe<AddPlayerToTeamOptions>;
  position?: InputMaybe<Scalars['Int']['input']>;
  positionId?: InputMaybe<Scalars['UUID']['input']>;
  teamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationAddSchoolLeagueGroupExclusionArgs = {
  leagueGroupId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type MutationAddSchoolToVarsityAssociationArgs = {
  firstEffectiveMetaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
  varsityAssociationSlug: Scalars['String']['input'];
};


export type MutationAddSchoolsToVarsityAssociationArgs = {
  input: AddSchoolsToVarsityAssociationInput;
};


export type MutationAddTeamToLeagueArgs = {
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  options?: InputMaybe<AddTeamToLeagueOptions>;
  teamId: Scalars['UUID']['input'];
};


export type MutationAddUserRoleArgs = {
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  role: UserRoleName;
  userId: Scalars['UUID']['input'];
};


export type MutationAddUserToChatArgs = {
  input: AddUserToChatInput;
};


export type MutationAddUserToSchoolArgs = {
  input: AddUserToSchoolInput;
};


export type MutationAdjustAnnualPassArgs = {
  annualPassInstanceId: Scalars['UUID']['input'];
  desiredProductId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type MutationAdminAllForfeitMatchArgs = {
  input: AdminAllForfeitMatchInput;
};


export type MutationAdminForfeitGameArgs = {
  input: AdminForfeitGameInput;
};


export type MutationAdminForfeitMatchArgs = {
  input: AdminForfeitMatchInput;
};


export type MutationAdminSaveGameResultLiveArgs = {
  input: AdminSaveGameResultInput;
};


export type MutationAdminSubmitLeaderboardMatchGameResultsArgs = {
  input: AdminSubmitLeaderboardMatchGameResultsInput;
};


export type MutationApplyForSchoolArgs = {
  input: ApplyForSchoolInput;
};


export type MutationAssignCaptainToTeamArgs = {
  teamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationAssignMatchAssignmentArgs = {
  input: AssignMatchAssignmentInput;
};


export type MutationAssignSeasonalPlayerAwardArgs = {
  input: AssignSeasonalPlayerAwardInput;
};


export type MutationAssignTeamCaptainRoleArgs = {
  teamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationAssignTeamCoachArgs = {
  coachUserId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationAssignWeeklyPlayerAwardArgs = {
  input: AssignWeeklyPlayerAwardInput;
};


export type MutationBackfillMatchesIndexArgs = {
  input?: InputMaybe<BackfillMatchesInput>;
};


export type MutationBackfillSchoolEnrollmentArgs = {
  enrollmentInput: Array<SchoolEnrollmentInput>;
  schoolId: Scalars['UUID']['input'];
};


export type MutationBackfillSearchIndexArgs = {
  input?: InputMaybe<BackfillIndexInput>;
};


export type MutationBanUserArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};


export type MutationBulkAssignMatchesArgs = {
  matchAssignments: Array<AssignMatchAssignmentInput>;
};


export type MutationBulkCreateSeasonArgs = {
  bulkSeasonSchedule: BulkSeasonCreateInput;
};


export type MutationBulkEditSeasonArgs = {
  input: BulkEditSeasonInput;
};


export type MutationBulkUnassignMatchesArgs = {
  matchAssignments: Array<UnassignMatchAssignmentInput>;
};


export type MutationByeMatchArgs = {
  input: ByeMatchInput;
};


export type MutationCancelGameArgs = {
  input: CancelGameInput;
};


export type MutationCancelMatchArgs = {
  input: CancelMatchInput;
};


export type MutationCancelMatchRescheduleRequestArgs = {
  input: CancelMatchRescheduleInput;
};


export type MutationCancelMatchesArgs = {
  input: CancelMatchesInput;
};


export type MutationCancelScrimmageArgs = {
  input: CancelScrimmageInput;
};


export type MutationCancelScrimmageByMatchIdArgs = {
  input: CancelScrimmageByMatchIdInput;
};


export type MutationCancelScrimmagesArgs = {
  input: CancelScrimmagesInput;
};


export type MutationCancelSlotArgs = {
  input: CancelSlotInput;
};


export type MutationCancelTeamRivalArgs = {
  input: CancelTeamRivalInput;
};


export type MutationChangeChildPasswordArgs = {
  input: ChangeChildPasswordInput;
};


export type MutationChangeMyPasswordArgs = {
  input: ChangeMyPasswordInput;
};


export type MutationChangeSchoolIdForUserArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type MutationCheckPlaceInQueueArgs = {
  input: CheckPlaceInQueueInput;
};


export type MutationClearMatchChatQueueArgs = {
  input: ClearMatchChatQueueInput;
};


export type MutationClearSmartQueueSlotArgs = {
  input: ClearSmartQueueSlotInput;
};


export type MutationClearSmartQueueTeamsArgs = {
  input: ClearSmartQueueTeamsInput;
};


export type MutationCompleteChecklistItemArgs = {
  schoolId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
};


export type MutationCompleteMatchArgs = {
  input: CompleteMatchInput;
};


export type MutationCompleteQueuePlaceArgs = {
  input: CompleteQueuePlaceInput;
};


export type MutationCompleteScrimmageArgs = {
  input: CompleteScrimmageInput;
};


export type MutationConfirmPhoneVerificationArgs = {
  code: Scalars['String']['input'];
};


export type MutationConsolidateLeagueArgs = {
  input: ConsolidateLeagueInput;
};


export type MutationCreateAnnualPassProductArgs = {
  attributes: CreateAnnualPassAttributes;
};


export type MutationCreateBracketSlotsArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type MutationCreateDemoArgs = {
  input: CreateDemoInput;
};


export type MutationCreateEsportArgs = {
  esportAttributes?: InputMaybe<EsportAttributes>;
};


export type MutationCreateEsportGroupArgs = {
  attributes: CreateEsportGroupAttributes;
};


export type MutationCreateEsportOfferingArgs = {
  descriptor: EsportOfferingDescriptor;
};


export type MutationCreateGameArgs = {
  input: CreateGameInput;
};


export type MutationCreateGameAssistantSelectionOptionsArgs = {
  input: GameAssistantSelectionOptionInsert;
};


export type MutationCreateGameHighlightArgs = {
  input: GameHighlightInput;
};


export type MutationCreateGameResultArgs = {
  input: CreateGameResultInput;
};


export type MutationCreateLeagueArgs = {
  input: CreateLeagueInput;
};


export type MutationCreateLeagueGroupArgs = {
  input: CreateLeagueGroupInput;
};


export type MutationCreateLegacyNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateLegacyUserNotificationArgs = {
  input: CreateUserNotificationInput;
};


export type MutationCreateLinkArgs = {
  input: CreateLinkInput;
};


export type MutationCreateMatchArgs = {
  input: CreateMatchInput;
};


export type MutationCreateMatchChatArgs = {
  input: CreateMatchChatInput;
};


export type MutationCreateMatchChatEventArgs = {
  input: CreateMatchChatEventInput;
};


export type MutationCreateMatchDisputeFeedbackArgs = {
  input: MatchDisputeFeedbackInput;
};


export type MutationCreateMatchDisputeRequestArgs = {
  input: CreateMatchDisputeRequestInput;
};


export type MutationCreateMatchResultArgs = {
  input: CreateMatchResultInput;
};


export type MutationCreateMatchSurveyResponseArgs = {
  input: MatchSurveyInput;
};


export type MutationCreateMetaseasonArgs = {
  config: CreateMetaseasonConfig;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreatePartnerArgs = {
  input: PartnerInput;
};


export type MutationCreatePastByeMatchArgs = {
  input: CreatePastByeMatchInput;
};


export type MutationCreatePhaseArgs = {
  input: CreatePhaseInput;
};


export type MutationCreatePhaseResultArgs = {
  input: CreatePhaseResultInput;
};


export type MutationCreateRoleInviteArgs = {
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
  resourceType: ResourceType;
  roleName: UserRoleName;
  userId: Scalars['UUID']['input'];
};


export type MutationCreateRoleInviteCodeArgs = {
  input: CreateRoleInviteCodeInput;
};


export type MutationCreateRoleRequestArgs = {
  resourceId: Scalars['UUID']['input'];
  resourceType: ResourceType;
  roleName: UserRoleName;
};


export type MutationCreateRoleReviewArgs = {
  role: UserRoleName;
  status: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationCreateSchoolArgs = {
  attributes: CreateSchoolAttributes;
};


export type MutationCreateSchoolMessageArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  schoolId: Scalars['UUID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};


export type MutationCreateScrimmageArgs = {
  input: RequestScrimmageInput;
};


export type MutationCreateSeasonArgs = {
  seasonSchedule?: InputMaybe<SeasonScheduleInput>;
};


export type MutationCreateSeasonDatesTemplateArgs = {
  input: SeasonDatesTemplateInput;
};


export type MutationCreateSeasonPassProductArgs = {
  attributes: CreateSeasonPassAttributes;
};


export type MutationCreateSeasonPlayoffTemplateArgs = {
  input: SeasonPlayoffTemplateInsertAttributes;
};


export type MutationCreateSeasonalPlayerAwardTypeArgs = {
  input: CreateSeasonalPlayerAwardTypeInput;
};


export type MutationCreateSlotArgs = {
  input: CreateSlotInput;
};


export type MutationCreateSlotExclusionRangeConfigurationArgs = {
  input: CreateSlotExclusionRangeConfigurationInput;
};


export type MutationCreateSlotExclusionWindowArgs = {
  input: SlotExclusionWindowInput;
};


export type MutationCreateSmashDiscordChannelArgs = {
  matchId: Scalars['UUID']['input'];
};


export type MutationCreateSponsorshipCampaignArgs = {
  input: SponsorshipCampaignInput;
};


export type MutationCreateSponsorshipComponentArgs = {
  input: SponsorshipComponentInput;
};


export type MutationCreateTeamForEventArgs = {
  input: CreateTeamForEventInput;
};


export type MutationCreateTeamV2Args = {
  input: CreateTeamV2Input;
  schoolOptions?: InputMaybe<TeamSchoolOptions>;
};


export type MutationCreateUserEmailArgs = {
  attributes?: InputMaybe<UserEmailInputAttributes>;
  options?: InputMaybe<CreateUserEmailOptions>;
  userId: Scalars['String']['input'];
};


export type MutationCreateUserLeadArgs = {
  input: UserLeadInput;
};


export type MutationCreateVarsityAssociationArgs = {
  attributes: CreateVarsityAssociationAttributes;
};


export type MutationDeclineQueueArgs = {
  input: DeclineQueueInput;
};


export type MutationDeclineScrimmageArgs = {
  input: CancelScrimmageInput;
};


export type MutationDeclineScrimmageQueueOpponentArgs = {
  teamId: Scalars['String']['input'];
};


export type MutationDecreaseSeasonReputationForTeamArgs = {
  input: DecreaseReputationInput;
};


export type MutationDeleteEsportOfferingArgs = {
  descriptor: DeleteEsportOfferingDescriptor;
};


export type MutationDeleteEsportPositionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteGameHighlightArgs = {
  input: DeleteGameHighlightInput;
};


export type MutationDeleteMatchArgs = {
  input: DeleteMatchInput;
};


export type MutationDeleteMatchChatEventArgs = {
  input: DeleteMatchChatEventInput;
};


export type MutationDeleteMatchDisputeRequestAssetArgs = {
  assetId: Scalars['UUID']['input'];
};


export type MutationDeleteMatchResultArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationDeleteMatchSettleRequestAssetArgs = {
  assetId: Scalars['UUID']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeletePartnerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSchoolArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type MutationDeleteSchoolMessageArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSeasonalPlayerAwardArgs = {
  input: DeleteSeasonalPlayerAwardInput;
};


export type MutationDeleteSeasonalPlayerAwardTypeArgs = {
  input: DeleteSeasonalPlayerAwardTypeInput;
};


export type MutationDeleteSlotArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSlotExclusionRangeConfigurationArgs = {
  input: DeleteSlotExclusionRangeConfigurationInput;
};


export type MutationDeleteSlotExclusionWindowArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSponsorshipCampaignArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSponsorshipComponentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteStadiumTeamArgs = {
  teamId: Scalars['UUID']['input'];
};


export type MutationDeleteSurveySchemaArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteTeamArgs = {
  teamId: Scalars['UUID']['input'];
};


export type MutationDeleteUserArgs = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDeleteUserEmailArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationDeleteUserTaskQueueArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationDeleteUsersPromotionalEmailAccountArgs = {
  userIds: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteWeeklyAssignedPlayerAwardArgs = {
  input: DeleteWeeklyAssignedPlayerAwardInput;
};


export type MutationDenyCoachArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationDenyPlayerArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationDenyTeamRivalArgs = {
  input: ResponseTeamRivalInput;
};


export type MutationDenyUserForOrganizationArgs = {
  input: UserRoleUpdateInput;
};


export type MutationDenyVerifiedCoachArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationDenyVerifiedPlayerArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationDismissMatchDisputeRequestArgs = {
  input: MatchDisputeRequestInput;
};


export type MutationDismissMatchSurveyArgs = {
  input: MatchSurveyInput;
};


export type MutationEnqueueClearUserNotificationsJobArgs = {
  schoolIds: Array<Scalars['UUID']['input']>;
};


export type MutationEnqueueNotificationForAllUsersArgs = {
  input: EnqueueNotificationForAllUsersInput;
};


export type MutationEnqueueUpcomingSlotScheduleJobsArgs = {
  input: EnqueueUpcomingSlotScheduleJobsInput;
};


export type MutationEnqueueUserNotificationsJobArgs = {
  input: EnqueueUserNotificationsJobInput;
};


export type MutationEnrollTeamInSeasonArgs = {
  options?: InputMaybe<TeamEnrollmentOptions>;
  seasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationExpireQueuePlaceArgs = {
  input: ExpireQueuePlaceInput;
};


export type MutationFinishGameArgs = {
  input: FinishGameInput;
};


export type MutationForceDeactivateTeamsArgs = {
  metaseasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationForceValidPlayerGameStatsArgs = {
  input: ForceValidPlayerGameStatsInput;
};


export type MutationForfeitMatchArgs = {
  forfeitDetail?: InputMaybe<Scalars['String']['input']>;
  forfeitedBy?: InputMaybe<Scalars['UUID']['input']>;
  matchId: Scalars['UUID']['input'];
  reason?: InputMaybe<ForfeitReason>;
  teamId: Scalars['UUID']['input'];
};


export type MutationFullFillPasswordResetArgs = {
  newPassword: Scalars['String']['input'];
  resetCode: Scalars['String']['input'];
};


export type MutationGenerateReferralLinkArgs = {
  attributes?: InputMaybe<ReferralLinkInput>;
};


export type MutationGenerateSeasonScheduleArgs = {
  config: SeasonConfig;
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
};


export type MutationGenerateSeasonalPlayerAwardCertificateArgs = {
  input: GenerateSeasonalPlayerAwardCertificateInput;
};


export type MutationGenerateSeasonalPlayerAwardSocialMediaImageArgs = {
  input: GenerateSeasonalPlayerAwardSocialMediaImageInput;
};


export type MutationGenerateTwilioAccessTokenByUserIdArgs = {
  input?: InputMaybe<GenerateTwilioAccessTokenByUserIdInput>;
};


export type MutationGetPasswordResetTokenArgs = {
  userId: Scalars['UUID']['input'];
};


export type MutationGraduatePlayerArgs = {
  input: GraduatePlayerInput;
};


export type MutationGrantAnnualPassToSchoolArgs = {
  initialMetaseasonId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['UUID']['input'];
  reason: ProductGrantReason;
  schoolId: Scalars['UUID']['input'];
};


export type MutationGrantSeasonPassToUserArgs = {
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['UUID']['input'];
  reason: ProductGrantReason;
  userId: Scalars['UUID']['input'];
};


export type MutationHardDeleteSchoolArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type MutationIncreaseSeasonReputationForTeamArgs = {
  input: IncreaseReputationInput;
};


export type MutationIndexMatchArgs = {
  matchId: Scalars['String']['input'];
};


export type MutationInitializeUserTaskQueueArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationJoinPreseasonQueueArgs = {
  teamId: Scalars['String']['input'];
};


export type MutationJoinQueueArgs = {
  input: JoinQueueInput;
};


export type MutationJoinScrimmageArgs = {
  input: JoinScrimmageInput;
};


export type MutationJoinScrimmageQueueArgs = {
  teamId: Scalars['String']['input'];
};


export type MutationJoinSmartQueueArgs = {
  input: JoinSmartQueueInput;
};


export type MutationJoinTeamArgs = {
  options?: InputMaybe<JoinTeamOptions>;
  position?: InputMaybe<Scalars['Int']['input']>;
  positionId?: InputMaybe<Scalars['UUID']['input']>;
  teamId: Scalars['UUID']['input'];
};


export type MutationLeavePreseasonQueueArgs = {
  teamId: Scalars['String']['input'];
};


export type MutationLeaveQueueArgs = {
  input: LeaveQueueInput;
};


export type MutationLeaveScrimmageQueueArgs = {
  teamId: Scalars['String']['input'];
};


export type MutationLeaveSmartQueueArgs = {
  input: LeaveSmartQueueInput;
};


export type MutationLeaveTeamArgs = {
  teamId: Scalars['UUID']['input'];
};


export type MutationLinkManualAccountArgs = {
  attributes: LinkManualAccountInput;
  userId: Scalars['UUID']['input'];
};


export type MutationLinkNintendoAccountArgs = {
  attributes: LinkNintendoAccountInput;
  userId: Scalars['UUID']['input'];
};


export type MutationLinkPlayStationNetworkAccountArgs = {
  input: LinkPlayStationNetworkAccountInput;
};


export type MutationLinkSmiteAccountArgs = {
  input: LinkSmiteAccountInput;
};


export type MutationLoginUserArgs = {
  input: LoginUserInput;
};


export type MutationManuallySeedPlayoffPhasesArgs = {
  input: ManuallySeedPlayoffPhasesInput;
};


export type MutationMarkAllUserNotificationsReadArgs = {
  input: MarkAllUserNotificationsReadInput;
};


export type MutationMarkContentAsReadArgs = {
  slugs: ContentSlugs;
};


export type MutationMarkTeamLockedInForPhaseArgs = {
  phaseId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationMarkTeamNotLockedInForPhaseArgs = {
  phaseId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationMarkUserNotificationOpenedArgs = {
  input: MarkUserNotificationOpenedInput;
};


export type MutationMarkUserNotificationTaskCompletedArgs = {
  input: MarkUserNotificationCompletedInput;
};


export type MutationMarkUserNotificationTaskCompletedByUserArgs = {
  input: MarkUserNotificationCompletedInput;
  userId: Scalars['UUID']['input'];
};


export type MutationMarkUserNotificationTaskOpenedArgs = {
  input: MarkUserNotificationOpenedInput;
};


export type MutationMatchUserToLeadArgs = {
  input: MatchUserToLeadInput;
};


export type MutationMergeMatchesArgs = {
  input: MergeMatchesInput;
};


export type MutationMigrateSchoolToAnnualPayArgs = {
  annualPassProductId: Scalars['UUID']['input'];
  initialMetaseasonId: Scalars['UUID']['input'];
  options?: InputMaybe<AnnualPassMigrationOptions>;
  productAcquisitionMethod: ProductAcquisitionMethod;
  schoolId: Scalars['UUID']['input'];
};


export type MutationMockConnectEpicAccountArgs = {
  attributes: LinkEpicAccountInput;
  userId: Scalars['UUID']['input'];
};


export type MutationMockFortniteTeamMatchStatsArgs = {
  matchId: Scalars['UUID']['input'];
};


export type MutationMoveSchoolToLeagueArgs = {
  fromLeagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
  toLeagueId: Scalars['UUID']['input'];
};


export type MutationMoveUserToSchoolArgs = {
  input: MoveUserToSchoolInput;
};


export type MutationOpenMatchArgs = {
  input: OpenMatchInput;
};


export type MutationPatchFortniteTeamMatchStatsArgs = {
  attributes?: InputMaybe<PatchFortniteTeamMatchStatsInput>;
  id: Scalars['UUID']['input'];
};


export type MutationPatchLegacyNotificationArgs = {
  id: Scalars['UUID']['input'];
  input: PatchNotificationInput;
};


export type MutationPatchMatchSettleRequestArgs = {
  input: PatchMatchSettleRequestInput;
};


export type MutationPatchTeamMatchStatsArgs = {
  attributes?: InputMaybe<PatchTeamMatchStatsInput>;
  id: Scalars['UUID']['input'];
};


export type MutationProcessBackupEventsArgs = {
  input: ProcessBackupEventsInput;
};


export type MutationRecheckNotificationTaskStatusArgs = {
  input: RecheckNotificationTaskStatusInput;
};


export type MutationRecreateBracketArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type MutationRedoPlayerGameStatsForGameArgs = {
  gameId: Scalars['UUID']['input'];
};


export type MutationRedoSchedulePhaseMatchesArgs = {
  input: SchedulePhaseMatchesInput;
};


export type MutationReferByEmailArgs = {
  input: ReferByEmailInput;
};


export type MutationReferParentByEmailArgs = {
  input: ReferParentByEmailInput;
};


export type MutationRefreshFortniteMatchArgs = {
  matchId: Scalars['UUID']['input'];
};


export type MutationRefreshSchoolLeagueGroupsArgs = {
  firstEffectiveMetaseasonId: Scalars['UUID']['input'];
  options?: InputMaybe<RefreshSchoolLeagueGroupsOptions>;
  schoolId: Scalars['UUID']['input'];
};


export type MutationRegisterUserArgs = {
  input: RegisterUserInput;
  options?: InputMaybe<RegisterUserOptions>;
};


export type MutationRegisterUserWithUsernameArgs = {
  input: RegisterUserWithUsernameInput;
  options?: InputMaybe<RegisterUserOptions>;
};


export type MutationRemoveAnnualPassArgs = {
  annualPassInstanceId: Scalars['UUID']['input'];
};


export type MutationRemoveLeagueFromLeagueGroupArgs = {
  leagueGroupId: Scalars['UUID']['input'];
  leagueId: Scalars['UUID']['input'];
};


export type MutationRemoveLeagueFromLeagueGroupsArgs = {
  leagueId: Scalars['UUID']['input'];
  states: Array<Scalars['String']['input']>;
  varsityAssociationSlugs: Array<Scalars['String']['input']>;
};


export type MutationRemoveLeagueFromSchoolArgs = {
  leagueId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type MutationRemoveLeagueFromSchoolsBulkArgs = {
  leagueId: Scalars['UUID']['input'];
  states: Array<Scalars['String']['input']>;
  varsityAssociationSlugs: Array<Scalars['String']['input']>;
};


export type MutationRemovePlatformsFromEsportArgs = {
  esportId: Scalars['UUID']['input'];
  platforms?: InputMaybe<Array<Platform>>;
};


export type MutationRemovePlayerFromTeamArgs = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  hideTeamInRequestIfDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  playerId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationRemoveProviderAccountArgs = {
  id: Scalars['UUID']['input'];
  provider: Scalars['String']['input'];
};


export type MutationRemoveSchoolFromVarsityAssociationArgs = {
  firstEffectiveMetaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
  varsityAssociationSlug: Scalars['String']['input'];
};


export type MutationRemoveSchoolLeagueGroupExclusionArgs = {
  leagueGroupId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type MutationRemoveSchoolsFromVarsityAssociationArgs = {
  input: RemoveSchoolsFromVarsityAssociationInput;
};


export type MutationRemoveSelectionOptionByIdArgs = {
  selectionOptionId: Scalars['UUID']['input'];
};


export type MutationRemoveSponsorshipImageArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveTeamCoachArgs = {
  coachUserId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationRemoveTeamFromLeagueArgs = {
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationRemoveTeamRivalArgs = {
  input: RemoveTeamRivalInput;
};


export type MutationRemoveUserEsportPlatformArgs = {
  esportId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationRemoveUserFromSchoolArgs = {
  input: RemoveUserFromSchoolInput;
};


export type MutationRemoveUserRoleArgs = {
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  role: UserRoleName;
  userId: Scalars['UUID']['input'];
};


export type MutationReplaceTeamCoachArgs = {
  existingCoachUserId: Scalars['UUID']['input'];
  newCoachUserId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationRepositionPlayersInTeamArgs = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  playerPositions: Array<PlayerPosition>;
  teamId: Scalars['UUID']['input'];
};


export type MutationReprocessFortniteMatchStatsArgs = {
  matchId: Scalars['UUID']['input'];
};


export type MutationReprocessFortnitePlayerTeamMatchArgs = {
  matchId: Scalars['UUID']['input'];
};


export type MutationRequestAccountEditArgs = {
  input?: InputMaybe<RequestAccountEditInput>;
};


export type MutationRequestEmailUpdateArgs = {
  input?: InputMaybe<RequestEmailUpdateInput>;
};


export type MutationRequestEmailVerificationArgs = {
  input: RequestEmailVerificationInput;
};


export type MutationRequestGameResetArgs = {
  input: RequestGameResetInput;
};


export type MutationRequestMatchAssistantBypassArgs = {
  input: RequestMatchAssistantBypassInput;
};


export type MutationRequestMatchRescheduleArgs = {
  input: RequestMatchRescheduleInput;
};


export type MutationRequestMatchRescheduleWithinSchoolArgs = {
  input: RequestMatchRescheduleWithinSchoolInput;
};


export type MutationRequestNextGameRosterChangeForRocketLeagueArgs = {
  input: RequestNextGameRosterChangeForRocketLeagueInput;
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestScrimmageArgs = {
  input: RequestScrimmageInput;
};


export type MutationRequestTeamRivalArgs = {
  input: RequestTeamRivalInput;
};


export type MutationRescheduleMatchArgs = {
  matchId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: AdminMatchRescheduleReason;
  updatedStartsAt: Scalars['DateTime']['input'];
};


export type MutationRescheduleMatchesArgs = {
  input: RescheduleMatchesInput;
};


export type MutationRescheduleSlotArgs = {
  input: RescheduleSlotInput;
};


export type MutationResetGameAssistantStepsForGameArgs = {
  gameOrdinal: Scalars['Int']['input'];
  matchId: Scalars['UUID']['input'];
  seriesOrdinal?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationResetGameAssistantStepsForMatchArgs = {
  matchId: Scalars['UUID']['input'];
};


export type MutationResetGameAssistantStepsForSeriesArgs = {
  matchId: Scalars['UUID']['input'];
  seriesOrdinal: Scalars['Int']['input'];
};


export type MutationResetUserForVerificationArgs = {
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationResetUserSeasonPassConsumedArgs = {
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationResizeAssetArgs = {
  resource: ResourceData;
};


export type MutationResolveUnknownPlayerGameStatsArgs = {
  input: ResolveUnknownPlayerGameStatsInput;
};


export type MutationRespondToMatchRescheduleRequestArgs = {
  input: ResponseMatchRescheduleInput;
};


export type MutationRespondToRoleInviteArgs = {
  roleInviteId: Scalars['UUID']['input'];
  status: UserRoleStatusName;
};


export type MutationRespondToRoleRequestArgs = {
  roleRequestId: Scalars['UUID']['input'];
  status: UserRoleStatusName;
};


export type MutationResurrectDuplicateDeletedTeamArgs = {
  deletedTeamMemberIds: Array<Scalars['UUID']['input']>;
  teamToReplaceId: Scalars['UUID']['input'];
};


export type MutationResurrectSchoolArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type MutationResurrectStadiumTeamArgs = {
  teamId: Scalars['UUID']['input'];
};


export type MutationResurrectTeamArgs = {
  teamId: Scalars['UUID']['input'];
};


export type MutationRollupAllPhaseResultsArgs = {
  input: RollupAllPhaseResultsInput;
};


export type MutationRollupFortnitePhaseStatsArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type MutationRollupPhaseResultsArgs = {
  input: RollupPhaseResultsInput;
};


export type MutationRollupPlayerPhaseStatsArgs = {
  phaseId?: InputMaybe<Scalars['UUID']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationRunBulkActionArgs = {
  input: RunBulkActionInput;
};


export type MutationRunPhaseGenerationArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type MutationSaveGameResultLiveArgs = {
  input: SaveGameResultInput;
};


export type MutationSaveMatchNotesLiveArgs = {
  input: SaveMatchNotesInput;
};


export type MutationSaveSurveyArgs = {
  input: SaveSurveyInput;
};


export type MutationSaveSurveyResponseArgs = {
  responseJson: Scalars['String']['input'];
  surveySchemaId: Scalars['UUID']['input'];
};


export type MutationSaveSurveySchemaArgs = {
  input: SaveSurveySchemaInput;
};


export type MutationSaveUpdateBracketArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type MutationScheduleMatchArgs = {
  input: ScheduleMatchInput;
};


export type MutationScheduleMatchesArgs = {
  input: ScheduleMatchesInput;
};


export type MutationScheduleNextBracketMatchArgs = {
  input: ScheduleNextBracketMatchInput;
};


export type MutationSchedulePhaseMatchesArgs = {
  input: SchedulePhaseMatchesInput;
};


export type MutationSchedulePhaseMatchesMockedArgs = {
  input: SchedulePhaseMatchesInput;
};


export type MutationSeedFortnitePlayoffTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  phaseId: Scalars['UUID']['input'];
};


export type MutationSeedPhaseTeamsArgs = {
  input: SeedPhaseTeamsInput;
};


export type MutationSendAnnouncementArgs = {
  input: SendAnnouncementInput;
};


export type MutationSendAnnouncementByMatchIdsArgs = {
  input: SendAnnouncementByMatchIdsInput;
};


export type MutationSendEnrollmentConfirmationArgs = {
  metaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type MutationSendFirstMessageNotificationIfNecessaryArgs = {
  input: SendFirstMessageNotificationIfNecessaryInput;
};


export type MutationSetChildAccountSettingsArgs = {
  input: ChildAccountSettingsInput;
  userId: Scalars['UUID']['input'];
};


export type MutationSetChildParentArgs = {
  childUserId: Scalars['UUID']['input'];
  parentUserId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSetContentForUserArgs = {
  input: SetContentForUserInput;
  userId: Scalars['UUID']['input'];
};


export type MutationSetEsportColorsArgs = {
  attributes: EsportColorsAttributes;
  esportId: Scalars['UUID']['input'];
};


export type MutationSetEsportLeagueDefaultsArgs = {
  attributes: EsportLeagueDefaultsAttributes;
  esportId: Scalars['UUID']['input'];
};


export type MutationSetEsportRulebookArgs = {
  competitionGroup: CompetitionGroup;
  esportId: Scalars['UUID']['input'];
  url: Scalars['String']['input'];
};


export type MutationSetGameOrdinalArgs = {
  matchId: Scalars['UUID']['input'];
  ordinal: Scalars['Int']['input'];
};


export type MutationSetHearthstonePlayerMatchDeckSelectionArgs = {
  attributes?: InputMaybe<SetHearthstonePlayerMatchDeckSelectionInput>;
  matchId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationSetIsEnabledEsportArgs = {
  esportId: Scalars['UUID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationSetLeaguesActiveForMetaseasonArgs = {
  leagueIds: Array<Scalars['UUID']['input']>;
  metaseasonId: Scalars['UUID']['input'];
};


export type MutationSetLeaguesInactiveForMetaseasonArgs = {
  leagueIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  metaseasonId: Scalars['UUID']['input'];
};


export type MutationSetMatchSeriesArgs = {
  matchId: Scalars['UUID']['input'];
};


export type MutationSetMyAccountSettingsArgs = {
  input: SetMyAccountSettingsInput;
};


export type MutationSetMyEsportInterestsArgs = {
  input?: InputMaybe<SetMyEsportInterests>;
};


export type MutationSetMyFacultyInformationArgs = {
  input: SetMyFacultyInformationInput;
};


export type MutationSetMyFacultyRoleArgs = {
  input: SetMyFacultyRoleInput;
};


export type MutationSetMySchoolSubmissionArgs = {
  input: SetMySchoolSubmissionInput;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSetMyUserDemographicsArgs = {
  input: UserDemographicsInput;
};


export type MutationSetPlayerLeaguesArgs = {
  leagueIds: Array<Scalars['UUID']['input']>;
  metaseasonId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationSetSchoolBillingContactArgs = {
  input: SchoolBillingContactInput;
  schoolId: Scalars['UUID']['input'];
};


export type MutationSetSchoolLogoArgs = {
  file: Scalars['Upload']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type MutationSetSchoolsForCampaignArgs = {
  input: SetSponsorshipCampaignSchoolsInput;
};


export type MutationSetSeasonReputationForTeamArgs = {
  input: SetReputationForTeamInput;
};


export type MutationSetSeasonReputationForTeamsArgs = {
  input: SetReputationForTeamsInput;
};


export type MutationSetSeriesOrdinalArgs = {
  matchId: Scalars['UUID']['input'];
  ordinal: Scalars['Int']['input'];
};


export type MutationSetSlotExclusionRangeDefaultWindowsArgs = {
  input: SetSlotExclusionRangeDefaultWindowsInput;
};


export type MutationSetStepOrdinalArgs = {
  matchId: Scalars['UUID']['input'];
  ordinal: Scalars['Int']['input'];
};


export type MutationSetTeamIsPlayerLedArgs = {
  isPlayerLed: Scalars['Boolean']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationSetUserAccountSettingsArgs = {
  input: SetAccountSettingsInput;
  userId: Scalars['UUID']['input'];
};


export type MutationSetUserAsParentArgs = {
  isParent: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationSetUserAvatarImageArgs = {
  file: Scalars['Upload']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationSetUserEsportInterestsArgs = {
  input: SetUserEsportInterestsInput;
};


export type MutationSetUserEsportPlatformArgs = {
  input: SetUserEsportPlatformInput;
};


export type MutationSetUserEsportProviderArgs = {
  input: SetUserEsportProviderInput;
};


export type MutationSetUserGradYearArgs = {
  gradYear: Scalars['Int']['input'];
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationSetUserNotificationEnabledArgs = {
  input: SetUserNotificationEnabledInput;
};


export type MutationSetUserNotificationIsPersonalArgs = {
  input: SetUserNotificationIsPersonalInput;
};


export type MutationSetUserNotificationScopeArgs = {
  input: SetUserNotificationScopeInput;
};


export type MutationSetUserOnlineArgs = {
  userId: Scalars['UUID']['input'];
};


export type MutationSetUserSeasonPassArgs = {
  consumedAt?: InputMaybe<Scalars['DateTime']['input']>;
  productInstanceId: Scalars['UUID']['input'];
};


export type MutationSetUsersSeasonPassConsumedArgs = {
  metaseasonId: Scalars['UUID']['input'];
  userConsumptions: Array<UserConsumptionInput>;
};


export type MutationStartGameArgs = {
  input: StartGameInput;
};


export type MutationStartPhoneVerificationArgs = {
  phone: Scalars['String']['input'];
};


export type MutationSubmitAdminMatchSettleRequestLiveArgs = {
  input: SubmitAdminMatchSettleRequestLiveInput;
};


export type MutationSubmitGameAssistantStepSelectionsArgs = {
  input: SubmitGameAssistantStepSelectionsInput;
};


export type MutationSubmitLeaderboardGameResultLiveArgs = {
  input: SubmitLeaderboardGameResultLiveInput;
};


export type MutationSubmitMatchSettleRequestAssetsLiveArgs = {
  input: SubmitAdminMatchSettleRequestAssetsInput;
};


export type MutationSubmitMatchSettleRequestLiveArgs = {
  input: SubmitMatchSettleRequestLiveInput;
};


export type MutationSubmitUserSchoolSurveyArgs = {
  input: SubmitUserSchoolSurveyInput;
};


export type MutationTogglePlayvsScoreArgs = {
  enabled: Scalars['Boolean']['input'];
  seasonId: Scalars['UUID']['input'];
};


export type MutationTourViewedArgs = {
  tour: Tour;
};


export type MutationTransferPlayerArgs = {
  input: TransferPlayerInput;
};


export type MutationTransferSubstituteToTeamArgs = {
  input: TransferSubstituteToTeamInput;
};


export type MutationTransferTeamToSeasonArgs = {
  destinationSeasonId: Scalars['UUID']['input'];
  options?: InputMaybe<TeamEnrollmentOptions>;
  originSeasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationTransferTeamsToSeasonArgs = {
  input: TransferTeamsToSeasonInput;
};


export type MutationTriggerFinishRocketLeagueCallbackHandlerArgs = {
  externalGameId?: InputMaybe<Scalars['String']['input']>;
  payload: PsyonixMatchResultPayload;
};


export type MutationTriggerUpdateRocketLeagueCallbackHandlerArgs = {
  externalGameId?: InputMaybe<Scalars['String']['input']>;
  payload: PsyonixMatchResultPayload;
};


export type MutationUnSetUserEsportProviderArgs = {
  input: UnSetUserEsportProviderInput;
};


export type MutationUnassignCaptainFromTeamArgs = {
  teamId: Scalars['UUID']['input'];
};


export type MutationUnassignMatchAssignmentArgs = {
  input: UnassignMatchAssignmentInput;
};


export type MutationUnassignTeamCaptainRoleArgs = {
  teamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationUnbanUserArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};


export type MutationUncompleteChecklistItemArgs = {
  schoolId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
};


export type MutationUnenrollTeamFromSeasonArgs = {
  seasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type MutationUnenrollTeamsFromSeasonArgs = {
  input: UnenrollTeamsFromSeasonInput;
};


export type MutationUnlinkParentFromChildArgs = {
  childUserId: Scalars['UUID']['input'];
  parentId: Scalars['UUID']['input'];
};


export type MutationUnlinkRiotAccountArgs = {
  puuid: Scalars['String']['input'];
};


export type MutationUnlinkSchoolProviderAccountArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationUnlinkUserProviderAccountArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationUnlockLeagueArgs = {
  input: UnlockLeagueInput;
};


export type MutationUpdateAllowCaptainEnrollmentArgs = {
  allowCaptainEnrollment: Scalars['Boolean']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type MutationUpdateAllowPlayerLedTeamsArgs = {
  allowPlayerLedTeams: Scalars['Boolean']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type MutationUpdateChannelMembersArgs = {
  input: UpdateChannelMembersInput;
};


export type MutationUpdateCurrentAnnualPassBySchoolIdArgs = {
  metaseasonIds: Array<Scalars['UUID']['input']>;
  schoolId: Scalars['UUID']['input'];
};


export type MutationUpdateEsportArgs = {
  attributes: EsportAttributes;
  id: Scalars['UUID']['input'];
};


export type MutationUpdateEsportDetailsArgs = {
  attributes?: InputMaybe<EsportDetailsAttributes>;
  esportSlug: Scalars['String']['input'];
};


export type MutationUpdateEsportGroupArgs = {
  attributes: UpdateEsportGroupAttributes;
  id: Scalars['UUID']['input'];
};


export type MutationUpdateEsportOfferingArgs = {
  descriptor: EsportOfferingUpdateDescriptor;
  esportGroupId: Scalars['UUID']['input'];
  esportOfferingId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationUpdateGameArgs = {
  input: UpdateGameInput;
};


export type MutationUpdateGameHighlightArgs = {
  input: UpdateGameHighlightInput;
};


export type MutationUpdateGameResultArgs = {
  input: UpdateGameResultInput;
};


export type MutationUpdateLeagueArgs = {
  input: UpdateLeagueInput;
};


export type MutationUpdateLeagueGroupArgs = {
  attributes: UpdateLeagueGroupInput;
  id: Scalars['UUID']['input'];
};


export type MutationUpdateLinkArgs = {
  input: UpdateLinkInput;
};


export type MutationUpdateLobbyArgs = {
  input?: InputMaybe<UpdateLobbyInput>;
  tournamentCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMatchArgs = {
  input: UpdateMatchInput;
};


export type MutationUpdateMatchChatEventArgs = {
  input: UpdateMatchChatEventInput;
};


export type MutationUpdateMatchResultArgs = {
  input: UpdateMatchResultInput;
};


export type MutationUpdateMemberDiscordRolesArgs = {
  metaseasonId: Scalars['UUID']['input'];
  teamIds: Array<Scalars['UUID']['input']>;
};


export type MutationUpdateMetaseasonArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateMetaseasonInput;
};


export type MutationUpdatePartnerArgs = {
  id: Scalars['UUID']['input'];
  input: PartnerInput;
};


export type MutationUpdatePhaseArgs = {
  input: UpdatePhaseInput;
};


export type MutationUpdatePhaseResultArgs = {
  input: UpdatePhaseResultInput;
};


export type MutationUpdateProductArgs = {
  attributes: UpdateProductAttributes;
  productId: Scalars['UUID']['input'];
};


export type MutationUpdateReferralBountySchoolsArgs = {
  referralSchoolIds: Array<Scalars['UUID']['input']>;
  schoolId: Scalars['UUID']['input'];
};


export type MutationUpdateRiotAccountByPuuidArgs = {
  puuid: Scalars['String']['input'];
};


export type MutationUpdateRoleMembersArgs = {
  input: UpdateRoleMembersInput;
};


export type MutationUpdateSchoolAddressArgs = {
  input: UpdateSchoolAddressInput;
  schoolId: Scalars['UUID']['input'];
};


export type MutationUpdateSchoolDetailArgs = {
  detail: SchoolDetailInput;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationUpdateSchoolEnrollmentArgs = {
  input: UpdateSchoolEnrollmentInput;
};


export type MutationUpdateSchoolMessageArgs = {
  id: Scalars['UUID']['input'];
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  schoolId: Scalars['UUID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};


export type MutationUpdateSchoolProfileArgs = {
  input: SetSchoolProfileInput;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationUpdateSchoolSearchIndexArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type MutationUpdateSchoolSheerIdArgs = {
  schoolId: Scalars['UUID']['input'];
  sheeridOrganizationId: Scalars['Int']['input'];
  sheeridOrganizationName: Scalars['String']['input'];
};


export type MutationUpdateSchoolSlugArgs = {
  id: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationUpdateSeasonArgs = {
  attributes?: InputMaybe<SeasonUpdateAttributes>;
  id: Scalars['UUID']['input'];
  seasonSchedule?: InputMaybe<UpdateSeasonScheduleInput>;
};


export type MutationUpdateSeasonDatesTemplateArgs = {
  attributes: UpdateSeasonDatesTemplateInput;
  name: Scalars['String']['input'];
};


export type MutationUpdateSeasonPlayoffTemplateArgs = {
  input: SeasonPlayoffTemplateUpdateAttributes;
};


export type MutationUpdateSeasonalPlayerAwardArgs = {
  input: UpdateSeasonalPlayerAwardInput;
};


export type MutationUpdateSeasonalPlayerAwardTypeArgs = {
  input: UpdateSeasonalPlayerAwardTypeInput;
};


export type MutationUpdateShowCoachEmailsArgs = {
  schoolId: Scalars['UUID']['input'];
  showCoachEmails: Scalars['Boolean']['input'];
};


export type MutationUpdateSlotArgs = {
  input: UpdateSlotInput;
};


export type MutationUpdateSlotExclusionRangeConfigurationArgs = {
  input: UpdateSlotExclusionRangeConfigurationInput;
};


export type MutationUpdateSlotExclusionWindowArgs = {
  attributes: SlotExclusionWindowAttributes;
  id: Scalars['UUID']['input'];
};


export type MutationUpdateSpinSchoolArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type MutationUpdateSponsorshipCampaignArgs = {
  id: Scalars['UUID']['input'];
  input: SponsorshipCampaignUpdateInput;
};


export type MutationUpdateSponsorshipComponentArgs = {
  id: Scalars['UUID']['input'];
  input: SponsorshipComponentUpdateInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
  teamId: Scalars['UUID']['input'];
};


export type MutationUpdateTeamGlobalStatsArgs = {
  teamId: Scalars['UUID']['input'];
};


export type MutationUpdateUserRoleStatusArgs = {
  input: UpdateUserRoleStatusInput;
};


export type MutationUpdateUserTaskQueueArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationUpdateVarsityAssociationArgs = {
  input: UpdateVarsityAssociationInput;
  slug: Scalars['String']['input'];
};


export type MutationUpdateWeeklyAssignedPlayerAwardArgs = {
  input: UpdateWeeklyAssignedPlayerAwardInput;
};


export type MutationUploadEsportFileArgs = {
  input: UploadEsportFileInput;
};


export type MutationUploadMatchDisputeRequestAssetArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadMatchSettleRequestAssetArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadSelectionOptionAssetArgs = {
  esportSlug: Scalars['EsportSlug']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUploadSponsorshipImageArgs = {
  entityId: Scalars['UUID']['input'];
  entityType: SponsorshipEntityType;
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
};


export type MutationUploadTeamAvatarArgs = {
  input: UploadTeamAvatarInput;
};


export type MutationUpsertMatchCheckInArgs = {
  params?: InputMaybe<MatchCheckInUpsertParams>;
};


export type MutationUpsertSponsorshipImageArgs = {
  entityId: Scalars['UUID']['input'];
  entityType: SponsorshipEntityType;
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationValidateScholasticRoleArgs = {
  input: ValidateScholasticRoleAttributes;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationVerifyArchivedPlayerArgs = {
  input: VerifyArchivedPlayerInput;
};


export type MutationVerifyCoachArgs = {
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationVerifyCoachUsingSheerIdArgs = {
  input: VerifyCoachInput;
};


export type MutationVerifyCommunicationWithOverrideArgs = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationVerifyDeniedCoachArgs = {
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationVerifyDeniedPlayerArgs = {
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationVerifyGameArgs = {
  input: VerifyGameInput;
};


export type MutationVerifyPlayerArgs = {
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationVerifyUserForOrganizationArgs = {
  input: UserRoleUpdateInput;
};

export type Nba2kGameStats = {
  __typename?: 'NBA2kGameStats';
  gameId: Scalars['UUID']['output'];
  players: Array<Nba2kPlayerGameStats>;
  winner: Scalars['UUID']['output'];
};

export type Nba2kMostPlayedStatsByPlayerId = {
  __typename?: 'NBA2kMostPlayedStatsByPlayerId';
  averageScore: Scalars['Float']['output'];
  mostPlayedTeams: Array<Maybe<Nba2kPlayedWinRate>>;
  playerId: Scalars['UUID']['output'];
};

export type Nba2kPlayedWinRate = {
  __typename?: 'NBA2kPlayedWinRate';
  assetUri: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  played: Scalars['Float']['output'];
  winRate: Scalars['Float']['output'];
};

export type Nba2kPlayerGameStats = {
  __typename?: 'NBA2kPlayerGameStats';
  playerId: Scalars['UUID']['output'];
  score: Scalars['Int']['output'];
  teamId: Scalars['UUID']['output'];
  teamPlayed: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['UUID']['output'];
};

export type Note = {
  __typename?: 'Note';
  author: User;
  authorId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  textContent: Scalars['String']['output'];
};

export type NoteFilters = {
  authorId?: InputMaybe<Scalars['UUID']['input']>;
  entityId?: InputMaybe<Scalars['UUID']['input']>;
  entityType?: InputMaybe<EntityType>;
};

export type NoteOptions = {
  filters?: InputMaybe<NoteFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<Array<InputMaybe<NoteSort>>>;
};

export type NoteSort = {
  field: NoteSortField;
  order: NoteSortOrder;
};

export enum NoteSortField {
  CreatedAt = 'CreatedAt'
}

export enum NoteSortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export enum NotificationCategory {
  Esport = 'esport',
  Promotional = 'promotional'
}

export enum NotificationScope {
  AllSchoolTeams = 'allSchoolTeams',
  PersonalTeams = 'personalTeams'
}

export enum NotificationStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type NotificationSummaryPayload = {
  __typename?: 'NotificationSummaryPayload';
  notificationTasksCount: Scalars['Int']['output'];
  unreadNotificationCount: Scalars['Int']['output'];
};

export type NumberOfPossibleTeamsAndPlayersResult = {
  __typename?: 'NumberOfPossibleTeamsAndPlayersResult';
  numberOfPlayers: Scalars['Int']['output'];
  numberOfTeams: Scalars['Int']['output'];
};

export type NumberOfTeamsInSeasonByStateResult = {
  __typename?: 'NumberOfTeamsInSeasonByStateResult';
  state: Scalars['String']['output'];
  teamCount: Scalars['Int']['output'];
};

export type NumberOfTeamsInSeasonByVarsityAssociationResult = {
  __typename?: 'NumberOfTeamsInSeasonByVarsityAssociationResult';
  teamCount: Scalars['Int']['output'];
  varsityAssociation: Maybe<VarsityAssociation>;
};

export type OAuthProvider = {
  __typename?: 'OAuthProvider';
  email: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export type ObjectIdEdge = {
  cursor: Scalars['String']['output'];
  node: ObjectIdNode;
};

export type ObjectIdNode = {
  id: Scalars['ObjectID']['output'];
};

export type ObjectIdPaginatedResults = {
  edges: Array<ObjectIdEdge>;
  pageInfo: PageInfo;
};

export enum OnlineStatus {
  Idle = 'idle',
  Offline = 'offline',
  Online = 'online'
}

export type OpenMatchInput = {
  matchId: Scalars['UUID']['input'];
  options?: InputMaybe<OpenMatchOptionsInput>;
};

export type OpenMatchOptionsInput = {
  ignoreStartTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OpenSlotLobbyDetails = {
  __typename?: 'OpenSlotLobbyDetails';
  lobbyClosesAt: Maybe<Scalars['DateTime']['output']>;
  nextPairingAt: Maybe<Scalars['DateTime']['output']>;
};

export type OrderByOptions = {
  field: Scalars['String']['input'];
  order: QuerySortOrder;
};

export type OrganizationEnrollmentData = {
  __typename?: 'OrganizationEnrollmentData';
  metaseason: Metaseason;
  organization: School;
  seasonSlotExclusionData: SlotExclusionData;
  slotExclusionData: SlotExclusionData;
};

export type OrganizationEnrollmentDataQueryInput = {
  metaseasonId: Scalars['UUID']['input'];
  organizationId: Scalars['UUID']['input'];
};

export type OrganizationEnrollmentDataQueryResult = {
  __typename?: 'OrganizationEnrollmentDataQueryResult';
  data: OrganizationEnrollmentData;
};

export type OrganizationScheduleQueryInput = {
  bounds?: InputMaybe<ScheduleQueryBounds>;
  organizationId: Scalars['UUID']['input'];
};

export type OrganizationScheduleQueryPayload = {
  __typename?: 'OrganizationScheduleQueryPayload';
  results: Array<TeamScheduleResult>;
};

export type OrganizationSlotExclusionWindowSuggestion = {
  __typename?: 'OrganizationSlotExclusionWindowSuggestion';
  isAvailable: Scalars['Boolean']['output'];
  suggestion: SlotExclusionWindowSuggestion;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PaginatedResults = {
  edges: Array<Edge>;
  pageInfo: PageInfo;
};

export type PairingRankingInput = {
  source?: InputMaybe<PairingRankingSourceInput>;
  type: PairingRankingType;
};

export enum PairingRankingSource {
  Phase = 'phase'
}

export type PairingRankingSourceInput = {
  id: Scalars['UUID']['input'];
  qualifyWins?: InputMaybe<Scalars['Int']['input']>;
  type: PairingRankingSource;
};

export enum PairingRankingType {
  None = 'none',
  Points = 'points',
  PointsPlus = 'pointsPlus',
  Qualifier = 'qualifier',
  Seed = 'seed'
}

export type ParentVerificationPayload = {
  __typename?: 'ParentVerificationPayload';
  success: Scalars['Boolean']['output'];
};

export type Partner = {
  __typename?: 'Partner';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type PartnerInput = {
  name: Scalars['String']['input'];
};

export type PartnerOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerResult = {
  __typename?: 'PartnerResult';
  result: Maybe<Array<Partner>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PartnerSearchInput = {
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<PartnerOptions>;
};

export type PassSummary = {
  __typename?: 'PassSummary';
  annualPassType: AnnualPassType;
  passUsage: Scalars['Int']['output'];
  passUsageByMetaseason: Array<MetaseasonPassUsageSummaryPayload>;
  planDateRange: DateRange;
  productName: Scalars['String']['output'];
  seasonPassesBilled: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

export type PasswordResetPayload = {
  __typename?: 'PasswordResetPayload';
  isValid: Scalars['Boolean']['output'];
  userId: Scalars['UUID']['output'];
};

export type PastMatchesByTeamIdInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  metaseasonId: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SeasonTeamMatchSort>;
  teamIds: Array<Scalars['UUID']['input']>;
};

export type PatchFortniteTeamMatchStatsInput = {
  avgEliminationsPerSession?: InputMaybe<Scalars['Float']['input']>;
  avgPlacementPerSession?: InputMaybe<Scalars['Float']['input']>;
  avgPointsPerSession?: InputMaybe<Scalars['Float']['input']>;
  clutched?: InputMaybe<Scalars['Boolean']['input']>;
  eliminationPoints?: InputMaybe<Scalars['Int']['input']>;
  placementPoints?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  sessionsPlayed?: InputMaybe<Scalars['Int']['input']>;
  totalPoints?: InputMaybe<Scalars['Int']['input']>;
  totalSecondsSurvived?: InputMaybe<Scalars['Int']['input']>;
  totalVictoryRoyales?: InputMaybe<Scalars['Int']['input']>;
};

export type PatchMatchSettleRequestData = {
  forfeitReason?: InputMaybe<ForfeitReason>;
  incompleteNotes?: InputMaybe<Scalars['String']['input']>;
  incompleteReason?: InputMaybe<MatchSettleIncompleteReason>;
  isReadyForReview?: InputMaybe<Scalars['Boolean']['input']>;
  results?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<MatchSettleRequestStatus>;
  type?: InputMaybe<MatchSettleRequestType>;
};

export type PatchMatchSettleRequestInput = {
  id: Scalars['UUID']['input'];
  patchData?: InputMaybe<PatchMatchSettleRequestData>;
};

export type PatchNotificationInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<NotificationStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PatchTeamMatchStatsInput = {
  fortniteTeamMatchStatsId?: InputMaybe<Scalars['UUID']['input']>;
  leagueOfLegendsTeamMatchStatsId?: InputMaybe<Scalars['UUID']['input']>;
  matchId?: InputMaybe<Scalars['UUID']['input']>;
  rocketLeagueTeamMatchStatsId?: InputMaybe<Scalars['UUID']['input']>;
  smiteTeamMatchStatsId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
  timePlayedInSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type PendingSlotEvent = ScheduleEvent & ScheduleEventWithSlot & {
  __typename?: 'PendingSlotEvent';
  slot: Slot;
  startsAt: Scalars['DateTime']['output'];
  type: ScheduleEventType;
};

export type PendingUserRolesFilterInput = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasPhone?: InputMaybe<Scalars['Boolean']['input']>;
  hasVerifiedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UserRoleName>>;
  schoolHasNoCoach?: InputMaybe<Scalars['Boolean']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  schoolType?: InputMaybe<SchoolType>;
  schoolVerificationSteps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Phase = IPhase & {
  __typename?: 'Phase';
  autoScheduleBracket: Maybe<Scalars['Boolean']['output']>;
  bestOf: Maybe<Scalars['Int']['output']>;
  bracketSize: Maybe<Scalars['Int']['output']>;
  defaultSlots: Maybe<Array<Slot>>;
  description: Maybe<Scalars['String']['output']>;
  endsAt: Scalars['DateTime']['output'];
  esport: Maybe<Esport>;
  format: PhaseFormat;
  fortniteEventId: Maybe<Scalars['String']['output']>;
  fortniteTeamPhaseStats: Maybe<FortniteTeamPhaseStatsResult>;
  id: Scalars['UUID']['output'];
  introText: Maybe<Scalars['String']['output']>;
  matchRescheduleEndsAt: Maybe<Scalars['DateTime']['output']>;
  maxSlotParticipation: Maybe<Scalars['Int']['output']>;
  maxTeamsPerSchool: Maybe<Scalars['Int']['output']>;
  minSlotParticipation: Maybe<Scalars['Int']['output']>;
  minutesBeforeMatchToLockInSeries: Maybe<Scalars['Int']['output']>;
  mode: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phaseResults: Maybe<Array<PhaseResult>>;
  playerPhaseStats: Maybe<Array<PlayerPhaseStats>>;
  rules: Maybe<Scalars['String']['output']>;
  season: Maybe<Season>;
  seasonId: Scalars['String']['output'];
  seriesBestOf: Maybe<Scalars['Int']['output']>;
  shouldSendPlayoffNotification: Maybe<Scalars['Boolean']['output']>;
  slots: Maybe<Array<Slot>>;
  slug: Maybe<Scalars['String']['output']>;
  startsAt: Scalars['DateTime']['output'];
  status: PhaseStatus;
  survivalAdvancementCount: Maybe<Scalars['Int']['output']>;
  survivalAdvancementPercentage: Maybe<Scalars['Int']['output']>;
  teamMatchCount: Maybe<Scalars['Int']['output']>;
  teamPhaseStats: Maybe<Array<TeamPhaseStats>>;
  teams: Maybe<Array<SeededTeam>>;
  type: PhaseType;
};


export type PhaseDefaultSlotsArgs = {
  maxStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  minStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type PhaseFortniteTeamPhaseStatsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type PhaseTeamMatchCountArgs = {
  teamId: Scalars['UUID']['input'];
};

export type PhaseAttributes = {
  __typename?: 'PhaseAttributes';
  autoScheduleBracket: Maybe<Scalars['Boolean']['output']>;
  bestOf: Scalars['Int']['output'];
  bracketSize: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  endsAt: Scalars['DateTime']['output'];
  format: PhaseFormat;
  fortniteEventId: Maybe<Scalars['String']['output']>;
  maxSlotParticipation: Maybe<Scalars['Int']['output']>;
  maxTeamsPerSchool: Maybe<Scalars['Int']['output']>;
  minSlotParticipation: Maybe<Scalars['Int']['output']>;
  minutesBeforeMatchToLockInSeries: Maybe<Scalars['Int']['output']>;
  mode: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  seriesBestOf: Maybe<Scalars['Int']['output']>;
  shouldSendPlayoffNotification: Maybe<Scalars['Boolean']['output']>;
  slots: Maybe<Array<SlotAttributes>>;
  slug: Maybe<Scalars['String']['output']>;
  startsAt: Scalars['DateTime']['output'];
  status: Maybe<PhaseStatus>;
  survivalAdvancementCount: Maybe<Scalars['Int']['output']>;
  survivalAdvancementPercentage: Maybe<Scalars['Int']['output']>;
  type: PhaseType;
};

export enum PhaseFormat {
  BattleRoyale = 'battleRoyale',
  DoubleElimination = 'doubleElimination',
  HybridSwiss = 'hybridSwiss',
  Manual = 'manual',
  RoundRobin = 'roundRobin',
  SingleElimination = 'singleElimination',
  SmartSchedule = 'smartSchedule',
  Survival = 'survival',
  Swiss = 'swiss'
}

export type PhaseJobPayload = {
  __typename?: 'PhaseJobPayload';
  errors: Maybe<Array<Scalars['String']['output']>>;
  jobId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type PhaseJobsPayload = {
  __typename?: 'PhaseJobsPayload';
  jobIds: Array<Scalars['UUID']['output']>;
};

export enum PhaseName {
  Championship = 'championship',
  Invitational = 'invitational',
  Playoffs = 'playoffs',
  Preseason = 'preseason',
  Qualifier = 'qualifier',
  RegularSeason = 'regularSeason'
}

export type PhasePayload = {
  __typename?: 'PhasePayload';
  phase: Maybe<Phase>;
  phaseId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type PhaseRecord = {
  __typename?: 'PhaseRecord';
  compoundRankingScore: Maybe<Scalars['Float']['output']>;
  lost: Scalars['Int']['output'];
  lostByForfeit: Scalars['Int']['output'];
  played: Scalars['Int']['output'];
  streak: Scalars['Int']['output'];
  tied: Scalars['Int']['output'];
  winPercentage: Maybe<Scalars['Float']['output']>;
  won: Scalars['Int']['output'];
  wonByBye: Maybe<Scalars['Int']['output']>;
  wonByForfeit: Scalars['Int']['output'];
};

export type PhaseResult = {
  __typename?: 'PhaseResult';
  avgPlacement: Maybe<Scalars['Float']['output']>;
  cumulativeScore: Maybe<Scalars['Float']['output']>;
  cumulativeScoreOfOpposition: Maybe<Scalars['Float']['output']>;
  gameStreak: Scalars['Int']['output'];
  gameWinPercentage: Maybe<Scalars['Float']['output']>;
  gamesLost: Scalars['Int']['output'];
  gamesLostByForfeit: Scalars['Int']['output'];
  gamesPlayed: Scalars['Int']['output'];
  gamesTied: Scalars['Int']['output'];
  gamesWon: Scalars['Int']['output'];
  gamesWonByForfeit: Scalars['Int']['output'];
  hasClinchedPlayoffs: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  matchStreak: Scalars['Int']['output'];
  matchWinPercentage: Maybe<Scalars['Float']['output']>;
  matchesCompleted: Maybe<Scalars['Int']['output']>;
  matchesLost: Scalars['Int']['output'];
  matchesLostByForfeit: Scalars['Int']['output'];
  matchesPlayed: Scalars['Int']['output'];
  matchesTied: Scalars['Int']['output'];
  matchesWon: Scalars['Int']['output'];
  matchesWonByBye: Maybe<Scalars['Int']['output']>;
  matchesWonByForfeit: Scalars['Int']['output'];
  numOfFirstPlace: Maybe<Scalars['Int']['output']>;
  numOfTopFourPlace: Maybe<Scalars['Int']['output']>;
  phase: Maybe<Phase>;
  phaseId: Scalars['UUID']['output'];
  phasePoints: Scalars['Int']['output'];
  phaseTiebreakerPoints: Scalars['Int']['output'];
  rank: Maybe<Scalars['Int']['output']>;
  rankingPoints: Scalars['Float']['output'];
  record: Maybe<PhaseRecord>;
  seriesLost: Maybe<Scalars['Int']['output']>;
  seriesLostByForfeit: Maybe<Scalars['Int']['output']>;
  seriesPlayed: Maybe<Scalars['Int']['output']>;
  seriesTied: Maybe<Scalars['Int']['output']>;
  seriesWinPercentage: Maybe<Scalars['Float']['output']>;
  seriesWon: Maybe<Scalars['Int']['output']>;
  seriesWonByForfeit: Maybe<Scalars['Int']['output']>;
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
};

export type PhaseScheduleInput = {
  autoScheduleBracket?: InputMaybe<Scalars['Boolean']['input']>;
  bestOf: Scalars['Int']['input'];
  bracketSize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['DateTime']['input'];
  format: PhaseFormat;
  fortniteEventId?: InputMaybe<Scalars['String']['input']>;
  maxSlotParticipation?: InputMaybe<Scalars['Int']['input']>;
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  minSlotParticipation?: InputMaybe<Scalars['Int']['input']>;
  minutesBeforeMatchToLockInSeries?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  shouldSendPlayoffNotification?: InputMaybe<Scalars['Boolean']['input']>;
  slots: Array<SlotScheduleInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['DateTime']['input'];
  status?: InputMaybe<PhaseStatus>;
  survivalAdvancementCount?: InputMaybe<Scalars['Int']['input']>;
  survivalAdvancementPercentage?: InputMaybe<Scalars['Int']['input']>;
  type: PhaseType;
};

export enum PhaseStatus {
  Active = 'active',
  Draft = 'draft'
}

export type PhaseTeam = IPhase & {
  __typename?: 'PhaseTeam';
  autoScheduleBracket: Maybe<Scalars['Boolean']['output']>;
  bestOf: Maybe<Scalars['Int']['output']>;
  bracketSize: Maybe<Scalars['Int']['output']>;
  defaultSlots: Maybe<Array<Slot>>;
  description: Maybe<Scalars['String']['output']>;
  endsAt: Scalars['DateTime']['output'];
  esport: Maybe<Esport>;
  format: PhaseFormat;
  fortniteEventId: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  introText: Maybe<Scalars['String']['output']>;
  lockedInAt: Maybe<Scalars['DateTime']['output']>;
  matchRescheduleEndsAt: Maybe<Scalars['DateTime']['output']>;
  maxSlotParticipation: Maybe<Scalars['Int']['output']>;
  maxTeamsPerSchool: Maybe<Scalars['Int']['output']>;
  minSlotParticipation: Maybe<Scalars['Int']['output']>;
  minutesBeforeMatchToLockInSeries: Maybe<Scalars['Int']['output']>;
  mode: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phaseResults: Maybe<Array<PhaseResult>>;
  rules: Maybe<Scalars['String']['output']>;
  season: Maybe<Season>;
  seasonId: Scalars['String']['output'];
  seed: Maybe<Scalars['Int']['output']>;
  seriesBestOf: Maybe<Scalars['Int']['output']>;
  shouldSendPlayoffNotification: Maybe<Scalars['Boolean']['output']>;
  slots: Maybe<Array<Slot>>;
  slug: Maybe<Scalars['String']['output']>;
  startsAt: Scalars['DateTime']['output'];
  status: PhaseStatus;
  survivalAdvancementCount: Maybe<Scalars['Int']['output']>;
  survivalAdvancementPercentage: Maybe<Scalars['Int']['output']>;
  teamMatchCount: Maybe<Scalars['Int']['output']>;
  teams: Maybe<Array<SeededTeam>>;
  type: PhaseType;
};


export type PhaseTeamDefaultSlotsArgs = {
  maxStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  minStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type PhaseTeamTeamMatchCountArgs = {
  teamId: Scalars['UUID']['input'];
};

export enum PhaseType {
  Championship = 'championship',
  Invitational = 'invitational',
  Playoff = 'playoff',
  Preseason = 'preseason',
  Qualifier = 'qualifier',
  RegularSeason = 'regularSeason'
}

export enum PhaseTypeFilter {
  Championship = 'championship',
  Invitational = 'invitational',
  NoPhases = 'noPhases',
  Playoff = 'playoff',
  Preseason = 'preseason',
  Qualifier = 'qualifier',
  RegularSeason = 'regularSeason'
}

export enum Platform {
  EpicGames = 'EpicGames',
  Mobile = 'Mobile',
  NintendoSwitch = 'NintendoSwitch',
  Pc = 'PC',
  PcMac = 'PCMac',
  PlayStation4 = 'PlayStation4',
  PlayStation5 = 'PlayStation5',
  Steam = 'Steam',
  XboxOne = 'XboxOne',
  XboxSeriesXs = 'XboxSeriesXS'
}

export type PlatformInfo = {
  __typename?: 'PlatformInfo';
  slug: Maybe<Platform>;
};

export type PlatformPayload = {
  __typename?: 'PlatformPayload';
  success: Scalars['Boolean']['output'];
};

export type PlayedWinRate = {
  __typename?: 'PlayedWinRate';
  name: Scalars['String']['output'];
  played: Scalars['Float']['output'];
  selectionOption: Maybe<GameAssistantSelectionOption>;
  winRate: Scalars['Float']['output'];
};

export type PlayerGameSpecificGameStats = LeagueOfLegendsPlayerGameStats | RocketLeaguePlayerGameStats | SmitePlayerGameStats;

/** The stats for a player for a game */
export type PlayerGameStats = PlayerStats & {
  __typename?: 'PlayerGameStats';
  gameId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isKnown: Scalars['Boolean']['output'];
  leagueOfLegendsPlayerGameStatsId: Maybe<Scalars['UUID']['output']>;
  leagueOfLegendsStats: Maybe<LeagueOfLegendsPlayerGameStats>;
  player: Maybe<User>;
  playerId: Maybe<Scalars['UUID']['output']>;
  publisherAccountId: Scalars['String']['output'];
  rocketLeaguePlayerGameStatsId: Maybe<Scalars['UUID']['output']>;
  rocketLeagueStats: Maybe<RocketLeaguePlayerGameStats>;
  rosterStatus: PlayerGameStatsRosterStatus;
  smitePlayerGameStatsId: Maybe<Scalars['UUID']['output']>;
  smiteStats: Maybe<SmitePlayerGameStats>;
  stats: Maybe<PlayerGameSpecificGameStats>;
  team: Team;
  teamId: Scalars['UUID']['output'];
  timePlayedInSeconds: Maybe<Scalars['Int']['output']>;
};

export type PlayerGameStatsResult = {
  __typename?: 'PlayerGameStatsResult';
  results: Maybe<Array<PlayerGameStats>>;
  total: Maybe<Scalars['Int']['output']>;
};

export enum PlayerGameStatsRosterStatus {
  Bot = 'bot',
  InSchoolAndLeagueNotOnTeam = 'inSchoolAndLeagueNotOnTeam',
  InSchoolNotInLeague = 'inSchoolNotInLeague',
  NotInSchool = 'notInSchool',
  OnTeam = 'onTeam',
  PreGameOnTeam = 'preGameOnTeam',
  UnknownAccount = 'unknownAccount'
}

export type PlayerLinkedAccount = {
  __typename?: 'PlayerLinkedAccount';
  platform: Platform;
  username: Scalars['String']['output'];
};

export type PlayerLolStandings = {
  __typename?: 'PlayerLolStandings';
  esportSlug: Maybe<Scalars['String']['output']>;
  gold: Maybe<LeaderboardMetric>;
  kda: Maybe<LeaderboardMetric>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']['output']>;
};

export type PlayerMatch = {
  __typename?: 'PlayerMatch';
  esport: Esport;
  id: Scalars['UUID']['output'];
  matchResults: Maybe<Array<MatchResult>>;
  opponent: Maybe<Team>;
  team: Maybe<Team>;
};

export type PlayerMatchFilters = {
  isScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
  phaseType?: InputMaybe<PhaseType>;
};

export type PlayerMatchSpecificGameStats = LeagueOfLegendsPlayerMatchStats | RocketLeaguePlayerMatchStats | SmitePlayerMatchStats;

/** The stats for a player for a match */
export type PlayerMatchStats = PlayerStats & {
  __typename?: 'PlayerMatchStats';
  id: Scalars['UUID']['output'];
  leagueOfLegendsPlayerMatchStatsId: Maybe<Scalars['UUID']['output']>;
  leagueOfLegendsStats: Maybe<LeagueOfLegendsPlayerMatchStats>;
  matchId: Scalars['UUID']['output'];
  player: Maybe<User>;
  playerId: Maybe<Scalars['UUID']['output']>;
  rocketLeaguePlayerMatchStatsId: Maybe<Scalars['UUID']['output']>;
  rocketLeagueStats: Maybe<RocketLeaguePlayerMatchStats>;
  smitePlayerMatchStatsId: Maybe<Scalars['UUID']['output']>;
  smiteStats: Maybe<SmitePlayerMatchStats>;
  stats: Maybe<PlayerMatchSpecificGameStats>;
  teamId: Scalars['UUID']['output'];
  timePlayedInSeconds: Maybe<Scalars['Int']['output']>;
};

export type PlayerMatchStatsFiltersInput = {
  matchId?: InputMaybe<Scalars['UUID']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PlayerMatchStatsResult = {
  __typename?: 'PlayerMatchStatsResult';
  results: Maybe<Array<PlayerMatchStats>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PlayerPhaseSpecificGameStats = LeagueOfLegendsPlayerPhaseStats | RocketLeaguePlayerPhaseStats | SmitePlayerPhaseStats;

/** The stats for a player for a phase */
export type PlayerPhaseStats = PlayerStats & {
  __typename?: 'PlayerPhaseStats';
  id: Scalars['UUID']['output'];
  leagueOfLegendsPlayerPhaseStatsId: Maybe<Scalars['UUID']['output']>;
  leagueOfLegendsStats: Maybe<LeagueOfLegendsPlayerPhaseStats>;
  phaseId: Scalars['UUID']['output'];
  player: Maybe<User>;
  playerId: Maybe<Scalars['UUID']['output']>;
  rocketLeaguePlayerPhaseStatsId: Maybe<Scalars['UUID']['output']>;
  rocketLeagueStats: Maybe<RocketLeaguePlayerPhaseStats>;
  smitePlayerPhaseStatsId: Maybe<Scalars['UUID']['output']>;
  smiteStats: Maybe<SmitePlayerPhaseStats>;
  stats: Maybe<PlayerPhaseSpecificGameStats>;
  timePlayedInSeconds: Maybe<Scalars['Int']['output']>;
};

export type PlayerPhaseStatsFiltersInput = {
  phaseId?: InputMaybe<Scalars['UUID']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PlayerPhaseStatsResult = {
  __typename?: 'PlayerPhaseStatsResult';
  results: Maybe<Array<PlayerPhaseStats>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type PlayerPosition = {
  id: Scalars['UUID']['input'];
  isSubstitute?: InputMaybe<Scalars['Boolean']['input']>;
  positionId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PlayerProfileSnapshot = {
  __typename?: 'PlayerProfileSnapshot';
  matchesPlayed: Scalars['Int']['output'];
  seasonsPlayed: Scalars['Int']['output'];
  titlesPlayed: Scalars['Int']['output'];
};

export type PlayerProfileStats = {
  __typename?: 'PlayerProfileStats';
  currentTeam: Maybe<Team>;
  esportsPlayed: Maybe<Scalars['Int']['output']>;
  phaseTeam: Maybe<Team>;
  profilePhaseStats: Maybe<Array<ProfilePhaseStat>>;
  profileScrimmageStat: Maybe<ProfileScrimmageStat>;
  seasonsPlayed: Maybe<Scalars['Int']['output']>;
};

export type PlayerProfileStatsByEsport = PlayerProfileStatsFortnite | PlayerProfileStatsLol | PlayerProfileStatsRl | PlayerProfileStatsSmite;

export type PlayerProfileStatsFortnite = {
  __typename?: 'PlayerProfileStatsFortnite';
  avgElimsPerSeason: Maybe<Array<ProfilePhaseData>>;
  avgPpgPerSeason: Maybe<Array<ProfilePhaseData>>;
  currentTeam: Maybe<Team>;
  esportSlug: Maybe<Scalars['String']['output']>;
  phaseTeam: Maybe<Team>;
  profilePhaseStats: Maybe<Array<ProfilePhaseStat>>;
};

export type PlayerProfileStatsLol = {
  __typename?: 'PlayerProfileStatsLol';
  avgGpmPerSeason: Maybe<Array<ProfilePhaseData>>;
  avgKdaPerSeason: Maybe<Array<ProfilePhaseData>>;
  currentTeam: Maybe<Team>;
  esportSlug: Maybe<Scalars['String']['output']>;
  phaseTeam: Maybe<Team>;
  profilePhaseStats: Maybe<Array<ProfilePhaseStat>>;
};

export type PlayerProfileStatsRl = {
  __typename?: 'PlayerProfileStatsRL';
  avgGpspPerSeason: Maybe<Array<ProfilePhaseData>>;
  avgSpgPerSeason: Maybe<Array<ProfilePhaseData>>;
  currentTeam: Maybe<Team>;
  esportSlug: Maybe<Scalars['String']['output']>;
  phaseTeam: Maybe<Team>;
  profilePhaseStats: Maybe<Array<ProfilePhaseStat>>;
};

export type PlayerProfileStatsSmite = {
  __typename?: 'PlayerProfileStatsSmite';
  avgGpmPerSeason: Maybe<Array<ProfilePhaseData>>;
  avgKdaPerSeason: Maybe<Array<ProfilePhaseData>>;
  currentTeam: Maybe<Team>;
  esportSlug: Maybe<Scalars['String']['output']>;
  phaseTeam: Maybe<Team>;
  profilePhaseStats: Maybe<Array<ProfilePhaseStat>>;
};

export type PlayerRlStandings = {
  __typename?: 'PlayerRLStandings';
  esportSlug: Maybe<Scalars['String']['output']>;
  goalsPerShot: Maybe<LeaderboardMetric>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  scorePerGame: Maybe<LeaderboardMetric>;
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']['output']>;
};

export type PlayerReplayInput = {
  userId: Scalars['UUID']['input'];
};

export type PlayerReplayPayload = {
  __typename?: 'PlayerReplayPayload';
  slidesData: Array<PlayerReplayStat>;
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type PlayerReplayStat = {
  __typename?: 'PlayerReplayStat';
  statName: PlayerReplayStatName;
  subtext: Scalars['String']['output'];
  team: Maybe<Team>;
  teamId: Maybe<Scalars['UUID']['output']>;
  title: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export enum PlayerReplayStatName {
  EndOfSeasonAwards = 'EndOfSeasonAwards',
  FirstMatchWin = 'FirstMatchWin',
  HighFunRating = 'HighFunRating',
  LolAvgGpm = 'LolAvgGpm',
  LolAvgKda = 'LolAvgKda',
  LongestWinningStreak = 'LongestWinningStreak',
  MadePlayoffs = 'MadePlayoffs',
  MatchParticipation = 'MatchParticipation',
  MostPlayedLolChampion = 'MostPlayedLolChampion',
  MostPlayedSmashCharacter = 'MostPlayedSmashCharacter',
  MostPlayedSmashCharacterWinRate = 'MostPlayedSmashCharacterWinRate',
  MostPlayedSmashStage = 'MostPlayedSmashStage',
  MostPlayedSmashStageWinRate = 'MostPlayedSmashStageWinRate',
  NumGamesPlayed = 'NumGamesPlayed',
  PlayVsCupChampion = 'PlayVsCupChampion',
  PlayerOfTheWeekAwards = 'PlayerOfTheWeekAwards',
  RocketLeagueTotalAssists = 'RocketLeagueTotalAssists',
  RocketLeagueTotalGoals = 'RocketLeagueTotalGoals',
  RocketLeagueTotalSaves = 'RocketLeagueTotalSaves',
  RocketLeagueTotalScore = 'RocketLeagueTotalScore',
  RocketLeagueTotalShots = 'RocketLeagueTotalShots',
  WonChampionship = 'WonChampionship'
}

export type PlayerSeasonSpecificGameStats = RocketLeaguePlayerSeasonStats;

/** The stats for a player for a season. Unlike others, this data is not persisted. */
export type PlayerSeasonStats = {
  __typename?: 'PlayerSeasonStats';
  maddenStats: Maybe<MaddenMostPlayedStatsByPlayerId>;
  nba2kStats: Maybe<Nba2kMostPlayedStatsByPlayerId>;
  player: Maybe<User>;
  playerId: Scalars['UUID']['output'];
  rocketLeagueStats: Maybe<RocketLeaguePlayerSeasonStats>;
  seasonId: Scalars['UUID']['output'];
  splatoonStats: Maybe<SplatoonMostPlayedStatsByPlayerId>;
};

export type PlayerSeasonStatsInput = {
  playerIds: Array<Scalars['UUID']['input']>;
  seasonId: Scalars['UUID']['input'];
};

export type PlayerSeasonStatsResult = {
  __typename?: 'PlayerSeasonStatsResult';
  results: Maybe<Array<PlayerSeasonStats>>;
};

export type PlayerSmiteStandings = {
  __typename?: 'PlayerSmiteStandings';
  esportSlug: Maybe<Scalars['String']['output']>;
  gold: Maybe<LeaderboardMetric>;
  kda: Maybe<LeaderboardMetric>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']['output']>;
};

export type PlayerStandingsUnionType = PlayerLolStandings | PlayerRlStandings | PlayerSmiteStandings | TeamFortniteStandings;

export type PlayerStats = {
  id: Scalars['UUID']['output'];
  player: Maybe<User>;
  playerId: Maybe<Scalars['UUID']['output']>;
  timePlayedInSeconds: Maybe<Scalars['Int']['output']>;
};

export type PlayerStatsFiltersInput = {
  gameId?: InputMaybe<Scalars['UUID']['input']>;
  playerId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PlaylistItem = {
  __typename?: 'PlaylistItem';
  durationSeconds: Scalars['Int']['output'];
  embedHtml: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PlaylistPayload = {
  __typename?: 'PlaylistPayload';
  playlist: Array<PlaylistItem>;
};

export type PossibleTeamRivalPayload = {
  __typename?: 'PossibleTeamRivalPayload';
  hasActiveRivalInSeason: Scalars['Boolean']['output'];
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
};

export type PracticeDaySchedule = {
  __typename?: 'PracticeDaySchedule';
  id: Scalars['UUID']['output'];
  isLive: Scalars['Boolean']['output'];
  practiceTimes: Array<PracticeTime>;
};

export type PracticeTime = {
  __typename?: 'PracticeTime';
  endTime: Scalars['String']['output'];
  isLive: Scalars['Boolean']['output'];
  startTime: Scalars['String']['output'];
};

export type PreseasonQueueUpdateSubscribeInput = {
  teamId: Scalars['UUID']['input'];
};

export type PreseasonQueueUpdateSubscribePayload = {
  __typename?: 'PreseasonQueueUpdateSubscribePayload';
  currentState: PreseasonStatePayload;
};

export type PreseasonStatePayload = {
  __typename?: 'PreseasonStatePayload';
  inQueue: Scalars['Boolean']['output'];
  matchId: Maybe<Scalars['String']['output']>;
  mostRecentPairing: Maybe<Scalars['DateTime']['output']>;
  nextScheduledPairing: Maybe<Scalars['DateTime']['output']>;
  numTeamsInQueue: Scalars['Int']['output'];
};

export type ProcessBackupEventsInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  processors: Array<ServiceEventProcessor>;
  startDate: Scalars['DateTime']['input'];
};

export type ProcessBackupEventsPayload = {
  __typename?: 'ProcessBackupEventsPayload';
  jobId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type Product = IProduct & {
  __typename?: 'Product';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  internalName: Maybe<Scalars['String']['output']>;
  isAdminOnly: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceUsd: Scalars['Float']['output'];
  seatCount: Maybe<Scalars['Int']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  type: ProductType;
};

export enum ProductAcquisitionMethod {
  Bundle = 'Bundle',
  Grant = 'Grant',
  Purchase = 'Purchase'
}

export type ProductGrant = {
  __typename?: 'ProductGrant';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<User>;
  createdById: Maybe<Scalars['UUID']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  productInstanceId: Scalars['UUID']['output'];
  reason: Maybe<ProductGrantReason>;
};

export enum ProductGrantReason {
  AdminGrant = 'AdminGrant',
  CollegePatch = 'CollegePatch',
  InternalTest = 'InternalTest',
  LegacyMigration = 'LegacyMigration'
}

export type ProductInstance = {
  __typename?: 'ProductInstance';
  acquisitionMethod: Maybe<ProductAcquisitionMethod>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  productId: Scalars['UUID']['output'];
};

export type ProductPayload = {
  __typename?: 'ProductPayload';
  product: Maybe<Product>;
  productId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export enum ProductType {
  AnnualPass = 'AnnualPass',
  SeasonPass = 'SeasonPass'
}

export type ProfileFortniteMatchStats = {
  __typename?: 'ProfileFortniteMatchStats';
  date: Maybe<Scalars['DateTime']['output']>;
  duration: Maybe<Scalars['Int']['output']>;
  eliminationPoints: Maybe<Scalars['Int']['output']>;
  esportSlug: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  matchId: Maybe<Scalars['UUID']['output']>;
  opponent: Maybe<Team>;
  place: Maybe<Scalars['String']['output']>;
  placing: Maybe<Scalars['Int']['output']>;
  totalPoints: Maybe<Scalars['Int']['output']>;
};

export type ProfileGameOrMatchStats = ProfileFortniteMatchStats | ProfileLolGameStats | ProfileRlGameStats | ProfileSmiteGameStats;

export type ProfileLolGameStats = {
  __typename?: 'ProfileLolGameStats';
  assists: Maybe<Scalars['Int']['output']>;
  champion: Maybe<LeagueOfLegendsChampion>;
  creepScore: Maybe<Scalars['Int']['output']>;
  damage: Maybe<Scalars['Int']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  deaths: Maybe<Scalars['Int']['output']>;
  duration: Maybe<Scalars['Int']['output']>;
  esportSlug: Maybe<Scalars['String']['output']>;
  goldPerMinute: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<LeagueOfLegendsItem>>;
  kills: Maybe<Scalars['Int']['output']>;
  matchId: Maybe<Scalars['UUID']['output']>;
  opponent: Maybe<Team>;
  placing: Maybe<Scalars['Int']['output']>;
  role: Maybe<LeagueOfLegendsRosterPosition>;
  wards: Maybe<Scalars['Int']['output']>;
};

export type ProfilePhaseData = {
  __typename?: 'ProfilePhaseData';
  phaseId: Maybe<Scalars['String']['output']>;
  phaseStartsAt: Maybe<Scalars['DateTime']['output']>;
  season: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['Float']['output']>;
};

export type ProfilePhaseStat = {
  __typename?: 'ProfilePhaseStat';
  leagueRankData: Maybe<Array<ProfileRankData>>;
  matchesPlayedData: Maybe<Array<ProfilePhaseData>>;
  phase: Maybe<PhaseType>;
  totalMatchesPlayed: Maybe<Scalars['Int']['output']>;
  totalMatchesWon: Maybe<Scalars['Int']['output']>;
  totalWinRate: Maybe<Scalars['Float']['output']>;
  winRateData: Maybe<Array<ProfilePhaseData>>;
};

export type ProfileRlGameStats = {
  __typename?: 'ProfileRLGameStats';
  assists: Maybe<Scalars['Int']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  duration: Maybe<Scalars['Int']['output']>;
  esportSlug: Maybe<Scalars['String']['output']>;
  goals: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  matchId: Maybe<Scalars['UUID']['output']>;
  opponent: Maybe<Team>;
  placing: Maybe<Scalars['Int']['output']>;
  saves: Maybe<Scalars['Int']['output']>;
  score: Maybe<Scalars['Int']['output']>;
  shots: Maybe<Scalars['Int']['output']>;
};

export type ProfileRankData = {
  __typename?: 'ProfileRankData';
  leagueName: Maybe<Scalars['String']['output']>;
  leagueSlug: Maybe<Scalars['String']['output']>;
  outOf: Maybe<Scalars['Int']['output']>;
  rank: Maybe<Scalars['Int']['output']>;
};

/** The stats viewed in a player profile */
export type ProfileScrimmageData = {
  __typename?: 'ProfileScrimmageData';
  month: Maybe<Scalars['Int']['output']>;
  value: Maybe<Scalars['Float']['output']>;
};

export type ProfileScrimmageStat = {
  __typename?: 'ProfileScrimmageStat';
  matchesPlayedData: Maybe<Array<ProfileScrimmageData>>;
  totalMatchesPlayed: Maybe<Scalars['Int']['output']>;
  totalMatchesWon: Maybe<Scalars['Int']['output']>;
  winRateData: Maybe<Array<ProfileScrimmageData>>;
};

export type ProfileSmiteGameStats = {
  __typename?: 'ProfileSmiteGameStats';
  assists: Maybe<Scalars['Int']['output']>;
  date: Maybe<Scalars['DateTime']['output']>;
  deaths: Maybe<Scalars['Int']['output']>;
  duration: Maybe<Scalars['Int']['output']>;
  esportSlug: Maybe<Scalars['String']['output']>;
  goldPerMinute: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['String']['output']>;
  kills: Maybe<Scalars['Int']['output']>;
  matchId: Maybe<Scalars['UUID']['output']>;
  opponent: Maybe<Team>;
  placing: Maybe<Scalars['Int']['output']>;
};

export enum Provider {
  BattleDotNet = 'BattleDotNet',
  ChessDotCom = 'ChessDotCom',
  ChessKid = 'ChessKid',
  Discord = 'Discord',
  ElectronicArts = 'ElectronicArts',
  EpicGames = 'EpicGames',
  F1 = 'F1',
  MarvelRivals = 'MarvelRivals',
  Nba2K = 'Nba2K',
  Nintendo = 'Nintendo',
  PlayStationNetwork = 'PlayStationNetwork',
  PokemonUnite = 'PokemonUnite',
  Riot = 'Riot',
  Smite = 'Smite',
  Spin = 'Spin',
  Steam = 'Steam',
  StreetFighter = 'StreetFighter',
  Twitch = 'Twitch',
  Vesl = 'Vesl',
  XBoxLive = 'XBoxLive',
  Youtube = 'Youtube'
}

export type ProviderFilterInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type: Provider;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PsyonixMatchResultMatchStatsMatchPayload = {
  game_time_seconds?: InputMaybe<Scalars['Int']['input']>;
  overtime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PsyonixMatchResultMatchStatsPayload = {
  match?: InputMaybe<PsyonixMatchResultMatchStatsMatchPayload>;
  players?: InputMaybe<Array<PsyonixMatchResultMatchStatsPlayersPayload>>;
};

export type PsyonixMatchResultMatchStatsPlayersPayload = {
  Assists?: InputMaybe<Scalars['Int']['input']>;
  Goals?: InputMaybe<Scalars['Int']['input']>;
  PlayerID: Scalars['String']['input'];
  Saves?: InputMaybe<Scalars['Int']['input']>;
  Score?: InputMaybe<Scalars['Int']['input']>;
  Shots?: InputMaybe<Scalars['Int']['input']>;
  TeamNum?: InputMaybe<Scalars['Int']['input']>;
};

export type PsyonixMatchResultPayload = {
  afk?: InputMaybe<Array<Scalars['String']['input']>>;
  leavers?: InputMaybe<Array<Scalars['String']['input']>>;
  match_stats?: InputMaybe<PsyonixMatchResultMatchStatsPayload>;
  round?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<PsyonixMatchResultScorePayload>;
};

export type PsyonixMatchResultScorePayload = {
  faction1?: InputMaybe<Scalars['Int']['input']>;
  faction2?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  _: Maybe<Scalars['Boolean']['output']>;
  annualPassProduct: Maybe<AnnualPassProduct>;
  asset: Maybe<Asset>;
  availableSeasonalPlayerAwardTypes: Maybe<AvailableSeasonalPlayerAwardTypesPayload>;
  availableSpectatorsByTeamId: AvailableSpectatorsPayload;
  availableWeeklyAwardPlayers: Maybe<AvailableWeeklyAwardPlayersPayload>;
  availableWeeklyAwardWeeks: Maybe<AvailableWeeklyAwardWeeksPayload>;
  bracket: Maybe<Bracket>;
  cachedOrdinals: Maybe<CachedOrdinalsPayload>;
  canEditAccount: CanEditAccountResult;
  champion: Maybe<Champion>;
  characterSelectionOptionsByEsportId: Maybe<GameAssistantSelectionOptionsPayload>;
  checkPlaceInPreseasonQueue: Maybe<CheckPlaceInPreseasonQueuePayload>;
  checkPlaceInSmartQueue: Maybe<SmartQueueStatePayload>;
  /** @deprecated No longer supported */
  checkValidPlayers: Maybe<CheckValidPlayersResponse>;
  checkValidPlayersOnPlatform: Maybe<CheckValidPlayerOnPlatformResponse>;
  /** @deprecated No longer supported */
  checkValidation: UserValidation;
  competitionIntervalsForOrganization: CompetitionIntervalsForOrganizationQueryPayload;
  currentGameAssistantStateByMatchId: GameAssistantStatePayload;
  currentSeriesPlayerSelectionsByMatchId: SeriesPlayerSelectionsPayload;
  downloadSchoolInvoice: DownloadSchoolInvoicePayload;
  eligibleMetaseasons: Array<Metaseason>;
  epicPlatformSelectionOptionsByUserIds: EpicPlatformSelectionOptionsByUserIdsPayload;
  /** Query a single esport, either by id or by slug */
  esport: Maybe<Esport>;
  esportPlatforms: Maybe<Array<Platform>>;
  /** Query all esports */
  esports: Array<Esport>;
  esportsByCompetitionGroup: Array<Esport>;
  esportsV2: Array<EsportV2>;
  /**
   * Calculates number of passes used by a school given which
   * teams will be enrolling/unenrolling for a given metaseason.
   */
  estimateSchoolSeasonPassUsage: EstimateSchoolSeasonPassUsageResult;
  fetchAllMatchChatEvents: MatchChatEventsResults;
  fetchMatchChatEventsByEsportIds: MatchChatEventsResults;
  fetchMatchSettleRequest: MultipleMatchSettleRequestsPayload;
  fetchPlayerStanding: Maybe<Array<PlayerStandingsUnionType>>;
  findCommonLeaguesForTeams: Maybe<Array<League>>;
  findDeniedUsers: Maybe<UsersResult>;
  findEligibleTeamsForSubstituteTransfer: EligibleTeamsForSubstituteTransferResult;
  findEligibleVarsityAssociations: Array<VarsityAssociation>;
  findLeaguePreviewsByEsportSchool: EsportLeaguesPreview;
  /** @deprecated Use getLastPlayedMetaseasonIdByPlayerId instead */
  findMatchesByTeamIds: Maybe<Array<Match>>;
  findNotes: FindNotesResult;
  findPlayerMatches: Maybe<Array<PlayerMatch>>;
  findPlayerMetaseasonMatches: Maybe<Array<Match>>;
  /** @deprecated No longer supported */
  findPlayersEligibleForTeam: Maybe<Array<User>>;
  /** @deprecated No longer supported */
  findRecommendedTeams: Maybe<Array<RecommendedTeam>>;
  findRecommendedTeamsForScrimmage: Maybe<Array<Team>>;
  /** @deprecated No longer supported */
  findReputationBySeasonIdTeamId: GenericTeamReputationPayload;
  findReputationsByTeamId: GenericTeamReputationPayload;
  findSchoolsByIds: Maybe<Array<School>>;
  /** @deprecated No longer supported */
  findScrimmageOpponents: Maybe<Array<Team>>;
  findSeasonReputationByTeamId: GenericTeamReputationPayload;
  findSurveyByTrigger: Maybe<Survey>;
  findTeamEnrollmentsByUser: TeamEnrollmentsPayload;
  findTeamsByLeagueId: Maybe<Array<Team>>;
  findTeamsBySchoolId: Maybe<Array<Team>>;
  findTeamsInSeason: FindTeamsInSeasonResult;
  findUsers: Maybe<UsersResult>;
  game: Maybe<Game>;
  gameAssistantStep: Maybe<GameAssistantStep>;
  gameHighlights: GameHighlightsResult;
  gameResult: Maybe<GameResult>;
  games: Maybe<Array<Game>>;
  getActiveLeaguesBySchoolId: Array<League>;
  getAggregateSchoolMessages: Maybe<Array<SchoolMessageTypeUnion>>;
  getAllLeagueGroups: AllLeagueGroupsResult;
  getAllLeagues: AllLeaguesResult;
  getAllPendingLegacyNotifications: Maybe<Array<LegacyUserNotification>>;
  getBillingPeriodSummaryForDateRange: BillingSummaryForDateRangePayload;
  getBillingPeriodUsage: BillingPeriodUsagePayload;
  getBracketByPhaseId: Maybe<Bracket>;
  getBulkOperationFromGoogleSheetJob: BulkActionJobPayload;
  getChecklist: ChecklistPayload;
  /** Get current metaseason.  This is the most recent metaseason that is active and ongoing. */
  getCurrentMetaseason: Maybe<Metaseason>;
  getEmailConflicts: EmailConflictPayload;
  getFortniteTeamMatchStats: Maybe<FortniteTeamMatchStatsResult>;
  getFortniteTeamPhaseStats: Maybe<FortniteTeamPhaseStatsResult>;
  getIncompleteNotificationTaskCount: Scalars['Int']['output'];
  getIncompleteNotificationTasks: UserNotificationsNotificationsPaginatedResults;
  getLastPlayedMetaseasonIdByPlayerId: Maybe<Scalars['UUID']['output']>;
  getLatestMatchPlayedByPlayerId: Maybe<Match>;
  getLeagueByPublicSlug: Maybe<League>;
  getLeagueMetadataBySchoolId: GetLeagueMetadataGenericPayload;
  getLeagueMetadataByTeamIds: GetLeagueMetadataGenericPayload;
  getLeaguesBySchoolId: Maybe<Array<League>>;
  getLeaguesEnrolledPlayerData: Array<Maybe<LeaguePlayerData>>;
  getLeaguesPendingPlayerData: Array<Maybe<LeaguePlayerData>>;
  getLinks: Array<Link>;
  getLobbyInfo: Maybe<LobbyInfoResponse>;
  getMaddenPlayerStatsByGameIds: GetMaddenPlayerStatsByGameIdsResults;
  getMatchChatByUniqueId: GetMatchChatByUniqueIdResults;
  getMatchChatQueueWaitingJobs: MatchChatJobResults;
  getMatchCheckIns: Array<MatchCheckIn>;
  getMatchDisputeFeedback: MatchDisputeRequest;
  getMatchRescheduleDateRange: Maybe<MatchRescheduleDateRange>;
  getMatchSurveyResponse: MatchSurvey;
  getMatches: MatchesResult;
  getNBA2kPlayerStatsByGameIds: GetNba2kPlayerStatsByGameIdsResults;
  getNoteAuthors: Maybe<Array<User>>;
  getNotes: Maybe<Array<Note>>;
  getPastMatchesByTeamId: Maybe<Array<Match>>;
  /** Use filter to get specific phases! */
  getPhases: GetPhasesResult;
  /** @deprecated No longer supported */
  getPlayerCountsForSchool: Maybe<SchoolPlayerCountsResult>;
  getPlayerGameStats: Maybe<PlayerGameStatsResult>;
  getPlayerGameStatsByMatchId: Array<PlayerGameStats>;
  getPlayerLinkedAccountPlatforms: Maybe<GetPlayerLinkedAccountPlatformsResponse>;
  getPlayerMatchStats: Maybe<PlayerMatchStatsResult>;
  getPlayerPhaseStats: Maybe<PlayerPhaseStatsResult>;
  getPlayerProfileGameOrMatchStats: Maybe<Array<ProfileGameOrMatchStats>>;
  getPlayerProfileRank: Maybe<Array<ProfileRankData>>;
  getPlayerProfileStats: Maybe<PlayerProfileStatsByEsport>;
  getPlayerSeasonStats: Maybe<PlayerSeasonStatsResult>;
  getPossibleTeamRivals: Maybe<GetPossibleTeamRivalsResult>;
  getPracticeDaySchedules: GetPracticeDaySchedulesPayload;
  getQualifiedTeamCount: Scalars['Int']['output'];
  getReferralSchools: ReferralSchoolsPayload;
  getReplayStatsByUserId: PlayerReplayPayload;
  getResourceImageUrl: Maybe<ResourceImage>;
  getResourceImagesByResourceIds: Array<ResourceImage>;
  getSameSchoolTeamsInSeason: Maybe<SameSchoolTeamsInSeasonResult>;
  getScheduledAndQueueMatchesByTeamIds: ScheduledAndQueueMatchesByTeamIdsResults;
  getSchoolBySlug: Maybe<School>;
  getSchoolInvoiceData: Array<SchoolInvoiceDataPayload>;
  getSchoolMessages: Maybe<Array<SchoolMessage>>;
  getSchoolRoles: UserSchoolRolesPayload;
  getSchoolRolesByUser: UserSchoolRolesPayload;
  getSchoolSeasonEnrollmentSummary: SchoolSeasonEnrollmentSummaryPayload;
  getSchoolsES: Maybe<SchoolsResult>;
  getSeasonDatesTemplates: GetSeasonDatesTemplateResult;
  /** Use filter to get specific seasons! */
  getSeasons: GetSeasonsResult;
  getSlotsByMetaseasonId: Maybe<Array<Slot>>;
  getSmashUltimateMostPlayedStatsByPlayerIds: GetSmashUltimateMostPlayedStatsByPlayerIdResults;
  getSmashUltimatePlayerStatsByGameIds: GetSmashUltimatePlayerStatsByGameIdsResults;
  getSplatoonPlayerStatsByGameIds: GetSplatoonPlayerStatsByGameIdsResults;
  getStepsForMatch: Array<Maybe<GameAssistantStep>>;
  getSupportedProvidersForEsport: Array<Provider>;
  getTeamGameStats: Maybe<TeamGameStatsResult>;
  getTeamMatchStats: Maybe<TeamMatchStatsResult>;
  getTeamPhaseStats: Maybe<TeamPhaseStatsResult>;
  getTeams: Maybe<TeamsResult>;
  getTour: Maybe<UserTourPayload>;
  getTwitchStreamForPlayer: TwitchData;
  getUserChildren: UserChildrenPayload;
  getUserChildrenByParentId: UserChildrenPayload;
  getUserMatchRescheduleRequests: Maybe<Array<MatchRescheduleRequest>>;
  getUserNotificationTasksByUser: UserNotificationsNotificationsPaginatedResults;
  getUserNotificationsSettings: GetUserNotificationsSettingsPayload;
  getUserTasks: Array<UserTaskPayload>;
  getUsers: Maybe<UsersResult>;
  getUsersOnlineStatus: GetUsersOnlineStatusPayload;
  getUsersWithPendingRoles: Maybe<UsersResult>;
  getVarsityAssociationBySlug: Maybe<VarsityAssociation>;
  getVarsityAssociations: GetVarsityAssociationsResult;
  getWalkthroughPlaylist: PlaylistPayload;
  /** @deprecated Discord is no longer used to manage matches. To be removed in MATCH-6755. */
  isDiscordConnectedToGuild: DiscordConnectedToGuildPayload;
  isPasswordResetValid: PasswordResetPayload;
  league: Maybe<League>;
  leagueBySlug: Maybe<League>;
  leagueGroup: Maybe<LeagueGroup>;
  listUserDemos: Maybe<Array<Demo>>;
  listUserSeasons: ListUserSeasonsResult;
  lobbyEventsForGame: Maybe<LobbyEventsResponse>;
  mapSelectionOptionsByEsportId: Maybe<GameAssistantSelectionOptionsPayload>;
  match: Maybe<Match>;
  matchAssignment: Maybe<MatchAssignment>;
  matchAssignments: Maybe<Array<MatchAssignment>>;
  matchRescheduleRequest: Maybe<MatchRescheduleRequest>;
  matchResult: Maybe<MatchResult>;
  matchSettleRequest: Maybe<MatchSettleRequestModel>;
  matchSettleRequests: Maybe<Array<MatchSettleRequestModel>>;
  matches: Maybe<Array<Match>>;
  matchesForSeasonByTeamIds: Maybe<Array<Match>>;
  me: Maybe<User>;
  /** Query a single metaseason */
  metaseason: Maybe<Metaseason>;
  /** Query all metaseasons */
  metaseasons: Array<Metaseason>;
  organizationEnrollmentData: OrganizationEnrollmentDataQueryResult;
  organizationSchedule: OrganizationScheduleQueryPayload;
  partner: Partner;
  partners: PartnerResult;
  /** Query a single phase by id */
  phase: Maybe<Phase>;
  phaseResult: Maybe<PhaseResult>;
  phaseResultByTeamIdAndPhaseId: Maybe<PhaseResult>;
  phaseResults: Maybe<Array<PhaseResult>>;
  playerGameStats: Maybe<PlayerGameStats>;
  playerMatchStats: Maybe<PlayerMatchStats>;
  playerPhaseStats: Maybe<PlayerPhaseStats>;
  playvsFortniteEvents: Maybe<FortniteEventsResponse>;
  /** @deprecated No longer supported */
  product: Maybe<Product>;
  referralDetailsV2: Maybe<ReferralDetailsV2>;
  replayAvailable: ReplayAvailablePayload;
  roleInviteCode: Maybe<RoleInviteCode>;
  roleInviteCodeByCode: Maybe<RoleInviteCode>;
  school: Maybe<School>;
  schoolEnrollableSeasons: SchoolEnrollableSeasonsPayload;
  schoolProviderAccount: SchoolProviderAccount;
  schoolProviderAccountsForSchool: Array<SchoolProviderAccount>;
  scrimmageRequest: Maybe<ScrimmageRequest>;
  scrimmageRequests: Maybe<ScrimmageRequestResult>;
  searchSchools: SearchSchoolsResults;
  /** A single season, either by id */
  season: Maybe<Season>;
  seasonDatesTemplate: Maybe<SeasonDatesTemplate>;
  seasonPassProduct: Maybe<SeasonPassProduct>;
  seasonPlayoffTemplate: SeasonPlayoffTemplate;
  seasonPlayoffTemplates: Array<SeasonPlayoffTemplate>;
  /** All seasons (regardless of date or status) */
  seasons: Array<Season>;
  series: Maybe<Array<Series>>;
  /** Query a single slot by id  */
  slot: Maybe<Slot>;
  slotExclusionRangeConfigurations: SlotExclusionRangeConfigurationsResult;
  slotLobbyStatus: SlotLobbyStatusPayload;
  slots: Maybe<Array<Slot>>;
  sponsorshipCampaign: SponsorshipCampaign;
  sponsorshipCampaigns: SponsorshipCampaignsResult;
  sponsorshipImages: Array<SponsorshipImage>;
  stopUnfilledScrimmageNotificationEmailJob: JobPayload;
  stopUpcomingScrimmageReminderEmailJob: JobPayload;
  stopWeeklyEmailJob: JobPayload;
  summonerInfo: Maybe<SummonerInfoResponse>;
  supportedProviders: Array<Provider>;
  supportedSchoolProviders: Array<SchoolProvider>;
  team: Maybe<Team>;
  teamGameStats: Maybe<TeamGameStats>;
  teamMatchStats: Maybe<TeamMatchStats>;
  teamPhaseStats: Maybe<TeamPhaseStats>;
  teamRoster: TeamRoster;
  teamsByIds: Maybe<Array<Team>>;
  teamsByIdsSchoolId: Maybe<Array<Team>>;
  triggerScheduledEmailTest: JobPayload;
  triggerUnfilledScrimmageNotificationEmail: JobPayload;
  triggerUpcomingScrimmageReminderEmail: JobPayload;
  triggerWeeklyEmail: JobPayload;
  user: Maybe<User>;
  userAttributes: Maybe<UserAttributes>;
  userEsportPlatforms: Maybe<Array<UserEsportPlatform>>;
  userEsportProviders: Array<UserEsportProvider>;
  userIPLocation: UserIpLocation;
  userNotifications: UserNotifications;
  userProviderAccount: UserProviderAccount;
  userProviderAccountsForUser: Array<UserProviderAccount>;
  userSchedule: UserScheduleQueryPayload;
  userSchoolSubmission: Maybe<UserSchoolSubmission>;
  userSchoolSubmissions: Maybe<Array<UserSchoolSubmission>>;
  users: Array<User>;
};


export type QueryAnnualPassProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAssetArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAvailableSpectatorsByTeamIdArgs = {
  teamId: Scalars['UUID']['input'];
};


export type QueryAvailableWeeklyAwardPlayersArgs = {
  input: AvailableWeeklyAwardPlayersInput;
};


export type QueryBracketArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCachedOrdinalsArgs = {
  matchId: Scalars['UUID']['input'];
};


export type QueryChampionArgs = {
  championId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCharacterSelectionOptionsByEsportIdArgs = {
  esportId: Scalars['UUID']['input'];
};


export type QueryCheckPlaceInPreseasonQueueArgs = {
  teamId: Scalars['String']['input'];
};


export type QueryCheckPlaceInSmartQueueArgs = {
  input: CheckPlaceInSmartQueueInput;
};


export type QueryCheckValidPlayersArgs = {
  epicAccountIds: Array<Scalars['String']['input']>;
};


export type QueryCheckValidPlayersOnPlatformArgs = {
  userAccountAndPlatformInputs: Array<UserAccountAndPlatformInput>;
};


export type QueryCheckValidationArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCompetitionIntervalsForOrganizationArgs = {
  input: CompetitionIntervalsForOrganizationQueryInput;
};


export type QueryCurrentGameAssistantStateByMatchIdArgs = {
  input: CurrentGameAssistantStateInput;
};


export type QueryCurrentSeriesPlayerSelectionsByMatchIdArgs = {
  matchId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type QueryDownloadSchoolInvoiceArgs = {
  input: DownloadSchoolInvoiceInput;
};


export type QueryEligibleMetaseasonsArgs = {
  includeDeletedSeasonTeam?: InputMaybe<Scalars['Boolean']['input']>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryEpicPlatformSelectionOptionsByUserIdsArgs = {
  userIds: Array<Scalars['UUID']['input']>;
};


export type QueryEsportArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  slug?: InputMaybe<Scalars['EsportSlug']['input']>;
};


export type QueryEsportPlatformsArgs = {
  esportId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryEsportsArgs = {
  filters?: InputMaybe<EsportFilters>;
};


export type QueryEsportsByCompetitionGroupArgs = {
  competitionGroup: CompetitionGroup;
};


export type QueryEstimateSchoolSeasonPassUsageArgs = {
  enrollTeamIds: Array<Scalars['UUID']['input']>;
  metaseasonId: Scalars['UUID']['input'];
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryFetchMatchChatEventsByEsportIdsArgs = {
  input: FetchMatchChatEventByEsportIdsInput;
};


export type QueryFetchMatchSettleRequestArgs = {
  input: FetchMatchSettleRequestInput;
};


export type QueryFetchPlayerStandingArgs = {
  phaseId: Scalars['UUID']['input'];
  playerId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryFindCommonLeaguesForTeamsArgs = {
  input: CommonLeaguesForTeamsInput;
};


export type QueryFindDeniedUsersArgs = {
  input: FindDeniedUsers;
};


export type QueryFindEligibleTeamsForSubstituteTransferArgs = {
  input: FindEligibleTeamsForSubstituteTransferInput;
};


export type QueryFindEligibleVarsityAssociationsArgs = {
  input: FindEligibleVarsityAssociationsInput;
};


export type QueryFindLeaguePreviewsByEsportSchoolArgs = {
  esportId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type QueryFindMatchesByTeamIdsArgs = {
  input: MatchesByTeamIdsInput;
};


export type QueryFindNotesArgs = {
  options?: InputMaybe<NoteOptions>;
};


export type QueryFindPlayerMatchesArgs = {
  filters?: InputMaybe<PlayerMatchFilters>;
  playerId: Scalars['UUID']['input'];
};


export type QueryFindPlayerMetaseasonMatchesArgs = {
  metaseasonId: Scalars['UUID']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['UUID']['input'];
  statuses?: InputMaybe<Array<MatchStatus>>;
};


export type QueryFindPlayersEligibleForTeamArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  teamId: Scalars['UUID']['input'];
};


export type QueryFindRecommendedTeamsArgs = {
  filters?: InputMaybe<TeamFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['UUID']['input'];
};


export type QueryFindRecommendedTeamsForScrimmageArgs = {
  filters?: InputMaybe<TeamFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['UUID']['input'];
};


export type QueryFindReputationBySeasonIdTeamIdArgs = {
  seasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type QueryFindReputationsByTeamIdArgs = {
  teamId: Scalars['UUID']['input'];
};


export type QueryFindSchoolsByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryFindScrimmageOpponentsArgs = {
  filters?: InputMaybe<TeamFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['UUID']['input'];
};


export type QueryFindSeasonReputationByTeamIdArgs = {
  seasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type QueryFindSurveyByTriggerArgs = {
  entityId: Scalars['UUID']['input'];
  entityType: SurveyTriggerEntityType;
  trigger: SurveyTrigger;
};


export type QueryFindTeamEnrollmentsByUserArgs = {
  input: TeamEnrollmentsInput;
};


export type QueryFindTeamsByLeagueIdArgs = {
  leagueId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryFindTeamsBySchoolIdArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type QueryFindTeamsInSeasonArgs = {
  input: FindTeamsInSeasonInput;
};


export type QueryFindUsersArgs = {
  input: FindUsers;
};


export type QueryGameArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGameAssistantStepArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGameHighlightsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GameHighlightFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGameResultArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGamesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QueryGetActiveLeaguesBySchoolIdArgs = {
  esportId?: InputMaybe<Scalars['UUID']['input']>;
  metaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type QueryGetAggregateSchoolMessagesArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetAllLeagueGroupsArgs = {
  filters?: InputMaybe<LeagueGroupFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllLeaguesArgs = {
  filters: LeagueFilters;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllPendingLegacyNotificationsArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetBillingPeriodSummaryForDateRangeArgs = {
  dateRange: DateRangeInput;
  schoolId: Scalars['UUID']['input'];
};


export type QueryGetBillingPeriodUsageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateRange: DateRangeInput;
  esportId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['UUID']['input'];
};


export type QueryGetBracketByPhaseIdArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type QueryGetBulkOperationFromGoogleSheetJobArgs = {
  input: GetJobInput;
};


export type QueryGetChecklistArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type QueryGetFortniteTeamMatchStatsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetFortniteTeamPhaseStatsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  phaseId: Scalars['UUID']['input'];
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetIncompleteNotificationTaskCountArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetIncompleteNotificationTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetLastPlayedMetaseasonIdByPlayerIdArgs = {
  playerId: Scalars['UUID']['input'];
};


export type QueryGetLatestMatchPlayedByPlayerIdArgs = {
  playerId: Scalars['UUID']['input'];
};


export type QueryGetLeagueByPublicSlugArgs = {
  publicSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLeagueMetadataBySchoolIdArgs = {
  input: GetLeagueMetadataBySchoolIdInput;
};


export type QueryGetLeagueMetadataByTeamIdsArgs = {
  input: GetLeagueMetadataByTeamIdsInput;
};


export type QueryGetLeaguesBySchoolIdArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type QueryGetLeaguesEnrolledPlayerDataArgs = {
  leagueIds: Array<Scalars['UUID']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetLeaguesPendingPlayerDataArgs = {
  leagueIds: Array<Scalars['UUID']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetLobbyInfoArgs = {
  tournamentCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMaddenPlayerStatsByGameIdsArgs = {
  input: Array<GetMaddenPlayerStatsByGameIdsInput>;
};


export type QueryGetMatchChatByUniqueIdArgs = {
  input: GetMatchChatByUniqueIdInput;
};


export type QueryGetMatchCheckInsArgs = {
  filters: MatchCheckInFilters;
};


export type QueryGetMatchDisputeFeedbackArgs = {
  input: MatchDisputeRequestInput;
};


export type QueryGetMatchRescheduleDateRangeArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetMatchSurveyResponseArgs = {
  input: MatchSurveyInput;
};


export type QueryGetMatchesArgs = {
  filters?: InputMaybe<MatchFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortFields?: InputMaybe<Array<MatchSortSpec>>;
};


export type QueryGetNba2kPlayerStatsByGameIdsArgs = {
  input: Array<GetNba2kPlayerStatsByGameIdsInput>;
};


export type QueryGetNoteAuthorsArgs = {
  input?: InputMaybe<GetNoteAuthorsInput>;
};


export type QueryGetNotesArgs = {
  options?: InputMaybe<NoteOptions>;
};


export type QueryGetPastMatchesByTeamIdArgs = {
  input: PastMatchesByTeamIdInput;
};


export type QueryGetPhasesArgs = {
  filter?: InputMaybe<GetPhasesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPlayerCountsForSchoolArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetPlayerGameStatsArgs = {
  filters?: InputMaybe<PlayerStatsFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPlayerGameStatsByMatchIdArgs = {
  matchId: Scalars['UUID']['input'];
};


export type QueryGetPlayerLinkedAccountPlatformsArgs = {
  epicAccountId: Scalars['String']['input'];
};


export type QueryGetPlayerMatchStatsArgs = {
  filters?: InputMaybe<PlayerMatchStatsFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPlayerPhaseStatsArgs = {
  filters?: InputMaybe<PlayerPhaseStatsFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPlayerProfileGameOrMatchStatsArgs = {
  phaseId: Scalars['UUID']['input'];
  playerId: Scalars['UUID']['input'];
};


export type QueryGetPlayerProfileRankArgs = {
  phaseId: Scalars['UUID']['input'];
  playerId: Scalars['UUID']['input'];
};


export type QueryGetPlayerProfileStatsArgs = {
  phaseId: Scalars['UUID']['input'];
  playerId: Scalars['UUID']['input'];
};


export type QueryGetPlayerSeasonStatsArgs = {
  input: PlayerSeasonStatsInput;
};


export type QueryGetPossibleTeamRivalsArgs = {
  input: GetPossibleTeamRivalsInput;
};


export type QueryGetPracticeDaySchedulesArgs = {
  input: GetPracticeDaySchedulesInput;
};


export type QueryGetQualifiedTeamCountArgs = {
  input: GetQualifiedTeamCountInput;
};


export type QueryGetReferralSchoolsArgs = {
  limit: Scalars['Int']['input'];
};


export type QueryGetReplayStatsByUserIdArgs = {
  input: PlayerReplayInput;
};


export type QueryGetResourceImageUrlArgs = {
  resource: ResourceData;
  size: Scalars['Int']['input'];
};


export type QueryGetResourceImagesByResourceIdsArgs = {
  resources: Array<ResourceData>;
};


export type QueryGetSameSchoolTeamsInSeasonArgs = {
  seasonIds: Array<Scalars['UUID']['input']>;
};


export type QueryGetScheduledAndQueueMatchesByTeamIdsArgs = {
  input: ScheduledAndQueueMatchesByTeamIdsInput;
};


export type QueryGetSchoolBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetSchoolInvoiceDataArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type QueryGetSchoolMessagesArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetSchoolRolesByUserArgs = {
  userId: Scalars['UUID']['input'];
};


export type QueryGetSchoolSeasonEnrollmentSummaryArgs = {
  metaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
};


export type QueryGetSchoolsEsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSeasonsArgs = {
  filter?: InputMaybe<GetSeasonsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSlotsByMetaseasonIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetSmashUltimateMostPlayedStatsByPlayerIdsArgs = {
  esportSlug?: InputMaybe<Scalars['EsportSlug']['input']>;
  input: GetSmashUltimateMostPlayedStatsByPlayerIdsInput;
};


export type QueryGetSmashUltimatePlayerStatsByGameIdsArgs = {
  esportSlug?: InputMaybe<Scalars['EsportSlug']['input']>;
  input: Array<GetSmashUltimatePlayerStatsByGameIdsInput>;
};


export type QueryGetSplatoonPlayerStatsByGameIdsArgs = {
  input: Array<GetSplatoonPlayerStatsByGameIdsInput>;
};


export type QueryGetStepsForMatchArgs = {
  matchId: Scalars['UUID']['input'];
};


export type QueryGetSupportedProvidersForEsportArgs = {
  esportSlug: Scalars['EsportSlug']['input'];
};


export type QueryGetTeamGameStatsArgs = {
  filters?: InputMaybe<TeamStatsFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTeamMatchStatsArgs = {
  filters?: InputMaybe<TeamMatchStatsFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTeamPhaseStatsArgs = {
  filters?: InputMaybe<TeamPhaseStatsFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTeamsArgs = {
  filters?: InputMaybe<TeamFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortFields?: InputMaybe<Array<TeamSortSpec>>;
};


export type QueryGetTourArgs = {
  tour: Tour;
};


export type QueryGetTwitchStreamForPlayerArgs = {
  twitchId: Scalars['String']['input'];
  twitchUsername: Scalars['String']['input'];
};


export type QueryGetUserChildrenByParentIdArgs = {
  parentUserId: Scalars['UUID']['input'];
};


export type QueryGetUserNotificationTasksByUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['UUID']['input'];
};


export type QueryGetUserNotificationsSettingsArgs = {
  input: GetUserNotificationsSettingsInput;
};


export type QueryGetUserTasksArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetUsersArgs = {
  filters: SearchAllUsersInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUsersOnlineStatusArgs = {
  input: GetUsersOnlineStatusInput;
};


export type QueryGetUsersWithPendingRolesArgs = {
  filters?: InputMaybe<PendingUserRolesFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetVarsityAssociationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetVarsityAssociationsArgs = {
  input: GetVarsityAssociationsInput;
};


export type QueryIsDiscordConnectedToGuildArgs = {
  userId: Scalars['UUID']['input'];
};


export type QueryIsPasswordResetValidArgs = {
  input?: InputMaybe<VerifyPasswordResetInput>;
};


export type QueryLeagueArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryLeagueBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryLeagueGroupArgs = {
  filters?: InputMaybe<LeagueFiltersInput>;
  id: Scalars['UUID']['input'];
};


export type QueryListUserSeasonsArgs = {
  esportId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryLobbyEventsForGameArgs = {
  tournamentCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMapSelectionOptionsByEsportIdArgs = {
  esportId: Scalars['UUID']['input'];
};


export type QueryMatchArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMatchAssignmentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMatchAssignmentsArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryMatchRescheduleRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMatchResultArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMatchSettleRequestArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMatchSettleRequestsArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryMatchesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QueryMatchesForSeasonByTeamIdsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  metaseasonId: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  teamIds: Array<Scalars['UUID']['input']>;
};


export type QueryMetaseasonArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMetaseasonsArgs = {
  options?: InputMaybe<MetaseasonsOptions>;
};


export type QueryOrganizationEnrollmentDataArgs = {
  input: OrganizationEnrollmentDataQueryInput;
};


export type QueryOrganizationScheduleArgs = {
  input: OrganizationScheduleQueryInput;
};


export type QueryPartnerArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPartnersArgs = {
  input: PartnerSearchInput;
};


export type QueryPhaseArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryPhaseResultArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPhaseResultByTeamIdAndPhaseIdArgs = {
  phaseId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type QueryPhaseResultsArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryPlayerGameStatsArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPlayerMatchStatsArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPlayerPhaseStatsArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPlayvsFortniteEventsArgs = {
  epicEventId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryReferralDetailsV2Args = {
  token: Scalars['String']['input'];
};


export type QueryReplayAvailableArgs = {
  input: PlayerReplayInput;
};


export type QueryRoleInviteCodeArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRoleInviteCodeByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QuerySchoolArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySchoolEnrollableSeasonsArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  schoolId: Scalars['UUID']['input'];
};


export type QuerySchoolProviderAccountArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySchoolProviderAccountsForSchoolArgs = {
  input: SchoolProviderAccountsForSchoolInput;
};


export type QueryScrimmageRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryScrimmageRequestsArgs = {
  filter?: InputMaybe<ScrimmageRequestFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchSchoolsArgs = {
  query?: InputMaybe<SearchSchoolsQuery>;
};


export type QuerySeasonArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySeasonDatesTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySeasonPassProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySeasonPlayoffTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySeriesArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QuerySlotArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySlotExclusionRangeConfigurationsArgs = {
  input: FindSlotExclusionRangeConfigurationsInput;
};


export type QuerySlotLobbyStatusArgs = {
  slotId: Scalars['UUID']['input'];
};


export type QuerySlotsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QuerySponsorshipCampaignArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySponsorshipCampaignsArgs = {
  input: SponsorshipCampaignSearchInput;
};


export type QuerySponsorshipImagesArgs = {
  entityId: Scalars['UUID']['input'];
  entityType: SponsorshipEntityType;
};


export type QuerySummonerInfoArgs = {
  summonerId?: InputMaybe<Scalars['String']['input']>;
  summonerName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryTeamGameStatsArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryTeamMatchStatsArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryTeamPhaseStatsArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryTeamRosterArgs = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtRange?: InputMaybe<DateRangeInput>;
  teamId: Scalars['UUID']['input'];
};


export type QueryTeamsByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryTeamsByIdsSchoolIdArgs = {
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserAttributesArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserEsportPlatformsArgs = {
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUserEsportProvidersArgs = {
  userId: Scalars['UUID']['input'];
};


export type QueryUserIpLocationArgs = {
  ipAddress?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserProviderAccountArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUserProviderAccountsForUserArgs = {
  input: UserProviderAccountsForUserInput;
};


export type QueryUserScheduleArgs = {
  input: UserScheduleQueryInput;
};


export type QueryUserSchoolSubmissionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUsersArgs = {
  role: RoleDescriptor;
};

export type QuerySeasonPassInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type QuerySeasonPassesInput = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum QuerySortOrder {
  Asc = 'Asc',
  Desc = 'Desc'
}

export type Question = {
  questionText: Scalars['String']['input'];
  response: Scalars['String']['input'];
};

export enum QueueStatus {
  Accepted = 'accepted',
  AwaitingOpponent = 'awaitingOpponent',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Declined = 'declined',
  Expired = 'expired',
  Failed = 'failed',
  FoundOpponent = 'foundOpponent',
  NoResponse = 'noResponse',
  NotInQueue = 'notInQueue',
  OpponentAccepted = 'opponentAccepted',
  OpponentDeclined = 'opponentDeclined',
  Pending = 'pending'
}

export enum Race {
  AmericanIndianOrAlaskaNative = 'AmericanIndianOrAlaskaNative',
  Asian = 'Asian',
  BlackOrAfricanAmerican = 'BlackOrAfricanAmerican',
  HispanicOrLatino = 'HispanicOrLatino',
  NativeHawaiianOrOtherPacificIslander = 'NativeHawaiianOrOtherPacificIslander',
  NotListed = 'NotListed',
  PreferNotToAnswer = 'PreferNotToAnswer',
  White = 'White'
}

export type RankedAnnualPassProduct = IRankedProduct & {
  __typename?: 'RankedAnnualPassProduct';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  internalName: Maybe<Scalars['String']['output']>;
  isAdminOnly: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  isRecommended: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  priceUsd: Scalars['Float']['output'];
  seasonPassesAllotted: Maybe<Array<AllottedSeasonPass>>;
  seatCount: Maybe<Scalars['Int']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  type: ProductType;
};

export type RecheckNotificationTaskStatusInput = {
  type: Scalars['String']['input'];
};

export type RecheckNotificationTaskStatusResult = {
  __typename?: 'RecheckNotificationTaskStatusResult';
  entityType: Scalars['String']['output'];
  totalChecking: Scalars['Int']['output'];
};

export type RecommendedTeam = {
  __typename?: 'RecommendedTeam';
  recommendationPercent: Scalars['Float']['output'];
  team: Team;
};

export type RecoverPasswordInput = {
  email: Scalars['String']['input'];
};

export type ReferByEmailInput = {
  competitionGroup?: InputMaybe<CompetitionGroup>;
  email: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roleName: UserRoleName;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type ReferEmailPayload = {
  __typename?: 'ReferEmailPayload';
  success: Scalars['Boolean']['output'];
};

export type ReferParentByEmailInput = {
  email: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type ReferralDetailsV2 = {
  __typename?: 'ReferralDetailsV2';
  referringUserId: Maybe<Scalars['UUID']['output']>;
  school: Maybe<School>;
  token: Maybe<Scalars['String']['output']>;
};

export type ReferralLinkInput = {
  competitionGroup?: InputMaybe<CompetitionGroup>;
  medium: Scalars['String']['input'];
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
  resourceType: ResourceType;
  roleName: UserRoleName;
  source: Scalars['String']['input'];
};

export type ReferralPayload = {
  __typename?: 'ReferralPayload';
  referral: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ReferralSchool = {
  __typename?: 'ReferralSchool';
  referredAt: Maybe<Scalars['DateTime']['output']>;
  school: Maybe<School>;
  schoolId: Scalars['String']['output'];
};

export type ReferralSchoolsPayload = {
  __typename?: 'ReferralSchoolsPayload';
  referralSchools: Array<ReferralSchool>;
};

export type RefreshSchoolLeagueGroupsOptions = {
  forceUnenrollPlayers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisterUserInput = {
  captcha?: InputMaybe<Scalars['String']['input']>;
  captchaToken?: InputMaybe<CaptchaVerificationInput>;
  dateOfBirth: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  userConsentId?: InputMaybe<Scalars['UUID']['input']>;
};

export type RegisterUserOptions = {
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  referralToken?: InputMaybe<Scalars['String']['input']>;
  sendEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisterUserResponse = {
  __typename?: 'RegisterUserResponse';
  user: User;
};

export type RegisterUserWithUsernameInput = {
  captcha?: InputMaybe<Scalars['String']['input']>;
  captchaToken?: InputMaybe<CaptchaVerificationInput>;
  dateOfBirth: Scalars['DateTime']['input'];
  email: Scalars['String']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  userConsentId?: InputMaybe<Scalars['UUID']['input']>;
  username: Scalars['String']['input'];
};

export type RemoveSchoolFromVarsityAssociationInput = {
  firstEffectiveMetaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
  varsityAssociationSlug: Scalars['String']['input'];
};

export type RemoveSchoolsFromVarsityAssociationInput = {
  schools: Array<RemoveSchoolFromVarsityAssociationInput>;
};

export type RemoveSelectionOptionPayload = {
  __typename?: 'RemoveSelectionOptionPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveTeamRivalInput = {
  teamId: Scalars['UUID']['input'];
  teamRivalId: Scalars['UUID']['input'];
};

export type RemoveUserEsportPayload = {
  __typename?: 'RemoveUserEsportPayload';
  esportId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
  userId: Scalars['UUID']['output'];
};

export type RemoveUserFromSchoolInput = {
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  userPersonalEmail?: InputMaybe<Scalars['String']['input']>;
  userSchoolEmail?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveUserProviderAccountSuccussPayload = {
  __typename?: 'RemoveUserProviderAccountSuccussPayload';
  removedUserProviderAccountId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemovedFromTeamEvent = IRosterEvent & {
  __typename?: 'RemovedFromTeamEvent';
  player: Maybe<User>;
  playerId: Scalars['UUID']['output'];
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Scalars['UUID']['output'];
};

export type ReplayAvailablePayload = {
  __typename?: 'ReplayAvailablePayload';
  success: Scalars['Boolean']['output'];
};

export type RequestAccountEditInput = {
  password: Scalars['String']['input'];
};

export type RequestAccountEditResult = {
  __typename?: 'RequestAccountEditResult';
  expiresAt: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
};

export type RequestEmailUpdateInput = {
  newEmail: Scalars['String']['input'];
  oldEmail?: InputMaybe<Scalars['String']['input']>;
};

export type RequestEmailUpdateResult = {
  __typename?: 'RequestEmailUpdateResult';
  success: Scalars['Boolean']['output'];
  userEmail: Maybe<UserEmail>;
  userEmailId: Maybe<Scalars['UUID']['output']>;
};

export type RequestEmailVerificationInput = {
  email: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

export type RequestGameResetInput = {
  matchId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type RequestGameResetPayload = {
  __typename?: 'RequestGameResetPayload';
  success: Scalars['Boolean']['output'];
};

export type RequestMatchAssistantBypassInput = {
  matchId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type RequestMatchAssistantBypassPayload = {
  __typename?: 'RequestMatchAssistantBypassPayload';
  success: Scalars['Boolean']['output'];
};

export type RequestMatchRescheduleInput = {
  matchId: Scalars['UUID']['input'];
  proposedTimes: Array<Scalars['DateTime']['input']>;
  rescheduleNotes?: InputMaybe<Scalars['String']['input']>;
  rescheduleReason: MatchRescheduleRequestReason;
  teamId: Scalars['UUID']['input'];
};

export type RequestMatchRescheduleWithinSchoolInput = {
  matchId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
  updatedStartsAt: Scalars['DateTime']['input'];
};

export type RequestNextGameRosterChangeForRocketLeagueInput = {
  currentGameOrdinal?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type RequestNextGameRosterChangeForRocketLeaguePayload = {
  __typename?: 'RequestNextGameRosterChangeForRocketLeaguePayload';
  success: Scalars['Boolean']['output'];
};

export type RequestScrimmageInput = {
  allowAutoSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  bestOf: Scalars['Int']['input'];
  isAutoGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  opposingTeamId?: InputMaybe<Scalars['UUID']['input']>;
  rating: Scalars['String']['input'];
  requestingTeamId: Scalars['UUID']['input'];
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  startsAt: Scalars['DateTime']['input'];
};

export type RequestScrimmageResponse = {
  __typename?: 'RequestScrimmageResponse';
  scrimmageLink: Scalars['String']['output'];
  scrimmageRequest: ScrimmageRequest;
};

export type RequestTeamRivalInput = {
  acceptingTeamId: Scalars['UUID']['input'];
  requestingTeamId: Scalars['UUID']['input'];
  seasonId: Scalars['UUID']['input'];
};

export type RequiredDateRange = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
};

export type RescheduleMatchError = {
  __typename?: 'RescheduleMatchError';
  error: BulkActionError;
  row: Scalars['UUID']['output'];
};

export type RescheduleMatchResult = {
  __typename?: 'RescheduleMatchResult';
  result: Scalars['Boolean']['output'];
  row: Scalars['UUID']['output'];
};

export type RescheduleMatchesInput = {
  matchIds: Array<Scalars['UUID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: AdminMatchRescheduleReason;
  updatedStartsAt: Scalars['DateTime']['input'];
};

export type RescheduleMatchesPayload = BulkActionCount & {
  __typename?: 'RescheduleMatchesPayload';
  errorCount: Scalars['Int']['output'];
  errors: Maybe<Array<Maybe<RescheduleMatchError>>>;
  results: Maybe<Array<Maybe<RescheduleMatchResult>>>;
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type RescheduleSlotInput = {
  slotId: Scalars['UUID']['input'];
  startsAt: Scalars['String']['input'];
};

export type ResetStepPayload = {
  __typename?: 'ResetStepPayload';
  currentStep: GameAssistantStep;
  success: Scalars['Boolean']['output'];
};

export type ResolveUnknownPlayerGameStatsInput = {
  gameId: Scalars['UUID']['input'];
  playerId: Scalars['UUID']['input'];
  publisherAccountId: Scalars['String']['input'];
};

/** A resource for a particular entity for example this could be an resource for a particular league. */
export type Resource = {
  __typename?: 'Resource';
  heading: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['UUID']['output']>;
  markdown: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type ResourceData = {
  id: Scalars['UUID']['input'];
  type: ResourceType;
};

export type ResourceImage = {
  __typename?: 'ResourceImage';
  fileName: Scalars['String']['output'];
  resourceId: Scalars['UUID']['output'];
  resourceType: ResourceType;
  size: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export enum ResourceType {
  Organization = 'organization',
  System = 'system',
  Team = 'team',
  User = 'user'
}

export type ResponseMatchRescheduleInput = {
  denyNotes?: InputMaybe<Scalars['String']['input']>;
  matchRescheduleRequestId: Scalars['UUID']['input'];
  proposedTimes?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  response: MatchRescheduleResponse;
  selectedProposedTime?: InputMaybe<Scalars['DateTime']['input']>;
  teamId: Scalars['UUID']['input'];
};

export type ResponseTeamRivalInput = {
  acceptingTeamId: Scalars['UUID']['input'];
  teamRivalId: Scalars['UUID']['input'];
};

export enum RiotApiPickType {
  AllRandom = 'ALL_RANDOM',
  BlindPick = 'BLIND_PICK',
  TournamentDraft = 'TOURNAMENT_DRAFT'
}

/** The Rocket League player stats for a game */
export type RocketLeaguePlayerGameStats = RocketLeagueStats & {
  __typename?: 'RocketLeaguePlayerGameStats';
  assists: Scalars['Int']['output'];
  goals: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  saves: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  shootingPercentage: Maybe<Scalars['Float']['output']>;
  shots: Scalars['Int']['output'];
};

/** The Rocket League player stats for a match */
export type RocketLeaguePlayerMatchStats = RocketLeagueStats & {
  __typename?: 'RocketLeaguePlayerMatchStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageGoals: Scalars['Float']['output'];
  averageSaves: Scalars['Float']['output'];
  averageScore: Scalars['Float']['output'];
  averageShots: Scalars['Float']['output'];
  goals: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  saves: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  shootingPercentage: Maybe<Scalars['Float']['output']>;
  shots: Scalars['Int']['output'];
};

/** The Rocket League player stats for a phase */
export type RocketLeaguePlayerPhaseStats = RocketLeagueStats & {
  __typename?: 'RocketLeaguePlayerPhaseStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageGoals: Scalars['Float']['output'];
  averageSaves: Scalars['Float']['output'];
  averageScore: Scalars['Float']['output'];
  averageShots: Scalars['Float']['output'];
  goals: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  saves: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  shootingPercentage: Maybe<Scalars['Float']['output']>;
  shots: Scalars['Int']['output'];
};

/**
 * The Rocket League player stats for a season.
 *   TODO: Consider persisting this data so that it matches
 *   Game/Match/Phase stats.
 */
export type RocketLeaguePlayerSeasonStats = {
  __typename?: 'RocketLeaguePlayerSeasonStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageGoals: Scalars['Float']['output'];
  averageSaves: Scalars['Float']['output'];
  averageScore: Scalars['Float']['output'];
  averageShots: Scalars['Float']['output'];
  goals: Scalars['Int']['output'];
  saves: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  shootingPercentage: Maybe<Scalars['Float']['output']>;
  shots: Scalars['Int']['output'];
};

export type RocketLeagueStats = {
  assists: Scalars['Int']['output'];
  goals: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  saves: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  shots: Scalars['Int']['output'];
};

/** The Rocket League team stats for a game */
export type RocketLeagueTeamGameStats = RocketLeagueStats & {
  __typename?: 'RocketLeagueTeamGameStats';
  assists: Scalars['Int']['output'];
  goals: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  saves: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  shots: Scalars['Int']['output'];
};

export type RocketLeagueTeamGameStatsWithSp = RocketLeagueStats & {
  __typename?: 'RocketLeagueTeamGameStatsWithSP';
  assists: Scalars['Int']['output'];
  goals: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  saves: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  shootingPercentage: Maybe<Scalars['Float']['output']>;
  shots: Scalars['Int']['output'];
};

/** The Rocket League team stats for a match */
export type RocketLeagueTeamMatchStats = RocketLeagueStats & {
  __typename?: 'RocketLeagueTeamMatchStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageGoals: Scalars['Float']['output'];
  averageSaves: Scalars['Float']['output'];
  averageScore: Scalars['Float']['output'];
  averageShots: Scalars['Float']['output'];
  goals: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  saves: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  shots: Scalars['Int']['output'];
};

/** The Rocket League team stats for a phase */
export type RocketLeagueTeamPhaseStats = RocketLeagueStats & {
  __typename?: 'RocketLeagueTeamPhaseStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageGoals: Scalars['Float']['output'];
  averageSaves: Scalars['Float']['output'];
  averageScore: Scalars['Float']['output'];
  averageShots: Scalars['Float']['output'];
  goals: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  saves: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  shots: Scalars['Int']['output'];
};

export type Role = {
  __typename?: 'Role';
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['UUID']['output']>;
  isDirect: Maybe<Scalars['Boolean']['output']>;
  parentRoleId: Maybe<Scalars['UUID']['output']>;
  resourceId: Scalars['UUID']['output'];
  resourceType: ResourceType;
  roleName: UserRoleName;
  status: UserRoleStatusName;
  userId: Scalars['UUID']['output'];
};

export type RoleDescriptor = {
  resourceId: Scalars['UUID']['input'];
  resourceType: ResourceType;
  roleName: UserRoleName;
};

export type RoleFilters = {
  roleNames: Array<UserRoleName>;
  roleStatuses: Array<UserRoleStatusName>;
};

export type RoleInvite = {
  __typename?: 'RoleInvite';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  invitedById: Scalars['UUID']['output'];
  resourceId: Scalars['UUID']['output'];
  resourceType: ResourceType;
  roleName: UserRoleName;
  roleUpdateId: Maybe<Scalars['UUID']['output']>;
  status: UserRoleStatusName;
  userId: Scalars['UUID']['output'];
};

/**
 * Contains a payload of referral attributes to be used in referral
 * sign up flow such as inviting a team member or a coach.
 *
 * resourceId and resourceType will be null if the referred to entity
 * is no longer in a referrable state, such as deleted or Denied status.
 */
export type RoleInviteCode = {
  __typename?: 'RoleInviteCode';
  code: Scalars['String']['output'];
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  resourceId: Maybe<Scalars['UUID']['output']>;
  resourceType: Maybe<Scalars['String']['output']>;
  roleName: UserRoleName;
  userId: Maybe<Scalars['UUID']['output']>;
};

export type RoleRequest = {
  __typename?: 'RoleRequest';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  resourceId: Scalars['UUID']['output'];
  resourceType: ResourceType;
  roleName: UserRoleName;
  status: UserRoleStatusName;
  userId: Scalars['UUID']['output'];
};

export type RoleRequestFilters = {
  resourceId: Scalars['UUID']['input'];
  resourceType: ResourceType;
  roleName: UserRoleName;
  status: UserRoleStatusName;
};

export type RoleReview = {
  __typename?: 'RoleReview';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  reviewBy: Maybe<Scalars['String']['output']>;
  role: UserRoleName;
  status: Scalars['String']['output'];
  userId: Scalars['UUID']['output'];
};

export type RoleStatus = {
  __typename?: 'RoleStatus';
  role: Role;
  status: UserRoleStatusName;
};

export type RollupAllPhaseResultsInput = {
  phaseId: Scalars['UUID']['input'];
};

export type RollupFortnitePhaseStatsPayload = {
  __typename?: 'RollupFortnitePhaseStatsPayload';
  phase: Maybe<Phase>;
  phaseId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type RollupPhaseResultsInput = {
  phaseId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type Roster = {
  __typename?: 'Roster';
  coaches: Maybe<Array<User>>;
  players: Maybe<Array<User>>;
};

export type RunBulkActionInput = {
  bulkAction: BulkActionOption;
  spreadsheetId: Scalars['String']['input'];
  spreadsheetNameRange: Scalars['String']['input'];
};

export type SalesRep = {
  __typename?: 'SalesRep';
  calendarLink: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SameSchoolTeamsInSeasonResult = {
  __typename?: 'SameSchoolTeamsInSeasonResult';
  seasonTeams: Array<Maybe<SeasonTeams>>;
};

export type SaveGameResultInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  gameOrdinalNumber: Scalars['Int']['input'];
  incompleteReason?: InputMaybe<GameIncompleteReason>;
  isIncomplete: Scalars['Boolean']['input'];
  losingPlayerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  losingTeamId: Scalars['UUID']['input'];
  losingTeamScore?: InputMaybe<Scalars['Int']['input']>;
  matchId: Scalars['UUID']['input'];
  requestRosterChangeForNextGame?: InputMaybe<Scalars['Boolean']['input']>;
  requestedById: Scalars['UUID']['input'];
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
  seriesOrdinalNumber?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
  winningPlayerIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  winningTeamId: Scalars['UUID']['input'];
  winningTeamScore?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveMatchNotesInput = {
  id: Scalars['UUID']['input'];
  notes: Scalars['String']['input'];
};

export type SaveSurveyInput = {
  questions: Array<Question>;
  surveyType: SurveyType;
  userId: Scalars['String']['input'];
};

export type SaveSurveySchemaInput = {
  schemaJson: Scalars['String']['input'];
  trigger: SurveyTrigger;
  triggerEntityId: Scalars['UUID']['input'];
  triggerEntityType: SurveyTriggerEntityType;
};

export type ScheduleConsultationEmailPayload = {
  __typename?: 'ScheduleConsultationEmailPayload';
  success: Scalars['Boolean']['output'];
};

export type ScheduleEvent = {
  startsAt: Scalars['DateTime']['output'];
  type: ScheduleEventType;
};

export enum ScheduleEventType {
  ExcludedSlot = 'excluded_slot',
  PendingSlot = 'pending_slot',
  ScheduledSlot = 'scheduled_slot',
  ScrimmageMatch = 'scrimmage_match'
}

export type ScheduleEventWithMatch = {
  match: Match;
  startsAt: Scalars['DateTime']['output'];
  type: ScheduleEventType;
};

export type ScheduleEventWithSlot = {
  slot: Slot;
  startsAt: Scalars['DateTime']['output'];
  type: ScheduleEventType;
};

export type ScheduleMatchInput = {
  generateRandomMatchResults?: InputMaybe<Scalars['Boolean']['input']>;
  isScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
  matchPairingId?: InputMaybe<Scalars['UUID']['input']>;
  matchSlotId?: InputMaybe<Scalars['UUID']['input']>;
  scheduleAt?: InputMaybe<Scalars['DateTime']['input']>;
  slotId: Scalars['UUID']['input'];
  teamIds: Array<Scalars['UUID']['input']>;
};

export type ScheduleMatchesInput = {
  generateRandomMatchResults?: InputMaybe<Scalars['Boolean']['input']>;
  isScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
  matchPairingId?: InputMaybe<Scalars['UUID']['input']>;
  matchSlotId?: InputMaybe<Scalars['UUID']['input']>;
  numberOfChatMessages?: InputMaybe<Scalars['Int']['input']>;
  numberOfMatches: Scalars['Int']['input'];
  scheduleAt?: InputMaybe<Scalars['DateTime']['input']>;
  slotId: Scalars['UUID']['input'];
  teamIds: Array<Scalars['UUID']['input']>;
};

export type ScheduleMatchesPayload = {
  __typename?: 'ScheduleMatchesPayload';
  jobIds: Array<Scalars['UUID']['output']>;
};

export type ScheduleNextBracketMatchInput = {
  matchId: Scalars['UUID']['input'];
  phaseId: Scalars['UUID']['input'];
};

export type SchedulePageQueueMatch = {
  __typename?: 'SchedulePageQueueMatch';
  bestOf: Scalars['Int']['output'];
  esport: Maybe<Esport>;
  esportId: Maybe<Scalars['UUID']['output']>;
  isScrimmage: Scalars['Boolean']['output'];
  scheduleContext: MatchScheduleContext;
  scheduledStartsAt: Scalars['DateTime']['output'];
  slot: Maybe<Slot>;
  slotId: Scalars['UUID']['output'];
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
};

export type SchedulePhaseMatchesInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreSlotStatus?: InputMaybe<Scalars['Boolean']['input']>;
  phaseId: Scalars['UUID']['input'];
  rankingArgs?: InputMaybe<PairingRankingInput>;
  seasonId: Scalars['UUID']['input'];
  slotIds: Array<Scalars['UUID']['input']>;
};

export type ScheduleQueryBounds = {
  maxStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  minStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduleTeam = {
  __typename?: 'ScheduleTeam';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type ScheduledAndQueueMatchesByTeamIdsInput = {
  esportId?: InputMaybe<Scalars['UUID']['input']>;
  pageLimit: Scalars['Int']['input'];
  queueMatchesOffset: Scalars['Int']['input'];
  scheduledMatchesOffset: Scalars['Int']['input'];
  scheduledStartsAtRange: RequiredDateRange;
  teamIds: Array<Scalars['UUID']['input']>;
};

export type ScheduledAndQueueMatchesByTeamIdsResults = {
  __typename?: 'ScheduledAndQueueMatchesByTeamIdsResults';
  queueMatches: Array<SchedulePageQueueMatch>;
  queueMatchesOffset: Scalars['Int']['output'];
  scheduledMatches: Array<Match>;
  scheduledMatchesOffset: Scalars['Int']['output'];
  totalQueueMatches: Scalars['Int']['output'];
  totalScheduledMatches: Scalars['Int']['output'];
};

export type ScheduledSlotEvent = ScheduleEvent & ScheduleEventWithMatch & ScheduleEventWithSlot & {
  __typename?: 'ScheduledSlotEvent';
  match: Match;
  slot: Slot;
  startsAt: Scalars['DateTime']['output'];
  type: ScheduleEventType;
};

/** A high school */
export type School = {
  __typename?: 'School';
  activeCampaign: Maybe<SponsorshipCampaign>;
  activePlayoffTeams: Maybe<Array<Team>>;
  address: Maybe<Scalars['String']['output']>;
  allowCaptainEnrollment: Maybe<Scalars['Boolean']['output']>;
  allowPlayerLedTeams: Maybe<Scalars['Boolean']['output']>;
  annualPassInstances: Array<AnnualPassInstance>;
  annualPassProductsEligible: Maybe<Array<RankedAnnualPassProduct>>;
  archivedPlayers: Maybe<Array<User>>;
  availableLeagueEsports: Array<Esport>;
  availableScrimmageRequests: Maybe<ScrimmageRequestResult>;
  billingContact: Maybe<SchoolBillingContact>;
  city: Maybe<Scalars['String']['output']>;
  coachRolePendingUsers: Maybe<Array<User>>;
  coaches: Maybe<Array<User>>;
  competitionGroup: Maybe<CompetitionGroup>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deniedCoaches: Maybe<Array<User>>;
  deniedPlayers: Maybe<Array<User>>;
  detail: Maybe<SchoolDetail>;
  dismissalTime: Maybe<Scalars['String']['output']>;
  districtClassification: Maybe<Scalars['String']['output']>;
  eligibleVarsityAssociations: Array<VarsityAssociation>;
  enrollments: Maybe<Array<SchoolEnrollment>>;
  getCurrentMetaseason: Maybe<Metaseason>;
  getLatestEnrolledMetaseason: Maybe<Metaseason>;
  gradeHigh: Maybe<Scalars['String']['output']>;
  gradeLow: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lat: Maybe<Scalars['Float']['output']>;
  leagueGroups: Array<LeagueGroup>;
  logoUrl: Maybe<Scalars['String']['output']>;
  lon: Maybe<Scalars['Float']['output']>;
  mascotName: Maybe<Scalars['String']['output']>;
  matchesWithMissingResults: Maybe<Array<Match>>;
  myScrimmageRequests: Maybe<ScrimmageRequestResult>;
  name: Maybe<Scalars['String']['output']>;
  ncesId: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  playerCount: Maybe<Scalars['Int']['output']>;
  playerRolePendingUsers: Maybe<Array<User>>;
  players: Maybe<Array<User>>;
  publicIp: Maybe<Scalars['String']['output']>;
  rosterAcrossAllTeams: Maybe<Roster>;
  salesRep: Maybe<SalesRep>;
  schoolProviderAccounts: Maybe<Array<SchoolProviderAccount>>;
  schoolVarsityAssociation: Maybe<SchoolVarsityAssociation>;
  /** @deprecated No longer supported */
  seasonPassProductsEligible: Maybe<Array<SeasonPassProduct>>;
  sheeridOrganizationId: Maybe<Scalars['Int']['output']>;
  sheeridOrganizationName: Maybe<Scalars['String']['output']>;
  showCoachEmails: Maybe<Scalars['Boolean']['output']>;
  slotExclusionWindows: Maybe<Array<SlotExclusionWindow>>;
  /** Unique public identifier as used in stable URLs referring to this school */
  slug: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use playerRolePendingUsers instead */
  students: Maybe<Array<User>>;
  submissions: Maybe<Array<UserSchoolSubmission>>;
  teams: Maybe<Array<Team>>;
  /** @deprecated No longer supported */
  teamsByFilter: Maybe<Array<Team>>;
  teamsIncludingDeleted: Maybe<Array<Team>>;
  timezone: Maybe<Scalars['String']['output']>;
  twitchUrl: Maybe<Scalars['String']['output']>;
  twitchUsername: Maybe<Scalars['String']['output']>;
  type: Maybe<SchoolType>;
  upcomingMatches: Maybe<UpcomingMatchResult>;
  users: Maybe<Array<User>>;
  varsityAssociations: Array<VarsityAssociation>;
  verified: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer supported */
  verifiedPlayerCount: Maybe<Scalars['Int']['output']>;
  website: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  whoPays: Maybe<WhoPays>;
  zip: Maybe<Scalars['String']['output']>;
};


/** A high school */
export type SchoolAnnualPassInstancesArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


/** A high school */
export type SchoolAvailableScrimmageRequestsArgs = {
  filter?: InputMaybe<ScrimmageRequestFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A high school */
export type SchoolEnrollmentsArgs = {
  metaseasonIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


/** A high school */
export type SchoolLeagueGroupsArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


/** A high school */
export type SchoolLogoUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** A high school */
export type SchoolMatchesWithMissingResultsArgs = {
  excludeBefore?: InputMaybe<Scalars['DateTime']['input']>;
};


/** A high school */
export type SchoolMyScrimmageRequestsArgs = {
  filter?: InputMaybe<ScrimmageRequestFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  past?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A high school */
export type SchoolSchoolVarsityAssociationArgs = {
  varsityAssociationSlug: Scalars['String']['input'];
};


/** A high school */
export type SchoolSeasonPassProductsEligibleArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


/** A high school */
export type SchoolSlotExclusionWindowsArgs = {
  bounds?: InputMaybe<DateRangeInput>;
};


/** A high school */
export type SchoolTeamsByFilterArgs = {
  esportId?: InputMaybe<Scalars['UUID']['input']>;
  filters?: InputMaybe<SchoolTeamFiltersInput>;
};


/** A high school */
export type SchoolUpcomingMatchesArgs = {
  filters?: InputMaybe<UpcomingMatchInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolBillingContact = {
  __typename?: 'SchoolBillingContact';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<User>;
  createdById: Scalars['UUID']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  organizationRole: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
  phoneExt: Maybe<Scalars['String']['output']>;
  schoolId: Scalars['UUID']['output'];
  state: Maybe<Scalars['String']['output']>;
  user: Maybe<BillingUser>;
  userId: Maybe<Scalars['UUID']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};

export type SchoolBillingContactInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationRole: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolDetail = {
  __typename?: 'SchoolDetail';
  at: Maybe<Scalars['String']['output']>;
  it: Maybe<ItDetails>;
  school: Maybe<Scalars['String']['output']>;
  schoolInfo: Maybe<SchoolInfo>;
};

export type SchoolDetailInput = {
  at?: InputMaybe<Scalars['String']['input']>;
  it?: InputMaybe<ItDetailsInput>;
  school?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
  schoolInfo?: InputMaybe<SchoolInfoInput>;
};

export type SchoolEnrollableSeasonsPayload = {
  __typename?: 'SchoolEnrollableSeasonsPayload';
  seasons: Array<Season>;
};

export type SchoolEnrollment = {
  __typename?: 'SchoolEnrollment';
  contractEndDate: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  metaseason: Metaseason;
  metaseasonId: Scalars['String']['output'];
  product: Maybe<AnnualPassProduct>;
  productId: Maybe<Scalars['String']['output']>;
  school: School;
  schoolId: Scalars['String']['output'];
  seatCount: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SchoolEnrollmentInput = {
  metaseasonId: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
  seatCount?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolEnrollmentPayload = {
  __typename?: 'SchoolEnrollmentPayload';
  annualPassInstance: Maybe<AnnualPassInstance>;
  annualPassInstanceId: Scalars['UUID']['output'];
};

export type SchoolFiltersInput = {
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  geolocation?: InputMaybe<Geolocation>;
  hasTeamsEnrolledInCurrentMetaseason?: InputMaybe<Scalars['Boolean']['input']>;
  hasVarsityAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  hasVerifiedCoach?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ncesId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  submittedAfter?: InputMaybe<Scalars['String']['input']>;
  submittedBefore?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SchoolType>;
  varsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolFortniteMatchResultMessage = ISchoolMessage & {
  __typename?: 'SchoolFortniteMatchResultMessage';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  esportSlug: Scalars['String']['output'];
  /** @deprecated Please use getResourceImage instead */
  homeSchoolLogoUrl: Maybe<Scalars['String']['output']>;
  homeTeamId: Scalars['UUID']['output'];
  homeTeamName: Scalars['String']['output'];
  isPinned: Maybe<Scalars['Boolean']['output']>;
  leagueName: Scalars['String']['output'];
  linkImageUrl: Maybe<Scalars['String']['output']>;
  linkTitle: Maybe<Scalars['String']['output']>;
  linkUrl: Maybe<Scalars['String']['output']>;
  matchId: Scalars['UUID']['output'];
  message: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  rankOutOf: Scalars['Int']['output'];
  school: Maybe<School>;
  title: Maybe<Scalars['String']['output']>;
};


export type SchoolFortniteMatchResultMessageHomeSchoolLogoUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolInfo = {
  __typename?: 'SchoolInfo';
  advisor: Maybe<AdvisorDetail>;
  isAdvisor: Maybe<Scalars['Boolean']['output']>;
  studentActivityFundingOpts: Maybe<StudentActivityFunding>;
};

export type SchoolInfoInput = {
  advisor?: InputMaybe<AdvisorDetailInput>;
  isAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  studentActivityFundingOpts?: InputMaybe<StudentActivityFundingInput>;
};

export type SchoolInvoiceDataPayload = {
  __typename?: 'SchoolInvoiceDataPayload';
  dateDue: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber: Scalars['String']['output'];
  invoiceStatus: Maybe<InvoiceStatus>;
  issueDate: Maybe<Scalars['DateTime']['output']>;
  paidStatus: InvoicePayStatus;
  referenceId: Scalars['String']['output'];
  seasonName: Scalars['String']['output'];
  totalAmount: Scalars['String']['output'];
};

export enum SchoolLeagueEnrollmentStatus {
  Active = 'active',
  Available = 'available',
  Past = 'past'
}

export type SchoolLeagueGroupsPayload = {
  __typename?: 'SchoolLeagueGroupsPayload';
  leagueGroupIds: Array<Scalars['UUID']['output']>;
  leagueGroups: Maybe<Array<Maybe<LeagueGroup>>>;
  schoolIds: Array<Scalars['UUID']['output']>;
  schools: Maybe<Array<Maybe<School>>>;
  success: Scalars['Boolean']['output'];
};

export type SchoolLeagueOptions = {
  forceUnenrollPlayers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchoolMessage = {
  __typename?: 'SchoolMessage';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isPinned: Maybe<Scalars['Boolean']['output']>;
  linkImageUrl: Maybe<Scalars['String']['output']>;
  linkTitle: Maybe<Scalars['String']['output']>;
  linkUrl: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  school: Maybe<School>;
  title: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type SchoolMessageTypeUnion = SchoolFortniteMatchResultMessage | SchoolOneOnOneMatchResultMessage | SchoolUserMessage;

export type SchoolOneOnOneMatchResultMessage = ISchoolMessage & {
  __typename?: 'SchoolOneOnOneMatchResultMessage';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  esportSlug: Scalars['String']['output'];
  /** @deprecated Please use getResourceImage instead */
  homeSchoolLogoUrl: Maybe<Scalars['String']['output']>;
  homeTeamGamesLost: Scalars['Int']['output'];
  homeTeamGamesWon: Scalars['Int']['output'];
  homeTeamId: Scalars['UUID']['output'];
  homeTeamName: Scalars['String']['output'];
  isPinned: Maybe<Scalars['Boolean']['output']>;
  leagueName: Scalars['String']['output'];
  linkImageUrl: Maybe<Scalars['String']['output']>;
  linkTitle: Maybe<Scalars['String']['output']>;
  linkUrl: Maybe<Scalars['String']['output']>;
  matchId: Scalars['UUID']['output'];
  message: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use getResourceImage instead */
  opposingSchoolLogoUrl: Maybe<Scalars['String']['output']>;
  opposingTeamId: Scalars['UUID']['output'];
  opposingTeamName: Scalars['String']['output'];
  school: Maybe<School>;
  title: Maybe<Scalars['String']['output']>;
};


export type SchoolOneOnOneMatchResultMessageHomeSchoolLogoUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type SchoolOneOnOneMatchResultMessageOpposingSchoolLogoUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolPayload = {
  __typename?: 'SchoolPayload';
  school: Maybe<School>;
  schoolId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type SchoolPlayerCountsResult = {
  __typename?: 'SchoolPlayerCountsResult';
  total: Maybe<Scalars['Int']['output']>;
};

export enum SchoolProvider {
  DiscordSchool = 'DiscordSchool',
  TwitchSchool = 'TwitchSchool',
  YoutubeSchool = 'YoutubeSchool'
}

export type SchoolProviderAccount = {
  __typename?: 'SchoolProviderAccount';
  id: Scalars['UUID']['output'];
  providerAccountId: Scalars['String']['output'];
  providerDisplayName: Scalars['String']['output'];
  providerIntegrationType: IntegrationType;
  providerName: Scalars['String']['output'];
  schoolId: Scalars['UUID']['output'];
};

export type SchoolProviderAccountsForSchoolInput = {
  schoolId: Scalars['UUID']['input'];
};

export type SchoolSearchResult = {
  __typename?: 'SchoolSearchResult';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  schoolId: Scalars['String']['output'];
  searchScore: Scalars['Float']['output'];
  state: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  zip: Maybe<Scalars['String']['output']>;
};


export type SchoolSearchResultLogoUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolSearchResults = {
  __typename?: 'SchoolSearchResults';
  results: Maybe<Array<School>>;
};

export type SchoolSeasonEnrollmentSummaryPayload = {
  __typename?: 'SchoolSeasonEnrollmentSummaryPayload';
  earliestEnrolledAt: Maybe<Scalars['DateTime']['output']>;
};

export type SchoolTeamFiltersInput = {
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  esportId?: InputMaybe<Scalars['UUID']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCurrentlyEnrolled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SchoolType {
  College = 'college',
  HighSchool = 'highSchool',
  MiddleSchool = 'middleSchool'
}

export type SchoolUserMessage = ISchoolMessage & {
  __typename?: 'SchoolUserMessage';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isPinned: Maybe<Scalars['Boolean']['output']>;
  linkImageUrl: Maybe<Scalars['String']['output']>;
  linkTitle: Maybe<Scalars['String']['output']>;
  linkUrl: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  school: Maybe<School>;
  title: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type SchoolVarsityAssociation = {
  __typename?: 'SchoolVarsityAssociation';
  createdAt: Scalars['DateTime']['output'];
  schoolId: Scalars['UUID']['output'];
  varsityAssociationSlug: Scalars['String']['output'];
};

export type SchoolsResult = {
  __typename?: 'SchoolsResult';
  schools: Maybe<Array<School>>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type Score = {
  __typename?: 'Score';
  esportId: Maybe<Scalars['UUID']['output']>;
  gameId: Maybe<Scalars['UUID']['output']>;
  leagueId: Maybe<Scalars['UUID']['output']>;
  matchId: Maybe<Scalars['UUID']['output']>;
  metaseasonId: Maybe<Scalars['UUID']['output']>;
  phaseId: Maybe<Scalars['UUID']['output']>;
  score: Maybe<Scalars['Int']['output']>;
  seasonId: Maybe<Scalars['UUID']['output']>;
  teamId: Maybe<Scalars['UUID']['output']>;
};

export type ScrimmageMatchEvent = ScheduleEvent & ScheduleEventWithMatch & {
  __typename?: 'ScrimmageMatchEvent';
  match: Match;
  startsAt: Scalars['DateTime']['output'];
  type: ScheduleEventType;
};

export type ScrimmageQueueStatePayload = {
  __typename?: 'ScrimmageQueueStatePayload';
  matchId: Maybe<Scalars['String']['output']>;
  opponentTeamId: Maybe<Scalars['String']['output']>;
  status: QueueStatus;
};

export type ScrimmageQueueUpdateSubscribeInput = {
  teamId: Scalars['UUID']['input'];
};

export type ScrimmageQueueUpdateSubscribePayload = {
  __typename?: 'ScrimmageQueueUpdateSubscribePayload';
  currentState: ScrimmageQueueStatePayload;
};

export type ScrimmageRequest = {
  __typename?: 'ScrimmageRequest';
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  acceptedBy: Maybe<User>;
  acceptedById: Maybe<Scalars['UUID']['output']>;
  allowAutoSchedule: Maybe<Scalars['Boolean']['output']>;
  bestOf: Maybe<Scalars['Int']['output']>;
  canceledAt: Maybe<Scalars['DateTime']['output']>;
  canceledBy: Maybe<User>;
  canceledById: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  esport: Maybe<Esport>;
  esportId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isAdminScheduled: Maybe<Scalars['Boolean']['output']>;
  isAutoGenerated: Maybe<Scalars['Boolean']['output']>;
  isPublic: Maybe<Scalars['Boolean']['output']>;
  league: Maybe<League>;
  match: Maybe<Match>;
  matchId: Maybe<Scalars['UUID']['output']>;
  myAvailableTeams: Maybe<Array<Team>>;
  opposingTeam: Maybe<Team>;
  opposingTeamId: Maybe<Scalars['UUID']['output']>;
  opposingTeamTimezone: Maybe<Scalars['String']['output']>;
  rating: Maybe<Scalars['String']['output']>;
  requestedBy: Maybe<User>;
  requestedById: Scalars['UUID']['output'];
  requestingTeam: Maybe<Team>;
  requestingTeamId: Scalars['UUID']['output'];
  requestingTeamTimezone: Maybe<Scalars['String']['output']>;
  seriesBestOf: Maybe<Scalars['Int']['output']>;
  startsAt: Scalars['DateTime']['output'];
  status: ScrimmageRequestStatus;
};


export type ScrimmageRequestMyAvailableTeamsArgs = {
  schoolId: Scalars['UUID']['input'];
};

export type ScrimmageRequestFilter = {
  competitionGroups?: InputMaybe<Array<CompetitionGroup>>;
  dayOfWeek?: InputMaybe<DayOfWeek>;
  esportSlugs?: InputMaybe<Array<Scalars['EsportSlug']['input']>>;
  leagueNames?: InputMaybe<Array<Scalars['String']['input']>>;
  matchStatuses?: InputMaybe<Array<MatchStatus>>;
  maxDisplayDays?: InputMaybe<Scalars['Int']['input']>;
  ratings?: InputMaybe<Array<Scalars['String']['input']>>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<ScrimmageRequestStartsAtRange>;
  states?: InputMaybe<Array<UsStateCode>>;
  statuses?: InputMaybe<Array<ScrimmageRequestStatus>>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<ScrimmageRequestTimeFilter>;
};

export type ScrimmageRequestResult = {
  __typename?: 'ScrimmageRequestResult';
  result: Maybe<Array<ScrimmageRequest>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type ScrimmageRequestStartsAtRange = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
};

export enum ScrimmageRequestStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  Declined = 'declined',
  NeedsOpponent = 'needsOpponent',
  NoResponse = 'noResponse',
  Processed = 'processed',
  Requested = 'requested',
  Scheduled = 'scheduled'
}

export enum ScrimmageRequestTimeFilter {
  All = 'all',
  Future = 'future',
  Past = 'past'
}

export type SearchAllUsersInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<ProviderFilterInput>;
  roleNames?: InputMaybe<Array<UserRoleName>>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum SearchIndex {
  Matches = 'matches',
  Schools = 'schools',
  Teams = 'teams'
}

export type SearchOptions = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderby?: InputMaybe<Array<OrderByOptions>>;
};

export type SearchSchoolsQuery = {
  nameQuery: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SearchSchoolsResults = {
  __typename?: 'SearchSchoolsResults';
  results: Maybe<Array<SchoolSearchResult>>;
};

/** A season within a league defining a period during which phases of tournament play happen */
export type Season = {
  __typename?: 'Season';
  activePhases: Maybe<Array<Phase>>;
  allPhases: Maybe<Array<Phase>>;
  allTeamMatches: Maybe<Array<Match>>;
  /** More detailed information used to introduce/describe the season */
  areBreakWeekSlotExclusionWindowsEnabled: Scalars['Boolean']['output'];
  currentPhase: Maybe<Phase>;
  /** @deprecated No longer supported */
  deregistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  description: Maybe<Scalars['String']['output']>;
  endsAt: Scalars['DateTime']['output'];
  enrollmentStatus: Maybe<SeasonEnrollmentStatus>;
  eventConfig: Maybe<EventConfig>;
  /** A heading used to introduce/describe the season */
  heading: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  league: Maybe<League>;
  leagueId: Scalars['UUID']['output'];
  maxTeamsPerSchool: Maybe<Scalars['Int']['output']>;
  /** Seasons from different leagues can all belong to a general/meta grouping for example a Spring meta season could have Georgia Rocket League Season and a Alaska League of Legends season */
  metaseason: Maybe<Metaseason>;
  metaseasonId: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  /** number of pending teams in a season */
  numberOfPendingTeams: Maybe<Scalars['Int']['output']>;
  /** number of enrolled playerrs in a season */
  numberOfPlayers: Maybe<Scalars['Int']['output']>;
  /** number of enrolled teams in a season */
  numberOfTeams: Maybe<Scalars['Int']['output']>;
  numberOfTeamsByStates: Maybe<Array<NumberOfTeamsInSeasonByStateResult>>;
  numberOfTeamsByVarsityAssociations: Maybe<Array<NumberOfTeamsInSeasonByVarsityAssociationResult>>;
  overridePlayoffGenerationDate: Maybe<Scalars['DateTime']['output']>;
  overridePlayoffSeedingDate: Maybe<Scalars['DateTime']['output']>;
  phases: Maybe<Array<Phase>>;
  playerDeregistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  playerEnrollableTeams: Maybe<Array<Team>>;
  /** This is the ISO date time when registration closes, after which players can no longer register for the season */
  playerRegistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  playvsScoreEnabled: Scalars['Boolean']['output'];
  /**
   * This is the ISO date time when registration closes, after which teams can no longer register for the season
   * @deprecated No longer supported
   */
  registrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  /** This is the ISO date time when registration/signup for the season starts */
  registrationStartsAt: Scalars['DateTime']['output'];
  /** Indicates when the season becomes roster locked after which no more changes to teams are possible */
  rostersLockAt: Maybe<Scalars['DateTime']['output']>;
  seasonPlayoffTemplateId: Maybe<Scalars['String']['output']>;
  slotExclusionRangeConfigurations: Maybe<Array<SlotExclusionRangeConfiguration>>;
  /** A unique, URL-safe idenentifier for this season */
  slug: Scalars['String']['output'];
  sponsorshipImages: Maybe<Array<SponsorshipImage>>;
  startsAt: Scalars['DateTime']['output'];
  status: SeasonStatus;
  /** This is the ISO date time when marketing suggests registration closes, this is not enforced. */
  suggestedRegistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  teamDeregistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  teamMatches: Maybe<Array<Match>>;
  teamRegistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  teams: Maybe<Array<Team>>;
  type: Maybe<SeasonType>;
  userMatchCount: Maybe<Scalars['Int']['output']>;
  weeklySlotDateEstimate: Maybe<WeeklySlotDateEstimate>;
};


/** A season within a league defining a period during which phases of tournament play happen */
export type SeasonAllTeamMatchesArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SeasonTeamMatchSort>;
  teamIds: Array<Scalars['UUID']['input']>;
};


/** A season within a league defining a period during which phases of tournament play happen */
export type SeasonTeamMatchesArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SeasonTeamMatchSort>;
  teamId: Scalars['UUID']['input'];
};


/** A season within a league defining a period during which phases of tournament play happen */
export type SeasonUserMatchCountArgs = {
  userId: Scalars['UUID']['input'];
};


/** A season within a league defining a period during which phases of tournament play happen */
export type SeasonWeeklySlotDateEstimateArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type SeasonConfig = {
  areBreakWeekSlotExclusionWindowsEnabled: Scalars['Boolean']['input'];
  deregistrationEndDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  heroBackgroundUrl?: InputMaybe<Scalars['String']['input']>;
  heroText?: InputMaybe<Scalars['String']['input']>;
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  phases: Array<CreatePhaseAttributes>;
  playerDeregistrationEndsAt?: InputMaybe<Scalars['String']['input']>;
  playerRegistrationEndsAt?: InputMaybe<Scalars['String']['input']>;
  registrationEndDate: Scalars['String']['input'];
  registrationStartDate: Scalars['String']['input'];
  rosterLockDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  status?: InputMaybe<SeasonStatus>;
  suggestedRegistrationEndsAt?: InputMaybe<Scalars['String']['input']>;
  teamDeregistrationEndDate?: InputMaybe<Scalars['String']['input']>;
  teamRegistrationEndDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SeasonType>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SeasonDatesTemplate = {
  __typename?: 'SeasonDatesTemplate';
  endsAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  playerDeregistrationEndsAt: Scalars['DateTime']['output'];
  playerRegistrationEndsAt: Scalars['DateTime']['output'];
  registrationStartsAt: Scalars['DateTime']['output'];
  rostersLockAt: Scalars['DateTime']['output'];
  startsAt: Scalars['DateTime']['output'];
  suggestedRegistrationEndsAt: Scalars['DateTime']['output'];
  teamDeregistrationEndsAt: Scalars['DateTime']['output'];
  teamRegistrationEndsAt: Scalars['DateTime']['output'];
};

export type SeasonDatesTemplateInput = {
  endsAt: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  playerDeregistrationEndsAt: Scalars['DateTime']['input'];
  playerRegistrationEndsAt: Scalars['DateTime']['input'];
  registrationStartsAt: Scalars['DateTime']['input'];
  rostersLockAt: Scalars['DateTime']['input'];
  slotExclusionRangeConfigurations?: InputMaybe<Array<SeasonUpdateOrCreateSlotExclusionRangeConfigurationInput>>;
  startsAt: Scalars['DateTime']['input'];
  suggestedRegistrationEndsAt: Scalars['DateTime']['input'];
  teamDeregistrationEndsAt: Scalars['DateTime']['input'];
  teamRegistrationEndsAt: Scalars['DateTime']['input'];
};

export enum SeasonEnrollmentStatus {
  Inactive = 'inactive',
  Pending = 'pending',
  Ready = 'ready'
}

export type SeasonJobPayload = {
  __typename?: 'SeasonJobPayload';
  jobId: Scalars['UUID']['output'];
};

export type SeasonPassAllotmentInput = {
  allotmentPerBundle: Scalars['Int']['input'];
};

export type SeasonPassBundle = {
  __typename?: 'SeasonPassBundle';
  metaseason: Maybe<Metaseason>;
  metaseasonId: Scalars['UUID']['output'];
};

export type SeasonPassProduct = ISeasonPassProduct & {
  __typename?: 'SeasonPassProduct';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  internalName: Maybe<Scalars['String']['output']>;
  isAdminOnly: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceUsd: Scalars['Float']['output'];
  seatCount: Maybe<Scalars['Int']['output']>;
  sku: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  type: ProductType;
};

export type SeasonPlayoffTemplate = {
  __typename?: 'SeasonPlayoffTemplate';
  generationDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phase: Phase;
  phaseId: Scalars['String']['output'];
  seasonPlayoffTemplateBestOfs: Array<SeasonPlayoffTemplateBestOf>;
  seedingDate: Maybe<Scalars['DateTime']['output']>;
};

export type SeasonPlayoffTemplateBestOf = {
  __typename?: 'SeasonPlayoffTemplateBestOf';
  bestOf: Scalars['Int']['output'];
  esport: Esport;
  esportId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type SeasonPlayoffTemplateBestOfCreateAttributes = {
  bestOf: Scalars['Int']['input'];
  esportId: Scalars['String']['input'];
};

export type SeasonPlayoffTemplateBestOfUpdateAttributes = {
  bestOf?: InputMaybe<Scalars['Int']['input']>;
  esportId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type SeasonPlayoffTemplateInsertAttributes = {
  generationDate: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  phase: CreatePhaseInput;
  seasonPlayoffTemplateBestOfs: Array<SeasonPlayoffTemplateBestOfCreateAttributes>;
  seedingDate?: InputMaybe<Scalars['DateTime']['input']>;
  slots: Array<SeasonPlayoffTemplateSlotCreateAttributes>;
};

export type SeasonPlayoffTemplateSlotCreateAttributes = {
  bestOf: Scalars['Int']['input'];
  fortniteEventWindowId?: InputMaybe<Scalars['String']['input']>;
  isStartsAtHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  scheduleMatchesAt?: InputMaybe<Scalars['DateTime']['input']>;
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  startsAt: Scalars['DateTime']['input'];
  status?: InputMaybe<SlotStatus>;
};

export type SeasonPlayoffTemplateSlotUpdateAttributes = {
  bestOf: Scalars['Int']['input'];
  fortniteEventWindowId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isStartsAtHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  scheduleMatchesAt?: InputMaybe<Scalars['DateTime']['input']>;
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  startsAt: Scalars['DateTime']['input'];
  status?: InputMaybe<SlotStatus>;
};

export type SeasonPlayoffTemplateUpdateAttributes = {
  generationDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phase?: InputMaybe<UpdatePhaseInput>;
  seasonPlayoffTemplateBestOfs?: InputMaybe<Array<SeasonPlayoffTemplateBestOfUpdateAttributes>>;
  seedingDate?: InputMaybe<Scalars['DateTime']['input']>;
  slots?: InputMaybe<Array<SeasonPlayoffTemplateSlotUpdateAttributes>>;
};

export type SeasonSchedule = {
  __typename?: 'SeasonSchedule';
  areBreakWeekSlotExclusionWindowsEnabled: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  endsAt: Scalars['DateTime']['output'];
  leagueId: Scalars['UUID']['output'];
  maxTeamsPerSchool: Maybe<Scalars['Int']['output']>;
  metaseasonId: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  overridePlayoffGenerationDate: Maybe<Scalars['DateTime']['output']>;
  overridePlayoffSeedingDate: Maybe<Scalars['DateTime']['output']>;
  phases: Maybe<Array<PhaseAttributes>>;
  playerDeregistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  playerRegistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  registrationStartsAt: Scalars['DateTime']['output'];
  rostersLockAt: Maybe<Scalars['DateTime']['output']>;
  seasonPlayoffTemplateId: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  status: SeasonStatus;
  suggestedRegistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  teamDeregistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  teamRegistrationEndsAt: Maybe<Scalars['DateTime']['output']>;
  type: Maybe<SeasonType>;
};

export type SeasonScheduleInput = {
  areBreakWeekSlotExclusionWindowsEnabled: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  endsAt: Scalars['DateTime']['input'];
  eventConfig?: InputMaybe<EventConfigInput>;
  leagueId: Scalars['UUID']['input'];
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  overridePlayoffGenerationDate?: InputMaybe<Scalars['DateTime']['input']>;
  overridePlayoffSeedingDate?: InputMaybe<Scalars['DateTime']['input']>;
  phases?: InputMaybe<Array<PhaseScheduleInput>>;
  playerDeregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  playerRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  playvsScoreEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStartsAt: Scalars['DateTime']['input'];
  rostersLockAt?: InputMaybe<Scalars['DateTime']['input']>;
  seasonPlayoffTemplateId?: InputMaybe<Scalars['String']['input']>;
  slotExclusionRangeConfigurations?: InputMaybe<Array<CreateSlotExclusionRangeConfigurationInput>>;
  slug: Scalars['String']['input'];
  startsAt: Scalars['DateTime']['input'];
  status: SeasonStatus;
  suggestedRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamDeregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<SeasonType>;
};

export enum SeasonStatus {
  Active = 'active',
  Draft = 'draft'
}

export type SeasonTeam = {
  __typename?: 'SeasonTeam';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  leagueId: Scalars['UUID']['output'];
  metaseasonId: Maybe<Scalars['UUID']['output']>;
  season: Maybe<Season>;
  seasonId: Scalars['UUID']['output'];
  teamId: Scalars['UUID']['output'];
};

export enum SeasonTeamMatchSort {
  Asc = 'asc',
  Desc = 'desc'
}

export type SeasonTeams = {
  __typename?: 'SeasonTeams';
  seasonId: Scalars['UUID']['output'];
  teams: Maybe<Array<Maybe<TeamSchool>>>;
};

export enum SeasonType {
  Season = 'season',
  Tournament = 'tournament'
}

/** Deprecated - Please use UpdateSeasonScheduleInput */
export type SeasonUpdateAttributes = {
  deregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  playerDeregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  playerRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  registrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  registrationStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  rostersLockAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SeasonStatus>;
  suggestedRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamDeregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SeasonUpdateOrCreateSlotExclusionRangeConfigurationInput = {
  attributes: CreateSlotExclusionRangeConfigurationInput;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type SeasonValidityResult = {
  __typename?: 'SeasonValidityResult';
  errors: Maybe<Array<VsError>>;
  value: Scalars['Boolean']['output'];
};

export type SeasonalPlayerAwardType = {
  __typename?: 'SeasonalPlayerAwardType';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  templatePdfUrl: Scalars['String']['output'];
  templateSharableImageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type SeedPhaseTeamsInput = {
  phaseId: Scalars['UUID']['input'];
  rankingArgs: PairingRankingInput;
  seasonId: Scalars['UUID']['input'];
};

export type SeededTeam = ITeam & {
  __typename?: 'SeededTeam';
  /** @deprecated use enrolledSeasons */
  allSeasons: Maybe<Array<Season>>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  captain: Maybe<User>;
  coaches: Maybe<Array<TeamCoach>>;
  competitionGroup: Maybe<CompetitionGroup>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Scalars['UUID']['output']>;
  createdByUser: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  deletedById: Maybe<Scalars['UUID']['output']>;
  enrolledSeasons: Maybe<Array<Season>>;
  enrollmentStatus: SeasonEnrollmentStatus;
  esport: Esport;
  esportId: Scalars['UUID']['output'];
  eventSeasonId: Maybe<Scalars['UUID']['output']>;
  getEligiblePlayers: Maybe<Array<EligiblePlayer>>;
  globalStats: Maybe<TeamGlobalStats>;
  id: Scalars['UUID']['output'];
  inviteUrl: Maybe<Scalars['String']['output']>;
  isEnrolledInCurrentMetaseason: Maybe<Scalars['Boolean']['output']>;
  isFixedRoster: Maybe<Scalars['Boolean']['output']>;
  isMyTeam: Maybe<Scalars['Boolean']['output']>;
  isPlayerLed: Maybe<Scalars['Boolean']['output']>;
  isPrivateRoster: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  league: Maybe<League>;
  leagues: Maybe<Array<League>>;
  lockedInAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated use Team.roster instead */
  members: Maybe<Array<TeamMember>>;
  name: Maybe<Scalars['String']['output']>;
  nextOpponent: Maybe<Team>;
  owners: Maybe<Array<User>>;
  phaseMatches: Maybe<Array<Match>>;
  phaseResult: Maybe<PhaseResult>;
  phases: Maybe<Array<PhaseTeam>>;
  rallySchool: Maybe<School>;
  recommendationPercent: Maybe<Scalars['Float']['output']>;
  recommendationScore: Maybe<Scalars['Int']['output']>;
  roster: Maybe<TeamRoster>;
  rosterHistory: Maybe<Array<IRosterEvent>>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  seasonTeams: Maybe<Array<SeasonTeam>>;
  /** @deprecated use enrolledSeasons */
  seasons: Maybe<Array<Season>>;
  seed: Maybe<Scalars['Int']['output']>;
  slotExclusionWindows: Maybe<Array<SlotExclusionWindow>>;
  slotIdsWithSmartQueueMatches: Maybe<Array<Scalars['UUID']['output']>>;
  slug: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  teamFormat: Maybe<Scalars['Int']['output']>;
  teamHistory: Maybe<Array<ITeamEvent>>;
  teamPhaseSummary: Maybe<TeamPhaseSummary>;
  teamPhaseSummaryByMetaseasonAndPhaseType: Maybe<TeamPhaseSummary>;
  unconnectedMembers: Maybe<Array<TeamMember>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type SeededTeamAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type SeededTeamEnrollmentStatusArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type SeededTeamLeaguesArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SeededTeamMembersArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtRange?: InputMaybe<EffectiveAtRange>;
};


export type SeededTeamNextOpponentArgs = {
  includeScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SeededTeamPhaseMatchesArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type SeededTeamRecommendationPercentArgs = {
  teamId: Scalars['UUID']['input'];
};


export type SeededTeamRecommendationScoreArgs = {
  teamId: Scalars['UUID']['input'];
};


export type SeededTeamRosterArgs = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtRange?: InputMaybe<DateRangeInput>;
};


export type SeededTeamRosterHistoryArgs = {
  dateRange: DateRangeInput;
};


export type SeededTeamSlotExclusionWindowsArgs = {
  bounds?: InputMaybe<DateRangeInput>;
};


export type SeededTeamSlotIdsWithSmartQueueMatchesArgs = {
  slotIds: Array<Scalars['UUID']['input']>;
};


export type SeededTeamTeamPhaseSummaryArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type SeededTeamTeamPhaseSummaryByMetaseasonAndPhaseTypeArgs = {
  metaseasonId: Scalars['UUID']['input'];
  phaseType: PhaseType;
};

export type SendAnnouncementByMatchIdsInput = {
  matchIds: Array<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};

export type SendAnnouncementFilters = {
  esportIds?: InputMaybe<Array<Scalars['String']['input']>>;
  leagueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  matchStartDate?: InputMaybe<Scalars['String']['input']>;
  matchStatuses?: InputMaybe<Array<MatchStatus>>;
  matchType?: InputMaybe<MatchType>;
};

export type SendAnnouncementInput = {
  filters: SendAnnouncementFilters;
  message: Scalars['String']['input'];
};

export type SendAnnouncementPayload = {
  __typename?: 'SendAnnouncementPayload';
  errors: Array<Maybe<Scalars['String']['output']>>;
  payload: SendAnnouncementResults;
  success: Scalars['Boolean']['output'];
};

export type SendAnnouncementResults = {
  __typename?: 'SendAnnouncementResults';
  count: Scalars['Int']['output'];
};

export type SendFirstMessageNotificationIfNecessaryInput = {
  isCoachChat?: InputMaybe<Scalars['Boolean']['input']>;
  matchId: Scalars['UUID']['input'];
  message: Scalars['String']['input'];
};

export type SendFirstMessageNotificationIfNecessaryPayload = {
  __typename?: 'SendFirstMessageNotificationIfNecessaryPayload';
  matchId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
  userId: Scalars['UUID']['output'];
};

export type Series = {
  __typename?: 'Series';
  bestOf: Maybe<Scalars['Int']['output']>;
  games: Maybe<Array<SeriesGame>>;
  gamesNotCancelled: Maybe<Array<SeriesGame>>;
  id: Scalars['UUID']['output'];
  matchId: Scalars['UUID']['output'];
  /** @deprecated use Series.teamContext instead */
  team1: Maybe<SeriesTeam>;
  /** @deprecated use Series.teamContext instead */
  team2: Maybe<SeriesTeam>;
  teamContext: SeriesTeamContext;
};

export type SeriesAssets = {
  gameAssets: Array<GameAssets>;
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SeriesGame = {
  __typename?: 'SeriesGame';
  entryCode: Maybe<Scalars['String']['output']>;
  externalGameId: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  losingTeam: Maybe<GameTeam>;
  matchId: Maybe<Scalars['UUID']['output']>;
  ordinalNumber: Maybe<Scalars['Int']['output']>;
  seriesId: Scalars['UUID']['output'];
  status: GameStatus;
  team1: Maybe<GameTeam>;
  team2: Maybe<GameTeam>;
  teamContext: GameTeamContext;
  winningTeam: Maybe<GameTeam>;
};

export type SeriesPlayer = {
  __typename?: 'SeriesPlayer';
  age: Maybe<Scalars['Int']['output']>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  /** The US state within which the user resides */
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  /** The year that a user will graduate from high school */
  gradYear: Maybe<Scalars['Int']['output']>;
  gradYears: Array<UserGradYear>;
  hearthstoneSelectedDecks: Maybe<Array<HearthstoneDeck>>;
  id: Scalars['UUID']['output'];
  isCaptain: Scalars['Boolean']['output'];
  isUnderage: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  lastSeen: Maybe<Scalars['DateTime']['output']>;
  name: Maybe<Scalars['String']['output']>;
  onlineStatus: Maybe<OnlineStatus>;
  publisherAccountName: Maybe<Scalars['String']['output']>;
  seriesId: Scalars['UUID']['output'];
  shortName: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  /** The user's preferred time zone for date/time localization, e.g. 'Africa/Johannesburg' */
  timeZone: Maybe<Scalars['String']['output']>;
  tosAcceptedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  username: Maybe<Scalars['String']['output']>;
};


export type SeriesPlayerAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesPlayerGradYearArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SeriesPlayerSelectionsPayload = {
  __typename?: 'SeriesPlayerSelectionsPayload';
  players: Maybe<Array<User>>;
};

export type SeriesResult = {
  __typename?: 'SeriesResult';
  gamesLost: Maybe<Scalars['Int']['output']>;
  gamesLostByForfeit: Maybe<Scalars['Int']['output']>;
  gamesPlayed: Maybe<Scalars['Int']['output']>;
  gamesTied: Maybe<Scalars['Int']['output']>;
  gamesWon: Maybe<Scalars['Int']['output']>;
  gamesWonByForfeit: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  placing: Maybe<Scalars['Int']['output']>;
  rosterId: Maybe<Scalars['UUID']['output']>;
  seriesId: Scalars['UUID']['output'];
  teamId: Scalars['UUID']['output'];
  teamSide: Maybe<Scalars['Int']['output']>;
};

export type SeriesResultRequest = {
  __typename?: 'SeriesResultRequest';
  gameResults: Array<GameResultRequest>;
  id: Maybe<Scalars['UUID']['output']>;
  isReadyForReview: Maybe<Scalars['Boolean']['output']>;
  ordinalNumber: Maybe<Scalars['Int']['output']>;
  winningTeamId: Maybe<Scalars['UUID']['output']>;
};

export type SeriesTeam = {
  __typename?: 'SeriesTeam';
  avatarUrl: Maybe<Scalars['String']['output']>;
  captain: Maybe<User>;
  coaches: Maybe<Array<TeamCoach>>;
  competitionGroup: Maybe<CompetitionGroup>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Scalars['UUID']['output']>;
  createdByUser: Maybe<User>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  deletedById: Maybe<Scalars['UUID']['output']>;
  esportId: Scalars['UUID']['output'];
  eventSeasonId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  isPlayerLed: Maybe<Scalars['Boolean']['output']>;
  isPrivateRoster: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  owners: Maybe<Array<User>>;
  result: Maybe<SeriesResult>;
  roster: Maybe<Array<SeriesPlayer>>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  seriesId: Scalars['UUID']['output'];
  slug: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  teamFormat: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type SeriesTeamAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SeriesTeamContext = {
  __typename?: 'SeriesTeamContext';
  myTeamSeriesResults: Array<SeriesResult>;
  myTeams: Array<SeriesTeam>;
  numberOfTeamsInSeries: Scalars['Int']['output'];
  otherTeamSeriesResults: Array<SeriesResult>;
  otherTeams: Array<SeriesTeam>;
  seriesId: Scalars['UUID']['output'];
  teams: Array<SeriesTeam>;
};

export enum ServiceEventProcessor {
  Notification = 'notification',
  NotificationTask = 'notificationTask'
}

export type SetAccountSettingsInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gradYear?: InputMaybe<Scalars['Int']['input']>;
  isNotCoaching?: InputMaybe<Scalars['Boolean']['input']>;
  isPhoneNumberVisible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SetContentForUserInput = {
  features: Array<FeatureUpdate>;
};

export type SetHearthstonePlayerMatchDeckSelectionInput = {
  decks: Array<HearthstoneDeck>;
  setToDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetLeaguesForUserInput = {
  leagueIds: Array<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};

export type SetLeaguesForUserPayload = {
  __typename?: 'SetLeaguesForUserPayload';
  user: Maybe<User>;
};

export type SetMyAccountSettingsInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isPhoneNumberVisible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneExt?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SetMyEsportInterests = {
  esportIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type SetMyFacultyInformationInput = {
  facultyRole: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  phoneExt?: InputMaybe<Scalars['String']['input']>;
};

export type SetMyFacultyRoleInput = {
  facultyRole: Scalars['String']['input'];
};

export type SetMySchoolSubmissionInput = {
  isInterestedInFall2019?: InputMaybe<Scalars['String']['input']>;
  isInterestedInFall2020?: InputMaybe<Scalars['String']['input']>;
  isInterestedInSpring2020?: InputMaybe<Scalars['String']['input']>;
  needsHelpWithApproval: Scalars['String']['input'];
};

export type SetMyUserRoleInput = {
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  role: UserRoleName;
};

export type SetOrdinalPayload = {
  __typename?: 'SetOrdinalPayload';
  gameOrdinal: Maybe<Scalars['Int']['output']>;
  seriesOrdinal: Maybe<Scalars['Int']['output']>;
  stepOrdinal: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SetReputationForTeamInput = {
  reputationScore: Scalars['Float']['input'];
  seasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type SetReputationForTeamsInput = {
  reputationScore: Scalars['Float']['input'];
  seasonId: Scalars['UUID']['input'];
  teamIds: Array<Scalars['UUID']['input']>;
};

export type SetSchoolInput = {
  schoolId: Scalars['UUID']['input'];
};

export type SetSchoolProfileInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  competitionGroup?: InputMaybe<CompetitionGroup>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  detail?: InputMaybe<SchoolDetailInput>;
  dismissalTime?: InputMaybe<Scalars['String']['input']>;
  districtClassification?: InputMaybe<Scalars['String']['input']>;
  gradeHigh?: InputMaybe<Scalars['String']['input']>;
  gradeLow?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  lon?: InputMaybe<Scalars['Float']['input']>;
  mascotName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ncesId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
  showCoachEmails?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SchoolType>;
  whoPays?: InputMaybe<WhoPays>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type SetSlotExclusionRangeDefaultWindowsInput = {
  defaults: Array<SlotExclusionRangeConfigurationDateRangeInput>;
  slotExclusionRangeConfigurationId: Scalars['UUID']['input'];
};

export type SetSlotExclusionRangeDefaultWindowsPayload = {
  __typename?: 'SetSlotExclusionRangeDefaultWindowsPayload';
  slotExclusionRangeDefaultWindowsIds: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  success: Scalars['Boolean']['output'];
};

export type SetSponsorshipCampaignSchoolsInput = {
  schoolIds: Array<Scalars['UUID']['input']>;
  sponsorshipCampaignId: Scalars['UUID']['input'];
};

export type SetSponsorshipCampaignSchoolsPayload = {
  __typename?: 'SetSponsorshipCampaignSchoolsPayload';
  success: Scalars['Boolean']['output'];
};

export type SetUserEsportInterestsInput = {
  esportIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  userId: Scalars['UUID']['input'];
};

export type SetUserEsportPlatformInput = {
  esportId: Scalars['UUID']['input'];
  platform: Platform;
  platformUsername: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

export type SetUserEsportProviderInput = {
  esportSlug: Scalars['EsportSlug']['input'];
  provider: Provider;
  userId: Scalars['UUID']['input'];
};

export type SetUserNotificationEnabledInput = {
  category: NotificationCategory;
  enable: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};

export type SetUserNotificationEnabledPayload = {
  __typename?: 'SetUserNotificationEnabledPayload';
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
  userEmail: Maybe<UserEmail>;
  userId: Scalars['UUID']['output'];
};

export type SetUserNotificationIsPersonalInput = {
  category: NotificationCategory;
  isPersonalEmail: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};

export type SetUserNotificationIsPersonalPayload = {
  __typename?: 'SetUserNotificationIsPersonalPayload';
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
  userEmail: UserEmail;
  userId: Scalars['UUID']['output'];
};

export type SetUserNotificationScopeInput = {
  category: NotificationCategory;
  scope: NotificationScope;
  userId: Scalars['UUID']['input'];
};

export type SetUserNotificationScopePayload = {
  __typename?: 'SetUserNotificationScopePayload';
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type SetUserOnlinePayload = {
  __typename?: 'SetUserOnlinePayload';
  success: Scalars['Boolean']['output'];
};

export type SheerIdResult = {
  __typename?: 'SheerIdResult';
  currentStep: Scalars['String']['output'];
  errorIds: Array<Scalars['String']['output']>;
  verificationId: Scalars['String']['output'];
};

/**
 * Represents a time-bounded period within a Phase during which matches are played.
 * Typically a match day slot during which teams play their matches, for example 2pm a particular date
 */
export type Slot = {
  __typename?: 'Slot';
  bestOf: Maybe<Scalars['Int']['output']>;
  fortniteEventWindowId: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isStartsAtHidden: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<SlotLabel>;
  matchSlots: Maybe<Array<MatchSlot>>;
  matches: Maybe<Array<Match>>;
  name: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  ordinal: Maybe<Scalars['Int']['output']>;
  phase: Maybe<Phase>;
  phaseId: Maybe<Scalars['String']['output']>;
  scheduleMatchesAt: Maybe<Scalars['DateTime']['output']>;
  seasonId: Maybe<Scalars['UUID']['output']>;
  seriesBestOf: Maybe<Scalars['Int']['output']>;
  /** Date/time (usually in UTC) when the slot opens for match play, nullable for generated slots when they first created */
  startsAt: Maybe<Scalars['DateTime']['output']>;
  status: SlotStatus;
  teamIdsWithSmartQueueMatches: Maybe<Array<Scalars['UUID']['output']>>;
  timezone: Maybe<Scalars['String']['output']>;
};


/**
 * Represents a time-bounded period within a Phase during which matches are played.
 * Typically a match day slot during which teams play their matches, for example 2pm a particular date
 */
export type SlotTeamIdsWithSmartQueueMatchesArgs = {
  teamIds: Array<Scalars['UUID']['input']>;
};

export type SlotAttributes = {
  __typename?: 'SlotAttributes';
  bestOf: Scalars['Int']['output'];
  fortniteEventWindowId: Maybe<Scalars['String']['output']>;
  isStartsAtHidden: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  ordinal: Maybe<Scalars['Int']['output']>;
  scheduleMatchesAt: Maybe<Scalars['DateTime']['output']>;
  seriesBestOf: Maybe<Scalars['Int']['output']>;
  startsAt: Scalars['DateTime']['output'];
  status: Maybe<SlotStatus>;
};

export type SlotConfig = {
  dayOfWeek: Scalars['Int']['input'];
  localTime: Scalars['String']['input'];
  numSlots: Scalars['Int']['input'];
  skipDates: Array<Scalars['DateTime']['input']>;
};

export type SlotDateConfig = {
  date: Scalars['String']['input'];
  localTime: Scalars['String']['input'];
};

export type SlotExclusionData = {
  __typename?: 'SlotExclusionData';
  bounds: DateRange;
  rangeData: Array<SlotExclusionRangeData>;
};

export type SlotExclusionRangeConfiguration = {
  __typename?: 'SlotExclusionRangeConfiguration';
  defaults: Array<SlotExclusionRangeDefaultWindow>;
  defaultsAppliedAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  maxSlotExclusions: Scalars['Int']['output'];
  metaseasonId: Maybe<Scalars['UUID']['output']>;
  minSlotExclusions: Scalars['Int']['output'];
  range: DateRange;
  resourceId: Scalars['UUID']['output'];
  resourceType: SlotExclusionRangeConfigurationResourceType;
  suggestions: Array<SlotExclusionWindowSuggestion>;
};

export type SlotExclusionRangeConfigurationDateRangeInput = {
  endsAt: Scalars['DateTime']['input'];
  startsAt: Scalars['DateTime']['input'];
};

export enum SlotExclusionRangeConfigurationResourceType {
  Metaseason = 'metaseason',
  Season = 'season'
}

export type SlotExclusionRangeConfigurationsResult = {
  __typename?: 'SlotExclusionRangeConfigurationsResult';
  results: Array<SlotExclusionRangeConfiguration>;
};

export type SlotExclusionRangeData = {
  __typename?: 'SlotExclusionRangeData';
  competitionGroup: CompetitionGroup;
  configuration: SlotExclusionRangeConfiguration;
  organizationId: Scalars['UUID']['output'];
  range: DateRange;
  season: Maybe<Season>;
  seasonId: Maybe<Scalars['UUID']['output']>;
  selectionData: SlotExclusionRangeSelectionData;
  suggestionsForOrganization: Array<OrganizationSlotExclusionWindowSuggestion>;
};

export type SlotExclusionRangeDefaultWindow = {
  __typename?: 'SlotExclusionRangeDefaultWindow';
  endsAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  startsAt: Scalars['DateTime']['output'];
};

export type SlotExclusionRangeSelection = {
  __typename?: 'SlotExclusionRangeSelection';
  isEditable: Scalars['Boolean']['output'];
  slotExclusionWindow: SlotExclusionWindow;
};

export type SlotExclusionRangeSelectionData = {
  __typename?: 'SlotExclusionRangeSelectionData';
  bounds: DateRange;
  resourceId: Scalars['UUID']['output'];
  resourceType: SlotExclusionWindowResourceType;
  selections: Array<SlotExclusionRangeSelection>;
};

export type SlotExclusionWindow = {
  __typename?: 'SlotExclusionWindow';
  createdAt: Scalars['DateTime']['output'];
  createdById: Maybe<Scalars['UUID']['output']>;
  endsAt: Maybe<Scalars['DateTime']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isNoBreakWeek: Maybe<Scalars['Boolean']['output']>;
  resourceId: Scalars['UUID']['output'];
  resourceType: SlotExclusionWindowResourceType;
  scheduleMatchesAt: Maybe<Scalars['DateTime']['output']>;
  seasonId: Maybe<Scalars['UUID']['output']>;
  slotExclusionWindowType: SlotExclusionWindowType;
  startsAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type SlotExclusionWindowAttributes = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SlotExclusionWindowInput = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  isNoBreakWeek?: InputMaybe<Scalars['Boolean']['input']>;
  resourceId: Scalars['UUID']['input'];
  resourceType: SlotExclusionWindowResourceType;
  seasonId?: InputMaybe<Scalars['UUID']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SlotExclusionWindowMutationPayload = {
  __typename?: 'SlotExclusionWindowMutationPayload';
  slotExclusionWindow: SlotExclusionWindow;
};

export enum SlotExclusionWindowResourceType {
  Organization = 'organization',
  Team = 'team'
}

export type SlotExclusionWindowSuggestion = {
  __typename?: 'SlotExclusionWindowSuggestion';
  isDefault: Scalars['Boolean']['output'];
  scheduleMatchesAt: Maybe<Scalars['DateTime']['output']>;
  template: SlotExclusionWindowTemplate;
};

export type SlotExclusionWindowTemplate = {
  __typename?: 'SlotExclusionWindowTemplate';
  endsAt: Maybe<Scalars['DateTime']['output']>;
  hash: Scalars['String']['output'];
  startsAt: Maybe<Scalars['DateTime']['output']>;
};

export enum SlotExclusionWindowType {
  Other = 'other',
  PreseasonOptOut = 'preseasonOptOut',
  SchoolBreakWeek = 'schoolBreakWeek',
  SchoolSeasonBreakWeek = 'schoolSeasonBreakWeek'
}

export enum SlotLabel {
  Finals = 'finals',
  Losers = 'losers',
  Winners = 'winners'
}

export enum SlotLobbyStatus {
  Closed = 'closed',
  Open = 'open',
  Unopened = 'unopened'
}

export type SlotLobbyStatusDetails = ClosedSlotLobbyDetails | OpenSlotLobbyDetails | UnopenedSlotLobbyDetails;

export type SlotLobbyStatusPayload = {
  __typename?: 'SlotLobbyStatusPayload';
  details: Maybe<SlotLobbyStatusDetails>;
  errors: Maybe<Array<GetSlotLobbyError>>;
  id: Maybe<Scalars['UUID']['output']>;
  status: Maybe<SlotLobbyStatus>;
  success: Scalars['Boolean']['output'];
};

export type SlotPayload = {
  __typename?: 'SlotPayload';
  slot: Maybe<Slot>;
  slotId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type SlotScheduleInput = {
  bestOf: Scalars['Int']['input'];
  fortniteEventWindowId?: InputMaybe<Scalars['String']['input']>;
  isStartsAtHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  scheduleMatchesAt?: InputMaybe<Scalars['DateTime']['input']>;
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  startsAt: Scalars['DateTime']['input'];
  status?: InputMaybe<SlotStatus>;
};

export enum SlotStatus {
  AwaitingSchedule = 'awaitingSchedule',
  Canceled = 'canceled',
  MatchesScheduled = 'matchesScheduled'
}

export type SmartQueueStatePayload = {
  __typename?: 'SmartQueueStatePayload';
  inQueue: Scalars['Boolean']['output'];
  matchId: Maybe<Scalars['String']['output']>;
  mostRecentPairing: Maybe<Scalars['DateTime']['output']>;
  remainingScheduleJobs: Maybe<Scalars['Int']['output']>;
};

export type SmartQueueUpdateSubscribeInput = {
  slotId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type SmartQueueUpdateSubscribePayload = {
  __typename?: 'SmartQueueUpdateSubscribePayload';
  currentState: SmartQueueStatePayload;
};

export type SmashUltimateCharacterSelection = {
  __typename?: 'SmashUltimateCharacterSelection';
  /** @deprecated Use characterPlayedOption instead */
  characterPlayed: Scalars['String']['output'];
  characterPlayedOption: GameAssistantSelectionOption;
  playerId: Scalars['UUID']['output'];
  teamId: Scalars['UUID']['output'];
};

export type SmashUltimateGameStats = {
  __typename?: 'SmashUltimateGameStats';
  gameId: Scalars['UUID']['output'];
  players: Array<SmashUltimateCharacterSelection>;
  stagePlayed: Scalars['String']['output'];
  winner: Scalars['UUID']['output'];
};

/** The Smite player stats for a game */
export type SmitePlayerGameStats = SmiteStats & {
  __typename?: 'SmitePlayerGameStats';
  assists: Scalars['Int']['output'];
  characterId: Scalars['String']['output'];
  eliminationParticipation: Scalars['Float']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstElimination: Scalars['Boolean']['output'];
  goldEarned: Scalars['Int']['output'];
  goldPerMinute: Scalars['Float']['output'];
  id: Scalars['UUID']['output'];
  respawns: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
};

/** The Smite player stats for a match */
export type SmitePlayerMatchStats = SmiteStats & {
  __typename?: 'SmitePlayerMatchStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageEliminations: Scalars['Float']['output'];
  averageGoldEarned: Scalars['Float']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  averageRespawns: Scalars['Float']['output'];
  averageTowersDestroyed: Scalars['Float']['output'];
  eliminationParticipation: Scalars['Float']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstEliminations: Scalars['Int']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  mostPickedCharacterId: Scalars['Int']['output'];
  respawns: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
};

/** The Smite player stats for a phase */
export type SmitePlayerPhaseStats = SmiteStats & {
  __typename?: 'SmitePlayerPhaseStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageEliminations: Scalars['Float']['output'];
  averageGoldEarned: Scalars['Float']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  averageRespawns: Scalars['Float']['output'];
  averageTowersDestroyed: Scalars['Float']['output'];
  eliminationParticipation: Scalars['Float']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstEliminations: Scalars['Int']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  mostPickedCharacterId: Scalars['Int']['output'];
  respawns: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
};

export type SmiteStats = {
  assists: Scalars['Int']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  respawns: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
};

/** The Smite team stats for a game */
export type SmiteTeamGameStats = SmiteStats & {
  __typename?: 'SmiteTeamGameStats';
  assists: Scalars['Int']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstElimination: Scalars['Boolean']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  respawns: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
};

/** The Smite team stats for a match */
export type SmiteTeamMatchStats = SmiteStats & {
  __typename?: 'SmiteTeamMatchStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageEliminations: Scalars['Float']['output'];
  averageGoldEarned: Scalars['Float']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  averageRespawns: Scalars['Float']['output'];
  averageTowersDestroyed: Scalars['Float']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstEliminationRate: Scalars['Float']['output'];
  firstEliminations: Scalars['Int']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  respawns: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
};

/** The Smite team stats for a phase */
export type SmiteTeamPhaseStats = SmiteStats & {
  __typename?: 'SmiteTeamPhaseStats';
  assists: Scalars['Int']['output'];
  averageAssists: Scalars['Float']['output'];
  averageEliminations: Scalars['Float']['output'];
  averageGoldEarned: Scalars['Float']['output'];
  averageGoldPerMinute: Scalars['Float']['output'];
  averageRespawns: Scalars['Float']['output'];
  averageTowersDestroyed: Scalars['Float']['output'];
  eliminationRespawnRatio: Scalars['Float']['output'];
  eliminations: Scalars['Int']['output'];
  firstEliminationRate: Scalars['Float']['output'];
  firstEliminations: Scalars['Int']['output'];
  goldEarned: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  respawns: Scalars['Int']['output'];
  towersDestroyed: Scalars['Int']['output'];
};

export type SplatoonCharacterSelection = {
  __typename?: 'SplatoonCharacterSelection';
  /** @deprecated Use characterPlayedOption instead */
  characterPlayed: Scalars['String']['output'];
  characterPlayedOption: GameAssistantSelectionOption;
  playerId: Scalars['UUID']['output'];
  teamId: Scalars['UUID']['output'];
};

export type SplatoonGameStats = {
  __typename?: 'SplatoonGameStats';
  gameId: Scalars['UUID']['output'];
  players: Array<SplatoonCharacterSelection>;
  stagePlayed: Scalars['String']['output'];
  winner: Scalars['UUID']['output'];
};

export type SplatoonMostPlayedStatsByPlayerId = {
  __typename?: 'SplatoonMostPlayedStatsByPlayerId';
  mostPlayedCharacters: Array<Maybe<SplatoonPlayedWinRate>>;
  mostPlayedStages: Array<Maybe<SplatoonPlayedWinRate>>;
  playerId: Scalars['UUID']['output'];
};

export type SplatoonPlayedWinRate = {
  __typename?: 'SplatoonPlayedWinRate';
  name: Scalars['String']['output'];
  played: Scalars['Float']['output'];
  winRate: Scalars['Float']['output'];
};

export type SponsorshipCampaign = {
  __typename?: 'SponsorshipCampaign';
  createdAt: Scalars['DateTime']['output'];
  endDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  partnerId: Maybe<Scalars['String']['output']>;
  schools: Maybe<Array<School>>;
  sponsorshipComponents: Maybe<Array<SponsorshipComponent>>;
  sponsorshipImages: Maybe<Array<SponsorshipImage>>;
  startDate: Scalars['DateTime']['output'];
  status: SponsorshipCampaignStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SponsorshipCampaignFilters = {
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SponsorshipCampaignInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  status: SponsorshipCampaignStatus;
  title: Scalars['String']['input'];
};

export type SponsorshipCampaignOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SponsorshipCampaignSearchInput = {
  filters?: InputMaybe<SponsorshipCampaignFilters>;
  options?: InputMaybe<SponsorshipCampaignOptions>;
};

export enum SponsorshipCampaignStatus {
  Draft = 'draft',
  Published = 'published'
}

export type SponsorshipCampaignUpdateInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SponsorshipCampaignStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SponsorshipCampaignsResult = {
  __typename?: 'SponsorshipCampaignsResult';
  result: Maybe<Array<SponsorshipCampaign>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type SponsorshipComponent = {
  __typename?: 'SponsorshipComponent';
  callToAction: Maybe<Scalars['String']['output']>;
  entityId: Scalars['UUID']['output'];
  entityType: SponsorshipEntityType;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sponsorshipImages: Maybe<Array<SponsorshipImage>>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type SponsorshipComponentInput = {
  callToAction?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['UUID']['input'];
  entityType: SponsorshipEntityType;
  name: Scalars['String']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SponsorshipComponentUpdateInput = {
  callToAction?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum SponsorshipEntityType {
  Campaign = 'campaign',
  Component = 'component',
  League = 'league',
  Season = 'season'
}

export type SponsorshipImage = {
  __typename?: 'SponsorshipImage';
  entityId: Scalars['UUID']['output'];
  entityType: SponsorshipEntityType;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type SponsorshipRemovePayload = {
  __typename?: 'SponsorshipRemovePayload';
  success: Scalars['Boolean']['output'];
};

export type StandingsPageLeagueMetadata = {
  __typename?: 'StandingsPageLeagueMetadata';
  competitionModel: CompetitionModel;
  displayName: Maybe<Scalars['String']['output']>;
  enrollmentStatus: Maybe<SchoolLeagueEnrollmentStatus>;
  esport: Maybe<Esport>;
  esportId: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  seasons: Maybe<Array<StandingsPageSeason>>;
};

export type StandingsPageMetaseason = {
  __typename?: 'StandingsPageMetaseason';
  endsAt: Scalars['String']['output'];
  hasMatches: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  promotionEndsAt: Maybe<Scalars['String']['output']>;
  promotionStartsAt: Maybe<Scalars['String']['output']>;
  startsAt: Scalars['String']['output'];
};

export type StandingsPagePhase = {
  __typename?: 'StandingsPagePhase';
  endsAt: Scalars['String']['output'];
  format: PhaseFormat;
  hasMatches: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  startsAt: Scalars['String']['output'];
  status: PhaseStatus;
};

export type StandingsPageSeason = {
  __typename?: 'StandingsPageSeason';
  endsAt: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  metaseason: StandingsPageMetaseason;
  name: Scalars['String']['output'];
  phases: Maybe<Array<StandingsPagePhase>>;
  startsAt: Scalars['String']['output'];
};

export type StartGameInput = {
  gameId: Scalars['UUID']['input'];
};

export type StarterPosition = {
  __typename?: 'StarterPosition';
  player: Maybe<TeamPlayer>;
  position: EsportPosition;
};

export type StudentActivityFunding = {
  __typename?: 'StudentActivityFunding';
  school: Maybe<Scalars['Boolean']['output']>;
  students: Maybe<Scalars['Boolean']['output']>;
};

export type StudentActivityFundingInput = {
  school?: InputMaybe<Scalars['Boolean']['input']>;
  students?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitAdminMatchSettleRequestAssetsInput = {
  matchSettleRequestId: Scalars['UUID']['input'];
  seriesAssets: Array<SeriesAssets>;
};

export type SubmitAdminMatchSettleRequestInput = {
  archiveMatch?: InputMaybe<Scalars['Boolean']['input']>;
  matchSettleRequestId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitAdminMatchSettleRequestLiveInput = {
  archiveMatch?: InputMaybe<Scalars['Boolean']['input']>;
  matchSettleRequestId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitGameAssistantStepSelectionAttributes = {
  selectionOptionId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  yesNoResponse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitGameAssistantStepSelectionsInput = {
  selectionOptions?: InputMaybe<Array<SubmitGameAssistantStepSelectionAttributes>>;
  stepId: Scalars['UUID']['input'];
};

export type SubmitGameAssistantStepSelectionsPayload = {
  __typename?: 'SubmitGameAssistantStepSelectionsPayload';
  success: Scalars['Boolean']['output'];
};

export type SubmitLeaderboardGameResultLiveInput = {
  gameOrdinal: Scalars['Int']['input'];
  matchId: Scalars['UUID']['input'];
  placing: Scalars['Int']['input'];
  teamId: Scalars['UUID']['input'];
};

export type SubmitLeaderboardGameResultLivePayload = {
  __typename?: 'SubmitLeaderboardGameResultLivePayload';
  success: Scalars['Boolean']['output'];
};

export type SubmitMatchSettleRequestInput = {
  matchSettleRequestId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['UUID']['input'];
};

export type SubmitMatchSettleRequestLiveInput = {
  matchSettleRequestId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['UUID']['input'];
};

export type SubmitMatchSettleRequestPayload = {
  __typename?: 'SubmitMatchSettleRequestPayload';
  errors: Maybe<Array<Scalars['String']['output']>>;
  match: Maybe<Match>;
  matchSettleRequest: MatchSettleRequestModel;
  matchSettleRequestId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
  traceId: Scalars['String']['output'];
};

export type SubmitUserSchoolSurveyInput = {
  surveyResponses?: InputMaybe<Array<SurveyQuestionResponse>>;
  surveySlug: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  _: Maybe<Scalars['Boolean']['output']>;
  gameAssistantStepUpdated: Maybe<GameAssistantStepUpdatedSubscribePayload>;
  matchSettleRequestAssetsUpdated: Maybe<GenericMatchSettleRequestPayload>;
  matchSettleRequestSubmitted: Maybe<SubmitMatchSettleRequestPayload>;
  matchSettleRequestUpdated: Maybe<MatchSettleRequestWithWinningTeamPayload>;
  preseasonQueueStateUpdated: Maybe<PreseasonQueueUpdateSubscribePayload>;
  scrimmageQueueStateUpdated: Maybe<ScrimmageQueueUpdateSubscribePayload>;
  smartQueueStateUpdated: Maybe<SmartQueueUpdateSubscribePayload>;
  userNotificationSummary: NotificationSummaryPayload;
};


export type SubscriptionGameAssistantStepUpdatedArgs = {
  input: GameAssistantStepUpdatedSubscribeInput;
};


export type SubscriptionMatchSettleRequestAssetsUpdatedArgs = {
  input?: InputMaybe<MatchSettleRequestAssetsUpdatedSubscribeInput>;
};


export type SubscriptionMatchSettleRequestSubmittedArgs = {
  input?: InputMaybe<MatchSettleRequestSubmittedSubscribeInput>;
};


export type SubscriptionMatchSettleRequestUpdatedArgs = {
  input?: InputMaybe<MatchSettleRequestUpdatedSubscribeInput>;
};


export type SubscriptionPreseasonQueueStateUpdatedArgs = {
  input: PreseasonQueueUpdateSubscribeInput;
};


export type SubscriptionScrimmageQueueStateUpdatedArgs = {
  input: ScrimmageQueueUpdateSubscribeInput;
};


export type SubscriptionSmartQueueStateUpdatedArgs = {
  input: SmartQueueUpdateSubscribeInput;
};


export type SubscriptionUserNotificationSummaryArgs = {
  userId: Scalars['UUID']['input'];
};

export type SubstituteTransferDestination = {
  __typename?: 'SubstituteTransferDestination';
  requiresTrade: Scalars['Boolean']['output'];
  team: Team;
  tradablePlayers: Array<TeamPlayer>;
};

export type SubstituteTransferOptions = {
  ignoreRegistrationWindow?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SuccessPayload = {
  __typename?: 'SuccessPayload';
  success: Scalars['Boolean']['output'];
};

export type SuggestedSchoolInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type?: InputMaybe<SchoolType>;
  zip: Scalars['String']['input'];
};

export type SummonerInfoResponse = {
  __typename?: 'SummonerInfoResponse';
  accountId: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  profileIconId: Maybe<Scalars['Int']['output']>;
  puuid: Maybe<Scalars['String']['output']>;
  revisionDate: Maybe<Scalars['Float']['output']>;
  summonerLevel: Maybe<Scalars['Int']['output']>;
};

export type SupportStaff = {
  __typename?: 'SupportStaff';
  email: Maybe<Scalars['String']['output']>;
  fname: Maybe<Scalars['String']['output']>;
  lname: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};

export type SupportStaffInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fname?: InputMaybe<Scalars['String']['input']>;
  lname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type Survey = {
  __typename?: 'Survey';
  id: Scalars['UUID']['output'];
  schemaJson: Scalars['String']['output'];
};

export type SurveyPayload = {
  __typename?: 'SurveyPayload';
  id: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type SurveyQuestionResponse = {
  answerSlug: Scalars['String']['input'];
  answerText: Scalars['String']['input'];
  questionSlug: Scalars['String']['input'];
  questionText: Scalars['String']['input'];
};

export enum SurveyTrigger {
  EventPreRegistration = 'EventPreRegistration'
}

export enum SurveyTriggerEntityType {
  Season = 'Season'
}

export enum SurveyType {
  FirstMatch = 'firstMatch',
  NewEnrollment = 'newEnrollment',
  ReturningEnrollment = 'returningEnrollment'
}

export type TaskCompletePayload = {
  __typename?: 'TaskCompletePayload';
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export enum TaskState {
  Completed = 'completed',
  Disabled = 'disabled',
  Enabled = 'enabled'
}

export type Team = ITeam & {
  __typename?: 'Team';
  /** @deprecated use enrolledSeasons */
  allSeasons: Maybe<Array<Season>>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  captain: Maybe<User>;
  coaches: Maybe<Array<TeamCoach>>;
  competitionGroup: Maybe<CompetitionGroup>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  createdBy: Maybe<Scalars['UUID']['output']>;
  createdByUser: Maybe<User>;
  currentTeamRival: Maybe<TeamRival>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deletedBy: Maybe<User>;
  deletedById: Maybe<Scalars['UUID']['output']>;
  enrolledSeasons: Maybe<Array<Season>>;
  enrollmentStatus: SeasonEnrollmentStatus;
  esport: Esport;
  esportId: Scalars['UUID']['output'];
  eventSeasonId: Maybe<Scalars['UUID']['output']>;
  /**
   * From the current Metaseason, get the most recent phase standings
   * for the team.  Returns null if there are not phase results for
   * the current metaseason.
   */
  getCurrentMetaseasonTeamPhaseStandings: Maybe<TeamPhaseStandings>;
  getEligiblePlayers: Maybe<Array<EligiblePlayer>>;
  globalStats: Maybe<TeamGlobalStats>;
  id: Scalars['UUID']['output'];
  inviteUrl: Maybe<Scalars['String']['output']>;
  isEnrolledInCurrentMetaseason: Maybe<Scalars['Boolean']['output']>;
  isFixedRoster: Maybe<Scalars['Boolean']['output']>;
  isMyTeam: Maybe<Scalars['Boolean']['output']>;
  isPlayerLed: Maybe<Scalars['Boolean']['output']>;
  isPrivateRoster: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  league: Maybe<League>;
  leagues: Maybe<Array<League>>;
  /** @deprecated use Team.roster instead */
  members: Maybe<Array<TeamMember>>;
  name: Maybe<Scalars['String']['output']>;
  nextOpponent: Maybe<Team>;
  owners: Maybe<Array<User>>;
  pendingTeamRivals: Maybe<Array<TeamRival>>;
  phaseMatches: Maybe<Array<Match>>;
  phaseResult: Maybe<PhaseResult>;
  phases: Maybe<Array<PhaseTeam>>;
  rallySchool: Maybe<School>;
  recommendationPercent: Maybe<Scalars['Float']['output']>;
  recommendationScore: Maybe<Scalars['Int']['output']>;
  requestedTeamRivals: Maybe<Array<TeamRival>>;
  roster: Maybe<TeamRoster>;
  rosterHistory: Maybe<Array<IRosterEvent>>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  seasonTeams: Maybe<Array<SeasonTeam>>;
  /** @deprecated use enrolledSeasons */
  seasons: Maybe<Array<Season>>;
  slotExclusionWindows: Maybe<Array<SlotExclusionWindow>>;
  slotIdsWithSmartQueueMatches: Maybe<Array<Scalars['UUID']['output']>>;
  slug: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  teamFormat: Maybe<Scalars['Int']['output']>;
  teamHistory: Maybe<Array<ITeamEvent>>;
  teamPhaseSummary: Maybe<TeamPhaseSummary>;
  teamPhaseSummaryByMetaseasonAndPhaseType: Maybe<TeamPhaseSummary>;
  unconnectedMembers: Maybe<Array<TeamMember>>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};


export type TeamAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamCurrentTeamRivalArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type TeamEnrollmentStatusArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type TeamLeaguesArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamMembersArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtRange?: InputMaybe<EffectiveAtRange>;
};


export type TeamNextOpponentArgs = {
  includeScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TeamPendingTeamRivalsArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type TeamPhaseMatchesArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type TeamRecommendationPercentArgs = {
  teamId: Scalars['UUID']['input'];
};


export type TeamRecommendationScoreArgs = {
  teamId: Scalars['UUID']['input'];
};


export type TeamRequestedTeamRivalsArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type TeamRosterArgs = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveAtRange?: InputMaybe<DateRangeInput>;
};


export type TeamRosterHistoryArgs = {
  dateRange: DateRangeInput;
};


export type TeamSlotExclusionWindowsArgs = {
  bounds?: InputMaybe<DateRangeInput>;
};


export type TeamSlotIdsWithSmartQueueMatchesArgs = {
  slotIds: Array<Scalars['UUID']['input']>;
};


export type TeamTeamPhaseSummaryArgs = {
  phaseId: Scalars['UUID']['input'];
};


export type TeamTeamPhaseSummaryByMetaseasonAndPhaseTypeArgs = {
  metaseasonId: Scalars['UUID']['input'];
  phaseType: PhaseType;
};

export type TeamCoach = IUser & {
  __typename?: 'TeamCoach';
  activatedLeagues: Maybe<Array<League>>;
  additionalInfo: Maybe<Scalars['String']['output']>;
  age: Maybe<Scalars['Int']['output']>;
  assignedSeasonalAwards: Maybe<Array<AssignedSeasonalPlayerAward>>;
  assignedWeeklyAwards: Maybe<Array<Maybe<AssignedWeeklyPlayerAward>>>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  banned: Maybe<Scalars['Boolean']['output']>;
  chatUserId: Maybe<Scalars['UUID']['output']>;
  coachType: TeamCoachType;
  content: Content;
  /** The US state within which the user resides */
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  currentVerification: Maybe<Verification>;
  dateOfBirth: Maybe<Scalars['String']['output']>;
  detail: Maybe<UserDetail>;
  /** @deprecated Use roles instead, the caching will take care of performance issues */
  directRoles: Maybe<Array<UserRole>>;
  /** @deprecated https://playvs.atlassian.net/browse/ID-1709 */
  email: Maybe<Scalars['String']['output']>;
  /** @deprecated https://playvs.atlassian.net/browse/ID-1709 */
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  emails: Maybe<Array<UserEmail>>;
  enrolledAt: Maybe<Scalars['DateTime']['output']>;
  enrolledTeamsByMetaseasonId: Maybe<Array<Team>>;
  esportInterests: Maybe<Array<Esport>>;
  firstName: Maybe<Scalars['String']['output']>;
  gameHighlights: Maybe<Array<Maybe<GameHighlight>>>;
  /** The year that a user will graduate from high school */
  gradYear: Maybe<Scalars['Int']['output']>;
  gradYears: Array<UserGradYear>;
  /** @deprecated needs to be refactored */
  hasScholasticTeamsAtSchool: Maybe<Scalars['Boolean']['output']>;
  hmac: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isNotCoaching: Maybe<Scalars['Boolean']['output']>;
  isPhoneNumberVisible: Maybe<Scalars['Boolean']['output']>;
  isUnderage: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  lastSeen: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated No longer supported */
  league: Maybe<League>;
  leagueScope: Maybe<AllLeaguesResult>;
  leagues: Maybe<Array<League>>;
  managedTeams: Maybe<Array<Team>>;
  name: Maybe<Scalars['String']['output']>;
  onlineStatus: Maybe<OnlineStatus>;
  phaseStats: Maybe<Array<PlayerPhaseStats>>;
  phone: Maybe<Scalars['String']['output']>;
  phoneExt: Maybe<Scalars['String']['output']>;
  playerProfileSnapshot: Maybe<PlayerProfileSnapshot>;
  promotionalEmail: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  referralLinks: Maybe<UserReferralLinks>;
  referralToken: Scalars['String']['output'];
  referredUsers: Maybe<Array<User>>;
  referringUser: Maybe<User>;
  roleRequests: Maybe<Array<RoleRequest>>;
  /** @deprecated No longer supported */
  roleReviews: Maybe<Array<RoleReview>>;
  roles: Maybe<Array<UserRole>>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  schoolRoleStatus: Maybe<Array<RoleStatus>>;
  seasonPasses: Maybe<Array<UserSeasonPass>>;
  shortName: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  submissions: Maybe<Array<UserSchoolSubmission>>;
  team: Maybe<Team>;
  teamId: Maybe<Scalars['UUID']['output']>;
  teams: Maybe<Array<Team>>;
  teamsWherePrimaryCoach: Array<Team>;
  /** The user's preferred time zone for date/time localization, e.g. 'Africa/Johannesburg' */
  timeZone: Maybe<Scalars['String']['output']>;
  tosAcceptedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userDemographics: Maybe<UserDemographics>;
  userEsportPlatforms: Maybe<Array<UserEsportPlatform>>;
  userProviderAccounts: Maybe<Array<UserProviderAccount>>;
  userValidation: Maybe<UserValidation>;
  username: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  workEmail: Maybe<Scalars['String']['output']>;
};


export type TeamCoachAssignedSeasonalAwardsArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamCoachAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamCoachEnrolledTeamsByMetaseasonIdArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamCoachGradYearArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamCoachHasScholasticTeamsAtSchoolArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type TeamCoachLeagueArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


export type TeamCoachLeagueScopeArgs = {
  filters?: InputMaybe<LeagueFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamCoachLeaguesArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


export type TeamCoachManagedTeamsArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamCoachPhaseStatsArgs = {
  phaseId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamCoachRoleRequestsArgs = {
  filters?: InputMaybe<RoleRequestFilters>;
};


export type TeamCoachSchoolRoleStatusArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamCoachTeamArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type TeamCoachTeamsArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamCoachTeamsWherePrimaryCoachArgs = {
  schoolId: Scalars['UUID']['input'];
};

export enum TeamCoachType {
  Organization = 'organization',
  Primary = 'primary'
}

export type TeamDateRange = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
};

export type TeamDeleteEvent = ITeamEvent & {
  __typename?: 'TeamDeleteEvent';
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Maybe<Scalars['UUID']['output']>;
};

export type TeamEnrollment = {
  __typename?: 'TeamEnrollment';
  activePhaseRanks: Array<TeamPhaseRank>;
  effectiveAt: Scalars['DateTime']['output'];
  enrollableSeasons: Array<Season>;
  enrolledSeasons: Array<Season>;
  team: Team;
};

export type TeamEnrollmentEvent = ITeamEvent & {
  __typename?: 'TeamEnrollmentEvent';
  league: Maybe<League>;
  leagueId: Maybe<Scalars['String']['output']>;
  metaseason: Maybe<Metaseason>;
  metaseasonId: Maybe<Scalars['String']['output']>;
  seasonId: Maybe<Scalars['String']['output']>;
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Maybe<Scalars['UUID']['output']>;
};

export type TeamEnrollmentOptions = {
  ignoreSchoolLeagueGroups?: InputMaybe<Scalars['Boolean']['input']>;
  slotExclusionWindows?: InputMaybe<Array<DateRangeInput>>;
};

export type TeamEnrollmentsInput = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type TeamEnrollmentsPayload = {
  __typename?: 'TeamEnrollmentsPayload';
  effectiveAt: Scalars['DateTime']['output'];
  teamEnrollments: Array<TeamEnrollment>;
};

export type TeamFiltersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  competitionGroup?: InputMaybe<CompetitionGroup>;
  createdAt?: InputMaybe<TeamDateRange>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  esportSlugs?: InputMaybe<Array<Scalars['EsportSlug']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  keywordExcludes?: InputMaybe<Array<Scalars['String']['input']>>;
  leagueGroupId?: InputMaybe<Scalars['UUID']['input']>;
  leagueId?: InputMaybe<Scalars['String']['input']>;
  matchStatus?: InputMaybe<Array<InputMaybe<MatchStatus>>>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  seasonId?: InputMaybe<Scalars['UUID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  teamIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  updatedAt?: InputMaybe<TeamDateRange>;
  varsityAssociationSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TeamFormat = {
  __typename?: 'TeamFormat';
  size: Scalars['Int']['output'];
};

export type TeamFortniteStandings = {
  __typename?: 'TeamFortniteStandings';
  eliminationsPerGame: Maybe<LeaderboardMetric>;
  esportSlug: Maybe<Scalars['String']['output']>;
  rankPerGame: Maybe<LeaderboardMetric>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  team: Maybe<Team>;
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']['output']>;
};

export type TeamGameRecord = {
  __typename?: 'TeamGameRecord';
  lost: Maybe<Scalars['Int']['output']>;
  won: Maybe<Scalars['Int']['output']>;
};

export type TeamGameSpecificGameStats = LeagueOfLegendsTeamGameStats | RocketLeagueTeamGameStats | SmiteTeamGameStats;

/** The stats for a team for a game */
export type TeamGameStats = TeamStats & {
  __typename?: 'TeamGameStats';
  gameId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  leagueOfLegendsStats: Maybe<LeagueOfLegendsTeamGameStats>;
  leagueOfLegendsTeamGameStatsId: Maybe<Scalars['UUID']['output']>;
  rocketLeagueStats: Maybe<RocketLeagueTeamGameStats>;
  rocketLeagueTeamGameStatsId: Maybe<Scalars['UUID']['output']>;
  smiteStats: Maybe<SmiteTeamGameStats>;
  smiteTeamGameStatsId: Maybe<Scalars['UUID']['output']>;
  stats: Maybe<TeamGameSpecificGameStats>;
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  timePlayedInSeconds: Maybe<Scalars['Int']['output']>;
};

export type TeamGameStatsResult = {
  __typename?: 'TeamGameStatsResult';
  results: Maybe<Array<TeamGameStats>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type TeamGlobalStats = {
  __typename?: 'TeamGlobalStats';
  id: Scalars['UUID']['output'];
  leagueMatchStreak: Maybe<Scalars['Float']['output']>;
  leagueMatchWinPercentage: Maybe<Scalars['Float']['output']>;
  leagueMatchesLost: Maybe<Scalars['Float']['output']>;
  leagueMatchesLostByForfeit: Maybe<Scalars['Float']['output']>;
  leagueMatchesPlayed: Maybe<Scalars['Float']['output']>;
  leagueMatchesPlayedLast90: Maybe<Scalars['Float']['output']>;
  leagueMatchesTied: Maybe<Scalars['Float']['output']>;
  leagueMatchesWon: Maybe<Scalars['Float']['output']>;
  leagueMatchesWonByForfeit: Maybe<Scalars['Float']['output']>;
  rankingPoints: Maybe<Scalars['Float']['output']>;
  scheduledScrimmagesCanceled: Maybe<Scalars['Float']['output']>;
  scrimmageStreak: Maybe<Scalars['Float']['output']>;
  scrimmageWinPercentage: Maybe<Scalars['Float']['output']>;
  scrimmagesLost: Maybe<Scalars['Float']['output']>;
  scrimmagesPlayed: Maybe<Scalars['Float']['output']>;
  scrimmagesPlayedLast90: Maybe<Scalars['Float']['output']>;
  scrimmagesTied: Maybe<Scalars['Float']['output']>;
  scrimmagesWon: Maybe<Scalars['Float']['output']>;
  teamId: Scalars['UUID']['output'];
  totalMatchesLost: Maybe<Scalars['Float']['output']>;
  totalMatchesPlayed: Maybe<Scalars['Float']['output']>;
  totalMatchesTied: Maybe<Scalars['Float']['output']>;
  totalMatchesWon: Maybe<Scalars['Float']['output']>;
  totalWinPercentage: Maybe<Scalars['Float']['output']>;
};

export type TeamHideEvent = ITeamEvent & {
  __typename?: 'TeamHideEvent';
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Maybe<Scalars['UUID']['output']>;
};

export type TeamLeaguePayload = {
  __typename?: 'TeamLeaguePayload';
  leagueIds: Array<Scalars['UUID']['output']>;
  leagues: Maybe<Array<Maybe<League>>>;
  success: Scalars['Boolean']['output'];
  teamIds: Array<Scalars['UUID']['output']>;
  teams: Maybe<Array<Maybe<Team>>>;
};

export type TeamMatchSpecificGameStats = FortniteTeamMatchStats | LeagueOfLegendsTeamMatchStats | RocketLeagueTeamMatchStats | SmiteTeamMatchStats;

/** The stats for a team for a match */
export type TeamMatchStats = TeamStats & {
  __typename?: 'TeamMatchStats';
  fortniteStats: Maybe<FortniteTeamMatchStats>;
  fortniteTeamMatchStatsId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  leagueOfLegendsStats: Maybe<LeagueOfLegendsTeamMatchStats>;
  leagueOfLegendsTeamMatchStatsId: Maybe<Scalars['UUID']['output']>;
  matchId: Scalars['UUID']['output'];
  rocketLeagueStats: Maybe<RocketLeagueTeamMatchStats>;
  rocketLeagueTeamMatchStatsId: Maybe<Scalars['UUID']['output']>;
  smiteStats: Maybe<SmiteTeamMatchStats>;
  smiteTeamMatchStatsId: Maybe<Scalars['UUID']['output']>;
  stats: Maybe<TeamMatchSpecificGameStats>;
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  timePlayedInSeconds: Maybe<Scalars['Int']['output']>;
};

export type TeamMatchStatsFiltersInput = {
  matchId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TeamMatchStatsResult = {
  __typename?: 'TeamMatchStatsResult';
  results: Maybe<Array<TeamMatchStats>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type TeamMember = IUser & {
  __typename?: 'TeamMember';
  activatedLeagues: Maybe<Array<League>>;
  additionalInfo: Maybe<Scalars['String']['output']>;
  age: Maybe<Scalars['Int']['output']>;
  assignedSeasonalAwards: Maybe<Array<AssignedSeasonalPlayerAward>>;
  assignedWeeklyAwards: Maybe<Array<Maybe<AssignedWeeklyPlayerAward>>>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  banned: Maybe<Scalars['Boolean']['output']>;
  chatUserId: Maybe<Scalars['UUID']['output']>;
  content: Content;
  /** The US state within which the user resides */
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  currentVerification: Maybe<Verification>;
  dateOfBirth: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  detail: Maybe<UserDetail>;
  /** @deprecated Use roles instead, the caching will take care of performance issues */
  directRoles: Maybe<Array<UserRole>>;
  effectiveAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated https://playvs.atlassian.net/browse/ID-1709 */
  email: Maybe<Scalars['String']['output']>;
  /** @deprecated https://playvs.atlassian.net/browse/ID-1709 */
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  emails: Maybe<Array<UserEmail>>;
  enrolledAt: Maybe<Scalars['DateTime']['output']>;
  enrolledTeamsByMetaseasonId: Maybe<Array<Team>>;
  esportInterests: Maybe<Array<Esport>>;
  firstName: Maybe<Scalars['String']['output']>;
  gameHighlights: Maybe<Array<Maybe<GameHighlight>>>;
  /** The year that a user will graduate from high school */
  gradYear: Maybe<Scalars['Int']['output']>;
  gradYears: Array<UserGradYear>;
  /** @deprecated needs to be refactored */
  hasScholasticTeamsAtSchool: Maybe<Scalars['Boolean']['output']>;
  hmac: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isCaptain: Maybe<Scalars['Boolean']['output']>;
  isNotCoaching: Maybe<Scalars['Boolean']['output']>;
  isPhoneNumberVisible: Maybe<Scalars['Boolean']['output']>;
  isUnderage: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  lastSeen: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated No longer supported */
  league: Maybe<League>;
  leagueScope: Maybe<AllLeaguesResult>;
  leagues: Maybe<Array<League>>;
  managedTeams: Maybe<Array<Team>>;
  name: Maybe<Scalars['String']['output']>;
  onlineStatus: Maybe<OnlineStatus>;
  phaseStats: Maybe<Array<PlayerPhaseStats>>;
  phone: Maybe<Scalars['String']['output']>;
  phoneExt: Maybe<Scalars['String']['output']>;
  playerProfileSnapshot: Maybe<PlayerProfileSnapshot>;
  /** @deprecated No longer supported */
  position: Scalars['Int']['output'];
  positionId: Maybe<Scalars['UUID']['output']>;
  promotionalEmail: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  referralLinks: Maybe<UserReferralLinks>;
  referralToken: Scalars['String']['output'];
  referredUsers: Maybe<Array<User>>;
  referringUser: Maybe<User>;
  roleRequests: Maybe<Array<RoleRequest>>;
  /** @deprecated No longer supported */
  roleReviews: Maybe<Array<RoleReview>>;
  roles: Maybe<Array<UserRole>>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  schoolRoleStatus: Maybe<Array<RoleStatus>>;
  seasonPasses: Maybe<Array<UserSeasonPass>>;
  shortName: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  submissions: Maybe<Array<UserSchoolSubmission>>;
  team: Maybe<Team>;
  teamId: Maybe<Scalars['UUID']['output']>;
  teams: Maybe<Array<Team>>;
  teamsWherePrimaryCoach: Array<Team>;
  /** The user's preferred time zone for date/time localization, e.g. 'Africa/Johannesburg' */
  timeZone: Maybe<Scalars['String']['output']>;
  tosAcceptedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userDemographics: Maybe<UserDemographics>;
  userEsportPlatforms: Maybe<Array<UserEsportPlatform>>;
  userProviderAccounts: Maybe<Array<UserProviderAccount>>;
  userValidation: Maybe<UserValidation>;
  username: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  workEmail: Maybe<Scalars['String']['output']>;
};


export type TeamMemberAssignedSeasonalAwardsArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamMemberAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamMemberEnrolledTeamsByMetaseasonIdArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamMemberGradYearArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamMemberHasScholasticTeamsAtSchoolArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type TeamMemberLeagueArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


export type TeamMemberLeagueScopeArgs = {
  filters?: InputMaybe<LeagueFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamMemberLeaguesArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


export type TeamMemberManagedTeamsArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamMemberPhaseStatsArgs = {
  phaseId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamMemberRoleRequestsArgs = {
  filters?: InputMaybe<RoleRequestFilters>;
};


export type TeamMemberSchoolRoleStatusArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamMemberTeamArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type TeamMemberTeamsArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type TeamMemberTeamsWherePrimaryCoachArgs = {
  schoolId: Scalars['UUID']['input'];
};

export type TeamMutationPayload = {
  __typename?: 'TeamMutationPayload';
  team: Team;
};

export type TeamPayload = {
  __typename?: 'TeamPayload';
  success: Scalars['Boolean']['output'];
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
};

export type TeamPhaseRank = {
  __typename?: 'TeamPhaseRank';
  effectiveAt: Scalars['DateTime']['output'];
  phase: Phase;
  rank: Scalars['Int']['output'];
  team: Team;
};

export type TeamPhaseRecord = {
  __typename?: 'TeamPhaseRecord';
  phaseId: Maybe<Scalars['UUID']['output']>;
  phaseType: Maybe<PhaseType>;
  rank: Maybe<Scalars['Int']['output']>;
  record: TeamGameRecord;
  team: Team;
  teamId: Scalars['UUID']['output'];
};

export type TeamPhaseRecordResult = {
  __typename?: 'TeamPhaseRecordResult';
  result: Maybe<Array<TeamPhaseRecord>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type TeamPhaseSpecificGameStats = FortniteTeamPhaseStats | LeagueOfLegendsTeamPhaseStats | RocketLeagueTeamPhaseStats | SmiteTeamPhaseStats;

export type TeamPhaseStandings = {
  __typename?: 'TeamPhaseStandings';
  phaseId: Scalars['UUID']['output'];
  /** 0 index based ranking (0 highest - XXX lowest) */
  ranking: Maybe<Scalars['Int']['output']>;
  teamId: Scalars['UUID']['output'];
  /** Win/Loss/Draw record based on games played. */
  winLossRecord: Maybe<WinLossRecord>;
};

/** The stats for a team for a phase */
export type TeamPhaseStats = TeamStats & {
  __typename?: 'TeamPhaseStats';
  fortniteStats: Maybe<FortniteTeamPhaseStats>;
  fortniteTeamPhaseStatsId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  leagueOfLegendsStats: Maybe<LeagueOfLegendsTeamPhaseStats>;
  leagueOfLegendsTeamPhaseStatsId: Maybe<Scalars['UUID']['output']>;
  phaseId: Scalars['UUID']['output'];
  rocketLeagueStats: Maybe<RocketLeagueTeamPhaseStats>;
  rocketLeagueTeamPhaseStatsId: Maybe<Scalars['UUID']['output']>;
  smiteStats: Maybe<SmiteTeamPhaseStats>;
  smiteTeamPhaseStatsId: Maybe<Scalars['UUID']['output']>;
  stats: Maybe<TeamPhaseSpecificGameStats>;
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  timePlayedInSeconds: Maybe<Scalars['Int']['output']>;
};

export type TeamPhaseStatsFiltersInput = {
  phaseId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TeamPhaseStatsResult = {
  __typename?: 'TeamPhaseStatsResult';
  results: Maybe<Array<TeamPhaseStats>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type TeamPhaseSummary = {
  __typename?: 'TeamPhaseSummary';
  fortniteTeamRecord: Maybe<FortniteTeamRecord>;
  recentFortniteMatches: Maybe<Array<Match>>;
  recentGames: Maybe<Array<Game>>;
  record: Maybe<TeamGameRecord>;
  standings: Maybe<PhaseResult>;
};

export type TeamPlacement = {
  __typename?: 'TeamPlacement';
  placing: Scalars['Int']['output'];
  teamId: Scalars['UUID']['output'];
};

export type TeamPlayer = {
  __typename?: 'TeamPlayer';
  effectiveAt: Scalars['DateTime']['output'];
  isCaptain: Scalars['Boolean']['output'];
  teamId: Scalars['UUID']['output'];
  user: User;
};

export type TeamRegSeasonPhaseStandings = {
  __typename?: 'TeamRegSeasonPhaseStandings';
  hasClinchedPlayoffs: Maybe<Scalars['Boolean']['output']>;
  matchStreak: Maybe<Scalars['Int']['output']>;
  phaseId: Maybe<Scalars['UUID']['output']>;
  ranking: Maybe<Scalars['Int']['output']>;
  teamId: Scalars['UUID']['output'];
  winLossRecord: Maybe<WinLossRecord>;
};

export type TeamReputation = {
  __typename?: 'TeamReputation';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Maybe<Scalars['UUID']['output']>;
  reputationScore: Maybe<Scalars['Float']['output']>;
  seasonId: Maybe<Scalars['UUID']['output']>;
  teamId: Maybe<Scalars['UUID']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type TeamRestoreEvent = ITeamEvent & {
  __typename?: 'TeamRestoreEvent';
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Maybe<Scalars['UUID']['output']>;
};

export type TeamRival = {
  __typename?: 'TeamRival';
  acceptingTeam: Maybe<Team>;
  acceptingTeamId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  requestingTeam: Maybe<Team>;
  requestingTeamId: Scalars['UUID']['output'];
  season: Maybe<Season>;
  seasonId: Scalars['UUID']['output'];
  status: TeamRivalStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum TeamRivalStatus {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Denied = 'denied',
  Pending = 'pending',
  Removed = 'removed'
}

export type TeamRoster = {
  __typename?: 'TeamRoster';
  effectiveAt: Scalars['DateTime']['output'];
  formats: Array<TeamRosterFormat>;
  id: Scalars['UUID']['output'];
  isFull: Scalars['Boolean']['output'];
  maxNumPlayers: Scalars['Int']['output'];
  numPlayers: Scalars['Int']['output'];
  players: Array<TeamPlayer>;
  teamId: Scalars['UUID']['output'];
};

export type TeamRosterFormat = {
  __typename?: 'TeamRosterFormat';
  starters: Array<StarterPosition>;
  substitutes: Array<TeamPlayer>;
  teamSize: Scalars['Int']['output'];
};

export type TeamScheduleQueryInput = {
  bounds?: InputMaybe<ScheduleQueryBounds>;
  teamId: Scalars['UUID']['input'];
};

export type TeamScheduleResult = {
  __typename?: 'TeamScheduleResult';
  event: ScheduleEvent;
  team: ScheduleTeam;
};

export type TeamSchool = {
  __typename?: 'TeamSchool';
  schoolId: Scalars['UUID']['output'];
  teamId: Scalars['UUID']['output'];
};

export type TeamSchoolOptions = {
  schoolId: Scalars['UUID']['input'];
};

export type TeamSeason = {
  seasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type TeamSeasonPayload = {
  __typename?: 'TeamSeasonPayload';
  season: Maybe<Season>;
  seasonId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
};

export type TeamSlot = {
  __typename?: 'TeamSlot';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isUnfilledForBye: Maybe<Scalars['Boolean']['output']>;
  matchSlotId: Scalars['UUID']['output'];
  sourceMatchSlot: Maybe<MatchSlot>;
  sourceMatchSlotId: Maybe<Scalars['UUID']['output']>;
  sourceSeed: Maybe<Scalars['Int']['output']>;
  sourceTeamPlacing: Maybe<Scalars['Int']['output']>;
  team: Maybe<BracketMatchTeam>;
  type: TeamSlotType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum TeamSlotType {
  MatchOutcome = 'matchOutcome',
  Seed = 'seed'
}

export type TeamSortSpec = {
  fieldName: Scalars['String']['input'];
  fieldSortDir: Scalars['String']['input'];
};

export type TeamStats = {
  id: Scalars['UUID']['output'];
  teamId: Scalars['UUID']['output'];
  timePlayedInSeconds: Maybe<Scalars['Int']['output']>;
};

export type TeamStatsFiltersInput = {
  gameId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
};

export type TeamTransferSeason = {
  destinationSeasonId: Scalars['UUID']['input'];
  originSeasonId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};

export type TeamUnEnrollmentEvent = ITeamEvent & {
  __typename?: 'TeamUnEnrollmentEvent';
  league: Maybe<League>;
  leagueId: Maybe<Scalars['String']['output']>;
  metaseason: Maybe<Metaseason>;
  metaseasonId: Maybe<Scalars['String']['output']>;
  seasonId: Maybe<Scalars['String']['output']>;
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Maybe<Scalars['UUID']['output']>;
};

export type TeamUnHideEvent = ITeamEvent & {
  __typename?: 'TeamUnHideEvent';
  triggeredAt: Scalars['DateTime']['output'];
  triggeredBy: Maybe<User>;
  triggeredById: Maybe<Scalars['UUID']['output']>;
};

export type TeamUserPayload = {
  __typename?: 'TeamUserPayload';
  success: Scalars['Boolean']['output'];
  team: Maybe<Team>;
  teamId: Scalars['UUID']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type TeamsResult = {
  __typename?: 'TeamsResult';
  teams: Maybe<Array<Team>>;
  totalCount: Maybe<Scalars['Int']['output']>;
};

export type TimeComponents = {
  __typename?: 'TimeComponents';
  hour: Scalars['Int']['output'];
  minute: Scalars['Int']['output'];
  timezone: Maybe<Scalars['String']['output']>;
};

export enum Tour {
  FindYourMatch = 'findYourMatch',
  MatchLobby = 'matchLobby',
  Product = 'product'
}

export type TourViewedPayload = {
  __typename?: 'TourViewedPayload';
  success: Scalars['Boolean']['output'];
};

export type TrackNoResponseToQueueResponse = {
  __typename?: 'TrackNoResponseToQueueResponse';
  placeId: Scalars['String']['output'];
};

export type TransferPlayerInput = {
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type TransferSubstituteToTeamInput = {
  destinationPlayerId?: InputMaybe<Scalars['UUID']['input']>;
  destinationTeamId: Scalars['UUID']['input'];
  originPlayerId: Scalars['UUID']['input'];
  originTeamId: Scalars['UUID']['input'];
};

export type TransferSubstituteToTeamResult = {
  __typename?: 'TransferSubstituteToTeamResult';
  destinationTeam: Team;
  originTeam: Team;
};

export type TransferTeamsToSeasonInput = {
  teamsTransferSeasons: Array<TeamTransferSeason>;
};

export type TriggerRocketLeagueCallbackResult = {
  __typename?: 'TriggerRocketLeagueCallbackResult';
  error: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TwilioAccessTokenMetadata = {
  __typename?: 'TwilioAccessTokenMetadata';
  twilioAccessToken: Scalars['String']['output'];
  userId: Scalars['UUID']['output'];
};

export type TwitchData = {
  __typename?: 'TwitchData';
  liveStream: Maybe<TwitchLiveStream>;
  pastStreams: Maybe<Array<TwitchVideo>>;
};

export type TwitchLiveStream = {
  __typename?: 'TwitchLiveStream';
  esport: Maybe<Scalars['EsportSlug']['output']>;
  startedAt: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type TwitchStreamChangePayload = {
  __typename?: 'TwitchStreamChangePayload';
  success: Scalars['Boolean']['output'];
  twitchId: Scalars['String']['output'];
};

export type TwitchVideo = {
  __typename?: 'TwitchVideo';
  id: Maybe<Scalars['String']['output']>;
  publishedAt: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type UnSetUserEsportProviderInput = {
  esportSlug?: InputMaybe<Scalars['EsportSlug']['input']>;
  provider: Provider;
  userId: Scalars['UUID']['input'];
};

export type UnassignMatchAssignmentInput = {
  assignerId: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UnenrollTeamsFromSeasonInput = {
  teamSeasons: Array<TeamSeason>;
};

export type UnlinkRiotAccountPayload = {
  __typename?: 'UnlinkRiotAccountPayload';
  providerAccountIds: Array<Scalars['String']['output']>;
  providerAccountUsers: Array<Scalars['String']['output']>;
  riotAccountIds: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UnlinkSchoolProviderAccountSuccussPayload = {
  __typename?: 'UnlinkSchoolProviderAccountSuccussPayload';
  success: Scalars['Boolean']['output'];
  unlinkedSchoolProviderAccountId: Scalars['UUID']['output'];
};

export type UnlockLeagueInput = {
  metaseasonId: Scalars['UUID']['input'];
  newLeagueId: Scalars['UUID']['input'];
  oldLeagueId: Scalars['UUID']['input'];
  statesToMove: Array<Scalars['String']['input']>;
  teamIdsToMove: Array<Scalars['UUID']['input']>;
  vaSlugsToMove: Array<Scalars['String']['input']>;
};

export type UnopenedSlotLobbyDetails = {
  __typename?: 'UnopenedSlotLobbyDetails';
  lobbyOpensAt: Maybe<Scalars['DateTime']['output']>;
};

export type UpcomingMatchInput = {
  isScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt?: InputMaybe<UpcomingMatchInputStartsAtRange>;
  statuses?: InputMaybe<Array<MatchStatus>>;
};

export type UpcomingMatchInputStartsAtRange = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
};

export type UpcomingMatchResult = {
  __typename?: 'UpcomingMatchResult';
  result: Maybe<Array<Match>>;
  total: Maybe<Scalars['Int']['output']>;
};

export type UpdateAssignSeasonalPlayerAwardAttributes = {
  awardTypeId?: InputMaybe<Scalars['UUID']['input']>;
  coachId?: InputMaybe<Scalars['UUID']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateChannelMembersInput = {
  append?: InputMaybe<Scalars['Boolean']['input']>;
  canSendMessages?: InputMaybe<Scalars['Boolean']['input']>;
  channelId: Scalars['String']['input'];
  memberIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateEsportGroupAttributes = {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGameHighlightInput = {
  attributes: UpdateGameHighlightInputAttributes;
  id: Scalars['UUID']['input'];
};

export type UpdateGameHighlightInputAttributes = {
  matchId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<GameHighlightSource>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGameHighlightPayload = {
  __typename?: 'UpdateGameHighlightPayload';
  gameHighlight: Maybe<GameHighlight>;
};

export type UpdateGameInput = {
  entryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  ordinalNumber?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<GameStatus>;
};

export type UpdateGamePayload = {
  __typename?: 'UpdateGamePayload';
  game: Maybe<Game>;
};

export type UpdateGameResultInput = {
  id: Scalars['UUID']['input'];
  placing?: InputMaybe<Scalars['Int']['input']>;
  sidePlayed?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGameResultPayload = {
  __typename?: 'UpdateGameResultPayload';
  gameResult: Maybe<GameResult>;
};

export type UpdateLeagueGroupInput = {
  competitionGroup?: InputMaybe<CompetitionGroup>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateAssociationSlug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LeagueType>;
  varsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeagueInput = {
  canHaveMultipleTeamsWithSamePlayers?: InputMaybe<Scalars['Boolean']['input']>;
  canRemovePlayersFromTeams?: InputMaybe<Scalars['Boolean']['input']>;
  checkInCloseTimeOffsetMilliseconds?: InputMaybe<Scalars['Int']['input']>;
  checkInOpenDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  checkInOpenTime?: InputMaybe<Scalars['String']['input']>;
  competitionGroup?: InputMaybe<CompetitionGroup>;
  competitionModel?: InputMaybe<CompetitionModel>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isCheckInEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  lockTeamsToSchool?: InputMaybe<Scalars['Boolean']['input']>;
  maxTeamsPerPlayer?: InputMaybe<Scalars['Int']['input']>;
  minutesBeforeMatchToLockInSeries?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publicSlug?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  teamFormat?: InputMaybe<Scalars['Int']['input']>;
  teamMaxSize?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LeagueType>;
  varsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeaguePayload = {
  __typename?: 'UpdateLeaguePayload';
  league: Maybe<League>;
};

export type UpdateLinkInput = {
  id: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type UpdateLobbyInput = {
  pickType: RiotApiPickType;
};

export type UpdateLobbyPayload = {
  __typename?: 'UpdateLobbyPayload';
  success: Scalars['Boolean']['output'];
  tournamentCode: Scalars['String']['output'];
};

export type UpdateMatchChatEventInput = {
  changesTo?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  esportId?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  object?: InputMaybe<Scalars['String']['input']>;
  sendMessage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMatchInput = {
  bestOf?: InputMaybe<Scalars['Int']['input']>;
  disqualifyAfter?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  isScrimmage?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduledStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  slotId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<MatchStatus>;
};

export type UpdateMatchPayload = {
  __typename?: 'UpdateMatchPayload';
  match: Maybe<Match>;
};

export type UpdateMatchResultInput = {
  gamesLost?: InputMaybe<Scalars['Int']['input']>;
  gamesLostByForfeit?: InputMaybe<Scalars['Int']['input']>;
  gamesPlayed?: InputMaybe<Scalars['Int']['input']>;
  gamesTied?: InputMaybe<Scalars['Int']['input']>;
  gamesWon?: InputMaybe<Scalars['Int']['input']>;
  gamesWonByForfeit?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  placing?: InputMaybe<Scalars['Int']['input']>;
  seriesLost?: InputMaybe<Scalars['Int']['input']>;
  seriesLostByForfeit?: InputMaybe<Scalars['Int']['input']>;
  seriesPlayed?: InputMaybe<Scalars['Int']['input']>;
  seriesTied?: InputMaybe<Scalars['Int']['input']>;
  seriesWon?: InputMaybe<Scalars['Int']['input']>;
  seriesWonByForfeit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMatchResultPayload = {
  __typename?: 'UpdateMatchResultPayload';
  matchResult: Maybe<MatchResult>;
};

export type UpdateMetaseasonInput = {
  competitionGroup?: InputMaybe<CompetitionGroup>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  isInitialMetaseason?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previousMetaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  promotionEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  promotionStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SeasonStatus>;
};

export type UpdateParentPayload = {
  __typename?: 'UpdateParentPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdatePhaseInput = {
  autoScheduleBracket?: InputMaybe<Scalars['Boolean']['input']>;
  bestOf?: InputMaybe<Scalars['Int']['input']>;
  bracketSize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  format?: InputMaybe<PhaseFormat>;
  fortniteEventId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  maxSlotParticipation?: InputMaybe<Scalars['Int']['input']>;
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  minSlotParticipation?: InputMaybe<Scalars['Int']['input']>;
  minutesBeforeMatchToLockInSeries?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  shouldSendPlayoffNotification?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<PhaseStatus>;
  survivalAdvancementCount?: InputMaybe<Scalars['Int']['input']>;
  survivalAdvancementPercentage?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<PhaseType>;
};

export type UpdatePhasePayload = {
  __typename?: 'UpdatePhasePayload';
  phase: Phase;
};

export type UpdatePhaseResultInput = {
  gameStreak?: InputMaybe<Scalars['Int']['input']>;
  gamesLost?: InputMaybe<Scalars['Int']['input']>;
  gamesLostByForfeit?: InputMaybe<Scalars['Int']['input']>;
  gamesPlayed?: InputMaybe<Scalars['Int']['input']>;
  gamesTied?: InputMaybe<Scalars['Int']['input']>;
  gamesWon?: InputMaybe<Scalars['Int']['input']>;
  gamesWonByForfeit?: InputMaybe<Scalars['Int']['input']>;
  hasClinchedPlayoffs?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  matchStreak?: InputMaybe<Scalars['Int']['input']>;
  matchesLost?: InputMaybe<Scalars['Int']['input']>;
  matchesLostByForfeit?: InputMaybe<Scalars['Int']['input']>;
  matchesPlayed?: InputMaybe<Scalars['Int']['input']>;
  matchesTied?: InputMaybe<Scalars['Int']['input']>;
  matchesWon?: InputMaybe<Scalars['Int']['input']>;
  matchesWonByBye?: InputMaybe<Scalars['Int']['input']>;
  matchesWonByForfeit?: InputMaybe<Scalars['Int']['input']>;
  phasePoints?: InputMaybe<Scalars['Int']['input']>;
  phaseTiebreakerPoints?: InputMaybe<Scalars['Int']['input']>;
  seriesLost?: InputMaybe<Scalars['Int']['input']>;
  seriesLostByForfeit?: InputMaybe<Scalars['Int']['input']>;
  seriesPlayed?: InputMaybe<Scalars['Int']['input']>;
  seriesTied?: InputMaybe<Scalars['Int']['input']>;
  seriesWon?: InputMaybe<Scalars['Int']['input']>;
  seriesWonByForfeit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePhaseResultPayload = {
  __typename?: 'UpdatePhaseResultPayload';
  phaseResult: Maybe<PhaseResult>;
};

export type UpdatePhaseScheduleInput = {
  bestOf?: InputMaybe<Scalars['Int']['input']>;
  bracketSize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  format?: InputMaybe<PhaseFormat>;
  fortniteEventId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  introText?: InputMaybe<Scalars['String']['input']>;
  matchRescheduleEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  shouldSendPlayoffNotification?: InputMaybe<Scalars['Boolean']['input']>;
  slots?: InputMaybe<Array<SlotScheduleInput>>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<PhaseStatus>;
  totalRounds?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<PhaseType>;
};

export type UpdateProductAttributes = {
  description?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  isAdminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seatCount?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProviderPayload = {
  __typename?: 'UpdateProviderPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateRiotAccountPayload = {
  __typename?: 'UpdateRiotAccountPayload';
  gameName: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tagLine: Scalars['String']['output'];
};

export type UpdateRoleMembersInput = {
  append?: InputMaybe<Scalars['Boolean']['input']>;
  memberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roleName: Scalars['String']['input'];
};

export type UpdateSchoolAddressInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type UpdateSchoolEnrollmentInput = {
  planType: Scalars['String']['input'];
  productIdOverride?: InputMaybe<Scalars['UUID']['input']>;
  schoolId: Scalars['UUID']['input'];
  seasons: Scalars['String']['input'];
  seatCount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSchoolsPayload = {
  __typename?: 'UpdateSchoolsPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateSeasonDatesTemplateInput = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  playerDeregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  playerRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  registrationStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  rostersLockAt?: InputMaybe<Scalars['DateTime']['input']>;
  slotExclusionRangeConfigurations?: InputMaybe<Array<SeasonUpdateOrCreateSlotExclusionRangeConfigurationInput>>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  suggestedRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamDeregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateSeasonScheduleInput = {
  areBreakWeekSlotExclusionWindowsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  deregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventConfig?: InputMaybe<EventConfigInput>;
  leagueId?: InputMaybe<Scalars['UUID']['input']>;
  maxTeamsPerSchool?: InputMaybe<Scalars['Int']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overridePlayoffGenerationDate?: InputMaybe<Scalars['DateTime']['input']>;
  overridePlayoffSeedingDate?: InputMaybe<Scalars['DateTime']['input']>;
  phases?: InputMaybe<Array<UpdatePhaseScheduleInput>>;
  playerDeregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  playerRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  playvsScoreEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  registrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  registrationStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  rostersLockAt?: InputMaybe<Scalars['DateTime']['input']>;
  seasonPlayoffTemplateId?: InputMaybe<Scalars['String']['input']>;
  slotExclusionRangeConfigurations?: InputMaybe<Array<SeasonUpdateOrCreateSlotExclusionRangeConfigurationInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SeasonStatus>;
  suggestedRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamDeregistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  teamRegistrationEndsAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<SeasonType>;
};

export type UpdateSeasonalPlayerAwardInput = {
  attributes: UpdateAssignSeasonalPlayerAwardAttributes;
  id: Scalars['UUID']['input'];
};

export type UpdateSeasonalPlayerAwardTypeAttributes = {
  description?: InputMaybe<Scalars['String']['input']>;
  templatePdfUrl?: InputMaybe<Scalars['String']['input']>;
  templateSharableImageUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSeasonalPlayerAwardTypeInput = {
  attributes: UpdateSeasonalPlayerAwardTypeAttributes;
  id: Scalars['UUID']['input'];
};

export type UpdateSlotExclusionRangeConfigurationAttributes = {
  defaultsAppliedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxSlotExclusions?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<SlotExclusionRangeConfigurationDateRangeInput>;
};

export type UpdateSlotExclusionRangeConfigurationInput = {
  attributes: UpdateSlotExclusionRangeConfigurationAttributes;
  id: Scalars['UUID']['input'];
};

export type UpdateSlotExclusionRangeConfigurationResult = {
  __typename?: 'UpdateSlotExclusionRangeConfigurationResult';
  configuration: SlotExclusionRangeConfiguration;
};

export type UpdateSlotExclusionWindowError = {
  __typename?: 'UpdateSlotExclusionWindowError';
  message: Scalars['String']['output'];
};

export type UpdateSlotExclusionWindowPayload = {
  __typename?: 'UpdateSlotExclusionWindowPayload';
  errors: Maybe<Array<UpdateSlotExclusionWindowError>>;
  slotExclusionWindow: Maybe<SlotExclusionWindow>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSlotInput = {
  bestOf?: InputMaybe<Scalars['Int']['input']>;
  fortniteEventWindowId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isStartsAtHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  scheduleMatchesAt?: InputMaybe<Scalars['DateTime']['input']>;
  seriesBestOf?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SlotStatus>;
};

export type UpdateSlotPayload = {
  __typename?: 'UpdateSlotPayload';
  slot: Slot;
};

export type UpdateSpinSchoolPayload = {
  __typename?: 'UpdateSpinSchoolPayload';
  platinumExpiresAt: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateTeamInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserRoleStatusInput = {
  resourceId: Scalars['UUID']['input'];
  roleName: UserRoleName;
  status: UserRoleStatusName;
  userId: Scalars['UUID']['input'];
};

export type UpdateVarsityAssociationInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  competitionGroup?: InputMaybe<CompetitionGroup>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWeeklyAssignedPlayerAwardInput = {
  id: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type UploadEsportFileInput = {
  esportSlug: Scalars['EsportSlug']['input'];
  file: Scalars['Upload']['input'];
};

export type UploadEsportFileResult = {
  __typename?: 'UploadEsportFileResult';
  fileUrl: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UploadSelectionOptionAssetPayload = {
  __typename?: 'UploadSelectionOptionAssetPayload';
  assetUri: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UploadTeamAvatarInput = {
  avatar: Scalars['Upload']['input'];
  teamId: Scalars['UUID']['input'];
};

export enum UsStateCode {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type User = IUser & {
  __typename?: 'User';
  activatedLeagues: Maybe<Array<League>>;
  additionalInfo: Maybe<Scalars['String']['output']>;
  age: Maybe<Scalars['Int']['output']>;
  assignedSeasonalAwards: Maybe<Array<AssignedSeasonalPlayerAward>>;
  assignedWeeklyAwards: Maybe<Array<Maybe<AssignedWeeklyPlayerAward>>>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  banned: Maybe<Scalars['Boolean']['output']>;
  chatUserId: Maybe<Scalars['UUID']['output']>;
  content: Content;
  /** The US state within which the user resides */
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  currentVerification: Maybe<Verification>;
  dateOfBirth: Maybe<Scalars['String']['output']>;
  detail: Maybe<UserDetail>;
  /** @deprecated Use roles instead, the caching will take care of performance issues */
  directRoles: Maybe<Array<UserRole>>;
  /** @deprecated https://playvs.atlassian.net/browse/ID-1709 */
  email: Maybe<Scalars['String']['output']>;
  /** @deprecated https://playvs.atlassian.net/browse/ID-1709 */
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  emails: Maybe<Array<UserEmail>>;
  enrolledAt: Maybe<Scalars['DateTime']['output']>;
  enrolledTeamsByMetaseasonId: Maybe<Array<Team>>;
  esportInterests: Maybe<Array<Esport>>;
  firstName: Maybe<Scalars['String']['output']>;
  gameHighlights: Maybe<Array<Maybe<GameHighlight>>>;
  /** The year that a user will graduate from high school */
  gradYear: Maybe<Scalars['Int']['output']>;
  gradYears: Array<UserGradYear>;
  hasMultiorgAccess: Scalars['Boolean']['output'];
  /** @deprecated needs to be refactored */
  hasScholasticTeamsAtSchool: Maybe<Scalars['Boolean']['output']>;
  hmac: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isNotCoaching: Maybe<Scalars['Boolean']['output']>;
  isParent: Scalars['Boolean']['output'];
  isPhoneNumberVisible: Maybe<Scalars['Boolean']['output']>;
  isUnderage: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  lastSeen: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated No longer supported */
  league: Maybe<League>;
  leagueScope: Maybe<AllLeaguesResult>;
  leagues: Maybe<Array<League>>;
  managedTeams: Maybe<Array<Team>>;
  name: Maybe<Scalars['String']['output']>;
  onlineStatus: Maybe<OnlineStatus>;
  parent: Maybe<User>;
  parentRole: Maybe<UserRole>;
  phaseStats: Maybe<Array<PlayerPhaseStats>>;
  phone: Maybe<Scalars['String']['output']>;
  phoneExt: Maybe<Scalars['String']['output']>;
  playerProfileSnapshot: Maybe<PlayerProfileSnapshot>;
  promotionalEmail: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  referralLinks: Maybe<UserReferralLinks>;
  referralToken: Scalars['String']['output'];
  referredUsers: Maybe<Array<User>>;
  referringUser: Maybe<User>;
  roleRequests: Maybe<Array<RoleRequest>>;
  /** @deprecated No longer supported */
  roleReviews: Maybe<Array<RoleReview>>;
  roles: Maybe<Array<UserRole>>;
  school: Maybe<School>;
  schoolId: Maybe<Scalars['UUID']['output']>;
  schoolRoleStatus: Maybe<Array<RoleStatus>>;
  seasonPasses: Maybe<Array<UserSeasonPass>>;
  shortName: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  submissions: Maybe<Array<UserSchoolSubmission>>;
  team: Maybe<Team>;
  teams: Maybe<Array<Team>>;
  teamsWherePrimaryCoach: Array<Team>;
  /** The user's preferred time zone for date/time localization, e.g. 'Africa/Johannesburg' */
  timeZone: Maybe<Scalars['String']['output']>;
  tosAcceptedAt: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userDemographics: Maybe<UserDemographics>;
  userEsportPlatforms: Maybe<Array<UserEsportPlatform>>;
  userProviderAccounts: Maybe<Array<UserProviderAccount>>;
  userValidation: Maybe<UserValidation>;
  username: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  workEmail: Maybe<Scalars['String']['output']>;
};


export type UserAssignedSeasonalAwardsArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type UserAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type UserEnrolledTeamsByMetaseasonIdArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type UserGradYearArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type UserHasScholasticTeamsAtSchoolArgs = {
  schoolId: Scalars['UUID']['input'];
};


export type UserLeagueArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


export type UserLeagueScopeArgs = {
  filters?: InputMaybe<LeagueFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserLeaguesArgs = {
  metaseasonId: Scalars['UUID']['input'];
};


export type UserManagedTeamsArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type UserPhaseStatsArgs = {
  phaseId?: InputMaybe<Scalars['UUID']['input']>;
};


export type UserRoleRequestsArgs = {
  filters?: InputMaybe<RoleRequestFilters>;
};


export type UserSchoolRoleStatusArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type UserTeamArgs = {
  seasonId: Scalars['UUID']['input'];
};


export type UserTeamsArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};


export type UserTeamsWherePrimaryCoachArgs = {
  schoolId: Scalars['UUID']['input'];
};

export type UserAccountAndPlatformInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Platform>;
};

export type UserAddedToMatchChatMetadata = {
  __typename?: 'UserAddedToMatchChatMetadata';
  newChatParticipants: Maybe<Array<Maybe<ChatParticipant>>>;
  userId: Scalars['UUID']['output'];
};

export type UserAttributes = {
  __typename?: 'UserAttributes';
  /** @deprecated No longer supported */
  hasActiveSchool: Maybe<Scalars['Boolean']['output']>;
  hasCompletedOnboardingSurvey: Maybe<Scalars['Boolean']['output']>;
  hasEverParticipated: Maybe<Scalars['Boolean']['output']>;
  hasManageTeams: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isParticipating: Maybe<Scalars['Boolean']['output']>;
  isParticipatingInMetaseason: Maybe<Scalars['Boolean']['output']>;
  metaseasonId: Maybe<Scalars['UUID']['output']>;
  missingFieldsAtAppLaunch: Maybe<Array<UserRequiredFieldsAtAppLaunch>>;
};


export type UserAttributesHasManageTeamsArgs = {
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
};


export type UserAttributesIsParticipatingInMetaseasonArgs = {
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserChildrenPayload = {
  __typename?: 'UserChildrenPayload';
  userIds: Array<Scalars['UUID']['output']>;
  users: Array<User>;
};

export type UserConsent = {
  __typename?: 'UserConsent';
  consentedForUserId: Maybe<Scalars['UUID']['output']>;
  consentingUserId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
};

export type UserConsumptionInput = {
  consumedAt: Scalars['DateTime']['input'];
  matchId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type UserDemographics = {
  __typename?: 'UserDemographics';
  gender: Gender;
  race: Array<Race>;
};

export type UserDemographicsInput = {
  gender: Gender;
  race: Array<Race>;
};

export type UserDetail = {
  __typename?: 'UserDetail';
  facultyRole: Maybe<Scalars['String']['output']>;
};

export type UserEmail = {
  __typename?: 'UserEmail';
  activeUpdateRequest: Maybe<EmailUpdateRequest>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isSchoolEmail: Scalars['Boolean']['output'];
  isVerified: Maybe<Scalars['Boolean']['output']>;
  oauthProviders: Maybe<Array<OAuthProvider>>;
  /** @deprecated use isSchoolEmail instead */
  schoolId: Maybe<Scalars['UUID']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['UUID']['output'];
};

export type UserEmailInputAttributes = {
  email: Scalars['String']['input'];
  isSchoolEmail: Scalars['Boolean']['input'];
};

export type UserEsportPlatform = {
  __typename?: 'UserEsportPlatform';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  esportId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  platform: Platform;
  platformUsername: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['UUID']['output'];
};

export type UserEsportProvider = {
  __typename?: 'UserEsportProvider';
  esportSlug: Scalars['EsportSlug']['output'];
  id: Scalars['UUID']['output'];
  provider: Provider;
  userId: Scalars['UUID']['output'];
};

export type UserFiltersInput = {
  battleNetTag?: InputMaybe<Scalars['String']['input']>;
  competitionGroup?: InputMaybe<CompetitionGroup>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  epicDisplayName?: InputMaybe<Scalars['String']['input']>;
  epicId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nintendoFriendCode?: InputMaybe<Scalars['String']['input']>;
  psnUsername?: InputMaybe<Scalars['String']['input']>;
  riotGameName?: InputMaybe<Scalars['String']['input']>;
  riotTagLine?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<UserRoleFiltersInput>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  smitePlayerName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  username?: InputMaybe<Scalars['String']['input']>;
  xboxLiveGamertag?: InputMaybe<Scalars['String']['input']>;
};

export type UserGradYear = {
  __typename?: 'UserGradYear';
  gradYear: Scalars['Int']['output'];
  schoolId: Scalars['UUID']['output'];
};

export type UserIpLocation = {
  __typename?: 'UserIPLocation';
  city: Scalars['String']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
};

export type UserLead = {
  __typename?: 'UserLead';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
  referredUserId: Maybe<Scalars['String']['output']>;
  schoolId: Scalars['String']['output'];
  schoolRoleName: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  submittedByUserId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserLeadInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  schoolId: Scalars['UUID']['input'];
  schoolRoleName?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
};

export type UserLeadPayload = {
  __typename?: 'UserLeadPayload';
  success: Scalars['Boolean']['output'];
  userLead: Maybe<UserLead>;
  userLeadId: Scalars['UUID']['output'];
};

export type UserNotification = ObjectIdNode & {
  __typename?: 'UserNotification';
  contentData: UserNotificationContentData;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  openedAt: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
};

export type UserNotificationContentData = {
  __typename?: 'UserNotificationContentData';
  glyph: Maybe<Scalars['String']['output']>;
  image1: Maybe<Scalars['String']['output']>;
  image2: Maybe<Scalars['String']['output']>;
  invoke: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  messageDates: Maybe<Array<Scalars['DateTime']['output']>>;
  rating: Maybe<EsportRating>;
  team1Id: Maybe<Scalars['String']['output']>;
  team2Id: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  category: NotificationCategory;
  enabled: Scalars['Boolean']['output'];
  isPersonalEmail: Maybe<Scalars['Boolean']['output']>;
  scope: Maybe<NotificationScope>;
  userEmail: Maybe<UserEmail>;
};

export enum UserNotificationStatus {
  Acked = 'acked',
  Dismissed = 'dismissed',
  Pending = 'pending'
}

export type UserNotifications = {
  __typename?: 'UserNotifications';
  id: Scalars['UUID']['output'];
  notifications: Maybe<UserNotificationsNotificationsPaginatedResults>;
  unreadCount: Scalars['Int']['output'];
};


export type UserNotificationsNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type UserNotificationsNotificationsPaginatedResults = ObjectIdPaginatedResults & {
  __typename?: 'UserNotificationsNotificationsPaginatedResults';
  edges: Array<UserNotificationsNotificationsPaginatedResultsEdge>;
  pageInfo: PageInfo;
};

export type UserNotificationsNotificationsPaginatedResultsEdge = ObjectIdEdge & {
  __typename?: 'UserNotificationsNotificationsPaginatedResultsEdge';
  cursor: Scalars['String']['output'];
  node: UserNotification;
};

export type UserNotificationsPayload = {
  __typename?: 'UserNotificationsPayload';
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
  userNotificationIds: Array<Scalars['UUID']['output']>;
  userNotifications: Maybe<Array<Maybe<LegacyUserNotification>>>;
};

export type UserPayload = {
  __typename?: 'UserPayload';
  success: Scalars['Boolean']['output'];
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type UserProviderAccount = {
  __typename?: 'UserProviderAccount';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  providerAccountId: Maybe<Scalars['String']['output']>;
  providerDisplayName: Maybe<Scalars['String']['output']>;
  providerIntegrationType: Maybe<IntegrationType>;
  providerName: Scalars['String']['output'];
  providerOnboardUrl: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['UUID']['output'];
};

export type UserProviderAccountPayload = {
  __typename?: 'UserProviderAccountPayload';
  success: Scalars['Boolean']['output'];
  userProviderAccount: Maybe<UserProviderAccount>;
  userProviderAccountId: Scalars['UUID']['output'];
};

export type UserProviderAccountsForUserInput = {
  userId: Scalars['UUID']['input'];
};

export type UserReferralLinks = {
  __typename?: 'UserReferralLinks';
  fac: Scalars['String']['output'];
  student: Scalars['String']['output'];
};

export enum UserRequiredFieldsAtAppLaunch {
  BillingContact = 'billingContact',
  DateOfBirth = 'dateOfBirth',
  DemographicData = 'demographicData',
  Name = 'name',
  SchoolEmail = 'schoolEmail',
  SchoolProduct = 'schoolProduct'
}

export type UserRole = {
  __typename?: 'UserRole';
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  resourceId: Scalars['UUID']['output'];
  resourceType: ResourceType;
  roleName: UserRoleName;
  status: UserRoleStatusName;
  userId: Scalars['UUID']['output'];
};

export type UserRoleFiltersInput = {
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserRoleInput = {
  role: UserRoleName;
};

export enum UserRoleName {
  Admin = 'admin',
  Captain = 'captain',
  Coach = 'coach',
  Cx = 'cx',
  Fac = 'fac',
  Owner = 'owner',
  Parent = 'parent',
  Player = 'player',
  PrimaryCoach = 'primary_coach',
  Student = 'student',
  User = 'user'
}

export enum UserRoleStatusName {
  Approved = 'approved',
  Denied = 'denied',
  Graduated = 'graduated',
  Invited = 'invited',
  Pending = 'pending',
  Transferred = 'transferred'
}

export type UserRoleUpdateInput = {
  overrideLastCoachChecks?: InputMaybe<Scalars['Boolean']['input']>;
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  userRoleName: UserRoleName;
};

export type UserScheduleQueryInput = {
  bounds?: InputMaybe<ScheduleQueryBounds>;
  userId: Scalars['UUID']['input'];
};

export type UserScheduleQueryPayload = {
  __typename?: 'UserScheduleQueryPayload';
  results: Array<TeamScheduleResult>;
};

export type UserSchoolRole = {
  __typename?: 'UserSchoolRole';
  role: Role;
  school: School;
  schoolId: Scalars['UUID']['output'];
};

export type UserSchoolRolesPayload = {
  __typename?: 'UserSchoolRolesPayload';
  roles: Array<UserSchoolRole>;
};

/** A faculty's school onboarding data */
export type UserSchoolSubmission = {
  __typename?: 'UserSchoolSubmission';
  createdAt: Scalars['DateTime']['output'];
  detail: UserSchoolSubmissionDetail;
  id: Scalars['UUID']['output'];
  isArchived: Maybe<Scalars['Boolean']['output']>;
  isRead: Maybe<Scalars['Boolean']['output']>;
  school: School;
  schoolId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type UserSchoolSubmissionDetail = {
  __typename?: 'UserSchoolSubmissionDetail';
  isInterestedInFall2019: Maybe<Scalars['String']['output']>;
  isInterestedInFall2020: Maybe<Scalars['String']['output']>;
  isInterestedInSpring2020: Maybe<Scalars['String']['output']>;
  needsHelpWithApproval: Maybe<Scalars['String']['output']>;
};

export type UserSeasonPass = {
  __typename?: 'UserSeasonPass';
  consumedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  league: Maybe<League>;
  leagueId: Maybe<Scalars['UUID']['output']>;
  metaseason: Maybe<Metaseason>;
  metaseasonId: Scalars['UUID']['output'];
  product: Maybe<Product>;
  productGrants: Maybe<Array<ProductGrant>>;
  productInstance: Maybe<ProductInstance>;
  productInstanceId: Scalars['UUID']['output'];
  redeemed: Maybe<Scalars['Boolean']['output']>;
  user: Maybe<User>;
  userId: Scalars['UUID']['output'];
};

export type UserSeasonPassPayload = {
  __typename?: 'UserSeasonPassPayload';
  productInstanceId: Maybe<Scalars['UUID']['output']>;
  success: Scalars['Boolean']['output'];
  userId: Maybe<Scalars['UUID']['output']>;
};

export type UserSeasonsResult = {
  __typename?: 'UserSeasonsResult';
  seasonIds: Array<Scalars['UUID']['output']>;
  seasons: Maybe<Array<Maybe<Season>>>;
};

export type UserTaskPayload = {
  __typename?: 'UserTaskPayload';
  id: Scalars['UUID']['output'];
  state: TaskState;
  type: Scalars['String']['output'];
};

export type UserTourPayload = {
  __typename?: 'UserTourPayload';
  tour: Tour;
  userId: Scalars['String']['output'];
  viewedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum UserUnableToJoinEventReason {
  MaxTeamsReached = 'MaxTeamsReached',
  UserBelowMinAge = 'UserBelowMinAge',
  UserExceedsMaxAge = 'UserExceedsMaxAge'
}

/** A Users Validation status. */
export type UserValidation = {
  __typename?: 'UserValidation';
  userId: Scalars['UUID']['output'];
  validationStatus: UserRoleStatusName;
  verification: Maybe<Verification>;
};

export type UserWithOnlineStatus = {
  __typename?: 'UserWithOnlineStatus';
  lastSeen: Scalars['DateTime']['output'];
  minutesSinceLastSeen: Scalars['Int']['output'];
  onlineStatus: Maybe<OnlineStatus>;
  userId: Scalars['String']['output'];
};

export type UsersPayload = {
  __typename?: 'UsersPayload';
  success: Scalars['Boolean']['output'];
  userIds: Array<Scalars['UUID']['output']>;
};

export type UsersResult = {
  __typename?: 'UsersResult';
  totalCount: Maybe<Scalars['Int']['output']>;
  users: Maybe<Array<User>>;
};

export type UsersSeasonPassConsumedPayload = {
  __typename?: 'UsersSeasonPassConsumedPayload';
  firstJobId: Maybe<Scalars['String']['output']>;
  lastJobId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type VsError = {
  __typename?: 'VSError';
  message: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  stack: Maybe<Scalars['String']['output']>;
};

export type ValidPlayerOnPlatform = {
  __typename?: 'ValidPlayerOnPlatform';
  accountId: Scalars['String']['output'];
  platform: Platform;
  valid: Scalars['Boolean']['output'];
};

export type ValidPlayerResponse = {
  __typename?: 'ValidPlayerResponse';
  accountId: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type ValidateScholasticRoleAttributes = {
  roleName: UserRoleName;
  schoolId: Scalars['UUID']['input'];
};

export type VarsityAssociation = {
  __typename?: 'VarsityAssociation';
  abbreviation: Scalars['String']['output'];
  competitionGroup: CompetitionGroup;
  enrolledSchoolsCount: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
};

export type VarsityAssociationFiltersInput = {
  abbreviations?: InputMaybe<Array<Scalars['String']['input']>>;
  competitionGroups?: InputMaybe<Array<CompetitionGroup>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VarsityAssociationFiltersResult = {
  __typename?: 'VarsityAssociationFiltersResult';
  abbreviations: Maybe<Array<Scalars['String']['output']>>;
  competitionGroups: Maybe<Array<CompetitionGroup>>;
  names: Maybe<Array<Scalars['String']['output']>>;
  slugs: Maybe<Array<Scalars['String']['output']>>;
  states: Maybe<Array<Scalars['String']['output']>>;
};

export type Verification = {
  __typename?: 'Verification';
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated No longer supported */
  denialReason: Maybe<Scalars['String']['output']>;
  errors: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  method: VerificationMethod;
  step: VerificationStep;
  updatedAt: Scalars['DateTime']['output'];
};

export enum VerificationMethod {
  CollegeStudentAutoVerify = 'collegeStudentAutoVerify',
  Internal = 'internal',
  Manual = 'manual',
  OrganizationDenied = 'organizationDenied',
  SheerId = 'sheerId'
}

export enum VerificationStep {
  CollectStudentPersonalInfo = 'collectStudentPersonalInfo',
  CollectTeacherPersonalInfo = 'collectTeacherPersonalInfo',
  DocUpload = 'docUpload',
  Error = 'error',
  Pending = 'pending',
  SheerIdExpired = 'sheerIdExpired',
  SmsLoop = 'smsLoop',
  Success = 'success'
}

export type VerifyArchivedPlayerInput = {
  resourceId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type VerifyCoachInput = {
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type VerifyCoachUsingSheerIdPayload = {
  __typename?: 'VerifyCoachUsingSheerIdPayload';
  sheerIdResult: Maybe<SheerIdResult>;
  success: Scalars['Boolean']['output'];
  userId: Scalars['UUID']['output'];
};

export type VerifyGameInput = {
  gameId: Scalars['UUID']['input'];
};

export type VerifyPasswordResetInput = {
  email: Scalars['String']['input'];
  vcode: Scalars['String']['input'];
};

export type WeeklyDateComponents = {
  __typename?: 'WeeklyDateComponents';
  dayOfWeek: Scalars['Int']['output'];
  time: TimeComponents;
  timezone: Maybe<Scalars['String']['output']>;
};

export type WeeklySlotDateEstimate = {
  __typename?: 'WeeklySlotDateEstimate';
  components: WeeklyDateComponents;
  sample: Scalars['DateTime']['output'];
};

export enum WhoPays {
  School = 'school',
  Students = 'students'
}

export type WinLossRecord = {
  __typename?: 'WinLossRecord';
  gamesLost: Scalars['Int']['output'];
  gamesTied: Scalars['Int']['output'];
  gamesWon: Scalars['Int']['output'];
  matchesLost: Scalars['Int']['output'];
  matchesTied: Scalars['Int']['output'];
  matchesWon: Scalars['Int']['output'];
};

export type CreateMatchDisputeRequestInput = {
  evidence?: InputMaybe<Array<DisputeEvidenceMap>>;
  matchId: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  reason: MatchDisputeReason;
  teamId: Scalars['String']['input'];
};

export type FindEligibleVarsityAssociationsInput = {
  competitionGroup: CompetitionGroup;
  state: Scalars['String']['input'];
};

export type FindEligibleVarsityAssociationsPayload = {
  __typename?: 'findEligibleVarsityAssociationsPayload';
  competitionGroup: Maybe<CompetitionGroup>;
  state: Maybe<Scalars['String']['output']>;
};

export type GetUserNotificationsSettingsInput = {
  userId: Scalars['UUID']['input'];
};

export type GetUserNotificationsSettingsPayload = {
  __typename?: 'getUserNotificationsSettingsPayload';
  success: Scalars['Boolean']['output'];
  userNotificationSettings: Maybe<Array<Maybe<UserNotificationSetting>>>;
};

export type GetMyRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyRolesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string }> | null, schoolRoleStatus: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName, role: { __typename?: 'Role', roleName: UserRoleName } }> | null } | null };

export type GetMyAccountDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAccountDetailsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, avatarUrl: string | null, dateOfBirth: string | null, firstName: string | null, lastName: string | null, username: string | null, name: string | null, additionalInfo: string | null, email: string | null, gradYear: number | null, phone: string | null, phoneExt: string | null, isPhoneNumberVisible: boolean | null, isParent: boolean, state: string | null, country: string | null, school: { __typename?: 'School', id: string, name: string | null, city: string | null, state: string | null, logoUrl: string | null } | null, schoolRoleStatus: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName, role: { __typename?: 'Role', roleName: UserRoleName } }> | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isVerified: boolean | null, isSchoolEmail: boolean, updatedAt: string | null, activeUpdateRequest: { __typename?: 'EmailUpdateRequest', newEmail: string, expiresAt: string } | null }> | null, esportInterests: Array<{ __typename?: 'Esport', id: string, slug: Types.EsportSlug }> | null, parent: { __typename?: 'User', id: string } | null, userDemographics: { __typename?: 'UserDemographics', gender: Gender, race: Array<Race> } | null } | null };

export type GetMyVerificationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyVerificationStatusQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, sheeridOrganizationId: number | null } | null, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, resourceType: ResourceType, userId: string, resourceId: string }> | null, currentVerification: { __typename?: 'Verification', id: string, step: VerificationStep } | null } | null };

export type GetMySchoolDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMySchoolDetailsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, address: string | null, city: string | null, state: string | null, zip: string | null, districtClassification: string | null, timezone: string | null, name: string | null, slug: string | null, mascotName: string | null, logoUrl: string | null, whoPays: WhoPays | null, allowPlayerLedTeams: boolean | null, allowCaptainEnrollment: boolean | null, showCoachEmails: boolean | null, competitionGroup: CompetitionGroup | null, dismissalTime: string | null, detail: { __typename?: 'SchoolDetail', at: string | null, it: { __typename?: 'ITDetails', osType: string | null, hasDedicatedLab: boolean | null, numStudentComps: string | null, suppStaffOnCampus: boolean | null, publicIP: string | null, agreeToInstallGames: boolean | null, agreeToWhitelistPorts: boolean | null, agreeToDoPatchUpdates: boolean | null, suppStaff: { __typename?: 'SupportStaff', email: string | null, fname: string | null, lname: string | null, phone: string | null } | null } | null } | null } | null } | null };

export type GetMyIdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyIdentityQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, hmac: string, avatarUrl: string | null, promotionalEmail: string | null, name: string | null, firstName: string | null, lastName: string | null, username: string | null, hasMultiorgAccess: boolean, isParent: boolean, isUnderage: boolean, state: string | null, phone: string | null, emails: Array<{ __typename?: 'UserEmail', email: string, isSchoolEmail: boolean, isVerified: boolean | null }> | null, school: { __typename?: 'School', id: string, name: string | null, competitionGroup: CompetitionGroup | null, city: string | null, state: string | null, country: string | null, deletedAt: string | null, type: SchoolType | null, teams: Array<{ __typename?: 'Team', id: string, schoolId: string | null }> | null, activeCampaign: { __typename?: 'SponsorshipCampaign', sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null } | null, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string, status: UserRoleStatusName }> | null, schoolRoleStatus: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName, role: { __typename?: 'Role', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string } }> | null, gradYears: Array<{ __typename?: 'UserGradYear', gradYear: number, schoolId: string }>, teams: Array<{ __typename?: 'Team', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null } | null };

export type GetManagedTeamsQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetManagedTeamsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, managedTeams: Array<{ __typename?: 'Team', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null } | null };

export type GetMyProviderAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyProviderAccountsQuery = { __typename?: 'Query', me: { __typename?: 'User', hasMultiorgAccess: boolean, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null, providerOnboardUrl: string | null }> | null } | null };

export type GetCoachesAtMySchoolQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCoachesAtMySchoolQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, coachRolePendingUsers: Array<{ __typename?: 'User', id: string, name: string | null, createdAt: string | null, avatarUrl: string | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean }> | null }> | null, coaches: Array<{ __typename?: 'User', id: string, name: string | null, createdAt: string | null, avatarUrl: string | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean }> | null }> | null, deniedCoaches: Array<{ __typename?: 'User', id: string, name: string | null, createdAt: string | null, avatarUrl: string | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean }> | null }> | null } | null } | null };

export type IsPasswordResetValidQueryVariables = Exact<{
  input?: InputMaybe<VerifyPasswordResetInput>;
}>;


export type IsPasswordResetValidQuery = { __typename?: 'Query', isPasswordResetValid: { __typename?: 'PasswordResetPayload', isValid: boolean } };

export type GetParentEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type GetParentEmailQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName: string | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string }> | null } | null };

export type ChangeMyPasswordMutationVariables = Exact<{
  input: ChangeMyPasswordInput;
}>;


export type ChangeMyPasswordMutation = { __typename?: 'Mutation', changeMyPassword: { __typename?: 'UserPayload', success: boolean } };

export type SetMyAccountSettingsMutationVariables = Exact<{
  input: SetMyAccountSettingsInput;
}>;


export type SetMyAccountSettingsMutation = { __typename?: 'Mutation', setMyAccountSettings: { __typename?: 'UserPayload', success: boolean } };

export type CreateUserEmailMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  attributes: UserEmailInputAttributes;
  options: CreateUserEmailOptions;
}>;


export type CreateUserEmailMutation = { __typename?: 'Mutation', createUserEmail: { __typename?: 'UserEmail', userId: string, email: string, isSchoolEmail: boolean } | null };

export type RequestAccountEditMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type RequestAccountEditMutation = { __typename?: 'Mutation', requestAccountEdit: { __typename?: 'RequestAccountEditResult', expiresAt: string } };

export type RequestEmailUpdateMutationVariables = Exact<{
  oldEmail: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
}>;


export type RequestEmailUpdateMutation = { __typename?: 'Mutation', requestEmailUpdate: { __typename?: 'RequestEmailUpdateResult', userEmail: { __typename?: 'UserEmail', id: string, isVerified: boolean | null, email: string, isSchoolEmail: boolean, updatedAt: string | null, activeUpdateRequest: { __typename?: 'EmailUpdateRequest', newEmail: string, expiresAt: string } | null } | null } };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: { __typename?: 'SuccessPayload', success: boolean } };

export type FullFillPasswordResetMutationVariables = Exact<{
  resetCode: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type FullFillPasswordResetMutation = { __typename?: 'Mutation', fullFillPasswordReset: { __typename?: 'UserPayload', success: boolean } };

export type SetSchoolLogoMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  file: Scalars['Upload']['input'];
}>;


export type SetSchoolLogoMutation = { __typename?: 'Mutation', setSchoolLogo: { __typename?: 'SchoolPayload', success: boolean } };

export type UpdateSchoolProfileMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  input: SetSchoolProfileInput;
}>;


export type UpdateSchoolProfileMutation = { __typename?: 'Mutation', updateSchoolProfile: { __typename?: 'School', id: string, mascotName: string | null, address: string | null, logoUrl: string | null } | null };

export type UpdateSchoolDetailMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  detail: SchoolDetailInput;
}>;


export type UpdateSchoolDetailMutation = { __typename?: 'Mutation', updateSchoolDetail: { __typename?: 'School', id: string, detail: { __typename?: 'SchoolDetail', at: string | null, it: { __typename?: 'ITDetails', osType: string | null, hasDedicatedLab: boolean | null, numStudentComps: string | null, suppStaffOnCampus: boolean | null, publicIP: string | null, agreeToInstallGames: boolean | null, agreeToWhitelistPorts: boolean | null, agreeToDoPatchUpdates: boolean | null, suppStaff: { __typename?: 'SupportStaff', email: string | null, fname: string | null, lname: string | null, phone: string | null } | null } | null } | null } | null };

export type VerifyCoachMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  resourceId: Scalars['UUID']['input'];
}>;


export type VerifyCoachMutation = { __typename?: 'Mutation', verifyCoach: { __typename?: 'UserPayload', success: boolean } };

export type DenyCoachMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  resourceId: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type DenyCoachMutation = { __typename?: 'Mutation', denyCoach: { __typename?: 'User', id: string } | null };

export type VerifyDeniedCoachMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  resourceId: Scalars['UUID']['input'];
}>;


export type VerifyDeniedCoachMutation = { __typename?: 'Mutation', verifyDeniedCoach: { __typename?: 'UserPayload', success: boolean } };

export type DenyVerifiedCoachMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  resourceId: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type DenyVerifiedCoachMutation = { __typename?: 'Mutation', denyVerifiedCoach: { __typename?: 'UserPayload', success: boolean } };

export type VerifyUserForOrganizationMutationVariables = Exact<{
  input: UserRoleUpdateInput;
}>;


export type VerifyUserForOrganizationMutation = { __typename?: 'Mutation', verifyUserForOrganization: { __typename?: 'UserPayload', success: boolean } };

export type DenyUserForOrganizationMutationVariables = Exact<{
  input: UserRoleUpdateInput;
}>;


export type DenyUserForOrganizationMutation = { __typename?: 'Mutation', denyUserForOrganization: { __typename?: 'UserPayload', success: boolean } };

export type CanEditAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CanEditAccountQuery = { __typename?: 'Query', canEditAccount: { __typename?: 'CanEditAccountResult', success: boolean } };

export type SetMyUserDemographicsMutationVariables = Exact<{
  input: UserDemographicsInput;
}>;


export type SetMyUserDemographicsMutation = { __typename?: 'Mutation', setMyUserDemographics: { __typename?: 'UserPayload', success: boolean } };

export type IsSchoolByIdVerifiedQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type IsSchoolByIdVerifiedQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null, deletedAt: string | null } | null };

export type MyRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyRolesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, resourceId: string, resourceType: ResourceType, userId: string }> | null } | null };

export type MySchoolInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MySchoolInfoQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null, leagueGroups: Array<{ __typename?: 'LeagueGroup', id: string }> } | null } | null };

export type AssignMatchAssignmentMutationVariables = Exact<{
  input: AssignMatchAssignmentInput;
}>;


export type AssignMatchAssignmentMutation = { __typename?: 'Mutation', assignMatchAssignment: { __typename?: 'MatchAssignment', id: string, matchId: string, assigneeId: string | null, assignerId: string, assignmentStatus: MatchAssignmentStatus, notes: string | null, assignee: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null } | null } };

export type UnassignMatchAssignmentMutationVariables = Exact<{
  input: UnassignMatchAssignmentInput;
}>;


export type UnassignMatchAssignmentMutation = { __typename?: 'Mutation', unassignMatchAssignment: { __typename?: 'MatchAssignment', id: string, matchId: string, assigneeId: string | null, assignerId: string, assignmentStatus: MatchAssignmentStatus, notes: string | null, assignee: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null } | null } };

export type MatchAssignmentHistoryQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type MatchAssignmentHistoryQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, matchAssignmentHistory: Array<{ __typename?: 'MatchAssignment', id: string, assignmentStatus: MatchAssignmentStatus, createdAt: string, notes: string | null, assignee: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null } | null, assigner: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null } | null }> | null } | null };

export type BulkAssignMatchesMutationVariables = Exact<{
  matchAssignments: Array<AssignMatchAssignmentInput> | AssignMatchAssignmentInput;
}>;


export type BulkAssignMatchesMutation = { __typename?: 'Mutation', bulkAssignMatches: { __typename?: 'MatchesPayload', success: boolean, matchIds: Array<string> } };

export type BulkUnassignMatchesMutationVariables = Exact<{
  matchAssignments: Array<UnassignMatchAssignmentInput> | UnassignMatchAssignmentInput;
}>;


export type BulkUnassignMatchesMutation = { __typename?: 'Mutation', bulkUnassignMatches: { __typename?: 'MatchesPayload', success: boolean, matchIds: Array<string> } };

export type AvailableWeeklyAwardWeeksQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableWeeklyAwardWeeksQuery = { __typename?: 'Query', availableWeeklyAwardWeeks: { __typename?: 'AvailableWeeklyAwardWeeksPayload', availableWeeks: Array<{ __typename?: 'AwardWeekOption', assignedAwardId: string | null, assignedUserId: string | null, startDate: string, endDate: string, beginningOfWeekTime: string, player: { __typename?: 'User', id: string, name: string | null } | null } | null> } | null };

export type AvailableWeeklyAwardPlayersQueryVariables = Exact<{
  input: AvailableWeeklyAwardPlayersInput;
}>;


export type AvailableWeeklyAwardPlayersQuery = { __typename?: 'Query', availableWeeklyAwardPlayers: { __typename?: 'AvailableWeeklyAwardPlayersPayload', availablePlayers: Array<{ __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null> } | null };

export type AssignWeeklyPlayerAwardMutationVariables = Exact<{
  input: AssignWeeklyPlayerAwardInput;
}>;


export type AssignWeeklyPlayerAwardMutation = { __typename?: 'Mutation', assignWeeklyPlayerAward: { __typename?: 'AssignedWeeklyPlayerAwardPayload', assignedWeeklyPlayerAward: { __typename?: 'AssignedWeeklyPlayerAward', id: string, userId: string, coachId: string, schoolId: string, beginningOfWeekTime: string, createdAt: string | null, awardWeekOption: { __typename?: 'AwardWeekOption', assignedAwardId: string | null, assignedUserId: string | null } } } };

export type DeleteSeasonalPlayerAwardMutationVariables = Exact<{
  input: DeleteSeasonalPlayerAwardInput;
}>;


export type DeleteSeasonalPlayerAwardMutation = { __typename?: 'Mutation', deleteSeasonalPlayerAward: { __typename?: 'DeleteSeasonalPlayerAwardPayload', deletedId: string } };

export type AssignSeasonalPlayerAwardMutationVariables = Exact<{
  input: AssignSeasonalPlayerAwardInput;
}>;


export type AssignSeasonalPlayerAwardMutation = { __typename?: 'Mutation', assignSeasonalPlayerAward: { __typename?: 'AssignedSeasonalPlayerAwardPayload', assignedSeasonalPlayerAward: { __typename?: 'AssignedSeasonalPlayerAward', id: string } | null } };

export type UpdateSeasonalPlayerAwardMutationVariables = Exact<{
  input: UpdateSeasonalPlayerAwardInput;
}>;


export type UpdateSeasonalPlayerAwardMutation = { __typename?: 'Mutation', updateSeasonalPlayerAward: { __typename?: 'AssignedSeasonalPlayerAwardPayload', assignedSeasonalPlayerAward: { __typename?: 'AssignedSeasonalPlayerAward', id: string } | null } };

export type GenerateSeasonalPlayerAwardCertificateMutationVariables = Exact<{
  input: GenerateSeasonalPlayerAwardCertificateInput;
}>;


export type GenerateSeasonalPlayerAwardCertificateMutation = { __typename?: 'Mutation', generateSeasonalPlayerAwardCertificate: { __typename?: 'GenerateSeasonalPlayerAwardCertificatePayload', signedUrl: string } };

export type GenerateSeasonalPlayerAwardSocialMediaImageMutationVariables = Exact<{
  input: GenerateSeasonalPlayerAwardSocialMediaImageInput;
}>;


export type GenerateSeasonalPlayerAwardSocialMediaImageMutation = { __typename?: 'Mutation', generateSeasonalPlayerAwardSocialMediaImage: { __typename?: 'GenerateSeasonalPlayerAwardSocialMediaImagePayload', signedUrl: string } };

export type AvailableSeasonalPlayerAwardTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableSeasonalPlayerAwardTypesQuery = { __typename?: 'Query', availableSeasonalPlayerAwardTypes: { __typename?: 'AvailableSeasonalPlayerAwardTypesPayload', availablePlayerAwardTypes: Array<{ __typename?: 'SeasonalPlayerAwardType', id: string, title: string, description: string } | null> } | null };

export type GetSchoolSeasonEnrollmentSummaryQueryVariables = Exact<{
  metaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolSeasonEnrollmentSummaryQuery = { __typename?: 'Query', getSchoolSeasonEnrollmentSummary: { __typename?: 'SchoolSeasonEnrollmentSummaryPayload', earliestEnrolledAt: string | null } };

export type GetPassUsageGroupedByEsportQueryVariables = Exact<{
  dateRange: DateRangeInput;
  schoolId: Scalars['UUID']['input'];
}>;


export type GetPassUsageGroupedByEsportQuery = { __typename?: 'Query', getBillingPeriodSummaryForDateRange: { __typename?: 'BillingSummaryForDateRangePayload', passUsageByEsport: Array<{ __typename?: 'EsportPassUsage', seasonPassesUsed: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, passUsageByMetaseason: Array<{ __typename?: 'MetaseasonPassUsageSummaryPayload', seasonPassesUsed: number, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } }> }> | null } };

export type GetBillingPeriodSummaryForDateRangeQueryVariables = Exact<{
  dateRange: DateRangeInput;
  schoolId: Scalars['UUID']['input'];
}>;


export type GetBillingPeriodSummaryForDateRangeQuery = { __typename?: 'Query', getBillingPeriodSummaryForDateRange: { __typename?: 'BillingSummaryForDateRangePayload', totalSeasonPassesBilled: number, totalSeasonPassesUsed: number, passUsageByEsport: Array<{ __typename?: 'EsportPassUsage', seasonPassesUsed: number, esport: { __typename?: 'Esport', id: string }, passUsageByMetaseason: Array<{ __typename?: 'MetaseasonPassUsageSummaryPayload', seasonPassesUsed: number, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } }> }> | null, summaryByPass: Array<{ __typename?: 'PassSummary', annualPassType: AnnualPassType, passUsage: number, productName: string, seasonPassesBilled: number, slug: string, passUsageByMetaseason: Array<{ __typename?: 'MetaseasonPassUsageSummaryPayload', seasonPassesUsed: number, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } }>, planDateRange: { __typename?: 'DateRange', startsAt: string, endsAt: string } }> | null } };

export type GetSchoolInvoiceDataQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolInvoiceDataQuery = { __typename?: 'Query', getSchoolInvoiceData: Array<{ __typename?: 'SchoolInvoiceDataPayload', dateDue: string | null, issueDate: string | null, invoiceNumber: string, referenceId: string, paidStatus: InvoicePayStatus, seasonName: string, totalAmount: string }> };

export type DownloadSchoolInvoiceQueryVariables = Exact<{
  input: DownloadSchoolInvoiceInput;
}>;


export type DownloadSchoolInvoiceQuery = { __typename?: 'Query', downloadSchoolInvoice: { __typename?: 'DownloadSchoolInvoicePayload', encodedFile: string, title: string } };

export type GetBillingPeriodUsageQueryVariables = Exact<{
  dateRange: DateRangeInput;
  schoolId: Scalars['UUID']['input'];
  esportId?: InputMaybe<Scalars['UUID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBillingPeriodUsageQuery = { __typename?: 'Query', getBillingPeriodUsage: { __typename?: 'BillingPeriodUsagePayload', total: number, pageInfo: { __typename?: 'PageInfo', hasNext: boolean, endCursor: string | null, startCursor: string | null }, edges: Array<{ __typename?: 'BillingPeriodUsageEdge', node: { __typename?: 'BillingPeriodUsage', id: string, esportId: string, consumedAt: string, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null, match: { __typename?: 'Match', matchResults: Array<{ __typename?: 'MatchResult', teamSide: number | null, team: { __typename?: 'Team', name: string | null } | null }> | null } | null, esport: { __typename?: 'Esport', name: string | null } | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null } | null } }> } };

export type UpdateCurrentAnnualPassBySchoolIdMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  metaseasonIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type UpdateCurrentAnnualPassBySchoolIdMutation = { __typename?: 'Mutation', updateCurrentAnnualPassBySchoolId: Array<{ __typename?: 'AnnualPassPayload', success: boolean, annualPassInstanceId: string }> };

export type UpdateSchoolEnrollmentMutationVariables = Exact<{
  input: UpdateSchoolEnrollmentInput;
}>;


export type UpdateSchoolEnrollmentMutation = { __typename?: 'Mutation', updateSchoolEnrollment: Array<{ __typename?: 'SchoolEnrollment', metaseasonId: string, schoolId: string }> };

export type ScheduleConsultationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ScheduleConsultationEmailMutation = { __typename?: 'Mutation', scheduleConsultationEmail: { __typename?: 'ScheduleConsultationEmailPayload', success: boolean } };

export type GetPhaseBracketQueryVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
}>;


export type GetPhaseBracketQuery = { __typename?: 'Query', getBracketByPhaseId: { __typename?: 'Bracket', type: BracketType, bracketMatches: Array<{ __typename?: 'BracketMatch', bracketIndex: string, nextBracketIndex: string | null, matchId: string | null, matchCompleted: boolean, isAFinalsMatch: boolean, slotType: BracketSlotType | null, roundNumber: number, ordinalNumber: number, roundType: BracketRoundType, slot: { __typename?: 'Slot', id: string, startsAt: string | null } | null, match: { __typename?: 'Match', id: string, scheduledStartsAt: string | null, matchResults: Array<{ __typename?: 'MatchResult', teamId: string | null, gamesWon: number | null, seriesWon: number | null }> | null } | null, bracketTeams: Array<{ __typename?: 'BracketTeam', teamId: string | null, seed: number | null, schoolId: string | null, matchStatus: BracketTeamMatchStatus, isDeleted: boolean, team: { __typename?: 'Team', id: string, avatarUrl: string | null, name: string | null, schoolId: string | null, school: { __typename?: 'School', id: string, name: string | null, slug: string | null } | null } | null }> }> } | null };

export type RunBulkActionMutationVariables = Exact<{
  input: RunBulkActionInput;
}>;


export type RunBulkActionMutation = { __typename?: 'Mutation', runBulkAction: { __typename?: 'BulkActionJobPayload', jobId: string } };

export type GetBulkActionJobQueryVariables = Exact<{
  input: GetJobInput;
}>;


export type GetBulkActionJobQuery = { __typename?: 'Query', getBulkOperationFromGoogleSheetJob: { __typename?: 'BulkActionJobPayload', status: string | null, statusReason: string | null } };

export type DeleteMatchChatEventMutationVariables = Exact<{
  input: DeleteMatchChatEventInput;
}>;


export type DeleteMatchChatEventMutation = { __typename?: 'Mutation', deleteMatchChatEvent: { __typename?: 'MatchChatEventResults', matchChatEvent: { __typename?: 'MatchChatEvent', id: string } } };

export type FetchAllMatchChatEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllMatchChatEventsQuery = { __typename?: 'Query', fetchAllMatchChatEvents: { __typename?: 'MatchChatEventsResults', matchChatEvents: Array<{ __typename?: 'MatchChatEvent', id: string, name: string, description: string, esportId: string | null, object: string, field: string, changesTo: string, sendMessage: string, createdAt: string }> } };

export type CreateMatchChatEventMutationVariables = Exact<{
  input: CreateMatchChatEventInput;
}>;


export type CreateMatchChatEventMutation = { __typename?: 'Mutation', createMatchChatEvent: { __typename?: 'MatchChatEventResults', matchChatEvent: { __typename?: 'MatchChatEvent', id: string, name: string, description: string, esportId: string | null, object: string, field: string, changesTo: string, sendMessage: string } } };

export type UpdateMatchChatEventMutationVariables = Exact<{
  input: UpdateMatchChatEventInput;
}>;


export type UpdateMatchChatEventMutation = { __typename?: 'Mutation', updateMatchChatEvent: { __typename?: 'MatchChatEventResults', matchChatEvent: { __typename?: 'MatchChatEvent', id: string, name: string, description: string, esportId: string | null, object: string, field: string, changesTo: string, sendMessage: string } } };

export type GetChatAccessTokenMutationVariables = Exact<{
  input: GenerateTwilioAccessTokenByUserIdInput;
}>;


export type GetChatAccessTokenMutation = { __typename?: 'Mutation', generateTwilioAccessTokenByUserId: { __typename?: 'GenerateTwilioAccessTokenByUserIdPayload', payload: { __typename?: 'TwilioAccessTokenMetadata', twilioAccessToken: string } } };

export type AddUserToChatMutationVariables = Exact<{
  input: AddUserToChatInput;
}>;


export type AddUserToChatMutation = { __typename?: 'Mutation', addUserToChat: { __typename?: 'AddUserToChatPayload', success: boolean, errors: Array<string | null> } };

export type SendAnnouncementMutationVariables = Exact<{
  input: SendAnnouncementByMatchIdsInput;
}>;


export type SendAnnouncementMutation = { __typename?: 'Mutation', sendAnnouncementByMatchIds: { __typename?: 'SendAnnouncementPayload', success: boolean, errors: Array<string | null> } };

export type MyCoachPlayerRolePendingUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCoachPlayerRolePendingUsersQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, playerRolePendingUsers: Array<{ __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean }> | null }> | null } | null } | null };

export type MyDeniedPlayersQueryVariables = Exact<{
  input: FindDeniedUsers;
}>;


export type MyDeniedPlayersQuery = { __typename?: 'Query', findDeniedUsers: { __typename?: 'UsersResult', totalCount: number | null, users: Array<{ __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, createdAt: string | null, gradYear: number | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean }> | null }> | null } | null };

export type MyArchivedPlayersQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type MyArchivedPlayersQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, archivedPlayers: Array<{ __typename?: 'User', id: string, avatarUrl: string | null, createdAt: string | null, gradYear: number | null, name: string | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean }> | null, schoolRoleStatus: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName, role: { __typename?: 'Role', roleName: UserRoleName } }> | null }> | null } | null };

export type MyCoachPlayersQueryVariables = Exact<{
  input: FindUsers;
}>;


export type MyCoachPlayersQuery = { __typename?: 'Query', findUsers: { __typename?: 'UsersResult', totalCount: number | null, users: Array<{ __typename?: 'User', id: string, name: string | null, firstName: string | null, lastName: string | null, avatarUrl: string | null, gradYear: number | null, createdAt: string | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean }> | null, esportInterests: Array<{ __typename?: 'Esport', id: string, slug: Types.EsportSlug }> | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null, school: { __typename?: 'School', id: string } | null, schoolRoleStatus: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName, role: { __typename?: 'Role', roleName: UserRoleName } }> | null }> | null } | null };

export type FindPlayersEligibleForTeamQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type FindPlayersEligibleForTeamQuery = { __typename?: 'Query', findPlayersEligibleForTeam: Array<{ __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null }> | null };

export type FindPlayersEligibleForTeamV2QueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type FindPlayersEligibleForTeamV2Query = { __typename?: 'Query', findPlayersEligibleForTeam: Array<{ __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, isUnderage: boolean, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean }> | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null }> | null, team: { __typename?: 'Team', id: string, roster: { __typename?: 'TeamRoster', teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } }> } | null } | null };

export type MySchoolDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySchoolDetailsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, address: string | null, whoPays: WhoPays | null, competitionGroup: CompetitionGroup | null } | null } | null };

export type MySchoolTeamEsportsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySchoolTeamEsportsQuery = { __typename?: 'Query', me: { __typename?: 'User', school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null } | null } | null };

export type AddPlayerToTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  hideTeamInRequestIfDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AddPlayerToTeamOptions>;
}>;


export type AddPlayerToTeamMutation = { __typename?: 'Mutation', addPlayerToTeam: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, roster: { __typename?: 'TeamRoster', id: string, numPlayers: number, maxNumPlayers: number, isFull: boolean, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, substitutes: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string } }> }> } | null } } };

export type JoinTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<JoinTeamOptions>;
}>;


export type JoinTeamMutation = { __typename?: 'Mutation', joinTeam: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, roster: { __typename?: 'TeamRoster', id: string, numPlayers: number, maxNumPlayers: number, isFull: boolean, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, substitutes: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string } }> }> } | null } } };

export type DenyPlayerMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  resourceId: Scalars['UUID']['input'];
}>;


export type DenyPlayerMutation = { __typename?: 'Mutation', denyPlayer: { __typename?: 'User', id: string, email: string | null, name: string | null } | null };

export type VerifyPlayerMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  resourceId: Scalars['UUID']['input'];
}>;


export type VerifyPlayerMutation = { __typename?: 'Mutation', verifyPlayer: { __typename?: 'User', id: string, email: string | null, name: string | null } | null };

export type GraduatePlayerMutationVariables = Exact<{
  input: GraduatePlayerInput;
}>;


export type GraduatePlayerMutation = { __typename?: 'Mutation', graduatePlayer: { __typename?: 'UserPayload', success: boolean } };

export type TransferPlayerMutationVariables = Exact<{
  input: TransferPlayerInput;
}>;


export type TransferPlayerMutation = { __typename?: 'Mutation', transferPlayer: { __typename?: 'UserPayload', success: boolean } };

export type VerifyArchivedPlayerMutationVariables = Exact<{
  input: VerifyArchivedPlayerInput;
}>;


export type VerifyArchivedPlayerMutation = { __typename?: 'Mutation', verifyArchivedPlayer: { __typename?: 'UserPayload', success: boolean } };

export type RemovePlayerFromTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  playerId: Scalars['UUID']['input'];
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type RemovePlayerFromTeamMutation = { __typename?: 'Mutation', removePlayerFromTeam: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } }>, formats: Array<{ __typename?: 'TeamRosterFormat', starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } }> }> } | null } } };

export type LeaveTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type LeaveTeamMutation = { __typename?: 'Mutation', leaveTeam: { __typename?: 'UserPayload', success: boolean } };

export type CreateTeamV2MutationVariables = Exact<{
  input: CreateTeamV2Input;
  schoolOptions?: InputMaybe<TeamSchoolOptions>;
}>;


export type CreateTeamV2Mutation = { __typename?: 'Mutation', createTeamV2: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, name: string | null, createdByUser: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string, status: UserRoleStatusName }> | null } | null, esport: { __typename?: 'Esport', id: string, name: string | null } } } };

export type UpdateTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, name: string | null } } | null };

export type AddTeamToLeagueMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  leagueId: Scalars['UUID']['input'];
}>;


export type AddTeamToLeagueMutation = { __typename?: 'Mutation', addTeamToLeague: { __typename?: 'TeamLeaguePayload', success: boolean } };

export type RepositionPlayersInTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  playerPositions: Array<PlayerPosition> | PlayerPosition;
}>;


export type RepositionPlayersInTeamMutation = { __typename?: 'Mutation', repositionPlayersInTeam: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, roster: { __typename?: 'TeamRoster', id: string, numPlayers: number, maxNumPlayers: number, isFull: boolean, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', position: { __typename?: 'EsportPosition', id: string }, player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } }> }> } | null } } };

export type GetEligiblePlayersForTeamQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type GetEligiblePlayersForTeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, esport: { __typename?: 'Esport', id: string, name: string | null }, roster: { __typename?: 'TeamRoster', teamId: string, formats: Array<{ __typename?: 'TeamRosterFormat', starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null, seasonPasses: Array<{ __typename?: 'UserSeasonPass', metaseasonId: string, leagueId: string | null, consumedAt: string | null }> | null } }> }>, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } }> } | null, getEligiblePlayers: Array<{ __typename?: 'EligiblePlayer', disabled: boolean, disabledReason: EligiblePlayerDisabledReason | null, user: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, emails: Array<{ __typename?: 'UserEmail', id: string, isSchoolEmail: boolean, email: string }> | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null, esportInterests: Array<{ __typename?: 'Esport', id: string, slug: Types.EsportSlug }> | null } }> | null } | null };

export type TeamDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TeamDetailsQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, competitionGroup: CompetitionGroup | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, leagues: Array<{ __typename?: 'League', id: string, seasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, name: string, rostersLockAt: string | null, teamRegistrationEndsAt: string | null, phases: Array<{ __typename?: 'Phase', id: string, startsAt: string, endsAt: string, name: string | null, type: PhaseType, seasonId: string, status: PhaseStatus, format: PhaseFormat, survivalAdvancementPercentage: number | null, survivalAdvancementCount: number | null }> | null }> | null }> | null, school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null } | null } | null };

export type GetSchoolLeaguesByTeamQueryVariables = Exact<{
  metaseasonId: Scalars['UUID']['input'];
  isCoach: Scalars['Boolean']['input'];
  teamId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolLeaguesByTeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, school: { __typename?: 'School', id: string, annualPassProductsEligible?: Array<{ __typename?: 'RankedAnnualPassProduct', id: string, name: string, description: string, priceUsd: number, type: ProductType, slug: string | null, position: number, seasonPassesAllotted: Array<{ __typename?: 'AllottedSeasonPass', id: string }> | null }> | null, annualPassInstances?: Array<{ __typename?: 'AnnualPassInstance', id: string, productId: string | null, productInstanceInfo: { __typename?: 'AnnualPassInstanceInfo', initialMetaseasonId: string } }> } | null } | null, getLeaguesBySchoolId: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, state: string | null, competitionModel: CompetitionModel, competitionGroup: CompetitionGroup, seasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, registrationStartsAt: string, teamRegistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null }> | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, rating: EsportRating } }> | null };

export type GetLeaguesForTeamQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeaguesForTeamQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, leagueScope: { __typename?: 'AllLeaguesResult', result: Array<{ __typename?: 'League', id: string, esportId: string | null, displayName: string | null, name: string | null, competitionModel: CompetitionModel, competitionGroup: CompetitionGroup, timezone: string | null, esport: { __typename?: 'Esport', id: string, name: string | null }, seasons: Array<{ __typename?: 'Season', id: string, rostersLockAt: string | null, metaseasonId: string | null, teamRegistrationEndsAt: string | null, phases: Array<{ __typename?: 'Phase', id: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null }> | null }> | null }> | null }> | null } | null } | null };

export type TeamQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type TeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, competitionGroup: CompetitionGroup | null, inviteUrl: string | null, deletedAt: string | null, isPlayerLed: boolean | null, createdAt: string | null, createdBy: string | null, name: string | null, school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null, logoUrl: string | null, name: string | null } | null, coaches: Array<{ __typename?: 'TeamCoach', id: string, name: string | null, firstName: string | null, lastName: string | null, phone: string | null, phoneExt: string | null, avatarUrl: string | null }> | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null, teamMaxSize: number | null } }, enrolledSeasons: Array<{ __typename?: 'Season', id: string, rostersLockAt: string | null, teamDeregistrationEndsAt: string | null, metaseason: { __typename?: 'Metaseason', id: string, isPromoted: boolean, startsAt: string | null, name: string | null, endsAt: string | null } | null }> | null, leagues: Array<{ __typename?: 'League', id: string, competitionModel: CompetitionModel, esport: { __typename?: 'Esport', id: string } }> | null, roster: { __typename?: 'TeamRoster', teamId: string, numPlayers: number, maxNumPlayers: number, isFull: boolean, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', position: { __typename?: 'EsportPosition', id: string, index: number, name: string, abbreviation: string, colloquial: string }, player: { __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> }> } | null } | null };

export type GetTeamNameQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTeamNameQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null } | null };

export type CompetitionIntervalsForOrgQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type CompetitionIntervalsForOrgQuery = { __typename?: 'Query', competitionIntervalsForOrganization: { __typename?: 'CompetitionIntervalsForOrganizationQueryPayload', results: Array<{ __typename?: 'CompetitionIntervalForOrganizationResult', interval: { __typename?: 'CompetitionInterval', name: string, startsAt: string, endsAt: string, tense: IntervalTense, enrollmentOpensAt: string | null, firstDay: { __typename?: 'DateComponents', month: number, dayOfMonth: number, year: number }, lastDay: { __typename?: 'DateComponents', month: number, dayOfMonth: number, year: number } }, metaseasonsForOrganization: Array<{ __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean, earliestEnrollmentDate: string | null }> }> } };

export type CompetitionIntervalsForOrganizationTeamManagementQueryVariables = Exact<{
  input: CompetitionIntervalsForOrganizationQueryInput;
}>;


export type CompetitionIntervalsForOrganizationTeamManagementQuery = { __typename?: 'Query', competitionIntervalsForOrganization: { __typename?: 'CompetitionIntervalsForOrganizationQueryPayload', results: Array<{ __typename?: 'CompetitionIntervalForOrganizationResult', interval: { __typename?: 'CompetitionInterval', name: string, startsAt: string, endsAt: string, tense: IntervalTense, firstDay: { __typename?: 'DateComponents', month: number, dayOfMonth: number, year: number }, lastDay: { __typename?: 'DateComponents', month: number, dayOfMonth: number, year: number }, enrolledSeasons: Array<{ __typename?: 'Season', endsAt: string, id: string, registrationStartsAt: string, teamRegistrationEndsAt: string | null, type: SeasonType | null }> | null }, metaseasonsForOrganization: Array<{ __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean, enrollmentStartsAt: string | null, enrollmentEndsAt: string | null }> }> } };

export type GetSchoolTeamsCountQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolTeamsCountQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string }> | null } | null };

export type GetSupportedAccountProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportedAccountProvidersQuery = { __typename?: 'Query', supportedProviders: Array<Provider> };

export type GetUserProviderAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProviderAccountsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceId: string, resourceType: ResourceType }> | null, school: { __typename?: 'School', id: string, varsityAssociations: Array<{ __typename?: 'VarsityAssociation', name: string, slug: string }> } | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerOnboardUrl: string | null, providerIntegrationType: IntegrationType | null, createdAt: string | null, updatedAt: string | null }> | null } | null };

export type GetUserProviderAccountsFromIdQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetUserProviderAccountsFromIdQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceId: string, resourceType: ResourceType }> | null, school: { __typename?: 'School', id: string, varsityAssociations: Array<{ __typename?: 'VarsityAssociation', name: string, slug: string }> } | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerOnboardUrl: string | null, providerIntegrationType: IntegrationType | null, createdAt: string | null, updatedAt: string | null }> | null } | null };

export type GetSchoolProviderAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSchoolProviderAccountsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, schoolProviderAccounts: Array<{ __typename?: 'SchoolProviderAccount', id: string, schoolId: string, providerName: string, providerAccountId: string, providerDisplayName: string, providerIntegrationType: IntegrationType }> | null } | null } | null };

export type GetSchoolProviderAccountFromIdQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolProviderAccountFromIdQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, schoolProviderAccounts: Array<{ __typename?: 'SchoolProviderAccount', id: string, schoolId: string, providerName: string, providerAccountId: string, providerDisplayName: string, providerIntegrationType: IntegrationType }> | null } | null };

export type UnlinkUserProviderAccountMutationVariables = Exact<{
  providerId: Scalars['UUID']['input'];
}>;


export type UnlinkUserProviderAccountMutation = { __typename?: 'Mutation', unlinkUserProviderAccount: { __typename?: 'RemoveUserProviderAccountSuccussPayload', success: boolean } };

export type UnlinkSchoolProviderAccountMutationVariables = Exact<{
  providerId: Scalars['UUID']['input'];
}>;


export type UnlinkSchoolProviderAccountMutation = { __typename?: 'Mutation', unlinkSchoolProviderAccount: { __typename?: 'UnlinkSchoolProviderAccountSuccussPayload', success: boolean } };

export type LinkPlayStationNetworkAccountMutationVariables = Exact<{
  input: LinkPlayStationNetworkAccountInput;
}>;


export type LinkPlayStationNetworkAccountMutation = { __typename?: 'Mutation', linkPlayStationNetworkAccount: { __typename?: 'UserProviderAccount', id: string, providerDisplayName: string | null } };

export type LinkNintendoAccountMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  attributes: LinkNintendoAccountInput;
}>;


export type LinkNintendoAccountMutation = { __typename?: 'Mutation', linkNintendoAccount: { __typename?: 'UserProviderAccount', id: string, providerDisplayName: string | null } };

export type LinkAccountMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  attributes: LinkManualAccountInput;
}>;


export type LinkAccountMutation = { __typename?: 'Mutation', linkManualAccount: { __typename?: 'UserProviderAccount', id: string, providerDisplayName: string | null } };

export type MySchoolCoachesQueryVariables = Exact<{ [key: string]: never; }>;


export type MySchoolCoachesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, coaches: Array<{ __typename?: 'User', id: string, lastSeen: string | null, name: string | null, avatarUrl: string | null, email: string | null, phone: string | null, emails: Array<{ __typename?: 'UserEmail', email: string, isSchoolEmail: boolean }> | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null }> | null } | null } | null };

export type CreateDemoMutationVariables = Exact<{
  input: CreateDemoInput;
}>;


export type CreateDemoMutation = { __typename?: 'Mutation', createDemo: { __typename?: 'DemoJobPayload', jobId: string } | null };

export type ListUserDemosQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUserDemosQuery = { __typename?: 'Query', listUserDemos: Array<{ __typename?: 'Demo', userId: string, schoolId: string, scheduledAt: string, createdAt: string, username: string, password: string, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, state: string | null, varsityAssociations: Array<{ __typename?: 'VarsityAssociation', name: string, slug: string }> } | null }> | null };

export type GameResultFragment = { __typename?: 'GameResultRequest', requestedById: string | null, ordinalNumber: number, winningTeamId: string, winningPlayerIds: Array<string> | null, winningTeamScore: number | null, losingTeamId: string, losingPlayerIds: Array<string> | null, losingTeamScore: number | null, incompleteReason: GameIncompleteReason | null, assetIds: Array<string | null> | null, approvedByTeamIds: Array<string | null> | null, gameRejected: boolean | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, fileType: string | null, bucket: string, signedUrl: string | null }> | null };

export type MatchSettleRequestFragment = { __typename?: 'MatchSettleRequestModel', id: string, matchId: string, teamId: string | null, status: MatchSettleRequestStatus | null, incompleteNotes: string | null, isReadyForReview: boolean | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', id: string | null, ordinalNumber: number | null, isReadyForReview: boolean | null, winningTeamId: string | null, gameResults: Array<{ __typename?: 'GameResultRequest', requestedById: string | null, ordinalNumber: number, winningTeamId: string, winningPlayerIds: Array<string> | null, winningTeamScore: number | null, losingTeamId: string, losingPlayerIds: Array<string> | null, losingTeamScore: number | null, incompleteReason: GameIncompleteReason | null, assetIds: Array<string | null> | null, approvedByTeamIds: Array<string | null> | null, gameRejected: boolean | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, fileType: string | null, bucket: string, signedUrl: string | null }> | null }> }> | null } | null };

export type FetchMatchSettleRequestQueryVariables = Exact<{
  input: FetchMatchSettleRequestInput;
}>;


export type FetchMatchSettleRequestQuery = { __typename?: 'Query', fetchMatchSettleRequest: { __typename?: 'MultipleMatchSettleRequestsPayload', success: boolean, errors: Array<string> | null, matchSettleRequest: Array<{ __typename?: 'MatchSettleRequestModel', id: string, matchId: string, teamId: string | null, status: MatchSettleRequestStatus | null, incompleteNotes: string | null, isReadyForReview: boolean | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', id: string | null, ordinalNumber: number | null, isReadyForReview: boolean | null, winningTeamId: string | null, gameResults: Array<{ __typename?: 'GameResultRequest', requestedById: string | null, ordinalNumber: number, winningTeamId: string, winningPlayerIds: Array<string> | null, winningTeamScore: number | null, losingTeamId: string, losingPlayerIds: Array<string> | null, losingTeamScore: number | null, incompleteReason: GameIncompleteReason | null, assetIds: Array<string | null> | null, approvedByTeamIds: Array<string | null> | null, gameRejected: boolean | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, fileType: string | null, bucket: string, signedUrl: string | null }> | null }> }> | null } | null }> | null } };

export type SaveGameResultLiveMutationVariables = Exact<{
  input: SaveGameResultInput;
}>;


export type SaveGameResultLiveMutation = { __typename?: 'Mutation', saveGameResultLive: { __typename?: 'MatchSettleRequestWithWinningTeamPayload', success: boolean, errors: Array<string> | null, matchSettleRequest: { __typename?: 'MatchSettleRequestModel', id: string, matchId: string, teamId: string | null, status: MatchSettleRequestStatus | null, incompleteNotes: string | null, isReadyForReview: boolean | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', id: string | null, ordinalNumber: number | null, isReadyForReview: boolean | null, winningTeamId: string | null, gameResults: Array<{ __typename?: 'GameResultRequest', requestedById: string | null, ordinalNumber: number, winningTeamId: string, winningPlayerIds: Array<string> | null, winningTeamScore: number | null, losingTeamId: string, losingPlayerIds: Array<string> | null, losingTeamScore: number | null, incompleteReason: GameIncompleteReason | null, assetIds: Array<string | null> | null, approvedByTeamIds: Array<string | null> | null, gameRejected: boolean | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, fileType: string | null, bucket: string, signedUrl: string | null }> | null }> }> | null } | null } | null, winningTeam: { __typename?: 'Team', id: string } | null } };

export type AdminSaveGameResultLiveMutationVariables = Exact<{
  input: AdminSaveGameResultInput;
}>;


export type AdminSaveGameResultLiveMutation = { __typename?: 'Mutation', adminSaveGameResultLive: { __typename?: 'MatchSettleRequestWithWinningTeamPayload', success: boolean, errors: Array<string> | null, matchSettleRequest: { __typename?: 'MatchSettleRequestModel', id: string, matchId: string, teamId: string | null, status: MatchSettleRequestStatus | null, incompleteNotes: string | null, isReadyForReview: boolean | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', id: string | null, ordinalNumber: number | null, isReadyForReview: boolean | null, winningTeamId: string | null, gameResults: Array<{ __typename?: 'GameResultRequest', requestedById: string | null, ordinalNumber: number, winningTeamId: string, winningPlayerIds: Array<string> | null, winningTeamScore: number | null, losingTeamId: string, losingPlayerIds: Array<string> | null, losingTeamScore: number | null, incompleteReason: GameIncompleteReason | null, assetIds: Array<string | null> | null, approvedByTeamIds: Array<string | null> | null, gameRejected: boolean | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, fileType: string | null, bucket: string, signedUrl: string | null }> | null }> }> | null } | null } | null, winningTeam: { __typename?: 'Team', id: string } | null } };

export type FetchMatchForReportCardQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type FetchMatchForReportCardQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, bestOf: number | null, seriesBestOf: number | null, scheduledStartsAt: string | null, status: MatchStatus, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null }> }, matchResults: Array<{ __typename?: 'MatchResult', id: string, teamSide: number | null, team: { __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } }> | null, games: Array<{ __typename?: 'Game', id: string, seriesId: string | null }> | null } | null };

export type SubmitMatchSettleRequestAssetsLiveMutationVariables = Exact<{
  input: SubmitAdminMatchSettleRequestAssetsInput;
}>;


export type SubmitMatchSettleRequestAssetsLiveMutation = { __typename?: 'Mutation', submitMatchSettleRequestAssetsLive: { __typename?: 'GenericMatchSettleRequestPayload', success: boolean, errors: Array<string> | null, matchSettleRequest: { __typename?: 'MatchSettleRequestModel', id: string, matchId: string, teamId: string | null, status: MatchSettleRequestStatus | null, incompleteNotes: string | null, isReadyForReview: boolean | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', id: string | null, ordinalNumber: number | null, isReadyForReview: boolean | null, winningTeamId: string | null, gameResults: Array<{ __typename?: 'GameResultRequest', requestedById: string | null, ordinalNumber: number, winningTeamId: string, winningPlayerIds: Array<string> | null, winningTeamScore: number | null, losingTeamId: string, losingPlayerIds: Array<string> | null, losingTeamScore: number | null, incompleteReason: GameIncompleteReason | null, assetIds: Array<string | null> | null, approvedByTeamIds: Array<string | null> | null, gameRejected: boolean | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, fileType: string | null, bucket: string, signedUrl: string | null }> | null }> }> | null } | null } | null } };

export type MatchSettleRequestUpdatedSubscriptionVariables = Exact<{
  input?: InputMaybe<MatchSettleRequestUpdatedSubscribeInput>;
}>;


export type MatchSettleRequestUpdatedSubscription = { __typename?: 'Subscription', matchSettleRequestUpdated: { __typename?: 'MatchSettleRequestWithWinningTeamPayload', success: boolean, errors: Array<string> | null, matchHasBeenAutoSettled: boolean, gameAssistantStepHasBeenUpdated: boolean, matchSettleRequest: { __typename?: 'MatchSettleRequestModel', id: string, matchId: string, teamId: string | null, status: MatchSettleRequestStatus | null, incompleteNotes: string | null, isReadyForReview: boolean | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', id: string | null, ordinalNumber: number | null, isReadyForReview: boolean | null, winningTeamId: string | null, gameResults: Array<{ __typename?: 'GameResultRequest', requestedById: string | null, ordinalNumber: number, winningTeamId: string, winningPlayerIds: Array<string> | null, winningTeamScore: number | null, losingTeamId: string, losingPlayerIds: Array<string> | null, losingTeamScore: number | null, incompleteReason: GameIncompleteReason | null, assetIds: Array<string | null> | null, approvedByTeamIds: Array<string | null> | null, gameRejected: boolean | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, fileType: string | null, bucket: string, signedUrl: string | null }> | null }> }> | null } | null } | null } | null };

export type MatchSettleRequestAssetsUpdatedSubscriptionVariables = Exact<{
  input?: InputMaybe<MatchSettleRequestAssetsUpdatedSubscribeInput>;
}>;


export type MatchSettleRequestAssetsUpdatedSubscription = { __typename?: 'Subscription', matchSettleRequestAssetsUpdated: { __typename?: 'GenericMatchSettleRequestPayload', success: boolean, errors: Array<string> | null, matchSettleRequest: { __typename?: 'MatchSettleRequestModel', id: string, matchId: string, teamId: string | null, status: MatchSettleRequestStatus | null, incompleteNotes: string | null, isReadyForReview: boolean | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', id: string | null, ordinalNumber: number | null, isReadyForReview: boolean | null, winningTeamId: string | null, gameResults: Array<{ __typename?: 'GameResultRequest', requestedById: string | null, ordinalNumber: number, winningTeamId: string, winningPlayerIds: Array<string> | null, winningTeamScore: number | null, losingTeamId: string, losingPlayerIds: Array<string> | null, losingTeamScore: number | null, incompleteReason: GameIncompleteReason | null, assetIds: Array<string | null> | null, approvedByTeamIds: Array<string | null> | null, gameRejected: boolean | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, fileType: string | null, bucket: string, signedUrl: string | null }> | null }> }> | null } | null } | null } | null };

export type GetMySchoolEnrollmentQueryVariables = Exact<{
  metaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
  isCoach: Scalars['Boolean']['input'];
}>;


export type GetMySchoolEnrollmentQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, annualPassProductsEligible?: Array<{ __typename?: 'RankedAnnualPassProduct', id: string, name: string, description: string, priceUsd: number, type: ProductType, slug: string | null, seasonPassesAllotted: Array<{ __typename?: 'AllottedSeasonPass', id: string }> | null }> | null, annualPassInstances?: Array<{ __typename?: 'AnnualPassInstance', id: string, productId: string | null, productInstanceInfo: { __typename?: 'AnnualPassInstanceInfo', initialMetaseasonId: string }, seasonPassBundles: Array<{ __typename?: 'SeasonPassBundle', metaseason: { __typename?: 'Metaseason', id: string, name: string | null, nextMetaseasonId: string | null, previousMetaseasonId: string | null } | null }> | null }>, teams: Array<{ __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } }> } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, leagues: Array<{ __typename?: 'League', id: string }> | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseason: { __typename?: 'Metaseason', id: string } | null }> | null }> | null, players: Array<{ __typename?: 'User', id: string, leagues: Array<{ __typename?: 'League', id: string, competitionModel: CompetitionModel, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null } }> | null }> | null, leagueGroups: Array<{ __typename?: 'LeagueGroup', id: string }> } | null };

export type GetActiveLeaguesBySchoolIdQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  esportId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetActiveLeaguesBySchoolIdQuery = { __typename?: 'Query', getActiveLeaguesBySchoolId: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, state: string | null, competitionModel: CompetitionModel, teamFormat: number, teamMaxSize: number, teamMinimumStarterSize: number, seasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, registrationStartsAt: string, teamRegistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null, maxTeamsPerSchool: number | null, name: string, areBreakWeekSlotExclusionWindowsEnabled: boolean, weeklySlotDateEstimate: { __typename?: 'WeeklySlotDateEstimate', sample: string } | null }> | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null } }> };

export type GetMySchoolSlotExclusionSelectionDataQueryVariables = Exact<{
  input: OrganizationEnrollmentDataQueryInput;
}>;


export type GetMySchoolSlotExclusionSelectionDataQuery = { __typename?: 'Query', organizationEnrollmentData: { __typename?: 'OrganizationEnrollmentDataQueryResult', data: { __typename?: 'OrganizationEnrollmentData', slotExclusionData: { __typename?: 'SlotExclusionData', rangeData: Array<{ __typename?: 'SlotExclusionRangeData', selectionData: { __typename?: 'SlotExclusionRangeSelectionData', resourceType: SlotExclusionWindowResourceType, resourceId: string, selections: Array<{ __typename?: 'SlotExclusionRangeSelection', slotExclusionWindow: { __typename?: 'SlotExclusionWindow', id: string, startsAt: string | null, endsAt: string | null } }> } }> }, seasonSlotExclusionData: { __typename?: 'SlotExclusionData', rangeData: Array<{ __typename?: 'SlotExclusionRangeData', seasonId: string | null, selectionData: { __typename?: 'SlotExclusionRangeSelectionData', resourceType: SlotExclusionWindowResourceType, resourceId: string, selections: Array<{ __typename?: 'SlotExclusionRangeSelection', slotExclusionWindow: { __typename?: 'SlotExclusionWindow', id: string, startsAt: string | null, endsAt: string | null } }> } }> } } } };

export type GetMySchoolSlotExclusionDataQueryVariables = Exact<{
  input: OrganizationEnrollmentDataQueryInput;
}>;


export type GetMySchoolSlotExclusionDataQuery = { __typename?: 'Query', organizationEnrollmentData: { __typename?: 'OrganizationEnrollmentDataQueryResult', data: { __typename?: 'OrganizationEnrollmentData', slotExclusionData: { __typename?: 'SlotExclusionData', rangeData: Array<{ __typename?: 'SlotExclusionRangeData', range: { __typename?: 'DateRange', startsAt: string, endsAt: string }, suggestionsForOrganization: Array<{ __typename?: 'OrganizationSlotExclusionWindowSuggestion', isAvailable: boolean, suggestion: { __typename?: 'SlotExclusionWindowSuggestion', template: { __typename?: 'SlotExclusionWindowTemplate', hash: string, startsAt: string | null, endsAt: string | null } } }>, selectionData: { __typename?: 'SlotExclusionRangeSelectionData', resourceType: SlotExclusionWindowResourceType, resourceId: string, selections: Array<{ __typename?: 'SlotExclusionRangeSelection', isEditable: boolean, slotExclusionWindow: { __typename?: 'SlotExclusionWindow', id: string, hash: string, startsAt: string | null, endsAt: string | null } }> }, configuration: { __typename?: 'SlotExclusionRangeConfiguration', maxSlotExclusions: number, defaultsAppliedAt: string } }> }, seasonSlotExclusionData: { __typename?: 'SlotExclusionData', rangeData: Array<{ __typename?: 'SlotExclusionRangeData', seasonId: string | null, season: { __typename?: 'Season', leagueId: string, league: { __typename?: 'League', id: string, displayName: string | null } | null } | null, range: { __typename?: 'DateRange', startsAt: string, endsAt: string }, suggestionsForOrganization: Array<{ __typename?: 'OrganizationSlotExclusionWindowSuggestion', isAvailable: boolean, suggestion: { __typename?: 'SlotExclusionWindowSuggestion', template: { __typename?: 'SlotExclusionWindowTemplate', hash: string, startsAt: string | null, endsAt: string | null } } }>, selectionData: { __typename?: 'SlotExclusionRangeSelectionData', resourceType: SlotExclusionWindowResourceType, resourceId: string, selections: Array<{ __typename?: 'SlotExclusionRangeSelection', isEditable: boolean, slotExclusionWindow: { __typename?: 'SlotExclusionWindow', id: string, hash: string, startsAt: string | null, endsAt: string | null } }> }, configuration: { __typename?: 'SlotExclusionRangeConfiguration', maxSlotExclusions: number, defaultsAppliedAt: string } }> } } } };

export type EstimateSchoolSeasonPassUsageQueryVariables = Exact<{
  metaseasonId: Scalars['UUID']['input'];
  enrollTeamIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EstimateSchoolSeasonPassUsageQuery = { __typename?: 'Query', estimateSchoolSeasonPassUsage: { __typename?: 'EstimateSchoolSeasonPassUsageResult', annualPassType: AnnualPassType, totalSeasonPassesNeeded: number, totalBillableSeasonPassesNeeded: number } };

export type GetAnnualPassProductByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetAnnualPassProductByIdQuery = { __typename?: 'Query', annualPassProduct: { __typename?: 'AnnualPassProduct', id: string, name: string, description: string, priceUsd: number, type: ProductType, slug: string | null, seasonPassesAllotted: Array<{ __typename?: 'AllottedSeasonPass', id: string }> | null } | null };

export type GetEnrollmentTeamsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<TeamFiltersInput>;
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetEnrollmentTeamsQuery = { __typename?: 'Query', getTeams: { __typename?: 'TeamsResult', teams: Array<{ __typename?: 'Team', id: string, name: string | null, leagues: Array<{ __typename?: 'League', id: string, esportId: string | null }> | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null } | null };

export type GetMetaseasonInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMetaseasonInfoQuery = { __typename?: 'Query', metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null };

export type PurchasePlanMutationVariables = Exact<{
  productId?: InputMaybe<Scalars['UUID']['input']>;
  schoolId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type PurchasePlanMutation = { __typename?: 'Mutation', addAnnualPassToSchool: { __typename?: 'AnnualPassInstance', id: string } };

export type AdjustAnnualPassMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  annualPassInstanceId: Scalars['UUID']['input'];
  desiredProductId: Scalars['UUID']['input'];
}>;


export type AdjustAnnualPassMutation = { __typename?: 'Mutation', adjustAnnualPass: { __typename?: 'AnnualPassInstance', id: string } };

export type SendEnrollmentConfirmationMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type SendEnrollmentConfirmationMutation = { __typename?: 'Mutation', sendEnrollmentConfirmation: { __typename?: 'EnrollmentConfirmationPayload', success: boolean } };

export type GetTeamsEnrolledSeasonIdsQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetTeamsEnrolledSeasonIdsQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string, enrolledSeasons: Array<{ __typename?: 'Season', id: string }> | null }> | null } | null };

export type GetEntryCodesQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetEntryCodesQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, entryCode: string | null, ordinalNumber: number | null }> | null } | null };

export type GetMatchStatusQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchStatusQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus } | null };

export type GetUserEsportInterestsForSchoolQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetUserEsportInterestsForSchoolQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, esportInterests: Array<{ __typename?: 'Esport', id: string, slug: Types.EsportSlug }> | null } | null };

export type SetUserEsportInterestsMutationVariables = Exact<{
  input: SetUserEsportInterestsInput;
}>;


export type SetUserEsportInterestsMutation = { __typename?: 'Mutation', setUserEsportInterests: { __typename?: 'UserPayload', success: boolean } };

export type SetMyEsportInterestsMutationVariables = Exact<{
  input?: InputMaybe<SetMyEsportInterests>;
}>;


export type SetMyEsportInterestsMutation = { __typename?: 'Mutation', setMyEsportInterests: { __typename?: 'UserPayload', success: boolean } };

export type GetFilteredEsportsQueryVariables = Exact<{
  filters?: InputMaybe<EsportFilters>;
}>;


export type GetFilteredEsportsQuery = { __typename?: 'Query', esports: Array<{ __typename?: 'Esport', id: string, name: string | null, description: string | null, slug: Types.EsportSlug, rating: EsportRating, isEnabled: boolean, details: { __typename?: 'EsportDetails', abbreviation: string | null, esportId: string } | null }> };

export type GetEsportBySlugQueryVariables = Exact<{
  slug: Scalars['EsportSlug']['input'];
}>;


export type GetEsportBySlugQuery = { __typename?: 'Query', esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating, name: string | null, description: string | null, isEnabled: boolean, updatedAt: string | null, createdAt: string | null, isPromoted: boolean | null } | null };

export type EsportDetailsFragment = { __typename?: 'EsportDetails', esportId: string, accountProviders: Array<Provider> | null, competitionGroups: Array<CompetitionGroup> | null, rankingInfoCopy: string | null, abbreviation: string | null, gameType: string | null, defaultBestOf: number, defaultSeriesBestOf: number, playerStatRankCategory: string | null, matchOverviewFormat: string | null, rulebookUrl: string | null, platforms: Array<Platform> | null, positions: Array<Array<string>> | null, matchInstructionsArticleId: string | null, matchAssistantVideoSrc: string | null, scoreDisplayName: string | null, teamMinStarterSize: number, features: { __typename?: 'EsportFeatures', hasSeries: boolean, hasApiIntegration: boolean, hasSubstitutesEnabled: boolean, isDiscordEnabled: boolean | null, isScrimmageEnabled: boolean, isPlayerLedTeamEnabled: boolean, matchAssistantEnabled: boolean, hasMatchAssistantScore: boolean } | null, positionsArray: Array<{ __typename?: 'EsportPositions', position: number, abbreviation: string | null, colloquial: string | null, name: string | null }> | null, missingConnectionCopy: { __typename?: 'EsportMissingConnectionCopy', match: { __typename?: 'MissingConnectionCopyBody', subtitle: string | null, title: string | null } | null, overview: { __typename?: 'MissingConnectionCopyBody', subtitle: string | null, title: string | null } | null } | null, assets: { __typename?: 'EsportAssets', blackAndWhiteSvgIcon: string | null, avatarLogoUrl: string | null, disabledAvatarLogoUrl: string | null, iconComponent: string | null } | null };

export type GetGeneralEsportAdapterDetailsQueryVariables = Exact<{
  filters?: InputMaybe<EsportFilters>;
}>;


export type GetGeneralEsportAdapterDetailsQuery = { __typename?: 'Query', esports: Array<{ __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating, name: string | null, isEnabled: boolean, isUnderageEnabled: boolean, details: { __typename?: 'EsportDetails', esportId: string, accountProviders: Array<Provider> | null, competitionGroups: Array<CompetitionGroup> | null, rankingInfoCopy: string | null, abbreviation: string | null, gameType: string | null, defaultBestOf: number, defaultSeriesBestOf: number, playerStatRankCategory: string | null, matchOverviewFormat: string | null, rulebookUrl: string | null, platforms: Array<Platform> | null, positions: Array<Array<string>> | null, matchInstructionsArticleId: string | null, matchAssistantVideoSrc: string | null, scoreDisplayName: string | null, teamMinStarterSize: number, features: { __typename?: 'EsportFeatures', hasSeries: boolean, hasApiIntegration: boolean, hasSubstitutesEnabled: boolean, isDiscordEnabled: boolean | null, isScrimmageEnabled: boolean, isPlayerLedTeamEnabled: boolean, matchAssistantEnabled: boolean, hasMatchAssistantScore: boolean } | null, positionsArray: Array<{ __typename?: 'EsportPositions', position: number, abbreviation: string | null, colloquial: string | null, name: string | null }> | null, missingConnectionCopy: { __typename?: 'EsportMissingConnectionCopy', match: { __typename?: 'MissingConnectionCopyBody', subtitle: string | null, title: string | null } | null, overview: { __typename?: 'MissingConnectionCopyBody', subtitle: string | null, title: string | null } | null } | null, assets: { __typename?: 'EsportAssets', blackAndWhiteSvgIcon: string | null, avatarLogoUrl: string | null, disabledAvatarLogoUrl: string | null, iconComponent: string | null } | null } | null, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null, teamMaxSize: number | null }, colors: { __typename?: 'EsportColors', color1: string | null, color2: string | null, color3: string | null, color4: string | null, color5: string | null, color6: string | null, mainColor: string | null, gradientStart: string | null, gradientEnd: string | null } | null }> };

export type GetEsportsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GetEsportsV2Query = { __typename?: 'Query', esportsV2: Array<{ __typename?: 'EsportV2', id: string, name: string, rating: EsportRating | null, offerings: Array<{ __typename?: 'EsportOffering', competitionGroup: CompetitionGroup, esportId: string, teamFormat: { __typename?: 'TeamFormat', size: number }, platform: { __typename?: 'PlatformInfo', slug: Platform | null } }> | null }> };

export type GetAllEsportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEsportsQuery = { __typename?: 'Query', esports: Array<{ __typename?: 'Esport', id: string, name: string | null, esportGroupId: string | null, slug: Types.EsportSlug, platform: string | null, isEnabled: boolean, isPromoted: boolean | null, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null }, details: { __typename?: 'EsportDetails', esportId: string, abbreviation: string | null, platforms: Array<Platform> | null } | null }> };

export type GetAllEsportsSlugsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEsportsSlugsQuery = { __typename?: 'Query', esports: Array<{ __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }> };

export type GetAllEsportsWithLeagueAndSeasonCountQueryVariables = Exact<{
  metaseasonId: Scalars['UUID']['input'];
  competitionGroup: CompetitionGroup;
}>;


export type GetAllEsportsWithLeagueAndSeasonCountQuery = { __typename?: 'Query', esports: Array<{ __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, eligibleLeaguesCount: number | null, leaguesWithSeasonCount: number | null, inactiveLeaguesCount: number | null }> };

export type CreateEsportMutationVariables = Exact<{
  esportAttributes: EsportAttributes;
}>;


export type CreateEsportMutation = { __typename?: 'Mutation', createEsport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } | null };

export type UpdateEsportDetailsMutationVariables = Exact<{
  esportSlug: Scalars['String']['input'];
  attributes?: InputMaybe<EsportDetailsAttributes>;
}>;


export type UpdateEsportDetailsMutation = { __typename?: 'Mutation', updateEsportDetails: { __typename?: 'EsportDetails', esportId: string, accountProviders: Array<Provider> | null, competitionGroups: Array<CompetitionGroup> | null, rankingInfoCopy: string | null, abbreviation: string | null, gameType: string | null, defaultBestOf: number, defaultSeriesBestOf: number, playerStatRankCategory: string | null, matchOverviewFormat: string | null, rulebookUrl: string | null, platforms: Array<Platform> | null, positions: Array<Array<string>> | null, matchInstructionsArticleId: string | null, matchAssistantVideoSrc: string | null, scoreDisplayName: string | null, teamMinStarterSize: number, features: { __typename?: 'EsportFeatures', hasSeries: boolean, hasApiIntegration: boolean, hasSubstitutesEnabled: boolean, isDiscordEnabled: boolean | null, isScrimmageEnabled: boolean, isPlayerLedTeamEnabled: boolean, matchAssistantEnabled: boolean, hasMatchAssistantScore: boolean } | null, positionsArray: Array<{ __typename?: 'EsportPositions', position: number, abbreviation: string | null, colloquial: string | null, name: string | null }> | null, missingConnectionCopy: { __typename?: 'EsportMissingConnectionCopy', match: { __typename?: 'MissingConnectionCopyBody', subtitle: string | null, title: string | null } | null, overview: { __typename?: 'MissingConnectionCopyBody', subtitle: string | null, title: string | null } | null } | null, assets: { __typename?: 'EsportAssets', blackAndWhiteSvgIcon: string | null, avatarLogoUrl: string | null, disabledAvatarLogoUrl: string | null, iconComponent: string | null } | null } };

export type UpdateEsportMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  attributes: EsportAttributes;
}>;


export type UpdateEsportMutation = { __typename?: 'Mutation', updateEsport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating, isEnabled: boolean } | null };

export type UploadEsportFileMutationVariables = Exact<{
  input: UploadEsportFileInput;
}>;


export type UploadEsportFileMutation = { __typename?: 'Mutation', uploadEsportFile: { __typename?: 'UploadEsportFileResult', success: boolean, fileUrl: string } };

export type EsportsByCompetitionGroupQueryVariables = Exact<{
  competitionGroup: CompetitionGroup;
}>;


export type EsportsByCompetitionGroupQuery = { __typename?: 'Query', esportsByCompetitionGroup: Array<{ __typename?: 'Esport', id: string, slug: Types.EsportSlug }> };

export type GetEsportsForNexusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEsportsForNexusQuery = { __typename?: 'Query', esports: Array<{ __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, colors: { __typename?: 'EsportColors', color1: string | null, color2: string | null, color3: string | null, color4: string | null, color5: string | null, color6: string | null, mainColor: string | null, gradientStart: string | null, gradientEnd: string | null } | null }> };

export type UpdateEsportColorsMutationVariables = Exact<{
  esportId: Scalars['UUID']['input'];
  attributes: EsportColorsAttributes;
}>;


export type UpdateEsportColorsMutation = { __typename?: 'Mutation', setEsportColors: { __typename?: 'EsportPayload', esport: { __typename?: 'Esport', id: string } | null } };

export type EligibleMetaseasonsQueryVariables = Exact<{
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
  teamId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type EligibleMetaseasonsQuery = { __typename?: 'Query', eligibleMetaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, isPromoted: boolean, startsAt: string | null, endsAt: string | null, competitionGroup: CompetitionGroup, isInitialMetaseason: boolean }> };

export type SchoolLeaguesQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type SchoolLeaguesQuery = { __typename?: 'Query', getLeaguesBySchoolId: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, state: string | null, competitionModel: CompetitionModel, competitionGroup: CompetitionGroup, seasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, registrationStartsAt: string, teamRegistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null }> | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, rating: EsportRating, esportGroupId: string | null } }> | null };

export type MyLeagueFiltersQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type MyLeagueFiltersQuery = { __typename?: 'Query', eligibleMetaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean, status: SeasonStatus | null }>, school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null } }> | null } | null };

export type MyTeamManagementFiltersQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
}>;


export type MyTeamManagementFiltersQuery = { __typename?: 'Query', eligibleMetaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean, competitionGroup: CompetitionGroup }>, school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null } }> | null } | null, getLeaguesBySchoolId: Array<{ __typename?: 'League', id: string, name: string | null, competitionModel: CompetitionModel, displayName: string | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug } }> | null };

export type SchoolLeaguesFiltersQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  includeDeletedSeasonTeam?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SchoolLeaguesFiltersQuery = { __typename?: 'Query', eligibleMetaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean, isInitialMetaseason: boolean }> };

export type TeamLeaguesFiltersQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  hasMetaseason: Scalars['Boolean']['input'];
}>;


export type TeamLeaguesFiltersQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, competitionGroup: CompetitionGroup | null, name: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null }, leagues?: Array<{ __typename?: 'League', id: string }> | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, name: string, rostersLockAt: string | null, teamRegistrationEndsAt: string | null, league: { __typename?: 'League', id: string, name: string | null, competitionModel: CompetitionModel, displayName: string | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating, esportGroupId: string | null } } | null, phases: Array<{ __typename?: 'Phase', id: string, startsAt: string, endsAt: string, name: string | null, type: PhaseType, seasonId: string, slug: string | null, status: PhaseStatus, format: PhaseFormat, survivalAdvancementCount: number | null, survivalAdvancementPercentage: number | null }> | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null } | null }> | null } | null };

export type OpsTeamManagementFiltersQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
  includeDeletedSeasonTeam?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OpsTeamManagementFiltersQuery = { __typename?: 'Query', eligibleMetaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean, competitionGroup: CompetitionGroup, isInitialMetaseason: boolean }> };

export type GetMySchoolEsportsQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetMySchoolEsportsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string } | null } | null, getLeaguesBySchoolId: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, state: string | null, competitionModel: CompetitionModel, competitionGroup: CompetitionGroup, seasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, registrationStartsAt: string, teamRegistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null }> | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, rating: EsportRating, esportGroupId: string | null } }> | null };

export type GetAllEligibleMetaseasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEligibleMetaseasonsQuery = { __typename?: 'Query', eligibleMetaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isInitialMetaseason: boolean, competitionGroup: CompetitionGroup }> };

export type UseLeaguesQueryVariables = Exact<{
  metaseasonId: Scalars['UUID']['input'];
}>;


export type UseLeaguesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, leagueGroups: Array<{ __typename?: 'LeagueGroup', id: string, name: string }> } | null } | null };

export type UserHighlightsQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type UserHighlightsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, gameHighlights: Array<{ __typename?: 'GameHighlight', id: string, title: string, videoUrl: string, userId: string, matchId: string | null, thumbnailUrl: string | null, source: GameHighlightSource, createdAt: string, match: { __typename?: 'Match', id: string, scheduledStartsAt: string | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null }> } } | null } | null> | null } | null };

export type GetAllHighlightsQueryVariables = Exact<{
  filters?: InputMaybe<GameHighlightFilters>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllHighlightsQuery = { __typename?: 'Query', gameHighlights: { __typename?: 'GameHighlightsResult', hasNextPage: boolean | null, endCursor: string | null, gameHighlights: Array<{ __typename?: 'GameHighlight', id: string, title: string, matchId: string | null, videoUrl: string, userId: string, updatedAt: string, createdAt: string, user: { __typename?: 'User', id: string, name: string | null } | null, match: { __typename?: 'Match', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } } | null }> | null } };

export type CreateGameHighlightMutationVariables = Exact<{
  input: GameHighlightInput;
}>;


export type CreateGameHighlightMutation = { __typename?: 'Mutation', createGameHighlight: { __typename?: 'CreateGameHighlightPayload', gameHighlight: { __typename?: 'GameHighlight', id: string } } };

export type DeleteGameHighlightMutationVariables = Exact<{
  input: DeleteGameHighlightInput;
}>;


export type DeleteGameHighlightMutation = { __typename?: 'Mutation', deleteGameHighlight: { __typename?: 'DeleteGameHighlightInputPayload', deletedId: string } };

export type UpdateGameHighlightMutationVariables = Exact<{
  input: UpdateGameHighlightInput;
}>;


export type UpdateGameHighlightMutation = { __typename?: 'Mutation', updateGameHighlight: { __typename?: 'UpdateGameHighlightPayload', gameHighlight: { __typename?: 'GameHighlight', id: string } | null } };

export type GetUsernameSchoolNameQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsernameSchoolNameQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, name: string | null, slug: string | null, state: string | null, coaches: Array<{ __typename?: 'User', id: string }> | null } | null } | null };

export type LeagueOverviewDetailsQueryVariables = Exact<{
  metaseasonId: Scalars['UUID']['input'];
  isStudent: Scalars['Boolean']['input'];
}>;


export type LeagueOverviewDetailsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, name: string | null, email: string | null, gradYear?: number | null, phone?: string | null, phoneExt?: string | null, leagues: Array<{ __typename?: 'League', id: string, name: string | null, teamFormat: number, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null, esportInterests?: Array<{ __typename?: 'Esport', id: string, slug: Types.EsportSlug }> | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerDisplayName: string | null, providerAccountId: string | null, providerIntegrationType: IntegrationType | null }> | null, teams?: Array<{ __typename?: 'Team', id: string, esportId: string }> | null, school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null, address: string | null, name: string | null, slug: string | null, state: string | null, zip: string | null, mascotName: string | null, logoUrl: string | null, detail?: { __typename?: 'SchoolDetail', at: string | null, it: { __typename?: 'ITDetails', osType: string | null, hasDedicatedLab: boolean | null, numStudentComps: string | null, suppStaffOnCampus: boolean | null, publicIP: string | null, agreeToInstallGames: boolean | null, agreeToWhitelistPorts: boolean | null, agreeToDoPatchUpdates: boolean | null, suppStaff: { __typename?: 'SupportStaff', email: string | null, fname: string | null, lname: string | null, phone: string | null } | null } | null } | null, leagueGroups?: Array<{ __typename?: 'LeagueGroup', id: string, name: string, leagues: Array<{ __typename?: 'League', id: string, name: string | null, esport: { __typename?: 'Esport', id: string, description: string | null, name: string | null, slug: Types.EsportSlug, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null } }, seasons: Array<{ __typename?: 'Season', id: string, leagueId: string, metaseasonId: string | null, name: string, status: SeasonStatus, teamRegistrationEndsAt: string | null, phases: Array<{ __typename?: 'Phase', id: string, name: string | null, startsAt: string, endsAt: string, bestOf: number | null, format: PhaseFormat, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null }> | null }> | null }> | null }> | null }> } | null } | null };

export type UnverifiedAlertQueryVariables = Exact<{ [key: string]: never; }>;


export type UnverifiedAlertQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, userId: string, resourceId: string, resourceType: ResourceType }> | null, school: { __typename?: 'School', id: string, coaches: Array<{ __typename?: 'User', id: string, name: string | null }> | null, coachRolePendingUsers: Array<{ __typename?: 'User', id: string }> | null, playerRolePendingUsers: Array<{ __typename?: 'User', id: string }> | null } | null } | null };

export type GetMatchesWithMissingResultsQueryVariables = Exact<{
  metaseasonStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetMatchesWithMissingResultsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, matchesWithMissingResults: Array<{ __typename?: 'Match', id: string }> | null } | null } | null };

export type GetBillingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingInfoQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, billingContact: { __typename?: 'SchoolBillingContact', email: string, phone: string | null, user: { __typename?: 'BillingUser', id: string, email: string | null, phone: string | null } | null } | null } | null } | null };

export type GetLeagueScopeLeaguesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeagueScopeLeaguesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, leagueScope: { __typename?: 'AllLeaguesResult', result: Array<{ __typename?: 'League', id: string, name: string | null, competitionGroup: CompetitionGroup, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, rating: EsportRating } }> | null } | null } | null };

export type GetSchoolLeaguesQueryVariables = Exact<{
  schoolIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolLeaguesQuery = { __typename?: 'Query', findSchoolsByIds: Array<{ __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null }> | null, getLeaguesBySchoolId: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, state: string | null, competitionModel: CompetitionModel, competitionGroup: CompetitionGroup, seasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, registrationStartsAt: string, teamRegistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null }> | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, rating: EsportRating } }> | null };

export type GetAllLeaguesForExploreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLeaguesForExploreQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, dateOfBirth: string | null, leagueScope: { __typename?: 'AllLeaguesResult', result: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, timezone: string | null, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, rating: EsportRating }, seasons: Array<{ __typename?: 'Season', id: string, numberOfTeams: number | null, name: string, teamRegistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null, registrationStartsAt: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, isPromoted: boolean, startsAt: string | null, endsAt: string | null } | null, phases: Array<{ __typename?: 'Phase', id: string, type: PhaseType, startsAt: string, endsAt: string, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null }> | null }> | null }> | null, rulebook: { __typename?: 'EsportRulebook', id: string, url: string } | null }> | null } | null } | null };

export type GetLeagueByPublicSlugQueryVariables = Exact<{
  publicSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLeagueByPublicSlugQuery = { __typename?: 'Query', getLeagueByPublicSlug: { __typename?: 'League', id: string, name: string | null, displayName: string | null, timezone: string | null, teamFormat: number, teamMaxSize: number, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel, canRemovePlayersFromTeams: boolean | null, isHidden: boolean | null, isCheckInEnabled: boolean | null, checkInOpenDaysBefore: number | null, checkInOpenTime: string | null, checkInCloseTimeOffsetMilliseconds: number | null, type: LeagueType | null, varsityAssociation: { __typename?: 'VarsityAssociation', slug: string, name: string } | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, platform: string | null, rating: EsportRating, details: { __typename?: 'EsportDetails', esportId: string, abbreviation: string | null, teamMinStarterSize: number, rulebookUrl: string | null } | null }, seasons: Array<{ __typename?: 'Season', status: SeasonStatus }> | null, rulebook: { __typename?: 'EsportRulebook', id: string, url: string } | null } | null };

export type GetLeagueSeasonDataQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetLeagueSeasonDataQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, seasonByMetaseasonId: { __typename?: 'Season', id: string, name: string, numberOfTeams: number | null, status: SeasonStatus, startsAt: string, rostersLockAt: string | null, endsAt: string, registrationStartsAt: string, teamRegistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null, activePhases: Array<{ __typename?: 'Phase', id: string, name: string | null, type: PhaseType, startsAt: string, endsAt: string, format: PhaseFormat, bracketSize: number | null, status: PhaseStatus, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, isStartsAtHidden: boolean | null, order: number | null, ordinal: number | null, label: SlotLabel | null, name: string | null }> | null }> | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, url: string, updatedAt: string }> | null } | null } | null };

export type FindOrgCompetitionGroupQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindOrgCompetitionGroupQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null, name: string | null } | null };

export type FindLeaguePreviewsByEsportSchoolQueryVariables = Exact<{
  esportId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
}>;


export type FindLeaguePreviewsByEsportSchoolQuery = { __typename?: 'Query', findLeaguePreviewsByEsportSchool: { __typename?: 'EsportLeaguesPreview', rulebook: { __typename?: 'EsportRulebook', id: string, url: string } | null, leaguePreviews: Array<{ __typename?: 'LeaguePreview', league: { __typename?: 'League', id: string, displayName: string | null, name: string | null, timezone: string | null, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel, publicSlug: string | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string, slug: string } | null }, nextSeason: { __typename?: 'Season', id: string, type: SeasonType | null, numberOfTeams: number | null, name: string, registrationStartsAt: string, teamRegistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null, startsAt: string, endsAt: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null, phases: Array<{ __typename?: 'Phase', id: string, type: PhaseType, startsAt: string, endsAt: string, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null }> | null }> | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, url: string, updatedAt: string }> | null } | null, nextSlot: { __typename?: 'Slot', id: string, startsAt: string | null } | null }> } };

export type GetLeagueTeamsQueryVariables = Exact<{
  filters: TeamFiltersInput;
}>;


export type GetLeagueTeamsQuery = { __typename?: 'Query', getTeams: { __typename?: 'TeamsResult', teams: Array<{ __typename?: 'Team', id: string, name: string | null, esportId: string, competitionGroup: CompetitionGroup | null, school: { __typename?: 'School', id: string, logoUrl: string | null } | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating }, leagues: Array<{ __typename?: 'League', id: string }> | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null }> | null, roster: { __typename?: 'TeamRoster', teamId: string, numPlayers: number } | null }> | null } | null };

export type GetAllLeagueTeamsQueryVariables = Exact<{
  filters: TeamFiltersInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllLeagueTeamsQuery = { __typename?: 'Query', getTeams: { __typename?: 'TeamsResult', totalCount: number | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, state: string | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating }, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null }> | null } | null };

export type GetExploreLeaguesQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetExploreLeaguesQuery = { __typename?: 'Query', getLeaguesBySchoolId: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, state: string | null, competitionModel: CompetitionModel, competitionGroup: CompetitionGroup, teamFormat: number, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, rating: EsportRating } }> | null };

export type AllLeagueGroupsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<LeagueGroupFiltersInput>;
}>;


export type AllLeagueGroupsQuery = { __typename?: 'Query', getAllLeagueGroups: { __typename?: 'AllLeagueGroupsResult', total: number | null, result: Array<{ __typename?: 'LeagueGroup', id: string, name: string, state: string | null, competitionGroup: CompetitionGroup, varsityAssociation: { __typename?: 'VarsityAssociation', slug: string, name: string } | null, leagues: Array<{ __typename?: 'League', id: string, name: string | null, competitionModel: CompetitionModel }> | null }> | null } };

export type GetLeagueGroupQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  filters?: InputMaybe<LeagueFiltersInput>;
}>;


export type GetLeagueGroupQuery = { __typename?: 'Query', leagueGroup: { __typename?: 'LeagueGroup', id: string, name: string, state: string | null, competitionGroup: CompetitionGroup, varsityAssociation: { __typename?: 'VarsityAssociation', slug: string, name: string } | null, leagues: Array<{ __typename?: 'League', id: string, name: string | null, competitionModel: CompetitionModel, isHidden: boolean | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string, slug: string } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null } }> | null } | null };

export type GetVaLeagueGroupsQueryVariables = Exact<{
  filters?: InputMaybe<LeagueGroupFiltersInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVaLeagueGroupsQuery = { __typename?: 'Query', getAllLeagueGroups: { __typename?: 'AllLeagueGroupsResult', total: number | null, result: Array<{ __typename?: 'LeagueGroup', id: string, name: string, state: string | null }> | null } };

export type GetLeagueLeagueGroupsQueryVariables = Exact<{
  filters?: InputMaybe<LeagueGroupFiltersInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLeagueLeagueGroupsQuery = { __typename?: 'Query', getAllLeagueGroups: { __typename?: 'AllLeagueGroupsResult', total: number | null, result: Array<{ __typename?: 'LeagueGroup', id: string, name: string, state: string | null }> | null } };

export type CreateLeagueGroupMutationVariables = Exact<{
  input: CreateLeagueGroupInput;
}>;


export type CreateLeagueGroupMutation = { __typename?: 'Mutation', createLeagueGroup: { __typename?: 'CreateLeagueGroupPayload', leagueGroup: { __typename?: 'LeagueGroup', id: string } | null } };

export type UpdateLeagueGroupMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  attributes: UpdateLeagueGroupInput;
}>;


export type UpdateLeagueGroupMutation = { __typename?: 'Mutation', updateLeagueGroup: { __typename?: 'LeagueGroup', id: string, name: string, state: string | null, competitionGroup: CompetitionGroup } };

export type RemoveLeagueFromLeagueGroupMutationVariables = Exact<{
  leagueGroupId: Scalars['UUID']['input'];
  leagueId: Scalars['UUID']['input'];
}>;


export type RemoveLeagueFromLeagueGroupMutation = { __typename?: 'Mutation', removeLeagueFromLeagueGroup: { __typename?: 'LeagueGroupPayload', success: boolean, leagueId: string, leagueGroupId: string } };

export type AddLeagueToLeagueGroupMutationVariables = Exact<{
  leagueGroupId: Scalars['UUID']['input'];
  leagueId: Scalars['UUID']['input'];
}>;


export type AddLeagueToLeagueGroupMutation = { __typename?: 'Mutation', addLeagueToLeagueGroup: { __typename?: 'LeagueGroupPayload', success: boolean, leagueId: string, leagueGroupId: string } };

export type UpdateLeagueDetailsMutationVariables = Exact<{
  input: UpdateLeagueInput;
}>;


export type UpdateLeagueDetailsMutation = { __typename?: 'Mutation', updateLeague: { __typename?: 'UpdateLeaguePayload', league: { __typename?: 'League', id: string, name: string | null } | null } };

export type GetLeagueScheduleSeasonsQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
}>;


export type GetLeagueScheduleSeasonsQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, seasons: Array<{ __typename?: 'Season', id: string, name: string, metaseasonId: string | null }> | null } | null };

export type GetLeagueSeasonsForFilterQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
}>;


export type GetLeagueSeasonsForFilterQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, seasons: Array<{ __typename?: 'Season', id: string, name: string, status: SeasonStatus, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null }> | null } | null };

export type GetLeagueSeasonsQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
}>;


export type GetLeagueSeasonsQuery = { __typename?: 'Query', metaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, competitionGroup: CompetitionGroup }>, league: { __typename?: 'League', id: string, name: string | null, timezone: string | null, competitionGroup: CompetitionGroup, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, allSeasons: Array<{ __typename?: 'Season', id: string, name: string, metaseasonId: string | null, registrationStartsAt: string, suggestedRegistrationEndsAt: string | null, teamRegistrationEndsAt: string | null, startsAt: string, endsAt: string, status: SeasonStatus }> | null } | null };

export type GetLeagueSeasonQueryVariables = Exact<{
  seasonId: Scalars['UUID']['input'];
}>;


export type GetLeagueSeasonQuery = { __typename?: 'Query', season: { __typename?: 'Season', id: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null } | null, allPhases: Array<{ __typename?: 'Phase', id: string, fortniteEventId: string | null, bestOf: number | null, bracketSize: number | null, format: PhaseFormat, name: string | null, startsAt: string, endsAt: string, status: PhaseStatus, type: PhaseType, teams: Array<{ __typename?: 'SeededTeam', id: string, seed: number | null, name: string | null }> | null, slots: Array<{ __typename?: 'Slot', id: string, fortniteEventWindowId: string | null, name: string | null, order: number | null, scheduleMatchesAt: string | null, startsAt: string | null, isStartsAtHidden: boolean | null, status: SlotStatus, ordinal: number | null, label: SlotLabel | null }> | null }> | null } | null };

export type GetLeaguePageQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
}>;


export type GetLeaguePageQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, name: string | null, state: string | null, timezone: string | null, competitionGroup: CompetitionGroup, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, seasons: Array<{ __typename?: 'Season', id: string, name: string, startsAt: string, endsAt: string, metaseason: { __typename?: 'Metaseason', id: string, isPromoted: boolean, name: string | null, startsAt: string | null, endsAt: string | null } | null }> | null, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null };

export type GetLeagueSeasonByMetaseasonIdQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetLeagueSeasonByMetaseasonIdQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, seasonByMetaseasonId: { __typename?: 'Season', id: string, numberOfTeams: number | null, numberOfPendingTeams: number | null, numberOfTeamsByStates: Array<{ __typename?: 'NumberOfTeamsInSeasonByStateResult', state: string, teamCount: number }> | null, numberOfTeamsByVarsityAssociations: Array<{ __typename?: 'NumberOfTeamsInSeasonByVarsityAssociationResult', teamCount: number, varsityAssociation: { __typename?: 'VarsityAssociation', slug: string, abbreviation: string, name: string } | null }> | null } | null } | null };

export type GetLeaguesDetailsByMetaseasonIdQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters: LeagueFilters;
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetLeaguesDetailsByMetaseasonIdQuery = { __typename?: 'Query', getAllLeagues: { __typename?: 'AllLeaguesResult', total: number | null, result: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, state: string | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, teams: Array<{ __typename?: 'Team', id: string, esport: { __typename?: 'Esport', leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null } }, roster: { __typename?: 'TeamRoster', numPlayers: number, isFull: boolean, maxNumPlayers: number } | null, school: { __typename?: 'School', id: string, state: string | null, varsityAssociations: Array<{ __typename?: 'VarsityAssociation', slug: string, name: string }> } | null }> | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string } | null, seasonByMetaseasonId: { __typename?: 'Season', id: string, numberOfTeams: number | null, numberOfTeamsByStates: Array<{ __typename?: 'NumberOfTeamsInSeasonByStateResult', state: string, teamCount: number }> | null, numberOfTeamsByVarsityAssociations: Array<{ __typename?: 'NumberOfTeamsInSeasonByVarsityAssociationResult', teamCount: number, varsityAssociation: { __typename?: 'VarsityAssociation', slug: string, abbreviation: string, name: string } | null }> | null } | null }> | null } };

export type GetSeasonForLeagueFilterQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetSeasonForLeagueFilterQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, seasonByMetaseasonId: { __typename?: 'Season', id: string, name: string, rostersLockAt: string | null, teamRegistrationEndsAt: string | null, phases: Array<{ __typename?: 'Phase', id: string, startsAt: string, endsAt: string, name: string | null, type: PhaseType, seasonId: string, slug: string | null, status: PhaseStatus, format: PhaseFormat, survivalAdvancementCount: number | null, survivalAdvancementPercentage: number | null }> | null } | null } | null };

export type GetLeaguePhasesForStandingsQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
}>;


export type GetLeaguePhasesForStandingsQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, seasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isInitialMetaseason: boolean, competitionGroup: CompetitionGroup } | null, phases: Array<{ __typename?: 'Phase', id: string, name: string | null, startsAt: string, endsAt: string, type: PhaseType, slug: string | null, format: PhaseFormat }> | null }> | null } | null };

export type GetLeagueBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetLeagueBySlugQuery = { __typename?: 'Query', leagueBySlug: { __typename?: 'League', id: string, name: string | null, displayName: string | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, seasons: Array<{ __typename?: 'Season', id: string, name: string, startsAt: string, endsAt: string, phases: Array<{ __typename?: 'Phase', id: string, name: string | null, type: PhaseType, startsAt: string, endsAt: string, format: PhaseFormat, teams: Array<{ __typename?: 'SeededTeam', id: string, name: string | null, seed: number | null, school: { __typename?: 'School', id: string, logoUrl: string | null } | null }> | null }> | null }> | null } | null };

export type InactivateLeaguesForMetaseasonMutationVariables = Exact<{
  leagueIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  metaseasonId: Scalars['UUID']['input'];
}>;


export type InactivateLeaguesForMetaseasonMutation = { __typename?: 'Mutation', setLeaguesInactiveForMetaseason: { __typename?: 'LeaguesPayload', success: boolean } };

export type ActivateLeaguesForMetaseasonMutationVariables = Exact<{
  leagueIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type ActivateLeaguesForMetaseasonMutation = { __typename?: 'Mutation', setLeaguesActiveForMetaseason: { __typename?: 'LeaguesPayload', success: boolean, leagueIds: Array<string> } };

export type CreateLeagueMutationVariables = Exact<{
  input: CreateLeagueInput;
}>;


export type CreateLeagueMutation = { __typename?: 'Mutation', createLeague: { __typename?: 'CreateLeaguePayload', league: { __typename?: 'League', id: string } | null } };

export type GetLeagueDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetLeagueDetailsQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, name: string | null, displayName: string | null, timezone: string | null, teamFormat: number, teamMaxSize: number, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel, state: string | null, canRemovePlayersFromTeams: boolean | null, canHaveMultipleTeamsWithSamePlayers: boolean | null, isHidden: boolean | null, isCheckInEnabled: boolean | null, checkInOpenDaysBefore: number | null, checkInOpenTime: string | null, checkInCloseTimeOffsetMilliseconds: number | null, type: LeagueType | null, publicSlug: string | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string, slug: string } | null, allSeasons: Array<{ __typename?: 'Season', id: string }> | null } | null };

export type GetLeagueMetaseasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeagueMetaseasonsQuery = { __typename?: 'Query', metaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, isPromoted: boolean, startsAt: string | null }> };

export type GetLeagueDetailsByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetLeagueDetailsByIdQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, name: string | null, timezone: string | null, teamFormat: number, teamMaxSize: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, seasons: Array<{ __typename?: 'Season', id: string, name: string, status: SeasonStatus, teamRegistrationEndsAt: string | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null, phases: Array<{ __typename?: 'Phase', id: string, name: string | null, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null }> | null }> | null }> | null } | null };

export type AllLeaguesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters: LeagueFilters;
}>;


export type AllLeaguesQuery = { __typename?: 'Query', getAllLeagues: { __typename?: 'AllLeaguesResult', total: number | null, result: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, isHidden: boolean | null, state: string | null, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel, varsityAssociation: { __typename?: 'VarsityAssociation', slug: string, name: string } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null }, seasons: Array<{ __typename?: 'Season', id: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null }> | null }> | null } };

export type AllLeaguesTotalQueryVariables = Exact<{
  filters: LeagueFilters;
}>;


export type AllLeaguesTotalQuery = { __typename?: 'Query', getAllLeagues: { __typename?: 'AllLeaguesResult', total: number | null } };

export type LeaguesSelectTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters: LeagueFilters;
}>;


export type LeaguesSelectTableQuery = { __typename?: 'Query', getAllLeagues: { __typename?: 'AllLeaguesResult', total: number | null, result: Array<{ __typename?: 'League', id: string, name: string | null, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel }> | null } };

export type MetaseasonLeaguesTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters: LeagueFilters;
  metaseasonId: Scalars['UUID']['input'];
}>;


export type MetaseasonLeaguesTableQuery = { __typename?: 'Query', getAllLeagues: { __typename?: 'AllLeaguesResult', total: number | null, result: Array<{ __typename?: 'League', id: string, name: string | null, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel, timezone: string | null, numberOfPossibleTeamsAndPlayers: { __typename?: 'NumberOfPossibleTeamsAndPlayersResult', numberOfPlayers: number, numberOfTeams: number } | null, seasonByMetaseasonId: { __typename?: 'Season', id: string, numberOfTeams: number | null, numberOfPlayers: number | null, enrollmentStatus: SeasonEnrollmentStatus | null, startsAt: string, endsAt: string, registrationStartsAt: string, suggestedRegistrationEndsAt: string | null, teamRegistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, playerRegistrationEndsAt: string | null, playerDeregistrationEndsAt: string | null, rostersLockAt: string | null, phases: Array<{ __typename?: 'Phase', id: string, type: PhaseType }> | null } | null }> | null } };

export type GetLeaguesPendingPlayerDataQueryVariables = Exact<{
  leagueIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetLeaguesPendingPlayerDataQuery = { __typename?: 'Query', getLeaguesPendingPlayerData: Array<{ __typename?: 'LeaguePlayerData', leagueId: string, leagueName: string, teamId: string, playerId: string } | null> };

export type GetLeaguesEnrolledPlayerDataQueryVariables = Exact<{
  leagueIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetLeaguesEnrolledPlayerDataQuery = { __typename?: 'Query', getLeaguesEnrolledPlayerData: Array<{ __typename?: 'LeaguePlayerData', leagueId: string, leagueName: string, teamId: string, playerId: string } | null> };

export type FindCommonLeaguesForTeamsQueryVariables = Exact<{
  input: CommonLeaguesForTeamsInput;
  metaseasonId: Scalars['UUID']['input'];
}>;


export type FindCommonLeaguesForTeamsQuery = { __typename?: 'Query', findCommonLeaguesForTeams: Array<{ __typename?: 'League', id: string, name: string | null, seasonByMetaseasonId: { __typename?: 'Season', id: string } | null }> | null };

export type GetVaLeaguesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters: LeagueFilters;
}>;


export type GetVaLeaguesQuery = { __typename?: 'Query', getAllLeagues: { __typename?: 'AllLeaguesResult', total: number | null, result: Array<{ __typename?: 'League', id: string, name: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null }, seasons: Array<{ __typename?: 'Season', id: string, name: string, startsAt: string, endsAt: string }> | null }> | null } };

export type UnlockLeagueMutationVariables = Exact<{
  input: UnlockLeagueInput;
}>;


export type UnlockLeagueMutation = { __typename?: 'Mutation', unlockLeague: { __typename?: 'LeaguePayload', success: boolean } | null };

export type ConsolidateLeagueMutationVariables = Exact<{
  input: ConsolidateLeagueInput;
}>;


export type ConsolidateLeagueMutation = { __typename?: 'Mutation', consolidateLeague: { __typename?: 'LeaguePayload', success: boolean } | null };

export type GetHelpLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHelpLinksQuery = { __typename?: 'Query', getLinks: Array<{ __typename?: 'Link', id: string, slug: string, url: string, title: string }> };

export type UpdateLinkMutationVariables = Exact<{
  input: UpdateLinkInput;
}>;


export type UpdateLinkMutation = { __typename?: 'Mutation', updateLink: { __typename?: 'Link', slug: string, url: string } };

export type MatchTeamFragment = { __typename?: 'MatchTeam', id: string, schoolId: string | null, isMyTeam: boolean | null, name: string | null, avatarUrl: string | null, competitionGroup: CompetitionGroup | null, league: { __typename?: 'League', id: string } | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null, regularSeasonTeamPhaseStandings: { __typename?: 'TeamRegSeasonPhaseStandings', ranking: number | null, hasClinchedPlayoffs: boolean | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number } | null } | null };

export type SeriesTeamFragment = { __typename?: 'SeriesTeam', id: string, seriesId: string, schoolId: string | null, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null, result: { __typename?: 'SeriesResult', placing: number | null } | null };

export type GetLobbyMatchStaticQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetLobbyMatchStaticQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, isSettleableByACoach: boolean, isScrimmage: boolean | null, scheduledStartsAt: string | null, bestOf: number | null, seriesBestOf: number | null, discordLink: string | null, scheduleContext: MatchScheduleContext | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, schoolId: string | null, isMyTeam: boolean | null, name: string | null, avatarUrl: string | null, competitionGroup: CompetitionGroup | null, league: { __typename?: 'League', id: string } | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null, regularSeasonTeamPhaseStandings: { __typename?: 'TeamRegSeasonPhaseStandings', ranking: number | null, hasClinchedPlayoffs: boolean | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number } | null } | null }> }, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating }, matchResults: Array<{ __typename?: 'MatchResult', id: string, placing: number | null, teamSide: number | null, metaseasonId: string | null, gamesWon: number | null, teamId: string | null, seriesWon: number | null, team: { __typename?: 'Team', id: string, name: string | null, deletedAt: string | null, roster: { __typename?: 'TeamRoster', id: string, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } } | null }> }>, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, leagues: Array<{ __typename?: 'League', id: string }> | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, startsAt: string, metaseason: { __typename?: 'Metaseason', id: string, startsAt: string | null, endsAt: string | null, name: string | null, isPromoted: boolean } | null }> | null } | null }> | null, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, schoolId: string | null, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null, result: { __typename?: 'SeriesResult', placing: number | null } | null }> } }> | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType, format: PhaseFormat, season: { __typename?: 'Season', id: string, leagueId: string, metaseasonId: string | null } | null } | null } | null } | null };

export type LobbyMatchFragment = { __typename?: 'Match', id: string, status: MatchStatus, isScrimmage: boolean | null, forfeitReason: ForfeitReason | null, autoForfeited: boolean | null, scheduleContext: MatchScheduleContext | null, scheduledStartsAt: string | null, bestOf: number | null, seriesBestOf: number | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, matchCheckIns: Array<{ __typename?: 'MatchCheckIn', id: string, teamId: string, userId: string, status: string | null }>, matchSettleRequests: Array<{ __typename?: 'MatchSettleRequestModel', id: string, status: MatchSettleRequestStatus | null, type: MatchSettleRequestType | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', gameResults: Array<{ __typename?: 'GameResultRequest', winningTeamId: string, winningTeamScore: number | null, losingTeamScore: number | null }> }> | null } | null }> | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, gamesWon: number | null, seriesWon: number | null, teamSide: number | null, placing: number | null, teamId: string | null, team: { __typename?: 'Team', id: string, name: string | null, isMyTeam: boolean | null, competitionGroup: CompetitionGroup | null, school: { __typename?: 'School', id: string, slug: string | null, name: string | null, logoUrl: string | null } | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating } } | null }> | null, matchDisputeRequests: Array<{ __typename?: 'MatchDisputeRequest', id: string, status: MatchDisputeStatus }> | null, series: Array<{ __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, schoolId: string | null, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null, result: { __typename?: 'SeriesResult', placing: number | null } | null }> } }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, gameResults: Array<{ __typename?: 'GameResult', id: string, teamId: string | null, sidePlayed: number | null, placing: number | null, score: number | null }> | null }> | null, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', id: string, status: MatchRescheduleRequestStatus | null, teamId: string, matchId: string, createdAt: string, rescheduleNotes: string | null, proposedTimes: Array<string> | null }> | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, competitionGroup: CompetitionGroup | null, isMyTeam: boolean | null, school: { __typename?: 'School', id: string, slug: string | null, name: string | null, logoUrl: string | null } | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating } }> }, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType } | null } | null };

export type GetLobbyMatchQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetLobbyMatchQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, isScrimmage: boolean | null, forfeitReason: ForfeitReason | null, autoForfeited: boolean | null, scheduleContext: MatchScheduleContext | null, scheduledStartsAt: string | null, bestOf: number | null, seriesBestOf: number | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, matchCheckIns: Array<{ __typename?: 'MatchCheckIn', id: string, teamId: string, userId: string, status: string | null }>, matchSettleRequests: Array<{ __typename?: 'MatchSettleRequestModel', id: string, status: MatchSettleRequestStatus | null, type: MatchSettleRequestType | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', gameResults: Array<{ __typename?: 'GameResultRequest', winningTeamId: string, winningTeamScore: number | null, losingTeamScore: number | null }> }> | null } | null }> | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, gamesWon: number | null, seriesWon: number | null, teamSide: number | null, placing: number | null, teamId: string | null, team: { __typename?: 'Team', id: string, name: string | null, isMyTeam: boolean | null, competitionGroup: CompetitionGroup | null, school: { __typename?: 'School', id: string, slug: string | null, name: string | null, logoUrl: string | null } | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating } } | null }> | null, matchDisputeRequests: Array<{ __typename?: 'MatchDisputeRequest', id: string, status: MatchDisputeStatus }> | null, series: Array<{ __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, schoolId: string | null, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null, result: { __typename?: 'SeriesResult', placing: number | null } | null }> } }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, gameResults: Array<{ __typename?: 'GameResult', id: string, teamId: string | null, sidePlayed: number | null, placing: number | null, score: number | null }> | null }> | null, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', id: string, status: MatchRescheduleRequestStatus | null, teamId: string, matchId: string, createdAt: string, rescheduleNotes: string | null, proposedTimes: Array<string> | null }> | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, competitionGroup: CompetitionGroup | null, isMyTeam: boolean | null, school: { __typename?: 'School', id: string, slug: string | null, name: string | null, logoUrl: string | null } | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating } }> }, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType } | null } | null } | null };

export type GetMatchDetailsForProviderQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchDetailsForProviderQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, scheduledStartsAt: string | null } | null };

export type GetCancelMatchQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetCancelMatchQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, isScrimmage: boolean | null, status: MatchStatus, scheduledStartsAt: string | null, bestOf: number | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null }> }, matchResults: Array<{ __typename?: 'MatchResult', id: string, team: { __typename?: 'Team', id: string, name: string | null } | null }> | null, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', id: string, status: MatchRescheduleRequestStatus | null, proposedTimes: Array<string> | null, teamId: string, matchId: string }> | null, scrimmageRequest: { __typename?: 'ScrimmageRequest', id: string, bestOf: number | null, startsAt: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string } | null } | null, opposingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string } | null } | null } | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType } | null } | null } | null };

export type GetRescheduleMatchQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetRescheduleMatchQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, scheduledStartsAt: string | null, bestOf: number | null, isScrimmage: boolean | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, startsAt: string, endsAt: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, scheduleMatchesAt: string | null, status: SlotStatus }> | null } | null } | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null, state: string | null, school: { __typename?: 'School', id: string } | null }> }, league: { __typename?: 'League', id: string, state: string | null, competitionGroup: CompetitionGroup } | null, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', id: string, matchId: string, proposedTimes: Array<string> | null, teamId: string, requestedById: string | null, deniedById: string | null, approvedById: string | null, canceledById: string | null, status: MatchRescheduleRequestStatus | null, rescheduleReason: MatchRescheduleRequestReason | null, rescheduleNotes: string | null, denyNotes: string | null, createdAt: string, updatedAt: string | null }> | null } | null };

export type ForfeitMatchMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
  reason?: InputMaybe<ForfeitReason>;
  forfeitDetail?: InputMaybe<Scalars['String']['input']>;
}>;


export type ForfeitMatchMutation = { __typename?: 'Mutation', forfeitMatch: { __typename?: 'ForfeitMatchResponse', matchId: string, teamId: string, losingTeamId: string, winningTeamId: string } };

export type GetFortniteTeamMatchStatsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetFortniteTeamMatchStatsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, format: PhaseFormat, survivalAdvancementPercentage: number | null, survivalAdvancementCount: number | null } | null } | null, fortniteTeamMatchStats: { __typename?: 'FortniteTeamMatchStatsResult', updatedAt: string | null, total: number | null, leaderboard: Array<{ __typename?: 'TeamMatchStats', team: { __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, state: string | null, slug: string | null } | null } | null, stats: { __typename?: 'FortniteTeamMatchStats', id: string, rank: number, clutched: boolean | null, totalPoints: number, placementPoints: number, eliminationPoints: number, totalSecondsSurvived: number, avgPointsPerSession: number, avgPlacementPerSession: number, avgEliminationsPerSession: number, sessionsPlayed: number } | { __typename?: 'LeagueOfLegendsTeamMatchStats' } | { __typename?: 'RocketLeagueTeamMatchStats' } | { __typename?: 'SmiteTeamMatchStats' } | null }> | null, schoolTeams: Array<{ __typename?: 'TeamMatchStats', team: { __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, state: string | null, slug: string | null } | null } | null, stats: { __typename?: 'FortniteTeamMatchStats', id: string, rank: number, clutched: boolean | null, totalPoints: number, placementPoints: number, eliminationPoints: number, totalSecondsSurvived: number, avgPointsPerSession: number, avgPlacementPerSession: number, avgEliminationsPerSession: number, sessionsPlayed: number } | { __typename?: 'LeagueOfLegendsTeamMatchStats' } | { __typename?: 'RocketLeagueTeamMatchStats' } | { __typename?: 'SmiteTeamMatchStats' } | null }> | null, myTeams: Array<{ __typename?: 'TeamMatchStats', team: { __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, state: string | null, slug: string | null } | null } | null, stats: { __typename?: 'FortniteTeamMatchStats', id: string, rank: number, clutched: boolean | null, totalPoints: number, placementPoints: number, eliminationPoints: number, totalSecondsSurvived: number, avgPointsPerSession: number, avgPlacementPerSession: number, avgEliminationsPerSession: number, sessionsPlayed: number } | { __typename?: 'LeagueOfLegendsTeamMatchStats' } | { __typename?: 'RocketLeagueTeamMatchStats' } | { __typename?: 'SmiteTeamMatchStats' } | null }> | null } | null } | null };

export type LeagueUnconnectedPlayersQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
}>;


export type LeagueUnconnectedPlayersQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, unconnectedUsers: Array<{ __typename?: 'User', id: string, name: string | null }> | null } | null };

export type DmrMatchSeriesTeamFragment = { __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null };

export type DmrMatchTeamFragment = { __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null, school: { __typename?: 'School', logoUrl: string | null, id: string, name: string | null } | null };

export type DmrMatchFragment = { __typename?: 'Match', id: string, seriesBestOf: number | null, status: MatchStatus, scheduledStartsAt: string | null, bestOf: number | null, esport: { __typename?: 'Esport', slug: Types.EsportSlug, rating: EsportRating }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null, school: { __typename?: 'School', logoUrl: string | null, id: string, name: string | null } | null }> }, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } }> | null, matchSettleRequests: Array<{ __typename?: 'MatchSettleRequestModel', id: string, status: MatchSettleRequestStatus | null, type: MatchSettleRequestType | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', gameResults: Array<{ __typename?: 'GameResultRequest', winningTeamId: string, winningTeamScore: number | null, losingTeamScore: number | null }> }> | null } | null }> | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, teamSide: number | null, teamId: string | null, placing: number | null, gamesWon: number | null, seriesWon: number | null, team: { __typename?: 'Team', id: string, name: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null } | null }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, gameResults: Array<{ __typename?: 'GameResult', id: string, teamId: string | null, sidePlayed: number | null, placing: number | null, score: number | null }> | null }> | null };

export type GetDmrMatchQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetDmrMatchQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, seriesBestOf: number | null, status: MatchStatus, scheduledStartsAt: string | null, bestOf: number | null, esport: { __typename?: 'Esport', slug: Types.EsportSlug, rating: EsportRating }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null, school: { __typename?: 'School', logoUrl: string | null, id: string, name: string | null } | null }> }, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } }> | null, matchSettleRequests: Array<{ __typename?: 'MatchSettleRequestModel', id: string, status: MatchSettleRequestStatus | null, type: MatchSettleRequestType | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', gameResults: Array<{ __typename?: 'GameResultRequest', winningTeamId: string, winningTeamScore: number | null, losingTeamScore: number | null }> }> | null } | null }> | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, teamSide: number | null, teamId: string | null, placing: number | null, gamesWon: number | null, seriesWon: number | null, team: { __typename?: 'Team', id: string, name: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null } | null }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, gameResults: Array<{ __typename?: 'GameResult', id: string, teamId: string | null, sidePlayed: number | null, placing: number | null, score: number | null }> | null }> | null } | null };

export type LoginUserMutationVariables = Exact<{
  input: LoginUserInput;
}>;


export type LoginUserMutation = { __typename?: 'Mutation', loginUser: { __typename?: 'LoginUserResponse', token: string | null, user: { __typename?: 'User', id: string, isUnderage: boolean } } };

export type RegisterUserMutationVariables = Exact<{
  input: RegisterUserInput;
  options: RegisterUserOptions;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', registerUser: { __typename?: 'RegisterUserResponse', user: { __typename?: 'User', id: string, isUnderage: boolean } } };

export type LogoutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { __typename?: 'Mutation', logoutUser: { __typename?: 'LogoutPayload', success: boolean } };

export type CreatePastByeMatchMutationVariables = Exact<{
  input: CreatePastByeMatchInput;
}>;


export type CreatePastByeMatchMutation = { __typename?: 'Mutation', createPastByeMatch: { __typename?: 'MatchJobPayload', jobId: string } };

export type ScheduleMatchMutationVariables = Exact<{
  input: ScheduleMatchInput;
}>;


export type ScheduleMatchMutation = { __typename?: 'Mutation', scheduleMatch: { __typename?: 'MatchJobPayload', jobId: string } };

export type ScheduleMatchesMutationVariables = Exact<{
  input: ScheduleMatchesInput;
}>;


export type ScheduleMatchesMutation = { __typename?: 'Mutation', scheduleMatches: { __typename?: 'ScheduleMatchesPayload', jobIds: Array<string> } };

export type OpenMatchMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type OpenMatchMutation = { __typename?: 'Mutation', openMatch: { __typename?: 'MatchJobPayload', jobId: string } };

export type CancelMatchMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type CancelMatchMutation = { __typename?: 'Mutation', cancelMatch: { __typename?: 'MatchJobPayload', jobId: string } };

export type CompleteMatchMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  reviewGames?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompleteMatchMutation = { __typename?: 'Mutation', completeMatch: { __typename?: 'MatchJobPayload', jobId: string } };

export type SendFirstMessageNotificationIfNecessaryMutationVariables = Exact<{
  input: SendFirstMessageNotificationIfNecessaryInput;
}>;


export type SendFirstMessageNotificationIfNecessaryMutation = { __typename?: 'Mutation', sendFirstMessageNotificationIfNecessary: { __typename?: 'SendFirstMessageNotificationIfNecessaryPayload', success: boolean } };

export type CancelGameMutationVariables = Exact<{
  gameId: Scalars['UUID']['input'];
}>;


export type CancelGameMutation = { __typename?: 'Mutation', cancelGame: { __typename?: 'GameJobPayload', jobId: string | null } };

export type ResolveUnknownPlayerGameStatsMutationVariables = Exact<{
  gameId: Scalars['UUID']['input'];
  playerId: Scalars['UUID']['input'];
  publisherAccountId: Scalars['String']['input'];
}>;


export type ResolveUnknownPlayerGameStatsMutation = { __typename?: 'Mutation', resolveUnknownPlayerGameStats: { __typename?: 'GameJobPayload', jobId: string | null } };

export type AdminForfeitMatchMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  losingTeamId: Scalars['UUID']['input'];
  winningTeamId: Scalars['UUID']['input'];
  forfeitReason?: InputMaybe<ForfeitReason>;
}>;


export type AdminForfeitMatchMutation = { __typename?: 'Mutation', adminForfeitMatch: { __typename?: 'MatchJobPayload', jobId: string } };

export type AdminAllForfeitMatchMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  losingTeamIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  forfeitReason?: InputMaybe<ForfeitReason>;
}>;


export type AdminAllForfeitMatchMutation = { __typename?: 'Mutation', adminAllForfeitMatch: { __typename?: 'MatchJobPayload', jobId: string } };

export type AddTeamToMatchMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
}>;


export type AddTeamToMatchMutation = { __typename?: 'Mutation', createMatchResult: { __typename?: 'CreateMatchResultPayload', matchResult: { __typename?: 'MatchResult', id: string } | null } };

export type AdminSubmitLeaderboardMatchGameResultsMutationVariables = Exact<{
  input: AdminSubmitLeaderboardMatchGameResultsInput;
}>;


export type AdminSubmitLeaderboardMatchGameResultsMutation = { __typename?: 'Mutation', adminSubmitLeaderboardMatchGameResults: boolean };

export type GameAssistantStepFragment = { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean };

export type GameAssistantSelectionOptionFragment = { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null };

export type GameAssistantTeamScoreFragment = { __typename?: 'GameAssistantTeamScore', teamId: string, score: number };

export type GameAssistantGameDetailsFragment = { __typename?: 'GameAssistantGameDetails', timeRemainingInSeconds: number, gameOrdinal: number, scores: Array<{ __typename?: 'GameAssistantTeamScore', teamId: string, score: number }> | null };

export type GameAssistantMatchDetailsFragment = { __typename?: 'GameAssistantMatchDetails', isComplete: boolean | null, games: Array<{ __typename?: 'GameAssistantGameDetails', timeRemainingInSeconds: number, gameOrdinal: number, scores: Array<{ __typename?: 'GameAssistantTeamScore', teamId: string, score: number }> | null }> | null };

export type GameAssistantSelectionFragment = { __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null };

export type GameAssistantStepWithSelectionsFragment = { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean, selections: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> };

export type GameAssistantStepRosterFragment = { __typename?: 'TeamRoster', id: string, teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }> }> };

export type GameAssistantStateFragment = { __typename?: 'GameAssistantStatePayload', nextGameRosterChangeRequested: boolean | null, splatoonGameMode: string | null, showMatchAssistant: boolean, lolGameCode: string | null, step: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean, selections: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> } | null, characterBans: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, characterPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, mapBans: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, mapPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, playerPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, spectatorPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, freeStrikeMaps: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, matchDetails: { __typename?: 'GameAssistantMatchDetails', isComplete: boolean | null, games: Array<{ __typename?: 'GameAssistantGameDetails', timeRemainingInSeconds: number, gameOrdinal: number, scores: Array<{ __typename?: 'GameAssistantTeamScore', teamId: string, score: number }> | null }> | null } | null, currentSeries: { __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } } | null, roster: { __typename?: 'TeamRoster', id: string, teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }> }> } | null, opponentRoster: { __typename?: 'TeamRoster', id: string, teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }> }> } | null };

export type GameAssistantStateUpdatedFragment = { __typename?: 'GameAssistantStepUpdatedSubscribePayload', currentState: { __typename?: 'GameAssistantStatePayload', nextGameRosterChangeRequested: boolean | null, splatoonGameMode: string | null, showMatchAssistant: boolean, lolGameCode: string | null, step: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean, selections: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> } | null, characterBans: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, characterPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, mapBans: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, mapPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, playerPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, spectatorPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, freeStrikeMaps: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, matchDetails: { __typename?: 'GameAssistantMatchDetails', isComplete: boolean | null, games: Array<{ __typename?: 'GameAssistantGameDetails', timeRemainingInSeconds: number, gameOrdinal: number, scores: Array<{ __typename?: 'GameAssistantTeamScore', teamId: string, score: number }> | null }> | null } | null, currentSeries: { __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } } | null, roster: { __typename?: 'TeamRoster', id: string, teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }> }> } | null, opponentRoster: { __typename?: 'TeamRoster', id: string, teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }> }> } | null } };

export type GameAssistantStepUpdatedSubscriptionVariables = Exact<{
  input: GameAssistantStepUpdatedSubscribeInput;
}>;


export type GameAssistantStepUpdatedSubscription = { __typename?: 'Subscription', gameAssistantStepUpdated: { __typename?: 'GameAssistantStepUpdatedSubscribePayload', currentState: { __typename?: 'GameAssistantStatePayload', nextGameRosterChangeRequested: boolean | null, splatoonGameMode: string | null, showMatchAssistant: boolean, lolGameCode: string | null, step: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean, selections: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> } | null, characterBans: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, characterPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, mapBans: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, mapPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, playerPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, spectatorPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, freeStrikeMaps: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, matchDetails: { __typename?: 'GameAssistantMatchDetails', isComplete: boolean | null, games: Array<{ __typename?: 'GameAssistantGameDetails', timeRemainingInSeconds: number, gameOrdinal: number, scores: Array<{ __typename?: 'GameAssistantTeamScore', teamId: string, score: number }> | null }> | null } | null, currentSeries: { __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } } | null, roster: { __typename?: 'TeamRoster', id: string, teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }> }> } | null, opponentRoster: { __typename?: 'TeamRoster', id: string, teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }> }> } | null } } | null };

export type GetFinalMatchResultsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetFinalMatchResultsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, matchResults: Array<{ __typename?: 'MatchResult', teamId: string | null, gamesWon: number | null }> | null } | null };

export type GetAvailableSpectatorsByTeamIdQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type GetAvailableSpectatorsByTeamIdQuery = { __typename?: 'Query', availableSpectatorsByTeamId: { __typename?: 'AvailableSpectatorsPayload', spectators: Array<{ __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null }> | null } };

export type GetShowMatchAssistantQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetShowMatchAssistantQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, matchAssistantEnabled: boolean | null } | null };

export type ResetGameAssistantStepsForGameMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  seriesOrdinal: Scalars['Int']['input'];
  gameOrdinal: Scalars['Int']['input'];
}>;


export type ResetGameAssistantStepsForGameMutation = { __typename?: 'Mutation', resetGameAssistantStepsForGame: { __typename?: 'ResetStepPayload', success: boolean, currentStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean, selections: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> } } };

export type ResetGameAssistantStepsForSeriesMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  seriesOrdinal: Scalars['Int']['input'];
}>;


export type ResetGameAssistantStepsForSeriesMutation = { __typename?: 'Mutation', resetGameAssistantStepsForSeries: { __typename?: 'ResetStepPayload', success: boolean, currentStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean, selections: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> } } };

export type ResetGameAssistantStepsForMatchMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type ResetGameAssistantStepsForMatchMutation = { __typename?: 'Mutation', resetGameAssistantStepsForMatch: { __typename?: 'ResetStepPayload', success: boolean, currentStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean, selections: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> } } };

export type GetCurrentGameAssistantStepByMatchIdQueryVariables = Exact<{
  input: CurrentGameAssistantStateInput;
}>;


export type GetCurrentGameAssistantStepByMatchIdQuery = { __typename?: 'Query', currentGameAssistantStateByMatchId: { __typename?: 'GameAssistantStatePayload', nextGameRosterChangeRequested: boolean | null, splatoonGameMode: string | null, showMatchAssistant: boolean, lolGameCode: string | null, step: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean, selections: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> } | null, characterBans: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, characterPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, mapBans: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, mapPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, playerPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, spectatorPicks: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, freeStrikeMaps: Array<{ __typename?: 'GameAssistantSelection', id: string, userId: string | null, selectionOptionId: string | null, stepId: string, gameAssistantStep: { __typename?: 'GameAssistantStep', id: string, matchId: string, seriesId: string | null, seriesOrdinal: number | null, gameId: string | null, gameOrdinal: number, type: GameAssistantStepType, stepOrdinal: number, teamId: string | null, turn: GameAssistantTurnType, totalSelections: number, selectionOptionType: GameAssistantSelectionOptionType | null, submitted: boolean } | null, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null } | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, matchDetails: { __typename?: 'GameAssistantMatchDetails', isComplete: boolean | null, games: Array<{ __typename?: 'GameAssistantGameDetails', timeRemainingInSeconds: number, gameOrdinal: number, scores: Array<{ __typename?: 'GameAssistantTeamScore', teamId: string, score: number }> | null }> | null } | null, currentSeries: { __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } } | null, roster: { __typename?: 'TeamRoster', id: string, teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }> }> } | null, opponentRoster: { __typename?: 'TeamRoster', id: string, teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerDisplayName: string | null }> | null } }> }> } | null } };

export type MatchAssistantUserFragment = { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null };

export type GetCurrentSeriesPlayerSelectionsByMatchIdQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
}>;


export type GetCurrentSeriesPlayerSelectionsByMatchIdQuery = { __typename?: 'Query', currentSeriesPlayerSelectionsByMatchId: { __typename?: 'SeriesPlayerSelectionsPayload', players: Array<{ __typename?: 'User', id: string, name: string | null, avatarUrl: string | null }> | null } };

export type SubmitGameAssistantStepSelectionsMutationVariables = Exact<{
  input: SubmitGameAssistantStepSelectionsInput;
}>;


export type SubmitGameAssistantStepSelectionsMutation = { __typename?: 'Mutation', submitGameAssistantStepSelections: { __typename?: 'SubmitGameAssistantStepSelectionsPayload', success: boolean } };

export type RequestGameResetMutationVariables = Exact<{
  input: RequestGameResetInput;
}>;


export type RequestGameResetMutation = { __typename?: 'Mutation', requestGameReset: { __typename?: 'RequestGameResetPayload', success: boolean } };

export type RequestMatchAssistantBypassMutationVariables = Exact<{
  input: RequestMatchAssistantBypassInput;
}>;


export type RequestMatchAssistantBypassMutation = { __typename?: 'Mutation', requestMatchAssistantBypass: { __typename?: 'RequestMatchAssistantBypassPayload', success: boolean } };

export type RequestNextGameRosterChangeMutationVariables = Exact<{
  input: RequestNextGameRosterChangeForRocketLeagueInput;
}>;


export type RequestNextGameRosterChangeMutation = { __typename?: 'Mutation', requestNextGameRosterChangeForRocketLeague: { __typename?: 'RequestNextGameRosterChangeForRocketLeaguePayload', success: boolean } };

export type MatchAssistantTeamFragment = { __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, name: string | null, competitionGroup: CompetitionGroup | null, avatarUrl: string | null, schoolId: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null } | null, regularSeasonTeamPhaseStandings: { __typename?: 'TeamRegSeasonPhaseStandings', ranking: number | null, hasClinchedPlayoffs: boolean | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number } | null } | null };

export type GetMatchForMatchAssistantQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  includeSeries: Scalars['Boolean']['input'];
}>;


export type GetMatchForMatchAssistantQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, scheduledStartsAt: string | null, bestOf: number | null, status: MatchStatus, format: MatchFormat | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, ordinalNumber: number | null, gameResults: Array<{ __typename?: 'GameResult', id: string, teamId: string | null, sidePlayed: number | null, placing: number | null, score: number | null }> | null }> | null, matchSettleRequests: Array<{ __typename?: 'MatchSettleRequestModel', id: string, status: MatchSettleRequestStatus | null, type: MatchSettleRequestType | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', gameResults: Array<{ __typename?: 'GameResultRequest', winningTeamId: string, winningTeamScore: number | null, losingTeamScore: number | null }> }> | null } | null }> | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, teamId: string | null, metaseasonId: string | null, teamSide: number | null, placing: number | null, gamesWon: number | null, seriesWon?: number | null, team: { __typename?: 'Team', id: string, name: string | null, avatarUrl: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerDisplayName: string | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null } | null } | null }> | null, series?: Array<{ __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, schoolId: string | null, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null, result: { __typename?: 'SeriesResult', placing: number | null } | null }> } }> | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, name: string | null, competitionGroup: CompetitionGroup | null, avatarUrl: string | null, schoolId: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null } | null, regularSeasonTeamPhaseStandings: { __typename?: 'TeamRegSeasonPhaseStandings', ranking: number | null, hasClinchedPlayoffs: boolean | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number } | null } | null }>, myTeams: Array<{ __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, name: string | null, competitionGroup: CompetitionGroup | null, avatarUrl: string | null, schoolId: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null } | null, regularSeasonTeamPhaseStandings: { __typename?: 'TeamRegSeasonPhaseStandings', ranking: number | null, hasClinchedPlayoffs: boolean | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number } | null } | null }>, otherTeams: Array<{ __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, name: string | null, competitionGroup: CompetitionGroup | null, avatarUrl: string | null, schoolId: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null } | null, regularSeasonTeamPhaseStandings: { __typename?: 'TeamRegSeasonPhaseStandings', ranking: number | null, hasClinchedPlayoffs: boolean | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number } | null } | null }> }, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, season: { __typename?: 'Season', id: string, metaseasonId: string | null } | null } | null } | null } | null };

export type GetMatchResultsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMatchResultsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, gameResults: Array<{ __typename?: 'GameResult', id: string, teamId: string | null, sidePlayed: number | null, placing: number | null, score: number | null }> | null }> | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating }, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, schoolId: string | null, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null, result: { __typename?: 'SeriesResult', placing: number | null } | null }> } }> | null, matchSettleRequests: Array<{ __typename?: 'MatchSettleRequestModel', id: string, status: MatchSettleRequestStatus | null, type: MatchSettleRequestType | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', gameResults: Array<{ __typename?: 'GameResultRequest', winningTeamId: string, winningTeamScore: number | null, losingTeamScore: number | null }> }> | null } | null }> | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, teamId: string | null, teamSide: number | null, gamesWon: number | null, seriesWon: number | null, team: { __typename?: 'Team', id: string, name: string | null, avatarUrl: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerDisplayName: string | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null } | null } | null }> | null } | null };

export type SubmitLeaderboardGameResultMutationVariables = Exact<{
  input: SubmitLeaderboardGameResultLiveInput;
}>;


export type SubmitLeaderboardGameResultMutation = { __typename?: 'Mutation', submitLeaderboardGameResultLive: { __typename?: 'SubmitLeaderboardGameResultLivePayload', success: boolean } };

export type GetMatchChatByUniqueIdQueryVariables = Exact<{
  input: GetMatchChatByUniqueIdInput;
}>;


export type GetMatchChatByUniqueIdQuery = { __typename?: 'Query', getMatchChatByUniqueId: { __typename?: 'GetMatchChatByUniqueIdResults', chat: { __typename?: 'Chat', sid: string, matchId: string, state: ChatState } } };

export type UpsertMatchCheckInMutationVariables = Exact<{
  params: MatchCheckInUpsertParams;
}>;


export type UpsertMatchCheckInMutation = { __typename?: 'Mutation', upsertMatchCheckIn: { __typename?: 'MatchCheckIn', id: string, matchId: string, teamId: string, userId: string, status: string | null } };

export type GetCheckInMatchesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MatchFiltersInput>;
  isFortnite: Scalars['Boolean']['input'];
}>;


export type GetCheckInMatchesQuery = { __typename?: 'Query', getMatches: { __typename?: 'MatchesResult', totalCount: number | null, matches: Array<{ __typename?: 'Match', id: string, isScrimmage: boolean | null, scheduledStartsAt: string | null, checkInOpensAt: string | null, checkInClosesAt: string | null, status: MatchStatus, name: string | null, slotId: string | null, scheduleContext: MatchScheduleContext | null, league: { __typename?: 'League', id: string, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel } | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating }, matchResults?: Array<{ __typename?: 'MatchResult', id: string, matchId: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, team: { __typename?: 'Team', id: string, name: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null } | null }> | null, matchCheckIns: Array<{ __typename?: 'MatchCheckIn', id: string, matchId: string, teamId: string, status: string | null, user: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null } | null }>, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, playerGameStats: Array<{ __typename?: 'PlayerGameStats', id: string, player: { __typename?: 'User', id: string } | null }> | null, winningTeam: { __typename?: 'GameTeam', id: string, gameId: string } | null, losingTeam: { __typename?: 'GameTeam', id: string, gameId: string } | null }> | null, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', status: MatchRescheduleRequestStatus | null, teamId: string }> | null, slot: { __typename?: 'Slot', id: string, startsAt: string | null, status: SlotStatus, phaseId: string | null, phase: { __typename?: 'Phase', id: string, name: string | null, type: PhaseType, seasonId: string, season: { __typename?: 'Season', id: string, metaseasonId: string | null, leagueId: string, league: { __typename?: 'League', id: string, timezone: string | null } | null } | null } | null } | null }> | null } };

export type GetTeamIdsForMatchDisputeQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetTeamIdsForMatchDisputeQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, school: { __typename?: 'School', id: string } | null }> } } | null };

export type FnMatchFaceoffQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type FnMatchFaceoffQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string | null, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, userId: string, resourceId: string }> | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, leagues: Array<{ __typename?: 'League', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, leagues: Array<{ __typename?: 'League', id: string }> | null }> | null } | null, match: { __typename?: 'Match', id: string, isScrimmage: boolean | null, name: string | null, status: MatchStatus, scheduledStartsAt: string | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, season: { __typename?: 'Season', id: string, leagueId: string } | null } | null } | null, fortniteTeamMatchStats: { __typename?: 'FortniteTeamMatchStatsResult', updatedAt: string | null, total: number | null, myTeams: Array<{ __typename?: 'TeamMatchStats', team: { __typename?: 'Team', id: string, name: string | null } | null, stats: { __typename?: 'FortniteTeamMatchStats', id: string, rank: number, totalPoints: number, placementPoints: number, eliminationPoints: number } | { __typename?: 'LeagueOfLegendsTeamMatchStats' } | { __typename?: 'RocketLeagueTeamMatchStats' } | { __typename?: 'SmiteTeamMatchStats' } | null }> | null } | null } | null };

export type JoinQueueMutationVariables = Exact<{
  input: JoinQueueInput;
}>;


export type JoinQueueMutation = { __typename?: 'Mutation', joinQueue: { __typename?: 'JoinQueueResponse', placeId: string | null } | null };

export type CheckPlaceInQueueMutationVariables = Exact<{
  input: CheckPlaceInQueueInput;
}>;


export type CheckPlaceInQueueMutation = { __typename?: 'Mutation', checkPlaceInQueue: { __typename?: 'CheckPlaceInQueueResponse', status: QueueStatus, matchId: string | null, opponentTeamId: string | null } | null };

export type LeaveQueueMutationVariables = Exact<{
  input: LeaveQueueInput;
}>;


export type LeaveQueueMutation = { __typename?: 'Mutation', leaveQueue: { __typename?: 'LeaveQueueResponse', success: boolean | null } | null };

export type AcceptQueueMutationVariables = Exact<{
  input: AcceptQueueInput;
}>;


export type AcceptQueueMutation = { __typename?: 'Mutation', acceptQueue: { __typename?: 'AcceptQueueResponse', placeId: string } | null };

export type DeclineQueueMutationVariables = Exact<{
  input: DeclineQueueInput;
}>;


export type DeclineQueueMutation = { __typename?: 'Mutation', declineQueue: { __typename?: 'DeclineQueueResponse', placeId: string } | null };

export type JoinSmartQueueMutationVariables = Exact<{
  input: JoinSmartQueueInput;
}>;


export type JoinSmartQueueMutation = { __typename?: 'Mutation', joinSmartQueue: { __typename?: 'GenericQueuePayload', success: boolean, errors: Array<string> | null } | null };

export type LeaveSmartQueueMutationVariables = Exact<{
  input: LeaveSmartQueueInput;
}>;


export type LeaveSmartQueueMutation = { __typename?: 'Mutation', leaveSmartQueue: { __typename?: 'GenericQueuePayload', success: boolean, errors: Array<string> | null } | null };

export type CheckPlaceInSmartQueueStateFragment = { __typename?: 'SmartQueueStatePayload', inQueue: boolean, matchId: string | null, mostRecentPairing: string | null, remainingScheduleJobs: number | null };

export type CheckPlaceInSmartQueueStateUpdatedFragment = { __typename?: 'SmartQueueUpdateSubscribePayload', currentState: { __typename?: 'SmartQueueStatePayload', inQueue: boolean, matchId: string | null, mostRecentPairing: string | null, remainingScheduleJobs: number | null } };

export type CheckPlaceInSmartQueueQueryVariables = Exact<{
  input: CheckPlaceInSmartQueueInput;
}>;


export type CheckPlaceInSmartQueueQuery = { __typename?: 'Query', checkPlaceInSmartQueue: { __typename?: 'SmartQueueStatePayload', inQueue: boolean, matchId: string | null, mostRecentPairing: string | null, remainingScheduleJobs: number | null } | null };

export type SmartQueueStateUpdatedSubscriptionVariables = Exact<{
  input: SmartQueueUpdateSubscribeInput;
}>;


export type SmartQueueStateUpdatedSubscription = { __typename?: 'Subscription', smartQueueStateUpdated: { __typename?: 'SmartQueueUpdateSubscribePayload', currentState: { __typename?: 'SmartQueueStatePayload', inQueue: boolean, matchId: string | null, mostRecentPairing: string | null, remainingScheduleJobs: number | null } } | null };

export type JoinPreseasonQueueMutationVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;


export type JoinPreseasonQueueMutation = { __typename?: 'Mutation', joinPreseasonQueue: { __typename?: 'GenericQueuePayload', success: boolean, errors: Array<string> | null } | null };

export type LeavePreseasonQueueMutationVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;


export type LeavePreseasonQueueMutation = { __typename?: 'Mutation', leavePreseasonQueue: { __typename?: 'GenericQueuePayload', success: boolean, errors: Array<string> | null } | null };

export type PreseasonQueueDataFragment = { __typename?: 'CheckPlaceInPreseasonQueuePayload', inQueue: boolean, matchId: string | null, mostRecentPairing: string | null, numTeamsInQueue: number, nextScheduledPairing: string | null };

export type CheckPlaceInPreseasonQueueQueryVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;


export type CheckPlaceInPreseasonQueueQuery = { __typename?: 'Query', checkPlaceInPreseasonQueue: { __typename?: 'CheckPlaceInPreseasonQueuePayload', success: boolean, errors: Array<string> | null, inQueue: boolean, matchId: string | null, mostRecentPairing: string | null, numTeamsInQueue: number, nextScheduledPairing: string | null } | null };

export type MatchStatsHeaderQueryVariables = Exact<{
  needAttentionFilters?: InputMaybe<MatchFiltersInput>;
  liveMatchesFilters?: InputMaybe<MatchFiltersInput>;
  getTeamsFilters?: InputMaybe<TeamFiltersInput>;
  scheduledMatchesFilters?: InputMaybe<MatchFiltersInput>;
}>;


export type MatchStatsHeaderQuery = { __typename?: 'Query', needAttention: { __typename?: 'MatchesResult', totalCount: number | null }, liveMatches: { __typename?: 'MatchesResult', totalCount: number | null }, teamsParticipating: { __typename?: 'TeamsResult', totalCount: number | null } | null, scheduledMatches: { __typename?: 'MatchesResult', totalCount: number | null } };

export type MatchResultTeamFragment = { __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, name: string | null, school: { __typename?: 'School', name: string | null, id: string, logoUrl: string | null } | null };

export type MatchSeriesTeamFragment = { __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, lastSeen: string | null, publisherAccountName: string | null }> | null };

export type GetMatchSeriesResultsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchSeriesResultsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, bestOf: number | null, scheduledStartsAt: string | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, metaseasonId: string | null, team: { __typename?: 'Team', id: string, isMyTeam: boolean | null } | null }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus }> | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, name: string | null, school: { __typename?: 'School', name: string | null, id: string, logoUrl: string | null } | null }> }, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, games: Array<{ __typename?: 'SeriesGame', id: string, ordinalNumber: number | null, teamContext: { __typename?: 'GameTeamContext', gameId: string, teams: Array<{ __typename?: 'GameTeam', id: string, gameId: string, result: { __typename?: 'GameResult', id: string, placing: number | null } | null }> } }> | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, lastSeen: string | null, publisherAccountName: string | null }> | null }> } }> | null } | null };

export type GetMatchReportHistoryQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  fetchInput: FetchMatchSettleRequestInput;
}>;


export type GetMatchReportHistoryQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, forfeitReason: ForfeitReason | null, forfeitDetail: string | null, autoForfeited: boolean | null, updatedAt: string | null, series: Array<{ __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null }> | null }> } }> | null, matchDisputeRequests: Array<{ __typename?: 'MatchDisputeRequest', id: string, reason: MatchDisputeReason | null, notes: string | null, status: MatchDisputeStatus, createdAt: string | null, updatedAt: string | null, requestedBy: { __typename?: 'User', id: string, name: string | null } | null, asset: { __typename?: 'Asset', id: string, fileName: string, signedUrl: string | null } | null }> | null, forfeitedByUser: { __typename?: 'User', id: string, name: string | null } | null } | null, fetchMatchSettleRequest: { __typename?: 'MultipleMatchSettleRequestsPayload', success: boolean, errors: Array<string> | null, matchSettleRequest: Array<{ __typename?: 'MatchSettleRequestModel', id: string, createdAt: string | null, updatedAt: string | null, status: MatchSettleRequestStatus | null, type: MatchSettleRequestType | null, incompleteReason: MatchSettleIncompleteReason | null, incompleteNotes: string | null, matchId: string, teamId: string | null, requestedById: string | null, isReadyForReview: boolean | null, forfeitReason: ForfeitReason | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', id: string | null, ordinalNumber: number | null, gameResults: Array<{ __typename?: 'GameResultRequest', ordinalNumber: number, losingTeamId: string, incompleteReason: GameIncompleteReason | null, winningTeam: { __typename?: 'Team', id: string, name: string | null } | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, signedUrl: string | null }> | null }> }> | null } | null, requestedBy: { __typename?: 'User', id: string, name: string | null } | null, team: { __typename?: 'Team', id: string, name: string | null } | null, match: { __typename?: 'Match', id: string, bestOf: number | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, ordinalNumber: number | null, winningTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null }> | null, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, games: Array<{ __typename?: 'SeriesGame', id: string, status: GameStatus, ordinalNumber: number | null, winningTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null }> | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null }> | null }> } }> | null } | null }> | null } };

export type MatchResultsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MatchResultsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, bestOf: number | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, placing: number | null, teamSide: number | null, gamesWon: number | null, gamesLost: number | null, seriesWon: number | null, seriesLost: number | null, team: { __typename?: 'Team', id: string, name: string | null } | null }> | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null }> }, games: Array<{ __typename?: 'Game', id: string, gameResults: Array<{ __typename?: 'GameResult', id: string, placing: number | null, teamId: string | null }> | null }> | null } | null };

export type GetTeamMatchStatsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<TeamMatchStatsFiltersInput>;
}>;


export type GetTeamMatchStatsQuery = { __typename?: 'Query', getTeamMatchStats: { __typename?: 'TeamMatchStatsResult', total: number | null, results: Array<{ __typename?: 'TeamMatchStats', id: string }> | null } | null };

export type StatsRateFragment = { __typename?: 'PlayedWinRate', name: string, played: number, winRate: number, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, assetUri: string | null } | null };

export type SmashUltimateStatsPlayerFragment = { __typename?: 'MostPlayedStatsByPlayerId', playerId: string, mostPlayedStages: Array<{ __typename?: 'PlayedWinRate', name: string, played: number, winRate: number, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, assetUri: string | null } | null } | null>, mostPlayedCharacters: Array<{ __typename?: 'PlayedWinRate', name: string, played: number, winRate: number, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, assetUri: string | null } | null } | null> };

export type SmashUltimateStatsFragment = { __typename?: 'GetSmashUltimateMostPlayedStatsByPlayerIdResults', players: Array<{ __typename?: 'MostPlayedStatsByPlayerId', playerId: string, mostPlayedStages: Array<{ __typename?: 'PlayedWinRate', name: string, played: number, winRate: number, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, assetUri: string | null } | null } | null>, mostPlayedCharacters: Array<{ __typename?: 'PlayedWinRate', name: string, played: number, winRate: number, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, assetUri: string | null } | null } | null> }> };

export type GetSmashUltimateStatsQueryVariables = Exact<{
  input: GetSmashUltimateMostPlayedStatsByPlayerIdsInput;
  esportSlug?: InputMaybe<Scalars['EsportSlug']['input']>;
}>;


export type GetSmashUltimateStatsQuery = { __typename?: 'Query', getSmashUltimateMostPlayedStatsByPlayerIds: { __typename?: 'GetSmashUltimateMostPlayedStatsByPlayerIdResults', players: Array<{ __typename?: 'MostPlayedStatsByPlayerId', playerId: string, mostPlayedStages: Array<{ __typename?: 'PlayedWinRate', name: string, played: number, winRate: number, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, assetUri: string | null } | null } | null>, mostPlayedCharacters: Array<{ __typename?: 'PlayedWinRate', name: string, played: number, winRate: number, selectionOption: { __typename?: 'GameAssistantSelectionOption', id: string, assetUri: string | null } | null } | null> }> } };

export type SmashUltimateGameStatsPlayerFragment = { __typename?: 'SmashUltimateCharacterSelection', playerId: string, teamId: string, characterPlayedOption: { __typename?: 'GameAssistantSelectionOption', id: string, assetUri: string | null, displayName: string } };

export type SmashUltimateGameStatsResultsFragment = { __typename?: 'SmashUltimateGameStats', gameId: string, stagePlayed: string, winner: string, players: Array<{ __typename?: 'SmashUltimateCharacterSelection', playerId: string, teamId: string, characterPlayedOption: { __typename?: 'GameAssistantSelectionOption', id: string, assetUri: string | null, displayName: string } }> };

export type GetSmashGameStatsQueryVariables = Exact<{
  input: Array<GetSmashUltimatePlayerStatsByGameIdsInput> | GetSmashUltimatePlayerStatsByGameIdsInput;
  esportSlug?: InputMaybe<Scalars['EsportSlug']['input']>;
}>;


export type GetSmashGameStatsQuery = { __typename?: 'Query', getSmashUltimatePlayerStatsByGameIds: { __typename?: 'GetSmashUltimatePlayerStatsByGameIdsResults', results: Array<{ __typename?: 'SmashUltimateGameStats', gameId: string, stagePlayed: string, winner: string, players: Array<{ __typename?: 'SmashUltimateCharacterSelection', playerId: string, teamId: string, characterPlayedOption: { __typename?: 'GameAssistantSelectionOption', id: string, assetUri: string | null, displayName: string } }> }> } };

type PlayerGameSpecificGameStats_LeagueOfLegendsPlayerGameStats_Fragment = { __typename?: 'LeagueOfLegendsPlayerGameStats' };

type PlayerGameSpecificGameStats_RocketLeaguePlayerGameStats_Fragment = { __typename?: 'RocketLeaguePlayerGameStats', id: string, shootingPercentage: number | null, score: number, goals: number, saves: number, assists: number, shots: number };

type PlayerGameSpecificGameStats_SmitePlayerGameStats_Fragment = { __typename?: 'SmitePlayerGameStats' };

export type PlayerGameSpecificGameStatsFragment = PlayerGameSpecificGameStats_LeagueOfLegendsPlayerGameStats_Fragment | PlayerGameSpecificGameStats_RocketLeaguePlayerGameStats_Fragment | PlayerGameSpecificGameStats_SmitePlayerGameStats_Fragment;

export type PlayerGameStatsFragment = { __typename?: 'PlayerGameStats', teamId: string, gameId: string, rosterStatus: PlayerGameStatsRosterStatus, isKnown: boolean, publisherAccountId: string, stats: { __typename?: 'LeagueOfLegendsPlayerGameStats' } | { __typename?: 'RocketLeaguePlayerGameStats', id: string, shootingPercentage: number | null, score: number, goals: number, saves: number, assists: number, shots: number } | { __typename?: 'SmitePlayerGameStats' } | null, team: { __typename?: 'Team', id: string } };

export type GetPlayerGameStatsByMatchIdQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetPlayerGameStatsByMatchIdQuery = { __typename?: 'Query', getPlayerGameStatsByMatchId: Array<{ __typename?: 'PlayerGameStats', teamId: string, gameId: string, rosterStatus: PlayerGameStatsRosterStatus, isKnown: boolean, publisherAccountId: string, stats: { __typename?: 'LeagueOfLegendsPlayerGameStats' } | { __typename?: 'RocketLeaguePlayerGameStats', id: string, shootingPercentage: number | null, score: number, goals: number, saves: number, assists: number, shots: number } | { __typename?: 'SmitePlayerGameStats' } | null, team: { __typename?: 'Team', id: string } }> };

export type RocketLeaguePlayerSeasonStatsFragment = { __typename?: 'RocketLeaguePlayerSeasonStats', averageShots: number, averageGoals: number, averageAssists: number, averageSaves: number };

export type SplatoonPlayedWinRateFragment = { __typename?: 'SplatoonPlayedWinRate', name: string, played: number, winRate: number };

export type SplatoonMostPlayedStatsFragment = { __typename?: 'SplatoonMostPlayedStatsByPlayerId', playerId: string, mostPlayedStages: Array<{ __typename?: 'SplatoonPlayedWinRate', name: string, played: number, winRate: number } | null>, mostPlayedCharacters: Array<{ __typename?: 'SplatoonPlayedWinRate', name: string, played: number, winRate: number } | null> };

export type MaddenPlayedWinRateFragment = { __typename?: 'MaddenPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null };

export type MaddenMostPlayedStatsFragment = { __typename?: 'MaddenMostPlayedStatsByPlayerId', playerId: string, mostPlayedTeams: Array<{ __typename?: 'MaddenPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null>, mostPlayedOffensivePlaybooks: Array<{ __typename?: 'MaddenPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null>, mostPlayedDefensivePlaybooks: Array<{ __typename?: 'MaddenPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null> };

export type NbaPlayedWinRateFragment = { __typename?: 'NBA2kPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null };

export type NbaMostPlayedStatsFragment = { __typename?: 'NBA2kMostPlayedStatsByPlayerId', playerId: string, averageScore: number, mostPlayedTeams: Array<{ __typename?: 'NBA2kPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null> };

export type PlayerSeasonStatsFragment = { __typename?: 'PlayerSeasonStats', playerId: string, seasonId: string, rocketLeagueStats: { __typename?: 'RocketLeaguePlayerSeasonStats', averageShots: number, averageGoals: number, averageAssists: number, averageSaves: number } | null, splatoonStats: { __typename?: 'SplatoonMostPlayedStatsByPlayerId', playerId: string, mostPlayedStages: Array<{ __typename?: 'SplatoonPlayedWinRate', name: string, played: number, winRate: number } | null>, mostPlayedCharacters: Array<{ __typename?: 'SplatoonPlayedWinRate', name: string, played: number, winRate: number } | null> } | null, maddenStats: { __typename?: 'MaddenMostPlayedStatsByPlayerId', playerId: string, mostPlayedTeams: Array<{ __typename?: 'MaddenPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null>, mostPlayedOffensivePlaybooks: Array<{ __typename?: 'MaddenPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null>, mostPlayedDefensivePlaybooks: Array<{ __typename?: 'MaddenPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null> } | null, nba2kStats: { __typename?: 'NBA2kMostPlayedStatsByPlayerId', playerId: string, averageScore: number, mostPlayedTeams: Array<{ __typename?: 'NBA2kPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null> } | null };

export type GetPlayerSeasonStatsQueryVariables = Exact<{
  input: PlayerSeasonStatsInput;
}>;


export type GetPlayerSeasonStatsQuery = { __typename?: 'Query', getPlayerSeasonStats: { __typename?: 'PlayerSeasonStatsResult', results: Array<{ __typename?: 'PlayerSeasonStats', playerId: string, seasonId: string, rocketLeagueStats: { __typename?: 'RocketLeaguePlayerSeasonStats', averageShots: number, averageGoals: number, averageAssists: number, averageSaves: number } | null, splatoonStats: { __typename?: 'SplatoonMostPlayedStatsByPlayerId', playerId: string, mostPlayedStages: Array<{ __typename?: 'SplatoonPlayedWinRate', name: string, played: number, winRate: number } | null>, mostPlayedCharacters: Array<{ __typename?: 'SplatoonPlayedWinRate', name: string, played: number, winRate: number } | null> } | null, maddenStats: { __typename?: 'MaddenMostPlayedStatsByPlayerId', playerId: string, mostPlayedTeams: Array<{ __typename?: 'MaddenPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null>, mostPlayedOffensivePlaybooks: Array<{ __typename?: 'MaddenPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null>, mostPlayedDefensivePlaybooks: Array<{ __typename?: 'MaddenPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null> } | null, nba2kStats: { __typename?: 'NBA2kMostPlayedStatsByPlayerId', playerId: string, averageScore: number, mostPlayedTeams: Array<{ __typename?: 'NBA2kPlayedWinRate', name: string, played: number, winRate: number, assetUri: string | null } | null> } | null }> | null } | null };

export type CreateMatchSurveyResponseMutationVariables = Exact<{
  matchSurveyInput: MatchSurveyInput;
}>;


export type CreateMatchSurveyResponseMutation = { __typename?: 'Mutation', createMatchSurveyResponse: { __typename?: 'MatchSurvey', matchId: string, userId: string, matchSetupRating: number | null, opponentCompetitivenessRating: number | null, funRating: number | null, surveyComment: string | null, shouldContact: boolean | null } };

export type SaveSurveyResponseMutationVariables = Exact<{
  input: SaveSurveyInput;
}>;


export type SaveSurveyResponseMutation = { __typename?: 'Mutation', saveSurvey: { __typename?: 'SurveyPayload', id: string } };

export type DismissMatchSurveyMutationVariables = Exact<{
  matchSurveyInput: MatchSurveyInput;
}>;


export type DismissMatchSurveyMutation = { __typename?: 'Mutation', dismissMatchSurvey: { __typename?: 'MatchPayload', success: boolean } };

export type PostMatchSurveyDetailsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type PostMatchSurveyDetailsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, bestOf: number | null, seriesBestOf: number | null, scheduledStartsAt: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, games: Array<{ __typename?: 'Game', id: string, gameResults: Array<{ __typename?: 'GameResult', id: string, placing: number | null, teamId: string | null }> | null }> | null, series: Array<{ __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, result: { __typename?: 'SeriesResult', placing: number | null } | null }> } }> | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, teamId: string | null, gamesWon: number | null, gamesLost: number | null, seriesWon: number | null, seriesLost: number | null }> | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, name: string | null, schoolId: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null } | null }> } } | null };

export type MatchDetailsTeamFragment = { __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null };

export type GetMatchDetailsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchDetailsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, bestOf: number | null, status: MatchStatus, scheduledStartsAt: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, ordinalNumber: number | null, winningTeam: { __typename?: 'GameTeam', id: string, gameId: string } | null, match: { __typename?: 'Match', id: string, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType, name: string | null } | null } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } } | null, gameResults: Array<{ __typename?: 'GameResult', id: string, placing: number | null, teamId: string | null, team: { __typename?: 'Team', id: string, isMyTeam: boolean | null, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null } | null } | null }> | null }> | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null }> } } | null };

export type GetTeamSlotsWithQueueMatchesQueryVariables = Exact<{
  slotIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  teamIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GetTeamSlotsWithQueueMatchesQuery = { __typename?: 'Query', slots: Array<{ __typename?: 'Slot', id: string, teamIdsWithSmartQueueMatches: Array<string> | null }> | null };

export type GetMatchInformationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMatchInformationQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, bestOf: number | null, seriesBestOf: number | null, scheduledStartsAt: string | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, team: { __typename?: 'Team', id: string, name: string | null } | null }> | null, matchSettleRequests: Array<{ __typename?: 'MatchSettleRequestModel', id: string, status: MatchSettleRequestStatus | null, type: MatchSettleRequestType | null, createdAt: string | null, updatedAt: string | null, requestedBy: { __typename?: 'User', id: string, name: string | null } | null }> | null, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', id: string, matchId: string, teamId: string, status: MatchRescheduleRequestStatus | null, proposedTimes: Array<string> | null, rescheduleReason: MatchRescheduleRequestReason | null, rescheduleNotes: string | null, denyNotes: string | null, createdAt: string, updatedAt: string | null, requestedBy: { __typename?: 'User', id: string, name: string | null } | null, deniedBy: { __typename?: 'User', id: string, name: string | null } | null, approvedBy: { __typename?: 'User', id: string, name: string | null } | null }> | null, games: Array<{ __typename?: 'Game', id: string, ordinalNumber: number | null, entryCode: string | null }> | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, season: { __typename?: 'Season', id: string, league: { __typename?: 'League', id: string, state: string | null, name: string | null } | null } | null } | null } | null } | null };

export type GetRescheduleRequestsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetRescheduleRequestsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, scheduledStartsAt: string | null, slot: { __typename?: 'Slot', id: string, timezone: string | null } | null, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', id: string, matchId: string, teamId: string, status: MatchRescheduleRequestStatus | null, proposedTimes: Array<string> | null, rescheduleReason: MatchRescheduleRequestReason | null, rescheduleNotes: string | null, denyNotes: string | null, createdAt: string, updatedAt: string | null, updatedStartsAt: string | null, requestedBy: { __typename?: 'User', id: string, name: string | null } | null, deniedBy: { __typename?: 'User', id: string, name: string | null } | null, approvedBy: { __typename?: 'User', id: string, name: string | null } | null }> | null } | null };

export type GetMatchEventsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  fetchInput: FetchMatchSettleRequestInput;
}>;


export type GetMatchEventsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', id: string, status: MatchRescheduleRequestStatus | null, proposedTimes: Array<string> | null, rescheduleReason: MatchRescheduleRequestReason | null, rescheduleNotes: string | null, denyNotes: string | null, createdAt: string, updatedAt: string | null, updatedStartsAt: string | null, requestedBy: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null, deniedBy: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null, approvedBy: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null, matchStatusChangeEvents: Array<{ __typename?: 'MatchLedgerEvent', status: MatchStatus | null, occurAt: string | null, actedById: string | null, actedByName: string | null }> | null, matchForfeitedEvents: Array<{ __typename?: 'MatchLedgerEvent', occurAt: string | null, actedById: string | null, actedByName: string | null }> | null, matchDisputeRequests: Array<{ __typename?: 'MatchDisputeRequest', id: string, reason: MatchDisputeReason | null, notes: string | null, status: MatchDisputeStatus, createdAt: string | null, updatedAt: string | null, requestedBy: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null, asset: { __typename?: 'Asset', id: string, fileName: string, signedUrl: string | null, createdBy: { __typename?: 'User', name: string | null } } | null }> | null } | null, fetchMatchSettleRequest: { __typename?: 'MultipleMatchSettleRequestsPayload', success: boolean, errors: Array<string> | null, matchSettleRequest: Array<{ __typename?: 'MatchSettleRequestModel', id: string, createdAt: string | null, updatedAt: string | null, status: MatchSettleRequestStatus | null, incompleteReason: MatchSettleIncompleteReason | null, incompleteNotes: string | null, requestedById: string | null, forfeitReason: ForfeitReason | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', id: string | null, ordinalNumber: number | null, gameResults: Array<{ __typename?: 'GameResultRequest', ordinalNumber: number, losingTeamId: string, incompleteReason: GameIncompleteReason | null, winningTeam: { __typename?: 'Team', id: string, name: string | null } | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, signedUrl: string | null, createdBy: { __typename?: 'User', name: string | null } }> | null }> }> | null } | null, requestedBy: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null } };

export type CoachAndOwnerFragment = { __typename?: 'User', id: string, avatarUrl: string | null, lastSeen: string | null, phone: string | null, name: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean }> | null };

export type TeamCoachFragment = { __typename?: 'TeamCoach', id: string, avatarUrl: string | null, lastSeen: string | null, phone: string | null, name: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean }> | null };

export type TeamMemberFragment = { __typename?: 'TeamMember', id: string, teamId: string | null, effectiveAt: string | null, isCaptain: boolean | null, name: string | null, firstName: string | null, lastName: string | null, avatarUrl: string | null, lastSeen: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null, userEsportPlatforms: Array<{ __typename?: 'UserEsportPlatform', platform: Platform, esportId: string }> | null };

export type MatchTeamRosterFragment = { __typename?: 'TeamRoster', teamId: string, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', isCaptain: boolean, effectiveAt: string, user: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, avatarUrl: string | null, lastSeen: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } } | null, position: { __typename?: 'EsportPosition', id: string, index: number } }>, substitutes: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, effectiveAt: string, user: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, avatarUrl: string | null, lastSeen: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> }> };

export type GetMatchInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMatchInfoQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, scheduledStartsAt: string | null, format: MatchFormat | null, status: MatchStatus, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, season: { __typename?: 'Season', id: string, metaseasonId: string | null } | null } | null } | null, league: { __typename?: 'League', id: string } | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, schoolId: string | null, competitionGroup: CompetitionGroup | null, name: string | null }> }, esport: { __typename?: 'Esport', id: string }, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, gameResults: Array<{ __typename?: 'GameResult', teamId: string | null, placing: number | null }> | null }> | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, team: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', name: string | null, logoUrl: string | null } | null } | null }> | null } | null };

export type GetMatchTeamDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMatchTeamDetailsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, schoolId: string | null }> } } | null };

export type MinimalMetaseasonForMatchQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MinimalMetaseasonForMatchQuery = { __typename?: 'Query', metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null };

export type CheckValidPlayersOnPlatformQueryVariables = Exact<{
  userAccountAndPlatformInputs: Array<UserAccountAndPlatformInput> | UserAccountAndPlatformInput;
}>;


export type CheckValidPlayersOnPlatformQuery = { __typename?: 'Query', checkValidPlayersOnPlatform: { __typename?: 'CheckValidPlayerOnPlatformResponse', accounts: Array<{ __typename?: 'ValidPlayerOnPlatform', accountId: string, platform: Platform, valid: boolean }> | null } | null };

export type GetGamesForMatchQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetGamesForMatchQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, games: Array<{ __typename?: 'Game', id: string }> | null } | null };

export type GetGameInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetGameInfoQuery = { __typename?: 'Query', game: { __typename?: 'Game', id: string, ordinalNumber: number | null, status: GameStatus, entryCode: string | null, match: { __typename?: 'Match', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, matchResults: Array<{ __typename?: 'MatchResult', id: string, team: { __typename?: 'Team', id: string, school: { __typename?: 'School', id: string } | null } | null }> | null } | null, playerGameStats: Array<{ __typename?: 'PlayerGameStats', id: string, publisherAccountId: string, rosterStatus: PlayerGameStatsRosterStatus, isKnown: boolean, teamId: string, player: { __typename?: 'User', id: string, name: string | null } | null, team: { __typename?: 'Team', name: string | null } }> | null } | null };

export type GetMatchesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MatchFiltersInput>;
  isFortnite: Scalars['Boolean']['input'];
}>;


export type GetMatchesQuery = { __typename?: 'Query', getMatches: { __typename?: 'MatchesResult', totalCount: number | null, matches: Array<{ __typename?: 'Match', id: string, metaseasonId: string | null, isScrimmage: boolean | null, scheduledStartsAt: string | null, checkInOpensAt: string | null, checkInClosesAt: string | null, bestOf: number | null, status: MatchStatus, name: string | null, slotId: string | null, format: MatchFormat | null, league: { __typename?: 'League', id: string, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel } | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string }>, otherTeams: Array<{ __typename?: 'MatchTeam', id: string }> }, matchResults?: Array<{ __typename?: 'MatchResult', id: string, matchId: string, gamesWon: number | null, gamesLost: number | null, seriesWon: number | null, gamesTied: number | null, team: { __typename?: 'Team', id: string, name: string | null, isMyTeam: boolean | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null } | null }> | null, matchCheckIns: Array<{ __typename?: 'MatchCheckIn', id: string, matchId: string, teamId: string, status: string | null, user: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null } | null }>, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, playerGameStats: Array<{ __typename?: 'PlayerGameStats', id: string, player: { __typename?: 'User', id: string } | null }> | null, winningTeam: { __typename?: 'GameTeam', id: string, gameId: string } | null, losingTeam: { __typename?: 'GameTeam', id: string, gameId: string } | null }> | null, series: Array<{ __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, result: { __typename?: 'SeriesResult', placing: number | null } | null }> } }> | null, slot: { __typename?: 'Slot', id: string, startsAt: string | null, status: SlotStatus, phaseId: string | null, phase: { __typename?: 'Phase', id: string, name: string | null, type: PhaseType, seasonId: string, season: { __typename?: 'Season', id: string, metaseasonId: string | null, leagueId: string, league: { __typename?: 'League', id: string, timezone: string | null } | null } | null } | null } | null }> | null } };

export type GetLowLevelMatchesForDrawerListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MatchFiltersInput>;
}>;


export type GetLowLevelMatchesForDrawerListQuery = { __typename?: 'Query', getMatches: { __typename?: 'MatchesResult', matches: Array<{ __typename?: 'Match', id: string, scheduledStartsAt: string | null, slotId: string | null, status: MatchStatus, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null }> } }> | null } };

export type GetCheckpointMatchesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MatchFiltersInput>;
}>;


export type GetCheckpointMatchesQuery = { __typename?: 'Query', getMatches: { __typename?: 'MatchesResult', totalCount: number | null, matches: Array<{ __typename?: 'Match', id: string, isScrimmage: boolean | null, scheduledStartsAt: string | null, bestOf: number | null, status: MatchStatus, format: MatchFormat | null, canBeRescheduledByAdmin: boolean | null, slotId: string | null, esport: { __typename?: 'Esport', name: string | null, slug: Types.EsportSlug }, scrimmageRequest: { __typename?: 'ScrimmageRequest', id: string } | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, playerGameStats: Array<{ __typename?: 'PlayerGameStats', id: string, player: { __typename?: 'User', id: string } | null }> | null, winningTeam: { __typename?: 'GameTeam', id: string, gameId: string } | null, losingTeam: { __typename?: 'GameTeam', id: string, gameId: string } | null }> | null, league: { __typename?: 'League', id: string, timezone: string | null } | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, competitionGroup: CompetitionGroup | null, name: string | null, schoolId: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }> }, matchAssignment: { __typename?: 'MatchAssignment', id: string, notes: string | null, assignee: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null } | null }> | null } };

export type GetMatchFormatByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMatchFormatByIdQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, format: MatchFormat | null } | null };

export type MatchHeroInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MatchHeroInfoQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, isScrimmage: boolean | null, status: MatchStatus, forfeitReason: ForfeitReason | null, canBeRescheduledByAdmin: boolean | null, scheduledStartsAt: string | null, discordLink: string | null, checkInOpensAt: string | null, checkInClosesAt: string | null, archivedAt: string | null, bestOf: number | null, seriesBestOf: number | null, format: MatchFormat | null, scheduleContext: MatchScheduleContext | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, myTeams: Array<{ __typename?: 'MatchTeam', id: string, schoolId: string | null, name: string | null }>, teams: Array<{ __typename?: 'MatchTeam', id: string, schoolId: string | null, competitionGroup: CompetitionGroup | null, name: string | null }> }, scrimmageRequest: { __typename?: 'ScrimmageRequest', id: string, bestOf: number | null, startsAt: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string } | null } | null, opposingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string } | null } | null } | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, matchId: string, teamSide: number | null, team: { __typename?: 'Team', id: string, name: string | null, schoolId: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null, matchCheckIns: Array<{ __typename?: 'MatchCheckIn', id: string, matchId: string, teamId: string, userId: string, status: string | null }>, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, league: { __typename?: 'League', id: string, competitionGroup: CompetitionGroup, timezone: string | null } | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType } | null } | null } | null };

export type GetMatchesByDateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  sort?: InputMaybe<SeasonTeamMatchSort>;
}>;


export type GetMatchesByDateQuery = { __typename?: 'Query', season: { __typename?: 'Season', id: string, teamMatches: Array<{ __typename?: 'Match', id: string }> | null } | null };

export type TeamMatchesFragment = { __typename?: 'Match', id: string, status: MatchStatus, bestOf: number | null, scheduledStartsAt: string | null, isScrimmage: boolean | null, name: string | null, scheduleContext: MatchScheduleContext | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating }, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, name: string | null, format: PhaseFormat, type: PhaseType } | null } | null, league: { __typename?: 'League', id: string, timezone: string | null } | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, matchId: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, seriesWon: number | null, seriesLost: number | null, seriesTied: number | null, placing: number | null, team: { __typename?: 'Team', id: string, name: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null };

export type GetPastMatchesForTeamQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MatchFiltersInput>;
  sortFields?: InputMaybe<Array<MatchSortSpec> | MatchSortSpec>;
}>;


export type GetPastMatchesForTeamQuery = { __typename?: 'Query', getMatches: { __typename?: 'MatchesResult', totalCount: number | null, matches: Array<{ __typename?: 'Match', id: string, status: MatchStatus, bestOf: number | null, scheduledStartsAt: string | null, isScrimmage: boolean | null, name: string | null, scheduleContext: MatchScheduleContext | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating }, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, name: string | null, format: PhaseFormat, type: PhaseType } | null } | null, league: { __typename?: 'League', id: string, timezone: string | null } | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, matchId: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, seriesWon: number | null, seriesLost: number | null, seriesTied: number | null, placing: number | null, team: { __typename?: 'Team', id: string, name: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null }> | null } };

export type GetTeamMatchesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MatchFiltersInput>;
  sortFields?: InputMaybe<Array<MatchSortSpec> | MatchSortSpec>;
}>;


export type GetTeamMatchesQuery = { __typename?: 'Query', getMatches: { __typename?: 'MatchesResult', matches: Array<{ __typename?: 'Match', id: string, status: MatchStatus, bestOf: number | null, scheduledStartsAt: string | null, isScrimmage: boolean | null, name: string | null, scheduleContext: MatchScheduleContext | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating }, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, name: string | null, format: PhaseFormat, type: PhaseType } | null } | null, league: { __typename?: 'League', id: string, timezone: string | null } | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, matchId: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, seriesWon: number | null, seriesLost: number | null, seriesTied: number | null, placing: number | null, team: { __typename?: 'Team', id: string, name: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null }> | null } };

export type GetLeagueMatchesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MatchFiltersInput>;
  sortFields?: InputMaybe<Array<MatchSortSpec> | MatchSortSpec>;
}>;


export type GetLeagueMatchesQuery = { __typename?: 'Query', getMatches: { __typename?: 'MatchesResult', matches: Array<{ __typename?: 'Match', id: string, status: MatchStatus, scheduledStartsAt: string | null, isScrimmage: boolean | null, scheduleContext: MatchScheduleContext | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating, slug: Types.EsportSlug, details: { __typename?: 'EsportDetails', esportId: string, abbreviation: string | null, matchFormat: MatchFormat | null } | null }, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType } | null } | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, myTeams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }>, otherTeams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }>, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }>, myTeamMatchResults: Array<{ __typename?: 'MatchResult', id: string, placing: number | null }> }, matchResults: Array<{ __typename?: 'MatchResult', id: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, seriesWon: number | null, seriesLost: number | null, seriesTied: number | null, placing: number | null, team: { __typename?: 'Team', id: string, name: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null }> | null } };

export type GetPlayerMatchHistoryQueryVariables = Exact<{
  playerId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  statuses?: InputMaybe<Array<MatchStatus> | MatchStatus>;
}>;


export type GetPlayerMatchHistoryQuery = { __typename?: 'Query', findPlayerMetaseasonMatches: Array<{ __typename?: 'Match', id: string, status: MatchStatus, scheduledStartsAt: string | null, isScrimmage: boolean | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating, slug: Types.EsportSlug }, matchResults: Array<{ __typename?: 'MatchResult', id: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, seriesWon: number | null, seriesLost: number | null, seriesTied: number | null, placing: number | null, team: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null }> | null };

export type GetTeamMatchHistoryQueryVariables = Exact<{
  input: MatchesByTeamIdsInput;
}>;


export type GetTeamMatchHistoryQuery = { __typename?: 'Query', findMatchesByTeamIds: Array<{ __typename?: 'Match', id: string, status: MatchStatus, scheduledStartsAt: string | null, isScrimmage: boolean | null, slotId: string | null, scheduleContext: MatchScheduleContext | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType } | null } | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, matchId: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, seriesWon: number | null, seriesLost: number | null, seriesTied: number | null, placing: number | null, team: { __typename?: 'Team', id: string, name: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null }> | null };

export type GetScheduledAndQueueMatchesByTeamIdsQueryVariables = Exact<{
  input: ScheduledAndQueueMatchesByTeamIdsInput;
}>;


export type GetScheduledAndQueueMatchesByTeamIdsQuery = { __typename?: 'Query', getScheduledAndQueueMatchesByTeamIds: { __typename?: 'ScheduledAndQueueMatchesByTeamIdsResults', scheduledMatchesOffset: number, queueMatchesOffset: number, totalScheduledMatches: number, totalQueueMatches: number, scheduledMatches: Array<{ __typename: 'Match', id: string, metaseasonId: string | null, status: MatchStatus, scheduledStartsAt: string | null, isScrimmage: boolean | null, bestOf: number | null, scheduleContext: MatchScheduleContext | null, slotId: string | null, format: MatchFormat | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType, season: { __typename?: 'Season', id: string, metaseasonId: string | null } | null } | null } | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating, details: { __typename?: 'EsportDetails', esportId: string, abbreviation: string | null, matchFormat: MatchFormat | null } | null }, league: { __typename?: 'League', id: string, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel } | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, myTeams: Array<{ __typename?: 'MatchTeam', id: string, schoolId: string | null, name: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }>, otherTeams: Array<{ __typename?: 'MatchTeam', id: string, schoolId: string | null, name: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }>, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, avatarUrl: string | null, isMyTeam: boolean | null, competitionGroup: CompetitionGroup | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating }, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }>, myTeamMatchResults: Array<{ __typename?: 'MatchResult', id: string, placing: number | null }> }, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', id: string, status: MatchRescheduleRequestStatus | null, proposedTimes: Array<string> | null, teamId: string, matchId: string }> | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, seriesWon: number | null, seriesLost: number | null, seriesTied: number | null, placing: number | null, team: { __typename?: 'Team', id: string, name: string | null, isMyTeam: boolean | null, avatarUrl: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null }>, queueMatches: Array<{ __typename: 'SchedulePageQueueMatch', slotId: string, bestOf: number, scheduledStartsAt: string, scheduleContext: MatchScheduleContext, isScrimmage: boolean, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating } | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType, season: { __typename?: 'Season', id: string, metaseasonId: string | null, league: { __typename?: 'League', id: string, competitionGroup: CompetitionGroup } | null } | null } | null } | null, team: { __typename?: 'Team', id: string, name: string | null, isMyTeam: boolean | null, avatarUrl: string | null, competitionGroup: CompetitionGroup | null, schoolId: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> } };

export type GetTeamMatchesForScheduleQueryVariables = Exact<{
  input: MatchesByTeamIdsInput;
}>;


export type GetTeamMatchesForScheduleQuery = { __typename?: 'Query', findMatchesByTeamIds: Array<{ __typename?: 'Match', id: string, metaseasonId: string | null, status: MatchStatus, scheduledStartsAt: string | null, checkInClosesAt: string | null, checkInOpensAt: string | null, isScrimmage: boolean | null, scheduleContext: MatchScheduleContext | null, slotId: string | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType, season: { __typename?: 'Season', id: string, metaseasonId: string | null } | null } | null } | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating }, league: { __typename?: 'League', id: string, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel } | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, competitionGroup: CompetitionGroup | null, avatarUrl: string | null, isMyTeam: boolean | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }> }, matchResults: Array<{ __typename?: 'MatchResult', id: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, seriesWon: number | null, seriesLost: number | null, seriesTied: number | null, placing: number | null, team: { __typename?: 'Team', id: string, name: string | null, isMyTeam: boolean | null, avatarUrl: string | null, deletedAt: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null, matchCheckIns: Array<{ __typename?: 'MatchCheckIn', teamId: string, status: string | null }> }> | null };

export type CreateMatchChatMutationVariables = Exact<{
  input: CreateMatchChatInput;
}>;


export type CreateMatchChatMutation = { __typename?: 'Mutation', createMatchChat: { __typename?: 'CreateMatchChatPayload', success: boolean, errors: Array<string | null>, results: { __typename?: 'CreateMatchChatResults', matchId: string, matchChatId: string } } };

export type GetAwardMatchesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MatchFiltersInput>;
  sortFields?: InputMaybe<Array<MatchSortSpec> | MatchSortSpec>;
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetAwardMatchesQuery = { __typename?: 'Query', getMatches: { __typename?: 'MatchesResult', matches: Array<{ __typename?: 'Match', id: string, status: MatchStatus, scheduledStartsAt: string | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating, name: string | null, slug: Types.EsportSlug }, matchResults: Array<{ __typename?: 'MatchResult', id: string, gamesWon: number | null, gamesLost: number | null, placing: number | null, team: { __typename?: 'Team', id: string, name: string | null, isMyTeam: boolean | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, roster: { __typename?: 'TeamRoster', id: string, formats: Array<{ __typename?: 'TeamRosterFormat', starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } } | null }> }> } | null } | null }> | null }> | null } };

export type GetHighlightMatchesQueryVariables = Exact<{
  playerId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  statuses?: InputMaybe<Array<MatchStatus> | MatchStatus>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHighlightMatchesQuery = { __typename?: 'Query', findPlayerMetaseasonMatches: Array<{ __typename?: 'Match', id: string, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null }> } }> | null };

export type GetLastPlayedMetaseasonIdByPlayerIdQueryVariables = Exact<{
  playerId: Scalars['UUID']['input'];
}>;


export type GetLastPlayedMetaseasonIdByPlayerIdQuery = { __typename?: 'Query', getLastPlayedMetaseasonIdByPlayerId: string | null };

export type LeaderboardMatchGameResultsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeaderboardMatchGameResultsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, bestOf: number | null, status: MatchStatus, teamContext: { __typename?: 'MatchTeamContext', matchId: string, numberOfTeamsInMatch: number, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, name: string | null } | null }> }, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, gameResults: Array<{ __typename?: 'GameResult', id: string, placing: number | null, teamId: string | null }> | null }> | null } | null };

export type GetMatchForOverlayQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchForOverlayQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, team1Score: number | null, team2Score: number | null, esport: { __typename?: 'Esport', id: string, slug: string }, slot: { __typename?: 'Slot', id: string, name: string | null, phase: { __typename?: 'Phase', id: string, season: { __typename?: 'Season', id: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null, league: { __typename?: 'League', id: string, name: string | null } | null } | null } | null } | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, avatarUrl: string | null, competitionGroup: CompetitionGroup | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }> } } | null };

export type MyConnectionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MyConnectionStatusQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerDisplayName: string | null, providerAccountId: string | null, providerIntegrationType: IntegrationType | null }> | null } | null };

export type GetMetaseasonsQueryVariables = Exact<{
  options?: InputMaybe<MetaseasonsOptions>;
}>;


export type GetMetaseasonsQuery = { __typename?: 'Query', metaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, slug: string | null, isPromoted: boolean, status: SeasonStatus | null, startsAt: string | null, endsAt: string | null, isInitialMetaseason: boolean, competitionGroup: CompetitionGroup, promotionStartsAt: string | null, promotionEndsAt: string | null, previousMetaseasonId: string | null, isPromotionWindowOverlap: boolean | null, leaguesWithSeasonCount: number | null, inactiveLeaguesCount: number | null }> };

export type GetNonAdminMetaseasonsQueryVariables = Exact<{
  options?: InputMaybe<MetaseasonsOptions>;
}>;


export type GetNonAdminMetaseasonsQuery = { __typename?: 'Query', metaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, slug: string | null, isPromoted: boolean, status: SeasonStatus | null, startsAt: string | null, endsAt: string | null, isInitialMetaseason: boolean, competitionGroup: CompetitionGroup, promotionStartsAt: string | null, promotionEndsAt: string | null, previousMetaseasonId: string | null, isPromotionWindowOverlap: boolean | null }> };

export type CreateMetaseasonMutationVariables = Exact<{
  config: CreateMetaseasonConfig;
}>;


export type CreateMetaseasonMutation = { __typename?: 'Mutation', createMetaseason: { __typename?: 'Metaseason', id: string, name: string | null, isPromoted: boolean, startsAt: string | null, endsAt: string | null, status: SeasonStatus | null } };

export type UpdateMetaseasonMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateMetaseasonInput;
}>;


export type UpdateMetaseasonMutation = { __typename?: 'Mutation', updateMetaseason: { __typename?: 'Metaseason', id: string, name: string | null, isPromoted: boolean, startsAt: string | null, endsAt: string | null, status: SeasonStatus | null } };

export type GetMetaseasonByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMetaseasonByIdQuery = { __typename?: 'Query', metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean, competitionGroup: CompetitionGroup } | null };

export type GetNonLoggedInMetaseasonsQueryVariables = Exact<{
  options?: InputMaybe<MetaseasonsOptions>;
}>;


export type GetNonLoggedInMetaseasonsQuery = { __typename?: 'Query', metaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean }> };

export type GetLeagueMetaseasonsByLeagueIdQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
}>;


export type GetLeagueMetaseasonsByLeagueIdQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, seasons: Array<{ __typename?: 'Season', id: string, status: SeasonStatus, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean, status: SeasonStatus | null } | null }> | null } | null };

export type GetSchoolRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSchoolRolesQuery = { __typename?: 'Query', getSchoolRoles: { __typename?: 'UserSchoolRolesPayload', roles: Array<{ __typename?: 'UserSchoolRole', schoolId: string, school: { __typename?: 'School', id: string, name: string | null, competitionGroup: CompetitionGroup | null } }> } };

export type GetSchoolRolesByUserQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetSchoolRolesByUserQuery = { __typename?: 'Query', getSchoolRolesByUser: { __typename?: 'UserSchoolRolesPayload', roles: Array<{ __typename?: 'UserSchoolRole', schoolId: string, school: { __typename?: 'School', id: string, deletedAt: string | null, name: string | null, logoUrl: string | null, coaches: Array<{ __typename?: 'User', id: string, name: string | null }> | null }, role: { __typename?: 'Role', roleName: UserRoleName, resourceId: string, resourceType: ResourceType, userId: string, status: UserRoleStatusName, deletedAt: string | null } }> } };

export type ChangeSchoolIdForUserMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type ChangeSchoolIdForUserMutation = { __typename?: 'Mutation', changeSchoolIdForUser: { __typename?: 'UserPayload', success: boolean, userId: string } };

export type AddAdditionalCoachRoleToUserMutationVariables = Exact<{
  input: UserRoleUpdateInput;
}>;


export type AddAdditionalCoachRoleToUserMutation = { __typename?: 'Mutation', addAdditionalCoachRoleToUser: { __typename?: 'UserPayload', success: boolean, userId: string } };

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'Note', id: string, textContent: string, createdAt: string, author: { __typename?: 'User', id: string, name: string | null } } };

export type DeleteNoteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote: { __typename?: 'DeleteNotePayload', success: boolean, deletedNoteId: string } };

export type FindNotesQueryVariables = Exact<{
  options?: InputMaybe<NoteOptions>;
}>;


export type FindNotesQuery = { __typename?: 'Query', findNotes: { __typename?: 'FindNotesResult', count: number | null, notes: Array<{ __typename?: 'Note', id: string, textContent: string, createdAt: string, author: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } }> | null } };

export type GetNoteAuthorsQueryVariables = Exact<{
  input?: InputMaybe<GetNoteAuthorsInput>;
}>;


export type GetNoteAuthorsQuery = { __typename?: 'Query', getNoteAuthors: Array<{ __typename?: 'User', id: string, name: string | null }> | null };

export type GetLegacyNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLegacyNotificationsQuery = { __typename?: 'Query', getAllPendingLegacyNotifications: Array<{ __typename?: 'LegacyUserNotification', id: string, status: UserNotificationStatus, total: number | null, rescheduleMatchId: string | null, surveyMatchId: string | null, notification: { __typename?: 'LegacyNotification', id: string, name: string, description: string | null, title: string | null, type: string | null, buttonText: string | null, href: string | null, imageUrl: string | null } }> | null };

export type AcknowledgeNotificationMutationVariables = Exact<{
  notificationId: Scalars['UUID']['input'];
}>;


export type AcknowledgeNotificationMutation = { __typename?: 'Mutation', ackPendingNotification: { __typename?: 'UserNotificationsPayload', success: boolean } };

export type GetNotificationCenterSummaryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skipTasks?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetNotificationCenterSummaryQuery = { __typename?: 'Query', getIncompleteNotificationTaskCount?: number, userNotifications: { __typename?: 'UserNotifications', id: string, unreadCount: number } };

export type GetUserNotificationSummarySubscriptionVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetUserNotificationSummarySubscription = { __typename?: 'Subscription', userNotificationSummary: { __typename?: 'NotificationSummaryPayload', unreadNotificationCount: number, notificationTasksCount: number } };

export type GetNotificationCenterQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNotificationCenterQuery = { __typename?: 'Query', userNotifications: { __typename?: 'UserNotifications', id: string, notifications: { __typename?: 'UserNotificationsNotificationsPaginatedResults', edges: Array<{ __typename?: 'UserNotificationsNotificationsPaginatedResultsEdge', cursor: string, node: { __typename?: 'UserNotification', id: string, type: string, createdAt: string, openedAt: string | null, contentData: { __typename?: 'UserNotificationContentData', messageDates: Array<string> | null, message: string, image1: string | null, image2: string | null, url: string | null, invoke: string | null, glyph: string | null, team1Id: string | null, team2Id: string | null, rating: EsportRating | null } } }>, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNext: boolean } } | null } };

export type GetIncompleteNotificationTasksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetIncompleteNotificationTasksQuery = { __typename?: 'Query', getIncompleteNotificationTasks: { __typename?: 'UserNotificationsNotificationsPaginatedResults', edges: Array<{ __typename?: 'UserNotificationsNotificationsPaginatedResultsEdge', cursor: string, node: { __typename?: 'UserNotification', id: string, type: string, createdAt: string, openedAt: string | null, contentData: { __typename?: 'UserNotificationContentData', messageDates: Array<string> | null, message: string, image1: string | null, image2: string | null, url: string | null, invoke: string | null, glyph: string | null, team1Id: string | null, team2Id: string | null, rating: EsportRating | null } } }>, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNext: boolean } } };

export type GetUserNotificationSettingsQueryVariables = Exact<{
  input: GetUserNotificationsSettingsInput;
}>;


export type GetUserNotificationSettingsQuery = { __typename?: 'Query', getUserNotificationsSettings: { __typename?: 'getUserNotificationsSettingsPayload', success: boolean, userNotificationSettings: Array<{ __typename?: 'UserNotificationSetting', category: NotificationCategory, enabled: boolean, scope: NotificationScope | null, isPersonalEmail: boolean | null, userEmail: { __typename?: 'UserEmail', email: string } | null } | null> | null } };

export type MarkAllUserNotificationsReadMutationVariables = Exact<{
  notificationId: Scalars['ObjectID']['input'];
}>;


export type MarkAllUserNotificationsReadMutation = { __typename?: 'Mutation', markAllUserNotificationsRead: { __typename?: 'MarkAllUserNotificationsReadResult', success: boolean } };

export type MarkUserNotificationOpenedMutationVariables = Exact<{
  notificationId: Scalars['ObjectID']['input'];
}>;


export type MarkUserNotificationOpenedMutation = { __typename?: 'Mutation', markUserNotificationOpened: { __typename?: 'MarkUserNotificationOpenedResult', userNotification: { __typename?: 'UserNotification', id: string, openedAt: string | null } | null } };

export type MarkUserNotificationTaskOpenedMutationVariables = Exact<{
  notificationId: Scalars['ObjectID']['input'];
}>;


export type MarkUserNotificationTaskOpenedMutation = { __typename?: 'Mutation', markUserNotificationTaskOpened: { __typename?: 'MarkUserNotificationTaskOpenedResult', userNotification: { __typename?: 'UserNotification', id: string, openedAt: string | null } | null } };

export type MarkUserNotificationTaskCompletedMutationVariables = Exact<{
  userNotificationId: Scalars['ObjectID']['input'];
}>;


export type MarkUserNotificationTaskCompletedMutation = { __typename?: 'Mutation', markUserNotificationTaskCompleted: { __typename?: 'MarkUserNotificationCompletedResult', success: boolean, userNotificationId: string } };

export type SetUserNotificationScopeMutationVariables = Exact<{
  input: SetUserNotificationScopeInput;
}>;


export type SetUserNotificationScopeMutation = { __typename?: 'Mutation', setUserNotificationScope: { __typename?: 'SetUserNotificationScopePayload', success: boolean } };

export type SetUserNotificationEnabledMutationVariables = Exact<{
  input: SetUserNotificationEnabledInput;
}>;


export type SetUserNotificationEnabledMutation = { __typename?: 'Mutation', setUserNotificationEnabled: { __typename?: 'SetUserNotificationEnabledPayload', success: boolean } };

export type SetUserNotificationIsPersonalMutationVariables = Exact<{
  input: SetUserNotificationIsPersonalInput;
}>;


export type SetUserNotificationIsPersonalMutation = { __typename?: 'Mutation', setUserNotificationIsPersonal: { __typename?: 'SetUserNotificationIsPersonalPayload', success: boolean } };

export type MarkAllUserNotificationsOpenedMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllUserNotificationsOpenedMutation = { __typename?: 'Mutation', markAllUserNotificationsOpened: { __typename?: 'MarkAllUserNotificationsOpenedResult', success: boolean } };

export type GetReferringUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferringUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, userId: string, resourceId: string }> | null } | null };

export type OnboardingSchoolSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type OnboardingSchoolSearchQuery = { __typename?: 'Query', searchSchools: { __typename?: 'SearchSchoolsResults', results: Array<{ __typename?: 'SchoolSearchResult', schoolId: string, name: string | null, searchScore: number, type: string | null, address: string | null, city: string | null, state: string | null, zip: string | null, logoUrl: string | null }> | null } };

export type MyOnboardReferralQueryVariables = Exact<{ [key: string]: never; }>;


export type MyOnboardReferralQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null } | null, referralLinks: { __typename?: 'UserReferralLinks', fac: string, student: string } | null } | null };

export type GetMissingFieldsAtAppLaunchQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMissingFieldsAtAppLaunchQuery = { __typename?: 'Query', userAttributes: { __typename?: 'UserAttributes', missingFieldsAtAppLaunch: Array<UserRequiredFieldsAtAppLaunch> | null } | null, me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string } | null } | null };

export type ReferByEmailMutationVariables = Exact<{
  input: ReferByEmailInput;
}>;


export type ReferByEmailMutation = { __typename?: 'Mutation', referByEmail: { __typename?: 'ReferralPayload', success: boolean } | null };

export type SetMyFacultyInformationMutationVariables = Exact<{
  input: SetMyFacultyInformationInput;
}>;


export type SetMyFacultyInformationMutation = { __typename?: 'Mutation', setMyFacultyInformation: { __typename?: 'UserPayload', success: boolean } };

export type SetMySchoolSubmissionMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  input: SetMySchoolSubmissionInput;
}>;


export type SetMySchoolSubmissionMutation = { __typename?: 'Mutation', setMySchoolSubmission: { __typename?: 'SchoolPayload', success: boolean } };

export type SetSchoolBillingContactMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  input: SchoolBillingContactInput;
}>;


export type SetSchoolBillingContactMutation = { __typename?: 'Mutation', setSchoolBillingContact: { __typename?: 'School', id: string, billingContact: { __typename?: 'SchoolBillingContact', schoolId: string, firstName: string, lastName: string, phone: string | null, phoneExt: string | null, email: string, address: string | null, city: string | null, state: string | null, zip: string | null } | null } };

export type GetScheduleConsultLinkQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetScheduleConsultLinkQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, salesRep: { __typename?: 'SalesRep', id: string, calendarLink: string | null } | null } | null, findTeamEnrollmentsByUser: { __typename?: 'TeamEnrollmentsPayload', teamEnrollments: Array<{ __typename?: 'TeamEnrollment', enrollableSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null }>, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, teamRegistrationEndsAt: string | null }> }> } };

export type ApplyForSchoolFacultyMutationVariables = Exact<{
  role: UserRoleName;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  schoolEmail: Scalars['String']['input'];
  schoolId: Scalars['UUID']['input'];
  suggestedSchool?: InputMaybe<SuggestedSchoolInput>;
  facultyInput?: InputMaybe<ApplyForSchoolFacultyInput>;
}>;


export type ApplyForSchoolFacultyMutation = { __typename?: 'Mutation', applyForSchool: { __typename?: 'ApplyForSchoolResult', user: { __typename?: 'User', school: { __typename?: 'School', id: string } | null } | null } | null };

export type ApplyForSchoolStudentMutationVariables = Exact<{
  role: UserRoleName;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  schoolEmail: Scalars['String']['input'];
  schoolId: Scalars['UUID']['input'];
  suggestedSchool?: InputMaybe<SuggestedSchoolInput>;
  studentInput?: InputMaybe<ApplyForSchoolStudentInput>;
}>;


export type ApplyForSchoolStudentMutation = { __typename?: 'Mutation', applyForSchool: { __typename?: 'ApplyForSchoolResult', user: { __typename?: 'User', school: { __typename?: 'School', id: string } | null } | null } | null };

export type ReferParentByEmailMutationVariables = Exact<{
  input: ReferParentByEmailInput;
}>;


export type ReferParentByEmailMutation = { __typename?: 'Mutation', referParentByEmail: { __typename?: 'ReferralPayload', success: boolean } | null };

export type RoleRouteQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleRouteQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, userId: string, resourceId: string }> | null } | null };

export type CreateUserConsentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateUserConsentMutation = { __typename?: 'Mutation', createUserConsent: { __typename?: 'UserConsent', id: string } };

export type AddChildToSchoolMutationVariables = Exact<{
  input: AddChildToSchoolInput;
}>;


export type AddChildToSchoolMutation = { __typename?: 'Mutation', addChildToSchool: { __typename?: 'AddUserToSchoolResult', success: boolean, userId: string, schoolId: string } };

export type ChangeChildPasswordMutationVariables = Exact<{
  input: ChangeChildPasswordInput;
}>;


export type ChangeChildPasswordMutation = { __typename?: 'Mutation', changeChildPassword: { __typename?: 'UserPayload', success: boolean } };

export type GetUserChildrenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserChildrenQuery = { __typename?: 'Query', getUserChildren: { __typename?: 'UserChildrenPayload', users: Array<{ __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, firstName: string | null, lastName: string | null, gradYear: number | null, school: { __typename?: 'School', id: string, name: string | null } | null }> } };

export type GetChildUserQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetChildUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, name: string | null, firstName: string | null, lastName: string | null, avatarUrl: string | null, gradYear: number | null, dateOfBirth: string | null, username: string | null, country: string | null, state: string | null, emails: Array<{ __typename?: 'UserEmail', email: string }> | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, city: string | null, state: string | null } | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null }> | null } | null };

export type GetUserChildOnboardQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetUserChildOnboardQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, name: string | null, firstName: string | null, lastName: string | null, gradYear: number | null, dateOfBirth: string | null, username: string | null, country: string | null, state: string | null, emails: Array<{ __typename?: 'UserEmail', email: string }> | null, school: { __typename?: 'School', id: string, name: string | null, state: string | null } | null, esportInterests: Array<{ __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }> | null } | null };

export type GetChildPlatformConnectionsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetChildPlatformConnectionsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerOnboardUrl: string | null, providerIntegrationType: IntegrationType | null, createdAt: string | null, updatedAt: string | null }> | null } | null };

export type SetUserAvatarImageMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  file: Scalars['Upload']['input'];
}>;


export type SetUserAvatarImageMutation = { __typename?: 'Mutation', setUserAvatarImage: Array<{ __typename?: 'ResourceImage', url: string, resourceId: string, resourceType: ResourceType, size: number | null }> };

export type SetChildAccountSettingsMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  input: ChildAccountSettingsInput;
}>;


export type SetChildAccountSettingsMutation = { __typename?: 'Mutation', setChildAccountSettings: { __typename?: 'UserPayload', success: boolean, user: { __typename?: 'User', id: string } | null } };

export type GetChildAvatarUrlQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetChildAvatarUrlQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, avatarUrl: string | null } | null };

export type GetUserChildrenByParentIdQueryVariables = Exact<{
  parentUserId: Scalars['UUID']['input'];
}>;


export type GetUserChildrenByParentIdQuery = { __typename?: 'Query', getUserChildrenByParentId: { __typename?: 'UserChildrenPayload', users: Array<{ __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, isUnderage: boolean }> } };

export type UnlinkParentFromChildMutationVariables = Exact<{
  parentId: Scalars['UUID']['input'];
  childUserId: Scalars['UUID']['input'];
}>;


export type UnlinkParentFromChildMutation = { __typename?: 'Mutation', unlinkParentFromChild: { __typename?: 'UpdateParentPayload', success: boolean } };

export type PartnersQueryVariables = Exact<{
  input: PartnerSearchInput;
}>;


export type PartnersQuery = { __typename?: 'Query', partners: { __typename?: 'PartnerResult', total: number | null, result: Array<{ __typename?: 'Partner', id: string, name: string }> | null } };

export type PartnerQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PartnerQuery = { __typename?: 'Query', partner: { __typename?: 'Partner', id: string, name: string } };

export type CreatePartnerMutationVariables = Exact<{
  input: PartnerInput;
}>;


export type CreatePartnerMutation = { __typename?: 'Mutation', createPartner: { __typename?: 'Partner', id: string, name: string } };

export type UpdatePartnerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: PartnerInput;
}>;


export type UpdatePartnerMutation = { __typename?: 'Mutation', updatePartner: { __typename?: 'Partner', id: string, name: string } };

export type DeletePartnerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeletePartnerMutation = { __typename?: 'Mutation', deletePartner: { __typename?: 'DeletePartnerPayload', success: boolean } };

export type GetMetaseasonNameForPhaseQueryVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
}>;


export type GetMetaseasonNameForPhaseQuery = { __typename?: 'Query', phase: { __typename?: 'Phase', id: string, season: { __typename?: 'Season', id: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null } | null } | null };

export type GetPhasesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<GetPhasesFilter>;
}>;


export type GetPhasesQuery = { __typename?: 'Query', getPhases: { __typename?: 'GetPhasesResult', result: Array<{ __typename?: 'Phase', id: string, slots: Array<{ __typename?: 'Slot', id: string, ordinal: number | null, order: number | null, label: SlotLabel | null, name: string | null }> | null }> | null } };

export type GetPhaseQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetPhaseQuery = { __typename?: 'Query', phase: { __typename?: 'Phase', id: string, name: string | null, format: PhaseFormat, type: PhaseType, bestOf: number | null, seriesBestOf: number | null, status: PhaseStatus, startsAt: string, endsAt: string, slug: string | null, bracketSize: number | null, maxTeamsPerSchool: number | null, fortniteEventId: string | null, minutesBeforeMatchToLockInSeries: number | null, survivalAdvancementCount: number | null, survivalAdvancementPercentage: number | null, shouldSendPlayoffNotification: boolean | null, autoScheduleBracket: boolean | null } | null };

export type GetSchoolLeaguePhasesQueryVariables = Exact<{
  filter?: InputMaybe<GetPhasesFilter>;
}>;


export type GetSchoolLeaguePhasesQuery = { __typename?: 'Query', getPhases: { __typename?: 'GetPhasesResult', result: Array<{ __typename?: 'Phase', id: string, startsAt: string, endsAt: string, name: string | null, type: PhaseType, seasonId: string, slug: string | null, status: PhaseStatus, format: PhaseFormat, survivalAdvancementCount: number | null, survivalAdvancementPercentage: number | null }> | null } };

export type GetQualifiedTeamCountQueryVariables = Exact<{
  input: GetQualifiedTeamCountInput;
}>;


export type GetQualifiedTeamCountQuery = { __typename?: 'Query', getQualifiedTeamCount: number };

export type CreatePhaseMutationVariables = Exact<{
  input: CreatePhaseInput;
}>;


export type CreatePhaseMutation = { __typename?: 'Mutation', createPhase: { __typename?: 'CreatePhasePayload', phase: { __typename?: 'Phase', id: string } } };

export type UpdatePhaseMutationVariables = Exact<{
  input: UpdatePhaseInput;
}>;


export type UpdatePhaseMutation = { __typename?: 'Mutation', updatePhase: { __typename?: 'UpdatePhasePayload', phase: { __typename?: 'Phase', id: string } } };

export type ManualSeedMutationVariables = Exact<{
  input: ManuallySeedPlayoffPhasesInput;
}>;


export type ManualSeedMutation = { __typename?: 'Mutation', manuallySeedPlayoffPhases: { __typename?: 'LeaguesPayload', success: boolean, leagueIds: Array<string> } };

export type AutoSeedMutationVariables = Exact<{
  input: SeedPhaseTeamsInput;
}>;


export type AutoSeedMutation = { __typename?: 'Mutation', seedPhaseTeams: { __typename?: 'PhaseJobPayload', jobId: string, success: boolean, errors: Array<string> | null } };

export type SchedulePhaseMatchesMutationVariables = Exact<{
  input: SchedulePhaseMatchesInput;
}>;


export type SchedulePhaseMatchesMutation = { __typename?: 'Mutation', schedulePhaseMatches: { __typename?: 'PhaseJobPayload', jobId: string } };

export type RedoSchedulePhaseMatchesMutationVariables = Exact<{
  input: SchedulePhaseMatchesInput;
}>;


export type RedoSchedulePhaseMatchesMutation = { __typename?: 'Mutation', redoSchedulePhaseMatches: { __typename?: 'PhasePayload', success: boolean, phase: { __typename?: 'Phase', id: string } | null } };

export type RollupAllPhaseResultsMutationVariables = Exact<{
  input: RollupAllPhaseResultsInput;
}>;


export type RollupAllPhaseResultsMutation = { __typename?: 'Mutation', rollupAllPhaseResults: { __typename?: 'PhaseJobsPayload', jobIds: Array<string> } };

export type GetUserEsportPlatformsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetUserEsportPlatformsQuery = { __typename?: 'Query', userEsportPlatforms: Array<{ __typename?: 'UserEsportPlatform', userId: string, platform: Platform, platformUsername: string | null, esportId: string }> | null };

export type SetUserEsportPlatformMutationVariables = Exact<{
  input: SetUserEsportPlatformInput;
}>;


export type SetUserEsportPlatformMutation = { __typename?: 'Mutation', setUserEsportPlatform: { __typename?: 'UserEsportPlatform', userId: string, platform: Platform, platformUsername: string | null, esportId: string } };

export type RemoveUserEsportPlatformMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  esportId: Scalars['UUID']['input'];
}>;


export type RemoveUserEsportPlatformMutation = { __typename?: 'Mutation', removeUserEsportPlatform: { __typename?: 'RemoveUserEsportPayload', success: boolean } | null };

export type GetPlayerLinkedAccountPlatformsQueryVariables = Exact<{
  epicAccountId: Scalars['String']['input'];
}>;


export type GetPlayerLinkedAccountPlatformsQuery = { __typename?: 'Query', getPlayerLinkedAccountPlatforms: { __typename?: 'GetPlayerLinkedAccountPlatformsResponse', playerLinkedAccounts: Array<{ __typename?: 'PlayerLinkedAccount', platform: Platform, username: string }> } | null };

export type AddPlatformsToEsportMutationVariables = Exact<{
  esportId: Scalars['UUID']['input'];
  platforms?: InputMaybe<Array<Platform> | Platform>;
}>;


export type AddPlatformsToEsportMutation = { __typename?: 'Mutation', addPlatformsToEsport: { __typename?: 'PlatformPayload', success: boolean } };

export type RemovePlatformsFromEsportMutationVariables = Exact<{
  esportId: Scalars['UUID']['input'];
  platforms?: InputMaybe<Array<Platform> | Platform>;
}>;


export type RemovePlatformsFromEsportMutation = { __typename?: 'Mutation', removePlatformsFromEsport: { __typename?: 'PlatformPayload', success: boolean } };

export type FetchPlayerStandingQueryVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
  playerId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type FetchPlayerStandingQuery = { __typename?: 'Query', fetchPlayerStanding: Array<{ __typename?: 'PlayerLolStandings', user: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null, kda: { __typename?: 'LeaderboardMetric', value: number | null, rank: { __typename?: 'LeaderboardRankGroup', league: number | null, state: number | null, overall: number | null } | null } | null, gold: { __typename?: 'LeaderboardMetric', value: number | null, rank: { __typename?: 'LeaderboardRankGroup', league: number | null, state: number | null, overall: number | null } | null } | null } | { __typename?: 'PlayerRLStandings', user: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null, scorePerGame: { __typename?: 'LeaderboardMetric', value: number | null, rank: { __typename?: 'LeaderboardRankGroup', league: number | null, state: number | null, overall: number | null } | null } | null, goalsPerShot: { __typename?: 'LeaderboardMetric', value: number | null, rank: { __typename?: 'LeaderboardRankGroup', league: number | null, state: number | null, overall: number | null } | null } | null } | { __typename?: 'PlayerSmiteStandings', user: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null, kda: { __typename?: 'LeaderboardMetric', value: number | null, rank: { __typename?: 'LeaderboardRankGroup', league: number | null, state: number | null, overall: number | null } | null } | null, gold: { __typename?: 'LeaderboardMetric', value: number | null, rank: { __typename?: 'LeaderboardRankGroup', league: number | null, state: number | null, overall: number | null } | null } | null } | { __typename?: 'TeamFortniteStandings', user: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null, team: { __typename?: 'Team', id: string, name: string | null } | null, eliminationsPerGame: { __typename?: 'LeaderboardMetric', value: number | null, rank: { __typename?: 'LeaderboardRankGroup', league: number | null, state: number | null, overall: number | null } | null } | null, rankPerGame: { __typename?: 'LeaderboardMetric', value: number | null, rank: { __typename?: 'LeaderboardRankGroup', league: number | null, state: number | null, overall: number | null } | null } | null }> | null };

export type GetSchoolPlayersQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolPlayersQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string | null, players: Array<{ __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null }> | null } | null };

export type DenyVerifiedPlayerMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  resourceId: Scalars['UUID']['input'];
}>;


export type DenyVerifiedPlayerMutation = { __typename?: 'Mutation', denyVerifiedPlayer: { __typename?: 'UserPayload', success: boolean } };

export type VerifyDeniedPlayerMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  resourceId: Scalars['UUID']['input'];
}>;


export type VerifyDeniedPlayerMutation = { __typename?: 'Mutation', verifyDeniedPlayer: { __typename?: 'UserPayload', success: boolean } };

export type PlayoffBracketForLeagueQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
}>;


export type PlayoffBracketForLeagueQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, name: string | null, state: string | null, esport: { __typename?: 'Esport', id: string, name: string | null }, seasons: Array<{ __typename?: 'Season', id: string, name: string, phases: Array<{ __typename?: 'Phase', id: string, name: string | null, format: PhaseFormat }> | null }> | null } | null };

export type GetPracticeDaySchedulesQueryVariables = Exact<{
  input: GetPracticeDaySchedulesInput;
}>;


export type GetPracticeDaySchedulesQuery = { __typename?: 'Query', getPracticeDaySchedules: { __typename?: 'GetPracticeDaySchedulesPayload', success: boolean, errors: Array<string> | null, payload: { __typename?: 'PracticeDaySchedule', id: string, isLive: boolean } } };

export type GetTeamsForPracticeDayQueryVariables = Exact<{
  teamIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GetTeamsForPracticeDayQuery = { __typename?: 'Query', teamsByIds: Array<{ __typename?: 'Team', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating }, roster: { __typename?: 'TeamRoster', id: string, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } } | null }> }> } | null }> | null };

export type RequestMatchRescheduleMutationVariables = Exact<{
  input: RequestMatchRescheduleInput;
}>;


export type RequestMatchRescheduleMutation = { __typename?: 'Mutation', requestMatchReschedule: { __typename?: 'MatchRescheduleRequest', id: string, matchId: string, teamId: string, requestedById: string | null, deniedById: string | null, approvedById: string | null, canceledById: string | null, status: MatchRescheduleRequestStatus | null, rescheduleReason: MatchRescheduleRequestReason | null, rescheduleNotes: string | null, denyNotes: string | null, proposedTimes: Array<string> | null, createdAt: string, updatedAt: string | null } };

export type RequestMatchRescheduleWithinSchoolMutationVariables = Exact<{
  input: RequestMatchRescheduleWithinSchoolInput;
}>;


export type RequestMatchRescheduleWithinSchoolMutation = { __typename?: 'Mutation', requestMatchRescheduleWithinSchool: { __typename?: 'MatchRescheduleRequest', id: string, matchId: string, teamId: string, requestedById: string | null, deniedById: string | null, approvedById: string | null, canceledById: string | null, status: MatchRescheduleRequestStatus | null, rescheduleReason: MatchRescheduleRequestReason | null, rescheduleNotes: string | null, denyNotes: string | null, proposedTimes: Array<string> | null, createdAt: string, updatedAt: string | null } };

export type CancelMatchRescheduleMutationVariables = Exact<{
  input: CancelMatchRescheduleInput;
}>;


export type CancelMatchRescheduleMutation = { __typename?: 'Mutation', cancelMatchRescheduleRequest: { __typename?: 'MatchRescheduleRequest', id: string, matchId: string, teamId: string, requestedById: string | null, deniedById: string | null, approvedById: string | null, canceledById: string | null, status: MatchRescheduleRequestStatus | null, rescheduleReason: MatchRescheduleRequestReason | null, rescheduleNotes: string | null, denyNotes: string | null, proposedTimes: Array<string> | null, createdAt: string, updatedAt: string | null } };

export type RespondToMatchRescheduleRequestMutationVariables = Exact<{
  input: ResponseMatchRescheduleInput;
}>;


export type RespondToMatchRescheduleRequestMutation = { __typename?: 'Mutation', respondToMatchRescheduleRequest: { __typename?: 'MatchRescheduleRequest', id: string, matchId: string, teamId: string, requestedById: string | null, deniedById: string | null, approvedById: string | null, canceledById: string | null, status: MatchRescheduleRequestStatus | null, rescheduleReason: MatchRescheduleRequestReason | null, rescheduleNotes: string | null, denyNotes: string | null, proposedTimes: Array<string> | null, createdAt: string, updatedAt: string | null } };

export type RescheduleMatchMutationVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  updatedStartsAt: Scalars['DateTime']['input'];
  reason: AdminMatchRescheduleReason;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type RescheduleMatchMutation = { __typename?: 'Mutation', rescheduleMatch: { __typename?: 'MatchPayload', success: boolean, match: { __typename?: 'Match', id: string, scheduledStartsAt: string | null } | null } };

export type MatchRescheduleDateRangeQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type MatchRescheduleDateRangeQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, scheduledStartsAt: string | null, slot: { __typename?: 'Slot', id: string, startsAt: string | null, phase: { __typename?: 'Phase', id: string, endsAt: string } | null } | null } | null };

export type GetMatchRescheduleDateRangeQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetMatchRescheduleDateRangeQuery = { __typename?: 'Query', getMatchRescheduleDateRange: { __typename?: 'MatchRescheduleDateRange', after: string | null, before: string | null } | null };

export type GetWalkthroughPlaylistQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWalkthroughPlaylistQuery = { __typename?: 'Query', getWalkthroughPlaylist: { __typename?: 'PlaylistPayload', playlist: Array<{ __typename?: 'PlaylistItem', title: string, thumbnail: string, embedHtml: string, durationSeconds: number }> } };

export type GetResourceImagesByResourceIdsQueryVariables = Exact<{
  resources: Array<ResourceData> | ResourceData;
}>;


export type GetResourceImagesByResourceIdsQuery = { __typename?: 'Query', getResourceImagesByResourceIds: Array<{ __typename?: 'ResourceImage', fileName: string, url: string, size: number | null, resourceId: string, resourceType: ResourceType }> };

export type GetChecklistQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetChecklistQuery = { __typename?: 'Query', getChecklist: { __typename?: 'ChecklistPayload', groups: Array<{ __typename?: 'ChecklistGroupPayload', group: string, items: Array<{ __typename?: 'ChecklistItemPayload', slug: string, label: string, cta: string, completedById: string | null, completedAt: string | null, urls: Array<{ __typename?: 'ChecklistUrl', url: string, label: string | null }> }> }> } };

export type GetCheckCompletedUserQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetCheckCompletedUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null } | null };

export type CompleteChecklistItemMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
}>;


export type CompleteChecklistItemMutation = { __typename?: 'Mutation', completeChecklistItem: { __typename?: 'CompleteChecklistItemPlayload', success: boolean } };

export type UncompleteChecklistItemMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  slug: Scalars['String']['input'];
}>;


export type UncompleteChecklistItemMutation = { __typename?: 'Mutation', uncompleteChecklistItem: { __typename?: 'CompleteChecklistItemPlayload', success: boolean } };

export type PlayerReplayStatFragment = { __typename?: 'PlayerReplayStat', title: string, subtext: string, value: string | null, statName: PlayerReplayStatName, teamId: string | null, team: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null };

export type PlayerReplayUserFragment = { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null };

export type GetReplayStatsByUserIdQueryVariables = Exact<{
  input: PlayerReplayInput;
}>;


export type GetReplayStatsByUserIdQuery = { __typename?: 'Query', getReplayStatsByUserId: { __typename?: 'PlayerReplayPayload', userId: string, slidesData: Array<{ __typename?: 'PlayerReplayStat', title: string, subtext: string, value: string | null, statName: PlayerReplayStatName, teamId: string | null, team: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }>, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null } };

export type LobbyEventsForGameQueryVariables = Exact<{
  tournamentCode: Scalars['String']['input'];
}>;


export type LobbyEventsForGameQuery = { __typename?: 'Query', lobbyEventsForGame: { __typename?: 'LobbyEventsResponse', events: Array<{ __typename?: 'LobbyEvent', summonerId: string | null, eventType: string, timestamp: string }> | null } | null };

export type SummonerInfoByIdQueryVariables = Exact<{
  summonerId: Scalars['String']['input'];
}>;


export type SummonerInfoByIdQuery = { __typename?: 'Query', summonerInfo: { __typename?: 'SummonerInfoResponse', profileIconId: number | null, name: string | null, id: string | null, summonerLevel: number | null, revisionDate: number | null } | null };

export type SummonerInfoByNameQueryVariables = Exact<{
  summonerId?: InputMaybe<Scalars['String']['input']>;
  summonerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SummonerInfoByNameQuery = { __typename?: 'Query', summonerInfo: { __typename?: 'SummonerInfoResponse', name: string | null, puuid: string | null } | null };

export type PickTypeForGameQueryVariables = Exact<{
  tournamentCode: Scalars['String']['input'];
}>;


export type PickTypeForGameQuery = { __typename?: 'Query', getLobbyInfo: { __typename?: 'LobbyInfoResponse', code: string | null, pickType: string | null } | null };

export type SetPickTypeForGameMutationVariables = Exact<{
  tournamentCode: Scalars['String']['input'];
  pickType: RiotApiPickType;
}>;


export type SetPickTypeForGameMutation = { __typename?: 'Mutation', updateLobby: { __typename?: 'UpdateLobbyPayload', success: boolean } };

export type UnlinkRiotAccountMutationVariables = Exact<{
  puuid: Scalars['String']['input'];
}>;


export type UnlinkRiotAccountMutation = { __typename?: 'Mutation', unlinkRiotAccount: { __typename?: 'UnlinkRiotAccountPayload', success: boolean } };

export type UpdateRiotAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateRiotAccountMutation = { __typename?: 'Mutation', updateRiotAccount: { __typename?: 'UserProviderAccount', providerDisplayName: string | null } };

export type TeamRivalDataFragment = { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null };

export type TeamRivalFragment = { __typename?: 'TeamRival', id: string, seasonId: string, requestingTeamId: string, acceptingTeamId: string, status: TeamRivalStatus, acceptingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null };

export type PossibleTeamRivalFragment = { __typename?: 'PossibleTeamRivalPayload', schoolId: string | null, teamId: string, hasActiveRivalInSeason: boolean, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null, team: { __typename?: 'Team', id: string, name: string | null } | null };

export type GetPossibleTeamRivalsQueryVariables = Exact<{
  input: GetPossibleTeamRivalsInput;
}>;


export type GetPossibleTeamRivalsQuery = { __typename?: 'Query', getPossibleTeamRivals: { __typename?: 'GetPossibleTeamRivalsResult', seasonId: string, results: Array<{ __typename?: 'PossibleTeamRivalPayload', schoolId: string | null, teamId: string, hasActiveRivalInSeason: boolean, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null, team: { __typename?: 'Team', id: string, name: string | null } | null }> | null } | null };

export type GetTeamRivalsQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  seasonId: Scalars['UUID']['input'];
}>;


export type GetTeamRivalsQuery = { __typename?: 'Query', team: { __typename?: 'Team', currentTeamRival: { __typename?: 'TeamRival', id: string, seasonId: string, requestingTeamId: string, acceptingTeamId: string, status: TeamRivalStatus, acceptingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null } | null, pendingTeamRivals: Array<{ __typename?: 'TeamRival', id: string, seasonId: string, requestingTeamId: string, acceptingTeamId: string, status: TeamRivalStatus, acceptingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null }> | null, requestedTeamRivals: Array<{ __typename?: 'TeamRival', id: string, seasonId: string, requestingTeamId: string, acceptingTeamId: string, status: TeamRivalStatus, acceptingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null }> | null } | null };

export type RequestTeamRivalMutationVariables = Exact<{
  input: RequestTeamRivalInput;
}>;


export type RequestTeamRivalMutation = { __typename?: 'Mutation', requestTeamRival: { __typename?: 'TeamRival', id: string, seasonId: string, requestingTeamId: string, acceptingTeamId: string, status: TeamRivalStatus, acceptingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null } };

export type CancelTeamRivalMutationVariables = Exact<{
  input: CancelTeamRivalInput;
}>;


export type CancelTeamRivalMutation = { __typename?: 'Mutation', cancelTeamRival: { __typename?: 'TeamRival', id: string, seasonId: string, requestingTeamId: string, acceptingTeamId: string, status: TeamRivalStatus, acceptingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null } };

export type AcceptTeamRivalMutationVariables = Exact<{
  input: ResponseTeamRivalInput;
}>;


export type AcceptTeamRivalMutation = { __typename?: 'Mutation', acceptTeamRival: { __typename?: 'TeamRival', id: string, seasonId: string, requestingTeamId: string, acceptingTeamId: string, status: TeamRivalStatus, acceptingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null } };

export type DenyTeamRivalMutationVariables = Exact<{
  input: ResponseTeamRivalInput;
}>;


export type DenyTeamRivalMutation = { __typename?: 'Mutation', denyTeamRival: { __typename?: 'TeamRival', id: string, seasonId: string, requestingTeamId: string, acceptingTeamId: string, status: TeamRivalStatus, acceptingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null } };

export type RemoveTeamRivalMutationVariables = Exact<{
  input: RemoveTeamRivalInput;
}>;


export type RemoveTeamRivalMutation = { __typename?: 'Mutation', removeTeamRival: { __typename?: 'TeamRival', id: string, seasonId: string, requestingTeamId: string, acceptingTeamId: string, status: TeamRivalStatus, acceptingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null } | null } | null } };

export type TeamPlayersOnRosterQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TeamPlayersOnRosterQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, roster: { __typename?: 'TeamRoster', teamId: string, maxNumPlayers: number, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }>, starters: Array<{ __typename?: 'StarterPosition', position: { __typename?: 'EsportPosition', id: string, index: number, abbreviation: string }, player: { __typename?: 'TeamPlayer', isCaptain: boolean, effectiveAt: string, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } } | null }> }> } | null } | null };

export type GetCoachAdditionalInfoQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type GetCoachAdditionalInfoQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, coaches: Array<{ __typename?: 'TeamCoach', id: string, additionalInfo: string | null }> | null } | null };

export type TeamRosterQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type TeamRosterQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, avatarUrl: string | null, competitionGroup: CompetitionGroup | null, schoolId: string | null, isPlayerLed: boolean | null, deletedAt: string | null, name: string | null, school: { __typename?: 'School', id: string } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating }, enrolledSeasons: Array<{ __typename?: 'Season', id: string, rostersLockAt: string | null, name: string, startsAt: string, endsAt: string, teamRegistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null, playerDeregistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, metaseason: { __typename?: 'Metaseason', id: string, isPromoted: boolean, startsAt: string | null, name: string | null, endsAt: string | null } | null }> | null, leagues: Array<{ __typename?: 'League', id: string, competitionModel: CompetitionModel, name: string | null, displayName: string | null, esportId: string | null }> | null, roster: { __typename?: 'TeamRoster', id: string, teamId: string, numPlayers: number, maxNumPlayers: number, players: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, effectiveAt: string, user: { __typename?: 'User', id: string, lastSeen: string | null, name: string | null, avatarUrl: string | null, userEsportPlatforms: Array<{ __typename?: 'UserEsportPlatform', platform: Platform, platformUsername: string | null }> | null, directRoles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string }> | null, schoolRoleStatus: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', position: { __typename?: 'EsportPosition', id: string, index: number, name: string, abbreviation: string, colloquial: string }, player: { __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, lastSeen: string | null, avatarUrl: string | null, directRoles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string }> | null, schoolRoleStatus: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName }> | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, lastSeen: string | null, directRoles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string }> | null, schoolRoleStatus: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName }> | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> }> } | null } | null };

export type GetTeamRosterCoachesQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  isPublic: Scalars['Boolean']['input'];
}>;


export type GetTeamRosterCoachesQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, coaches: Array<{ __typename?: 'TeamCoach', id: string, name: string | null, firstName: string | null, lastName: string | null, lastSeen: string | null, email?: string | null, phone?: string | null, phoneExt?: string | null, isPhoneNumberVisible: boolean | null, avatarUrl: string | null, directRoles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceId: string, resourceType: ResourceType }> | null }> | null } | null };

export type TeamRosterOwnerQueryVariables = Exact<{
  role: RoleDescriptor;
}>;


export type TeamRosterOwnerQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, name: string | null, lastSeen: string | null, avatarUrl: string | null }> };

export type GetOwnerToAddToTeamQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetOwnerToAddToTeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, inviteUrl: string | null, owners: Array<{ __typename?: 'User', id: string, avatarUrl: string | null, name: string | null }> | null, roster: { __typename?: 'TeamRoster', teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } }> } | null } | null };

export type GetRosterRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRosterRolesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string, status: UserRoleStatusName }> | null } | null };

export type GetMatchesByDateForScheduleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  teamIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SeasonTeamMatchSort>;
}>;


export type GetMatchesByDateForScheduleQuery = { __typename?: 'Query', season: { __typename?: 'Season', id: string, allTeamMatches: Array<{ __typename?: 'Match', id: string, isScrimmage: boolean | null, name: string | null, slotId: string | null, status: MatchStatus, scheduledStartsAt: string | null, scheduleContext: MatchScheduleContext | null, league: { __typename?: 'League', id: string, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel } | null, slot: { __typename?: 'Slot', id: string, phaseId: string | null, startsAt: string | null, status: SlotStatus, phase: { __typename?: 'Phase', id: string, type: PhaseType, seasonId: string, season: { __typename?: 'Season', id: string, metaseasonId: string | null } | null } | null } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, isMyTeam: boolean | null, school: { __typename?: 'School', id: string } | null }> }, matchResults: Array<{ __typename?: 'MatchResult', id: string, matchId: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, team: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null } | null }> | null }> | null } | null };

export type GetSlotsByMetaseasonIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSlotsByMetaseasonIdQuery = { __typename?: 'Query', getSlotsByMetaseasonId: Array<{ __typename?: 'Slot', id: string, order: number | null, phaseId: string | null, startsAt: string | null, status: SlotStatus }> | null };

export type MyTeamsAndLeaguesQueryVariables = Exact<{
  metaseasonId: Scalars['UUID']['input'];
  isCoach: Scalars['Boolean']['input'];
  filters?: InputMaybe<TeamFiltersInput>;
}>;


export type MyTeamsAndLeaguesQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, leagues: Array<{ __typename?: 'League', id: string }> | null } | null, getTeams?: { __typename?: 'TeamsResult', teams: Array<{ __typename?: 'Team', id: string, leagues: Array<{ __typename?: 'League', id: string }> | null }> | null } | null };

export type GetSchoolDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSchoolDetailsQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, address: string | null, allowCaptainEnrollment: boolean | null, allowPlayerLedTeams: boolean | null, showCoachEmails: boolean | null, name: string | null, slug: string | null, city: string | null, state: string | null, zip: string | null, phone: string | null, ncesId: string | null, mascotName: string | null, logoUrl: string | null, whoPays: WhoPays | null, type: SchoolType | null, competitionGroup: CompetitionGroup | null, createdAt: string | null, deletedAt: string | null, timezone: string | null, districtClassification: string | null, dismissalTime: string | null, detail: { __typename?: 'SchoolDetail', at: string | null, it: { __typename?: 'ITDetails', osType: string | null, hasDedicatedLab: boolean | null, numStudentComps: string | null, suppStaffOnCampus: boolean | null, publicIP: string | null, agreeToInstallGames: boolean | null, agreeToWhitelistPorts: boolean | null, agreeToDoPatchUpdates: boolean | null, suppStaff: { __typename?: 'SupportStaff', email: string | null, fname: string | null, lname: string | null, phone: string | null } | null } | null } | null } | null };

export type SelectedOrganizationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SelectedOrganizationQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null, country: string | null } | null };

export type GetSchoolPreviewQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolPreviewQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, city: string | null, state: string | null, zip: string | null, playerCount: number | null, coaches: Array<{ __typename?: 'User', id: string }> | null, teams: Array<{ __typename?: 'Team', id: string }> | null } | null };

export type GetSchoolTypeQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolTypeQuery = { __typename?: 'Query', school: { __typename?: 'School', type: SchoolType | null } | null };

export type UpdateSchoolProfile2MutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  input: SetSchoolProfileInput;
}>;


export type UpdateSchoolProfile2Mutation = { __typename?: 'Mutation', updateSchoolProfile: { __typename?: 'School', id: string, mascotName: string | null, name: string | null, whoPays: WhoPays | null, address: string | null, phone: string | null, type: SchoolType | null } | null };

export type UpdateSchoolDetailsMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  detail: SchoolDetailInput;
}>;


export type UpdateSchoolDetailsMutation = { __typename?: 'Mutation', updateSchoolDetail: { __typename?: 'School', id: string, detail: { __typename?: 'SchoolDetail', at: string | null, it: { __typename?: 'ITDetails', osType: string | null, publicIP: string | null, suppStaff: { __typename?: 'SupportStaff', email: string | null, fname: string | null, lname: string | null, phone: string | null } | null } | null } | null } | null };

export type GetSchoolQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSchoolQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, slug: string | null, name: string | null, city: string | null, state: string | null, zip: string | null, whoPays: WhoPays | null, type: SchoolType | null, logoUrl: string | null, deletedAt: string | null, coachRolePendingUsers: Array<{ __typename?: 'User', id: string, email: string | null, name: string | null, phone: string | null }> | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, esport: { __typename?: 'Esport', id: string, name: string | null } }> | null } | null };

export type GetSchoolNameQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSchoolNameQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string | null } | null };

export type GetPublicSchoolQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetPublicSchoolQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string | null, slug: string | null, city: string | null, state: string | null, zip: string | null, logoUrl: string | null, competitionGroup: CompetitionGroup | null, twitchUrl: string | null, twitchUsername: string | null, schoolProviderAccounts: Array<{ __typename?: 'SchoolProviderAccount', id: string, schoolId: string, providerName: string, providerAccountId: string, providerDisplayName: string, providerIntegrationType: IntegrationType }> | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, deletedAt: string | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating } }> | null, getLatestEnrolledMetaseason: { __typename?: 'Metaseason', id: string } | null } | null };

export type GetSchoolTeamIdsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSchoolTeamIdsQuery = { __typename?: 'Query', school: { __typename?: 'School', teams: Array<{ __typename?: 'Team', id: string }> | null } | null };

export type GetUsersForSchoolQueryVariables = Exact<{
  schoolId: Scalars['String']['input'];
  roles: Array<UserRoleName> | UserRoleName;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersForSchoolQuery = { __typename?: 'Query', getUsers: { __typename?: 'UsersResult', totalCount: number | null, users: Array<{ __typename?: 'User', id: string, name: string | null, firstName: string | null, lastName: string | null, avatarUrl: string | null, phone: string | null, phoneExt: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null, emails: Array<{ __typename?: 'UserEmail', email: string, isVerified: boolean | null, isSchoolEmail: boolean }> | null, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, resourceId: string, resourceType: ResourceType, userId: string }> | null, schoolRoleStatus: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName, role: { __typename?: 'Role', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string } }> | null }> | null } | null, getUsersWithPendingRoles: { __typename?: 'UsersResult', totalCount: number | null, users: Array<{ __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, phone: string | null, email: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null, emails: Array<{ __typename?: 'UserEmail', email: string, isSchoolEmail: boolean, isVerified: boolean | null }> | null, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, resourceId: string, resourceType: ResourceType, userId: string }> | null, roleRequests: Array<{ __typename?: 'RoleRequest', status: UserRoleStatusName, roleName: UserRoleName, resourceId: string, resourceType: ResourceType }> | null, schoolRoleStatus: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName, role: { __typename?: 'Role', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string } }> | null }> | null } | null };

export type GetLeagueGroupsForSchoolQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetLeagueGroupsForSchoolQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null, leagueGroups: Array<{ __typename?: 'LeagueGroup', id: string }> } | null, getActiveLeaguesBySchoolId: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, state: string | null, competitionModel: CompetitionModel, isHidden: boolean | null, seasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, registrationStartsAt: string, teamRegistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null }> | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null } }> };

export type GetAllLeagueGroupsForSchoolQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetAllLeagueGroupsForSchoolQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null, leagueGroups: Array<{ __typename?: 'LeagueGroup', id: string }> } | null, getLeaguesBySchoolId: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, state: string | null, competitionModel: CompetitionModel, isHidden: boolean | null, seasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, registrationStartsAt: string, teamRegistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null }> | null, varsityAssociation: { __typename?: 'VarsityAssociation', name: string } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null } }> | null };

export type GetAllSchoolTeamsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type GetAllSchoolTeamsQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null, logoUrl: string | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, isPlayerLed: boolean | null, deletedAt: string | null, deletedBy: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceId: string, resourceType: ResourceType }> | null } | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null }> | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null } }, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, effectiveAt: string, teamId: string, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } }> } | null }> | null } | null };

export type GetPublicSchoolTeamRecordsQueryVariables = Exact<{
  schoolSlug: Scalars['String']['input'];
}>;


export type GetPublicSchoolTeamRecordsQuery = { __typename?: 'Query', getSchoolBySlug: { __typename?: 'School', id: string, logoUrl: string | null, competitionGroup: CompetitionGroup | null, name: string | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, isEnrolledInCurrentMetaseason: boolean | null, getCurrentMetaseasonTeamPhaseStandings: { __typename?: 'TeamPhaseStandings', phaseId: string, ranking: number | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number, matchesTied: number } | null } | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating } }> | null, getLatestEnrolledMetaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null } | null };

export type GetMySchoolTeamRecordsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMySchoolTeamRecordsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, competitionGroup: CompetitionGroup | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, isEnrolledInCurrentMetaseason: boolean | null, getCurrentMetaseasonTeamPhaseStandings: { __typename?: 'TeamPhaseStandings', phaseId: string, ranking: number | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number, matchesTied: number } | null } | null, esport: { __typename?: 'Esport', id: string, rating: EsportRating } }> | null, getLatestEnrolledMetaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null } | null } | null };

export type GetRosterAcrossAllTeamsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  isPublic: Scalars['Boolean']['input'];
}>;


export type GetRosterAcrossAllTeamsQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, showCoachEmails?: boolean | null, coaches: Array<{ __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, emails?: Array<{ __typename?: 'UserEmail', email: string, isSchoolEmail: boolean }> | null, teamsWherePrimaryCoach: Array<{ __typename?: 'Team', id: string, name: string | null }> }> | null, players: Array<{ __typename?: 'User', id: string, name: string | null, avatarUrl: string | null }> | null } | null };

export type GetSchoolScrimmagesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  past?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ScrimmageRequestFilter>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetSchoolScrimmagesQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string | null, myScrimmageRequests: { __typename?: 'ScrimmageRequestResult', total: number | null, result: Array<{ __typename?: 'ScrimmageRequest', id: string, status: ScrimmageRequestStatus, startsAt: string, bestOf: number | null, esportId: string, requestingTeamId: string, requestedById: string, createdAt: string, league: { __typename?: 'League', id: string, timezone: string | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null } | null, opposingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating, name: string | null } | null }> | null } | null } | null };

export type GetSchoolRecommendedScrimmagesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<ScrimmageRequestFilter>;
  teamId: Scalars['UUID']['input'];
}>;


export type GetSchoolRecommendedScrimmagesQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string | null, availableScrimmageRequests: { __typename?: 'ScrimmageRequestResult', total: number | null, result: Array<{ __typename?: 'ScrimmageRequest', id: string, status: ScrimmageRequestStatus, startsAt: string, bestOf: number | null, rating: string | null, esportId: string, requestingTeamId: string, requestedById: string, createdAt: string, requestingTeam: { __typename?: 'Team', id: string, name: string | null, competitionGroup: CompetitionGroup | null, recommendationPercent: number | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null } | null, league: { __typename?: 'League', id: string, name: string | null, state: string | null, timezone: string | null } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating } | null }> | null } | null } | null };

export type GetSchoolAvailableScrimmagesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<ScrimmageRequestFilter>;
}>;


export type GetSchoolAvailableScrimmagesQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string | null, availableScrimmageRequests: { __typename?: 'ScrimmageRequestResult', total: number | null, result: Array<{ __typename?: 'ScrimmageRequest', id: string, status: ScrimmageRequestStatus, startsAt: string, bestOf: number | null, seriesBestOf: number | null, esportId: string, requestingTeamId: string, requestedById: string, createdAt: string, rating: string | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null } | null, league: { __typename?: 'League', id: string, name: string | null, state: string | null, timezone: string | null } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating } | null }> | null } | null } | null };

export type GetSchoolSheerIdQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolSheerIdQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, type: SchoolType | null, sheeridOrganizationId: number | null, sheeridOrganizationName: string | null } | null };

export type GetSchoolBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetSchoolBySlugQuery = { __typename?: 'Query', getSchoolBySlug: { __typename?: 'School', id: string, name: string | null, city: string | null, state: string | null } | null };

export type UpdateSchoolSheerIdMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  sheeridOrganizationId: Scalars['Int']['input'];
  sheeridOrganizationName: Scalars['String']['input'];
}>;


export type UpdateSchoolSheerIdMutation = { __typename?: 'Mutation', updateSchoolSheerId: { __typename?: 'SchoolPayload', success: boolean, school: { __typename?: 'School', id: string, sheeridOrganizationId: number | null } | null } | null };

export type DeleteSchoolMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type DeleteSchoolMutation = { __typename?: 'Mutation', deleteSchool: { __typename?: 'DeleteSchoolPayload', success: boolean, deletedSchoolId: string } };

export type ResurrectSchoolMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type ResurrectSchoolMutation = { __typename?: 'Mutation', resurrectSchool: { __typename?: 'SchoolPayload', success: boolean, school: { __typename?: 'School', id: string, deletedAt: string | null } | null } };

export type GetPurchasedProductsForSchoolQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetPurchasedProductsForSchoolQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, annualPassInstances: Array<{ __typename?: 'AnnualPassInstance', id: string, productId: string | null, product: { __typename?: 'AnnualPassProduct', id: string, name: string } | null }> } | null };

export type FindEligibleVarsityAssociationsQueryVariables = Exact<{
  state: Scalars['String']['input'];
  competitionGroup: CompetitionGroup;
}>;


export type FindEligibleVarsityAssociationsQuery = { __typename?: 'Query', findEligibleVarsityAssociations: Array<{ __typename?: 'VarsityAssociation', name: string, slug: string }> };

export type GetStateAssociationsBySchoolIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetStateAssociationsBySchoolIdQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, varsityAssociations: Array<{ __typename?: 'VarsityAssociation', name: string, slug: string }>, eligibleVarsityAssociations: Array<{ __typename?: 'VarsityAssociation', name: string, slug: string }> } | null };

export type AddSchoolToVarsityAssociationMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  firstEffectiveMetaseasonId: Scalars['UUID']['input'];
  varsityAssociationSlug: Scalars['String']['input'];
}>;


export type AddSchoolToVarsityAssociationMutation = { __typename?: 'Mutation', addSchoolToVarsityAssociation: { __typename?: 'SchoolPayload', success: boolean } | null };

export type CreateSchoolMessageMutationVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type CreateSchoolMessageMutation = { __typename?: 'Mutation', createSchoolMessage: { __typename?: 'SchoolMessage', id: string, title: string | null, message: string | null, school: { __typename?: 'School', id: string, name: string | null } | null, user: { __typename?: 'User', id: string, name: string | null } | null } | null };

export type GetAggregateSchoolMessagesQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetAggregateSchoolMessagesQuery = { __typename?: 'Query', getAggregateSchoolMessages: Array<{ __typename: 'SchoolFortniteMatchResultMessage', title: string | null, message: string | null, createdAt: string | null, linkUrl: string | null, matchId: string, esportSlug: string, leagueName: string, homeTeamId: string, homeTeamName: string, homeSchoolLogoUrl: string | null, rank: number } | { __typename: 'SchoolOneOnOneMatchResultMessage', title: string | null, message: string | null, createdAt: string | null, linkUrl: string | null, matchId: string, esportSlug: string, leagueName: string, homeTeamId: string, homeTeamName: string, homeSchoolLogoUrl: string | null, opposingTeamId: string, opposingTeamName: string, opposingSchoolLogoUrl: string | null, homeTeamGamesWon: number, homeTeamGamesLost: number } | { __typename: 'SchoolUserMessage', title: string | null, message: string | null, createdAt: string | null, linkUrl: string | null, id: string, isPinned: boolean | null, linkImageUrl: string | null, linkTitle: string | null, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }> | null };

export type GetSchoolCoachesBySchoolIdQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolCoachesBySchoolIdQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, coaches: Array<{ __typename?: 'User', id: string, name: string | null, lastSeen: string | null, firstName: string | null, lastName: string | null, email: string | null, avatarUrl: string | null, directRoles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceId: string, resourceType: ResourceType }> | null }> | null } | null };

export type MySchoolBillingContactQueryVariables = Exact<{ [key: string]: never; }>;


export type MySchoolBillingContactQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, address: string | null, city: string | null, state: string | null, zip: string | null, name: string | null, deletedAt: string | null, annualPassInstances: Array<{ __typename?: 'AnnualPassInstance', id: string, product: { __typename?: 'AnnualPassProduct', priceUsd: number } | null }>, billingContact: { __typename?: 'SchoolBillingContact', firstName: string, email: string } | null, coaches: Array<{ __typename?: 'User', id: string, name: string | null, firstName: string | null, lastName: string | null, phone: string | null, phoneExt: string | null, avatarUrl: string | null, emails: Array<{ __typename?: 'UserEmail', email: string, isSchoolEmail: boolean }> | null }> | null } | null } | null };

export type GetSchoolBillingContactQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolBillingContactQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, name: string | null, address: string | null, city: string | null, state: string | null, zip: string | null, billingContact: { __typename?: 'SchoolBillingContact', userId: string | null, firstName: string, lastName: string, email: string, organizationRole: string, phone: string | null, phoneExt: string | null, address: string | null, city: string | null, state: string | null, zip: string | null, createdAt: string, user: { __typename?: 'BillingUser', id: string, firstName: string | null, lastName: string | null, phone: string | null, phoneExt: string | null, email: string | null } | null, createdBy: { __typename?: 'User', id: string, name: string | null, email: string | null, phone: string | null } | null } | null } | null };

export type GetAllSchoolsEsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<SchoolFiltersInput>;
}>;


export type GetAllSchoolsEsQuery = { __typename?: 'Query', getSchoolsES: { __typename?: 'SchoolsResult', totalCount: number | null, schools: Array<{ __typename?: 'School', id: string, name: string | null, city: string | null, state: string | null, logoUrl: string | null, createdAt: string | null, deletedAt: string | null, type: SchoolType | null, ncesId: string | null, playerCount: number | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null }> | null, submissions: Array<{ __typename?: 'UserSchoolSubmission', id: string, createdAt: string, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, emails: Array<{ __typename?: 'UserEmail', id: string, isVerified: boolean | null, isSchoolEmail: boolean }> | null, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, userId: string, resourceId: string }> | null } | null }> | null, coaches: Array<{ __typename?: 'User', id: string, name: string | null }> | null }> | null } | null };

export type FindSchoolsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type FindSchoolsByIdsQuery = { __typename?: 'Query', findSchoolsByIds: Array<{ __typename?: 'School', id: string, name: string | null, competitionGroup: CompetitionGroup | null, logoUrl: string | null }> | null };

export type GetSchoolsOnUserPageEsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<SchoolFiltersInput>;
}>;


export type GetSchoolsOnUserPageEsQuery = { __typename?: 'Query', getSchoolsES: { __typename?: 'SchoolsResult', schools: Array<{ __typename?: 'School', id: string, name: string | null, logoUrl: string | null }> | null } | null };

export type GetSchoolEligibleMetaseasonsQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetSchoolEligibleMetaseasonsQuery = { __typename?: 'Query', eligibleMetaseasons: Array<{ __typename?: 'Metaseason', id: string, isPromoted: boolean }> };

export type GetSchoolsOnVarsityAssociationPageEsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<SchoolFiltersInput>;
  varsityAssociationSlug: Scalars['String']['input'];
}>;


export type GetSchoolsOnVarsityAssociationPageEsQuery = { __typename?: 'Query', getSchoolsES: { __typename?: 'SchoolsResult', totalCount: number | null, schools: Array<{ __typename?: 'School', id: string, name: string | null, logoUrl: string | null, state: string | null, schoolVarsityAssociation: { __typename?: 'SchoolVarsityAssociation', createdAt: string } | null }> | null } | null };

export type BillingContactFormInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingContactFormInfoQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, address: string | null, city: string | null, state: string | null, zip: string | null, billingContact: { __typename?: 'SchoolBillingContact', firstName: string, lastName: string, phone: string | null, phoneExt: string | null, email: string, address: string | null, city: string | null, state: string | null, zip: string | null, user: { __typename?: 'BillingUser', id: string, firstName: string | null, lastName: string | null, phone: string | null, phoneExt: string | null, email: string | null } | null } | null } | null } | null };

export type GetAllSchoolsForCoachLeadQueryVariables = Exact<{
  query: Scalars['String']['input'];
  type: Scalars['String']['input'];
  state: Scalars['String']['input'];
}>;


export type GetAllSchoolsForCoachLeadQuery = { __typename?: 'Query', searchSchools: { __typename?: 'SearchSchoolsResults', results: Array<{ __typename?: 'SchoolSearchResult', schoolId: string, name: string | null, logoUrl: string | null, city: string | null, state: string | null }> | null } };

export type GetMySchoolNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMySchoolNameQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, name: string | null, state: string | null, slug: string | null } | null } | null };

export type UpdateSchoolMessageMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSchoolMessageMutation = { __typename?: 'Mutation', updateSchoolMessage: { __typename?: 'SchoolMessage', id: string } | null };

export type DeleteSchoolMessageMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteSchoolMessageMutation = { __typename?: 'Mutation', deleteSchoolMessage: { __typename?: 'DeleteSchoolMessagePayload', success: boolean, deletedSchoolMessageId: string } };

export type RemoveSchoolFromVarsityAssociationMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  firstEffectiveMetaseasonId: Scalars['UUID']['input'];
  varsityAssociationSlug: Scalars['String']['input'];
}>;


export type RemoveSchoolFromVarsityAssociationMutation = { __typename?: 'Mutation', removeSchoolFromVarsityAssociation: { __typename?: 'SchoolPayload', success: boolean } | null };

export type RemoveSchoolsFromVarsityAssociationMutationVariables = Exact<{
  input: RemoveSchoolsFromVarsityAssociationInput;
}>;


export type RemoveSchoolsFromVarsityAssociationMutation = { __typename?: 'Mutation', removeSchoolsFromVarsityAssociation: { __typename?: 'BulkActionJobPayload', jobId: string } };

export type UpdateAllowPlayerLedTeamsMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  allowPlayerLedTeams: Scalars['Boolean']['input'];
}>;


export type UpdateAllowPlayerLedTeamsMutation = { __typename?: 'Mutation', updateAllowPlayerLedTeams: { __typename?: 'School', id: string, allowPlayerLedTeams: boolean | null } | null };

export type UpdateShowCoachEmailsMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  showCoachEmails: Scalars['Boolean']['input'];
}>;


export type UpdateShowCoachEmailsMutation = { __typename?: 'Mutation', updateShowCoachEmails: { __typename?: 'School', id: string, showCoachEmails: boolean | null } | null };

export type UpdateAllowCaptainEnrollmentMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  allowCaptainEnrollment: Scalars['Boolean']['input'];
}>;


export type UpdateAllowCaptainEnrollmentMutation = { __typename?: 'Mutation', updateAllowCaptainEnrollment: { __typename?: 'School', id: string, allowCaptainEnrollment: boolean | null } | null };

export type CreateSchoolMutationVariables = Exact<{
  type: SchoolType;
  schoolName: Scalars['String']['input'];
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
  ncesId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  varsityAssociationSlug?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSchoolMutation = { __typename?: 'Mutation', createSchool: { __typename?: 'School', id: string } | null };

export type GetSchoolCoordinatesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSchoolCoordinatesQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, lat: number | null, lon: number | null } | null };

export type GetLocalReferralSchoolsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<SchoolFiltersInput>;
}>;


export type GetLocalReferralSchoolsQuery = { __typename?: 'Query', getSchoolsES: { __typename?: 'SchoolsResult', totalCount: number | null, schools: Array<{ __typename?: 'School', id: string, name: string | null, logoUrl: string | null, createdAt: string | null, state: string | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null }> | null } | null };

export type GetSchoolTeamsAndMembersEffectiveAtRangeQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  effectiveAtRange: DateRangeInput;
  teamFilters: SchoolTeamFiltersInput;
}>;


export type GetSchoolTeamsAndMembersEffectiveAtRangeQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string | null, leagues: Array<{ __typename?: 'League', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, effectiveAt: string, teamId: string, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, assignedSeasonalAwards: Array<{ __typename?: 'AssignedSeasonalPlayerAward', id: string, teamId: string, awardType: { __typename?: 'SeasonalPlayerAwardType', id: string, title: string } | null }> | null } }> } | null }> | null } | null };

export type GetSchoolVarsityAssociationsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSchoolVarsityAssociationsQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, varsityAssociations: Array<{ __typename?: 'VarsityAssociation', name: string, slug: string }> } | null };

export type GetMySchoolTeamsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetMySchoolTeamsQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, competitionGroup: CompetitionGroup | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, deletedAt: string | null, isEnrolledInCurrentMetaseason: boolean | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating }, leagues: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null }> | null, phaseResult: { __typename?: 'PhaseResult', id: string, matchesWon: number, matchesLost: number, phase: { __typename?: 'Phase', id: string, name: string | null, season: { __typename?: 'Season', id: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null } | null } | null } | null }> | null } | null };

export type AddLeagueToSchoolMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  leagueId: Scalars['UUID']['input'];
}>;


export type AddLeagueToSchoolMutation = { __typename?: 'Mutation', addLeagueToSchool: { __typename?: 'LeaguePayload', success: boolean } | null };

export type RemoveLeagueFromSchoolMutationVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  leagueId: Scalars['UUID']['input'];
}>;


export type RemoveLeagueFromSchoolMutation = { __typename?: 'Mutation', removeLeagueFromSchool: { __typename?: 'LeaguePayload', success: boolean } | null };

export type AddLeagueToSchoolsBulkMutationVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
  states: Array<Scalars['String']['input']> | Scalars['String']['input'];
  varsityAssociationSlugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddLeagueToSchoolsBulkMutation = { __typename?: 'Mutation', addLeagueToSchoolsBulk: { __typename?: 'AddLeagueBulkPayload', success: boolean, total: number | null } | null, addLeagueToLeagueGroups: { __typename?: 'AddLeagueBulkPayload', success: boolean, total: number | null } | null };

export type RemoveLeagueFromSchoolsBulkMutationVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
  states: Array<Scalars['String']['input']> | Scalars['String']['input'];
  varsityAssociationSlugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RemoveLeagueFromSchoolsBulkMutation = { __typename?: 'Mutation', removeLeagueFromSchoolsBulk: { __typename?: 'LeaguePayload', success: boolean } | null, removeLeagueFromLeagueGroups: { __typename?: 'LeaguePayload', success: boolean } | null };

export type AvailableLeagueEsportsForSchoolQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type AvailableLeagueEsportsForSchoolQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, availableLeagueEsports: Array<{ __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }> } | null };

export type ScrimmageRequestQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
}>;


export type ScrimmageRequestQuery = { __typename?: 'Query', scrimmageRequest: { __typename?: 'ScrimmageRequest', id: string, bestOf: number | null, seriesBestOf: number | null, rating: string | null, startsAt: string, status: ScrimmageRequestStatus, matchId: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null } | null, requestedBy: { __typename?: 'User', id: string, email: string | null, phone: string | null, avatarUrl: string | null, name: string | null, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, userId: string, resourceId: string, resourceType: ResourceType }> | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null, slug: string | null } | null } | null, opposingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null, name: string | null, slug: string | null } | null } | null, myAvailableTeams: Array<{ __typename?: 'Team', id: string, name: string | null }> | null, league: { __typename?: 'League', id: string, timezone: string | null } | null } | null };

export type FindRecommendedTeamsQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  filters?: InputMaybe<TeamFiltersInput>;
}>;


export type FindRecommendedTeamsQuery = { __typename?: 'Query', findRecommendedTeams: Array<{ __typename?: 'RecommendedTeam', recommendationPercent: number, team: { __typename?: 'Team', id: string, name: string | null, state: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, rating: EsportRating }, phaseResult: { __typename?: 'PhaseResult', id: string, rank: number | null } | null } }> | null };

export type FindRecommendedTeamsForScrimmageQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  limit: Scalars['Int']['input'];
  filters?: InputMaybe<TeamFiltersInput>;
}>;


export type FindRecommendedTeamsForScrimmageQuery = { __typename?: 'Query', findRecommendedTeamsForScrimmage: Array<{ __typename?: 'Team', id: string, name: string | null, state: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, rating: EsportRating }, phaseResult: { __typename?: 'PhaseResult', id: string, rank: number | null } | null }> | null };

export type GetScrimmageRequestsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<ScrimmageRequestFilter>;
}>;


export type GetScrimmageRequestsQuery = { __typename?: 'Query', scrimmageRequests: { __typename?: 'ScrimmageRequestResult', total: number | null, result: Array<{ __typename?: 'ScrimmageRequest', id: string, status: ScrimmageRequestStatus, startsAt: string, bestOf: number | null, esportId: string, requestingTeamId: string, requestedById: string, createdAt: string, rating: string | null, requestingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null } | null, opposingTeam: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } | null, league: { __typename?: 'League', id: string, timezone: string | null } | null }> | null } | null };

export type RequestScrimmageMutationVariables = Exact<{
  input: RequestScrimmageInput;
}>;


export type RequestScrimmageMutation = { __typename?: 'Mutation', requestScrimmage: { __typename?: 'RequestScrimmageResponse', scrimmageLink: string, scrimmageRequest: { __typename?: 'ScrimmageRequest', id: string } } };

export type CreateScrimmageMutationVariables = Exact<{
  input: RequestScrimmageInput;
}>;


export type CreateScrimmageMutation = { __typename?: 'Mutation', createScrimmage: { __typename?: 'RequestScrimmageResponse', scrimmageLink: string, scrimmageRequest: { __typename?: 'ScrimmageRequest', id: string } } };

export type CancelScrimmageMutationVariables = Exact<{
  input: CancelScrimmageInput;
}>;


export type CancelScrimmageMutation = { __typename?: 'Mutation', cancelScrimmage: { __typename?: 'CancelScrimmagesPayload', success: boolean, canceledScrimmageIds: Array<string> } };

export type DeclineScrimmageMutationVariables = Exact<{
  input: CancelScrimmageInput;
}>;


export type DeclineScrimmageMutation = { __typename?: 'Mutation', declineScrimmage: { __typename?: 'CancelScrimmagesPayload', success: boolean } };

export type JoinScrimmageMutationVariables = Exact<{
  input: JoinScrimmageInput;
}>;


export type JoinScrimmageMutation = { __typename?: 'Mutation', joinScrimmage: { __typename?: 'JoinScrimmageResponse', success: boolean } };

export type GetPlayoffTemplateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetPlayoffTemplateQuery = { __typename?: 'Query', seasonPlayoffTemplate: { __typename?: 'SeasonPlayoffTemplate', id: string, name: string, generationDate: string, seedingDate: string | null, phase: { __typename?: 'Phase', id: string, name: string | null, description: string | null, status: PhaseStatus, startsAt: string, endsAt: string, format: PhaseFormat, mode: string | null, bestOf: number | null, seriesBestOf: number | null, bracketSize: number | null, type: PhaseType, fortniteEventId: string | null, maxTeamsPerSchool: number | null, minutesBeforeMatchToLockInSeries: number | null, slug: string | null, survivalAdvancementPercentage: number | null, survivalAdvancementCount: number | null, minSlotParticipation: number | null, maxSlotParticipation: number | null, shouldSendPlayoffNotification: boolean | null, autoScheduleBracket: boolean | null, slots: Array<{ __typename?: 'Slot', id: string, name: string | null, status: SlotStatus, bestOf: number | null, seriesBestOf: number | null, scheduleMatchesAt: string | null, startsAt: string | null, isStartsAtHidden: boolean | null, fortniteEventWindowId: string | null, ordinal: number | null }> | null }, seasonPlayoffTemplateBestOfs: Array<{ __typename?: 'SeasonPlayoffTemplateBestOf', id: string, esportId: string, bestOf: number, esport: { __typename?: 'Esport', id: string, name: string | null } }> } };

export type GetPlayoffTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlayoffTemplatesQuery = { __typename?: 'Query', seasonPlayoffTemplates: Array<{ __typename?: 'SeasonPlayoffTemplate', id: string, name: string, generationDate: string, seedingDate: string | null, seasonPlayoffTemplateBestOfs: Array<{ __typename?: 'SeasonPlayoffTemplateBestOf', esportId: string, bestOf: number, esport: { __typename?: 'Esport', id: string, name: string | null } }> }> };

export type CreateSeasonPlayoffTemplateMutationVariables = Exact<{
  input: SeasonPlayoffTemplateInsertAttributes;
}>;


export type CreateSeasonPlayoffTemplateMutation = { __typename?: 'Mutation', createSeasonPlayoffTemplate: { __typename?: 'SeasonPlayoffTemplate', id: string } };

export type UpdateSeasonPlayoffTemplateMutationVariables = Exact<{
  input: SeasonPlayoffTemplateUpdateAttributes;
}>;


export type UpdateSeasonPlayoffTemplateMutation = { __typename?: 'Mutation', updateSeasonPlayoffTemplate: { __typename?: 'SeasonPlayoffTemplate', id: string } };

export type BulkCreateSeasonMutationVariables = Exact<{
  bulkSeasonSchedule: BulkSeasonCreateInput;
}>;


export type BulkCreateSeasonMutation = { __typename?: 'Mutation', bulkCreateSeason: { __typename?: 'SeasonJobPayload', jobId: string } };

export type BulkEditSeasonMutationVariables = Exact<{
  bulkEditSeasonInput: BulkEditSeasonInput;
}>;


export type BulkEditSeasonMutation = { __typename?: 'Mutation', bulkEditSeason: { __typename?: 'SeasonJobPayload', jobId: string } };

export type CreateSeasonMutationVariables = Exact<{
  seasonSchedule: SeasonScheduleInput;
}>;


export type CreateSeasonMutation = { __typename?: 'Mutation', createSeason: { __typename?: 'Season', id: string, name: string } | null };

export type UpdateSeasonMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  seasonSchedule?: InputMaybe<UpdateSeasonScheduleInput>;
}>;


export type UpdateSeasonMutation = { __typename?: 'Mutation', updateSeason: { __typename?: 'Season', id: string, name: string, type: SeasonType | null, slug: string, status: SeasonStatus, startsAt: string, endsAt: string, rostersLockAt: string | null, metaseasonId: string | null, registrationStartsAt: string, teamRegistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, playerRegistrationEndsAt: string | null, playerDeregistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null, areBreakWeekSlotExclusionWindowsEnabled: boolean, seasonPlayoffTemplateId: string | null, overridePlayoffGenerationDate: string | null, overridePlayoffSeedingDate: string | null, playvsScoreEnabled: boolean, eventConfig: { __typename?: 'EventConfig', eventDetails: string | null, isHidden: boolean, maxAge: number | null, maxTeamsAllowed: number | null, minAge: number | null, prizeDetails: string | null, surveyId: string | null } | null } | null };

export type GetSeasonQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSeasonQuery = { __typename?: 'Query', season: { __typename?: 'Season', id: string, name: string, type: SeasonType | null, slug: string, status: SeasonStatus, startsAt: string, endsAt: string, rostersLockAt: string | null, metaseasonId: string | null, registrationStartsAt: string, teamRegistrationEndsAt: string | null, teamDeregistrationEndsAt: string | null, playerRegistrationEndsAt: string | null, playerDeregistrationEndsAt: string | null, maxTeamsPerSchool: number | null, suggestedRegistrationEndsAt: string | null, playvsScoreEnabled: boolean, areBreakWeekSlotExclusionWindowsEnabled: boolean, seasonPlayoffTemplateId: string | null, overridePlayoffGenerationDate: string | null, overridePlayoffSeedingDate: string | null, eventConfig: { __typename?: 'EventConfig', eventDetails: string | null, isHidden: boolean, maxAge: number | null, maxTeamsAllowed: number | null, minAge: number | null, prizeDetails: string | null, surveyId: string | null } | null, slotExclusionRangeConfigurations: Array<{ __typename?: 'SlotExclusionRangeConfiguration', id: string, maxSlotExclusions: number, range: { __typename?: 'DateRange', startsAt: string, endsAt: string } }> | null } | null };

export type CreateSeasonDatesTemplateMutationVariables = Exact<{
  input: SeasonDatesTemplateInput;
}>;


export type CreateSeasonDatesTemplateMutation = { __typename?: 'Mutation', createSeasonDatesTemplate: { __typename?: 'SeasonDatesTemplate', id: string } | null };

export type GetSeasonDatesTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSeasonDatesTemplatesQuery = { __typename?: 'Query', getSeasonDatesTemplates: { __typename?: 'GetSeasonDatesTemplateResult', seasonDatesTemplates: Array<{ __typename?: 'SeasonDatesTemplate', id: string, name: string, startsAt: string, endsAt: string, registrationStartsAt: string, suggestedRegistrationEndsAt: string, teamRegistrationEndsAt: string, teamDeregistrationEndsAt: string, playerRegistrationEndsAt: string, playerDeregistrationEndsAt: string, rostersLockAt: string }> | null } };

export type UpdateSeasonDatesTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  attributes: UpdateSeasonDatesTemplateInput;
}>;


export type UpdateSeasonDatesTemplateMutation = { __typename?: 'Mutation', updateSeasonDatesTemplate: { __typename?: 'SeasonDatesTemplate', id: string } | null };

export type GetSeasonsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<GetSeasonsFilter>;
}>;


export type GetSeasonsQuery = { __typename?: 'Query', getSeasons: { __typename?: 'GetSeasonsResult', result: Array<{ __typename?: 'Season', id: string, league: { __typename?: 'League', id: string, name: string | null } | null }> | null } };

export type GetAreBreakWeeksEnabledBySeasonIdsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<GetSeasonsFilter>;
}>;


export type GetAreBreakWeeksEnabledBySeasonIdsQuery = { __typename?: 'Query', getSeasons: { __typename?: 'GetSeasonsResult', result: Array<{ __typename?: 'Season', id: string, areBreakWeekSlotExclusionWindowsEnabled: boolean, slotExclusionRangeConfigurations: Array<{ __typename?: 'SlotExclusionRangeConfiguration', id: string, maxSlotExclusions: number, range: { __typename?: 'DateRange', startsAt: string, endsAt: string } }> | null }> | null } };

export type GetCharacterSelectionOptionsByEsportIdQueryVariables = Exact<{
  input: Scalars['UUID']['input'];
}>;


export type GetCharacterSelectionOptionsByEsportIdQuery = { __typename?: 'Query', characterSelectionOptionsByEsportId: { __typename?: 'GameAssistantSelectionOptionsPayload', selectionOptions: Array<{ __typename?: 'GameAssistantSelectionOptionsByGameOrdinal', gameOrdinal: number | null, selectionOptions: Array<{ __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null }> }> } | null };

export type GetMapSelectionOptionsByEsportIdQueryVariables = Exact<{
  input: Scalars['UUID']['input'];
}>;


export type GetMapSelectionOptionsByEsportIdQuery = { __typename?: 'Query', mapSelectionOptionsByEsportId: { __typename?: 'GameAssistantSelectionOptionsPayload', selectionOptions: Array<{ __typename?: 'GameAssistantSelectionOptionsByGameOrdinal', gameOrdinal: number | null, selectionOptions: Array<{ __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null }> }> } | null };

export type GetEpicPlatformSelectionOptionsByUserIdsQueryVariables = Exact<{
  userIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type GetEpicPlatformSelectionOptionsByUserIdsQuery = { __typename?: 'Query', epicPlatformSelectionOptionsByUserIds: { __typename?: 'EpicPlatformSelectionOptionsByUserIdsPayload', selectionOptions: Array<{ __typename?: 'EpicPlatformSelectionOptionsForUser', userId: string, selectionOptions: Array<{ __typename?: 'GameAssistantSelectionOption', id: string, type: GameAssistantSelectionOptionType, displayName: string, displayCategory: string | null, slug: string, assetUri: string | null, esportId: string | null, earliestGameOrdinal: number | null, unique: boolean | null }> }> } };

export type UploadSelectionOptionAssetMutationVariables = Exact<{
  esportSlug: Scalars['EsportSlug']['input'];
  file: Scalars['Upload']['input'];
}>;


export type UploadSelectionOptionAssetMutation = { __typename?: 'Mutation', uploadSelectionOptionAsset: { __typename?: 'UploadSelectionOptionAssetPayload', success: boolean, assetUri: string | null } };

export type CreateSelectionOptionMutationVariables = Exact<{
  input: GameAssistantSelectionOptionInsert;
}>;


export type CreateSelectionOptionMutation = { __typename?: 'Mutation', createGameAssistantSelectionOptions: { __typename?: 'GameAssistantSelectionOption', id: string, displayName: string, assetUri: string | null } };

export type RemoveSelectionOptionMutationVariables = Exact<{
  selectionOptionId: Scalars['UUID']['input'];
}>;


export type RemoveSelectionOptionMutation = { __typename?: 'Mutation', removeSelectionOptionById: { __typename?: 'RemoveSelectionOptionPayload', success: boolean } };

export type SettleMatchInfoQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type SettleMatchInfoQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, bestOf: number | null, status: MatchStatus, isSettleable: boolean, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, games: Array<{ __typename?: 'SeriesGame', id: string, status: GameStatus, ordinalNumber: number | null, winningTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null, losingTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null }> | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null }> | null }> } }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, ordinalNumber: number | null, winningTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null, losingTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null }> | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null }> } } | null };

export type CoachSettleMatchInfoQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type CoachSettleMatchInfoQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string }> | null } | null } | null, match: { __typename?: 'Match', id: string, bestOf: number | null, isSettleableByACoach: boolean, scheduledStartsAt: string | null, status: MatchStatus, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType } | null } | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, games: Array<{ __typename?: 'SeriesGame', id: string, status: GameStatus, ordinalNumber: number | null, winningTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null, losingTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null }> | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null }> | null }> } }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, ordinalNumber: number | null, winningTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null, losingTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null }> | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null }> }, matchSettleRequests: Array<{ __typename?: 'MatchSettleRequestModel', id: string }> | null, matchDisputeRequests: Array<{ __typename?: 'MatchDisputeRequest', id: string, status: MatchDisputeStatus, reason: MatchDisputeReason | null, notes: string | null }> | null } | null };

export type GetReportedResultsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  fetchInput: FetchMatchSettleRequestInput;
}>;


export type GetReportedResultsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string }> | null } | null } | null, match: { __typename?: 'Match', id: string, bestOf: number | null, status: MatchStatus, scheduledStartsAt: string | null, esport: { __typename?: 'Esport', id: string, name: string | null }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null }> }, matchSettleRequests: Array<{ __typename?: 'MatchSettleRequestModel', id: string, status: MatchSettleRequestStatus | null, type: MatchSettleRequestType | null, createdAt: string | null, requestedBy: { __typename?: 'User', id: string, name: string | null } | null, team: { __typename?: 'Team', id: string, name: string | null } | null }> | null } | null, fetchMatchSettleRequest: { __typename?: 'MultipleMatchSettleRequestsPayload', success: boolean, errors: Array<string> | null, matchSettleRequest: Array<{ __typename?: 'MatchSettleRequestModel', id: string, createdAt: string | null, updatedAt: string | null, status: MatchSettleRequestStatus | null, type: MatchSettleRequestType | null, incompleteReason: MatchSettleIncompleteReason | null, incompleteNotes: string | null, matchId: string, teamId: string | null, requestedById: string | null, isReadyForReview: boolean | null, forfeitReason: ForfeitReason | null, results: { __typename?: 'MatchSettleRequestResults', seriesResults: Array<{ __typename?: 'SeriesResultRequest', id: string | null, ordinalNumber: number | null, gameResults: Array<{ __typename?: 'GameResultRequest', ordinalNumber: number, losingTeamId: string, incompleteReason: GameIncompleteReason | null, winningTeam: { __typename?: 'Team', id: string, name: string | null } | null, assets: Array<{ __typename?: 'Asset', id: string, fileName: string, signedUrl: string | null }> | null }> }> | null } | null, requestedBy: { __typename?: 'User', id: string, name: string | null } | null, team: { __typename?: 'Team', id: string, name: string | null } | null, match: { __typename?: 'Match', id: string, bestOf: number | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, ordinalNumber: number | null, winningTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null }> | null, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, games: Array<{ __typename?: 'SeriesGame', id: string, status: GameStatus, ordinalNumber: number | null, winningTeam: { __typename?: 'GameTeam', id: string, name: string | null, gameId: string } | null }> | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, name: string | null, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null }> | null }> } }> | null } | null }> | null } };

export type GetDisputeRequestQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetDisputeRequestQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string }> | null } | null } | null, match: { __typename?: 'Match', id: string, bestOf: number | null, status: MatchStatus, scheduledStartsAt: string | null, esport: { __typename?: 'Esport', id: string, name: string | null }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null }> }, matchDisputeRequests: Array<{ __typename?: 'MatchDisputeRequest', id: string, status: MatchDisputeStatus, reason: MatchDisputeReason | null, notes: string | null, createdAt: string | null, asset: { __typename?: 'Asset', id: string, fileName: string, signedUrl: string | null } | null, requestedBy: { __typename?: 'User', id: string, name: string | null } | null, team: { __typename?: 'Team', id: string, name: string | null } | null }> | null } | null };

export type UploadMatchSettleRequestAssetMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadMatchSettleRequestAssetMutation = { __typename?: 'Mutation', uploadMatchSettleRequestAsset: { __typename?: 'Asset', id: string, fileName: string, signedUrl: string | null } };

export type DeleteMatchSettleRequestAssetMutationVariables = Exact<{
  assetId: Scalars['UUID']['input'];
}>;


export type DeleteMatchSettleRequestAssetMutation = { __typename?: 'Mutation', deleteMatchSettleRequestAsset: { __typename?: 'DeletedMatchSettleRequestPayload', success: boolean, deletedMatchSettleRequestId: string } };

export type CreateMatchDisputeRequestMutationVariables = Exact<{
  input: CreateMatchDisputeRequestInput;
}>;


export type CreateMatchDisputeRequestMutation = { __typename?: 'Mutation', createMatchDisputeRequest: { __typename?: 'MatchDisputeRequest', id: string, status: MatchDisputeStatus } };

export type UploadMatchDisputeRequestAssetMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadMatchDisputeRequestAssetMutation = { __typename?: 'Mutation', uploadMatchDisputeRequestAsset: { __typename?: 'Asset', id: string, fileName: string, signedUrl: string | null } };

export type DeleteMatchDisputeRequestAssetMutationVariables = Exact<{
  assetId: Scalars['UUID']['input'];
}>;


export type DeleteMatchDisputeRequestAssetMutation = { __typename?: 'Mutation', deleteMatchDisputeRequestAsset: { __typename?: 'DeleteMatchDisputePayload', success: boolean } };

export type RefetchMatchFragmentFragment = { __typename?: 'Match', id: string, status: MatchStatus, forfeitReason: ForfeitReason | null, autoForfeited: boolean | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, teamSide: number | null, metaseasonId: string | null, team: { __typename?: 'Team', id: string, name: string | null, members: Array<{ __typename?: 'TeamMember', id: string, teamId: string | null, effectiveAt: string | null, name: string | null, avatarUrl: string | null, isCaptain: boolean | null, position: number, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null, createdAt: string | null, updatedAt: string | null }> | null }> | null, leagues: Array<{ __typename?: 'League', id: string }> | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, startsAt: string, metaseason: { __typename?: 'Metaseason', id: string, startsAt: string | null, endsAt: string | null, name: string | null, isPromoted: boolean } | null }> | null } | null }> | null, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, gameResults: Array<{ __typename?: 'GameResult', id: string, teamId: string | null, sidePlayed: number | null, placing: number | null }> | null }> | null };

export type SubmitMatchSettleRequestLiveMutationVariables = Exact<{
  input: SubmitMatchSettleRequestLiveInput;
}>;


export type SubmitMatchSettleRequestLiveMutation = { __typename?: 'Mutation', submitMatchSettleRequestLive: { __typename?: 'SubmitMatchSettleRequestPayload', success: boolean, errors: Array<string> | null, match: { __typename?: 'Match', id: string, status: MatchStatus, forfeitReason: ForfeitReason | null, autoForfeited: boolean | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, teamSide: number | null, metaseasonId: string | null, team: { __typename?: 'Team', id: string, name: string | null, members: Array<{ __typename?: 'TeamMember', id: string, teamId: string | null, effectiveAt: string | null, name: string | null, avatarUrl: string | null, isCaptain: boolean | null, position: number, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null, createdAt: string | null, updatedAt: string | null }> | null }> | null, leagues: Array<{ __typename?: 'League', id: string }> | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, startsAt: string, metaseason: { __typename?: 'Metaseason', id: string, startsAt: string | null, endsAt: string | null, name: string | null, isPromoted: boolean } | null }> | null } | null }> | null, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, gameResults: Array<{ __typename?: 'GameResult', id: string, teamId: string | null, sidePlayed: number | null, placing: number | null }> | null }> | null } | null } };

export type SubmitAdminMatchSettleRequestLiveMutationVariables = Exact<{
  input: SubmitAdminMatchSettleRequestLiveInput;
}>;


export type SubmitAdminMatchSettleRequestLiveMutation = { __typename?: 'Mutation', submitAdminMatchSettleRequestLive: { __typename?: 'SubmitMatchSettleRequestPayload', success: boolean, errors: Array<string> | null, match: { __typename?: 'Match', id: string, status: MatchStatus, forfeitReason: ForfeitReason | null, autoForfeited: boolean | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, teamSide: number | null, metaseasonId: string | null, team: { __typename?: 'Team', id: string, name: string | null, members: Array<{ __typename?: 'TeamMember', id: string, teamId: string | null, effectiveAt: string | null, name: string | null, avatarUrl: string | null, isCaptain: boolean | null, position: number, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null, createdAt: string | null, updatedAt: string | null }> | null }> | null, leagues: Array<{ __typename?: 'League', id: string }> | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, startsAt: string, metaseason: { __typename?: 'Metaseason', id: string, startsAt: string | null, endsAt: string | null, name: string | null, isPromoted: boolean } | null }> | null } | null }> | null, series: Array<{ __typename?: 'Series', id: string, bestOf: number | null, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, roster: Array<{ __typename?: 'SeriesPlayer', id: string, name: string | null, avatarUrl: string | null, publisherAccountName: string | null }> | null }> } }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, gameResults: Array<{ __typename?: 'GameResult', id: string, teamId: string | null, sidePlayed: number | null, placing: number | null }> | null }> | null } | null } };

export type MatchSettleRequestSubmittedSubscriptionVariables = Exact<{
  input?: InputMaybe<MatchSettleRequestSubmittedSubscribeInput>;
}>;


export type MatchSettleRequestSubmittedSubscription = { __typename?: 'Subscription', matchSettleRequestSubmitted: { __typename?: 'SubmitMatchSettleRequestPayload', success: boolean, errors: Array<string> | null } | null };

export type DeleteSlotExclusionWindowMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteSlotExclusionWindowMutation = { __typename?: 'Mutation', deleteSlotExclusionWindow: { __typename?: 'SlotExclusionWindowMutationPayload', slotExclusionWindow: { __typename?: 'SlotExclusionWindow', id: string } } };

export type CreateSlotExclusionWindowMutationVariables = Exact<{
  input: SlotExclusionWindowInput;
}>;


export type CreateSlotExclusionWindowMutation = { __typename?: 'Mutation', createSlotExclusionWindow: { __typename?: 'SlotExclusionWindowMutationPayload', slotExclusionWindow: { __typename?: 'SlotExclusionWindow', id: string, hash: string, resourceId: string, resourceType: SlotExclusionWindowResourceType, seasonId: string | null, createdAt: string, updatedAt: string | null, startsAt: string | null, endsAt: string | null } } };

export type UpdateSlotExclusionWindowMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  attributes: SlotExclusionWindowAttributes;
}>;


export type UpdateSlotExclusionWindowMutation = { __typename?: 'Mutation', updateSlotExclusionWindow: { __typename?: 'UpdateSlotExclusionWindowPayload', slotExclusionWindow: { __typename?: 'SlotExclusionWindow', id: string } | null } };

export type SlotExclusionRangeConfigurationsQueryVariables = Exact<{
  input: FindSlotExclusionRangeConfigurationsInput;
}>;


export type SlotExclusionRangeConfigurationsQuery = { __typename?: 'Query', slotExclusionRangeConfigurations: { __typename?: 'SlotExclusionRangeConfigurationsResult', results: Array<{ __typename?: 'SlotExclusionRangeConfiguration', id: string, minSlotExclusions: number, maxSlotExclusions: number, defaultsAppliedAt: string, range: { __typename?: 'DateRange', startsAt: string, endsAt: string }, suggestions: Array<{ __typename?: 'SlotExclusionWindowSuggestion', isDefault: boolean, template: { __typename?: 'SlotExclusionWindowTemplate', startsAt: string | null, endsAt: string | null, hash: string } }>, defaults: Array<{ __typename?: 'SlotExclusionRangeDefaultWindow', startsAt: string, endsAt: string }> }> } };

export type CreateSlotExclusionRangeConfigurationMutationVariables = Exact<{
  input: CreateSlotExclusionRangeConfigurationInput;
}>;


export type CreateSlotExclusionRangeConfigurationMutation = { __typename?: 'Mutation', createSlotExclusionRangeConfiguration: { __typename?: 'CreateSlotExclusionRangeConfigurationResult', configuration: { __typename?: 'SlotExclusionRangeConfiguration', id: string, minSlotExclusions: number, maxSlotExclusions: number, defaultsAppliedAt: string, range: { __typename?: 'DateRange', startsAt: string, endsAt: string }, suggestions: Array<{ __typename?: 'SlotExclusionWindowSuggestion', isDefault: boolean, template: { __typename?: 'SlotExclusionWindowTemplate', startsAt: string | null, endsAt: string | null, hash: string } }>, defaults: Array<{ __typename?: 'SlotExclusionRangeDefaultWindow', startsAt: string, endsAt: string }> } } };

export type UpdateSlotExclusionRangeConfigurationMutationVariables = Exact<{
  input: UpdateSlotExclusionRangeConfigurationInput;
}>;


export type UpdateSlotExclusionRangeConfigurationMutation = { __typename?: 'Mutation', updateSlotExclusionRangeConfiguration: { __typename?: 'UpdateSlotExclusionRangeConfigurationResult', configuration: { __typename?: 'SlotExclusionRangeConfiguration', id: string, minSlotExclusions: number, maxSlotExclusions: number, defaultsAppliedAt: string, range: { __typename?: 'DateRange', startsAt: string, endsAt: string }, suggestions: Array<{ __typename?: 'SlotExclusionWindowSuggestion', isDefault: boolean, template: { __typename?: 'SlotExclusionWindowTemplate', startsAt: string | null, endsAt: string | null, hash: string } }>, defaults: Array<{ __typename?: 'SlotExclusionRangeDefaultWindow', startsAt: string, endsAt: string }> } } };

export type GetTeamSlotExclusionWindowsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTeamSlotExclusionWindowsQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, slotExclusionWindows: Array<{ __typename?: 'SlotExclusionWindow', id: string, resourceType: SlotExclusionWindowResourceType, resourceId: string, startsAt: string | null, endsAt: string | null }> | null } | null };

export type SetSlotExclusionRangeDefaultWindowsMutationVariables = Exact<{
  input: SetSlotExclusionRangeDefaultWindowsInput;
}>;


export type SetSlotExclusionRangeDefaultWindowsMutation = { __typename?: 'Mutation', setSlotExclusionRangeDefaultWindows: { __typename?: 'SetSlotExclusionRangeDefaultWindowsPayload', success: boolean, slotExclusionRangeDefaultWindowsIds: Array<string | null> | null } };

export type LeagueSeasonSlotExclusionWindowQueryVariables = Exact<{
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type LeagueSeasonSlotExclusionWindowQuery = { __typename?: 'Query', league: { __typename?: 'League', id: string, seasonByMetaseasonId: { __typename?: 'Season', slotExclusionRangeConfigurations: Array<{ __typename?: 'SlotExclusionRangeConfiguration', id: string, maxSlotExclusions: number, range: { __typename?: 'DateRange', startsAt: string, endsAt: string } }> | null } | null } | null };

export type SlotLobbyStatusQueryVariables = Exact<{
  slotId: Scalars['UUID']['input'];
}>;


export type SlotLobbyStatusQuery = { __typename?: 'Query', slotLobbyStatus: { __typename?: 'SlotLobbyStatusPayload', id: string | null, status: SlotLobbyStatus | null, success: boolean, errors: Array<{ __typename?: 'GetSlotLobbyError', message: string }> | null, details: { __typename?: 'ClosedSlotLobbyDetails', lobbyClosedAt: string | null } | { __typename?: 'OpenSlotLobbyDetails', nextPairingAt: string | null, lobbyClosesAt: string | null } | { __typename?: 'UnopenedSlotLobbyDetails', lobbyOpensAt: string | null } | null } };

export type GetSlotsForSeasonQueryVariables = Exact<{
  seasonId: Scalars['UUID']['input'];
}>;


export type GetSlotsForSeasonQuery = { __typename?: 'Query', season: { __typename?: 'Season', id: string, phases: Array<{ __typename?: 'Phase', id: string, slots: Array<{ __typename?: 'Slot', id: string, bestOf: number | null, order: number | null, startsAt: string | null, status: SlotStatus, phase: { __typename?: 'Phase', id: string, name: string | null, bestOf: number | null } | null }> | null }> | null } | null };

export type GetSlotQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSlotQuery = { __typename?: 'Query', slot: { __typename?: 'Slot', id: string, name: string | null, status: SlotStatus, bestOf: number | null, seriesBestOf: number | null, scheduleMatchesAt: string | null, startsAt: string | null, isStartsAtHidden: boolean | null, fortniteEventWindowId: string | null, phase: { __typename?: 'Phase', id: string, type: PhaseType } | null } | null };

export type SlotTimezoneQueryVariables = Exact<{
  slotId: Scalars['UUID']['input'];
}>;


export type SlotTimezoneQuery = { __typename?: 'Query', slot: { __typename?: 'Slot', id: string, timezone: string | null } | null };

export type RescheduleSlotMutationVariables = Exact<{
  input: RescheduleSlotInput;
}>;


export type RescheduleSlotMutation = { __typename?: 'Mutation', rescheduleSlot: { __typename?: 'SlotPayload', success: boolean, slot: { __typename?: 'Slot', id: string, startsAt: string | null, scheduleMatchesAt: string | null } | null } };

export type CreateBracketSlotsMutationVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
}>;


export type CreateBracketSlotsMutation = { __typename?: 'Mutation', createBracketSlots: Array<{ __typename?: 'Slot', id: string }> };

export type CreateSlotMutationVariables = Exact<{
  input: CreateSlotInput;
}>;


export type CreateSlotMutation = { __typename?: 'Mutation', createSlot: { __typename?: 'CreateSlotPayload', slot: { __typename?: 'Slot', id: string } } };

export type UpdateSlotMutationVariables = Exact<{
  input: UpdateSlotInput;
}>;


export type UpdateSlotMutation = { __typename?: 'Mutation', updateSlot: { __typename?: 'UpdateSlotPayload', slot: { __typename?: 'Slot', id: string } } };

export type CancelSlotMutationVariables = Exact<{
  input: CancelSlotInput;
}>;


export type CancelSlotMutation = { __typename?: 'Mutation', cancelSlot: { __typename?: 'DeleteSlotPayload', success: boolean } };

export type SponsorshipImagesQueryVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  entityType: SponsorshipEntityType;
}>;


export type SponsorshipImagesQuery = { __typename?: 'Query', sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, url: string, updatedAt: string }> };

export type SeasonSponsorshipImagesQueryVariables = Exact<{
  seasonId: Scalars['UUID']['input'];
}>;


export type SeasonSponsorshipImagesQuery = { __typename?: 'Query', season: { __typename?: 'Season', id: string, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, url: string, updatedAt: string }> | null } | null };

export type SponsorshipCampaignsQueryVariables = Exact<{
  input: SponsorshipCampaignSearchInput;
}>;


export type SponsorshipCampaignsQuery = { __typename?: 'Query', sponsorshipCampaigns: { __typename?: 'SponsorshipCampaignsResult', total: number | null, result: Array<{ __typename?: 'SponsorshipCampaign', id: string, title: string, startDate: string, endDate: string | null, status: SponsorshipCampaignStatus, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, url: string, updatedAt: string }> | null }> | null } };

export type SponsorshipCampaignQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SponsorshipCampaignQuery = { __typename?: 'Query', sponsorshipCampaign: { __typename?: 'SponsorshipCampaign', id: string, partnerId: string | null, title: string, startDate: string, endDate: string | null, status: SponsorshipCampaignStatus, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, url: string, updatedAt: string }> | null, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, url: string, updatedAt: string }> | null }> | null, schools: Array<{ __typename?: 'School', id: string, name: string | null }> | null } };

export type UploadSponsorshipImageMutationVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  entityType: SponsorshipEntityType;
  name: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
}>;


export type UploadSponsorshipImageMutation = { __typename?: 'Mutation', uploadSponsorshipImage: { __typename?: 'SponsorshipImage', id: string, url: string } };

export type RemoveSponsorshipImageMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RemoveSponsorshipImageMutation = { __typename?: 'Mutation', removeSponsorshipImage: { __typename?: 'SponsorshipRemovePayload', success: boolean } };

export type UpsertSponsorshipImageMutationVariables = Exact<{
  entityId: Scalars['UUID']['input'];
  entityType: SponsorshipEntityType;
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
}>;


export type UpsertSponsorshipImageMutation = { __typename?: 'Mutation', upsertSponsorshipImage: { __typename?: 'SponsorshipImage', id: string, url: string } };

export type CreateSponsorshipCampaignMutationVariables = Exact<{
  input: SponsorshipCampaignInput;
}>;


export type CreateSponsorshipCampaignMutation = { __typename?: 'Mutation', createSponsorshipCampaign: { __typename?: 'SponsorshipCampaign', id: string, partnerId: string | null, title: string, startDate: string, endDate: string | null, status: SponsorshipCampaignStatus, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, url: string, updatedAt: string }> | null } };

export type UpdateSponsorshipCampaignMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: SponsorshipCampaignUpdateInput;
}>;


export type UpdateSponsorshipCampaignMutation = { __typename?: 'Mutation', updateSponsorshipCampaign: { __typename?: 'SponsorshipCampaign', id: string, partnerId: string | null, title: string, startDate: string, endDate: string | null, status: SponsorshipCampaignStatus, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, url: string, updatedAt: string }> | null } };

export type DeleteSponsorshipCampaignMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteSponsorshipCampaignMutation = { __typename?: 'Mutation', deleteSponsorshipCampaign: { __typename?: 'DeleteSponsorshipCampaignPayload', success: boolean } };

export type SetSchoolsForCampaignMutationVariables = Exact<{
  input: SetSponsorshipCampaignSchoolsInput;
}>;


export type SetSchoolsForCampaignMutation = { __typename?: 'Mutation', setSchoolsForCampaign: { __typename?: 'SetSponsorshipCampaignSchoolsPayload', success: boolean } };

export type CreateSponsorshipComponentMutationVariables = Exact<{
  input: SponsorshipComponentInput;
}>;


export type CreateSponsorshipComponentMutation = { __typename?: 'Mutation', createSponsorshipComponent: { __typename?: 'SponsorshipComponent', id: string } };

export type UpdateSponsorshipComponentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: SponsorshipComponentUpdateInput;
}>;


export type UpdateSponsorshipComponentMutation = { __typename?: 'Mutation', updateSponsorshipComponent: { __typename?: 'SponsorshipComponent', id: string } };

export type GetMatchDataForActionAndInfoSectionQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchDataForActionAndInfoSectionQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, scheduledStartsAt: string | null, bestOf: number | null, isScrimmage: boolean | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, isMyTeam: boolean | null }> }, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', id: string, proposedTimes: Array<string> | null, status: MatchRescheduleRequestStatus | null, teamId: string, matchId: string }> | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType } | null } | null } | null };

export type GetMatchRescheduleRequestDataForMenuQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchRescheduleRequestDataForMenuQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, matchRescheduleRequests: Array<{ __typename?: 'MatchRescheduleRequest', id: string, status: MatchRescheduleRequestStatus | null, teamId: string, matchId: string, rescheduleNotes: string | null }> | null } | null };

export type GetMatchFormatByUuidQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchFormatByUuidQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, format: MatchFormat | null } | null };

export type GetTopLevelMatchDataQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetTopLevelMatchDataQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, isScrimmage: boolean | null, scheduledStartsAt: string | null, matchAssistantEnabled: boolean | null, bestOf: number | null, seriesBestOf: number | null, winningTeamId: string | null, team1Score: number | null, team2Score: number | null, format: MatchFormat | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, format: PhaseFormat } | null } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating }, teamContext: { __typename?: 'MatchTeamContext', matchId: string, myTeams: Array<{ __typename?: 'MatchTeam', id: string, schoolId: string | null, name: string | null, avatarUrl: string | null, competitionGroup: CompetitionGroup | null, school: { __typename?: 'School', id: string, name: string | null, slug: string | null } | null }>, otherTeams: Array<{ __typename?: 'MatchTeam', id: string, schoolId: string | null, name: string | null, avatarUrl: string | null, competitionGroup: CompetitionGroup | null, school: { __typename?: 'School', id: string, name: string | null, slug: string | null } | null }>, teams: Array<{ __typename?: 'MatchTeam', isMyTeam: boolean | null, id: string, competitionGroup: CompetitionGroup | null, name: string | null, avatarUrl: string | null, schoolId: string | null, school: { __typename?: 'School', id: string, name: string | null, slug: string | null } | null }> }, league: { __typename?: 'League', sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null } | null };

export type GetOnMatchQueueRedirectDataQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetOnMatchQueueRedirectDataQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, matchResults: Array<{ __typename?: 'MatchResult', id: string, placing: number | null, teamId: string | null }> | null } | null };

export type GetMatchPhaseTypeAndScheduleStartsAtQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchPhaseTypeAndScheduleStartsAtQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, scheduledStartsAt: string | null, isScrimmage: boolean | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, gameResults: Array<{ __typename?: 'GameResult', id: string, placing: number | null, teamId: string | null }> | null }> | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType, season: { __typename?: 'Season', id: string, name: string } | null } | null } | null } | null };

export type GetDataForMatchFaceoffSeriesQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetDataForMatchFaceoffSeriesQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, series: Array<{ __typename?: 'Series', id: string, teamContext: { __typename?: 'SeriesTeamContext', seriesId: string, teams: Array<{ __typename?: 'SeriesTeam', id: string, seriesId: string, result: { __typename?: 'SeriesResult', id: string, placing: number | null } | null }> } }> | null } | null };

export type GetCurrentStepGamesScoreQueryVariables = Exact<{
  input: CurrentGameAssistantStateInput;
}>;


export type GetCurrentStepGamesScoreQuery = { __typename?: 'Query', currentGameAssistantStateByMatchId: { __typename?: 'GameAssistantStatePayload', matchDetails: { __typename?: 'GameAssistantMatchDetails', games: Array<{ __typename?: 'GameAssistantGameDetails', scores: Array<{ __typename?: 'GameAssistantTeamScore', teamId: string, score: number }> | null }> | null } | null } };

export type GetMatchScoreForHeaderQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
  includeHeadToHead: Scalars['Boolean']['input'];
}>;


export type GetMatchScoreForHeaderQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, winningTeamId: string | null, status: MatchStatus, matchResults?: Array<{ __typename?: 'MatchResult', id: string, teamId: string | null, teamSide: number | null }> | null, headToHeadMatchScores?: { __typename?: 'HeadToHeadMatchTeamScores', matchId: string, team1Score: number | null, team2Score: number | null } | null, teamContext?: { __typename?: 'MatchTeamContext', matchId: string, myTeamMatchResults: Array<{ __typename?: 'MatchResult', id: string, placing: number | null }>, otherTeamMatchResults: Array<{ __typename?: 'MatchResult', id: string, placing: number | null }> } } | null };

export type GetMatchPhaseQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchPhaseQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, type: PhaseType } | null } | null } | null };

export type GetMatchRostersContainerDataQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchRostersContainerDataQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, metaseasonId: string | null, scheduledStartsAt: string | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string, season: { __typename?: 'Season', id: string } | null } | null } | null, teamContext: { __typename?: 'MatchTeamContext', matchId: string, myTeams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, competitionGroup: CompetitionGroup | null, deletedAt: string | null, isMyTeam: boolean | null, regularSeasonTeamPhaseStandings: { __typename?: 'TeamRegSeasonPhaseStandings', ranking: number | null, hasClinchedPlayoffs: boolean | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number } | null } | null }>, teams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, competitionGroup: CompetitionGroup | null, deletedAt: string | null, isMyTeam: boolean | null, regularSeasonTeamPhaseStandings: { __typename?: 'TeamRegSeasonPhaseStandings', ranking: number | null, hasClinchedPlayoffs: boolean | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number } | null } | null }>, otherTeams: Array<{ __typename?: 'MatchTeam', id: string, name: string | null, competitionGroup: CompetitionGroup | null, deletedAt: string | null, isMyTeam: boolean | null, regularSeasonTeamPhaseStandings: { __typename?: 'TeamRegSeasonPhaseStandings', ranking: number | null, hasClinchedPlayoffs: boolean | null, winLossRecord: { __typename?: 'WinLossRecord', matchesWon: number, matchesLost: number } | null } | null }> } } | null };

export type RegisterUserWithUsernameMutationVariables = Exact<{
  input: RegisterUserWithUsernameInput;
  options: RegisterUserOptions;
}>;


export type RegisterUserWithUsernameMutation = { __typename?: 'Mutation', registerUserWithUsername: { __typename?: 'RegisterUserResponse', user: { __typename?: 'User', id: string, email: string | null, username: string | null } } };

export type EventSeasonFragment = { __typename?: 'Season', id: string, name: string, startsAt: string, teamRegistrationEndsAt: string | null, endsAt: string, suggestedRegistrationEndsAt: string | null, rostersLockAt: string | null, numberOfPlayers: number | null, numberOfTeams: number | null, leagueId: string, eventConfig: { __typename?: 'EventConfig', maxTeamsAllowed: number | null, eventBestOf: number | null } | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null, activePhases: Array<{ __typename?: 'Phase', id: string, status: PhaseStatus, startsAt: string, endsAt: string, format: PhaseFormat, name: string | null, type: PhaseType, bracketSize: number | null, slots: Array<{ __typename?: 'Slot', id: string, label: SlotLabel | null, name: string | null, isStartsAtHidden: boolean | null, startsAt: string | null, order: number | null, ordinal: number | null }> | null }> | null, currentPhase: { __typename?: 'Phase', id: string, startsAt: string, endsAt: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, name: string | null }> | null } | null, league: { __typename?: 'League', id: string, teamFormat: number, teamMaxSize: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, details: { __typename?: 'EsportDetails', platforms: Array<Platform> | null, gameType: string | null, abbreviation: string | null, esportId: string } | null }, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null };

export type UserSeasonResultsFragment = { __typename?: 'UserSeasonsResult', seasons: Array<{ __typename?: 'Season', id: string, name: string, startsAt: string, teamRegistrationEndsAt: string | null, endsAt: string, suggestedRegistrationEndsAt: string | null, rostersLockAt: string | null, numberOfPlayers: number | null, numberOfTeams: number | null, leagueId: string, eventConfig: { __typename?: 'EventConfig', maxTeamsAllowed: number | null, eventBestOf: number | null } | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null, activePhases: Array<{ __typename?: 'Phase', id: string, status: PhaseStatus, startsAt: string, endsAt: string, format: PhaseFormat, name: string | null, type: PhaseType, bracketSize: number | null, slots: Array<{ __typename?: 'Slot', id: string, label: SlotLabel | null, name: string | null, isStartsAtHidden: boolean | null, startsAt: string | null, order: number | null, ordinal: number | null }> | null }> | null, currentPhase: { __typename?: 'Phase', id: string, startsAt: string, endsAt: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, name: string | null }> | null } | null, league: { __typename?: 'League', id: string, teamFormat: number, teamMaxSize: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, details: { __typename?: 'EsportDetails', platforms: Array<Platform> | null, gameType: string | null, abbreviation: string | null, esportId: string } | null }, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null } | null> | null };

export type GetUserEventSeasonsQueryVariables = Exact<{
  esportId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetUserEventSeasonsQuery = { __typename?: 'Query', listUserSeasons: { __typename?: 'ListUserSeasonsResult', upcomingSeasons: { __typename?: 'UserSeasonsResult', seasons: Array<{ __typename?: 'Season', id: string, name: string, startsAt: string, teamRegistrationEndsAt: string | null, endsAt: string, suggestedRegistrationEndsAt: string | null, rostersLockAt: string | null, numberOfPlayers: number | null, numberOfTeams: number | null, leagueId: string, eventConfig: { __typename?: 'EventConfig', maxTeamsAllowed: number | null, eventBestOf: number | null } | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null, activePhases: Array<{ __typename?: 'Phase', id: string, status: PhaseStatus, startsAt: string, endsAt: string, format: PhaseFormat, name: string | null, type: PhaseType, bracketSize: number | null, slots: Array<{ __typename?: 'Slot', id: string, label: SlotLabel | null, name: string | null, isStartsAtHidden: boolean | null, startsAt: string | null, order: number | null, ordinal: number | null }> | null }> | null, currentPhase: { __typename?: 'Phase', id: string, startsAt: string, endsAt: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, name: string | null }> | null } | null, league: { __typename?: 'League', id: string, teamFormat: number, teamMaxSize: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, details: { __typename?: 'EsportDetails', platforms: Array<Platform> | null, gameType: string | null, abbreviation: string | null, esportId: string } | null }, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null } | null> | null }, ongoingSeasons: { __typename?: 'UserSeasonsResult', seasons: Array<{ __typename?: 'Season', id: string, name: string, startsAt: string, teamRegistrationEndsAt: string | null, endsAt: string, suggestedRegistrationEndsAt: string | null, rostersLockAt: string | null, numberOfPlayers: number | null, numberOfTeams: number | null, leagueId: string, eventConfig: { __typename?: 'EventConfig', maxTeamsAllowed: number | null, eventBestOf: number | null } | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null, activePhases: Array<{ __typename?: 'Phase', id: string, status: PhaseStatus, startsAt: string, endsAt: string, format: PhaseFormat, name: string | null, type: PhaseType, bracketSize: number | null, slots: Array<{ __typename?: 'Slot', id: string, label: SlotLabel | null, name: string | null, isStartsAtHidden: boolean | null, startsAt: string | null, order: number | null, ordinal: number | null }> | null }> | null, currentPhase: { __typename?: 'Phase', id: string, startsAt: string, endsAt: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, name: string | null }> | null } | null, league: { __typename?: 'League', id: string, teamFormat: number, teamMaxSize: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, details: { __typename?: 'EsportDetails', platforms: Array<Platform> | null, gameType: string | null, abbreviation: string | null, esportId: string } | null }, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null } | null> | null }, enrolledSeasons: { __typename?: 'UserSeasonsResult', seasons: Array<{ __typename?: 'Season', id: string, name: string, startsAt: string, teamRegistrationEndsAt: string | null, endsAt: string, suggestedRegistrationEndsAt: string | null, rostersLockAt: string | null, numberOfPlayers: number | null, numberOfTeams: number | null, leagueId: string, eventConfig: { __typename?: 'EventConfig', maxTeamsAllowed: number | null, eventBestOf: number | null } | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null, activePhases: Array<{ __typename?: 'Phase', id: string, status: PhaseStatus, startsAt: string, endsAt: string, format: PhaseFormat, name: string | null, type: PhaseType, bracketSize: number | null, slots: Array<{ __typename?: 'Slot', id: string, label: SlotLabel | null, name: string | null, isStartsAtHidden: boolean | null, startsAt: string | null, order: number | null, ordinal: number | null }> | null }> | null, currentPhase: { __typename?: 'Phase', id: string, startsAt: string, endsAt: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, name: string | null }> | null } | null, league: { __typename?: 'League', id: string, teamFormat: number, teamMaxSize: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, details: { __typename?: 'EsportDetails', platforms: Array<Platform> | null, gameType: string | null, abbreviation: string | null, esportId: string } | null }, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null } | null> | null }, pastSeasons: { __typename?: 'UserSeasonsResult', seasons: Array<{ __typename?: 'Season', id: string, name: string, startsAt: string, teamRegistrationEndsAt: string | null, endsAt: string, suggestedRegistrationEndsAt: string | null, rostersLockAt: string | null, numberOfPlayers: number | null, numberOfTeams: number | null, leagueId: string, eventConfig: { __typename?: 'EventConfig', maxTeamsAllowed: number | null, eventBestOf: number | null } | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null, activePhases: Array<{ __typename?: 'Phase', id: string, status: PhaseStatus, startsAt: string, endsAt: string, format: PhaseFormat, name: string | null, type: PhaseType, bracketSize: number | null, slots: Array<{ __typename?: 'Slot', id: string, label: SlotLabel | null, name: string | null, isStartsAtHidden: boolean | null, startsAt: string | null, order: number | null, ordinal: number | null }> | null }> | null, currentPhase: { __typename?: 'Phase', id: string, startsAt: string, endsAt: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, name: string | null }> | null } | null, league: { __typename?: 'League', id: string, teamFormat: number, teamMaxSize: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, details: { __typename?: 'EsportDetails', platforms: Array<Platform> | null, gameType: string | null, abbreviation: string | null, esportId: string } | null }, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null } | null> | null } } };

export type EventSeasonWithConfigFragment = { __typename?: 'Season', id: string, name: string, startsAt: string, teamRegistrationEndsAt: string | null, endsAt: string, suggestedRegistrationEndsAt: string | null, rostersLockAt: string | null, numberOfPlayers: number | null, numberOfTeams: number | null, leagueId: string, eventConfig: { __typename?: 'EventConfig', id: string, seasonId: string, eventDetails: string | null, prizeDetails: string | null, minAge: number | null, maxAge: number | null, maxTeamsAllowed: number | null, eventBestOf: number | null, eventStatus: EventStatus | null, surveyId: string | null } | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null, activePhases: Array<{ __typename?: 'Phase', id: string, status: PhaseStatus, startsAt: string, endsAt: string, format: PhaseFormat, name: string | null, type: PhaseType, bracketSize: number | null, slots: Array<{ __typename?: 'Slot', id: string, label: SlotLabel | null, name: string | null, isStartsAtHidden: boolean | null, startsAt: string | null, order: number | null, ordinal: number | null }> | null }> | null, currentPhase: { __typename?: 'Phase', id: string, startsAt: string, endsAt: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, name: string | null }> | null } | null, league: { __typename?: 'League', id: string, teamFormat: number, teamMaxSize: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, details: { __typename?: 'EsportDetails', platforms: Array<Platform> | null, gameType: string | null, abbreviation: string | null, esportId: string } | null }, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null };

export type EventSeasonTeamWithConfigFragment = { __typename?: 'Season', id: string, name: string, startsAt: string, teamRegistrationEndsAt: string | null, endsAt: string, suggestedRegistrationEndsAt: string | null, rostersLockAt: string | null, numberOfPlayers: number | null, numberOfTeams: number | null, leagueId: string, eventConfig: { __typename?: 'EventConfig', maxTeamsAllowed: number | null, eventBestOf: number | null, isUserAbleToJoinEvent: { __typename?: 'IsUserAbleToJoinEventResponse', result: boolean, reason: UserUnableToJoinEventReason | null } | null, userEventTeam: { __typename?: 'Team', id: string, name: string | null, avatarUrl: string | null, roster: { __typename?: 'TeamRoster', id: string, formats: Array<{ __typename?: 'TeamRosterFormat', starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', effectiveAt: string, user: { __typename?: 'User', id: string } } | null, position: { __typename?: 'EsportPosition', id: string, index: number } }> }> } | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string }> | null } | null } | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null, activePhases: Array<{ __typename?: 'Phase', id: string, status: PhaseStatus, startsAt: string, endsAt: string, format: PhaseFormat, name: string | null, type: PhaseType, bracketSize: number | null, slots: Array<{ __typename?: 'Slot', id: string, label: SlotLabel | null, name: string | null, isStartsAtHidden: boolean | null, startsAt: string | null, order: number | null, ordinal: number | null }> | null }> | null, currentPhase: { __typename?: 'Phase', id: string, startsAt: string, endsAt: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, name: string | null }> | null } | null, league: { __typename?: 'League', id: string, teamFormat: number, teamMaxSize: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, details: { __typename?: 'EsportDetails', platforms: Array<Platform> | null, gameType: string | null, abbreviation: string | null, esportId: string } | null }, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null };

export type GetEventSeasonQueryVariables = Exact<{
  seasonId: Scalars['UUID']['input'];
  isSignedIn: Scalars['Boolean']['input'];
}>;


export type GetEventSeasonQuery = { __typename?: 'Query', season: { __typename?: 'Season', id: string, name: string, startsAt: string, teamRegistrationEndsAt: string | null, endsAt: string, suggestedRegistrationEndsAt: string | null, rostersLockAt: string | null, numberOfPlayers: number | null, numberOfTeams: number | null, leagueId: string, eventConfig: { __typename?: 'EventConfig', id: string, seasonId: string, eventDetails: string | null, prizeDetails: string | null, minAge: number | null, maxAge: number | null, maxTeamsAllowed: number | null, eventBestOf: number | null, eventStatus: EventStatus | null, surveyId: string | null, isUserAbleToJoinEvent: { __typename?: 'IsUserAbleToJoinEventResponse', result: boolean, reason: UserUnableToJoinEventReason | null } | null, userEventTeam: { __typename?: 'Team', id: string, name: string | null, avatarUrl: string | null, roster: { __typename?: 'TeamRoster', id: string, formats: Array<{ __typename?: 'TeamRosterFormat', starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', effectiveAt: string, user: { __typename?: 'User', id: string } } | null, position: { __typename?: 'EsportPosition', id: string, index: number } }> }> } | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string }> | null } | null } | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, endsAt: string | null, isPromoted: boolean } | null, activePhases: Array<{ __typename?: 'Phase', id: string, status: PhaseStatus, startsAt: string, endsAt: string, format: PhaseFormat, name: string | null, type: PhaseType, bracketSize: number | null, slots: Array<{ __typename?: 'Slot', id: string, label: SlotLabel | null, name: string | null, isStartsAtHidden: boolean | null, startsAt: string | null, order: number | null, ordinal: number | null }> | null }> | null, currentPhase: { __typename?: 'Phase', id: string, startsAt: string, endsAt: string, type: PhaseType, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, name: string | null }> | null } | null, league: { __typename?: 'League', id: string, teamFormat: number, teamMaxSize: number, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, details: { __typename?: 'EsportDetails', platforms: Array<Platform> | null, gameType: string | null, abbreviation: string | null, esportId: string } | null }, sponsorshipComponents: Array<{ __typename?: 'SponsorshipComponent', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, title: string | null, subtitle: string | null, url: string | null, callToAction: string | null, sponsorshipImages: Array<{ __typename?: 'SponsorshipImage', id: string, entityId: string, entityType: SponsorshipEntityType, name: string, updatedAt: string, url: string }> | null }> | null } | null } | null };

export type GetMyEventsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyEventsDataQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, dateOfBirth: string | null, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isVerified: boolean | null }> | null } | null };

export type GetTeamAvatarQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTeamAvatarQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, avatarUrl: string | null } | null };

export type CreateTeamForEventMutationVariables = Exact<{
  input: CreateTeamForEventInput;
}>;


export type CreateTeamForEventMutation = { __typename?: 'Mutation', createTeamForEvent: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, name: string | null, eventSeasonId: string | null, createdByUser: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceId: string, resourceType: ResourceType, status: UserRoleStatusName }> | null } | null } } };

export type UploadTeamAvatarMutationVariables = Exact<{
  input: UploadTeamAvatarInput;
}>;


export type UploadTeamAvatarMutation = { __typename?: 'Mutation', uploadTeamAvatar: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, avatarUrl: string | null } } };

export type DeleteStadiumTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type DeleteStadiumTeamMutation = { __typename?: 'Mutation', deleteStadiumTeam: { __typename?: 'DeleteTeamPayload', success: boolean, deletedTeamId: string } };

export type SchoolEnrollableSeasonsQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SchoolEnrollableSeasonsQuery = { __typename?: 'Query', schoolEnrollableSeasons: { __typename?: 'SchoolEnrollableSeasonsPayload', seasons: Array<{ __typename?: 'Season', id: string, leagueId: string, teamRegistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null, rostersLockAt: string | null, league: { __typename?: 'League', id: string, displayName: string | null, name: string | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug } } | null }> } };

export type GetPhaseResultsQueryVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
}>;


export type GetPhaseResultsQuery = { __typename?: 'Query', phase: { __typename?: 'Phase', id: string, name: string | null, type: PhaseType, startsAt: string, phaseResults: Array<{ __typename?: 'PhaseResult', id: string, phaseTiebreakerPoints: number, gamesWon: number, gamesLost: number, matchesWon: number, matchesLost: number, seriesWon: number | null, seriesLost: number | null, cumulativeScore: number | null, cumulativeScoreOfOpposition: number | null, hasClinchedPlayoffs: boolean, avgPlacement: number | null, numOfFirstPlace: number | null, numOfTopFourPlace: number | null, rankingPoints: number, team: { __typename?: 'Team', id: string, name: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating }, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null } | null } | null, record: { __typename?: 'PhaseRecord', won: number, lost: number, streak: number, winPercentage: number | null, compoundRankingScore: number | null } | null }> | null } | null };

export type GetSeasonStandingsColumnsQueryVariables = Exact<{
  seasonId: Scalars['UUID']['input'];
}>;


export type GetSeasonStandingsColumnsQuery = { __typename?: 'Query', season: { __typename?: 'Season', id: string, playvsScoreEnabled: boolean } | null };

export type FnTeamMatchStandingsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  phaseId: Scalars['UUID']['input'];
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type FnTeamMatchStandingsQuery = { __typename?: 'Query', phase: { __typename?: 'Phase', id: string, season: { __typename?: 'Season', id: string, metaseasonId: string | null } | null, slots: Array<{ __typename?: 'Slot', id: string, order: number | null, name: string | null, matches: Array<{ __typename?: 'Match', id: string, status: MatchStatus, fortniteTeamMatchStats: { __typename?: 'FortniteTeamMatchStatsResult', updatedAt: string | null, total: number | null, leaderboard: Array<{ __typename?: 'TeamMatchStats', team: { __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null, state: string | null } | null } | null, stats: { __typename?: 'FortniteTeamMatchStats', id: string, rank: number, clutched: boolean | null, totalPoints: number, placementPoints: number, eliminationPoints: number, totalSecondsSurvived: number, avgPointsPerSession: number, avgPlacementPerSession: number, avgEliminationsPerSession: number, sessionsPlayed: number } | { __typename?: 'LeagueOfLegendsTeamMatchStats' } | { __typename?: 'RocketLeagueTeamMatchStats' } | { __typename?: 'SmiteTeamMatchStats' } | null }> | null, schoolTeams: Array<{ __typename?: 'TeamMatchStats', team: { __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, state: string | null, slug: string | null } | null } | null, stats: { __typename?: 'FortniteTeamMatchStats', id: string, rank: number, clutched: boolean | null, totalPoints: number, placementPoints: number, eliminationPoints: number, totalSecondsSurvived: number, avgPointsPerSession: number, avgPlacementPerSession: number, avgEliminationsPerSession: number, sessionsPlayed: number } | { __typename?: 'LeagueOfLegendsTeamMatchStats' } | { __typename?: 'RocketLeagueTeamMatchStats' } | { __typename?: 'SmiteTeamMatchStats' } | null }> | null, myTeams: Array<{ __typename?: 'TeamMatchStats', team: { __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, state: string | null, slug: string | null } | null } | null, stats: { __typename?: 'FortniteTeamMatchStats', id: string, rank: number, clutched: boolean | null, totalPoints: number, placementPoints: number, eliminationPoints: number, totalSecondsSurvived: number, avgPointsPerSession: number, avgPlacementPerSession: number, avgEliminationsPerSession: number, sessionsPlayed: number } | { __typename?: 'LeagueOfLegendsTeamMatchStats' } | { __typename?: 'RocketLeagueTeamMatchStats' } | { __typename?: 'SmiteTeamMatchStats' } | null }> | null } | null }> | null }> | null } | null };

export type FnTeamPhaseStandingsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  phaseId: Scalars['UUID']['input'];
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type FnTeamPhaseStandingsQuery = { __typename?: 'Query', phase: { __typename?: 'Phase', id: string, format: PhaseFormat, survivalAdvancementPercentage: number | null, survivalAdvancementCount: number | null, season: { __typename?: 'Season', id: string, metaseasonId: string | null, league: { __typename?: 'League', id: string, competitionGroup: CompetitionGroup } | null } | null, slots: Array<{ __typename?: 'Slot', id: string, order: number | null, name: string | null, matches: Array<{ __typename?: 'Match', id: string, status: MatchStatus }> | null }> | null, fortniteTeamPhaseStats: { __typename?: 'FortniteTeamPhaseStatsResult', updatedAt: string | null, total: number | null, leaderboard: Array<{ __typename?: 'TeamPhaseStats', team: { __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, state: string | null, slug: string | null } | null } | null, stats: { __typename?: 'FortniteTeamPhaseStats', id: string, rank: number, clutched: boolean | null, totalPoints: number, placementPoints: number, eliminationPoints: number, totalSecondsSurvived: number, avgPointsPerSession: number, avgPlacementPerSession: number, avgEliminationsPerSession: number, sessionsPlayed: number } | { __typename?: 'LeagueOfLegendsTeamPhaseStats' } | { __typename?: 'RocketLeagueTeamPhaseStats' } | { __typename?: 'SmiteTeamPhaseStats' } | null }> | null, schoolTeams: Array<{ __typename?: 'TeamPhaseStats', team: { __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, state: string | null, slug: string | null } | null } | null, stats: { __typename?: 'FortniteTeamPhaseStats', id: string, rank: number, clutched: boolean | null, totalPoints: number, placementPoints: number, eliminationPoints: number, totalSecondsSurvived: number, avgPointsPerSession: number, avgPlacementPerSession: number, avgEliminationsPerSession: number, sessionsPlayed: number } | { __typename?: 'LeagueOfLegendsTeamPhaseStats' } | { __typename?: 'RocketLeagueTeamPhaseStats' } | { __typename?: 'SmiteTeamPhaseStats' } | null }> | null, myTeams: Array<{ __typename?: 'TeamPhaseStats', team: { __typename?: 'Team', id: string, name: string | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> } | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, slug: string | null, state: string | null } | null } | null, stats: { __typename?: 'FortniteTeamPhaseStats', id: string, rank: number, clutched: boolean | null, totalPoints: number, placementPoints: number, eliminationPoints: number, totalSecondsSurvived: number, avgPointsPerSession: number, avgPlacementPerSession: number, avgEliminationsPerSession: number, sessionsPlayed: number } | { __typename?: 'LeagueOfLegendsTeamPhaseStats' } | { __typename?: 'RocketLeagueTeamPhaseStats' } | { __typename?: 'SmiteTeamPhaseStats' } | null }> | null } | null } | null };

export type BracketResultsQueryVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
}>;


export type BracketResultsQuery = { __typename?: 'Query', phase: { __typename?: 'Phase', id: string, type: PhaseType, format: PhaseFormat, esport: { __typename?: 'Esport', id: string, rating: EsportRating } | null, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, matches: Array<{ __typename?: 'Match', id: string, status: MatchStatus, matchResults: Array<{ __typename?: 'MatchResult', id: string, matchId: string, placing: number | null, teamId: string | null }> | null }> | null }> | null, teams: Array<{ __typename?: 'SeededTeam', id: string, name: string | null, seed: number | null, school: { __typename?: 'School', id: string, logoUrl: string | null } | null }> | null } | null };

export type DoubleEliminationResultsQueryVariables = Exact<{
  phaseId: Scalars['UUID']['input'];
}>;


export type DoubleEliminationResultsQuery = { __typename?: 'Query', phase: { __typename?: 'Phase', id: string, esport: { __typename?: 'Esport', id: string, rating: EsportRating } | null, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null, label: SlotLabel | null, ordinal: number | null, matchSlots: Array<{ __typename?: 'MatchSlot', id: string, slotId: string, ordinal: number, match: { __typename?: 'Match', id: string, status: MatchStatus, matchResults: Array<{ __typename?: 'MatchResult', id: string, placing: number | null, teamId: string | null }> | null } | null, teamSlots: Array<{ __typename?: 'TeamSlot', id: string, matchSlotId: string, type: TeamSlotType, sourceSeed: number | null, sourceMatchSlotId: string | null, sourceTeamPlacing: number | null, isUnfilledForBye: boolean | null, team: { __typename?: 'BracketMatchTeam', id: string, name: string | null, seed: number, school: { __typename?: 'School', id: string, logoUrl: string | null } | null, result: { __typename?: 'MatchResult', matchId: string, placing: number | null } | null } | null }> | null }> | null }> | null } | null };

export type GetLeagueMetadataBySchoolIdQueryVariables = Exact<{
  input: GetLeagueMetadataBySchoolIdInput;
}>;


export type GetLeagueMetadataBySchoolIdQuery = { __typename?: 'Query', getLeagueMetadataBySchoolId: { __typename?: 'GetLeagueMetadataGenericPayload', success: boolean, error: Array<string> | null, payload: Array<{ __typename?: 'StandingsPageLeagueMetadata', id: string, displayName: string | null, name: string, competitionModel: CompetitionModel, enrollmentStatus: SchoolLeagueEnrollmentStatus | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug } | null, seasons: Array<{ __typename?: 'StandingsPageSeason', id: string, name: string, startsAt: string, metaseason: { __typename?: 'StandingsPageMetaseason', id: string, name: string, startsAt: string, endsAt: string, promotionStartsAt: string | null, promotionEndsAt: string | null, hasMatches: boolean }, phases: Array<{ __typename?: 'StandingsPagePhase', id: string, name: string, startsAt: string, endsAt: string, format: PhaseFormat, hasMatches: boolean, status: PhaseStatus }> | null }> | null }> | null } };

export type GetLeagueMetadataByTeamIdsQueryVariables = Exact<{
  input: GetLeagueMetadataByTeamIdsInput;
}>;


export type GetLeagueMetadataByTeamIdsQuery = { __typename?: 'Query', getLeagueMetadataByTeamIds: { __typename?: 'GetLeagueMetadataGenericPayload', success: boolean, error: Array<string> | null, payload: Array<{ __typename?: 'StandingsPageLeagueMetadata', id: string, displayName: string | null, name: string, competitionModel: CompetitionModel, enrollmentStatus: SchoolLeagueEnrollmentStatus | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug } | null, seasons: Array<{ __typename?: 'StandingsPageSeason', id: string, name: string, startsAt: string, metaseason: { __typename?: 'StandingsPageMetaseason', id: string, name: string, startsAt: string, endsAt: string, promotionStartsAt: string | null, promotionEndsAt: string | null, hasMatches: boolean }, phases: Array<{ __typename?: 'StandingsPagePhase', id: string, name: string, startsAt: string, endsAt: string, status: PhaseStatus, format: PhaseFormat, hasMatches: boolean }> | null }> | null }> | null } };

export type GameStatsQueryVariables = Exact<{
  gameId: Scalars['UUID']['input'];
}>;


export type GameStatsQuery = { __typename?: 'Query', game: { __typename?: 'Game', id: string, status: GameStatus, playerGameStats: Array<{ __typename?: 'PlayerGameStats', id: string, teamId: string, player: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } | null, leagueOfLegendsStats: { __typename?: 'LeagueOfLegendsPlayerGameStats', id: string, champion: { __typename?: 'LeagueOfLegendsChampion', id: string, name: string | null, image: { __typename?: 'Image', src: string }, loadScreenImage: { __typename?: 'Image', src: string } } | null } | null }> | null, teamGameStats: Array<{ __typename?: 'TeamGameStats', id: string, teamId: string, leagueOfLegendsStats: { __typename?: 'LeagueOfLegendsTeamGameStats', id: string, detail: { __typename?: 'LeagueOfLegendsGameDetail', bans: Array<{ __typename?: 'LeagueOfLegendsBan', championId: number, champion: { __typename?: 'LeagueOfLegendsChampion', id: string, name: string | null, image: { __typename?: 'Image', src: string } } | null }> | null } | null } | null, stats: { __typename?: 'LeagueOfLegendsTeamGameStats', id: string, creepScore: number, averageGoldPerMinute: number, eliminationRespawnRatio: number, towersDestroyed: number, inhibitorsDestroyed: number, dragonEliminations: number, baronEliminations: number, eliminations: number, respawns: number, assists: number } | { __typename?: 'RocketLeagueTeamGameStats', id: string, score: number, goals: number, saves: number, assists: number, shots: number } | { __typename?: 'SmiteTeamGameStats', id: string, eliminations: number, respawns: number, assists: number, averageGoldPerMinute: number, eliminationRespawnRatio: number } | null }> | null } | null };

export type MatchStatsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type MatchStatsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, scheduledStartsAt: string | null, bestOf: number | null, teamMatchStats: Array<{ __typename?: 'TeamMatchStats', id: string, teamId: string, stats: { __typename?: 'FortniteTeamMatchStats' } | { __typename?: 'LeagueOfLegendsTeamMatchStats', averageCreepScore: number, averageGoldEarned: number, averageGoldPerMinute: number, eliminationRespawnRatio: number, towersDestroyed: number, inhibitorsDestroyed: number, dragonEliminations: number, baronEliminations: number, eliminations: number, respawns: number, assists: number } | { __typename?: 'RocketLeagueTeamMatchStats', id: string, score: number, goals: number, saves: number, assists: number, shots: number } | { __typename?: 'SmiteTeamMatchStats', id: string, eliminations: number, respawns: number, assists: number, averageGoldPerMinute: number, eliminationRespawnRatio: number } | null }> | null } | null };

export type GetMatchGamesForStatsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchGamesForStatsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, seriesId: string | null, gameResults: Array<{ __typename?: 'GameResult', id: string, teamId: string | null, sidePlayed: number | null, placing: number | null, score: number | null }> | null }> | null } | null };

export type GetMatchAndGameStatsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetMatchAndGameStatsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, status: MatchStatus, scheduledStartsAt: string | null, bestOf: number | null, teamMatchStats: Array<{ __typename?: 'TeamMatchStats', id: string, teamId: string, stats: { __typename?: 'FortniteTeamMatchStats' } | { __typename?: 'LeagueOfLegendsTeamMatchStats', averageCreepScore: number, averageGoldEarned: number, averageGoldPerMinute: number, eliminationRespawnRatio: number, towersDestroyed: number, inhibitorsDestroyed: number, dragonEliminations: number, baronEliminations: number, eliminations: number, respawns: number, assists: number } | { __typename?: 'RocketLeagueTeamMatchStats', id: string, score: number, goals: number, saves: number, assists: number, shots: number } | { __typename?: 'SmiteTeamMatchStats', id: string, eliminations: number, respawns: number, assists: number, averageGoldPerMinute: number, eliminationRespawnRatio: number } | null }> | null, games: Array<{ __typename?: 'Game', id: string, status: GameStatus, playerGameStats: Array<{ __typename?: 'PlayerGameStats', id: string, teamId: string, player: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } | null, rocketLeagueStats: { __typename?: 'RocketLeaguePlayerGameStats', id: string, score: number, shots: number, goals: number, saves: number, assists: number } | null, leagueOfLegendsStats: { __typename?: 'LeagueOfLegendsPlayerGameStats', id: string, champion: { __typename?: 'LeagueOfLegendsChampion', id: string, name: string | null, image: { __typename?: 'Image', src: string }, loadScreenImage: { __typename?: 'Image', src: string } } | null } | null }> | null, teamGameStats: Array<{ __typename?: 'TeamGameStats', id: string, teamId: string, leagueOfLegendsStats: { __typename?: 'LeagueOfLegendsTeamGameStats', id: string, detail: { __typename?: 'LeagueOfLegendsGameDetail', bans: Array<{ __typename?: 'LeagueOfLegendsBan', championId: number, champion: { __typename?: 'LeagueOfLegendsChampion', id: string, name: string | null, image: { __typename?: 'Image', src: string } } | null }> | null } | null } | null, stats: { __typename?: 'LeagueOfLegendsTeamGameStats', id: string, creepScore: number, averageGoldPerMinute: number, eliminationRespawnRatio: number, towersDestroyed: number, inhibitorsDestroyed: number, dragonEliminations: number, baronEliminations: number, eliminations: number, respawns: number, assists: number } | { __typename?: 'RocketLeagueTeamGameStats', id: string, score: number, goals: number, saves: number, assists: number, shots: number } | { __typename?: 'SmiteTeamGameStats', id: string, eliminations: number, respawns: number, assists: number, averageGoldPerMinute: number, eliminationRespawnRatio: number } | null }> | null }> | null } | null };

export type GetPlayerGameStatsQueryVariables = Exact<{
  gameId: Scalars['UUID']['input'];
}>;


export type GetPlayerGameStatsQuery = { __typename?: 'Query', game: { __typename?: 'Game', id: string, playerGameStats: Array<{ __typename?: 'PlayerGameStats', id: string, teamId: string, team: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null } | null }, player: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } | null, stats: { __typename?: 'LeagueOfLegendsPlayerGameStats', id: string, eliminations: number, respawns: number, assists: number, goldPerMinute: number, creepScore: number, wardsPlaced: number, championDamageDealt: number, player: { __typename?: 'LeagueOfLegendsPlayer', name: string | null, summonerName: string } | null, champion: { __typename?: 'LeagueOfLegendsChampion', id: string, name: string | null, image: { __typename?: 'Image', src: string } } | null, detail: { __typename?: 'LeagueOfLegendsGameDetail', items: Array<{ __typename?: 'LeagueOfLegendsItem', id: string, image: { __typename?: 'Image', src: string } }> | null } | null } | { __typename?: 'RocketLeaguePlayerGameStats', id: string, shootingPercentage: number | null, goals: number, saves: number, assists: number, shots: number, score: number } | { __typename?: 'SmitePlayerGameStats', id: string, eliminations: number, respawns: number, assists: number, eliminationParticipation: number, goldEarned: number, towersDestroyed: number } | null }> | null } | null };

export type GetPlayerMatchStatsQueryVariables = Exact<{
  matchId: Scalars['UUID']['input'];
}>;


export type GetPlayerMatchStatsQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, playerMatchStats: Array<{ __typename?: 'PlayerMatchStats', id: string, teamId: string, player: { __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } | null, stats: { __typename?: 'LeagueOfLegendsPlayerMatchStats', id: string, eliminations: number, respawns: number, assists: number, averageGoldPerMinute: number, creepScore: number, wardsPlaced: number, championDamageDealt: number, champions: Array<{ __typename?: 'LeagueOfLegendsChampion', id: string, name: string | null, image: { __typename?: 'Image', src: string } }> | null } | { __typename?: 'RocketLeaguePlayerMatchStats', id: string, shootingPercentage: number | null, goals: number, saves: number, assists: number, shots: number, score: number } | { __typename?: 'SmitePlayerMatchStats', id: string, eliminations: number, respawns: number, assists: number, eliminationParticipation: number, averageGoldPerMinute: number, towersDestroyed: number } | null }> | null } | null };

export type GetTopPerformersStatsByGameIdQueryVariables = Exact<{
  gameId: Scalars['UUID']['input'];
}>;


export type GetTopPerformersStatsByGameIdQuery = { __typename?: 'Query', game: { __typename?: 'Game', id: string, status: GameStatus, playerGameStats: Array<{ __typename?: 'PlayerGameStats', teamId: string, player: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } | null, stats: { __typename?: 'LeagueOfLegendsPlayerGameStats', id: string, eliminationRespawnRatio: number, eliminations: number, assists: number, goldPerMinute: number } | { __typename?: 'RocketLeaguePlayerGameStats', id: string, shootingPercentage: number | null, goals: number, saves: number, assists: number } | { __typename?: 'SmitePlayerGameStats', id: string, eliminationRespawnRatio: number, eliminations: number, assists: number, goldEarned: number } | null, team: { __typename?: 'Team', id: string, school: { __typename?: 'School', id: string, logoUrl: string | null } | null } }> | null } | null };

export type FindSurveyByTriggerQueryVariables = Exact<{
  trigger: SurveyTrigger;
  entityType: SurveyTriggerEntityType;
  entityId: Scalars['UUID']['input'];
}>;


export type FindSurveyByTriggerQuery = { __typename?: 'Query', findSurveyByTrigger: { __typename?: 'Survey', id: string, schemaJson: string } | null };

export type SaveSurveySchemaMutationVariables = Exact<{
  input: SaveSurveySchemaInput;
}>;


export type SaveSurveySchemaMutation = { __typename?: 'Mutation', saveSurveySchema: { __typename?: 'SurveyPayload', id: string, success: boolean } };

export type DeleteSurveySchemaMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteSurveySchemaMutation = { __typename?: 'Mutation', deleteSurveySchema: { __typename?: 'SurveyPayload', id: string, success: boolean } };

export type SaveGeneralSurveyResponseMutationVariables = Exact<{
  surveySchemaId: Scalars['UUID']['input'];
  responseJson: Scalars['String']['input'];
}>;


export type SaveGeneralSurveyResponseMutation = { __typename?: 'Mutation', saveSurveyResponse: { __typename?: 'SurveyPayload', id: string, success: boolean } };

export type SaveSurveyMutationVariables = Exact<{
  input: SaveSurveyInput;
}>;


export type SaveSurveyMutation = { __typename?: 'Mutation', saveSurvey: { __typename?: 'SurveyPayload', id: string } };

export type ResurrectDuplicateTeamMutationVariables = Exact<{
  teamToReplaceId: Scalars['UUID']['input'];
  deletedTeamMemberIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type ResurrectDuplicateTeamMutation = { __typename?: 'Mutation', resurrectDuplicateDeletedTeam: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string } } };

export type ResurrectTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type ResurrectTeamMutation = { __typename?: 'Mutation', resurrectTeam: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, deletedById: string | null, deletedAt: string | null } } };

export type UpdateTeamNameMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  input: UpdateTeamInput;
}>;


export type UpdateTeamNameMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, name: string | null } } | null };

export type DeactivateTeamFromLeagueMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  leagueId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type DeactivateTeamFromLeagueMutation = { __typename?: 'Mutation', removeTeamFromLeague: { __typename?: 'TeamPayload', success: boolean, team: { __typename?: 'Team', id: string, leagues: Array<{ __typename?: 'League', id: string }> | null } | null } };

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: { __typename?: 'DeleteTeamPayload', success: boolean, deletedTeamId: string } };

export type CreateRoleInviteCodeMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  resourceId: Scalars['UUID']['input'];
  resourceType: Scalars['String']['input'];
  roleName: UserRoleName;
}>;


export type CreateRoleInviteCodeMutation = { __typename?: 'Mutation', createRoleInviteCode: { __typename?: 'RoleInviteCode', id: string, code: string } | null };

export type GenerateReferralLinkMutationVariables = Exact<{
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
  resourceType: ResourceType;
  roleName: UserRoleName;
  source: Scalars['String']['input'];
  medium: Scalars['String']['input'];
  competitionGroup?: InputMaybe<CompetitionGroup>;
}>;


export type GenerateReferralLinkMutation = { __typename?: 'Mutation', generateReferralLink: string };

export type AssignTeamCaptainRoleMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type AssignTeamCaptainRoleMutation = { __typename?: 'Mutation', assignTeamCaptainRole: { __typename?: 'TeamUserPayload', team: { __typename?: 'Team', id: string, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string } }>, formats: Array<{ __typename?: 'TeamRosterFormat', starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string } } | null }> }> } | null } | null } };

export type UnassignTeamCaptainRoleMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type UnassignTeamCaptainRoleMutation = { __typename?: 'Mutation', unassignTeamCaptainRole: { __typename?: 'TeamUserPayload', team: { __typename?: 'Team', id: string, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string } }>, formats: Array<{ __typename?: 'TeamRosterFormat', starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string } } | null }> }> } | null } | null } };

export type SetTeamIsPlayerLedMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  isPlayerLed: Scalars['Boolean']['input'];
}>;


export type SetTeamIsPlayerLedMutation = { __typename?: 'Mutation', setTeamIsPlayerLed: { __typename?: 'TeamMutationPayload', team: { __typename?: 'Team', id: string, isPlayerLed: boolean | null } } | null };

export type SwapSubstitutesBetweenTeamsMutationVariables = Exact<{
  input: TransferSubstituteToTeamInput;
}>;


export type SwapSubstitutesBetweenTeamsMutation = { __typename?: 'Mutation', transferSubstituteToTeam: { __typename?: 'TransferSubstituteToTeamResult', originTeam: { __typename?: 'Team', id: string, roster: { __typename?: 'TeamRoster', id: string, teamId: string, numPlayers: number, maxNumPlayers: number, isFull: boolean, players: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, effectiveAt: string, user: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', position: { __typename?: 'EsportPosition', id: string, index: number, name: string, abbreviation: string, colloquial: string }, player: { __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string }> | null } }> }> } | null }, destinationTeam: { __typename?: 'Team', id: string, roster: { __typename?: 'TeamRoster', id: string, teamId: string, numPlayers: number, maxNumPlayers: number, isFull: boolean, players: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, effectiveAt: string, user: { __typename?: 'User', id: string, lastSeen: string | null, name: string | null, avatarUrl: string | null, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', position: { __typename?: 'EsportPosition', id: string, index: number, name: string, abbreviation: string, colloquial: string }, player: { __typename?: 'TeamPlayer', effectiveAt: string, isCaptain: boolean, user: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string }> | null } }> }> } | null } } };

export type AssignTeamCoachMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  coachUserId: Scalars['UUID']['input'];
}>;


export type AssignTeamCoachMutation = { __typename?: 'Mutation', assignTeamCoach: { __typename?: 'TeamUserPayload', success: boolean } };

export type RemoveTeamCoachMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  coachUserId: Scalars['UUID']['input'];
}>;


export type RemoveTeamCoachMutation = { __typename?: 'Mutation', removeTeamCoach: { __typename?: 'TeamUserPayload', success: boolean } };

export type ReplaceTeamCoachMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  existingCoachUserId: Scalars['UUID']['input'];
  newCoachUserId: Scalars['UUID']['input'];
}>;


export type ReplaceTeamCoachMutation = { __typename?: 'Mutation', replaceTeamCoach: { __typename?: 'TeamUserPayload', success: boolean } };

export type EnrollTeamInSeasonMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  seasonId: Scalars['UUID']['input'];
  options?: InputMaybe<TeamEnrollmentOptions>;
}>;


export type EnrollTeamInSeasonMutation = { __typename?: 'Mutation', enrollTeamInSeason: { __typename?: 'TeamSeasonPayload', success: boolean } };

export type UnenrollTeamFromSeasonMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  seasonId: Scalars['UUID']['input'];
}>;


export type UnenrollTeamFromSeasonMutation = { __typename?: 'Mutation', unenrollTeamFromSeason: { __typename?: 'TeamPayload', success: boolean } };

export type TransferTeamToSeasonMutationVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  originSeasonId: Scalars['UUID']['input'];
  destinationSeasonId: Scalars['UUID']['input'];
  options?: InputMaybe<TeamEnrollmentOptions>;
}>;


export type TransferTeamToSeasonMutation = { __typename?: 'Mutation', transferTeamToSeason: { __typename?: 'TeamSeasonPayload', success: boolean } };

export type UnenrollTeamsFromSeasonMutationVariables = Exact<{
  input: UnenrollTeamsFromSeasonInput;
}>;


export type UnenrollTeamsFromSeasonMutation = { __typename?: 'Mutation', unenrollTeamsFromSeason: { __typename?: 'BulkActionJobPayload', jobId: string } };

export type TransferTeamsToSeasonMutationVariables = Exact<{
  input: TransferTeamsToSeasonInput;
}>;


export type TransferTeamsToSeasonMutation = { __typename?: 'Mutation', transferTeamsToSeason: { __typename?: 'BulkActionJobPayload', jobId: string } };

export type GetPlayerPhaseStatsByTeamQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  phaseId: Scalars['UUID']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type GetPlayerPhaseStatsByTeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, leagues: Array<{ __typename?: 'League', id: string, teamFormat: number, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, teamId: string, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null, phaseStats: Array<{ __typename?: 'PlayerPhaseStats', stats: { __typename?: 'LeagueOfLegendsPlayerPhaseStats', id: string, averageEliminations: number, averageAssists: number, averageRespawns: number, averageGoldPerMinute: number, averageCreepScore: number, averageTowersDestroyed: number, eliminationRespawnRatio: number, mostPickedChampionId: number, eliminationParticipation: number, mostPickedChampion: { __typename?: 'LeagueOfLegendsChampion', id: string, image: { __typename?: 'Image', src: string } } | null } | { __typename?: 'RocketLeaguePlayerPhaseStats', id: string, shootingPercentage: number | null, averageGoals: number, averageSaves: number, averageAssists: number, averageShots: number } | { __typename?: 'SmitePlayerPhaseStats', id: string, eliminations: number, respawns: number, assists: number, eliminationParticipation: number, averageGoldPerMinute: number, towersDestroyed: number } | null }> | null } }> } | null } | null };

export type GetTopPerformersStatsByTeamIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  phaseId: Scalars['UUID']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type GetTopPerformersStatsByTeamIdQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, leagues: Array<{ __typename?: 'League', id: string, teamFormat: number, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, teamId: string, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null } | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null, phaseStats: Array<{ __typename?: 'PlayerPhaseStats', stats: { __typename?: 'LeagueOfLegendsPlayerPhaseStats', id: string, eliminationRespawnRatio: number, averageEliminations: number, averageAssists: number, averageGoldPerMinute: number } | { __typename?: 'RocketLeaguePlayerPhaseStats', id: string, shootingPercentage: number | null, averageGoals: number, averageSaves: number, averageAssists: number } | { __typename?: 'SmitePlayerPhaseStats', id: string, eliminationRespawnRatio: number, averageEliminations: number, averageAssists: number, averageGoldEarned: number } | null }> | null } }> } | null } | null };

export type GetTeamsUserAccountConnectionsQueryVariables = Exact<{
  filters?: InputMaybe<TeamFiltersInput>;
}>;


export type GetTeamsUserAccountConnectionsQuery = { __typename?: 'Query', getTeams: { __typename?: 'TeamsResult', teams: Array<{ __typename?: 'Team', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug }, roster: { __typename?: 'TeamRoster', teamId: string, players: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, providerName: string }> | null, userEsportPlatforms: Array<{ __typename?: 'UserEsportPlatform', id: string, platform: Platform, esportId: string }> | null } }>, formats: Array<{ __typename?: 'TeamRosterFormat', starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } } | null }> }> } | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, startsAt: string, endsAt: string }> | null }> | null } | null };

export type FindEligibleMoveTeamsQueryVariables = Exact<{
  input: FindEligibleTeamsForSubstituteTransferInput;
  id: Scalars['UUID']['input'];
}>;


export type FindEligibleMoveTeamsQuery = { __typename?: 'Query', findEligibleTeamsForSubstituteTransfer: { __typename?: 'EligibleTeamsForSubstituteTransferResult', destinations: Array<{ __typename?: 'SubstituteTransferDestination', requiresTrade: boolean, team: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null } | null }, tradablePlayers: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, name: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> }> }, team: { __typename?: 'Team', id: string, name: string | null } | null };

export type GetAllTeamsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<TeamFiltersInput>;
}>;


export type GetAllTeamsQuery = { __typename?: 'Query', getTeams: { __typename?: 'TeamsResult', totalCount: number | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, league: { __typename?: 'League', id: string } | null, seasons: Array<{ __typename?: 'Season', id: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null }> | null }> | null } | null };

export type GetTeamsForScheduleMatchesWithSlotsQueryVariables = Exact<{
  teamIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  minStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetTeamsForScheduleMatchesWithSlotsQuery = { __typename?: 'Query', teamsByIds: Array<{ __typename?: 'Team', id: string, name: string | null, competitionGroup: CompetitionGroup | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating }, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, slotExclusionWindows: Array<{ __typename?: 'SlotExclusionWindow', id: string, resourceId: string, startsAt: string | null, endsAt: string | null }> | null, seasonTeams: Array<{ __typename?: 'SeasonTeam', seasonId: string, season: { __typename?: 'Season', id: string, metaseasonId: string | null, league: { __typename?: 'League', id: string, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel } | null, activePhases: Array<{ __typename?: 'Phase', id: string, bestOf: number | null, format: PhaseFormat, type: PhaseType, startsAt: string, endsAt: string, defaultSlots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null }> | null }> | null } | null }> | null }> | null };

export type GetTeamsForScheduleMatchesQueryVariables = Exact<{
  teamIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type GetTeamsForScheduleMatchesQuery = { __typename?: 'Query', teamsByIds: Array<{ __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, logoUrl: string | null } | null, slotExclusionWindows: Array<{ __typename?: 'SlotExclusionWindow', id: string, resourceId: string, startsAt: string | null, endsAt: string | null }> | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating }, seasons: Array<{ __typename?: 'Season', id: string, league: { __typename?: 'League', id: string, competitionGroup: CompetitionGroup, competitionModel: CompetitionModel } | null, activePhases: Array<{ __typename?: 'Phase', id: string, type: PhaseType, startsAt: string, endsAt: string, slots: Array<{ __typename?: 'Slot', id: string, startsAt: string | null }> | null }> | null }> | null }> | null };

export type TeamPlayerFragment = { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } };

export type GetTeamOverviewQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type GetTeamOverviewQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, competitionGroup: CompetitionGroup | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating }, roster: { __typename?: 'TeamRoster', id: string, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } } | null }>, substitutes: Array<{ __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> }> } | null, school: { __typename?: 'School', id: string, name: string | null, slug: string | null, logoUrl: string | null } | null } | null };

export type GetDecodedInviteCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetDecodedInviteCodeQuery = { __typename?: 'Query', roleInviteCodeByCode: { __typename?: 'RoleInviteCode', id: string, userId: string | null, resourceId: string | null, roleName: UserRoleName, resourceType: string | null, code: string } | null };

export type FindTeamsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  schoolId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type FindTeamsQuery = { __typename?: 'Query', teamsByIdsSchoolId: Array<{ __typename?: 'Team', id: string, name: string | null, competitionGroup: CompetitionGroup | null, esportId: string, esport: { __typename?: 'Esport', slug: Types.EsportSlug }, school: { __typename?: 'School', logoUrl: string | null } | null, coaches: Array<{ __typename?: 'TeamCoach', id: string, name: string | null }> | null }> | null };

export type GetTeamEsportDetailsQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type GetTeamEsportDetailsQuery = { __typename?: 'Query', team: { __typename?: 'Team', esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, description: string | null, platform: string | null, details: { __typename?: 'EsportDetails', esportId: string, abbreviation: string | null, gameType: string | null, platforms: Array<Platform> | null } | null, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null } } } | null };

export type GetTeamInviteDetailsQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
}>;


export type GetTeamInviteDetailsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string } | null, user: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, name: string | null, avatarUrl: string | null } | null, team: { __typename?: 'Team', id: string, name: string | null, competitionGroup: CompetitionGroup | null, inviteUrl: string | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, description: string | null, platform: string | null, details: { __typename?: 'EsportDetails', esportId: string, abbreviation: string | null, gameType: string | null, platforms: Array<Platform> | null } | null, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null } }, school: { __typename?: 'School', id: string, name: string | null, slug: string | null, logoUrl: string | null } | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, description: string | null, startsAt: string, endsAt: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null }> | null } | null };

export type GetTeamPhaseRecentGamesQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  phaseId: Scalars['UUID']['input'];
}>;


export type GetTeamPhaseRecentGamesQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, teamPhaseSummary: { __typename?: 'TeamPhaseSummary', recentGames: Array<{ __typename?: 'Game', id: string, status: GameStatus, placing: number | null, ordinalNumber: number | null, match: { __typename?: 'Match', id: string, name: string | null, week: number | null } | null, winningTeam: { __typename?: 'GameTeam', id: string, gameId: string, name: string | null } | null, losingTeam: { __typename?: 'GameTeam', id: string, gameId: string, name: string | null } | null, leagueOfLegendsTeamStats: { __typename?: 'LeagueOfLegendsTeamGameStatsExtended', id: string, goldEarned: number, eliminationRespawnRatio: number, creepScore: number, champions: Array<{ __typename?: 'LeagueOfLegendsChampion', id: string, name: string | null, image: { __typename?: 'Image', src: string } }> | null, detail: { __typename?: 'LeagueOfLegendsGameDetail', bans: Array<{ __typename?: 'LeagueOfLegendsBan', champion: { __typename?: 'LeagueOfLegendsChampion', id: string, name: string | null, image: { __typename?: 'Image', src: string } } | null }> | null } | null } | null, smiteTeamStats: { __typename?: 'SmiteTeamGameStats', id: string, goldEarned: number, eliminationRespawnRatio: number } | null, rocketLeagueTeamStats: { __typename?: 'RocketLeagueTeamGameStatsWithSP', id: string, score: number, shootingPercentage: number | null, goals: number, shots: number, assists: number, saves: number } | null }> | null, recentFortniteMatches: Array<{ __typename?: 'Match', id: string, status: MatchStatus, week: number | null, name: string | null, scheduledStartsAt: string | null, teamMatchStats: Array<{ __typename?: 'TeamMatchStats', teamId: string, fortniteStats: { __typename?: 'FortniteTeamMatchStats', rank: number, totalPoints: number, eliminationPoints: number } | null }> | null }> | null } | null } | null };

export type GetCoachSchoolTeamsQueryVariables = Exact<{
  orgId: Scalars['UUID']['input'];
}>;


export type GetCoachSchoolTeamsQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, startsAt: string, endsAt: string }> | null, roster: { __typename?: 'TeamRoster', id: string, formats: Array<{ __typename?: 'TeamRosterFormat', teamSize: number, starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', user: { __typename?: 'User', id: string } } | null }> }> } | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null } | null };

export type GetTeamMembersAtNowQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type GetTeamMembersAtNowQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null, teamMaxSize: number | null } }, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseason: { __typename?: 'Metaseason', id: string, isPromoted: boolean, startsAt: string | null, name: string | null, endsAt: string | null } | null }> | null, roster: { __typename?: 'TeamRoster', id: string, formats: Array<{ __typename?: 'TeamRosterFormat', starters: Array<{ __typename?: 'StarterPosition', player: { __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } } | null, position: { __typename?: 'EsportPosition', id: string, index: number } }>, substitutes: Array<{ __typename?: 'TeamPlayer', isCaptain: boolean, user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } }> }> } | null } | null };

export type GetMatchesForSeasonByTeamIdsQueryVariables = Exact<{
  teamIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMatchesForSeasonByTeamIdsQuery = { __typename?: 'Query', matchesForSeasonByTeamIds: Array<{ __typename?: 'Match', id: string, status: MatchStatus, scheduledStartsAt: string | null, isScrimmage: boolean | null, slot: { __typename?: 'Slot', id: string, phase: { __typename?: 'Phase', id: string } | null } | null, matchResults: Array<{ __typename?: 'MatchResult', id: string, matchId: string, gamesWon: number | null, gamesLost: number | null, gamesTied: number | null, seriesWon: number | null, seriesLost: number | null, seriesTied: number | null, placing: number | null, team: { __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null } | null }> | null }> | null };

export type GetPhaseResultByTeamIdAndPhaseIdQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  phaseId: Scalars['UUID']['input'];
}>;


export type GetPhaseResultByTeamIdAndPhaseIdQuery = { __typename?: 'Query', phaseResultByTeamIdAndPhaseId: { __typename?: 'PhaseResult', id: string, gamesWon: number, gamesLost: number, rank: number | null, matchStreak: number } | null };

export type GetTeamSeasonsQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
}>;


export type GetTeamSeasonsQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, league: { __typename?: 'League', id: string, name: string | null } | null, allSeasons: Array<{ __typename?: 'Season', id: string, name: string }> | null } | null };

export type GetTeamsByUserQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetTeamsByUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug } }> | null, school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug } }> | null, coaches: Array<{ __typename?: 'User', id: string, name: string | null }> | null } | null } | null };

export type GetTeamsLeaguesTableQueryVariables = Exact<{
  input: FindTeamsInSeasonInput;
  isStadium: Scalars['Boolean']['input'];
  seasonId: Scalars['UUID']['input'];
}>;


export type GetTeamsLeaguesTableQuery = { __typename?: 'Query', findTeamsInSeason: { __typename?: 'FindTeamsInSeasonResult', totalCount: number, teams: Array<{ __typename?: 'Team', id: string, slug: string | null, name: string | null, createdAt?: string | null, enrollmentStatus?: SeasonEnrollmentStatus, avatarUrl?: string | null, captain?: { __typename?: 'User', id: string, name: string | null } | null, roster: { __typename?: 'TeamRoster', numPlayers: number } | null, seasonTeams: Array<{ __typename?: 'SeasonTeam', seasonId: string, metaseasonId: string | null, leagueId: string, teamId: string, createdAt: string, deletedAt: string | null }> | null, school?: { __typename?: 'School', id: string, name: string | null, state: string | null, logoUrl: string | null, varsityAssociations: Array<{ __typename?: 'VarsityAssociation', slug: string, name: string }> } | null, coaches?: Array<{ __typename?: 'TeamCoach', id: string, name: string | null, coachType: TeamCoachType, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean, deletedAt: string | null }> | null }> | null }> } };

export type LeagueTeamFragment = { __typename?: 'Team', id: string, slug: string | null, name: string | null, createdAt?: string | null, enrollmentStatus?: SeasonEnrollmentStatus, avatarUrl?: string | null, captain?: { __typename?: 'User', id: string, name: string | null } | null, roster: { __typename?: 'TeamRoster', numPlayers: number } | null, seasonTeams: Array<{ __typename?: 'SeasonTeam', seasonId: string, metaseasonId: string | null, leagueId: string, teamId: string, createdAt: string, deletedAt: string | null }> | null, school?: { __typename?: 'School', id: string, name: string | null, state: string | null, logoUrl: string | null, varsityAssociations: Array<{ __typename?: 'VarsityAssociation', slug: string, name: string }> } | null, coaches?: Array<{ __typename?: 'TeamCoach', id: string, name: string | null, coachType: TeamCoachType, emails: Array<{ __typename?: 'UserEmail', id: string, email: string, isSchoolEmail: boolean, deletedAt: string | null }> | null }> | null };

export type GetTeamInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTeamInfoQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, competitionGroup: CompetitionGroup | null, school: { __typename?: 'School', id: string, name: string | null } | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug }, leagues: Array<{ __typename?: 'League', id: string, seasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, name: string, rostersLockAt: string | null, teamRegistrationEndsAt: string | null, phases: Array<{ __typename?: 'Phase', id: string, startsAt: string, endsAt: string, name: string | null, type: PhaseType, seasonId: string, status: PhaseStatus, format: PhaseFormat, survivalAdvancementPercentage: number | null, survivalAdvancementCount: number | null }> | null }> | null }> | null } | null };

export type GetTeamUnenrollInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetTeamUnenrollInfoQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, leagues: Array<{ __typename?: 'League', id: string, competitionModel: CompetitionModel, competitionGroup: CompetitionGroup }> | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null, teamRegistrationEndsAt: string | null }> | null } | null };

export type GetTeamDeleteInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTeamDeleteInfoQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, isFixedRoster: boolean | null, competitionGroup: CompetitionGroup | null } | null };

export type GetTeamInfoTableQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
  hasMetaseasonId: Scalars['Boolean']['input'];
}>;


export type GetTeamInfoTableQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, createdAt: string | null, updatedAt: string | null, createdBy: string | null, deletedAt: string | null, isPlayerLed: boolean | null, createdByUser: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, userId: string, resourceId: string }> | null } | null, deletedBy: { __typename?: 'User', id: string, firstName: string | null, lastName: string | null, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, resourceId: string, userId: string }> | null } | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, user: { __typename?: 'User', id: string } }> } | null, leagues?: Array<{ __typename?: 'League', id: string, name: string | null, competitionModel: CompetitionModel }> | null, slotExclusionWindows: Array<{ __typename?: 'SlotExclusionWindow', id: string, resourceType: SlotExclusionWindowResourceType, resourceId: string, seasonId: string | null, startsAt: string | null, endsAt: string | null }> | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null, city: string | null, competitionGroup: CompetitionGroup | null, state: string | null, varsityAssociations: Array<{ __typename?: 'VarsityAssociation', name: string, abbreviation: string }> } | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug, rating: EsportRating, details: { __typename?: 'EsportDetails', esportId: string, abbreviation: string | null, gameType: string | null, assets: { __typename?: 'EsportAssets', avatarLogoUrl: string | null } | null } | null, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null, teamMaxSize: number | null } }, teamHistory: Array<{ __typename?: 'TeamDeleteEvent', triggeredById: string | null, triggeredAt: string, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'TeamEnrollmentEvent', triggeredById: string | null, triggeredAt: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, competitionGroup: CompetitionGroup } | null, league: { __typename?: 'League', id: string, displayName: string | null, name: string | null } | null, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'TeamHideEvent', triggeredById: string | null, triggeredAt: string, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'TeamRestoreEvent', triggeredById: string | null, triggeredAt: string, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'TeamUnEnrollmentEvent', triggeredById: string | null, triggeredAt: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null, competitionGroup: CompetitionGroup } | null, league: { __typename?: 'League', id: string, displayName: string | null, name: string | null } | null, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'TeamUnHideEvent', triggeredById: string | null, triggeredAt: string, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null }> | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null }> | null } | null };

export type GetTeamRecordQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTeamRecordQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, leagues: Array<{ __typename?: 'League', id: string, varsityAssociation: { __typename?: 'VarsityAssociation', name: string } | null, seasons: Array<{ __typename?: 'Season', id: string, name: string, metaseasonId: string | null, startsAt: string, phases: Array<{ __typename?: 'Phase', id: string, name: string | null, startsAt: string, phaseResults: Array<{ __typename?: 'PhaseResult', id: string, teamId: string, gamesPlayed: number, gamesWon: number, gamesLost: number, matchesWon: number, matchesLost: number, matchesTied: number, matchesWonByForfeit: number, matchesLostByForfeit: number }> | null }> | null }> | null }> | null } | null };

export type GetTeamClusterInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetTeamClusterInfoQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string | null, createdAt: string | null, updatedAt: string | null, schoolId: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null, esport: { __typename?: 'Esport', id: string, name: string | null, slug: Types.EsportSlug } } | null };

export type FindTeamEnrollmentsByUserQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type FindTeamEnrollmentsByUserQuery = { __typename?: 'Query', findTeamEnrollmentsByUser: { __typename?: 'TeamEnrollmentsPayload', effectiveAt: string, teamEnrollments: Array<{ __typename?: 'TeamEnrollment', team: { __typename?: 'Team', id: string, name: string | null, competitionGroup: CompetitionGroup | null, owners: Array<{ __typename?: 'User', id: string }> | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, rating: EsportRating, details: { __typename?: 'EsportDetails', esportId: string, abbreviation: string | null, teamMinStarterSize: number } | null }, school: { __typename?: 'School', id: string, logoUrl: string | null } | null, roster: { __typename?: 'TeamRoster', teamId: string, numPlayers: number } | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseason: { __typename?: 'Metaseason', id: string } | null }> | null }, enrollableSeasons: Array<{ __typename?: 'Season', id: string, name: string, registrationStartsAt: string, suggestedRegistrationEndsAt: string | null, teamRegistrationEndsAt: string | null, metaseasonId: string | null, league: { __typename?: 'League', id: string, name: string | null, displayName: string | null, competitionModel: CompetitionModel, competitionGroup: CompetitionGroup } | null }>, enrolledSeasons: Array<{ __typename?: 'Season', id: string, name: string, metaseasonId: string | null, teamRegistrationEndsAt: string | null, suggestedRegistrationEndsAt: string | null, league: { __typename?: 'League', id: string, name: string | null, displayName: string | null, competitionModel: CompetitionModel, competitionGroup: CompetitionGroup } | null }>, activePhaseRanks: Array<{ __typename?: 'TeamPhaseRank', rank: number, effectiveAt: string, phase: { __typename?: 'Phase', name: string | null } }> }> } };

export type TeamsForMatchQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TeamsForMatchQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: string, games: Array<{ __typename?: 'Game', id: string, playerGameStats: Array<{ __typename?: 'PlayerGameStats', id: string, playerId: string | null, isKnown: boolean, publisherAccountId: string, player: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null }> | null }> | null } | null };

export type TeamRosterHistoryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  dateRange: DateRangeInput;
}>;


export type TeamRosterHistoryQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, rosterHistory: Array<{ __typename?: 'AddedToBenchEvent', triggeredById: string, triggeredAt: string, teamId: string, player: { __typename?: 'User', id: string, name: string | null } | null, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'AddedToRosterEvent', triggeredById: string, triggeredAt: string, teamId: string, player: { __typename?: 'User', id: string, name: string | null } | null, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'CoachAssignedEvent', triggeredById: string, triggeredAt: string, teamId: string, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'CoachUnassignedEvent', triggeredById: string, triggeredAt: string, teamId: string, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'MovedToBenchEvent', triggeredById: string, triggeredAt: string, teamId: string, player: { __typename?: 'User', id: string, name: string | null } | null, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'MovedToRosterEvent', triggeredById: string, triggeredAt: string, teamId: string, player: { __typename?: 'User', id: string, name: string | null } | null, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null } | { __typename?: 'RemovedFromTeamEvent', triggeredById: string, triggeredAt: string, teamId: string, player: { __typename?: 'User', id: string, name: string | null } | null, triggeredBy: { __typename?: 'User', id: string, name: string | null } | null }> | null } | null };

export type GetTeamLeaguesByMetaseasonIdQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetTeamLeaguesByMetaseasonIdQuery = { __typename?: 'Query', teamsByIds: Array<{ __typename?: 'Team', id: string, name: string | null, schoolId: string | null, leagues: Array<{ __typename?: 'League', id: string, displayName: string | null, name: string | null, publicSlug: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseasonId: string | null }> | null }> | null };

export type GetTeamsSearchQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<TeamFiltersInput>;
}>;


export type GetTeamsSearchQuery = { __typename?: 'Query', getTeams: { __typename?: 'TeamsResult', totalCount: number | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, school: { __typename?: 'School', id: string, name: string | null, logoUrl: string | null } | null }> | null } | null };

export type GetTeamReputationQueryVariables = Exact<{
  teamId: Scalars['UUID']['input'];
  seasonId: Scalars['UUID']['input'];
}>;


export type GetTeamReputationQuery = { __typename?: 'Query', findSeasonReputationByTeamId: { __typename?: 'GenericTeamReputationPayload', reputations: Array<{ __typename?: 'TeamReputation', id: string | null, reputationScore: number | null } | null> | null } };

export type GetManagePageTeamsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<TeamFiltersInput>;
}>;


export type GetManagePageTeamsQuery = { __typename?: 'Query', getTeams: { __typename?: 'TeamsResult', teams: Array<{ __typename?: 'Team', id: string, enrolledSeasons: Array<{ __typename?: 'Season', id: string, metaseason: { __typename?: 'Metaseason', id: string, isPromoted: boolean } | null, league: { __typename?: 'League', id: string, name: string | null } | null }> | null, esport: { __typename?: 'Esport', id: string, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamMaxSize: number | null, teamFormat: number | null } } }> | null } | null };

export type SetTeamReputationMutationVariables = Exact<{
  input: SetReputationForTeamInput;
}>;


export type SetTeamReputationMutation = { __typename?: 'Mutation', setSeasonReputationForTeam: { __typename?: 'GenericTeamReputationPayload', reputations: Array<{ __typename?: 'TeamReputation', id: string | null, reputationScore: number | null } | null> | null } | null };

export type GetTourQueryVariables = Exact<{
  tour: Tour;
}>;


export type GetTourQuery = { __typename?: 'Query', getTour: { __typename?: 'UserTourPayload', userId: string, tour: Tour, viewedAt: string | null } | null };

export type SetTourViewedMutationVariables = Exact<{
  tour: Tour;
}>;


export type SetTourViewedMutation = { __typename?: 'Mutation', tourViewed: { __typename?: 'TourViewedPayload', success: boolean } };

export type GetUserAttrsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']['input']>;
  metaseasonId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetUserAttrsQuery = { __typename?: 'Query', userAttributes: { __typename?: 'UserAttributes', id: string, isParticipatingInMetaseason: boolean | null, hasEverParticipated: boolean | null, hasCompletedOnboardingSurvey: boolean | null, hasManageTeams: boolean | null } | null };

export type MarkContentAsReadMutationVariables = Exact<{
  slugs: ContentSlugs;
}>;


export type MarkContentAsReadMutation = { __typename?: 'Mutation', markContentAsRead: { __typename?: 'ContentPayload', success: boolean } };

export type UserContentQueryVariables = Exact<{ [key: string]: never; }>;


export type UserContentQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, content: { __typename?: 'Content', features: Array<{ __typename?: 'ContentFeature', slug: string, variant: string | null }> } } | null };

export type GetAllUserContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUserContentQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, content: { __typename?: 'Content', features: Array<{ __typename?: 'ContentFeature', slug: string, variant: string | null, sections: Array<{ __typename?: 'ContentSection', slug: string, items: Array<{ __typename?: 'ContentItem', slug: string, read: boolean | null }> | null }> }> } } | null };

export type GetUsersEsportQueryVariables = Exact<{
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetUsersEsportQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, league: { __typename?: 'League', id: string, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } } | null } | null };

export type GetReferralSchoolsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type GetReferralSchoolsQuery = { __typename?: 'Query', getReferralSchools: { __typename?: 'ReferralSchoolsPayload', referralSchools: Array<{ __typename?: 'ReferralSchool', schoolId: string, referredAt: string | null, school: { __typename?: 'School', name: string | null, state: string | null, city: string | null, phone: string | null, competitionGroup: CompetitionGroup | null } | null }> } };

export type CreateUserLeadMutationVariables = Exact<{
  input: UserLeadInput;
}>;


export type CreateUserLeadMutation = { __typename?: 'Mutation', createUserLead: { __typename?: 'UserLeadPayload', success: boolean } };

export type ReferCoachEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ReferCoachEmailMutation = { __typename?: 'Mutation', referCoachEmail: { __typename?: 'ReferEmailPayload', success: boolean } };

export type GetUsersOnlineStatusQueryVariables = Exact<{
  input: GetUsersOnlineStatusInput;
}>;


export type GetUsersOnlineStatusQuery = { __typename?: 'Query', getUsersOnlineStatus: { __typename?: 'GetUsersOnlineStatusPayload', success: boolean, errors: Array<string | null> | null, usersOnlineStatus: Array<{ __typename?: 'UserWithOnlineStatus', userId: string, onlineStatus: OnlineStatus | null }> } };

export type GetTeamsByUserIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  isStadium: Scalars['Boolean']['input'];
}>;


export type GetTeamsByUserIdQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, roles?: Array<{ __typename?: 'UserRole', roleName: UserRoleName, resourceId: string, resourceType: ResourceType, userId: string }> | null, schoolRoleStatus?: Array<{ __typename?: 'RoleStatus', status: UserRoleStatusName, role: { __typename?: 'Role', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string } }> | null, teams: Array<{ __typename?: 'Team', id: string, name: string | null, competitionGroup: CompetitionGroup | null, esport: { __typename?: 'Esport', id: string, name: string | null } }> | null } | null };

export type GetManagedTeamsByUserIdAtSchoolQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
}>;


export type GetManagedTeamsByUserIdAtSchoolQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, managedTeams: Array<{ __typename?: 'Team', id: string, name: string | null, competitionGroup: CompetitionGroup | null, esport: { __typename?: 'Esport', id: string, name: string | null } }> | null } | null };

export type GetUserDetailsToAddToTeamQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type GetUserDetailsToAddToTeamQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, leagues: Array<{ __typename?: 'League', id: string }> | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null } | null };

export type GetUserByRoleQueryVariables = Exact<{
  role: RoleDescriptor;
}>;


export type GetUserByRoleQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, name: string | null, avatarUrl: string | null, phone: string | null, email: string | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null, providerIntegrationType: IntegrationType | null }> | null }> };

export type GetUserAccountInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetUserAccountInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, schoolId: string | null, firstName: string | null, lastName: string | null, dateOfBirth: string | null, username: string | null, name: string | null, email: string | null, banned: boolean | null, gradYear: number | null, avatarUrl: string | null, createdAt: string | null, updatedAt: string | null, lastSeen: string | null, phone: string | null, timeZone: string | null, state: string | null, country: string | null, isParent: boolean, isUnderage: boolean, emails: Array<{ __typename?: 'UserEmail', isSchoolEmail: boolean, email: string, isVerified: boolean | null, oauthProviders: Array<{ __typename?: 'OAuthProvider', provider: string, email: string }> | null }> | null, roles: Array<{ __typename?: 'UserRole', userId: string, roleName: UserRoleName, resourceType: ResourceType, resourceId: string, status: UserRoleStatusName }> | null, teams: Array<{ __typename?: 'Team', seasons: Array<{ __typename?: 'Season', metaseason: { __typename?: 'Metaseason', competitionGroup: CompetitionGroup } | null }> | null }> | null, parent: { __typename?: 'User', id: string, name: string | null, avatarUrl: string | null } | null } | null };

export type GetTosAcceptanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTosAcceptanceQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, tosAcceptedAt: string | null } | null };

export type AcceptTosMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptTosMutation = { __typename?: 'Mutation', acceptTos: boolean | null };

export type AcceptTosPrivacyPolicyMutationVariables = Exact<{
  metaseasonId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
}>;


export type AcceptTosPrivacyPolicyMutation = { __typename?: 'Mutation', acceptTosPrivacyPolicy: { __typename?: 'UserPayload', success: boolean } };

export type GetSchoolByUserIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
  hasSchoolId: Scalars['Boolean']['input'];
}>;


export type GetSchoolByUserIdQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, hasScholasticTeamsAtSchool?: boolean | null, school: { __typename?: 'School', id: string, deletedAt: string | null, name: string | null, logoUrl: string | null, coaches: Array<{ __typename?: 'User', id: string, name: string | null }> | null } | null, userValidation: { __typename?: 'UserValidation', userId: string, verification: { __typename?: 'Verification', id: string } | null } | null } | null };

export type GetSchoolByUserIdBaseQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSchoolByUserIdBaseQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, gradYears: Array<{ __typename?: 'UserGradYear', gradYear: number, schoolId: string }>, school: { __typename?: 'School', id: string, deletedAt: string | null } | null } | null };

export type SchoolTeamFragment = { __typename?: 'Team', id: string, name: string | null, createdAt: string | null, deletedAt: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null } }, seasons: Array<{ __typename?: 'Season', id: string, startsAt: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null }> | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, user: { __typename?: 'User', id: string } }> } | null };

export type GetSchoolTeamsByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSchoolTeamsByIdQuery = { __typename?: 'Query', school: { __typename?: 'School', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string | null, createdAt: string | null, deletedAt: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug, name: string | null, leagueDefaults: { __typename?: 'EsportLeagueDefaults', teamFormat: number | null } }, seasons: Array<{ __typename?: 'Season', id: string, startsAt: string, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null }> | null, roster: { __typename?: 'TeamRoster', id: string, players: Array<{ __typename?: 'TeamPlayer', effectiveAt: string, user: { __typename?: 'User', id: string } }> } | null }> | null } | null };

export type AddUserRoleMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  role: UserRoleName;
  resourceType?: InputMaybe<ResourceType>;
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AddUserRoleMutation = { __typename?: 'Mutation', addUserRole: Array<{ __typename?: 'UserRole', roleName: UserRoleName }> | null };

export type UpdateUserDetailsMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  input: SetAccountSettingsInput;
}>;


export type UpdateUserDetailsMutation = { __typename?: 'Mutation', setUserAccountSettings: { __typename?: 'UserPayload', success: boolean, userId: string } };

export type SetUserGradYearMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  schoolId: Scalars['UUID']['input'];
  gradYear: Scalars['Int']['input'];
}>;


export type SetUserGradYearMutation = { __typename?: 'Mutation', setUserGradYear: { __typename?: 'UserPayload', success: boolean } };

export type RemoveUserFromSchoolMutationVariables = Exact<{
  input: RemoveUserFromSchoolInput;
}>;


export type RemoveUserFromSchoolMutation = { __typename?: 'Mutation', removeUserFromSchool: { __typename?: 'User', id: string } };

export type RemoveUserRoleMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  role: UserRoleName;
  resourceType?: InputMaybe<ResourceType>;
  resourceId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type RemoveUserRoleMutation = { __typename?: 'Mutation', removeUserRole: Array<{ __typename?: 'UserRole', userId: string }> | null };

export type SetUserAccountSettingsMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  input: SetAccountSettingsInput;
}>;


export type SetUserAccountSettingsMutation = { __typename?: 'Mutation', setUserAccountSettings: { __typename?: 'UserPayload', success: boolean } };

export type GetUserResetTokenMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetUserResetTokenMutation = { __typename?: 'Mutation', getPasswordResetToken: string | null };

export type ResetUserForVerificationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}>;


export type ResetUserForVerificationMutation = { __typename?: 'Mutation', resetUserForVerification: { __typename?: 'UserPayload', success: boolean, userId: string } };

export type ValidateScholasticRoleMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']['input']>;
  input: ValidateScholasticRoleAttributes;
}>;


export type ValidateScholasticRoleMutation = { __typename?: 'Mutation', validateScholasticRole: { __typename?: 'UserValidation', userId: string, validationStatus: UserRoleStatusName, verification: { __typename?: 'Verification', id: string, step: VerificationStep, errors: string | null } | null } };

export type UserSeasonInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
}>;


export type UserSeasonInfoQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, userId: string, resourceId: string }> | null, leagues: Array<{ __typename?: 'League', id: string }> | null } | null };

export type UserSeasonPassesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type UserSeasonPassesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, seasonPasses: Array<{ __typename?: 'UserSeasonPass', id: string, leagueId: string | null, redeemed: boolean | null, league: { __typename?: 'League', id: string, name: string | null } | null, metaseason: { __typename?: 'Metaseason', id: string, name: string | null } | null, productInstance: { __typename?: 'ProductInstance', id: string, acquisitionMethod: ProductAcquisitionMethod | null, createdAt: string | null } | null }> | null } | null };

export type GetAllUsersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters: SearchAllUsersInput;
}>;


export type GetAllUsersQuery = { __typename?: 'Query', getUsers: { __typename?: 'UsersResult', totalCount: number | null, users: Array<{ __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, username: string | null, email: string | null, phone: string | null, state: string | null, emails: Array<{ __typename?: 'UserEmail', isSchoolEmail: boolean, email: string, isVerified: boolean | null }> | null, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, userId: string, resourceId: string }> | null, roleRequests: Array<{ __typename?: 'RoleRequest', status: UserRoleStatusName, createdAt: string }> | null, school: { __typename?: 'School', id: string, name: string | null } | null }> | null } | null };

export type GetUsersWithPendingRolesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<PendingUserRolesFilterInput>;
}>;


export type GetUsersWithPendingRolesQuery = { __typename?: 'Query', getUsersWithPendingRoles: { __typename?: 'UsersResult', totalCount: number | null, users: Array<{ __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, email: string | null, phone: string | null, state: string | null, createdAt: string | null, emails: Array<{ __typename?: 'UserEmail', email: string, isSchoolEmail: boolean, isVerified: boolean | null }> | null, roleRequests: Array<{ __typename?: 'RoleRequest', roleName: UserRoleName, resourceId: string, resourceType: ResourceType, status: UserRoleStatusName, createdAt: string }> | null, school: { __typename?: 'School', id: string, name: string | null } | null }> | null } | null };

export type GetCxUsersQueryVariables = Exact<{
  filters: SearchAllUsersInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCxUsersQuery = { __typename?: 'Query', getUsers: { __typename?: 'UsersResult', totalCount: number | null, users: Array<{ __typename?: 'User', id: string, avatarUrl: string | null, name: string | null, roles: Array<{ __typename?: 'UserRole', roleName: UserRoleName, userId: string, resourceId: string, resourceType: ResourceType }> | null }> | null } | null };

export type BanUserMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type BanUserMutation = { __typename?: 'Mutation', banUser: { __typename?: 'UserPayload', success: boolean, user: { __typename?: 'User', id: string, banned: boolean | null } | null } };

export type UnbanUserMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnbanUserMutation = { __typename?: 'Mutation', unbanUser: { __typename?: 'UserPayload', success: boolean, user: { __typename?: 'User', id: string, banned: boolean | null } | null } };

export type GetUserTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTasksQuery = { __typename?: 'Query', getUserTasks: Array<{ __typename?: 'UserTaskPayload', id: string, type: string, state: TaskState }> };

export type HandbookViewedMutationVariables = Exact<{ [key: string]: never; }>;


export type HandbookViewedMutation = { __typename?: 'Mutation', handbookViewed: { __typename?: 'TaskCompletePayload', success: boolean } };

export type DeleteUserTaskQueueMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserTaskQueueMutation = { __typename?: 'Mutation', deleteUserTaskQueue: { __typename?: 'DeleteTaskQueuePayload', success: boolean } };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'DeleteUserPayload', success: boolean } | null };

export type AddUserToSchoolMutationVariables = Exact<{
  input: AddUserToSchoolInput;
}>;


export type AddUserToSchoolMutation = { __typename?: 'Mutation', addUserToSchool: { __typename?: 'AddUserToSchoolResult', success: boolean, userId: string, schoolId: string } };

export type MoveUserToSchoolMutationVariables = Exact<{
  input: MoveUserToSchoolInput;
}>;


export type MoveUserToSchoolMutation = { __typename?: 'Mutation', moveUserToSchool: { __typename?: 'MoveUserToSchoolResult', success: boolean, userId: string, schoolId: string } };

export type GetEligibleMetaseasonsForUserQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetEligibleMetaseasonsForUserQuery = { __typename?: 'Query', eligibleMetaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null }> };

export type GetEligibleMetaseasonsForSchoolQueryVariables = Exact<{
  schoolId: Scalars['UUID']['input'];
}>;


export type GetEligibleMetaseasonsForSchoolQuery = { __typename?: 'Query', eligibleMetaseasons: Array<{ __typename?: 'Metaseason', id: string, name: string | null, startsAt: string | null, isPromoted: boolean }> };

export type GetUserTeamsStatsQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
  metaseasonId: Scalars['UUID']['input'];
  phaseType: PhaseType;
}>;


export type GetUserTeamsStatsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, enrolledTeamsByMetaseasonId: Array<{ __typename?: 'Team', id: string, name: string | null, leagues: Array<{ __typename?: 'League', id: string, name: string | null, displayName: string | null, esport: { __typename?: 'Esport', id: string, slug: Types.EsportSlug } }> | null, teamPhaseSummaryByMetaseasonAndPhaseType: { __typename?: 'TeamPhaseSummary', standings: { __typename?: 'PhaseResult', matchesWon: number, matchesLost: number } | null, fortniteTeamRecord: { __typename?: 'FortniteTeamRecord', avgPlacementPerSeason: number | null, placementPointRank: number | null } | null } | null }> | null } | null };

export type UserProfileQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type UserProfileQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, name: string | null, gradYear: number | null, avatarUrl: string | null, playerProfileSnapshot: { __typename?: 'PlayerProfileSnapshot', matchesPlayed: number, seasonsPlayed: number, titlesPlayed: number } | null, roles: Array<{ __typename?: 'UserRole', resourceId: string, roleName: UserRoleName, userId: string, resourceType: ResourceType }> | null, school: { __typename?: 'School', id: string, name: string | null, city: string | null, state: string | null } | null, userProviderAccounts: Array<{ __typename?: 'UserProviderAccount', id: string, userId: string, providerName: string, providerAccountId: string | null, providerDisplayName: string | null }> | null } | null };

export type GetUserAwardsQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetUserAwardsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, assignedWeeklyAwards: Array<{ __typename?: 'AssignedWeeklyPlayerAward', id: string, awardWeekOption: { __typename?: 'AwardWeekOption', startDate: string, endDate: string, beginningOfWeekTime: string } } | null> | null, assignedSeasonalAwards: Array<{ __typename?: 'AssignedSeasonalPlayerAward', id: string, awardTypeId: string, metaseasonId: string, awardType: { __typename?: 'SeasonalPlayerAwardType', id: string, title: string, description: string } | null }> | null } | null };

export type UpdateSpinAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateSpinAccountMutation = { __typename?: 'Mutation', updateSpinAccount: { __typename?: 'UpdateProviderPayload', success: boolean } };

export type SendParentVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendParentVerificationEmailMutation = { __typename?: 'Mutation', sendParentVerificationEmail: { __typename?: 'ParentVerificationPayload', success: boolean } };

export type RequestEmailVerificationMutationVariables = Exact<{
  input: RequestEmailVerificationInput;
}>;


export type RequestEmailVerificationMutation = { __typename?: 'Mutation', requestEmailVerification: { __typename?: 'SuccessPayload', success: boolean } };

export type StartPhoneVerificationMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type StartPhoneVerificationMutation = { __typename?: 'Mutation', startPhoneVerification: { __typename?: 'UserPayload', success: boolean } };

export type ConfirmPhoneVerificationMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ConfirmPhoneVerificationMutation = { __typename?: 'Mutation', confirmPhoneVerification: { __typename?: 'UserPayload', success: boolean } };

export type GetVarsityAssociationsQueryVariables = Exact<{
  input: GetVarsityAssociationsInput;
}>;


export type GetVarsityAssociationsQuery = { __typename?: 'Query', getVarsityAssociations: { __typename?: 'GetVarsityAssociationsResult', total: number | null, result: Array<{ __typename?: 'VarsityAssociation', name: string, abbreviation: string, state: string | null, slug: string, competitionGroup: CompetitionGroup }> | null } };

export type CreateVarsityAssociationMutationVariables = Exact<{
  input: CreateVarsityAssociationAttributes;
}>;


export type CreateVarsityAssociationMutation = { __typename?: 'Mutation', createVarsityAssociation: { __typename?: 'VarsityAssociation', slug: string, name: string, abbreviation: string, state: string | null, competitionGroup: CompetitionGroup } };

export type UpdateVarsityAssociationMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  input: UpdateVarsityAssociationInput;
}>;


export type UpdateVarsityAssociationMutation = { __typename?: 'Mutation', updateVarsityAssociation: { __typename?: 'VarsityAssociation', slug: string, name: string, abbreviation: string, state: string | null, competitionGroup: CompetitionGroup } };

export type GetVarsityAssociationQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetVarsityAssociationQuery = { __typename?: 'Query', getVarsityAssociationBySlug: { __typename?: 'VarsityAssociation', name: string, slug: string, competitionGroup: CompetitionGroup, enrolledSchoolsCount: number | null, abbreviation: string, state: string | null } | null };

export type AddSchoolsToVarsityAssociationMutationVariables = Exact<{
  input: AddSchoolsToVarsityAssociationInput;
}>;


export type AddSchoolsToVarsityAssociationMutation = { __typename?: 'Mutation', addSchoolsToVarsityAssociation: { __typename?: 'BulkActionJobPayload', jobId: string } };

export const GameResultFragmentDoc = gql`
    fragment GameResult on GameResultRequest {
  requestedById
  ordinalNumber
  winningTeamId
  winningPlayerIds
  winningTeamScore
  losingTeamId
  losingPlayerIds
  losingTeamScore
  incompleteReason
  assetIds
  approvedByTeamIds
  gameRejected
  assets {
    id
    fileName
    fileType
    bucket
    signedUrl
  }
}
    `;
export const MatchSettleRequestFragmentDoc = gql`
    fragment MatchSettleRequest on MatchSettleRequestModel {
  id
  matchId
  teamId
  status
  results {
    seriesResults {
      id
      ordinalNumber
      isReadyForReview
      winningTeamId
      gameResults {
        ...GameResult
      }
    }
  }
  incompleteNotes
  isReadyForReview
}
    ${GameResultFragmentDoc}`;
export const EsportDetailsFragmentDoc = gql`
    fragment EsportDetails on EsportDetails {
  esportId
  accountProviders
  features {
    hasSeries
    hasApiIntegration
    hasSubstitutesEnabled
    isDiscordEnabled
    isScrimmageEnabled
    isPlayerLedTeamEnabled
    matchAssistantEnabled
    hasMatchAssistantScore
  }
  competitionGroups
  rankingInfoCopy
  abbreviation
  gameType
  defaultBestOf
  defaultSeriesBestOf
  playerStatRankCategory
  matchOverviewFormat
  rulebookUrl
  platforms
  positions
  positionsArray {
    position
    abbreviation
    colloquial
    name
  }
  matchInstructionsArticleId
  matchAssistantVideoSrc
  scoreDisplayName
  missingConnectionCopy {
    match {
      subtitle
      title
    }
    overview {
      subtitle
      title
    }
  }
  competitionGroups
  assets {
    blackAndWhiteSvgIcon
    avatarLogoUrl
    disabledAvatarLogoUrl
    iconComponent
  }
  teamMinStarterSize
}
    `;
export const MatchTeamFragmentDoc = gql`
    fragment MatchTeam on MatchTeam {
  id
  schoolId
  isMyTeam
  name
  avatarUrl
  league {
    id
  }
  school {
    id
    logoUrl
    name
  }
  competitionGroup
  regularSeasonTeamPhaseStandings {
    winLossRecord {
      matchesWon
      matchesLost
    }
    ranking
    hasClinchedPlayoffs
  }
}
    `;
export const SeriesTeamFragmentDoc = gql`
    fragment SeriesTeam on SeriesTeam {
  id
  seriesId
  schoolId
  name
  roster {
    id
    name
    avatarUrl
    publisherAccountName
  }
  result {
    placing
  }
}
    `;
export const LobbyMatchFragmentDoc = gql`
    fragment LobbyMatch on Match {
  id
  status
  isScrimmage
  forfeitReason
  autoForfeited
  scheduleContext
  scheduledStartsAt
  bestOf
  seriesBestOf
  esport {
    id
    name
    slug
  }
  matchCheckIns {
    id
    teamId
    userId
    status
  }
  matchSettleRequests {
    id
    status
    type
    results {
      seriesResults {
        gameResults {
          winningTeamId
          winningTeamScore
          losingTeamScore
        }
      }
    }
  }
  matchResults {
    id
    gamesWon
    seriesWon
    teamSide
    placing
    teamId
    team {
      id
      name
      isMyTeam
      competitionGroup
      school {
        id
        slug
        name
        logoUrl
      }
      esport {
        id
        rating
      }
    }
  }
  matchDisputeRequests {
    id
    status
  }
  series {
    id
    teamContext {
      seriesId
      teams {
        ...SeriesTeam
      }
    }
  }
  games {
    id
    status
    seriesId
    gameResults {
      id
      teamId
      sidePlayed
      placing
      score
    }
  }
  matchRescheduleRequests {
    id
    status
    teamId
    matchId
    createdAt
    rescheduleNotes
    proposedTimes
  }
  teamContext {
    matchId
    teams {
      id
      name
      competitionGroup
      isMyTeam
      school {
        id
        slug
        name
        logoUrl
      }
      esport {
        id
        rating
      }
    }
  }
  slot {
    id
    phase {
      id
      type
    }
  }
}
    ${SeriesTeamFragmentDoc}`;
export const DmrMatchTeamFragmentDoc = gql`
    fragment DmrMatchTeam on MatchTeam {
  id
  name
  isMyTeam
  school {
    logoUrl
    id
    name
  }
}
    `;
export const DmrMatchSeriesTeamFragmentDoc = gql`
    fragment DmrMatchSeriesTeam on SeriesTeam {
  id
  seriesId
  roster {
    id
    name
    avatarUrl
    publisherAccountName
  }
}
    `;
export const DmrMatchFragmentDoc = gql`
    fragment DmrMatch on Match {
  id
  seriesBestOf
  status
  scheduledStartsAt
  bestOf
  esport {
    slug
    rating
  }
  teamContext {
    matchId
    teams {
      ...DmrMatchTeam
    }
  }
  series {
    id
    bestOf
    teamContext {
      seriesId
      teams {
        ...DmrMatchSeriesTeam
      }
    }
  }
  matchSettleRequests {
    id
    status
    type
    results {
      seriesResults {
        gameResults {
          winningTeamId
          winningTeamScore
          losingTeamScore
        }
      }
    }
  }
  matchResults {
    id
    teamSide
    teamId
    placing
    gamesWon
    seriesWon
    team {
      id
      name
      avatarUrl
      school {
        id
        logoUrl
        name
      }
      roster {
        id
        players {
          user {
            id
            name
            avatarUrl
            userProviderAccounts {
              id
              userId
              providerName
              providerAccountId
              providerDisplayName
              providerIntegrationType
            }
          }
        }
      }
    }
  }
  games {
    id
    status
    seriesId
    gameResults {
      id
      teamId
      sidePlayed
      placing
      score
    }
  }
}
    ${DmrMatchTeamFragmentDoc}
${DmrMatchSeriesTeamFragmentDoc}`;
export const GameAssistantStepFragmentDoc = gql`
    fragment GameAssistantStep on GameAssistantStep {
  id
  matchId
  seriesId
  seriesOrdinal
  gameId
  gameOrdinal
  type
  stepOrdinal
  teamId
  turn
  totalSelections
  selectionOptionType
  submitted
}
    `;
export const GameAssistantSelectionOptionFragmentDoc = gql`
    fragment GameAssistantSelectionOption on GameAssistantSelectionOption {
  id
  type
  displayName
  displayCategory
  slug
  assetUri
  esportId
  earliestGameOrdinal
  unique
}
    `;
export const GameAssistantSelectionFragmentDoc = gql`
    fragment GameAssistantSelection on GameAssistantSelection {
  id
  gameAssistantStep {
    ...GameAssistantStep
  }
  userId
  selectionOption {
    ...GameAssistantSelectionOption
  }
  selectionOptionId
  stepId
  user {
    id
    name
    avatarUrl
  }
}
    ${GameAssistantStepFragmentDoc}
${GameAssistantSelectionOptionFragmentDoc}`;
export const GameAssistantStepWithSelectionsFragmentDoc = gql`
    fragment GameAssistantStepWithSelections on GameAssistantStep {
  ...GameAssistantStep
  selections {
    ...GameAssistantSelection
  }
}
    ${GameAssistantStepFragmentDoc}
${GameAssistantSelectionFragmentDoc}`;
export const GameAssistantTeamScoreFragmentDoc = gql`
    fragment GameAssistantTeamScore on GameAssistantTeamScore {
  teamId
  score
}
    `;
export const GameAssistantGameDetailsFragmentDoc = gql`
    fragment GameAssistantGameDetails on GameAssistantGameDetails {
  timeRemainingInSeconds
  gameOrdinal
  scores {
    ...GameAssistantTeamScore
  }
}
    ${GameAssistantTeamScoreFragmentDoc}`;
export const GameAssistantMatchDetailsFragmentDoc = gql`
    fragment GameAssistantMatchDetails on GameAssistantMatchDetails {
  isComplete
  games {
    ...GameAssistantGameDetails
  }
}
    ${GameAssistantGameDetailsFragmentDoc}`;
export const GameAssistantStepRosterFragmentDoc = gql`
    fragment GameAssistantStepRoster on TeamRoster {
  id
  teamId
  players {
    user {
      id
      name
      avatarUrl
      userProviderAccounts {
        id
        providerName
        providerDisplayName
      }
    }
  }
  formats {
    teamSize
    starters {
      player {
        user {
          id
          name
          avatarUrl
          userProviderAccounts {
            id
            providerName
            providerDisplayName
          }
        }
      }
    }
    substitutes {
      user {
        id
        name
        avatarUrl
        userProviderAccounts {
          id
          providerName
          providerDisplayName
        }
      }
    }
  }
}
    `;
export const GameAssistantStateFragmentDoc = gql`
    fragment GameAssistantState on GameAssistantStatePayload {
  step {
    ...GameAssistantStepWithSelections
  }
  characterBans {
    ...GameAssistantSelection
  }
  characterPicks {
    ...GameAssistantSelection
  }
  mapBans {
    ...GameAssistantSelection
  }
  mapPicks {
    ...GameAssistantSelection
  }
  playerPicks {
    ...GameAssistantSelection
  }
  spectatorPicks {
    ...GameAssistantSelection
  }
  freeStrikeMaps {
    ...GameAssistantSelection
  }
  matchDetails {
    ...GameAssistantMatchDetails
  }
  nextGameRosterChangeRequested
  splatoonGameMode
  showMatchAssistant
  lolGameCode
  currentSeries {
    id
    teamContext {
      seriesId
      teams {
        id
        seriesId
        roster {
          id
          name
          avatarUrl
          publisherAccountName
        }
      }
    }
  }
  roster {
    ...GameAssistantStepRoster
  }
  opponentRoster {
    ...GameAssistantStepRoster
  }
}
    ${GameAssistantStepWithSelectionsFragmentDoc}
${GameAssistantSelectionFragmentDoc}
${GameAssistantMatchDetailsFragmentDoc}
${GameAssistantStepRosterFragmentDoc}`;
export const GameAssistantStateUpdatedFragmentDoc = gql`
    fragment GameAssistantStateUpdated on GameAssistantStepUpdatedSubscribePayload {
  currentState {
    ...GameAssistantState
  }
}
    ${GameAssistantStateFragmentDoc}`;
export const MatchAssistantUserFragmentDoc = gql`
    fragment MatchAssistantUser on User {
  id
  name
  avatarUrl
}
    `;
export const MatchAssistantTeamFragmentDoc = gql`
    fragment MatchAssistantTeam on MatchTeam {
  id
  isMyTeam
  name
  competitionGroup
  avatarUrl
  schoolId
  deletedAt
  school {
    id
    name
  }
  regularSeasonTeamPhaseStandings {
    ranking
    hasClinchedPlayoffs
    winLossRecord {
      matchesWon
      matchesLost
    }
  }
}
    `;
export const CheckPlaceInSmartQueueStateFragmentDoc = gql`
    fragment CheckPlaceInSmartQueueState on SmartQueueStatePayload {
  inQueue
  matchId
  mostRecentPairing
  remainingScheduleJobs
}
    `;
export const CheckPlaceInSmartQueueStateUpdatedFragmentDoc = gql`
    fragment CheckPlaceInSmartQueueStateUpdated on SmartQueueUpdateSubscribePayload {
  currentState {
    ...CheckPlaceInSmartQueueState
  }
}
    ${CheckPlaceInSmartQueueStateFragmentDoc}`;
export const PreseasonQueueDataFragmentDoc = gql`
    fragment PreseasonQueueData on CheckPlaceInPreseasonQueuePayload {
  inQueue
  matchId
  mostRecentPairing
  numTeamsInQueue
  nextScheduledPairing
}
    `;
export const MatchResultTeamFragmentDoc = gql`
    fragment MatchResultTeam on MatchTeam {
  id
  isMyTeam
  name
  school {
    name
    id
    logoUrl
  }
}
    `;
export const MatchSeriesTeamFragmentDoc = gql`
    fragment MatchSeriesTeam on SeriesTeam {
  id
  seriesId
  roster {
    id
    name
    avatarUrl
    lastSeen
    publisherAccountName
  }
}
    `;
export const StatsRateFragmentDoc = gql`
    fragment StatsRate on PlayedWinRate {
  name
  played
  selectionOption {
    id
    assetUri
  }
  winRate
}
    `;
export const SmashUltimateStatsPlayerFragmentDoc = gql`
    fragment SmashUltimateStatsPlayer on MostPlayedStatsByPlayerId {
  playerId
  mostPlayedStages {
    ...StatsRate
  }
  mostPlayedCharacters {
    ...StatsRate
  }
}
    ${StatsRateFragmentDoc}`;
export const SmashUltimateStatsFragmentDoc = gql`
    fragment SmashUltimateStats on GetSmashUltimateMostPlayedStatsByPlayerIdResults {
  players {
    ...SmashUltimateStatsPlayer
  }
}
    ${SmashUltimateStatsPlayerFragmentDoc}`;
export const SmashUltimateGameStatsPlayerFragmentDoc = gql`
    fragment SmashUltimateGameStatsPlayer on SmashUltimateCharacterSelection {
  playerId
  teamId
  characterPlayedOption {
    id
    assetUri
    displayName
  }
}
    `;
export const SmashUltimateGameStatsResultsFragmentDoc = gql`
    fragment SmashUltimateGameStatsResults on SmashUltimateGameStats {
  gameId
  stagePlayed
  winner
  players {
    ...SmashUltimateGameStatsPlayer
  }
}
    ${SmashUltimateGameStatsPlayerFragmentDoc}`;
export const PlayerGameSpecificGameStatsFragmentDoc = gql`
    fragment PlayerGameSpecificGameStats on PlayerGameSpecificGameStats {
  ... on RocketLeaguePlayerGameStats {
    id
    shootingPercentage
    score
    goals
    saves
    assists
    shots
  }
}
    `;
export const PlayerGameStatsFragmentDoc = gql`
    fragment PlayerGameStats on PlayerGameStats {
  teamId
  gameId
  stats {
    ...PlayerGameSpecificGameStats
  }
  rosterStatus
  isKnown
  team {
    id
  }
  publisherAccountId
}
    ${PlayerGameSpecificGameStatsFragmentDoc}`;
export const RocketLeaguePlayerSeasonStatsFragmentDoc = gql`
    fragment RocketLeaguePlayerSeasonStats on RocketLeaguePlayerSeasonStats {
  averageShots
  averageGoals
  averageAssists
  averageSaves
}
    `;
export const SplatoonPlayedWinRateFragmentDoc = gql`
    fragment SplatoonPlayedWinRate on SplatoonPlayedWinRate {
  name
  played
  winRate
}
    `;
export const SplatoonMostPlayedStatsFragmentDoc = gql`
    fragment SplatoonMostPlayedStats on SplatoonMostPlayedStatsByPlayerId {
  playerId
  mostPlayedStages {
    ...SplatoonPlayedWinRate
  }
  mostPlayedCharacters {
    ...SplatoonPlayedWinRate
  }
}
    ${SplatoonPlayedWinRateFragmentDoc}`;
export const MaddenPlayedWinRateFragmentDoc = gql`
    fragment MaddenPlayedWinRate on MaddenPlayedWinRate {
  name
  played
  winRate
  assetUri
}
    `;
export const MaddenMostPlayedStatsFragmentDoc = gql`
    fragment MaddenMostPlayedStats on MaddenMostPlayedStatsByPlayerId {
  playerId
  mostPlayedTeams {
    ...MaddenPlayedWinRate
  }
  mostPlayedOffensivePlaybooks {
    ...MaddenPlayedWinRate
  }
  mostPlayedDefensivePlaybooks {
    ...MaddenPlayedWinRate
  }
}
    ${MaddenPlayedWinRateFragmentDoc}`;
export const NbaPlayedWinRateFragmentDoc = gql`
    fragment NBAPlayedWinRate on NBA2kPlayedWinRate {
  name
  played
  winRate
  assetUri
}
    `;
export const NbaMostPlayedStatsFragmentDoc = gql`
    fragment NBAMostPlayedStats on NBA2kMostPlayedStatsByPlayerId {
  playerId
  mostPlayedTeams {
    ...NBAPlayedWinRate
  }
  averageScore
}
    ${NbaPlayedWinRateFragmentDoc}`;
export const PlayerSeasonStatsFragmentDoc = gql`
    fragment PlayerSeasonStats on PlayerSeasonStats {
  playerId
  seasonId
  rocketLeagueStats {
    ...RocketLeaguePlayerSeasonStats
  }
  splatoonStats {
    ...SplatoonMostPlayedStats
  }
  maddenStats {
    ...MaddenMostPlayedStats
  }
  nba2kStats {
    ...NBAMostPlayedStats
  }
}
    ${RocketLeaguePlayerSeasonStatsFragmentDoc}
${SplatoonMostPlayedStatsFragmentDoc}
${MaddenMostPlayedStatsFragmentDoc}
${NbaMostPlayedStatsFragmentDoc}`;
export const MatchDetailsTeamFragmentDoc = gql`
    fragment MatchDetailsTeam on MatchTeam {
  id
  isMyTeam
  name
  school {
    id
    logoUrl
    name
  }
}
    `;
export const CoachAndOwnerFragmentDoc = gql`
    fragment CoachAndOwner on User {
  id
  avatarUrl
  userProviderAccounts {
    id
    userId
    providerName
    providerAccountId
    providerDisplayName
    providerIntegrationType
  }
  emails {
    id
    email
    isSchoolEmail
  }
  lastSeen
  phone
  name
}
    `;
export const TeamCoachFragmentDoc = gql`
    fragment TeamCoach on TeamCoach {
  id
  avatarUrl
  userProviderAccounts {
    id
    userId
    providerName
    providerAccountId
    providerDisplayName
    providerIntegrationType
  }
  emails {
    id
    email
    isSchoolEmail
  }
  lastSeen
  phone
  name
}
    `;
export const TeamMemberFragmentDoc = gql`
    fragment TeamMember on TeamMember {
  id
  teamId
  effectiveAt
  isCaptain
  name
  firstName
  lastName
  avatarUrl
  lastSeen
  userProviderAccounts {
    id
    userId
    providerName
    providerAccountId
    providerDisplayName
    providerIntegrationType
  }
  userEsportPlatforms {
    platform
    esportId
  }
}
    `;
export const MatchTeamRosterFragmentDoc = gql`
    fragment MatchTeamRoster on TeamRoster {
  teamId
  formats {
    starters {
      player {
        isCaptain
        effectiveAt
        user {
          id
          firstName
          lastName
          avatarUrl
          lastSeen
          userProviderAccounts {
            id
            userId
            providerName
            providerAccountId
            providerDisplayName
            providerIntegrationType
          }
        }
      }
      position {
        id
        index
      }
    }
    substitutes {
      isCaptain
      effectiveAt
      user {
        id
        firstName
        lastName
        avatarUrl
        lastSeen
        userProviderAccounts {
          id
          userId
          providerName
          providerAccountId
          providerDisplayName
          providerIntegrationType
        }
      }
    }
    teamSize
  }
}
    `;
export const TeamMatchesFragmentDoc = gql`
    fragment TeamMatches on Match {
  id
  status
  bestOf
  scheduledStartsAt
  isScrimmage
  name
  scheduleContext
  esport {
    id
    slug
    rating
  }
  slot {
    id
    phase {
      id
      name
      format
      type
    }
  }
  league {
    id
    timezone
  }
  matchResults {
    id
    matchId
    gamesWon
    gamesLost
    gamesTied
    seriesWon
    seriesLost
    seriesTied
    placing
    team {
      id
      name
      deletedAt
      school {
        id
        name
        logoUrl
      }
    }
  }
}
    `;
export const PlayerReplayStatFragmentDoc = gql`
    fragment PlayerReplayStat on PlayerReplayStat {
  title
  subtext
  value
  statName
  teamId
  team {
    id
    name
    school {
      id
      name
      logoUrl
    }
  }
}
    `;
export const PlayerReplayUserFragmentDoc = gql`
    fragment PlayerReplayUser on User {
  id
  name
  avatarUrl
}
    `;
export const TeamRivalDataFragmentDoc = gql`
    fragment TeamRivalData on Team {
  id
  name
  school {
    id
    logoUrl
    name
  }
}
    `;
export const TeamRivalFragmentDoc = gql`
    fragment TeamRival on TeamRival {
  id
  seasonId
  requestingTeamId
  acceptingTeamId
  acceptingTeam {
    ...TeamRivalData
  }
  requestingTeam {
    ...TeamRivalData
  }
  status
}
    ${TeamRivalDataFragmentDoc}`;
export const PossibleTeamRivalFragmentDoc = gql`
    fragment PossibleTeamRival on PossibleTeamRivalPayload {
  schoolId
  teamId
  school {
    id
    logoUrl
    name
  }
  team {
    id
    name
  }
  hasActiveRivalInSeason
}
    `;
export const RefetchMatchFragmentFragmentDoc = gql`
    fragment RefetchMatchFragment on Match {
  id
  status
  forfeitReason
  autoForfeited
  matchResults {
    id
    teamSide
    metaseasonId
    team {
      id
      name
      members {
        id
        teamId
        effectiveAt
        name
        teamId
        avatarUrl
        isCaptain
        position
        userProviderAccounts {
          id
          userId
          providerName
          providerAccountId
          providerDisplayName
          providerIntegrationType
          createdAt
          updatedAt
        }
      }
      leagues {
        id
      }
      school {
        id
        name
        logoUrl
      }
      enrolledSeasons {
        id
        metaseasonId
        startsAt
        metaseason {
          id
          startsAt
          endsAt
          name
          isPromoted
        }
      }
    }
  }
  series {
    id
    bestOf
    teamContext {
      seriesId
      teams {
        id
        seriesId
        roster {
          id
          name
          avatarUrl
          publisherAccountName
        }
      }
    }
  }
  games {
    id
    status
    seriesId
    gameResults {
      id
      teamId
      sidePlayed
      placing
    }
  }
}
    `;
export const EventSeasonFragmentDoc = gql`
    fragment EventSeason on Season {
  id
  name
  startsAt
  teamRegistrationEndsAt
  endsAt
  suggestedRegistrationEndsAt
  rostersLockAt
  numberOfPlayers
  numberOfTeams
  leagueId
  eventConfig {
    maxTeamsAllowed
    eventBestOf
  }
  sponsorshipImages {
    id
    entityId
    entityType
    name
    updatedAt
    url
  }
  metaseason {
    id
    name
    startsAt
    endsAt
    isPromoted
  }
  activePhases {
    id
    status
    startsAt
    endsAt
    format
    name
    type
    bracketSize
    slots {
      id
      label
      name
      isStartsAtHidden
      startsAt
      order
      ordinal
    }
  }
  currentPhase {
    id
    startsAt
    endsAt
    type
    slots {
      id
      startsAt
      name
    }
  }
  league {
    id
    teamFormat
    teamMaxSize
    esport {
      id
      name
      slug
      details {
        platforms
        gameType
        abbreviation
        esportId
      }
    }
    sponsorshipComponents {
      id
      entityId
      entityType
      name
      title
      subtitle
      url
      callToAction
      sponsorshipImages {
        id
        entityId
        entityType
        name
        updatedAt
        url
      }
    }
  }
}
    `;
export const UserSeasonResultsFragmentDoc = gql`
    fragment UserSeasonResults on UserSeasonsResult {
  seasons {
    ...EventSeason
  }
}
    ${EventSeasonFragmentDoc}`;
export const EventSeasonWithConfigFragmentDoc = gql`
    fragment EventSeasonWithConfig on Season {
  ...EventSeason
  eventConfig {
    id
    seasonId
    eventDetails
    prizeDetails
    minAge
    maxAge
    maxTeamsAllowed
    eventBestOf
    eventStatus
    surveyId
  }
}
    ${EventSeasonFragmentDoc}`;
export const EventSeasonTeamWithConfigFragmentDoc = gql`
    fragment EventSeasonTeamWithConfig on Season {
  ...EventSeason
  eventConfig {
    isUserAbleToJoinEvent {
      result
      reason
    }
    userEventTeam {
      id
      name
      avatarUrl
      roster {
        id
        formats {
          starters {
            player {
              user {
                id
              }
              effectiveAt
            }
            position {
              id
              index
            }
          }
        }
      }
      enrolledSeasons {
        id
      }
    }
  }
}
    ${EventSeasonFragmentDoc}`;
export const TeamPlayerFragmentDoc = gql`
    fragment TeamPlayer on TeamPlayer {
  user {
    id
    userProviderAccounts {
      id
      userId
      providerName
      providerAccountId
      providerDisplayName
      providerIntegrationType
    }
  }
}
    `;
export const LeagueTeamFragmentDoc = gql`
    fragment LeagueTeam on Team {
  id
  slug
  name
  createdAt @include(if: $isStadium)
  enrollmentStatus(seasonId: $seasonId) @include(if: $isStadium)
  avatarUrl @include(if: $isStadium)
  captain @include(if: $isStadium) {
    id
    name
  }
  roster {
    numPlayers
  }
  seasonTeams {
    seasonId
    metaseasonId
    leagueId
    teamId
    createdAt
    deletedAt
  }
  school @skip(if: $isStadium) {
    id
    name
    state
    logoUrl
    varsityAssociations {
      slug
      name
    }
  }
  coaches @skip(if: $isStadium) {
    id
    name
    coachType
    emails {
      id
      email
      isSchoolEmail
      deletedAt
    }
  }
}
    `;
export const SchoolTeamFragmentDoc = gql`
    fragment SchoolTeam on Team {
  id
  name
  createdAt
  deletedAt
  esport {
    id
    slug
    name
    leagueDefaults {
      teamFormat
    }
  }
  seasons {
    id
    startsAt
    metaseason {
      id
      name
    }
  }
  roster {
    id
    players {
      user {
        id
      }
      effectiveAt
    }
  }
}
    `;
export const GetMyRolesDocument = gql`
    query getMyRoles {
  me {
    id
    roles {
      userId
      roleName
      resourceType
      resourceId
    }
    schoolRoleStatus {
      role {
        roleName
      }
      status
    }
  }
}
    `;

/**
 * __useGetMyRolesQuery__
 *
 * To run a query within a React component, call `useGetMyRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyRolesQuery, GetMyRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyRolesQuery, GetMyRolesQueryVariables>(GetMyRolesDocument, options);
      }
export function useGetMyRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyRolesQuery, GetMyRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyRolesQuery, GetMyRolesQueryVariables>(GetMyRolesDocument, options);
        }
export type GetMyRolesQueryHookResult = ReturnType<typeof useGetMyRolesQuery>;
export type GetMyRolesLazyQueryHookResult = ReturnType<typeof useGetMyRolesLazyQuery>;
export type GetMyRolesQueryResult = Apollo.QueryResult<GetMyRolesQuery, GetMyRolesQueryVariables>;
export function refetchGetMyRolesQuery(variables?: GetMyRolesQueryVariables) {
      return { query: GetMyRolesDocument, variables: variables }
    }
export const GetMyAccountDetailsDocument = gql`
    query getMyAccountDetails {
  me {
    id
    avatarUrl
    school {
      id
    }
    school {
      id
      name
      city
      state
      logoUrl
    }
    schoolRoleStatus {
      role {
        roleName
      }
      status
    }
    dateOfBirth
    firstName
    lastName
    username
    name
    additionalInfo
    email
    emails {
      id
      activeUpdateRequest {
        newEmail
        expiresAt
      }
      email
      isVerified
      isSchoolEmail
      updatedAt
    }
    dateOfBirth
    gradYear
    phone
    phoneExt
    isPhoneNumberVisible
    esportInterests {
      id
      slug
    }
    isParent
    parent {
      id
    }
    state
    country
    userDemographics {
      gender
      race
    }
  }
}
    `;

/**
 * __useGetMyAccountDetailsQuery__
 *
 * To run a query within a React component, call `useGetMyAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAccountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAccountDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyAccountDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAccountDetailsQuery, GetMyAccountDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAccountDetailsQuery, GetMyAccountDetailsQueryVariables>(GetMyAccountDetailsDocument, options);
      }
export function useGetMyAccountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAccountDetailsQuery, GetMyAccountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAccountDetailsQuery, GetMyAccountDetailsQueryVariables>(GetMyAccountDetailsDocument, options);
        }
export type GetMyAccountDetailsQueryHookResult = ReturnType<typeof useGetMyAccountDetailsQuery>;
export type GetMyAccountDetailsLazyQueryHookResult = ReturnType<typeof useGetMyAccountDetailsLazyQuery>;
export type GetMyAccountDetailsQueryResult = Apollo.QueryResult<GetMyAccountDetailsQuery, GetMyAccountDetailsQueryVariables>;
export function refetchGetMyAccountDetailsQuery(variables?: GetMyAccountDetailsQueryVariables) {
      return { query: GetMyAccountDetailsDocument, variables: variables }
    }
export const GetMyVerificationStatusDocument = gql`
    query getMyVerificationStatus {
  me {
    id
    school {
      id
      sheeridOrganizationId
    }
    roles {
      roleName
      resourceType
      userId
      resourceId
    }
    currentVerification {
      id
      step
    }
  }
}
    `;

/**
 * __useGetMyVerificationStatusQuery__
 *
 * To run a query within a React component, call `useGetMyVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyVerificationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyVerificationStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetMyVerificationStatusQuery, GetMyVerificationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyVerificationStatusQuery, GetMyVerificationStatusQueryVariables>(GetMyVerificationStatusDocument, options);
      }
export function useGetMyVerificationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyVerificationStatusQuery, GetMyVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyVerificationStatusQuery, GetMyVerificationStatusQueryVariables>(GetMyVerificationStatusDocument, options);
        }
export type GetMyVerificationStatusQueryHookResult = ReturnType<typeof useGetMyVerificationStatusQuery>;
export type GetMyVerificationStatusLazyQueryHookResult = ReturnType<typeof useGetMyVerificationStatusLazyQuery>;
export type GetMyVerificationStatusQueryResult = Apollo.QueryResult<GetMyVerificationStatusQuery, GetMyVerificationStatusQueryVariables>;
export function refetchGetMyVerificationStatusQuery(variables?: GetMyVerificationStatusQueryVariables) {
      return { query: GetMyVerificationStatusDocument, variables: variables }
    }
export const GetMySchoolDetailsDocument = gql`
    query getMySchoolDetails {
  me {
    id
    school {
      id
      address
      city
      state
      zip
      districtClassification
      timezone
      detail {
        at
        it {
          osType
          suppStaff {
            email
            fname
            lname
            phone
          }
          hasDedicatedLab
          numStudentComps
          suppStaffOnCampus
          publicIP
          agreeToInstallGames
          agreeToWhitelistPorts
          agreeToDoPatchUpdates
        }
      }
      name
      slug
      mascotName
      logoUrl
      whoPays
      allowPlayerLedTeams
      allowCaptainEnrollment
      showCoachEmails
      competitionGroup
      dismissalTime
    }
  }
}
    `;

/**
 * __useGetMySchoolDetailsQuery__
 *
 * To run a query within a React component, call `useGetMySchoolDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySchoolDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySchoolDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySchoolDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySchoolDetailsQuery, GetMySchoolDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySchoolDetailsQuery, GetMySchoolDetailsQueryVariables>(GetMySchoolDetailsDocument, options);
      }
export function useGetMySchoolDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySchoolDetailsQuery, GetMySchoolDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySchoolDetailsQuery, GetMySchoolDetailsQueryVariables>(GetMySchoolDetailsDocument, options);
        }
export type GetMySchoolDetailsQueryHookResult = ReturnType<typeof useGetMySchoolDetailsQuery>;
export type GetMySchoolDetailsLazyQueryHookResult = ReturnType<typeof useGetMySchoolDetailsLazyQuery>;
export type GetMySchoolDetailsQueryResult = Apollo.QueryResult<GetMySchoolDetailsQuery, GetMySchoolDetailsQueryVariables>;
export function refetchGetMySchoolDetailsQuery(variables?: GetMySchoolDetailsQueryVariables) {
      return { query: GetMySchoolDetailsDocument, variables: variables }
    }
export const GetMyIdentityDocument = gql`
    query getMyIdentity {
  me {
    id
    hmac
    avatarUrl
    emails {
      email
      isSchoolEmail
      isVerified
    }
    promotionalEmail
    name
    firstName
    lastName
    username
    school {
      id
      name
      competitionGroup
      city
      state
      country
      deletedAt
      type
      teams {
        id
        schoolId
      }
      activeCampaign {
        sponsorshipImages {
          id
          entityId
          entityType
          name
          updatedAt
          url
        }
        sponsorshipComponents {
          id
          entityId
          entityType
          name
          title
          subtitle
          url
          callToAction
          sponsorshipImages {
            id
            entityId
            entityType
            name
            updatedAt
            url
          }
        }
      }
    }
    roles {
      userId
      roleName
      resourceType
      resourceId
      status
    }
    schoolRoleStatus {
      role {
        userId
        roleName
        resourceType
        resourceId
      }
      status
    }
    hasMultiorgAccess
    isParent
    isUnderage
    state
    gradYears {
      gradYear
      schoolId
    }
    teams {
      id
      esport {
        id
        slug
      }
    }
    phone
  }
}
    `;

/**
 * __useGetMyIdentityQuery__
 *
 * To run a query within a React component, call `useGetMyIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyIdentityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyIdentityQuery(baseOptions?: Apollo.QueryHookOptions<GetMyIdentityQuery, GetMyIdentityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyIdentityQuery, GetMyIdentityQueryVariables>(GetMyIdentityDocument, options);
      }
export function useGetMyIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyIdentityQuery, GetMyIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyIdentityQuery, GetMyIdentityQueryVariables>(GetMyIdentityDocument, options);
        }
export type GetMyIdentityQueryHookResult = ReturnType<typeof useGetMyIdentityQuery>;
export type GetMyIdentityLazyQueryHookResult = ReturnType<typeof useGetMyIdentityLazyQuery>;
export type GetMyIdentityQueryResult = Apollo.QueryResult<GetMyIdentityQuery, GetMyIdentityQueryVariables>;
export function refetchGetMyIdentityQuery(variables?: GetMyIdentityQueryVariables) {
      return { query: GetMyIdentityDocument, variables: variables }
    }
export const GetManagedTeamsDocument = gql`
    query getManagedTeams($schoolId: UUID!) {
  me {
    id
    managedTeams(schoolId: $schoolId) {
      id
      esport {
        id
        slug
      }
    }
  }
}
    `;

/**
 * __useGetManagedTeamsQuery__
 *
 * To run a query within a React component, call `useGetManagedTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedTeamsQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetManagedTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetManagedTeamsQuery, GetManagedTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagedTeamsQuery, GetManagedTeamsQueryVariables>(GetManagedTeamsDocument, options);
      }
export function useGetManagedTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagedTeamsQuery, GetManagedTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagedTeamsQuery, GetManagedTeamsQueryVariables>(GetManagedTeamsDocument, options);
        }
export type GetManagedTeamsQueryHookResult = ReturnType<typeof useGetManagedTeamsQuery>;
export type GetManagedTeamsLazyQueryHookResult = ReturnType<typeof useGetManagedTeamsLazyQuery>;
export type GetManagedTeamsQueryResult = Apollo.QueryResult<GetManagedTeamsQuery, GetManagedTeamsQueryVariables>;
export function refetchGetManagedTeamsQuery(variables: GetManagedTeamsQueryVariables) {
      return { query: GetManagedTeamsDocument, variables: variables }
    }
export const GetMyProviderAccountsDocument = gql`
    query getMyProviderAccounts {
  me {
    userProviderAccounts {
      id
      providerName
      providerDisplayName
      providerOnboardUrl
    }
    hasMultiorgAccess
  }
}
    `;

/**
 * __useGetMyProviderAccountsQuery__
 *
 * To run a query within a React component, call `useGetMyProviderAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProviderAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProviderAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProviderAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyProviderAccountsQuery, GetMyProviderAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProviderAccountsQuery, GetMyProviderAccountsQueryVariables>(GetMyProviderAccountsDocument, options);
      }
export function useGetMyProviderAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProviderAccountsQuery, GetMyProviderAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProviderAccountsQuery, GetMyProviderAccountsQueryVariables>(GetMyProviderAccountsDocument, options);
        }
export type GetMyProviderAccountsQueryHookResult = ReturnType<typeof useGetMyProviderAccountsQuery>;
export type GetMyProviderAccountsLazyQueryHookResult = ReturnType<typeof useGetMyProviderAccountsLazyQuery>;
export type GetMyProviderAccountsQueryResult = Apollo.QueryResult<GetMyProviderAccountsQuery, GetMyProviderAccountsQueryVariables>;
export function refetchGetMyProviderAccountsQuery(variables?: GetMyProviderAccountsQueryVariables) {
      return { query: GetMyProviderAccountsDocument, variables: variables }
    }
export const GetCoachesAtMySchoolDocument = gql`
    query getCoachesAtMySchool {
  me {
    id
    school {
      id
      coachRolePendingUsers {
        id
        name
        createdAt
        emails {
          id
          email
          isSchoolEmail
        }
        avatarUrl
      }
      coaches {
        id
        name
        createdAt
        emails {
          id
          email
          isSchoolEmail
        }
        avatarUrl
      }
      deniedCoaches {
        id
        name
        createdAt
        emails {
          id
          email
          isSchoolEmail
        }
        avatarUrl
      }
    }
  }
}
    `;

/**
 * __useGetCoachesAtMySchoolQuery__
 *
 * To run a query within a React component, call `useGetCoachesAtMySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachesAtMySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachesAtMySchoolQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoachesAtMySchoolQuery(baseOptions?: Apollo.QueryHookOptions<GetCoachesAtMySchoolQuery, GetCoachesAtMySchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachesAtMySchoolQuery, GetCoachesAtMySchoolQueryVariables>(GetCoachesAtMySchoolDocument, options);
      }
export function useGetCoachesAtMySchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachesAtMySchoolQuery, GetCoachesAtMySchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachesAtMySchoolQuery, GetCoachesAtMySchoolQueryVariables>(GetCoachesAtMySchoolDocument, options);
        }
export type GetCoachesAtMySchoolQueryHookResult = ReturnType<typeof useGetCoachesAtMySchoolQuery>;
export type GetCoachesAtMySchoolLazyQueryHookResult = ReturnType<typeof useGetCoachesAtMySchoolLazyQuery>;
export type GetCoachesAtMySchoolQueryResult = Apollo.QueryResult<GetCoachesAtMySchoolQuery, GetCoachesAtMySchoolQueryVariables>;
export function refetchGetCoachesAtMySchoolQuery(variables?: GetCoachesAtMySchoolQueryVariables) {
      return { query: GetCoachesAtMySchoolDocument, variables: variables }
    }
export const IsPasswordResetValidDocument = gql`
    query isPasswordResetValid($input: VerifyPasswordResetInput) {
  isPasswordResetValid(input: $input) {
    isValid
  }
}
    `;

/**
 * __useIsPasswordResetValidQuery__
 *
 * To run a query within a React component, call `useIsPasswordResetValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPasswordResetValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPasswordResetValidQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsPasswordResetValidQuery(baseOptions?: Apollo.QueryHookOptions<IsPasswordResetValidQuery, IsPasswordResetValidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsPasswordResetValidQuery, IsPasswordResetValidQueryVariables>(IsPasswordResetValidDocument, options);
      }
export function useIsPasswordResetValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsPasswordResetValidQuery, IsPasswordResetValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsPasswordResetValidQuery, IsPasswordResetValidQueryVariables>(IsPasswordResetValidDocument, options);
        }
export type IsPasswordResetValidQueryHookResult = ReturnType<typeof useIsPasswordResetValidQuery>;
export type IsPasswordResetValidLazyQueryHookResult = ReturnType<typeof useIsPasswordResetValidLazyQuery>;
export type IsPasswordResetValidQueryResult = Apollo.QueryResult<IsPasswordResetValidQuery, IsPasswordResetValidQueryVariables>;
export function refetchIsPasswordResetValidQuery(variables?: IsPasswordResetValidQueryVariables) {
      return { query: IsPasswordResetValidDocument, variables: variables }
    }
export const GetParentEmailDocument = gql`
    query getParentEmail {
  me {
    id
    firstName
    emails {
      id
      email
    }
  }
}
    `;

/**
 * __useGetParentEmailQuery__
 *
 * To run a query within a React component, call `useGetParentEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentEmailQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetParentEmailQuery(baseOptions?: Apollo.QueryHookOptions<GetParentEmailQuery, GetParentEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentEmailQuery, GetParentEmailQueryVariables>(GetParentEmailDocument, options);
      }
export function useGetParentEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParentEmailQuery, GetParentEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentEmailQuery, GetParentEmailQueryVariables>(GetParentEmailDocument, options);
        }
export type GetParentEmailQueryHookResult = ReturnType<typeof useGetParentEmailQuery>;
export type GetParentEmailLazyQueryHookResult = ReturnType<typeof useGetParentEmailLazyQuery>;
export type GetParentEmailQueryResult = Apollo.QueryResult<GetParentEmailQuery, GetParentEmailQueryVariables>;
export function refetchGetParentEmailQuery(variables?: GetParentEmailQueryVariables) {
      return { query: GetParentEmailDocument, variables: variables }
    }
export const ChangeMyPasswordDocument = gql`
    mutation changeMyPassword($input: ChangeMyPasswordInput!) {
  changeMyPassword(input: $input) {
    success
  }
}
    `;
export type ChangeMyPasswordMutationFn = Apollo.MutationFunction<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>;

/**
 * __useChangeMyPasswordMutation__
 *
 * To run a mutation, you first call `useChangeMyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMyPasswordMutation, { data, loading, error }] = useChangeMyPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeMyPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>(ChangeMyPasswordDocument, options);
      }
export type ChangeMyPasswordMutationHookResult = ReturnType<typeof useChangeMyPasswordMutation>;
export type ChangeMyPasswordMutationResult = Apollo.MutationResult<ChangeMyPasswordMutation>;
export type ChangeMyPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>;
export const SetMyAccountSettingsDocument = gql`
    mutation setMyAccountSettings($input: SetMyAccountSettingsInput!) {
  setMyAccountSettings(input: $input) {
    success
  }
}
    `;
export type SetMyAccountSettingsMutationFn = Apollo.MutationFunction<SetMyAccountSettingsMutation, SetMyAccountSettingsMutationVariables>;

/**
 * __useSetMyAccountSettingsMutation__
 *
 * To run a mutation, you first call `useSetMyAccountSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyAccountSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyAccountSettingsMutation, { data, loading, error }] = useSetMyAccountSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMyAccountSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SetMyAccountSettingsMutation, SetMyAccountSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyAccountSettingsMutation, SetMyAccountSettingsMutationVariables>(SetMyAccountSettingsDocument, options);
      }
export type SetMyAccountSettingsMutationHookResult = ReturnType<typeof useSetMyAccountSettingsMutation>;
export type SetMyAccountSettingsMutationResult = Apollo.MutationResult<SetMyAccountSettingsMutation>;
export type SetMyAccountSettingsMutationOptions = Apollo.BaseMutationOptions<SetMyAccountSettingsMutation, SetMyAccountSettingsMutationVariables>;
export const CreateUserEmailDocument = gql`
    mutation createUserEmail($userId: String!, $attributes: UserEmailInputAttributes!, $options: CreateUserEmailOptions!) {
  createUserEmail(userId: $userId, attributes: $attributes, options: $options) {
    userId
    email
    isSchoolEmail
  }
}
    `;
export type CreateUserEmailMutationFn = Apollo.MutationFunction<CreateUserEmailMutation, CreateUserEmailMutationVariables>;

/**
 * __useCreateUserEmailMutation__
 *
 * To run a mutation, you first call `useCreateUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserEmailMutation, { data, loading, error }] = useCreateUserEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      attributes: // value for 'attributes'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCreateUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserEmailMutation, CreateUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserEmailMutation, CreateUserEmailMutationVariables>(CreateUserEmailDocument, options);
      }
export type CreateUserEmailMutationHookResult = ReturnType<typeof useCreateUserEmailMutation>;
export type CreateUserEmailMutationResult = Apollo.MutationResult<CreateUserEmailMutation>;
export type CreateUserEmailMutationOptions = Apollo.BaseMutationOptions<CreateUserEmailMutation, CreateUserEmailMutationVariables>;
export const RequestAccountEditDocument = gql`
    mutation requestAccountEdit($password: String!) {
  requestAccountEdit(input: {password: $password}) {
    expiresAt
  }
}
    `;
export type RequestAccountEditMutationFn = Apollo.MutationFunction<RequestAccountEditMutation, RequestAccountEditMutationVariables>;

/**
 * __useRequestAccountEditMutation__
 *
 * To run a mutation, you first call `useRequestAccountEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccountEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccountEditMutation, { data, loading, error }] = useRequestAccountEditMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRequestAccountEditMutation(baseOptions?: Apollo.MutationHookOptions<RequestAccountEditMutation, RequestAccountEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAccountEditMutation, RequestAccountEditMutationVariables>(RequestAccountEditDocument, options);
      }
export type RequestAccountEditMutationHookResult = ReturnType<typeof useRequestAccountEditMutation>;
export type RequestAccountEditMutationResult = Apollo.MutationResult<RequestAccountEditMutation>;
export type RequestAccountEditMutationOptions = Apollo.BaseMutationOptions<RequestAccountEditMutation, RequestAccountEditMutationVariables>;
export const RequestEmailUpdateDocument = gql`
    mutation requestEmailUpdate($oldEmail: String!, $newEmail: String!) {
  requestEmailUpdate(input: {oldEmail: $oldEmail, newEmail: $newEmail}) {
    userEmail {
      id
      isVerified
      activeUpdateRequest {
        newEmail
        expiresAt
      }
      email
      isSchoolEmail
      updatedAt
    }
  }
}
    `;
export type RequestEmailUpdateMutationFn = Apollo.MutationFunction<RequestEmailUpdateMutation, RequestEmailUpdateMutationVariables>;

/**
 * __useRequestEmailUpdateMutation__
 *
 * To run a mutation, you first call `useRequestEmailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailUpdateMutation, { data, loading, error }] = useRequestEmailUpdateMutation({
 *   variables: {
 *      oldEmail: // value for 'oldEmail'
 *      newEmail: // value for 'newEmail'
 *   },
 * });
 */
export function useRequestEmailUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RequestEmailUpdateMutation, RequestEmailUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEmailUpdateMutation, RequestEmailUpdateMutationVariables>(RequestEmailUpdateDocument, options);
      }
export type RequestEmailUpdateMutationHookResult = ReturnType<typeof useRequestEmailUpdateMutation>;
export type RequestEmailUpdateMutationResult = Apollo.MutationResult<RequestEmailUpdateMutation>;
export type RequestEmailUpdateMutationOptions = Apollo.BaseMutationOptions<RequestEmailUpdateMutation, RequestEmailUpdateMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation requestPasswordReset($email: String!) {
  requestPasswordReset(email: $email) {
    success
  }
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const FullFillPasswordResetDocument = gql`
    mutation fullFillPasswordReset($resetCode: String!, $newPassword: String!) {
  fullFillPasswordReset(resetCode: $resetCode, newPassword: $newPassword) {
    success
  }
}
    `;
export type FullFillPasswordResetMutationFn = Apollo.MutationFunction<FullFillPasswordResetMutation, FullFillPasswordResetMutationVariables>;

/**
 * __useFullFillPasswordResetMutation__
 *
 * To run a mutation, you first call `useFullFillPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFullFillPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fullFillPasswordResetMutation, { data, loading, error }] = useFullFillPasswordResetMutation({
 *   variables: {
 *      resetCode: // value for 'resetCode'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useFullFillPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<FullFillPasswordResetMutation, FullFillPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FullFillPasswordResetMutation, FullFillPasswordResetMutationVariables>(FullFillPasswordResetDocument, options);
      }
export type FullFillPasswordResetMutationHookResult = ReturnType<typeof useFullFillPasswordResetMutation>;
export type FullFillPasswordResetMutationResult = Apollo.MutationResult<FullFillPasswordResetMutation>;
export type FullFillPasswordResetMutationOptions = Apollo.BaseMutationOptions<FullFillPasswordResetMutation, FullFillPasswordResetMutationVariables>;
export const SetSchoolLogoDocument = gql`
    mutation setSchoolLogo($schoolId: UUID!, $file: Upload!) {
  setSchoolLogo(schoolId: $schoolId, file: $file) {
    success
  }
}
    `;
export type SetSchoolLogoMutationFn = Apollo.MutationFunction<SetSchoolLogoMutation, SetSchoolLogoMutationVariables>;

/**
 * __useSetSchoolLogoMutation__
 *
 * To run a mutation, you first call `useSetSchoolLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSchoolLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSchoolLogoMutation, { data, loading, error }] = useSetSchoolLogoMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSetSchoolLogoMutation(baseOptions?: Apollo.MutationHookOptions<SetSchoolLogoMutation, SetSchoolLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSchoolLogoMutation, SetSchoolLogoMutationVariables>(SetSchoolLogoDocument, options);
      }
export type SetSchoolLogoMutationHookResult = ReturnType<typeof useSetSchoolLogoMutation>;
export type SetSchoolLogoMutationResult = Apollo.MutationResult<SetSchoolLogoMutation>;
export type SetSchoolLogoMutationOptions = Apollo.BaseMutationOptions<SetSchoolLogoMutation, SetSchoolLogoMutationVariables>;
export const UpdateSchoolProfileDocument = gql`
    mutation updateSchoolProfile($schoolId: UUID!, $input: SetSchoolProfileInput!) {
  updateSchoolProfile(schoolId: $schoolId, input: $input) {
    id
    mascotName
    address
    logoUrl
  }
}
    `;
export type UpdateSchoolProfileMutationFn = Apollo.MutationFunction<UpdateSchoolProfileMutation, UpdateSchoolProfileMutationVariables>;

/**
 * __useUpdateSchoolProfileMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolProfileMutation, { data, loading, error }] = useUpdateSchoolProfileMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSchoolProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchoolProfileMutation, UpdateSchoolProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchoolProfileMutation, UpdateSchoolProfileMutationVariables>(UpdateSchoolProfileDocument, options);
      }
export type UpdateSchoolProfileMutationHookResult = ReturnType<typeof useUpdateSchoolProfileMutation>;
export type UpdateSchoolProfileMutationResult = Apollo.MutationResult<UpdateSchoolProfileMutation>;
export type UpdateSchoolProfileMutationOptions = Apollo.BaseMutationOptions<UpdateSchoolProfileMutation, UpdateSchoolProfileMutationVariables>;
export const UpdateSchoolDetailDocument = gql`
    mutation updateSchoolDetail($schoolId: UUID!, $detail: SchoolDetailInput!) {
  updateSchoolDetail(schoolId: $schoolId, detail: $detail) {
    id
    detail {
      at
      it {
        osType
        suppStaff {
          email
          fname
          lname
          phone
        }
        hasDedicatedLab
        numStudentComps
        suppStaffOnCampus
        publicIP
        agreeToInstallGames
        agreeToWhitelistPorts
        agreeToDoPatchUpdates
      }
    }
  }
}
    `;
export type UpdateSchoolDetailMutationFn = Apollo.MutationFunction<UpdateSchoolDetailMutation, UpdateSchoolDetailMutationVariables>;

/**
 * __useUpdateSchoolDetailMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolDetailMutation, { data, loading, error }] = useUpdateSchoolDetailMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      detail: // value for 'detail'
 *   },
 * });
 */
export function useUpdateSchoolDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchoolDetailMutation, UpdateSchoolDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchoolDetailMutation, UpdateSchoolDetailMutationVariables>(UpdateSchoolDetailDocument, options);
      }
export type UpdateSchoolDetailMutationHookResult = ReturnType<typeof useUpdateSchoolDetailMutation>;
export type UpdateSchoolDetailMutationResult = Apollo.MutationResult<UpdateSchoolDetailMutation>;
export type UpdateSchoolDetailMutationOptions = Apollo.BaseMutationOptions<UpdateSchoolDetailMutation, UpdateSchoolDetailMutationVariables>;
export const VerifyCoachDocument = gql`
    mutation verifyCoach($userId: UUID!, $resourceId: UUID!) {
  verifyCoach(userId: $userId, resourceId: $resourceId) {
    success
  }
}
    `;
export type VerifyCoachMutationFn = Apollo.MutationFunction<VerifyCoachMutation, VerifyCoachMutationVariables>;

/**
 * __useVerifyCoachMutation__
 *
 * To run a mutation, you first call `useVerifyCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCoachMutation, { data, loading, error }] = useVerifyCoachMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useVerifyCoachMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCoachMutation, VerifyCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCoachMutation, VerifyCoachMutationVariables>(VerifyCoachDocument, options);
      }
export type VerifyCoachMutationHookResult = ReturnType<typeof useVerifyCoachMutation>;
export type VerifyCoachMutationResult = Apollo.MutationResult<VerifyCoachMutation>;
export type VerifyCoachMutationOptions = Apollo.BaseMutationOptions<VerifyCoachMutation, VerifyCoachMutationVariables>;
export const DenyCoachDocument = gql`
    mutation denyCoach($userId: UUID!, $resourceId: UUID!, $reason: String) {
  denyCoach(userId: $userId, resourceId: $resourceId, reason: $reason) {
    id
  }
}
    `;
export type DenyCoachMutationFn = Apollo.MutationFunction<DenyCoachMutation, DenyCoachMutationVariables>;

/**
 * __useDenyCoachMutation__
 *
 * To run a mutation, you first call `useDenyCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyCoachMutation, { data, loading, error }] = useDenyCoachMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      resourceId: // value for 'resourceId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDenyCoachMutation(baseOptions?: Apollo.MutationHookOptions<DenyCoachMutation, DenyCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyCoachMutation, DenyCoachMutationVariables>(DenyCoachDocument, options);
      }
export type DenyCoachMutationHookResult = ReturnType<typeof useDenyCoachMutation>;
export type DenyCoachMutationResult = Apollo.MutationResult<DenyCoachMutation>;
export type DenyCoachMutationOptions = Apollo.BaseMutationOptions<DenyCoachMutation, DenyCoachMutationVariables>;
export const VerifyDeniedCoachDocument = gql`
    mutation verifyDeniedCoach($userId: UUID!, $resourceId: UUID!) {
  verifyDeniedCoach(userId: $userId, resourceId: $resourceId) {
    success
  }
}
    `;
export type VerifyDeniedCoachMutationFn = Apollo.MutationFunction<VerifyDeniedCoachMutation, VerifyDeniedCoachMutationVariables>;

/**
 * __useVerifyDeniedCoachMutation__
 *
 * To run a mutation, you first call `useVerifyDeniedCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyDeniedCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyDeniedCoachMutation, { data, loading, error }] = useVerifyDeniedCoachMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useVerifyDeniedCoachMutation(baseOptions?: Apollo.MutationHookOptions<VerifyDeniedCoachMutation, VerifyDeniedCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyDeniedCoachMutation, VerifyDeniedCoachMutationVariables>(VerifyDeniedCoachDocument, options);
      }
export type VerifyDeniedCoachMutationHookResult = ReturnType<typeof useVerifyDeniedCoachMutation>;
export type VerifyDeniedCoachMutationResult = Apollo.MutationResult<VerifyDeniedCoachMutation>;
export type VerifyDeniedCoachMutationOptions = Apollo.BaseMutationOptions<VerifyDeniedCoachMutation, VerifyDeniedCoachMutationVariables>;
export const DenyVerifiedCoachDocument = gql`
    mutation denyVerifiedCoach($userId: UUID!, $resourceId: UUID!, $reason: String) {
  denyVerifiedCoach(userId: $userId, resourceId: $resourceId, reason: $reason) {
    success
  }
}
    `;
export type DenyVerifiedCoachMutationFn = Apollo.MutationFunction<DenyVerifiedCoachMutation, DenyVerifiedCoachMutationVariables>;

/**
 * __useDenyVerifiedCoachMutation__
 *
 * To run a mutation, you first call `useDenyVerifiedCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyVerifiedCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyVerifiedCoachMutation, { data, loading, error }] = useDenyVerifiedCoachMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      resourceId: // value for 'resourceId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDenyVerifiedCoachMutation(baseOptions?: Apollo.MutationHookOptions<DenyVerifiedCoachMutation, DenyVerifiedCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyVerifiedCoachMutation, DenyVerifiedCoachMutationVariables>(DenyVerifiedCoachDocument, options);
      }
export type DenyVerifiedCoachMutationHookResult = ReturnType<typeof useDenyVerifiedCoachMutation>;
export type DenyVerifiedCoachMutationResult = Apollo.MutationResult<DenyVerifiedCoachMutation>;
export type DenyVerifiedCoachMutationOptions = Apollo.BaseMutationOptions<DenyVerifiedCoachMutation, DenyVerifiedCoachMutationVariables>;
export const VerifyUserForOrganizationDocument = gql`
    mutation verifyUserForOrganization($input: UserRoleUpdateInput!) {
  verifyUserForOrganization(input: $input) {
    success
  }
}
    `;
export type VerifyUserForOrganizationMutationFn = Apollo.MutationFunction<VerifyUserForOrganizationMutation, VerifyUserForOrganizationMutationVariables>;

/**
 * __useVerifyUserForOrganizationMutation__
 *
 * To run a mutation, you first call `useVerifyUserForOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserForOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserForOrganizationMutation, { data, loading, error }] = useVerifyUserForOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyUserForOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserForOrganizationMutation, VerifyUserForOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUserForOrganizationMutation, VerifyUserForOrganizationMutationVariables>(VerifyUserForOrganizationDocument, options);
      }
export type VerifyUserForOrganizationMutationHookResult = ReturnType<typeof useVerifyUserForOrganizationMutation>;
export type VerifyUserForOrganizationMutationResult = Apollo.MutationResult<VerifyUserForOrganizationMutation>;
export type VerifyUserForOrganizationMutationOptions = Apollo.BaseMutationOptions<VerifyUserForOrganizationMutation, VerifyUserForOrganizationMutationVariables>;
export const DenyUserForOrganizationDocument = gql`
    mutation denyUserForOrganization($input: UserRoleUpdateInput!) {
  denyUserForOrganization(input: $input) {
    success
  }
}
    `;
export type DenyUserForOrganizationMutationFn = Apollo.MutationFunction<DenyUserForOrganizationMutation, DenyUserForOrganizationMutationVariables>;

/**
 * __useDenyUserForOrganizationMutation__
 *
 * To run a mutation, you first call `useDenyUserForOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyUserForOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyUserForOrganizationMutation, { data, loading, error }] = useDenyUserForOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDenyUserForOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DenyUserForOrganizationMutation, DenyUserForOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyUserForOrganizationMutation, DenyUserForOrganizationMutationVariables>(DenyUserForOrganizationDocument, options);
      }
export type DenyUserForOrganizationMutationHookResult = ReturnType<typeof useDenyUserForOrganizationMutation>;
export type DenyUserForOrganizationMutationResult = Apollo.MutationResult<DenyUserForOrganizationMutation>;
export type DenyUserForOrganizationMutationOptions = Apollo.BaseMutationOptions<DenyUserForOrganizationMutation, DenyUserForOrganizationMutationVariables>;
export const CanEditAccountDocument = gql`
    query canEditAccount {
  canEditAccount {
    success
  }
}
    `;

/**
 * __useCanEditAccountQuery__
 *
 * To run a query within a React component, call `useCanEditAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanEditAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanEditAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCanEditAccountQuery(baseOptions?: Apollo.QueryHookOptions<CanEditAccountQuery, CanEditAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanEditAccountQuery, CanEditAccountQueryVariables>(CanEditAccountDocument, options);
      }
export function useCanEditAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanEditAccountQuery, CanEditAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanEditAccountQuery, CanEditAccountQueryVariables>(CanEditAccountDocument, options);
        }
export type CanEditAccountQueryHookResult = ReturnType<typeof useCanEditAccountQuery>;
export type CanEditAccountLazyQueryHookResult = ReturnType<typeof useCanEditAccountLazyQuery>;
export type CanEditAccountQueryResult = Apollo.QueryResult<CanEditAccountQuery, CanEditAccountQueryVariables>;
export function refetchCanEditAccountQuery(variables?: CanEditAccountQueryVariables) {
      return { query: CanEditAccountDocument, variables: variables }
    }
export const SetMyUserDemographicsDocument = gql`
    mutation setMyUserDemographics($input: UserDemographicsInput!) {
  setMyUserDemographics(input: $input) {
    success
  }
}
    `;
export type SetMyUserDemographicsMutationFn = Apollo.MutationFunction<SetMyUserDemographicsMutation, SetMyUserDemographicsMutationVariables>;

/**
 * __useSetMyUserDemographicsMutation__
 *
 * To run a mutation, you first call `useSetMyUserDemographicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyUserDemographicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyUserDemographicsMutation, { data, loading, error }] = useSetMyUserDemographicsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMyUserDemographicsMutation(baseOptions?: Apollo.MutationHookOptions<SetMyUserDemographicsMutation, SetMyUserDemographicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyUserDemographicsMutation, SetMyUserDemographicsMutationVariables>(SetMyUserDemographicsDocument, options);
      }
export type SetMyUserDemographicsMutationHookResult = ReturnType<typeof useSetMyUserDemographicsMutation>;
export type SetMyUserDemographicsMutationResult = Apollo.MutationResult<SetMyUserDemographicsMutation>;
export type SetMyUserDemographicsMutationOptions = Apollo.BaseMutationOptions<SetMyUserDemographicsMutation, SetMyUserDemographicsMutationVariables>;
export const IsSchoolByIdVerifiedDocument = gql`
    query isSchoolByIdVerified($id: UUID!) {
  school(id: $id) {
    id
    competitionGroup
    deletedAt
  }
}
    `;

/**
 * __useIsSchoolByIdVerifiedQuery__
 *
 * To run a query within a React component, call `useIsSchoolByIdVerifiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSchoolByIdVerifiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSchoolByIdVerifiedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsSchoolByIdVerifiedQuery(baseOptions: Apollo.QueryHookOptions<IsSchoolByIdVerifiedQuery, IsSchoolByIdVerifiedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsSchoolByIdVerifiedQuery, IsSchoolByIdVerifiedQueryVariables>(IsSchoolByIdVerifiedDocument, options);
      }
export function useIsSchoolByIdVerifiedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsSchoolByIdVerifiedQuery, IsSchoolByIdVerifiedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsSchoolByIdVerifiedQuery, IsSchoolByIdVerifiedQueryVariables>(IsSchoolByIdVerifiedDocument, options);
        }
export type IsSchoolByIdVerifiedQueryHookResult = ReturnType<typeof useIsSchoolByIdVerifiedQuery>;
export type IsSchoolByIdVerifiedLazyQueryHookResult = ReturnType<typeof useIsSchoolByIdVerifiedLazyQuery>;
export type IsSchoolByIdVerifiedQueryResult = Apollo.QueryResult<IsSchoolByIdVerifiedQuery, IsSchoolByIdVerifiedQueryVariables>;
export function refetchIsSchoolByIdVerifiedQuery(variables: IsSchoolByIdVerifiedQueryVariables) {
      return { query: IsSchoolByIdVerifiedDocument, variables: variables }
    }
export const MyRolesDocument = gql`
    query myRoles {
  me {
    id
    roles {
      roleName
      resourceId
      resourceType
      userId
    }
  }
}
    `;

/**
 * __useMyRolesQuery__
 *
 * To run a query within a React component, call `useMyRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyRolesQuery(baseOptions?: Apollo.QueryHookOptions<MyRolesQuery, MyRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRolesQuery, MyRolesQueryVariables>(MyRolesDocument, options);
      }
export function useMyRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRolesQuery, MyRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRolesQuery, MyRolesQueryVariables>(MyRolesDocument, options);
        }
export type MyRolesQueryHookResult = ReturnType<typeof useMyRolesQuery>;
export type MyRolesLazyQueryHookResult = ReturnType<typeof useMyRolesLazyQuery>;
export type MyRolesQueryResult = Apollo.QueryResult<MyRolesQuery, MyRolesQueryVariables>;
export function refetchMyRolesQuery(variables?: MyRolesQueryVariables) {
      return { query: MyRolesDocument, variables: variables }
    }
export const MySchoolInfoDocument = gql`
    query mySchoolInfo {
  me {
    id
    school {
      id
      competitionGroup
      leagueGroups {
        id
      }
    }
  }
}
    `;

/**
 * __useMySchoolInfoQuery__
 *
 * To run a query within a React component, call `useMySchoolInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySchoolInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySchoolInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySchoolInfoQuery(baseOptions?: Apollo.QueryHookOptions<MySchoolInfoQuery, MySchoolInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySchoolInfoQuery, MySchoolInfoQueryVariables>(MySchoolInfoDocument, options);
      }
export function useMySchoolInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySchoolInfoQuery, MySchoolInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySchoolInfoQuery, MySchoolInfoQueryVariables>(MySchoolInfoDocument, options);
        }
export type MySchoolInfoQueryHookResult = ReturnType<typeof useMySchoolInfoQuery>;
export type MySchoolInfoLazyQueryHookResult = ReturnType<typeof useMySchoolInfoLazyQuery>;
export type MySchoolInfoQueryResult = Apollo.QueryResult<MySchoolInfoQuery, MySchoolInfoQueryVariables>;
export function refetchMySchoolInfoQuery(variables?: MySchoolInfoQueryVariables) {
      return { query: MySchoolInfoDocument, variables: variables }
    }
export const AssignMatchAssignmentDocument = gql`
    mutation assignMatchAssignment($input: AssignMatchAssignmentInput!) {
  assignMatchAssignment(input: $input) {
    id
    matchId
    assigneeId
    assignerId
    assignmentStatus
    notes
    assignee {
      id
      avatarUrl
      name
    }
  }
}
    `;
export type AssignMatchAssignmentMutationFn = Apollo.MutationFunction<AssignMatchAssignmentMutation, AssignMatchAssignmentMutationVariables>;

/**
 * __useAssignMatchAssignmentMutation__
 *
 * To run a mutation, you first call `useAssignMatchAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignMatchAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignMatchAssignmentMutation, { data, loading, error }] = useAssignMatchAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignMatchAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<AssignMatchAssignmentMutation, AssignMatchAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignMatchAssignmentMutation, AssignMatchAssignmentMutationVariables>(AssignMatchAssignmentDocument, options);
      }
export type AssignMatchAssignmentMutationHookResult = ReturnType<typeof useAssignMatchAssignmentMutation>;
export type AssignMatchAssignmentMutationResult = Apollo.MutationResult<AssignMatchAssignmentMutation>;
export type AssignMatchAssignmentMutationOptions = Apollo.BaseMutationOptions<AssignMatchAssignmentMutation, AssignMatchAssignmentMutationVariables>;
export const UnassignMatchAssignmentDocument = gql`
    mutation unassignMatchAssignment($input: UnassignMatchAssignmentInput!) {
  unassignMatchAssignment(input: $input) {
    id
    matchId
    assigneeId
    assignerId
    assignmentStatus
    notes
    assignee {
      id
      avatarUrl
      name
    }
  }
}
    `;
export type UnassignMatchAssignmentMutationFn = Apollo.MutationFunction<UnassignMatchAssignmentMutation, UnassignMatchAssignmentMutationVariables>;

/**
 * __useUnassignMatchAssignmentMutation__
 *
 * To run a mutation, you first call `useUnassignMatchAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignMatchAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignMatchAssignmentMutation, { data, loading, error }] = useUnassignMatchAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignMatchAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UnassignMatchAssignmentMutation, UnassignMatchAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignMatchAssignmentMutation, UnassignMatchAssignmentMutationVariables>(UnassignMatchAssignmentDocument, options);
      }
export type UnassignMatchAssignmentMutationHookResult = ReturnType<typeof useUnassignMatchAssignmentMutation>;
export type UnassignMatchAssignmentMutationResult = Apollo.MutationResult<UnassignMatchAssignmentMutation>;
export type UnassignMatchAssignmentMutationOptions = Apollo.BaseMutationOptions<UnassignMatchAssignmentMutation, UnassignMatchAssignmentMutationVariables>;
export const MatchAssignmentHistoryDocument = gql`
    query matchAssignmentHistory($matchId: UUID!) {
  match(id: $matchId) {
    id
    matchAssignmentHistory {
      id
      assignmentStatus
      createdAt
      notes
      assignee {
        id
        firstName
        lastName
      }
      assigner {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useMatchAssignmentHistoryQuery__
 *
 * To run a query within a React component, call `useMatchAssignmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchAssignmentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchAssignmentHistoryQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchAssignmentHistoryQuery(baseOptions: Apollo.QueryHookOptions<MatchAssignmentHistoryQuery, MatchAssignmentHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchAssignmentHistoryQuery, MatchAssignmentHistoryQueryVariables>(MatchAssignmentHistoryDocument, options);
      }
export function useMatchAssignmentHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchAssignmentHistoryQuery, MatchAssignmentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchAssignmentHistoryQuery, MatchAssignmentHistoryQueryVariables>(MatchAssignmentHistoryDocument, options);
        }
export type MatchAssignmentHistoryQueryHookResult = ReturnType<typeof useMatchAssignmentHistoryQuery>;
export type MatchAssignmentHistoryLazyQueryHookResult = ReturnType<typeof useMatchAssignmentHistoryLazyQuery>;
export type MatchAssignmentHistoryQueryResult = Apollo.QueryResult<MatchAssignmentHistoryQuery, MatchAssignmentHistoryQueryVariables>;
export function refetchMatchAssignmentHistoryQuery(variables: MatchAssignmentHistoryQueryVariables) {
      return { query: MatchAssignmentHistoryDocument, variables: variables }
    }
export const BulkAssignMatchesDocument = gql`
    mutation bulkAssignMatches($matchAssignments: [AssignMatchAssignmentInput!]!) {
  bulkAssignMatches(matchAssignments: $matchAssignments) {
    success
    matchIds
  }
}
    `;
export type BulkAssignMatchesMutationFn = Apollo.MutationFunction<BulkAssignMatchesMutation, BulkAssignMatchesMutationVariables>;

/**
 * __useBulkAssignMatchesMutation__
 *
 * To run a mutation, you first call `useBulkAssignMatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignMatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignMatchesMutation, { data, loading, error }] = useBulkAssignMatchesMutation({
 *   variables: {
 *      matchAssignments: // value for 'matchAssignments'
 *   },
 * });
 */
export function useBulkAssignMatchesMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssignMatchesMutation, BulkAssignMatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssignMatchesMutation, BulkAssignMatchesMutationVariables>(BulkAssignMatchesDocument, options);
      }
export type BulkAssignMatchesMutationHookResult = ReturnType<typeof useBulkAssignMatchesMutation>;
export type BulkAssignMatchesMutationResult = Apollo.MutationResult<BulkAssignMatchesMutation>;
export type BulkAssignMatchesMutationOptions = Apollo.BaseMutationOptions<BulkAssignMatchesMutation, BulkAssignMatchesMutationVariables>;
export const BulkUnassignMatchesDocument = gql`
    mutation bulkUnassignMatches($matchAssignments: [UnassignMatchAssignmentInput!]!) {
  bulkUnassignMatches(matchAssignments: $matchAssignments) {
    success
    matchIds
  }
}
    `;
export type BulkUnassignMatchesMutationFn = Apollo.MutationFunction<BulkUnassignMatchesMutation, BulkUnassignMatchesMutationVariables>;

/**
 * __useBulkUnassignMatchesMutation__
 *
 * To run a mutation, you first call `useBulkUnassignMatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnassignMatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnassignMatchesMutation, { data, loading, error }] = useBulkUnassignMatchesMutation({
 *   variables: {
 *      matchAssignments: // value for 'matchAssignments'
 *   },
 * });
 */
export function useBulkUnassignMatchesMutation(baseOptions?: Apollo.MutationHookOptions<BulkUnassignMatchesMutation, BulkUnassignMatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUnassignMatchesMutation, BulkUnassignMatchesMutationVariables>(BulkUnassignMatchesDocument, options);
      }
export type BulkUnassignMatchesMutationHookResult = ReturnType<typeof useBulkUnassignMatchesMutation>;
export type BulkUnassignMatchesMutationResult = Apollo.MutationResult<BulkUnassignMatchesMutation>;
export type BulkUnassignMatchesMutationOptions = Apollo.BaseMutationOptions<BulkUnassignMatchesMutation, BulkUnassignMatchesMutationVariables>;
export const AvailableWeeklyAwardWeeksDocument = gql`
    query availableWeeklyAwardWeeks {
  availableWeeklyAwardWeeks {
    availableWeeks {
      assignedAwardId
      assignedUserId
      player {
        id
        name
      }
      startDate
      endDate
      beginningOfWeekTime
    }
  }
}
    `;

/**
 * __useAvailableWeeklyAwardWeeksQuery__
 *
 * To run a query within a React component, call `useAvailableWeeklyAwardWeeksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableWeeklyAwardWeeksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableWeeklyAwardWeeksQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableWeeklyAwardWeeksQuery(baseOptions?: Apollo.QueryHookOptions<AvailableWeeklyAwardWeeksQuery, AvailableWeeklyAwardWeeksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableWeeklyAwardWeeksQuery, AvailableWeeklyAwardWeeksQueryVariables>(AvailableWeeklyAwardWeeksDocument, options);
      }
export function useAvailableWeeklyAwardWeeksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableWeeklyAwardWeeksQuery, AvailableWeeklyAwardWeeksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableWeeklyAwardWeeksQuery, AvailableWeeklyAwardWeeksQueryVariables>(AvailableWeeklyAwardWeeksDocument, options);
        }
export type AvailableWeeklyAwardWeeksQueryHookResult = ReturnType<typeof useAvailableWeeklyAwardWeeksQuery>;
export type AvailableWeeklyAwardWeeksLazyQueryHookResult = ReturnType<typeof useAvailableWeeklyAwardWeeksLazyQuery>;
export type AvailableWeeklyAwardWeeksQueryResult = Apollo.QueryResult<AvailableWeeklyAwardWeeksQuery, AvailableWeeklyAwardWeeksQueryVariables>;
export function refetchAvailableWeeklyAwardWeeksQuery(variables?: AvailableWeeklyAwardWeeksQueryVariables) {
      return { query: AvailableWeeklyAwardWeeksDocument, variables: variables }
    }
export const AvailableWeeklyAwardPlayersDocument = gql`
    query availableWeeklyAwardPlayers($input: AvailableWeeklyAwardPlayersInput!) {
  availableWeeklyAwardPlayers(input: $input) {
    availablePlayers {
      id
      name
      avatarUrl
    }
  }
}
    `;

/**
 * __useAvailableWeeklyAwardPlayersQuery__
 *
 * To run a query within a React component, call `useAvailableWeeklyAwardPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableWeeklyAwardPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableWeeklyAwardPlayersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvailableWeeklyAwardPlayersQuery(baseOptions: Apollo.QueryHookOptions<AvailableWeeklyAwardPlayersQuery, AvailableWeeklyAwardPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableWeeklyAwardPlayersQuery, AvailableWeeklyAwardPlayersQueryVariables>(AvailableWeeklyAwardPlayersDocument, options);
      }
export function useAvailableWeeklyAwardPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableWeeklyAwardPlayersQuery, AvailableWeeklyAwardPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableWeeklyAwardPlayersQuery, AvailableWeeklyAwardPlayersQueryVariables>(AvailableWeeklyAwardPlayersDocument, options);
        }
export type AvailableWeeklyAwardPlayersQueryHookResult = ReturnType<typeof useAvailableWeeklyAwardPlayersQuery>;
export type AvailableWeeklyAwardPlayersLazyQueryHookResult = ReturnType<typeof useAvailableWeeklyAwardPlayersLazyQuery>;
export type AvailableWeeklyAwardPlayersQueryResult = Apollo.QueryResult<AvailableWeeklyAwardPlayersQuery, AvailableWeeklyAwardPlayersQueryVariables>;
export function refetchAvailableWeeklyAwardPlayersQuery(variables: AvailableWeeklyAwardPlayersQueryVariables) {
      return { query: AvailableWeeklyAwardPlayersDocument, variables: variables }
    }
export const AssignWeeklyPlayerAwardDocument = gql`
    mutation assignWeeklyPlayerAward($input: AssignWeeklyPlayerAwardInput!) {
  assignWeeklyPlayerAward(input: $input) {
    assignedWeeklyPlayerAward {
      id
      userId
      coachId
      schoolId
      beginningOfWeekTime
      awardWeekOption {
        assignedAwardId
        assignedUserId
      }
      createdAt
    }
  }
}
    `;
export type AssignWeeklyPlayerAwardMutationFn = Apollo.MutationFunction<AssignWeeklyPlayerAwardMutation, AssignWeeklyPlayerAwardMutationVariables>;

/**
 * __useAssignWeeklyPlayerAwardMutation__
 *
 * To run a mutation, you first call `useAssignWeeklyPlayerAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignWeeklyPlayerAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignWeeklyPlayerAwardMutation, { data, loading, error }] = useAssignWeeklyPlayerAwardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignWeeklyPlayerAwardMutation(baseOptions?: Apollo.MutationHookOptions<AssignWeeklyPlayerAwardMutation, AssignWeeklyPlayerAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignWeeklyPlayerAwardMutation, AssignWeeklyPlayerAwardMutationVariables>(AssignWeeklyPlayerAwardDocument, options);
      }
export type AssignWeeklyPlayerAwardMutationHookResult = ReturnType<typeof useAssignWeeklyPlayerAwardMutation>;
export type AssignWeeklyPlayerAwardMutationResult = Apollo.MutationResult<AssignWeeklyPlayerAwardMutation>;
export type AssignWeeklyPlayerAwardMutationOptions = Apollo.BaseMutationOptions<AssignWeeklyPlayerAwardMutation, AssignWeeklyPlayerAwardMutationVariables>;
export const DeleteSeasonalPlayerAwardDocument = gql`
    mutation deleteSeasonalPlayerAward($input: DeleteSeasonalPlayerAwardInput!) {
  deleteSeasonalPlayerAward(input: $input) {
    deletedId
  }
}
    `;
export type DeleteSeasonalPlayerAwardMutationFn = Apollo.MutationFunction<DeleteSeasonalPlayerAwardMutation, DeleteSeasonalPlayerAwardMutationVariables>;

/**
 * __useDeleteSeasonalPlayerAwardMutation__
 *
 * To run a mutation, you first call `useDeleteSeasonalPlayerAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSeasonalPlayerAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSeasonalPlayerAwardMutation, { data, loading, error }] = useDeleteSeasonalPlayerAwardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSeasonalPlayerAwardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSeasonalPlayerAwardMutation, DeleteSeasonalPlayerAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSeasonalPlayerAwardMutation, DeleteSeasonalPlayerAwardMutationVariables>(DeleteSeasonalPlayerAwardDocument, options);
      }
export type DeleteSeasonalPlayerAwardMutationHookResult = ReturnType<typeof useDeleteSeasonalPlayerAwardMutation>;
export type DeleteSeasonalPlayerAwardMutationResult = Apollo.MutationResult<DeleteSeasonalPlayerAwardMutation>;
export type DeleteSeasonalPlayerAwardMutationOptions = Apollo.BaseMutationOptions<DeleteSeasonalPlayerAwardMutation, DeleteSeasonalPlayerAwardMutationVariables>;
export const AssignSeasonalPlayerAwardDocument = gql`
    mutation assignSeasonalPlayerAward($input: AssignSeasonalPlayerAwardInput!) {
  assignSeasonalPlayerAward(input: $input) {
    assignedSeasonalPlayerAward {
      id
    }
  }
}
    `;
export type AssignSeasonalPlayerAwardMutationFn = Apollo.MutationFunction<AssignSeasonalPlayerAwardMutation, AssignSeasonalPlayerAwardMutationVariables>;

/**
 * __useAssignSeasonalPlayerAwardMutation__
 *
 * To run a mutation, you first call `useAssignSeasonalPlayerAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignSeasonalPlayerAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignSeasonalPlayerAwardMutation, { data, loading, error }] = useAssignSeasonalPlayerAwardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignSeasonalPlayerAwardMutation(baseOptions?: Apollo.MutationHookOptions<AssignSeasonalPlayerAwardMutation, AssignSeasonalPlayerAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignSeasonalPlayerAwardMutation, AssignSeasonalPlayerAwardMutationVariables>(AssignSeasonalPlayerAwardDocument, options);
      }
export type AssignSeasonalPlayerAwardMutationHookResult = ReturnType<typeof useAssignSeasonalPlayerAwardMutation>;
export type AssignSeasonalPlayerAwardMutationResult = Apollo.MutationResult<AssignSeasonalPlayerAwardMutation>;
export type AssignSeasonalPlayerAwardMutationOptions = Apollo.BaseMutationOptions<AssignSeasonalPlayerAwardMutation, AssignSeasonalPlayerAwardMutationVariables>;
export const UpdateSeasonalPlayerAwardDocument = gql`
    mutation updateSeasonalPlayerAward($input: UpdateSeasonalPlayerAwardInput!) {
  updateSeasonalPlayerAward(input: $input) {
    assignedSeasonalPlayerAward {
      id
    }
  }
}
    `;
export type UpdateSeasonalPlayerAwardMutationFn = Apollo.MutationFunction<UpdateSeasonalPlayerAwardMutation, UpdateSeasonalPlayerAwardMutationVariables>;

/**
 * __useUpdateSeasonalPlayerAwardMutation__
 *
 * To run a mutation, you first call `useUpdateSeasonalPlayerAwardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeasonalPlayerAwardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeasonalPlayerAwardMutation, { data, loading, error }] = useUpdateSeasonalPlayerAwardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeasonalPlayerAwardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeasonalPlayerAwardMutation, UpdateSeasonalPlayerAwardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeasonalPlayerAwardMutation, UpdateSeasonalPlayerAwardMutationVariables>(UpdateSeasonalPlayerAwardDocument, options);
      }
export type UpdateSeasonalPlayerAwardMutationHookResult = ReturnType<typeof useUpdateSeasonalPlayerAwardMutation>;
export type UpdateSeasonalPlayerAwardMutationResult = Apollo.MutationResult<UpdateSeasonalPlayerAwardMutation>;
export type UpdateSeasonalPlayerAwardMutationOptions = Apollo.BaseMutationOptions<UpdateSeasonalPlayerAwardMutation, UpdateSeasonalPlayerAwardMutationVariables>;
export const GenerateSeasonalPlayerAwardCertificateDocument = gql`
    mutation generateSeasonalPlayerAwardCertificate($input: GenerateSeasonalPlayerAwardCertificateInput!) {
  generateSeasonalPlayerAwardCertificate(input: $input) {
    signedUrl
  }
}
    `;
export type GenerateSeasonalPlayerAwardCertificateMutationFn = Apollo.MutationFunction<GenerateSeasonalPlayerAwardCertificateMutation, GenerateSeasonalPlayerAwardCertificateMutationVariables>;

/**
 * __useGenerateSeasonalPlayerAwardCertificateMutation__
 *
 * To run a mutation, you first call `useGenerateSeasonalPlayerAwardCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSeasonalPlayerAwardCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSeasonalPlayerAwardCertificateMutation, { data, loading, error }] = useGenerateSeasonalPlayerAwardCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSeasonalPlayerAwardCertificateMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSeasonalPlayerAwardCertificateMutation, GenerateSeasonalPlayerAwardCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSeasonalPlayerAwardCertificateMutation, GenerateSeasonalPlayerAwardCertificateMutationVariables>(GenerateSeasonalPlayerAwardCertificateDocument, options);
      }
export type GenerateSeasonalPlayerAwardCertificateMutationHookResult = ReturnType<typeof useGenerateSeasonalPlayerAwardCertificateMutation>;
export type GenerateSeasonalPlayerAwardCertificateMutationResult = Apollo.MutationResult<GenerateSeasonalPlayerAwardCertificateMutation>;
export type GenerateSeasonalPlayerAwardCertificateMutationOptions = Apollo.BaseMutationOptions<GenerateSeasonalPlayerAwardCertificateMutation, GenerateSeasonalPlayerAwardCertificateMutationVariables>;
export const GenerateSeasonalPlayerAwardSocialMediaImageDocument = gql`
    mutation generateSeasonalPlayerAwardSocialMediaImage($input: GenerateSeasonalPlayerAwardSocialMediaImageInput!) {
  generateSeasonalPlayerAwardSocialMediaImage(input: $input) {
    signedUrl
  }
}
    `;
export type GenerateSeasonalPlayerAwardSocialMediaImageMutationFn = Apollo.MutationFunction<GenerateSeasonalPlayerAwardSocialMediaImageMutation, GenerateSeasonalPlayerAwardSocialMediaImageMutationVariables>;

/**
 * __useGenerateSeasonalPlayerAwardSocialMediaImageMutation__
 *
 * To run a mutation, you first call `useGenerateSeasonalPlayerAwardSocialMediaImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSeasonalPlayerAwardSocialMediaImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSeasonalPlayerAwardSocialMediaImageMutation, { data, loading, error }] = useGenerateSeasonalPlayerAwardSocialMediaImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSeasonalPlayerAwardSocialMediaImageMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSeasonalPlayerAwardSocialMediaImageMutation, GenerateSeasonalPlayerAwardSocialMediaImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSeasonalPlayerAwardSocialMediaImageMutation, GenerateSeasonalPlayerAwardSocialMediaImageMutationVariables>(GenerateSeasonalPlayerAwardSocialMediaImageDocument, options);
      }
export type GenerateSeasonalPlayerAwardSocialMediaImageMutationHookResult = ReturnType<typeof useGenerateSeasonalPlayerAwardSocialMediaImageMutation>;
export type GenerateSeasonalPlayerAwardSocialMediaImageMutationResult = Apollo.MutationResult<GenerateSeasonalPlayerAwardSocialMediaImageMutation>;
export type GenerateSeasonalPlayerAwardSocialMediaImageMutationOptions = Apollo.BaseMutationOptions<GenerateSeasonalPlayerAwardSocialMediaImageMutation, GenerateSeasonalPlayerAwardSocialMediaImageMutationVariables>;
export const AvailableSeasonalPlayerAwardTypesDocument = gql`
    query availableSeasonalPlayerAwardTypes {
  availableSeasonalPlayerAwardTypes {
    availablePlayerAwardTypes {
      id
      title
      description
    }
  }
}
    `;

/**
 * __useAvailableSeasonalPlayerAwardTypesQuery__
 *
 * To run a query within a React component, call `useAvailableSeasonalPlayerAwardTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableSeasonalPlayerAwardTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableSeasonalPlayerAwardTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableSeasonalPlayerAwardTypesQuery(baseOptions?: Apollo.QueryHookOptions<AvailableSeasonalPlayerAwardTypesQuery, AvailableSeasonalPlayerAwardTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableSeasonalPlayerAwardTypesQuery, AvailableSeasonalPlayerAwardTypesQueryVariables>(AvailableSeasonalPlayerAwardTypesDocument, options);
      }
export function useAvailableSeasonalPlayerAwardTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableSeasonalPlayerAwardTypesQuery, AvailableSeasonalPlayerAwardTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableSeasonalPlayerAwardTypesQuery, AvailableSeasonalPlayerAwardTypesQueryVariables>(AvailableSeasonalPlayerAwardTypesDocument, options);
        }
export type AvailableSeasonalPlayerAwardTypesQueryHookResult = ReturnType<typeof useAvailableSeasonalPlayerAwardTypesQuery>;
export type AvailableSeasonalPlayerAwardTypesLazyQueryHookResult = ReturnType<typeof useAvailableSeasonalPlayerAwardTypesLazyQuery>;
export type AvailableSeasonalPlayerAwardTypesQueryResult = Apollo.QueryResult<AvailableSeasonalPlayerAwardTypesQuery, AvailableSeasonalPlayerAwardTypesQueryVariables>;
export function refetchAvailableSeasonalPlayerAwardTypesQuery(variables?: AvailableSeasonalPlayerAwardTypesQueryVariables) {
      return { query: AvailableSeasonalPlayerAwardTypesDocument, variables: variables }
    }
export const GetSchoolSeasonEnrollmentSummaryDocument = gql`
    query getSchoolSeasonEnrollmentSummary($metaseasonId: UUID!, $schoolId: UUID!) {
  getSchoolSeasonEnrollmentSummary(
    metaseasonId: $metaseasonId
    schoolId: $schoolId
  ) {
    earliestEnrolledAt
  }
}
    `;

/**
 * __useGetSchoolSeasonEnrollmentSummaryQuery__
 *
 * To run a query within a React component, call `useGetSchoolSeasonEnrollmentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolSeasonEnrollmentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolSeasonEnrollmentSummaryQuery({
 *   variables: {
 *      metaseasonId: // value for 'metaseasonId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolSeasonEnrollmentSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolSeasonEnrollmentSummaryQuery, GetSchoolSeasonEnrollmentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolSeasonEnrollmentSummaryQuery, GetSchoolSeasonEnrollmentSummaryQueryVariables>(GetSchoolSeasonEnrollmentSummaryDocument, options);
      }
export function useGetSchoolSeasonEnrollmentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolSeasonEnrollmentSummaryQuery, GetSchoolSeasonEnrollmentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolSeasonEnrollmentSummaryQuery, GetSchoolSeasonEnrollmentSummaryQueryVariables>(GetSchoolSeasonEnrollmentSummaryDocument, options);
        }
export type GetSchoolSeasonEnrollmentSummaryQueryHookResult = ReturnType<typeof useGetSchoolSeasonEnrollmentSummaryQuery>;
export type GetSchoolSeasonEnrollmentSummaryLazyQueryHookResult = ReturnType<typeof useGetSchoolSeasonEnrollmentSummaryLazyQuery>;
export type GetSchoolSeasonEnrollmentSummaryQueryResult = Apollo.QueryResult<GetSchoolSeasonEnrollmentSummaryQuery, GetSchoolSeasonEnrollmentSummaryQueryVariables>;
export function refetchGetSchoolSeasonEnrollmentSummaryQuery(variables: GetSchoolSeasonEnrollmentSummaryQueryVariables) {
      return { query: GetSchoolSeasonEnrollmentSummaryDocument, variables: variables }
    }
export const GetPassUsageGroupedByEsportDocument = gql`
    query getPassUsageGroupedByEsport($dateRange: DateRangeInput!, $schoolId: UUID!) {
  getBillingPeriodSummaryForDateRange(dateRange: $dateRange, schoolId: $schoolId) {
    passUsageByEsport {
      esport {
        id
        name
        slug
      }
      seasonPassesUsed
      passUsageByMetaseason {
        metaseason {
          id
          name
        }
        seasonPassesUsed
      }
    }
  }
}
    `;

/**
 * __useGetPassUsageGroupedByEsportQuery__
 *
 * To run a query within a React component, call `useGetPassUsageGroupedByEsportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPassUsageGroupedByEsportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPassUsageGroupedByEsportQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetPassUsageGroupedByEsportQuery(baseOptions: Apollo.QueryHookOptions<GetPassUsageGroupedByEsportQuery, GetPassUsageGroupedByEsportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPassUsageGroupedByEsportQuery, GetPassUsageGroupedByEsportQueryVariables>(GetPassUsageGroupedByEsportDocument, options);
      }
export function useGetPassUsageGroupedByEsportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPassUsageGroupedByEsportQuery, GetPassUsageGroupedByEsportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPassUsageGroupedByEsportQuery, GetPassUsageGroupedByEsportQueryVariables>(GetPassUsageGroupedByEsportDocument, options);
        }
export type GetPassUsageGroupedByEsportQueryHookResult = ReturnType<typeof useGetPassUsageGroupedByEsportQuery>;
export type GetPassUsageGroupedByEsportLazyQueryHookResult = ReturnType<typeof useGetPassUsageGroupedByEsportLazyQuery>;
export type GetPassUsageGroupedByEsportQueryResult = Apollo.QueryResult<GetPassUsageGroupedByEsportQuery, GetPassUsageGroupedByEsportQueryVariables>;
export function refetchGetPassUsageGroupedByEsportQuery(variables: GetPassUsageGroupedByEsportQueryVariables) {
      return { query: GetPassUsageGroupedByEsportDocument, variables: variables }
    }
export const GetBillingPeriodSummaryForDateRangeDocument = gql`
    query getBillingPeriodSummaryForDateRange($dateRange: DateRangeInput!, $schoolId: UUID!) {
  getBillingPeriodSummaryForDateRange(dateRange: $dateRange, schoolId: $schoolId) {
    totalSeasonPassesBilled
    totalSeasonPassesUsed
    passUsageByEsport {
      esport {
        id
      }
      seasonPassesUsed
      passUsageByMetaseason {
        metaseason {
          id
          name
        }
        seasonPassesUsed
      }
    }
    summaryByPass {
      annualPassType
      passUsage
      passUsageByMetaseason {
        metaseason {
          id
          name
        }
        seasonPassesUsed
      }
      planDateRange {
        startsAt
        endsAt
      }
      productName
      seasonPassesBilled
      slug
    }
  }
}
    `;

/**
 * __useGetBillingPeriodSummaryForDateRangeQuery__
 *
 * To run a query within a React component, call `useGetBillingPeriodSummaryForDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingPeriodSummaryForDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingPeriodSummaryForDateRangeQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetBillingPeriodSummaryForDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetBillingPeriodSummaryForDateRangeQuery, GetBillingPeriodSummaryForDateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingPeriodSummaryForDateRangeQuery, GetBillingPeriodSummaryForDateRangeQueryVariables>(GetBillingPeriodSummaryForDateRangeDocument, options);
      }
export function useGetBillingPeriodSummaryForDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingPeriodSummaryForDateRangeQuery, GetBillingPeriodSummaryForDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingPeriodSummaryForDateRangeQuery, GetBillingPeriodSummaryForDateRangeQueryVariables>(GetBillingPeriodSummaryForDateRangeDocument, options);
        }
export type GetBillingPeriodSummaryForDateRangeQueryHookResult = ReturnType<typeof useGetBillingPeriodSummaryForDateRangeQuery>;
export type GetBillingPeriodSummaryForDateRangeLazyQueryHookResult = ReturnType<typeof useGetBillingPeriodSummaryForDateRangeLazyQuery>;
export type GetBillingPeriodSummaryForDateRangeQueryResult = Apollo.QueryResult<GetBillingPeriodSummaryForDateRangeQuery, GetBillingPeriodSummaryForDateRangeQueryVariables>;
export function refetchGetBillingPeriodSummaryForDateRangeQuery(variables: GetBillingPeriodSummaryForDateRangeQueryVariables) {
      return { query: GetBillingPeriodSummaryForDateRangeDocument, variables: variables }
    }
export const GetSchoolInvoiceDataDocument = gql`
    query getSchoolInvoiceData($schoolId: UUID!) {
  getSchoolInvoiceData(schoolId: $schoolId) {
    dateDue
    issueDate
    invoiceNumber
    referenceId
    paidStatus
    referenceId
    seasonName
    totalAmount
  }
}
    `;

/**
 * __useGetSchoolInvoiceDataQuery__
 *
 * To run a query within a React component, call `useGetSchoolInvoiceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolInvoiceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolInvoiceDataQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolInvoiceDataQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolInvoiceDataQuery, GetSchoolInvoiceDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolInvoiceDataQuery, GetSchoolInvoiceDataQueryVariables>(GetSchoolInvoiceDataDocument, options);
      }
export function useGetSchoolInvoiceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolInvoiceDataQuery, GetSchoolInvoiceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolInvoiceDataQuery, GetSchoolInvoiceDataQueryVariables>(GetSchoolInvoiceDataDocument, options);
        }
export type GetSchoolInvoiceDataQueryHookResult = ReturnType<typeof useGetSchoolInvoiceDataQuery>;
export type GetSchoolInvoiceDataLazyQueryHookResult = ReturnType<typeof useGetSchoolInvoiceDataLazyQuery>;
export type GetSchoolInvoiceDataQueryResult = Apollo.QueryResult<GetSchoolInvoiceDataQuery, GetSchoolInvoiceDataQueryVariables>;
export function refetchGetSchoolInvoiceDataQuery(variables: GetSchoolInvoiceDataQueryVariables) {
      return { query: GetSchoolInvoiceDataDocument, variables: variables }
    }
export const DownloadSchoolInvoiceDocument = gql`
    query downloadSchoolInvoice($input: DownloadSchoolInvoiceInput!) {
  downloadSchoolInvoice(input: $input) {
    encodedFile
    title
  }
}
    `;

/**
 * __useDownloadSchoolInvoiceQuery__
 *
 * To run a query within a React component, call `useDownloadSchoolInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadSchoolInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadSchoolInvoiceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadSchoolInvoiceQuery(baseOptions: Apollo.QueryHookOptions<DownloadSchoolInvoiceQuery, DownloadSchoolInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadSchoolInvoiceQuery, DownloadSchoolInvoiceQueryVariables>(DownloadSchoolInvoiceDocument, options);
      }
export function useDownloadSchoolInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadSchoolInvoiceQuery, DownloadSchoolInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadSchoolInvoiceQuery, DownloadSchoolInvoiceQueryVariables>(DownloadSchoolInvoiceDocument, options);
        }
export type DownloadSchoolInvoiceQueryHookResult = ReturnType<typeof useDownloadSchoolInvoiceQuery>;
export type DownloadSchoolInvoiceLazyQueryHookResult = ReturnType<typeof useDownloadSchoolInvoiceLazyQuery>;
export type DownloadSchoolInvoiceQueryResult = Apollo.QueryResult<DownloadSchoolInvoiceQuery, DownloadSchoolInvoiceQueryVariables>;
export function refetchDownloadSchoolInvoiceQuery(variables: DownloadSchoolInvoiceQueryVariables) {
      return { query: DownloadSchoolInvoiceDocument, variables: variables }
    }
export const GetBillingPeriodUsageDocument = gql`
    query getBillingPeriodUsage($dateRange: DateRangeInput!, $schoolId: UUID!, $esportId: UUID, $after: String, $before: String) {
  getBillingPeriodUsage(
    dateRange: $dateRange
    schoolId: $schoolId
    esportId: $esportId
    after: $after
    before: $before
    first: 10
  ) {
    total
    pageInfo {
      hasNext
      endCursor
      startCursor
    }
    edges {
      node {
        id
        user {
          id
          name
          avatarUrl
        }
        match {
          matchResults {
            team {
              name
            }
            teamSide
          }
        }
        esportId
        esport {
          name
        }
        metaseason {
          id
          name
          startsAt
          endsAt
        }
        consumedAt
      }
    }
  }
}
    `;

/**
 * __useGetBillingPeriodUsageQuery__
 *
 * To run a query within a React component, call `useGetBillingPeriodUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingPeriodUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingPeriodUsageQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      schoolId: // value for 'schoolId'
 *      esportId: // value for 'esportId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetBillingPeriodUsageQuery(baseOptions: Apollo.QueryHookOptions<GetBillingPeriodUsageQuery, GetBillingPeriodUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingPeriodUsageQuery, GetBillingPeriodUsageQueryVariables>(GetBillingPeriodUsageDocument, options);
      }
export function useGetBillingPeriodUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingPeriodUsageQuery, GetBillingPeriodUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingPeriodUsageQuery, GetBillingPeriodUsageQueryVariables>(GetBillingPeriodUsageDocument, options);
        }
export type GetBillingPeriodUsageQueryHookResult = ReturnType<typeof useGetBillingPeriodUsageQuery>;
export type GetBillingPeriodUsageLazyQueryHookResult = ReturnType<typeof useGetBillingPeriodUsageLazyQuery>;
export type GetBillingPeriodUsageQueryResult = Apollo.QueryResult<GetBillingPeriodUsageQuery, GetBillingPeriodUsageQueryVariables>;
export function refetchGetBillingPeriodUsageQuery(variables: GetBillingPeriodUsageQueryVariables) {
      return { query: GetBillingPeriodUsageDocument, variables: variables }
    }
export const UpdateCurrentAnnualPassBySchoolIdDocument = gql`
    mutation updateCurrentAnnualPassBySchoolId($schoolId: UUID!, $metaseasonIds: [UUID!]!) {
  updateCurrentAnnualPassBySchoolId(
    schoolId: $schoolId
    metaseasonIds: $metaseasonIds
  ) {
    success
    annualPassInstanceId
  }
}
    `;
export type UpdateCurrentAnnualPassBySchoolIdMutationFn = Apollo.MutationFunction<UpdateCurrentAnnualPassBySchoolIdMutation, UpdateCurrentAnnualPassBySchoolIdMutationVariables>;

/**
 * __useUpdateCurrentAnnualPassBySchoolIdMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentAnnualPassBySchoolIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentAnnualPassBySchoolIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentAnnualPassBySchoolIdMutation, { data, loading, error }] = useUpdateCurrentAnnualPassBySchoolIdMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      metaseasonIds: // value for 'metaseasonIds'
 *   },
 * });
 */
export function useUpdateCurrentAnnualPassBySchoolIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentAnnualPassBySchoolIdMutation, UpdateCurrentAnnualPassBySchoolIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentAnnualPassBySchoolIdMutation, UpdateCurrentAnnualPassBySchoolIdMutationVariables>(UpdateCurrentAnnualPassBySchoolIdDocument, options);
      }
export type UpdateCurrentAnnualPassBySchoolIdMutationHookResult = ReturnType<typeof useUpdateCurrentAnnualPassBySchoolIdMutation>;
export type UpdateCurrentAnnualPassBySchoolIdMutationResult = Apollo.MutationResult<UpdateCurrentAnnualPassBySchoolIdMutation>;
export type UpdateCurrentAnnualPassBySchoolIdMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentAnnualPassBySchoolIdMutation, UpdateCurrentAnnualPassBySchoolIdMutationVariables>;
export const UpdateSchoolEnrollmentDocument = gql`
    mutation updateSchoolEnrollment($input: UpdateSchoolEnrollmentInput!) {
  updateSchoolEnrollment(input: $input) {
    metaseasonId
    schoolId
  }
}
    `;
export type UpdateSchoolEnrollmentMutationFn = Apollo.MutationFunction<UpdateSchoolEnrollmentMutation, UpdateSchoolEnrollmentMutationVariables>;

/**
 * __useUpdateSchoolEnrollmentMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolEnrollmentMutation, { data, loading, error }] = useUpdateSchoolEnrollmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSchoolEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchoolEnrollmentMutation, UpdateSchoolEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchoolEnrollmentMutation, UpdateSchoolEnrollmentMutationVariables>(UpdateSchoolEnrollmentDocument, options);
      }
export type UpdateSchoolEnrollmentMutationHookResult = ReturnType<typeof useUpdateSchoolEnrollmentMutation>;
export type UpdateSchoolEnrollmentMutationResult = Apollo.MutationResult<UpdateSchoolEnrollmentMutation>;
export type UpdateSchoolEnrollmentMutationOptions = Apollo.BaseMutationOptions<UpdateSchoolEnrollmentMutation, UpdateSchoolEnrollmentMutationVariables>;
export const ScheduleConsultationEmailDocument = gql`
    mutation scheduleConsultationEmail {
  scheduleConsultationEmail {
    success
  }
}
    `;
export type ScheduleConsultationEmailMutationFn = Apollo.MutationFunction<ScheduleConsultationEmailMutation, ScheduleConsultationEmailMutationVariables>;

/**
 * __useScheduleConsultationEmailMutation__
 *
 * To run a mutation, you first call `useScheduleConsultationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleConsultationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleConsultationEmailMutation, { data, loading, error }] = useScheduleConsultationEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useScheduleConsultationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleConsultationEmailMutation, ScheduleConsultationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleConsultationEmailMutation, ScheduleConsultationEmailMutationVariables>(ScheduleConsultationEmailDocument, options);
      }
export type ScheduleConsultationEmailMutationHookResult = ReturnType<typeof useScheduleConsultationEmailMutation>;
export type ScheduleConsultationEmailMutationResult = Apollo.MutationResult<ScheduleConsultationEmailMutation>;
export type ScheduleConsultationEmailMutationOptions = Apollo.BaseMutationOptions<ScheduleConsultationEmailMutation, ScheduleConsultationEmailMutationVariables>;
export const GetPhaseBracketDocument = gql`
    query getPhaseBracket($phaseId: UUID!) {
  getBracketByPhaseId(phaseId: $phaseId) {
    type
    bracketMatches {
      bracketIndex
      nextBracketIndex
      matchId
      matchCompleted
      isAFinalsMatch
      slotType
      roundNumber
      ordinalNumber
      roundType
      slot {
        id
        startsAt
      }
      match {
        id
        scheduledStartsAt
        matchResults {
          teamId
          gamesWon
          seriesWon
        }
      }
      bracketTeams {
        teamId
        seed
        schoolId
        matchStatus
        isDeleted
        team {
          id
          avatarUrl
          name
          schoolId
          school {
            id
            name
            slug
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPhaseBracketQuery__
 *
 * To run a query within a React component, call `useGetPhaseBracketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhaseBracketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhaseBracketQuery({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useGetPhaseBracketQuery(baseOptions: Apollo.QueryHookOptions<GetPhaseBracketQuery, GetPhaseBracketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhaseBracketQuery, GetPhaseBracketQueryVariables>(GetPhaseBracketDocument, options);
      }
export function useGetPhaseBracketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhaseBracketQuery, GetPhaseBracketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhaseBracketQuery, GetPhaseBracketQueryVariables>(GetPhaseBracketDocument, options);
        }
export type GetPhaseBracketQueryHookResult = ReturnType<typeof useGetPhaseBracketQuery>;
export type GetPhaseBracketLazyQueryHookResult = ReturnType<typeof useGetPhaseBracketLazyQuery>;
export type GetPhaseBracketQueryResult = Apollo.QueryResult<GetPhaseBracketQuery, GetPhaseBracketQueryVariables>;
export function refetchGetPhaseBracketQuery(variables: GetPhaseBracketQueryVariables) {
      return { query: GetPhaseBracketDocument, variables: variables }
    }
export const RunBulkActionDocument = gql`
    mutation runBulkAction($input: RunBulkActionInput!) {
  runBulkAction(input: $input) {
    jobId
  }
}
    `;
export type RunBulkActionMutationFn = Apollo.MutationFunction<RunBulkActionMutation, RunBulkActionMutationVariables>;

/**
 * __useRunBulkActionMutation__
 *
 * To run a mutation, you first call `useRunBulkActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunBulkActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runBulkActionMutation, { data, loading, error }] = useRunBulkActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunBulkActionMutation(baseOptions?: Apollo.MutationHookOptions<RunBulkActionMutation, RunBulkActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunBulkActionMutation, RunBulkActionMutationVariables>(RunBulkActionDocument, options);
      }
export type RunBulkActionMutationHookResult = ReturnType<typeof useRunBulkActionMutation>;
export type RunBulkActionMutationResult = Apollo.MutationResult<RunBulkActionMutation>;
export type RunBulkActionMutationOptions = Apollo.BaseMutationOptions<RunBulkActionMutation, RunBulkActionMutationVariables>;
export const GetBulkActionJobDocument = gql`
    query getBulkActionJob($input: GetJobInput!) {
  getBulkOperationFromGoogleSheetJob(input: $input) {
    status
    statusReason
  }
}
    `;

/**
 * __useGetBulkActionJobQuery__
 *
 * To run a query within a React component, call `useGetBulkActionJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkActionJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkActionJobQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBulkActionJobQuery(baseOptions: Apollo.QueryHookOptions<GetBulkActionJobQuery, GetBulkActionJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBulkActionJobQuery, GetBulkActionJobQueryVariables>(GetBulkActionJobDocument, options);
      }
export function useGetBulkActionJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBulkActionJobQuery, GetBulkActionJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBulkActionJobQuery, GetBulkActionJobQueryVariables>(GetBulkActionJobDocument, options);
        }
export type GetBulkActionJobQueryHookResult = ReturnType<typeof useGetBulkActionJobQuery>;
export type GetBulkActionJobLazyQueryHookResult = ReturnType<typeof useGetBulkActionJobLazyQuery>;
export type GetBulkActionJobQueryResult = Apollo.QueryResult<GetBulkActionJobQuery, GetBulkActionJobQueryVariables>;
export function refetchGetBulkActionJobQuery(variables: GetBulkActionJobQueryVariables) {
      return { query: GetBulkActionJobDocument, variables: variables }
    }
export const DeleteMatchChatEventDocument = gql`
    mutation deleteMatchChatEvent($input: DeleteMatchChatEventInput!) {
  deleteMatchChatEvent(input: $input) {
    matchChatEvent {
      id
    }
  }
}
    `;
export type DeleteMatchChatEventMutationFn = Apollo.MutationFunction<DeleteMatchChatEventMutation, DeleteMatchChatEventMutationVariables>;

/**
 * __useDeleteMatchChatEventMutation__
 *
 * To run a mutation, you first call `useDeleteMatchChatEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchChatEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchChatEventMutation, { data, loading, error }] = useDeleteMatchChatEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMatchChatEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMatchChatEventMutation, DeleteMatchChatEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMatchChatEventMutation, DeleteMatchChatEventMutationVariables>(DeleteMatchChatEventDocument, options);
      }
export type DeleteMatchChatEventMutationHookResult = ReturnType<typeof useDeleteMatchChatEventMutation>;
export type DeleteMatchChatEventMutationResult = Apollo.MutationResult<DeleteMatchChatEventMutation>;
export type DeleteMatchChatEventMutationOptions = Apollo.BaseMutationOptions<DeleteMatchChatEventMutation, DeleteMatchChatEventMutationVariables>;
export const FetchAllMatchChatEventsDocument = gql`
    query fetchAllMatchChatEvents {
  fetchAllMatchChatEvents {
    matchChatEvents {
      id
      name
      description
      esportId
      object
      field
      changesTo
      sendMessage
      createdAt
    }
  }
}
    `;

/**
 * __useFetchAllMatchChatEventsQuery__
 *
 * To run a query within a React component, call `useFetchAllMatchChatEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllMatchChatEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllMatchChatEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllMatchChatEventsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllMatchChatEventsQuery, FetchAllMatchChatEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllMatchChatEventsQuery, FetchAllMatchChatEventsQueryVariables>(FetchAllMatchChatEventsDocument, options);
      }
export function useFetchAllMatchChatEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllMatchChatEventsQuery, FetchAllMatchChatEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllMatchChatEventsQuery, FetchAllMatchChatEventsQueryVariables>(FetchAllMatchChatEventsDocument, options);
        }
export type FetchAllMatchChatEventsQueryHookResult = ReturnType<typeof useFetchAllMatchChatEventsQuery>;
export type FetchAllMatchChatEventsLazyQueryHookResult = ReturnType<typeof useFetchAllMatchChatEventsLazyQuery>;
export type FetchAllMatchChatEventsQueryResult = Apollo.QueryResult<FetchAllMatchChatEventsQuery, FetchAllMatchChatEventsQueryVariables>;
export function refetchFetchAllMatchChatEventsQuery(variables?: FetchAllMatchChatEventsQueryVariables) {
      return { query: FetchAllMatchChatEventsDocument, variables: variables }
    }
export const CreateMatchChatEventDocument = gql`
    mutation createMatchChatEvent($input: CreateMatchChatEventInput!) {
  createMatchChatEvent(input: $input) {
    matchChatEvent {
      id
      name
      description
      esportId
      object
      field
      changesTo
      sendMessage
    }
  }
}
    `;
export type CreateMatchChatEventMutationFn = Apollo.MutationFunction<CreateMatchChatEventMutation, CreateMatchChatEventMutationVariables>;

/**
 * __useCreateMatchChatEventMutation__
 *
 * To run a mutation, you first call `useCreateMatchChatEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatchChatEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatchChatEventMutation, { data, loading, error }] = useCreateMatchChatEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMatchChatEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateMatchChatEventMutation, CreateMatchChatEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMatchChatEventMutation, CreateMatchChatEventMutationVariables>(CreateMatchChatEventDocument, options);
      }
export type CreateMatchChatEventMutationHookResult = ReturnType<typeof useCreateMatchChatEventMutation>;
export type CreateMatchChatEventMutationResult = Apollo.MutationResult<CreateMatchChatEventMutation>;
export type CreateMatchChatEventMutationOptions = Apollo.BaseMutationOptions<CreateMatchChatEventMutation, CreateMatchChatEventMutationVariables>;
export const UpdateMatchChatEventDocument = gql`
    mutation updateMatchChatEvent($input: UpdateMatchChatEventInput!) {
  updateMatchChatEvent(input: $input) {
    matchChatEvent {
      id
      name
      description
      esportId
      object
      field
      changesTo
      sendMessage
    }
  }
}
    `;
export type UpdateMatchChatEventMutationFn = Apollo.MutationFunction<UpdateMatchChatEventMutation, UpdateMatchChatEventMutationVariables>;

/**
 * __useUpdateMatchChatEventMutation__
 *
 * To run a mutation, you first call `useUpdateMatchChatEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMatchChatEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMatchChatEventMutation, { data, loading, error }] = useUpdateMatchChatEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMatchChatEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMatchChatEventMutation, UpdateMatchChatEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMatchChatEventMutation, UpdateMatchChatEventMutationVariables>(UpdateMatchChatEventDocument, options);
      }
export type UpdateMatchChatEventMutationHookResult = ReturnType<typeof useUpdateMatchChatEventMutation>;
export type UpdateMatchChatEventMutationResult = Apollo.MutationResult<UpdateMatchChatEventMutation>;
export type UpdateMatchChatEventMutationOptions = Apollo.BaseMutationOptions<UpdateMatchChatEventMutation, UpdateMatchChatEventMutationVariables>;
export const GetChatAccessTokenDocument = gql`
    mutation getChatAccessToken($input: GenerateTwilioAccessTokenByUserIdInput!) {
  generateTwilioAccessTokenByUserId(input: $input) {
    payload {
      twilioAccessToken
    }
  }
}
    `;
export type GetChatAccessTokenMutationFn = Apollo.MutationFunction<GetChatAccessTokenMutation, GetChatAccessTokenMutationVariables>;

/**
 * __useGetChatAccessTokenMutation__
 *
 * To run a mutation, you first call `useGetChatAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetChatAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getChatAccessTokenMutation, { data, loading, error }] = useGetChatAccessTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChatAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetChatAccessTokenMutation, GetChatAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetChatAccessTokenMutation, GetChatAccessTokenMutationVariables>(GetChatAccessTokenDocument, options);
      }
export type GetChatAccessTokenMutationHookResult = ReturnType<typeof useGetChatAccessTokenMutation>;
export type GetChatAccessTokenMutationResult = Apollo.MutationResult<GetChatAccessTokenMutation>;
export type GetChatAccessTokenMutationOptions = Apollo.BaseMutationOptions<GetChatAccessTokenMutation, GetChatAccessTokenMutationVariables>;
export const AddUserToChatDocument = gql`
    mutation addUserToChat($input: AddUserToChatInput!) {
  addUserToChat(input: $input) {
    success
    errors
  }
}
    `;
export type AddUserToChatMutationFn = Apollo.MutationFunction<AddUserToChatMutation, AddUserToChatMutationVariables>;

/**
 * __useAddUserToChatMutation__
 *
 * To run a mutation, you first call `useAddUserToChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToChatMutation, { data, loading, error }] = useAddUserToChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToChatMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToChatMutation, AddUserToChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToChatMutation, AddUserToChatMutationVariables>(AddUserToChatDocument, options);
      }
export type AddUserToChatMutationHookResult = ReturnType<typeof useAddUserToChatMutation>;
export type AddUserToChatMutationResult = Apollo.MutationResult<AddUserToChatMutation>;
export type AddUserToChatMutationOptions = Apollo.BaseMutationOptions<AddUserToChatMutation, AddUserToChatMutationVariables>;
export const SendAnnouncementDocument = gql`
    mutation sendAnnouncement($input: SendAnnouncementByMatchIdsInput!) {
  sendAnnouncementByMatchIds(input: $input) {
    success
    errors
  }
}
    `;
export type SendAnnouncementMutationFn = Apollo.MutationFunction<SendAnnouncementMutation, SendAnnouncementMutationVariables>;

/**
 * __useSendAnnouncementMutation__
 *
 * To run a mutation, you first call `useSendAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAnnouncementMutation, { data, loading, error }] = useSendAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<SendAnnouncementMutation, SendAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAnnouncementMutation, SendAnnouncementMutationVariables>(SendAnnouncementDocument, options);
      }
export type SendAnnouncementMutationHookResult = ReturnType<typeof useSendAnnouncementMutation>;
export type SendAnnouncementMutationResult = Apollo.MutationResult<SendAnnouncementMutation>;
export type SendAnnouncementMutationOptions = Apollo.BaseMutationOptions<SendAnnouncementMutation, SendAnnouncementMutationVariables>;
export const MyCoachPlayerRolePendingUsersDocument = gql`
    query myCoachPlayerRolePendingUsers {
  me {
    id
    school {
      id
      playerRolePendingUsers {
        id
        avatarUrl
        emails {
          id
          email
          isSchoolEmail
        }
        name
      }
    }
  }
}
    `;

/**
 * __useMyCoachPlayerRolePendingUsersQuery__
 *
 * To run a query within a React component, call `useMyCoachPlayerRolePendingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCoachPlayerRolePendingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCoachPlayerRolePendingUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCoachPlayerRolePendingUsersQuery(baseOptions?: Apollo.QueryHookOptions<MyCoachPlayerRolePendingUsersQuery, MyCoachPlayerRolePendingUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCoachPlayerRolePendingUsersQuery, MyCoachPlayerRolePendingUsersQueryVariables>(MyCoachPlayerRolePendingUsersDocument, options);
      }
export function useMyCoachPlayerRolePendingUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCoachPlayerRolePendingUsersQuery, MyCoachPlayerRolePendingUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCoachPlayerRolePendingUsersQuery, MyCoachPlayerRolePendingUsersQueryVariables>(MyCoachPlayerRolePendingUsersDocument, options);
        }
export type MyCoachPlayerRolePendingUsersQueryHookResult = ReturnType<typeof useMyCoachPlayerRolePendingUsersQuery>;
export type MyCoachPlayerRolePendingUsersLazyQueryHookResult = ReturnType<typeof useMyCoachPlayerRolePendingUsersLazyQuery>;
export type MyCoachPlayerRolePendingUsersQueryResult = Apollo.QueryResult<MyCoachPlayerRolePendingUsersQuery, MyCoachPlayerRolePendingUsersQueryVariables>;
export function refetchMyCoachPlayerRolePendingUsersQuery(variables?: MyCoachPlayerRolePendingUsersQueryVariables) {
      return { query: MyCoachPlayerRolePendingUsersDocument, variables: variables }
    }
export const MyDeniedPlayersDocument = gql`
    query myDeniedPlayers($input: FindDeniedUsers!) {
  findDeniedUsers(input: $input) {
    totalCount
    users {
      id
      name
      avatarUrl
      emails {
        id
        email
        isSchoolEmail
      }
      createdAt
      gradYear
    }
  }
}
    `;

/**
 * __useMyDeniedPlayersQuery__
 *
 * To run a query within a React component, call `useMyDeniedPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDeniedPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDeniedPlayersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyDeniedPlayersQuery(baseOptions: Apollo.QueryHookOptions<MyDeniedPlayersQuery, MyDeniedPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyDeniedPlayersQuery, MyDeniedPlayersQueryVariables>(MyDeniedPlayersDocument, options);
      }
export function useMyDeniedPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyDeniedPlayersQuery, MyDeniedPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyDeniedPlayersQuery, MyDeniedPlayersQueryVariables>(MyDeniedPlayersDocument, options);
        }
export type MyDeniedPlayersQueryHookResult = ReturnType<typeof useMyDeniedPlayersQuery>;
export type MyDeniedPlayersLazyQueryHookResult = ReturnType<typeof useMyDeniedPlayersLazyQuery>;
export type MyDeniedPlayersQueryResult = Apollo.QueryResult<MyDeniedPlayersQuery, MyDeniedPlayersQueryVariables>;
export function refetchMyDeniedPlayersQuery(variables: MyDeniedPlayersQueryVariables) {
      return { query: MyDeniedPlayersDocument, variables: variables }
    }
export const MyArchivedPlayersDocument = gql`
    query myArchivedPlayers($schoolId: UUID!) {
  school(id: $schoolId) {
    id
    archivedPlayers {
      id
      avatarUrl
      createdAt
      emails {
        id
        email
        isSchoolEmail
      }
      schoolRoleStatus {
        role {
          roleName
        }
        status
      }
      gradYear
      name
    }
  }
}
    `;

/**
 * __useMyArchivedPlayersQuery__
 *
 * To run a query within a React component, call `useMyArchivedPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyArchivedPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyArchivedPlayersQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useMyArchivedPlayersQuery(baseOptions: Apollo.QueryHookOptions<MyArchivedPlayersQuery, MyArchivedPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyArchivedPlayersQuery, MyArchivedPlayersQueryVariables>(MyArchivedPlayersDocument, options);
      }
export function useMyArchivedPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyArchivedPlayersQuery, MyArchivedPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyArchivedPlayersQuery, MyArchivedPlayersQueryVariables>(MyArchivedPlayersDocument, options);
        }
export type MyArchivedPlayersQueryHookResult = ReturnType<typeof useMyArchivedPlayersQuery>;
export type MyArchivedPlayersLazyQueryHookResult = ReturnType<typeof useMyArchivedPlayersLazyQuery>;
export type MyArchivedPlayersQueryResult = Apollo.QueryResult<MyArchivedPlayersQuery, MyArchivedPlayersQueryVariables>;
export function refetchMyArchivedPlayersQuery(variables: MyArchivedPlayersQueryVariables) {
      return { query: MyArchivedPlayersDocument, variables: variables }
    }
export const MyCoachPlayersDocument = gql`
    query myCoachPlayers($input: FindUsers!) {
  findUsers(input: $input) {
    totalCount
    users {
      id
      name
      firstName
      lastName
      emails {
        id
        email
        isSchoolEmail
      }
      avatarUrl
      gradYear
      createdAt
      esportInterests {
        id
        slug
      }
      userProviderAccounts {
        id
        userId
        providerName
        providerAccountId
        providerDisplayName
        providerIntegrationType
      }
      school {
        id
      }
      schoolRoleStatus {
        role {
          roleName
        }
        status
      }
    }
  }
}
    `;

/**
 * __useMyCoachPlayersQuery__
 *
 * To run a query within a React component, call `useMyCoachPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCoachPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCoachPlayersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMyCoachPlayersQuery(baseOptions: Apollo.QueryHookOptions<MyCoachPlayersQuery, MyCoachPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCoachPlayersQuery, MyCoachPlayersQueryVariables>(MyCoachPlayersDocument, options);
      }
export function useMyCoachPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCoachPlayersQuery, MyCoachPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCoachPlayersQuery, MyCoachPlayersQueryVariables>(MyCoachPlayersDocument, options);
        }
export type MyCoachPlayersQueryHookResult = ReturnType<typeof useMyCoachPlayersQuery>;
export type MyCoachPlayersLazyQueryHookResult = ReturnType<typeof useMyCoachPlayersLazyQuery>;
export type MyCoachPlayersQueryResult = Apollo.QueryResult<MyCoachPlayersQuery, MyCoachPlayersQueryVariables>;
export function refetchMyCoachPlayersQuery(variables: MyCoachPlayersQueryVariables) {
      return { query: MyCoachPlayersDocument, variables: variables }
    }
export const FindPlayersEligibleForTeamDocument = gql`
    query findPlayersEligibleForTeam($teamId: UUID!, $metaseasonId: UUID) {
  findPlayersEligibleForTeam(teamId: $teamId, metaseasonId: $metaseasonId) {
    id
    avatarUrl
    name
    userProviderAccounts {
      id
      userId
      providerName
      providerAccountId
      providerDisplayName
      providerIntegrationType
    }
  }
}
    `;

/**
 * __useFindPlayersEligibleForTeamQuery__
 *
 * To run a query within a React component, call `useFindPlayersEligibleForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPlayersEligibleForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPlayersEligibleForTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useFindPlayersEligibleForTeamQuery(baseOptions: Apollo.QueryHookOptions<FindPlayersEligibleForTeamQuery, FindPlayersEligibleForTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPlayersEligibleForTeamQuery, FindPlayersEligibleForTeamQueryVariables>(FindPlayersEligibleForTeamDocument, options);
      }
export function useFindPlayersEligibleForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPlayersEligibleForTeamQuery, FindPlayersEligibleForTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPlayersEligibleForTeamQuery, FindPlayersEligibleForTeamQueryVariables>(FindPlayersEligibleForTeamDocument, options);
        }
export type FindPlayersEligibleForTeamQueryHookResult = ReturnType<typeof useFindPlayersEligibleForTeamQuery>;
export type FindPlayersEligibleForTeamLazyQueryHookResult = ReturnType<typeof useFindPlayersEligibleForTeamLazyQuery>;
export type FindPlayersEligibleForTeamQueryResult = Apollo.QueryResult<FindPlayersEligibleForTeamQuery, FindPlayersEligibleForTeamQueryVariables>;
export function refetchFindPlayersEligibleForTeamQuery(variables: FindPlayersEligibleForTeamQueryVariables) {
      return { query: FindPlayersEligibleForTeamDocument, variables: variables }
    }
export const FindPlayersEligibleForTeamV2Document = gql`
    query findPlayersEligibleForTeamV2($teamId: UUID!, $metaseasonId: UUID) {
  findPlayersEligibleForTeam(teamId: $teamId, metaseasonId: $metaseasonId) {
    id
    avatarUrl
    name
    isUnderage
    emails {
      id
      email
      isSchoolEmail
    }
    userProviderAccounts {
      id
      userId
      providerName
      providerAccountId
      providerDisplayName
      providerIntegrationType
    }
  }
  team(id: $teamId) {
    id
    roster {
      teamId
      players {
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useFindPlayersEligibleForTeamV2Query__
 *
 * To run a query within a React component, call `useFindPlayersEligibleForTeamV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFindPlayersEligibleForTeamV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPlayersEligibleForTeamV2Query({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useFindPlayersEligibleForTeamV2Query(baseOptions: Apollo.QueryHookOptions<FindPlayersEligibleForTeamV2Query, FindPlayersEligibleForTeamV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPlayersEligibleForTeamV2Query, FindPlayersEligibleForTeamV2QueryVariables>(FindPlayersEligibleForTeamV2Document, options);
      }
export function useFindPlayersEligibleForTeamV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPlayersEligibleForTeamV2Query, FindPlayersEligibleForTeamV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPlayersEligibleForTeamV2Query, FindPlayersEligibleForTeamV2QueryVariables>(FindPlayersEligibleForTeamV2Document, options);
        }
export type FindPlayersEligibleForTeamV2QueryHookResult = ReturnType<typeof useFindPlayersEligibleForTeamV2Query>;
export type FindPlayersEligibleForTeamV2LazyQueryHookResult = ReturnType<typeof useFindPlayersEligibleForTeamV2LazyQuery>;
export type FindPlayersEligibleForTeamV2QueryResult = Apollo.QueryResult<FindPlayersEligibleForTeamV2Query, FindPlayersEligibleForTeamV2QueryVariables>;
export function refetchFindPlayersEligibleForTeamV2Query(variables: FindPlayersEligibleForTeamV2QueryVariables) {
      return { query: FindPlayersEligibleForTeamV2Document, variables: variables }
    }
export const MySchoolDetailsDocument = gql`
    query mySchoolDetails {
  me {
    id
    school {
      id
      address
      whoPays
      competitionGroup
    }
  }
}
    `;

/**
 * __useMySchoolDetailsQuery__
 *
 * To run a query within a React component, call `useMySchoolDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySchoolDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySchoolDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySchoolDetailsQuery(baseOptions?: Apollo.QueryHookOptions<MySchoolDetailsQuery, MySchoolDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySchoolDetailsQuery, MySchoolDetailsQueryVariables>(MySchoolDetailsDocument, options);
      }
export function useMySchoolDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySchoolDetailsQuery, MySchoolDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySchoolDetailsQuery, MySchoolDetailsQueryVariables>(MySchoolDetailsDocument, options);
        }
export type MySchoolDetailsQueryHookResult = ReturnType<typeof useMySchoolDetailsQuery>;
export type MySchoolDetailsLazyQueryHookResult = ReturnType<typeof useMySchoolDetailsLazyQuery>;
export type MySchoolDetailsQueryResult = Apollo.QueryResult<MySchoolDetailsQuery, MySchoolDetailsQueryVariables>;
export function refetchMySchoolDetailsQuery(variables?: MySchoolDetailsQueryVariables) {
      return { query: MySchoolDetailsDocument, variables: variables }
    }
export const MySchoolTeamEsportsDocument = gql`
    query mySchoolTeamEsports {
  me {
    school {
      id
      teams {
        id
        esport {
          id
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useMySchoolTeamEsportsQuery__
 *
 * To run a query within a React component, call `useMySchoolTeamEsportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySchoolTeamEsportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySchoolTeamEsportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySchoolTeamEsportsQuery(baseOptions?: Apollo.QueryHookOptions<MySchoolTeamEsportsQuery, MySchoolTeamEsportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySchoolTeamEsportsQuery, MySchoolTeamEsportsQueryVariables>(MySchoolTeamEsportsDocument, options);
      }
export function useMySchoolTeamEsportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySchoolTeamEsportsQuery, MySchoolTeamEsportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySchoolTeamEsportsQuery, MySchoolTeamEsportsQueryVariables>(MySchoolTeamEsportsDocument, options);
        }
export type MySchoolTeamEsportsQueryHookResult = ReturnType<typeof useMySchoolTeamEsportsQuery>;
export type MySchoolTeamEsportsLazyQueryHookResult = ReturnType<typeof useMySchoolTeamEsportsLazyQuery>;
export type MySchoolTeamEsportsQueryResult = Apollo.QueryResult<MySchoolTeamEsportsQuery, MySchoolTeamEsportsQueryVariables>;
export function refetchMySchoolTeamEsportsQuery(variables?: MySchoolTeamEsportsQueryVariables) {
      return { query: MySchoolTeamEsportsDocument, variables: variables }
    }
export const AddPlayerToTeamDocument = gql`
    mutation addPlayerToTeam($teamId: UUID!, $userId: UUID!, $metaseasonId: UUID, $position: Int, $hideTeamInRequestIfDuplicate: Boolean, $options: AddPlayerToTeamOptions) {
  addPlayerToTeam(
    teamId: $teamId
    userId: $userId
    metaseasonId: $metaseasonId
    position: $position
    hideTeamInRequestIfDuplicate: $hideTeamInRequestIfDuplicate
    options: $options
  ) {
    team {
      id
      roster {
        id
        numPlayers
        maxNumPlayers
        isFull
        players {
          user {
            id
          }
        }
        formats {
          teamSize
          substitutes {
            isCaptain
            user {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type AddPlayerToTeamMutationFn = Apollo.MutationFunction<AddPlayerToTeamMutation, AddPlayerToTeamMutationVariables>;

/**
 * __useAddPlayerToTeamMutation__
 *
 * To run a mutation, you first call `useAddPlayerToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlayerToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlayerToTeamMutation, { data, loading, error }] = useAddPlayerToTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *      metaseasonId: // value for 'metaseasonId'
 *      position: // value for 'position'
 *      hideTeamInRequestIfDuplicate: // value for 'hideTeamInRequestIfDuplicate'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useAddPlayerToTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddPlayerToTeamMutation, AddPlayerToTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlayerToTeamMutation, AddPlayerToTeamMutationVariables>(AddPlayerToTeamDocument, options);
      }
export type AddPlayerToTeamMutationHookResult = ReturnType<typeof useAddPlayerToTeamMutation>;
export type AddPlayerToTeamMutationResult = Apollo.MutationResult<AddPlayerToTeamMutation>;
export type AddPlayerToTeamMutationOptions = Apollo.BaseMutationOptions<AddPlayerToTeamMutation, AddPlayerToTeamMutationVariables>;
export const JoinTeamDocument = gql`
    mutation joinTeam($teamId: UUID!, $position: Int, $options: JoinTeamOptions) {
  joinTeam(teamId: $teamId, position: $position, options: $options) {
    team {
      id
      roster {
        id
        numPlayers
        maxNumPlayers
        isFull
        players {
          user {
            id
          }
        }
        formats {
          teamSize
          substitutes {
            isCaptain
            user {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type JoinTeamMutationFn = Apollo.MutationFunction<JoinTeamMutation, JoinTeamMutationVariables>;

/**
 * __useJoinTeamMutation__
 *
 * To run a mutation, you first call `useJoinTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinTeamMutation, { data, loading, error }] = useJoinTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      position: // value for 'position'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useJoinTeamMutation(baseOptions?: Apollo.MutationHookOptions<JoinTeamMutation, JoinTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinTeamMutation, JoinTeamMutationVariables>(JoinTeamDocument, options);
      }
export type JoinTeamMutationHookResult = ReturnType<typeof useJoinTeamMutation>;
export type JoinTeamMutationResult = Apollo.MutationResult<JoinTeamMutation>;
export type JoinTeamMutationOptions = Apollo.BaseMutationOptions<JoinTeamMutation, JoinTeamMutationVariables>;
export const DenyPlayerDocument = gql`
    mutation denyPlayer($userId: UUID!, $resourceId: UUID!) {
  denyPlayer(userId: $userId, resourceId: $resourceId) {
    id
    email
    name
  }
}
    `;
export type DenyPlayerMutationFn = Apollo.MutationFunction<DenyPlayerMutation, DenyPlayerMutationVariables>;

/**
 * __useDenyPlayerMutation__
 *
 * To run a mutation, you first call `useDenyPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyPlayerMutation, { data, loading, error }] = useDenyPlayerMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useDenyPlayerMutation(baseOptions?: Apollo.MutationHookOptions<DenyPlayerMutation, DenyPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyPlayerMutation, DenyPlayerMutationVariables>(DenyPlayerDocument, options);
      }
export type DenyPlayerMutationHookResult = ReturnType<typeof useDenyPlayerMutation>;
export type DenyPlayerMutationResult = Apollo.MutationResult<DenyPlayerMutation>;
export type DenyPlayerMutationOptions = Apollo.BaseMutationOptions<DenyPlayerMutation, DenyPlayerMutationVariables>;
export const VerifyPlayerDocument = gql`
    mutation verifyPlayer($userId: UUID!, $resourceId: UUID!) {
  verifyPlayer(userId: $userId, resourceId: $resourceId) {
    id
    email
    name
  }
}
    `;
export type VerifyPlayerMutationFn = Apollo.MutationFunction<VerifyPlayerMutation, VerifyPlayerMutationVariables>;

/**
 * __useVerifyPlayerMutation__
 *
 * To run a mutation, you first call `useVerifyPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPlayerMutation, { data, loading, error }] = useVerifyPlayerMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useVerifyPlayerMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPlayerMutation, VerifyPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPlayerMutation, VerifyPlayerMutationVariables>(VerifyPlayerDocument, options);
      }
export type VerifyPlayerMutationHookResult = ReturnType<typeof useVerifyPlayerMutation>;
export type VerifyPlayerMutationResult = Apollo.MutationResult<VerifyPlayerMutation>;
export type VerifyPlayerMutationOptions = Apollo.BaseMutationOptions<VerifyPlayerMutation, VerifyPlayerMutationVariables>;
export const GraduatePlayerDocument = gql`
    mutation graduatePlayer($input: GraduatePlayerInput!) {
  graduatePlayer(input: $input) {
    success
  }
}
    `;
export type GraduatePlayerMutationFn = Apollo.MutationFunction<GraduatePlayerMutation, GraduatePlayerMutationVariables>;

/**
 * __useGraduatePlayerMutation__
 *
 * To run a mutation, you first call `useGraduatePlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGraduatePlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [graduatePlayerMutation, { data, loading, error }] = useGraduatePlayerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGraduatePlayerMutation(baseOptions?: Apollo.MutationHookOptions<GraduatePlayerMutation, GraduatePlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraduatePlayerMutation, GraduatePlayerMutationVariables>(GraduatePlayerDocument, options);
      }
export type GraduatePlayerMutationHookResult = ReturnType<typeof useGraduatePlayerMutation>;
export type GraduatePlayerMutationResult = Apollo.MutationResult<GraduatePlayerMutation>;
export type GraduatePlayerMutationOptions = Apollo.BaseMutationOptions<GraduatePlayerMutation, GraduatePlayerMutationVariables>;
export const TransferPlayerDocument = gql`
    mutation transferPlayer($input: TransferPlayerInput!) {
  transferPlayer(input: $input) {
    success
  }
}
    `;
export type TransferPlayerMutationFn = Apollo.MutationFunction<TransferPlayerMutation, TransferPlayerMutationVariables>;

/**
 * __useTransferPlayerMutation__
 *
 * To run a mutation, you first call `useTransferPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferPlayerMutation, { data, loading, error }] = useTransferPlayerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferPlayerMutation(baseOptions?: Apollo.MutationHookOptions<TransferPlayerMutation, TransferPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferPlayerMutation, TransferPlayerMutationVariables>(TransferPlayerDocument, options);
      }
export type TransferPlayerMutationHookResult = ReturnType<typeof useTransferPlayerMutation>;
export type TransferPlayerMutationResult = Apollo.MutationResult<TransferPlayerMutation>;
export type TransferPlayerMutationOptions = Apollo.BaseMutationOptions<TransferPlayerMutation, TransferPlayerMutationVariables>;
export const VerifyArchivedPlayerDocument = gql`
    mutation verifyArchivedPlayer($input: VerifyArchivedPlayerInput!) {
  verifyArchivedPlayer(input: $input) {
    success
  }
}
    `;
export type VerifyArchivedPlayerMutationFn = Apollo.MutationFunction<VerifyArchivedPlayerMutation, VerifyArchivedPlayerMutationVariables>;

/**
 * __useVerifyArchivedPlayerMutation__
 *
 * To run a mutation, you first call `useVerifyArchivedPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyArchivedPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyArchivedPlayerMutation, { data, loading, error }] = useVerifyArchivedPlayerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyArchivedPlayerMutation(baseOptions?: Apollo.MutationHookOptions<VerifyArchivedPlayerMutation, VerifyArchivedPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyArchivedPlayerMutation, VerifyArchivedPlayerMutationVariables>(VerifyArchivedPlayerDocument, options);
      }
export type VerifyArchivedPlayerMutationHookResult = ReturnType<typeof useVerifyArchivedPlayerMutation>;
export type VerifyArchivedPlayerMutationResult = Apollo.MutationResult<VerifyArchivedPlayerMutation>;
export type VerifyArchivedPlayerMutationOptions = Apollo.BaseMutationOptions<VerifyArchivedPlayerMutation, VerifyArchivedPlayerMutationVariables>;
export const RemovePlayerFromTeamDocument = gql`
    mutation removePlayerFromTeam($teamId: UUID!, $playerId: UUID!, $metaseasonId: UUID) {
  removePlayerFromTeam(
    teamId: $teamId
    playerId: $playerId
    metaseasonId: $metaseasonId
  ) {
    team {
      id
      roster {
        id
        players {
          user {
            id
          }
        }
        formats {
          starters {
            player {
              isCaptain
              user {
                id
              }
            }
          }
          substitutes {
            user {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type RemovePlayerFromTeamMutationFn = Apollo.MutationFunction<RemovePlayerFromTeamMutation, RemovePlayerFromTeamMutationVariables>;

/**
 * __useRemovePlayerFromTeamMutation__
 *
 * To run a mutation, you first call `useRemovePlayerFromTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlayerFromTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlayerFromTeamMutation, { data, loading, error }] = useRemovePlayerFromTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      playerId: // value for 'playerId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useRemovePlayerFromTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemovePlayerFromTeamMutation, RemovePlayerFromTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePlayerFromTeamMutation, RemovePlayerFromTeamMutationVariables>(RemovePlayerFromTeamDocument, options);
      }
export type RemovePlayerFromTeamMutationHookResult = ReturnType<typeof useRemovePlayerFromTeamMutation>;
export type RemovePlayerFromTeamMutationResult = Apollo.MutationResult<RemovePlayerFromTeamMutation>;
export type RemovePlayerFromTeamMutationOptions = Apollo.BaseMutationOptions<RemovePlayerFromTeamMutation, RemovePlayerFromTeamMutationVariables>;
export const LeaveTeamDocument = gql`
    mutation leaveTeam($teamId: UUID!) {
  leaveTeam(teamId: $teamId) {
    success
  }
}
    `;
export type LeaveTeamMutationFn = Apollo.MutationFunction<LeaveTeamMutation, LeaveTeamMutationVariables>;

/**
 * __useLeaveTeamMutation__
 *
 * To run a mutation, you first call `useLeaveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveTeamMutation, { data, loading, error }] = useLeaveTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useLeaveTeamMutation(baseOptions?: Apollo.MutationHookOptions<LeaveTeamMutation, LeaveTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveTeamMutation, LeaveTeamMutationVariables>(LeaveTeamDocument, options);
      }
export type LeaveTeamMutationHookResult = ReturnType<typeof useLeaveTeamMutation>;
export type LeaveTeamMutationResult = Apollo.MutationResult<LeaveTeamMutation>;
export type LeaveTeamMutationOptions = Apollo.BaseMutationOptions<LeaveTeamMutation, LeaveTeamMutationVariables>;
export const CreateTeamV2Document = gql`
    mutation createTeamV2($input: CreateTeamV2Input!, $schoolOptions: TeamSchoolOptions) {
  createTeamV2(input: $input, schoolOptions: $schoolOptions) {
    team {
      id
      name
      createdByUser {
        id
        roles {
          userId
          roleName
          resourceType
          resourceId
          status
        }
      }
      esport {
        id
        name
      }
    }
  }
}
    `;
export type CreateTeamV2MutationFn = Apollo.MutationFunction<CreateTeamV2Mutation, CreateTeamV2MutationVariables>;

/**
 * __useCreateTeamV2Mutation__
 *
 * To run a mutation, you first call `useCreateTeamV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamV2Mutation, { data, loading, error }] = useCreateTeamV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *      schoolOptions: // value for 'schoolOptions'
 *   },
 * });
 */
export function useCreateTeamV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamV2Mutation, CreateTeamV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamV2Mutation, CreateTeamV2MutationVariables>(CreateTeamV2Document, options);
      }
export type CreateTeamV2MutationHookResult = ReturnType<typeof useCreateTeamV2Mutation>;
export type CreateTeamV2MutationResult = Apollo.MutationResult<CreateTeamV2Mutation>;
export type CreateTeamV2MutationOptions = Apollo.BaseMutationOptions<CreateTeamV2Mutation, CreateTeamV2MutationVariables>;
export const UpdateTeamDocument = gql`
    mutation updateTeam($teamId: UUID!, $input: UpdateTeamInput!) {
  updateTeam(teamId: $teamId, input: $input) {
    team {
      id
      name
    }
  }
}
    `;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const AddTeamToLeagueDocument = gql`
    mutation addTeamToLeague($teamId: UUID!, $metaseasonId: UUID!, $leagueId: UUID!) {
  addTeamToLeague(
    teamId: $teamId
    leagueId: $leagueId
    metaseasonId: $metaseasonId
  ) {
    success
  }
}
    `;
export type AddTeamToLeagueMutationFn = Apollo.MutationFunction<AddTeamToLeagueMutation, AddTeamToLeagueMutationVariables>;

/**
 * __useAddTeamToLeagueMutation__
 *
 * To run a mutation, you first call `useAddTeamToLeagueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamToLeagueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamToLeagueMutation, { data, loading, error }] = useAddTeamToLeagueMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      metaseasonId: // value for 'metaseasonId'
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useAddTeamToLeagueMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamToLeagueMutation, AddTeamToLeagueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamToLeagueMutation, AddTeamToLeagueMutationVariables>(AddTeamToLeagueDocument, options);
      }
export type AddTeamToLeagueMutationHookResult = ReturnType<typeof useAddTeamToLeagueMutation>;
export type AddTeamToLeagueMutationResult = Apollo.MutationResult<AddTeamToLeagueMutation>;
export type AddTeamToLeagueMutationOptions = Apollo.BaseMutationOptions<AddTeamToLeagueMutation, AddTeamToLeagueMutationVariables>;
export const RepositionPlayersInTeamDocument = gql`
    mutation repositionPlayersInTeam($teamId: UUID!, $metaseasonId: UUID, $playerPositions: [PlayerPosition!]!) {
  repositionPlayersInTeam(
    teamId: $teamId
    metaseasonId: $metaseasonId
    playerPositions: $playerPositions
  ) {
    team {
      id
      roster {
        id
        numPlayers
        maxNumPlayers
        isFull
        players {
          user {
            id
          }
        }
        formats {
          teamSize
          starters {
            position {
              id
            }
            player {
              user {
                id
              }
            }
          }
          substitutes {
            user {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type RepositionPlayersInTeamMutationFn = Apollo.MutationFunction<RepositionPlayersInTeamMutation, RepositionPlayersInTeamMutationVariables>;

/**
 * __useRepositionPlayersInTeamMutation__
 *
 * To run a mutation, you first call `useRepositionPlayersInTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepositionPlayersInTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repositionPlayersInTeamMutation, { data, loading, error }] = useRepositionPlayersInTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      metaseasonId: // value for 'metaseasonId'
 *      playerPositions: // value for 'playerPositions'
 *   },
 * });
 */
export function useRepositionPlayersInTeamMutation(baseOptions?: Apollo.MutationHookOptions<RepositionPlayersInTeamMutation, RepositionPlayersInTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepositionPlayersInTeamMutation, RepositionPlayersInTeamMutationVariables>(RepositionPlayersInTeamDocument, options);
      }
export type RepositionPlayersInTeamMutationHookResult = ReturnType<typeof useRepositionPlayersInTeamMutation>;
export type RepositionPlayersInTeamMutationResult = Apollo.MutationResult<RepositionPlayersInTeamMutation>;
export type RepositionPlayersInTeamMutationOptions = Apollo.BaseMutationOptions<RepositionPlayersInTeamMutation, RepositionPlayersInTeamMutationVariables>;
export const GetEligiblePlayersForTeamDocument = gql`
    query getEligiblePlayersForTeam($teamId: UUID!) {
  team(id: $teamId) {
    id
    esport {
      id
      name
    }
    roster {
      teamId
      formats {
        starters {
          player {
            user {
              id
            }
          }
        }
        substitutes {
          user {
            id
            name
            avatarUrl
            userProviderAccounts {
              id
              userId
              providerName
              providerAccountId
              providerDisplayName
              providerIntegrationType
            }
            seasonPasses {
              metaseasonId
              leagueId
              consumedAt
            }
          }
        }
      }
      players {
        user {
          id
        }
      }
    }
    getEligiblePlayers {
      disabled
      disabledReason
      user {
        id
        avatarUrl
        name
        emails {
          id
          isSchoolEmail
          email
        }
        userProviderAccounts {
          id
          userId
          providerName
          providerAccountId
          providerDisplayName
          providerIntegrationType
        }
        esportInterests {
          id
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useGetEligiblePlayersForTeamQuery__
 *
 * To run a query within a React component, call `useGetEligiblePlayersForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligiblePlayersForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligiblePlayersForTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetEligiblePlayersForTeamQuery(baseOptions: Apollo.QueryHookOptions<GetEligiblePlayersForTeamQuery, GetEligiblePlayersForTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEligiblePlayersForTeamQuery, GetEligiblePlayersForTeamQueryVariables>(GetEligiblePlayersForTeamDocument, options);
      }
export function useGetEligiblePlayersForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEligiblePlayersForTeamQuery, GetEligiblePlayersForTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEligiblePlayersForTeamQuery, GetEligiblePlayersForTeamQueryVariables>(GetEligiblePlayersForTeamDocument, options);
        }
export type GetEligiblePlayersForTeamQueryHookResult = ReturnType<typeof useGetEligiblePlayersForTeamQuery>;
export type GetEligiblePlayersForTeamLazyQueryHookResult = ReturnType<typeof useGetEligiblePlayersForTeamLazyQuery>;
export type GetEligiblePlayersForTeamQueryResult = Apollo.QueryResult<GetEligiblePlayersForTeamQuery, GetEligiblePlayersForTeamQueryVariables>;
export function refetchGetEligiblePlayersForTeamQuery(variables: GetEligiblePlayersForTeamQueryVariables) {
      return { query: GetEligiblePlayersForTeamDocument, variables: variables }
    }
export const TeamDetailsDocument = gql`
    query teamDetails($id: UUID!) {
  team(id: $id) {
    id
    name
    competitionGroup
    esport {
      id
      name
      slug
    }
    leagues {
      id
      seasons {
        id
        metaseasonId
        name
        rostersLockAt
        teamRegistrationEndsAt
        phases {
          id
          startsAt
          endsAt
          name
          type
          seasonId
          status
          format
          survivalAdvancementPercentage
          survivalAdvancementCount
        }
      }
    }
    school {
      id
      competitionGroup
    }
  }
}
    `;

/**
 * __useTeamDetailsQuery__
 *
 * To run a query within a React component, call `useTeamDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamDetailsQuery(baseOptions: Apollo.QueryHookOptions<TeamDetailsQuery, TeamDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamDetailsQuery, TeamDetailsQueryVariables>(TeamDetailsDocument, options);
      }
export function useTeamDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamDetailsQuery, TeamDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamDetailsQuery, TeamDetailsQueryVariables>(TeamDetailsDocument, options);
        }
export type TeamDetailsQueryHookResult = ReturnType<typeof useTeamDetailsQuery>;
export type TeamDetailsLazyQueryHookResult = ReturnType<typeof useTeamDetailsLazyQuery>;
export type TeamDetailsQueryResult = Apollo.QueryResult<TeamDetailsQuery, TeamDetailsQueryVariables>;
export function refetchTeamDetailsQuery(variables: TeamDetailsQueryVariables) {
      return { query: TeamDetailsDocument, variables: variables }
    }
export const GetSchoolLeaguesByTeamDocument = gql`
    query getSchoolLeaguesByTeam($metaseasonId: UUID!, $isCoach: Boolean!, $teamId: UUID!, $schoolId: UUID!) {
  team(id: $teamId) {
    id
    school {
      id
      annualPassProductsEligible @include(if: $isCoach) {
        id
        name
        description
        priceUsd
        type
        slug
        position
        seasonPassesAllotted {
          id
        }
      }
      annualPassInstances(metaseasonId: $metaseasonId) @include(if: $isCoach) {
        id
        productId
        productInstanceInfo {
          initialMetaseasonId
        }
      }
    }
  }
  getLeaguesBySchoolId(schoolId: $schoolId) {
    id
    name
    displayName
    state
    competitionModel
    competitionGroup
    seasons {
      id
      metaseasonId
      registrationStartsAt
      teamRegistrationEndsAt
      teamDeregistrationEndsAt
      suggestedRegistrationEndsAt
    }
    varsityAssociation {
      name
    }
    esport {
      id
      slug
      name
      rating
    }
  }
}
    `;

/**
 * __useGetSchoolLeaguesByTeamQuery__
 *
 * To run a query within a React component, call `useGetSchoolLeaguesByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolLeaguesByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolLeaguesByTeamQuery({
 *   variables: {
 *      metaseasonId: // value for 'metaseasonId'
 *      isCoach: // value for 'isCoach'
 *      teamId: // value for 'teamId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolLeaguesByTeamQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolLeaguesByTeamQuery, GetSchoolLeaguesByTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolLeaguesByTeamQuery, GetSchoolLeaguesByTeamQueryVariables>(GetSchoolLeaguesByTeamDocument, options);
      }
export function useGetSchoolLeaguesByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolLeaguesByTeamQuery, GetSchoolLeaguesByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolLeaguesByTeamQuery, GetSchoolLeaguesByTeamQueryVariables>(GetSchoolLeaguesByTeamDocument, options);
        }
export type GetSchoolLeaguesByTeamQueryHookResult = ReturnType<typeof useGetSchoolLeaguesByTeamQuery>;
export type GetSchoolLeaguesByTeamLazyQueryHookResult = ReturnType<typeof useGetSchoolLeaguesByTeamLazyQuery>;
export type GetSchoolLeaguesByTeamQueryResult = Apollo.QueryResult<GetSchoolLeaguesByTeamQuery, GetSchoolLeaguesByTeamQueryVariables>;
export function refetchGetSchoolLeaguesByTeamQuery(variables: GetSchoolLeaguesByTeamQueryVariables) {
      return { query: GetSchoolLeaguesByTeamDocument, variables: variables }
    }
export const GetLeaguesForTeamDocument = gql`
    query getLeaguesForTeam {
  me {
    id
    leagueScope {
      result {
        id
        esportId
        displayName
        name
        esport {
          id
          name
        }
        competitionModel
        competitionGroup
        timezone
        seasons {
          id
          rostersLockAt
          metaseasonId
          teamRegistrationEndsAt
          phases {
            id
            type
            slots {
              id
              startsAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLeaguesForTeamQuery__
 *
 * To run a query within a React component, call `useGetLeaguesForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaguesForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaguesForTeamQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeaguesForTeamQuery(baseOptions?: Apollo.QueryHookOptions<GetLeaguesForTeamQuery, GetLeaguesForTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaguesForTeamQuery, GetLeaguesForTeamQueryVariables>(GetLeaguesForTeamDocument, options);
      }
export function useGetLeaguesForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaguesForTeamQuery, GetLeaguesForTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaguesForTeamQuery, GetLeaguesForTeamQueryVariables>(GetLeaguesForTeamDocument, options);
        }
export type GetLeaguesForTeamQueryHookResult = ReturnType<typeof useGetLeaguesForTeamQuery>;
export type GetLeaguesForTeamLazyQueryHookResult = ReturnType<typeof useGetLeaguesForTeamLazyQuery>;
export type GetLeaguesForTeamQueryResult = Apollo.QueryResult<GetLeaguesForTeamQuery, GetLeaguesForTeamQueryVariables>;
export function refetchGetLeaguesForTeamQuery(variables?: GetLeaguesForTeamQueryVariables) {
      return { query: GetLeaguesForTeamDocument, variables: variables }
    }
export const TeamDocument = gql`
    query team($id: UUID!, $date: DateTime!) {
  team(id: $id) {
    id
    competitionGroup
    school {
      id
      competitionGroup
      logoUrl
      name
    }
    inviteUrl
    deletedAt
    isPlayerLed
    createdAt
    createdBy
    coaches {
      id
      name
      firstName
      lastName
      phone
      phoneExt
      avatarUrl
    }
    esport {
      id
      slug
      leagueDefaults {
        teamFormat
        teamMaxSize
      }
    }
    enrolledSeasons {
      id
      rostersLockAt
      teamDeregistrationEndsAt
      metaseason {
        id
        isPromoted
        startsAt
        name
        endsAt
      }
    }
    leagues {
      id
      competitionModel
      esport {
        id
      }
    }
    name
    roster(effectiveAt: $date) {
      teamId
      numPlayers
      maxNumPlayers
      isFull
      players {
        user {
          id
          name
        }
      }
      formats {
        teamSize
        starters {
          position {
            id
            index
            name
            abbreviation
            colloquial
          }
          player {
            isCaptain
            user {
              id
              name
              avatarUrl
              userProviderAccounts {
                id
                userId
                providerName
                providerAccountId
                providerDisplayName
                providerIntegrationType
              }
            }
          }
        }
        substitutes {
          isCaptain
          user {
            id
            name
            avatarUrl
            userProviderAccounts {
              id
              userId
              providerName
              providerAccountId
              providerDisplayName
              providerIntegrationType
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTeamQuery(baseOptions: Apollo.QueryHookOptions<TeamQuery, TeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
      }
export function useTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>;
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>;
export type TeamQueryResult = Apollo.QueryResult<TeamQuery, TeamQueryVariables>;
export function refetchTeamQuery(variables: TeamQueryVariables) {
      return { query: TeamDocument, variables: variables }
    }
export const GetTeamNameDocument = gql`
    query getTeamName($id: UUID!) {
  team(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetTeamNameQuery__
 *
 * To run a query within a React component, call `useGetTeamNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamNameQuery(baseOptions: Apollo.QueryHookOptions<GetTeamNameQuery, GetTeamNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamNameQuery, GetTeamNameQueryVariables>(GetTeamNameDocument, options);
      }
export function useGetTeamNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamNameQuery, GetTeamNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamNameQuery, GetTeamNameQueryVariables>(GetTeamNameDocument, options);
        }
export type GetTeamNameQueryHookResult = ReturnType<typeof useGetTeamNameQuery>;
export type GetTeamNameLazyQueryHookResult = ReturnType<typeof useGetTeamNameLazyQuery>;
export type GetTeamNameQueryResult = Apollo.QueryResult<GetTeamNameQuery, GetTeamNameQueryVariables>;
export function refetchGetTeamNameQuery(variables: GetTeamNameQueryVariables) {
      return { query: GetTeamNameDocument, variables: variables }
    }
export const CompetitionIntervalsForOrgDocument = gql`
    query competitionIntervalsForOrg($schoolId: UUID!) {
  competitionIntervalsForOrganization(input: {organizationId: $schoolId}) {
    results {
      interval {
        name
        startsAt
        endsAt
        tense
        firstDay {
          month
          dayOfMonth
          year
        }
        lastDay {
          month
          dayOfMonth
          year
        }
        enrollmentOpensAt(input: {organizationId: $schoolId})
      }
      metaseasonsForOrganization {
        id
        name
        startsAt
        endsAt
        isPromoted
        earliestEnrollmentDate(schoolId: $schoolId)
      }
    }
  }
}
    `;

/**
 * __useCompetitionIntervalsForOrgQuery__
 *
 * To run a query within a React component, call `useCompetitionIntervalsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetitionIntervalsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetitionIntervalsForOrgQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useCompetitionIntervalsForOrgQuery(baseOptions: Apollo.QueryHookOptions<CompetitionIntervalsForOrgQuery, CompetitionIntervalsForOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetitionIntervalsForOrgQuery, CompetitionIntervalsForOrgQueryVariables>(CompetitionIntervalsForOrgDocument, options);
      }
export function useCompetitionIntervalsForOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetitionIntervalsForOrgQuery, CompetitionIntervalsForOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetitionIntervalsForOrgQuery, CompetitionIntervalsForOrgQueryVariables>(CompetitionIntervalsForOrgDocument, options);
        }
export type CompetitionIntervalsForOrgQueryHookResult = ReturnType<typeof useCompetitionIntervalsForOrgQuery>;
export type CompetitionIntervalsForOrgLazyQueryHookResult = ReturnType<typeof useCompetitionIntervalsForOrgLazyQuery>;
export type CompetitionIntervalsForOrgQueryResult = Apollo.QueryResult<CompetitionIntervalsForOrgQuery, CompetitionIntervalsForOrgQueryVariables>;
export function refetchCompetitionIntervalsForOrgQuery(variables: CompetitionIntervalsForOrgQueryVariables) {
      return { query: CompetitionIntervalsForOrgDocument, variables: variables }
    }
export const CompetitionIntervalsForOrganizationTeamManagementDocument = gql`
    query competitionIntervalsForOrganizationTeamManagement($input: CompetitionIntervalsForOrganizationQueryInput!) {
  competitionIntervalsForOrganization(input: $input) {
    results {
      interval {
        name
        startsAt
        endsAt
        tense
        firstDay {
          month
          dayOfMonth
          year
        }
        lastDay {
          month
          dayOfMonth
          year
        }
        enrolledSeasons(input: $input) {
          endsAt
          id
          registrationStartsAt
          teamRegistrationEndsAt
          type
        }
      }
      metaseasonsForOrganization {
        id
        name
        startsAt
        endsAt
        isPromoted
        enrollmentStartsAt
        enrollmentEndsAt
      }
    }
  }
}
    `;

/**
 * __useCompetitionIntervalsForOrganizationTeamManagementQuery__
 *
 * To run a query within a React component, call `useCompetitionIntervalsForOrganizationTeamManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetitionIntervalsForOrganizationTeamManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetitionIntervalsForOrganizationTeamManagementQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompetitionIntervalsForOrganizationTeamManagementQuery(baseOptions: Apollo.QueryHookOptions<CompetitionIntervalsForOrganizationTeamManagementQuery, CompetitionIntervalsForOrganizationTeamManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetitionIntervalsForOrganizationTeamManagementQuery, CompetitionIntervalsForOrganizationTeamManagementQueryVariables>(CompetitionIntervalsForOrganizationTeamManagementDocument, options);
      }
export function useCompetitionIntervalsForOrganizationTeamManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetitionIntervalsForOrganizationTeamManagementQuery, CompetitionIntervalsForOrganizationTeamManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetitionIntervalsForOrganizationTeamManagementQuery, CompetitionIntervalsForOrganizationTeamManagementQueryVariables>(CompetitionIntervalsForOrganizationTeamManagementDocument, options);
        }
export type CompetitionIntervalsForOrganizationTeamManagementQueryHookResult = ReturnType<typeof useCompetitionIntervalsForOrganizationTeamManagementQuery>;
export type CompetitionIntervalsForOrganizationTeamManagementLazyQueryHookResult = ReturnType<typeof useCompetitionIntervalsForOrganizationTeamManagementLazyQuery>;
export type CompetitionIntervalsForOrganizationTeamManagementQueryResult = Apollo.QueryResult<CompetitionIntervalsForOrganizationTeamManagementQuery, CompetitionIntervalsForOrganizationTeamManagementQueryVariables>;
export function refetchCompetitionIntervalsForOrganizationTeamManagementQuery(variables: CompetitionIntervalsForOrganizationTeamManagementQueryVariables) {
      return { query: CompetitionIntervalsForOrganizationTeamManagementDocument, variables: variables }
    }
export const GetSchoolTeamsCountDocument = gql`
    query getSchoolTeamsCount($schoolId: UUID!) {
  school(id: $schoolId) {
    id
    teams {
      id
    }
  }
}
    `;

/**
 * __useGetSchoolTeamsCountQuery__
 *
 * To run a query within a React component, call `useGetSchoolTeamsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolTeamsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolTeamsCountQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolTeamsCountQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolTeamsCountQuery, GetSchoolTeamsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolTeamsCountQuery, GetSchoolTeamsCountQueryVariables>(GetSchoolTeamsCountDocument, options);
      }
export function useGetSchoolTeamsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolTeamsCountQuery, GetSchoolTeamsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolTeamsCountQuery, GetSchoolTeamsCountQueryVariables>(GetSchoolTeamsCountDocument, options);
        }
export type GetSchoolTeamsCountQueryHookResult = ReturnType<typeof useGetSchoolTeamsCountQuery>;
export type GetSchoolTeamsCountLazyQueryHookResult = ReturnType<typeof useGetSchoolTeamsCountLazyQuery>;
export type GetSchoolTeamsCountQueryResult = Apollo.QueryResult<GetSchoolTeamsCountQuery, GetSchoolTeamsCountQueryVariables>;
export function refetchGetSchoolTeamsCountQuery(variables: GetSchoolTeamsCountQueryVariables) {
      return { query: GetSchoolTeamsCountDocument, variables: variables }
    }
export const GetSupportedAccountProvidersDocument = gql`
    query getSupportedAccountProviders {
  supportedProviders
}
    `;

/**
 * __useGetSupportedAccountProvidersQuery__
 *
 * To run a query within a React component, call `useGetSupportedAccountProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedAccountProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedAccountProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportedAccountProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetSupportedAccountProvidersQuery, GetSupportedAccountProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportedAccountProvidersQuery, GetSupportedAccountProvidersQueryVariables>(GetSupportedAccountProvidersDocument, options);
      }
export function useGetSupportedAccountProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportedAccountProvidersQuery, GetSupportedAccountProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportedAccountProvidersQuery, GetSupportedAccountProvidersQueryVariables>(GetSupportedAccountProvidersDocument, options);
        }
export type GetSupportedAccountProvidersQueryHookResult = ReturnType<typeof useGetSupportedAccountProvidersQuery>;
export type GetSupportedAccountProvidersLazyQueryHookResult = ReturnType<typeof useGetSupportedAccountProvidersLazyQuery>;
export type GetSupportedAccountProvidersQueryResult = Apollo.QueryResult<GetSupportedAccountProvidersQuery, GetSupportedAccountProvidersQueryVariables>;
export function refetchGetSupportedAccountProvidersQuery(variables?: GetSupportedAccountProvidersQueryVariables) {
      return { query: GetSupportedAccountProvidersDocument, variables: variables }
    }
export const GetUserProviderAccountsDocument = gql`
    query getUserProviderAccounts {
  me {
    id
    roles {
      userId
      roleName
      resourceId
      resourceType
    }
    school {
      id
      varsityAssociations {
        name
        slug
      }
    }
    userProviderAccounts {
      id
      userId
      providerName
      providerAccountId
      providerDisplayName
      providerOnboardUrl
      providerIntegrationType
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetUserProviderAccountsQuery__
 *
 * To run a query within a React component, call `useGetUserProviderAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProviderAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProviderAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProviderAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserProviderAccountsQuery, GetUserProviderAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProviderAccountsQuery, GetUserProviderAccountsQueryVariables>(GetUserProviderAccountsDocument, options);
      }
export function useGetUserProviderAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProviderAccountsQuery, GetUserProviderAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProviderAccountsQuery, GetUserProviderAccountsQueryVariables>(GetUserProviderAccountsDocument, options);
        }
export type GetUserProviderAccountsQueryHookResult = ReturnType<typeof useGetUserProviderAccountsQuery>;
export type GetUserProviderAccountsLazyQueryHookResult = ReturnType<typeof useGetUserProviderAccountsLazyQuery>;
export type GetUserProviderAccountsQueryResult = Apollo.QueryResult<GetUserProviderAccountsQuery, GetUserProviderAccountsQueryVariables>;
export function refetchGetUserProviderAccountsQuery(variables?: GetUserProviderAccountsQueryVariables) {
      return { query: GetUserProviderAccountsDocument, variables: variables }
    }
export const GetUserProviderAccountsFromIdDocument = gql`
    query getUserProviderAccountsFromId($userId: UUID!) {
  user(id: $userId) {
    id
    roles {
      userId
      roleName
      resourceId
      resourceType
    }
    school {
      id
      varsityAssociations {
        name
        slug
      }
    }
    userProviderAccounts {
      id
      userId
      providerName
      providerAccountId
      providerDisplayName
      providerOnboardUrl
      providerIntegrationType
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetUserProviderAccountsFromIdQuery__
 *
 * To run a query within a React component, call `useGetUserProviderAccountsFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProviderAccountsFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProviderAccountsFromIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserProviderAccountsFromIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserProviderAccountsFromIdQuery, GetUserProviderAccountsFromIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProviderAccountsFromIdQuery, GetUserProviderAccountsFromIdQueryVariables>(GetUserProviderAccountsFromIdDocument, options);
      }
export function useGetUserProviderAccountsFromIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProviderAccountsFromIdQuery, GetUserProviderAccountsFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProviderAccountsFromIdQuery, GetUserProviderAccountsFromIdQueryVariables>(GetUserProviderAccountsFromIdDocument, options);
        }
export type GetUserProviderAccountsFromIdQueryHookResult = ReturnType<typeof useGetUserProviderAccountsFromIdQuery>;
export type GetUserProviderAccountsFromIdLazyQueryHookResult = ReturnType<typeof useGetUserProviderAccountsFromIdLazyQuery>;
export type GetUserProviderAccountsFromIdQueryResult = Apollo.QueryResult<GetUserProviderAccountsFromIdQuery, GetUserProviderAccountsFromIdQueryVariables>;
export function refetchGetUserProviderAccountsFromIdQuery(variables: GetUserProviderAccountsFromIdQueryVariables) {
      return { query: GetUserProviderAccountsFromIdDocument, variables: variables }
    }
export const GetSchoolProviderAccountsDocument = gql`
    query getSchoolProviderAccounts {
  me {
    id
    school {
      id
      schoolProviderAccounts {
        id
        schoolId
        providerName
        providerAccountId
        providerDisplayName
        providerIntegrationType
      }
    }
  }
}
    `;

/**
 * __useGetSchoolProviderAccountsQuery__
 *
 * To run a query within a React component, call `useGetSchoolProviderAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolProviderAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolProviderAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSchoolProviderAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetSchoolProviderAccountsQuery, GetSchoolProviderAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolProviderAccountsQuery, GetSchoolProviderAccountsQueryVariables>(GetSchoolProviderAccountsDocument, options);
      }
export function useGetSchoolProviderAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolProviderAccountsQuery, GetSchoolProviderAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolProviderAccountsQuery, GetSchoolProviderAccountsQueryVariables>(GetSchoolProviderAccountsDocument, options);
        }
export type GetSchoolProviderAccountsQueryHookResult = ReturnType<typeof useGetSchoolProviderAccountsQuery>;
export type GetSchoolProviderAccountsLazyQueryHookResult = ReturnType<typeof useGetSchoolProviderAccountsLazyQuery>;
export type GetSchoolProviderAccountsQueryResult = Apollo.QueryResult<GetSchoolProviderAccountsQuery, GetSchoolProviderAccountsQueryVariables>;
export function refetchGetSchoolProviderAccountsQuery(variables?: GetSchoolProviderAccountsQueryVariables) {
      return { query: GetSchoolProviderAccountsDocument, variables: variables }
    }
export const GetSchoolProviderAccountFromIdDocument = gql`
    query getSchoolProviderAccountFromId($schoolId: UUID!) {
  school(id: $schoolId) {
    id
    schoolProviderAccounts {
      id
      schoolId
      providerName
      providerAccountId
      providerDisplayName
      providerIntegrationType
    }
  }
}
    `;

/**
 * __useGetSchoolProviderAccountFromIdQuery__
 *
 * To run a query within a React component, call `useGetSchoolProviderAccountFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolProviderAccountFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolProviderAccountFromIdQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolProviderAccountFromIdQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolProviderAccountFromIdQuery, GetSchoolProviderAccountFromIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolProviderAccountFromIdQuery, GetSchoolProviderAccountFromIdQueryVariables>(GetSchoolProviderAccountFromIdDocument, options);
      }
export function useGetSchoolProviderAccountFromIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolProviderAccountFromIdQuery, GetSchoolProviderAccountFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolProviderAccountFromIdQuery, GetSchoolProviderAccountFromIdQueryVariables>(GetSchoolProviderAccountFromIdDocument, options);
        }
export type GetSchoolProviderAccountFromIdQueryHookResult = ReturnType<typeof useGetSchoolProviderAccountFromIdQuery>;
export type GetSchoolProviderAccountFromIdLazyQueryHookResult = ReturnType<typeof useGetSchoolProviderAccountFromIdLazyQuery>;
export type GetSchoolProviderAccountFromIdQueryResult = Apollo.QueryResult<GetSchoolProviderAccountFromIdQuery, GetSchoolProviderAccountFromIdQueryVariables>;
export function refetchGetSchoolProviderAccountFromIdQuery(variables: GetSchoolProviderAccountFromIdQueryVariables) {
      return { query: GetSchoolProviderAccountFromIdDocument, variables: variables }
    }
export const UnlinkUserProviderAccountDocument = gql`
    mutation unlinkUserProviderAccount($providerId: UUID!) {
  unlinkUserProviderAccount(id: $providerId) {
    success
  }
}
    `;
export type UnlinkUserProviderAccountMutationFn = Apollo.MutationFunction<UnlinkUserProviderAccountMutation, UnlinkUserProviderAccountMutationVariables>;

/**
 * __useUnlinkUserProviderAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkUserProviderAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkUserProviderAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkUserProviderAccountMutation, { data, loading, error }] = useUnlinkUserProviderAccountMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useUnlinkUserProviderAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkUserProviderAccountMutation, UnlinkUserProviderAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkUserProviderAccountMutation, UnlinkUserProviderAccountMutationVariables>(UnlinkUserProviderAccountDocument, options);
      }
export type UnlinkUserProviderAccountMutationHookResult = ReturnType<typeof useUnlinkUserProviderAccountMutation>;
export type UnlinkUserProviderAccountMutationResult = Apollo.MutationResult<UnlinkUserProviderAccountMutation>;
export type UnlinkUserProviderAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkUserProviderAccountMutation, UnlinkUserProviderAccountMutationVariables>;
export const UnlinkSchoolProviderAccountDocument = gql`
    mutation unlinkSchoolProviderAccount($providerId: UUID!) {
  unlinkSchoolProviderAccount(id: $providerId) {
    success
  }
}
    `;
export type UnlinkSchoolProviderAccountMutationFn = Apollo.MutationFunction<UnlinkSchoolProviderAccountMutation, UnlinkSchoolProviderAccountMutationVariables>;

/**
 * __useUnlinkSchoolProviderAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkSchoolProviderAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkSchoolProviderAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkSchoolProviderAccountMutation, { data, loading, error }] = useUnlinkSchoolProviderAccountMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useUnlinkSchoolProviderAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkSchoolProviderAccountMutation, UnlinkSchoolProviderAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkSchoolProviderAccountMutation, UnlinkSchoolProviderAccountMutationVariables>(UnlinkSchoolProviderAccountDocument, options);
      }
export type UnlinkSchoolProviderAccountMutationHookResult = ReturnType<typeof useUnlinkSchoolProviderAccountMutation>;
export type UnlinkSchoolProviderAccountMutationResult = Apollo.MutationResult<UnlinkSchoolProviderAccountMutation>;
export type UnlinkSchoolProviderAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkSchoolProviderAccountMutation, UnlinkSchoolProviderAccountMutationVariables>;
export const LinkPlayStationNetworkAccountDocument = gql`
    mutation linkPlayStationNetworkAccount($input: LinkPlayStationNetworkAccountInput!) {
  linkPlayStationNetworkAccount(input: $input) {
    id
    providerDisplayName
  }
}
    `;
export type LinkPlayStationNetworkAccountMutationFn = Apollo.MutationFunction<LinkPlayStationNetworkAccountMutation, LinkPlayStationNetworkAccountMutationVariables>;

/**
 * __useLinkPlayStationNetworkAccountMutation__
 *
 * To run a mutation, you first call `useLinkPlayStationNetworkAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkPlayStationNetworkAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkPlayStationNetworkAccountMutation, { data, loading, error }] = useLinkPlayStationNetworkAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkPlayStationNetworkAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkPlayStationNetworkAccountMutation, LinkPlayStationNetworkAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkPlayStationNetworkAccountMutation, LinkPlayStationNetworkAccountMutationVariables>(LinkPlayStationNetworkAccountDocument, options);
      }
export type LinkPlayStationNetworkAccountMutationHookResult = ReturnType<typeof useLinkPlayStationNetworkAccountMutation>;
export type LinkPlayStationNetworkAccountMutationResult = Apollo.MutationResult<LinkPlayStationNetworkAccountMutation>;
export type LinkPlayStationNetworkAccountMutationOptions = Apollo.BaseMutationOptions<LinkPlayStationNetworkAccountMutation, LinkPlayStationNetworkAccountMutationVariables>;
export const LinkNintendoAccountDocument = gql`
    mutation linkNintendoAccount($userId: UUID!, $attributes: LinkNintendoAccountInput!) {
  linkNintendoAccount(userId: $userId, attributes: $attributes) {
    id
    providerDisplayName
  }
}
    `;
export type LinkNintendoAccountMutationFn = Apollo.MutationFunction<LinkNintendoAccountMutation, LinkNintendoAccountMutationVariables>;

/**
 * __useLinkNintendoAccountMutation__
 *
 * To run a mutation, you first call `useLinkNintendoAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkNintendoAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkNintendoAccountMutation, { data, loading, error }] = useLinkNintendoAccountMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useLinkNintendoAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkNintendoAccountMutation, LinkNintendoAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkNintendoAccountMutation, LinkNintendoAccountMutationVariables>(LinkNintendoAccountDocument, options);
      }
export type LinkNintendoAccountMutationHookResult = ReturnType<typeof useLinkNintendoAccountMutation>;
export type LinkNintendoAccountMutationResult = Apollo.MutationResult<LinkNintendoAccountMutation>;
export type LinkNintendoAccountMutationOptions = Apollo.BaseMutationOptions<LinkNintendoAccountMutation, LinkNintendoAccountMutationVariables>;
export const LinkAccountDocument = gql`
    mutation linkAccount($userId: UUID!, $attributes: LinkManualAccountInput!) {
  linkManualAccount(userId: $userId, attributes: $attributes) {
    id
    providerDisplayName
  }
}
    `;
export type LinkAccountMutationFn = Apollo.MutationFunction<LinkAccountMutation, LinkAccountMutationVariables>;

/**
 * __useLinkAccountMutation__
 *
 * To run a mutation, you first call `useLinkAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAccountMutation, { data, loading, error }] = useLinkAccountMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useLinkAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkAccountMutation, LinkAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkAccountMutation, LinkAccountMutationVariables>(LinkAccountDocument, options);
      }
export type LinkAccountMutationHookResult = ReturnType<typeof useLinkAccountMutation>;
export type LinkAccountMutationResult = Apollo.MutationResult<LinkAccountMutation>;
export type LinkAccountMutationOptions = Apollo.BaseMutationOptions<LinkAccountMutation, LinkAccountMutationVariables>;
export const MySchoolCoachesDocument = gql`
    query mySchoolCoaches {
  me {
    id
    school {
      id
      coaches {
        id
        lastSeen
        name
        avatarUrl
        email
        emails {
          email
          isSchoolEmail
        }
        phone
        userProviderAccounts {
          id
          userId
          providerName
          providerAccountId
          providerDisplayName
          providerIntegrationType
        }
      }
      name
      logoUrl
    }
  }
}
    `;

/**
 * __useMySchoolCoachesQuery__
 *
 * To run a query within a React component, call `useMySchoolCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySchoolCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySchoolCoachesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySchoolCoachesQuery(baseOptions?: Apollo.QueryHookOptions<MySchoolCoachesQuery, MySchoolCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySchoolCoachesQuery, MySchoolCoachesQueryVariables>(MySchoolCoachesDocument, options);
      }
export function useMySchoolCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySchoolCoachesQuery, MySchoolCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySchoolCoachesQuery, MySchoolCoachesQueryVariables>(MySchoolCoachesDocument, options);
        }
export type MySchoolCoachesQueryHookResult = ReturnType<typeof useMySchoolCoachesQuery>;
export type MySchoolCoachesLazyQueryHookResult = ReturnType<typeof useMySchoolCoachesLazyQuery>;
export type MySchoolCoachesQueryResult = Apollo.QueryResult<MySchoolCoachesQuery, MySchoolCoachesQueryVariables>;
export function refetchMySchoolCoachesQuery(variables?: MySchoolCoachesQueryVariables) {
      return { query: MySchoolCoachesDocument, variables: variables }
    }
export const CreateDemoDocument = gql`
    mutation createDemo($input: CreateDemoInput!) {
  createDemo(input: $input) {
    jobId
  }
}
    `;
export type CreateDemoMutationFn = Apollo.MutationFunction<CreateDemoMutation, CreateDemoMutationVariables>;

/**
 * __useCreateDemoMutation__
 *
 * To run a mutation, you first call `useCreateDemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDemoMutation, { data, loading, error }] = useCreateDemoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDemoMutation(baseOptions?: Apollo.MutationHookOptions<CreateDemoMutation, CreateDemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDemoMutation, CreateDemoMutationVariables>(CreateDemoDocument, options);
      }
export type CreateDemoMutationHookResult = ReturnType<typeof useCreateDemoMutation>;
export type CreateDemoMutationResult = Apollo.MutationResult<CreateDemoMutation>;
export type CreateDemoMutationOptions = Apollo.BaseMutationOptions<CreateDemoMutation, CreateDemoMutationVariables>;
export const ListUserDemosDocument = gql`
    query listUserDemos {
  listUserDemos {
    userId
    schoolId
    scheduledAt
    school {
      id
      name
      logoUrl
      state
      varsityAssociations {
        name
        slug
      }
    }
    createdAt
    username
    password
  }
}
    `;

/**
 * __useListUserDemosQuery__
 *
 * To run a query within a React component, call `useListUserDemosQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserDemosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserDemosQuery({
 *   variables: {
 *   },
 * });
 */
export function useListUserDemosQuery(baseOptions?: Apollo.QueryHookOptions<ListUserDemosQuery, ListUserDemosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUserDemosQuery, ListUserDemosQueryVariables>(ListUserDemosDocument, options);
      }
export function useListUserDemosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUserDemosQuery, ListUserDemosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUserDemosQuery, ListUserDemosQueryVariables>(ListUserDemosDocument, options);
        }
export type ListUserDemosQueryHookResult = ReturnType<typeof useListUserDemosQuery>;
export type ListUserDemosLazyQueryHookResult = ReturnType<typeof useListUserDemosLazyQuery>;
export type ListUserDemosQueryResult = Apollo.QueryResult<ListUserDemosQuery, ListUserDemosQueryVariables>;
export function refetchListUserDemosQuery(variables?: ListUserDemosQueryVariables) {
      return { query: ListUserDemosDocument, variables: variables }
    }
export const FetchMatchSettleRequestDocument = gql`
    query fetchMatchSettleRequest($input: FetchMatchSettleRequestInput!) {
  fetchMatchSettleRequest(input: $input) {
    success
    errors
    matchSettleRequest {
      ...MatchSettleRequest
    }
  }
}
    ${MatchSettleRequestFragmentDoc}`;

/**
 * __useFetchMatchSettleRequestQuery__
 *
 * To run a query within a React component, call `useFetchMatchSettleRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMatchSettleRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMatchSettleRequestQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchMatchSettleRequestQuery(baseOptions: Apollo.QueryHookOptions<FetchMatchSettleRequestQuery, FetchMatchSettleRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMatchSettleRequestQuery, FetchMatchSettleRequestQueryVariables>(FetchMatchSettleRequestDocument, options);
      }
export function useFetchMatchSettleRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMatchSettleRequestQuery, FetchMatchSettleRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMatchSettleRequestQuery, FetchMatchSettleRequestQueryVariables>(FetchMatchSettleRequestDocument, options);
        }
export type FetchMatchSettleRequestQueryHookResult = ReturnType<typeof useFetchMatchSettleRequestQuery>;
export type FetchMatchSettleRequestLazyQueryHookResult = ReturnType<typeof useFetchMatchSettleRequestLazyQuery>;
export type FetchMatchSettleRequestQueryResult = Apollo.QueryResult<FetchMatchSettleRequestQuery, FetchMatchSettleRequestQueryVariables>;
export function refetchFetchMatchSettleRequestQuery(variables: FetchMatchSettleRequestQueryVariables) {
      return { query: FetchMatchSettleRequestDocument, variables: variables }
    }
export const SaveGameResultLiveDocument = gql`
    mutation saveGameResultLive($input: SaveGameResultInput!) {
  saveGameResultLive(input: $input) {
    success
    errors
    matchSettleRequest {
      ...MatchSettleRequest
    }
    winningTeam {
      id
    }
  }
}
    ${MatchSettleRequestFragmentDoc}`;
export type SaveGameResultLiveMutationFn = Apollo.MutationFunction<SaveGameResultLiveMutation, SaveGameResultLiveMutationVariables>;

/**
 * __useSaveGameResultLiveMutation__
 *
 * To run a mutation, you first call `useSaveGameResultLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGameResultLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGameResultLiveMutation, { data, loading, error }] = useSaveGameResultLiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveGameResultLiveMutation(baseOptions?: Apollo.MutationHookOptions<SaveGameResultLiveMutation, SaveGameResultLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGameResultLiveMutation, SaveGameResultLiveMutationVariables>(SaveGameResultLiveDocument, options);
      }
export type SaveGameResultLiveMutationHookResult = ReturnType<typeof useSaveGameResultLiveMutation>;
export type SaveGameResultLiveMutationResult = Apollo.MutationResult<SaveGameResultLiveMutation>;
export type SaveGameResultLiveMutationOptions = Apollo.BaseMutationOptions<SaveGameResultLiveMutation, SaveGameResultLiveMutationVariables>;
export const AdminSaveGameResultLiveDocument = gql`
    mutation adminSaveGameResultLive($input: AdminSaveGameResultInput!) {
  adminSaveGameResultLive(input: $input) {
    success
    errors
    matchSettleRequest {
      ...MatchSettleRequest
    }
    winningTeam {
      id
    }
  }
}
    ${MatchSettleRequestFragmentDoc}`;
export type AdminSaveGameResultLiveMutationFn = Apollo.MutationFunction<AdminSaveGameResultLiveMutation, AdminSaveGameResultLiveMutationVariables>;

/**
 * __useAdminSaveGameResultLiveMutation__
 *
 * To run a mutation, you first call `useAdminSaveGameResultLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSaveGameResultLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSaveGameResultLiveMutation, { data, loading, error }] = useAdminSaveGameResultLiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSaveGameResultLiveMutation(baseOptions?: Apollo.MutationHookOptions<AdminSaveGameResultLiveMutation, AdminSaveGameResultLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSaveGameResultLiveMutation, AdminSaveGameResultLiveMutationVariables>(AdminSaveGameResultLiveDocument, options);
      }
export type AdminSaveGameResultLiveMutationHookResult = ReturnType<typeof useAdminSaveGameResultLiveMutation>;
export type AdminSaveGameResultLiveMutationResult = Apollo.MutationResult<AdminSaveGameResultLiveMutation>;
export type AdminSaveGameResultLiveMutationOptions = Apollo.BaseMutationOptions<AdminSaveGameResultLiveMutation, AdminSaveGameResultLiveMutationVariables>;
export const FetchMatchForReportCardDocument = gql`
    query fetchMatchForReportCard($matchId: UUID!) {
  match(id: $matchId) {
    id
    bestOf
    seriesBestOf
    scheduledStartsAt
    status
    esport {
      id
      slug
      rating
    }
    teamContext {
      matchId
      teams {
        id
        isMyTeam
        name
        school {
          id
          logoUrl
          name
        }
      }
    }
    matchResults {
      id
      teamSide
      team {
        id
        name
        roster {
          id
          players {
            user {
              id
              name
              avatarUrl
              userProviderAccounts {
                id
                providerName
                providerAccountId
                providerDisplayName
                providerIntegrationType
              }
            }
          }
        }
        school {
          id
          name
          logoUrl
        }
      }
    }
    series {
      id
      bestOf
      teamContext {
        seriesId
        teams {
          id
          seriesId
          roster {
            id
            name
            avatarUrl
            publisherAccountName
          }
        }
      }
    }
    games {
      id
      seriesId
    }
  }
}
    `;

/**
 * __useFetchMatchForReportCardQuery__
 *
 * To run a query within a React component, call `useFetchMatchForReportCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMatchForReportCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMatchForReportCardQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useFetchMatchForReportCardQuery(baseOptions: Apollo.QueryHookOptions<FetchMatchForReportCardQuery, FetchMatchForReportCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMatchForReportCardQuery, FetchMatchForReportCardQueryVariables>(FetchMatchForReportCardDocument, options);
      }
export function useFetchMatchForReportCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMatchForReportCardQuery, FetchMatchForReportCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMatchForReportCardQuery, FetchMatchForReportCardQueryVariables>(FetchMatchForReportCardDocument, options);
        }
export type FetchMatchForReportCardQueryHookResult = ReturnType<typeof useFetchMatchForReportCardQuery>;
export type FetchMatchForReportCardLazyQueryHookResult = ReturnType<typeof useFetchMatchForReportCardLazyQuery>;
export type FetchMatchForReportCardQueryResult = Apollo.QueryResult<FetchMatchForReportCardQuery, FetchMatchForReportCardQueryVariables>;
export function refetchFetchMatchForReportCardQuery(variables: FetchMatchForReportCardQueryVariables) {
      return { query: FetchMatchForReportCardDocument, variables: variables }
    }
export const SubmitMatchSettleRequestAssetsLiveDocument = gql`
    mutation submitMatchSettleRequestAssetsLive($input: SubmitAdminMatchSettleRequestAssetsInput!) {
  submitMatchSettleRequestAssetsLive(input: $input) {
    success
    errors
    matchSettleRequest {
      ...MatchSettleRequest
    }
  }
}
    ${MatchSettleRequestFragmentDoc}`;
export type SubmitMatchSettleRequestAssetsLiveMutationFn = Apollo.MutationFunction<SubmitMatchSettleRequestAssetsLiveMutation, SubmitMatchSettleRequestAssetsLiveMutationVariables>;

/**
 * __useSubmitMatchSettleRequestAssetsLiveMutation__
 *
 * To run a mutation, you first call `useSubmitMatchSettleRequestAssetsLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMatchSettleRequestAssetsLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMatchSettleRequestAssetsLiveMutation, { data, loading, error }] = useSubmitMatchSettleRequestAssetsLiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitMatchSettleRequestAssetsLiveMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMatchSettleRequestAssetsLiveMutation, SubmitMatchSettleRequestAssetsLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMatchSettleRequestAssetsLiveMutation, SubmitMatchSettleRequestAssetsLiveMutationVariables>(SubmitMatchSettleRequestAssetsLiveDocument, options);
      }
export type SubmitMatchSettleRequestAssetsLiveMutationHookResult = ReturnType<typeof useSubmitMatchSettleRequestAssetsLiveMutation>;
export type SubmitMatchSettleRequestAssetsLiveMutationResult = Apollo.MutationResult<SubmitMatchSettleRequestAssetsLiveMutation>;
export type SubmitMatchSettleRequestAssetsLiveMutationOptions = Apollo.BaseMutationOptions<SubmitMatchSettleRequestAssetsLiveMutation, SubmitMatchSettleRequestAssetsLiveMutationVariables>;
export const MatchSettleRequestUpdatedDocument = gql`
    subscription matchSettleRequestUpdated($input: MatchSettleRequestUpdatedSubscribeInput) {
  matchSettleRequestUpdated(input: $input) {
    success
    errors
    matchSettleRequest {
      ...MatchSettleRequest
    }
    matchHasBeenAutoSettled
    gameAssistantStepHasBeenUpdated
  }
}
    ${MatchSettleRequestFragmentDoc}`;

/**
 * __useMatchSettleRequestUpdatedSubscription__
 *
 * To run a query within a React component, call `useMatchSettleRequestUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMatchSettleRequestUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchSettleRequestUpdatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchSettleRequestUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MatchSettleRequestUpdatedSubscription, MatchSettleRequestUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MatchSettleRequestUpdatedSubscription, MatchSettleRequestUpdatedSubscriptionVariables>(MatchSettleRequestUpdatedDocument, options);
      }
export type MatchSettleRequestUpdatedSubscriptionHookResult = ReturnType<typeof useMatchSettleRequestUpdatedSubscription>;
export type MatchSettleRequestUpdatedSubscriptionResult = Apollo.SubscriptionResult<MatchSettleRequestUpdatedSubscription>;
export const MatchSettleRequestAssetsUpdatedDocument = gql`
    subscription matchSettleRequestAssetsUpdated($input: MatchSettleRequestAssetsUpdatedSubscribeInput) {
  matchSettleRequestAssetsUpdated(input: $input) {
    success
    errors
    matchSettleRequest {
      ...MatchSettleRequest
    }
  }
}
    ${MatchSettleRequestFragmentDoc}`;

/**
 * __useMatchSettleRequestAssetsUpdatedSubscription__
 *
 * To run a query within a React component, call `useMatchSettleRequestAssetsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMatchSettleRequestAssetsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchSettleRequestAssetsUpdatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchSettleRequestAssetsUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MatchSettleRequestAssetsUpdatedSubscription, MatchSettleRequestAssetsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MatchSettleRequestAssetsUpdatedSubscription, MatchSettleRequestAssetsUpdatedSubscriptionVariables>(MatchSettleRequestAssetsUpdatedDocument, options);
      }
export type MatchSettleRequestAssetsUpdatedSubscriptionHookResult = ReturnType<typeof useMatchSettleRequestAssetsUpdatedSubscription>;
export type MatchSettleRequestAssetsUpdatedSubscriptionResult = Apollo.SubscriptionResult<MatchSettleRequestAssetsUpdatedSubscription>;
export const GetMySchoolEnrollmentDocument = gql`
    query getMySchoolEnrollment($metaseasonId: UUID!, $schoolId: UUID!, $isCoach: Boolean!) {
  school(id: $schoolId) {
    id
    name
    logoUrl
    annualPassProductsEligible @include(if: $isCoach) {
      id
      name
      description
      priceUsd
      type
      slug
      seasonPassesAllotted {
        id
      }
    }
    annualPassInstances(metaseasonId: $metaseasonId) @include(if: $isCoach) {
      id
      productId
      productInstanceInfo {
        initialMetaseasonId
      }
      seasonPassBundles {
        metaseason {
          id
          name
          nextMetaseasonId
          previousMetaseasonId
        }
      }
    }
    teams {
      id
      name
      roster {
        id
        players {
          user {
            id
          }
        }
      }
      esport {
        id
        slug
      }
      leagues(metaseasonId: $metaseasonId) {
        id
      }
      enrolledSeasons {
        id
        metaseason {
          id
        }
      }
    }
    players {
      id
      leagues(metaseasonId: $metaseasonId) {
        id
        esport {
          id
          slug
          name
        }
        competitionModel
      }
    }
    leagueGroups(metaseasonId: $metaseasonId) {
      id
    }
  }
}
    `;

/**
 * __useGetMySchoolEnrollmentQuery__
 *
 * To run a query within a React component, call `useGetMySchoolEnrollmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySchoolEnrollmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySchoolEnrollmentQuery({
 *   variables: {
 *      metaseasonId: // value for 'metaseasonId'
 *      schoolId: // value for 'schoolId'
 *      isCoach: // value for 'isCoach'
 *   },
 * });
 */
export function useGetMySchoolEnrollmentQuery(baseOptions: Apollo.QueryHookOptions<GetMySchoolEnrollmentQuery, GetMySchoolEnrollmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySchoolEnrollmentQuery, GetMySchoolEnrollmentQueryVariables>(GetMySchoolEnrollmentDocument, options);
      }
export function useGetMySchoolEnrollmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySchoolEnrollmentQuery, GetMySchoolEnrollmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySchoolEnrollmentQuery, GetMySchoolEnrollmentQueryVariables>(GetMySchoolEnrollmentDocument, options);
        }
export type GetMySchoolEnrollmentQueryHookResult = ReturnType<typeof useGetMySchoolEnrollmentQuery>;
export type GetMySchoolEnrollmentLazyQueryHookResult = ReturnType<typeof useGetMySchoolEnrollmentLazyQuery>;
export type GetMySchoolEnrollmentQueryResult = Apollo.QueryResult<GetMySchoolEnrollmentQuery, GetMySchoolEnrollmentQueryVariables>;
export function refetchGetMySchoolEnrollmentQuery(variables: GetMySchoolEnrollmentQueryVariables) {
      return { query: GetMySchoolEnrollmentDocument, variables: variables }
    }
export const GetActiveLeaguesBySchoolIdDocument = gql`
    query getActiveLeaguesBySchoolId($schoolId: UUID!, $metaseasonId: UUID!, $esportId: UUID) {
  getActiveLeaguesBySchoolId(
    schoolId: $schoolId
    metaseasonId: $metaseasonId
    esportId: $esportId
  ) {
    id
    name
    displayName
    state
    competitionModel
    teamFormat
    teamMaxSize
    teamMinimumStarterSize
    seasons {
      id
      metaseasonId
      registrationStartsAt
      teamRegistrationEndsAt
      teamDeregistrationEndsAt
      suggestedRegistrationEndsAt
      maxTeamsPerSchool
      name
      areBreakWeekSlotExclusionWindowsEnabled
      weeklySlotDateEstimate {
        sample
      }
    }
    varsityAssociation {
      name
    }
    esport {
      id
      slug
      name
    }
  }
}
    `;

/**
 * __useGetActiveLeaguesBySchoolIdQuery__
 *
 * To run a query within a React component, call `useGetActiveLeaguesBySchoolIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveLeaguesBySchoolIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveLeaguesBySchoolIdQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      metaseasonId: // value for 'metaseasonId'
 *      esportId: // value for 'esportId'
 *   },
 * });
 */
export function useGetActiveLeaguesBySchoolIdQuery(baseOptions: Apollo.QueryHookOptions<GetActiveLeaguesBySchoolIdQuery, GetActiveLeaguesBySchoolIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveLeaguesBySchoolIdQuery, GetActiveLeaguesBySchoolIdQueryVariables>(GetActiveLeaguesBySchoolIdDocument, options);
      }
export function useGetActiveLeaguesBySchoolIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveLeaguesBySchoolIdQuery, GetActiveLeaguesBySchoolIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveLeaguesBySchoolIdQuery, GetActiveLeaguesBySchoolIdQueryVariables>(GetActiveLeaguesBySchoolIdDocument, options);
        }
export type GetActiveLeaguesBySchoolIdQueryHookResult = ReturnType<typeof useGetActiveLeaguesBySchoolIdQuery>;
export type GetActiveLeaguesBySchoolIdLazyQueryHookResult = ReturnType<typeof useGetActiveLeaguesBySchoolIdLazyQuery>;
export type GetActiveLeaguesBySchoolIdQueryResult = Apollo.QueryResult<GetActiveLeaguesBySchoolIdQuery, GetActiveLeaguesBySchoolIdQueryVariables>;
export function refetchGetActiveLeaguesBySchoolIdQuery(variables: GetActiveLeaguesBySchoolIdQueryVariables) {
      return { query: GetActiveLeaguesBySchoolIdDocument, variables: variables }
    }
export const GetMySchoolSlotExclusionSelectionDataDocument = gql`
    query getMySchoolSlotExclusionSelectionData($input: OrganizationEnrollmentDataQueryInput!) {
  organizationEnrollmentData(input: $input) {
    data {
      slotExclusionData {
        rangeData {
          selectionData {
            resourceType
            resourceId
            selections {
              slotExclusionWindow {
                id
                startsAt
                endsAt
              }
            }
          }
        }
      }
      seasonSlotExclusionData {
        rangeData {
          seasonId
          selectionData {
            resourceType
            resourceId
            selections {
              slotExclusionWindow {
                id
                startsAt
                endsAt
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMySchoolSlotExclusionSelectionDataQuery__
 *
 * To run a query within a React component, call `useGetMySchoolSlotExclusionSelectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySchoolSlotExclusionSelectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySchoolSlotExclusionSelectionDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMySchoolSlotExclusionSelectionDataQuery(baseOptions: Apollo.QueryHookOptions<GetMySchoolSlotExclusionSelectionDataQuery, GetMySchoolSlotExclusionSelectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySchoolSlotExclusionSelectionDataQuery, GetMySchoolSlotExclusionSelectionDataQueryVariables>(GetMySchoolSlotExclusionSelectionDataDocument, options);
      }
export function useGetMySchoolSlotExclusionSelectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySchoolSlotExclusionSelectionDataQuery, GetMySchoolSlotExclusionSelectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySchoolSlotExclusionSelectionDataQuery, GetMySchoolSlotExclusionSelectionDataQueryVariables>(GetMySchoolSlotExclusionSelectionDataDocument, options);
        }
export type GetMySchoolSlotExclusionSelectionDataQueryHookResult = ReturnType<typeof useGetMySchoolSlotExclusionSelectionDataQuery>;
export type GetMySchoolSlotExclusionSelectionDataLazyQueryHookResult = ReturnType<typeof useGetMySchoolSlotExclusionSelectionDataLazyQuery>;
export type GetMySchoolSlotExclusionSelectionDataQueryResult = Apollo.QueryResult<GetMySchoolSlotExclusionSelectionDataQuery, GetMySchoolSlotExclusionSelectionDataQueryVariables>;
export function refetchGetMySchoolSlotExclusionSelectionDataQuery(variables: GetMySchoolSlotExclusionSelectionDataQueryVariables) {
      return { query: GetMySchoolSlotExclusionSelectionDataDocument, variables: variables }
    }
export const GetMySchoolSlotExclusionDataDocument = gql`
    query getMySchoolSlotExclusionData($input: OrganizationEnrollmentDataQueryInput!) {
  organizationEnrollmentData(input: $input) {
    data {
      slotExclusionData {
        rangeData {
          range {
            startsAt
            endsAt
          }
          suggestionsForOrganization {
            suggestion {
              template {
                hash
                startsAt
                endsAt
              }
            }
            isAvailable
          }
          selectionData {
            resourceType
            resourceId
            selections {
              isEditable
              slotExclusionWindow {
                id
                hash
                startsAt
                endsAt
              }
            }
          }
          configuration {
            maxSlotExclusions
            defaultsAppliedAt
          }
        }
      }
      seasonSlotExclusionData {
        rangeData {
          seasonId
          season {
            leagueId
            league {
              id
              displayName
            }
          }
          range {
            startsAt
            endsAt
          }
          suggestionsForOrganization {
            suggestion {
              template {
                hash
                startsAt
                endsAt
              }
            }
            isAvailable
          }
          selectionData {
            resourceType
            resourceId
            selections {
              isEditable
              slotExclusionWindow {
                id
                hash
                startsAt
                endsAt
              }
            }
          }
          configuration {
            maxSlotExclusions
            defaultsAppliedAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMySchoolSlotExclusionDataQuery__
 *
 * To run a query within a React component, call `useGetMySchoolSlotExclusionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySchoolSlotExclusionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySchoolSlotExclusionDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMySchoolSlotExclusionDataQuery(baseOptions: Apollo.QueryHookOptions<GetMySchoolSlotExclusionDataQuery, GetMySchoolSlotExclusionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySchoolSlotExclusionDataQuery, GetMySchoolSlotExclusionDataQueryVariables>(GetMySchoolSlotExclusionDataDocument, options);
      }
export function useGetMySchoolSlotExclusionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySchoolSlotExclusionDataQuery, GetMySchoolSlotExclusionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySchoolSlotExclusionDataQuery, GetMySchoolSlotExclusionDataQueryVariables>(GetMySchoolSlotExclusionDataDocument, options);
        }
export type GetMySchoolSlotExclusionDataQueryHookResult = ReturnType<typeof useGetMySchoolSlotExclusionDataQuery>;
export type GetMySchoolSlotExclusionDataLazyQueryHookResult = ReturnType<typeof useGetMySchoolSlotExclusionDataLazyQuery>;
export type GetMySchoolSlotExclusionDataQueryResult = Apollo.QueryResult<GetMySchoolSlotExclusionDataQuery, GetMySchoolSlotExclusionDataQueryVariables>;
export function refetchGetMySchoolSlotExclusionDataQuery(variables: GetMySchoolSlotExclusionDataQueryVariables) {
      return { query: GetMySchoolSlotExclusionDataDocument, variables: variables }
    }
export const EstimateSchoolSeasonPassUsageDocument = gql`
    query estimateSchoolSeasonPassUsage($metaseasonId: UUID!, $enrollTeamIds: [UUID!]!, $schoolId: UUID) {
  estimateSchoolSeasonPassUsage(
    metaseasonId: $metaseasonId
    enrollTeamIds: $enrollTeamIds
    schoolId: $schoolId
  ) {
    annualPassType
    totalSeasonPassesNeeded
    totalBillableSeasonPassesNeeded
  }
}
    `;

/**
 * __useEstimateSchoolSeasonPassUsageQuery__
 *
 * To run a query within a React component, call `useEstimateSchoolSeasonPassUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimateSchoolSeasonPassUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateSchoolSeasonPassUsageQuery({
 *   variables: {
 *      metaseasonId: // value for 'metaseasonId'
 *      enrollTeamIds: // value for 'enrollTeamIds'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useEstimateSchoolSeasonPassUsageQuery(baseOptions: Apollo.QueryHookOptions<EstimateSchoolSeasonPassUsageQuery, EstimateSchoolSeasonPassUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstimateSchoolSeasonPassUsageQuery, EstimateSchoolSeasonPassUsageQueryVariables>(EstimateSchoolSeasonPassUsageDocument, options);
      }
export function useEstimateSchoolSeasonPassUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstimateSchoolSeasonPassUsageQuery, EstimateSchoolSeasonPassUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstimateSchoolSeasonPassUsageQuery, EstimateSchoolSeasonPassUsageQueryVariables>(EstimateSchoolSeasonPassUsageDocument, options);
        }
export type EstimateSchoolSeasonPassUsageQueryHookResult = ReturnType<typeof useEstimateSchoolSeasonPassUsageQuery>;
export type EstimateSchoolSeasonPassUsageLazyQueryHookResult = ReturnType<typeof useEstimateSchoolSeasonPassUsageLazyQuery>;
export type EstimateSchoolSeasonPassUsageQueryResult = Apollo.QueryResult<EstimateSchoolSeasonPassUsageQuery, EstimateSchoolSeasonPassUsageQueryVariables>;
export function refetchEstimateSchoolSeasonPassUsageQuery(variables: EstimateSchoolSeasonPassUsageQueryVariables) {
      return { query: EstimateSchoolSeasonPassUsageDocument, variables: variables }
    }
export const GetAnnualPassProductByIdDocument = gql`
    query getAnnualPassProductById($id: UUID!) {
  annualPassProduct(id: $id) {
    id
    name
    description
    priceUsd
    type
    slug
    seasonPassesAllotted {
      id
    }
  }
}
    `;

/**
 * __useGetAnnualPassProductByIdQuery__
 *
 * To run a query within a React component, call `useGetAnnualPassProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnualPassProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnualPassProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnnualPassProductByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAnnualPassProductByIdQuery, GetAnnualPassProductByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnualPassProductByIdQuery, GetAnnualPassProductByIdQueryVariables>(GetAnnualPassProductByIdDocument, options);
      }
export function useGetAnnualPassProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnualPassProductByIdQuery, GetAnnualPassProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnualPassProductByIdQuery, GetAnnualPassProductByIdQueryVariables>(GetAnnualPassProductByIdDocument, options);
        }
export type GetAnnualPassProductByIdQueryHookResult = ReturnType<typeof useGetAnnualPassProductByIdQuery>;
export type GetAnnualPassProductByIdLazyQueryHookResult = ReturnType<typeof useGetAnnualPassProductByIdLazyQuery>;
export type GetAnnualPassProductByIdQueryResult = Apollo.QueryResult<GetAnnualPassProductByIdQuery, GetAnnualPassProductByIdQueryVariables>;
export function refetchGetAnnualPassProductByIdQuery(variables: GetAnnualPassProductByIdQueryVariables) {
      return { query: GetAnnualPassProductByIdDocument, variables: variables }
    }
export const GetEnrollmentTeamsDocument = gql`
    query getEnrollmentTeams($offset: Int, $limit: Int, $filters: TeamFiltersInput, $metaseasonId: UUID!) {
  getTeams(limit: $limit, offset: $offset, filters: $filters) {
    teams {
      id
      name
      leagues(metaseasonId: $metaseasonId) {
        id
        esportId
      }
      esport {
        id
        slug
      }
    }
  }
}
    `;

/**
 * __useGetEnrollmentTeamsQuery__
 *
 * To run a query within a React component, call `useGetEnrollmentTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrollmentTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrollmentTeamsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetEnrollmentTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetEnrollmentTeamsQuery, GetEnrollmentTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnrollmentTeamsQuery, GetEnrollmentTeamsQueryVariables>(GetEnrollmentTeamsDocument, options);
      }
export function useGetEnrollmentTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnrollmentTeamsQuery, GetEnrollmentTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnrollmentTeamsQuery, GetEnrollmentTeamsQueryVariables>(GetEnrollmentTeamsDocument, options);
        }
export type GetEnrollmentTeamsQueryHookResult = ReturnType<typeof useGetEnrollmentTeamsQuery>;
export type GetEnrollmentTeamsLazyQueryHookResult = ReturnType<typeof useGetEnrollmentTeamsLazyQuery>;
export type GetEnrollmentTeamsQueryResult = Apollo.QueryResult<GetEnrollmentTeamsQuery, GetEnrollmentTeamsQueryVariables>;
export function refetchGetEnrollmentTeamsQuery(variables: GetEnrollmentTeamsQueryVariables) {
      return { query: GetEnrollmentTeamsDocument, variables: variables }
    }
export const GetMetaseasonInfoDocument = gql`
    query getMetaseasonInfo($id: UUID!) {
  metaseason(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetMetaseasonInfoQuery__
 *
 * To run a query within a React component, call `useGetMetaseasonInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetaseasonInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetaseasonInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMetaseasonInfoQuery(baseOptions: Apollo.QueryHookOptions<GetMetaseasonInfoQuery, GetMetaseasonInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetaseasonInfoQuery, GetMetaseasonInfoQueryVariables>(GetMetaseasonInfoDocument, options);
      }
export function useGetMetaseasonInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetaseasonInfoQuery, GetMetaseasonInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetaseasonInfoQuery, GetMetaseasonInfoQueryVariables>(GetMetaseasonInfoDocument, options);
        }
export type GetMetaseasonInfoQueryHookResult = ReturnType<typeof useGetMetaseasonInfoQuery>;
export type GetMetaseasonInfoLazyQueryHookResult = ReturnType<typeof useGetMetaseasonInfoLazyQuery>;
export type GetMetaseasonInfoQueryResult = Apollo.QueryResult<GetMetaseasonInfoQuery, GetMetaseasonInfoQueryVariables>;
export function refetchGetMetaseasonInfoQuery(variables: GetMetaseasonInfoQueryVariables) {
      return { query: GetMetaseasonInfoDocument, variables: variables }
    }
export const PurchasePlanDocument = gql`
    mutation purchasePlan($productId: UUID, $schoolId: UUID!, $metaseasonId: UUID!) {
  addAnnualPassToSchool(
    productId: $productId
    schoolId: $schoolId
    initialMetaseasonId: $metaseasonId
  ) {
    id
  }
}
    `;
export type PurchasePlanMutationFn = Apollo.MutationFunction<PurchasePlanMutation, PurchasePlanMutationVariables>;

/**
 * __usePurchasePlanMutation__
 *
 * To run a mutation, you first call `usePurchasePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchasePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchasePlanMutation, { data, loading, error }] = usePurchasePlanMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      schoolId: // value for 'schoolId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function usePurchasePlanMutation(baseOptions?: Apollo.MutationHookOptions<PurchasePlanMutation, PurchasePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchasePlanMutation, PurchasePlanMutationVariables>(PurchasePlanDocument, options);
      }
export type PurchasePlanMutationHookResult = ReturnType<typeof usePurchasePlanMutation>;
export type PurchasePlanMutationResult = Apollo.MutationResult<PurchasePlanMutation>;
export type PurchasePlanMutationOptions = Apollo.BaseMutationOptions<PurchasePlanMutation, PurchasePlanMutationVariables>;
export const AdjustAnnualPassDocument = gql`
    mutation adjustAnnualPass($schoolId: UUID!, $annualPassInstanceId: UUID!, $desiredProductId: UUID!) {
  adjustAnnualPass(
    schoolId: $schoolId
    annualPassInstanceId: $annualPassInstanceId
    desiredProductId: $desiredProductId
  ) {
    id
  }
}
    `;
export type AdjustAnnualPassMutationFn = Apollo.MutationFunction<AdjustAnnualPassMutation, AdjustAnnualPassMutationVariables>;

/**
 * __useAdjustAnnualPassMutation__
 *
 * To run a mutation, you first call `useAdjustAnnualPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustAnnualPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustAnnualPassMutation, { data, loading, error }] = useAdjustAnnualPassMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      annualPassInstanceId: // value for 'annualPassInstanceId'
 *      desiredProductId: // value for 'desiredProductId'
 *   },
 * });
 */
export function useAdjustAnnualPassMutation(baseOptions?: Apollo.MutationHookOptions<AdjustAnnualPassMutation, AdjustAnnualPassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjustAnnualPassMutation, AdjustAnnualPassMutationVariables>(AdjustAnnualPassDocument, options);
      }
export type AdjustAnnualPassMutationHookResult = ReturnType<typeof useAdjustAnnualPassMutation>;
export type AdjustAnnualPassMutationResult = Apollo.MutationResult<AdjustAnnualPassMutation>;
export type AdjustAnnualPassMutationOptions = Apollo.BaseMutationOptions<AdjustAnnualPassMutation, AdjustAnnualPassMutationVariables>;
export const SendEnrollmentConfirmationDocument = gql`
    mutation sendEnrollmentConfirmation($schoolId: UUID!, $metaseasonId: UUID!) {
  sendEnrollmentConfirmation(schoolId: $schoolId, metaseasonId: $metaseasonId) {
    success
  }
}
    `;
export type SendEnrollmentConfirmationMutationFn = Apollo.MutationFunction<SendEnrollmentConfirmationMutation, SendEnrollmentConfirmationMutationVariables>;

/**
 * __useSendEnrollmentConfirmationMutation__
 *
 * To run a mutation, you first call `useSendEnrollmentConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEnrollmentConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEnrollmentConfirmationMutation, { data, loading, error }] = useSendEnrollmentConfirmationMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useSendEnrollmentConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<SendEnrollmentConfirmationMutation, SendEnrollmentConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEnrollmentConfirmationMutation, SendEnrollmentConfirmationMutationVariables>(SendEnrollmentConfirmationDocument, options);
      }
export type SendEnrollmentConfirmationMutationHookResult = ReturnType<typeof useSendEnrollmentConfirmationMutation>;
export type SendEnrollmentConfirmationMutationResult = Apollo.MutationResult<SendEnrollmentConfirmationMutation>;
export type SendEnrollmentConfirmationMutationOptions = Apollo.BaseMutationOptions<SendEnrollmentConfirmationMutation, SendEnrollmentConfirmationMutationVariables>;
export const GetTeamsEnrolledSeasonIdsDocument = gql`
    query getTeamsEnrolledSeasonIds($schoolId: UUID!) {
  school(id: $schoolId) {
    id
    teams {
      id
      enrolledSeasons {
        id
      }
    }
  }
}
    `;

/**
 * __useGetTeamsEnrolledSeasonIdsQuery__
 *
 * To run a query within a React component, call `useGetTeamsEnrolledSeasonIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsEnrolledSeasonIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsEnrolledSeasonIdsQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetTeamsEnrolledSeasonIdsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamsEnrolledSeasonIdsQuery, GetTeamsEnrolledSeasonIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsEnrolledSeasonIdsQuery, GetTeamsEnrolledSeasonIdsQueryVariables>(GetTeamsEnrolledSeasonIdsDocument, options);
      }
export function useGetTeamsEnrolledSeasonIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsEnrolledSeasonIdsQuery, GetTeamsEnrolledSeasonIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsEnrolledSeasonIdsQuery, GetTeamsEnrolledSeasonIdsQueryVariables>(GetTeamsEnrolledSeasonIdsDocument, options);
        }
export type GetTeamsEnrolledSeasonIdsQueryHookResult = ReturnType<typeof useGetTeamsEnrolledSeasonIdsQuery>;
export type GetTeamsEnrolledSeasonIdsLazyQueryHookResult = ReturnType<typeof useGetTeamsEnrolledSeasonIdsLazyQuery>;
export type GetTeamsEnrolledSeasonIdsQueryResult = Apollo.QueryResult<GetTeamsEnrolledSeasonIdsQuery, GetTeamsEnrolledSeasonIdsQueryVariables>;
export function refetchGetTeamsEnrolledSeasonIdsQuery(variables: GetTeamsEnrolledSeasonIdsQueryVariables) {
      return { query: GetTeamsEnrolledSeasonIdsDocument, variables: variables }
    }
export const GetEntryCodesDocument = gql`
    query getEntryCodes($matchId: UUID!) {
  match(id: $matchId) {
    id
    status
    games {
      id
      status
      entryCode
      ordinalNumber
    }
  }
}
    `;

/**
 * __useGetEntryCodesQuery__
 *
 * To run a query within a React component, call `useGetEntryCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntryCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntryCodesQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetEntryCodesQuery(baseOptions: Apollo.QueryHookOptions<GetEntryCodesQuery, GetEntryCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntryCodesQuery, GetEntryCodesQueryVariables>(GetEntryCodesDocument, options);
      }
export function useGetEntryCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntryCodesQuery, GetEntryCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntryCodesQuery, GetEntryCodesQueryVariables>(GetEntryCodesDocument, options);
        }
export type GetEntryCodesQueryHookResult = ReturnType<typeof useGetEntryCodesQuery>;
export type GetEntryCodesLazyQueryHookResult = ReturnType<typeof useGetEntryCodesLazyQuery>;
export type GetEntryCodesQueryResult = Apollo.QueryResult<GetEntryCodesQuery, GetEntryCodesQueryVariables>;
export function refetchGetEntryCodesQuery(variables: GetEntryCodesQueryVariables) {
      return { query: GetEntryCodesDocument, variables: variables }
    }
export const GetMatchStatusDocument = gql`
    query getMatchStatus($matchId: UUID!) {
  match(id: $matchId) {
    id
    status
  }
}
    `;

/**
 * __useGetMatchStatusQuery__
 *
 * To run a query within a React component, call `useGetMatchStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchStatusQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMatchStatusQuery, GetMatchStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchStatusQuery, GetMatchStatusQueryVariables>(GetMatchStatusDocument, options);
      }
export function useGetMatchStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchStatusQuery, GetMatchStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchStatusQuery, GetMatchStatusQueryVariables>(GetMatchStatusDocument, options);
        }
export type GetMatchStatusQueryHookResult = ReturnType<typeof useGetMatchStatusQuery>;
export type GetMatchStatusLazyQueryHookResult = ReturnType<typeof useGetMatchStatusLazyQuery>;
export type GetMatchStatusQueryResult = Apollo.QueryResult<GetMatchStatusQuery, GetMatchStatusQueryVariables>;
export function refetchGetMatchStatusQuery(variables: GetMatchStatusQueryVariables) {
      return { query: GetMatchStatusDocument, variables: variables }
    }
export const GetUserEsportInterestsForSchoolDocument = gql`
    query getUserEsportInterestsForSchool($id: UUID!) {
  user(id: $id) {
    id
    esportInterests {
      id
      slug
    }
  }
}
    `;

/**
 * __useGetUserEsportInterestsForSchoolQuery__
 *
 * To run a query within a React component, call `useGetUserEsportInterestsForSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEsportInterestsForSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEsportInterestsForSchoolQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserEsportInterestsForSchoolQuery(baseOptions: Apollo.QueryHookOptions<GetUserEsportInterestsForSchoolQuery, GetUserEsportInterestsForSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEsportInterestsForSchoolQuery, GetUserEsportInterestsForSchoolQueryVariables>(GetUserEsportInterestsForSchoolDocument, options);
      }
export function useGetUserEsportInterestsForSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEsportInterestsForSchoolQuery, GetUserEsportInterestsForSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEsportInterestsForSchoolQuery, GetUserEsportInterestsForSchoolQueryVariables>(GetUserEsportInterestsForSchoolDocument, options);
        }
export type GetUserEsportInterestsForSchoolQueryHookResult = ReturnType<typeof useGetUserEsportInterestsForSchoolQuery>;
export type GetUserEsportInterestsForSchoolLazyQueryHookResult = ReturnType<typeof useGetUserEsportInterestsForSchoolLazyQuery>;
export type GetUserEsportInterestsForSchoolQueryResult = Apollo.QueryResult<GetUserEsportInterestsForSchoolQuery, GetUserEsportInterestsForSchoolQueryVariables>;
export function refetchGetUserEsportInterestsForSchoolQuery(variables: GetUserEsportInterestsForSchoolQueryVariables) {
      return { query: GetUserEsportInterestsForSchoolDocument, variables: variables }
    }
export const SetUserEsportInterestsDocument = gql`
    mutation setUserEsportInterests($input: SetUserEsportInterestsInput!) {
  setUserEsportInterests(input: $input) {
    success
  }
}
    `;
export type SetUserEsportInterestsMutationFn = Apollo.MutationFunction<SetUserEsportInterestsMutation, SetUserEsportInterestsMutationVariables>;

/**
 * __useSetUserEsportInterestsMutation__
 *
 * To run a mutation, you first call `useSetUserEsportInterestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserEsportInterestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserEsportInterestsMutation, { data, loading, error }] = useSetUserEsportInterestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserEsportInterestsMutation(baseOptions?: Apollo.MutationHookOptions<SetUserEsportInterestsMutation, SetUserEsportInterestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserEsportInterestsMutation, SetUserEsportInterestsMutationVariables>(SetUserEsportInterestsDocument, options);
      }
export type SetUserEsportInterestsMutationHookResult = ReturnType<typeof useSetUserEsportInterestsMutation>;
export type SetUserEsportInterestsMutationResult = Apollo.MutationResult<SetUserEsportInterestsMutation>;
export type SetUserEsportInterestsMutationOptions = Apollo.BaseMutationOptions<SetUserEsportInterestsMutation, SetUserEsportInterestsMutationVariables>;
export const SetMyEsportInterestsDocument = gql`
    mutation setMyEsportInterests($input: SetMyEsportInterests) {
  setMyEsportInterests(input: $input) {
    success
  }
}
    `;
export type SetMyEsportInterestsMutationFn = Apollo.MutationFunction<SetMyEsportInterestsMutation, SetMyEsportInterestsMutationVariables>;

/**
 * __useSetMyEsportInterestsMutation__
 *
 * To run a mutation, you first call `useSetMyEsportInterestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyEsportInterestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyEsportInterestsMutation, { data, loading, error }] = useSetMyEsportInterestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMyEsportInterestsMutation(baseOptions?: Apollo.MutationHookOptions<SetMyEsportInterestsMutation, SetMyEsportInterestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyEsportInterestsMutation, SetMyEsportInterestsMutationVariables>(SetMyEsportInterestsDocument, options);
      }
export type SetMyEsportInterestsMutationHookResult = ReturnType<typeof useSetMyEsportInterestsMutation>;
export type SetMyEsportInterestsMutationResult = Apollo.MutationResult<SetMyEsportInterestsMutation>;
export type SetMyEsportInterestsMutationOptions = Apollo.BaseMutationOptions<SetMyEsportInterestsMutation, SetMyEsportInterestsMutationVariables>;
export const GetFilteredEsportsDocument = gql`
    query getFilteredEsports($filters: EsportFilters) {
  esports(filters: $filters) {
    id
    name
    description
    slug
    rating
    isEnabled
    details {
      abbreviation
      esportId
    }
  }
}
    `;

/**
 * __useGetFilteredEsportsQuery__
 *
 * To run a query within a React component, call `useGetFilteredEsportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredEsportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredEsportsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetFilteredEsportsQuery(baseOptions?: Apollo.QueryHookOptions<GetFilteredEsportsQuery, GetFilteredEsportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredEsportsQuery, GetFilteredEsportsQueryVariables>(GetFilteredEsportsDocument, options);
      }
export function useGetFilteredEsportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredEsportsQuery, GetFilteredEsportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredEsportsQuery, GetFilteredEsportsQueryVariables>(GetFilteredEsportsDocument, options);
        }
export type GetFilteredEsportsQueryHookResult = ReturnType<typeof useGetFilteredEsportsQuery>;
export type GetFilteredEsportsLazyQueryHookResult = ReturnType<typeof useGetFilteredEsportsLazyQuery>;
export type GetFilteredEsportsQueryResult = Apollo.QueryResult<GetFilteredEsportsQuery, GetFilteredEsportsQueryVariables>;
export function refetchGetFilteredEsportsQuery(variables?: GetFilteredEsportsQueryVariables) {
      return { query: GetFilteredEsportsDocument, variables: variables }
    }
export const GetEsportBySlugDocument = gql`
    query getEsportBySlug($slug: EsportSlug!) {
  esport(slug: $slug) {
    id
    slug
    rating
    name
    description
    isEnabled
    updatedAt
    createdAt
    isPromoted
  }
}
    `;

/**
 * __useGetEsportBySlugQuery__
 *
 * To run a query within a React component, call `useGetEsportBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsportBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsportBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetEsportBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetEsportBySlugQuery, GetEsportBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsportBySlugQuery, GetEsportBySlugQueryVariables>(GetEsportBySlugDocument, options);
      }
export function useGetEsportBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEsportBySlugQuery, GetEsportBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsportBySlugQuery, GetEsportBySlugQueryVariables>(GetEsportBySlugDocument, options);
        }
export type GetEsportBySlugQueryHookResult = ReturnType<typeof useGetEsportBySlugQuery>;
export type GetEsportBySlugLazyQueryHookResult = ReturnType<typeof useGetEsportBySlugLazyQuery>;
export type GetEsportBySlugQueryResult = Apollo.QueryResult<GetEsportBySlugQuery, GetEsportBySlugQueryVariables>;
export function refetchGetEsportBySlugQuery(variables: GetEsportBySlugQueryVariables) {
      return { query: GetEsportBySlugDocument, variables: variables }
    }
export const GetGeneralEsportAdapterDetailsDocument = gql`
    query getGeneralEsportAdapterDetails($filters: EsportFilters) {
  esports(filters: $filters) {
    id
    slug
    rating
    name
    isEnabled
    isUnderageEnabled
    details {
      ...EsportDetails
    }
    leagueDefaults {
      teamFormat
      teamMaxSize
    }
    colors {
      color1
      color2
      color3
      color4
      color5
      color6
      mainColor
      gradientStart
      gradientEnd
    }
  }
}
    ${EsportDetailsFragmentDoc}`;

/**
 * __useGetGeneralEsportAdapterDetailsQuery__
 *
 * To run a query within a React component, call `useGetGeneralEsportAdapterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralEsportAdapterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralEsportAdapterDetailsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGeneralEsportAdapterDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneralEsportAdapterDetailsQuery, GetGeneralEsportAdapterDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralEsportAdapterDetailsQuery, GetGeneralEsportAdapterDetailsQueryVariables>(GetGeneralEsportAdapterDetailsDocument, options);
      }
export function useGetGeneralEsportAdapterDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralEsportAdapterDetailsQuery, GetGeneralEsportAdapterDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralEsportAdapterDetailsQuery, GetGeneralEsportAdapterDetailsQueryVariables>(GetGeneralEsportAdapterDetailsDocument, options);
        }
export type GetGeneralEsportAdapterDetailsQueryHookResult = ReturnType<typeof useGetGeneralEsportAdapterDetailsQuery>;
export type GetGeneralEsportAdapterDetailsLazyQueryHookResult = ReturnType<typeof useGetGeneralEsportAdapterDetailsLazyQuery>;
export type GetGeneralEsportAdapterDetailsQueryResult = Apollo.QueryResult<GetGeneralEsportAdapterDetailsQuery, GetGeneralEsportAdapterDetailsQueryVariables>;
export function refetchGetGeneralEsportAdapterDetailsQuery(variables?: GetGeneralEsportAdapterDetailsQueryVariables) {
      return { query: GetGeneralEsportAdapterDetailsDocument, variables: variables }
    }
export const GetEsportsV2Document = gql`
    query getEsportsV2 {
  esportsV2 {
    id
    name
    rating
    offerings {
      competitionGroup
      esportId
      teamFormat {
        size
      }
      platform {
        slug
      }
    }
  }
}
    `;

/**
 * __useGetEsportsV2Query__
 *
 * To run a query within a React component, call `useGetEsportsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetEsportsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsportsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetEsportsV2Query(baseOptions?: Apollo.QueryHookOptions<GetEsportsV2Query, GetEsportsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsportsV2Query, GetEsportsV2QueryVariables>(GetEsportsV2Document, options);
      }
export function useGetEsportsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEsportsV2Query, GetEsportsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsportsV2Query, GetEsportsV2QueryVariables>(GetEsportsV2Document, options);
        }
export type GetEsportsV2QueryHookResult = ReturnType<typeof useGetEsportsV2Query>;
export type GetEsportsV2LazyQueryHookResult = ReturnType<typeof useGetEsportsV2LazyQuery>;
export type GetEsportsV2QueryResult = Apollo.QueryResult<GetEsportsV2Query, GetEsportsV2QueryVariables>;
export function refetchGetEsportsV2Query(variables?: GetEsportsV2QueryVariables) {
      return { query: GetEsportsV2Document, variables: variables }
    }
export const GetAllEsportsDocument = gql`
    query getAllEsports {
  esports {
    id
    name
    esportGroupId
    slug
    platform
    isEnabled
    isPromoted
    leagueDefaults {
      teamFormat
    }
    details {
      esportId
      abbreviation
      platforms
    }
  }
}
    `;

/**
 * __useGetAllEsportsQuery__
 *
 * To run a query within a React component, call `useGetAllEsportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEsportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEsportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEsportsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEsportsQuery, GetAllEsportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEsportsQuery, GetAllEsportsQueryVariables>(GetAllEsportsDocument, options);
      }
export function useGetAllEsportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEsportsQuery, GetAllEsportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEsportsQuery, GetAllEsportsQueryVariables>(GetAllEsportsDocument, options);
        }
export type GetAllEsportsQueryHookResult = ReturnType<typeof useGetAllEsportsQuery>;
export type GetAllEsportsLazyQueryHookResult = ReturnType<typeof useGetAllEsportsLazyQuery>;
export type GetAllEsportsQueryResult = Apollo.QueryResult<GetAllEsportsQuery, GetAllEsportsQueryVariables>;
export function refetchGetAllEsportsQuery(variables?: GetAllEsportsQueryVariables) {
      return { query: GetAllEsportsDocument, variables: variables }
    }
export const GetAllEsportsSlugsDocument = gql`
    query getAllEsportsSlugs {
  esports {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetAllEsportsSlugsQuery__
 *
 * To run a query within a React component, call `useGetAllEsportsSlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEsportsSlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEsportsSlugsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEsportsSlugsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEsportsSlugsQuery, GetAllEsportsSlugsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEsportsSlugsQuery, GetAllEsportsSlugsQueryVariables>(GetAllEsportsSlugsDocument, options);
      }
export function useGetAllEsportsSlugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEsportsSlugsQuery, GetAllEsportsSlugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEsportsSlugsQuery, GetAllEsportsSlugsQueryVariables>(GetAllEsportsSlugsDocument, options);
        }
export type GetAllEsportsSlugsQueryHookResult = ReturnType<typeof useGetAllEsportsSlugsQuery>;
export type GetAllEsportsSlugsLazyQueryHookResult = ReturnType<typeof useGetAllEsportsSlugsLazyQuery>;
export type GetAllEsportsSlugsQueryResult = Apollo.QueryResult<GetAllEsportsSlugsQuery, GetAllEsportsSlugsQueryVariables>;
export function refetchGetAllEsportsSlugsQuery(variables?: GetAllEsportsSlugsQueryVariables) {
      return { query: GetAllEsportsSlugsDocument, variables: variables }
    }
export const GetAllEsportsWithLeagueAndSeasonCountDocument = gql`
    query getAllEsportsWithLeagueAndSeasonCount($metaseasonId: UUID!, $competitionGroup: CompetitionGroup!) {
  esports {
    id
    name
    slug
    eligibleLeaguesCount(competitionGroup: $competitionGroup)
    leaguesWithSeasonCount(metaseasonId: $metaseasonId)
    inactiveLeaguesCount(metaseasonId: $metaseasonId)
  }
}
    `;

/**
 * __useGetAllEsportsWithLeagueAndSeasonCountQuery__
 *
 * To run a query within a React component, call `useGetAllEsportsWithLeagueAndSeasonCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEsportsWithLeagueAndSeasonCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEsportsWithLeagueAndSeasonCountQuery({
 *   variables: {
 *      metaseasonId: // value for 'metaseasonId'
 *      competitionGroup: // value for 'competitionGroup'
 *   },
 * });
 */
export function useGetAllEsportsWithLeagueAndSeasonCountQuery(baseOptions: Apollo.QueryHookOptions<GetAllEsportsWithLeagueAndSeasonCountQuery, GetAllEsportsWithLeagueAndSeasonCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEsportsWithLeagueAndSeasonCountQuery, GetAllEsportsWithLeagueAndSeasonCountQueryVariables>(GetAllEsportsWithLeagueAndSeasonCountDocument, options);
      }
export function useGetAllEsportsWithLeagueAndSeasonCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEsportsWithLeagueAndSeasonCountQuery, GetAllEsportsWithLeagueAndSeasonCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEsportsWithLeagueAndSeasonCountQuery, GetAllEsportsWithLeagueAndSeasonCountQueryVariables>(GetAllEsportsWithLeagueAndSeasonCountDocument, options);
        }
export type GetAllEsportsWithLeagueAndSeasonCountQueryHookResult = ReturnType<typeof useGetAllEsportsWithLeagueAndSeasonCountQuery>;
export type GetAllEsportsWithLeagueAndSeasonCountLazyQueryHookResult = ReturnType<typeof useGetAllEsportsWithLeagueAndSeasonCountLazyQuery>;
export type GetAllEsportsWithLeagueAndSeasonCountQueryResult = Apollo.QueryResult<GetAllEsportsWithLeagueAndSeasonCountQuery, GetAllEsportsWithLeagueAndSeasonCountQueryVariables>;
export function refetchGetAllEsportsWithLeagueAndSeasonCountQuery(variables: GetAllEsportsWithLeagueAndSeasonCountQueryVariables) {
      return { query: GetAllEsportsWithLeagueAndSeasonCountDocument, variables: variables }
    }
export const CreateEsportDocument = gql`
    mutation createEsport($esportAttributes: EsportAttributes!) {
  createEsport(esportAttributes: $esportAttributes) {
    id
    slug
  }
}
    `;
export type CreateEsportMutationFn = Apollo.MutationFunction<CreateEsportMutation, CreateEsportMutationVariables>;

/**
 * __useCreateEsportMutation__
 *
 * To run a mutation, you first call `useCreateEsportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEsportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEsportMutation, { data, loading, error }] = useCreateEsportMutation({
 *   variables: {
 *      esportAttributes: // value for 'esportAttributes'
 *   },
 * });
 */
export function useCreateEsportMutation(baseOptions?: Apollo.MutationHookOptions<CreateEsportMutation, CreateEsportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEsportMutation, CreateEsportMutationVariables>(CreateEsportDocument, options);
      }
export type CreateEsportMutationHookResult = ReturnType<typeof useCreateEsportMutation>;
export type CreateEsportMutationResult = Apollo.MutationResult<CreateEsportMutation>;
export type CreateEsportMutationOptions = Apollo.BaseMutationOptions<CreateEsportMutation, CreateEsportMutationVariables>;
export const UpdateEsportDetailsDocument = gql`
    mutation updateEsportDetails($esportSlug: String!, $attributes: EsportDetailsAttributes) {
  updateEsportDetails(esportSlug: $esportSlug, attributes: $attributes) {
    ...EsportDetails
  }
}
    ${EsportDetailsFragmentDoc}`;
export type UpdateEsportDetailsMutationFn = Apollo.MutationFunction<UpdateEsportDetailsMutation, UpdateEsportDetailsMutationVariables>;

/**
 * __useUpdateEsportDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateEsportDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsportDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsportDetailsMutation, { data, loading, error }] = useUpdateEsportDetailsMutation({
 *   variables: {
 *      esportSlug: // value for 'esportSlug'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateEsportDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsportDetailsMutation, UpdateEsportDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsportDetailsMutation, UpdateEsportDetailsMutationVariables>(UpdateEsportDetailsDocument, options);
      }
export type UpdateEsportDetailsMutationHookResult = ReturnType<typeof useUpdateEsportDetailsMutation>;
export type UpdateEsportDetailsMutationResult = Apollo.MutationResult<UpdateEsportDetailsMutation>;
export type UpdateEsportDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateEsportDetailsMutation, UpdateEsportDetailsMutationVariables>;
export const UpdateEsportDocument = gql`
    mutation updateEsport($id: UUID!, $attributes: EsportAttributes!) {
  updateEsport(id: $id, attributes: $attributes) {
    id
    slug
    rating
    isEnabled
  }
}
    `;
export type UpdateEsportMutationFn = Apollo.MutationFunction<UpdateEsportMutation, UpdateEsportMutationVariables>;

/**
 * __useUpdateEsportMutation__
 *
 * To run a mutation, you first call `useUpdateEsportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsportMutation, { data, loading, error }] = useUpdateEsportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateEsportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsportMutation, UpdateEsportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsportMutation, UpdateEsportMutationVariables>(UpdateEsportDocument, options);
      }
export type UpdateEsportMutationHookResult = ReturnType<typeof useUpdateEsportMutation>;
export type UpdateEsportMutationResult = Apollo.MutationResult<UpdateEsportMutation>;
export type UpdateEsportMutationOptions = Apollo.BaseMutationOptions<UpdateEsportMutation, UpdateEsportMutationVariables>;
export const UploadEsportFileDocument = gql`
    mutation uploadEsportFile($input: UploadEsportFileInput!) {
  uploadEsportFile(input: $input) {
    success
    fileUrl
  }
}
    `;
export type UploadEsportFileMutationFn = Apollo.MutationFunction<UploadEsportFileMutation, UploadEsportFileMutationVariables>;

/**
 * __useUploadEsportFileMutation__
 *
 * To run a mutation, you first call `useUploadEsportFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEsportFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEsportFileMutation, { data, loading, error }] = useUploadEsportFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadEsportFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadEsportFileMutation, UploadEsportFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEsportFileMutation, UploadEsportFileMutationVariables>(UploadEsportFileDocument, options);
      }
export type UploadEsportFileMutationHookResult = ReturnType<typeof useUploadEsportFileMutation>;
export type UploadEsportFileMutationResult = Apollo.MutationResult<UploadEsportFileMutation>;
export type UploadEsportFileMutationOptions = Apollo.BaseMutationOptions<UploadEsportFileMutation, UploadEsportFileMutationVariables>;
export const EsportsByCompetitionGroupDocument = gql`
    query esportsByCompetitionGroup($competitionGroup: CompetitionGroup!) {
  esportsByCompetitionGroup(competitionGroup: $competitionGroup) {
    id
    slug
  }
}
    `;

/**
 * __useEsportsByCompetitionGroupQuery__
 *
 * To run a query within a React component, call `useEsportsByCompetitionGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsportsByCompetitionGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsportsByCompetitionGroupQuery({
 *   variables: {
 *      competitionGroup: // value for 'competitionGroup'
 *   },
 * });
 */
export function useEsportsByCompetitionGroupQuery(baseOptions: Apollo.QueryHookOptions<EsportsByCompetitionGroupQuery, EsportsByCompetitionGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsportsByCompetitionGroupQuery, EsportsByCompetitionGroupQueryVariables>(EsportsByCompetitionGroupDocument, options);
      }
export function useEsportsByCompetitionGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EsportsByCompetitionGroupQuery, EsportsByCompetitionGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsportsByCompetitionGroupQuery, EsportsByCompetitionGroupQueryVariables>(EsportsByCompetitionGroupDocument, options);
        }
export type EsportsByCompetitionGroupQueryHookResult = ReturnType<typeof useEsportsByCompetitionGroupQuery>;
export type EsportsByCompetitionGroupLazyQueryHookResult = ReturnType<typeof useEsportsByCompetitionGroupLazyQuery>;
export type EsportsByCompetitionGroupQueryResult = Apollo.QueryResult<EsportsByCompetitionGroupQuery, EsportsByCompetitionGroupQueryVariables>;
export function refetchEsportsByCompetitionGroupQuery(variables: EsportsByCompetitionGroupQueryVariables) {
      return { query: EsportsByCompetitionGroupDocument, variables: variables }
    }
export const GetEsportsForNexusDocument = gql`
    query getEsportsForNexus {
  esports {
    id
    slug
    name
    colors {
      color1
      color2
      color3
      color4
      color5
      color6
      mainColor
      gradientStart
      gradientEnd
    }
  }
}
    `;

/**
 * __useGetEsportsForNexusQuery__
 *
 * To run a query within a React component, call `useGetEsportsForNexusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsportsForNexusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsportsForNexusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEsportsForNexusQuery(baseOptions?: Apollo.QueryHookOptions<GetEsportsForNexusQuery, GetEsportsForNexusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsportsForNexusQuery, GetEsportsForNexusQueryVariables>(GetEsportsForNexusDocument, options);
      }
export function useGetEsportsForNexusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEsportsForNexusQuery, GetEsportsForNexusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsportsForNexusQuery, GetEsportsForNexusQueryVariables>(GetEsportsForNexusDocument, options);
        }
export type GetEsportsForNexusQueryHookResult = ReturnType<typeof useGetEsportsForNexusQuery>;
export type GetEsportsForNexusLazyQueryHookResult = ReturnType<typeof useGetEsportsForNexusLazyQuery>;
export type GetEsportsForNexusQueryResult = Apollo.QueryResult<GetEsportsForNexusQuery, GetEsportsForNexusQueryVariables>;
export function refetchGetEsportsForNexusQuery(variables?: GetEsportsForNexusQueryVariables) {
      return { query: GetEsportsForNexusDocument, variables: variables }
    }
export const UpdateEsportColorsDocument = gql`
    mutation updateEsportColors($esportId: UUID!, $attributes: EsportColorsAttributes!) {
  setEsportColors(esportId: $esportId, attributes: $attributes) {
    esport {
      id
    }
  }
}
    `;
export type UpdateEsportColorsMutationFn = Apollo.MutationFunction<UpdateEsportColorsMutation, UpdateEsportColorsMutationVariables>;

/**
 * __useUpdateEsportColorsMutation__
 *
 * To run a mutation, you first call `useUpdateEsportColorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsportColorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsportColorsMutation, { data, loading, error }] = useUpdateEsportColorsMutation({
 *   variables: {
 *      esportId: // value for 'esportId'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateEsportColorsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsportColorsMutation, UpdateEsportColorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsportColorsMutation, UpdateEsportColorsMutationVariables>(UpdateEsportColorsDocument, options);
      }
export type UpdateEsportColorsMutationHookResult = ReturnType<typeof useUpdateEsportColorsMutation>;
export type UpdateEsportColorsMutationResult = Apollo.MutationResult<UpdateEsportColorsMutation>;
export type UpdateEsportColorsMutationOptions = Apollo.BaseMutationOptions<UpdateEsportColorsMutation, UpdateEsportColorsMutationVariables>;
export const EligibleMetaseasonsDocument = gql`
    query eligibleMetaseasons($schoolId: UUID, $teamId: UUID) {
  eligibleMetaseasons(schoolId: $schoolId, teamId: $teamId) {
    id
    name
    isPromoted
    startsAt
    endsAt
    competitionGroup
    isInitialMetaseason
  }
}
    `;

/**
 * __useEligibleMetaseasonsQuery__
 *
 * To run a query within a React component, call `useEligibleMetaseasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibleMetaseasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibleMetaseasonsQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useEligibleMetaseasonsQuery(baseOptions?: Apollo.QueryHookOptions<EligibleMetaseasonsQuery, EligibleMetaseasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EligibleMetaseasonsQuery, EligibleMetaseasonsQueryVariables>(EligibleMetaseasonsDocument, options);
      }
export function useEligibleMetaseasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EligibleMetaseasonsQuery, EligibleMetaseasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EligibleMetaseasonsQuery, EligibleMetaseasonsQueryVariables>(EligibleMetaseasonsDocument, options);
        }
export type EligibleMetaseasonsQueryHookResult = ReturnType<typeof useEligibleMetaseasonsQuery>;
export type EligibleMetaseasonsLazyQueryHookResult = ReturnType<typeof useEligibleMetaseasonsLazyQuery>;
export type EligibleMetaseasonsQueryResult = Apollo.QueryResult<EligibleMetaseasonsQuery, EligibleMetaseasonsQueryVariables>;
export function refetchEligibleMetaseasonsQuery(variables?: EligibleMetaseasonsQueryVariables) {
      return { query: EligibleMetaseasonsDocument, variables: variables }
    }
export const SchoolLeaguesDocument = gql`
    query schoolLeagues($schoolId: UUID!) {
  getLeaguesBySchoolId(schoolId: $schoolId) {
    id
    name
    displayName
    state
    competitionModel
    competitionGroup
    seasons {
      id
      metaseasonId
      registrationStartsAt
      teamRegistrationEndsAt
      teamDeregistrationEndsAt
      suggestedRegistrationEndsAt
    }
    varsityAssociation {
      name
    }
    esport {
      id
      slug
      name
      rating
      esportGroupId
    }
  }
}
    `;

/**
 * __useSchoolLeaguesQuery__
 *
 * To run a query within a React component, call `useSchoolLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolLeaguesQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useSchoolLeaguesQuery(baseOptions: Apollo.QueryHookOptions<SchoolLeaguesQuery, SchoolLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolLeaguesQuery, SchoolLeaguesQueryVariables>(SchoolLeaguesDocument, options);
      }
export function useSchoolLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolLeaguesQuery, SchoolLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolLeaguesQuery, SchoolLeaguesQueryVariables>(SchoolLeaguesDocument, options);
        }
export type SchoolLeaguesQueryHookResult = ReturnType<typeof useSchoolLeaguesQuery>;
export type SchoolLeaguesLazyQueryHookResult = ReturnType<typeof useSchoolLeaguesLazyQuery>;
export type SchoolLeaguesQueryResult = Apollo.QueryResult<SchoolLeaguesQuery, SchoolLeaguesQueryVariables>;
export function refetchSchoolLeaguesQuery(variables: SchoolLeaguesQueryVariables) {
      return { query: SchoolLeaguesDocument, variables: variables }
    }
export const MyLeagueFiltersDocument = gql`
    query myLeagueFilters($schoolId: UUID!) {
  eligibleMetaseasons(schoolId: $schoolId) {
    id
    name
    startsAt
    endsAt
    isPromoted
    status
  }
  school(id: $schoolId) {
    id
    teams {
      id
      esport {
        id
        slug
        name
      }
      name
    }
  }
}
    `;

/**
 * __useMyLeagueFiltersQuery__
 *
 * To run a query within a React component, call `useMyLeagueFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLeagueFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLeagueFiltersQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useMyLeagueFiltersQuery(baseOptions: Apollo.QueryHookOptions<MyLeagueFiltersQuery, MyLeagueFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLeagueFiltersQuery, MyLeagueFiltersQueryVariables>(MyLeagueFiltersDocument, options);
      }
export function useMyLeagueFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLeagueFiltersQuery, MyLeagueFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLeagueFiltersQuery, MyLeagueFiltersQueryVariables>(MyLeagueFiltersDocument, options);
        }
export type MyLeagueFiltersQueryHookResult = ReturnType<typeof useMyLeagueFiltersQuery>;
export type MyLeagueFiltersLazyQueryHookResult = ReturnType<typeof useMyLeagueFiltersLazyQuery>;
export type MyLeagueFiltersQueryResult = Apollo.QueryResult<MyLeagueFiltersQuery, MyLeagueFiltersQueryVariables>;
export function refetchMyLeagueFiltersQuery(variables: MyLeagueFiltersQueryVariables) {
      return { query: MyLeagueFiltersDocument, variables: variables }
    }
export const MyTeamManagementFiltersDocument = gql`
    query myTeamManagementFilters($schoolId: UUID!, $teamId: UUID!) {
  eligibleMetaseasons(schoolId: $schoolId, teamId: $teamId) {
    id
    name
    startsAt
    endsAt
    isPromoted
    competitionGroup
  }
  school(id: $schoolId) {
    id
    teams {
      id
      esport {
        id
        slug
        name
      }
      name
    }
  }
  getLeaguesBySchoolId(schoolId: $schoolId) {
    id
    name
    competitionModel
    displayName
    esport {
      id
      name
      slug
    }
  }
}
    `;

/**
 * __useMyTeamManagementFiltersQuery__
 *
 * To run a query within a React component, call `useMyTeamManagementFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamManagementFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamManagementFiltersQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useMyTeamManagementFiltersQuery(baseOptions: Apollo.QueryHookOptions<MyTeamManagementFiltersQuery, MyTeamManagementFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamManagementFiltersQuery, MyTeamManagementFiltersQueryVariables>(MyTeamManagementFiltersDocument, options);
      }
export function useMyTeamManagementFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamManagementFiltersQuery, MyTeamManagementFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamManagementFiltersQuery, MyTeamManagementFiltersQueryVariables>(MyTeamManagementFiltersDocument, options);
        }
export type MyTeamManagementFiltersQueryHookResult = ReturnType<typeof useMyTeamManagementFiltersQuery>;
export type MyTeamManagementFiltersLazyQueryHookResult = ReturnType<typeof useMyTeamManagementFiltersLazyQuery>;
export type MyTeamManagementFiltersQueryResult = Apollo.QueryResult<MyTeamManagementFiltersQuery, MyTeamManagementFiltersQueryVariables>;
export function refetchMyTeamManagementFiltersQuery(variables: MyTeamManagementFiltersQueryVariables) {
      return { query: MyTeamManagementFiltersDocument, variables: variables }
    }
export const SchoolLeaguesFiltersDocument = gql`
    query schoolLeaguesFilters($schoolId: UUID!, $includeDeletedSeasonTeam: Boolean) {
  eligibleMetaseasons(
    schoolId: $schoolId
    includeDeletedSeasonTeam: $includeDeletedSeasonTeam
  ) {
    id
    name
    startsAt
    endsAt
    isPromoted
    isInitialMetaseason
  }
}
    `;

/**
 * __useSchoolLeaguesFiltersQuery__
 *
 * To run a query within a React component, call `useSchoolLeaguesFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolLeaguesFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolLeaguesFiltersQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      includeDeletedSeasonTeam: // value for 'includeDeletedSeasonTeam'
 *   },
 * });
 */
export function useSchoolLeaguesFiltersQuery(baseOptions: Apollo.QueryHookOptions<SchoolLeaguesFiltersQuery, SchoolLeaguesFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolLeaguesFiltersQuery, SchoolLeaguesFiltersQueryVariables>(SchoolLeaguesFiltersDocument, options);
      }
export function useSchoolLeaguesFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolLeaguesFiltersQuery, SchoolLeaguesFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolLeaguesFiltersQuery, SchoolLeaguesFiltersQueryVariables>(SchoolLeaguesFiltersDocument, options);
        }
export type SchoolLeaguesFiltersQueryHookResult = ReturnType<typeof useSchoolLeaguesFiltersQuery>;
export type SchoolLeaguesFiltersLazyQueryHookResult = ReturnType<typeof useSchoolLeaguesFiltersLazyQuery>;
export type SchoolLeaguesFiltersQueryResult = Apollo.QueryResult<SchoolLeaguesFiltersQuery, SchoolLeaguesFiltersQueryVariables>;
export function refetchSchoolLeaguesFiltersQuery(variables: SchoolLeaguesFiltersQueryVariables) {
      return { query: SchoolLeaguesFiltersDocument, variables: variables }
    }
export const TeamLeaguesFiltersDocument = gql`
    query teamLeaguesFilters($teamId: UUID!, $metaseasonId: UUID, $hasMetaseason: Boolean!) {
  team(id: $teamId) {
    id
    competitionGroup
    esport {
      id
      slug
      name
    }
    name
    leagues(metaseasonId: $metaseasonId) @include(if: $hasMetaseason) {
      id
    }
    enrolledSeasons {
      id
      name
      rostersLockAt
      teamRegistrationEndsAt
      league {
        id
        name
        competitionModel
        displayName
        esport {
          id
          name
          slug
          rating
          esportGroupId
        }
      }
      phases {
        id
        startsAt
        endsAt
        name
        type
        seasonId
        slug
        status
        format
        survivalAdvancementCount
        survivalAdvancementPercentage
      }
      metaseason {
        id
        name
        startsAt
        endsAt
      }
    }
  }
}
    `;

/**
 * __useTeamLeaguesFiltersQuery__
 *
 * To run a query within a React component, call `useTeamLeaguesFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamLeaguesFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamLeaguesFiltersQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      metaseasonId: // value for 'metaseasonId'
 *      hasMetaseason: // value for 'hasMetaseason'
 *   },
 * });
 */
export function useTeamLeaguesFiltersQuery(baseOptions: Apollo.QueryHookOptions<TeamLeaguesFiltersQuery, TeamLeaguesFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamLeaguesFiltersQuery, TeamLeaguesFiltersQueryVariables>(TeamLeaguesFiltersDocument, options);
      }
export function useTeamLeaguesFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamLeaguesFiltersQuery, TeamLeaguesFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamLeaguesFiltersQuery, TeamLeaguesFiltersQueryVariables>(TeamLeaguesFiltersDocument, options);
        }
export type TeamLeaguesFiltersQueryHookResult = ReturnType<typeof useTeamLeaguesFiltersQuery>;
export type TeamLeaguesFiltersLazyQueryHookResult = ReturnType<typeof useTeamLeaguesFiltersLazyQuery>;
export type TeamLeaguesFiltersQueryResult = Apollo.QueryResult<TeamLeaguesFiltersQuery, TeamLeaguesFiltersQueryVariables>;
export function refetchTeamLeaguesFiltersQuery(variables: TeamLeaguesFiltersQueryVariables) {
      return { query: TeamLeaguesFiltersDocument, variables: variables }
    }
export const OpsTeamManagementFiltersDocument = gql`
    query opsTeamManagementFilters($schoolId: UUID!, $teamId: UUID!, $includeDeletedSeasonTeam: Boolean) {
  eligibleMetaseasons(
    schoolId: $schoolId
    teamId: $teamId
    includeDeletedSeasonTeam: $includeDeletedSeasonTeam
  ) {
    id
    name
    startsAt
    endsAt
    isPromoted
    competitionGroup
    isInitialMetaseason
  }
}
    `;

/**
 * __useOpsTeamManagementFiltersQuery__
 *
 * To run a query within a React component, call `useOpsTeamManagementFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpsTeamManagementFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpsTeamManagementFiltersQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      teamId: // value for 'teamId'
 *      includeDeletedSeasonTeam: // value for 'includeDeletedSeasonTeam'
 *   },
 * });
 */
export function useOpsTeamManagementFiltersQuery(baseOptions: Apollo.QueryHookOptions<OpsTeamManagementFiltersQuery, OpsTeamManagementFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpsTeamManagementFiltersQuery, OpsTeamManagementFiltersQueryVariables>(OpsTeamManagementFiltersDocument, options);
      }
export function useOpsTeamManagementFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpsTeamManagementFiltersQuery, OpsTeamManagementFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpsTeamManagementFiltersQuery, OpsTeamManagementFiltersQueryVariables>(OpsTeamManagementFiltersDocument, options);
        }
export type OpsTeamManagementFiltersQueryHookResult = ReturnType<typeof useOpsTeamManagementFiltersQuery>;
export type OpsTeamManagementFiltersLazyQueryHookResult = ReturnType<typeof useOpsTeamManagementFiltersLazyQuery>;
export type OpsTeamManagementFiltersQueryResult = Apollo.QueryResult<OpsTeamManagementFiltersQuery, OpsTeamManagementFiltersQueryVariables>;
export function refetchOpsTeamManagementFiltersQuery(variables: OpsTeamManagementFiltersQueryVariables) {
      return { query: OpsTeamManagementFiltersDocument, variables: variables }
    }
export const GetMySchoolEsportsDocument = gql`
    query getMySchoolEsports($schoolId: UUID!) {
  me {
    id
    school {
      id
    }
  }
  getLeaguesBySchoolId(schoolId: $schoolId) {
    id
    name
    displayName
    state
    competitionModel
    competitionGroup
    seasons {
      id
      metaseasonId
      registrationStartsAt
      teamRegistrationEndsAt
      teamDeregistrationEndsAt
      suggestedRegistrationEndsAt
    }
    varsityAssociation {
      name
    }
    esport {
      id
      slug
      name
      rating
      esportGroupId
    }
  }
}
    `;

/**
 * __useGetMySchoolEsportsQuery__
 *
 * To run a query within a React component, call `useGetMySchoolEsportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySchoolEsportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySchoolEsportsQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetMySchoolEsportsQuery(baseOptions: Apollo.QueryHookOptions<GetMySchoolEsportsQuery, GetMySchoolEsportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySchoolEsportsQuery, GetMySchoolEsportsQueryVariables>(GetMySchoolEsportsDocument, options);
      }
export function useGetMySchoolEsportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySchoolEsportsQuery, GetMySchoolEsportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySchoolEsportsQuery, GetMySchoolEsportsQueryVariables>(GetMySchoolEsportsDocument, options);
        }
export type GetMySchoolEsportsQueryHookResult = ReturnType<typeof useGetMySchoolEsportsQuery>;
export type GetMySchoolEsportsLazyQueryHookResult = ReturnType<typeof useGetMySchoolEsportsLazyQuery>;
export type GetMySchoolEsportsQueryResult = Apollo.QueryResult<GetMySchoolEsportsQuery, GetMySchoolEsportsQueryVariables>;
export function refetchGetMySchoolEsportsQuery(variables: GetMySchoolEsportsQueryVariables) {
      return { query: GetMySchoolEsportsDocument, variables: variables }
    }
export const GetAllEligibleMetaseasonsDocument = gql`
    query getAllEligibleMetaseasons {
  eligibleMetaseasons {
    id
    name
    startsAt
    endsAt
    isInitialMetaseason
    competitionGroup
  }
}
    `;

/**
 * __useGetAllEligibleMetaseasonsQuery__
 *
 * To run a query within a React component, call `useGetAllEligibleMetaseasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEligibleMetaseasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEligibleMetaseasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEligibleMetaseasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEligibleMetaseasonsQuery, GetAllEligibleMetaseasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEligibleMetaseasonsQuery, GetAllEligibleMetaseasonsQueryVariables>(GetAllEligibleMetaseasonsDocument, options);
      }
export function useGetAllEligibleMetaseasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEligibleMetaseasonsQuery, GetAllEligibleMetaseasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEligibleMetaseasonsQuery, GetAllEligibleMetaseasonsQueryVariables>(GetAllEligibleMetaseasonsDocument, options);
        }
export type GetAllEligibleMetaseasonsQueryHookResult = ReturnType<typeof useGetAllEligibleMetaseasonsQuery>;
export type GetAllEligibleMetaseasonsLazyQueryHookResult = ReturnType<typeof useGetAllEligibleMetaseasonsLazyQuery>;
export type GetAllEligibleMetaseasonsQueryResult = Apollo.QueryResult<GetAllEligibleMetaseasonsQuery, GetAllEligibleMetaseasonsQueryVariables>;
export function refetchGetAllEligibleMetaseasonsQuery(variables?: GetAllEligibleMetaseasonsQueryVariables) {
      return { query: GetAllEligibleMetaseasonsDocument, variables: variables }
    }
export const UseLeaguesDocument = gql`
    query useLeagues($metaseasonId: UUID!) {
  me {
    id
    school {
      id
      leagueGroups(metaseasonId: $metaseasonId) {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUseLeaguesQuery__
 *
 * To run a query within a React component, call `useUseLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseLeaguesQuery({
 *   variables: {
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useUseLeaguesQuery(baseOptions: Apollo.QueryHookOptions<UseLeaguesQuery, UseLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseLeaguesQuery, UseLeaguesQueryVariables>(UseLeaguesDocument, options);
      }
export function useUseLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseLeaguesQuery, UseLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseLeaguesQuery, UseLeaguesQueryVariables>(UseLeaguesDocument, options);
        }
export type UseLeaguesQueryHookResult = ReturnType<typeof useUseLeaguesQuery>;
export type UseLeaguesLazyQueryHookResult = ReturnType<typeof useUseLeaguesLazyQuery>;
export type UseLeaguesQueryResult = Apollo.QueryResult<UseLeaguesQuery, UseLeaguesQueryVariables>;
export function refetchUseLeaguesQuery(variables: UseLeaguesQueryVariables) {
      return { query: UseLeaguesDocument, variables: variables }
    }
export const UserHighlightsDocument = gql`
    query userHighlights($userId: UUID!) {
  user(id: $userId) {
    id
    gameHighlights {
      id
      title
      videoUrl
      userId
      matchId
      thumbnailUrl
      match {
        id
        scheduledStartsAt
        teamContext {
          matchId
          teams {
            id
            name
            isMyTeam
          }
        }
      }
      source
      createdAt
    }
  }
}
    `;

/**
 * __useUserHighlightsQuery__
 *
 * To run a query within a React component, call `useUserHighlightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHighlightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHighlightsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserHighlightsQuery(baseOptions: Apollo.QueryHookOptions<UserHighlightsQuery, UserHighlightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserHighlightsQuery, UserHighlightsQueryVariables>(UserHighlightsDocument, options);
      }
export function useUserHighlightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserHighlightsQuery, UserHighlightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserHighlightsQuery, UserHighlightsQueryVariables>(UserHighlightsDocument, options);
        }
export type UserHighlightsQueryHookResult = ReturnType<typeof useUserHighlightsQuery>;
export type UserHighlightsLazyQueryHookResult = ReturnType<typeof useUserHighlightsLazyQuery>;
export type UserHighlightsQueryResult = Apollo.QueryResult<UserHighlightsQuery, UserHighlightsQueryVariables>;
export function refetchUserHighlightsQuery(variables: UserHighlightsQueryVariables) {
      return { query: UserHighlightsDocument, variables: variables }
    }
export const GetAllHighlightsDocument = gql`
    query getAllHighlights($filters: GameHighlightFilters, $cursor: String, $limit: Int, $offset: Int) {
  gameHighlights(
    filters: $filters
    cursor: $cursor
    limit: $limit
    offset: $offset
  ) {
    gameHighlights {
      id
      title
      matchId
      videoUrl
      userId
      user {
        id
        name
      }
      match {
        id
        esport {
          id
          slug
        }
      }
      updatedAt
      createdAt
    }
    hasNextPage
    endCursor
  }
}
    `;

/**
 * __useGetAllHighlightsQuery__
 *
 * To run a query within a React component, call `useGetAllHighlightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllHighlightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllHighlightsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAllHighlightsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllHighlightsQuery, GetAllHighlightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllHighlightsQuery, GetAllHighlightsQueryVariables>(GetAllHighlightsDocument, options);
      }
export function useGetAllHighlightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllHighlightsQuery, GetAllHighlightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllHighlightsQuery, GetAllHighlightsQueryVariables>(GetAllHighlightsDocument, options);
        }
export type GetAllHighlightsQueryHookResult = ReturnType<typeof useGetAllHighlightsQuery>;
export type GetAllHighlightsLazyQueryHookResult = ReturnType<typeof useGetAllHighlightsLazyQuery>;
export type GetAllHighlightsQueryResult = Apollo.QueryResult<GetAllHighlightsQuery, GetAllHighlightsQueryVariables>;
export function refetchGetAllHighlightsQuery(variables?: GetAllHighlightsQueryVariables) {
      return { query: GetAllHighlightsDocument, variables: variables }
    }
export const CreateGameHighlightDocument = gql`
    mutation createGameHighlight($input: GameHighlightInput!) {
  createGameHighlight(input: $input) {
    gameHighlight {
      id
    }
  }
}
    `;
export type CreateGameHighlightMutationFn = Apollo.MutationFunction<CreateGameHighlightMutation, CreateGameHighlightMutationVariables>;

/**
 * __useCreateGameHighlightMutation__
 *
 * To run a mutation, you first call `useCreateGameHighlightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGameHighlightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGameHighlightMutation, { data, loading, error }] = useCreateGameHighlightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGameHighlightMutation(baseOptions?: Apollo.MutationHookOptions<CreateGameHighlightMutation, CreateGameHighlightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGameHighlightMutation, CreateGameHighlightMutationVariables>(CreateGameHighlightDocument, options);
      }
export type CreateGameHighlightMutationHookResult = ReturnType<typeof useCreateGameHighlightMutation>;
export type CreateGameHighlightMutationResult = Apollo.MutationResult<CreateGameHighlightMutation>;
export type CreateGameHighlightMutationOptions = Apollo.BaseMutationOptions<CreateGameHighlightMutation, CreateGameHighlightMutationVariables>;
export const DeleteGameHighlightDocument = gql`
    mutation deleteGameHighlight($input: DeleteGameHighlightInput!) {
  deleteGameHighlight(input: $input) {
    deletedId
  }
}
    `;
export type DeleteGameHighlightMutationFn = Apollo.MutationFunction<DeleteGameHighlightMutation, DeleteGameHighlightMutationVariables>;

/**
 * __useDeleteGameHighlightMutation__
 *
 * To run a mutation, you first call `useDeleteGameHighlightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGameHighlightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGameHighlightMutation, { data, loading, error }] = useDeleteGameHighlightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGameHighlightMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGameHighlightMutation, DeleteGameHighlightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGameHighlightMutation, DeleteGameHighlightMutationVariables>(DeleteGameHighlightDocument, options);
      }
export type DeleteGameHighlightMutationHookResult = ReturnType<typeof useDeleteGameHighlightMutation>;
export type DeleteGameHighlightMutationResult = Apollo.MutationResult<DeleteGameHighlightMutation>;
export type DeleteGameHighlightMutationOptions = Apollo.BaseMutationOptions<DeleteGameHighlightMutation, DeleteGameHighlightMutationVariables>;
export const UpdateGameHighlightDocument = gql`
    mutation updateGameHighlight($input: UpdateGameHighlightInput!) {
  updateGameHighlight(input: $input) {
    gameHighlight {
      id
    }
  }
}
    `;
export type UpdateGameHighlightMutationFn = Apollo.MutationFunction<UpdateGameHighlightMutation, UpdateGameHighlightMutationVariables>;

/**
 * __useUpdateGameHighlightMutation__
 *
 * To run a mutation, you first call `useUpdateGameHighlightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGameHighlightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGameHighlightMutation, { data, loading, error }] = useUpdateGameHighlightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGameHighlightMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGameHighlightMutation, UpdateGameHighlightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGameHighlightMutation, UpdateGameHighlightMutationVariables>(UpdateGameHighlightDocument, options);
      }
export type UpdateGameHighlightMutationHookResult = ReturnType<typeof useUpdateGameHighlightMutation>;
export type UpdateGameHighlightMutationResult = Apollo.MutationResult<UpdateGameHighlightMutation>;
export type UpdateGameHighlightMutationOptions = Apollo.BaseMutationOptions<UpdateGameHighlightMutation, UpdateGameHighlightMutationVariables>;
export const GetUsernameSchoolNameDocument = gql`
    query getUsernameSchoolName($size: Int) {
  me {
    id
    firstName
    avatarUrl(size: $size)
    school {
      id
      name
      slug
      state
      coaches {
        id
      }
    }
  }
}
    `;

/**
 * __useGetUsernameSchoolNameQuery__
 *
 * To run a query within a React component, call `useGetUsernameSchoolNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsernameSchoolNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsernameSchoolNameQuery({
 *   variables: {
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetUsernameSchoolNameQuery(baseOptions?: Apollo.QueryHookOptions<GetUsernameSchoolNameQuery, GetUsernameSchoolNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsernameSchoolNameQuery, GetUsernameSchoolNameQueryVariables>(GetUsernameSchoolNameDocument, options);
      }
export function useGetUsernameSchoolNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsernameSchoolNameQuery, GetUsernameSchoolNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsernameSchoolNameQuery, GetUsernameSchoolNameQueryVariables>(GetUsernameSchoolNameDocument, options);
        }
export type GetUsernameSchoolNameQueryHookResult = ReturnType<typeof useGetUsernameSchoolNameQuery>;
export type GetUsernameSchoolNameLazyQueryHookResult = ReturnType<typeof useGetUsernameSchoolNameLazyQuery>;
export type GetUsernameSchoolNameQueryResult = Apollo.QueryResult<GetUsernameSchoolNameQuery, GetUsernameSchoolNameQueryVariables>;
export function refetchGetUsernameSchoolNameQuery(variables?: GetUsernameSchoolNameQueryVariables) {
      return { query: GetUsernameSchoolNameDocument, variables: variables }
    }
export const LeagueOverviewDetailsDocument = gql`
    query leagueOverviewDetails($metaseasonId: UUID!, $isStudent: Boolean!) {
  me {
    id
    firstName
    lastName
    name
    email
    gradYear @include(if: $isStudent)
    phone @skip(if: $isStudent)
    phoneExt @skip(if: $isStudent)
    leagues(metaseasonId: $metaseasonId) {
      id
      name
      teamFormat
      esport {
        id
        slug
      }
    }
    esportInterests @include(if: $isStudent) {
      id
      slug
    }
    userProviderAccounts {
      id
      userId
      providerName
      providerDisplayName
      providerAccountId
      providerIntegrationType
    }
    teams(metaseasonId: $metaseasonId) @include(if: $isStudent) {
      id
      esportId
    }
    school {
      id
      competitionGroup
      address
      name
      slug
      state
      zip
      mascotName
      logoUrl
      detail @skip(if: $isStudent) {
        at
        it {
          osType
          suppStaff {
            email
            fname
            lname
            phone
          }
          hasDedicatedLab
          numStudentComps
          suppStaffOnCampus
          publicIP
          agreeToInstallGames
          agreeToWhitelistPorts
          agreeToDoPatchUpdates
        }
      }
      leagueGroups(metaseasonId: $metaseasonId) @skip(if: $isStudent) {
        id
        name
        leagues {
          id
          name
          esport {
            id
            leagueDefaults {
              teamFormat
            }
          }
          seasons {
            id
            leagueId
            metaseasonId
            name
            status
            teamRegistrationEndsAt
            phases {
              id
              name
              startsAt
              endsAt
              bestOf
              format
              type
              slots {
                id
                startsAt
              }
            }
          }
          esport {
            id
            description
            name
            slug
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLeagueOverviewDetailsQuery__
 *
 * To run a query within a React component, call `useLeagueOverviewDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeagueOverviewDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeagueOverviewDetailsQuery({
 *   variables: {
 *      metaseasonId: // value for 'metaseasonId'
 *      isStudent: // value for 'isStudent'
 *   },
 * });
 */
export function useLeagueOverviewDetailsQuery(baseOptions: Apollo.QueryHookOptions<LeagueOverviewDetailsQuery, LeagueOverviewDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeagueOverviewDetailsQuery, LeagueOverviewDetailsQueryVariables>(LeagueOverviewDetailsDocument, options);
      }
export function useLeagueOverviewDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeagueOverviewDetailsQuery, LeagueOverviewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeagueOverviewDetailsQuery, LeagueOverviewDetailsQueryVariables>(LeagueOverviewDetailsDocument, options);
        }
export type LeagueOverviewDetailsQueryHookResult = ReturnType<typeof useLeagueOverviewDetailsQuery>;
export type LeagueOverviewDetailsLazyQueryHookResult = ReturnType<typeof useLeagueOverviewDetailsLazyQuery>;
export type LeagueOverviewDetailsQueryResult = Apollo.QueryResult<LeagueOverviewDetailsQuery, LeagueOverviewDetailsQueryVariables>;
export function refetchLeagueOverviewDetailsQuery(variables: LeagueOverviewDetailsQueryVariables) {
      return { query: LeagueOverviewDetailsDocument, variables: variables }
    }
export const UnverifiedAlertDocument = gql`
    query unverifiedAlert {
  me {
    id
    roles {
      roleName
      userId
      resourceId
      resourceType
    }
    school {
      id
      coaches {
        id
        name
      }
      coachRolePendingUsers {
        id
      }
      playerRolePendingUsers {
        id
      }
    }
  }
}
    `;

/**
 * __useUnverifiedAlertQuery__
 *
 * To run a query within a React component, call `useUnverifiedAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnverifiedAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnverifiedAlertQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnverifiedAlertQuery(baseOptions?: Apollo.QueryHookOptions<UnverifiedAlertQuery, UnverifiedAlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnverifiedAlertQuery, UnverifiedAlertQueryVariables>(UnverifiedAlertDocument, options);
      }
export function useUnverifiedAlertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnverifiedAlertQuery, UnverifiedAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnverifiedAlertQuery, UnverifiedAlertQueryVariables>(UnverifiedAlertDocument, options);
        }
export type UnverifiedAlertQueryHookResult = ReturnType<typeof useUnverifiedAlertQuery>;
export type UnverifiedAlertLazyQueryHookResult = ReturnType<typeof useUnverifiedAlertLazyQuery>;
export type UnverifiedAlertQueryResult = Apollo.QueryResult<UnverifiedAlertQuery, UnverifiedAlertQueryVariables>;
export function refetchUnverifiedAlertQuery(variables?: UnverifiedAlertQueryVariables) {
      return { query: UnverifiedAlertDocument, variables: variables }
    }
export const GetMatchesWithMissingResultsDocument = gql`
    query getMatchesWithMissingResults($metaseasonStartsAt: DateTime) {
  me {
    id
    school {
      id
      matchesWithMissingResults(excludeBefore: $metaseasonStartsAt) {
        id
      }
    }
  }
}
    `;

/**
 * __useGetMatchesWithMissingResultsQuery__
 *
 * To run a query within a React component, call `useGetMatchesWithMissingResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchesWithMissingResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchesWithMissingResultsQuery({
 *   variables: {
 *      metaseasonStartsAt: // value for 'metaseasonStartsAt'
 *   },
 * });
 */
export function useGetMatchesWithMissingResultsQuery(baseOptions?: Apollo.QueryHookOptions<GetMatchesWithMissingResultsQuery, GetMatchesWithMissingResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchesWithMissingResultsQuery, GetMatchesWithMissingResultsQueryVariables>(GetMatchesWithMissingResultsDocument, options);
      }
export function useGetMatchesWithMissingResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchesWithMissingResultsQuery, GetMatchesWithMissingResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchesWithMissingResultsQuery, GetMatchesWithMissingResultsQueryVariables>(GetMatchesWithMissingResultsDocument, options);
        }
export type GetMatchesWithMissingResultsQueryHookResult = ReturnType<typeof useGetMatchesWithMissingResultsQuery>;
export type GetMatchesWithMissingResultsLazyQueryHookResult = ReturnType<typeof useGetMatchesWithMissingResultsLazyQuery>;
export type GetMatchesWithMissingResultsQueryResult = Apollo.QueryResult<GetMatchesWithMissingResultsQuery, GetMatchesWithMissingResultsQueryVariables>;
export function refetchGetMatchesWithMissingResultsQuery(variables?: GetMatchesWithMissingResultsQueryVariables) {
      return { query: GetMatchesWithMissingResultsDocument, variables: variables }
    }
export const GetBillingInfoDocument = gql`
    query getBillingInfo {
  me {
    id
    school {
      id
      billingContact {
        user {
          id
          email
          phone
        }
        email
        phone
      }
    }
  }
}
    `;

/**
 * __useGetBillingInfoQuery__
 *
 * To run a query within a React component, call `useGetBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingInfoQuery, GetBillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingInfoQuery, GetBillingInfoQueryVariables>(GetBillingInfoDocument, options);
      }
export function useGetBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingInfoQuery, GetBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingInfoQuery, GetBillingInfoQueryVariables>(GetBillingInfoDocument, options);
        }
export type GetBillingInfoQueryHookResult = ReturnType<typeof useGetBillingInfoQuery>;
export type GetBillingInfoLazyQueryHookResult = ReturnType<typeof useGetBillingInfoLazyQuery>;
export type GetBillingInfoQueryResult = Apollo.QueryResult<GetBillingInfoQuery, GetBillingInfoQueryVariables>;
export function refetchGetBillingInfoQuery(variables?: GetBillingInfoQueryVariables) {
      return { query: GetBillingInfoDocument, variables: variables }
    }
export const GetLeagueScopeLeaguesDocument = gql`
    query getLeagueScopeLeagues {
  me {
    id
    leagueScope {
      result {
        id
        name
        competitionGroup
        esport {
          id
          slug
          name
          rating
        }
      }
    }
  }
}
    `;

/**
 * __useGetLeagueScopeLeaguesQuery__
 *
 * To run a query within a React component, call `useGetLeagueScopeLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueScopeLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueScopeLeaguesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeagueScopeLeaguesQuery(baseOptions?: Apollo.QueryHookOptions<GetLeagueScopeLeaguesQuery, GetLeagueScopeLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueScopeLeaguesQuery, GetLeagueScopeLeaguesQueryVariables>(GetLeagueScopeLeaguesDocument, options);
      }
export function useGetLeagueScopeLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueScopeLeaguesQuery, GetLeagueScopeLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueScopeLeaguesQuery, GetLeagueScopeLeaguesQueryVariables>(GetLeagueScopeLeaguesDocument, options);
        }
export type GetLeagueScopeLeaguesQueryHookResult = ReturnType<typeof useGetLeagueScopeLeaguesQuery>;
export type GetLeagueScopeLeaguesLazyQueryHookResult = ReturnType<typeof useGetLeagueScopeLeaguesLazyQuery>;
export type GetLeagueScopeLeaguesQueryResult = Apollo.QueryResult<GetLeagueScopeLeaguesQuery, GetLeagueScopeLeaguesQueryVariables>;
export function refetchGetLeagueScopeLeaguesQuery(variables?: GetLeagueScopeLeaguesQueryVariables) {
      return { query: GetLeagueScopeLeaguesDocument, variables: variables }
    }
export const GetSchoolLeaguesDocument = gql`
    query getSchoolLeagues($schoolIds: [UUID!], $schoolId: UUID!) {
  findSchoolsByIds(ids: $schoolIds) {
    id
    competitionGroup
  }
  getLeaguesBySchoolId(schoolId: $schoolId) {
    id
    name
    displayName
    state
    competitionModel
    competitionGroup
    seasons {
      id
      metaseasonId
      registrationStartsAt
      teamRegistrationEndsAt
      teamDeregistrationEndsAt
      suggestedRegistrationEndsAt
    }
    varsityAssociation {
      name
    }
    esport {
      id
      slug
      name
      rating
    }
  }
}
    `;

/**
 * __useGetSchoolLeaguesQuery__
 *
 * To run a query within a React component, call `useGetSchoolLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolLeaguesQuery({
 *   variables: {
 *      schoolIds: // value for 'schoolIds'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolLeaguesQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolLeaguesQuery, GetSchoolLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolLeaguesQuery, GetSchoolLeaguesQueryVariables>(GetSchoolLeaguesDocument, options);
      }
export function useGetSchoolLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolLeaguesQuery, GetSchoolLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolLeaguesQuery, GetSchoolLeaguesQueryVariables>(GetSchoolLeaguesDocument, options);
        }
export type GetSchoolLeaguesQueryHookResult = ReturnType<typeof useGetSchoolLeaguesQuery>;
export type GetSchoolLeaguesLazyQueryHookResult = ReturnType<typeof useGetSchoolLeaguesLazyQuery>;
export type GetSchoolLeaguesQueryResult = Apollo.QueryResult<GetSchoolLeaguesQuery, GetSchoolLeaguesQueryVariables>;
export function refetchGetSchoolLeaguesQuery(variables: GetSchoolLeaguesQueryVariables) {
      return { query: GetSchoolLeaguesDocument, variables: variables }
    }
export const GetAllLeaguesForExploreDocument = gql`
    query getAllLeaguesForExplore {
  me {
    id
    dateOfBirth
    leagueScope {
      result {
        id
        name
        displayName
        timezone
        esport {
          id
          slug
          name
          rating
        }
        competitionGroup
        competitionModel
        seasons {
          id
          numberOfTeams
          metaseason {
            id
            name
            isPromoted
            startsAt
            endsAt
          }
          name
          teamRegistrationEndsAt
          suggestedRegistrationEndsAt
          registrationStartsAt
          phases {
            id
            type
            startsAt
            endsAt
            slots {
              id
              startsAt
            }
          }
        }
        rulebook {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllLeaguesForExploreQuery__
 *
 * To run a query within a React component, call `useGetAllLeaguesForExploreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLeaguesForExploreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLeaguesForExploreQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLeaguesForExploreQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLeaguesForExploreQuery, GetAllLeaguesForExploreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLeaguesForExploreQuery, GetAllLeaguesForExploreQueryVariables>(GetAllLeaguesForExploreDocument, options);
      }
export function useGetAllLeaguesForExploreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLeaguesForExploreQuery, GetAllLeaguesForExploreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLeaguesForExploreQuery, GetAllLeaguesForExploreQueryVariables>(GetAllLeaguesForExploreDocument, options);
        }
export type GetAllLeaguesForExploreQueryHookResult = ReturnType<typeof useGetAllLeaguesForExploreQuery>;
export type GetAllLeaguesForExploreLazyQueryHookResult = ReturnType<typeof useGetAllLeaguesForExploreLazyQuery>;
export type GetAllLeaguesForExploreQueryResult = Apollo.QueryResult<GetAllLeaguesForExploreQuery, GetAllLeaguesForExploreQueryVariables>;
export function refetchGetAllLeaguesForExploreQuery(variables?: GetAllLeaguesForExploreQueryVariables) {
      return { query: GetAllLeaguesForExploreDocument, variables: variables }
    }
export const GetLeagueByPublicSlugDocument = gql`
    query getLeagueByPublicSlug($publicSlug: String) {
  getLeagueByPublicSlug(publicSlug: $publicSlug) {
    id
    name
    displayName
    timezone
    teamFormat
    teamMaxSize
    competitionGroup
    competitionModel
    canRemovePlayersFromTeams
    isHidden
    isCheckInEnabled
    checkInOpenDaysBefore
    checkInOpenTime
    checkInCloseTimeOffsetMilliseconds
    type
    varsityAssociation {
      slug
      name
    }
    esport {
      id
      name
      slug
      platform
      rating
      details {
        esportId
        abbreviation
        teamMinStarterSize
        rulebookUrl
      }
    }
    seasons {
      status
    }
    rulebook {
      id
      url
    }
  }
}
    `;

/**
 * __useGetLeagueByPublicSlugQuery__
 *
 * To run a query within a React component, call `useGetLeagueByPublicSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueByPublicSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueByPublicSlugQuery({
 *   variables: {
 *      publicSlug: // value for 'publicSlug'
 *   },
 * });
 */
export function useGetLeagueByPublicSlugQuery(baseOptions?: Apollo.QueryHookOptions<GetLeagueByPublicSlugQuery, GetLeagueByPublicSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueByPublicSlugQuery, GetLeagueByPublicSlugQueryVariables>(GetLeagueByPublicSlugDocument, options);
      }
export function useGetLeagueByPublicSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueByPublicSlugQuery, GetLeagueByPublicSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueByPublicSlugQuery, GetLeagueByPublicSlugQueryVariables>(GetLeagueByPublicSlugDocument, options);
        }
export type GetLeagueByPublicSlugQueryHookResult = ReturnType<typeof useGetLeagueByPublicSlugQuery>;
export type GetLeagueByPublicSlugLazyQueryHookResult = ReturnType<typeof useGetLeagueByPublicSlugLazyQuery>;
export type GetLeagueByPublicSlugQueryResult = Apollo.QueryResult<GetLeagueByPublicSlugQuery, GetLeagueByPublicSlugQueryVariables>;
export function refetchGetLeagueByPublicSlugQuery(variables?: GetLeagueByPublicSlugQueryVariables) {
      return { query: GetLeagueByPublicSlugDocument, variables: variables }
    }
export const GetLeagueSeasonDataDocument = gql`
    query getLeagueSeasonData($leagueId: UUID!, $metaseasonId: UUID!) {
  league(id: $leagueId) {
    id
    seasonByMetaseasonId(metaseasonId: $metaseasonId) {
      id
      name
      numberOfTeams
      status
      startsAt
      rostersLockAt
      endsAt
      registrationStartsAt
      teamRegistrationEndsAt
      suggestedRegistrationEndsAt
      activePhases {
        id
        name
        type
        startsAt
        endsAt
        format
        bracketSize
        slots {
          id
          startsAt
          isStartsAtHidden
          order
          ordinal
          label
          name
        }
        status
      }
      sponsorshipImages {
        id
        entityId
        entityType
        name
        url
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetLeagueSeasonDataQuery__
 *
 * To run a query within a React component, call `useGetLeagueSeasonDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueSeasonDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueSeasonDataQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetLeagueSeasonDataQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueSeasonDataQuery, GetLeagueSeasonDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueSeasonDataQuery, GetLeagueSeasonDataQueryVariables>(GetLeagueSeasonDataDocument, options);
      }
export function useGetLeagueSeasonDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueSeasonDataQuery, GetLeagueSeasonDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueSeasonDataQuery, GetLeagueSeasonDataQueryVariables>(GetLeagueSeasonDataDocument, options);
        }
export type GetLeagueSeasonDataQueryHookResult = ReturnType<typeof useGetLeagueSeasonDataQuery>;
export type GetLeagueSeasonDataLazyQueryHookResult = ReturnType<typeof useGetLeagueSeasonDataLazyQuery>;
export type GetLeagueSeasonDataQueryResult = Apollo.QueryResult<GetLeagueSeasonDataQuery, GetLeagueSeasonDataQueryVariables>;
export function refetchGetLeagueSeasonDataQuery(variables: GetLeagueSeasonDataQueryVariables) {
      return { query: GetLeagueSeasonDataDocument, variables: variables }
    }
export const FindOrgCompetitionGroupDocument = gql`
    query findOrgCompetitionGroup($id: UUID!) {
  school(id: $id) {
    id
    competitionGroup
    name
  }
}
    `;

/**
 * __useFindOrgCompetitionGroupQuery__
 *
 * To run a query within a React component, call `useFindOrgCompetitionGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrgCompetitionGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrgCompetitionGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindOrgCompetitionGroupQuery(baseOptions: Apollo.QueryHookOptions<FindOrgCompetitionGroupQuery, FindOrgCompetitionGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrgCompetitionGroupQuery, FindOrgCompetitionGroupQueryVariables>(FindOrgCompetitionGroupDocument, options);
      }
export function useFindOrgCompetitionGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrgCompetitionGroupQuery, FindOrgCompetitionGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrgCompetitionGroupQuery, FindOrgCompetitionGroupQueryVariables>(FindOrgCompetitionGroupDocument, options);
        }
export type FindOrgCompetitionGroupQueryHookResult = ReturnType<typeof useFindOrgCompetitionGroupQuery>;
export type FindOrgCompetitionGroupLazyQueryHookResult = ReturnType<typeof useFindOrgCompetitionGroupLazyQuery>;
export type FindOrgCompetitionGroupQueryResult = Apollo.QueryResult<FindOrgCompetitionGroupQuery, FindOrgCompetitionGroupQueryVariables>;
export function refetchFindOrgCompetitionGroupQuery(variables: FindOrgCompetitionGroupQueryVariables) {
      return { query: FindOrgCompetitionGroupDocument, variables: variables }
    }
export const FindLeaguePreviewsByEsportSchoolDocument = gql`
    query findLeaguePreviewsByEsportSchool($esportId: UUID!, $schoolId: UUID!) {
  findLeaguePreviewsByEsportSchool(esportId: $esportId, schoolId: $schoolId) {
    rulebook {
      id
      url
    }
    leaguePreviews {
      league {
        id
        displayName
        name
        timezone
        competitionGroup
        competitionModel
        publicSlug
        varsityAssociation {
          name
          slug
        }
      }
      nextSeason {
        id
        type
        numberOfTeams
        metaseason {
          id
          name
          startsAt
          endsAt
          isPromoted
        }
        name
        registrationStartsAt
        teamRegistrationEndsAt
        suggestedRegistrationEndsAt
        startsAt
        endsAt
        phases {
          id
          type
          startsAt
          endsAt
          slots {
            id
            startsAt
          }
        }
        sponsorshipImages {
          id
          entityId
          entityType
          name
          url
          updatedAt
        }
      }
      nextSlot {
        id
        startsAt
      }
    }
  }
}
    `;

/**
 * __useFindLeaguePreviewsByEsportSchoolQuery__
 *
 * To run a query within a React component, call `useFindLeaguePreviewsByEsportSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindLeaguePreviewsByEsportSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindLeaguePreviewsByEsportSchoolQuery({
 *   variables: {
 *      esportId: // value for 'esportId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useFindLeaguePreviewsByEsportSchoolQuery(baseOptions: Apollo.QueryHookOptions<FindLeaguePreviewsByEsportSchoolQuery, FindLeaguePreviewsByEsportSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindLeaguePreviewsByEsportSchoolQuery, FindLeaguePreviewsByEsportSchoolQueryVariables>(FindLeaguePreviewsByEsportSchoolDocument, options);
      }
export function useFindLeaguePreviewsByEsportSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindLeaguePreviewsByEsportSchoolQuery, FindLeaguePreviewsByEsportSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindLeaguePreviewsByEsportSchoolQuery, FindLeaguePreviewsByEsportSchoolQueryVariables>(FindLeaguePreviewsByEsportSchoolDocument, options);
        }
export type FindLeaguePreviewsByEsportSchoolQueryHookResult = ReturnType<typeof useFindLeaguePreviewsByEsportSchoolQuery>;
export type FindLeaguePreviewsByEsportSchoolLazyQueryHookResult = ReturnType<typeof useFindLeaguePreviewsByEsportSchoolLazyQuery>;
export type FindLeaguePreviewsByEsportSchoolQueryResult = Apollo.QueryResult<FindLeaguePreviewsByEsportSchoolQuery, FindLeaguePreviewsByEsportSchoolQueryVariables>;
export function refetchFindLeaguePreviewsByEsportSchoolQuery(variables: FindLeaguePreviewsByEsportSchoolQueryVariables) {
      return { query: FindLeaguePreviewsByEsportSchoolDocument, variables: variables }
    }
export const GetLeagueTeamsDocument = gql`
    query getLeagueTeams($filters: TeamFiltersInput!) {
  getTeams(filters: $filters) {
    teams {
      id
      school {
        id
        logoUrl
      }
      esport {
        id
        rating
      }
      name
      esportId
      competitionGroup
      leagues {
        id
      }
      enrolledSeasons {
        id
        metaseasonId
      }
      roster {
        teamId
        numPlayers
      }
    }
  }
}
    `;

/**
 * __useGetLeagueTeamsQuery__
 *
 * To run a query within a React component, call `useGetLeagueTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueTeamsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetLeagueTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueTeamsQuery, GetLeagueTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueTeamsQuery, GetLeagueTeamsQueryVariables>(GetLeagueTeamsDocument, options);
      }
export function useGetLeagueTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueTeamsQuery, GetLeagueTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueTeamsQuery, GetLeagueTeamsQueryVariables>(GetLeagueTeamsDocument, options);
        }
export type GetLeagueTeamsQueryHookResult = ReturnType<typeof useGetLeagueTeamsQuery>;
export type GetLeagueTeamsLazyQueryHookResult = ReturnType<typeof useGetLeagueTeamsLazyQuery>;
export type GetLeagueTeamsQueryResult = Apollo.QueryResult<GetLeagueTeamsQuery, GetLeagueTeamsQueryVariables>;
export function refetchGetLeagueTeamsQuery(variables: GetLeagueTeamsQueryVariables) {
      return { query: GetLeagueTeamsDocument, variables: variables }
    }
export const GetAllLeagueTeamsDocument = gql`
    query getAllLeagueTeams($filters: TeamFiltersInput!, $limit: Int, $offset: Int) {
  getTeams(filters: $filters, limit: $limit, offset: $offset) {
    teams {
      id
      name
      state
      esport {
        id
        rating
      }
      school {
        id
        name
        logoUrl
        slug
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllLeagueTeamsQuery__
 *
 * To run a query within a React component, call `useGetAllLeagueTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLeagueTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLeagueTeamsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAllLeagueTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetAllLeagueTeamsQuery, GetAllLeagueTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLeagueTeamsQuery, GetAllLeagueTeamsQueryVariables>(GetAllLeagueTeamsDocument, options);
      }
export function useGetAllLeagueTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLeagueTeamsQuery, GetAllLeagueTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLeagueTeamsQuery, GetAllLeagueTeamsQueryVariables>(GetAllLeagueTeamsDocument, options);
        }
export type GetAllLeagueTeamsQueryHookResult = ReturnType<typeof useGetAllLeagueTeamsQuery>;
export type GetAllLeagueTeamsLazyQueryHookResult = ReturnType<typeof useGetAllLeagueTeamsLazyQuery>;
export type GetAllLeagueTeamsQueryResult = Apollo.QueryResult<GetAllLeagueTeamsQuery, GetAllLeagueTeamsQueryVariables>;
export function refetchGetAllLeagueTeamsQuery(variables: GetAllLeagueTeamsQueryVariables) {
      return { query: GetAllLeagueTeamsDocument, variables: variables }
    }
export const GetExploreLeaguesDocument = gql`
    query getExploreLeagues($schoolId: UUID!) {
  getLeaguesBySchoolId(schoolId: $schoolId) {
    id
    name
    displayName
    state
    competitionModel
    competitionGroup
    teamFormat
    esport {
      id
      slug
      name
      rating
    }
  }
}
    `;

/**
 * __useGetExploreLeaguesQuery__
 *
 * To run a query within a React component, call `useGetExploreLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExploreLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExploreLeaguesQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetExploreLeaguesQuery(baseOptions: Apollo.QueryHookOptions<GetExploreLeaguesQuery, GetExploreLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExploreLeaguesQuery, GetExploreLeaguesQueryVariables>(GetExploreLeaguesDocument, options);
      }
export function useGetExploreLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExploreLeaguesQuery, GetExploreLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExploreLeaguesQuery, GetExploreLeaguesQueryVariables>(GetExploreLeaguesDocument, options);
        }
export type GetExploreLeaguesQueryHookResult = ReturnType<typeof useGetExploreLeaguesQuery>;
export type GetExploreLeaguesLazyQueryHookResult = ReturnType<typeof useGetExploreLeaguesLazyQuery>;
export type GetExploreLeaguesQueryResult = Apollo.QueryResult<GetExploreLeaguesQuery, GetExploreLeaguesQueryVariables>;
export function refetchGetExploreLeaguesQuery(variables: GetExploreLeaguesQueryVariables) {
      return { query: GetExploreLeaguesDocument, variables: variables }
    }
export const AllLeagueGroupsDocument = gql`
    query allLeagueGroups($limit: Int, $offset: Int, $filters: LeagueGroupFiltersInput) {
  getAllLeagueGroups(limit: $limit, offset: $offset, filters: $filters) {
    result {
      id
      name
      state
      competitionGroup
      varsityAssociation {
        slug
        name
      }
      leagues {
        id
        name
        competitionModel
      }
    }
    total
  }
}
    `;

/**
 * __useAllLeagueGroupsQuery__
 *
 * To run a query within a React component, call `useAllLeagueGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLeagueGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLeagueGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAllLeagueGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AllLeagueGroupsQuery, AllLeagueGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLeagueGroupsQuery, AllLeagueGroupsQueryVariables>(AllLeagueGroupsDocument, options);
      }
export function useAllLeagueGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLeagueGroupsQuery, AllLeagueGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLeagueGroupsQuery, AllLeagueGroupsQueryVariables>(AllLeagueGroupsDocument, options);
        }
export type AllLeagueGroupsQueryHookResult = ReturnType<typeof useAllLeagueGroupsQuery>;
export type AllLeagueGroupsLazyQueryHookResult = ReturnType<typeof useAllLeagueGroupsLazyQuery>;
export type AllLeagueGroupsQueryResult = Apollo.QueryResult<AllLeagueGroupsQuery, AllLeagueGroupsQueryVariables>;
export function refetchAllLeagueGroupsQuery(variables?: AllLeagueGroupsQueryVariables) {
      return { query: AllLeagueGroupsDocument, variables: variables }
    }
export const GetLeagueGroupDocument = gql`
    query getLeagueGroup($id: UUID!, $filters: LeagueFiltersInput) {
  leagueGroup(id: $id, filters: $filters) {
    id
    name
    state
    competitionGroup
    varsityAssociation {
      slug
      name
    }
    leagues {
      id
      name
      competitionModel
      isHidden
      varsityAssociation {
        name
        slug
      }
      esport {
        id
        slug
        name
      }
    }
  }
}
    `;

/**
 * __useGetLeagueGroupQuery__
 *
 * To run a query within a React component, call `useGetLeagueGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetLeagueGroupQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueGroupQuery, GetLeagueGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueGroupQuery, GetLeagueGroupQueryVariables>(GetLeagueGroupDocument, options);
      }
export function useGetLeagueGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueGroupQuery, GetLeagueGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueGroupQuery, GetLeagueGroupQueryVariables>(GetLeagueGroupDocument, options);
        }
export type GetLeagueGroupQueryHookResult = ReturnType<typeof useGetLeagueGroupQuery>;
export type GetLeagueGroupLazyQueryHookResult = ReturnType<typeof useGetLeagueGroupLazyQuery>;
export type GetLeagueGroupQueryResult = Apollo.QueryResult<GetLeagueGroupQuery, GetLeagueGroupQueryVariables>;
export function refetchGetLeagueGroupQuery(variables: GetLeagueGroupQueryVariables) {
      return { query: GetLeagueGroupDocument, variables: variables }
    }
export const GetVaLeagueGroupsDocument = gql`
    query getVaLeagueGroups($filters: LeagueGroupFiltersInput, $offset: Int, $limit: Int) {
  getAllLeagueGroups(filters: $filters, offset: $offset, limit: $limit) {
    result {
      id
      name
      state
    }
    total
  }
}
    `;

/**
 * __useGetVaLeagueGroupsQuery__
 *
 * To run a query within a React component, call `useGetVaLeagueGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVaLeagueGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVaLeagueGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetVaLeagueGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetVaLeagueGroupsQuery, GetVaLeagueGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVaLeagueGroupsQuery, GetVaLeagueGroupsQueryVariables>(GetVaLeagueGroupsDocument, options);
      }
export function useGetVaLeagueGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVaLeagueGroupsQuery, GetVaLeagueGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVaLeagueGroupsQuery, GetVaLeagueGroupsQueryVariables>(GetVaLeagueGroupsDocument, options);
        }
export type GetVaLeagueGroupsQueryHookResult = ReturnType<typeof useGetVaLeagueGroupsQuery>;
export type GetVaLeagueGroupsLazyQueryHookResult = ReturnType<typeof useGetVaLeagueGroupsLazyQuery>;
export type GetVaLeagueGroupsQueryResult = Apollo.QueryResult<GetVaLeagueGroupsQuery, GetVaLeagueGroupsQueryVariables>;
export function refetchGetVaLeagueGroupsQuery(variables?: GetVaLeagueGroupsQueryVariables) {
      return { query: GetVaLeagueGroupsDocument, variables: variables }
    }
export const GetLeagueLeagueGroupsDocument = gql`
    query getLeagueLeagueGroups($filters: LeagueGroupFiltersInput, $offset: Int, $limit: Int) {
  getAllLeagueGroups(filters: $filters, offset: $offset, limit: $limit) {
    result {
      id
      name
      state
    }
    total
  }
}
    `;

/**
 * __useGetLeagueLeagueGroupsQuery__
 *
 * To run a query within a React component, call `useGetLeagueLeagueGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueLeagueGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueLeagueGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetLeagueLeagueGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeagueLeagueGroupsQuery, GetLeagueLeagueGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueLeagueGroupsQuery, GetLeagueLeagueGroupsQueryVariables>(GetLeagueLeagueGroupsDocument, options);
      }
export function useGetLeagueLeagueGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueLeagueGroupsQuery, GetLeagueLeagueGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueLeagueGroupsQuery, GetLeagueLeagueGroupsQueryVariables>(GetLeagueLeagueGroupsDocument, options);
        }
export type GetLeagueLeagueGroupsQueryHookResult = ReturnType<typeof useGetLeagueLeagueGroupsQuery>;
export type GetLeagueLeagueGroupsLazyQueryHookResult = ReturnType<typeof useGetLeagueLeagueGroupsLazyQuery>;
export type GetLeagueLeagueGroupsQueryResult = Apollo.QueryResult<GetLeagueLeagueGroupsQuery, GetLeagueLeagueGroupsQueryVariables>;
export function refetchGetLeagueLeagueGroupsQuery(variables?: GetLeagueLeagueGroupsQueryVariables) {
      return { query: GetLeagueLeagueGroupsDocument, variables: variables }
    }
export const CreateLeagueGroupDocument = gql`
    mutation createLeagueGroup($input: CreateLeagueGroupInput!) {
  createLeagueGroup(input: $input) {
    leagueGroup {
      id
    }
  }
}
    `;
export type CreateLeagueGroupMutationFn = Apollo.MutationFunction<CreateLeagueGroupMutation, CreateLeagueGroupMutationVariables>;

/**
 * __useCreateLeagueGroupMutation__
 *
 * To run a mutation, you first call `useCreateLeagueGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeagueGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeagueGroupMutation, { data, loading, error }] = useCreateLeagueGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeagueGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeagueGroupMutation, CreateLeagueGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeagueGroupMutation, CreateLeagueGroupMutationVariables>(CreateLeagueGroupDocument, options);
      }
export type CreateLeagueGroupMutationHookResult = ReturnType<typeof useCreateLeagueGroupMutation>;
export type CreateLeagueGroupMutationResult = Apollo.MutationResult<CreateLeagueGroupMutation>;
export type CreateLeagueGroupMutationOptions = Apollo.BaseMutationOptions<CreateLeagueGroupMutation, CreateLeagueGroupMutationVariables>;
export const UpdateLeagueGroupDocument = gql`
    mutation updateLeagueGroup($id: UUID!, $attributes: UpdateLeagueGroupInput!) {
  updateLeagueGroup(id: $id, attributes: $attributes) {
    id
    name
    state
    competitionGroup
  }
}
    `;
export type UpdateLeagueGroupMutationFn = Apollo.MutationFunction<UpdateLeagueGroupMutation, UpdateLeagueGroupMutationVariables>;

/**
 * __useUpdateLeagueGroupMutation__
 *
 * To run a mutation, you first call `useUpdateLeagueGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeagueGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeagueGroupMutation, { data, loading, error }] = useUpdateLeagueGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateLeagueGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeagueGroupMutation, UpdateLeagueGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeagueGroupMutation, UpdateLeagueGroupMutationVariables>(UpdateLeagueGroupDocument, options);
      }
export type UpdateLeagueGroupMutationHookResult = ReturnType<typeof useUpdateLeagueGroupMutation>;
export type UpdateLeagueGroupMutationResult = Apollo.MutationResult<UpdateLeagueGroupMutation>;
export type UpdateLeagueGroupMutationOptions = Apollo.BaseMutationOptions<UpdateLeagueGroupMutation, UpdateLeagueGroupMutationVariables>;
export const RemoveLeagueFromLeagueGroupDocument = gql`
    mutation removeLeagueFromLeagueGroup($leagueGroupId: UUID!, $leagueId: UUID!) {
  removeLeagueFromLeagueGroup(leagueGroupId: $leagueGroupId, leagueId: $leagueId) {
    success
    leagueId
    leagueGroupId
  }
}
    `;
export type RemoveLeagueFromLeagueGroupMutationFn = Apollo.MutationFunction<RemoveLeagueFromLeagueGroupMutation, RemoveLeagueFromLeagueGroupMutationVariables>;

/**
 * __useRemoveLeagueFromLeagueGroupMutation__
 *
 * To run a mutation, you first call `useRemoveLeagueFromLeagueGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLeagueFromLeagueGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLeagueFromLeagueGroupMutation, { data, loading, error }] = useRemoveLeagueFromLeagueGroupMutation({
 *   variables: {
 *      leagueGroupId: // value for 'leagueGroupId'
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useRemoveLeagueFromLeagueGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLeagueFromLeagueGroupMutation, RemoveLeagueFromLeagueGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLeagueFromLeagueGroupMutation, RemoveLeagueFromLeagueGroupMutationVariables>(RemoveLeagueFromLeagueGroupDocument, options);
      }
export type RemoveLeagueFromLeagueGroupMutationHookResult = ReturnType<typeof useRemoveLeagueFromLeagueGroupMutation>;
export type RemoveLeagueFromLeagueGroupMutationResult = Apollo.MutationResult<RemoveLeagueFromLeagueGroupMutation>;
export type RemoveLeagueFromLeagueGroupMutationOptions = Apollo.BaseMutationOptions<RemoveLeagueFromLeagueGroupMutation, RemoveLeagueFromLeagueGroupMutationVariables>;
export const AddLeagueToLeagueGroupDocument = gql`
    mutation addLeagueToLeagueGroup($leagueGroupId: UUID!, $leagueId: UUID!) {
  addLeagueToLeagueGroup(leagueGroupId: $leagueGroupId, leagueId: $leagueId) {
    success
    leagueId
    leagueGroupId
  }
}
    `;
export type AddLeagueToLeagueGroupMutationFn = Apollo.MutationFunction<AddLeagueToLeagueGroupMutation, AddLeagueToLeagueGroupMutationVariables>;

/**
 * __useAddLeagueToLeagueGroupMutation__
 *
 * To run a mutation, you first call `useAddLeagueToLeagueGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLeagueToLeagueGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLeagueToLeagueGroupMutation, { data, loading, error }] = useAddLeagueToLeagueGroupMutation({
 *   variables: {
 *      leagueGroupId: // value for 'leagueGroupId'
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useAddLeagueToLeagueGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddLeagueToLeagueGroupMutation, AddLeagueToLeagueGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLeagueToLeagueGroupMutation, AddLeagueToLeagueGroupMutationVariables>(AddLeagueToLeagueGroupDocument, options);
      }
export type AddLeagueToLeagueGroupMutationHookResult = ReturnType<typeof useAddLeagueToLeagueGroupMutation>;
export type AddLeagueToLeagueGroupMutationResult = Apollo.MutationResult<AddLeagueToLeagueGroupMutation>;
export type AddLeagueToLeagueGroupMutationOptions = Apollo.BaseMutationOptions<AddLeagueToLeagueGroupMutation, AddLeagueToLeagueGroupMutationVariables>;
export const UpdateLeagueDetailsDocument = gql`
    mutation updateLeagueDetails($input: UpdateLeagueInput!) {
  updateLeague(input: $input) {
    league {
      id
      name
    }
  }
}
    `;
export type UpdateLeagueDetailsMutationFn = Apollo.MutationFunction<UpdateLeagueDetailsMutation, UpdateLeagueDetailsMutationVariables>;

/**
 * __useUpdateLeagueDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateLeagueDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeagueDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeagueDetailsMutation, { data, loading, error }] = useUpdateLeagueDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLeagueDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeagueDetailsMutation, UpdateLeagueDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeagueDetailsMutation, UpdateLeagueDetailsMutationVariables>(UpdateLeagueDetailsDocument, options);
      }
export type UpdateLeagueDetailsMutationHookResult = ReturnType<typeof useUpdateLeagueDetailsMutation>;
export type UpdateLeagueDetailsMutationResult = Apollo.MutationResult<UpdateLeagueDetailsMutation>;
export type UpdateLeagueDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateLeagueDetailsMutation, UpdateLeagueDetailsMutationVariables>;
export const GetLeagueScheduleSeasonsDocument = gql`
    query getLeagueScheduleSeasons($leagueId: UUID!) {
  league(id: $leagueId) {
    id
    seasons {
      id
      name
      metaseasonId
    }
  }
}
    `;

/**
 * __useGetLeagueScheduleSeasonsQuery__
 *
 * To run a query within a React component, call `useGetLeagueScheduleSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueScheduleSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueScheduleSeasonsQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useGetLeagueScheduleSeasonsQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueScheduleSeasonsQuery, GetLeagueScheduleSeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueScheduleSeasonsQuery, GetLeagueScheduleSeasonsQueryVariables>(GetLeagueScheduleSeasonsDocument, options);
      }
export function useGetLeagueScheduleSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueScheduleSeasonsQuery, GetLeagueScheduleSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueScheduleSeasonsQuery, GetLeagueScheduleSeasonsQueryVariables>(GetLeagueScheduleSeasonsDocument, options);
        }
export type GetLeagueScheduleSeasonsQueryHookResult = ReturnType<typeof useGetLeagueScheduleSeasonsQuery>;
export type GetLeagueScheduleSeasonsLazyQueryHookResult = ReturnType<typeof useGetLeagueScheduleSeasonsLazyQuery>;
export type GetLeagueScheduleSeasonsQueryResult = Apollo.QueryResult<GetLeagueScheduleSeasonsQuery, GetLeagueScheduleSeasonsQueryVariables>;
export function refetchGetLeagueScheduleSeasonsQuery(variables: GetLeagueScheduleSeasonsQueryVariables) {
      return { query: GetLeagueScheduleSeasonsDocument, variables: variables }
    }
export const GetLeagueSeasonsForFilterDocument = gql`
    query getLeagueSeasonsForFilter($leagueId: UUID!) {
  league(id: $leagueId) {
    id
    seasons {
      id
      name
      status
      metaseason {
        id
        name
        startsAt
        endsAt
        isPromoted
      }
    }
  }
}
    `;

/**
 * __useGetLeagueSeasonsForFilterQuery__
 *
 * To run a query within a React component, call `useGetLeagueSeasonsForFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueSeasonsForFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueSeasonsForFilterQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useGetLeagueSeasonsForFilterQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueSeasonsForFilterQuery, GetLeagueSeasonsForFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueSeasonsForFilterQuery, GetLeagueSeasonsForFilterQueryVariables>(GetLeagueSeasonsForFilterDocument, options);
      }
export function useGetLeagueSeasonsForFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueSeasonsForFilterQuery, GetLeagueSeasonsForFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueSeasonsForFilterQuery, GetLeagueSeasonsForFilterQueryVariables>(GetLeagueSeasonsForFilterDocument, options);
        }
export type GetLeagueSeasonsForFilterQueryHookResult = ReturnType<typeof useGetLeagueSeasonsForFilterQuery>;
export type GetLeagueSeasonsForFilterLazyQueryHookResult = ReturnType<typeof useGetLeagueSeasonsForFilterLazyQuery>;
export type GetLeagueSeasonsForFilterQueryResult = Apollo.QueryResult<GetLeagueSeasonsForFilterQuery, GetLeagueSeasonsForFilterQueryVariables>;
export function refetchGetLeagueSeasonsForFilterQuery(variables: GetLeagueSeasonsForFilterQueryVariables) {
      return { query: GetLeagueSeasonsForFilterDocument, variables: variables }
    }
export const GetLeagueSeasonsDocument = gql`
    query getLeagueSeasons($leagueId: UUID!) {
  metaseasons {
    id
    name
    competitionGroup
  }
  league(id: $leagueId) {
    id
    name
    timezone
    competitionGroup
    esport {
      id
      slug
    }
    allSeasons {
      id
      name
      metaseasonId
      registrationStartsAt
      suggestedRegistrationEndsAt
      teamRegistrationEndsAt
      suggestedRegistrationEndsAt
      startsAt
      endsAt
      status
    }
  }
}
    `;

/**
 * __useGetLeagueSeasonsQuery__
 *
 * To run a query within a React component, call `useGetLeagueSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueSeasonsQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useGetLeagueSeasonsQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueSeasonsQuery, GetLeagueSeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueSeasonsQuery, GetLeagueSeasonsQueryVariables>(GetLeagueSeasonsDocument, options);
      }
export function useGetLeagueSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueSeasonsQuery, GetLeagueSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueSeasonsQuery, GetLeagueSeasonsQueryVariables>(GetLeagueSeasonsDocument, options);
        }
export type GetLeagueSeasonsQueryHookResult = ReturnType<typeof useGetLeagueSeasonsQuery>;
export type GetLeagueSeasonsLazyQueryHookResult = ReturnType<typeof useGetLeagueSeasonsLazyQuery>;
export type GetLeagueSeasonsQueryResult = Apollo.QueryResult<GetLeagueSeasonsQuery, GetLeagueSeasonsQueryVariables>;
export function refetchGetLeagueSeasonsQuery(variables: GetLeagueSeasonsQueryVariables) {
      return { query: GetLeagueSeasonsDocument, variables: variables }
    }
export const GetLeagueSeasonDocument = gql`
    query getLeagueSeason($seasonId: UUID!) {
  season(id: $seasonId) {
    id
    metaseason {
      id
      name
      startsAt
      endsAt
    }
    allPhases {
      id
      fortniteEventId
      bestOf
      bracketSize
      format
      name
      startsAt
      endsAt
      status
      type
      teams {
        id
        seed
        name
      }
      slots {
        id
        fortniteEventWindowId
        name
        order
        scheduleMatchesAt
        startsAt
        isStartsAtHidden
        status
        ordinal
        label
      }
    }
  }
}
    `;

/**
 * __useGetLeagueSeasonQuery__
 *
 * To run a query within a React component, call `useGetLeagueSeasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueSeasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueSeasonQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useGetLeagueSeasonQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueSeasonQuery, GetLeagueSeasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueSeasonQuery, GetLeagueSeasonQueryVariables>(GetLeagueSeasonDocument, options);
      }
export function useGetLeagueSeasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueSeasonQuery, GetLeagueSeasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueSeasonQuery, GetLeagueSeasonQueryVariables>(GetLeagueSeasonDocument, options);
        }
export type GetLeagueSeasonQueryHookResult = ReturnType<typeof useGetLeagueSeasonQuery>;
export type GetLeagueSeasonLazyQueryHookResult = ReturnType<typeof useGetLeagueSeasonLazyQuery>;
export type GetLeagueSeasonQueryResult = Apollo.QueryResult<GetLeagueSeasonQuery, GetLeagueSeasonQueryVariables>;
export function refetchGetLeagueSeasonQuery(variables: GetLeagueSeasonQueryVariables) {
      return { query: GetLeagueSeasonDocument, variables: variables }
    }
export const GetLeaguePageDocument = gql`
    query getLeaguePage($leagueId: UUID!) {
  league(id: $leagueId) {
    id
    name
    state
    timezone
    competitionGroup
    esport {
      id
      name
      slug
    }
    seasons {
      id
      name
      startsAt
      endsAt
      metaseason {
        id
        isPromoted
        name
        startsAt
        endsAt
      }
    }
    sponsorshipComponents {
      id
      entityId
      entityType
      name
      title
      subtitle
      url
      callToAction
      sponsorshipImages {
        id
        entityId
        entityType
        name
        updatedAt
        url
      }
    }
  }
}
    `;

/**
 * __useGetLeaguePageQuery__
 *
 * To run a query within a React component, call `useGetLeaguePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaguePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaguePageQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useGetLeaguePageQuery(baseOptions: Apollo.QueryHookOptions<GetLeaguePageQuery, GetLeaguePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaguePageQuery, GetLeaguePageQueryVariables>(GetLeaguePageDocument, options);
      }
export function useGetLeaguePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaguePageQuery, GetLeaguePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaguePageQuery, GetLeaguePageQueryVariables>(GetLeaguePageDocument, options);
        }
export type GetLeaguePageQueryHookResult = ReturnType<typeof useGetLeaguePageQuery>;
export type GetLeaguePageLazyQueryHookResult = ReturnType<typeof useGetLeaguePageLazyQuery>;
export type GetLeaguePageQueryResult = Apollo.QueryResult<GetLeaguePageQuery, GetLeaguePageQueryVariables>;
export function refetchGetLeaguePageQuery(variables: GetLeaguePageQueryVariables) {
      return { query: GetLeaguePageDocument, variables: variables }
    }
export const GetLeagueSeasonByMetaseasonIdDocument = gql`
    query getLeagueSeasonByMetaseasonId($leagueId: UUID!, $metaseasonId: UUID!) {
  league(id: $leagueId) {
    id
    seasonByMetaseasonId(metaseasonId: $metaseasonId) {
      id
      numberOfTeams
      numberOfPendingTeams
      numberOfTeamsByStates {
        state
        teamCount
      }
      numberOfTeamsByVarsityAssociations {
        varsityAssociation {
          slug
          abbreviation
          name
        }
        teamCount
      }
    }
  }
}
    `;

/**
 * __useGetLeagueSeasonByMetaseasonIdQuery__
 *
 * To run a query within a React component, call `useGetLeagueSeasonByMetaseasonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueSeasonByMetaseasonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueSeasonByMetaseasonIdQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetLeagueSeasonByMetaseasonIdQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueSeasonByMetaseasonIdQuery, GetLeagueSeasonByMetaseasonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueSeasonByMetaseasonIdQuery, GetLeagueSeasonByMetaseasonIdQueryVariables>(GetLeagueSeasonByMetaseasonIdDocument, options);
      }
export function useGetLeagueSeasonByMetaseasonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueSeasonByMetaseasonIdQuery, GetLeagueSeasonByMetaseasonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueSeasonByMetaseasonIdQuery, GetLeagueSeasonByMetaseasonIdQueryVariables>(GetLeagueSeasonByMetaseasonIdDocument, options);
        }
export type GetLeagueSeasonByMetaseasonIdQueryHookResult = ReturnType<typeof useGetLeagueSeasonByMetaseasonIdQuery>;
export type GetLeagueSeasonByMetaseasonIdLazyQueryHookResult = ReturnType<typeof useGetLeagueSeasonByMetaseasonIdLazyQuery>;
export type GetLeagueSeasonByMetaseasonIdQueryResult = Apollo.QueryResult<GetLeagueSeasonByMetaseasonIdQuery, GetLeagueSeasonByMetaseasonIdQueryVariables>;
export function refetchGetLeagueSeasonByMetaseasonIdQuery(variables: GetLeagueSeasonByMetaseasonIdQueryVariables) {
      return { query: GetLeagueSeasonByMetaseasonIdDocument, variables: variables }
    }
export const GetLeaguesDetailsByMetaseasonIdDocument = gql`
    query getLeaguesDetailsByMetaseasonId($limit: Int, $offset: Int, $filters: LeagueFilters!, $metaseasonId: UUID!) {
  getAllLeagues(limit: $limit, offset: $offset, filters: $filters) {
    total
    result {
      id
      name
      displayName
      state
      esport {
        id
        name
        slug
      }
      teams(metaseasonId: $metaseasonId) {
        id
        esport {
          leagueDefaults {
            teamFormat
          }
        }
        roster {
          numPlayers
          isFull
          maxNumPlayers
        }
        school {
          id
          state
          varsityAssociations {
            slug
            name
          }
        }
      }
      varsityAssociation {
        name
      }
      seasonByMetaseasonId(metaseasonId: $metaseasonId) {
        id
        numberOfTeams
        numberOfTeamsByStates {
          state
          teamCount
        }
        numberOfTeamsByVarsityAssociations {
          varsityAssociation {
            slug
            abbreviation
            name
          }
          teamCount
        }
      }
    }
  }
}
    `;

/**
 * __useGetLeaguesDetailsByMetaseasonIdQuery__
 *
 * To run a query within a React component, call `useGetLeaguesDetailsByMetaseasonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaguesDetailsByMetaseasonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaguesDetailsByMetaseasonIdQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetLeaguesDetailsByMetaseasonIdQuery(baseOptions: Apollo.QueryHookOptions<GetLeaguesDetailsByMetaseasonIdQuery, GetLeaguesDetailsByMetaseasonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaguesDetailsByMetaseasonIdQuery, GetLeaguesDetailsByMetaseasonIdQueryVariables>(GetLeaguesDetailsByMetaseasonIdDocument, options);
      }
export function useGetLeaguesDetailsByMetaseasonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaguesDetailsByMetaseasonIdQuery, GetLeaguesDetailsByMetaseasonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaguesDetailsByMetaseasonIdQuery, GetLeaguesDetailsByMetaseasonIdQueryVariables>(GetLeaguesDetailsByMetaseasonIdDocument, options);
        }
export type GetLeaguesDetailsByMetaseasonIdQueryHookResult = ReturnType<typeof useGetLeaguesDetailsByMetaseasonIdQuery>;
export type GetLeaguesDetailsByMetaseasonIdLazyQueryHookResult = ReturnType<typeof useGetLeaguesDetailsByMetaseasonIdLazyQuery>;
export type GetLeaguesDetailsByMetaseasonIdQueryResult = Apollo.QueryResult<GetLeaguesDetailsByMetaseasonIdQuery, GetLeaguesDetailsByMetaseasonIdQueryVariables>;
export function refetchGetLeaguesDetailsByMetaseasonIdQuery(variables: GetLeaguesDetailsByMetaseasonIdQueryVariables) {
      return { query: GetLeaguesDetailsByMetaseasonIdDocument, variables: variables }
    }
export const GetSeasonForLeagueFilterDocument = gql`
    query getSeasonForLeagueFilter($leagueId: UUID!, $metaseasonId: UUID!) {
  league(id: $leagueId) {
    id
    seasonByMetaseasonId(metaseasonId: $metaseasonId) {
      id
      name
      rostersLockAt
      teamRegistrationEndsAt
      phases {
        id
        startsAt
        endsAt
        name
        type
        seasonId
        slug
        status
        format
        survivalAdvancementCount
        survivalAdvancementPercentage
      }
    }
  }
}
    `;

/**
 * __useGetSeasonForLeagueFilterQuery__
 *
 * To run a query within a React component, call `useGetSeasonForLeagueFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonForLeagueFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonForLeagueFilterQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetSeasonForLeagueFilterQuery(baseOptions: Apollo.QueryHookOptions<GetSeasonForLeagueFilterQuery, GetSeasonForLeagueFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeasonForLeagueFilterQuery, GetSeasonForLeagueFilterQueryVariables>(GetSeasonForLeagueFilterDocument, options);
      }
export function useGetSeasonForLeagueFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeasonForLeagueFilterQuery, GetSeasonForLeagueFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeasonForLeagueFilterQuery, GetSeasonForLeagueFilterQueryVariables>(GetSeasonForLeagueFilterDocument, options);
        }
export type GetSeasonForLeagueFilterQueryHookResult = ReturnType<typeof useGetSeasonForLeagueFilterQuery>;
export type GetSeasonForLeagueFilterLazyQueryHookResult = ReturnType<typeof useGetSeasonForLeagueFilterLazyQuery>;
export type GetSeasonForLeagueFilterQueryResult = Apollo.QueryResult<GetSeasonForLeagueFilterQuery, GetSeasonForLeagueFilterQueryVariables>;
export function refetchGetSeasonForLeagueFilterQuery(variables: GetSeasonForLeagueFilterQueryVariables) {
      return { query: GetSeasonForLeagueFilterDocument, variables: variables }
    }
export const GetLeaguePhasesForStandingsDocument = gql`
    query getLeaguePhasesForStandings($leagueId: UUID!) {
  league(id: $leagueId) {
    id
    seasons {
      id
      metaseasonId
      metaseason {
        id
        name
        startsAt
        endsAt
        isInitialMetaseason
        competitionGroup
      }
      phases {
        id
        name
        startsAt
        endsAt
        type
        slug
        format
      }
    }
  }
}
    `;

/**
 * __useGetLeaguePhasesForStandingsQuery__
 *
 * To run a query within a React component, call `useGetLeaguePhasesForStandingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaguePhasesForStandingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaguePhasesForStandingsQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useGetLeaguePhasesForStandingsQuery(baseOptions: Apollo.QueryHookOptions<GetLeaguePhasesForStandingsQuery, GetLeaguePhasesForStandingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaguePhasesForStandingsQuery, GetLeaguePhasesForStandingsQueryVariables>(GetLeaguePhasesForStandingsDocument, options);
      }
export function useGetLeaguePhasesForStandingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaguePhasesForStandingsQuery, GetLeaguePhasesForStandingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaguePhasesForStandingsQuery, GetLeaguePhasesForStandingsQueryVariables>(GetLeaguePhasesForStandingsDocument, options);
        }
export type GetLeaguePhasesForStandingsQueryHookResult = ReturnType<typeof useGetLeaguePhasesForStandingsQuery>;
export type GetLeaguePhasesForStandingsLazyQueryHookResult = ReturnType<typeof useGetLeaguePhasesForStandingsLazyQuery>;
export type GetLeaguePhasesForStandingsQueryResult = Apollo.QueryResult<GetLeaguePhasesForStandingsQuery, GetLeaguePhasesForStandingsQueryVariables>;
export function refetchGetLeaguePhasesForStandingsQuery(variables: GetLeaguePhasesForStandingsQueryVariables) {
      return { query: GetLeaguePhasesForStandingsDocument, variables: variables }
    }
export const GetLeagueBySlugDocument = gql`
    query getLeagueBySlug($slug: String!) {
  leagueBySlug(slug: $slug) {
    id
    name
    displayName
    esport {
      id
      name
      slug
    }
    seasons {
      id
      name
      startsAt
      endsAt
      phases {
        id
        name
        type
        startsAt
        endsAt
        format
        teams {
          id
          name
          seed
          school {
            id
            logoUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLeagueBySlugQuery__
 *
 * To run a query within a React component, call `useGetLeagueBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetLeagueBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueBySlugQuery, GetLeagueBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueBySlugQuery, GetLeagueBySlugQueryVariables>(GetLeagueBySlugDocument, options);
      }
export function useGetLeagueBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueBySlugQuery, GetLeagueBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueBySlugQuery, GetLeagueBySlugQueryVariables>(GetLeagueBySlugDocument, options);
        }
export type GetLeagueBySlugQueryHookResult = ReturnType<typeof useGetLeagueBySlugQuery>;
export type GetLeagueBySlugLazyQueryHookResult = ReturnType<typeof useGetLeagueBySlugLazyQuery>;
export type GetLeagueBySlugQueryResult = Apollo.QueryResult<GetLeagueBySlugQuery, GetLeagueBySlugQueryVariables>;
export function refetchGetLeagueBySlugQuery(variables: GetLeagueBySlugQueryVariables) {
      return { query: GetLeagueBySlugDocument, variables: variables }
    }
export const InactivateLeaguesForMetaseasonDocument = gql`
    mutation inactivateLeaguesForMetaseason($leagueIds: [UUID!], $metaseasonId: UUID!) {
  setLeaguesInactiveForMetaseason(
    leagueIds: $leagueIds
    metaseasonId: $metaseasonId
  ) {
    success
  }
}
    `;
export type InactivateLeaguesForMetaseasonMutationFn = Apollo.MutationFunction<InactivateLeaguesForMetaseasonMutation, InactivateLeaguesForMetaseasonMutationVariables>;

/**
 * __useInactivateLeaguesForMetaseasonMutation__
 *
 * To run a mutation, you first call `useInactivateLeaguesForMetaseasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivateLeaguesForMetaseasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivateLeaguesForMetaseasonMutation, { data, loading, error }] = useInactivateLeaguesForMetaseasonMutation({
 *   variables: {
 *      leagueIds: // value for 'leagueIds'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useInactivateLeaguesForMetaseasonMutation(baseOptions?: Apollo.MutationHookOptions<InactivateLeaguesForMetaseasonMutation, InactivateLeaguesForMetaseasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InactivateLeaguesForMetaseasonMutation, InactivateLeaguesForMetaseasonMutationVariables>(InactivateLeaguesForMetaseasonDocument, options);
      }
export type InactivateLeaguesForMetaseasonMutationHookResult = ReturnType<typeof useInactivateLeaguesForMetaseasonMutation>;
export type InactivateLeaguesForMetaseasonMutationResult = Apollo.MutationResult<InactivateLeaguesForMetaseasonMutation>;
export type InactivateLeaguesForMetaseasonMutationOptions = Apollo.BaseMutationOptions<InactivateLeaguesForMetaseasonMutation, InactivateLeaguesForMetaseasonMutationVariables>;
export const ActivateLeaguesForMetaseasonDocument = gql`
    mutation activateLeaguesForMetaseason($leagueIds: [UUID!]!, $metaseasonId: UUID!) {
  setLeaguesActiveForMetaseason(
    leagueIds: $leagueIds
    metaseasonId: $metaseasonId
  ) {
    success
    leagueIds
  }
}
    `;
export type ActivateLeaguesForMetaseasonMutationFn = Apollo.MutationFunction<ActivateLeaguesForMetaseasonMutation, ActivateLeaguesForMetaseasonMutationVariables>;

/**
 * __useActivateLeaguesForMetaseasonMutation__
 *
 * To run a mutation, you first call `useActivateLeaguesForMetaseasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateLeaguesForMetaseasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateLeaguesForMetaseasonMutation, { data, loading, error }] = useActivateLeaguesForMetaseasonMutation({
 *   variables: {
 *      leagueIds: // value for 'leagueIds'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useActivateLeaguesForMetaseasonMutation(baseOptions?: Apollo.MutationHookOptions<ActivateLeaguesForMetaseasonMutation, ActivateLeaguesForMetaseasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateLeaguesForMetaseasonMutation, ActivateLeaguesForMetaseasonMutationVariables>(ActivateLeaguesForMetaseasonDocument, options);
      }
export type ActivateLeaguesForMetaseasonMutationHookResult = ReturnType<typeof useActivateLeaguesForMetaseasonMutation>;
export type ActivateLeaguesForMetaseasonMutationResult = Apollo.MutationResult<ActivateLeaguesForMetaseasonMutation>;
export type ActivateLeaguesForMetaseasonMutationOptions = Apollo.BaseMutationOptions<ActivateLeaguesForMetaseasonMutation, ActivateLeaguesForMetaseasonMutationVariables>;
export const CreateLeagueDocument = gql`
    mutation createLeague($input: CreateLeagueInput!) {
  createLeague(input: $input) {
    league {
      id
    }
  }
}
    `;
export type CreateLeagueMutationFn = Apollo.MutationFunction<CreateLeagueMutation, CreateLeagueMutationVariables>;

/**
 * __useCreateLeagueMutation__
 *
 * To run a mutation, you first call `useCreateLeagueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeagueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeagueMutation, { data, loading, error }] = useCreateLeagueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLeagueMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeagueMutation, CreateLeagueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeagueMutation, CreateLeagueMutationVariables>(CreateLeagueDocument, options);
      }
export type CreateLeagueMutationHookResult = ReturnType<typeof useCreateLeagueMutation>;
export type CreateLeagueMutationResult = Apollo.MutationResult<CreateLeagueMutation>;
export type CreateLeagueMutationOptions = Apollo.BaseMutationOptions<CreateLeagueMutation, CreateLeagueMutationVariables>;
export const GetLeagueDetailsDocument = gql`
    query getLeagueDetails($id: UUID!) {
  league(id: $id) {
    id
    name
    displayName
    timezone
    teamFormat
    teamMaxSize
    competitionGroup
    competitionModel
    varsityAssociation {
      name
      slug
    }
    allSeasons {
      id
    }
    state
    canRemovePlayersFromTeams
    canHaveMultipleTeamsWithSamePlayers
    isHidden
    isCheckInEnabled
    checkInOpenDaysBefore
    checkInOpenTime
    checkInCloseTimeOffsetMilliseconds
    type
    publicSlug
  }
}
    `;

/**
 * __useGetLeagueDetailsQuery__
 *
 * To run a query within a React component, call `useGetLeagueDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeagueDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueDetailsQuery, GetLeagueDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueDetailsQuery, GetLeagueDetailsQueryVariables>(GetLeagueDetailsDocument, options);
      }
export function useGetLeagueDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueDetailsQuery, GetLeagueDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueDetailsQuery, GetLeagueDetailsQueryVariables>(GetLeagueDetailsDocument, options);
        }
export type GetLeagueDetailsQueryHookResult = ReturnType<typeof useGetLeagueDetailsQuery>;
export type GetLeagueDetailsLazyQueryHookResult = ReturnType<typeof useGetLeagueDetailsLazyQuery>;
export type GetLeagueDetailsQueryResult = Apollo.QueryResult<GetLeagueDetailsQuery, GetLeagueDetailsQueryVariables>;
export function refetchGetLeagueDetailsQuery(variables: GetLeagueDetailsQueryVariables) {
      return { query: GetLeagueDetailsDocument, variables: variables }
    }
export const GetLeagueMetaseasonsDocument = gql`
    query getLeagueMetaseasons {
  metaseasons {
    id
    name
    isPromoted
    startsAt
  }
}
    `;

/**
 * __useGetLeagueMetaseasonsQuery__
 *
 * To run a query within a React component, call `useGetLeagueMetaseasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueMetaseasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueMetaseasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLeagueMetaseasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeagueMetaseasonsQuery, GetLeagueMetaseasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueMetaseasonsQuery, GetLeagueMetaseasonsQueryVariables>(GetLeagueMetaseasonsDocument, options);
      }
export function useGetLeagueMetaseasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueMetaseasonsQuery, GetLeagueMetaseasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueMetaseasonsQuery, GetLeagueMetaseasonsQueryVariables>(GetLeagueMetaseasonsDocument, options);
        }
export type GetLeagueMetaseasonsQueryHookResult = ReturnType<typeof useGetLeagueMetaseasonsQuery>;
export type GetLeagueMetaseasonsLazyQueryHookResult = ReturnType<typeof useGetLeagueMetaseasonsLazyQuery>;
export type GetLeagueMetaseasonsQueryResult = Apollo.QueryResult<GetLeagueMetaseasonsQuery, GetLeagueMetaseasonsQueryVariables>;
export function refetchGetLeagueMetaseasonsQuery(variables?: GetLeagueMetaseasonsQueryVariables) {
      return { query: GetLeagueMetaseasonsDocument, variables: variables }
    }
export const GetLeagueDetailsByIdDocument = gql`
    query getLeagueDetailsById($id: UUID!) {
  league(id: $id) {
    id
    name
    timezone
    teamFormat
    teamMaxSize
    esport {
      id
      name
      slug
    }
    seasons {
      id
      name
      status
      teamRegistrationEndsAt
      metaseason {
        id
        name
      }
      phases {
        id
        name
        slots {
          id
          startsAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetLeagueDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetLeagueDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeagueDetailsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueDetailsByIdQuery, GetLeagueDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueDetailsByIdQuery, GetLeagueDetailsByIdQueryVariables>(GetLeagueDetailsByIdDocument, options);
      }
export function useGetLeagueDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueDetailsByIdQuery, GetLeagueDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueDetailsByIdQuery, GetLeagueDetailsByIdQueryVariables>(GetLeagueDetailsByIdDocument, options);
        }
export type GetLeagueDetailsByIdQueryHookResult = ReturnType<typeof useGetLeagueDetailsByIdQuery>;
export type GetLeagueDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetLeagueDetailsByIdLazyQuery>;
export type GetLeagueDetailsByIdQueryResult = Apollo.QueryResult<GetLeagueDetailsByIdQuery, GetLeagueDetailsByIdQueryVariables>;
export function refetchGetLeagueDetailsByIdQuery(variables: GetLeagueDetailsByIdQueryVariables) {
      return { query: GetLeagueDetailsByIdDocument, variables: variables }
    }
export const AllLeaguesDocument = gql`
    query allLeagues($limit: Int, $offset: Int, $filters: LeagueFilters!) {
  getAllLeagues(limit: $limit, offset: $offset, filters: $filters) {
    result {
      id
      name
      displayName
      isHidden
      state
      competitionGroup
      competitionModel
      varsityAssociation {
        slug
        name
      }
      esport {
        id
        slug
        name
      }
      seasons {
        id
        metaseason {
          id
          name
        }
      }
    }
    total
  }
}
    `;

/**
 * __useAllLeaguesQuery__
 *
 * To run a query within a React component, call `useAllLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLeaguesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAllLeaguesQuery(baseOptions: Apollo.QueryHookOptions<AllLeaguesQuery, AllLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLeaguesQuery, AllLeaguesQueryVariables>(AllLeaguesDocument, options);
      }
export function useAllLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLeaguesQuery, AllLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLeaguesQuery, AllLeaguesQueryVariables>(AllLeaguesDocument, options);
        }
export type AllLeaguesQueryHookResult = ReturnType<typeof useAllLeaguesQuery>;
export type AllLeaguesLazyQueryHookResult = ReturnType<typeof useAllLeaguesLazyQuery>;
export type AllLeaguesQueryResult = Apollo.QueryResult<AllLeaguesQuery, AllLeaguesQueryVariables>;
export function refetchAllLeaguesQuery(variables: AllLeaguesQueryVariables) {
      return { query: AllLeaguesDocument, variables: variables }
    }
export const AllLeaguesTotalDocument = gql`
    query allLeaguesTotal($filters: LeagueFilters!) {
  getAllLeagues(filters: $filters) {
    total
  }
}
    `;

/**
 * __useAllLeaguesTotalQuery__
 *
 * To run a query within a React component, call `useAllLeaguesTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLeaguesTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLeaguesTotalQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAllLeaguesTotalQuery(baseOptions: Apollo.QueryHookOptions<AllLeaguesTotalQuery, AllLeaguesTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLeaguesTotalQuery, AllLeaguesTotalQueryVariables>(AllLeaguesTotalDocument, options);
      }
export function useAllLeaguesTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLeaguesTotalQuery, AllLeaguesTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLeaguesTotalQuery, AllLeaguesTotalQueryVariables>(AllLeaguesTotalDocument, options);
        }
export type AllLeaguesTotalQueryHookResult = ReturnType<typeof useAllLeaguesTotalQuery>;
export type AllLeaguesTotalLazyQueryHookResult = ReturnType<typeof useAllLeaguesTotalLazyQuery>;
export type AllLeaguesTotalQueryResult = Apollo.QueryResult<AllLeaguesTotalQuery, AllLeaguesTotalQueryVariables>;
export function refetchAllLeaguesTotalQuery(variables: AllLeaguesTotalQueryVariables) {
      return { query: AllLeaguesTotalDocument, variables: variables }
    }
export const LeaguesSelectTableDocument = gql`
    query leaguesSelectTable($limit: Int, $offset: Int, $filters: LeagueFilters!) {
  getAllLeagues(limit: $limit, offset: $offset, filters: $filters) {
    result {
      id
      name
      competitionGroup
      competitionModel
    }
    total
  }
}
    `;

/**
 * __useLeaguesSelectTableQuery__
 *
 * To run a query within a React component, call `useLeaguesSelectTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaguesSelectTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaguesSelectTableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLeaguesSelectTableQuery(baseOptions: Apollo.QueryHookOptions<LeaguesSelectTableQuery, LeaguesSelectTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaguesSelectTableQuery, LeaguesSelectTableQueryVariables>(LeaguesSelectTableDocument, options);
      }
export function useLeaguesSelectTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaguesSelectTableQuery, LeaguesSelectTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaguesSelectTableQuery, LeaguesSelectTableQueryVariables>(LeaguesSelectTableDocument, options);
        }
export type LeaguesSelectTableQueryHookResult = ReturnType<typeof useLeaguesSelectTableQuery>;
export type LeaguesSelectTableLazyQueryHookResult = ReturnType<typeof useLeaguesSelectTableLazyQuery>;
export type LeaguesSelectTableQueryResult = Apollo.QueryResult<LeaguesSelectTableQuery, LeaguesSelectTableQueryVariables>;
export function refetchLeaguesSelectTableQuery(variables: LeaguesSelectTableQueryVariables) {
      return { query: LeaguesSelectTableDocument, variables: variables }
    }
export const MetaseasonLeaguesTableDocument = gql`
    query metaseasonLeaguesTable($limit: Int, $filters: LeagueFilters!, $metaseasonId: UUID!) {
  getAllLeagues(limit: $limit, filters: $filters) {
    result {
      id
      name
      competitionGroup
      competitionModel
      timezone
      numberOfPossibleTeamsAndPlayers(metaseasonId: $metaseasonId) {
        numberOfPlayers
        numberOfTeams
      }
      seasonByMetaseasonId(metaseasonId: $metaseasonId) {
        id
        numberOfTeams
        numberOfPlayers
        enrollmentStatus
        phases {
          id
          type
        }
        startsAt
        endsAt
        registrationStartsAt
        suggestedRegistrationEndsAt
        teamRegistrationEndsAt
        teamDeregistrationEndsAt
        playerRegistrationEndsAt
        playerDeregistrationEndsAt
        rostersLockAt
      }
    }
    total
  }
}
    `;

/**
 * __useMetaseasonLeaguesTableQuery__
 *
 * To run a query within a React component, call `useMetaseasonLeaguesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaseasonLeaguesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaseasonLeaguesTableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useMetaseasonLeaguesTableQuery(baseOptions: Apollo.QueryHookOptions<MetaseasonLeaguesTableQuery, MetaseasonLeaguesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaseasonLeaguesTableQuery, MetaseasonLeaguesTableQueryVariables>(MetaseasonLeaguesTableDocument, options);
      }
export function useMetaseasonLeaguesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaseasonLeaguesTableQuery, MetaseasonLeaguesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaseasonLeaguesTableQuery, MetaseasonLeaguesTableQueryVariables>(MetaseasonLeaguesTableDocument, options);
        }
export type MetaseasonLeaguesTableQueryHookResult = ReturnType<typeof useMetaseasonLeaguesTableQuery>;
export type MetaseasonLeaguesTableLazyQueryHookResult = ReturnType<typeof useMetaseasonLeaguesTableLazyQuery>;
export type MetaseasonLeaguesTableQueryResult = Apollo.QueryResult<MetaseasonLeaguesTableQuery, MetaseasonLeaguesTableQueryVariables>;
export function refetchMetaseasonLeaguesTableQuery(variables: MetaseasonLeaguesTableQueryVariables) {
      return { query: MetaseasonLeaguesTableDocument, variables: variables }
    }
export const GetLeaguesPendingPlayerDataDocument = gql`
    query getLeaguesPendingPlayerData($leagueIds: [UUID!]!, $metaseasonId: UUID!) {
  getLeaguesPendingPlayerData(leagueIds: $leagueIds, metaseasonId: $metaseasonId) {
    leagueId
    leagueName
    teamId
    playerId
  }
}
    `;

/**
 * __useGetLeaguesPendingPlayerDataQuery__
 *
 * To run a query within a React component, call `useGetLeaguesPendingPlayerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaguesPendingPlayerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaguesPendingPlayerDataQuery({
 *   variables: {
 *      leagueIds: // value for 'leagueIds'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetLeaguesPendingPlayerDataQuery(baseOptions: Apollo.QueryHookOptions<GetLeaguesPendingPlayerDataQuery, GetLeaguesPendingPlayerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaguesPendingPlayerDataQuery, GetLeaguesPendingPlayerDataQueryVariables>(GetLeaguesPendingPlayerDataDocument, options);
      }
export function useGetLeaguesPendingPlayerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaguesPendingPlayerDataQuery, GetLeaguesPendingPlayerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaguesPendingPlayerDataQuery, GetLeaguesPendingPlayerDataQueryVariables>(GetLeaguesPendingPlayerDataDocument, options);
        }
export type GetLeaguesPendingPlayerDataQueryHookResult = ReturnType<typeof useGetLeaguesPendingPlayerDataQuery>;
export type GetLeaguesPendingPlayerDataLazyQueryHookResult = ReturnType<typeof useGetLeaguesPendingPlayerDataLazyQuery>;
export type GetLeaguesPendingPlayerDataQueryResult = Apollo.QueryResult<GetLeaguesPendingPlayerDataQuery, GetLeaguesPendingPlayerDataQueryVariables>;
export function refetchGetLeaguesPendingPlayerDataQuery(variables: GetLeaguesPendingPlayerDataQueryVariables) {
      return { query: GetLeaguesPendingPlayerDataDocument, variables: variables }
    }
export const GetLeaguesEnrolledPlayerDataDocument = gql`
    query getLeaguesEnrolledPlayerData($leagueIds: [UUID!]!, $metaseasonId: UUID!) {
  getLeaguesEnrolledPlayerData(leagueIds: $leagueIds, metaseasonId: $metaseasonId) {
    leagueId
    leagueName
    teamId
    playerId
  }
}
    `;

/**
 * __useGetLeaguesEnrolledPlayerDataQuery__
 *
 * To run a query within a React component, call `useGetLeaguesEnrolledPlayerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaguesEnrolledPlayerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaguesEnrolledPlayerDataQuery({
 *   variables: {
 *      leagueIds: // value for 'leagueIds'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetLeaguesEnrolledPlayerDataQuery(baseOptions: Apollo.QueryHookOptions<GetLeaguesEnrolledPlayerDataQuery, GetLeaguesEnrolledPlayerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaguesEnrolledPlayerDataQuery, GetLeaguesEnrolledPlayerDataQueryVariables>(GetLeaguesEnrolledPlayerDataDocument, options);
      }
export function useGetLeaguesEnrolledPlayerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaguesEnrolledPlayerDataQuery, GetLeaguesEnrolledPlayerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaguesEnrolledPlayerDataQuery, GetLeaguesEnrolledPlayerDataQueryVariables>(GetLeaguesEnrolledPlayerDataDocument, options);
        }
export type GetLeaguesEnrolledPlayerDataQueryHookResult = ReturnType<typeof useGetLeaguesEnrolledPlayerDataQuery>;
export type GetLeaguesEnrolledPlayerDataLazyQueryHookResult = ReturnType<typeof useGetLeaguesEnrolledPlayerDataLazyQuery>;
export type GetLeaguesEnrolledPlayerDataQueryResult = Apollo.QueryResult<GetLeaguesEnrolledPlayerDataQuery, GetLeaguesEnrolledPlayerDataQueryVariables>;
export function refetchGetLeaguesEnrolledPlayerDataQuery(variables: GetLeaguesEnrolledPlayerDataQueryVariables) {
      return { query: GetLeaguesEnrolledPlayerDataDocument, variables: variables }
    }
export const FindCommonLeaguesForTeamsDocument = gql`
    query findCommonLeaguesForTeams($input: CommonLeaguesForTeamsInput!, $metaseasonId: UUID!) {
  findCommonLeaguesForTeams(input: $input) {
    id
    name
    seasonByMetaseasonId(metaseasonId: $metaseasonId) {
      id
    }
  }
}
    `;

/**
 * __useFindCommonLeaguesForTeamsQuery__
 *
 * To run a query within a React component, call `useFindCommonLeaguesForTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCommonLeaguesForTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCommonLeaguesForTeamsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useFindCommonLeaguesForTeamsQuery(baseOptions: Apollo.QueryHookOptions<FindCommonLeaguesForTeamsQuery, FindCommonLeaguesForTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCommonLeaguesForTeamsQuery, FindCommonLeaguesForTeamsQueryVariables>(FindCommonLeaguesForTeamsDocument, options);
      }
export function useFindCommonLeaguesForTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCommonLeaguesForTeamsQuery, FindCommonLeaguesForTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCommonLeaguesForTeamsQuery, FindCommonLeaguesForTeamsQueryVariables>(FindCommonLeaguesForTeamsDocument, options);
        }
export type FindCommonLeaguesForTeamsQueryHookResult = ReturnType<typeof useFindCommonLeaguesForTeamsQuery>;
export type FindCommonLeaguesForTeamsLazyQueryHookResult = ReturnType<typeof useFindCommonLeaguesForTeamsLazyQuery>;
export type FindCommonLeaguesForTeamsQueryResult = Apollo.QueryResult<FindCommonLeaguesForTeamsQuery, FindCommonLeaguesForTeamsQueryVariables>;
export function refetchFindCommonLeaguesForTeamsQuery(variables: FindCommonLeaguesForTeamsQueryVariables) {
      return { query: FindCommonLeaguesForTeamsDocument, variables: variables }
    }
export const GetVaLeaguesDocument = gql`
    query getVaLeagues($limit: Int, $offset: Int, $filters: LeagueFilters!) {
  getAllLeagues(limit: $limit, offset: $offset, filters: $filters) {
    result {
      id
      name
      esport {
        id
        slug
        name
      }
      seasons {
        id
        name
        startsAt
        endsAt
      }
    }
    total
  }
}
    `;

/**
 * __useGetVaLeaguesQuery__
 *
 * To run a query within a React component, call `useGetVaLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVaLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVaLeaguesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetVaLeaguesQuery(baseOptions: Apollo.QueryHookOptions<GetVaLeaguesQuery, GetVaLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVaLeaguesQuery, GetVaLeaguesQueryVariables>(GetVaLeaguesDocument, options);
      }
export function useGetVaLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVaLeaguesQuery, GetVaLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVaLeaguesQuery, GetVaLeaguesQueryVariables>(GetVaLeaguesDocument, options);
        }
export type GetVaLeaguesQueryHookResult = ReturnType<typeof useGetVaLeaguesQuery>;
export type GetVaLeaguesLazyQueryHookResult = ReturnType<typeof useGetVaLeaguesLazyQuery>;
export type GetVaLeaguesQueryResult = Apollo.QueryResult<GetVaLeaguesQuery, GetVaLeaguesQueryVariables>;
export function refetchGetVaLeaguesQuery(variables: GetVaLeaguesQueryVariables) {
      return { query: GetVaLeaguesDocument, variables: variables }
    }
export const UnlockLeagueDocument = gql`
    mutation unlockLeague($input: UnlockLeagueInput!) {
  unlockLeague(input: $input) {
    success
  }
}
    `;
export type UnlockLeagueMutationFn = Apollo.MutationFunction<UnlockLeagueMutation, UnlockLeagueMutationVariables>;

/**
 * __useUnlockLeagueMutation__
 *
 * To run a mutation, you first call `useUnlockLeagueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockLeagueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockLeagueMutation, { data, loading, error }] = useUnlockLeagueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlockLeagueMutation(baseOptions?: Apollo.MutationHookOptions<UnlockLeagueMutation, UnlockLeagueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockLeagueMutation, UnlockLeagueMutationVariables>(UnlockLeagueDocument, options);
      }
export type UnlockLeagueMutationHookResult = ReturnType<typeof useUnlockLeagueMutation>;
export type UnlockLeagueMutationResult = Apollo.MutationResult<UnlockLeagueMutation>;
export type UnlockLeagueMutationOptions = Apollo.BaseMutationOptions<UnlockLeagueMutation, UnlockLeagueMutationVariables>;
export const ConsolidateLeagueDocument = gql`
    mutation consolidateLeague($input: ConsolidateLeagueInput!) {
  consolidateLeague(input: $input) {
    success
  }
}
    `;
export type ConsolidateLeagueMutationFn = Apollo.MutationFunction<ConsolidateLeagueMutation, ConsolidateLeagueMutationVariables>;

/**
 * __useConsolidateLeagueMutation__
 *
 * To run a mutation, you first call `useConsolidateLeagueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsolidateLeagueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consolidateLeagueMutation, { data, loading, error }] = useConsolidateLeagueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsolidateLeagueMutation(baseOptions?: Apollo.MutationHookOptions<ConsolidateLeagueMutation, ConsolidateLeagueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsolidateLeagueMutation, ConsolidateLeagueMutationVariables>(ConsolidateLeagueDocument, options);
      }
export type ConsolidateLeagueMutationHookResult = ReturnType<typeof useConsolidateLeagueMutation>;
export type ConsolidateLeagueMutationResult = Apollo.MutationResult<ConsolidateLeagueMutation>;
export type ConsolidateLeagueMutationOptions = Apollo.BaseMutationOptions<ConsolidateLeagueMutation, ConsolidateLeagueMutationVariables>;
export const GetHelpLinksDocument = gql`
    query getHelpLinks {
  getLinks {
    id
    slug
    url
    title
  }
}
    `;

/**
 * __useGetHelpLinksQuery__
 *
 * To run a query within a React component, call `useGetHelpLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelpLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelpLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHelpLinksQuery(baseOptions?: Apollo.QueryHookOptions<GetHelpLinksQuery, GetHelpLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelpLinksQuery, GetHelpLinksQueryVariables>(GetHelpLinksDocument, options);
      }
export function useGetHelpLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelpLinksQuery, GetHelpLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelpLinksQuery, GetHelpLinksQueryVariables>(GetHelpLinksDocument, options);
        }
export type GetHelpLinksQueryHookResult = ReturnType<typeof useGetHelpLinksQuery>;
export type GetHelpLinksLazyQueryHookResult = ReturnType<typeof useGetHelpLinksLazyQuery>;
export type GetHelpLinksQueryResult = Apollo.QueryResult<GetHelpLinksQuery, GetHelpLinksQueryVariables>;
export function refetchGetHelpLinksQuery(variables?: GetHelpLinksQueryVariables) {
      return { query: GetHelpLinksDocument, variables: variables }
    }
export const UpdateLinkDocument = gql`
    mutation updateLink($input: UpdateLinkInput!) {
  updateLink(input: $input) {
    slug
    url
  }
}
    `;
export type UpdateLinkMutationFn = Apollo.MutationFunction<UpdateLinkMutation, UpdateLinkMutationVariables>;

/**
 * __useUpdateLinkMutation__
 *
 * To run a mutation, you first call `useUpdateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinkMutation, { data, loading, error }] = useUpdateLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinkMutation, UpdateLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinkMutation, UpdateLinkMutationVariables>(UpdateLinkDocument, options);
      }
export type UpdateLinkMutationHookResult = ReturnType<typeof useUpdateLinkMutation>;
export type UpdateLinkMutationResult = Apollo.MutationResult<UpdateLinkMutation>;
export type UpdateLinkMutationOptions = Apollo.BaseMutationOptions<UpdateLinkMutation, UpdateLinkMutationVariables>;
export const GetLobbyMatchStaticDocument = gql`
    query getLobbyMatchStatic($matchId: UUID!) {
  match(id: $matchId) {
    id
    isSettleableByACoach
    isScrimmage
    scheduledStartsAt
    bestOf
    seriesBestOf
    discordLink
    teamContext {
      matchId
      teams {
        ...MatchTeam
      }
    }
    scheduleContext
    esport {
      id
      name
      slug
      rating
    }
    matchResults {
      id
      placing
      teamSide
      metaseasonId
      gamesWon
      teamId
      seriesWon
      team {
        id
        name
        deletedAt
        roster {
          id
          formats {
            starters {
              player {
                user {
                  id
                  name
                  avatarUrl
                  userProviderAccounts {
                    id
                    userId
                    providerName
                    providerAccountId
                    providerDisplayName
                    providerIntegrationType
                  }
                }
              }
            }
            teamSize
          }
          players {
            user {
              id
              name
              avatarUrl
              userProviderAccounts {
                id
                userId
                providerName
                providerAccountId
                providerDisplayName
                providerIntegrationType
              }
            }
          }
        }
        leagues {
          id
        }
        school {
          id
          name
          logoUrl
        }
        enrolledSeasons {
          id
          metaseasonId
          startsAt
          metaseason {
            id
            startsAt
            endsAt
            name
            isPromoted
          }
        }
      }
    }
    series {
      id
      bestOf
      teamContext {
        seriesId
        teams {
          ...SeriesTeam
        }
      }
    }
    slot {
      id
      phase {
        id
        type
        format
        season {
          id
          leagueId
          metaseasonId
        }
      }
    }
  }
}
    ${MatchTeamFragmentDoc}
${SeriesTeamFragmentDoc}`;

/**
 * __useGetLobbyMatchStaticQuery__
 *
 * To run a query within a React component, call `useGetLobbyMatchStaticQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLobbyMatchStaticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLobbyMatchStaticQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetLobbyMatchStaticQuery(baseOptions: Apollo.QueryHookOptions<GetLobbyMatchStaticQuery, GetLobbyMatchStaticQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLobbyMatchStaticQuery, GetLobbyMatchStaticQueryVariables>(GetLobbyMatchStaticDocument, options);
      }
export function useGetLobbyMatchStaticLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLobbyMatchStaticQuery, GetLobbyMatchStaticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLobbyMatchStaticQuery, GetLobbyMatchStaticQueryVariables>(GetLobbyMatchStaticDocument, options);
        }
export type GetLobbyMatchStaticQueryHookResult = ReturnType<typeof useGetLobbyMatchStaticQuery>;
export type GetLobbyMatchStaticLazyQueryHookResult = ReturnType<typeof useGetLobbyMatchStaticLazyQuery>;
export type GetLobbyMatchStaticQueryResult = Apollo.QueryResult<GetLobbyMatchStaticQuery, GetLobbyMatchStaticQueryVariables>;
export function refetchGetLobbyMatchStaticQuery(variables: GetLobbyMatchStaticQueryVariables) {
      return { query: GetLobbyMatchStaticDocument, variables: variables }
    }
export const GetLobbyMatchDocument = gql`
    query getLobbyMatch($matchId: UUID!) {
  match(id: $matchId) {
    ...LobbyMatch
  }
}
    ${LobbyMatchFragmentDoc}`;

/**
 * __useGetLobbyMatchQuery__
 *
 * To run a query within a React component, call `useGetLobbyMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLobbyMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLobbyMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetLobbyMatchQuery(baseOptions: Apollo.QueryHookOptions<GetLobbyMatchQuery, GetLobbyMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLobbyMatchQuery, GetLobbyMatchQueryVariables>(GetLobbyMatchDocument, options);
      }
export function useGetLobbyMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLobbyMatchQuery, GetLobbyMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLobbyMatchQuery, GetLobbyMatchQueryVariables>(GetLobbyMatchDocument, options);
        }
export type GetLobbyMatchQueryHookResult = ReturnType<typeof useGetLobbyMatchQuery>;
export type GetLobbyMatchLazyQueryHookResult = ReturnType<typeof useGetLobbyMatchLazyQuery>;
export type GetLobbyMatchQueryResult = Apollo.QueryResult<GetLobbyMatchQuery, GetLobbyMatchQueryVariables>;
export function refetchGetLobbyMatchQuery(variables: GetLobbyMatchQueryVariables) {
      return { query: GetLobbyMatchDocument, variables: variables }
    }
export const GetMatchDetailsForProviderDocument = gql`
    query getMatchDetailsForProvider($matchId: UUID!) {
  match(id: $matchId) {
    id
    status
    scheduledStartsAt
  }
}
    `;

/**
 * __useGetMatchDetailsForProviderQuery__
 *
 * To run a query within a React component, call `useGetMatchDetailsForProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchDetailsForProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchDetailsForProviderQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchDetailsForProviderQuery(baseOptions: Apollo.QueryHookOptions<GetMatchDetailsForProviderQuery, GetMatchDetailsForProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchDetailsForProviderQuery, GetMatchDetailsForProviderQueryVariables>(GetMatchDetailsForProviderDocument, options);
      }
export function useGetMatchDetailsForProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchDetailsForProviderQuery, GetMatchDetailsForProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchDetailsForProviderQuery, GetMatchDetailsForProviderQueryVariables>(GetMatchDetailsForProviderDocument, options);
        }
export type GetMatchDetailsForProviderQueryHookResult = ReturnType<typeof useGetMatchDetailsForProviderQuery>;
export type GetMatchDetailsForProviderLazyQueryHookResult = ReturnType<typeof useGetMatchDetailsForProviderLazyQuery>;
export type GetMatchDetailsForProviderQueryResult = Apollo.QueryResult<GetMatchDetailsForProviderQuery, GetMatchDetailsForProviderQueryVariables>;
export function refetchGetMatchDetailsForProviderQuery(variables: GetMatchDetailsForProviderQueryVariables) {
      return { query: GetMatchDetailsForProviderDocument, variables: variables }
    }
export const GetCancelMatchDocument = gql`
    query getCancelMatch($matchId: UUID!) {
  match(id: $matchId) {
    id
    isScrimmage
    status
    scheduledStartsAt
    bestOf
    esport {
      id
      slug
    }
    teamContext {
      matchId
      teams {
        id
        name
        isMyTeam
      }
    }
    esport {
      id
      slug
      name
    }
    matchResults {
      id
      team {
        id
        name
      }
    }
    matchRescheduleRequests {
      id
      status
      proposedTimes
      teamId
      matchId
    }
    scrimmageRequest {
      id
      bestOf
      startsAt
      esport {
        id
        slug
        name
      }
      requestingTeam {
        id
        name
        school {
          id
        }
      }
      opposingTeam {
        id
        name
        school {
          id
        }
      }
    }
    slot {
      id
      phase {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useGetCancelMatchQuery__
 *
 * To run a query within a React component, call `useGetCancelMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancelMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancelMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetCancelMatchQuery(baseOptions: Apollo.QueryHookOptions<GetCancelMatchQuery, GetCancelMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancelMatchQuery, GetCancelMatchQueryVariables>(GetCancelMatchDocument, options);
      }
export function useGetCancelMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancelMatchQuery, GetCancelMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancelMatchQuery, GetCancelMatchQueryVariables>(GetCancelMatchDocument, options);
        }
export type GetCancelMatchQueryHookResult = ReturnType<typeof useGetCancelMatchQuery>;
export type GetCancelMatchLazyQueryHookResult = ReturnType<typeof useGetCancelMatchLazyQuery>;
export type GetCancelMatchQueryResult = Apollo.QueryResult<GetCancelMatchQuery, GetCancelMatchQueryVariables>;
export function refetchGetCancelMatchQuery(variables: GetCancelMatchQueryVariables) {
      return { query: GetCancelMatchDocument, variables: variables }
    }
export const GetRescheduleMatchDocument = gql`
    query getRescheduleMatch($matchId: UUID!) {
  match(id: $matchId) {
    id
    status
    scheduledStartsAt
    bestOf
    isScrimmage
    esport {
      id
      slug
    }
    slot {
      id
      phase {
        id
        startsAt
        endsAt
        type
        slots {
          id
          startsAt
          scheduleMatchesAt
          status
        }
      }
    }
    teamContext {
      matchId
      teams {
        id
        name
        isMyTeam
        school {
          id
        }
        state
      }
    }
    league {
      id
      state
      competitionGroup
    }
    matchRescheduleRequests {
      id
      matchId
      proposedTimes
      teamId
      requestedById
      deniedById
      approvedById
      canceledById
      status
      rescheduleReason
      rescheduleNotes
      denyNotes
      proposedTimes
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetRescheduleMatchQuery__
 *
 * To run a query within a React component, call `useGetRescheduleMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRescheduleMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRescheduleMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetRescheduleMatchQuery(baseOptions: Apollo.QueryHookOptions<GetRescheduleMatchQuery, GetRescheduleMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRescheduleMatchQuery, GetRescheduleMatchQueryVariables>(GetRescheduleMatchDocument, options);
      }
export function useGetRescheduleMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRescheduleMatchQuery, GetRescheduleMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRescheduleMatchQuery, GetRescheduleMatchQueryVariables>(GetRescheduleMatchDocument, options);
        }
export type GetRescheduleMatchQueryHookResult = ReturnType<typeof useGetRescheduleMatchQuery>;
export type GetRescheduleMatchLazyQueryHookResult = ReturnType<typeof useGetRescheduleMatchLazyQuery>;
export type GetRescheduleMatchQueryResult = Apollo.QueryResult<GetRescheduleMatchQuery, GetRescheduleMatchQueryVariables>;
export function refetchGetRescheduleMatchQuery(variables: GetRescheduleMatchQueryVariables) {
      return { query: GetRescheduleMatchDocument, variables: variables }
    }
export const ForfeitMatchDocument = gql`
    mutation forfeitMatch($matchId: UUID!, $teamId: UUID!, $reason: ForfeitReason, $forfeitDetail: String) {
  forfeitMatch(
    matchId: $matchId
    teamId: $teamId
    reason: $reason
    forfeitDetail: $forfeitDetail
  ) {
    matchId
    teamId
    losingTeamId
    winningTeamId
  }
}
    `;
export type ForfeitMatchMutationFn = Apollo.MutationFunction<ForfeitMatchMutation, ForfeitMatchMutationVariables>;

/**
 * __useForfeitMatchMutation__
 *
 * To run a mutation, you first call `useForfeitMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForfeitMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forfeitMatchMutation, { data, loading, error }] = useForfeitMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      teamId: // value for 'teamId'
 *      reason: // value for 'reason'
 *      forfeitDetail: // value for 'forfeitDetail'
 *   },
 * });
 */
export function useForfeitMatchMutation(baseOptions?: Apollo.MutationHookOptions<ForfeitMatchMutation, ForfeitMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForfeitMatchMutation, ForfeitMatchMutationVariables>(ForfeitMatchDocument, options);
      }
export type ForfeitMatchMutationHookResult = ReturnType<typeof useForfeitMatchMutation>;
export type ForfeitMatchMutationResult = Apollo.MutationResult<ForfeitMatchMutation>;
export type ForfeitMatchMutationOptions = Apollo.BaseMutationOptions<ForfeitMatchMutation, ForfeitMatchMutationVariables>;
export const GetFortniteTeamMatchStatsDocument = gql`
    query getFortniteTeamMatchStats($matchId: UUID!, $limit: Int!, $offset: Int!, $schoolId: UUID) {
  match(id: $matchId) {
    slot {
      id
      phase {
        id
        format
        survivalAdvancementPercentage
        survivalAdvancementCount
      }
    }
    id
    status
    fortniteTeamMatchStats(limit: $limit, offset: $offset, schoolId: $schoolId) {
      leaderboard {
        team {
          id
          name
          roster {
            id
            players {
              user {
                id
                name
                avatarUrl
                userProviderAccounts {
                  id
                  userId
                  providerName
                  providerAccountId
                  providerDisplayName
                  providerIntegrationType
                }
              }
              effectiveAt
              isCaptain
            }
          }
          school {
            id
            name
            logoUrl
            state
            slug
          }
        }
        stats {
          ... on FortniteTeamMatchStats {
            id
            rank
            clutched
            totalPoints
            placementPoints
            eliminationPoints
            totalSecondsSurvived
            avgPointsPerSession
            avgPlacementPerSession
            avgEliminationsPerSession
            sessionsPlayed
          }
        }
      }
      schoolTeams {
        team {
          id
          name
          roster {
            id
            players {
              user {
                id
                name
                avatarUrl
                userProviderAccounts {
                  id
                  userId
                  providerName
                  providerAccountId
                  providerDisplayName
                  providerIntegrationType
                }
              }
              effectiveAt
              isCaptain
            }
          }
          school {
            id
            name
            logoUrl
            state
            slug
          }
        }
        stats {
          ... on FortniteTeamMatchStats {
            id
            rank
            clutched
            totalPoints
            placementPoints
            eliminationPoints
            totalSecondsSurvived
            avgPointsPerSession
            avgPlacementPerSession
            avgEliminationsPerSession
            sessionsPlayed
          }
        }
      }
      myTeams {
        team {
          id
          name
          roster {
            id
            players {
              user {
                id
                name
                avatarUrl
                userProviderAccounts {
                  id
                  userId
                  providerName
                  providerAccountId
                  providerDisplayName
                  providerIntegrationType
                }
              }
              effectiveAt
              isCaptain
            }
          }
          school {
            id
            name
            logoUrl
            state
            slug
          }
        }
        stats {
          ... on FortniteTeamMatchStats {
            id
            rank
            clutched
            totalPoints
            placementPoints
            eliminationPoints
            totalSecondsSurvived
            avgPointsPerSession
            avgPlacementPerSession
            avgEliminationsPerSession
            sessionsPlayed
          }
        }
      }
      updatedAt
      total
    }
  }
}
    `;

/**
 * __useGetFortniteTeamMatchStatsQuery__
 *
 * To run a query within a React component, call `useGetFortniteTeamMatchStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFortniteTeamMatchStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFortniteTeamMatchStatsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetFortniteTeamMatchStatsQuery(baseOptions: Apollo.QueryHookOptions<GetFortniteTeamMatchStatsQuery, GetFortniteTeamMatchStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFortniteTeamMatchStatsQuery, GetFortniteTeamMatchStatsQueryVariables>(GetFortniteTeamMatchStatsDocument, options);
      }
export function useGetFortniteTeamMatchStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFortniteTeamMatchStatsQuery, GetFortniteTeamMatchStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFortniteTeamMatchStatsQuery, GetFortniteTeamMatchStatsQueryVariables>(GetFortniteTeamMatchStatsDocument, options);
        }
export type GetFortniteTeamMatchStatsQueryHookResult = ReturnType<typeof useGetFortniteTeamMatchStatsQuery>;
export type GetFortniteTeamMatchStatsLazyQueryHookResult = ReturnType<typeof useGetFortniteTeamMatchStatsLazyQuery>;
export type GetFortniteTeamMatchStatsQueryResult = Apollo.QueryResult<GetFortniteTeamMatchStatsQuery, GetFortniteTeamMatchStatsQueryVariables>;
export function refetchGetFortniteTeamMatchStatsQuery(variables: GetFortniteTeamMatchStatsQueryVariables) {
      return { query: GetFortniteTeamMatchStatsDocument, variables: variables }
    }
export const LeagueUnconnectedPlayersDocument = gql`
    query leagueUnconnectedPlayers($leagueId: UUID!, $metaseasonId: UUID!, $schoolId: UUID!) {
  league(id: $leagueId) {
    id
    unconnectedUsers(metaseasonId: $metaseasonId, schoolId: $schoolId) {
      id
      name
    }
  }
}
    `;

/**
 * __useLeagueUnconnectedPlayersQuery__
 *
 * To run a query within a React component, call `useLeagueUnconnectedPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeagueUnconnectedPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeagueUnconnectedPlayersQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *      metaseasonId: // value for 'metaseasonId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useLeagueUnconnectedPlayersQuery(baseOptions: Apollo.QueryHookOptions<LeagueUnconnectedPlayersQuery, LeagueUnconnectedPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeagueUnconnectedPlayersQuery, LeagueUnconnectedPlayersQueryVariables>(LeagueUnconnectedPlayersDocument, options);
      }
export function useLeagueUnconnectedPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeagueUnconnectedPlayersQuery, LeagueUnconnectedPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeagueUnconnectedPlayersQuery, LeagueUnconnectedPlayersQueryVariables>(LeagueUnconnectedPlayersDocument, options);
        }
export type LeagueUnconnectedPlayersQueryHookResult = ReturnType<typeof useLeagueUnconnectedPlayersQuery>;
export type LeagueUnconnectedPlayersLazyQueryHookResult = ReturnType<typeof useLeagueUnconnectedPlayersLazyQuery>;
export type LeagueUnconnectedPlayersQueryResult = Apollo.QueryResult<LeagueUnconnectedPlayersQuery, LeagueUnconnectedPlayersQueryVariables>;
export function refetchLeagueUnconnectedPlayersQuery(variables: LeagueUnconnectedPlayersQueryVariables) {
      return { query: LeagueUnconnectedPlayersDocument, variables: variables }
    }
export const GetDmrMatchDocument = gql`
    query getDmrMatch($matchId: UUID!) {
  match(id: $matchId) {
    ...DmrMatch
  }
}
    ${DmrMatchFragmentDoc}`;

/**
 * __useGetDmrMatchQuery__
 *
 * To run a query within a React component, call `useGetDmrMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDmrMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDmrMatchQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetDmrMatchQuery(baseOptions: Apollo.QueryHookOptions<GetDmrMatchQuery, GetDmrMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDmrMatchQuery, GetDmrMatchQueryVariables>(GetDmrMatchDocument, options);
      }
export function useGetDmrMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDmrMatchQuery, GetDmrMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDmrMatchQuery, GetDmrMatchQueryVariables>(GetDmrMatchDocument, options);
        }
export type GetDmrMatchQueryHookResult = ReturnType<typeof useGetDmrMatchQuery>;
export type GetDmrMatchLazyQueryHookResult = ReturnType<typeof useGetDmrMatchLazyQuery>;
export type GetDmrMatchQueryResult = Apollo.QueryResult<GetDmrMatchQuery, GetDmrMatchQueryVariables>;
export function refetchGetDmrMatchQuery(variables: GetDmrMatchQueryVariables) {
      return { query: GetDmrMatchDocument, variables: variables }
    }
export const LoginUserDocument = gql`
    mutation loginUser($input: LoginUserInput!) {
  loginUser(input: $input) {
    token
    user {
      id
      isUnderage
    }
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const RegisterUserDocument = gql`
    mutation registerUser($input: RegisterUserInput!, $options: RegisterUserOptions!) {
  registerUser(input: $input, options: $options) {
    user {
      id
      isUnderage
    }
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const LogoutUserDocument = gql`
    mutation logoutUser {
  logoutUser {
    success
  }
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: Apollo.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const CreatePastByeMatchDocument = gql`
    mutation createPastByeMatch($input: CreatePastByeMatchInput!) {
  createPastByeMatch(input: $input) {
    jobId
  }
}
    `;
export type CreatePastByeMatchMutationFn = Apollo.MutationFunction<CreatePastByeMatchMutation, CreatePastByeMatchMutationVariables>;

/**
 * __useCreatePastByeMatchMutation__
 *
 * To run a mutation, you first call `useCreatePastByeMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePastByeMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPastByeMatchMutation, { data, loading, error }] = useCreatePastByeMatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePastByeMatchMutation(baseOptions?: Apollo.MutationHookOptions<CreatePastByeMatchMutation, CreatePastByeMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePastByeMatchMutation, CreatePastByeMatchMutationVariables>(CreatePastByeMatchDocument, options);
      }
export type CreatePastByeMatchMutationHookResult = ReturnType<typeof useCreatePastByeMatchMutation>;
export type CreatePastByeMatchMutationResult = Apollo.MutationResult<CreatePastByeMatchMutation>;
export type CreatePastByeMatchMutationOptions = Apollo.BaseMutationOptions<CreatePastByeMatchMutation, CreatePastByeMatchMutationVariables>;
export const ScheduleMatchDocument = gql`
    mutation scheduleMatch($input: ScheduleMatchInput!) {
  scheduleMatch(input: $input) {
    jobId
  }
}
    `;
export type ScheduleMatchMutationFn = Apollo.MutationFunction<ScheduleMatchMutation, ScheduleMatchMutationVariables>;

/**
 * __useScheduleMatchMutation__
 *
 * To run a mutation, you first call `useScheduleMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleMatchMutation, { data, loading, error }] = useScheduleMatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleMatchMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleMatchMutation, ScheduleMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleMatchMutation, ScheduleMatchMutationVariables>(ScheduleMatchDocument, options);
      }
export type ScheduleMatchMutationHookResult = ReturnType<typeof useScheduleMatchMutation>;
export type ScheduleMatchMutationResult = Apollo.MutationResult<ScheduleMatchMutation>;
export type ScheduleMatchMutationOptions = Apollo.BaseMutationOptions<ScheduleMatchMutation, ScheduleMatchMutationVariables>;
export const ScheduleMatchesDocument = gql`
    mutation scheduleMatches($input: ScheduleMatchesInput!) {
  scheduleMatches(input: $input) {
    jobIds
  }
}
    `;
export type ScheduleMatchesMutationFn = Apollo.MutationFunction<ScheduleMatchesMutation, ScheduleMatchesMutationVariables>;

/**
 * __useScheduleMatchesMutation__
 *
 * To run a mutation, you first call `useScheduleMatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleMatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleMatchesMutation, { data, loading, error }] = useScheduleMatchesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleMatchesMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleMatchesMutation, ScheduleMatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleMatchesMutation, ScheduleMatchesMutationVariables>(ScheduleMatchesDocument, options);
      }
export type ScheduleMatchesMutationHookResult = ReturnType<typeof useScheduleMatchesMutation>;
export type ScheduleMatchesMutationResult = Apollo.MutationResult<ScheduleMatchesMutation>;
export type ScheduleMatchesMutationOptions = Apollo.BaseMutationOptions<ScheduleMatchesMutation, ScheduleMatchesMutationVariables>;
export const OpenMatchDocument = gql`
    mutation openMatch($matchId: UUID!) {
  openMatch(input: {matchId: $matchId}) {
    jobId
  }
}
    `;
export type OpenMatchMutationFn = Apollo.MutationFunction<OpenMatchMutation, OpenMatchMutationVariables>;

/**
 * __useOpenMatchMutation__
 *
 * To run a mutation, you first call `useOpenMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openMatchMutation, { data, loading, error }] = useOpenMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useOpenMatchMutation(baseOptions?: Apollo.MutationHookOptions<OpenMatchMutation, OpenMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenMatchMutation, OpenMatchMutationVariables>(OpenMatchDocument, options);
      }
export type OpenMatchMutationHookResult = ReturnType<typeof useOpenMatchMutation>;
export type OpenMatchMutationResult = Apollo.MutationResult<OpenMatchMutation>;
export type OpenMatchMutationOptions = Apollo.BaseMutationOptions<OpenMatchMutation, OpenMatchMutationVariables>;
export const CancelMatchDocument = gql`
    mutation cancelMatch($matchId: UUID!) {
  cancelMatch(input: {matchId: $matchId}) {
    jobId
  }
}
    `;
export type CancelMatchMutationFn = Apollo.MutationFunction<CancelMatchMutation, CancelMatchMutationVariables>;

/**
 * __useCancelMatchMutation__
 *
 * To run a mutation, you first call `useCancelMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMatchMutation, { data, loading, error }] = useCancelMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useCancelMatchMutation(baseOptions?: Apollo.MutationHookOptions<CancelMatchMutation, CancelMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMatchMutation, CancelMatchMutationVariables>(CancelMatchDocument, options);
      }
export type CancelMatchMutationHookResult = ReturnType<typeof useCancelMatchMutation>;
export type CancelMatchMutationResult = Apollo.MutationResult<CancelMatchMutation>;
export type CancelMatchMutationOptions = Apollo.BaseMutationOptions<CancelMatchMutation, CancelMatchMutationVariables>;
export const CompleteMatchDocument = gql`
    mutation completeMatch($matchId: UUID!, $reviewGames: Boolean) {
  completeMatch(input: {matchId: $matchId, reviewGames: $reviewGames}) {
    jobId
  }
}
    `;
export type CompleteMatchMutationFn = Apollo.MutationFunction<CompleteMatchMutation, CompleteMatchMutationVariables>;

/**
 * __useCompleteMatchMutation__
 *
 * To run a mutation, you first call `useCompleteMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMatchMutation, { data, loading, error }] = useCompleteMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      reviewGames: // value for 'reviewGames'
 *   },
 * });
 */
export function useCompleteMatchMutation(baseOptions?: Apollo.MutationHookOptions<CompleteMatchMutation, CompleteMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteMatchMutation, CompleteMatchMutationVariables>(CompleteMatchDocument, options);
      }
export type CompleteMatchMutationHookResult = ReturnType<typeof useCompleteMatchMutation>;
export type CompleteMatchMutationResult = Apollo.MutationResult<CompleteMatchMutation>;
export type CompleteMatchMutationOptions = Apollo.BaseMutationOptions<CompleteMatchMutation, CompleteMatchMutationVariables>;
export const SendFirstMessageNotificationIfNecessaryDocument = gql`
    mutation sendFirstMessageNotificationIfNecessary($input: SendFirstMessageNotificationIfNecessaryInput!) {
  sendFirstMessageNotificationIfNecessary(input: $input) {
    success
  }
}
    `;
export type SendFirstMessageNotificationIfNecessaryMutationFn = Apollo.MutationFunction<SendFirstMessageNotificationIfNecessaryMutation, SendFirstMessageNotificationIfNecessaryMutationVariables>;

/**
 * __useSendFirstMessageNotificationIfNecessaryMutation__
 *
 * To run a mutation, you first call `useSendFirstMessageNotificationIfNecessaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFirstMessageNotificationIfNecessaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFirstMessageNotificationIfNecessaryMutation, { data, loading, error }] = useSendFirstMessageNotificationIfNecessaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendFirstMessageNotificationIfNecessaryMutation(baseOptions?: Apollo.MutationHookOptions<SendFirstMessageNotificationIfNecessaryMutation, SendFirstMessageNotificationIfNecessaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFirstMessageNotificationIfNecessaryMutation, SendFirstMessageNotificationIfNecessaryMutationVariables>(SendFirstMessageNotificationIfNecessaryDocument, options);
      }
export type SendFirstMessageNotificationIfNecessaryMutationHookResult = ReturnType<typeof useSendFirstMessageNotificationIfNecessaryMutation>;
export type SendFirstMessageNotificationIfNecessaryMutationResult = Apollo.MutationResult<SendFirstMessageNotificationIfNecessaryMutation>;
export type SendFirstMessageNotificationIfNecessaryMutationOptions = Apollo.BaseMutationOptions<SendFirstMessageNotificationIfNecessaryMutation, SendFirstMessageNotificationIfNecessaryMutationVariables>;
export const CancelGameDocument = gql`
    mutation cancelGame($gameId: UUID!) {
  cancelGame(input: {gameId: $gameId}) {
    jobId
  }
}
    `;
export type CancelGameMutationFn = Apollo.MutationFunction<CancelGameMutation, CancelGameMutationVariables>;

/**
 * __useCancelGameMutation__
 *
 * To run a mutation, you first call `useCancelGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelGameMutation, { data, loading, error }] = useCancelGameMutation({
 *   variables: {
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useCancelGameMutation(baseOptions?: Apollo.MutationHookOptions<CancelGameMutation, CancelGameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelGameMutation, CancelGameMutationVariables>(CancelGameDocument, options);
      }
export type CancelGameMutationHookResult = ReturnType<typeof useCancelGameMutation>;
export type CancelGameMutationResult = Apollo.MutationResult<CancelGameMutation>;
export type CancelGameMutationOptions = Apollo.BaseMutationOptions<CancelGameMutation, CancelGameMutationVariables>;
export const ResolveUnknownPlayerGameStatsDocument = gql`
    mutation resolveUnknownPlayerGameStats($gameId: UUID!, $playerId: UUID!, $publisherAccountId: String!) {
  resolveUnknownPlayerGameStats(
    input: {gameId: $gameId, playerId: $playerId, publisherAccountId: $publisherAccountId}
  ) {
    jobId
  }
}
    `;
export type ResolveUnknownPlayerGameStatsMutationFn = Apollo.MutationFunction<ResolveUnknownPlayerGameStatsMutation, ResolveUnknownPlayerGameStatsMutationVariables>;

/**
 * __useResolveUnknownPlayerGameStatsMutation__
 *
 * To run a mutation, you first call `useResolveUnknownPlayerGameStatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveUnknownPlayerGameStatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveUnknownPlayerGameStatsMutation, { data, loading, error }] = useResolveUnknownPlayerGameStatsMutation({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      playerId: // value for 'playerId'
 *      publisherAccountId: // value for 'publisherAccountId'
 *   },
 * });
 */
export function useResolveUnknownPlayerGameStatsMutation(baseOptions?: Apollo.MutationHookOptions<ResolveUnknownPlayerGameStatsMutation, ResolveUnknownPlayerGameStatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveUnknownPlayerGameStatsMutation, ResolveUnknownPlayerGameStatsMutationVariables>(ResolveUnknownPlayerGameStatsDocument, options);
      }
export type ResolveUnknownPlayerGameStatsMutationHookResult = ReturnType<typeof useResolveUnknownPlayerGameStatsMutation>;
export type ResolveUnknownPlayerGameStatsMutationResult = Apollo.MutationResult<ResolveUnknownPlayerGameStatsMutation>;
export type ResolveUnknownPlayerGameStatsMutationOptions = Apollo.BaseMutationOptions<ResolveUnknownPlayerGameStatsMutation, ResolveUnknownPlayerGameStatsMutationVariables>;
export const AdminForfeitMatchDocument = gql`
    mutation adminForfeitMatch($matchId: UUID!, $losingTeamId: UUID!, $winningTeamId: UUID!, $forfeitReason: ForfeitReason) {
  adminForfeitMatch(
    input: {matchId: $matchId, losingTeamId: $losingTeamId, winningTeamId: $winningTeamId, forfeitReason: $forfeitReason}
  ) {
    jobId
  }
}
    `;
export type AdminForfeitMatchMutationFn = Apollo.MutationFunction<AdminForfeitMatchMutation, AdminForfeitMatchMutationVariables>;

/**
 * __useAdminForfeitMatchMutation__
 *
 * To run a mutation, you first call `useAdminForfeitMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForfeitMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForfeitMatchMutation, { data, loading, error }] = useAdminForfeitMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      losingTeamId: // value for 'losingTeamId'
 *      winningTeamId: // value for 'winningTeamId'
 *      forfeitReason: // value for 'forfeitReason'
 *   },
 * });
 */
export function useAdminForfeitMatchMutation(baseOptions?: Apollo.MutationHookOptions<AdminForfeitMatchMutation, AdminForfeitMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminForfeitMatchMutation, AdminForfeitMatchMutationVariables>(AdminForfeitMatchDocument, options);
      }
export type AdminForfeitMatchMutationHookResult = ReturnType<typeof useAdminForfeitMatchMutation>;
export type AdminForfeitMatchMutationResult = Apollo.MutationResult<AdminForfeitMatchMutation>;
export type AdminForfeitMatchMutationOptions = Apollo.BaseMutationOptions<AdminForfeitMatchMutation, AdminForfeitMatchMutationVariables>;
export const AdminAllForfeitMatchDocument = gql`
    mutation adminAllForfeitMatch($matchId: UUID!, $losingTeamIds: [UUID!]!, $forfeitReason: ForfeitReason) {
  adminAllForfeitMatch(
    input: {matchId: $matchId, losingTeamIds: $losingTeamIds, forfeitReason: $forfeitReason}
  ) {
    jobId
  }
}
    `;
export type AdminAllForfeitMatchMutationFn = Apollo.MutationFunction<AdminAllForfeitMatchMutation, AdminAllForfeitMatchMutationVariables>;

/**
 * __useAdminAllForfeitMatchMutation__
 *
 * To run a mutation, you first call `useAdminAllForfeitMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAllForfeitMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAllForfeitMatchMutation, { data, loading, error }] = useAdminAllForfeitMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      losingTeamIds: // value for 'losingTeamIds'
 *      forfeitReason: // value for 'forfeitReason'
 *   },
 * });
 */
export function useAdminAllForfeitMatchMutation(baseOptions?: Apollo.MutationHookOptions<AdminAllForfeitMatchMutation, AdminAllForfeitMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAllForfeitMatchMutation, AdminAllForfeitMatchMutationVariables>(AdminAllForfeitMatchDocument, options);
      }
export type AdminAllForfeitMatchMutationHookResult = ReturnType<typeof useAdminAllForfeitMatchMutation>;
export type AdminAllForfeitMatchMutationResult = Apollo.MutationResult<AdminAllForfeitMatchMutation>;
export type AdminAllForfeitMatchMutationOptions = Apollo.BaseMutationOptions<AdminAllForfeitMatchMutation, AdminAllForfeitMatchMutationVariables>;
export const AddTeamToMatchDocument = gql`
    mutation addTeamToMatch($matchId: UUID!, $teamId: UUID!) {
  createMatchResult(input: {matchId: $matchId, teamId: $teamId}) {
    matchResult {
      id
    }
  }
}
    `;
export type AddTeamToMatchMutationFn = Apollo.MutationFunction<AddTeamToMatchMutation, AddTeamToMatchMutationVariables>;

/**
 * __useAddTeamToMatchMutation__
 *
 * To run a mutation, you first call `useAddTeamToMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamToMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamToMatchMutation, { data, loading, error }] = useAddTeamToMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useAddTeamToMatchMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamToMatchMutation, AddTeamToMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamToMatchMutation, AddTeamToMatchMutationVariables>(AddTeamToMatchDocument, options);
      }
export type AddTeamToMatchMutationHookResult = ReturnType<typeof useAddTeamToMatchMutation>;
export type AddTeamToMatchMutationResult = Apollo.MutationResult<AddTeamToMatchMutation>;
export type AddTeamToMatchMutationOptions = Apollo.BaseMutationOptions<AddTeamToMatchMutation, AddTeamToMatchMutationVariables>;
export const AdminSubmitLeaderboardMatchGameResultsDocument = gql`
    mutation adminSubmitLeaderboardMatchGameResults($input: AdminSubmitLeaderboardMatchGameResultsInput!) {
  adminSubmitLeaderboardMatchGameResults(input: $input)
}
    `;
export type AdminSubmitLeaderboardMatchGameResultsMutationFn = Apollo.MutationFunction<AdminSubmitLeaderboardMatchGameResultsMutation, AdminSubmitLeaderboardMatchGameResultsMutationVariables>;

/**
 * __useAdminSubmitLeaderboardMatchGameResultsMutation__
 *
 * To run a mutation, you first call `useAdminSubmitLeaderboardMatchGameResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSubmitLeaderboardMatchGameResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSubmitLeaderboardMatchGameResultsMutation, { data, loading, error }] = useAdminSubmitLeaderboardMatchGameResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSubmitLeaderboardMatchGameResultsMutation(baseOptions?: Apollo.MutationHookOptions<AdminSubmitLeaderboardMatchGameResultsMutation, AdminSubmitLeaderboardMatchGameResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSubmitLeaderboardMatchGameResultsMutation, AdminSubmitLeaderboardMatchGameResultsMutationVariables>(AdminSubmitLeaderboardMatchGameResultsDocument, options);
      }
export type AdminSubmitLeaderboardMatchGameResultsMutationHookResult = ReturnType<typeof useAdminSubmitLeaderboardMatchGameResultsMutation>;
export type AdminSubmitLeaderboardMatchGameResultsMutationResult = Apollo.MutationResult<AdminSubmitLeaderboardMatchGameResultsMutation>;
export type AdminSubmitLeaderboardMatchGameResultsMutationOptions = Apollo.BaseMutationOptions<AdminSubmitLeaderboardMatchGameResultsMutation, AdminSubmitLeaderboardMatchGameResultsMutationVariables>;
export const GameAssistantStepUpdatedDocument = gql`
    subscription gameAssistantStepUpdated($input: GameAssistantStepUpdatedSubscribeInput!) {
  gameAssistantStepUpdated(input: $input) {
    ...GameAssistantStateUpdated
  }
}
    ${GameAssistantStateUpdatedFragmentDoc}`;

/**
 * __useGameAssistantStepUpdatedSubscription__
 *
 * To run a query within a React component, call `useGameAssistantStepUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGameAssistantStepUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameAssistantStepUpdatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGameAssistantStepUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GameAssistantStepUpdatedSubscription, GameAssistantStepUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GameAssistantStepUpdatedSubscription, GameAssistantStepUpdatedSubscriptionVariables>(GameAssistantStepUpdatedDocument, options);
      }
export type GameAssistantStepUpdatedSubscriptionHookResult = ReturnType<typeof useGameAssistantStepUpdatedSubscription>;
export type GameAssistantStepUpdatedSubscriptionResult = Apollo.SubscriptionResult<GameAssistantStepUpdatedSubscription>;
export const GetFinalMatchResultsDocument = gql`
    query getFinalMatchResults($id: UUID!) {
  match(id: $id) {
    id
    matchResults {
      teamId
      gamesWon
    }
  }
}
    `;

/**
 * __useGetFinalMatchResultsQuery__
 *
 * To run a query within a React component, call `useGetFinalMatchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinalMatchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinalMatchResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFinalMatchResultsQuery(baseOptions: Apollo.QueryHookOptions<GetFinalMatchResultsQuery, GetFinalMatchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinalMatchResultsQuery, GetFinalMatchResultsQueryVariables>(GetFinalMatchResultsDocument, options);
      }
export function useGetFinalMatchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinalMatchResultsQuery, GetFinalMatchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinalMatchResultsQuery, GetFinalMatchResultsQueryVariables>(GetFinalMatchResultsDocument, options);
        }
export type GetFinalMatchResultsQueryHookResult = ReturnType<typeof useGetFinalMatchResultsQuery>;
export type GetFinalMatchResultsLazyQueryHookResult = ReturnType<typeof useGetFinalMatchResultsLazyQuery>;
export type GetFinalMatchResultsQueryResult = Apollo.QueryResult<GetFinalMatchResultsQuery, GetFinalMatchResultsQueryVariables>;
export function refetchGetFinalMatchResultsQuery(variables: GetFinalMatchResultsQueryVariables) {
      return { query: GetFinalMatchResultsDocument, variables: variables }
    }
export const GetAvailableSpectatorsByTeamIdDocument = gql`
    query getAvailableSpectatorsByTeamId($teamId: UUID!) {
  availableSpectatorsByTeamId(teamId: $teamId) {
    spectators {
      id
      name
      avatarUrl
      userProviderAccounts {
        id
        userId
        providerName
        providerAccountId
        providerDisplayName
        providerIntegrationType
      }
    }
  }
}
    `;

/**
 * __useGetAvailableSpectatorsByTeamIdQuery__
 *
 * To run a query within a React component, call `useGetAvailableSpectatorsByTeamIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableSpectatorsByTeamIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableSpectatorsByTeamIdQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetAvailableSpectatorsByTeamIdQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableSpectatorsByTeamIdQuery, GetAvailableSpectatorsByTeamIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableSpectatorsByTeamIdQuery, GetAvailableSpectatorsByTeamIdQueryVariables>(GetAvailableSpectatorsByTeamIdDocument, options);
      }
export function useGetAvailableSpectatorsByTeamIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableSpectatorsByTeamIdQuery, GetAvailableSpectatorsByTeamIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableSpectatorsByTeamIdQuery, GetAvailableSpectatorsByTeamIdQueryVariables>(GetAvailableSpectatorsByTeamIdDocument, options);
        }
export type GetAvailableSpectatorsByTeamIdQueryHookResult = ReturnType<typeof useGetAvailableSpectatorsByTeamIdQuery>;
export type GetAvailableSpectatorsByTeamIdLazyQueryHookResult = ReturnType<typeof useGetAvailableSpectatorsByTeamIdLazyQuery>;
export type GetAvailableSpectatorsByTeamIdQueryResult = Apollo.QueryResult<GetAvailableSpectatorsByTeamIdQuery, GetAvailableSpectatorsByTeamIdQueryVariables>;
export function refetchGetAvailableSpectatorsByTeamIdQuery(variables: GetAvailableSpectatorsByTeamIdQueryVariables) {
      return { query: GetAvailableSpectatorsByTeamIdDocument, variables: variables }
    }
export const GetShowMatchAssistantDocument = gql`
    query getShowMatchAssistant($id: UUID!) {
  match(id: $id) {
    id
    matchAssistantEnabled
  }
}
    `;

/**
 * __useGetShowMatchAssistantQuery__
 *
 * To run a query within a React component, call `useGetShowMatchAssistantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShowMatchAssistantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShowMatchAssistantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShowMatchAssistantQuery(baseOptions: Apollo.QueryHookOptions<GetShowMatchAssistantQuery, GetShowMatchAssistantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShowMatchAssistantQuery, GetShowMatchAssistantQueryVariables>(GetShowMatchAssistantDocument, options);
      }
export function useGetShowMatchAssistantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShowMatchAssistantQuery, GetShowMatchAssistantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShowMatchAssistantQuery, GetShowMatchAssistantQueryVariables>(GetShowMatchAssistantDocument, options);
        }
export type GetShowMatchAssistantQueryHookResult = ReturnType<typeof useGetShowMatchAssistantQuery>;
export type GetShowMatchAssistantLazyQueryHookResult = ReturnType<typeof useGetShowMatchAssistantLazyQuery>;
export type GetShowMatchAssistantQueryResult = Apollo.QueryResult<GetShowMatchAssistantQuery, GetShowMatchAssistantQueryVariables>;
export function refetchGetShowMatchAssistantQuery(variables: GetShowMatchAssistantQueryVariables) {
      return { query: GetShowMatchAssistantDocument, variables: variables }
    }
export const ResetGameAssistantStepsForGameDocument = gql`
    mutation resetGameAssistantStepsForGame($matchId: UUID!, $seriesOrdinal: Int!, $gameOrdinal: Int!) {
  resetGameAssistantStepsForGame(
    matchId: $matchId
    seriesOrdinal: $seriesOrdinal
    gameOrdinal: $gameOrdinal
  ) {
    success
    currentStep {
      ...GameAssistantStepWithSelections
    }
  }
}
    ${GameAssistantStepWithSelectionsFragmentDoc}`;
export type ResetGameAssistantStepsForGameMutationFn = Apollo.MutationFunction<ResetGameAssistantStepsForGameMutation, ResetGameAssistantStepsForGameMutationVariables>;

/**
 * __useResetGameAssistantStepsForGameMutation__
 *
 * To run a mutation, you first call `useResetGameAssistantStepsForGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetGameAssistantStepsForGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetGameAssistantStepsForGameMutation, { data, loading, error }] = useResetGameAssistantStepsForGameMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      seriesOrdinal: // value for 'seriesOrdinal'
 *      gameOrdinal: // value for 'gameOrdinal'
 *   },
 * });
 */
export function useResetGameAssistantStepsForGameMutation(baseOptions?: Apollo.MutationHookOptions<ResetGameAssistantStepsForGameMutation, ResetGameAssistantStepsForGameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetGameAssistantStepsForGameMutation, ResetGameAssistantStepsForGameMutationVariables>(ResetGameAssistantStepsForGameDocument, options);
      }
export type ResetGameAssistantStepsForGameMutationHookResult = ReturnType<typeof useResetGameAssistantStepsForGameMutation>;
export type ResetGameAssistantStepsForGameMutationResult = Apollo.MutationResult<ResetGameAssistantStepsForGameMutation>;
export type ResetGameAssistantStepsForGameMutationOptions = Apollo.BaseMutationOptions<ResetGameAssistantStepsForGameMutation, ResetGameAssistantStepsForGameMutationVariables>;
export const ResetGameAssistantStepsForSeriesDocument = gql`
    mutation resetGameAssistantStepsForSeries($matchId: UUID!, $seriesOrdinal: Int!) {
  resetGameAssistantStepsForSeries(
    matchId: $matchId
    seriesOrdinal: $seriesOrdinal
  ) {
    success
    currentStep {
      ...GameAssistantStepWithSelections
    }
  }
}
    ${GameAssistantStepWithSelectionsFragmentDoc}`;
export type ResetGameAssistantStepsForSeriesMutationFn = Apollo.MutationFunction<ResetGameAssistantStepsForSeriesMutation, ResetGameAssistantStepsForSeriesMutationVariables>;

/**
 * __useResetGameAssistantStepsForSeriesMutation__
 *
 * To run a mutation, you first call `useResetGameAssistantStepsForSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetGameAssistantStepsForSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetGameAssistantStepsForSeriesMutation, { data, loading, error }] = useResetGameAssistantStepsForSeriesMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      seriesOrdinal: // value for 'seriesOrdinal'
 *   },
 * });
 */
export function useResetGameAssistantStepsForSeriesMutation(baseOptions?: Apollo.MutationHookOptions<ResetGameAssistantStepsForSeriesMutation, ResetGameAssistantStepsForSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetGameAssistantStepsForSeriesMutation, ResetGameAssistantStepsForSeriesMutationVariables>(ResetGameAssistantStepsForSeriesDocument, options);
      }
export type ResetGameAssistantStepsForSeriesMutationHookResult = ReturnType<typeof useResetGameAssistantStepsForSeriesMutation>;
export type ResetGameAssistantStepsForSeriesMutationResult = Apollo.MutationResult<ResetGameAssistantStepsForSeriesMutation>;
export type ResetGameAssistantStepsForSeriesMutationOptions = Apollo.BaseMutationOptions<ResetGameAssistantStepsForSeriesMutation, ResetGameAssistantStepsForSeriesMutationVariables>;
export const ResetGameAssistantStepsForMatchDocument = gql`
    mutation resetGameAssistantStepsForMatch($matchId: UUID!) {
  resetGameAssistantStepsForMatch(matchId: $matchId) {
    success
    currentStep {
      ...GameAssistantStepWithSelections
    }
  }
}
    ${GameAssistantStepWithSelectionsFragmentDoc}`;
export type ResetGameAssistantStepsForMatchMutationFn = Apollo.MutationFunction<ResetGameAssistantStepsForMatchMutation, ResetGameAssistantStepsForMatchMutationVariables>;

/**
 * __useResetGameAssistantStepsForMatchMutation__
 *
 * To run a mutation, you first call `useResetGameAssistantStepsForMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetGameAssistantStepsForMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetGameAssistantStepsForMatchMutation, { data, loading, error }] = useResetGameAssistantStepsForMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useResetGameAssistantStepsForMatchMutation(baseOptions?: Apollo.MutationHookOptions<ResetGameAssistantStepsForMatchMutation, ResetGameAssistantStepsForMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetGameAssistantStepsForMatchMutation, ResetGameAssistantStepsForMatchMutationVariables>(ResetGameAssistantStepsForMatchDocument, options);
      }
export type ResetGameAssistantStepsForMatchMutationHookResult = ReturnType<typeof useResetGameAssistantStepsForMatchMutation>;
export type ResetGameAssistantStepsForMatchMutationResult = Apollo.MutationResult<ResetGameAssistantStepsForMatchMutation>;
export type ResetGameAssistantStepsForMatchMutationOptions = Apollo.BaseMutationOptions<ResetGameAssistantStepsForMatchMutation, ResetGameAssistantStepsForMatchMutationVariables>;
export const GetCurrentGameAssistantStepByMatchIdDocument = gql`
    query getCurrentGameAssistantStepByMatchId($input: CurrentGameAssistantStateInput!) {
  currentGameAssistantStateByMatchId(input: $input) {
    ...GameAssistantState
  }
}
    ${GameAssistantStateFragmentDoc}`;

/**
 * __useGetCurrentGameAssistantStepByMatchIdQuery__
 *
 * To run a query within a React component, call `useGetCurrentGameAssistantStepByMatchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentGameAssistantStepByMatchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentGameAssistantStepByMatchIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCurrentGameAssistantStepByMatchIdQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentGameAssistantStepByMatchIdQuery, GetCurrentGameAssistantStepByMatchIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentGameAssistantStepByMatchIdQuery, GetCurrentGameAssistantStepByMatchIdQueryVariables>(GetCurrentGameAssistantStepByMatchIdDocument, options);
      }
export function useGetCurrentGameAssistantStepByMatchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentGameAssistantStepByMatchIdQuery, GetCurrentGameAssistantStepByMatchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentGameAssistantStepByMatchIdQuery, GetCurrentGameAssistantStepByMatchIdQueryVariables>(GetCurrentGameAssistantStepByMatchIdDocument, options);
        }
export type GetCurrentGameAssistantStepByMatchIdQueryHookResult = ReturnType<typeof useGetCurrentGameAssistantStepByMatchIdQuery>;
export type GetCurrentGameAssistantStepByMatchIdLazyQueryHookResult = ReturnType<typeof useGetCurrentGameAssistantStepByMatchIdLazyQuery>;
export type GetCurrentGameAssistantStepByMatchIdQueryResult = Apollo.QueryResult<GetCurrentGameAssistantStepByMatchIdQuery, GetCurrentGameAssistantStepByMatchIdQueryVariables>;
export function refetchGetCurrentGameAssistantStepByMatchIdQuery(variables: GetCurrentGameAssistantStepByMatchIdQueryVariables) {
      return { query: GetCurrentGameAssistantStepByMatchIdDocument, variables: variables }
    }
export const GetCurrentSeriesPlayerSelectionsByMatchIdDocument = gql`
    query getCurrentSeriesPlayerSelectionsByMatchId($matchId: UUID!, $teamId: UUID!) {
  currentSeriesPlayerSelectionsByMatchId(matchId: $matchId, teamId: $teamId) {
    players {
      ...MatchAssistantUser
    }
  }
}
    ${MatchAssistantUserFragmentDoc}`;

/**
 * __useGetCurrentSeriesPlayerSelectionsByMatchIdQuery__
 *
 * To run a query within a React component, call `useGetCurrentSeriesPlayerSelectionsByMatchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentSeriesPlayerSelectionsByMatchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentSeriesPlayerSelectionsByMatchIdQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetCurrentSeriesPlayerSelectionsByMatchIdQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentSeriesPlayerSelectionsByMatchIdQuery, GetCurrentSeriesPlayerSelectionsByMatchIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentSeriesPlayerSelectionsByMatchIdQuery, GetCurrentSeriesPlayerSelectionsByMatchIdQueryVariables>(GetCurrentSeriesPlayerSelectionsByMatchIdDocument, options);
      }
export function useGetCurrentSeriesPlayerSelectionsByMatchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentSeriesPlayerSelectionsByMatchIdQuery, GetCurrentSeriesPlayerSelectionsByMatchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentSeriesPlayerSelectionsByMatchIdQuery, GetCurrentSeriesPlayerSelectionsByMatchIdQueryVariables>(GetCurrentSeriesPlayerSelectionsByMatchIdDocument, options);
        }
export type GetCurrentSeriesPlayerSelectionsByMatchIdQueryHookResult = ReturnType<typeof useGetCurrentSeriesPlayerSelectionsByMatchIdQuery>;
export type GetCurrentSeriesPlayerSelectionsByMatchIdLazyQueryHookResult = ReturnType<typeof useGetCurrentSeriesPlayerSelectionsByMatchIdLazyQuery>;
export type GetCurrentSeriesPlayerSelectionsByMatchIdQueryResult = Apollo.QueryResult<GetCurrentSeriesPlayerSelectionsByMatchIdQuery, GetCurrentSeriesPlayerSelectionsByMatchIdQueryVariables>;
export function refetchGetCurrentSeriesPlayerSelectionsByMatchIdQuery(variables: GetCurrentSeriesPlayerSelectionsByMatchIdQueryVariables) {
      return { query: GetCurrentSeriesPlayerSelectionsByMatchIdDocument, variables: variables }
    }
export const SubmitGameAssistantStepSelectionsDocument = gql`
    mutation submitGameAssistantStepSelections($input: SubmitGameAssistantStepSelectionsInput!) {
  submitGameAssistantStepSelections(input: $input) {
    success
  }
}
    `;
export type SubmitGameAssistantStepSelectionsMutationFn = Apollo.MutationFunction<SubmitGameAssistantStepSelectionsMutation, SubmitGameAssistantStepSelectionsMutationVariables>;

/**
 * __useSubmitGameAssistantStepSelectionsMutation__
 *
 * To run a mutation, you first call `useSubmitGameAssistantStepSelectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGameAssistantStepSelectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGameAssistantStepSelectionsMutation, { data, loading, error }] = useSubmitGameAssistantStepSelectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitGameAssistantStepSelectionsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitGameAssistantStepSelectionsMutation, SubmitGameAssistantStepSelectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitGameAssistantStepSelectionsMutation, SubmitGameAssistantStepSelectionsMutationVariables>(SubmitGameAssistantStepSelectionsDocument, options);
      }
export type SubmitGameAssistantStepSelectionsMutationHookResult = ReturnType<typeof useSubmitGameAssistantStepSelectionsMutation>;
export type SubmitGameAssistantStepSelectionsMutationResult = Apollo.MutationResult<SubmitGameAssistantStepSelectionsMutation>;
export type SubmitGameAssistantStepSelectionsMutationOptions = Apollo.BaseMutationOptions<SubmitGameAssistantStepSelectionsMutation, SubmitGameAssistantStepSelectionsMutationVariables>;
export const RequestGameResetDocument = gql`
    mutation requestGameReset($input: RequestGameResetInput!) {
  requestGameReset(input: $input) {
    success
  }
}
    `;
export type RequestGameResetMutationFn = Apollo.MutationFunction<RequestGameResetMutation, RequestGameResetMutationVariables>;

/**
 * __useRequestGameResetMutation__
 *
 * To run a mutation, you first call `useRequestGameResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestGameResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestGameResetMutation, { data, loading, error }] = useRequestGameResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestGameResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestGameResetMutation, RequestGameResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestGameResetMutation, RequestGameResetMutationVariables>(RequestGameResetDocument, options);
      }
export type RequestGameResetMutationHookResult = ReturnType<typeof useRequestGameResetMutation>;
export type RequestGameResetMutationResult = Apollo.MutationResult<RequestGameResetMutation>;
export type RequestGameResetMutationOptions = Apollo.BaseMutationOptions<RequestGameResetMutation, RequestGameResetMutationVariables>;
export const RequestMatchAssistantBypassDocument = gql`
    mutation requestMatchAssistantBypass($input: RequestMatchAssistantBypassInput!) {
  requestMatchAssistantBypass(input: $input) {
    success
  }
}
    `;
export type RequestMatchAssistantBypassMutationFn = Apollo.MutationFunction<RequestMatchAssistantBypassMutation, RequestMatchAssistantBypassMutationVariables>;

/**
 * __useRequestMatchAssistantBypassMutation__
 *
 * To run a mutation, you first call `useRequestMatchAssistantBypassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMatchAssistantBypassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMatchAssistantBypassMutation, { data, loading, error }] = useRequestMatchAssistantBypassMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMatchAssistantBypassMutation(baseOptions?: Apollo.MutationHookOptions<RequestMatchAssistantBypassMutation, RequestMatchAssistantBypassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMatchAssistantBypassMutation, RequestMatchAssistantBypassMutationVariables>(RequestMatchAssistantBypassDocument, options);
      }
export type RequestMatchAssistantBypassMutationHookResult = ReturnType<typeof useRequestMatchAssistantBypassMutation>;
export type RequestMatchAssistantBypassMutationResult = Apollo.MutationResult<RequestMatchAssistantBypassMutation>;
export type RequestMatchAssistantBypassMutationOptions = Apollo.BaseMutationOptions<RequestMatchAssistantBypassMutation, RequestMatchAssistantBypassMutationVariables>;
export const RequestNextGameRosterChangeDocument = gql`
    mutation requestNextGameRosterChange($input: RequestNextGameRosterChangeForRocketLeagueInput!) {
  requestNextGameRosterChangeForRocketLeague(input: $input) {
    success
  }
}
    `;
export type RequestNextGameRosterChangeMutationFn = Apollo.MutationFunction<RequestNextGameRosterChangeMutation, RequestNextGameRosterChangeMutationVariables>;

/**
 * __useRequestNextGameRosterChangeMutation__
 *
 * To run a mutation, you first call `useRequestNextGameRosterChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNextGameRosterChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNextGameRosterChangeMutation, { data, loading, error }] = useRequestNextGameRosterChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestNextGameRosterChangeMutation(baseOptions?: Apollo.MutationHookOptions<RequestNextGameRosterChangeMutation, RequestNextGameRosterChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestNextGameRosterChangeMutation, RequestNextGameRosterChangeMutationVariables>(RequestNextGameRosterChangeDocument, options);
      }
export type RequestNextGameRosterChangeMutationHookResult = ReturnType<typeof useRequestNextGameRosterChangeMutation>;
export type RequestNextGameRosterChangeMutationResult = Apollo.MutationResult<RequestNextGameRosterChangeMutation>;
export type RequestNextGameRosterChangeMutationOptions = Apollo.BaseMutationOptions<RequestNextGameRosterChangeMutation, RequestNextGameRosterChangeMutationVariables>;
export const GetMatchForMatchAssistantDocument = gql`
    query getMatchForMatchAssistant($matchId: UUID!, $includeSeries: Boolean!) {
  match(id: $matchId) {
    id
    scheduledStartsAt
    bestOf
    status
    format
    games {
      id
      status
      seriesId
      ordinalNumber
      gameResults {
        id
        teamId
        sidePlayed
        placing
        score
      }
    }
    matchSettleRequests {
      id
      status
      type
      results {
        seriesResults {
          gameResults {
            winningTeamId
            winningTeamScore
            losingTeamScore
          }
        }
      }
    }
    matchResults {
      id
      teamId
      metaseasonId
      teamSide
      team {
        id
        name
        avatarUrl
        roster {
          id
          players {
            user {
              id
              name
              avatarUrl
              userProviderAccounts {
                id
                userId
                providerName
                providerDisplayName
              }
            }
          }
        }
        school {
          id
          name
        }
      }
      placing
      gamesWon
      seriesWon @include(if: $includeSeries)
    }
    series @include(if: $includeSeries) {
      id
      teamContext {
        seriesId
        teams {
          ...SeriesTeam
        }
      }
    }
    teamContext {
      matchId
      teams {
        ...MatchAssistantTeam
      }
      myTeams {
        ...MatchAssistantTeam
      }
      otherTeams {
        ...MatchAssistantTeam
      }
    }
    slot {
      id
      phase {
        id
        season {
          id
          metaseasonId
        }
      }
    }
  }
}
    ${SeriesTeamFragmentDoc}
${MatchAssistantTeamFragmentDoc}`;

/**
 * __useGetMatchForMatchAssistantQuery__
 *
 * To run a query within a React component, call `useGetMatchForMatchAssistantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchForMatchAssistantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchForMatchAssistantQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      includeSeries: // value for 'includeSeries'
 *   },
 * });
 */
export function useGetMatchForMatchAssistantQuery(baseOptions: Apollo.QueryHookOptions<GetMatchForMatchAssistantQuery, GetMatchForMatchAssistantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchForMatchAssistantQuery, GetMatchForMatchAssistantQueryVariables>(GetMatchForMatchAssistantDocument, options);
      }
export function useGetMatchForMatchAssistantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchForMatchAssistantQuery, GetMatchForMatchAssistantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchForMatchAssistantQuery, GetMatchForMatchAssistantQueryVariables>(GetMatchForMatchAssistantDocument, options);
        }
export type GetMatchForMatchAssistantQueryHookResult = ReturnType<typeof useGetMatchForMatchAssistantQuery>;
export type GetMatchForMatchAssistantLazyQueryHookResult = ReturnType<typeof useGetMatchForMatchAssistantLazyQuery>;
export type GetMatchForMatchAssistantQueryResult = Apollo.QueryResult<GetMatchForMatchAssistantQuery, GetMatchForMatchAssistantQueryVariables>;
export function refetchGetMatchForMatchAssistantQuery(variables: GetMatchForMatchAssistantQueryVariables) {
      return { query: GetMatchForMatchAssistantDocument, variables: variables }
    }
export const GetMatchResultsDocument = gql`
    query getMatchResults($id: UUID!) {
  match(id: $id) {
    id
    games {
      id
      status
      seriesId
      gameResults {
        id
        teamId
        sidePlayed
        placing
        score
      }
    }
    esport {
      id
      slug
      rating
    }
    series {
      id
      bestOf
      teamContext {
        seriesId
        teams {
          ...SeriesTeam
        }
      }
    }
    matchSettleRequests {
      id
      status
      type
      results {
        seriesResults {
          gameResults {
            winningTeamId
            winningTeamScore
            losingTeamScore
          }
        }
      }
    }
    games {
      id
      status
      seriesId
      gameResults {
        id
        teamId
        sidePlayed
        placing
        score
      }
    }
    matchResults {
      id
      teamId
      teamSide
      gamesWon
      seriesWon
      team {
        id
        name
        avatarUrl
        roster {
          id
          players {
            user {
              id
              name
              avatarUrl
              userProviderAccounts {
                id
                userId
                providerName
                providerDisplayName
              }
            }
          }
        }
        school {
          id
          name
        }
      }
    }
  }
}
    ${SeriesTeamFragmentDoc}`;

/**
 * __useGetMatchResultsQuery__
 *
 * To run a query within a React component, call `useGetMatchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMatchResultsQuery(baseOptions: Apollo.QueryHookOptions<GetMatchResultsQuery, GetMatchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchResultsQuery, GetMatchResultsQueryVariables>(GetMatchResultsDocument, options);
      }
export function useGetMatchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchResultsQuery, GetMatchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchResultsQuery, GetMatchResultsQueryVariables>(GetMatchResultsDocument, options);
        }
export type GetMatchResultsQueryHookResult = ReturnType<typeof useGetMatchResultsQuery>;
export type GetMatchResultsLazyQueryHookResult = ReturnType<typeof useGetMatchResultsLazyQuery>;
export type GetMatchResultsQueryResult = Apollo.QueryResult<GetMatchResultsQuery, GetMatchResultsQueryVariables>;
export function refetchGetMatchResultsQuery(variables: GetMatchResultsQueryVariables) {
      return { query: GetMatchResultsDocument, variables: variables }
    }
export const SubmitLeaderboardGameResultDocument = gql`
    mutation submitLeaderboardGameResult($input: SubmitLeaderboardGameResultLiveInput!) {
  submitLeaderboardGameResultLive(input: $input) {
    success
  }
}
    `;
export type SubmitLeaderboardGameResultMutationFn = Apollo.MutationFunction<SubmitLeaderboardGameResultMutation, SubmitLeaderboardGameResultMutationVariables>;

/**
 * __useSubmitLeaderboardGameResultMutation__
 *
 * To run a mutation, you first call `useSubmitLeaderboardGameResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLeaderboardGameResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLeaderboardGameResultMutation, { data, loading, error }] = useSubmitLeaderboardGameResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitLeaderboardGameResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLeaderboardGameResultMutation, SubmitLeaderboardGameResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLeaderboardGameResultMutation, SubmitLeaderboardGameResultMutationVariables>(SubmitLeaderboardGameResultDocument, options);
      }
export type SubmitLeaderboardGameResultMutationHookResult = ReturnType<typeof useSubmitLeaderboardGameResultMutation>;
export type SubmitLeaderboardGameResultMutationResult = Apollo.MutationResult<SubmitLeaderboardGameResultMutation>;
export type SubmitLeaderboardGameResultMutationOptions = Apollo.BaseMutationOptions<SubmitLeaderboardGameResultMutation, SubmitLeaderboardGameResultMutationVariables>;
export const GetMatchChatByUniqueIdDocument = gql`
    query getMatchChatByUniqueId($input: GetMatchChatByUniqueIdInput!) {
  getMatchChatByUniqueId(input: $input) {
    chat {
      sid
      matchId
      state
    }
  }
}
    `;

/**
 * __useGetMatchChatByUniqueIdQuery__
 *
 * To run a query within a React component, call `useGetMatchChatByUniqueIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchChatByUniqueIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchChatByUniqueIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMatchChatByUniqueIdQuery(baseOptions: Apollo.QueryHookOptions<GetMatchChatByUniqueIdQuery, GetMatchChatByUniqueIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchChatByUniqueIdQuery, GetMatchChatByUniqueIdQueryVariables>(GetMatchChatByUniqueIdDocument, options);
      }
export function useGetMatchChatByUniqueIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchChatByUniqueIdQuery, GetMatchChatByUniqueIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchChatByUniqueIdQuery, GetMatchChatByUniqueIdQueryVariables>(GetMatchChatByUniqueIdDocument, options);
        }
export type GetMatchChatByUniqueIdQueryHookResult = ReturnType<typeof useGetMatchChatByUniqueIdQuery>;
export type GetMatchChatByUniqueIdLazyQueryHookResult = ReturnType<typeof useGetMatchChatByUniqueIdLazyQuery>;
export type GetMatchChatByUniqueIdQueryResult = Apollo.QueryResult<GetMatchChatByUniqueIdQuery, GetMatchChatByUniqueIdQueryVariables>;
export function refetchGetMatchChatByUniqueIdQuery(variables: GetMatchChatByUniqueIdQueryVariables) {
      return { query: GetMatchChatByUniqueIdDocument, variables: variables }
    }
export const UpsertMatchCheckInDocument = gql`
    mutation upsertMatchCheckIn($params: MatchCheckInUpsertParams!) {
  upsertMatchCheckIn(params: $params) {
    id
    matchId
    teamId
    userId
    status
  }
}
    `;
export type UpsertMatchCheckInMutationFn = Apollo.MutationFunction<UpsertMatchCheckInMutation, UpsertMatchCheckInMutationVariables>;

/**
 * __useUpsertMatchCheckInMutation__
 *
 * To run a mutation, you first call `useUpsertMatchCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMatchCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMatchCheckInMutation, { data, loading, error }] = useUpsertMatchCheckInMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpsertMatchCheckInMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMatchCheckInMutation, UpsertMatchCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMatchCheckInMutation, UpsertMatchCheckInMutationVariables>(UpsertMatchCheckInDocument, options);
      }
export type UpsertMatchCheckInMutationHookResult = ReturnType<typeof useUpsertMatchCheckInMutation>;
export type UpsertMatchCheckInMutationResult = Apollo.MutationResult<UpsertMatchCheckInMutation>;
export type UpsertMatchCheckInMutationOptions = Apollo.BaseMutationOptions<UpsertMatchCheckInMutation, UpsertMatchCheckInMutationVariables>;
export const GetCheckInMatchesDocument = gql`
    query getCheckInMatches($offset: Int, $limit: Int, $filters: MatchFiltersInput, $isFortnite: Boolean!) {
  getMatches(offset: $offset, limit: $limit, filters: $filters) {
    totalCount
    matches {
      id
      isScrimmage
      scheduledStartsAt
      checkInOpensAt
      checkInClosesAt
      status
      name
      slotId
      league {
        id
        competitionGroup
        competitionModel
      }
      esport {
        id
        name
        slug
        rating
      }
      matchResults @skip(if: $isFortnite) {
        id
        matchId
        gamesWon
        gamesLost
        gamesTied
        team {
          id
          name
          deletedAt
          school {
            id
            name
            logoUrl
            slug
          }
        }
      }
      matchCheckIns {
        id
        matchId
        teamId
        status
        user {
          id
          avatarUrl
          name
        }
      }
      games {
        id
        status
        playerGameStats {
          id
          player {
            id
          }
        }
        winningTeam {
          id
          gameId
        }
        losingTeam {
          id
          gameId
        }
      }
      matchRescheduleRequests {
        status
        teamId
      }
      slot {
        id
        startsAt
        status
        phaseId
        phase {
          id
          name
          type
          seasonId
          season {
            id
            metaseasonId
            leagueId
            league {
              id
              timezone
            }
          }
        }
      }
      scheduleContext
    }
  }
}
    `;

/**
 * __useGetCheckInMatchesQuery__
 *
 * To run a query within a React component, call `useGetCheckInMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckInMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckInMatchesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      isFortnite: // value for 'isFortnite'
 *   },
 * });
 */
export function useGetCheckInMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetCheckInMatchesQuery, GetCheckInMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckInMatchesQuery, GetCheckInMatchesQueryVariables>(GetCheckInMatchesDocument, options);
      }
export function useGetCheckInMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckInMatchesQuery, GetCheckInMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckInMatchesQuery, GetCheckInMatchesQueryVariables>(GetCheckInMatchesDocument, options);
        }
export type GetCheckInMatchesQueryHookResult = ReturnType<typeof useGetCheckInMatchesQuery>;
export type GetCheckInMatchesLazyQueryHookResult = ReturnType<typeof useGetCheckInMatchesLazyQuery>;
export type GetCheckInMatchesQueryResult = Apollo.QueryResult<GetCheckInMatchesQuery, GetCheckInMatchesQueryVariables>;
export function refetchGetCheckInMatchesQuery(variables: GetCheckInMatchesQueryVariables) {
      return { query: GetCheckInMatchesDocument, variables: variables }
    }
export const GetTeamIdsForMatchDisputeDocument = gql`
    query getTeamIdsForMatchDispute($matchId: UUID!) {
  match(id: $matchId) {
    id
    teamContext {
      matchId
      teams {
        id
        isMyTeam
        school {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamIdsForMatchDisputeQuery__
 *
 * To run a query within a React component, call `useGetTeamIdsForMatchDisputeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamIdsForMatchDisputeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamIdsForMatchDisputeQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetTeamIdsForMatchDisputeQuery(baseOptions: Apollo.QueryHookOptions<GetTeamIdsForMatchDisputeQuery, GetTeamIdsForMatchDisputeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamIdsForMatchDisputeQuery, GetTeamIdsForMatchDisputeQueryVariables>(GetTeamIdsForMatchDisputeDocument, options);
      }
export function useGetTeamIdsForMatchDisputeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamIdsForMatchDisputeQuery, GetTeamIdsForMatchDisputeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamIdsForMatchDisputeQuery, GetTeamIdsForMatchDisputeQueryVariables>(GetTeamIdsForMatchDisputeDocument, options);
        }
export type GetTeamIdsForMatchDisputeQueryHookResult = ReturnType<typeof useGetTeamIdsForMatchDisputeQuery>;
export type GetTeamIdsForMatchDisputeLazyQueryHookResult = ReturnType<typeof useGetTeamIdsForMatchDisputeLazyQuery>;
export type GetTeamIdsForMatchDisputeQueryResult = Apollo.QueryResult<GetTeamIdsForMatchDisputeQuery, GetTeamIdsForMatchDisputeQueryVariables>;
export function refetchGetTeamIdsForMatchDisputeQuery(variables: GetTeamIdsForMatchDisputeQueryVariables) {
      return { query: GetTeamIdsForMatchDisputeDocument, variables: variables }
    }
export const FnMatchFaceoffDocument = gql`
    query fnMatchFaceoff($matchId: UUID!, $metaseasonId: UUID!) {
  me {
    id
    name
    roles {
      roleName
      userId
      resourceId
    }
    school {
      id
      name
      logoUrl
    }
    leagues(metaseasonId: $metaseasonId) {
      id
      esport {
        id
        slug
      }
    }
    teams(metaseasonId: $metaseasonId) {
      id
      name
      leagues(metaseasonId: $metaseasonId) {
        id
      }
    }
  }
  match(id: $matchId) {
    id
    isScrimmage
    name
    status
    scheduledStartsAt
    slot {
      id
      phase {
        id
        season {
          id
          leagueId
        }
      }
    }
    fortniteTeamMatchStats(limit: 9001, offset: 0) {
      myTeams {
        team {
          id
          name
        }
        stats {
          ... on FortniteTeamMatchStats {
            id
            rank
            totalPoints
            placementPoints
            eliminationPoints
          }
        }
      }
      updatedAt
      total
    }
  }
}
    `;

/**
 * __useFnMatchFaceoffQuery__
 *
 * To run a query within a React component, call `useFnMatchFaceoffQuery` and pass it any options that fit your needs.
 * When your component renders, `useFnMatchFaceoffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFnMatchFaceoffQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useFnMatchFaceoffQuery(baseOptions: Apollo.QueryHookOptions<FnMatchFaceoffQuery, FnMatchFaceoffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FnMatchFaceoffQuery, FnMatchFaceoffQueryVariables>(FnMatchFaceoffDocument, options);
      }
export function useFnMatchFaceoffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FnMatchFaceoffQuery, FnMatchFaceoffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FnMatchFaceoffQuery, FnMatchFaceoffQueryVariables>(FnMatchFaceoffDocument, options);
        }
export type FnMatchFaceoffQueryHookResult = ReturnType<typeof useFnMatchFaceoffQuery>;
export type FnMatchFaceoffLazyQueryHookResult = ReturnType<typeof useFnMatchFaceoffLazyQuery>;
export type FnMatchFaceoffQueryResult = Apollo.QueryResult<FnMatchFaceoffQuery, FnMatchFaceoffQueryVariables>;
export function refetchFnMatchFaceoffQuery(variables: FnMatchFaceoffQueryVariables) {
      return { query: FnMatchFaceoffDocument, variables: variables }
    }
export const JoinQueueDocument = gql`
    mutation joinQueue($input: JoinQueueInput!) {
  joinQueue(input: $input) {
    placeId
  }
}
    `;
export type JoinQueueMutationFn = Apollo.MutationFunction<JoinQueueMutation, JoinQueueMutationVariables>;

/**
 * __useJoinQueueMutation__
 *
 * To run a mutation, you first call `useJoinQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinQueueMutation, { data, loading, error }] = useJoinQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinQueueMutation(baseOptions?: Apollo.MutationHookOptions<JoinQueueMutation, JoinQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinQueueMutation, JoinQueueMutationVariables>(JoinQueueDocument, options);
      }
export type JoinQueueMutationHookResult = ReturnType<typeof useJoinQueueMutation>;
export type JoinQueueMutationResult = Apollo.MutationResult<JoinQueueMutation>;
export type JoinQueueMutationOptions = Apollo.BaseMutationOptions<JoinQueueMutation, JoinQueueMutationVariables>;
export const CheckPlaceInQueueDocument = gql`
    mutation checkPlaceInQueue($input: CheckPlaceInQueueInput!) {
  checkPlaceInQueue(input: $input) {
    status
    matchId
    opponentTeamId
  }
}
    `;
export type CheckPlaceInQueueMutationFn = Apollo.MutationFunction<CheckPlaceInQueueMutation, CheckPlaceInQueueMutationVariables>;

/**
 * __useCheckPlaceInQueueMutation__
 *
 * To run a mutation, you first call `useCheckPlaceInQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckPlaceInQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkPlaceInQueueMutation, { data, loading, error }] = useCheckPlaceInQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckPlaceInQueueMutation(baseOptions?: Apollo.MutationHookOptions<CheckPlaceInQueueMutation, CheckPlaceInQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckPlaceInQueueMutation, CheckPlaceInQueueMutationVariables>(CheckPlaceInQueueDocument, options);
      }
export type CheckPlaceInQueueMutationHookResult = ReturnType<typeof useCheckPlaceInQueueMutation>;
export type CheckPlaceInQueueMutationResult = Apollo.MutationResult<CheckPlaceInQueueMutation>;
export type CheckPlaceInQueueMutationOptions = Apollo.BaseMutationOptions<CheckPlaceInQueueMutation, CheckPlaceInQueueMutationVariables>;
export const LeaveQueueDocument = gql`
    mutation leaveQueue($input: LeaveQueueInput!) {
  leaveQueue(input: $input) {
    success
  }
}
    `;
export type LeaveQueueMutationFn = Apollo.MutationFunction<LeaveQueueMutation, LeaveQueueMutationVariables>;

/**
 * __useLeaveQueueMutation__
 *
 * To run a mutation, you first call `useLeaveQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveQueueMutation, { data, loading, error }] = useLeaveQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaveQueueMutation(baseOptions?: Apollo.MutationHookOptions<LeaveQueueMutation, LeaveQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveQueueMutation, LeaveQueueMutationVariables>(LeaveQueueDocument, options);
      }
export type LeaveQueueMutationHookResult = ReturnType<typeof useLeaveQueueMutation>;
export type LeaveQueueMutationResult = Apollo.MutationResult<LeaveQueueMutation>;
export type LeaveQueueMutationOptions = Apollo.BaseMutationOptions<LeaveQueueMutation, LeaveQueueMutationVariables>;
export const AcceptQueueDocument = gql`
    mutation acceptQueue($input: AcceptQueueInput!) {
  acceptQueue(input: $input) {
    placeId
  }
}
    `;
export type AcceptQueueMutationFn = Apollo.MutationFunction<AcceptQueueMutation, AcceptQueueMutationVariables>;

/**
 * __useAcceptQueueMutation__
 *
 * To run a mutation, you first call `useAcceptQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptQueueMutation, { data, loading, error }] = useAcceptQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptQueueMutation(baseOptions?: Apollo.MutationHookOptions<AcceptQueueMutation, AcceptQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptQueueMutation, AcceptQueueMutationVariables>(AcceptQueueDocument, options);
      }
export type AcceptQueueMutationHookResult = ReturnType<typeof useAcceptQueueMutation>;
export type AcceptQueueMutationResult = Apollo.MutationResult<AcceptQueueMutation>;
export type AcceptQueueMutationOptions = Apollo.BaseMutationOptions<AcceptQueueMutation, AcceptQueueMutationVariables>;
export const DeclineQueueDocument = gql`
    mutation declineQueue($input: DeclineQueueInput!) {
  declineQueue(input: $input) {
    placeId
  }
}
    `;
export type DeclineQueueMutationFn = Apollo.MutationFunction<DeclineQueueMutation, DeclineQueueMutationVariables>;

/**
 * __useDeclineQueueMutation__
 *
 * To run a mutation, you first call `useDeclineQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineQueueMutation, { data, loading, error }] = useDeclineQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineQueueMutation(baseOptions?: Apollo.MutationHookOptions<DeclineQueueMutation, DeclineQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineQueueMutation, DeclineQueueMutationVariables>(DeclineQueueDocument, options);
      }
export type DeclineQueueMutationHookResult = ReturnType<typeof useDeclineQueueMutation>;
export type DeclineQueueMutationResult = Apollo.MutationResult<DeclineQueueMutation>;
export type DeclineQueueMutationOptions = Apollo.BaseMutationOptions<DeclineQueueMutation, DeclineQueueMutationVariables>;
export const JoinSmartQueueDocument = gql`
    mutation joinSmartQueue($input: JoinSmartQueueInput!) {
  joinSmartQueue(input: $input) {
    success
    errors
  }
}
    `;
export type JoinSmartQueueMutationFn = Apollo.MutationFunction<JoinSmartQueueMutation, JoinSmartQueueMutationVariables>;

/**
 * __useJoinSmartQueueMutation__
 *
 * To run a mutation, you first call `useJoinSmartQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinSmartQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinSmartQueueMutation, { data, loading, error }] = useJoinSmartQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinSmartQueueMutation(baseOptions?: Apollo.MutationHookOptions<JoinSmartQueueMutation, JoinSmartQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinSmartQueueMutation, JoinSmartQueueMutationVariables>(JoinSmartQueueDocument, options);
      }
export type JoinSmartQueueMutationHookResult = ReturnType<typeof useJoinSmartQueueMutation>;
export type JoinSmartQueueMutationResult = Apollo.MutationResult<JoinSmartQueueMutation>;
export type JoinSmartQueueMutationOptions = Apollo.BaseMutationOptions<JoinSmartQueueMutation, JoinSmartQueueMutationVariables>;
export const LeaveSmartQueueDocument = gql`
    mutation leaveSmartQueue($input: LeaveSmartQueueInput!) {
  leaveSmartQueue(input: $input) {
    success
    errors
  }
}
    `;
export type LeaveSmartQueueMutationFn = Apollo.MutationFunction<LeaveSmartQueueMutation, LeaveSmartQueueMutationVariables>;

/**
 * __useLeaveSmartQueueMutation__
 *
 * To run a mutation, you first call `useLeaveSmartQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveSmartQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveSmartQueueMutation, { data, loading, error }] = useLeaveSmartQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaveSmartQueueMutation(baseOptions?: Apollo.MutationHookOptions<LeaveSmartQueueMutation, LeaveSmartQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveSmartQueueMutation, LeaveSmartQueueMutationVariables>(LeaveSmartQueueDocument, options);
      }
export type LeaveSmartQueueMutationHookResult = ReturnType<typeof useLeaveSmartQueueMutation>;
export type LeaveSmartQueueMutationResult = Apollo.MutationResult<LeaveSmartQueueMutation>;
export type LeaveSmartQueueMutationOptions = Apollo.BaseMutationOptions<LeaveSmartQueueMutation, LeaveSmartQueueMutationVariables>;
export const CheckPlaceInSmartQueueDocument = gql`
    query checkPlaceInSmartQueue($input: CheckPlaceInSmartQueueInput!) {
  checkPlaceInSmartQueue(input: $input) {
    ...CheckPlaceInSmartQueueState
  }
}
    ${CheckPlaceInSmartQueueStateFragmentDoc}`;

/**
 * __useCheckPlaceInSmartQueueQuery__
 *
 * To run a query within a React component, call `useCheckPlaceInSmartQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPlaceInSmartQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPlaceInSmartQueueQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckPlaceInSmartQueueQuery(baseOptions: Apollo.QueryHookOptions<CheckPlaceInSmartQueueQuery, CheckPlaceInSmartQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckPlaceInSmartQueueQuery, CheckPlaceInSmartQueueQueryVariables>(CheckPlaceInSmartQueueDocument, options);
      }
export function useCheckPlaceInSmartQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckPlaceInSmartQueueQuery, CheckPlaceInSmartQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckPlaceInSmartQueueQuery, CheckPlaceInSmartQueueQueryVariables>(CheckPlaceInSmartQueueDocument, options);
        }
export type CheckPlaceInSmartQueueQueryHookResult = ReturnType<typeof useCheckPlaceInSmartQueueQuery>;
export type CheckPlaceInSmartQueueLazyQueryHookResult = ReturnType<typeof useCheckPlaceInSmartQueueLazyQuery>;
export type CheckPlaceInSmartQueueQueryResult = Apollo.QueryResult<CheckPlaceInSmartQueueQuery, CheckPlaceInSmartQueueQueryVariables>;
export function refetchCheckPlaceInSmartQueueQuery(variables: CheckPlaceInSmartQueueQueryVariables) {
      return { query: CheckPlaceInSmartQueueDocument, variables: variables }
    }
export const SmartQueueStateUpdatedDocument = gql`
    subscription smartQueueStateUpdated($input: SmartQueueUpdateSubscribeInput!) {
  smartQueueStateUpdated(input: $input) {
    ...CheckPlaceInSmartQueueStateUpdated
  }
}
    ${CheckPlaceInSmartQueueStateUpdatedFragmentDoc}`;

/**
 * __useSmartQueueStateUpdatedSubscription__
 *
 * To run a query within a React component, call `useSmartQueueStateUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSmartQueueStateUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartQueueStateUpdatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSmartQueueStateUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SmartQueueStateUpdatedSubscription, SmartQueueStateUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SmartQueueStateUpdatedSubscription, SmartQueueStateUpdatedSubscriptionVariables>(SmartQueueStateUpdatedDocument, options);
      }
export type SmartQueueStateUpdatedSubscriptionHookResult = ReturnType<typeof useSmartQueueStateUpdatedSubscription>;
export type SmartQueueStateUpdatedSubscriptionResult = Apollo.SubscriptionResult<SmartQueueStateUpdatedSubscription>;
export const JoinPreseasonQueueDocument = gql`
    mutation joinPreseasonQueue($teamId: String!) {
  joinPreseasonQueue(teamId: $teamId) {
    success
    errors
  }
}
    `;
export type JoinPreseasonQueueMutationFn = Apollo.MutationFunction<JoinPreseasonQueueMutation, JoinPreseasonQueueMutationVariables>;

/**
 * __useJoinPreseasonQueueMutation__
 *
 * To run a mutation, you first call `useJoinPreseasonQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinPreseasonQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinPreseasonQueueMutation, { data, loading, error }] = useJoinPreseasonQueueMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useJoinPreseasonQueueMutation(baseOptions?: Apollo.MutationHookOptions<JoinPreseasonQueueMutation, JoinPreseasonQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinPreseasonQueueMutation, JoinPreseasonQueueMutationVariables>(JoinPreseasonQueueDocument, options);
      }
export type JoinPreseasonQueueMutationHookResult = ReturnType<typeof useJoinPreseasonQueueMutation>;
export type JoinPreseasonQueueMutationResult = Apollo.MutationResult<JoinPreseasonQueueMutation>;
export type JoinPreseasonQueueMutationOptions = Apollo.BaseMutationOptions<JoinPreseasonQueueMutation, JoinPreseasonQueueMutationVariables>;
export const LeavePreseasonQueueDocument = gql`
    mutation leavePreseasonQueue($teamId: String!) {
  leavePreseasonQueue(teamId: $teamId) {
    success
    errors
  }
}
    `;
export type LeavePreseasonQueueMutationFn = Apollo.MutationFunction<LeavePreseasonQueueMutation, LeavePreseasonQueueMutationVariables>;

/**
 * __useLeavePreseasonQueueMutation__
 *
 * To run a mutation, you first call `useLeavePreseasonQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeavePreseasonQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leavePreseasonQueueMutation, { data, loading, error }] = useLeavePreseasonQueueMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useLeavePreseasonQueueMutation(baseOptions?: Apollo.MutationHookOptions<LeavePreseasonQueueMutation, LeavePreseasonQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeavePreseasonQueueMutation, LeavePreseasonQueueMutationVariables>(LeavePreseasonQueueDocument, options);
      }
export type LeavePreseasonQueueMutationHookResult = ReturnType<typeof useLeavePreseasonQueueMutation>;
export type LeavePreseasonQueueMutationResult = Apollo.MutationResult<LeavePreseasonQueueMutation>;
export type LeavePreseasonQueueMutationOptions = Apollo.BaseMutationOptions<LeavePreseasonQueueMutation, LeavePreseasonQueueMutationVariables>;
export const CheckPlaceInPreseasonQueueDocument = gql`
    query checkPlaceInPreseasonQueue($teamId: String!) {
  checkPlaceInPreseasonQueue(teamId: $teamId) {
    success
    errors
    ...PreseasonQueueData
  }
}
    ${PreseasonQueueDataFragmentDoc}`;

/**
 * __useCheckPlaceInPreseasonQueueQuery__
 *
 * To run a query within a React component, call `useCheckPlaceInPreseasonQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPlaceInPreseasonQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPlaceInPreseasonQueueQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useCheckPlaceInPreseasonQueueQuery(baseOptions: Apollo.QueryHookOptions<CheckPlaceInPreseasonQueueQuery, CheckPlaceInPreseasonQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckPlaceInPreseasonQueueQuery, CheckPlaceInPreseasonQueueQueryVariables>(CheckPlaceInPreseasonQueueDocument, options);
      }
export function useCheckPlaceInPreseasonQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckPlaceInPreseasonQueueQuery, CheckPlaceInPreseasonQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckPlaceInPreseasonQueueQuery, CheckPlaceInPreseasonQueueQueryVariables>(CheckPlaceInPreseasonQueueDocument, options);
        }
export type CheckPlaceInPreseasonQueueQueryHookResult = ReturnType<typeof useCheckPlaceInPreseasonQueueQuery>;
export type CheckPlaceInPreseasonQueueLazyQueryHookResult = ReturnType<typeof useCheckPlaceInPreseasonQueueLazyQuery>;
export type CheckPlaceInPreseasonQueueQueryResult = Apollo.QueryResult<CheckPlaceInPreseasonQueueQuery, CheckPlaceInPreseasonQueueQueryVariables>;
export function refetchCheckPlaceInPreseasonQueueQuery(variables: CheckPlaceInPreseasonQueueQueryVariables) {
      return { query: CheckPlaceInPreseasonQueueDocument, variables: variables }
    }
export const MatchStatsHeaderDocument = gql`
    query matchStatsHeader($needAttentionFilters: MatchFiltersInput, $liveMatchesFilters: MatchFiltersInput, $getTeamsFilters: TeamFiltersInput, $scheduledMatchesFilters: MatchFiltersInput) {
  needAttention: getMatches(filters: $needAttentionFilters) {
    totalCount
  }
  liveMatches: getMatches(filters: $liveMatchesFilters) {
    totalCount
  }
  teamsParticipating: getTeams(filters: $getTeamsFilters) {
    totalCount
  }
  scheduledMatches: getMatches(filters: $scheduledMatchesFilters) {
    totalCount
  }
}
    `;

/**
 * __useMatchStatsHeaderQuery__
 *
 * To run a query within a React component, call `useMatchStatsHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchStatsHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchStatsHeaderQuery({
 *   variables: {
 *      needAttentionFilters: // value for 'needAttentionFilters'
 *      liveMatchesFilters: // value for 'liveMatchesFilters'
 *      getTeamsFilters: // value for 'getTeamsFilters'
 *      scheduledMatchesFilters: // value for 'scheduledMatchesFilters'
 *   },
 * });
 */
export function useMatchStatsHeaderQuery(baseOptions?: Apollo.QueryHookOptions<MatchStatsHeaderQuery, MatchStatsHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchStatsHeaderQuery, MatchStatsHeaderQueryVariables>(MatchStatsHeaderDocument, options);
      }
export function useMatchStatsHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchStatsHeaderQuery, MatchStatsHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchStatsHeaderQuery, MatchStatsHeaderQueryVariables>(MatchStatsHeaderDocument, options);
        }
export type MatchStatsHeaderQueryHookResult = ReturnType<typeof useMatchStatsHeaderQuery>;
export type MatchStatsHeaderLazyQueryHookResult = ReturnType<typeof useMatchStatsHeaderLazyQuery>;
export type MatchStatsHeaderQueryResult = Apollo.QueryResult<MatchStatsHeaderQuery, MatchStatsHeaderQueryVariables>;
export function refetchMatchStatsHeaderQuery(variables?: MatchStatsHeaderQueryVariables) {
      return { query: MatchStatsHeaderDocument, variables: variables }
    }
export const GetMatchSeriesResultsDocument = gql`
    query getMatchSeriesResults($matchId: UUID!) {
  match(id: $matchId) {
    id
    bestOf
    scheduledStartsAt
    matchResults {
      id
      metaseasonId
      team {
        id
        isMyTeam
      }
    }
    games {
      id
      status
    }
    teamContext {
      matchId
      teams {
        ...MatchResultTeam
      }
    }
    series {
      id
      bestOf
      games {
        id
        ordinalNumber
        teamContext {
          gameId
          teams {
            id
            gameId
            result {
              id
              placing
            }
          }
        }
      }
      teamContext {
        seriesId
        teams {
          ...MatchSeriesTeam
        }
      }
    }
  }
}
    ${MatchResultTeamFragmentDoc}
${MatchSeriesTeamFragmentDoc}`;

/**
 * __useGetMatchSeriesResultsQuery__
 *
 * To run a query within a React component, call `useGetMatchSeriesResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchSeriesResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchSeriesResultsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchSeriesResultsQuery(baseOptions: Apollo.QueryHookOptions<GetMatchSeriesResultsQuery, GetMatchSeriesResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchSeriesResultsQuery, GetMatchSeriesResultsQueryVariables>(GetMatchSeriesResultsDocument, options);
      }
export function useGetMatchSeriesResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchSeriesResultsQuery, GetMatchSeriesResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchSeriesResultsQuery, GetMatchSeriesResultsQueryVariables>(GetMatchSeriesResultsDocument, options);
        }
export type GetMatchSeriesResultsQueryHookResult = ReturnType<typeof useGetMatchSeriesResultsQuery>;
export type GetMatchSeriesResultsLazyQueryHookResult = ReturnType<typeof useGetMatchSeriesResultsLazyQuery>;
export type GetMatchSeriesResultsQueryResult = Apollo.QueryResult<GetMatchSeriesResultsQuery, GetMatchSeriesResultsQueryVariables>;
export function refetchGetMatchSeriesResultsQuery(variables: GetMatchSeriesResultsQueryVariables) {
      return { query: GetMatchSeriesResultsDocument, variables: variables }
    }
export const GetMatchReportHistoryDocument = gql`
    query getMatchReportHistory($matchId: UUID!, $fetchInput: FetchMatchSettleRequestInput!) {
  match(id: $matchId) {
    id
    status
    series {
      id
      teamContext {
        seriesId
        teams {
          id
          seriesId
          name
          roster {
            id
            name
          }
        }
      }
    }
    matchDisputeRequests {
      id
      requestedBy {
        id
        name
      }
      reason
      notes
      status
      asset {
        id
        fileName
        signedUrl
      }
      createdAt
      updatedAt
    }
    forfeitedByUser {
      id
      name
    }
    forfeitReason
    forfeitDetail
    autoForfeited
    updatedAt
  }
  fetchMatchSettleRequest(input: $fetchInput) {
    success
    errors
    matchSettleRequest {
      id
      createdAt
      updatedAt
      status
      type
      incompleteReason
      incompleteNotes
      matchId
      teamId
      requestedById
      isReadyForReview
      forfeitReason
      results {
        seriesResults {
          id
          ordinalNumber
          gameResults {
            ordinalNumber
            winningTeam {
              id
              name
            }
            losingTeamId
            incompleteReason
            assets {
              id
              fileName
              signedUrl
            }
          }
        }
      }
      requestedBy {
        id
        name
      }
      team {
        id
        name
      }
      match {
        id
        bestOf
        esport {
          id
          slug
        }
        games {
          id
          status
          ordinalNumber
          winningTeam {
            id
            name
            gameId
          }
        }
        series {
          id
          bestOf
          games {
            id
            status
            ordinalNumber
            winningTeam {
              id
              name
              gameId
            }
          }
          teamContext {
            seriesId
            teams {
              id
              seriesId
              name
              roster {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMatchReportHistoryQuery__
 *
 * To run a query within a React component, call `useGetMatchReportHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchReportHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchReportHistoryQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      fetchInput: // value for 'fetchInput'
 *   },
 * });
 */
export function useGetMatchReportHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetMatchReportHistoryQuery, GetMatchReportHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchReportHistoryQuery, GetMatchReportHistoryQueryVariables>(GetMatchReportHistoryDocument, options);
      }
export function useGetMatchReportHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchReportHistoryQuery, GetMatchReportHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchReportHistoryQuery, GetMatchReportHistoryQueryVariables>(GetMatchReportHistoryDocument, options);
        }
export type GetMatchReportHistoryQueryHookResult = ReturnType<typeof useGetMatchReportHistoryQuery>;
export type GetMatchReportHistoryLazyQueryHookResult = ReturnType<typeof useGetMatchReportHistoryLazyQuery>;
export type GetMatchReportHistoryQueryResult = Apollo.QueryResult<GetMatchReportHistoryQuery, GetMatchReportHistoryQueryVariables>;
export function refetchGetMatchReportHistoryQuery(variables: GetMatchReportHistoryQueryVariables) {
      return { query: GetMatchReportHistoryDocument, variables: variables }
    }
export const MatchResultsDocument = gql`
    query matchResults($matchId: UUID!, $limit: Int) {
  match(id: $matchId) {
    id
    bestOf
    matchResults {
      id
      placing
      teamSide
      team {
        id
        name
      }
      gamesWon
      gamesLost
      seriesWon
      seriesLost
    }
    teamContext {
      matchId
      teams {
        id
        name
      }
    }
    games {
      id
      gameResults(limit: $limit) {
        id
        placing
        teamId
      }
    }
  }
}
    `;

/**
 * __useMatchResultsQuery__
 *
 * To run a query within a React component, call `useMatchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchResultsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMatchResultsQuery(baseOptions: Apollo.QueryHookOptions<MatchResultsQuery, MatchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchResultsQuery, MatchResultsQueryVariables>(MatchResultsDocument, options);
      }
export function useMatchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchResultsQuery, MatchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchResultsQuery, MatchResultsQueryVariables>(MatchResultsDocument, options);
        }
export type MatchResultsQueryHookResult = ReturnType<typeof useMatchResultsQuery>;
export type MatchResultsLazyQueryHookResult = ReturnType<typeof useMatchResultsLazyQuery>;
export type MatchResultsQueryResult = Apollo.QueryResult<MatchResultsQuery, MatchResultsQueryVariables>;
export function refetchMatchResultsQuery(variables: MatchResultsQueryVariables) {
      return { query: MatchResultsDocument, variables: variables }
    }
export const GetTeamMatchStatsDocument = gql`
    query getTeamMatchStats($limit: Int, $offset: Int, $filters: TeamMatchStatsFiltersInput) {
  getTeamMatchStats(limit: $limit, offset: $offset, filters: $filters) {
    total
    results {
      id
    }
  }
}
    `;

/**
 * __useGetTeamMatchStatsQuery__
 *
 * To run a query within a React component, call `useGetTeamMatchStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMatchStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMatchStatsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTeamMatchStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamMatchStatsQuery, GetTeamMatchStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMatchStatsQuery, GetTeamMatchStatsQueryVariables>(GetTeamMatchStatsDocument, options);
      }
export function useGetTeamMatchStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMatchStatsQuery, GetTeamMatchStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMatchStatsQuery, GetTeamMatchStatsQueryVariables>(GetTeamMatchStatsDocument, options);
        }
export type GetTeamMatchStatsQueryHookResult = ReturnType<typeof useGetTeamMatchStatsQuery>;
export type GetTeamMatchStatsLazyQueryHookResult = ReturnType<typeof useGetTeamMatchStatsLazyQuery>;
export type GetTeamMatchStatsQueryResult = Apollo.QueryResult<GetTeamMatchStatsQuery, GetTeamMatchStatsQueryVariables>;
export function refetchGetTeamMatchStatsQuery(variables?: GetTeamMatchStatsQueryVariables) {
      return { query: GetTeamMatchStatsDocument, variables: variables }
    }
export const GetSmashUltimateStatsDocument = gql`
    query getSmashUltimateStats($input: GetSmashUltimateMostPlayedStatsByPlayerIdsInput!, $esportSlug: EsportSlug) {
  getSmashUltimateMostPlayedStatsByPlayerIds(
    input: $input
    esportSlug: $esportSlug
  ) {
    ...SmashUltimateStats
  }
}
    ${SmashUltimateStatsFragmentDoc}`;

/**
 * __useGetSmashUltimateStatsQuery__
 *
 * To run a query within a React component, call `useGetSmashUltimateStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmashUltimateStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmashUltimateStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      esportSlug: // value for 'esportSlug'
 *   },
 * });
 */
export function useGetSmashUltimateStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSmashUltimateStatsQuery, GetSmashUltimateStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmashUltimateStatsQuery, GetSmashUltimateStatsQueryVariables>(GetSmashUltimateStatsDocument, options);
      }
export function useGetSmashUltimateStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmashUltimateStatsQuery, GetSmashUltimateStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmashUltimateStatsQuery, GetSmashUltimateStatsQueryVariables>(GetSmashUltimateStatsDocument, options);
        }
export type GetSmashUltimateStatsQueryHookResult = ReturnType<typeof useGetSmashUltimateStatsQuery>;
export type GetSmashUltimateStatsLazyQueryHookResult = ReturnType<typeof useGetSmashUltimateStatsLazyQuery>;
export type GetSmashUltimateStatsQueryResult = Apollo.QueryResult<GetSmashUltimateStatsQuery, GetSmashUltimateStatsQueryVariables>;
export function refetchGetSmashUltimateStatsQuery(variables: GetSmashUltimateStatsQueryVariables) {
      return { query: GetSmashUltimateStatsDocument, variables: variables }
    }
export const GetSmashGameStatsDocument = gql`
    query getSmashGameStats($input: [GetSmashUltimatePlayerStatsByGameIdsInput!]!, $esportSlug: EsportSlug) {
  getSmashUltimatePlayerStatsByGameIds(input: $input, esportSlug: $esportSlug) {
    results {
      ...SmashUltimateGameStatsResults
    }
  }
}
    ${SmashUltimateGameStatsResultsFragmentDoc}`;

/**
 * __useGetSmashGameStatsQuery__
 *
 * To run a query within a React component, call `useGetSmashGameStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmashGameStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmashGameStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      esportSlug: // value for 'esportSlug'
 *   },
 * });
 */
export function useGetSmashGameStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSmashGameStatsQuery, GetSmashGameStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmashGameStatsQuery, GetSmashGameStatsQueryVariables>(GetSmashGameStatsDocument, options);
      }
export function useGetSmashGameStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmashGameStatsQuery, GetSmashGameStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmashGameStatsQuery, GetSmashGameStatsQueryVariables>(GetSmashGameStatsDocument, options);
        }
export type GetSmashGameStatsQueryHookResult = ReturnType<typeof useGetSmashGameStatsQuery>;
export type GetSmashGameStatsLazyQueryHookResult = ReturnType<typeof useGetSmashGameStatsLazyQuery>;
export type GetSmashGameStatsQueryResult = Apollo.QueryResult<GetSmashGameStatsQuery, GetSmashGameStatsQueryVariables>;
export function refetchGetSmashGameStatsQuery(variables: GetSmashGameStatsQueryVariables) {
      return { query: GetSmashGameStatsDocument, variables: variables }
    }
export const GetPlayerGameStatsByMatchIdDocument = gql`
    query getPlayerGameStatsByMatchId($matchId: UUID!) {
  getPlayerGameStatsByMatchId(matchId: $matchId) {
    ...PlayerGameStats
  }
}
    ${PlayerGameStatsFragmentDoc}`;

/**
 * __useGetPlayerGameStatsByMatchIdQuery__
 *
 * To run a query within a React component, call `useGetPlayerGameStatsByMatchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerGameStatsByMatchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerGameStatsByMatchIdQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetPlayerGameStatsByMatchIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerGameStatsByMatchIdQuery, GetPlayerGameStatsByMatchIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerGameStatsByMatchIdQuery, GetPlayerGameStatsByMatchIdQueryVariables>(GetPlayerGameStatsByMatchIdDocument, options);
      }
export function useGetPlayerGameStatsByMatchIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerGameStatsByMatchIdQuery, GetPlayerGameStatsByMatchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerGameStatsByMatchIdQuery, GetPlayerGameStatsByMatchIdQueryVariables>(GetPlayerGameStatsByMatchIdDocument, options);
        }
export type GetPlayerGameStatsByMatchIdQueryHookResult = ReturnType<typeof useGetPlayerGameStatsByMatchIdQuery>;
export type GetPlayerGameStatsByMatchIdLazyQueryHookResult = ReturnType<typeof useGetPlayerGameStatsByMatchIdLazyQuery>;
export type GetPlayerGameStatsByMatchIdQueryResult = Apollo.QueryResult<GetPlayerGameStatsByMatchIdQuery, GetPlayerGameStatsByMatchIdQueryVariables>;
export function refetchGetPlayerGameStatsByMatchIdQuery(variables: GetPlayerGameStatsByMatchIdQueryVariables) {
      return { query: GetPlayerGameStatsByMatchIdDocument, variables: variables }
    }
export const GetPlayerSeasonStatsDocument = gql`
    query getPlayerSeasonStats($input: PlayerSeasonStatsInput!) {
  getPlayerSeasonStats(input: $input) {
    results {
      ...PlayerSeasonStats
    }
  }
}
    ${PlayerSeasonStatsFragmentDoc}`;

/**
 * __useGetPlayerSeasonStatsQuery__
 *
 * To run a query within a React component, call `useGetPlayerSeasonStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerSeasonStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerSeasonStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPlayerSeasonStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerSeasonStatsQuery, GetPlayerSeasonStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerSeasonStatsQuery, GetPlayerSeasonStatsQueryVariables>(GetPlayerSeasonStatsDocument, options);
      }
export function useGetPlayerSeasonStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerSeasonStatsQuery, GetPlayerSeasonStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerSeasonStatsQuery, GetPlayerSeasonStatsQueryVariables>(GetPlayerSeasonStatsDocument, options);
        }
export type GetPlayerSeasonStatsQueryHookResult = ReturnType<typeof useGetPlayerSeasonStatsQuery>;
export type GetPlayerSeasonStatsLazyQueryHookResult = ReturnType<typeof useGetPlayerSeasonStatsLazyQuery>;
export type GetPlayerSeasonStatsQueryResult = Apollo.QueryResult<GetPlayerSeasonStatsQuery, GetPlayerSeasonStatsQueryVariables>;
export function refetchGetPlayerSeasonStatsQuery(variables: GetPlayerSeasonStatsQueryVariables) {
      return { query: GetPlayerSeasonStatsDocument, variables: variables }
    }
export const CreateMatchSurveyResponseDocument = gql`
    mutation createMatchSurveyResponse($matchSurveyInput: MatchSurveyInput!) {
  createMatchSurveyResponse(input: $matchSurveyInput) {
    matchId
    userId
    matchSetupRating
    opponentCompetitivenessRating
    funRating
    surveyComment
    shouldContact
  }
}
    `;
export type CreateMatchSurveyResponseMutationFn = Apollo.MutationFunction<CreateMatchSurveyResponseMutation, CreateMatchSurveyResponseMutationVariables>;

/**
 * __useCreateMatchSurveyResponseMutation__
 *
 * To run a mutation, you first call `useCreateMatchSurveyResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatchSurveyResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatchSurveyResponseMutation, { data, loading, error }] = useCreateMatchSurveyResponseMutation({
 *   variables: {
 *      matchSurveyInput: // value for 'matchSurveyInput'
 *   },
 * });
 */
export function useCreateMatchSurveyResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateMatchSurveyResponseMutation, CreateMatchSurveyResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMatchSurveyResponseMutation, CreateMatchSurveyResponseMutationVariables>(CreateMatchSurveyResponseDocument, options);
      }
export type CreateMatchSurveyResponseMutationHookResult = ReturnType<typeof useCreateMatchSurveyResponseMutation>;
export type CreateMatchSurveyResponseMutationResult = Apollo.MutationResult<CreateMatchSurveyResponseMutation>;
export type CreateMatchSurveyResponseMutationOptions = Apollo.BaseMutationOptions<CreateMatchSurveyResponseMutation, CreateMatchSurveyResponseMutationVariables>;
export const SaveSurveyResponseDocument = gql`
    mutation saveSurveyResponse($input: SaveSurveyInput!) {
  saveSurvey(input: $input) {
    id
  }
}
    `;
export type SaveSurveyResponseMutationFn = Apollo.MutationFunction<SaveSurveyResponseMutation, SaveSurveyResponseMutationVariables>;

/**
 * __useSaveSurveyResponseMutation__
 *
 * To run a mutation, you first call `useSaveSurveyResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSurveyResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSurveyResponseMutation, { data, loading, error }] = useSaveSurveyResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSurveyResponseMutation(baseOptions?: Apollo.MutationHookOptions<SaveSurveyResponseMutation, SaveSurveyResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSurveyResponseMutation, SaveSurveyResponseMutationVariables>(SaveSurveyResponseDocument, options);
      }
export type SaveSurveyResponseMutationHookResult = ReturnType<typeof useSaveSurveyResponseMutation>;
export type SaveSurveyResponseMutationResult = Apollo.MutationResult<SaveSurveyResponseMutation>;
export type SaveSurveyResponseMutationOptions = Apollo.BaseMutationOptions<SaveSurveyResponseMutation, SaveSurveyResponseMutationVariables>;
export const DismissMatchSurveyDocument = gql`
    mutation dismissMatchSurvey($matchSurveyInput: MatchSurveyInput!) {
  dismissMatchSurvey(input: $matchSurveyInput) {
    success
  }
}
    `;
export type DismissMatchSurveyMutationFn = Apollo.MutationFunction<DismissMatchSurveyMutation, DismissMatchSurveyMutationVariables>;

/**
 * __useDismissMatchSurveyMutation__
 *
 * To run a mutation, you first call `useDismissMatchSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissMatchSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissMatchSurveyMutation, { data, loading, error }] = useDismissMatchSurveyMutation({
 *   variables: {
 *      matchSurveyInput: // value for 'matchSurveyInput'
 *   },
 * });
 */
export function useDismissMatchSurveyMutation(baseOptions?: Apollo.MutationHookOptions<DismissMatchSurveyMutation, DismissMatchSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissMatchSurveyMutation, DismissMatchSurveyMutationVariables>(DismissMatchSurveyDocument, options);
      }
export type DismissMatchSurveyMutationHookResult = ReturnType<typeof useDismissMatchSurveyMutation>;
export type DismissMatchSurveyMutationResult = Apollo.MutationResult<DismissMatchSurveyMutation>;
export type DismissMatchSurveyMutationOptions = Apollo.BaseMutationOptions<DismissMatchSurveyMutation, DismissMatchSurveyMutationVariables>;
export const PostMatchSurveyDetailsDocument = gql`
    query postMatchSurveyDetails($matchId: UUID!) {
  match(id: $matchId) {
    id
    bestOf
    seriesBestOf
    esport {
      id
      slug
    }
    scheduledStartsAt
    games {
      id
      gameResults {
        id
        placing
        teamId
      }
    }
    series {
      id
      teamContext {
        seriesId
        teams {
          id
          seriesId
          result {
            placing
          }
        }
      }
    }
    matchResults {
      id
      teamId
      gamesWon
      gamesLost
      seriesWon
      seriesLost
    }
    teamContext {
      matchId
      teams {
        id
        isMyTeam
        name
        schoolId
        school {
          id
          logoUrl
        }
      }
    }
  }
}
    `;

/**
 * __usePostMatchSurveyDetailsQuery__
 *
 * To run a query within a React component, call `usePostMatchSurveyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostMatchSurveyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostMatchSurveyDetailsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function usePostMatchSurveyDetailsQuery(baseOptions: Apollo.QueryHookOptions<PostMatchSurveyDetailsQuery, PostMatchSurveyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostMatchSurveyDetailsQuery, PostMatchSurveyDetailsQueryVariables>(PostMatchSurveyDetailsDocument, options);
      }
export function usePostMatchSurveyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostMatchSurveyDetailsQuery, PostMatchSurveyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostMatchSurveyDetailsQuery, PostMatchSurveyDetailsQueryVariables>(PostMatchSurveyDetailsDocument, options);
        }
export type PostMatchSurveyDetailsQueryHookResult = ReturnType<typeof usePostMatchSurveyDetailsQuery>;
export type PostMatchSurveyDetailsLazyQueryHookResult = ReturnType<typeof usePostMatchSurveyDetailsLazyQuery>;
export type PostMatchSurveyDetailsQueryResult = Apollo.QueryResult<PostMatchSurveyDetailsQuery, PostMatchSurveyDetailsQueryVariables>;
export function refetchPostMatchSurveyDetailsQuery(variables: PostMatchSurveyDetailsQueryVariables) {
      return { query: PostMatchSurveyDetailsDocument, variables: variables }
    }
export const GetMatchDetailsDocument = gql`
    query getMatchDetails($matchId: UUID!) {
  match(id: $matchId) {
    id
    bestOf
    status
    esport {
      id
      slug
    }
    scheduledStartsAt
    games {
      id
      status
      ordinalNumber
      winningTeam {
        id
        gameId
      }
      match {
        id
        slot {
          id
          phase {
            id
            type
            name
          }
        }
        esport {
          id
          slug
        }
      }
      gameResults {
        id
        placing
        teamId
        team {
          id
          isMyTeam
          name
          school {
            id
            logoUrl
          }
        }
      }
    }
    teamContext {
      matchId
      teams {
        ...MatchDetailsTeam
      }
    }
  }
}
    ${MatchDetailsTeamFragmentDoc}`;

/**
 * __useGetMatchDetailsQuery__
 *
 * To run a query within a React component, call `useGetMatchDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchDetailsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMatchDetailsQuery, GetMatchDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchDetailsQuery, GetMatchDetailsQueryVariables>(GetMatchDetailsDocument, options);
      }
export function useGetMatchDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchDetailsQuery, GetMatchDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchDetailsQuery, GetMatchDetailsQueryVariables>(GetMatchDetailsDocument, options);
        }
export type GetMatchDetailsQueryHookResult = ReturnType<typeof useGetMatchDetailsQuery>;
export type GetMatchDetailsLazyQueryHookResult = ReturnType<typeof useGetMatchDetailsLazyQuery>;
export type GetMatchDetailsQueryResult = Apollo.QueryResult<GetMatchDetailsQuery, GetMatchDetailsQueryVariables>;
export function refetchGetMatchDetailsQuery(variables: GetMatchDetailsQueryVariables) {
      return { query: GetMatchDetailsDocument, variables: variables }
    }
export const GetTeamSlotsWithQueueMatchesDocument = gql`
    query getTeamSlotsWithQueueMatches($slotIds: [UUID!]!, $teamIds: [UUID!]!) {
  slots(ids: $slotIds) {
    id
    teamIdsWithSmartQueueMatches(teamIds: $teamIds)
  }
}
    `;

/**
 * __useGetTeamSlotsWithQueueMatchesQuery__
 *
 * To run a query within a React component, call `useGetTeamSlotsWithQueueMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamSlotsWithQueueMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamSlotsWithQueueMatchesQuery({
 *   variables: {
 *      slotIds: // value for 'slotIds'
 *      teamIds: // value for 'teamIds'
 *   },
 * });
 */
export function useGetTeamSlotsWithQueueMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetTeamSlotsWithQueueMatchesQuery, GetTeamSlotsWithQueueMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamSlotsWithQueueMatchesQuery, GetTeamSlotsWithQueueMatchesQueryVariables>(GetTeamSlotsWithQueueMatchesDocument, options);
      }
export function useGetTeamSlotsWithQueueMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamSlotsWithQueueMatchesQuery, GetTeamSlotsWithQueueMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamSlotsWithQueueMatchesQuery, GetTeamSlotsWithQueueMatchesQueryVariables>(GetTeamSlotsWithQueueMatchesDocument, options);
        }
export type GetTeamSlotsWithQueueMatchesQueryHookResult = ReturnType<typeof useGetTeamSlotsWithQueueMatchesQuery>;
export type GetTeamSlotsWithQueueMatchesLazyQueryHookResult = ReturnType<typeof useGetTeamSlotsWithQueueMatchesLazyQuery>;
export type GetTeamSlotsWithQueueMatchesQueryResult = Apollo.QueryResult<GetTeamSlotsWithQueueMatchesQuery, GetTeamSlotsWithQueueMatchesQueryVariables>;
export function refetchGetTeamSlotsWithQueueMatchesQuery(variables: GetTeamSlotsWithQueueMatchesQueryVariables) {
      return { query: GetTeamSlotsWithQueueMatchesDocument, variables: variables }
    }
export const GetMatchInformationDocument = gql`
    query getMatchInformation($id: UUID!) {
  match(id: $id) {
    id
    status
    bestOf
    seriesBestOf
    scheduledStartsAt
    matchResults {
      id
      team {
        id
        name
      }
    }
    matchSettleRequests {
      id
      status
      type
      requestedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
    matchRescheduleRequests {
      id
      matchId
      teamId
      status
      proposedTimes
      requestedBy {
        id
        name
      }
      rescheduleReason
      rescheduleNotes
      denyNotes
      deniedBy {
        id
        name
      }
      approvedBy {
        id
        name
      }
      createdAt
      updatedAt
    }
    games {
      id
      ordinalNumber
      entryCode
    }
    slot {
      id
      phase {
        id
        season {
          id
          league {
            id
            state
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMatchInformationQuery__
 *
 * To run a query within a React component, call `useGetMatchInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchInformationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMatchInformationQuery(baseOptions: Apollo.QueryHookOptions<GetMatchInformationQuery, GetMatchInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchInformationQuery, GetMatchInformationQueryVariables>(GetMatchInformationDocument, options);
      }
export function useGetMatchInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchInformationQuery, GetMatchInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchInformationQuery, GetMatchInformationQueryVariables>(GetMatchInformationDocument, options);
        }
export type GetMatchInformationQueryHookResult = ReturnType<typeof useGetMatchInformationQuery>;
export type GetMatchInformationLazyQueryHookResult = ReturnType<typeof useGetMatchInformationLazyQuery>;
export type GetMatchInformationQueryResult = Apollo.QueryResult<GetMatchInformationQuery, GetMatchInformationQueryVariables>;
export function refetchGetMatchInformationQuery(variables: GetMatchInformationQueryVariables) {
      return { query: GetMatchInformationDocument, variables: variables }
    }
export const GetRescheduleRequestsDocument = gql`
    query getRescheduleRequests($matchId: UUID!) {
  match(id: $matchId) {
    id
    scheduledStartsAt
    slot {
      id
      timezone
    }
    matchRescheduleRequests {
      id
      matchId
      teamId
      status
      proposedTimes
      requestedBy {
        id
        name
      }
      rescheduleReason
      rescheduleNotes
      denyNotes
      deniedBy {
        id
        name
      }
      approvedBy {
        id
        name
      }
      createdAt
      updatedAt
      updatedStartsAt
    }
  }
}
    `;

/**
 * __useGetRescheduleRequestsQuery__
 *
 * To run a query within a React component, call `useGetRescheduleRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRescheduleRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRescheduleRequestsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetRescheduleRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetRescheduleRequestsQuery, GetRescheduleRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRescheduleRequestsQuery, GetRescheduleRequestsQueryVariables>(GetRescheduleRequestsDocument, options);
      }
export function useGetRescheduleRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRescheduleRequestsQuery, GetRescheduleRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRescheduleRequestsQuery, GetRescheduleRequestsQueryVariables>(GetRescheduleRequestsDocument, options);
        }
export type GetRescheduleRequestsQueryHookResult = ReturnType<typeof useGetRescheduleRequestsQuery>;
export type GetRescheduleRequestsLazyQueryHookResult = ReturnType<typeof useGetRescheduleRequestsLazyQuery>;
export type GetRescheduleRequestsQueryResult = Apollo.QueryResult<GetRescheduleRequestsQuery, GetRescheduleRequestsQueryVariables>;
export function refetchGetRescheduleRequestsQuery(variables: GetRescheduleRequestsQueryVariables) {
      return { query: GetRescheduleRequestsDocument, variables: variables }
    }
export const GetMatchEventsDocument = gql`
    query getMatchEvents($matchId: UUID!, $fetchInput: FetchMatchSettleRequestInput!) {
  match(id: $matchId) {
    id
    matchRescheduleRequests {
      id
      status
      proposedTimes
      requestedBy {
        id
        name
        avatarUrl
      }
      rescheduleReason
      rescheduleNotes
      denyNotes
      deniedBy {
        id
        name
        avatarUrl
      }
      approvedBy {
        id
        name
        avatarUrl
      }
      createdAt
      updatedAt
      updatedStartsAt
    }
    matchStatusChangeEvents {
      status
      occurAt
      actedById
      actedByName
    }
    matchForfeitedEvents {
      occurAt
      actedById
      actedByName
    }
    matchDisputeRequests {
      id
      requestedBy {
        id
        name
        avatarUrl
      }
      reason
      notes
      status
      asset {
        id
        fileName
        signedUrl
        createdBy {
          name
        }
      }
      createdAt
      updatedAt
    }
  }
  fetchMatchSettleRequest(input: $fetchInput) {
    success
    errors
    matchSettleRequest {
      id
      createdAt
      updatedAt
      status
      incompleteReason
      incompleteNotes
      requestedById
      forfeitReason
      results {
        seriesResults {
          id
          ordinalNumber
          gameResults {
            ordinalNumber
            winningTeam {
              id
              name
            }
            losingTeamId
            incompleteReason
            assets {
              id
              fileName
              signedUrl
              createdBy {
                name
              }
            }
          }
        }
      }
      requestedBy {
        id
        name
        avatarUrl
      }
    }
  }
}
    `;

/**
 * __useGetMatchEventsQuery__
 *
 * To run a query within a React component, call `useGetMatchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchEventsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      fetchInput: // value for 'fetchInput'
 *   },
 * });
 */
export function useGetMatchEventsQuery(baseOptions: Apollo.QueryHookOptions<GetMatchEventsQuery, GetMatchEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchEventsQuery, GetMatchEventsQueryVariables>(GetMatchEventsDocument, options);
      }
export function useGetMatchEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchEventsQuery, GetMatchEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchEventsQuery, GetMatchEventsQueryVariables>(GetMatchEventsDocument, options);
        }
export type GetMatchEventsQueryHookResult = ReturnType<typeof useGetMatchEventsQuery>;
export type GetMatchEventsLazyQueryHookResult = ReturnType<typeof useGetMatchEventsLazyQuery>;
export type GetMatchEventsQueryResult = Apollo.QueryResult<GetMatchEventsQuery, GetMatchEventsQueryVariables>;
export function refetchGetMatchEventsQuery(variables: GetMatchEventsQueryVariables) {
      return { query: GetMatchEventsDocument, variables: variables }
    }
export const GetMatchInfoDocument = gql`
    query getMatchInfo($id: UUID!) {
  match(id: $id) {
    id
    scheduledStartsAt
    slot {
      id
      phase {
        id
        season {
          id
          metaseasonId
        }
      }
    }
    league {
      id
    }
    format
    teamContext {
      matchId
      teams {
        id
        schoolId
        competitionGroup
        name
      }
    }
    esport {
      id
    }
    series {
      id
      bestOf
      teamContext {
        seriesId
        teams {
          id
          seriesId
          roster {
            id
            name
            avatarUrl
            publisherAccountName
          }
        }
      }
    }
    status
    games {
      id
      status
      seriesId
      gameResults {
        teamId
        placing
      }
    }
    matchResults {
      id
      team {
        id
        name
        school {
          name
          logoUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetMatchInfoQuery__
 *
 * To run a query within a React component, call `useGetMatchInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMatchInfoQuery(baseOptions: Apollo.QueryHookOptions<GetMatchInfoQuery, GetMatchInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchInfoQuery, GetMatchInfoQueryVariables>(GetMatchInfoDocument, options);
      }
export function useGetMatchInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchInfoQuery, GetMatchInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchInfoQuery, GetMatchInfoQueryVariables>(GetMatchInfoDocument, options);
        }
export type GetMatchInfoQueryHookResult = ReturnType<typeof useGetMatchInfoQuery>;
export type GetMatchInfoLazyQueryHookResult = ReturnType<typeof useGetMatchInfoLazyQuery>;
export type GetMatchInfoQueryResult = Apollo.QueryResult<GetMatchInfoQuery, GetMatchInfoQueryVariables>;
export function refetchGetMatchInfoQuery(variables: GetMatchInfoQueryVariables) {
      return { query: GetMatchInfoDocument, variables: variables }
    }
export const GetMatchTeamDetailsDocument = gql`
    query getMatchTeamDetails($id: UUID!) {
  match(id: $id) {
    id
    esport {
      id
      slug
    }
    teamContext {
      matchId
      teams {
        id
        name
        schoolId
      }
    }
  }
}
    `;

/**
 * __useGetMatchTeamDetailsQuery__
 *
 * To run a query within a React component, call `useGetMatchTeamDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchTeamDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchTeamDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMatchTeamDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetMatchTeamDetailsQuery, GetMatchTeamDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchTeamDetailsQuery, GetMatchTeamDetailsQueryVariables>(GetMatchTeamDetailsDocument, options);
      }
export function useGetMatchTeamDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchTeamDetailsQuery, GetMatchTeamDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchTeamDetailsQuery, GetMatchTeamDetailsQueryVariables>(GetMatchTeamDetailsDocument, options);
        }
export type GetMatchTeamDetailsQueryHookResult = ReturnType<typeof useGetMatchTeamDetailsQuery>;
export type GetMatchTeamDetailsLazyQueryHookResult = ReturnType<typeof useGetMatchTeamDetailsLazyQuery>;
export type GetMatchTeamDetailsQueryResult = Apollo.QueryResult<GetMatchTeamDetailsQuery, GetMatchTeamDetailsQueryVariables>;
export function refetchGetMatchTeamDetailsQuery(variables: GetMatchTeamDetailsQueryVariables) {
      return { query: GetMatchTeamDetailsDocument, variables: variables }
    }
export const MinimalMetaseasonForMatchDocument = gql`
    query minimalMetaseasonForMatch($id: UUID!) {
  metaseason(id: $id) {
    id
    name
    startsAt
    endsAt
    isPromoted
  }
}
    `;

/**
 * __useMinimalMetaseasonForMatchQuery__
 *
 * To run a query within a React component, call `useMinimalMetaseasonForMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinimalMetaseasonForMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinimalMetaseasonForMatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMinimalMetaseasonForMatchQuery(baseOptions: Apollo.QueryHookOptions<MinimalMetaseasonForMatchQuery, MinimalMetaseasonForMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MinimalMetaseasonForMatchQuery, MinimalMetaseasonForMatchQueryVariables>(MinimalMetaseasonForMatchDocument, options);
      }
export function useMinimalMetaseasonForMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MinimalMetaseasonForMatchQuery, MinimalMetaseasonForMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MinimalMetaseasonForMatchQuery, MinimalMetaseasonForMatchQueryVariables>(MinimalMetaseasonForMatchDocument, options);
        }
export type MinimalMetaseasonForMatchQueryHookResult = ReturnType<typeof useMinimalMetaseasonForMatchQuery>;
export type MinimalMetaseasonForMatchLazyQueryHookResult = ReturnType<typeof useMinimalMetaseasonForMatchLazyQuery>;
export type MinimalMetaseasonForMatchQueryResult = Apollo.QueryResult<MinimalMetaseasonForMatchQuery, MinimalMetaseasonForMatchQueryVariables>;
export function refetchMinimalMetaseasonForMatchQuery(variables: MinimalMetaseasonForMatchQueryVariables) {
      return { query: MinimalMetaseasonForMatchDocument, variables: variables }
    }
export const CheckValidPlayersOnPlatformDocument = gql`
    query checkValidPlayersOnPlatform($userAccountAndPlatformInputs: [UserAccountAndPlatformInput!]!) {
  checkValidPlayersOnPlatform(
    userAccountAndPlatformInputs: $userAccountAndPlatformInputs
  ) {
    accounts {
      accountId
      platform
      valid
    }
  }
}
    `;

/**
 * __useCheckValidPlayersOnPlatformQuery__
 *
 * To run a query within a React component, call `useCheckValidPlayersOnPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckValidPlayersOnPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckValidPlayersOnPlatformQuery({
 *   variables: {
 *      userAccountAndPlatformInputs: // value for 'userAccountAndPlatformInputs'
 *   },
 * });
 */
export function useCheckValidPlayersOnPlatformQuery(baseOptions: Apollo.QueryHookOptions<CheckValidPlayersOnPlatformQuery, CheckValidPlayersOnPlatformQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckValidPlayersOnPlatformQuery, CheckValidPlayersOnPlatformQueryVariables>(CheckValidPlayersOnPlatformDocument, options);
      }
export function useCheckValidPlayersOnPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckValidPlayersOnPlatformQuery, CheckValidPlayersOnPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckValidPlayersOnPlatformQuery, CheckValidPlayersOnPlatformQueryVariables>(CheckValidPlayersOnPlatformDocument, options);
        }
export type CheckValidPlayersOnPlatformQueryHookResult = ReturnType<typeof useCheckValidPlayersOnPlatformQuery>;
export type CheckValidPlayersOnPlatformLazyQueryHookResult = ReturnType<typeof useCheckValidPlayersOnPlatformLazyQuery>;
export type CheckValidPlayersOnPlatformQueryResult = Apollo.QueryResult<CheckValidPlayersOnPlatformQuery, CheckValidPlayersOnPlatformQueryVariables>;
export function refetchCheckValidPlayersOnPlatformQuery(variables: CheckValidPlayersOnPlatformQueryVariables) {
      return { query: CheckValidPlayersOnPlatformDocument, variables: variables }
    }
export const GetGamesForMatchDocument = gql`
    query getGamesForMatch($id: UUID!) {
  match(id: $id) {
    id
    esport {
      id
      slug
    }
    games {
      id
    }
  }
}
    `;

/**
 * __useGetGamesForMatchQuery__
 *
 * To run a query within a React component, call `useGetGamesForMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGamesForMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGamesForMatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGamesForMatchQuery(baseOptions: Apollo.QueryHookOptions<GetGamesForMatchQuery, GetGamesForMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGamesForMatchQuery, GetGamesForMatchQueryVariables>(GetGamesForMatchDocument, options);
      }
export function useGetGamesForMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGamesForMatchQuery, GetGamesForMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGamesForMatchQuery, GetGamesForMatchQueryVariables>(GetGamesForMatchDocument, options);
        }
export type GetGamesForMatchQueryHookResult = ReturnType<typeof useGetGamesForMatchQuery>;
export type GetGamesForMatchLazyQueryHookResult = ReturnType<typeof useGetGamesForMatchLazyQuery>;
export type GetGamesForMatchQueryResult = Apollo.QueryResult<GetGamesForMatchQuery, GetGamesForMatchQueryVariables>;
export function refetchGetGamesForMatchQuery(variables: GetGamesForMatchQueryVariables) {
      return { query: GetGamesForMatchDocument, variables: variables }
    }
export const GetGameInfoDocument = gql`
    query getGameInfo($id: UUID!) {
  game(id: $id) {
    id
    ordinalNumber
    status
    entryCode
    match {
      id
      esport {
        id
        slug
      }
      matchResults {
        id
        team {
          id
          school {
            id
          }
        }
      }
    }
    playerGameStats {
      id
      publisherAccountId
      player {
        id
        name
      }
      rosterStatus
      isKnown
      teamId
      team {
        name
      }
    }
  }
}
    `;

/**
 * __useGetGameInfoQuery__
 *
 * To run a query within a React component, call `useGetGameInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGameInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGameInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGameInfoQuery(baseOptions: Apollo.QueryHookOptions<GetGameInfoQuery, GetGameInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGameInfoQuery, GetGameInfoQueryVariables>(GetGameInfoDocument, options);
      }
export function useGetGameInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGameInfoQuery, GetGameInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGameInfoQuery, GetGameInfoQueryVariables>(GetGameInfoDocument, options);
        }
export type GetGameInfoQueryHookResult = ReturnType<typeof useGetGameInfoQuery>;
export type GetGameInfoLazyQueryHookResult = ReturnType<typeof useGetGameInfoLazyQuery>;
export type GetGameInfoQueryResult = Apollo.QueryResult<GetGameInfoQuery, GetGameInfoQueryVariables>;
export function refetchGetGameInfoQuery(variables: GetGameInfoQueryVariables) {
      return { query: GetGameInfoDocument, variables: variables }
    }
export const GetMatchesDocument = gql`
    query getMatches($offset: Int, $limit: Int, $filters: MatchFiltersInput, $isFortnite: Boolean!) {
  getMatches(offset: $offset, limit: $limit, filters: $filters) {
    totalCount
    matches {
      id
      metaseasonId
      isScrimmage
      scheduledStartsAt
      checkInOpensAt
      checkInClosesAt
      bestOf
      status
      name
      slotId
      checkInOpensAt
      checkInClosesAt
      format
      league {
        id
        competitionGroup
        competitionModel
      }
      esport {
        id
        name
        slug
        rating
      }
      teamContext {
        matchId
        teams {
          id
        }
        otherTeams {
          id
        }
      }
      matchResults @skip(if: $isFortnite) {
        id
        matchId
        gamesWon
        gamesLost
        seriesWon
        gamesTied
        team {
          id
          name
          isMyTeam
          deletedAt
          school {
            id
            name
            logoUrl
            slug
          }
        }
      }
      matchCheckIns {
        id
        matchId
        teamId
        status
        user {
          id
          avatarUrl
          name
        }
      }
      games {
        id
        status
        playerGameStats {
          id
          player {
            id
          }
        }
        winningTeam {
          id
          gameId
        }
        losingTeam {
          id
          gameId
        }
      }
      series {
        id
        teamContext {
          seriesId
          teams {
            id
            seriesId
            result {
              placing
            }
          }
        }
      }
      slot {
        id
        startsAt
        status
        phaseId
        phase {
          id
          name
          type
          seasonId
          season {
            id
            metaseasonId
            leagueId
            league {
              id
              timezone
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMatchesQuery__
 *
 * To run a query within a React component, call `useGetMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      isFortnite: // value for 'isFortnite'
 *   },
 * });
 */
export function useGetMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetMatchesQuery, GetMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchesQuery, GetMatchesQueryVariables>(GetMatchesDocument, options);
      }
export function useGetMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchesQuery, GetMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchesQuery, GetMatchesQueryVariables>(GetMatchesDocument, options);
        }
export type GetMatchesQueryHookResult = ReturnType<typeof useGetMatchesQuery>;
export type GetMatchesLazyQueryHookResult = ReturnType<typeof useGetMatchesLazyQuery>;
export type GetMatchesQueryResult = Apollo.QueryResult<GetMatchesQuery, GetMatchesQueryVariables>;
export function refetchGetMatchesQuery(variables: GetMatchesQueryVariables) {
      return { query: GetMatchesDocument, variables: variables }
    }
export const GetLowLevelMatchesForDrawerListDocument = gql`
    query getLowLevelMatchesForDrawerList($offset: Int, $limit: Int, $filters: MatchFiltersInput) {
  getMatches(offset: $offset, limit: $limit, filters: $filters) {
    matches {
      id
      scheduledStartsAt
      slotId
      status
      esport {
        id
        slug
      }
      teamContext {
        matchId
        teams {
          id
          name
          isMyTeam
        }
      }
    }
  }
}
    `;

/**
 * __useGetLowLevelMatchesForDrawerListQuery__
 *
 * To run a query within a React component, call `useGetLowLevelMatchesForDrawerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLowLevelMatchesForDrawerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLowLevelMatchesForDrawerListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetLowLevelMatchesForDrawerListQuery(baseOptions?: Apollo.QueryHookOptions<GetLowLevelMatchesForDrawerListQuery, GetLowLevelMatchesForDrawerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLowLevelMatchesForDrawerListQuery, GetLowLevelMatchesForDrawerListQueryVariables>(GetLowLevelMatchesForDrawerListDocument, options);
      }
export function useGetLowLevelMatchesForDrawerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLowLevelMatchesForDrawerListQuery, GetLowLevelMatchesForDrawerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLowLevelMatchesForDrawerListQuery, GetLowLevelMatchesForDrawerListQueryVariables>(GetLowLevelMatchesForDrawerListDocument, options);
        }
export type GetLowLevelMatchesForDrawerListQueryHookResult = ReturnType<typeof useGetLowLevelMatchesForDrawerListQuery>;
export type GetLowLevelMatchesForDrawerListLazyQueryHookResult = ReturnType<typeof useGetLowLevelMatchesForDrawerListLazyQuery>;
export type GetLowLevelMatchesForDrawerListQueryResult = Apollo.QueryResult<GetLowLevelMatchesForDrawerListQuery, GetLowLevelMatchesForDrawerListQueryVariables>;
export function refetchGetLowLevelMatchesForDrawerListQuery(variables?: GetLowLevelMatchesForDrawerListQueryVariables) {
      return { query: GetLowLevelMatchesForDrawerListDocument, variables: variables }
    }
export const GetCheckpointMatchesDocument = gql`
    query getCheckpointMatches($offset: Int, $limit: Int, $filters: MatchFiltersInput) {
  getMatches(offset: $offset, limit: $limit, filters: $filters) {
    totalCount
    matches {
      id
      isScrimmage
      scheduledStartsAt
      bestOf
      status
      format
      canBeRescheduledByAdmin
      slotId
      esport {
        name
        slug
      }
      scrimmageRequest {
        id
      }
      games {
        id
        status
        playerGameStats {
          id
          player {
            id
          }
        }
        winningTeam {
          id
          gameId
        }
        losingTeam {
          id
          gameId
        }
      }
      league {
        id
        timezone
      }
      teamContext {
        matchId
        teams {
          id
          competitionGroup
          name
          schoolId
          school {
            id
            name
            logoUrl
          }
        }
      }
      matchAssignment {
        id
        notes
        assignee {
          id
          name
          avatarUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetCheckpointMatchesQuery__
 *
 * To run a query within a React component, call `useGetCheckpointMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckpointMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckpointMatchesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCheckpointMatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetCheckpointMatchesQuery, GetCheckpointMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckpointMatchesQuery, GetCheckpointMatchesQueryVariables>(GetCheckpointMatchesDocument, options);
      }
export function useGetCheckpointMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckpointMatchesQuery, GetCheckpointMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckpointMatchesQuery, GetCheckpointMatchesQueryVariables>(GetCheckpointMatchesDocument, options);
        }
export type GetCheckpointMatchesQueryHookResult = ReturnType<typeof useGetCheckpointMatchesQuery>;
export type GetCheckpointMatchesLazyQueryHookResult = ReturnType<typeof useGetCheckpointMatchesLazyQuery>;
export type GetCheckpointMatchesQueryResult = Apollo.QueryResult<GetCheckpointMatchesQuery, GetCheckpointMatchesQueryVariables>;
export function refetchGetCheckpointMatchesQuery(variables?: GetCheckpointMatchesQueryVariables) {
      return { query: GetCheckpointMatchesDocument, variables: variables }
    }
export const GetMatchFormatByIdDocument = gql`
    query getMatchFormatById($id: UUID!) {
  match(id: $id) {
    id
    format
  }
}
    `;

/**
 * __useGetMatchFormatByIdQuery__
 *
 * To run a query within a React component, call `useGetMatchFormatByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchFormatByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchFormatByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMatchFormatByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMatchFormatByIdQuery, GetMatchFormatByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchFormatByIdQuery, GetMatchFormatByIdQueryVariables>(GetMatchFormatByIdDocument, options);
      }
export function useGetMatchFormatByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchFormatByIdQuery, GetMatchFormatByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchFormatByIdQuery, GetMatchFormatByIdQueryVariables>(GetMatchFormatByIdDocument, options);
        }
export type GetMatchFormatByIdQueryHookResult = ReturnType<typeof useGetMatchFormatByIdQuery>;
export type GetMatchFormatByIdLazyQueryHookResult = ReturnType<typeof useGetMatchFormatByIdLazyQuery>;
export type GetMatchFormatByIdQueryResult = Apollo.QueryResult<GetMatchFormatByIdQuery, GetMatchFormatByIdQueryVariables>;
export function refetchGetMatchFormatByIdQuery(variables: GetMatchFormatByIdQueryVariables) {
      return { query: GetMatchFormatByIdDocument, variables: variables }
    }
export const MatchHeroInfoDocument = gql`
    query matchHeroInfo($id: UUID!) {
  match(id: $id) {
    id
    isScrimmage
    status
    forfeitReason
    canBeRescheduledByAdmin
    scheduledStartsAt
    discordLink
    checkInOpensAt
    checkInClosesAt
    archivedAt
    bestOf
    seriesBestOf
    teamContext {
      matchId
      myTeams {
        id
        schoolId
        name
      }
      teams {
        id
        schoolId
        competitionGroup
        name
      }
    }
    format
    scrimmageRequest {
      id
      bestOf
      startsAt
      esport {
        id
        slug
        name
      }
      requestingTeam {
        id
        name
        school {
          id
        }
      }
      opposingTeam {
        id
        name
        school {
          id
        }
      }
    }
    matchResults {
      id
      matchId
      teamSide
      team {
        id
        name
        schoolId
        school {
          id
          name
          logoUrl
        }
      }
    }
    matchCheckIns {
      id
      matchId
      teamId
      userId
      status
    }
    esport {
      id
      name
      slug
    }
    league {
      id
      competitionGroup
      timezone
    }
    slot {
      id
      phase {
        id
        type
      }
    }
    scheduleContext
  }
}
    `;

/**
 * __useMatchHeroInfoQuery__
 *
 * To run a query within a React component, call `useMatchHeroInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchHeroInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchHeroInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatchHeroInfoQuery(baseOptions: Apollo.QueryHookOptions<MatchHeroInfoQuery, MatchHeroInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchHeroInfoQuery, MatchHeroInfoQueryVariables>(MatchHeroInfoDocument, options);
      }
export function useMatchHeroInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchHeroInfoQuery, MatchHeroInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchHeroInfoQuery, MatchHeroInfoQueryVariables>(MatchHeroInfoDocument, options);
        }
export type MatchHeroInfoQueryHookResult = ReturnType<typeof useMatchHeroInfoQuery>;
export type MatchHeroInfoLazyQueryHookResult = ReturnType<typeof useMatchHeroInfoLazyQuery>;
export type MatchHeroInfoQueryResult = Apollo.QueryResult<MatchHeroInfoQuery, MatchHeroInfoQueryVariables>;
export function refetchMatchHeroInfoQuery(variables: MatchHeroInfoQueryVariables) {
      return { query: MatchHeroInfoDocument, variables: variables }
    }
export const GetMatchesByDateDocument = gql`
    query getMatchesByDate($id: UUID!, $teamId: UUID!, $after: DateTime, $before: DateTime, $sort: SeasonTeamMatchSort) {
  season(id: $id) {
    id
    teamMatches(
      teamId: $teamId
      after: $after
      before: $before
      limit: 1
      sort: $sort
    ) {
      id
    }
  }
}
    `;

/**
 * __useGetMatchesByDateQuery__
 *
 * To run a query within a React component, call `useGetMatchesByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchesByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchesByDateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      teamId: // value for 'teamId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMatchesByDateQuery(baseOptions: Apollo.QueryHookOptions<GetMatchesByDateQuery, GetMatchesByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchesByDateQuery, GetMatchesByDateQueryVariables>(GetMatchesByDateDocument, options);
      }
export function useGetMatchesByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchesByDateQuery, GetMatchesByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchesByDateQuery, GetMatchesByDateQueryVariables>(GetMatchesByDateDocument, options);
        }
export type GetMatchesByDateQueryHookResult = ReturnType<typeof useGetMatchesByDateQuery>;
export type GetMatchesByDateLazyQueryHookResult = ReturnType<typeof useGetMatchesByDateLazyQuery>;
export type GetMatchesByDateQueryResult = Apollo.QueryResult<GetMatchesByDateQuery, GetMatchesByDateQueryVariables>;
export function refetchGetMatchesByDateQuery(variables: GetMatchesByDateQueryVariables) {
      return { query: GetMatchesByDateDocument, variables: variables }
    }
export const GetPastMatchesForTeamDocument = gql`
    query getPastMatchesForTeam($offset: Int, $limit: Int, $filters: MatchFiltersInput, $sortFields: [MatchSortSpec!]) {
  getMatches(
    offset: $offset
    limit: $limit
    filters: $filters
    sortFields: $sortFields
  ) {
    totalCount
    matches {
      ...TeamMatches
    }
  }
}
    ${TeamMatchesFragmentDoc}`;

/**
 * __useGetPastMatchesForTeamQuery__
 *
 * To run a query within a React component, call `useGetPastMatchesForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastMatchesForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastMatchesForTeamQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useGetPastMatchesForTeamQuery(baseOptions?: Apollo.QueryHookOptions<GetPastMatchesForTeamQuery, GetPastMatchesForTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPastMatchesForTeamQuery, GetPastMatchesForTeamQueryVariables>(GetPastMatchesForTeamDocument, options);
      }
export function useGetPastMatchesForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPastMatchesForTeamQuery, GetPastMatchesForTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPastMatchesForTeamQuery, GetPastMatchesForTeamQueryVariables>(GetPastMatchesForTeamDocument, options);
        }
export type GetPastMatchesForTeamQueryHookResult = ReturnType<typeof useGetPastMatchesForTeamQuery>;
export type GetPastMatchesForTeamLazyQueryHookResult = ReturnType<typeof useGetPastMatchesForTeamLazyQuery>;
export type GetPastMatchesForTeamQueryResult = Apollo.QueryResult<GetPastMatchesForTeamQuery, GetPastMatchesForTeamQueryVariables>;
export function refetchGetPastMatchesForTeamQuery(variables?: GetPastMatchesForTeamQueryVariables) {
      return { query: GetPastMatchesForTeamDocument, variables: variables }
    }
export const GetTeamMatchesDocument = gql`
    query getTeamMatches($offset: Int, $limit: Int, $filters: MatchFiltersInput, $sortFields: [MatchSortSpec!]) {
  getMatches(
    offset: $offset
    limit: $limit
    filters: $filters
    sortFields: $sortFields
  ) {
    matches {
      ...TeamMatches
    }
  }
}
    ${TeamMatchesFragmentDoc}`;

/**
 * __useGetTeamMatchesQuery__
 *
 * To run a query within a React component, call `useGetTeamMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMatchesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useGetTeamMatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamMatchesQuery, GetTeamMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMatchesQuery, GetTeamMatchesQueryVariables>(GetTeamMatchesDocument, options);
      }
export function useGetTeamMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMatchesQuery, GetTeamMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMatchesQuery, GetTeamMatchesQueryVariables>(GetTeamMatchesDocument, options);
        }
export type GetTeamMatchesQueryHookResult = ReturnType<typeof useGetTeamMatchesQuery>;
export type GetTeamMatchesLazyQueryHookResult = ReturnType<typeof useGetTeamMatchesLazyQuery>;
export type GetTeamMatchesQueryResult = Apollo.QueryResult<GetTeamMatchesQuery, GetTeamMatchesQueryVariables>;
export function refetchGetTeamMatchesQuery(variables?: GetTeamMatchesQueryVariables) {
      return { query: GetTeamMatchesDocument, variables: variables }
    }
export const GetLeagueMatchesDocument = gql`
    query getLeagueMatches($offset: Int, $limit: Int, $filters: MatchFiltersInput, $sortFields: [MatchSortSpec!]) {
  getMatches(
    offset: $offset
    limit: $limit
    filters: $filters
    sortFields: $sortFields
  ) {
    matches {
      id
      status
      scheduledStartsAt
      isScrimmage
      scheduleContext
      esport {
        id
        rating
        slug
        details {
          esportId
          abbreviation
          matchFormat
        }
      }
      slot {
        id
        phase {
          id
          type
        }
      }
      teamContext {
        matchId
        myTeams {
          id
          name
          avatarUrl
          school {
            id
            name
            logoUrl
          }
        }
        otherTeams {
          id
          name
          avatarUrl
          school {
            id
            name
            logoUrl
          }
        }
        teams {
          id
          name
          avatarUrl
          school {
            id
            name
            logoUrl
          }
        }
        myTeamMatchResults {
          id
          placing
        }
      }
      matchResults {
        id
        gamesWon
        gamesLost
        gamesTied
        seriesWon
        seriesLost
        seriesTied
        placing
        team {
          id
          name
          avatarUrl
          school {
            id
            name
            logoUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLeagueMatchesQuery__
 *
 * To run a query within a React component, call `useGetLeagueMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueMatchesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sortFields: // value for 'sortFields'
 *   },
 * });
 */
export function useGetLeagueMatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetLeagueMatchesQuery, GetLeagueMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueMatchesQuery, GetLeagueMatchesQueryVariables>(GetLeagueMatchesDocument, options);
      }
export function useGetLeagueMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueMatchesQuery, GetLeagueMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueMatchesQuery, GetLeagueMatchesQueryVariables>(GetLeagueMatchesDocument, options);
        }
export type GetLeagueMatchesQueryHookResult = ReturnType<typeof useGetLeagueMatchesQuery>;
export type GetLeagueMatchesLazyQueryHookResult = ReturnType<typeof useGetLeagueMatchesLazyQuery>;
export type GetLeagueMatchesQueryResult = Apollo.QueryResult<GetLeagueMatchesQuery, GetLeagueMatchesQueryVariables>;
export function refetchGetLeagueMatchesQuery(variables?: GetLeagueMatchesQueryVariables) {
      return { query: GetLeagueMatchesDocument, variables: variables }
    }
export const GetPlayerMatchHistoryDocument = gql`
    query getPlayerMatchHistory($playerId: UUID!, $metaseasonId: UUID!, $statuses: [MatchStatus!]) {
  findPlayerMetaseasonMatches(
    playerId: $playerId
    metaseasonId: $metaseasonId
    statuses: $statuses
  ) {
    id
    status
    scheduledStartsAt
    isScrimmage
    esport {
      id
      rating
      slug
    }
    matchResults {
      id
      gamesWon
      gamesLost
      gamesTied
      seriesWon
      seriesLost
      seriesTied
      placing
      team {
        id
        name
        school {
          id
          name
          logoUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetPlayerMatchHistoryQuery__
 *
 * To run a query within a React component, call `useGetPlayerMatchHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerMatchHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerMatchHistoryQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      metaseasonId: // value for 'metaseasonId'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetPlayerMatchHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerMatchHistoryQuery, GetPlayerMatchHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerMatchHistoryQuery, GetPlayerMatchHistoryQueryVariables>(GetPlayerMatchHistoryDocument, options);
      }
export function useGetPlayerMatchHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerMatchHistoryQuery, GetPlayerMatchHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerMatchHistoryQuery, GetPlayerMatchHistoryQueryVariables>(GetPlayerMatchHistoryDocument, options);
        }
export type GetPlayerMatchHistoryQueryHookResult = ReturnType<typeof useGetPlayerMatchHistoryQuery>;
export type GetPlayerMatchHistoryLazyQueryHookResult = ReturnType<typeof useGetPlayerMatchHistoryLazyQuery>;
export type GetPlayerMatchHistoryQueryResult = Apollo.QueryResult<GetPlayerMatchHistoryQuery, GetPlayerMatchHistoryQueryVariables>;
export function refetchGetPlayerMatchHistoryQuery(variables: GetPlayerMatchHistoryQueryVariables) {
      return { query: GetPlayerMatchHistoryDocument, variables: variables }
    }
export const GetTeamMatchHistoryDocument = gql`
    query getTeamMatchHistory($input: MatchesByTeamIdsInput!) {
  findMatchesByTeamIds(input: $input) {
    id
    status
    scheduledStartsAt
    isScrimmage
    slotId
    slot {
      id
      phase {
        id
        type
      }
    }
    scheduleContext
    matchResults {
      id
      matchId
      gamesWon
      gamesLost
      gamesTied
      seriesWon
      seriesLost
      seriesTied
      placing
      team {
        id
        name
        deletedAt
        school {
          id
          name
          logoUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamMatchHistoryQuery__
 *
 * To run a query within a React component, call `useGetTeamMatchHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMatchHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMatchHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTeamMatchHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetTeamMatchHistoryQuery, GetTeamMatchHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMatchHistoryQuery, GetTeamMatchHistoryQueryVariables>(GetTeamMatchHistoryDocument, options);
      }
export function useGetTeamMatchHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMatchHistoryQuery, GetTeamMatchHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMatchHistoryQuery, GetTeamMatchHistoryQueryVariables>(GetTeamMatchHistoryDocument, options);
        }
export type GetTeamMatchHistoryQueryHookResult = ReturnType<typeof useGetTeamMatchHistoryQuery>;
export type GetTeamMatchHistoryLazyQueryHookResult = ReturnType<typeof useGetTeamMatchHistoryLazyQuery>;
export type GetTeamMatchHistoryQueryResult = Apollo.QueryResult<GetTeamMatchHistoryQuery, GetTeamMatchHistoryQueryVariables>;
export function refetchGetTeamMatchHistoryQuery(variables: GetTeamMatchHistoryQueryVariables) {
      return { query: GetTeamMatchHistoryDocument, variables: variables }
    }
export const GetScheduledAndQueueMatchesByTeamIdsDocument = gql`
    query getScheduledAndQueueMatchesByTeamIds($input: ScheduledAndQueueMatchesByTeamIdsInput!) {
  getScheduledAndQueueMatchesByTeamIds(input: $input) {
    scheduledMatchesOffset
    queueMatchesOffset
    totalScheduledMatches
    totalQueueMatches
    scheduledMatches {
      id
      metaseasonId
      status
      scheduledStartsAt
      isScrimmage
      bestOf
      scheduleContext
      slotId
      slot {
        id
        phase {
          id
          type
          season {
            id
            metaseasonId
          }
        }
      }
      esport {
        id
        name
        slug
        rating
        details {
          esportId
          abbreviation
          matchFormat
        }
      }
      league {
        id
        competitionGroup
        competitionModel
      }
      format
      teamContext {
        matchId
        myTeams {
          id
          schoolId
        }
        otherTeams {
          id
          schoolId
        }
        teams {
          id
          name
          avatarUrl
          isMyTeam
          competitionGroup
          esport {
            id
            name
            slug
            rating
          }
          school {
            id
            name
            logoUrl
          }
        }
      }
      teamContext {
        matchId
        myTeams {
          id
          name
          avatarUrl
          school {
            id
            name
            logoUrl
          }
        }
        otherTeams {
          id
          name
          avatarUrl
          school {
            id
            name
            logoUrl
          }
        }
        teams {
          id
          name
          avatarUrl
          school {
            id
            name
            logoUrl
          }
        }
        myTeamMatchResults {
          id
          placing
        }
      }
      matchRescheduleRequests {
        id
        status
        proposedTimes
        teamId
        matchId
      }
      matchResults {
        id
        gamesWon
        gamesLost
        gamesTied
        seriesWon
        seriesLost
        seriesTied
        placing
        team {
          id
          name
          isMyTeam
          avatarUrl
          deletedAt
          school {
            id
            name
            logoUrl
          }
        }
      }
      __typename
    }
    queueMatches {
      slotId
      esport {
        id
        name
        slug
        rating
      }
      slot {
        id
        phase {
          id
          type
          season {
            id
            metaseasonId
            league {
              id
              competitionGroup
            }
          }
        }
      }
      bestOf
      scheduledStartsAt
      scheduleContext
      team {
        id
        name
        isMyTeam
        avatarUrl
        competitionGroup
        schoolId
        school {
          id
          name
          logoUrl
        }
      }
      isScrimmage
      __typename
    }
  }
}
    `;

/**
 * __useGetScheduledAndQueueMatchesByTeamIdsQuery__
 *
 * To run a query within a React component, call `useGetScheduledAndQueueMatchesByTeamIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledAndQueueMatchesByTeamIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledAndQueueMatchesByTeamIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetScheduledAndQueueMatchesByTeamIdsQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledAndQueueMatchesByTeamIdsQuery, GetScheduledAndQueueMatchesByTeamIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledAndQueueMatchesByTeamIdsQuery, GetScheduledAndQueueMatchesByTeamIdsQueryVariables>(GetScheduledAndQueueMatchesByTeamIdsDocument, options);
      }
export function useGetScheduledAndQueueMatchesByTeamIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledAndQueueMatchesByTeamIdsQuery, GetScheduledAndQueueMatchesByTeamIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledAndQueueMatchesByTeamIdsQuery, GetScheduledAndQueueMatchesByTeamIdsQueryVariables>(GetScheduledAndQueueMatchesByTeamIdsDocument, options);
        }
export type GetScheduledAndQueueMatchesByTeamIdsQueryHookResult = ReturnType<typeof useGetScheduledAndQueueMatchesByTeamIdsQuery>;
export type GetScheduledAndQueueMatchesByTeamIdsLazyQueryHookResult = ReturnType<typeof useGetScheduledAndQueueMatchesByTeamIdsLazyQuery>;
export type GetScheduledAndQueueMatchesByTeamIdsQueryResult = Apollo.QueryResult<GetScheduledAndQueueMatchesByTeamIdsQuery, GetScheduledAndQueueMatchesByTeamIdsQueryVariables>;
export function refetchGetScheduledAndQueueMatchesByTeamIdsQuery(variables: GetScheduledAndQueueMatchesByTeamIdsQueryVariables) {
      return { query: GetScheduledAndQueueMatchesByTeamIdsDocument, variables: variables }
    }
export const GetTeamMatchesForScheduleDocument = gql`
    query getTeamMatchesForSchedule($input: MatchesByTeamIdsInput!) {
  findMatchesByTeamIds(input: $input) {
    id
    metaseasonId
    status
    scheduledStartsAt
    checkInClosesAt
    checkInOpensAt
    isScrimmage
    scheduleContext
    slotId
    slot {
      id
      phase {
        id
        type
        season {
          id
          metaseasonId
        }
      }
    }
    esport {
      id
      name
      slug
      rating
    }
    league {
      id
      competitionGroup
      competitionModel
    }
    teamContext {
      matchId
      teams {
        id
        name
        competitionGroup
        avatarUrl
        isMyTeam
        school {
          id
          name
          logoUrl
        }
      }
    }
    matchResults {
      id
      gamesWon
      gamesLost
      gamesTied
      seriesWon
      seriesLost
      seriesTied
      placing
      team {
        id
        name
        isMyTeam
        avatarUrl
        deletedAt
        school {
          id
          name
          logoUrl
        }
      }
    }
    matchCheckIns {
      teamId
      status
    }
  }
}
    `;

/**
 * __useGetTeamMatchesForScheduleQuery__
 *
 * To run a query within a React component, call `useGetTeamMatchesForScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMatchesForScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMatchesForScheduleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTeamMatchesForScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetTeamMatchesForScheduleQuery, GetTeamMatchesForScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMatchesForScheduleQuery, GetTeamMatchesForScheduleQueryVariables>(GetTeamMatchesForScheduleDocument, options);
      }
export function useGetTeamMatchesForScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMatchesForScheduleQuery, GetTeamMatchesForScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMatchesForScheduleQuery, GetTeamMatchesForScheduleQueryVariables>(GetTeamMatchesForScheduleDocument, options);
        }
export type GetTeamMatchesForScheduleQueryHookResult = ReturnType<typeof useGetTeamMatchesForScheduleQuery>;
export type GetTeamMatchesForScheduleLazyQueryHookResult = ReturnType<typeof useGetTeamMatchesForScheduleLazyQuery>;
export type GetTeamMatchesForScheduleQueryResult = Apollo.QueryResult<GetTeamMatchesForScheduleQuery, GetTeamMatchesForScheduleQueryVariables>;
export function refetchGetTeamMatchesForScheduleQuery(variables: GetTeamMatchesForScheduleQueryVariables) {
      return { query: GetTeamMatchesForScheduleDocument, variables: variables }
    }
export const CreateMatchChatDocument = gql`
    mutation createMatchChat($input: CreateMatchChatInput!) {
  createMatchChat(input: $input) {
    success
    errors
    results {
      matchId
      matchChatId
    }
  }
}
    `;
export type CreateMatchChatMutationFn = Apollo.MutationFunction<CreateMatchChatMutation, CreateMatchChatMutationVariables>;

/**
 * __useCreateMatchChatMutation__
 *
 * To run a mutation, you first call `useCreateMatchChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatchChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatchChatMutation, { data, loading, error }] = useCreateMatchChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMatchChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateMatchChatMutation, CreateMatchChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMatchChatMutation, CreateMatchChatMutationVariables>(CreateMatchChatDocument, options);
      }
export type CreateMatchChatMutationHookResult = ReturnType<typeof useCreateMatchChatMutation>;
export type CreateMatchChatMutationResult = Apollo.MutationResult<CreateMatchChatMutation>;
export type CreateMatchChatMutationOptions = Apollo.BaseMutationOptions<CreateMatchChatMutation, CreateMatchChatMutationVariables>;
export const GetAwardMatchesDocument = gql`
    query getAwardMatches($offset: Int, $limit: Int, $filters: MatchFiltersInput, $sortFields: [MatchSortSpec!], $effectiveAt: DateTime) {
  getMatches(
    offset: $offset
    limit: $limit
    filters: $filters
    sortFields: $sortFields
  ) {
    matches {
      id
      status
      scheduledStartsAt
      esport {
        id
        rating
        name
        slug
      }
      matchResults {
        id
        gamesWon
        gamesLost
        placing
        team {
          id
          name
          isMyTeam
          school {
            id
            name
            logoUrl
          }
          roster(effectiveAt: $effectiveAt) {
            id
            formats {
              starters {
                player {
                  user {
                    id
                    name
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAwardMatchesQuery__
 *
 * To run a query within a React component, call `useGetAwardMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAwardMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAwardMatchesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      sortFields: // value for 'sortFields'
 *      effectiveAt: // value for 'effectiveAt'
 *   },
 * });
 */
export function useGetAwardMatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetAwardMatchesQuery, GetAwardMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAwardMatchesQuery, GetAwardMatchesQueryVariables>(GetAwardMatchesDocument, options);
      }
export function useGetAwardMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAwardMatchesQuery, GetAwardMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAwardMatchesQuery, GetAwardMatchesQueryVariables>(GetAwardMatchesDocument, options);
        }
export type GetAwardMatchesQueryHookResult = ReturnType<typeof useGetAwardMatchesQuery>;
export type GetAwardMatchesLazyQueryHookResult = ReturnType<typeof useGetAwardMatchesLazyQuery>;
export type GetAwardMatchesQueryResult = Apollo.QueryResult<GetAwardMatchesQuery, GetAwardMatchesQueryVariables>;
export function refetchGetAwardMatchesQuery(variables?: GetAwardMatchesQueryVariables) {
      return { query: GetAwardMatchesDocument, variables: variables }
    }
export const GetHighlightMatchesDocument = gql`
    query getHighlightMatches($playerId: UUID!, $metaseasonId: UUID!, $statuses: [MatchStatus!], $order: String) {
  findPlayerMetaseasonMatches(
    playerId: $playerId
    metaseasonId: $metaseasonId
    statuses: $statuses
    order: $order
  ) {
    id
    teamContext {
      matchId
      teams {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetHighlightMatchesQuery__
 *
 * To run a query within a React component, call `useGetHighlightMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHighlightMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHighlightMatchesQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      metaseasonId: // value for 'metaseasonId'
 *      statuses: // value for 'statuses'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetHighlightMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetHighlightMatchesQuery, GetHighlightMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHighlightMatchesQuery, GetHighlightMatchesQueryVariables>(GetHighlightMatchesDocument, options);
      }
export function useGetHighlightMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHighlightMatchesQuery, GetHighlightMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHighlightMatchesQuery, GetHighlightMatchesQueryVariables>(GetHighlightMatchesDocument, options);
        }
export type GetHighlightMatchesQueryHookResult = ReturnType<typeof useGetHighlightMatchesQuery>;
export type GetHighlightMatchesLazyQueryHookResult = ReturnType<typeof useGetHighlightMatchesLazyQuery>;
export type GetHighlightMatchesQueryResult = Apollo.QueryResult<GetHighlightMatchesQuery, GetHighlightMatchesQueryVariables>;
export function refetchGetHighlightMatchesQuery(variables: GetHighlightMatchesQueryVariables) {
      return { query: GetHighlightMatchesDocument, variables: variables }
    }
export const GetLastPlayedMetaseasonIdByPlayerIdDocument = gql`
    query getLastPlayedMetaseasonIdByPlayerId($playerId: UUID!) {
  getLastPlayedMetaseasonIdByPlayerId(playerId: $playerId)
}
    `;

/**
 * __useGetLastPlayedMetaseasonIdByPlayerIdQuery__
 *
 * To run a query within a React component, call `useGetLastPlayedMetaseasonIdByPlayerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastPlayedMetaseasonIdByPlayerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastPlayedMetaseasonIdByPlayerIdQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useGetLastPlayedMetaseasonIdByPlayerIdQuery(baseOptions: Apollo.QueryHookOptions<GetLastPlayedMetaseasonIdByPlayerIdQuery, GetLastPlayedMetaseasonIdByPlayerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastPlayedMetaseasonIdByPlayerIdQuery, GetLastPlayedMetaseasonIdByPlayerIdQueryVariables>(GetLastPlayedMetaseasonIdByPlayerIdDocument, options);
      }
export function useGetLastPlayedMetaseasonIdByPlayerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastPlayedMetaseasonIdByPlayerIdQuery, GetLastPlayedMetaseasonIdByPlayerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastPlayedMetaseasonIdByPlayerIdQuery, GetLastPlayedMetaseasonIdByPlayerIdQueryVariables>(GetLastPlayedMetaseasonIdByPlayerIdDocument, options);
        }
export type GetLastPlayedMetaseasonIdByPlayerIdQueryHookResult = ReturnType<typeof useGetLastPlayedMetaseasonIdByPlayerIdQuery>;
export type GetLastPlayedMetaseasonIdByPlayerIdLazyQueryHookResult = ReturnType<typeof useGetLastPlayedMetaseasonIdByPlayerIdLazyQuery>;
export type GetLastPlayedMetaseasonIdByPlayerIdQueryResult = Apollo.QueryResult<GetLastPlayedMetaseasonIdByPlayerIdQuery, GetLastPlayedMetaseasonIdByPlayerIdQueryVariables>;
export function refetchGetLastPlayedMetaseasonIdByPlayerIdQuery(variables: GetLastPlayedMetaseasonIdByPlayerIdQueryVariables) {
      return { query: GetLastPlayedMetaseasonIdByPlayerIdDocument, variables: variables }
    }
export const LeaderboardMatchGameResultsDocument = gql`
    query leaderboardMatchGameResults($matchId: UUID!, $limit: Int) {
  match(id: $matchId) {
    id
    bestOf
    status
    teamContext {
      matchId
      numberOfTeamsInMatch
      teams {
        id
        name
        avatarUrl
        school {
          id
          name
        }
      }
    }
    games {
      id
      status
      gameResults(limit: $limit) {
        id
        placing
        teamId
      }
    }
  }
}
    `;

/**
 * __useLeaderboardMatchGameResultsQuery__
 *
 * To run a query within a React component, call `useLeaderboardMatchGameResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeaderboardMatchGameResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeaderboardMatchGameResultsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLeaderboardMatchGameResultsQuery(baseOptions: Apollo.QueryHookOptions<LeaderboardMatchGameResultsQuery, LeaderboardMatchGameResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeaderboardMatchGameResultsQuery, LeaderboardMatchGameResultsQueryVariables>(LeaderboardMatchGameResultsDocument, options);
      }
export function useLeaderboardMatchGameResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeaderboardMatchGameResultsQuery, LeaderboardMatchGameResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeaderboardMatchGameResultsQuery, LeaderboardMatchGameResultsQueryVariables>(LeaderboardMatchGameResultsDocument, options);
        }
export type LeaderboardMatchGameResultsQueryHookResult = ReturnType<typeof useLeaderboardMatchGameResultsQuery>;
export type LeaderboardMatchGameResultsLazyQueryHookResult = ReturnType<typeof useLeaderboardMatchGameResultsLazyQuery>;
export type LeaderboardMatchGameResultsQueryResult = Apollo.QueryResult<LeaderboardMatchGameResultsQuery, LeaderboardMatchGameResultsQueryVariables>;
export function refetchLeaderboardMatchGameResultsQuery(variables: LeaderboardMatchGameResultsQueryVariables) {
      return { query: LeaderboardMatchGameResultsDocument, variables: variables }
    }
export const GetMatchForOverlayDocument = gql`
    query getMatchForOverlay($matchId: UUID!) {
  match(id: $matchId) {
    id
    status
    esport {
      id
      slug
    }
    slot {
      id
      name
      phase {
        id
        season {
          id
          metaseason {
            id
            name
          }
          league {
            id
            name
          }
        }
      }
    }
    team1Score
    team2Score
    teamContext {
      matchId
      teams {
        id
        name
        avatarUrl
        competitionGroup
        school {
          id
          name
          logoUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetMatchForOverlayQuery__
 *
 * To run a query within a React component, call `useGetMatchForOverlayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchForOverlayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchForOverlayQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchForOverlayQuery(baseOptions: Apollo.QueryHookOptions<GetMatchForOverlayQuery, GetMatchForOverlayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchForOverlayQuery, GetMatchForOverlayQueryVariables>(GetMatchForOverlayDocument, options);
      }
export function useGetMatchForOverlayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchForOverlayQuery, GetMatchForOverlayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchForOverlayQuery, GetMatchForOverlayQueryVariables>(GetMatchForOverlayDocument, options);
        }
export type GetMatchForOverlayQueryHookResult = ReturnType<typeof useGetMatchForOverlayQuery>;
export type GetMatchForOverlayLazyQueryHookResult = ReturnType<typeof useGetMatchForOverlayLazyQuery>;
export type GetMatchForOverlayQueryResult = Apollo.QueryResult<GetMatchForOverlayQuery, GetMatchForOverlayQueryVariables>;
export function refetchGetMatchForOverlayQuery(variables: GetMatchForOverlayQueryVariables) {
      return { query: GetMatchForOverlayDocument, variables: variables }
    }
export const MyConnectionStatusDocument = gql`
    query myConnectionStatus {
  me {
    id
    userProviderAccounts {
      id
      userId
      providerName
      providerDisplayName
      providerAccountId
      providerIntegrationType
    }
  }
}
    `;

/**
 * __useMyConnectionStatusQuery__
 *
 * To run a query within a React component, call `useMyConnectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyConnectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyConnectionStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyConnectionStatusQuery(baseOptions?: Apollo.QueryHookOptions<MyConnectionStatusQuery, MyConnectionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyConnectionStatusQuery, MyConnectionStatusQueryVariables>(MyConnectionStatusDocument, options);
      }
export function useMyConnectionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyConnectionStatusQuery, MyConnectionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyConnectionStatusQuery, MyConnectionStatusQueryVariables>(MyConnectionStatusDocument, options);
        }
export type MyConnectionStatusQueryHookResult = ReturnType<typeof useMyConnectionStatusQuery>;
export type MyConnectionStatusLazyQueryHookResult = ReturnType<typeof useMyConnectionStatusLazyQuery>;
export type MyConnectionStatusQueryResult = Apollo.QueryResult<MyConnectionStatusQuery, MyConnectionStatusQueryVariables>;
export function refetchMyConnectionStatusQuery(variables?: MyConnectionStatusQueryVariables) {
      return { query: MyConnectionStatusDocument, variables: variables }
    }
export const GetMetaseasonsDocument = gql`
    query getMetaseasons($options: MetaseasonsOptions) {
  metaseasons(options: $options) {
    id
    name
    slug
    isPromoted
    status
    startsAt
    endsAt
    isInitialMetaseason
    competitionGroup
    promotionStartsAt
    promotionEndsAt
    previousMetaseasonId
    isPromotionWindowOverlap
    leaguesWithSeasonCount
    inactiveLeaguesCount
  }
}
    `;

/**
 * __useGetMetaseasonsQuery__
 *
 * To run a query within a React component, call `useGetMetaseasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetaseasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetaseasonsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetMetaseasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetMetaseasonsQuery, GetMetaseasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetaseasonsQuery, GetMetaseasonsQueryVariables>(GetMetaseasonsDocument, options);
      }
export function useGetMetaseasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetaseasonsQuery, GetMetaseasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetaseasonsQuery, GetMetaseasonsQueryVariables>(GetMetaseasonsDocument, options);
        }
export type GetMetaseasonsQueryHookResult = ReturnType<typeof useGetMetaseasonsQuery>;
export type GetMetaseasonsLazyQueryHookResult = ReturnType<typeof useGetMetaseasonsLazyQuery>;
export type GetMetaseasonsQueryResult = Apollo.QueryResult<GetMetaseasonsQuery, GetMetaseasonsQueryVariables>;
export function refetchGetMetaseasonsQuery(variables?: GetMetaseasonsQueryVariables) {
      return { query: GetMetaseasonsDocument, variables: variables }
    }
export const GetNonAdminMetaseasonsDocument = gql`
    query getNonAdminMetaseasons($options: MetaseasonsOptions) {
  metaseasons(options: $options) {
    id
    name
    slug
    isPromoted
    status
    startsAt
    endsAt
    isInitialMetaseason
    competitionGroup
    promotionStartsAt
    promotionEndsAt
    previousMetaseasonId
    isPromotionWindowOverlap
  }
}
    `;

/**
 * __useGetNonAdminMetaseasonsQuery__
 *
 * To run a query within a React component, call `useGetNonAdminMetaseasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonAdminMetaseasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonAdminMetaseasonsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetNonAdminMetaseasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetNonAdminMetaseasonsQuery, GetNonAdminMetaseasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonAdminMetaseasonsQuery, GetNonAdminMetaseasonsQueryVariables>(GetNonAdminMetaseasonsDocument, options);
      }
export function useGetNonAdminMetaseasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonAdminMetaseasonsQuery, GetNonAdminMetaseasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonAdminMetaseasonsQuery, GetNonAdminMetaseasonsQueryVariables>(GetNonAdminMetaseasonsDocument, options);
        }
export type GetNonAdminMetaseasonsQueryHookResult = ReturnType<typeof useGetNonAdminMetaseasonsQuery>;
export type GetNonAdminMetaseasonsLazyQueryHookResult = ReturnType<typeof useGetNonAdminMetaseasonsLazyQuery>;
export type GetNonAdminMetaseasonsQueryResult = Apollo.QueryResult<GetNonAdminMetaseasonsQuery, GetNonAdminMetaseasonsQueryVariables>;
export function refetchGetNonAdminMetaseasonsQuery(variables?: GetNonAdminMetaseasonsQueryVariables) {
      return { query: GetNonAdminMetaseasonsDocument, variables: variables }
    }
export const CreateMetaseasonDocument = gql`
    mutation createMetaseason($config: CreateMetaseasonConfig!) {
  createMetaseason(config: $config) {
    id
    name
    isPromoted
    startsAt
    endsAt
    status
  }
}
    `;
export type CreateMetaseasonMutationFn = Apollo.MutationFunction<CreateMetaseasonMutation, CreateMetaseasonMutationVariables>;

/**
 * __useCreateMetaseasonMutation__
 *
 * To run a mutation, you first call `useCreateMetaseasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetaseasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetaseasonMutation, { data, loading, error }] = useCreateMetaseasonMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function useCreateMetaseasonMutation(baseOptions?: Apollo.MutationHookOptions<CreateMetaseasonMutation, CreateMetaseasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMetaseasonMutation, CreateMetaseasonMutationVariables>(CreateMetaseasonDocument, options);
      }
export type CreateMetaseasonMutationHookResult = ReturnType<typeof useCreateMetaseasonMutation>;
export type CreateMetaseasonMutationResult = Apollo.MutationResult<CreateMetaseasonMutation>;
export type CreateMetaseasonMutationOptions = Apollo.BaseMutationOptions<CreateMetaseasonMutation, CreateMetaseasonMutationVariables>;
export const UpdateMetaseasonDocument = gql`
    mutation updateMetaseason($id: UUID!, $input: UpdateMetaseasonInput!) {
  updateMetaseason(id: $id, input: $input) {
    id
    name
    isPromoted
    startsAt
    endsAt
    status
  }
}
    `;
export type UpdateMetaseasonMutationFn = Apollo.MutationFunction<UpdateMetaseasonMutation, UpdateMetaseasonMutationVariables>;

/**
 * __useUpdateMetaseasonMutation__
 *
 * To run a mutation, you first call `useUpdateMetaseasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetaseasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetaseasonMutation, { data, loading, error }] = useUpdateMetaseasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetaseasonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetaseasonMutation, UpdateMetaseasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetaseasonMutation, UpdateMetaseasonMutationVariables>(UpdateMetaseasonDocument, options);
      }
export type UpdateMetaseasonMutationHookResult = ReturnType<typeof useUpdateMetaseasonMutation>;
export type UpdateMetaseasonMutationResult = Apollo.MutationResult<UpdateMetaseasonMutation>;
export type UpdateMetaseasonMutationOptions = Apollo.BaseMutationOptions<UpdateMetaseasonMutation, UpdateMetaseasonMutationVariables>;
export const GetMetaseasonByIdDocument = gql`
    query getMetaseasonById($id: UUID!) {
  metaseason(id: $id) {
    id
    name
    startsAt
    endsAt
    isPromoted
    competitionGroup
  }
}
    `;

/**
 * __useGetMetaseasonByIdQuery__
 *
 * To run a query within a React component, call `useGetMetaseasonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetaseasonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetaseasonByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMetaseasonByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMetaseasonByIdQuery, GetMetaseasonByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetaseasonByIdQuery, GetMetaseasonByIdQueryVariables>(GetMetaseasonByIdDocument, options);
      }
export function useGetMetaseasonByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetaseasonByIdQuery, GetMetaseasonByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetaseasonByIdQuery, GetMetaseasonByIdQueryVariables>(GetMetaseasonByIdDocument, options);
        }
export type GetMetaseasonByIdQueryHookResult = ReturnType<typeof useGetMetaseasonByIdQuery>;
export type GetMetaseasonByIdLazyQueryHookResult = ReturnType<typeof useGetMetaseasonByIdLazyQuery>;
export type GetMetaseasonByIdQueryResult = Apollo.QueryResult<GetMetaseasonByIdQuery, GetMetaseasonByIdQueryVariables>;
export function refetchGetMetaseasonByIdQuery(variables: GetMetaseasonByIdQueryVariables) {
      return { query: GetMetaseasonByIdDocument, variables: variables }
    }
export const GetNonLoggedInMetaseasonsDocument = gql`
    query getNonLoggedInMetaseasons($options: MetaseasonsOptions) {
  metaseasons(options: $options) {
    id
    name
    startsAt
    endsAt
    isPromoted
  }
}
    `;

/**
 * __useGetNonLoggedInMetaseasonsQuery__
 *
 * To run a query within a React component, call `useGetNonLoggedInMetaseasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonLoggedInMetaseasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonLoggedInMetaseasonsQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetNonLoggedInMetaseasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetNonLoggedInMetaseasonsQuery, GetNonLoggedInMetaseasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonLoggedInMetaseasonsQuery, GetNonLoggedInMetaseasonsQueryVariables>(GetNonLoggedInMetaseasonsDocument, options);
      }
export function useGetNonLoggedInMetaseasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonLoggedInMetaseasonsQuery, GetNonLoggedInMetaseasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonLoggedInMetaseasonsQuery, GetNonLoggedInMetaseasonsQueryVariables>(GetNonLoggedInMetaseasonsDocument, options);
        }
export type GetNonLoggedInMetaseasonsQueryHookResult = ReturnType<typeof useGetNonLoggedInMetaseasonsQuery>;
export type GetNonLoggedInMetaseasonsLazyQueryHookResult = ReturnType<typeof useGetNonLoggedInMetaseasonsLazyQuery>;
export type GetNonLoggedInMetaseasonsQueryResult = Apollo.QueryResult<GetNonLoggedInMetaseasonsQuery, GetNonLoggedInMetaseasonsQueryVariables>;
export function refetchGetNonLoggedInMetaseasonsQuery(variables?: GetNonLoggedInMetaseasonsQueryVariables) {
      return { query: GetNonLoggedInMetaseasonsDocument, variables: variables }
    }
export const GetLeagueMetaseasonsByLeagueIdDocument = gql`
    query getLeagueMetaseasonsByLeagueId($leagueId: UUID!) {
  league(id: $leagueId) {
    id
    seasons {
      id
      status
      metaseason {
        id
        name
        startsAt
        endsAt
        isPromoted
        status
      }
    }
  }
}
    `;

/**
 * __useGetLeagueMetaseasonsByLeagueIdQuery__
 *
 * To run a query within a React component, call `useGetLeagueMetaseasonsByLeagueIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueMetaseasonsByLeagueIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueMetaseasonsByLeagueIdQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useGetLeagueMetaseasonsByLeagueIdQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueMetaseasonsByLeagueIdQuery, GetLeagueMetaseasonsByLeagueIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueMetaseasonsByLeagueIdQuery, GetLeagueMetaseasonsByLeagueIdQueryVariables>(GetLeagueMetaseasonsByLeagueIdDocument, options);
      }
export function useGetLeagueMetaseasonsByLeagueIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueMetaseasonsByLeagueIdQuery, GetLeagueMetaseasonsByLeagueIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueMetaseasonsByLeagueIdQuery, GetLeagueMetaseasonsByLeagueIdQueryVariables>(GetLeagueMetaseasonsByLeagueIdDocument, options);
        }
export type GetLeagueMetaseasonsByLeagueIdQueryHookResult = ReturnType<typeof useGetLeagueMetaseasonsByLeagueIdQuery>;
export type GetLeagueMetaseasonsByLeagueIdLazyQueryHookResult = ReturnType<typeof useGetLeagueMetaseasonsByLeagueIdLazyQuery>;
export type GetLeagueMetaseasonsByLeagueIdQueryResult = Apollo.QueryResult<GetLeagueMetaseasonsByLeagueIdQuery, GetLeagueMetaseasonsByLeagueIdQueryVariables>;
export function refetchGetLeagueMetaseasonsByLeagueIdQuery(variables: GetLeagueMetaseasonsByLeagueIdQueryVariables) {
      return { query: GetLeagueMetaseasonsByLeagueIdDocument, variables: variables }
    }
export const GetSchoolRolesDocument = gql`
    query getSchoolRoles {
  getSchoolRoles {
    roles {
      schoolId
      school {
        id
        name
        competitionGroup
      }
    }
  }
}
    `;

/**
 * __useGetSchoolRolesQuery__
 *
 * To run a query within a React component, call `useGetSchoolRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSchoolRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetSchoolRolesQuery, GetSchoolRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolRolesQuery, GetSchoolRolesQueryVariables>(GetSchoolRolesDocument, options);
      }
export function useGetSchoolRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolRolesQuery, GetSchoolRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolRolesQuery, GetSchoolRolesQueryVariables>(GetSchoolRolesDocument, options);
        }
export type GetSchoolRolesQueryHookResult = ReturnType<typeof useGetSchoolRolesQuery>;
export type GetSchoolRolesLazyQueryHookResult = ReturnType<typeof useGetSchoolRolesLazyQuery>;
export type GetSchoolRolesQueryResult = Apollo.QueryResult<GetSchoolRolesQuery, GetSchoolRolesQueryVariables>;
export function refetchGetSchoolRolesQuery(variables?: GetSchoolRolesQueryVariables) {
      return { query: GetSchoolRolesDocument, variables: variables }
    }
export const GetSchoolRolesByUserDocument = gql`
    query getSchoolRolesByUser($userId: UUID!) {
  getSchoolRolesByUser(userId: $userId) {
    roles {
      schoolId
      school {
        id
        deletedAt
        name
        logoUrl
        coaches {
          id
          name
        }
      }
      role {
        roleName
        resourceId
        resourceType
        userId
        status
        deletedAt
      }
    }
  }
}
    `;

/**
 * __useGetSchoolRolesByUserQuery__
 *
 * To run a query within a React component, call `useGetSchoolRolesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolRolesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolRolesByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSchoolRolesByUserQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolRolesByUserQuery, GetSchoolRolesByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolRolesByUserQuery, GetSchoolRolesByUserQueryVariables>(GetSchoolRolesByUserDocument, options);
      }
export function useGetSchoolRolesByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolRolesByUserQuery, GetSchoolRolesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolRolesByUserQuery, GetSchoolRolesByUserQueryVariables>(GetSchoolRolesByUserDocument, options);
        }
export type GetSchoolRolesByUserQueryHookResult = ReturnType<typeof useGetSchoolRolesByUserQuery>;
export type GetSchoolRolesByUserLazyQueryHookResult = ReturnType<typeof useGetSchoolRolesByUserLazyQuery>;
export type GetSchoolRolesByUserQueryResult = Apollo.QueryResult<GetSchoolRolesByUserQuery, GetSchoolRolesByUserQueryVariables>;
export function refetchGetSchoolRolesByUserQuery(variables: GetSchoolRolesByUserQueryVariables) {
      return { query: GetSchoolRolesByUserDocument, variables: variables }
    }
export const ChangeSchoolIdForUserDocument = gql`
    mutation changeSchoolIdForUser($schoolId: UUID!) {
  changeSchoolIdForUser(schoolId: $schoolId) {
    success
    userId
  }
}
    `;
export type ChangeSchoolIdForUserMutationFn = Apollo.MutationFunction<ChangeSchoolIdForUserMutation, ChangeSchoolIdForUserMutationVariables>;

/**
 * __useChangeSchoolIdForUserMutation__
 *
 * To run a mutation, you first call `useChangeSchoolIdForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSchoolIdForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSchoolIdForUserMutation, { data, loading, error }] = useChangeSchoolIdForUserMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useChangeSchoolIdForUserMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSchoolIdForUserMutation, ChangeSchoolIdForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSchoolIdForUserMutation, ChangeSchoolIdForUserMutationVariables>(ChangeSchoolIdForUserDocument, options);
      }
export type ChangeSchoolIdForUserMutationHookResult = ReturnType<typeof useChangeSchoolIdForUserMutation>;
export type ChangeSchoolIdForUserMutationResult = Apollo.MutationResult<ChangeSchoolIdForUserMutation>;
export type ChangeSchoolIdForUserMutationOptions = Apollo.BaseMutationOptions<ChangeSchoolIdForUserMutation, ChangeSchoolIdForUserMutationVariables>;
export const AddAdditionalCoachRoleToUserDocument = gql`
    mutation addAdditionalCoachRoleToUser($input: UserRoleUpdateInput!) {
  addAdditionalCoachRoleToUser(input: $input) {
    success
    userId
  }
}
    `;
export type AddAdditionalCoachRoleToUserMutationFn = Apollo.MutationFunction<AddAdditionalCoachRoleToUserMutation, AddAdditionalCoachRoleToUserMutationVariables>;

/**
 * __useAddAdditionalCoachRoleToUserMutation__
 *
 * To run a mutation, you first call `useAddAdditionalCoachRoleToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdditionalCoachRoleToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdditionalCoachRoleToUserMutation, { data, loading, error }] = useAddAdditionalCoachRoleToUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAdditionalCoachRoleToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddAdditionalCoachRoleToUserMutation, AddAdditionalCoachRoleToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAdditionalCoachRoleToUserMutation, AddAdditionalCoachRoleToUserMutationVariables>(AddAdditionalCoachRoleToUserDocument, options);
      }
export type AddAdditionalCoachRoleToUserMutationHookResult = ReturnType<typeof useAddAdditionalCoachRoleToUserMutation>;
export type AddAdditionalCoachRoleToUserMutationResult = Apollo.MutationResult<AddAdditionalCoachRoleToUserMutation>;
export type AddAdditionalCoachRoleToUserMutationOptions = Apollo.BaseMutationOptions<AddAdditionalCoachRoleToUserMutation, AddAdditionalCoachRoleToUserMutationVariables>;
export const CreateNoteDocument = gql`
    mutation createNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    id
    textContent
    author {
      id
      name
    }
    createdAt
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation deleteNote($id: UUID!) {
  deleteNote(id: $id) {
    success
    deletedNoteId
  }
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const FindNotesDocument = gql`
    query findNotes($options: NoteOptions) {
  findNotes(options: $options) {
    notes {
      id
      textContent
      author {
        id
        name
        avatarUrl
      }
      createdAt
    }
    count
  }
}
    `;

/**
 * __useFindNotesQuery__
 *
 * To run a query within a React component, call `useFindNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindNotesQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useFindNotesQuery(baseOptions?: Apollo.QueryHookOptions<FindNotesQuery, FindNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindNotesQuery, FindNotesQueryVariables>(FindNotesDocument, options);
      }
export function useFindNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindNotesQuery, FindNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindNotesQuery, FindNotesQueryVariables>(FindNotesDocument, options);
        }
export type FindNotesQueryHookResult = ReturnType<typeof useFindNotesQuery>;
export type FindNotesLazyQueryHookResult = ReturnType<typeof useFindNotesLazyQuery>;
export type FindNotesQueryResult = Apollo.QueryResult<FindNotesQuery, FindNotesQueryVariables>;
export function refetchFindNotesQuery(variables?: FindNotesQueryVariables) {
      return { query: FindNotesDocument, variables: variables }
    }
export const GetNoteAuthorsDocument = gql`
    query getNoteAuthors($input: GetNoteAuthorsInput) {
  getNoteAuthors(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useGetNoteAuthorsQuery__
 *
 * To run a query within a React component, call `useGetNoteAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteAuthorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNoteAuthorsQuery(baseOptions?: Apollo.QueryHookOptions<GetNoteAuthorsQuery, GetNoteAuthorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoteAuthorsQuery, GetNoteAuthorsQueryVariables>(GetNoteAuthorsDocument, options);
      }
export function useGetNoteAuthorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoteAuthorsQuery, GetNoteAuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoteAuthorsQuery, GetNoteAuthorsQueryVariables>(GetNoteAuthorsDocument, options);
        }
export type GetNoteAuthorsQueryHookResult = ReturnType<typeof useGetNoteAuthorsQuery>;
export type GetNoteAuthorsLazyQueryHookResult = ReturnType<typeof useGetNoteAuthorsLazyQuery>;
export type GetNoteAuthorsQueryResult = Apollo.QueryResult<GetNoteAuthorsQuery, GetNoteAuthorsQueryVariables>;
export function refetchGetNoteAuthorsQuery(variables?: GetNoteAuthorsQueryVariables) {
      return { query: GetNoteAuthorsDocument, variables: variables }
    }
export const GetLegacyNotificationsDocument = gql`
    query getLegacyNotifications {
  getAllPendingLegacyNotifications {
    id
    status
    total
    rescheduleMatchId
    surveyMatchId
    notification {
      id
      name
      description
      title
      type
      buttonText
      href
      imageUrl
    }
  }
}
    `;

/**
 * __useGetLegacyNotificationsQuery__
 *
 * To run a query within a React component, call `useGetLegacyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLegacyNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLegacyNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLegacyNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLegacyNotificationsQuery, GetLegacyNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLegacyNotificationsQuery, GetLegacyNotificationsQueryVariables>(GetLegacyNotificationsDocument, options);
      }
export function useGetLegacyNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLegacyNotificationsQuery, GetLegacyNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLegacyNotificationsQuery, GetLegacyNotificationsQueryVariables>(GetLegacyNotificationsDocument, options);
        }
export type GetLegacyNotificationsQueryHookResult = ReturnType<typeof useGetLegacyNotificationsQuery>;
export type GetLegacyNotificationsLazyQueryHookResult = ReturnType<typeof useGetLegacyNotificationsLazyQuery>;
export type GetLegacyNotificationsQueryResult = Apollo.QueryResult<GetLegacyNotificationsQuery, GetLegacyNotificationsQueryVariables>;
export function refetchGetLegacyNotificationsQuery(variables?: GetLegacyNotificationsQueryVariables) {
      return { query: GetLegacyNotificationsDocument, variables: variables }
    }
export const AcknowledgeNotificationDocument = gql`
    mutation acknowledgeNotification($notificationId: UUID!) {
  ackPendingNotification(id: $notificationId) {
    success
  }
}
    `;
export type AcknowledgeNotificationMutationFn = Apollo.MutationFunction<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>;

/**
 * __useAcknowledgeNotificationMutation__
 *
 * To run a mutation, you first call `useAcknowledgeNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeNotificationMutation, { data, loading, error }] = useAcknowledgeNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useAcknowledgeNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>(AcknowledgeNotificationDocument, options);
      }
export type AcknowledgeNotificationMutationHookResult = ReturnType<typeof useAcknowledgeNotificationMutation>;
export type AcknowledgeNotificationMutationResult = Apollo.MutationResult<AcknowledgeNotificationMutation>;
export type AcknowledgeNotificationMutationOptions = Apollo.BaseMutationOptions<AcknowledgeNotificationMutation, AcknowledgeNotificationMutationVariables>;
export const GetNotificationCenterSummaryDocument = gql`
    query getNotificationCenterSummary($limit: Int, $skipTasks: Boolean = true) {
  userNotifications {
    id
    unreadCount
  }
  getIncompleteNotificationTaskCount(limit: $limit) @skip(if: $skipTasks)
}
    `;

/**
 * __useGetNotificationCenterSummaryQuery__
 *
 * To run a query within a React component, call `useGetNotificationCenterSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationCenterSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationCenterSummaryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skipTasks: // value for 'skipTasks'
 *   },
 * });
 */
export function useGetNotificationCenterSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationCenterSummaryQuery, GetNotificationCenterSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationCenterSummaryQuery, GetNotificationCenterSummaryQueryVariables>(GetNotificationCenterSummaryDocument, options);
      }
export function useGetNotificationCenterSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationCenterSummaryQuery, GetNotificationCenterSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationCenterSummaryQuery, GetNotificationCenterSummaryQueryVariables>(GetNotificationCenterSummaryDocument, options);
        }
export type GetNotificationCenterSummaryQueryHookResult = ReturnType<typeof useGetNotificationCenterSummaryQuery>;
export type GetNotificationCenterSummaryLazyQueryHookResult = ReturnType<typeof useGetNotificationCenterSummaryLazyQuery>;
export type GetNotificationCenterSummaryQueryResult = Apollo.QueryResult<GetNotificationCenterSummaryQuery, GetNotificationCenterSummaryQueryVariables>;
export function refetchGetNotificationCenterSummaryQuery(variables?: GetNotificationCenterSummaryQueryVariables) {
      return { query: GetNotificationCenterSummaryDocument, variables: variables }
    }
export const GetUserNotificationSummaryDocument = gql`
    subscription getUserNotificationSummary($userId: UUID!) {
  userNotificationSummary(userId: $userId) {
    unreadNotificationCount
    notificationTasksCount
  }
}
    `;

/**
 * __useGetUserNotificationSummarySubscription__
 *
 * To run a query within a React component, call `useGetUserNotificationSummarySubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationSummarySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationSummarySubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserNotificationSummarySubscription(baseOptions: Apollo.SubscriptionHookOptions<GetUserNotificationSummarySubscription, GetUserNotificationSummarySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetUserNotificationSummarySubscription, GetUserNotificationSummarySubscriptionVariables>(GetUserNotificationSummaryDocument, options);
      }
export type GetUserNotificationSummarySubscriptionHookResult = ReturnType<typeof useGetUserNotificationSummarySubscription>;
export type GetUserNotificationSummarySubscriptionResult = Apollo.SubscriptionResult<GetUserNotificationSummarySubscription>;
export const GetNotificationCenterDocument = gql`
    query getNotificationCenter($after: String, $first: Int) {
  userNotifications {
    id
    notifications(after: $after, first: $first) {
      edges {
        node {
          id
          type
          createdAt
          openedAt
          contentData {
            messageDates
            message
            image1
            image2
            url
            invoke
            glyph
            team1Id
            team2Id
            rating
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNext
      }
    }
  }
}
    `;

/**
 * __useGetNotificationCenterQuery__
 *
 * To run a query within a React component, call `useGetNotificationCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationCenterQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetNotificationCenterQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationCenterQuery, GetNotificationCenterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationCenterQuery, GetNotificationCenterQueryVariables>(GetNotificationCenterDocument, options);
      }
export function useGetNotificationCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationCenterQuery, GetNotificationCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationCenterQuery, GetNotificationCenterQueryVariables>(GetNotificationCenterDocument, options);
        }
export type GetNotificationCenterQueryHookResult = ReturnType<typeof useGetNotificationCenterQuery>;
export type GetNotificationCenterLazyQueryHookResult = ReturnType<typeof useGetNotificationCenterLazyQuery>;
export type GetNotificationCenterQueryResult = Apollo.QueryResult<GetNotificationCenterQuery, GetNotificationCenterQueryVariables>;
export function refetchGetNotificationCenterQuery(variables?: GetNotificationCenterQueryVariables) {
      return { query: GetNotificationCenterDocument, variables: variables }
    }
export const GetIncompleteNotificationTasksDocument = gql`
    query getIncompleteNotificationTasks($after: String, $first: Int) {
  getIncompleteNotificationTasks(after: $after, first: $first) {
    edges {
      node {
        id
        type
        createdAt
        openedAt
        contentData {
          messageDates
          message
          image1
          image2
          url
          invoke
          glyph
          team1Id
          team2Id
          rating
        }
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNext
    }
  }
}
    `;

/**
 * __useGetIncompleteNotificationTasksQuery__
 *
 * To run a query within a React component, call `useGetIncompleteNotificationTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncompleteNotificationTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncompleteNotificationTasksQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetIncompleteNotificationTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetIncompleteNotificationTasksQuery, GetIncompleteNotificationTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncompleteNotificationTasksQuery, GetIncompleteNotificationTasksQueryVariables>(GetIncompleteNotificationTasksDocument, options);
      }
export function useGetIncompleteNotificationTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncompleteNotificationTasksQuery, GetIncompleteNotificationTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncompleteNotificationTasksQuery, GetIncompleteNotificationTasksQueryVariables>(GetIncompleteNotificationTasksDocument, options);
        }
export type GetIncompleteNotificationTasksQueryHookResult = ReturnType<typeof useGetIncompleteNotificationTasksQuery>;
export type GetIncompleteNotificationTasksLazyQueryHookResult = ReturnType<typeof useGetIncompleteNotificationTasksLazyQuery>;
export type GetIncompleteNotificationTasksQueryResult = Apollo.QueryResult<GetIncompleteNotificationTasksQuery, GetIncompleteNotificationTasksQueryVariables>;
export function refetchGetIncompleteNotificationTasksQuery(variables?: GetIncompleteNotificationTasksQueryVariables) {
      return { query: GetIncompleteNotificationTasksDocument, variables: variables }
    }
export const GetUserNotificationSettingsDocument = gql`
    query getUserNotificationSettings($input: getUserNotificationsSettingsInput!) {
  getUserNotificationsSettings(input: $input) {
    success
    userNotificationSettings {
      userEmail {
        email
      }
      category
      enabled
      scope
      isPersonalEmail
    }
  }
}
    `;

/**
 * __useGetUserNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserNotificationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>(GetUserNotificationSettingsDocument, options);
      }
export function useGetUserNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>(GetUserNotificationSettingsDocument, options);
        }
export type GetUserNotificationSettingsQueryHookResult = ReturnType<typeof useGetUserNotificationSettingsQuery>;
export type GetUserNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetUserNotificationSettingsLazyQuery>;
export type GetUserNotificationSettingsQueryResult = Apollo.QueryResult<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>;
export function refetchGetUserNotificationSettingsQuery(variables: GetUserNotificationSettingsQueryVariables) {
      return { query: GetUserNotificationSettingsDocument, variables: variables }
    }
export const MarkAllUserNotificationsReadDocument = gql`
    mutation markAllUserNotificationsRead($notificationId: ObjectID!) {
  markAllUserNotificationsRead(input: {lastReadNotificationId: $notificationId}) {
    success
  }
}
    `;
export type MarkAllUserNotificationsReadMutationFn = Apollo.MutationFunction<MarkAllUserNotificationsReadMutation, MarkAllUserNotificationsReadMutationVariables>;

/**
 * __useMarkAllUserNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllUserNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllUserNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllUserNotificationsReadMutation, { data, loading, error }] = useMarkAllUserNotificationsReadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkAllUserNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllUserNotificationsReadMutation, MarkAllUserNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllUserNotificationsReadMutation, MarkAllUserNotificationsReadMutationVariables>(MarkAllUserNotificationsReadDocument, options);
      }
export type MarkAllUserNotificationsReadMutationHookResult = ReturnType<typeof useMarkAllUserNotificationsReadMutation>;
export type MarkAllUserNotificationsReadMutationResult = Apollo.MutationResult<MarkAllUserNotificationsReadMutation>;
export type MarkAllUserNotificationsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllUserNotificationsReadMutation, MarkAllUserNotificationsReadMutationVariables>;
export const MarkUserNotificationOpenedDocument = gql`
    mutation markUserNotificationOpened($notificationId: ObjectID!) {
  markUserNotificationOpened(input: {userNotificationId: $notificationId}) {
    userNotification {
      id
      openedAt
    }
  }
}
    `;
export type MarkUserNotificationOpenedMutationFn = Apollo.MutationFunction<MarkUserNotificationOpenedMutation, MarkUserNotificationOpenedMutationVariables>;

/**
 * __useMarkUserNotificationOpenedMutation__
 *
 * To run a mutation, you first call `useMarkUserNotificationOpenedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUserNotificationOpenedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUserNotificationOpenedMutation, { data, loading, error }] = useMarkUserNotificationOpenedMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkUserNotificationOpenedMutation(baseOptions?: Apollo.MutationHookOptions<MarkUserNotificationOpenedMutation, MarkUserNotificationOpenedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUserNotificationOpenedMutation, MarkUserNotificationOpenedMutationVariables>(MarkUserNotificationOpenedDocument, options);
      }
export type MarkUserNotificationOpenedMutationHookResult = ReturnType<typeof useMarkUserNotificationOpenedMutation>;
export type MarkUserNotificationOpenedMutationResult = Apollo.MutationResult<MarkUserNotificationOpenedMutation>;
export type MarkUserNotificationOpenedMutationOptions = Apollo.BaseMutationOptions<MarkUserNotificationOpenedMutation, MarkUserNotificationOpenedMutationVariables>;
export const MarkUserNotificationTaskOpenedDocument = gql`
    mutation markUserNotificationTaskOpened($notificationId: ObjectID!) {
  markUserNotificationTaskOpened(input: {userNotificationId: $notificationId}) {
    userNotification {
      id
      openedAt
    }
  }
}
    `;
export type MarkUserNotificationTaskOpenedMutationFn = Apollo.MutationFunction<MarkUserNotificationTaskOpenedMutation, MarkUserNotificationTaskOpenedMutationVariables>;

/**
 * __useMarkUserNotificationTaskOpenedMutation__
 *
 * To run a mutation, you first call `useMarkUserNotificationTaskOpenedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUserNotificationTaskOpenedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUserNotificationTaskOpenedMutation, { data, loading, error }] = useMarkUserNotificationTaskOpenedMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkUserNotificationTaskOpenedMutation(baseOptions?: Apollo.MutationHookOptions<MarkUserNotificationTaskOpenedMutation, MarkUserNotificationTaskOpenedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUserNotificationTaskOpenedMutation, MarkUserNotificationTaskOpenedMutationVariables>(MarkUserNotificationTaskOpenedDocument, options);
      }
export type MarkUserNotificationTaskOpenedMutationHookResult = ReturnType<typeof useMarkUserNotificationTaskOpenedMutation>;
export type MarkUserNotificationTaskOpenedMutationResult = Apollo.MutationResult<MarkUserNotificationTaskOpenedMutation>;
export type MarkUserNotificationTaskOpenedMutationOptions = Apollo.BaseMutationOptions<MarkUserNotificationTaskOpenedMutation, MarkUserNotificationTaskOpenedMutationVariables>;
export const MarkUserNotificationTaskCompletedDocument = gql`
    mutation markUserNotificationTaskCompleted($userNotificationId: ObjectID!) {
  markUserNotificationTaskCompleted(
    input: {userNotificationId: $userNotificationId}
  ) {
    success
    userNotificationId
  }
}
    `;
export type MarkUserNotificationTaskCompletedMutationFn = Apollo.MutationFunction<MarkUserNotificationTaskCompletedMutation, MarkUserNotificationTaskCompletedMutationVariables>;

/**
 * __useMarkUserNotificationTaskCompletedMutation__
 *
 * To run a mutation, you first call `useMarkUserNotificationTaskCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkUserNotificationTaskCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markUserNotificationTaskCompletedMutation, { data, loading, error }] = useMarkUserNotificationTaskCompletedMutation({
 *   variables: {
 *      userNotificationId: // value for 'userNotificationId'
 *   },
 * });
 */
export function useMarkUserNotificationTaskCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkUserNotificationTaskCompletedMutation, MarkUserNotificationTaskCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkUserNotificationTaskCompletedMutation, MarkUserNotificationTaskCompletedMutationVariables>(MarkUserNotificationTaskCompletedDocument, options);
      }
export type MarkUserNotificationTaskCompletedMutationHookResult = ReturnType<typeof useMarkUserNotificationTaskCompletedMutation>;
export type MarkUserNotificationTaskCompletedMutationResult = Apollo.MutationResult<MarkUserNotificationTaskCompletedMutation>;
export type MarkUserNotificationTaskCompletedMutationOptions = Apollo.BaseMutationOptions<MarkUserNotificationTaskCompletedMutation, MarkUserNotificationTaskCompletedMutationVariables>;
export const SetUserNotificationScopeDocument = gql`
    mutation setUserNotificationScope($input: SetUserNotificationScopeInput!) {
  setUserNotificationScope(input: $input) {
    success
  }
}
    `;
export type SetUserNotificationScopeMutationFn = Apollo.MutationFunction<SetUserNotificationScopeMutation, SetUserNotificationScopeMutationVariables>;

/**
 * __useSetUserNotificationScopeMutation__
 *
 * To run a mutation, you first call `useSetUserNotificationScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserNotificationScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserNotificationScopeMutation, { data, loading, error }] = useSetUserNotificationScopeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserNotificationScopeMutation(baseOptions?: Apollo.MutationHookOptions<SetUserNotificationScopeMutation, SetUserNotificationScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserNotificationScopeMutation, SetUserNotificationScopeMutationVariables>(SetUserNotificationScopeDocument, options);
      }
export type SetUserNotificationScopeMutationHookResult = ReturnType<typeof useSetUserNotificationScopeMutation>;
export type SetUserNotificationScopeMutationResult = Apollo.MutationResult<SetUserNotificationScopeMutation>;
export type SetUserNotificationScopeMutationOptions = Apollo.BaseMutationOptions<SetUserNotificationScopeMutation, SetUserNotificationScopeMutationVariables>;
export const SetUserNotificationEnabledDocument = gql`
    mutation setUserNotificationEnabled($input: SetUserNotificationEnabledInput!) {
  setUserNotificationEnabled(input: $input) {
    success
  }
}
    `;
export type SetUserNotificationEnabledMutationFn = Apollo.MutationFunction<SetUserNotificationEnabledMutation, SetUserNotificationEnabledMutationVariables>;

/**
 * __useSetUserNotificationEnabledMutation__
 *
 * To run a mutation, you first call `useSetUserNotificationEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserNotificationEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserNotificationEnabledMutation, { data, loading, error }] = useSetUserNotificationEnabledMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserNotificationEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetUserNotificationEnabledMutation, SetUserNotificationEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserNotificationEnabledMutation, SetUserNotificationEnabledMutationVariables>(SetUserNotificationEnabledDocument, options);
      }
export type SetUserNotificationEnabledMutationHookResult = ReturnType<typeof useSetUserNotificationEnabledMutation>;
export type SetUserNotificationEnabledMutationResult = Apollo.MutationResult<SetUserNotificationEnabledMutation>;
export type SetUserNotificationEnabledMutationOptions = Apollo.BaseMutationOptions<SetUserNotificationEnabledMutation, SetUserNotificationEnabledMutationVariables>;
export const SetUserNotificationIsPersonalDocument = gql`
    mutation setUserNotificationIsPersonal($input: SetUserNotificationIsPersonalInput!) {
  setUserNotificationIsPersonal(input: $input) {
    success
  }
}
    `;
export type SetUserNotificationIsPersonalMutationFn = Apollo.MutationFunction<SetUserNotificationIsPersonalMutation, SetUserNotificationIsPersonalMutationVariables>;

/**
 * __useSetUserNotificationIsPersonalMutation__
 *
 * To run a mutation, you first call `useSetUserNotificationIsPersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserNotificationIsPersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserNotificationIsPersonalMutation, { data, loading, error }] = useSetUserNotificationIsPersonalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserNotificationIsPersonalMutation(baseOptions?: Apollo.MutationHookOptions<SetUserNotificationIsPersonalMutation, SetUserNotificationIsPersonalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserNotificationIsPersonalMutation, SetUserNotificationIsPersonalMutationVariables>(SetUserNotificationIsPersonalDocument, options);
      }
export type SetUserNotificationIsPersonalMutationHookResult = ReturnType<typeof useSetUserNotificationIsPersonalMutation>;
export type SetUserNotificationIsPersonalMutationResult = Apollo.MutationResult<SetUserNotificationIsPersonalMutation>;
export type SetUserNotificationIsPersonalMutationOptions = Apollo.BaseMutationOptions<SetUserNotificationIsPersonalMutation, SetUserNotificationIsPersonalMutationVariables>;
export const MarkAllUserNotificationsOpenedDocument = gql`
    mutation markAllUserNotificationsOpened {
  markAllUserNotificationsOpened {
    success
  }
}
    `;
export type MarkAllUserNotificationsOpenedMutationFn = Apollo.MutationFunction<MarkAllUserNotificationsOpenedMutation, MarkAllUserNotificationsOpenedMutationVariables>;

/**
 * __useMarkAllUserNotificationsOpenedMutation__
 *
 * To run a mutation, you first call `useMarkAllUserNotificationsOpenedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllUserNotificationsOpenedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllUserNotificationsOpenedMutation, { data, loading, error }] = useMarkAllUserNotificationsOpenedMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllUserNotificationsOpenedMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllUserNotificationsOpenedMutation, MarkAllUserNotificationsOpenedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllUserNotificationsOpenedMutation, MarkAllUserNotificationsOpenedMutationVariables>(MarkAllUserNotificationsOpenedDocument, options);
      }
export type MarkAllUserNotificationsOpenedMutationHookResult = ReturnType<typeof useMarkAllUserNotificationsOpenedMutation>;
export type MarkAllUserNotificationsOpenedMutationResult = Apollo.MutationResult<MarkAllUserNotificationsOpenedMutation>;
export type MarkAllUserNotificationsOpenedMutationOptions = Apollo.BaseMutationOptions<MarkAllUserNotificationsOpenedMutation, MarkAllUserNotificationsOpenedMutationVariables>;
export const GetReferringUserDocument = gql`
    query getReferringUser {
  me {
    id
    roles {
      roleName
      userId
      resourceId
    }
  }
}
    `;

/**
 * __useGetReferringUserQuery__
 *
 * To run a query within a React component, call `useGetReferringUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferringUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferringUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferringUserQuery(baseOptions?: Apollo.QueryHookOptions<GetReferringUserQuery, GetReferringUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferringUserQuery, GetReferringUserQueryVariables>(GetReferringUserDocument, options);
      }
export function useGetReferringUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferringUserQuery, GetReferringUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferringUserQuery, GetReferringUserQueryVariables>(GetReferringUserDocument, options);
        }
export type GetReferringUserQueryHookResult = ReturnType<typeof useGetReferringUserQuery>;
export type GetReferringUserLazyQueryHookResult = ReturnType<typeof useGetReferringUserLazyQuery>;
export type GetReferringUserQueryResult = Apollo.QueryResult<GetReferringUserQuery, GetReferringUserQueryVariables>;
export function refetchGetReferringUserQuery(variables?: GetReferringUserQueryVariables) {
      return { query: GetReferringUserDocument, variables: variables }
    }
export const OnboardingSchoolSearchDocument = gql`
    query onboardingSchoolSearch($query: String!, $state: String!, $type: String!) {
  searchSchools(query: {nameQuery: $query, state: $state, type: $type}) {
    results {
      schoolId
      name
      searchScore
      type
      address
      city
      state
      zip
      logoUrl
    }
  }
}
    `;

/**
 * __useOnboardingSchoolSearchQuery__
 *
 * To run a query within a React component, call `useOnboardingSchoolSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingSchoolSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingSchoolSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      state: // value for 'state'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useOnboardingSchoolSearchQuery(baseOptions: Apollo.QueryHookOptions<OnboardingSchoolSearchQuery, OnboardingSchoolSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingSchoolSearchQuery, OnboardingSchoolSearchQueryVariables>(OnboardingSchoolSearchDocument, options);
      }
export function useOnboardingSchoolSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingSchoolSearchQuery, OnboardingSchoolSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingSchoolSearchQuery, OnboardingSchoolSearchQueryVariables>(OnboardingSchoolSearchDocument, options);
        }
export type OnboardingSchoolSearchQueryHookResult = ReturnType<typeof useOnboardingSchoolSearchQuery>;
export type OnboardingSchoolSearchLazyQueryHookResult = ReturnType<typeof useOnboardingSchoolSearchLazyQuery>;
export type OnboardingSchoolSearchQueryResult = Apollo.QueryResult<OnboardingSchoolSearchQuery, OnboardingSchoolSearchQueryVariables>;
export function refetchOnboardingSchoolSearchQuery(variables: OnboardingSchoolSearchQueryVariables) {
      return { query: OnboardingSchoolSearchDocument, variables: variables }
    }
export const MyOnboardReferralDocument = gql`
    query myOnboardReferral {
  me {
    id
    school {
      id
      competitionGroup
    }
    referralLinks {
      fac
      student
    }
  }
}
    `;

/**
 * __useMyOnboardReferralQuery__
 *
 * To run a query within a React component, call `useMyOnboardReferralQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOnboardReferralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOnboardReferralQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyOnboardReferralQuery(baseOptions?: Apollo.QueryHookOptions<MyOnboardReferralQuery, MyOnboardReferralQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyOnboardReferralQuery, MyOnboardReferralQueryVariables>(MyOnboardReferralDocument, options);
      }
export function useMyOnboardReferralLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyOnboardReferralQuery, MyOnboardReferralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyOnboardReferralQuery, MyOnboardReferralQueryVariables>(MyOnboardReferralDocument, options);
        }
export type MyOnboardReferralQueryHookResult = ReturnType<typeof useMyOnboardReferralQuery>;
export type MyOnboardReferralLazyQueryHookResult = ReturnType<typeof useMyOnboardReferralLazyQuery>;
export type MyOnboardReferralQueryResult = Apollo.QueryResult<MyOnboardReferralQuery, MyOnboardReferralQueryVariables>;
export function refetchMyOnboardReferralQuery(variables?: MyOnboardReferralQueryVariables) {
      return { query: MyOnboardReferralDocument, variables: variables }
    }
export const GetMissingFieldsAtAppLaunchDocument = gql`
    query getMissingFieldsAtAppLaunch {
  userAttributes {
    missingFieldsAtAppLaunch
  }
  me {
    id
    school {
      id
    }
  }
}
    `;

/**
 * __useGetMissingFieldsAtAppLaunchQuery__
 *
 * To run a query within a React component, call `useGetMissingFieldsAtAppLaunchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMissingFieldsAtAppLaunchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMissingFieldsAtAppLaunchQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMissingFieldsAtAppLaunchQuery(baseOptions?: Apollo.QueryHookOptions<GetMissingFieldsAtAppLaunchQuery, GetMissingFieldsAtAppLaunchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMissingFieldsAtAppLaunchQuery, GetMissingFieldsAtAppLaunchQueryVariables>(GetMissingFieldsAtAppLaunchDocument, options);
      }
export function useGetMissingFieldsAtAppLaunchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMissingFieldsAtAppLaunchQuery, GetMissingFieldsAtAppLaunchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMissingFieldsAtAppLaunchQuery, GetMissingFieldsAtAppLaunchQueryVariables>(GetMissingFieldsAtAppLaunchDocument, options);
        }
export type GetMissingFieldsAtAppLaunchQueryHookResult = ReturnType<typeof useGetMissingFieldsAtAppLaunchQuery>;
export type GetMissingFieldsAtAppLaunchLazyQueryHookResult = ReturnType<typeof useGetMissingFieldsAtAppLaunchLazyQuery>;
export type GetMissingFieldsAtAppLaunchQueryResult = Apollo.QueryResult<GetMissingFieldsAtAppLaunchQuery, GetMissingFieldsAtAppLaunchQueryVariables>;
export function refetchGetMissingFieldsAtAppLaunchQuery(variables?: GetMissingFieldsAtAppLaunchQueryVariables) {
      return { query: GetMissingFieldsAtAppLaunchDocument, variables: variables }
    }
export const ReferByEmailDocument = gql`
    mutation referByEmail($input: ReferByEmailInput!) {
  referByEmail(input: $input) {
    success
  }
}
    `;
export type ReferByEmailMutationFn = Apollo.MutationFunction<ReferByEmailMutation, ReferByEmailMutationVariables>;

/**
 * __useReferByEmailMutation__
 *
 * To run a mutation, you first call `useReferByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReferByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referByEmailMutation, { data, loading, error }] = useReferByEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReferByEmailMutation(baseOptions?: Apollo.MutationHookOptions<ReferByEmailMutation, ReferByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReferByEmailMutation, ReferByEmailMutationVariables>(ReferByEmailDocument, options);
      }
export type ReferByEmailMutationHookResult = ReturnType<typeof useReferByEmailMutation>;
export type ReferByEmailMutationResult = Apollo.MutationResult<ReferByEmailMutation>;
export type ReferByEmailMutationOptions = Apollo.BaseMutationOptions<ReferByEmailMutation, ReferByEmailMutationVariables>;
export const SetMyFacultyInformationDocument = gql`
    mutation setMyFacultyInformation($input: SetMyFacultyInformationInput!) {
  setMyFacultyInformation(input: $input) {
    success
  }
}
    `;
export type SetMyFacultyInformationMutationFn = Apollo.MutationFunction<SetMyFacultyInformationMutation, SetMyFacultyInformationMutationVariables>;

/**
 * __useSetMyFacultyInformationMutation__
 *
 * To run a mutation, you first call `useSetMyFacultyInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyFacultyInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyFacultyInformationMutation, { data, loading, error }] = useSetMyFacultyInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMyFacultyInformationMutation(baseOptions?: Apollo.MutationHookOptions<SetMyFacultyInformationMutation, SetMyFacultyInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyFacultyInformationMutation, SetMyFacultyInformationMutationVariables>(SetMyFacultyInformationDocument, options);
      }
export type SetMyFacultyInformationMutationHookResult = ReturnType<typeof useSetMyFacultyInformationMutation>;
export type SetMyFacultyInformationMutationResult = Apollo.MutationResult<SetMyFacultyInformationMutation>;
export type SetMyFacultyInformationMutationOptions = Apollo.BaseMutationOptions<SetMyFacultyInformationMutation, SetMyFacultyInformationMutationVariables>;
export const SetMySchoolSubmissionDocument = gql`
    mutation setMySchoolSubmission($schoolId: UUID!, $input: SetMySchoolSubmissionInput!) {
  setMySchoolSubmission(schoolId: $schoolId, input: $input) {
    success
  }
}
    `;
export type SetMySchoolSubmissionMutationFn = Apollo.MutationFunction<SetMySchoolSubmissionMutation, SetMySchoolSubmissionMutationVariables>;

/**
 * __useSetMySchoolSubmissionMutation__
 *
 * To run a mutation, you first call `useSetMySchoolSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMySchoolSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMySchoolSubmissionMutation, { data, loading, error }] = useSetMySchoolSubmissionMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMySchoolSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<SetMySchoolSubmissionMutation, SetMySchoolSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMySchoolSubmissionMutation, SetMySchoolSubmissionMutationVariables>(SetMySchoolSubmissionDocument, options);
      }
export type SetMySchoolSubmissionMutationHookResult = ReturnType<typeof useSetMySchoolSubmissionMutation>;
export type SetMySchoolSubmissionMutationResult = Apollo.MutationResult<SetMySchoolSubmissionMutation>;
export type SetMySchoolSubmissionMutationOptions = Apollo.BaseMutationOptions<SetMySchoolSubmissionMutation, SetMySchoolSubmissionMutationVariables>;
export const SetSchoolBillingContactDocument = gql`
    mutation setSchoolBillingContact($schoolId: UUID!, $input: SchoolBillingContactInput!) {
  setSchoolBillingContact(schoolId: $schoolId, input: $input) {
    id
    billingContact {
      schoolId
      firstName
      lastName
      phone
      phoneExt
      email
      address
      city
      state
      zip
    }
  }
}
    `;
export type SetSchoolBillingContactMutationFn = Apollo.MutationFunction<SetSchoolBillingContactMutation, SetSchoolBillingContactMutationVariables>;

/**
 * __useSetSchoolBillingContactMutation__
 *
 * To run a mutation, you first call `useSetSchoolBillingContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSchoolBillingContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSchoolBillingContactMutation, { data, loading, error }] = useSetSchoolBillingContactMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSchoolBillingContactMutation(baseOptions?: Apollo.MutationHookOptions<SetSchoolBillingContactMutation, SetSchoolBillingContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSchoolBillingContactMutation, SetSchoolBillingContactMutationVariables>(SetSchoolBillingContactDocument, options);
      }
export type SetSchoolBillingContactMutationHookResult = ReturnType<typeof useSetSchoolBillingContactMutation>;
export type SetSchoolBillingContactMutationResult = Apollo.MutationResult<SetSchoolBillingContactMutation>;
export type SetSchoolBillingContactMutationOptions = Apollo.BaseMutationOptions<SetSchoolBillingContactMutation, SetSchoolBillingContactMutationVariables>;
export const GetScheduleConsultLinkDocument = gql`
    query getScheduleConsultLink($schoolId: UUID!, $userId: UUID!, $effectiveAt: DateTime) {
  school(id: $schoolId) {
    id
    salesRep {
      id
      calendarLink
    }
  }
  findTeamEnrollmentsByUser(
    input: {schoolId: $schoolId, userId: $userId, effectiveAt: $effectiveAt}
  ) {
    teamEnrollments {
      enrollableSeasons {
        id
        metaseasonId
      }
      enrolledSeasons {
        id
        metaseasonId
        teamRegistrationEndsAt
      }
    }
  }
}
    `;

/**
 * __useGetScheduleConsultLinkQuery__
 *
 * To run a query within a React component, call `useGetScheduleConsultLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleConsultLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleConsultLinkQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      userId: // value for 'userId'
 *      effectiveAt: // value for 'effectiveAt'
 *   },
 * });
 */
export function useGetScheduleConsultLinkQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleConsultLinkQuery, GetScheduleConsultLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleConsultLinkQuery, GetScheduleConsultLinkQueryVariables>(GetScheduleConsultLinkDocument, options);
      }
export function useGetScheduleConsultLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleConsultLinkQuery, GetScheduleConsultLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleConsultLinkQuery, GetScheduleConsultLinkQueryVariables>(GetScheduleConsultLinkDocument, options);
        }
export type GetScheduleConsultLinkQueryHookResult = ReturnType<typeof useGetScheduleConsultLinkQuery>;
export type GetScheduleConsultLinkLazyQueryHookResult = ReturnType<typeof useGetScheduleConsultLinkLazyQuery>;
export type GetScheduleConsultLinkQueryResult = Apollo.QueryResult<GetScheduleConsultLinkQuery, GetScheduleConsultLinkQueryVariables>;
export function refetchGetScheduleConsultLinkQuery(variables: GetScheduleConsultLinkQueryVariables) {
      return { query: GetScheduleConsultLinkDocument, variables: variables }
    }
export const ApplyForSchoolFacultyDocument = gql`
    mutation applyForSchoolFaculty($role: UserRoleName!, $personalEmail: String, $schoolEmail: String!, $schoolId: UUID!, $suggestedSchool: SuggestedSchoolInput, $facultyInput: ApplyForSchoolFacultyInput) {
  applyForSchool(
    input: {requestedRole: $role, personalEmail: $personalEmail, schoolEmail: $schoolEmail, schoolId: $schoolId, suggestedSchool: $suggestedSchool, facultyInput: $facultyInput}
  ) {
    user {
      school {
        id
      }
    }
  }
}
    `;
export type ApplyForSchoolFacultyMutationFn = Apollo.MutationFunction<ApplyForSchoolFacultyMutation, ApplyForSchoolFacultyMutationVariables>;

/**
 * __useApplyForSchoolFacultyMutation__
 *
 * To run a mutation, you first call `useApplyForSchoolFacultyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyForSchoolFacultyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyForSchoolFacultyMutation, { data, loading, error }] = useApplyForSchoolFacultyMutation({
 *   variables: {
 *      role: // value for 'role'
 *      personalEmail: // value for 'personalEmail'
 *      schoolEmail: // value for 'schoolEmail'
 *      schoolId: // value for 'schoolId'
 *      suggestedSchool: // value for 'suggestedSchool'
 *      facultyInput: // value for 'facultyInput'
 *   },
 * });
 */
export function useApplyForSchoolFacultyMutation(baseOptions?: Apollo.MutationHookOptions<ApplyForSchoolFacultyMutation, ApplyForSchoolFacultyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyForSchoolFacultyMutation, ApplyForSchoolFacultyMutationVariables>(ApplyForSchoolFacultyDocument, options);
      }
export type ApplyForSchoolFacultyMutationHookResult = ReturnType<typeof useApplyForSchoolFacultyMutation>;
export type ApplyForSchoolFacultyMutationResult = Apollo.MutationResult<ApplyForSchoolFacultyMutation>;
export type ApplyForSchoolFacultyMutationOptions = Apollo.BaseMutationOptions<ApplyForSchoolFacultyMutation, ApplyForSchoolFacultyMutationVariables>;
export const ApplyForSchoolStudentDocument = gql`
    mutation applyForSchoolStudent($role: UserRoleName!, $personalEmail: String, $schoolEmail: String!, $schoolId: UUID!, $suggestedSchool: SuggestedSchoolInput, $studentInput: ApplyForSchoolStudentInput) {
  applyForSchool(
    input: {requestedRole: $role, personalEmail: $personalEmail, schoolEmail: $schoolEmail, schoolId: $schoolId, suggestedSchool: $suggestedSchool, studentInput: $studentInput}
  ) {
    user {
      school {
        id
      }
    }
  }
}
    `;
export type ApplyForSchoolStudentMutationFn = Apollo.MutationFunction<ApplyForSchoolStudentMutation, ApplyForSchoolStudentMutationVariables>;

/**
 * __useApplyForSchoolStudentMutation__
 *
 * To run a mutation, you first call `useApplyForSchoolStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyForSchoolStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyForSchoolStudentMutation, { data, loading, error }] = useApplyForSchoolStudentMutation({
 *   variables: {
 *      role: // value for 'role'
 *      personalEmail: // value for 'personalEmail'
 *      schoolEmail: // value for 'schoolEmail'
 *      schoolId: // value for 'schoolId'
 *      suggestedSchool: // value for 'suggestedSchool'
 *      studentInput: // value for 'studentInput'
 *   },
 * });
 */
export function useApplyForSchoolStudentMutation(baseOptions?: Apollo.MutationHookOptions<ApplyForSchoolStudentMutation, ApplyForSchoolStudentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyForSchoolStudentMutation, ApplyForSchoolStudentMutationVariables>(ApplyForSchoolStudentDocument, options);
      }
export type ApplyForSchoolStudentMutationHookResult = ReturnType<typeof useApplyForSchoolStudentMutation>;
export type ApplyForSchoolStudentMutationResult = Apollo.MutationResult<ApplyForSchoolStudentMutation>;
export type ApplyForSchoolStudentMutationOptions = Apollo.BaseMutationOptions<ApplyForSchoolStudentMutation, ApplyForSchoolStudentMutationVariables>;
export const ReferParentByEmailDocument = gql`
    mutation referParentByEmail($input: ReferParentByEmailInput!) {
  referParentByEmail(input: $input) {
    success
  }
}
    `;
export type ReferParentByEmailMutationFn = Apollo.MutationFunction<ReferParentByEmailMutation, ReferParentByEmailMutationVariables>;

/**
 * __useReferParentByEmailMutation__
 *
 * To run a mutation, you first call `useReferParentByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReferParentByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referParentByEmailMutation, { data, loading, error }] = useReferParentByEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReferParentByEmailMutation(baseOptions?: Apollo.MutationHookOptions<ReferParentByEmailMutation, ReferParentByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReferParentByEmailMutation, ReferParentByEmailMutationVariables>(ReferParentByEmailDocument, options);
      }
export type ReferParentByEmailMutationHookResult = ReturnType<typeof useReferParentByEmailMutation>;
export type ReferParentByEmailMutationResult = Apollo.MutationResult<ReferParentByEmailMutation>;
export type ReferParentByEmailMutationOptions = Apollo.BaseMutationOptions<ReferParentByEmailMutation, ReferParentByEmailMutationVariables>;
export const RoleRouteDocument = gql`
    query roleRoute {
  me {
    id
    roles {
      roleName
      userId
      resourceId
    }
  }
}
    `;

/**
 * __useRoleRouteQuery__
 *
 * To run a query within a React component, call `useRoleRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleRouteQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoleRouteQuery(baseOptions?: Apollo.QueryHookOptions<RoleRouteQuery, RoleRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleRouteQuery, RoleRouteQueryVariables>(RoleRouteDocument, options);
      }
export function useRoleRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleRouteQuery, RoleRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleRouteQuery, RoleRouteQueryVariables>(RoleRouteDocument, options);
        }
export type RoleRouteQueryHookResult = ReturnType<typeof useRoleRouteQuery>;
export type RoleRouteLazyQueryHookResult = ReturnType<typeof useRoleRouteLazyQuery>;
export type RoleRouteQueryResult = Apollo.QueryResult<RoleRouteQuery, RoleRouteQueryVariables>;
export function refetchRoleRouteQuery(variables?: RoleRouteQueryVariables) {
      return { query: RoleRouteDocument, variables: variables }
    }
export const CreateUserConsentDocument = gql`
    mutation createUserConsent {
  createUserConsent {
    id
  }
}
    `;
export type CreateUserConsentMutationFn = Apollo.MutationFunction<CreateUserConsentMutation, CreateUserConsentMutationVariables>;

/**
 * __useCreateUserConsentMutation__
 *
 * To run a mutation, you first call `useCreateUserConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserConsentMutation, { data, loading, error }] = useCreateUserConsentMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateUserConsentMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserConsentMutation, CreateUserConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserConsentMutation, CreateUserConsentMutationVariables>(CreateUserConsentDocument, options);
      }
export type CreateUserConsentMutationHookResult = ReturnType<typeof useCreateUserConsentMutation>;
export type CreateUserConsentMutationResult = Apollo.MutationResult<CreateUserConsentMutation>;
export type CreateUserConsentMutationOptions = Apollo.BaseMutationOptions<CreateUserConsentMutation, CreateUserConsentMutationVariables>;
export const AddChildToSchoolDocument = gql`
    mutation addChildToSchool($input: AddChildToSchoolInput!) {
  addChildToSchool(input: $input) {
    success
    userId
    schoolId
  }
}
    `;
export type AddChildToSchoolMutationFn = Apollo.MutationFunction<AddChildToSchoolMutation, AddChildToSchoolMutationVariables>;

/**
 * __useAddChildToSchoolMutation__
 *
 * To run a mutation, you first call `useAddChildToSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChildToSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChildToSchoolMutation, { data, loading, error }] = useAddChildToSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddChildToSchoolMutation(baseOptions?: Apollo.MutationHookOptions<AddChildToSchoolMutation, AddChildToSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddChildToSchoolMutation, AddChildToSchoolMutationVariables>(AddChildToSchoolDocument, options);
      }
export type AddChildToSchoolMutationHookResult = ReturnType<typeof useAddChildToSchoolMutation>;
export type AddChildToSchoolMutationResult = Apollo.MutationResult<AddChildToSchoolMutation>;
export type AddChildToSchoolMutationOptions = Apollo.BaseMutationOptions<AddChildToSchoolMutation, AddChildToSchoolMutationVariables>;
export const ChangeChildPasswordDocument = gql`
    mutation changeChildPassword($input: ChangeChildPasswordInput!) {
  changeChildPassword(input: $input) {
    success
  }
}
    `;
export type ChangeChildPasswordMutationFn = Apollo.MutationFunction<ChangeChildPasswordMutation, ChangeChildPasswordMutationVariables>;

/**
 * __useChangeChildPasswordMutation__
 *
 * To run a mutation, you first call `useChangeChildPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeChildPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeChildPasswordMutation, { data, loading, error }] = useChangeChildPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeChildPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeChildPasswordMutation, ChangeChildPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeChildPasswordMutation, ChangeChildPasswordMutationVariables>(ChangeChildPasswordDocument, options);
      }
export type ChangeChildPasswordMutationHookResult = ReturnType<typeof useChangeChildPasswordMutation>;
export type ChangeChildPasswordMutationResult = Apollo.MutationResult<ChangeChildPasswordMutation>;
export type ChangeChildPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeChildPasswordMutation, ChangeChildPasswordMutationVariables>;
export const GetUserChildrenDocument = gql`
    query getUserChildren {
  getUserChildren {
    users {
      id
      name
      avatarUrl
      firstName
      lastName
      gradYear
      school {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetUserChildrenQuery__
 *
 * To run a query within a React component, call `useGetUserChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserChildrenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserChildrenQuery(baseOptions?: Apollo.QueryHookOptions<GetUserChildrenQuery, GetUserChildrenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserChildrenQuery, GetUserChildrenQueryVariables>(GetUserChildrenDocument, options);
      }
export function useGetUserChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserChildrenQuery, GetUserChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserChildrenQuery, GetUserChildrenQueryVariables>(GetUserChildrenDocument, options);
        }
export type GetUserChildrenQueryHookResult = ReturnType<typeof useGetUserChildrenQuery>;
export type GetUserChildrenLazyQueryHookResult = ReturnType<typeof useGetUserChildrenLazyQuery>;
export type GetUserChildrenQueryResult = Apollo.QueryResult<GetUserChildrenQuery, GetUserChildrenQueryVariables>;
export function refetchGetUserChildrenQuery(variables?: GetUserChildrenQueryVariables) {
      return { query: GetUserChildrenDocument, variables: variables }
    }
export const GetChildUserDocument = gql`
    query getChildUser($id: UUID!) {
  user(id: $id) {
    id
    name
    firstName
    lastName
    avatarUrl
    gradYear
    dateOfBirth
    username
    country
    state
    emails {
      email
    }
    school {
      id
      name
      logoUrl
      city
      state
    }
    userProviderAccounts {
      id
      providerName
      providerAccountId
      providerDisplayName
    }
  }
}
    `;

/**
 * __useGetChildUserQuery__
 *
 * To run a query within a React component, call `useGetChildUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChildUserQuery(baseOptions: Apollo.QueryHookOptions<GetChildUserQuery, GetChildUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildUserQuery, GetChildUserQueryVariables>(GetChildUserDocument, options);
      }
export function useGetChildUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildUserQuery, GetChildUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildUserQuery, GetChildUserQueryVariables>(GetChildUserDocument, options);
        }
export type GetChildUserQueryHookResult = ReturnType<typeof useGetChildUserQuery>;
export type GetChildUserLazyQueryHookResult = ReturnType<typeof useGetChildUserLazyQuery>;
export type GetChildUserQueryResult = Apollo.QueryResult<GetChildUserQuery, GetChildUserQueryVariables>;
export function refetchGetChildUserQuery(variables: GetChildUserQueryVariables) {
      return { query: GetChildUserDocument, variables: variables }
    }
export const GetUserChildOnboardDocument = gql`
    query getUserChildOnboard($id: UUID) {
  user(id: $id) {
    id
    name
    firstName
    lastName
    gradYear
    dateOfBirth
    username
    country
    state
    emails {
      email
    }
    school {
      id
      name
      state
    }
    esportInterests {
      id
      name
      slug
    }
  }
}
    `;

/**
 * __useGetUserChildOnboardQuery__
 *
 * To run a query within a React component, call `useGetUserChildOnboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserChildOnboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserChildOnboardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserChildOnboardQuery(baseOptions?: Apollo.QueryHookOptions<GetUserChildOnboardQuery, GetUserChildOnboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserChildOnboardQuery, GetUserChildOnboardQueryVariables>(GetUserChildOnboardDocument, options);
      }
export function useGetUserChildOnboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserChildOnboardQuery, GetUserChildOnboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserChildOnboardQuery, GetUserChildOnboardQueryVariables>(GetUserChildOnboardDocument, options);
        }
export type GetUserChildOnboardQueryHookResult = ReturnType<typeof useGetUserChildOnboardQuery>;
export type GetUserChildOnboardLazyQueryHookResult = ReturnType<typeof useGetUserChildOnboardLazyQuery>;
export type GetUserChildOnboardQueryResult = Apollo.QueryResult<GetUserChildOnboardQuery, GetUserChildOnboardQueryVariables>;
export function refetchGetUserChildOnboardQuery(variables?: GetUserChildOnboardQueryVariables) {
      return { query: GetUserChildOnboardDocument, variables: variables }
    }
export const GetChildPlatformConnectionsDocument = gql`
    query getChildPlatformConnections($id: UUID) {
  user(id: $id) {
    id
    userProviderAccounts {
      id
      userId
      providerName
      providerAccountId
      providerDisplayName
      providerOnboardUrl
      providerIntegrationType
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetChildPlatformConnectionsQuery__
 *
 * To run a query within a React component, call `useGetChildPlatformConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildPlatformConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildPlatformConnectionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChildPlatformConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetChildPlatformConnectionsQuery, GetChildPlatformConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildPlatformConnectionsQuery, GetChildPlatformConnectionsQueryVariables>(GetChildPlatformConnectionsDocument, options);
      }
export function useGetChildPlatformConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildPlatformConnectionsQuery, GetChildPlatformConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildPlatformConnectionsQuery, GetChildPlatformConnectionsQueryVariables>(GetChildPlatformConnectionsDocument, options);
        }
export type GetChildPlatformConnectionsQueryHookResult = ReturnType<typeof useGetChildPlatformConnectionsQuery>;
export type GetChildPlatformConnectionsLazyQueryHookResult = ReturnType<typeof useGetChildPlatformConnectionsLazyQuery>;
export type GetChildPlatformConnectionsQueryResult = Apollo.QueryResult<GetChildPlatformConnectionsQuery, GetChildPlatformConnectionsQueryVariables>;
export function refetchGetChildPlatformConnectionsQuery(variables?: GetChildPlatformConnectionsQueryVariables) {
      return { query: GetChildPlatformConnectionsDocument, variables: variables }
    }
export const SetUserAvatarImageDocument = gql`
    mutation setUserAvatarImage($userId: UUID!, $file: Upload!) {
  setUserAvatarImage(userId: $userId, file: $file) {
    url
    resourceId
    resourceType
    size
  }
}
    `;
export type SetUserAvatarImageMutationFn = Apollo.MutationFunction<SetUserAvatarImageMutation, SetUserAvatarImageMutationVariables>;

/**
 * __useSetUserAvatarImageMutation__
 *
 * To run a mutation, you first call `useSetUserAvatarImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserAvatarImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserAvatarImageMutation, { data, loading, error }] = useSetUserAvatarImageMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSetUserAvatarImageMutation(baseOptions?: Apollo.MutationHookOptions<SetUserAvatarImageMutation, SetUserAvatarImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserAvatarImageMutation, SetUserAvatarImageMutationVariables>(SetUserAvatarImageDocument, options);
      }
export type SetUserAvatarImageMutationHookResult = ReturnType<typeof useSetUserAvatarImageMutation>;
export type SetUserAvatarImageMutationResult = Apollo.MutationResult<SetUserAvatarImageMutation>;
export type SetUserAvatarImageMutationOptions = Apollo.BaseMutationOptions<SetUserAvatarImageMutation, SetUserAvatarImageMutationVariables>;
export const SetChildAccountSettingsDocument = gql`
    mutation setChildAccountSettings($userId: UUID!, $input: ChildAccountSettingsInput!) {
  setChildAccountSettings(userId: $userId, input: $input) {
    success
    user {
      id
    }
  }
}
    `;
export type SetChildAccountSettingsMutationFn = Apollo.MutationFunction<SetChildAccountSettingsMutation, SetChildAccountSettingsMutationVariables>;

/**
 * __useSetChildAccountSettingsMutation__
 *
 * To run a mutation, you first call `useSetChildAccountSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChildAccountSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChildAccountSettingsMutation, { data, loading, error }] = useSetChildAccountSettingsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetChildAccountSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SetChildAccountSettingsMutation, SetChildAccountSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetChildAccountSettingsMutation, SetChildAccountSettingsMutationVariables>(SetChildAccountSettingsDocument, options);
      }
export type SetChildAccountSettingsMutationHookResult = ReturnType<typeof useSetChildAccountSettingsMutation>;
export type SetChildAccountSettingsMutationResult = Apollo.MutationResult<SetChildAccountSettingsMutation>;
export type SetChildAccountSettingsMutationOptions = Apollo.BaseMutationOptions<SetChildAccountSettingsMutation, SetChildAccountSettingsMutationVariables>;
export const GetChildAvatarUrlDocument = gql`
    query getChildAvatarUrl($userId: UUID!) {
  user(id: $userId) {
    id
    avatarUrl
  }
}
    `;

/**
 * __useGetChildAvatarUrlQuery__
 *
 * To run a query within a React component, call `useGetChildAvatarUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildAvatarUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildAvatarUrlQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetChildAvatarUrlQuery(baseOptions: Apollo.QueryHookOptions<GetChildAvatarUrlQuery, GetChildAvatarUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildAvatarUrlQuery, GetChildAvatarUrlQueryVariables>(GetChildAvatarUrlDocument, options);
      }
export function useGetChildAvatarUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildAvatarUrlQuery, GetChildAvatarUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildAvatarUrlQuery, GetChildAvatarUrlQueryVariables>(GetChildAvatarUrlDocument, options);
        }
export type GetChildAvatarUrlQueryHookResult = ReturnType<typeof useGetChildAvatarUrlQuery>;
export type GetChildAvatarUrlLazyQueryHookResult = ReturnType<typeof useGetChildAvatarUrlLazyQuery>;
export type GetChildAvatarUrlQueryResult = Apollo.QueryResult<GetChildAvatarUrlQuery, GetChildAvatarUrlQueryVariables>;
export function refetchGetChildAvatarUrlQuery(variables: GetChildAvatarUrlQueryVariables) {
      return { query: GetChildAvatarUrlDocument, variables: variables }
    }
export const GetUserChildrenByParentIdDocument = gql`
    query getUserChildrenByParentId($parentUserId: UUID!) {
  getUserChildrenByParentId(parentUserId: $parentUserId) {
    users {
      id
      name
      avatarUrl
      isUnderage
    }
  }
}
    `;

/**
 * __useGetUserChildrenByParentIdQuery__
 *
 * To run a query within a React component, call `useGetUserChildrenByParentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserChildrenByParentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserChildrenByParentIdQuery({
 *   variables: {
 *      parentUserId: // value for 'parentUserId'
 *   },
 * });
 */
export function useGetUserChildrenByParentIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserChildrenByParentIdQuery, GetUserChildrenByParentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserChildrenByParentIdQuery, GetUserChildrenByParentIdQueryVariables>(GetUserChildrenByParentIdDocument, options);
      }
export function useGetUserChildrenByParentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserChildrenByParentIdQuery, GetUserChildrenByParentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserChildrenByParentIdQuery, GetUserChildrenByParentIdQueryVariables>(GetUserChildrenByParentIdDocument, options);
        }
export type GetUserChildrenByParentIdQueryHookResult = ReturnType<typeof useGetUserChildrenByParentIdQuery>;
export type GetUserChildrenByParentIdLazyQueryHookResult = ReturnType<typeof useGetUserChildrenByParentIdLazyQuery>;
export type GetUserChildrenByParentIdQueryResult = Apollo.QueryResult<GetUserChildrenByParentIdQuery, GetUserChildrenByParentIdQueryVariables>;
export function refetchGetUserChildrenByParentIdQuery(variables: GetUserChildrenByParentIdQueryVariables) {
      return { query: GetUserChildrenByParentIdDocument, variables: variables }
    }
export const UnlinkParentFromChildDocument = gql`
    mutation unlinkParentFromChild($parentId: UUID!, $childUserId: UUID!) {
  unlinkParentFromChild(parentId: $parentId, childUserId: $childUserId) {
    success
  }
}
    `;
export type UnlinkParentFromChildMutationFn = Apollo.MutationFunction<UnlinkParentFromChildMutation, UnlinkParentFromChildMutationVariables>;

/**
 * __useUnlinkParentFromChildMutation__
 *
 * To run a mutation, you first call `useUnlinkParentFromChildMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkParentFromChildMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkParentFromChildMutation, { data, loading, error }] = useUnlinkParentFromChildMutation({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      childUserId: // value for 'childUserId'
 *   },
 * });
 */
export function useUnlinkParentFromChildMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkParentFromChildMutation, UnlinkParentFromChildMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkParentFromChildMutation, UnlinkParentFromChildMutationVariables>(UnlinkParentFromChildDocument, options);
      }
export type UnlinkParentFromChildMutationHookResult = ReturnType<typeof useUnlinkParentFromChildMutation>;
export type UnlinkParentFromChildMutationResult = Apollo.MutationResult<UnlinkParentFromChildMutation>;
export type UnlinkParentFromChildMutationOptions = Apollo.BaseMutationOptions<UnlinkParentFromChildMutation, UnlinkParentFromChildMutationVariables>;
export const PartnersDocument = gql`
    query partners($input: PartnerSearchInput!) {
  partners(input: $input) {
    result {
      id
      name
    }
    total
  }
}
    `;

/**
 * __usePartnersQuery__
 *
 * To run a query within a React component, call `usePartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartnersQuery(baseOptions: Apollo.QueryHookOptions<PartnersQuery, PartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnersQuery, PartnersQueryVariables>(PartnersDocument, options);
      }
export function usePartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnersQuery, PartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnersQuery, PartnersQueryVariables>(PartnersDocument, options);
        }
export type PartnersQueryHookResult = ReturnType<typeof usePartnersQuery>;
export type PartnersLazyQueryHookResult = ReturnType<typeof usePartnersLazyQuery>;
export type PartnersQueryResult = Apollo.QueryResult<PartnersQuery, PartnersQueryVariables>;
export function refetchPartnersQuery(variables: PartnersQueryVariables) {
      return { query: PartnersDocument, variables: variables }
    }
export const PartnerDocument = gql`
    query partner($id: UUID!) {
  partner(id: $id) {
    id
    name
  }
}
    `;

/**
 * __usePartnerQuery__
 *
 * To run a query within a React component, call `usePartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerQuery(baseOptions: Apollo.QueryHookOptions<PartnerQuery, PartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerQuery, PartnerQueryVariables>(PartnerDocument, options);
      }
export function usePartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerQuery, PartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerQuery, PartnerQueryVariables>(PartnerDocument, options);
        }
export type PartnerQueryHookResult = ReturnType<typeof usePartnerQuery>;
export type PartnerLazyQueryHookResult = ReturnType<typeof usePartnerLazyQuery>;
export type PartnerQueryResult = Apollo.QueryResult<PartnerQuery, PartnerQueryVariables>;
export function refetchPartnerQuery(variables: PartnerQueryVariables) {
      return { query: PartnerDocument, variables: variables }
    }
export const CreatePartnerDocument = gql`
    mutation createPartner($input: PartnerInput!) {
  createPartner(input: $input) {
    id
    name
  }
}
    `;
export type CreatePartnerMutationFn = Apollo.MutationFunction<CreatePartnerMutation, CreatePartnerMutationVariables>;

/**
 * __useCreatePartnerMutation__
 *
 * To run a mutation, you first call `useCreatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerMutation, { data, loading, error }] = useCreatePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnerMutation, CreatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnerMutation, CreatePartnerMutationVariables>(CreatePartnerDocument, options);
      }
export type CreatePartnerMutationHookResult = ReturnType<typeof useCreatePartnerMutation>;
export type CreatePartnerMutationResult = Apollo.MutationResult<CreatePartnerMutation>;
export type CreatePartnerMutationOptions = Apollo.BaseMutationOptions<CreatePartnerMutation, CreatePartnerMutationVariables>;
export const UpdatePartnerDocument = gql`
    mutation updatePartner($id: UUID!, $input: PartnerInput!) {
  updatePartner(id: $id, input: $input) {
    id
    name
  }
}
    `;
export type UpdatePartnerMutationFn = Apollo.MutationFunction<UpdatePartnerMutation, UpdatePartnerMutationVariables>;

/**
 * __useUpdatePartnerMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerMutation, { data, loading, error }] = useUpdatePartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerMutation, UpdatePartnerMutationVariables>(UpdatePartnerDocument, options);
      }
export type UpdatePartnerMutationHookResult = ReturnType<typeof useUpdatePartnerMutation>;
export type UpdatePartnerMutationResult = Apollo.MutationResult<UpdatePartnerMutation>;
export type UpdatePartnerMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>;
export const DeletePartnerDocument = gql`
    mutation deletePartner($id: UUID!) {
  deletePartner(id: $id) {
    success
  }
}
    `;
export type DeletePartnerMutationFn = Apollo.MutationFunction<DeletePartnerMutation, DeletePartnerMutationVariables>;

/**
 * __useDeletePartnerMutation__
 *
 * To run a mutation, you first call `useDeletePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnerMutation, { data, loading, error }] = useDeletePartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePartnerMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartnerMutation, DeletePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartnerMutation, DeletePartnerMutationVariables>(DeletePartnerDocument, options);
      }
export type DeletePartnerMutationHookResult = ReturnType<typeof useDeletePartnerMutation>;
export type DeletePartnerMutationResult = Apollo.MutationResult<DeletePartnerMutation>;
export type DeletePartnerMutationOptions = Apollo.BaseMutationOptions<DeletePartnerMutation, DeletePartnerMutationVariables>;
export const GetMetaseasonNameForPhaseDocument = gql`
    query getMetaseasonNameForPhase($phaseId: UUID!) {
  phase(id: $phaseId) {
    id
    season {
      id
      metaseason {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetMetaseasonNameForPhaseQuery__
 *
 * To run a query within a React component, call `useGetMetaseasonNameForPhaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetaseasonNameForPhaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetaseasonNameForPhaseQuery({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useGetMetaseasonNameForPhaseQuery(baseOptions: Apollo.QueryHookOptions<GetMetaseasonNameForPhaseQuery, GetMetaseasonNameForPhaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetaseasonNameForPhaseQuery, GetMetaseasonNameForPhaseQueryVariables>(GetMetaseasonNameForPhaseDocument, options);
      }
export function useGetMetaseasonNameForPhaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetaseasonNameForPhaseQuery, GetMetaseasonNameForPhaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetaseasonNameForPhaseQuery, GetMetaseasonNameForPhaseQueryVariables>(GetMetaseasonNameForPhaseDocument, options);
        }
export type GetMetaseasonNameForPhaseQueryHookResult = ReturnType<typeof useGetMetaseasonNameForPhaseQuery>;
export type GetMetaseasonNameForPhaseLazyQueryHookResult = ReturnType<typeof useGetMetaseasonNameForPhaseLazyQuery>;
export type GetMetaseasonNameForPhaseQueryResult = Apollo.QueryResult<GetMetaseasonNameForPhaseQuery, GetMetaseasonNameForPhaseQueryVariables>;
export function refetchGetMetaseasonNameForPhaseQuery(variables: GetMetaseasonNameForPhaseQueryVariables) {
      return { query: GetMetaseasonNameForPhaseDocument, variables: variables }
    }
export const GetPhasesDocument = gql`
    query getPhases($limit: Int, $offset: Int, $filter: GetPhasesFilter) {
  getPhases(limit: $limit, offset: $offset, filter: $filter) {
    result {
      id
      slots {
        id
        ordinal
        order
        label
        name
      }
    }
  }
}
    `;

/**
 * __useGetPhasesQuery__
 *
 * To run a query within a React component, call `useGetPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhasesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPhasesQuery(baseOptions?: Apollo.QueryHookOptions<GetPhasesQuery, GetPhasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhasesQuery, GetPhasesQueryVariables>(GetPhasesDocument, options);
      }
export function useGetPhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhasesQuery, GetPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhasesQuery, GetPhasesQueryVariables>(GetPhasesDocument, options);
        }
export type GetPhasesQueryHookResult = ReturnType<typeof useGetPhasesQuery>;
export type GetPhasesLazyQueryHookResult = ReturnType<typeof useGetPhasesLazyQuery>;
export type GetPhasesQueryResult = Apollo.QueryResult<GetPhasesQuery, GetPhasesQueryVariables>;
export function refetchGetPhasesQuery(variables?: GetPhasesQueryVariables) {
      return { query: GetPhasesDocument, variables: variables }
    }
export const GetPhaseDocument = gql`
    query getPhase($id: UUID!) {
  phase(id: $id) {
    id
    name
    format
    type
    bestOf
    seriesBestOf
    status
    startsAt
    endsAt
    slug
    bracketSize
    maxTeamsPerSchool
    fortniteEventId
    minutesBeforeMatchToLockInSeries
    survivalAdvancementCount
    survivalAdvancementPercentage
    shouldSendPlayoffNotification
    autoScheduleBracket
  }
}
    `;

/**
 * __useGetPhaseQuery__
 *
 * To run a query within a React component, call `useGetPhaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPhaseQuery(baseOptions: Apollo.QueryHookOptions<GetPhaseQuery, GetPhaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhaseQuery, GetPhaseQueryVariables>(GetPhaseDocument, options);
      }
export function useGetPhaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhaseQuery, GetPhaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhaseQuery, GetPhaseQueryVariables>(GetPhaseDocument, options);
        }
export type GetPhaseQueryHookResult = ReturnType<typeof useGetPhaseQuery>;
export type GetPhaseLazyQueryHookResult = ReturnType<typeof useGetPhaseLazyQuery>;
export type GetPhaseQueryResult = Apollo.QueryResult<GetPhaseQuery, GetPhaseQueryVariables>;
export function refetchGetPhaseQuery(variables: GetPhaseQueryVariables) {
      return { query: GetPhaseDocument, variables: variables }
    }
export const GetSchoolLeaguePhasesDocument = gql`
    query getSchoolLeaguePhases($filter: GetPhasesFilter) {
  getPhases(filter: $filter) {
    result {
      id
      startsAt
      endsAt
      name
      type
      seasonId
      slug
      status
      format
      survivalAdvancementCount
      survivalAdvancementPercentage
    }
  }
}
    `;

/**
 * __useGetSchoolLeaguePhasesQuery__
 *
 * To run a query within a React component, call `useGetSchoolLeaguePhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolLeaguePhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolLeaguePhasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSchoolLeaguePhasesQuery(baseOptions?: Apollo.QueryHookOptions<GetSchoolLeaguePhasesQuery, GetSchoolLeaguePhasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolLeaguePhasesQuery, GetSchoolLeaguePhasesQueryVariables>(GetSchoolLeaguePhasesDocument, options);
      }
export function useGetSchoolLeaguePhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolLeaguePhasesQuery, GetSchoolLeaguePhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolLeaguePhasesQuery, GetSchoolLeaguePhasesQueryVariables>(GetSchoolLeaguePhasesDocument, options);
        }
export type GetSchoolLeaguePhasesQueryHookResult = ReturnType<typeof useGetSchoolLeaguePhasesQuery>;
export type GetSchoolLeaguePhasesLazyQueryHookResult = ReturnType<typeof useGetSchoolLeaguePhasesLazyQuery>;
export type GetSchoolLeaguePhasesQueryResult = Apollo.QueryResult<GetSchoolLeaguePhasesQuery, GetSchoolLeaguePhasesQueryVariables>;
export function refetchGetSchoolLeaguePhasesQuery(variables?: GetSchoolLeaguePhasesQueryVariables) {
      return { query: GetSchoolLeaguePhasesDocument, variables: variables }
    }
export const GetQualifiedTeamCountDocument = gql`
    query getQualifiedTeamCount($input: GetQualifiedTeamCountInput!) {
  getQualifiedTeamCount(input: $input)
}
    `;

/**
 * __useGetQualifiedTeamCountQuery__
 *
 * To run a query within a React component, call `useGetQualifiedTeamCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQualifiedTeamCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQualifiedTeamCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQualifiedTeamCountQuery(baseOptions: Apollo.QueryHookOptions<GetQualifiedTeamCountQuery, GetQualifiedTeamCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQualifiedTeamCountQuery, GetQualifiedTeamCountQueryVariables>(GetQualifiedTeamCountDocument, options);
      }
export function useGetQualifiedTeamCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQualifiedTeamCountQuery, GetQualifiedTeamCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQualifiedTeamCountQuery, GetQualifiedTeamCountQueryVariables>(GetQualifiedTeamCountDocument, options);
        }
export type GetQualifiedTeamCountQueryHookResult = ReturnType<typeof useGetQualifiedTeamCountQuery>;
export type GetQualifiedTeamCountLazyQueryHookResult = ReturnType<typeof useGetQualifiedTeamCountLazyQuery>;
export type GetQualifiedTeamCountQueryResult = Apollo.QueryResult<GetQualifiedTeamCountQuery, GetQualifiedTeamCountQueryVariables>;
export function refetchGetQualifiedTeamCountQuery(variables: GetQualifiedTeamCountQueryVariables) {
      return { query: GetQualifiedTeamCountDocument, variables: variables }
    }
export const CreatePhaseDocument = gql`
    mutation createPhase($input: CreatePhaseInput!) {
  createPhase(input: $input) {
    phase {
      id
    }
  }
}
    `;
export type CreatePhaseMutationFn = Apollo.MutationFunction<CreatePhaseMutation, CreatePhaseMutationVariables>;

/**
 * __useCreatePhaseMutation__
 *
 * To run a mutation, you first call `useCreatePhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhaseMutation, { data, loading, error }] = useCreatePhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePhaseMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhaseMutation, CreatePhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePhaseMutation, CreatePhaseMutationVariables>(CreatePhaseDocument, options);
      }
export type CreatePhaseMutationHookResult = ReturnType<typeof useCreatePhaseMutation>;
export type CreatePhaseMutationResult = Apollo.MutationResult<CreatePhaseMutation>;
export type CreatePhaseMutationOptions = Apollo.BaseMutationOptions<CreatePhaseMutation, CreatePhaseMutationVariables>;
export const UpdatePhaseDocument = gql`
    mutation updatePhase($input: UpdatePhaseInput!) {
  updatePhase(input: $input) {
    phase {
      id
    }
  }
}
    `;
export type UpdatePhaseMutationFn = Apollo.MutationFunction<UpdatePhaseMutation, UpdatePhaseMutationVariables>;

/**
 * __useUpdatePhaseMutation__
 *
 * To run a mutation, you first call `useUpdatePhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhaseMutation, { data, loading, error }] = useUpdatePhaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePhaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhaseMutation, UpdatePhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhaseMutation, UpdatePhaseMutationVariables>(UpdatePhaseDocument, options);
      }
export type UpdatePhaseMutationHookResult = ReturnType<typeof useUpdatePhaseMutation>;
export type UpdatePhaseMutationResult = Apollo.MutationResult<UpdatePhaseMutation>;
export type UpdatePhaseMutationOptions = Apollo.BaseMutationOptions<UpdatePhaseMutation, UpdatePhaseMutationVariables>;
export const ManualSeedDocument = gql`
    mutation manualSeed($input: ManuallySeedPlayoffPhasesInput!) {
  manuallySeedPlayoffPhases(input: $input) {
    success
    leagueIds
  }
}
    `;
export type ManualSeedMutationFn = Apollo.MutationFunction<ManualSeedMutation, ManualSeedMutationVariables>;

/**
 * __useManualSeedMutation__
 *
 * To run a mutation, you first call `useManualSeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManualSeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manualSeedMutation, { data, loading, error }] = useManualSeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManualSeedMutation(baseOptions?: Apollo.MutationHookOptions<ManualSeedMutation, ManualSeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManualSeedMutation, ManualSeedMutationVariables>(ManualSeedDocument, options);
      }
export type ManualSeedMutationHookResult = ReturnType<typeof useManualSeedMutation>;
export type ManualSeedMutationResult = Apollo.MutationResult<ManualSeedMutation>;
export type ManualSeedMutationOptions = Apollo.BaseMutationOptions<ManualSeedMutation, ManualSeedMutationVariables>;
export const AutoSeedDocument = gql`
    mutation autoSeed($input: SeedPhaseTeamsInput!) {
  seedPhaseTeams(input: $input) {
    jobId
    success
    errors
  }
}
    `;
export type AutoSeedMutationFn = Apollo.MutationFunction<AutoSeedMutation, AutoSeedMutationVariables>;

/**
 * __useAutoSeedMutation__
 *
 * To run a mutation, you first call `useAutoSeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoSeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoSeedMutation, { data, loading, error }] = useAutoSeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutoSeedMutation(baseOptions?: Apollo.MutationHookOptions<AutoSeedMutation, AutoSeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoSeedMutation, AutoSeedMutationVariables>(AutoSeedDocument, options);
      }
export type AutoSeedMutationHookResult = ReturnType<typeof useAutoSeedMutation>;
export type AutoSeedMutationResult = Apollo.MutationResult<AutoSeedMutation>;
export type AutoSeedMutationOptions = Apollo.BaseMutationOptions<AutoSeedMutation, AutoSeedMutationVariables>;
export const SchedulePhaseMatchesDocument = gql`
    mutation schedulePhaseMatches($input: SchedulePhaseMatchesInput!) {
  schedulePhaseMatches(input: $input) {
    jobId
  }
}
    `;
export type SchedulePhaseMatchesMutationFn = Apollo.MutationFunction<SchedulePhaseMatchesMutation, SchedulePhaseMatchesMutationVariables>;

/**
 * __useSchedulePhaseMatchesMutation__
 *
 * To run a mutation, you first call `useSchedulePhaseMatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulePhaseMatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulePhaseMatchesMutation, { data, loading, error }] = useSchedulePhaseMatchesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchedulePhaseMatchesMutation(baseOptions?: Apollo.MutationHookOptions<SchedulePhaseMatchesMutation, SchedulePhaseMatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchedulePhaseMatchesMutation, SchedulePhaseMatchesMutationVariables>(SchedulePhaseMatchesDocument, options);
      }
export type SchedulePhaseMatchesMutationHookResult = ReturnType<typeof useSchedulePhaseMatchesMutation>;
export type SchedulePhaseMatchesMutationResult = Apollo.MutationResult<SchedulePhaseMatchesMutation>;
export type SchedulePhaseMatchesMutationOptions = Apollo.BaseMutationOptions<SchedulePhaseMatchesMutation, SchedulePhaseMatchesMutationVariables>;
export const RedoSchedulePhaseMatchesDocument = gql`
    mutation redoSchedulePhaseMatches($input: SchedulePhaseMatchesInput!) {
  redoSchedulePhaseMatches(input: $input) {
    success
    phase {
      id
    }
  }
}
    `;
export type RedoSchedulePhaseMatchesMutationFn = Apollo.MutationFunction<RedoSchedulePhaseMatchesMutation, RedoSchedulePhaseMatchesMutationVariables>;

/**
 * __useRedoSchedulePhaseMatchesMutation__
 *
 * To run a mutation, you first call `useRedoSchedulePhaseMatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedoSchedulePhaseMatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redoSchedulePhaseMatchesMutation, { data, loading, error }] = useRedoSchedulePhaseMatchesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRedoSchedulePhaseMatchesMutation(baseOptions?: Apollo.MutationHookOptions<RedoSchedulePhaseMatchesMutation, RedoSchedulePhaseMatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedoSchedulePhaseMatchesMutation, RedoSchedulePhaseMatchesMutationVariables>(RedoSchedulePhaseMatchesDocument, options);
      }
export type RedoSchedulePhaseMatchesMutationHookResult = ReturnType<typeof useRedoSchedulePhaseMatchesMutation>;
export type RedoSchedulePhaseMatchesMutationResult = Apollo.MutationResult<RedoSchedulePhaseMatchesMutation>;
export type RedoSchedulePhaseMatchesMutationOptions = Apollo.BaseMutationOptions<RedoSchedulePhaseMatchesMutation, RedoSchedulePhaseMatchesMutationVariables>;
export const RollupAllPhaseResultsDocument = gql`
    mutation rollupAllPhaseResults($input: RollupAllPhaseResultsInput!) {
  rollupAllPhaseResults(input: $input) {
    jobIds
  }
}
    `;
export type RollupAllPhaseResultsMutationFn = Apollo.MutationFunction<RollupAllPhaseResultsMutation, RollupAllPhaseResultsMutationVariables>;

/**
 * __useRollupAllPhaseResultsMutation__
 *
 * To run a mutation, you first call `useRollupAllPhaseResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRollupAllPhaseResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rollupAllPhaseResultsMutation, { data, loading, error }] = useRollupAllPhaseResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRollupAllPhaseResultsMutation(baseOptions?: Apollo.MutationHookOptions<RollupAllPhaseResultsMutation, RollupAllPhaseResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RollupAllPhaseResultsMutation, RollupAllPhaseResultsMutationVariables>(RollupAllPhaseResultsDocument, options);
      }
export type RollupAllPhaseResultsMutationHookResult = ReturnType<typeof useRollupAllPhaseResultsMutation>;
export type RollupAllPhaseResultsMutationResult = Apollo.MutationResult<RollupAllPhaseResultsMutation>;
export type RollupAllPhaseResultsMutationOptions = Apollo.BaseMutationOptions<RollupAllPhaseResultsMutation, RollupAllPhaseResultsMutationVariables>;
export const GetUserEsportPlatformsDocument = gql`
    query getUserEsportPlatforms($userId: UUID) {
  userEsportPlatforms(userId: $userId) {
    userId
    platform
    platformUsername
    esportId
  }
}
    `;

/**
 * __useGetUserEsportPlatformsQuery__
 *
 * To run a query within a React component, call `useGetUserEsportPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEsportPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEsportPlatformsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserEsportPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserEsportPlatformsQuery, GetUserEsportPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEsportPlatformsQuery, GetUserEsportPlatformsQueryVariables>(GetUserEsportPlatformsDocument, options);
      }
export function useGetUserEsportPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEsportPlatformsQuery, GetUserEsportPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEsportPlatformsQuery, GetUserEsportPlatformsQueryVariables>(GetUserEsportPlatformsDocument, options);
        }
export type GetUserEsportPlatformsQueryHookResult = ReturnType<typeof useGetUserEsportPlatformsQuery>;
export type GetUserEsportPlatformsLazyQueryHookResult = ReturnType<typeof useGetUserEsportPlatformsLazyQuery>;
export type GetUserEsportPlatformsQueryResult = Apollo.QueryResult<GetUserEsportPlatformsQuery, GetUserEsportPlatformsQueryVariables>;
export function refetchGetUserEsportPlatformsQuery(variables?: GetUserEsportPlatformsQueryVariables) {
      return { query: GetUserEsportPlatformsDocument, variables: variables }
    }
export const SetUserEsportPlatformDocument = gql`
    mutation setUserEsportPlatform($input: SetUserEsportPlatformInput!) {
  setUserEsportPlatform(input: $input) {
    userId
    platform
    platformUsername
    esportId
  }
}
    `;
export type SetUserEsportPlatformMutationFn = Apollo.MutationFunction<SetUserEsportPlatformMutation, SetUserEsportPlatformMutationVariables>;

/**
 * __useSetUserEsportPlatformMutation__
 *
 * To run a mutation, you first call `useSetUserEsportPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserEsportPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserEsportPlatformMutation, { data, loading, error }] = useSetUserEsportPlatformMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserEsportPlatformMutation(baseOptions?: Apollo.MutationHookOptions<SetUserEsportPlatformMutation, SetUserEsportPlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserEsportPlatformMutation, SetUserEsportPlatformMutationVariables>(SetUserEsportPlatformDocument, options);
      }
export type SetUserEsportPlatformMutationHookResult = ReturnType<typeof useSetUserEsportPlatformMutation>;
export type SetUserEsportPlatformMutationResult = Apollo.MutationResult<SetUserEsportPlatformMutation>;
export type SetUserEsportPlatformMutationOptions = Apollo.BaseMutationOptions<SetUserEsportPlatformMutation, SetUserEsportPlatformMutationVariables>;
export const RemoveUserEsportPlatformDocument = gql`
    mutation removeUserEsportPlatform($userId: UUID!, $esportId: UUID!) {
  removeUserEsportPlatform(userId: $userId, esportId: $esportId) {
    success
  }
}
    `;
export type RemoveUserEsportPlatformMutationFn = Apollo.MutationFunction<RemoveUserEsportPlatformMutation, RemoveUserEsportPlatformMutationVariables>;

/**
 * __useRemoveUserEsportPlatformMutation__
 *
 * To run a mutation, you first call `useRemoveUserEsportPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserEsportPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserEsportPlatformMutation, { data, loading, error }] = useRemoveUserEsportPlatformMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      esportId: // value for 'esportId'
 *   },
 * });
 */
export function useRemoveUserEsportPlatformMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserEsportPlatformMutation, RemoveUserEsportPlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserEsportPlatformMutation, RemoveUserEsportPlatformMutationVariables>(RemoveUserEsportPlatformDocument, options);
      }
export type RemoveUserEsportPlatformMutationHookResult = ReturnType<typeof useRemoveUserEsportPlatformMutation>;
export type RemoveUserEsportPlatformMutationResult = Apollo.MutationResult<RemoveUserEsportPlatformMutation>;
export type RemoveUserEsportPlatformMutationOptions = Apollo.BaseMutationOptions<RemoveUserEsportPlatformMutation, RemoveUserEsportPlatformMutationVariables>;
export const GetPlayerLinkedAccountPlatformsDocument = gql`
    query getPlayerLinkedAccountPlatforms($epicAccountId: String!) {
  getPlayerLinkedAccountPlatforms(epicAccountId: $epicAccountId) {
    playerLinkedAccounts {
      platform
      username
    }
  }
}
    `;

/**
 * __useGetPlayerLinkedAccountPlatformsQuery__
 *
 * To run a query within a React component, call `useGetPlayerLinkedAccountPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerLinkedAccountPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerLinkedAccountPlatformsQuery({
 *   variables: {
 *      epicAccountId: // value for 'epicAccountId'
 *   },
 * });
 */
export function useGetPlayerLinkedAccountPlatformsQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerLinkedAccountPlatformsQuery, GetPlayerLinkedAccountPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerLinkedAccountPlatformsQuery, GetPlayerLinkedAccountPlatformsQueryVariables>(GetPlayerLinkedAccountPlatformsDocument, options);
      }
export function useGetPlayerLinkedAccountPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerLinkedAccountPlatformsQuery, GetPlayerLinkedAccountPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerLinkedAccountPlatformsQuery, GetPlayerLinkedAccountPlatformsQueryVariables>(GetPlayerLinkedAccountPlatformsDocument, options);
        }
export type GetPlayerLinkedAccountPlatformsQueryHookResult = ReturnType<typeof useGetPlayerLinkedAccountPlatformsQuery>;
export type GetPlayerLinkedAccountPlatformsLazyQueryHookResult = ReturnType<typeof useGetPlayerLinkedAccountPlatformsLazyQuery>;
export type GetPlayerLinkedAccountPlatformsQueryResult = Apollo.QueryResult<GetPlayerLinkedAccountPlatformsQuery, GetPlayerLinkedAccountPlatformsQueryVariables>;
export function refetchGetPlayerLinkedAccountPlatformsQuery(variables: GetPlayerLinkedAccountPlatformsQueryVariables) {
      return { query: GetPlayerLinkedAccountPlatformsDocument, variables: variables }
    }
export const AddPlatformsToEsportDocument = gql`
    mutation addPlatformsToEsport($esportId: UUID!, $platforms: [Platform!]) {
  addPlatformsToEsport(esportId: $esportId, platforms: $platforms) {
    success
  }
}
    `;
export type AddPlatformsToEsportMutationFn = Apollo.MutationFunction<AddPlatformsToEsportMutation, AddPlatformsToEsportMutationVariables>;

/**
 * __useAddPlatformsToEsportMutation__
 *
 * To run a mutation, you first call `useAddPlatformsToEsportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlatformsToEsportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlatformsToEsportMutation, { data, loading, error }] = useAddPlatformsToEsportMutation({
 *   variables: {
 *      esportId: // value for 'esportId'
 *      platforms: // value for 'platforms'
 *   },
 * });
 */
export function useAddPlatformsToEsportMutation(baseOptions?: Apollo.MutationHookOptions<AddPlatformsToEsportMutation, AddPlatformsToEsportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlatformsToEsportMutation, AddPlatformsToEsportMutationVariables>(AddPlatformsToEsportDocument, options);
      }
export type AddPlatformsToEsportMutationHookResult = ReturnType<typeof useAddPlatformsToEsportMutation>;
export type AddPlatformsToEsportMutationResult = Apollo.MutationResult<AddPlatformsToEsportMutation>;
export type AddPlatformsToEsportMutationOptions = Apollo.BaseMutationOptions<AddPlatformsToEsportMutation, AddPlatformsToEsportMutationVariables>;
export const RemovePlatformsFromEsportDocument = gql`
    mutation removePlatformsFromEsport($esportId: UUID!, $platforms: [Platform!]) {
  removePlatformsFromEsport(esportId: $esportId, platforms: $platforms) {
    success
  }
}
    `;
export type RemovePlatformsFromEsportMutationFn = Apollo.MutationFunction<RemovePlatformsFromEsportMutation, RemovePlatformsFromEsportMutationVariables>;

/**
 * __useRemovePlatformsFromEsportMutation__
 *
 * To run a mutation, you first call `useRemovePlatformsFromEsportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlatformsFromEsportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlatformsFromEsportMutation, { data, loading, error }] = useRemovePlatformsFromEsportMutation({
 *   variables: {
 *      esportId: // value for 'esportId'
 *      platforms: // value for 'platforms'
 *   },
 * });
 */
export function useRemovePlatformsFromEsportMutation(baseOptions?: Apollo.MutationHookOptions<RemovePlatformsFromEsportMutation, RemovePlatformsFromEsportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePlatformsFromEsportMutation, RemovePlatformsFromEsportMutationVariables>(RemovePlatformsFromEsportDocument, options);
      }
export type RemovePlatformsFromEsportMutationHookResult = ReturnType<typeof useRemovePlatformsFromEsportMutation>;
export type RemovePlatformsFromEsportMutationResult = Apollo.MutationResult<RemovePlatformsFromEsportMutation>;
export type RemovePlatformsFromEsportMutationOptions = Apollo.BaseMutationOptions<RemovePlatformsFromEsportMutation, RemovePlatformsFromEsportMutationVariables>;
export const FetchPlayerStandingDocument = gql`
    query fetchPlayerStanding($phaseId: UUID!, $playerId: UUID) {
  fetchPlayerStanding(phaseId: $phaseId, playerId: $playerId) {
    ... on PlayerLolStandings {
      user {
        id
        avatarUrl
        name
      }
      school {
        id
        name
        logoUrl
        slug
      }
      kda {
        value
        rank {
          league
          state
          overall
        }
      }
      gold {
        value
        rank {
          league
          state
          overall
        }
      }
    }
    ... on PlayerSmiteStandings {
      user {
        id
        avatarUrl
        name
      }
      school {
        id
        name
        logoUrl
        slug
      }
      kda {
        value
        rank {
          league
          state
          overall
        }
      }
      gold {
        value
        rank {
          league
          state
          overall
        }
      }
    }
    ... on PlayerRLStandings {
      user {
        id
        avatarUrl
        name
      }
      school {
        id
        name
        logoUrl
        slug
      }
      scorePerGame {
        value
        rank {
          league
          state
          overall
        }
      }
      goalsPerShot {
        value
        rank {
          league
          state
          overall
        }
      }
    }
    ... on TeamFortniteStandings {
      user {
        id
        avatarUrl
        name
      }
      school {
        id
        name
        logoUrl
        slug
      }
      team {
        id
        name
      }
      eliminationsPerGame {
        value
        rank {
          league
          state
          overall
        }
      }
      rankPerGame {
        value
        rank {
          league
          state
          overall
        }
      }
    }
  }
}
    `;

/**
 * __useFetchPlayerStandingQuery__
 *
 * To run a query within a React component, call `useFetchPlayerStandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlayerStandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPlayerStandingQuery({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useFetchPlayerStandingQuery(baseOptions: Apollo.QueryHookOptions<FetchPlayerStandingQuery, FetchPlayerStandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPlayerStandingQuery, FetchPlayerStandingQueryVariables>(FetchPlayerStandingDocument, options);
      }
export function useFetchPlayerStandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPlayerStandingQuery, FetchPlayerStandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPlayerStandingQuery, FetchPlayerStandingQueryVariables>(FetchPlayerStandingDocument, options);
        }
export type FetchPlayerStandingQueryHookResult = ReturnType<typeof useFetchPlayerStandingQuery>;
export type FetchPlayerStandingLazyQueryHookResult = ReturnType<typeof useFetchPlayerStandingLazyQuery>;
export type FetchPlayerStandingQueryResult = Apollo.QueryResult<FetchPlayerStandingQuery, FetchPlayerStandingQueryVariables>;
export function refetchFetchPlayerStandingQuery(variables: FetchPlayerStandingQueryVariables) {
      return { query: FetchPlayerStandingDocument, variables: variables }
    }
export const GetSchoolPlayersDocument = gql`
    query getSchoolPlayers($schoolId: UUID!) {
  school(id: $schoolId) {
    id
    name
    players {
      id
      avatarUrl
      name
      userProviderAccounts {
        id
        userId
        providerName
        providerAccountId
        providerDisplayName
        providerIntegrationType
      }
    }
  }
}
    `;

/**
 * __useGetSchoolPlayersQuery__
 *
 * To run a query within a React component, call `useGetSchoolPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolPlayersQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolPlayersQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolPlayersQuery, GetSchoolPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolPlayersQuery, GetSchoolPlayersQueryVariables>(GetSchoolPlayersDocument, options);
      }
export function useGetSchoolPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolPlayersQuery, GetSchoolPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolPlayersQuery, GetSchoolPlayersQueryVariables>(GetSchoolPlayersDocument, options);
        }
export type GetSchoolPlayersQueryHookResult = ReturnType<typeof useGetSchoolPlayersQuery>;
export type GetSchoolPlayersLazyQueryHookResult = ReturnType<typeof useGetSchoolPlayersLazyQuery>;
export type GetSchoolPlayersQueryResult = Apollo.QueryResult<GetSchoolPlayersQuery, GetSchoolPlayersQueryVariables>;
export function refetchGetSchoolPlayersQuery(variables: GetSchoolPlayersQueryVariables) {
      return { query: GetSchoolPlayersDocument, variables: variables }
    }
export const DenyVerifiedPlayerDocument = gql`
    mutation denyVerifiedPlayer($userId: UUID!, $resourceId: UUID!) {
  denyVerifiedPlayer(userId: $userId, resourceId: $resourceId) {
    success
  }
}
    `;
export type DenyVerifiedPlayerMutationFn = Apollo.MutationFunction<DenyVerifiedPlayerMutation, DenyVerifiedPlayerMutationVariables>;

/**
 * __useDenyVerifiedPlayerMutation__
 *
 * To run a mutation, you first call `useDenyVerifiedPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyVerifiedPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyVerifiedPlayerMutation, { data, loading, error }] = useDenyVerifiedPlayerMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useDenyVerifiedPlayerMutation(baseOptions?: Apollo.MutationHookOptions<DenyVerifiedPlayerMutation, DenyVerifiedPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyVerifiedPlayerMutation, DenyVerifiedPlayerMutationVariables>(DenyVerifiedPlayerDocument, options);
      }
export type DenyVerifiedPlayerMutationHookResult = ReturnType<typeof useDenyVerifiedPlayerMutation>;
export type DenyVerifiedPlayerMutationResult = Apollo.MutationResult<DenyVerifiedPlayerMutation>;
export type DenyVerifiedPlayerMutationOptions = Apollo.BaseMutationOptions<DenyVerifiedPlayerMutation, DenyVerifiedPlayerMutationVariables>;
export const VerifyDeniedPlayerDocument = gql`
    mutation verifyDeniedPlayer($userId: UUID!, $resourceId: UUID!) {
  verifyDeniedPlayer(userId: $userId, resourceId: $resourceId) {
    success
  }
}
    `;
export type VerifyDeniedPlayerMutationFn = Apollo.MutationFunction<VerifyDeniedPlayerMutation, VerifyDeniedPlayerMutationVariables>;

/**
 * __useVerifyDeniedPlayerMutation__
 *
 * To run a mutation, you first call `useVerifyDeniedPlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyDeniedPlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyDeniedPlayerMutation, { data, loading, error }] = useVerifyDeniedPlayerMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useVerifyDeniedPlayerMutation(baseOptions?: Apollo.MutationHookOptions<VerifyDeniedPlayerMutation, VerifyDeniedPlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyDeniedPlayerMutation, VerifyDeniedPlayerMutationVariables>(VerifyDeniedPlayerDocument, options);
      }
export type VerifyDeniedPlayerMutationHookResult = ReturnType<typeof useVerifyDeniedPlayerMutation>;
export type VerifyDeniedPlayerMutationResult = Apollo.MutationResult<VerifyDeniedPlayerMutation>;
export type VerifyDeniedPlayerMutationOptions = Apollo.BaseMutationOptions<VerifyDeniedPlayerMutation, VerifyDeniedPlayerMutationVariables>;
export const PlayoffBracketForLeagueDocument = gql`
    query playoffBracketForLeague($leagueId: UUID!) {
  league(id: $leagueId) {
    id
    name
    state
    esport {
      id
      name
    }
    seasons {
      id
      name
      phases {
        id
        name
        format
      }
    }
  }
}
    `;

/**
 * __usePlayoffBracketForLeagueQuery__
 *
 * To run a query within a React component, call `usePlayoffBracketForLeagueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayoffBracketForLeagueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayoffBracketForLeagueQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function usePlayoffBracketForLeagueQuery(baseOptions: Apollo.QueryHookOptions<PlayoffBracketForLeagueQuery, PlayoffBracketForLeagueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayoffBracketForLeagueQuery, PlayoffBracketForLeagueQueryVariables>(PlayoffBracketForLeagueDocument, options);
      }
export function usePlayoffBracketForLeagueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayoffBracketForLeagueQuery, PlayoffBracketForLeagueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayoffBracketForLeagueQuery, PlayoffBracketForLeagueQueryVariables>(PlayoffBracketForLeagueDocument, options);
        }
export type PlayoffBracketForLeagueQueryHookResult = ReturnType<typeof usePlayoffBracketForLeagueQuery>;
export type PlayoffBracketForLeagueLazyQueryHookResult = ReturnType<typeof usePlayoffBracketForLeagueLazyQuery>;
export type PlayoffBracketForLeagueQueryResult = Apollo.QueryResult<PlayoffBracketForLeagueQuery, PlayoffBracketForLeagueQueryVariables>;
export function refetchPlayoffBracketForLeagueQuery(variables: PlayoffBracketForLeagueQueryVariables) {
      return { query: PlayoffBracketForLeagueDocument, variables: variables }
    }
export const GetPracticeDaySchedulesDocument = gql`
    query getPracticeDaySchedules($input: GetPracticeDaySchedulesInput!) {
  getPracticeDaySchedules(input: $input) {
    success
    errors
    payload {
      id
      isLive
    }
  }
}
    `;

/**
 * __useGetPracticeDaySchedulesQuery__
 *
 * To run a query within a React component, call `useGetPracticeDaySchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPracticeDaySchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPracticeDaySchedulesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPracticeDaySchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetPracticeDaySchedulesQuery, GetPracticeDaySchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPracticeDaySchedulesQuery, GetPracticeDaySchedulesQueryVariables>(GetPracticeDaySchedulesDocument, options);
      }
export function useGetPracticeDaySchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPracticeDaySchedulesQuery, GetPracticeDaySchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPracticeDaySchedulesQuery, GetPracticeDaySchedulesQueryVariables>(GetPracticeDaySchedulesDocument, options);
        }
export type GetPracticeDaySchedulesQueryHookResult = ReturnType<typeof useGetPracticeDaySchedulesQuery>;
export type GetPracticeDaySchedulesLazyQueryHookResult = ReturnType<typeof useGetPracticeDaySchedulesLazyQuery>;
export type GetPracticeDaySchedulesQueryResult = Apollo.QueryResult<GetPracticeDaySchedulesQuery, GetPracticeDaySchedulesQueryVariables>;
export function refetchGetPracticeDaySchedulesQuery(variables: GetPracticeDaySchedulesQueryVariables) {
      return { query: GetPracticeDaySchedulesDocument, variables: variables }
    }
export const GetTeamsForPracticeDayDocument = gql`
    query getTeamsForPracticeDay($teamIds: [UUID!]!) {
  teamsByIds(ids: $teamIds) {
    id
    esport {
      id
      slug
      rating
    }
    roster {
      id
      formats {
        teamSize
        starters {
          player {
            user {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamsForPracticeDayQuery__
 *
 * To run a query within a React component, call `useGetTeamsForPracticeDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsForPracticeDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsForPracticeDayQuery({
 *   variables: {
 *      teamIds: // value for 'teamIds'
 *   },
 * });
 */
export function useGetTeamsForPracticeDayQuery(baseOptions: Apollo.QueryHookOptions<GetTeamsForPracticeDayQuery, GetTeamsForPracticeDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsForPracticeDayQuery, GetTeamsForPracticeDayQueryVariables>(GetTeamsForPracticeDayDocument, options);
      }
export function useGetTeamsForPracticeDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsForPracticeDayQuery, GetTeamsForPracticeDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsForPracticeDayQuery, GetTeamsForPracticeDayQueryVariables>(GetTeamsForPracticeDayDocument, options);
        }
export type GetTeamsForPracticeDayQueryHookResult = ReturnType<typeof useGetTeamsForPracticeDayQuery>;
export type GetTeamsForPracticeDayLazyQueryHookResult = ReturnType<typeof useGetTeamsForPracticeDayLazyQuery>;
export type GetTeamsForPracticeDayQueryResult = Apollo.QueryResult<GetTeamsForPracticeDayQuery, GetTeamsForPracticeDayQueryVariables>;
export function refetchGetTeamsForPracticeDayQuery(variables: GetTeamsForPracticeDayQueryVariables) {
      return { query: GetTeamsForPracticeDayDocument, variables: variables }
    }
export const RequestMatchRescheduleDocument = gql`
    mutation requestMatchReschedule($input: RequestMatchRescheduleInput!) {
  requestMatchReschedule(input: $input) {
    id
    matchId
    teamId
    requestedById
    deniedById
    approvedById
    canceledById
    status
    rescheduleReason
    rescheduleNotes
    denyNotes
    proposedTimes
    createdAt
    updatedAt
  }
}
    `;
export type RequestMatchRescheduleMutationFn = Apollo.MutationFunction<RequestMatchRescheduleMutation, RequestMatchRescheduleMutationVariables>;

/**
 * __useRequestMatchRescheduleMutation__
 *
 * To run a mutation, you first call `useRequestMatchRescheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMatchRescheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMatchRescheduleMutation, { data, loading, error }] = useRequestMatchRescheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMatchRescheduleMutation(baseOptions?: Apollo.MutationHookOptions<RequestMatchRescheduleMutation, RequestMatchRescheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMatchRescheduleMutation, RequestMatchRescheduleMutationVariables>(RequestMatchRescheduleDocument, options);
      }
export type RequestMatchRescheduleMutationHookResult = ReturnType<typeof useRequestMatchRescheduleMutation>;
export type RequestMatchRescheduleMutationResult = Apollo.MutationResult<RequestMatchRescheduleMutation>;
export type RequestMatchRescheduleMutationOptions = Apollo.BaseMutationOptions<RequestMatchRescheduleMutation, RequestMatchRescheduleMutationVariables>;
export const RequestMatchRescheduleWithinSchoolDocument = gql`
    mutation requestMatchRescheduleWithinSchool($input: RequestMatchRescheduleWithinSchoolInput!) {
  requestMatchRescheduleWithinSchool(input: $input) {
    id
    matchId
    teamId
    requestedById
    deniedById
    approvedById
    canceledById
    status
    rescheduleReason
    rescheduleNotes
    denyNotes
    proposedTimes
    createdAt
    updatedAt
  }
}
    `;
export type RequestMatchRescheduleWithinSchoolMutationFn = Apollo.MutationFunction<RequestMatchRescheduleWithinSchoolMutation, RequestMatchRescheduleWithinSchoolMutationVariables>;

/**
 * __useRequestMatchRescheduleWithinSchoolMutation__
 *
 * To run a mutation, you first call `useRequestMatchRescheduleWithinSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMatchRescheduleWithinSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMatchRescheduleWithinSchoolMutation, { data, loading, error }] = useRequestMatchRescheduleWithinSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMatchRescheduleWithinSchoolMutation(baseOptions?: Apollo.MutationHookOptions<RequestMatchRescheduleWithinSchoolMutation, RequestMatchRescheduleWithinSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMatchRescheduleWithinSchoolMutation, RequestMatchRescheduleWithinSchoolMutationVariables>(RequestMatchRescheduleWithinSchoolDocument, options);
      }
export type RequestMatchRescheduleWithinSchoolMutationHookResult = ReturnType<typeof useRequestMatchRescheduleWithinSchoolMutation>;
export type RequestMatchRescheduleWithinSchoolMutationResult = Apollo.MutationResult<RequestMatchRescheduleWithinSchoolMutation>;
export type RequestMatchRescheduleWithinSchoolMutationOptions = Apollo.BaseMutationOptions<RequestMatchRescheduleWithinSchoolMutation, RequestMatchRescheduleWithinSchoolMutationVariables>;
export const CancelMatchRescheduleDocument = gql`
    mutation cancelMatchReschedule($input: CancelMatchRescheduleInput!) {
  cancelMatchRescheduleRequest(input: $input) {
    id
    matchId
    teamId
    requestedById
    deniedById
    approvedById
    canceledById
    status
    rescheduleReason
    rescheduleNotes
    denyNotes
    proposedTimes
    createdAt
    updatedAt
  }
}
    `;
export type CancelMatchRescheduleMutationFn = Apollo.MutationFunction<CancelMatchRescheduleMutation, CancelMatchRescheduleMutationVariables>;

/**
 * __useCancelMatchRescheduleMutation__
 *
 * To run a mutation, you first call `useCancelMatchRescheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMatchRescheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMatchRescheduleMutation, { data, loading, error }] = useCancelMatchRescheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelMatchRescheduleMutation(baseOptions?: Apollo.MutationHookOptions<CancelMatchRescheduleMutation, CancelMatchRescheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMatchRescheduleMutation, CancelMatchRescheduleMutationVariables>(CancelMatchRescheduleDocument, options);
      }
export type CancelMatchRescheduleMutationHookResult = ReturnType<typeof useCancelMatchRescheduleMutation>;
export type CancelMatchRescheduleMutationResult = Apollo.MutationResult<CancelMatchRescheduleMutation>;
export type CancelMatchRescheduleMutationOptions = Apollo.BaseMutationOptions<CancelMatchRescheduleMutation, CancelMatchRescheduleMutationVariables>;
export const RespondToMatchRescheduleRequestDocument = gql`
    mutation respondToMatchRescheduleRequest($input: ResponseMatchRescheduleInput!) {
  respondToMatchRescheduleRequest(input: $input) {
    id
    matchId
    teamId
    requestedById
    deniedById
    approvedById
    canceledById
    status
    rescheduleReason
    rescheduleNotes
    denyNotes
    proposedTimes
    createdAt
    updatedAt
  }
}
    `;
export type RespondToMatchRescheduleRequestMutationFn = Apollo.MutationFunction<RespondToMatchRescheduleRequestMutation, RespondToMatchRescheduleRequestMutationVariables>;

/**
 * __useRespondToMatchRescheduleRequestMutation__
 *
 * To run a mutation, you first call `useRespondToMatchRescheduleRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToMatchRescheduleRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToMatchRescheduleRequestMutation, { data, loading, error }] = useRespondToMatchRescheduleRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondToMatchRescheduleRequestMutation(baseOptions?: Apollo.MutationHookOptions<RespondToMatchRescheduleRequestMutation, RespondToMatchRescheduleRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToMatchRescheduleRequestMutation, RespondToMatchRescheduleRequestMutationVariables>(RespondToMatchRescheduleRequestDocument, options);
      }
export type RespondToMatchRescheduleRequestMutationHookResult = ReturnType<typeof useRespondToMatchRescheduleRequestMutation>;
export type RespondToMatchRescheduleRequestMutationResult = Apollo.MutationResult<RespondToMatchRescheduleRequestMutation>;
export type RespondToMatchRescheduleRequestMutationOptions = Apollo.BaseMutationOptions<RespondToMatchRescheduleRequestMutation, RespondToMatchRescheduleRequestMutationVariables>;
export const RescheduleMatchDocument = gql`
    mutation rescheduleMatch($matchId: UUID!, $updatedStartsAt: DateTime!, $reason: AdminMatchRescheduleReason!, $notes: String) {
  rescheduleMatch(
    matchId: $matchId
    updatedStartsAt: $updatedStartsAt
    reason: $reason
    notes: $notes
  ) {
    success
    match {
      id
      scheduledStartsAt
    }
  }
}
    `;
export type RescheduleMatchMutationFn = Apollo.MutationFunction<RescheduleMatchMutation, RescheduleMatchMutationVariables>;

/**
 * __useRescheduleMatchMutation__
 *
 * To run a mutation, you first call `useRescheduleMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleMatchMutation, { data, loading, error }] = useRescheduleMatchMutation({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      updatedStartsAt: // value for 'updatedStartsAt'
 *      reason: // value for 'reason'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useRescheduleMatchMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleMatchMutation, RescheduleMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleMatchMutation, RescheduleMatchMutationVariables>(RescheduleMatchDocument, options);
      }
export type RescheduleMatchMutationHookResult = ReturnType<typeof useRescheduleMatchMutation>;
export type RescheduleMatchMutationResult = Apollo.MutationResult<RescheduleMatchMutation>;
export type RescheduleMatchMutationOptions = Apollo.BaseMutationOptions<RescheduleMatchMutation, RescheduleMatchMutationVariables>;
export const MatchRescheduleDateRangeDocument = gql`
    query matchRescheduleDateRange($matchId: UUID!) {
  match(id: $matchId) {
    id
    scheduledStartsAt
    slot {
      id
      startsAt
      phase {
        id
        endsAt
      }
    }
  }
}
    `;

/**
 * __useMatchRescheduleDateRangeQuery__
 *
 * To run a query within a React component, call `useMatchRescheduleDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchRescheduleDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchRescheduleDateRangeQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchRescheduleDateRangeQuery(baseOptions: Apollo.QueryHookOptions<MatchRescheduleDateRangeQuery, MatchRescheduleDateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchRescheduleDateRangeQuery, MatchRescheduleDateRangeQueryVariables>(MatchRescheduleDateRangeDocument, options);
      }
export function useMatchRescheduleDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchRescheduleDateRangeQuery, MatchRescheduleDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchRescheduleDateRangeQuery, MatchRescheduleDateRangeQueryVariables>(MatchRescheduleDateRangeDocument, options);
        }
export type MatchRescheduleDateRangeQueryHookResult = ReturnType<typeof useMatchRescheduleDateRangeQuery>;
export type MatchRescheduleDateRangeLazyQueryHookResult = ReturnType<typeof useMatchRescheduleDateRangeLazyQuery>;
export type MatchRescheduleDateRangeQueryResult = Apollo.QueryResult<MatchRescheduleDateRangeQuery, MatchRescheduleDateRangeQueryVariables>;
export function refetchMatchRescheduleDateRangeQuery(variables: MatchRescheduleDateRangeQueryVariables) {
      return { query: MatchRescheduleDateRangeDocument, variables: variables }
    }
export const GetMatchRescheduleDateRangeDocument = gql`
    query getMatchRescheduleDateRange($id: UUID!) {
  getMatchRescheduleDateRange(id: $id) {
    after
    before
  }
}
    `;

/**
 * __useGetMatchRescheduleDateRangeQuery__
 *
 * To run a query within a React component, call `useGetMatchRescheduleDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchRescheduleDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchRescheduleDateRangeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMatchRescheduleDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetMatchRescheduleDateRangeQuery, GetMatchRescheduleDateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchRescheduleDateRangeQuery, GetMatchRescheduleDateRangeQueryVariables>(GetMatchRescheduleDateRangeDocument, options);
      }
export function useGetMatchRescheduleDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchRescheduleDateRangeQuery, GetMatchRescheduleDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchRescheduleDateRangeQuery, GetMatchRescheduleDateRangeQueryVariables>(GetMatchRescheduleDateRangeDocument, options);
        }
export type GetMatchRescheduleDateRangeQueryHookResult = ReturnType<typeof useGetMatchRescheduleDateRangeQuery>;
export type GetMatchRescheduleDateRangeLazyQueryHookResult = ReturnType<typeof useGetMatchRescheduleDateRangeLazyQuery>;
export type GetMatchRescheduleDateRangeQueryResult = Apollo.QueryResult<GetMatchRescheduleDateRangeQuery, GetMatchRescheduleDateRangeQueryVariables>;
export function refetchGetMatchRescheduleDateRangeQuery(variables: GetMatchRescheduleDateRangeQueryVariables) {
      return { query: GetMatchRescheduleDateRangeDocument, variables: variables }
    }
export const GetWalkthroughPlaylistDocument = gql`
    query getWalkthroughPlaylist {
  getWalkthroughPlaylist {
    playlist {
      title
      thumbnail
      embedHtml
      durationSeconds
    }
  }
}
    `;

/**
 * __useGetWalkthroughPlaylistQuery__
 *
 * To run a query within a React component, call `useGetWalkthroughPlaylistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalkthroughPlaylistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalkthroughPlaylistQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWalkthroughPlaylistQuery(baseOptions?: Apollo.QueryHookOptions<GetWalkthroughPlaylistQuery, GetWalkthroughPlaylistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalkthroughPlaylistQuery, GetWalkthroughPlaylistQueryVariables>(GetWalkthroughPlaylistDocument, options);
      }
export function useGetWalkthroughPlaylistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalkthroughPlaylistQuery, GetWalkthroughPlaylistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalkthroughPlaylistQuery, GetWalkthroughPlaylistQueryVariables>(GetWalkthroughPlaylistDocument, options);
        }
export type GetWalkthroughPlaylistQueryHookResult = ReturnType<typeof useGetWalkthroughPlaylistQuery>;
export type GetWalkthroughPlaylistLazyQueryHookResult = ReturnType<typeof useGetWalkthroughPlaylistLazyQuery>;
export type GetWalkthroughPlaylistQueryResult = Apollo.QueryResult<GetWalkthroughPlaylistQuery, GetWalkthroughPlaylistQueryVariables>;
export function refetchGetWalkthroughPlaylistQuery(variables?: GetWalkthroughPlaylistQueryVariables) {
      return { query: GetWalkthroughPlaylistDocument, variables: variables }
    }
export const GetResourceImagesByResourceIdsDocument = gql`
    query getResourceImagesByResourceIds($resources: [ResourceData!]!) {
  getResourceImagesByResourceIds(resources: $resources) {
    fileName
    url
    size
    resourceId
    resourceType
  }
}
    `;

/**
 * __useGetResourceImagesByResourceIdsQuery__
 *
 * To run a query within a React component, call `useGetResourceImagesByResourceIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceImagesByResourceIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceImagesByResourceIdsQuery({
 *   variables: {
 *      resources: // value for 'resources'
 *   },
 * });
 */
export function useGetResourceImagesByResourceIdsQuery(baseOptions: Apollo.QueryHookOptions<GetResourceImagesByResourceIdsQuery, GetResourceImagesByResourceIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceImagesByResourceIdsQuery, GetResourceImagesByResourceIdsQueryVariables>(GetResourceImagesByResourceIdsDocument, options);
      }
export function useGetResourceImagesByResourceIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceImagesByResourceIdsQuery, GetResourceImagesByResourceIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceImagesByResourceIdsQuery, GetResourceImagesByResourceIdsQueryVariables>(GetResourceImagesByResourceIdsDocument, options);
        }
export type GetResourceImagesByResourceIdsQueryHookResult = ReturnType<typeof useGetResourceImagesByResourceIdsQuery>;
export type GetResourceImagesByResourceIdsLazyQueryHookResult = ReturnType<typeof useGetResourceImagesByResourceIdsLazyQuery>;
export type GetResourceImagesByResourceIdsQueryResult = Apollo.QueryResult<GetResourceImagesByResourceIdsQuery, GetResourceImagesByResourceIdsQueryVariables>;
export function refetchGetResourceImagesByResourceIdsQuery(variables: GetResourceImagesByResourceIdsQueryVariables) {
      return { query: GetResourceImagesByResourceIdsDocument, variables: variables }
    }
export const GetChecklistDocument = gql`
    query getChecklist($schoolId: UUID!) {
  getChecklist(schoolId: $schoolId) {
    groups {
      group
      items {
        slug
        label
        cta
        urls {
          url
          label
        }
        completedById
        completedAt
      }
    }
  }
}
    `;

/**
 * __useGetChecklistQuery__
 *
 * To run a query within a React component, call `useGetChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChecklistQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetChecklistQuery(baseOptions: Apollo.QueryHookOptions<GetChecklistQuery, GetChecklistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChecklistQuery, GetChecklistQueryVariables>(GetChecklistDocument, options);
      }
export function useGetChecklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChecklistQuery, GetChecklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChecklistQuery, GetChecklistQueryVariables>(GetChecklistDocument, options);
        }
export type GetChecklistQueryHookResult = ReturnType<typeof useGetChecklistQuery>;
export type GetChecklistLazyQueryHookResult = ReturnType<typeof useGetChecklistLazyQuery>;
export type GetChecklistQueryResult = Apollo.QueryResult<GetChecklistQuery, GetChecklistQueryVariables>;
export function refetchGetChecklistQuery(variables: GetChecklistQueryVariables) {
      return { query: GetChecklistDocument, variables: variables }
    }
export const GetCheckCompletedUserDocument = gql`
    query getCheckCompletedUser($id: UUID!) {
  user(id: $id) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useGetCheckCompletedUserQuery__
 *
 * To run a query within a React component, call `useGetCheckCompletedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckCompletedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckCompletedUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCheckCompletedUserQuery(baseOptions: Apollo.QueryHookOptions<GetCheckCompletedUserQuery, GetCheckCompletedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckCompletedUserQuery, GetCheckCompletedUserQueryVariables>(GetCheckCompletedUserDocument, options);
      }
export function useGetCheckCompletedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckCompletedUserQuery, GetCheckCompletedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckCompletedUserQuery, GetCheckCompletedUserQueryVariables>(GetCheckCompletedUserDocument, options);
        }
export type GetCheckCompletedUserQueryHookResult = ReturnType<typeof useGetCheckCompletedUserQuery>;
export type GetCheckCompletedUserLazyQueryHookResult = ReturnType<typeof useGetCheckCompletedUserLazyQuery>;
export type GetCheckCompletedUserQueryResult = Apollo.QueryResult<GetCheckCompletedUserQuery, GetCheckCompletedUserQueryVariables>;
export function refetchGetCheckCompletedUserQuery(variables: GetCheckCompletedUserQueryVariables) {
      return { query: GetCheckCompletedUserDocument, variables: variables }
    }
export const CompleteChecklistItemDocument = gql`
    mutation completeChecklistItem($schoolId: UUID!, $slug: String!) {
  completeChecklistItem(schoolId: $schoolId, slug: $slug) {
    success
  }
}
    `;
export type CompleteChecklistItemMutationFn = Apollo.MutationFunction<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>;

/**
 * __useCompleteChecklistItemMutation__
 *
 * To run a mutation, you first call `useCompleteChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeChecklistItemMutation, { data, loading, error }] = useCompleteChecklistItemMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCompleteChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>(CompleteChecklistItemDocument, options);
      }
export type CompleteChecklistItemMutationHookResult = ReturnType<typeof useCompleteChecklistItemMutation>;
export type CompleteChecklistItemMutationResult = Apollo.MutationResult<CompleteChecklistItemMutation>;
export type CompleteChecklistItemMutationOptions = Apollo.BaseMutationOptions<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>;
export const UncompleteChecklistItemDocument = gql`
    mutation uncompleteChecklistItem($schoolId: UUID!, $slug: String!) {
  uncompleteChecklistItem(schoolId: $schoolId, slug: $slug) {
    success
  }
}
    `;
export type UncompleteChecklistItemMutationFn = Apollo.MutationFunction<UncompleteChecklistItemMutation, UncompleteChecklistItemMutationVariables>;

/**
 * __useUncompleteChecklistItemMutation__
 *
 * To run a mutation, you first call `useUncompleteChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncompleteChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncompleteChecklistItemMutation, { data, loading, error }] = useUncompleteChecklistItemMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useUncompleteChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<UncompleteChecklistItemMutation, UncompleteChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncompleteChecklistItemMutation, UncompleteChecklistItemMutationVariables>(UncompleteChecklistItemDocument, options);
      }
export type UncompleteChecklistItemMutationHookResult = ReturnType<typeof useUncompleteChecklistItemMutation>;
export type UncompleteChecklistItemMutationResult = Apollo.MutationResult<UncompleteChecklistItemMutation>;
export type UncompleteChecklistItemMutationOptions = Apollo.BaseMutationOptions<UncompleteChecklistItemMutation, UncompleteChecklistItemMutationVariables>;
export const GetReplayStatsByUserIdDocument = gql`
    query getReplayStatsByUserId($input: PlayerReplayInput!) {
  getReplayStatsByUserId(input: $input) {
    slidesData {
      ...PlayerReplayStat
    }
    userId
    user {
      ...PlayerReplayUser
    }
  }
}
    ${PlayerReplayStatFragmentDoc}
${PlayerReplayUserFragmentDoc}`;

/**
 * __useGetReplayStatsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetReplayStatsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReplayStatsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReplayStatsByUserIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReplayStatsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetReplayStatsByUserIdQuery, GetReplayStatsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReplayStatsByUserIdQuery, GetReplayStatsByUserIdQueryVariables>(GetReplayStatsByUserIdDocument, options);
      }
export function useGetReplayStatsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReplayStatsByUserIdQuery, GetReplayStatsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReplayStatsByUserIdQuery, GetReplayStatsByUserIdQueryVariables>(GetReplayStatsByUserIdDocument, options);
        }
export type GetReplayStatsByUserIdQueryHookResult = ReturnType<typeof useGetReplayStatsByUserIdQuery>;
export type GetReplayStatsByUserIdLazyQueryHookResult = ReturnType<typeof useGetReplayStatsByUserIdLazyQuery>;
export type GetReplayStatsByUserIdQueryResult = Apollo.QueryResult<GetReplayStatsByUserIdQuery, GetReplayStatsByUserIdQueryVariables>;
export function refetchGetReplayStatsByUserIdQuery(variables: GetReplayStatsByUserIdQueryVariables) {
      return { query: GetReplayStatsByUserIdDocument, variables: variables }
    }
export const LobbyEventsForGameDocument = gql`
    query lobbyEventsForGame($tournamentCode: String!) {
  lobbyEventsForGame(tournamentCode: $tournamentCode) {
    events {
      summonerId
      eventType
      timestamp
    }
  }
}
    `;

/**
 * __useLobbyEventsForGameQuery__
 *
 * To run a query within a React component, call `useLobbyEventsForGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useLobbyEventsForGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLobbyEventsForGameQuery({
 *   variables: {
 *      tournamentCode: // value for 'tournamentCode'
 *   },
 * });
 */
export function useLobbyEventsForGameQuery(baseOptions: Apollo.QueryHookOptions<LobbyEventsForGameQuery, LobbyEventsForGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LobbyEventsForGameQuery, LobbyEventsForGameQueryVariables>(LobbyEventsForGameDocument, options);
      }
export function useLobbyEventsForGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LobbyEventsForGameQuery, LobbyEventsForGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LobbyEventsForGameQuery, LobbyEventsForGameQueryVariables>(LobbyEventsForGameDocument, options);
        }
export type LobbyEventsForGameQueryHookResult = ReturnType<typeof useLobbyEventsForGameQuery>;
export type LobbyEventsForGameLazyQueryHookResult = ReturnType<typeof useLobbyEventsForGameLazyQuery>;
export type LobbyEventsForGameQueryResult = Apollo.QueryResult<LobbyEventsForGameQuery, LobbyEventsForGameQueryVariables>;
export function refetchLobbyEventsForGameQuery(variables: LobbyEventsForGameQueryVariables) {
      return { query: LobbyEventsForGameDocument, variables: variables }
    }
export const SummonerInfoByIdDocument = gql`
    query summonerInfoById($summonerId: String!) {
  summonerInfo(summonerId: $summonerId) {
    profileIconId
    name
    id
    summonerLevel
    revisionDate
  }
}
    `;

/**
 * __useSummonerInfoByIdQuery__
 *
 * To run a query within a React component, call `useSummonerInfoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummonerInfoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummonerInfoByIdQuery({
 *   variables: {
 *      summonerId: // value for 'summonerId'
 *   },
 * });
 */
export function useSummonerInfoByIdQuery(baseOptions: Apollo.QueryHookOptions<SummonerInfoByIdQuery, SummonerInfoByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummonerInfoByIdQuery, SummonerInfoByIdQueryVariables>(SummonerInfoByIdDocument, options);
      }
export function useSummonerInfoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummonerInfoByIdQuery, SummonerInfoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummonerInfoByIdQuery, SummonerInfoByIdQueryVariables>(SummonerInfoByIdDocument, options);
        }
export type SummonerInfoByIdQueryHookResult = ReturnType<typeof useSummonerInfoByIdQuery>;
export type SummonerInfoByIdLazyQueryHookResult = ReturnType<typeof useSummonerInfoByIdLazyQuery>;
export type SummonerInfoByIdQueryResult = Apollo.QueryResult<SummonerInfoByIdQuery, SummonerInfoByIdQueryVariables>;
export function refetchSummonerInfoByIdQuery(variables: SummonerInfoByIdQueryVariables) {
      return { query: SummonerInfoByIdDocument, variables: variables }
    }
export const SummonerInfoByNameDocument = gql`
    query summonerInfoByName($summonerId: String, $summonerName: String) {
  summonerInfo(summonerId: $summonerId, summonerName: $summonerName) {
    name
    puuid
  }
}
    `;

/**
 * __useSummonerInfoByNameQuery__
 *
 * To run a query within a React component, call `useSummonerInfoByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummonerInfoByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummonerInfoByNameQuery({
 *   variables: {
 *      summonerId: // value for 'summonerId'
 *      summonerName: // value for 'summonerName'
 *   },
 * });
 */
export function useSummonerInfoByNameQuery(baseOptions?: Apollo.QueryHookOptions<SummonerInfoByNameQuery, SummonerInfoByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummonerInfoByNameQuery, SummonerInfoByNameQueryVariables>(SummonerInfoByNameDocument, options);
      }
export function useSummonerInfoByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummonerInfoByNameQuery, SummonerInfoByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummonerInfoByNameQuery, SummonerInfoByNameQueryVariables>(SummonerInfoByNameDocument, options);
        }
export type SummonerInfoByNameQueryHookResult = ReturnType<typeof useSummonerInfoByNameQuery>;
export type SummonerInfoByNameLazyQueryHookResult = ReturnType<typeof useSummonerInfoByNameLazyQuery>;
export type SummonerInfoByNameQueryResult = Apollo.QueryResult<SummonerInfoByNameQuery, SummonerInfoByNameQueryVariables>;
export function refetchSummonerInfoByNameQuery(variables?: SummonerInfoByNameQueryVariables) {
      return { query: SummonerInfoByNameDocument, variables: variables }
    }
export const PickTypeForGameDocument = gql`
    query pickTypeForGame($tournamentCode: String!) {
  getLobbyInfo(tournamentCode: $tournamentCode) {
    code
    pickType
  }
}
    `;

/**
 * __usePickTypeForGameQuery__
 *
 * To run a query within a React component, call `usePickTypeForGameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickTypeForGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickTypeForGameQuery({
 *   variables: {
 *      tournamentCode: // value for 'tournamentCode'
 *   },
 * });
 */
export function usePickTypeForGameQuery(baseOptions: Apollo.QueryHookOptions<PickTypeForGameQuery, PickTypeForGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickTypeForGameQuery, PickTypeForGameQueryVariables>(PickTypeForGameDocument, options);
      }
export function usePickTypeForGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickTypeForGameQuery, PickTypeForGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickTypeForGameQuery, PickTypeForGameQueryVariables>(PickTypeForGameDocument, options);
        }
export type PickTypeForGameQueryHookResult = ReturnType<typeof usePickTypeForGameQuery>;
export type PickTypeForGameLazyQueryHookResult = ReturnType<typeof usePickTypeForGameLazyQuery>;
export type PickTypeForGameQueryResult = Apollo.QueryResult<PickTypeForGameQuery, PickTypeForGameQueryVariables>;
export function refetchPickTypeForGameQuery(variables: PickTypeForGameQueryVariables) {
      return { query: PickTypeForGameDocument, variables: variables }
    }
export const SetPickTypeForGameDocument = gql`
    mutation setPickTypeForGame($tournamentCode: String!, $pickType: RiotApiPickType!) {
  updateLobby(tournamentCode: $tournamentCode, input: {pickType: $pickType}) {
    success
  }
}
    `;
export type SetPickTypeForGameMutationFn = Apollo.MutationFunction<SetPickTypeForGameMutation, SetPickTypeForGameMutationVariables>;

/**
 * __useSetPickTypeForGameMutation__
 *
 * To run a mutation, you first call `useSetPickTypeForGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPickTypeForGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPickTypeForGameMutation, { data, loading, error }] = useSetPickTypeForGameMutation({
 *   variables: {
 *      tournamentCode: // value for 'tournamentCode'
 *      pickType: // value for 'pickType'
 *   },
 * });
 */
export function useSetPickTypeForGameMutation(baseOptions?: Apollo.MutationHookOptions<SetPickTypeForGameMutation, SetPickTypeForGameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPickTypeForGameMutation, SetPickTypeForGameMutationVariables>(SetPickTypeForGameDocument, options);
      }
export type SetPickTypeForGameMutationHookResult = ReturnType<typeof useSetPickTypeForGameMutation>;
export type SetPickTypeForGameMutationResult = Apollo.MutationResult<SetPickTypeForGameMutation>;
export type SetPickTypeForGameMutationOptions = Apollo.BaseMutationOptions<SetPickTypeForGameMutation, SetPickTypeForGameMutationVariables>;
export const UnlinkRiotAccountDocument = gql`
    mutation unlinkRiotAccount($puuid: String!) {
  unlinkRiotAccount(puuid: $puuid) {
    success
  }
}
    `;
export type UnlinkRiotAccountMutationFn = Apollo.MutationFunction<UnlinkRiotAccountMutation, UnlinkRiotAccountMutationVariables>;

/**
 * __useUnlinkRiotAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkRiotAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkRiotAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkRiotAccountMutation, { data, loading, error }] = useUnlinkRiotAccountMutation({
 *   variables: {
 *      puuid: // value for 'puuid'
 *   },
 * });
 */
export function useUnlinkRiotAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkRiotAccountMutation, UnlinkRiotAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkRiotAccountMutation, UnlinkRiotAccountMutationVariables>(UnlinkRiotAccountDocument, options);
      }
export type UnlinkRiotAccountMutationHookResult = ReturnType<typeof useUnlinkRiotAccountMutation>;
export type UnlinkRiotAccountMutationResult = Apollo.MutationResult<UnlinkRiotAccountMutation>;
export type UnlinkRiotAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkRiotAccountMutation, UnlinkRiotAccountMutationVariables>;
export const UpdateRiotAccountDocument = gql`
    mutation updateRiotAccount {
  updateRiotAccount {
    providerDisplayName
  }
}
    `;
export type UpdateRiotAccountMutationFn = Apollo.MutationFunction<UpdateRiotAccountMutation, UpdateRiotAccountMutationVariables>;

/**
 * __useUpdateRiotAccountMutation__
 *
 * To run a mutation, you first call `useUpdateRiotAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiotAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiotAccountMutation, { data, loading, error }] = useUpdateRiotAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateRiotAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiotAccountMutation, UpdateRiotAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiotAccountMutation, UpdateRiotAccountMutationVariables>(UpdateRiotAccountDocument, options);
      }
export type UpdateRiotAccountMutationHookResult = ReturnType<typeof useUpdateRiotAccountMutation>;
export type UpdateRiotAccountMutationResult = Apollo.MutationResult<UpdateRiotAccountMutation>;
export type UpdateRiotAccountMutationOptions = Apollo.BaseMutationOptions<UpdateRiotAccountMutation, UpdateRiotAccountMutationVariables>;
export const GetPossibleTeamRivalsDocument = gql`
    query getPossibleTeamRivals($input: GetPossibleTeamRivalsInput!) {
  getPossibleTeamRivals(input: $input) {
    seasonId
    results {
      ...PossibleTeamRival
    }
  }
}
    ${PossibleTeamRivalFragmentDoc}`;

/**
 * __useGetPossibleTeamRivalsQuery__
 *
 * To run a query within a React component, call `useGetPossibleTeamRivalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPossibleTeamRivalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPossibleTeamRivalsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPossibleTeamRivalsQuery(baseOptions: Apollo.QueryHookOptions<GetPossibleTeamRivalsQuery, GetPossibleTeamRivalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPossibleTeamRivalsQuery, GetPossibleTeamRivalsQueryVariables>(GetPossibleTeamRivalsDocument, options);
      }
export function useGetPossibleTeamRivalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPossibleTeamRivalsQuery, GetPossibleTeamRivalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPossibleTeamRivalsQuery, GetPossibleTeamRivalsQueryVariables>(GetPossibleTeamRivalsDocument, options);
        }
export type GetPossibleTeamRivalsQueryHookResult = ReturnType<typeof useGetPossibleTeamRivalsQuery>;
export type GetPossibleTeamRivalsLazyQueryHookResult = ReturnType<typeof useGetPossibleTeamRivalsLazyQuery>;
export type GetPossibleTeamRivalsQueryResult = Apollo.QueryResult<GetPossibleTeamRivalsQuery, GetPossibleTeamRivalsQueryVariables>;
export function refetchGetPossibleTeamRivalsQuery(variables: GetPossibleTeamRivalsQueryVariables) {
      return { query: GetPossibleTeamRivalsDocument, variables: variables }
    }
export const GetTeamRivalsDocument = gql`
    query getTeamRivals($teamId: UUID!, $seasonId: UUID!) {
  team(id: $teamId) {
    currentTeamRival(seasonId: $seasonId) {
      ...TeamRival
    }
    pendingTeamRivals(seasonId: $seasonId) {
      ...TeamRival
    }
    requestedTeamRivals(seasonId: $seasonId) {
      ...TeamRival
    }
  }
}
    ${TeamRivalFragmentDoc}`;

/**
 * __useGetTeamRivalsQuery__
 *
 * To run a query within a React component, call `useGetTeamRivalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamRivalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamRivalsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useGetTeamRivalsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamRivalsQuery, GetTeamRivalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamRivalsQuery, GetTeamRivalsQueryVariables>(GetTeamRivalsDocument, options);
      }
export function useGetTeamRivalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamRivalsQuery, GetTeamRivalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamRivalsQuery, GetTeamRivalsQueryVariables>(GetTeamRivalsDocument, options);
        }
export type GetTeamRivalsQueryHookResult = ReturnType<typeof useGetTeamRivalsQuery>;
export type GetTeamRivalsLazyQueryHookResult = ReturnType<typeof useGetTeamRivalsLazyQuery>;
export type GetTeamRivalsQueryResult = Apollo.QueryResult<GetTeamRivalsQuery, GetTeamRivalsQueryVariables>;
export function refetchGetTeamRivalsQuery(variables: GetTeamRivalsQueryVariables) {
      return { query: GetTeamRivalsDocument, variables: variables }
    }
export const RequestTeamRivalDocument = gql`
    mutation requestTeamRival($input: RequestTeamRivalInput!) {
  requestTeamRival(input: $input) {
    ...TeamRival
  }
}
    ${TeamRivalFragmentDoc}`;
export type RequestTeamRivalMutationFn = Apollo.MutationFunction<RequestTeamRivalMutation, RequestTeamRivalMutationVariables>;

/**
 * __useRequestTeamRivalMutation__
 *
 * To run a mutation, you first call `useRequestTeamRivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTeamRivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTeamRivalMutation, { data, loading, error }] = useRequestTeamRivalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestTeamRivalMutation(baseOptions?: Apollo.MutationHookOptions<RequestTeamRivalMutation, RequestTeamRivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTeamRivalMutation, RequestTeamRivalMutationVariables>(RequestTeamRivalDocument, options);
      }
export type RequestTeamRivalMutationHookResult = ReturnType<typeof useRequestTeamRivalMutation>;
export type RequestTeamRivalMutationResult = Apollo.MutationResult<RequestTeamRivalMutation>;
export type RequestTeamRivalMutationOptions = Apollo.BaseMutationOptions<RequestTeamRivalMutation, RequestTeamRivalMutationVariables>;
export const CancelTeamRivalDocument = gql`
    mutation cancelTeamRival($input: CancelTeamRivalInput!) {
  cancelTeamRival(input: $input) {
    ...TeamRival
  }
}
    ${TeamRivalFragmentDoc}`;
export type CancelTeamRivalMutationFn = Apollo.MutationFunction<CancelTeamRivalMutation, CancelTeamRivalMutationVariables>;

/**
 * __useCancelTeamRivalMutation__
 *
 * To run a mutation, you first call `useCancelTeamRivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTeamRivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTeamRivalMutation, { data, loading, error }] = useCancelTeamRivalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelTeamRivalMutation(baseOptions?: Apollo.MutationHookOptions<CancelTeamRivalMutation, CancelTeamRivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTeamRivalMutation, CancelTeamRivalMutationVariables>(CancelTeamRivalDocument, options);
      }
export type CancelTeamRivalMutationHookResult = ReturnType<typeof useCancelTeamRivalMutation>;
export type CancelTeamRivalMutationResult = Apollo.MutationResult<CancelTeamRivalMutation>;
export type CancelTeamRivalMutationOptions = Apollo.BaseMutationOptions<CancelTeamRivalMutation, CancelTeamRivalMutationVariables>;
export const AcceptTeamRivalDocument = gql`
    mutation acceptTeamRival($input: ResponseTeamRivalInput!) {
  acceptTeamRival(input: $input) {
    ...TeamRival
  }
}
    ${TeamRivalFragmentDoc}`;
export type AcceptTeamRivalMutationFn = Apollo.MutationFunction<AcceptTeamRivalMutation, AcceptTeamRivalMutationVariables>;

/**
 * __useAcceptTeamRivalMutation__
 *
 * To run a mutation, you first call `useAcceptTeamRivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTeamRivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTeamRivalMutation, { data, loading, error }] = useAcceptTeamRivalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptTeamRivalMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTeamRivalMutation, AcceptTeamRivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTeamRivalMutation, AcceptTeamRivalMutationVariables>(AcceptTeamRivalDocument, options);
      }
export type AcceptTeamRivalMutationHookResult = ReturnType<typeof useAcceptTeamRivalMutation>;
export type AcceptTeamRivalMutationResult = Apollo.MutationResult<AcceptTeamRivalMutation>;
export type AcceptTeamRivalMutationOptions = Apollo.BaseMutationOptions<AcceptTeamRivalMutation, AcceptTeamRivalMutationVariables>;
export const DenyTeamRivalDocument = gql`
    mutation denyTeamRival($input: ResponseTeamRivalInput!) {
  denyTeamRival(input: $input) {
    ...TeamRival
  }
}
    ${TeamRivalFragmentDoc}`;
export type DenyTeamRivalMutationFn = Apollo.MutationFunction<DenyTeamRivalMutation, DenyTeamRivalMutationVariables>;

/**
 * __useDenyTeamRivalMutation__
 *
 * To run a mutation, you first call `useDenyTeamRivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDenyTeamRivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [denyTeamRivalMutation, { data, loading, error }] = useDenyTeamRivalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDenyTeamRivalMutation(baseOptions?: Apollo.MutationHookOptions<DenyTeamRivalMutation, DenyTeamRivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DenyTeamRivalMutation, DenyTeamRivalMutationVariables>(DenyTeamRivalDocument, options);
      }
export type DenyTeamRivalMutationHookResult = ReturnType<typeof useDenyTeamRivalMutation>;
export type DenyTeamRivalMutationResult = Apollo.MutationResult<DenyTeamRivalMutation>;
export type DenyTeamRivalMutationOptions = Apollo.BaseMutationOptions<DenyTeamRivalMutation, DenyTeamRivalMutationVariables>;
export const RemoveTeamRivalDocument = gql`
    mutation removeTeamRival($input: RemoveTeamRivalInput!) {
  removeTeamRival(input: $input) {
    ...TeamRival
  }
}
    ${TeamRivalFragmentDoc}`;
export type RemoveTeamRivalMutationFn = Apollo.MutationFunction<RemoveTeamRivalMutation, RemoveTeamRivalMutationVariables>;

/**
 * __useRemoveTeamRivalMutation__
 *
 * To run a mutation, you first call `useRemoveTeamRivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamRivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamRivalMutation, { data, loading, error }] = useRemoveTeamRivalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTeamRivalMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamRivalMutation, RemoveTeamRivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamRivalMutation, RemoveTeamRivalMutationVariables>(RemoveTeamRivalDocument, options);
      }
export type RemoveTeamRivalMutationHookResult = ReturnType<typeof useRemoveTeamRivalMutation>;
export type RemoveTeamRivalMutationResult = Apollo.MutationResult<RemoveTeamRivalMutation>;
export type RemoveTeamRivalMutationOptions = Apollo.BaseMutationOptions<RemoveTeamRivalMutation, RemoveTeamRivalMutationVariables>;
export const TeamPlayersOnRosterDocument = gql`
    query teamPlayersOnRoster($id: UUID!) {
  team(id: $id) {
    id
    roster {
      teamId
      maxNumPlayers
      formats {
        teamSize
        substitutes {
          user {
            id
            name
            avatarUrl
            userProviderAccounts {
              id
              userId
              providerName
              providerAccountId
              providerDisplayName
              providerIntegrationType
            }
          }
        }
        starters {
          position {
            id
            index
            abbreviation
          }
          player {
            isCaptain
            effectiveAt
            user {
              id
              name
              avatarUrl
              userProviderAccounts {
                id
                userId
                providerName
                providerAccountId
                providerDisplayName
                providerIntegrationType
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTeamPlayersOnRosterQuery__
 *
 * To run a query within a React component, call `useTeamPlayersOnRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPlayersOnRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPlayersOnRosterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamPlayersOnRosterQuery(baseOptions: Apollo.QueryHookOptions<TeamPlayersOnRosterQuery, TeamPlayersOnRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamPlayersOnRosterQuery, TeamPlayersOnRosterQueryVariables>(TeamPlayersOnRosterDocument, options);
      }
export function useTeamPlayersOnRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamPlayersOnRosterQuery, TeamPlayersOnRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamPlayersOnRosterQuery, TeamPlayersOnRosterQueryVariables>(TeamPlayersOnRosterDocument, options);
        }
export type TeamPlayersOnRosterQueryHookResult = ReturnType<typeof useTeamPlayersOnRosterQuery>;
export type TeamPlayersOnRosterLazyQueryHookResult = ReturnType<typeof useTeamPlayersOnRosterLazyQuery>;
export type TeamPlayersOnRosterQueryResult = Apollo.QueryResult<TeamPlayersOnRosterQuery, TeamPlayersOnRosterQueryVariables>;
export function refetchTeamPlayersOnRosterQuery(variables: TeamPlayersOnRosterQueryVariables) {
      return { query: TeamPlayersOnRosterDocument, variables: variables }
    }
export const GetCoachAdditionalInfoDocument = gql`
    query getCoachAdditionalInfo($teamId: UUID!) {
  team(id: $teamId) {
    id
    coaches {
      id
      additionalInfo
    }
  }
}
    `;

/**
 * __useGetCoachAdditionalInfoQuery__
 *
 * To run a query within a React component, call `useGetCoachAdditionalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachAdditionalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachAdditionalInfoQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetCoachAdditionalInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCoachAdditionalInfoQuery, GetCoachAdditionalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachAdditionalInfoQuery, GetCoachAdditionalInfoQueryVariables>(GetCoachAdditionalInfoDocument, options);
      }
export function useGetCoachAdditionalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachAdditionalInfoQuery, GetCoachAdditionalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachAdditionalInfoQuery, GetCoachAdditionalInfoQueryVariables>(GetCoachAdditionalInfoDocument, options);
        }
export type GetCoachAdditionalInfoQueryHookResult = ReturnType<typeof useGetCoachAdditionalInfoQuery>;
export type GetCoachAdditionalInfoLazyQueryHookResult = ReturnType<typeof useGetCoachAdditionalInfoLazyQuery>;
export type GetCoachAdditionalInfoQueryResult = Apollo.QueryResult<GetCoachAdditionalInfoQuery, GetCoachAdditionalInfoQueryVariables>;
export function refetchGetCoachAdditionalInfoQuery(variables: GetCoachAdditionalInfoQueryVariables) {
      return { query: GetCoachAdditionalInfoDocument, variables: variables }
    }
export const TeamRosterDocument = gql`
    query teamRoster($id: UUID!, $metaseasonId: UUID, $effectiveAt: DateTime) {
  team(id: $id) {
    id
    avatarUrl
    competitionGroup
    schoolId
    school {
      id
    }
    isPlayerLed
    deletedAt
    esport {
      id
      slug
      rating
    }
    enrolledSeasons {
      id
      rostersLockAt
      name
      startsAt
      endsAt
      teamRegistrationEndsAt
      suggestedRegistrationEndsAt
      playerDeregistrationEndsAt
      teamDeregistrationEndsAt
      metaseason {
        id
        isPromoted
        startsAt
        name
        endsAt
      }
    }
    leagues(metaseasonId: $metaseasonId) {
      id
      competitionModel
      name
      displayName
      esportId
    }
    name
    roster(effectiveAt: $effectiveAt) {
      id
      teamId
      numPlayers
      maxNumPlayers
      players {
        isCaptain
        effectiveAt
        user {
          id
          lastSeen
          name
          avatarUrl
          userEsportPlatforms {
            platform
            platformUsername
          }
          directRoles {
            userId
            roleName
            resourceType
            resourceId
          }
          schoolRoleStatus {
            status
          }
        }
      }
      formats {
        teamSize
        starters {
          position {
            id
            index
            name
            abbreviation
            colloquial
          }
          player {
            effectiveAt
            isCaptain
            user {
              id
              name
              lastSeen
              avatarUrl
              directRoles {
                userId
                roleName
                resourceType
                resourceId
              }
              schoolRoleStatus {
                status
              }
              userProviderAccounts {
                id
                userId
                providerName
                providerAccountId
                providerDisplayName
                providerIntegrationType
              }
            }
          }
        }
        substitutes {
          isCaptain
          user {
            id
            name
            avatarUrl
            lastSeen
            directRoles {
              userId
              roleName
              resourceType
              resourceId
            }
            schoolRoleStatus {
              status
            }
            userProviderAccounts {
              id
              userId
              providerName
              providerAccountId
              providerDisplayName
              providerIntegrationType
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTeamRosterQuery__
 *
 * To run a query within a React component, call `useTeamRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamRosterQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *      effectiveAt: // value for 'effectiveAt'
 *   },
 * });
 */
export function useTeamRosterQuery(baseOptions: Apollo.QueryHookOptions<TeamRosterQuery, TeamRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamRosterQuery, TeamRosterQueryVariables>(TeamRosterDocument, options);
      }
export function useTeamRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamRosterQuery, TeamRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamRosterQuery, TeamRosterQueryVariables>(TeamRosterDocument, options);
        }
export type TeamRosterQueryHookResult = ReturnType<typeof useTeamRosterQuery>;
export type TeamRosterLazyQueryHookResult = ReturnType<typeof useTeamRosterLazyQuery>;
export type TeamRosterQueryResult = Apollo.QueryResult<TeamRosterQuery, TeamRosterQueryVariables>;
export function refetchTeamRosterQuery(variables: TeamRosterQueryVariables) {
      return { query: TeamRosterDocument, variables: variables }
    }
export const GetTeamRosterCoachesDocument = gql`
    query getTeamRosterCoaches($teamId: UUID!, $isPublic: Boolean!) {
  team(id: $teamId) {
    id
    coaches {
      id
      name
      firstName
      lastName
      lastSeen
      email @skip(if: $isPublic)
      phone @skip(if: $isPublic)
      phoneExt @skip(if: $isPublic)
      isPhoneNumberVisible
      avatarUrl
      directRoles {
        userId
        roleName
        resourceId
        resourceType
      }
    }
  }
}
    `;

/**
 * __useGetTeamRosterCoachesQuery__
 *
 * To run a query within a React component, call `useGetTeamRosterCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamRosterCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamRosterCoachesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      isPublic: // value for 'isPublic'
 *   },
 * });
 */
export function useGetTeamRosterCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetTeamRosterCoachesQuery, GetTeamRosterCoachesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamRosterCoachesQuery, GetTeamRosterCoachesQueryVariables>(GetTeamRosterCoachesDocument, options);
      }
export function useGetTeamRosterCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamRosterCoachesQuery, GetTeamRosterCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamRosterCoachesQuery, GetTeamRosterCoachesQueryVariables>(GetTeamRosterCoachesDocument, options);
        }
export type GetTeamRosterCoachesQueryHookResult = ReturnType<typeof useGetTeamRosterCoachesQuery>;
export type GetTeamRosterCoachesLazyQueryHookResult = ReturnType<typeof useGetTeamRosterCoachesLazyQuery>;
export type GetTeamRosterCoachesQueryResult = Apollo.QueryResult<GetTeamRosterCoachesQuery, GetTeamRosterCoachesQueryVariables>;
export function refetchGetTeamRosterCoachesQuery(variables: GetTeamRosterCoachesQueryVariables) {
      return { query: GetTeamRosterCoachesDocument, variables: variables }
    }
export const TeamRosterOwnerDocument = gql`
    query teamRosterOwner($role: RoleDescriptor!) {
  users(role: $role) {
    id
    name
    lastSeen
    avatarUrl
  }
}
    `;

/**
 * __useTeamRosterOwnerQuery__
 *
 * To run a query within a React component, call `useTeamRosterOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamRosterOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamRosterOwnerQuery({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useTeamRosterOwnerQuery(baseOptions: Apollo.QueryHookOptions<TeamRosterOwnerQuery, TeamRosterOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamRosterOwnerQuery, TeamRosterOwnerQueryVariables>(TeamRosterOwnerDocument, options);
      }
export function useTeamRosterOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamRosterOwnerQuery, TeamRosterOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamRosterOwnerQuery, TeamRosterOwnerQueryVariables>(TeamRosterOwnerDocument, options);
        }
export type TeamRosterOwnerQueryHookResult = ReturnType<typeof useTeamRosterOwnerQuery>;
export type TeamRosterOwnerLazyQueryHookResult = ReturnType<typeof useTeamRosterOwnerLazyQuery>;
export type TeamRosterOwnerQueryResult = Apollo.QueryResult<TeamRosterOwnerQuery, TeamRosterOwnerQueryVariables>;
export function refetchTeamRosterOwnerQuery(variables: TeamRosterOwnerQueryVariables) {
      return { query: TeamRosterOwnerDocument, variables: variables }
    }
export const GetOwnerToAddToTeamDocument = gql`
    query getOwnerToAddToTeam($id: UUID!) {
  team(id: $id) {
    id
    inviteUrl
    owners {
      id
      avatarUrl
      name
    }
    roster {
      teamId
      players {
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetOwnerToAddToTeamQuery__
 *
 * To run a query within a React component, call `useGetOwnerToAddToTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerToAddToTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerToAddToTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOwnerToAddToTeamQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerToAddToTeamQuery, GetOwnerToAddToTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerToAddToTeamQuery, GetOwnerToAddToTeamQueryVariables>(GetOwnerToAddToTeamDocument, options);
      }
export function useGetOwnerToAddToTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerToAddToTeamQuery, GetOwnerToAddToTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerToAddToTeamQuery, GetOwnerToAddToTeamQueryVariables>(GetOwnerToAddToTeamDocument, options);
        }
export type GetOwnerToAddToTeamQueryHookResult = ReturnType<typeof useGetOwnerToAddToTeamQuery>;
export type GetOwnerToAddToTeamLazyQueryHookResult = ReturnType<typeof useGetOwnerToAddToTeamLazyQuery>;
export type GetOwnerToAddToTeamQueryResult = Apollo.QueryResult<GetOwnerToAddToTeamQuery, GetOwnerToAddToTeamQueryVariables>;
export function refetchGetOwnerToAddToTeamQuery(variables: GetOwnerToAddToTeamQueryVariables) {
      return { query: GetOwnerToAddToTeamDocument, variables: variables }
    }
export const GetRosterRolesDocument = gql`
    query getRosterRoles {
  me {
    id
    roles {
      userId
      roleName
      resourceType
      resourceId
      status
    }
  }
}
    `;

/**
 * __useGetRosterRolesQuery__
 *
 * To run a query within a React component, call `useGetRosterRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRosterRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRosterRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRosterRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRosterRolesQuery, GetRosterRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRosterRolesQuery, GetRosterRolesQueryVariables>(GetRosterRolesDocument, options);
      }
export function useGetRosterRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRosterRolesQuery, GetRosterRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRosterRolesQuery, GetRosterRolesQueryVariables>(GetRosterRolesDocument, options);
        }
export type GetRosterRolesQueryHookResult = ReturnType<typeof useGetRosterRolesQuery>;
export type GetRosterRolesLazyQueryHookResult = ReturnType<typeof useGetRosterRolesLazyQuery>;
export type GetRosterRolesQueryResult = Apollo.QueryResult<GetRosterRolesQuery, GetRosterRolesQueryVariables>;
export function refetchGetRosterRolesQuery(variables?: GetRosterRolesQueryVariables) {
      return { query: GetRosterRolesDocument, variables: variables }
    }
export const GetMatchesByDateForScheduleDocument = gql`
    query getMatchesByDateForSchedule($id: UUID!, $teamIds: [UUID!]!, $after: DateTime, $before: DateTime, $limit: Int, $sort: SeasonTeamMatchSort) {
  season(id: $id) {
    id
    allTeamMatches(
      teamIds: $teamIds
      after: $after
      before: $before
      limit: $limit
      sort: $sort
    ) {
      id
      isScrimmage
      name
      slotId
      league {
        id
        competitionGroup
        competitionModel
      }
      slot {
        id
        phaseId
        startsAt
        phase {
          id
          type
          seasonId
          season {
            id
            metaseasonId
          }
        }
        status
      }
      status
      scheduledStartsAt
      esport {
        id
        slug
        name
      }
      teamContext {
        matchId
        teams {
          id
          isMyTeam
          school {
            id
          }
        }
      }
      matchResults {
        id
        matchId
        gamesWon
        gamesLost
        gamesTied
        team {
          id
          name
          school {
            id
            name
            logoUrl
            slug
          }
        }
      }
      scheduleContext
    }
  }
}
    `;

/**
 * __useGetMatchesByDateForScheduleQuery__
 *
 * To run a query within a React component, call `useGetMatchesByDateForScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchesByDateForScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchesByDateForScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      teamIds: // value for 'teamIds'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMatchesByDateForScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetMatchesByDateForScheduleQuery, GetMatchesByDateForScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchesByDateForScheduleQuery, GetMatchesByDateForScheduleQueryVariables>(GetMatchesByDateForScheduleDocument, options);
      }
export function useGetMatchesByDateForScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchesByDateForScheduleQuery, GetMatchesByDateForScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchesByDateForScheduleQuery, GetMatchesByDateForScheduleQueryVariables>(GetMatchesByDateForScheduleDocument, options);
        }
export type GetMatchesByDateForScheduleQueryHookResult = ReturnType<typeof useGetMatchesByDateForScheduleQuery>;
export type GetMatchesByDateForScheduleLazyQueryHookResult = ReturnType<typeof useGetMatchesByDateForScheduleLazyQuery>;
export type GetMatchesByDateForScheduleQueryResult = Apollo.QueryResult<GetMatchesByDateForScheduleQuery, GetMatchesByDateForScheduleQueryVariables>;
export function refetchGetMatchesByDateForScheduleQuery(variables: GetMatchesByDateForScheduleQueryVariables) {
      return { query: GetMatchesByDateForScheduleDocument, variables: variables }
    }
export const GetSlotsByMetaseasonIdDocument = gql`
    query getSlotsByMetaseasonId($id: UUID!) {
  getSlotsByMetaseasonId(id: $id) {
    id
    order
    phaseId
    startsAt
    status
  }
}
    `;

/**
 * __useGetSlotsByMetaseasonIdQuery__
 *
 * To run a query within a React component, call `useGetSlotsByMetaseasonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlotsByMetaseasonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlotsByMetaseasonIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSlotsByMetaseasonIdQuery(baseOptions: Apollo.QueryHookOptions<GetSlotsByMetaseasonIdQuery, GetSlotsByMetaseasonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlotsByMetaseasonIdQuery, GetSlotsByMetaseasonIdQueryVariables>(GetSlotsByMetaseasonIdDocument, options);
      }
export function useGetSlotsByMetaseasonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlotsByMetaseasonIdQuery, GetSlotsByMetaseasonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlotsByMetaseasonIdQuery, GetSlotsByMetaseasonIdQueryVariables>(GetSlotsByMetaseasonIdDocument, options);
        }
export type GetSlotsByMetaseasonIdQueryHookResult = ReturnType<typeof useGetSlotsByMetaseasonIdQuery>;
export type GetSlotsByMetaseasonIdLazyQueryHookResult = ReturnType<typeof useGetSlotsByMetaseasonIdLazyQuery>;
export type GetSlotsByMetaseasonIdQueryResult = Apollo.QueryResult<GetSlotsByMetaseasonIdQuery, GetSlotsByMetaseasonIdQueryVariables>;
export function refetchGetSlotsByMetaseasonIdQuery(variables: GetSlotsByMetaseasonIdQueryVariables) {
      return { query: GetSlotsByMetaseasonIdDocument, variables: variables }
    }
export const MyTeamsAndLeaguesDocument = gql`
    query myTeamsAndLeagues($metaseasonId: UUID!, $isCoach: Boolean!, $filters: TeamFiltersInput) {
  me @skip(if: $isCoach) {
    id
    leagues(metaseasonId: $metaseasonId) {
      id
    }
  }
  getTeams(filters: $filters) @include(if: $isCoach) {
    teams {
      id
      leagues(metaseasonId: $metaseasonId) {
        id
      }
    }
  }
}
    `;

/**
 * __useMyTeamsAndLeaguesQuery__
 *
 * To run a query within a React component, call `useMyTeamsAndLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsAndLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsAndLeaguesQuery({
 *   variables: {
 *      metaseasonId: // value for 'metaseasonId'
 *      isCoach: // value for 'isCoach'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMyTeamsAndLeaguesQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsAndLeaguesQuery, MyTeamsAndLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsAndLeaguesQuery, MyTeamsAndLeaguesQueryVariables>(MyTeamsAndLeaguesDocument, options);
      }
export function useMyTeamsAndLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsAndLeaguesQuery, MyTeamsAndLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsAndLeaguesQuery, MyTeamsAndLeaguesQueryVariables>(MyTeamsAndLeaguesDocument, options);
        }
export type MyTeamsAndLeaguesQueryHookResult = ReturnType<typeof useMyTeamsAndLeaguesQuery>;
export type MyTeamsAndLeaguesLazyQueryHookResult = ReturnType<typeof useMyTeamsAndLeaguesLazyQuery>;
export type MyTeamsAndLeaguesQueryResult = Apollo.QueryResult<MyTeamsAndLeaguesQuery, MyTeamsAndLeaguesQueryVariables>;
export function refetchMyTeamsAndLeaguesQuery(variables: MyTeamsAndLeaguesQueryVariables) {
      return { query: MyTeamsAndLeaguesDocument, variables: variables }
    }
export const GetSchoolDetailsDocument = gql`
    query getSchoolDetails($id: UUID!) {
  school(id: $id) {
    id
    detail {
      at
      it {
        osType
        suppStaff {
          email
          fname
          lname
          phone
        }
        hasDedicatedLab
        numStudentComps
        suppStaffOnCampus
        publicIP
        agreeToInstallGames
        agreeToWhitelistPorts
        agreeToDoPatchUpdates
      }
    }
    address
    allowCaptainEnrollment
    allowPlayerLedTeams
    showCoachEmails
    name
    slug
    city
    state
    zip
    phone
    ncesId
    mascotName
    logoUrl
    whoPays
    type
    competitionGroup
    createdAt
    deletedAt
    timezone
    districtClassification
    dismissalTime
  }
}
    `;

/**
 * __useGetSchoolDetailsQuery__
 *
 * To run a query within a React component, call `useGetSchoolDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSchoolDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolDetailsQuery, GetSchoolDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolDetailsQuery, GetSchoolDetailsQueryVariables>(GetSchoolDetailsDocument, options);
      }
export function useGetSchoolDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolDetailsQuery, GetSchoolDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolDetailsQuery, GetSchoolDetailsQueryVariables>(GetSchoolDetailsDocument, options);
        }
export type GetSchoolDetailsQueryHookResult = ReturnType<typeof useGetSchoolDetailsQuery>;
export type GetSchoolDetailsLazyQueryHookResult = ReturnType<typeof useGetSchoolDetailsLazyQuery>;
export type GetSchoolDetailsQueryResult = Apollo.QueryResult<GetSchoolDetailsQuery, GetSchoolDetailsQueryVariables>;
export function refetchGetSchoolDetailsQuery(variables: GetSchoolDetailsQueryVariables) {
      return { query: GetSchoolDetailsDocument, variables: variables }
    }
export const SelectedOrganizationDocument = gql`
    query selectedOrganization($id: UUID!) {
  school(id: $id) {
    id
    competitionGroup
    country
  }
}
    `;

/**
 * __useSelectedOrganizationQuery__
 *
 * To run a query within a React component, call `useSelectedOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectedOrganizationQuery(baseOptions: Apollo.QueryHookOptions<SelectedOrganizationQuery, SelectedOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedOrganizationQuery, SelectedOrganizationQueryVariables>(SelectedOrganizationDocument, options);
      }
export function useSelectedOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedOrganizationQuery, SelectedOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedOrganizationQuery, SelectedOrganizationQueryVariables>(SelectedOrganizationDocument, options);
        }
export type SelectedOrganizationQueryHookResult = ReturnType<typeof useSelectedOrganizationQuery>;
export type SelectedOrganizationLazyQueryHookResult = ReturnType<typeof useSelectedOrganizationLazyQuery>;
export type SelectedOrganizationQueryResult = Apollo.QueryResult<SelectedOrganizationQuery, SelectedOrganizationQueryVariables>;
export function refetchSelectedOrganizationQuery(variables: SelectedOrganizationQueryVariables) {
      return { query: SelectedOrganizationDocument, variables: variables }
    }
export const GetSchoolPreviewDocument = gql`
    query getSchoolPreview($schoolId: UUID!) {
  school(id: $schoolId) {
    id
    name
    logoUrl
    city
    state
    zip
    coaches {
      id
    }
    teams {
      id
    }
    playerCount
  }
}
    `;

/**
 * __useGetSchoolPreviewQuery__
 *
 * To run a query within a React component, call `useGetSchoolPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolPreviewQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolPreviewQuery, GetSchoolPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolPreviewQuery, GetSchoolPreviewQueryVariables>(GetSchoolPreviewDocument, options);
      }
export function useGetSchoolPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolPreviewQuery, GetSchoolPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolPreviewQuery, GetSchoolPreviewQueryVariables>(GetSchoolPreviewDocument, options);
        }
export type GetSchoolPreviewQueryHookResult = ReturnType<typeof useGetSchoolPreviewQuery>;
export type GetSchoolPreviewLazyQueryHookResult = ReturnType<typeof useGetSchoolPreviewLazyQuery>;
export type GetSchoolPreviewQueryResult = Apollo.QueryResult<GetSchoolPreviewQuery, GetSchoolPreviewQueryVariables>;
export function refetchGetSchoolPreviewQuery(variables: GetSchoolPreviewQueryVariables) {
      return { query: GetSchoolPreviewDocument, variables: variables }
    }
export const GetSchoolTypeDocument = gql`
    query getSchoolType($schoolId: UUID!) {
  school(id: $schoolId) {
    type
  }
}
    `;

/**
 * __useGetSchoolTypeQuery__
 *
 * To run a query within a React component, call `useGetSchoolTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolTypeQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolTypeQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolTypeQuery, GetSchoolTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolTypeQuery, GetSchoolTypeQueryVariables>(GetSchoolTypeDocument, options);
      }
export function useGetSchoolTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolTypeQuery, GetSchoolTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolTypeQuery, GetSchoolTypeQueryVariables>(GetSchoolTypeDocument, options);
        }
export type GetSchoolTypeQueryHookResult = ReturnType<typeof useGetSchoolTypeQuery>;
export type GetSchoolTypeLazyQueryHookResult = ReturnType<typeof useGetSchoolTypeLazyQuery>;
export type GetSchoolTypeQueryResult = Apollo.QueryResult<GetSchoolTypeQuery, GetSchoolTypeQueryVariables>;
export function refetchGetSchoolTypeQuery(variables: GetSchoolTypeQueryVariables) {
      return { query: GetSchoolTypeDocument, variables: variables }
    }
export const UpdateSchoolProfile2Document = gql`
    mutation updateSchoolProfile2($schoolId: UUID!, $input: SetSchoolProfileInput!) {
  updateSchoolProfile(schoolId: $schoolId, input: $input) {
    id
    mascotName
    name
    whoPays
    address
    phone
    type
  }
}
    `;
export type UpdateSchoolProfile2MutationFn = Apollo.MutationFunction<UpdateSchoolProfile2Mutation, UpdateSchoolProfile2MutationVariables>;

/**
 * __useUpdateSchoolProfile2Mutation__
 *
 * To run a mutation, you first call `useUpdateSchoolProfile2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolProfile2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolProfile2Mutation, { data, loading, error }] = useUpdateSchoolProfile2Mutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSchoolProfile2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchoolProfile2Mutation, UpdateSchoolProfile2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchoolProfile2Mutation, UpdateSchoolProfile2MutationVariables>(UpdateSchoolProfile2Document, options);
      }
export type UpdateSchoolProfile2MutationHookResult = ReturnType<typeof useUpdateSchoolProfile2Mutation>;
export type UpdateSchoolProfile2MutationResult = Apollo.MutationResult<UpdateSchoolProfile2Mutation>;
export type UpdateSchoolProfile2MutationOptions = Apollo.BaseMutationOptions<UpdateSchoolProfile2Mutation, UpdateSchoolProfile2MutationVariables>;
export const UpdateSchoolDetailsDocument = gql`
    mutation updateSchoolDetails($schoolId: UUID!, $detail: SchoolDetailInput!) {
  updateSchoolDetail(schoolId: $schoolId, detail: $detail) {
    id
    detail {
      at
      it {
        osType
        suppStaff {
          email
          fname
          lname
          phone
        }
        publicIP
      }
    }
  }
}
    `;
export type UpdateSchoolDetailsMutationFn = Apollo.MutationFunction<UpdateSchoolDetailsMutation, UpdateSchoolDetailsMutationVariables>;

/**
 * __useUpdateSchoolDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolDetailsMutation, { data, loading, error }] = useUpdateSchoolDetailsMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      detail: // value for 'detail'
 *   },
 * });
 */
export function useUpdateSchoolDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchoolDetailsMutation, UpdateSchoolDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchoolDetailsMutation, UpdateSchoolDetailsMutationVariables>(UpdateSchoolDetailsDocument, options);
      }
export type UpdateSchoolDetailsMutationHookResult = ReturnType<typeof useUpdateSchoolDetailsMutation>;
export type UpdateSchoolDetailsMutationResult = Apollo.MutationResult<UpdateSchoolDetailsMutation>;
export type UpdateSchoolDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateSchoolDetailsMutation, UpdateSchoolDetailsMutationVariables>;
export const GetSchoolDocument = gql`
    query getSchool($id: UUID!) {
  school(id: $id) {
    id
    slug
    name
    city
    state
    zip
    whoPays
    type
    logoUrl
    deletedAt
    coachRolePendingUsers {
      id
      email
      name
      phone
    }
    teams: teamsIncludingDeleted {
      id
      name
      esport {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSchoolQuery__
 *
 * To run a query within a React component, call `useGetSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSchoolQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolQuery, GetSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolQuery, GetSchoolQueryVariables>(GetSchoolDocument, options);
      }
export function useGetSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolQuery, GetSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolQuery, GetSchoolQueryVariables>(GetSchoolDocument, options);
        }
export type GetSchoolQueryHookResult = ReturnType<typeof useGetSchoolQuery>;
export type GetSchoolLazyQueryHookResult = ReturnType<typeof useGetSchoolLazyQuery>;
export type GetSchoolQueryResult = Apollo.QueryResult<GetSchoolQuery, GetSchoolQueryVariables>;
export function refetchGetSchoolQuery(variables: GetSchoolQueryVariables) {
      return { query: GetSchoolDocument, variables: variables }
    }
export const GetSchoolNameDocument = gql`
    query getSchoolName($id: UUID!) {
  school(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetSchoolNameQuery__
 *
 * To run a query within a React component, call `useGetSchoolNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSchoolNameQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolNameQuery, GetSchoolNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolNameQuery, GetSchoolNameQueryVariables>(GetSchoolNameDocument, options);
      }
export function useGetSchoolNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolNameQuery, GetSchoolNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolNameQuery, GetSchoolNameQueryVariables>(GetSchoolNameDocument, options);
        }
export type GetSchoolNameQueryHookResult = ReturnType<typeof useGetSchoolNameQuery>;
export type GetSchoolNameLazyQueryHookResult = ReturnType<typeof useGetSchoolNameLazyQuery>;
export type GetSchoolNameQueryResult = Apollo.QueryResult<GetSchoolNameQuery, GetSchoolNameQueryVariables>;
export function refetchGetSchoolNameQuery(variables: GetSchoolNameQueryVariables) {
      return { query: GetSchoolNameDocument, variables: variables }
    }
export const GetPublicSchoolDocument = gql`
    query getPublicSchool($id: UUID!) {
  school(id: $id) {
    id
    name
    slug
    city
    state
    zip
    logoUrl
    competitionGroup
    twitchUrl
    twitchUsername
    schoolProviderAccounts {
      id
      schoolId
      providerName
      providerAccountId
      providerDisplayName
      providerIntegrationType
    }
    teams {
      id
      name
      deletedAt
      esport {
        id
        name
        slug
        rating
      }
    }
    getLatestEnrolledMetaseason {
      id
    }
  }
}
    `;

/**
 * __useGetPublicSchoolQuery__
 *
 * To run a query within a React component, call `useGetPublicSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicSchoolQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPublicSchoolQuery(baseOptions: Apollo.QueryHookOptions<GetPublicSchoolQuery, GetPublicSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicSchoolQuery, GetPublicSchoolQueryVariables>(GetPublicSchoolDocument, options);
      }
export function useGetPublicSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicSchoolQuery, GetPublicSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicSchoolQuery, GetPublicSchoolQueryVariables>(GetPublicSchoolDocument, options);
        }
export type GetPublicSchoolQueryHookResult = ReturnType<typeof useGetPublicSchoolQuery>;
export type GetPublicSchoolLazyQueryHookResult = ReturnType<typeof useGetPublicSchoolLazyQuery>;
export type GetPublicSchoolQueryResult = Apollo.QueryResult<GetPublicSchoolQuery, GetPublicSchoolQueryVariables>;
export function refetchGetPublicSchoolQuery(variables: GetPublicSchoolQueryVariables) {
      return { query: GetPublicSchoolDocument, variables: variables }
    }
export const GetSchoolTeamIdsDocument = gql`
    query getSchoolTeamIds($id: UUID!) {
  school(id: $id) {
    teams {
      id
    }
  }
}
    `;

/**
 * __useGetSchoolTeamIdsQuery__
 *
 * To run a query within a React component, call `useGetSchoolTeamIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolTeamIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolTeamIdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSchoolTeamIdsQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolTeamIdsQuery, GetSchoolTeamIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolTeamIdsQuery, GetSchoolTeamIdsQueryVariables>(GetSchoolTeamIdsDocument, options);
      }
export function useGetSchoolTeamIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolTeamIdsQuery, GetSchoolTeamIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolTeamIdsQuery, GetSchoolTeamIdsQueryVariables>(GetSchoolTeamIdsDocument, options);
        }
export type GetSchoolTeamIdsQueryHookResult = ReturnType<typeof useGetSchoolTeamIdsQuery>;
export type GetSchoolTeamIdsLazyQueryHookResult = ReturnType<typeof useGetSchoolTeamIdsLazyQuery>;
export type GetSchoolTeamIdsQueryResult = Apollo.QueryResult<GetSchoolTeamIdsQuery, GetSchoolTeamIdsQueryVariables>;
export function refetchGetSchoolTeamIdsQuery(variables: GetSchoolTeamIdsQueryVariables) {
      return { query: GetSchoolTeamIdsDocument, variables: variables }
    }
export const GetUsersForSchoolDocument = gql`
    query getUsersForSchool($schoolId: String!, $roles: [UserRoleName!]!, $name: String) {
  getUsers(
    limit: 1000
    offset: 0
    filters: {roleNames: $roles, schoolId: $schoolId, name: $name}
  ) {
    totalCount
    users {
      id
      name
      firstName
      lastName
      avatarUrl
      userProviderAccounts {
        id
        userId
        providerName
        providerAccountId
        providerDisplayName
        providerIntegrationType
      }
      phone
      phoneExt
      emails {
        email
        isVerified
        isSchoolEmail
      }
      roles {
        roleName
        resourceId
        resourceType
        userId
      }
      schoolRoleStatus {
        role {
          userId
          roleName
          resourceType
          resourceId
        }
        status
      }
    }
  }
  getUsersWithPendingRoles(
    limit: 100
    offset: 0
    filters: {roles: $roles, schoolId: $schoolId, firstName: $name, lastName: $name}
  ) {
    totalCount
    users {
      id
      name
      avatarUrl
      userProviderAccounts {
        id
        userId
        providerName
        providerAccountId
        providerDisplayName
        providerIntegrationType
      }
      phone
      email
      emails {
        email
        isSchoolEmail
        isVerified
      }
      roles {
        roleName
        resourceId
        resourceType
        userId
      }
      roleRequests {
        status
        roleName
        resourceId
        resourceType
      }
      schoolRoleStatus {
        role {
          userId
          roleName
          resourceType
          resourceId
        }
        status
      }
    }
  }
}
    `;

/**
 * __useGetUsersForSchoolQuery__
 *
 * To run a query within a React component, call `useGetUsersForSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersForSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersForSchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      roles: // value for 'roles'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetUsersForSchoolQuery(baseOptions: Apollo.QueryHookOptions<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>(GetUsersForSchoolDocument, options);
      }
export function useGetUsersForSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>(GetUsersForSchoolDocument, options);
        }
export type GetUsersForSchoolQueryHookResult = ReturnType<typeof useGetUsersForSchoolQuery>;
export type GetUsersForSchoolLazyQueryHookResult = ReturnType<typeof useGetUsersForSchoolLazyQuery>;
export type GetUsersForSchoolQueryResult = Apollo.QueryResult<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>;
export function refetchGetUsersForSchoolQuery(variables: GetUsersForSchoolQueryVariables) {
      return { query: GetUsersForSchoolDocument, variables: variables }
    }
export const GetLeagueGroupsForSchoolDocument = gql`
    query getLeagueGroupsForSchool($id: UUID!, $metaseasonId: UUID!) {
  school(id: $id) {
    id
    competitionGroup
    leagueGroups(metaseasonId: $metaseasonId) {
      id
    }
  }
  getActiveLeaguesBySchoolId(schoolId: $id, metaseasonId: $metaseasonId) {
    id
    name
    displayName
    state
    competitionModel
    isHidden
    seasons {
      id
      metaseasonId
      registrationStartsAt
      teamRegistrationEndsAt
      teamDeregistrationEndsAt
      suggestedRegistrationEndsAt
    }
    varsityAssociation {
      name
    }
    esport {
      id
      slug
      name
    }
  }
}
    `;

/**
 * __useGetLeagueGroupsForSchoolQuery__
 *
 * To run a query within a React component, call `useGetLeagueGroupsForSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueGroupsForSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueGroupsForSchoolQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetLeagueGroupsForSchoolQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueGroupsForSchoolQuery, GetLeagueGroupsForSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueGroupsForSchoolQuery, GetLeagueGroupsForSchoolQueryVariables>(GetLeagueGroupsForSchoolDocument, options);
      }
export function useGetLeagueGroupsForSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueGroupsForSchoolQuery, GetLeagueGroupsForSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueGroupsForSchoolQuery, GetLeagueGroupsForSchoolQueryVariables>(GetLeagueGroupsForSchoolDocument, options);
        }
export type GetLeagueGroupsForSchoolQueryHookResult = ReturnType<typeof useGetLeagueGroupsForSchoolQuery>;
export type GetLeagueGroupsForSchoolLazyQueryHookResult = ReturnType<typeof useGetLeagueGroupsForSchoolLazyQuery>;
export type GetLeagueGroupsForSchoolQueryResult = Apollo.QueryResult<GetLeagueGroupsForSchoolQuery, GetLeagueGroupsForSchoolQueryVariables>;
export function refetchGetLeagueGroupsForSchoolQuery(variables: GetLeagueGroupsForSchoolQueryVariables) {
      return { query: GetLeagueGroupsForSchoolDocument, variables: variables }
    }
export const GetAllLeagueGroupsForSchoolDocument = gql`
    query getAllLeagueGroupsForSchool($id: UUID!, $metaseasonId: UUID!) {
  school(id: $id) {
    id
    competitionGroup
    leagueGroups(metaseasonId: $metaseasonId) {
      id
    }
  }
  getLeaguesBySchoolId(schoolId: $id) {
    id
    name
    displayName
    state
    competitionModel
    isHidden
    seasons {
      id
      metaseasonId
      registrationStartsAt
      teamRegistrationEndsAt
      teamDeregistrationEndsAt
      suggestedRegistrationEndsAt
    }
    varsityAssociation {
      name
    }
    esport {
      id
      slug
      name
    }
  }
}
    `;

/**
 * __useGetAllLeagueGroupsForSchoolQuery__
 *
 * To run a query within a React component, call `useGetAllLeagueGroupsForSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLeagueGroupsForSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLeagueGroupsForSchoolQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetAllLeagueGroupsForSchoolQuery(baseOptions: Apollo.QueryHookOptions<GetAllLeagueGroupsForSchoolQuery, GetAllLeagueGroupsForSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLeagueGroupsForSchoolQuery, GetAllLeagueGroupsForSchoolQueryVariables>(GetAllLeagueGroupsForSchoolDocument, options);
      }
export function useGetAllLeagueGroupsForSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLeagueGroupsForSchoolQuery, GetAllLeagueGroupsForSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLeagueGroupsForSchoolQuery, GetAllLeagueGroupsForSchoolQueryVariables>(GetAllLeagueGroupsForSchoolDocument, options);
        }
export type GetAllLeagueGroupsForSchoolQueryHookResult = ReturnType<typeof useGetAllLeagueGroupsForSchoolQuery>;
export type GetAllLeagueGroupsForSchoolLazyQueryHookResult = ReturnType<typeof useGetAllLeagueGroupsForSchoolLazyQuery>;
export type GetAllLeagueGroupsForSchoolQueryResult = Apollo.QueryResult<GetAllLeagueGroupsForSchoolQuery, GetAllLeagueGroupsForSchoolQueryVariables>;
export function refetchGetAllLeagueGroupsForSchoolQuery(variables: GetAllLeagueGroupsForSchoolQueryVariables) {
      return { query: GetAllLeagueGroupsForSchoolDocument, variables: variables }
    }
export const GetAllSchoolTeamsDocument = gql`
    query getAllSchoolTeams($id: UUID!, $date: DateTime!) {
  school(id: $id) {
    id
    competitionGroup
    logoUrl
    teams: teamsIncludingDeleted {
      id
      name
      isPlayerLed
      deletedAt
      deletedBy {
        id
        name
        avatarUrl
        roles {
          userId
          roleName
          resourceId
          resourceType
        }
      }
      enrolledSeasons {
        id
        metaseasonId
      }
      esport {
        id
        slug
        leagueDefaults {
          teamFormat
        }
      }
      roster(effectiveAt: $date) {
        id
        players {
          isCaptain
          user {
            id
            name
            avatarUrl
          }
          effectiveAt
          teamId
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllSchoolTeamsQuery__
 *
 * To run a query within a React component, call `useGetAllSchoolTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSchoolTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSchoolTeamsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetAllSchoolTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetAllSchoolTeamsQuery, GetAllSchoolTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSchoolTeamsQuery, GetAllSchoolTeamsQueryVariables>(GetAllSchoolTeamsDocument, options);
      }
export function useGetAllSchoolTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSchoolTeamsQuery, GetAllSchoolTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSchoolTeamsQuery, GetAllSchoolTeamsQueryVariables>(GetAllSchoolTeamsDocument, options);
        }
export type GetAllSchoolTeamsQueryHookResult = ReturnType<typeof useGetAllSchoolTeamsQuery>;
export type GetAllSchoolTeamsLazyQueryHookResult = ReturnType<typeof useGetAllSchoolTeamsLazyQuery>;
export type GetAllSchoolTeamsQueryResult = Apollo.QueryResult<GetAllSchoolTeamsQuery, GetAllSchoolTeamsQueryVariables>;
export function refetchGetAllSchoolTeamsQuery(variables: GetAllSchoolTeamsQueryVariables) {
      return { query: GetAllSchoolTeamsDocument, variables: variables }
    }
export const GetPublicSchoolTeamRecordsDocument = gql`
    query getPublicSchoolTeamRecords($schoolSlug: String!) {
  getSchoolBySlug(slug: $schoolSlug) {
    id
    logoUrl
    competitionGroup
    name
    teams {
      id
      name
      getCurrentMetaseasonTeamPhaseStandings {
        phaseId
        winLossRecord {
          matchesWon
          matchesLost
          matchesTied
        }
        ranking
      }
      isEnrolledInCurrentMetaseason
      esport {
        id
        rating
      }
    }
    getLatestEnrolledMetaseason {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPublicSchoolTeamRecordsQuery__
 *
 * To run a query within a React component, call `useGetPublicSchoolTeamRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicSchoolTeamRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicSchoolTeamRecordsQuery({
 *   variables: {
 *      schoolSlug: // value for 'schoolSlug'
 *   },
 * });
 */
export function useGetPublicSchoolTeamRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetPublicSchoolTeamRecordsQuery, GetPublicSchoolTeamRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicSchoolTeamRecordsQuery, GetPublicSchoolTeamRecordsQueryVariables>(GetPublicSchoolTeamRecordsDocument, options);
      }
export function useGetPublicSchoolTeamRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicSchoolTeamRecordsQuery, GetPublicSchoolTeamRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicSchoolTeamRecordsQuery, GetPublicSchoolTeamRecordsQueryVariables>(GetPublicSchoolTeamRecordsDocument, options);
        }
export type GetPublicSchoolTeamRecordsQueryHookResult = ReturnType<typeof useGetPublicSchoolTeamRecordsQuery>;
export type GetPublicSchoolTeamRecordsLazyQueryHookResult = ReturnType<typeof useGetPublicSchoolTeamRecordsLazyQuery>;
export type GetPublicSchoolTeamRecordsQueryResult = Apollo.QueryResult<GetPublicSchoolTeamRecordsQuery, GetPublicSchoolTeamRecordsQueryVariables>;
export function refetchGetPublicSchoolTeamRecordsQuery(variables: GetPublicSchoolTeamRecordsQueryVariables) {
      return { query: GetPublicSchoolTeamRecordsDocument, variables: variables }
    }
export const GetMySchoolTeamRecordsDocument = gql`
    query getMySchoolTeamRecords {
  me {
    id
    school {
      id
      name
      logoUrl
      competitionGroup
      teams {
        id
        name
        getCurrentMetaseasonTeamPhaseStandings {
          phaseId
          winLossRecord {
            matchesWon
            matchesLost
            matchesTied
          }
          ranking
        }
        isEnrolledInCurrentMetaseason
        esport {
          id
          rating
        }
      }
      getLatestEnrolledMetaseason {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetMySchoolTeamRecordsQuery__
 *
 * To run a query within a React component, call `useGetMySchoolTeamRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySchoolTeamRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySchoolTeamRecordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySchoolTeamRecordsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySchoolTeamRecordsQuery, GetMySchoolTeamRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySchoolTeamRecordsQuery, GetMySchoolTeamRecordsQueryVariables>(GetMySchoolTeamRecordsDocument, options);
      }
export function useGetMySchoolTeamRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySchoolTeamRecordsQuery, GetMySchoolTeamRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySchoolTeamRecordsQuery, GetMySchoolTeamRecordsQueryVariables>(GetMySchoolTeamRecordsDocument, options);
        }
export type GetMySchoolTeamRecordsQueryHookResult = ReturnType<typeof useGetMySchoolTeamRecordsQuery>;
export type GetMySchoolTeamRecordsLazyQueryHookResult = ReturnType<typeof useGetMySchoolTeamRecordsLazyQuery>;
export type GetMySchoolTeamRecordsQueryResult = Apollo.QueryResult<GetMySchoolTeamRecordsQuery, GetMySchoolTeamRecordsQueryVariables>;
export function refetchGetMySchoolTeamRecordsQuery(variables?: GetMySchoolTeamRecordsQueryVariables) {
      return { query: GetMySchoolTeamRecordsDocument, variables: variables }
    }
export const GetRosterAcrossAllTeamsDocument = gql`
    query getRosterAcrossAllTeams($id: UUID!, $isPublic: Boolean!) {
  school(id: $id) {
    id
    showCoachEmails @skip(if: $isPublic)
    coaches {
      id
      name
      emails @skip(if: $isPublic) {
        email
        isSchoolEmail
      }
      avatarUrl
      teamsWherePrimaryCoach(schoolId: $id) {
        id
        name
      }
    }
    players {
      id
      name
      avatarUrl
    }
  }
}
    `;

/**
 * __useGetRosterAcrossAllTeamsQuery__
 *
 * To run a query within a React component, call `useGetRosterAcrossAllTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRosterAcrossAllTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRosterAcrossAllTeamsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isPublic: // value for 'isPublic'
 *   },
 * });
 */
export function useGetRosterAcrossAllTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetRosterAcrossAllTeamsQuery, GetRosterAcrossAllTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRosterAcrossAllTeamsQuery, GetRosterAcrossAllTeamsQueryVariables>(GetRosterAcrossAllTeamsDocument, options);
      }
export function useGetRosterAcrossAllTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRosterAcrossAllTeamsQuery, GetRosterAcrossAllTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRosterAcrossAllTeamsQuery, GetRosterAcrossAllTeamsQueryVariables>(GetRosterAcrossAllTeamsDocument, options);
        }
export type GetRosterAcrossAllTeamsQueryHookResult = ReturnType<typeof useGetRosterAcrossAllTeamsQuery>;
export type GetRosterAcrossAllTeamsLazyQueryHookResult = ReturnType<typeof useGetRosterAcrossAllTeamsLazyQuery>;
export type GetRosterAcrossAllTeamsQueryResult = Apollo.QueryResult<GetRosterAcrossAllTeamsQuery, GetRosterAcrossAllTeamsQueryVariables>;
export function refetchGetRosterAcrossAllTeamsQuery(variables: GetRosterAcrossAllTeamsQueryVariables) {
      return { query: GetRosterAcrossAllTeamsDocument, variables: variables }
    }
export const GetSchoolScrimmagesDocument = gql`
    query getSchoolScrimmages($id: UUID!, $past: Boolean, $filter: ScrimmageRequestFilter, $offset: Int!, $limit: Int!) {
  school(id: $id) {
    id
    name
    myScrimmageRequests(
      filter: $filter
      past: $past
      offset: $offset
      limit: $limit
    ) {
      total
      result {
        id
        league {
          id
          timezone
        }
        requestingTeam {
          id
          name
          school {
            id
            name
            logoUrl
            slug
          }
        }
        opposingTeam {
          id
          name
          school {
            id
            name
            logoUrl
            slug
          }
        }
        esport {
          id
          slug
          rating
          name
        }
        status
        startsAt
        bestOf
        esportId
        requestingTeamId
        requestedById
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetSchoolScrimmagesQuery__
 *
 * To run a query within a React component, call `useGetSchoolScrimmagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolScrimmagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolScrimmagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      past: // value for 'past'
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSchoolScrimmagesQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolScrimmagesQuery, GetSchoolScrimmagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolScrimmagesQuery, GetSchoolScrimmagesQueryVariables>(GetSchoolScrimmagesDocument, options);
      }
export function useGetSchoolScrimmagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolScrimmagesQuery, GetSchoolScrimmagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolScrimmagesQuery, GetSchoolScrimmagesQueryVariables>(GetSchoolScrimmagesDocument, options);
        }
export type GetSchoolScrimmagesQueryHookResult = ReturnType<typeof useGetSchoolScrimmagesQuery>;
export type GetSchoolScrimmagesLazyQueryHookResult = ReturnType<typeof useGetSchoolScrimmagesLazyQuery>;
export type GetSchoolScrimmagesQueryResult = Apollo.QueryResult<GetSchoolScrimmagesQuery, GetSchoolScrimmagesQueryVariables>;
export function refetchGetSchoolScrimmagesQuery(variables: GetSchoolScrimmagesQueryVariables) {
      return { query: GetSchoolScrimmagesDocument, variables: variables }
    }
export const GetSchoolRecommendedScrimmagesDocument = gql`
    query getSchoolRecommendedScrimmages($id: UUID!, $offset: Int!, $limit: Int!, $filter: ScrimmageRequestFilter, $teamId: UUID!) {
  school(id: $id) {
    id
    name
    availableScrimmageRequests(offset: $offset, limit: $limit, filter: $filter) {
      total
      result {
        id
        requestingTeam {
          id
          name
          competitionGroup
          school {
            id
            name
            logoUrl
            slug
          }
          recommendationPercent(teamId: $teamId)
        }
        league {
          id
          name
          state
          timezone
        }
        esport {
          id
          slug
          rating
        }
        status
        startsAt
        bestOf
        rating
        esportId
        requestingTeamId
        requestedById
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetSchoolRecommendedScrimmagesQuery__
 *
 * To run a query within a React component, call `useGetSchoolRecommendedScrimmagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolRecommendedScrimmagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolRecommendedScrimmagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetSchoolRecommendedScrimmagesQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolRecommendedScrimmagesQuery, GetSchoolRecommendedScrimmagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolRecommendedScrimmagesQuery, GetSchoolRecommendedScrimmagesQueryVariables>(GetSchoolRecommendedScrimmagesDocument, options);
      }
export function useGetSchoolRecommendedScrimmagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolRecommendedScrimmagesQuery, GetSchoolRecommendedScrimmagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolRecommendedScrimmagesQuery, GetSchoolRecommendedScrimmagesQueryVariables>(GetSchoolRecommendedScrimmagesDocument, options);
        }
export type GetSchoolRecommendedScrimmagesQueryHookResult = ReturnType<typeof useGetSchoolRecommendedScrimmagesQuery>;
export type GetSchoolRecommendedScrimmagesLazyQueryHookResult = ReturnType<typeof useGetSchoolRecommendedScrimmagesLazyQuery>;
export type GetSchoolRecommendedScrimmagesQueryResult = Apollo.QueryResult<GetSchoolRecommendedScrimmagesQuery, GetSchoolRecommendedScrimmagesQueryVariables>;
export function refetchGetSchoolRecommendedScrimmagesQuery(variables: GetSchoolRecommendedScrimmagesQueryVariables) {
      return { query: GetSchoolRecommendedScrimmagesDocument, variables: variables }
    }
export const GetSchoolAvailableScrimmagesDocument = gql`
    query getSchoolAvailableScrimmages($id: UUID!, $offset: Int!, $limit: Int!, $filter: ScrimmageRequestFilter) {
  school(id: $id) {
    id
    name
    availableScrimmageRequests(offset: $offset, limit: $limit, filter: $filter) {
      total
      result {
        id
        requestingTeam {
          id
          name
          school {
            id
            name
            logoUrl
            slug
          }
        }
        league {
          id
          name
          state
          timezone
        }
        esport {
          id
          slug
          rating
        }
        status
        startsAt
        bestOf
        seriesBestOf
        esportId
        requestingTeamId
        requestedById
        createdAt
        rating
      }
    }
  }
}
    `;

/**
 * __useGetSchoolAvailableScrimmagesQuery__
 *
 * To run a query within a React component, call `useGetSchoolAvailableScrimmagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolAvailableScrimmagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolAvailableScrimmagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSchoolAvailableScrimmagesQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolAvailableScrimmagesQuery, GetSchoolAvailableScrimmagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolAvailableScrimmagesQuery, GetSchoolAvailableScrimmagesQueryVariables>(GetSchoolAvailableScrimmagesDocument, options);
      }
export function useGetSchoolAvailableScrimmagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolAvailableScrimmagesQuery, GetSchoolAvailableScrimmagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolAvailableScrimmagesQuery, GetSchoolAvailableScrimmagesQueryVariables>(GetSchoolAvailableScrimmagesDocument, options);
        }
export type GetSchoolAvailableScrimmagesQueryHookResult = ReturnType<typeof useGetSchoolAvailableScrimmagesQuery>;
export type GetSchoolAvailableScrimmagesLazyQueryHookResult = ReturnType<typeof useGetSchoolAvailableScrimmagesLazyQuery>;
export type GetSchoolAvailableScrimmagesQueryResult = Apollo.QueryResult<GetSchoolAvailableScrimmagesQuery, GetSchoolAvailableScrimmagesQueryVariables>;
export function refetchGetSchoolAvailableScrimmagesQuery(variables: GetSchoolAvailableScrimmagesQueryVariables) {
      return { query: GetSchoolAvailableScrimmagesDocument, variables: variables }
    }
export const GetSchoolSheerIdDocument = gql`
    query getSchoolSheerID($schoolId: UUID!) {
  school(id: $schoolId) {
    id
    type
    sheeridOrganizationId
    sheeridOrganizationName
  }
}
    `;

/**
 * __useGetSchoolSheerIdQuery__
 *
 * To run a query within a React component, call `useGetSchoolSheerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolSheerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolSheerIdQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolSheerIdQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolSheerIdQuery, GetSchoolSheerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolSheerIdQuery, GetSchoolSheerIdQueryVariables>(GetSchoolSheerIdDocument, options);
      }
export function useGetSchoolSheerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolSheerIdQuery, GetSchoolSheerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolSheerIdQuery, GetSchoolSheerIdQueryVariables>(GetSchoolSheerIdDocument, options);
        }
export type GetSchoolSheerIdQueryHookResult = ReturnType<typeof useGetSchoolSheerIdQuery>;
export type GetSchoolSheerIdLazyQueryHookResult = ReturnType<typeof useGetSchoolSheerIdLazyQuery>;
export type GetSchoolSheerIdQueryResult = Apollo.QueryResult<GetSchoolSheerIdQuery, GetSchoolSheerIdQueryVariables>;
export function refetchGetSchoolSheerIdQuery(variables: GetSchoolSheerIdQueryVariables) {
      return { query: GetSchoolSheerIdDocument, variables: variables }
    }
export const GetSchoolBySlugDocument = gql`
    query getSchoolBySlug($slug: String!) {
  getSchoolBySlug(slug: $slug) {
    id
    name
    city
    state
  }
}
    `;

/**
 * __useGetSchoolBySlugQuery__
 *
 * To run a query within a React component, call `useGetSchoolBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetSchoolBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolBySlugQuery, GetSchoolBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolBySlugQuery, GetSchoolBySlugQueryVariables>(GetSchoolBySlugDocument, options);
      }
export function useGetSchoolBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolBySlugQuery, GetSchoolBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolBySlugQuery, GetSchoolBySlugQueryVariables>(GetSchoolBySlugDocument, options);
        }
export type GetSchoolBySlugQueryHookResult = ReturnType<typeof useGetSchoolBySlugQuery>;
export type GetSchoolBySlugLazyQueryHookResult = ReturnType<typeof useGetSchoolBySlugLazyQuery>;
export type GetSchoolBySlugQueryResult = Apollo.QueryResult<GetSchoolBySlugQuery, GetSchoolBySlugQueryVariables>;
export function refetchGetSchoolBySlugQuery(variables: GetSchoolBySlugQueryVariables) {
      return { query: GetSchoolBySlugDocument, variables: variables }
    }
export const UpdateSchoolSheerIdDocument = gql`
    mutation updateSchoolSheerID($schoolId: UUID!, $sheeridOrganizationId: Int!, $sheeridOrganizationName: String!) {
  updateSchoolSheerId(
    schoolId: $schoolId
    sheeridOrganizationId: $sheeridOrganizationId
    sheeridOrganizationName: $sheeridOrganizationName
  ) {
    success
    school {
      id
      sheeridOrganizationId
    }
  }
}
    `;
export type UpdateSchoolSheerIdMutationFn = Apollo.MutationFunction<UpdateSchoolSheerIdMutation, UpdateSchoolSheerIdMutationVariables>;

/**
 * __useUpdateSchoolSheerIdMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolSheerIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolSheerIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolSheerIdMutation, { data, loading, error }] = useUpdateSchoolSheerIdMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      sheeridOrganizationId: // value for 'sheeridOrganizationId'
 *      sheeridOrganizationName: // value for 'sheeridOrganizationName'
 *   },
 * });
 */
export function useUpdateSchoolSheerIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchoolSheerIdMutation, UpdateSchoolSheerIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchoolSheerIdMutation, UpdateSchoolSheerIdMutationVariables>(UpdateSchoolSheerIdDocument, options);
      }
export type UpdateSchoolSheerIdMutationHookResult = ReturnType<typeof useUpdateSchoolSheerIdMutation>;
export type UpdateSchoolSheerIdMutationResult = Apollo.MutationResult<UpdateSchoolSheerIdMutation>;
export type UpdateSchoolSheerIdMutationOptions = Apollo.BaseMutationOptions<UpdateSchoolSheerIdMutation, UpdateSchoolSheerIdMutationVariables>;
export const DeleteSchoolDocument = gql`
    mutation deleteSchool($schoolId: UUID!) {
  deleteSchool(schoolId: $schoolId) {
    success
    deletedSchoolId
  }
}
    `;
export type DeleteSchoolMutationFn = Apollo.MutationFunction<DeleteSchoolMutation, DeleteSchoolMutationVariables>;

/**
 * __useDeleteSchoolMutation__
 *
 * To run a mutation, you first call `useDeleteSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchoolMutation, { data, loading, error }] = useDeleteSchoolMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useDeleteSchoolMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchoolMutation, DeleteSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchoolMutation, DeleteSchoolMutationVariables>(DeleteSchoolDocument, options);
      }
export type DeleteSchoolMutationHookResult = ReturnType<typeof useDeleteSchoolMutation>;
export type DeleteSchoolMutationResult = Apollo.MutationResult<DeleteSchoolMutation>;
export type DeleteSchoolMutationOptions = Apollo.BaseMutationOptions<DeleteSchoolMutation, DeleteSchoolMutationVariables>;
export const ResurrectSchoolDocument = gql`
    mutation resurrectSchool($schoolId: UUID!) {
  resurrectSchool(schoolId: $schoolId) {
    success
    school {
      id
      deletedAt
    }
  }
}
    `;
export type ResurrectSchoolMutationFn = Apollo.MutationFunction<ResurrectSchoolMutation, ResurrectSchoolMutationVariables>;

/**
 * __useResurrectSchoolMutation__
 *
 * To run a mutation, you first call `useResurrectSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResurrectSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resurrectSchoolMutation, { data, loading, error }] = useResurrectSchoolMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useResurrectSchoolMutation(baseOptions?: Apollo.MutationHookOptions<ResurrectSchoolMutation, ResurrectSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResurrectSchoolMutation, ResurrectSchoolMutationVariables>(ResurrectSchoolDocument, options);
      }
export type ResurrectSchoolMutationHookResult = ReturnType<typeof useResurrectSchoolMutation>;
export type ResurrectSchoolMutationResult = Apollo.MutationResult<ResurrectSchoolMutation>;
export type ResurrectSchoolMutationOptions = Apollo.BaseMutationOptions<ResurrectSchoolMutation, ResurrectSchoolMutationVariables>;
export const GetPurchasedProductsForSchoolDocument = gql`
    query getPurchasedProductsForSchool($id: UUID!, $metaseasonId: UUID!) {
  school(id: $id) {
    id
    annualPassInstances(metaseasonId: $metaseasonId) {
      id
      productId
      product {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPurchasedProductsForSchoolQuery__
 *
 * To run a query within a React component, call `useGetPurchasedProductsForSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchasedProductsForSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchasedProductsForSchoolQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetPurchasedProductsForSchoolQuery(baseOptions: Apollo.QueryHookOptions<GetPurchasedProductsForSchoolQuery, GetPurchasedProductsForSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchasedProductsForSchoolQuery, GetPurchasedProductsForSchoolQueryVariables>(GetPurchasedProductsForSchoolDocument, options);
      }
export function useGetPurchasedProductsForSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchasedProductsForSchoolQuery, GetPurchasedProductsForSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchasedProductsForSchoolQuery, GetPurchasedProductsForSchoolQueryVariables>(GetPurchasedProductsForSchoolDocument, options);
        }
export type GetPurchasedProductsForSchoolQueryHookResult = ReturnType<typeof useGetPurchasedProductsForSchoolQuery>;
export type GetPurchasedProductsForSchoolLazyQueryHookResult = ReturnType<typeof useGetPurchasedProductsForSchoolLazyQuery>;
export type GetPurchasedProductsForSchoolQueryResult = Apollo.QueryResult<GetPurchasedProductsForSchoolQuery, GetPurchasedProductsForSchoolQueryVariables>;
export function refetchGetPurchasedProductsForSchoolQuery(variables: GetPurchasedProductsForSchoolQueryVariables) {
      return { query: GetPurchasedProductsForSchoolDocument, variables: variables }
    }
export const FindEligibleVarsityAssociationsDocument = gql`
    query findEligibleVarsityAssociations($state: String!, $competitionGroup: CompetitionGroup!) {
  findEligibleVarsityAssociations(
    input: {state: $state, competitionGroup: $competitionGroup}
  ) {
    name
    slug
  }
}
    `;

/**
 * __useFindEligibleVarsityAssociationsQuery__
 *
 * To run a query within a React component, call `useFindEligibleVarsityAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEligibleVarsityAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEligibleVarsityAssociationsQuery({
 *   variables: {
 *      state: // value for 'state'
 *      competitionGroup: // value for 'competitionGroup'
 *   },
 * });
 */
export function useFindEligibleVarsityAssociationsQuery(baseOptions: Apollo.QueryHookOptions<FindEligibleVarsityAssociationsQuery, FindEligibleVarsityAssociationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindEligibleVarsityAssociationsQuery, FindEligibleVarsityAssociationsQueryVariables>(FindEligibleVarsityAssociationsDocument, options);
      }
export function useFindEligibleVarsityAssociationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindEligibleVarsityAssociationsQuery, FindEligibleVarsityAssociationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindEligibleVarsityAssociationsQuery, FindEligibleVarsityAssociationsQueryVariables>(FindEligibleVarsityAssociationsDocument, options);
        }
export type FindEligibleVarsityAssociationsQueryHookResult = ReturnType<typeof useFindEligibleVarsityAssociationsQuery>;
export type FindEligibleVarsityAssociationsLazyQueryHookResult = ReturnType<typeof useFindEligibleVarsityAssociationsLazyQuery>;
export type FindEligibleVarsityAssociationsQueryResult = Apollo.QueryResult<FindEligibleVarsityAssociationsQuery, FindEligibleVarsityAssociationsQueryVariables>;
export function refetchFindEligibleVarsityAssociationsQuery(variables: FindEligibleVarsityAssociationsQueryVariables) {
      return { query: FindEligibleVarsityAssociationsDocument, variables: variables }
    }
export const GetStateAssociationsBySchoolIdDocument = gql`
    query getStateAssociationsBySchoolId($id: UUID!) {
  school(id: $id) {
    id
    varsityAssociations {
      name
      slug
    }
    eligibleVarsityAssociations {
      name
      slug
    }
  }
}
    `;

/**
 * __useGetStateAssociationsBySchoolIdQuery__
 *
 * To run a query within a React component, call `useGetStateAssociationsBySchoolIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateAssociationsBySchoolIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateAssociationsBySchoolIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStateAssociationsBySchoolIdQuery(baseOptions: Apollo.QueryHookOptions<GetStateAssociationsBySchoolIdQuery, GetStateAssociationsBySchoolIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateAssociationsBySchoolIdQuery, GetStateAssociationsBySchoolIdQueryVariables>(GetStateAssociationsBySchoolIdDocument, options);
      }
export function useGetStateAssociationsBySchoolIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateAssociationsBySchoolIdQuery, GetStateAssociationsBySchoolIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateAssociationsBySchoolIdQuery, GetStateAssociationsBySchoolIdQueryVariables>(GetStateAssociationsBySchoolIdDocument, options);
        }
export type GetStateAssociationsBySchoolIdQueryHookResult = ReturnType<typeof useGetStateAssociationsBySchoolIdQuery>;
export type GetStateAssociationsBySchoolIdLazyQueryHookResult = ReturnType<typeof useGetStateAssociationsBySchoolIdLazyQuery>;
export type GetStateAssociationsBySchoolIdQueryResult = Apollo.QueryResult<GetStateAssociationsBySchoolIdQuery, GetStateAssociationsBySchoolIdQueryVariables>;
export function refetchGetStateAssociationsBySchoolIdQuery(variables: GetStateAssociationsBySchoolIdQueryVariables) {
      return { query: GetStateAssociationsBySchoolIdDocument, variables: variables }
    }
export const AddSchoolToVarsityAssociationDocument = gql`
    mutation addSchoolToVarsityAssociation($schoolId: UUID!, $firstEffectiveMetaseasonId: UUID!, $varsityAssociationSlug: String!) {
  addSchoolToVarsityAssociation(
    schoolId: $schoolId
    firstEffectiveMetaseasonId: $firstEffectiveMetaseasonId
    varsityAssociationSlug: $varsityAssociationSlug
  ) {
    success
  }
}
    `;
export type AddSchoolToVarsityAssociationMutationFn = Apollo.MutationFunction<AddSchoolToVarsityAssociationMutation, AddSchoolToVarsityAssociationMutationVariables>;

/**
 * __useAddSchoolToVarsityAssociationMutation__
 *
 * To run a mutation, you first call `useAddSchoolToVarsityAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSchoolToVarsityAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSchoolToVarsityAssociationMutation, { data, loading, error }] = useAddSchoolToVarsityAssociationMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      firstEffectiveMetaseasonId: // value for 'firstEffectiveMetaseasonId'
 *      varsityAssociationSlug: // value for 'varsityAssociationSlug'
 *   },
 * });
 */
export function useAddSchoolToVarsityAssociationMutation(baseOptions?: Apollo.MutationHookOptions<AddSchoolToVarsityAssociationMutation, AddSchoolToVarsityAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSchoolToVarsityAssociationMutation, AddSchoolToVarsityAssociationMutationVariables>(AddSchoolToVarsityAssociationDocument, options);
      }
export type AddSchoolToVarsityAssociationMutationHookResult = ReturnType<typeof useAddSchoolToVarsityAssociationMutation>;
export type AddSchoolToVarsityAssociationMutationResult = Apollo.MutationResult<AddSchoolToVarsityAssociationMutation>;
export type AddSchoolToVarsityAssociationMutationOptions = Apollo.BaseMutationOptions<AddSchoolToVarsityAssociationMutation, AddSchoolToVarsityAssociationMutationVariables>;
export const CreateSchoolMessageDocument = gql`
    mutation createSchoolMessage($title: String, $message: String, $schoolId: UUID!, $userId: UUID!) {
  createSchoolMessage(
    title: $title
    message: $message
    schoolId: $schoolId
    userId: $userId
  ) {
    id
    title
    message
    school {
      id
      name
    }
    user {
      id
      name
    }
  }
}
    `;
export type CreateSchoolMessageMutationFn = Apollo.MutationFunction<CreateSchoolMessageMutation, CreateSchoolMessageMutationVariables>;

/**
 * __useCreateSchoolMessageMutation__
 *
 * To run a mutation, you first call `useCreateSchoolMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolMessageMutation, { data, loading, error }] = useCreateSchoolMessageMutation({
 *   variables: {
 *      title: // value for 'title'
 *      message: // value for 'message'
 *      schoolId: // value for 'schoolId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateSchoolMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchoolMessageMutation, CreateSchoolMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchoolMessageMutation, CreateSchoolMessageMutationVariables>(CreateSchoolMessageDocument, options);
      }
export type CreateSchoolMessageMutationHookResult = ReturnType<typeof useCreateSchoolMessageMutation>;
export type CreateSchoolMessageMutationResult = Apollo.MutationResult<CreateSchoolMessageMutation>;
export type CreateSchoolMessageMutationOptions = Apollo.BaseMutationOptions<CreateSchoolMessageMutation, CreateSchoolMessageMutationVariables>;
export const GetAggregateSchoolMessagesDocument = gql`
    query getAggregateSchoolMessages($schoolId: UUID!) {
  getAggregateSchoolMessages(schoolId: $schoolId) {
    ... on ISchoolMessage {
      title
      message
      createdAt
      linkUrl
    }
    ... on SchoolUserMessage {
      __typename
      id
      user {
        id
        name
        avatarUrl
      }
      school {
        id
        name
        logoUrl
      }
      isPinned
      linkUrl
      linkImageUrl
      linkTitle
    }
    ... on SchoolOneOnOneMatchResultMessage {
      __typename
      matchId
      esportSlug
      leagueName
      homeTeamId
      homeTeamName
      homeSchoolLogoUrl
      opposingTeamId
      opposingTeamName
      opposingSchoolLogoUrl
      homeTeamGamesWon
      homeTeamGamesLost
    }
    ... on SchoolFortniteMatchResultMessage {
      __typename
      matchId
      esportSlug
      leagueName
      homeTeamId
      homeTeamName
      homeSchoolLogoUrl
      rank
    }
  }
}
    `;

/**
 * __useGetAggregateSchoolMessagesQuery__
 *
 * To run a query within a React component, call `useGetAggregateSchoolMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregateSchoolMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregateSchoolMessagesQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetAggregateSchoolMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetAggregateSchoolMessagesQuery, GetAggregateSchoolMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregateSchoolMessagesQuery, GetAggregateSchoolMessagesQueryVariables>(GetAggregateSchoolMessagesDocument, options);
      }
export function useGetAggregateSchoolMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregateSchoolMessagesQuery, GetAggregateSchoolMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregateSchoolMessagesQuery, GetAggregateSchoolMessagesQueryVariables>(GetAggregateSchoolMessagesDocument, options);
        }
export type GetAggregateSchoolMessagesQueryHookResult = ReturnType<typeof useGetAggregateSchoolMessagesQuery>;
export type GetAggregateSchoolMessagesLazyQueryHookResult = ReturnType<typeof useGetAggregateSchoolMessagesLazyQuery>;
export type GetAggregateSchoolMessagesQueryResult = Apollo.QueryResult<GetAggregateSchoolMessagesQuery, GetAggregateSchoolMessagesQueryVariables>;
export function refetchGetAggregateSchoolMessagesQuery(variables: GetAggregateSchoolMessagesQueryVariables) {
      return { query: GetAggregateSchoolMessagesDocument, variables: variables }
    }
export const GetSchoolCoachesBySchoolIdDocument = gql`
    query getSchoolCoachesBySchoolId($schoolId: UUID!) {
  school(id: $schoolId) {
    id
    coaches {
      id
      name
      lastSeen
      firstName
      lastName
      email
      avatarUrl
      directRoles {
        userId
        roleName
        resourceId
        resourceType
      }
    }
  }
}
    `;

/**
 * __useGetSchoolCoachesBySchoolIdQuery__
 *
 * To run a query within a React component, call `useGetSchoolCoachesBySchoolIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolCoachesBySchoolIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolCoachesBySchoolIdQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolCoachesBySchoolIdQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolCoachesBySchoolIdQuery, GetSchoolCoachesBySchoolIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolCoachesBySchoolIdQuery, GetSchoolCoachesBySchoolIdQueryVariables>(GetSchoolCoachesBySchoolIdDocument, options);
      }
export function useGetSchoolCoachesBySchoolIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolCoachesBySchoolIdQuery, GetSchoolCoachesBySchoolIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolCoachesBySchoolIdQuery, GetSchoolCoachesBySchoolIdQueryVariables>(GetSchoolCoachesBySchoolIdDocument, options);
        }
export type GetSchoolCoachesBySchoolIdQueryHookResult = ReturnType<typeof useGetSchoolCoachesBySchoolIdQuery>;
export type GetSchoolCoachesBySchoolIdLazyQueryHookResult = ReturnType<typeof useGetSchoolCoachesBySchoolIdLazyQuery>;
export type GetSchoolCoachesBySchoolIdQueryResult = Apollo.QueryResult<GetSchoolCoachesBySchoolIdQuery, GetSchoolCoachesBySchoolIdQueryVariables>;
export function refetchGetSchoolCoachesBySchoolIdQuery(variables: GetSchoolCoachesBySchoolIdQueryVariables) {
      return { query: GetSchoolCoachesBySchoolIdDocument, variables: variables }
    }
export const MySchoolBillingContactDocument = gql`
    query mySchoolBillingContact {
  me {
    id
    school {
      id
      address
      city
      state
      zip
      name
      deletedAt
      annualPassInstances {
        id
        product {
          priceUsd
        }
      }
      billingContact {
        firstName
        email
      }
      coaches {
        id
        name
        firstName
        lastName
        phone
        phoneExt
        emails {
          email
          isSchoolEmail
        }
        avatarUrl
      }
    }
  }
}
    `;

/**
 * __useMySchoolBillingContactQuery__
 *
 * To run a query within a React component, call `useMySchoolBillingContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySchoolBillingContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySchoolBillingContactQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySchoolBillingContactQuery(baseOptions?: Apollo.QueryHookOptions<MySchoolBillingContactQuery, MySchoolBillingContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySchoolBillingContactQuery, MySchoolBillingContactQueryVariables>(MySchoolBillingContactDocument, options);
      }
export function useMySchoolBillingContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySchoolBillingContactQuery, MySchoolBillingContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySchoolBillingContactQuery, MySchoolBillingContactQueryVariables>(MySchoolBillingContactDocument, options);
        }
export type MySchoolBillingContactQueryHookResult = ReturnType<typeof useMySchoolBillingContactQuery>;
export type MySchoolBillingContactLazyQueryHookResult = ReturnType<typeof useMySchoolBillingContactLazyQuery>;
export type MySchoolBillingContactQueryResult = Apollo.QueryResult<MySchoolBillingContactQuery, MySchoolBillingContactQueryVariables>;
export function refetchMySchoolBillingContactQuery(variables?: MySchoolBillingContactQueryVariables) {
      return { query: MySchoolBillingContactDocument, variables: variables }
    }
export const GetSchoolBillingContactDocument = gql`
    query getSchoolBillingContact($schoolId: UUID!) {
  school(id: $schoolId) {
    id
    name
    address
    city
    state
    zip
    billingContact {
      user {
        id
        firstName
        lastName
        phone
        phoneExt
        email
      }
      userId
      firstName
      lastName
      email
      organizationRole
      phone
      phoneExt
      address
      city
      state
      zip
      createdBy {
        id
        name
        email
        phone
      }
      createdAt
    }
  }
}
    `;

/**
 * __useGetSchoolBillingContactQuery__
 *
 * To run a query within a React component, call `useGetSchoolBillingContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolBillingContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolBillingContactQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolBillingContactQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolBillingContactQuery, GetSchoolBillingContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolBillingContactQuery, GetSchoolBillingContactQueryVariables>(GetSchoolBillingContactDocument, options);
      }
export function useGetSchoolBillingContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolBillingContactQuery, GetSchoolBillingContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolBillingContactQuery, GetSchoolBillingContactQueryVariables>(GetSchoolBillingContactDocument, options);
        }
export type GetSchoolBillingContactQueryHookResult = ReturnType<typeof useGetSchoolBillingContactQuery>;
export type GetSchoolBillingContactLazyQueryHookResult = ReturnType<typeof useGetSchoolBillingContactLazyQuery>;
export type GetSchoolBillingContactQueryResult = Apollo.QueryResult<GetSchoolBillingContactQuery, GetSchoolBillingContactQueryVariables>;
export function refetchGetSchoolBillingContactQuery(variables: GetSchoolBillingContactQueryVariables) {
      return { query: GetSchoolBillingContactDocument, variables: variables }
    }
export const GetAllSchoolsEsDocument = gql`
    query getAllSchoolsEs($offset: Int, $limit: Int, $filters: SchoolFiltersInput) {
  getSchoolsES(offset: $offset, limit: $limit, filters: $filters) {
    totalCount
    schools {
      id
      name
      city
      state
      logoUrl
      createdAt
      deletedAt
      type
      ncesId
      teams {
        id
        name
      }
      playerCount
      submissions {
        id
        user {
          id
          name
          emails {
            id
            isVerified
            isSchoolEmail
          }
          roles {
            roleName
            userId
            resourceId
          }
          avatarUrl
        }
        createdAt
      }
      coaches {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllSchoolsEsQuery__
 *
 * To run a query within a React component, call `useGetAllSchoolsEsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSchoolsEsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSchoolsEsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAllSchoolsEsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSchoolsEsQuery, GetAllSchoolsEsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSchoolsEsQuery, GetAllSchoolsEsQueryVariables>(GetAllSchoolsEsDocument, options);
      }
export function useGetAllSchoolsEsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSchoolsEsQuery, GetAllSchoolsEsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSchoolsEsQuery, GetAllSchoolsEsQueryVariables>(GetAllSchoolsEsDocument, options);
        }
export type GetAllSchoolsEsQueryHookResult = ReturnType<typeof useGetAllSchoolsEsQuery>;
export type GetAllSchoolsEsLazyQueryHookResult = ReturnType<typeof useGetAllSchoolsEsLazyQuery>;
export type GetAllSchoolsEsQueryResult = Apollo.QueryResult<GetAllSchoolsEsQuery, GetAllSchoolsEsQueryVariables>;
export function refetchGetAllSchoolsEsQuery(variables?: GetAllSchoolsEsQueryVariables) {
      return { query: GetAllSchoolsEsDocument, variables: variables }
    }
export const FindSchoolsByIdsDocument = gql`
    query findSchoolsByIds($ids: [UUID!]) {
  findSchoolsByIds(ids: $ids) {
    id
    name
    competitionGroup
    logoUrl
  }
}
    `;

/**
 * __useFindSchoolsByIdsQuery__
 *
 * To run a query within a React component, call `useFindSchoolsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSchoolsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSchoolsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFindSchoolsByIdsQuery(baseOptions?: Apollo.QueryHookOptions<FindSchoolsByIdsQuery, FindSchoolsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSchoolsByIdsQuery, FindSchoolsByIdsQueryVariables>(FindSchoolsByIdsDocument, options);
      }
export function useFindSchoolsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSchoolsByIdsQuery, FindSchoolsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSchoolsByIdsQuery, FindSchoolsByIdsQueryVariables>(FindSchoolsByIdsDocument, options);
        }
export type FindSchoolsByIdsQueryHookResult = ReturnType<typeof useFindSchoolsByIdsQuery>;
export type FindSchoolsByIdsLazyQueryHookResult = ReturnType<typeof useFindSchoolsByIdsLazyQuery>;
export type FindSchoolsByIdsQueryResult = Apollo.QueryResult<FindSchoolsByIdsQuery, FindSchoolsByIdsQueryVariables>;
export function refetchFindSchoolsByIdsQuery(variables?: FindSchoolsByIdsQueryVariables) {
      return { query: FindSchoolsByIdsDocument, variables: variables }
    }
export const GetSchoolsOnUserPageEsDocument = gql`
    query getSchoolsOnUserPageEs($offset: Int, $limit: Int, $filters: SchoolFiltersInput) {
  getSchoolsES(offset: $offset, limit: $limit, filters: $filters) {
    schools {
      id
      name
      logoUrl
    }
  }
}
    `;

/**
 * __useGetSchoolsOnUserPageEsQuery__
 *
 * To run a query within a React component, call `useGetSchoolsOnUserPageEsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolsOnUserPageEsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolsOnUserPageEsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSchoolsOnUserPageEsQuery(baseOptions?: Apollo.QueryHookOptions<GetSchoolsOnUserPageEsQuery, GetSchoolsOnUserPageEsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolsOnUserPageEsQuery, GetSchoolsOnUserPageEsQueryVariables>(GetSchoolsOnUserPageEsDocument, options);
      }
export function useGetSchoolsOnUserPageEsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolsOnUserPageEsQuery, GetSchoolsOnUserPageEsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolsOnUserPageEsQuery, GetSchoolsOnUserPageEsQueryVariables>(GetSchoolsOnUserPageEsDocument, options);
        }
export type GetSchoolsOnUserPageEsQueryHookResult = ReturnType<typeof useGetSchoolsOnUserPageEsQuery>;
export type GetSchoolsOnUserPageEsLazyQueryHookResult = ReturnType<typeof useGetSchoolsOnUserPageEsLazyQuery>;
export type GetSchoolsOnUserPageEsQueryResult = Apollo.QueryResult<GetSchoolsOnUserPageEsQuery, GetSchoolsOnUserPageEsQueryVariables>;
export function refetchGetSchoolsOnUserPageEsQuery(variables?: GetSchoolsOnUserPageEsQueryVariables) {
      return { query: GetSchoolsOnUserPageEsDocument, variables: variables }
    }
export const GetSchoolEligibleMetaseasonsDocument = gql`
    query getSchoolEligibleMetaseasons($schoolId: UUID!) {
  eligibleMetaseasons(schoolId: $schoolId) {
    id
    isPromoted
  }
}
    `;

/**
 * __useGetSchoolEligibleMetaseasonsQuery__
 *
 * To run a query within a React component, call `useGetSchoolEligibleMetaseasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolEligibleMetaseasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolEligibleMetaseasonsQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetSchoolEligibleMetaseasonsQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolEligibleMetaseasonsQuery, GetSchoolEligibleMetaseasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolEligibleMetaseasonsQuery, GetSchoolEligibleMetaseasonsQueryVariables>(GetSchoolEligibleMetaseasonsDocument, options);
      }
export function useGetSchoolEligibleMetaseasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolEligibleMetaseasonsQuery, GetSchoolEligibleMetaseasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolEligibleMetaseasonsQuery, GetSchoolEligibleMetaseasonsQueryVariables>(GetSchoolEligibleMetaseasonsDocument, options);
        }
export type GetSchoolEligibleMetaseasonsQueryHookResult = ReturnType<typeof useGetSchoolEligibleMetaseasonsQuery>;
export type GetSchoolEligibleMetaseasonsLazyQueryHookResult = ReturnType<typeof useGetSchoolEligibleMetaseasonsLazyQuery>;
export type GetSchoolEligibleMetaseasonsQueryResult = Apollo.QueryResult<GetSchoolEligibleMetaseasonsQuery, GetSchoolEligibleMetaseasonsQueryVariables>;
export function refetchGetSchoolEligibleMetaseasonsQuery(variables: GetSchoolEligibleMetaseasonsQueryVariables) {
      return { query: GetSchoolEligibleMetaseasonsDocument, variables: variables }
    }
export const GetSchoolsOnVarsityAssociationPageEsDocument = gql`
    query getSchoolsOnVarsityAssociationPageEs($offset: Int, $limit: Int, $filters: SchoolFiltersInput, $varsityAssociationSlug: String!) {
  getSchoolsES(offset: $offset, limit: $limit, filters: $filters) {
    schools {
      id
      name
      logoUrl
      state
      schoolVarsityAssociation(varsityAssociationSlug: $varsityAssociationSlug) {
        createdAt
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetSchoolsOnVarsityAssociationPageEsQuery__
 *
 * To run a query within a React component, call `useGetSchoolsOnVarsityAssociationPageEsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolsOnVarsityAssociationPageEsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolsOnVarsityAssociationPageEsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      varsityAssociationSlug: // value for 'varsityAssociationSlug'
 *   },
 * });
 */
export function useGetSchoolsOnVarsityAssociationPageEsQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolsOnVarsityAssociationPageEsQuery, GetSchoolsOnVarsityAssociationPageEsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolsOnVarsityAssociationPageEsQuery, GetSchoolsOnVarsityAssociationPageEsQueryVariables>(GetSchoolsOnVarsityAssociationPageEsDocument, options);
      }
export function useGetSchoolsOnVarsityAssociationPageEsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolsOnVarsityAssociationPageEsQuery, GetSchoolsOnVarsityAssociationPageEsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolsOnVarsityAssociationPageEsQuery, GetSchoolsOnVarsityAssociationPageEsQueryVariables>(GetSchoolsOnVarsityAssociationPageEsDocument, options);
        }
export type GetSchoolsOnVarsityAssociationPageEsQueryHookResult = ReturnType<typeof useGetSchoolsOnVarsityAssociationPageEsQuery>;
export type GetSchoolsOnVarsityAssociationPageEsLazyQueryHookResult = ReturnType<typeof useGetSchoolsOnVarsityAssociationPageEsLazyQuery>;
export type GetSchoolsOnVarsityAssociationPageEsQueryResult = Apollo.QueryResult<GetSchoolsOnVarsityAssociationPageEsQuery, GetSchoolsOnVarsityAssociationPageEsQueryVariables>;
export function refetchGetSchoolsOnVarsityAssociationPageEsQuery(variables: GetSchoolsOnVarsityAssociationPageEsQueryVariables) {
      return { query: GetSchoolsOnVarsityAssociationPageEsDocument, variables: variables }
    }
export const BillingContactFormInfoDocument = gql`
    query billingContactFormInfo {
  me {
    id
    school {
      id
      address
      city
      state
      zip
      billingContact {
        firstName
        lastName
        phone
        phoneExt
        email
        address
        city
        state
        zip
        user {
          id
          firstName
          lastName
          phone
          phoneExt
          email
        }
      }
    }
  }
}
    `;

/**
 * __useBillingContactFormInfoQuery__
 *
 * To run a query within a React component, call `useBillingContactFormInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingContactFormInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingContactFormInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingContactFormInfoQuery(baseOptions?: Apollo.QueryHookOptions<BillingContactFormInfoQuery, BillingContactFormInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingContactFormInfoQuery, BillingContactFormInfoQueryVariables>(BillingContactFormInfoDocument, options);
      }
export function useBillingContactFormInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingContactFormInfoQuery, BillingContactFormInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingContactFormInfoQuery, BillingContactFormInfoQueryVariables>(BillingContactFormInfoDocument, options);
        }
export type BillingContactFormInfoQueryHookResult = ReturnType<typeof useBillingContactFormInfoQuery>;
export type BillingContactFormInfoLazyQueryHookResult = ReturnType<typeof useBillingContactFormInfoLazyQuery>;
export type BillingContactFormInfoQueryResult = Apollo.QueryResult<BillingContactFormInfoQuery, BillingContactFormInfoQueryVariables>;
export function refetchBillingContactFormInfoQuery(variables?: BillingContactFormInfoQueryVariables) {
      return { query: BillingContactFormInfoDocument, variables: variables }
    }
export const GetAllSchoolsForCoachLeadDocument = gql`
    query getAllSchoolsForCoachLead($query: String!, $type: String!, $state: String!) {
  searchSchools(query: {nameQuery: $query, type: $type, state: $state}) {
    results {
      schoolId
      name
      logoUrl
      city
      state
    }
  }
}
    `;

/**
 * __useGetAllSchoolsForCoachLeadQuery__
 *
 * To run a query within a React component, call `useGetAllSchoolsForCoachLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSchoolsForCoachLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSchoolsForCoachLeadQuery({
 *   variables: {
 *      query: // value for 'query'
 *      type: // value for 'type'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetAllSchoolsForCoachLeadQuery(baseOptions: Apollo.QueryHookOptions<GetAllSchoolsForCoachLeadQuery, GetAllSchoolsForCoachLeadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSchoolsForCoachLeadQuery, GetAllSchoolsForCoachLeadQueryVariables>(GetAllSchoolsForCoachLeadDocument, options);
      }
export function useGetAllSchoolsForCoachLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSchoolsForCoachLeadQuery, GetAllSchoolsForCoachLeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSchoolsForCoachLeadQuery, GetAllSchoolsForCoachLeadQueryVariables>(GetAllSchoolsForCoachLeadDocument, options);
        }
export type GetAllSchoolsForCoachLeadQueryHookResult = ReturnType<typeof useGetAllSchoolsForCoachLeadQuery>;
export type GetAllSchoolsForCoachLeadLazyQueryHookResult = ReturnType<typeof useGetAllSchoolsForCoachLeadLazyQuery>;
export type GetAllSchoolsForCoachLeadQueryResult = Apollo.QueryResult<GetAllSchoolsForCoachLeadQuery, GetAllSchoolsForCoachLeadQueryVariables>;
export function refetchGetAllSchoolsForCoachLeadQuery(variables: GetAllSchoolsForCoachLeadQueryVariables) {
      return { query: GetAllSchoolsForCoachLeadDocument, variables: variables }
    }
export const GetMySchoolNameDocument = gql`
    query getMySchoolName {
  me {
    id
    school {
      id
      name
      state
      slug
    }
  }
}
    `;

/**
 * __useGetMySchoolNameQuery__
 *
 * To run a query within a React component, call `useGetMySchoolNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySchoolNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySchoolNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySchoolNameQuery(baseOptions?: Apollo.QueryHookOptions<GetMySchoolNameQuery, GetMySchoolNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySchoolNameQuery, GetMySchoolNameQueryVariables>(GetMySchoolNameDocument, options);
      }
export function useGetMySchoolNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySchoolNameQuery, GetMySchoolNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySchoolNameQuery, GetMySchoolNameQueryVariables>(GetMySchoolNameDocument, options);
        }
export type GetMySchoolNameQueryHookResult = ReturnType<typeof useGetMySchoolNameQuery>;
export type GetMySchoolNameLazyQueryHookResult = ReturnType<typeof useGetMySchoolNameLazyQuery>;
export type GetMySchoolNameQueryResult = Apollo.QueryResult<GetMySchoolNameQuery, GetMySchoolNameQueryVariables>;
export function refetchGetMySchoolNameQuery(variables?: GetMySchoolNameQueryVariables) {
      return { query: GetMySchoolNameDocument, variables: variables }
    }
export const UpdateSchoolMessageDocument = gql`
    mutation updateSchoolMessage($id: UUID!, $title: String, $message: String, $schoolId: UUID!, $userId: UUID!, $isPinned: Boolean) {
  updateSchoolMessage(
    id: $id
    title: $title
    message: $message
    schoolId: $schoolId
    userId: $userId
    isPinned: $isPinned
  ) {
    id
  }
}
    `;
export type UpdateSchoolMessageMutationFn = Apollo.MutationFunction<UpdateSchoolMessageMutation, UpdateSchoolMessageMutationVariables>;

/**
 * __useUpdateSchoolMessageMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolMessageMutation, { data, loading, error }] = useUpdateSchoolMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      message: // value for 'message'
 *      schoolId: // value for 'schoolId'
 *      userId: // value for 'userId'
 *      isPinned: // value for 'isPinned'
 *   },
 * });
 */
export function useUpdateSchoolMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchoolMessageMutation, UpdateSchoolMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchoolMessageMutation, UpdateSchoolMessageMutationVariables>(UpdateSchoolMessageDocument, options);
      }
export type UpdateSchoolMessageMutationHookResult = ReturnType<typeof useUpdateSchoolMessageMutation>;
export type UpdateSchoolMessageMutationResult = Apollo.MutationResult<UpdateSchoolMessageMutation>;
export type UpdateSchoolMessageMutationOptions = Apollo.BaseMutationOptions<UpdateSchoolMessageMutation, UpdateSchoolMessageMutationVariables>;
export const DeleteSchoolMessageDocument = gql`
    mutation deleteSchoolMessage($id: UUID!) {
  deleteSchoolMessage(id: $id) {
    success
    deletedSchoolMessageId
  }
}
    `;
export type DeleteSchoolMessageMutationFn = Apollo.MutationFunction<DeleteSchoolMessageMutation, DeleteSchoolMessageMutationVariables>;

/**
 * __useDeleteSchoolMessageMutation__
 *
 * To run a mutation, you first call `useDeleteSchoolMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchoolMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchoolMessageMutation, { data, loading, error }] = useDeleteSchoolMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSchoolMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchoolMessageMutation, DeleteSchoolMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchoolMessageMutation, DeleteSchoolMessageMutationVariables>(DeleteSchoolMessageDocument, options);
      }
export type DeleteSchoolMessageMutationHookResult = ReturnType<typeof useDeleteSchoolMessageMutation>;
export type DeleteSchoolMessageMutationResult = Apollo.MutationResult<DeleteSchoolMessageMutation>;
export type DeleteSchoolMessageMutationOptions = Apollo.BaseMutationOptions<DeleteSchoolMessageMutation, DeleteSchoolMessageMutationVariables>;
export const RemoveSchoolFromVarsityAssociationDocument = gql`
    mutation removeSchoolFromVarsityAssociation($schoolId: UUID!, $firstEffectiveMetaseasonId: UUID!, $varsityAssociationSlug: String!) {
  removeSchoolFromVarsityAssociation(
    schoolId: $schoolId
    firstEffectiveMetaseasonId: $firstEffectiveMetaseasonId
    varsityAssociationSlug: $varsityAssociationSlug
  ) {
    success
  }
}
    `;
export type RemoveSchoolFromVarsityAssociationMutationFn = Apollo.MutationFunction<RemoveSchoolFromVarsityAssociationMutation, RemoveSchoolFromVarsityAssociationMutationVariables>;

/**
 * __useRemoveSchoolFromVarsityAssociationMutation__
 *
 * To run a mutation, you first call `useRemoveSchoolFromVarsityAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSchoolFromVarsityAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSchoolFromVarsityAssociationMutation, { data, loading, error }] = useRemoveSchoolFromVarsityAssociationMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      firstEffectiveMetaseasonId: // value for 'firstEffectiveMetaseasonId'
 *      varsityAssociationSlug: // value for 'varsityAssociationSlug'
 *   },
 * });
 */
export function useRemoveSchoolFromVarsityAssociationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSchoolFromVarsityAssociationMutation, RemoveSchoolFromVarsityAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSchoolFromVarsityAssociationMutation, RemoveSchoolFromVarsityAssociationMutationVariables>(RemoveSchoolFromVarsityAssociationDocument, options);
      }
export type RemoveSchoolFromVarsityAssociationMutationHookResult = ReturnType<typeof useRemoveSchoolFromVarsityAssociationMutation>;
export type RemoveSchoolFromVarsityAssociationMutationResult = Apollo.MutationResult<RemoveSchoolFromVarsityAssociationMutation>;
export type RemoveSchoolFromVarsityAssociationMutationOptions = Apollo.BaseMutationOptions<RemoveSchoolFromVarsityAssociationMutation, RemoveSchoolFromVarsityAssociationMutationVariables>;
export const RemoveSchoolsFromVarsityAssociationDocument = gql`
    mutation removeSchoolsFromVarsityAssociation($input: RemoveSchoolsFromVarsityAssociationInput!) {
  removeSchoolsFromVarsityAssociation(input: $input) {
    jobId
  }
}
    `;
export type RemoveSchoolsFromVarsityAssociationMutationFn = Apollo.MutationFunction<RemoveSchoolsFromVarsityAssociationMutation, RemoveSchoolsFromVarsityAssociationMutationVariables>;

/**
 * __useRemoveSchoolsFromVarsityAssociationMutation__
 *
 * To run a mutation, you first call `useRemoveSchoolsFromVarsityAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSchoolsFromVarsityAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSchoolsFromVarsityAssociationMutation, { data, loading, error }] = useRemoveSchoolsFromVarsityAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSchoolsFromVarsityAssociationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSchoolsFromVarsityAssociationMutation, RemoveSchoolsFromVarsityAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSchoolsFromVarsityAssociationMutation, RemoveSchoolsFromVarsityAssociationMutationVariables>(RemoveSchoolsFromVarsityAssociationDocument, options);
      }
export type RemoveSchoolsFromVarsityAssociationMutationHookResult = ReturnType<typeof useRemoveSchoolsFromVarsityAssociationMutation>;
export type RemoveSchoolsFromVarsityAssociationMutationResult = Apollo.MutationResult<RemoveSchoolsFromVarsityAssociationMutation>;
export type RemoveSchoolsFromVarsityAssociationMutationOptions = Apollo.BaseMutationOptions<RemoveSchoolsFromVarsityAssociationMutation, RemoveSchoolsFromVarsityAssociationMutationVariables>;
export const UpdateAllowPlayerLedTeamsDocument = gql`
    mutation updateAllowPlayerLedTeams($schoolId: UUID!, $allowPlayerLedTeams: Boolean!) {
  updateAllowPlayerLedTeams(
    schoolId: $schoolId
    allowPlayerLedTeams: $allowPlayerLedTeams
  ) {
    id
    allowPlayerLedTeams
  }
}
    `;
export type UpdateAllowPlayerLedTeamsMutationFn = Apollo.MutationFunction<UpdateAllowPlayerLedTeamsMutation, UpdateAllowPlayerLedTeamsMutationVariables>;

/**
 * __useUpdateAllowPlayerLedTeamsMutation__
 *
 * To run a mutation, you first call `useUpdateAllowPlayerLedTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowPlayerLedTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllowPlayerLedTeamsMutation, { data, loading, error }] = useUpdateAllowPlayerLedTeamsMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      allowPlayerLedTeams: // value for 'allowPlayerLedTeams'
 *   },
 * });
 */
export function useUpdateAllowPlayerLedTeamsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllowPlayerLedTeamsMutation, UpdateAllowPlayerLedTeamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllowPlayerLedTeamsMutation, UpdateAllowPlayerLedTeamsMutationVariables>(UpdateAllowPlayerLedTeamsDocument, options);
      }
export type UpdateAllowPlayerLedTeamsMutationHookResult = ReturnType<typeof useUpdateAllowPlayerLedTeamsMutation>;
export type UpdateAllowPlayerLedTeamsMutationResult = Apollo.MutationResult<UpdateAllowPlayerLedTeamsMutation>;
export type UpdateAllowPlayerLedTeamsMutationOptions = Apollo.BaseMutationOptions<UpdateAllowPlayerLedTeamsMutation, UpdateAllowPlayerLedTeamsMutationVariables>;
export const UpdateShowCoachEmailsDocument = gql`
    mutation updateShowCoachEmails($schoolId: UUID!, $showCoachEmails: Boolean!) {
  updateShowCoachEmails(schoolId: $schoolId, showCoachEmails: $showCoachEmails) {
    id
    showCoachEmails
  }
}
    `;
export type UpdateShowCoachEmailsMutationFn = Apollo.MutationFunction<UpdateShowCoachEmailsMutation, UpdateShowCoachEmailsMutationVariables>;

/**
 * __useUpdateShowCoachEmailsMutation__
 *
 * To run a mutation, you first call `useUpdateShowCoachEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShowCoachEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShowCoachEmailsMutation, { data, loading, error }] = useUpdateShowCoachEmailsMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      showCoachEmails: // value for 'showCoachEmails'
 *   },
 * });
 */
export function useUpdateShowCoachEmailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShowCoachEmailsMutation, UpdateShowCoachEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShowCoachEmailsMutation, UpdateShowCoachEmailsMutationVariables>(UpdateShowCoachEmailsDocument, options);
      }
export type UpdateShowCoachEmailsMutationHookResult = ReturnType<typeof useUpdateShowCoachEmailsMutation>;
export type UpdateShowCoachEmailsMutationResult = Apollo.MutationResult<UpdateShowCoachEmailsMutation>;
export type UpdateShowCoachEmailsMutationOptions = Apollo.BaseMutationOptions<UpdateShowCoachEmailsMutation, UpdateShowCoachEmailsMutationVariables>;
export const UpdateAllowCaptainEnrollmentDocument = gql`
    mutation updateAllowCaptainEnrollment($schoolId: UUID!, $allowCaptainEnrollment: Boolean!) {
  updateAllowCaptainEnrollment(
    schoolId: $schoolId
    allowCaptainEnrollment: $allowCaptainEnrollment
  ) {
    id
    allowCaptainEnrollment
  }
}
    `;
export type UpdateAllowCaptainEnrollmentMutationFn = Apollo.MutationFunction<UpdateAllowCaptainEnrollmentMutation, UpdateAllowCaptainEnrollmentMutationVariables>;

/**
 * __useUpdateAllowCaptainEnrollmentMutation__
 *
 * To run a mutation, you first call `useUpdateAllowCaptainEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowCaptainEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllowCaptainEnrollmentMutation, { data, loading, error }] = useUpdateAllowCaptainEnrollmentMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      allowCaptainEnrollment: // value for 'allowCaptainEnrollment'
 *   },
 * });
 */
export function useUpdateAllowCaptainEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllowCaptainEnrollmentMutation, UpdateAllowCaptainEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllowCaptainEnrollmentMutation, UpdateAllowCaptainEnrollmentMutationVariables>(UpdateAllowCaptainEnrollmentDocument, options);
      }
export type UpdateAllowCaptainEnrollmentMutationHookResult = ReturnType<typeof useUpdateAllowCaptainEnrollmentMutation>;
export type UpdateAllowCaptainEnrollmentMutationResult = Apollo.MutationResult<UpdateAllowCaptainEnrollmentMutation>;
export type UpdateAllowCaptainEnrollmentMutationOptions = Apollo.BaseMutationOptions<UpdateAllowCaptainEnrollmentMutation, UpdateAllowCaptainEnrollmentMutationVariables>;
export const CreateSchoolDocument = gql`
    mutation createSchool($type: SchoolType!, $schoolName: String!, $address: String!, $city: String!, $state: String!, $zipCode: String!, $ncesId: String, $country: String, $phone: String, $varsityAssociationSlug: String) {
  createSchool(
    attributes: {type: $type, name: $schoolName, address: $address, city: $city, state: $state, zip: $zipCode, phone: $phone, ncesId: $ncesId, country: $country, varsityAssociationSlug: $varsityAssociationSlug}
  ) {
    id
  }
}
    `;
export type CreateSchoolMutationFn = Apollo.MutationFunction<CreateSchoolMutation, CreateSchoolMutationVariables>;

/**
 * __useCreateSchoolMutation__
 *
 * To run a mutation, you first call `useCreateSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolMutation, { data, loading, error }] = useCreateSchoolMutation({
 *   variables: {
 *      type: // value for 'type'
 *      schoolName: // value for 'schoolName'
 *      address: // value for 'address'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zipCode: // value for 'zipCode'
 *      ncesId: // value for 'ncesId'
 *      country: // value for 'country'
 *      phone: // value for 'phone'
 *      varsityAssociationSlug: // value for 'varsityAssociationSlug'
 *   },
 * });
 */
export function useCreateSchoolMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchoolMutation, CreateSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchoolMutation, CreateSchoolMutationVariables>(CreateSchoolDocument, options);
      }
export type CreateSchoolMutationHookResult = ReturnType<typeof useCreateSchoolMutation>;
export type CreateSchoolMutationResult = Apollo.MutationResult<CreateSchoolMutation>;
export type CreateSchoolMutationOptions = Apollo.BaseMutationOptions<CreateSchoolMutation, CreateSchoolMutationVariables>;
export const GetSchoolCoordinatesDocument = gql`
    query getSchoolCoordinates($id: UUID!) {
  school(id: $id) {
    id
    lat
    lon
  }
}
    `;

/**
 * __useGetSchoolCoordinatesQuery__
 *
 * To run a query within a React component, call `useGetSchoolCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolCoordinatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSchoolCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolCoordinatesQuery, GetSchoolCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolCoordinatesQuery, GetSchoolCoordinatesQueryVariables>(GetSchoolCoordinatesDocument, options);
      }
export function useGetSchoolCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolCoordinatesQuery, GetSchoolCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolCoordinatesQuery, GetSchoolCoordinatesQueryVariables>(GetSchoolCoordinatesDocument, options);
        }
export type GetSchoolCoordinatesQueryHookResult = ReturnType<typeof useGetSchoolCoordinatesQuery>;
export type GetSchoolCoordinatesLazyQueryHookResult = ReturnType<typeof useGetSchoolCoordinatesLazyQuery>;
export type GetSchoolCoordinatesQueryResult = Apollo.QueryResult<GetSchoolCoordinatesQuery, GetSchoolCoordinatesQueryVariables>;
export function refetchGetSchoolCoordinatesQuery(variables: GetSchoolCoordinatesQueryVariables) {
      return { query: GetSchoolCoordinatesDocument, variables: variables }
    }
export const GetLocalReferralSchoolsDocument = gql`
    query getLocalReferralSchools($offset: Int, $limit: Int, $filters: SchoolFiltersInput) {
  getSchoolsES(offset: $offset, limit: $limit, filters: $filters) {
    totalCount
    schools {
      id
      name
      logoUrl
      createdAt
      state
      teams: teamsByFilter(filters: {isCurrentlyEnrolled: true}) {
        id
        name
        esport {
          id
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocalReferralSchoolsQuery__
 *
 * To run a query within a React component, call `useGetLocalReferralSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalReferralSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalReferralSchoolsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetLocalReferralSchoolsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocalReferralSchoolsQuery, GetLocalReferralSchoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalReferralSchoolsQuery, GetLocalReferralSchoolsQueryVariables>(GetLocalReferralSchoolsDocument, options);
      }
export function useGetLocalReferralSchoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalReferralSchoolsQuery, GetLocalReferralSchoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalReferralSchoolsQuery, GetLocalReferralSchoolsQueryVariables>(GetLocalReferralSchoolsDocument, options);
        }
export type GetLocalReferralSchoolsQueryHookResult = ReturnType<typeof useGetLocalReferralSchoolsQuery>;
export type GetLocalReferralSchoolsLazyQueryHookResult = ReturnType<typeof useGetLocalReferralSchoolsLazyQuery>;
export type GetLocalReferralSchoolsQueryResult = Apollo.QueryResult<GetLocalReferralSchoolsQuery, GetLocalReferralSchoolsQueryVariables>;
export function refetchGetLocalReferralSchoolsQuery(variables?: GetLocalReferralSchoolsQueryVariables) {
      return { query: GetLocalReferralSchoolsDocument, variables: variables }
    }
export const GetSchoolTeamsAndMembersEffectiveAtRangeDocument = gql`
    query getSchoolTeamsAndMembersEffectiveAtRange($id: UUID!, $metaseasonId: UUID!, $effectiveAtRange: DateRangeInput!, $teamFilters: SchoolTeamFiltersInput!) {
  school(id: $id) {
    id
    teams: teamsByFilter(filters: $teamFilters) {
      id
      name
      leagues(metaseasonId: $metaseasonId) {
        id
        esport {
          id
          slug
        }
      }
      roster(effectiveAtRange: $effectiveAtRange) {
        id
        players {
          isCaptain
          user {
            id
            name
            avatarUrl
            assignedSeasonalAwards(metaseasonId: $metaseasonId) {
              id
              teamId
              awardType {
                id
                title
              }
            }
          }
          effectiveAt
          teamId
        }
      }
    }
  }
}
    `;

/**
 * __useGetSchoolTeamsAndMembersEffectiveAtRangeQuery__
 *
 * To run a query within a React component, call `useGetSchoolTeamsAndMembersEffectiveAtRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolTeamsAndMembersEffectiveAtRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolTeamsAndMembersEffectiveAtRangeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *      effectiveAtRange: // value for 'effectiveAtRange'
 *      teamFilters: // value for 'teamFilters'
 *   },
 * });
 */
export function useGetSchoolTeamsAndMembersEffectiveAtRangeQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolTeamsAndMembersEffectiveAtRangeQuery, GetSchoolTeamsAndMembersEffectiveAtRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolTeamsAndMembersEffectiveAtRangeQuery, GetSchoolTeamsAndMembersEffectiveAtRangeQueryVariables>(GetSchoolTeamsAndMembersEffectiveAtRangeDocument, options);
      }
export function useGetSchoolTeamsAndMembersEffectiveAtRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolTeamsAndMembersEffectiveAtRangeQuery, GetSchoolTeamsAndMembersEffectiveAtRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolTeamsAndMembersEffectiveAtRangeQuery, GetSchoolTeamsAndMembersEffectiveAtRangeQueryVariables>(GetSchoolTeamsAndMembersEffectiveAtRangeDocument, options);
        }
export type GetSchoolTeamsAndMembersEffectiveAtRangeQueryHookResult = ReturnType<typeof useGetSchoolTeamsAndMembersEffectiveAtRangeQuery>;
export type GetSchoolTeamsAndMembersEffectiveAtRangeLazyQueryHookResult = ReturnType<typeof useGetSchoolTeamsAndMembersEffectiveAtRangeLazyQuery>;
export type GetSchoolTeamsAndMembersEffectiveAtRangeQueryResult = Apollo.QueryResult<GetSchoolTeamsAndMembersEffectiveAtRangeQuery, GetSchoolTeamsAndMembersEffectiveAtRangeQueryVariables>;
export function refetchGetSchoolTeamsAndMembersEffectiveAtRangeQuery(variables: GetSchoolTeamsAndMembersEffectiveAtRangeQueryVariables) {
      return { query: GetSchoolTeamsAndMembersEffectiveAtRangeDocument, variables: variables }
    }
export const GetSchoolVarsityAssociationsDocument = gql`
    query getSchoolVarsityAssociations($id: UUID!) {
  school(id: $id) {
    id
    varsityAssociations {
      name
      slug
    }
  }
}
    `;

/**
 * __useGetSchoolVarsityAssociationsQuery__
 *
 * To run a query within a React component, call `useGetSchoolVarsityAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolVarsityAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolVarsityAssociationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSchoolVarsityAssociationsQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolVarsityAssociationsQuery, GetSchoolVarsityAssociationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolVarsityAssociationsQuery, GetSchoolVarsityAssociationsQueryVariables>(GetSchoolVarsityAssociationsDocument, options);
      }
export function useGetSchoolVarsityAssociationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolVarsityAssociationsQuery, GetSchoolVarsityAssociationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolVarsityAssociationsQuery, GetSchoolVarsityAssociationsQueryVariables>(GetSchoolVarsityAssociationsDocument, options);
        }
export type GetSchoolVarsityAssociationsQueryHookResult = ReturnType<typeof useGetSchoolVarsityAssociationsQuery>;
export type GetSchoolVarsityAssociationsLazyQueryHookResult = ReturnType<typeof useGetSchoolVarsityAssociationsLazyQuery>;
export type GetSchoolVarsityAssociationsQueryResult = Apollo.QueryResult<GetSchoolVarsityAssociationsQuery, GetSchoolVarsityAssociationsQueryVariables>;
export function refetchGetSchoolVarsityAssociationsQuery(variables: GetSchoolVarsityAssociationsQueryVariables) {
      return { query: GetSchoolVarsityAssociationsDocument, variables: variables }
    }
export const GetMySchoolTeamsDocument = gql`
    query getMySchoolTeams($id: UUID!, $metaseasonId: UUID!) {
  school(id: $id) {
    id
    competitionGroup
    teams {
      id
      name
      deletedAt
      isEnrolledInCurrentMetaseason
      esport {
        id
        name
        slug
        rating
      }
      leagues(metaseasonId: $metaseasonId) {
        id
        name
        displayName
      }
      phaseResult {
        id
        matchesWon
        matchesLost
        phase {
          id
          name
          season {
            id
            metaseason {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMySchoolTeamsQuery__
 *
 * To run a query within a React component, call `useGetMySchoolTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySchoolTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySchoolTeamsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetMySchoolTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetMySchoolTeamsQuery, GetMySchoolTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySchoolTeamsQuery, GetMySchoolTeamsQueryVariables>(GetMySchoolTeamsDocument, options);
      }
export function useGetMySchoolTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySchoolTeamsQuery, GetMySchoolTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySchoolTeamsQuery, GetMySchoolTeamsQueryVariables>(GetMySchoolTeamsDocument, options);
        }
export type GetMySchoolTeamsQueryHookResult = ReturnType<typeof useGetMySchoolTeamsQuery>;
export type GetMySchoolTeamsLazyQueryHookResult = ReturnType<typeof useGetMySchoolTeamsLazyQuery>;
export type GetMySchoolTeamsQueryResult = Apollo.QueryResult<GetMySchoolTeamsQuery, GetMySchoolTeamsQueryVariables>;
export function refetchGetMySchoolTeamsQuery(variables: GetMySchoolTeamsQueryVariables) {
      return { query: GetMySchoolTeamsDocument, variables: variables }
    }
export const AddLeagueToSchoolDocument = gql`
    mutation addLeagueToSchool($schoolId: UUID!, $leagueId: UUID!) {
  addLeagueToSchool(schoolId: $schoolId, leagueId: $leagueId) {
    success
  }
}
    `;
export type AddLeagueToSchoolMutationFn = Apollo.MutationFunction<AddLeagueToSchoolMutation, AddLeagueToSchoolMutationVariables>;

/**
 * __useAddLeagueToSchoolMutation__
 *
 * To run a mutation, you first call `useAddLeagueToSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLeagueToSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLeagueToSchoolMutation, { data, loading, error }] = useAddLeagueToSchoolMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useAddLeagueToSchoolMutation(baseOptions?: Apollo.MutationHookOptions<AddLeagueToSchoolMutation, AddLeagueToSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLeagueToSchoolMutation, AddLeagueToSchoolMutationVariables>(AddLeagueToSchoolDocument, options);
      }
export type AddLeagueToSchoolMutationHookResult = ReturnType<typeof useAddLeagueToSchoolMutation>;
export type AddLeagueToSchoolMutationResult = Apollo.MutationResult<AddLeagueToSchoolMutation>;
export type AddLeagueToSchoolMutationOptions = Apollo.BaseMutationOptions<AddLeagueToSchoolMutation, AddLeagueToSchoolMutationVariables>;
export const RemoveLeagueFromSchoolDocument = gql`
    mutation removeLeagueFromSchool($schoolId: UUID!, $leagueId: UUID!) {
  removeLeagueFromSchool(schoolId: $schoolId, leagueId: $leagueId) {
    success
  }
}
    `;
export type RemoveLeagueFromSchoolMutationFn = Apollo.MutationFunction<RemoveLeagueFromSchoolMutation, RemoveLeagueFromSchoolMutationVariables>;

/**
 * __useRemoveLeagueFromSchoolMutation__
 *
 * To run a mutation, you first call `useRemoveLeagueFromSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLeagueFromSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLeagueFromSchoolMutation, { data, loading, error }] = useRemoveLeagueFromSchoolMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useRemoveLeagueFromSchoolMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLeagueFromSchoolMutation, RemoveLeagueFromSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLeagueFromSchoolMutation, RemoveLeagueFromSchoolMutationVariables>(RemoveLeagueFromSchoolDocument, options);
      }
export type RemoveLeagueFromSchoolMutationHookResult = ReturnType<typeof useRemoveLeagueFromSchoolMutation>;
export type RemoveLeagueFromSchoolMutationResult = Apollo.MutationResult<RemoveLeagueFromSchoolMutation>;
export type RemoveLeagueFromSchoolMutationOptions = Apollo.BaseMutationOptions<RemoveLeagueFromSchoolMutation, RemoveLeagueFromSchoolMutationVariables>;
export const AddLeagueToSchoolsBulkDocument = gql`
    mutation addLeagueToSchoolsBulk($leagueId: UUID!, $states: [String!]!, $varsityAssociationSlugs: [String!]!) {
  addLeagueToSchoolsBulk(
    leagueId: $leagueId
    states: $states
    varsityAssociationSlugs: $varsityAssociationSlugs
  ) {
    success
    total
  }
  addLeagueToLeagueGroups(
    leagueId: $leagueId
    states: $states
    varsityAssociationSlugs: $varsityAssociationSlugs
  ) {
    success
    total
  }
}
    `;
export type AddLeagueToSchoolsBulkMutationFn = Apollo.MutationFunction<AddLeagueToSchoolsBulkMutation, AddLeagueToSchoolsBulkMutationVariables>;

/**
 * __useAddLeagueToSchoolsBulkMutation__
 *
 * To run a mutation, you first call `useAddLeagueToSchoolsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLeagueToSchoolsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLeagueToSchoolsBulkMutation, { data, loading, error }] = useAddLeagueToSchoolsBulkMutation({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *      states: // value for 'states'
 *      varsityAssociationSlugs: // value for 'varsityAssociationSlugs'
 *   },
 * });
 */
export function useAddLeagueToSchoolsBulkMutation(baseOptions?: Apollo.MutationHookOptions<AddLeagueToSchoolsBulkMutation, AddLeagueToSchoolsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLeagueToSchoolsBulkMutation, AddLeagueToSchoolsBulkMutationVariables>(AddLeagueToSchoolsBulkDocument, options);
      }
export type AddLeagueToSchoolsBulkMutationHookResult = ReturnType<typeof useAddLeagueToSchoolsBulkMutation>;
export type AddLeagueToSchoolsBulkMutationResult = Apollo.MutationResult<AddLeagueToSchoolsBulkMutation>;
export type AddLeagueToSchoolsBulkMutationOptions = Apollo.BaseMutationOptions<AddLeagueToSchoolsBulkMutation, AddLeagueToSchoolsBulkMutationVariables>;
export const RemoveLeagueFromSchoolsBulkDocument = gql`
    mutation removeLeagueFromSchoolsBulk($leagueId: UUID!, $states: [String!]!, $varsityAssociationSlugs: [String!]!) {
  removeLeagueFromSchoolsBulk(
    leagueId: $leagueId
    states: $states
    varsityAssociationSlugs: $varsityAssociationSlugs
  ) {
    success
  }
  removeLeagueFromLeagueGroups(
    leagueId: $leagueId
    states: $states
    varsityAssociationSlugs: $varsityAssociationSlugs
  ) {
    success
  }
}
    `;
export type RemoveLeagueFromSchoolsBulkMutationFn = Apollo.MutationFunction<RemoveLeagueFromSchoolsBulkMutation, RemoveLeagueFromSchoolsBulkMutationVariables>;

/**
 * __useRemoveLeagueFromSchoolsBulkMutation__
 *
 * To run a mutation, you first call `useRemoveLeagueFromSchoolsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLeagueFromSchoolsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLeagueFromSchoolsBulkMutation, { data, loading, error }] = useRemoveLeagueFromSchoolsBulkMutation({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *      states: // value for 'states'
 *      varsityAssociationSlugs: // value for 'varsityAssociationSlugs'
 *   },
 * });
 */
export function useRemoveLeagueFromSchoolsBulkMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLeagueFromSchoolsBulkMutation, RemoveLeagueFromSchoolsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLeagueFromSchoolsBulkMutation, RemoveLeagueFromSchoolsBulkMutationVariables>(RemoveLeagueFromSchoolsBulkDocument, options);
      }
export type RemoveLeagueFromSchoolsBulkMutationHookResult = ReturnType<typeof useRemoveLeagueFromSchoolsBulkMutation>;
export type RemoveLeagueFromSchoolsBulkMutationResult = Apollo.MutationResult<RemoveLeagueFromSchoolsBulkMutation>;
export type RemoveLeagueFromSchoolsBulkMutationOptions = Apollo.BaseMutationOptions<RemoveLeagueFromSchoolsBulkMutation, RemoveLeagueFromSchoolsBulkMutationVariables>;
export const AvailableLeagueEsportsForSchoolDocument = gql`
    query availableLeagueEsportsForSchool($schoolId: UUID!) {
  school(id: $schoolId) {
    id
    availableLeagueEsports {
      id
      name
      slug
    }
  }
}
    `;

/**
 * __useAvailableLeagueEsportsForSchoolQuery__
 *
 * To run a query within a React component, call `useAvailableLeagueEsportsForSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableLeagueEsportsForSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableLeagueEsportsForSchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useAvailableLeagueEsportsForSchoolQuery(baseOptions: Apollo.QueryHookOptions<AvailableLeagueEsportsForSchoolQuery, AvailableLeagueEsportsForSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableLeagueEsportsForSchoolQuery, AvailableLeagueEsportsForSchoolQueryVariables>(AvailableLeagueEsportsForSchoolDocument, options);
      }
export function useAvailableLeagueEsportsForSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableLeagueEsportsForSchoolQuery, AvailableLeagueEsportsForSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableLeagueEsportsForSchoolQuery, AvailableLeagueEsportsForSchoolQueryVariables>(AvailableLeagueEsportsForSchoolDocument, options);
        }
export type AvailableLeagueEsportsForSchoolQueryHookResult = ReturnType<typeof useAvailableLeagueEsportsForSchoolQuery>;
export type AvailableLeagueEsportsForSchoolLazyQueryHookResult = ReturnType<typeof useAvailableLeagueEsportsForSchoolLazyQuery>;
export type AvailableLeagueEsportsForSchoolQueryResult = Apollo.QueryResult<AvailableLeagueEsportsForSchoolQuery, AvailableLeagueEsportsForSchoolQueryVariables>;
export function refetchAvailableLeagueEsportsForSchoolQuery(variables: AvailableLeagueEsportsForSchoolQueryVariables) {
      return { query: AvailableLeagueEsportsForSchoolDocument, variables: variables }
    }
export const ScrimmageRequestDocument = gql`
    query scrimmageRequest($id: UUID!, $schoolId: UUID!) {
  scrimmageRequest(id: $id) {
    id
    bestOf
    seriesBestOf
    rating
    startsAt
    status
    matchId
    esport {
      id
      slug
      name
    }
    requestedBy {
      id
      email
      phone
      avatarUrl
      name
      roles {
        roleName
        userId
        resourceId
        resourceType
      }
      userProviderAccounts {
        id
        userId
        providerName
        providerAccountId
        providerDisplayName
        providerIntegrationType
      }
    }
    requestingTeam {
      id
      name
      school {
        id
        logoUrl
        name
        slug
      }
    }
    opposingTeam {
      id
      name
      school {
        id
        logoUrl
        name
        slug
      }
    }
    myAvailableTeams(schoolId: $schoolId) {
      id
      name
    }
    league {
      id
      timezone
    }
  }
}
    `;

/**
 * __useScrimmageRequestQuery__
 *
 * To run a query within a React component, call `useScrimmageRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useScrimmageRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScrimmageRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useScrimmageRequestQuery(baseOptions: Apollo.QueryHookOptions<ScrimmageRequestQuery, ScrimmageRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScrimmageRequestQuery, ScrimmageRequestQueryVariables>(ScrimmageRequestDocument, options);
      }
export function useScrimmageRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScrimmageRequestQuery, ScrimmageRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScrimmageRequestQuery, ScrimmageRequestQueryVariables>(ScrimmageRequestDocument, options);
        }
export type ScrimmageRequestQueryHookResult = ReturnType<typeof useScrimmageRequestQuery>;
export type ScrimmageRequestLazyQueryHookResult = ReturnType<typeof useScrimmageRequestLazyQuery>;
export type ScrimmageRequestQueryResult = Apollo.QueryResult<ScrimmageRequestQuery, ScrimmageRequestQueryVariables>;
export function refetchScrimmageRequestQuery(variables: ScrimmageRequestQueryVariables) {
      return { query: ScrimmageRequestDocument, variables: variables }
    }
export const FindRecommendedTeamsDocument = gql`
    query findRecommendedTeams($teamId: UUID!, $limit: Int!, $offset: Int!, $filters: TeamFiltersInput) {
  findRecommendedTeams(
    teamId: $teamId
    filters: $filters
    limit: $limit
    offset: $offset
  ) {
    team {
      id
      name
      state
      school {
        id
        name
        logoUrl
      }
      esport {
        id
        slug
        name
        rating
      }
      phaseResult {
        id
        rank
      }
    }
    recommendationPercent
  }
}
    `;

/**
 * __useFindRecommendedTeamsQuery__
 *
 * To run a query within a React component, call `useFindRecommendedTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRecommendedTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRecommendedTeamsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindRecommendedTeamsQuery(baseOptions: Apollo.QueryHookOptions<FindRecommendedTeamsQuery, FindRecommendedTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRecommendedTeamsQuery, FindRecommendedTeamsQueryVariables>(FindRecommendedTeamsDocument, options);
      }
export function useFindRecommendedTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRecommendedTeamsQuery, FindRecommendedTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRecommendedTeamsQuery, FindRecommendedTeamsQueryVariables>(FindRecommendedTeamsDocument, options);
        }
export type FindRecommendedTeamsQueryHookResult = ReturnType<typeof useFindRecommendedTeamsQuery>;
export type FindRecommendedTeamsLazyQueryHookResult = ReturnType<typeof useFindRecommendedTeamsLazyQuery>;
export type FindRecommendedTeamsQueryResult = Apollo.QueryResult<FindRecommendedTeamsQuery, FindRecommendedTeamsQueryVariables>;
export function refetchFindRecommendedTeamsQuery(variables: FindRecommendedTeamsQueryVariables) {
      return { query: FindRecommendedTeamsDocument, variables: variables }
    }
export const FindRecommendedTeamsForScrimmageDocument = gql`
    query findRecommendedTeamsForScrimmage($teamId: UUID!, $limit: Int!, $filters: TeamFiltersInput) {
  findRecommendedTeamsForScrimmage(
    teamId: $teamId
    filters: $filters
    limit: $limit
  ) {
    id
    name
    state
    school {
      id
      name
      logoUrl
    }
    esport {
      id
      slug
      name
      rating
    }
    phaseResult {
      id
      rank
    }
  }
}
    `;

/**
 * __useFindRecommendedTeamsForScrimmageQuery__
 *
 * To run a query within a React component, call `useFindRecommendedTeamsForScrimmageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRecommendedTeamsForScrimmageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRecommendedTeamsForScrimmageQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFindRecommendedTeamsForScrimmageQuery(baseOptions: Apollo.QueryHookOptions<FindRecommendedTeamsForScrimmageQuery, FindRecommendedTeamsForScrimmageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindRecommendedTeamsForScrimmageQuery, FindRecommendedTeamsForScrimmageQueryVariables>(FindRecommendedTeamsForScrimmageDocument, options);
      }
export function useFindRecommendedTeamsForScrimmageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindRecommendedTeamsForScrimmageQuery, FindRecommendedTeamsForScrimmageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindRecommendedTeamsForScrimmageQuery, FindRecommendedTeamsForScrimmageQueryVariables>(FindRecommendedTeamsForScrimmageDocument, options);
        }
export type FindRecommendedTeamsForScrimmageQueryHookResult = ReturnType<typeof useFindRecommendedTeamsForScrimmageQuery>;
export type FindRecommendedTeamsForScrimmageLazyQueryHookResult = ReturnType<typeof useFindRecommendedTeamsForScrimmageLazyQuery>;
export type FindRecommendedTeamsForScrimmageQueryResult = Apollo.QueryResult<FindRecommendedTeamsForScrimmageQuery, FindRecommendedTeamsForScrimmageQueryVariables>;
export function refetchFindRecommendedTeamsForScrimmageQuery(variables: FindRecommendedTeamsForScrimmageQueryVariables) {
      return { query: FindRecommendedTeamsForScrimmageDocument, variables: variables }
    }
export const GetScrimmageRequestsDocument = gql`
    query getScrimmageRequests($offset: Int, $limit: Int!, $filter: ScrimmageRequestFilter) {
  scrimmageRequests(offset: $offset, limit: $limit, filter: $filter) {
    total
    result {
      id
      requestingTeam {
        id
        name
        school {
          id
          name
          logoUrl
          slug
        }
      }
      opposingTeam {
        id
        name
        school {
          id
          name
          logoUrl
          slug
        }
      }
      esport {
        id
        slug
      }
      league {
        id
        timezone
      }
      status
      startsAt
      bestOf
      esportId
      requestingTeamId
      requestedById
      createdAt
      rating
    }
  }
}
    `;

/**
 * __useGetScrimmageRequestsQuery__
 *
 * To run a query within a React component, call `useGetScrimmageRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScrimmageRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScrimmageRequestsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetScrimmageRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetScrimmageRequestsQuery, GetScrimmageRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScrimmageRequestsQuery, GetScrimmageRequestsQueryVariables>(GetScrimmageRequestsDocument, options);
      }
export function useGetScrimmageRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScrimmageRequestsQuery, GetScrimmageRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScrimmageRequestsQuery, GetScrimmageRequestsQueryVariables>(GetScrimmageRequestsDocument, options);
        }
export type GetScrimmageRequestsQueryHookResult = ReturnType<typeof useGetScrimmageRequestsQuery>;
export type GetScrimmageRequestsLazyQueryHookResult = ReturnType<typeof useGetScrimmageRequestsLazyQuery>;
export type GetScrimmageRequestsQueryResult = Apollo.QueryResult<GetScrimmageRequestsQuery, GetScrimmageRequestsQueryVariables>;
export function refetchGetScrimmageRequestsQuery(variables: GetScrimmageRequestsQueryVariables) {
      return { query: GetScrimmageRequestsDocument, variables: variables }
    }
export const RequestScrimmageDocument = gql`
    mutation requestScrimmage($input: RequestScrimmageInput!) {
  requestScrimmage(input: $input) {
    scrimmageLink
    scrimmageRequest {
      id
    }
  }
}
    `;
export type RequestScrimmageMutationFn = Apollo.MutationFunction<RequestScrimmageMutation, RequestScrimmageMutationVariables>;

/**
 * __useRequestScrimmageMutation__
 *
 * To run a mutation, you first call `useRequestScrimmageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestScrimmageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestScrimmageMutation, { data, loading, error }] = useRequestScrimmageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestScrimmageMutation(baseOptions?: Apollo.MutationHookOptions<RequestScrimmageMutation, RequestScrimmageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestScrimmageMutation, RequestScrimmageMutationVariables>(RequestScrimmageDocument, options);
      }
export type RequestScrimmageMutationHookResult = ReturnType<typeof useRequestScrimmageMutation>;
export type RequestScrimmageMutationResult = Apollo.MutationResult<RequestScrimmageMutation>;
export type RequestScrimmageMutationOptions = Apollo.BaseMutationOptions<RequestScrimmageMutation, RequestScrimmageMutationVariables>;
export const CreateScrimmageDocument = gql`
    mutation createScrimmage($input: RequestScrimmageInput!) {
  createScrimmage(input: $input) {
    scrimmageLink
    scrimmageRequest {
      id
    }
  }
}
    `;
export type CreateScrimmageMutationFn = Apollo.MutationFunction<CreateScrimmageMutation, CreateScrimmageMutationVariables>;

/**
 * __useCreateScrimmageMutation__
 *
 * To run a mutation, you first call `useCreateScrimmageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScrimmageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScrimmageMutation, { data, loading, error }] = useCreateScrimmageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScrimmageMutation(baseOptions?: Apollo.MutationHookOptions<CreateScrimmageMutation, CreateScrimmageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScrimmageMutation, CreateScrimmageMutationVariables>(CreateScrimmageDocument, options);
      }
export type CreateScrimmageMutationHookResult = ReturnType<typeof useCreateScrimmageMutation>;
export type CreateScrimmageMutationResult = Apollo.MutationResult<CreateScrimmageMutation>;
export type CreateScrimmageMutationOptions = Apollo.BaseMutationOptions<CreateScrimmageMutation, CreateScrimmageMutationVariables>;
export const CancelScrimmageDocument = gql`
    mutation cancelScrimmage($input: CancelScrimmageInput!) {
  cancelScrimmage(input: $input) {
    success
    canceledScrimmageIds
  }
}
    `;
export type CancelScrimmageMutationFn = Apollo.MutationFunction<CancelScrimmageMutation, CancelScrimmageMutationVariables>;

/**
 * __useCancelScrimmageMutation__
 *
 * To run a mutation, you first call `useCancelScrimmageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScrimmageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScrimmageMutation, { data, loading, error }] = useCancelScrimmageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelScrimmageMutation(baseOptions?: Apollo.MutationHookOptions<CancelScrimmageMutation, CancelScrimmageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelScrimmageMutation, CancelScrimmageMutationVariables>(CancelScrimmageDocument, options);
      }
export type CancelScrimmageMutationHookResult = ReturnType<typeof useCancelScrimmageMutation>;
export type CancelScrimmageMutationResult = Apollo.MutationResult<CancelScrimmageMutation>;
export type CancelScrimmageMutationOptions = Apollo.BaseMutationOptions<CancelScrimmageMutation, CancelScrimmageMutationVariables>;
export const DeclineScrimmageDocument = gql`
    mutation declineScrimmage($input: CancelScrimmageInput!) {
  declineScrimmage(input: $input) {
    success
  }
}
    `;
export type DeclineScrimmageMutationFn = Apollo.MutationFunction<DeclineScrimmageMutation, DeclineScrimmageMutationVariables>;

/**
 * __useDeclineScrimmageMutation__
 *
 * To run a mutation, you first call `useDeclineScrimmageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineScrimmageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineScrimmageMutation, { data, loading, error }] = useDeclineScrimmageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineScrimmageMutation(baseOptions?: Apollo.MutationHookOptions<DeclineScrimmageMutation, DeclineScrimmageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineScrimmageMutation, DeclineScrimmageMutationVariables>(DeclineScrimmageDocument, options);
      }
export type DeclineScrimmageMutationHookResult = ReturnType<typeof useDeclineScrimmageMutation>;
export type DeclineScrimmageMutationResult = Apollo.MutationResult<DeclineScrimmageMutation>;
export type DeclineScrimmageMutationOptions = Apollo.BaseMutationOptions<DeclineScrimmageMutation, DeclineScrimmageMutationVariables>;
export const JoinScrimmageDocument = gql`
    mutation joinScrimmage($input: JoinScrimmageInput!) {
  joinScrimmage(input: $input) {
    success
  }
}
    `;
export type JoinScrimmageMutationFn = Apollo.MutationFunction<JoinScrimmageMutation, JoinScrimmageMutationVariables>;

/**
 * __useJoinScrimmageMutation__
 *
 * To run a mutation, you first call `useJoinScrimmageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinScrimmageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinScrimmageMutation, { data, loading, error }] = useJoinScrimmageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinScrimmageMutation(baseOptions?: Apollo.MutationHookOptions<JoinScrimmageMutation, JoinScrimmageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinScrimmageMutation, JoinScrimmageMutationVariables>(JoinScrimmageDocument, options);
      }
export type JoinScrimmageMutationHookResult = ReturnType<typeof useJoinScrimmageMutation>;
export type JoinScrimmageMutationResult = Apollo.MutationResult<JoinScrimmageMutation>;
export type JoinScrimmageMutationOptions = Apollo.BaseMutationOptions<JoinScrimmageMutation, JoinScrimmageMutationVariables>;
export const GetPlayoffTemplateDocument = gql`
    query getPlayoffTemplate($id: UUID!) {
  seasonPlayoffTemplate(id: $id) {
    id
    name
    generationDate
    seedingDate
    phase {
      id
      name
      description
      status
      startsAt
      endsAt
      format
      mode
      bestOf
      seriesBestOf
      bracketSize
      type
      slots {
        id
        name
        status
        bestOf
        seriesBestOf
        scheduleMatchesAt
        startsAt
        isStartsAtHidden
        fortniteEventWindowId
        ordinal
      }
      fortniteEventId
      maxTeamsPerSchool
      minutesBeforeMatchToLockInSeries
      slug
      survivalAdvancementPercentage
      survivalAdvancementCount
      minSlotParticipation
      maxSlotParticipation
      shouldSendPlayoffNotification
      autoScheduleBracket
    }
    seasonPlayoffTemplateBestOfs {
      id
      esportId
      esport {
        id
        name
      }
      bestOf
    }
  }
}
    `;

/**
 * __useGetPlayoffTemplateQuery__
 *
 * To run a query within a React component, call `useGetPlayoffTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayoffTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayoffTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlayoffTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetPlayoffTemplateQuery, GetPlayoffTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayoffTemplateQuery, GetPlayoffTemplateQueryVariables>(GetPlayoffTemplateDocument, options);
      }
export function useGetPlayoffTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayoffTemplateQuery, GetPlayoffTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayoffTemplateQuery, GetPlayoffTemplateQueryVariables>(GetPlayoffTemplateDocument, options);
        }
export type GetPlayoffTemplateQueryHookResult = ReturnType<typeof useGetPlayoffTemplateQuery>;
export type GetPlayoffTemplateLazyQueryHookResult = ReturnType<typeof useGetPlayoffTemplateLazyQuery>;
export type GetPlayoffTemplateQueryResult = Apollo.QueryResult<GetPlayoffTemplateQuery, GetPlayoffTemplateQueryVariables>;
export function refetchGetPlayoffTemplateQuery(variables: GetPlayoffTemplateQueryVariables) {
      return { query: GetPlayoffTemplateDocument, variables: variables }
    }
export const GetPlayoffTemplatesDocument = gql`
    query getPlayoffTemplates {
  seasonPlayoffTemplates {
    id
    name
    generationDate
    seedingDate
    seasonPlayoffTemplateBestOfs {
      esportId
      esport {
        id
        name
      }
      bestOf
    }
  }
}
    `;

/**
 * __useGetPlayoffTemplatesQuery__
 *
 * To run a query within a React component, call `useGetPlayoffTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayoffTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayoffTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlayoffTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetPlayoffTemplatesQuery, GetPlayoffTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayoffTemplatesQuery, GetPlayoffTemplatesQueryVariables>(GetPlayoffTemplatesDocument, options);
      }
export function useGetPlayoffTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayoffTemplatesQuery, GetPlayoffTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayoffTemplatesQuery, GetPlayoffTemplatesQueryVariables>(GetPlayoffTemplatesDocument, options);
        }
export type GetPlayoffTemplatesQueryHookResult = ReturnType<typeof useGetPlayoffTemplatesQuery>;
export type GetPlayoffTemplatesLazyQueryHookResult = ReturnType<typeof useGetPlayoffTemplatesLazyQuery>;
export type GetPlayoffTemplatesQueryResult = Apollo.QueryResult<GetPlayoffTemplatesQuery, GetPlayoffTemplatesQueryVariables>;
export function refetchGetPlayoffTemplatesQuery(variables?: GetPlayoffTemplatesQueryVariables) {
      return { query: GetPlayoffTemplatesDocument, variables: variables }
    }
export const CreateSeasonPlayoffTemplateDocument = gql`
    mutation createSeasonPlayoffTemplate($input: SeasonPlayoffTemplateInsertAttributes!) {
  createSeasonPlayoffTemplate(input: $input) {
    id
  }
}
    `;
export type CreateSeasonPlayoffTemplateMutationFn = Apollo.MutationFunction<CreateSeasonPlayoffTemplateMutation, CreateSeasonPlayoffTemplateMutationVariables>;

/**
 * __useCreateSeasonPlayoffTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSeasonPlayoffTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeasonPlayoffTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeasonPlayoffTemplateMutation, { data, loading, error }] = useCreateSeasonPlayoffTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeasonPlayoffTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateSeasonPlayoffTemplateMutation, CreateSeasonPlayoffTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSeasonPlayoffTemplateMutation, CreateSeasonPlayoffTemplateMutationVariables>(CreateSeasonPlayoffTemplateDocument, options);
      }
export type CreateSeasonPlayoffTemplateMutationHookResult = ReturnType<typeof useCreateSeasonPlayoffTemplateMutation>;
export type CreateSeasonPlayoffTemplateMutationResult = Apollo.MutationResult<CreateSeasonPlayoffTemplateMutation>;
export type CreateSeasonPlayoffTemplateMutationOptions = Apollo.BaseMutationOptions<CreateSeasonPlayoffTemplateMutation, CreateSeasonPlayoffTemplateMutationVariables>;
export const UpdateSeasonPlayoffTemplateDocument = gql`
    mutation updateSeasonPlayoffTemplate($input: SeasonPlayoffTemplateUpdateAttributes!) {
  updateSeasonPlayoffTemplate(input: $input) {
    id
  }
}
    `;
export type UpdateSeasonPlayoffTemplateMutationFn = Apollo.MutationFunction<UpdateSeasonPlayoffTemplateMutation, UpdateSeasonPlayoffTemplateMutationVariables>;

/**
 * __useUpdateSeasonPlayoffTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSeasonPlayoffTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeasonPlayoffTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeasonPlayoffTemplateMutation, { data, loading, error }] = useUpdateSeasonPlayoffTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSeasonPlayoffTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeasonPlayoffTemplateMutation, UpdateSeasonPlayoffTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeasonPlayoffTemplateMutation, UpdateSeasonPlayoffTemplateMutationVariables>(UpdateSeasonPlayoffTemplateDocument, options);
      }
export type UpdateSeasonPlayoffTemplateMutationHookResult = ReturnType<typeof useUpdateSeasonPlayoffTemplateMutation>;
export type UpdateSeasonPlayoffTemplateMutationResult = Apollo.MutationResult<UpdateSeasonPlayoffTemplateMutation>;
export type UpdateSeasonPlayoffTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateSeasonPlayoffTemplateMutation, UpdateSeasonPlayoffTemplateMutationVariables>;
export const BulkCreateSeasonDocument = gql`
    mutation bulkCreateSeason($bulkSeasonSchedule: BulkSeasonCreateInput!) {
  bulkCreateSeason(bulkSeasonSchedule: $bulkSeasonSchedule) {
    jobId
  }
}
    `;
export type BulkCreateSeasonMutationFn = Apollo.MutationFunction<BulkCreateSeasonMutation, BulkCreateSeasonMutationVariables>;

/**
 * __useBulkCreateSeasonMutation__
 *
 * To run a mutation, you first call `useBulkCreateSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateSeasonMutation, { data, loading, error }] = useBulkCreateSeasonMutation({
 *   variables: {
 *      bulkSeasonSchedule: // value for 'bulkSeasonSchedule'
 *   },
 * });
 */
export function useBulkCreateSeasonMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateSeasonMutation, BulkCreateSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateSeasonMutation, BulkCreateSeasonMutationVariables>(BulkCreateSeasonDocument, options);
      }
export type BulkCreateSeasonMutationHookResult = ReturnType<typeof useBulkCreateSeasonMutation>;
export type BulkCreateSeasonMutationResult = Apollo.MutationResult<BulkCreateSeasonMutation>;
export type BulkCreateSeasonMutationOptions = Apollo.BaseMutationOptions<BulkCreateSeasonMutation, BulkCreateSeasonMutationVariables>;
export const BulkEditSeasonDocument = gql`
    mutation bulkEditSeason($bulkEditSeasonInput: BulkEditSeasonInput!) {
  bulkEditSeason(input: $bulkEditSeasonInput) {
    jobId
  }
}
    `;
export type BulkEditSeasonMutationFn = Apollo.MutationFunction<BulkEditSeasonMutation, BulkEditSeasonMutationVariables>;

/**
 * __useBulkEditSeasonMutation__
 *
 * To run a mutation, you first call `useBulkEditSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEditSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEditSeasonMutation, { data, loading, error }] = useBulkEditSeasonMutation({
 *   variables: {
 *      bulkEditSeasonInput: // value for 'bulkEditSeasonInput'
 *   },
 * });
 */
export function useBulkEditSeasonMutation(baseOptions?: Apollo.MutationHookOptions<BulkEditSeasonMutation, BulkEditSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkEditSeasonMutation, BulkEditSeasonMutationVariables>(BulkEditSeasonDocument, options);
      }
export type BulkEditSeasonMutationHookResult = ReturnType<typeof useBulkEditSeasonMutation>;
export type BulkEditSeasonMutationResult = Apollo.MutationResult<BulkEditSeasonMutation>;
export type BulkEditSeasonMutationOptions = Apollo.BaseMutationOptions<BulkEditSeasonMutation, BulkEditSeasonMutationVariables>;
export const CreateSeasonDocument = gql`
    mutation createSeason($seasonSchedule: SeasonScheduleInput!) {
  createSeason(seasonSchedule: $seasonSchedule) {
    id
    name
  }
}
    `;
export type CreateSeasonMutationFn = Apollo.MutationFunction<CreateSeasonMutation, CreateSeasonMutationVariables>;

/**
 * __useCreateSeasonMutation__
 *
 * To run a mutation, you first call `useCreateSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeasonMutation, { data, loading, error }] = useCreateSeasonMutation({
 *   variables: {
 *      seasonSchedule: // value for 'seasonSchedule'
 *   },
 * });
 */
export function useCreateSeasonMutation(baseOptions?: Apollo.MutationHookOptions<CreateSeasonMutation, CreateSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSeasonMutation, CreateSeasonMutationVariables>(CreateSeasonDocument, options);
      }
export type CreateSeasonMutationHookResult = ReturnType<typeof useCreateSeasonMutation>;
export type CreateSeasonMutationResult = Apollo.MutationResult<CreateSeasonMutation>;
export type CreateSeasonMutationOptions = Apollo.BaseMutationOptions<CreateSeasonMutation, CreateSeasonMutationVariables>;
export const UpdateSeasonDocument = gql`
    mutation updateSeason($id: UUID!, $seasonSchedule: UpdateSeasonScheduleInput) {
  updateSeason(id: $id, seasonSchedule: $seasonSchedule) {
    id
    name
    type
    slug
    status
    startsAt
    endsAt
    rostersLockAt
    metaseasonId
    registrationStartsAt
    teamRegistrationEndsAt
    teamDeregistrationEndsAt
    playerRegistrationEndsAt
    playerDeregistrationEndsAt
    suggestedRegistrationEndsAt
    type
    areBreakWeekSlotExclusionWindowsEnabled
    seasonPlayoffTemplateId
    overridePlayoffGenerationDate
    overridePlayoffSeedingDate
    playvsScoreEnabled
    eventConfig {
      eventDetails
      isHidden
      maxAge
      maxTeamsAllowed
      minAge
      prizeDetails
      surveyId
    }
  }
}
    `;
export type UpdateSeasonMutationFn = Apollo.MutationFunction<UpdateSeasonMutation, UpdateSeasonMutationVariables>;

/**
 * __useUpdateSeasonMutation__
 *
 * To run a mutation, you first call `useUpdateSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeasonMutation, { data, loading, error }] = useUpdateSeasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      seasonSchedule: // value for 'seasonSchedule'
 *   },
 * });
 */
export function useUpdateSeasonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeasonMutation, UpdateSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeasonMutation, UpdateSeasonMutationVariables>(UpdateSeasonDocument, options);
      }
export type UpdateSeasonMutationHookResult = ReturnType<typeof useUpdateSeasonMutation>;
export type UpdateSeasonMutationResult = Apollo.MutationResult<UpdateSeasonMutation>;
export type UpdateSeasonMutationOptions = Apollo.BaseMutationOptions<UpdateSeasonMutation, UpdateSeasonMutationVariables>;
export const GetSeasonDocument = gql`
    query getSeason($id: UUID!) {
  season(id: $id) {
    id
    name
    type
    slug
    status
    startsAt
    endsAt
    rostersLockAt
    metaseasonId
    registrationStartsAt
    teamRegistrationEndsAt
    teamDeregistrationEndsAt
    playerRegistrationEndsAt
    playerDeregistrationEndsAt
    maxTeamsPerSchool
    suggestedRegistrationEndsAt
    type
    playvsScoreEnabled
    eventConfig {
      eventDetails
      isHidden
      maxAge
      maxTeamsAllowed
      minAge
      prizeDetails
      surveyId
    }
    areBreakWeekSlotExclusionWindowsEnabled
    seasonPlayoffTemplateId
    overridePlayoffGenerationDate
    overridePlayoffSeedingDate
    slotExclusionRangeConfigurations {
      id
      maxSlotExclusions
      range {
        startsAt
        endsAt
      }
    }
  }
}
    `;

/**
 * __useGetSeasonQuery__
 *
 * To run a query within a React component, call `useGetSeasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSeasonQuery(baseOptions: Apollo.QueryHookOptions<GetSeasonQuery, GetSeasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeasonQuery, GetSeasonQueryVariables>(GetSeasonDocument, options);
      }
export function useGetSeasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeasonQuery, GetSeasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeasonQuery, GetSeasonQueryVariables>(GetSeasonDocument, options);
        }
export type GetSeasonQueryHookResult = ReturnType<typeof useGetSeasonQuery>;
export type GetSeasonLazyQueryHookResult = ReturnType<typeof useGetSeasonLazyQuery>;
export type GetSeasonQueryResult = Apollo.QueryResult<GetSeasonQuery, GetSeasonQueryVariables>;
export function refetchGetSeasonQuery(variables: GetSeasonQueryVariables) {
      return { query: GetSeasonDocument, variables: variables }
    }
export const CreateSeasonDatesTemplateDocument = gql`
    mutation createSeasonDatesTemplate($input: SeasonDatesTemplateInput!) {
  createSeasonDatesTemplate(input: $input) {
    id
  }
}
    `;
export type CreateSeasonDatesTemplateMutationFn = Apollo.MutationFunction<CreateSeasonDatesTemplateMutation, CreateSeasonDatesTemplateMutationVariables>;

/**
 * __useCreateSeasonDatesTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSeasonDatesTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeasonDatesTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeasonDatesTemplateMutation, { data, loading, error }] = useCreateSeasonDatesTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSeasonDatesTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateSeasonDatesTemplateMutation, CreateSeasonDatesTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSeasonDatesTemplateMutation, CreateSeasonDatesTemplateMutationVariables>(CreateSeasonDatesTemplateDocument, options);
      }
export type CreateSeasonDatesTemplateMutationHookResult = ReturnType<typeof useCreateSeasonDatesTemplateMutation>;
export type CreateSeasonDatesTemplateMutationResult = Apollo.MutationResult<CreateSeasonDatesTemplateMutation>;
export type CreateSeasonDatesTemplateMutationOptions = Apollo.BaseMutationOptions<CreateSeasonDatesTemplateMutation, CreateSeasonDatesTemplateMutationVariables>;
export const GetSeasonDatesTemplatesDocument = gql`
    query getSeasonDatesTemplates {
  getSeasonDatesTemplates {
    seasonDatesTemplates {
      id
      name
      startsAt
      endsAt
      registrationStartsAt
      suggestedRegistrationEndsAt
      teamRegistrationEndsAt
      teamDeregistrationEndsAt
      playerRegistrationEndsAt
      playerDeregistrationEndsAt
      rostersLockAt
    }
  }
}
    `;

/**
 * __useGetSeasonDatesTemplatesQuery__
 *
 * To run a query within a React component, call `useGetSeasonDatesTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonDatesTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonDatesTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSeasonDatesTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetSeasonDatesTemplatesQuery, GetSeasonDatesTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeasonDatesTemplatesQuery, GetSeasonDatesTemplatesQueryVariables>(GetSeasonDatesTemplatesDocument, options);
      }
export function useGetSeasonDatesTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeasonDatesTemplatesQuery, GetSeasonDatesTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeasonDatesTemplatesQuery, GetSeasonDatesTemplatesQueryVariables>(GetSeasonDatesTemplatesDocument, options);
        }
export type GetSeasonDatesTemplatesQueryHookResult = ReturnType<typeof useGetSeasonDatesTemplatesQuery>;
export type GetSeasonDatesTemplatesLazyQueryHookResult = ReturnType<typeof useGetSeasonDatesTemplatesLazyQuery>;
export type GetSeasonDatesTemplatesQueryResult = Apollo.QueryResult<GetSeasonDatesTemplatesQuery, GetSeasonDatesTemplatesQueryVariables>;
export function refetchGetSeasonDatesTemplatesQuery(variables?: GetSeasonDatesTemplatesQueryVariables) {
      return { query: GetSeasonDatesTemplatesDocument, variables: variables }
    }
export const UpdateSeasonDatesTemplateDocument = gql`
    mutation updateSeasonDatesTemplate($name: String!, $attributes: UpdateSeasonDatesTemplateInput!) {
  updateSeasonDatesTemplate(name: $name, attributes: $attributes) {
    id
  }
}
    `;
export type UpdateSeasonDatesTemplateMutationFn = Apollo.MutationFunction<UpdateSeasonDatesTemplateMutation, UpdateSeasonDatesTemplateMutationVariables>;

/**
 * __useUpdateSeasonDatesTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSeasonDatesTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSeasonDatesTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSeasonDatesTemplateMutation, { data, loading, error }] = useUpdateSeasonDatesTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateSeasonDatesTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSeasonDatesTemplateMutation, UpdateSeasonDatesTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSeasonDatesTemplateMutation, UpdateSeasonDatesTemplateMutationVariables>(UpdateSeasonDatesTemplateDocument, options);
      }
export type UpdateSeasonDatesTemplateMutationHookResult = ReturnType<typeof useUpdateSeasonDatesTemplateMutation>;
export type UpdateSeasonDatesTemplateMutationResult = Apollo.MutationResult<UpdateSeasonDatesTemplateMutation>;
export type UpdateSeasonDatesTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateSeasonDatesTemplateMutation, UpdateSeasonDatesTemplateMutationVariables>;
export const GetSeasonsDocument = gql`
    query getSeasons($offset: Int, $limit: Int, $filter: GetSeasonsFilter) {
  getSeasons(limit: $limit, offset: $offset, filter: $filter) {
    result {
      id
      league {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSeasonsQuery__
 *
 * To run a query within a React component, call `useGetSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSeasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeasonsQuery, GetSeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeasonsQuery, GetSeasonsQueryVariables>(GetSeasonsDocument, options);
      }
export function useGetSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeasonsQuery, GetSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeasonsQuery, GetSeasonsQueryVariables>(GetSeasonsDocument, options);
        }
export type GetSeasonsQueryHookResult = ReturnType<typeof useGetSeasonsQuery>;
export type GetSeasonsLazyQueryHookResult = ReturnType<typeof useGetSeasonsLazyQuery>;
export type GetSeasonsQueryResult = Apollo.QueryResult<GetSeasonsQuery, GetSeasonsQueryVariables>;
export function refetchGetSeasonsQuery(variables?: GetSeasonsQueryVariables) {
      return { query: GetSeasonsDocument, variables: variables }
    }
export const GetAreBreakWeeksEnabledBySeasonIdsDocument = gql`
    query getAreBreakWeeksEnabledBySeasonIds($offset: Int, $limit: Int, $filter: GetSeasonsFilter) {
  getSeasons(limit: $limit, offset: $offset, filter: $filter) {
    result {
      id
      areBreakWeekSlotExclusionWindowsEnabled
      slotExclusionRangeConfigurations {
        id
        maxSlotExclusions
        range {
          startsAt
          endsAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetAreBreakWeeksEnabledBySeasonIdsQuery__
 *
 * To run a query within a React component, call `useGetAreBreakWeeksEnabledBySeasonIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreBreakWeeksEnabledBySeasonIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreBreakWeeksEnabledBySeasonIdsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAreBreakWeeksEnabledBySeasonIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetAreBreakWeeksEnabledBySeasonIdsQuery, GetAreBreakWeeksEnabledBySeasonIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreBreakWeeksEnabledBySeasonIdsQuery, GetAreBreakWeeksEnabledBySeasonIdsQueryVariables>(GetAreBreakWeeksEnabledBySeasonIdsDocument, options);
      }
export function useGetAreBreakWeeksEnabledBySeasonIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreBreakWeeksEnabledBySeasonIdsQuery, GetAreBreakWeeksEnabledBySeasonIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreBreakWeeksEnabledBySeasonIdsQuery, GetAreBreakWeeksEnabledBySeasonIdsQueryVariables>(GetAreBreakWeeksEnabledBySeasonIdsDocument, options);
        }
export type GetAreBreakWeeksEnabledBySeasonIdsQueryHookResult = ReturnType<typeof useGetAreBreakWeeksEnabledBySeasonIdsQuery>;
export type GetAreBreakWeeksEnabledBySeasonIdsLazyQueryHookResult = ReturnType<typeof useGetAreBreakWeeksEnabledBySeasonIdsLazyQuery>;
export type GetAreBreakWeeksEnabledBySeasonIdsQueryResult = Apollo.QueryResult<GetAreBreakWeeksEnabledBySeasonIdsQuery, GetAreBreakWeeksEnabledBySeasonIdsQueryVariables>;
export function refetchGetAreBreakWeeksEnabledBySeasonIdsQuery(variables?: GetAreBreakWeeksEnabledBySeasonIdsQueryVariables) {
      return { query: GetAreBreakWeeksEnabledBySeasonIdsDocument, variables: variables }
    }
export const GetCharacterSelectionOptionsByEsportIdDocument = gql`
    query getCharacterSelectionOptionsByEsportId($input: UUID!) {
  characterSelectionOptionsByEsportId(esportId: $input) {
    selectionOptions {
      gameOrdinal
      selectionOptions {
        ...GameAssistantSelectionOption
      }
    }
  }
}
    ${GameAssistantSelectionOptionFragmentDoc}`;

/**
 * __useGetCharacterSelectionOptionsByEsportIdQuery__
 *
 * To run a query within a React component, call `useGetCharacterSelectionOptionsByEsportIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCharacterSelectionOptionsByEsportIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCharacterSelectionOptionsByEsportIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCharacterSelectionOptionsByEsportIdQuery(baseOptions: Apollo.QueryHookOptions<GetCharacterSelectionOptionsByEsportIdQuery, GetCharacterSelectionOptionsByEsportIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCharacterSelectionOptionsByEsportIdQuery, GetCharacterSelectionOptionsByEsportIdQueryVariables>(GetCharacterSelectionOptionsByEsportIdDocument, options);
      }
export function useGetCharacterSelectionOptionsByEsportIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCharacterSelectionOptionsByEsportIdQuery, GetCharacterSelectionOptionsByEsportIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCharacterSelectionOptionsByEsportIdQuery, GetCharacterSelectionOptionsByEsportIdQueryVariables>(GetCharacterSelectionOptionsByEsportIdDocument, options);
        }
export type GetCharacterSelectionOptionsByEsportIdQueryHookResult = ReturnType<typeof useGetCharacterSelectionOptionsByEsportIdQuery>;
export type GetCharacterSelectionOptionsByEsportIdLazyQueryHookResult = ReturnType<typeof useGetCharacterSelectionOptionsByEsportIdLazyQuery>;
export type GetCharacterSelectionOptionsByEsportIdQueryResult = Apollo.QueryResult<GetCharacterSelectionOptionsByEsportIdQuery, GetCharacterSelectionOptionsByEsportIdQueryVariables>;
export function refetchGetCharacterSelectionOptionsByEsportIdQuery(variables: GetCharacterSelectionOptionsByEsportIdQueryVariables) {
      return { query: GetCharacterSelectionOptionsByEsportIdDocument, variables: variables }
    }
export const GetMapSelectionOptionsByEsportIdDocument = gql`
    query getMapSelectionOptionsByEsportId($input: UUID!) {
  mapSelectionOptionsByEsportId(esportId: $input) {
    selectionOptions {
      gameOrdinal
      selectionOptions {
        ...GameAssistantSelectionOption
      }
    }
  }
}
    ${GameAssistantSelectionOptionFragmentDoc}`;

/**
 * __useGetMapSelectionOptionsByEsportIdQuery__
 *
 * To run a query within a React component, call `useGetMapSelectionOptionsByEsportIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapSelectionOptionsByEsportIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapSelectionOptionsByEsportIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMapSelectionOptionsByEsportIdQuery(baseOptions: Apollo.QueryHookOptions<GetMapSelectionOptionsByEsportIdQuery, GetMapSelectionOptionsByEsportIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMapSelectionOptionsByEsportIdQuery, GetMapSelectionOptionsByEsportIdQueryVariables>(GetMapSelectionOptionsByEsportIdDocument, options);
      }
export function useGetMapSelectionOptionsByEsportIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMapSelectionOptionsByEsportIdQuery, GetMapSelectionOptionsByEsportIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMapSelectionOptionsByEsportIdQuery, GetMapSelectionOptionsByEsportIdQueryVariables>(GetMapSelectionOptionsByEsportIdDocument, options);
        }
export type GetMapSelectionOptionsByEsportIdQueryHookResult = ReturnType<typeof useGetMapSelectionOptionsByEsportIdQuery>;
export type GetMapSelectionOptionsByEsportIdLazyQueryHookResult = ReturnType<typeof useGetMapSelectionOptionsByEsportIdLazyQuery>;
export type GetMapSelectionOptionsByEsportIdQueryResult = Apollo.QueryResult<GetMapSelectionOptionsByEsportIdQuery, GetMapSelectionOptionsByEsportIdQueryVariables>;
export function refetchGetMapSelectionOptionsByEsportIdQuery(variables: GetMapSelectionOptionsByEsportIdQueryVariables) {
      return { query: GetMapSelectionOptionsByEsportIdDocument, variables: variables }
    }
export const GetEpicPlatformSelectionOptionsByUserIdsDocument = gql`
    query getEpicPlatformSelectionOptionsByUserIds($userIds: [UUID!]!) {
  epicPlatformSelectionOptionsByUserIds(userIds: $userIds) {
    selectionOptions {
      userId
      selectionOptions {
        ...GameAssistantSelectionOption
      }
    }
  }
}
    ${GameAssistantSelectionOptionFragmentDoc}`;

/**
 * __useGetEpicPlatformSelectionOptionsByUserIdsQuery__
 *
 * To run a query within a React component, call `useGetEpicPlatformSelectionOptionsByUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpicPlatformSelectionOptionsByUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpicPlatformSelectionOptionsByUserIdsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetEpicPlatformSelectionOptionsByUserIdsQuery(baseOptions: Apollo.QueryHookOptions<GetEpicPlatformSelectionOptionsByUserIdsQuery, GetEpicPlatformSelectionOptionsByUserIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEpicPlatformSelectionOptionsByUserIdsQuery, GetEpicPlatformSelectionOptionsByUserIdsQueryVariables>(GetEpicPlatformSelectionOptionsByUserIdsDocument, options);
      }
export function useGetEpicPlatformSelectionOptionsByUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEpicPlatformSelectionOptionsByUserIdsQuery, GetEpicPlatformSelectionOptionsByUserIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEpicPlatformSelectionOptionsByUserIdsQuery, GetEpicPlatformSelectionOptionsByUserIdsQueryVariables>(GetEpicPlatformSelectionOptionsByUserIdsDocument, options);
        }
export type GetEpicPlatformSelectionOptionsByUserIdsQueryHookResult = ReturnType<typeof useGetEpicPlatformSelectionOptionsByUserIdsQuery>;
export type GetEpicPlatformSelectionOptionsByUserIdsLazyQueryHookResult = ReturnType<typeof useGetEpicPlatformSelectionOptionsByUserIdsLazyQuery>;
export type GetEpicPlatformSelectionOptionsByUserIdsQueryResult = Apollo.QueryResult<GetEpicPlatformSelectionOptionsByUserIdsQuery, GetEpicPlatformSelectionOptionsByUserIdsQueryVariables>;
export function refetchGetEpicPlatformSelectionOptionsByUserIdsQuery(variables: GetEpicPlatformSelectionOptionsByUserIdsQueryVariables) {
      return { query: GetEpicPlatformSelectionOptionsByUserIdsDocument, variables: variables }
    }
export const UploadSelectionOptionAssetDocument = gql`
    mutation uploadSelectionOptionAsset($esportSlug: EsportSlug!, $file: Upload!) {
  uploadSelectionOptionAsset(esportSlug: $esportSlug, file: $file) {
    success
    assetUri
  }
}
    `;
export type UploadSelectionOptionAssetMutationFn = Apollo.MutationFunction<UploadSelectionOptionAssetMutation, UploadSelectionOptionAssetMutationVariables>;

/**
 * __useUploadSelectionOptionAssetMutation__
 *
 * To run a mutation, you first call `useUploadSelectionOptionAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSelectionOptionAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSelectionOptionAssetMutation, { data, loading, error }] = useUploadSelectionOptionAssetMutation({
 *   variables: {
 *      esportSlug: // value for 'esportSlug'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadSelectionOptionAssetMutation(baseOptions?: Apollo.MutationHookOptions<UploadSelectionOptionAssetMutation, UploadSelectionOptionAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadSelectionOptionAssetMutation, UploadSelectionOptionAssetMutationVariables>(UploadSelectionOptionAssetDocument, options);
      }
export type UploadSelectionOptionAssetMutationHookResult = ReturnType<typeof useUploadSelectionOptionAssetMutation>;
export type UploadSelectionOptionAssetMutationResult = Apollo.MutationResult<UploadSelectionOptionAssetMutation>;
export type UploadSelectionOptionAssetMutationOptions = Apollo.BaseMutationOptions<UploadSelectionOptionAssetMutation, UploadSelectionOptionAssetMutationVariables>;
export const CreateSelectionOptionDocument = gql`
    mutation createSelectionOption($input: GameAssistantSelectionOptionInsert!) {
  createGameAssistantSelectionOptions(input: $input) {
    id
    displayName
    assetUri
  }
}
    `;
export type CreateSelectionOptionMutationFn = Apollo.MutationFunction<CreateSelectionOptionMutation, CreateSelectionOptionMutationVariables>;

/**
 * __useCreateSelectionOptionMutation__
 *
 * To run a mutation, you first call `useCreateSelectionOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSelectionOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSelectionOptionMutation, { data, loading, error }] = useCreateSelectionOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSelectionOptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSelectionOptionMutation, CreateSelectionOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSelectionOptionMutation, CreateSelectionOptionMutationVariables>(CreateSelectionOptionDocument, options);
      }
export type CreateSelectionOptionMutationHookResult = ReturnType<typeof useCreateSelectionOptionMutation>;
export type CreateSelectionOptionMutationResult = Apollo.MutationResult<CreateSelectionOptionMutation>;
export type CreateSelectionOptionMutationOptions = Apollo.BaseMutationOptions<CreateSelectionOptionMutation, CreateSelectionOptionMutationVariables>;
export const RemoveSelectionOptionDocument = gql`
    mutation removeSelectionOption($selectionOptionId: UUID!) {
  removeSelectionOptionById(selectionOptionId: $selectionOptionId) {
    success
  }
}
    `;
export type RemoveSelectionOptionMutationFn = Apollo.MutationFunction<RemoveSelectionOptionMutation, RemoveSelectionOptionMutationVariables>;

/**
 * __useRemoveSelectionOptionMutation__
 *
 * To run a mutation, you first call `useRemoveSelectionOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSelectionOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSelectionOptionMutation, { data, loading, error }] = useRemoveSelectionOptionMutation({
 *   variables: {
 *      selectionOptionId: // value for 'selectionOptionId'
 *   },
 * });
 */
export function useRemoveSelectionOptionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSelectionOptionMutation, RemoveSelectionOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSelectionOptionMutation, RemoveSelectionOptionMutationVariables>(RemoveSelectionOptionDocument, options);
      }
export type RemoveSelectionOptionMutationHookResult = ReturnType<typeof useRemoveSelectionOptionMutation>;
export type RemoveSelectionOptionMutationResult = Apollo.MutationResult<RemoveSelectionOptionMutation>;
export type RemoveSelectionOptionMutationOptions = Apollo.BaseMutationOptions<RemoveSelectionOptionMutation, RemoveSelectionOptionMutationVariables>;
export const SettleMatchInfoDocument = gql`
    query settleMatchInfo($matchId: UUID!) {
  match(id: $matchId) {
    id
    bestOf
    status
    isSettleable
    esport {
      id
      slug
    }
    series {
      id
      bestOf
      games {
        id
        status
        ordinalNumber
        winningTeam {
          id
          name
          gameId
        }
        losingTeam {
          id
          name
          gameId
        }
      }
      teamContext {
        seriesId
        teams {
          id
          seriesId
          name
          roster {
            id
            name
          }
        }
      }
    }
    games {
      id
      status
      ordinalNumber
      winningTeam {
        id
        name
        gameId
      }
      losingTeam {
        id
        name
        gameId
      }
    }
    teamContext {
      matchId
      teams {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSettleMatchInfoQuery__
 *
 * To run a query within a React component, call `useSettleMatchInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettleMatchInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettleMatchInfoQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useSettleMatchInfoQuery(baseOptions: Apollo.QueryHookOptions<SettleMatchInfoQuery, SettleMatchInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettleMatchInfoQuery, SettleMatchInfoQueryVariables>(SettleMatchInfoDocument, options);
      }
export function useSettleMatchInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettleMatchInfoQuery, SettleMatchInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettleMatchInfoQuery, SettleMatchInfoQueryVariables>(SettleMatchInfoDocument, options);
        }
export type SettleMatchInfoQueryHookResult = ReturnType<typeof useSettleMatchInfoQuery>;
export type SettleMatchInfoLazyQueryHookResult = ReturnType<typeof useSettleMatchInfoLazyQuery>;
export type SettleMatchInfoQueryResult = Apollo.QueryResult<SettleMatchInfoQuery, SettleMatchInfoQueryVariables>;
export function refetchSettleMatchInfoQuery(variables: SettleMatchInfoQueryVariables) {
      return { query: SettleMatchInfoDocument, variables: variables }
    }
export const CoachSettleMatchInfoDocument = gql`
    query coachSettleMatchInfo($matchId: UUID!) {
  me {
    id
    school {
      id
      teams {
        id
      }
    }
  }
  match(id: $matchId) {
    id
    bestOf
    isSettleableByACoach
    scheduledStartsAt
    status
    slot {
      id
      phase {
        id
        type
      }
    }
    esport {
      id
      name
      slug
    }
    series {
      id
      bestOf
      games {
        id
        status
        ordinalNumber
        winningTeam {
          id
          name
          gameId
        }
        losingTeam {
          id
          name
          gameId
        }
      }
      teamContext {
        seriesId
        teams {
          id
          seriesId
          name
          roster {
            id
            name
          }
        }
      }
    }
    games {
      id
      status
      ordinalNumber
      winningTeam {
        id
        name
        gameId
      }
      losingTeam {
        id
        name
        gameId
      }
    }
    teamContext {
      matchId
      teams {
        id
        name
        isMyTeam
      }
    }
    matchSettleRequests {
      id
    }
    matchDisputeRequests {
      id
      status
      reason
      notes
    }
  }
}
    `;

/**
 * __useCoachSettleMatchInfoQuery__
 *
 * To run a query within a React component, call `useCoachSettleMatchInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachSettleMatchInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachSettleMatchInfoQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useCoachSettleMatchInfoQuery(baseOptions: Apollo.QueryHookOptions<CoachSettleMatchInfoQuery, CoachSettleMatchInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachSettleMatchInfoQuery, CoachSettleMatchInfoQueryVariables>(CoachSettleMatchInfoDocument, options);
      }
export function useCoachSettleMatchInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachSettleMatchInfoQuery, CoachSettleMatchInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachSettleMatchInfoQuery, CoachSettleMatchInfoQueryVariables>(CoachSettleMatchInfoDocument, options);
        }
export type CoachSettleMatchInfoQueryHookResult = ReturnType<typeof useCoachSettleMatchInfoQuery>;
export type CoachSettleMatchInfoLazyQueryHookResult = ReturnType<typeof useCoachSettleMatchInfoLazyQuery>;
export type CoachSettleMatchInfoQueryResult = Apollo.QueryResult<CoachSettleMatchInfoQuery, CoachSettleMatchInfoQueryVariables>;
export function refetchCoachSettleMatchInfoQuery(variables: CoachSettleMatchInfoQueryVariables) {
      return { query: CoachSettleMatchInfoDocument, variables: variables }
    }
export const GetReportedResultsDocument = gql`
    query getReportedResults($matchId: UUID!, $fetchInput: FetchMatchSettleRequestInput!) {
  me {
    id
    school {
      id
      teams {
        id
      }
    }
  }
  match(id: $matchId) {
    id
    bestOf
    status
    scheduledStartsAt
    esport {
      id
      name
    }
    teamContext {
      matchId
      teams {
        id
        name
        isMyTeam
      }
    }
    matchSettleRequests {
      id
      status
      type
      createdAt
      requestedBy {
        id
        name
      }
      team {
        id
        name
      }
    }
  }
  fetchMatchSettleRequest(input: $fetchInput) {
    success
    errors
    matchSettleRequest {
      id
      createdAt
      updatedAt
      status
      type
      incompleteReason
      incompleteNotes
      matchId
      teamId
      requestedById
      isReadyForReview
      forfeitReason
      results {
        seriesResults {
          id
          ordinalNumber
          gameResults {
            ordinalNumber
            winningTeam {
              id
              name
            }
            losingTeamId
            incompleteReason
            assets {
              id
              fileName
              signedUrl
            }
          }
        }
      }
      requestedBy {
        id
        name
      }
      team {
        id
        name
      }
      match {
        id
        bestOf
        esport {
          id
          slug
        }
        games {
          id
          status
          ordinalNumber
          winningTeam {
            id
            name
            gameId
          }
        }
        series {
          id
          bestOf
          games {
            id
            status
            ordinalNumber
            winningTeam {
              id
              name
              gameId
            }
          }
          teamContext {
            seriesId
            teams {
              id
              seriesId
              name
              roster {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetReportedResultsQuery__
 *
 * To run a query within a React component, call `useGetReportedResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportedResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportedResultsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      fetchInput: // value for 'fetchInput'
 *   },
 * });
 */
export function useGetReportedResultsQuery(baseOptions: Apollo.QueryHookOptions<GetReportedResultsQuery, GetReportedResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportedResultsQuery, GetReportedResultsQueryVariables>(GetReportedResultsDocument, options);
      }
export function useGetReportedResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportedResultsQuery, GetReportedResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportedResultsQuery, GetReportedResultsQueryVariables>(GetReportedResultsDocument, options);
        }
export type GetReportedResultsQueryHookResult = ReturnType<typeof useGetReportedResultsQuery>;
export type GetReportedResultsLazyQueryHookResult = ReturnType<typeof useGetReportedResultsLazyQuery>;
export type GetReportedResultsQueryResult = Apollo.QueryResult<GetReportedResultsQuery, GetReportedResultsQueryVariables>;
export function refetchGetReportedResultsQuery(variables: GetReportedResultsQueryVariables) {
      return { query: GetReportedResultsDocument, variables: variables }
    }
export const GetDisputeRequestDocument = gql`
    query getDisputeRequest($matchId: UUID!) {
  me {
    id
    school {
      id
      teams {
        id
      }
    }
  }
  match(id: $matchId) {
    id
    bestOf
    status
    scheduledStartsAt
    esport {
      id
      name
    }
    teamContext {
      matchId
      teams {
        id
        name
        isMyTeam
      }
    }
    matchDisputeRequests {
      id
      status
      reason
      notes
      createdAt
      asset {
        id
        fileName
        signedUrl
      }
      requestedBy {
        id
        name
      }
      team {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDisputeRequestQuery__
 *
 * To run a query within a React component, call `useGetDisputeRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisputeRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisputeRequestQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetDisputeRequestQuery(baseOptions: Apollo.QueryHookOptions<GetDisputeRequestQuery, GetDisputeRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisputeRequestQuery, GetDisputeRequestQueryVariables>(GetDisputeRequestDocument, options);
      }
export function useGetDisputeRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisputeRequestQuery, GetDisputeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisputeRequestQuery, GetDisputeRequestQueryVariables>(GetDisputeRequestDocument, options);
        }
export type GetDisputeRequestQueryHookResult = ReturnType<typeof useGetDisputeRequestQuery>;
export type GetDisputeRequestLazyQueryHookResult = ReturnType<typeof useGetDisputeRequestLazyQuery>;
export type GetDisputeRequestQueryResult = Apollo.QueryResult<GetDisputeRequestQuery, GetDisputeRequestQueryVariables>;
export function refetchGetDisputeRequestQuery(variables: GetDisputeRequestQueryVariables) {
      return { query: GetDisputeRequestDocument, variables: variables }
    }
export const UploadMatchSettleRequestAssetDocument = gql`
    mutation uploadMatchSettleRequestAsset($file: Upload!) {
  uploadMatchSettleRequestAsset(file: $file) {
    id
    fileName
    signedUrl
  }
}
    `;
export type UploadMatchSettleRequestAssetMutationFn = Apollo.MutationFunction<UploadMatchSettleRequestAssetMutation, UploadMatchSettleRequestAssetMutationVariables>;

/**
 * __useUploadMatchSettleRequestAssetMutation__
 *
 * To run a mutation, you first call `useUploadMatchSettleRequestAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMatchSettleRequestAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMatchSettleRequestAssetMutation, { data, loading, error }] = useUploadMatchSettleRequestAssetMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadMatchSettleRequestAssetMutation(baseOptions?: Apollo.MutationHookOptions<UploadMatchSettleRequestAssetMutation, UploadMatchSettleRequestAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMatchSettleRequestAssetMutation, UploadMatchSettleRequestAssetMutationVariables>(UploadMatchSettleRequestAssetDocument, options);
      }
export type UploadMatchSettleRequestAssetMutationHookResult = ReturnType<typeof useUploadMatchSettleRequestAssetMutation>;
export type UploadMatchSettleRequestAssetMutationResult = Apollo.MutationResult<UploadMatchSettleRequestAssetMutation>;
export type UploadMatchSettleRequestAssetMutationOptions = Apollo.BaseMutationOptions<UploadMatchSettleRequestAssetMutation, UploadMatchSettleRequestAssetMutationVariables>;
export const DeleteMatchSettleRequestAssetDocument = gql`
    mutation deleteMatchSettleRequestAsset($assetId: UUID!) {
  deleteMatchSettleRequestAsset(assetId: $assetId) {
    success
    deletedMatchSettleRequestId
  }
}
    `;
export type DeleteMatchSettleRequestAssetMutationFn = Apollo.MutationFunction<DeleteMatchSettleRequestAssetMutation, DeleteMatchSettleRequestAssetMutationVariables>;

/**
 * __useDeleteMatchSettleRequestAssetMutation__
 *
 * To run a mutation, you first call `useDeleteMatchSettleRequestAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchSettleRequestAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchSettleRequestAssetMutation, { data, loading, error }] = useDeleteMatchSettleRequestAssetMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDeleteMatchSettleRequestAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMatchSettleRequestAssetMutation, DeleteMatchSettleRequestAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMatchSettleRequestAssetMutation, DeleteMatchSettleRequestAssetMutationVariables>(DeleteMatchSettleRequestAssetDocument, options);
      }
export type DeleteMatchSettleRequestAssetMutationHookResult = ReturnType<typeof useDeleteMatchSettleRequestAssetMutation>;
export type DeleteMatchSettleRequestAssetMutationResult = Apollo.MutationResult<DeleteMatchSettleRequestAssetMutation>;
export type DeleteMatchSettleRequestAssetMutationOptions = Apollo.BaseMutationOptions<DeleteMatchSettleRequestAssetMutation, DeleteMatchSettleRequestAssetMutationVariables>;
export const CreateMatchDisputeRequestDocument = gql`
    mutation createMatchDisputeRequest($input: createMatchDisputeRequestInput!) {
  createMatchDisputeRequest(input: $input) {
    id
    status
  }
}
    `;
export type CreateMatchDisputeRequestMutationFn = Apollo.MutationFunction<CreateMatchDisputeRequestMutation, CreateMatchDisputeRequestMutationVariables>;

/**
 * __useCreateMatchDisputeRequestMutation__
 *
 * To run a mutation, you first call `useCreateMatchDisputeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatchDisputeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatchDisputeRequestMutation, { data, loading, error }] = useCreateMatchDisputeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMatchDisputeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateMatchDisputeRequestMutation, CreateMatchDisputeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMatchDisputeRequestMutation, CreateMatchDisputeRequestMutationVariables>(CreateMatchDisputeRequestDocument, options);
      }
export type CreateMatchDisputeRequestMutationHookResult = ReturnType<typeof useCreateMatchDisputeRequestMutation>;
export type CreateMatchDisputeRequestMutationResult = Apollo.MutationResult<CreateMatchDisputeRequestMutation>;
export type CreateMatchDisputeRequestMutationOptions = Apollo.BaseMutationOptions<CreateMatchDisputeRequestMutation, CreateMatchDisputeRequestMutationVariables>;
export const UploadMatchDisputeRequestAssetDocument = gql`
    mutation uploadMatchDisputeRequestAsset($file: Upload!) {
  uploadMatchDisputeRequestAsset(file: $file) {
    id
    fileName
    signedUrl
  }
}
    `;
export type UploadMatchDisputeRequestAssetMutationFn = Apollo.MutationFunction<UploadMatchDisputeRequestAssetMutation, UploadMatchDisputeRequestAssetMutationVariables>;

/**
 * __useUploadMatchDisputeRequestAssetMutation__
 *
 * To run a mutation, you first call `useUploadMatchDisputeRequestAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMatchDisputeRequestAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMatchDisputeRequestAssetMutation, { data, loading, error }] = useUploadMatchDisputeRequestAssetMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadMatchDisputeRequestAssetMutation(baseOptions?: Apollo.MutationHookOptions<UploadMatchDisputeRequestAssetMutation, UploadMatchDisputeRequestAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMatchDisputeRequestAssetMutation, UploadMatchDisputeRequestAssetMutationVariables>(UploadMatchDisputeRequestAssetDocument, options);
      }
export type UploadMatchDisputeRequestAssetMutationHookResult = ReturnType<typeof useUploadMatchDisputeRequestAssetMutation>;
export type UploadMatchDisputeRequestAssetMutationResult = Apollo.MutationResult<UploadMatchDisputeRequestAssetMutation>;
export type UploadMatchDisputeRequestAssetMutationOptions = Apollo.BaseMutationOptions<UploadMatchDisputeRequestAssetMutation, UploadMatchDisputeRequestAssetMutationVariables>;
export const DeleteMatchDisputeRequestAssetDocument = gql`
    mutation deleteMatchDisputeRequestAsset($assetId: UUID!) {
  deleteMatchDisputeRequestAsset(assetId: $assetId) {
    success
  }
}
    `;
export type DeleteMatchDisputeRequestAssetMutationFn = Apollo.MutationFunction<DeleteMatchDisputeRequestAssetMutation, DeleteMatchDisputeRequestAssetMutationVariables>;

/**
 * __useDeleteMatchDisputeRequestAssetMutation__
 *
 * To run a mutation, you first call `useDeleteMatchDisputeRequestAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchDisputeRequestAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchDisputeRequestAssetMutation, { data, loading, error }] = useDeleteMatchDisputeRequestAssetMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDeleteMatchDisputeRequestAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMatchDisputeRequestAssetMutation, DeleteMatchDisputeRequestAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMatchDisputeRequestAssetMutation, DeleteMatchDisputeRequestAssetMutationVariables>(DeleteMatchDisputeRequestAssetDocument, options);
      }
export type DeleteMatchDisputeRequestAssetMutationHookResult = ReturnType<typeof useDeleteMatchDisputeRequestAssetMutation>;
export type DeleteMatchDisputeRequestAssetMutationResult = Apollo.MutationResult<DeleteMatchDisputeRequestAssetMutation>;
export type DeleteMatchDisputeRequestAssetMutationOptions = Apollo.BaseMutationOptions<DeleteMatchDisputeRequestAssetMutation, DeleteMatchDisputeRequestAssetMutationVariables>;
export const SubmitMatchSettleRequestLiveDocument = gql`
    mutation submitMatchSettleRequestLive($input: SubmitMatchSettleRequestLiveInput!) {
  submitMatchSettleRequestLive(input: $input) {
    success
    errors
    match {
      ...RefetchMatchFragment
    }
  }
}
    ${RefetchMatchFragmentFragmentDoc}`;
export type SubmitMatchSettleRequestLiveMutationFn = Apollo.MutationFunction<SubmitMatchSettleRequestLiveMutation, SubmitMatchSettleRequestLiveMutationVariables>;

/**
 * __useSubmitMatchSettleRequestLiveMutation__
 *
 * To run a mutation, you first call `useSubmitMatchSettleRequestLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMatchSettleRequestLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMatchSettleRequestLiveMutation, { data, loading, error }] = useSubmitMatchSettleRequestLiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitMatchSettleRequestLiveMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMatchSettleRequestLiveMutation, SubmitMatchSettleRequestLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMatchSettleRequestLiveMutation, SubmitMatchSettleRequestLiveMutationVariables>(SubmitMatchSettleRequestLiveDocument, options);
      }
export type SubmitMatchSettleRequestLiveMutationHookResult = ReturnType<typeof useSubmitMatchSettleRequestLiveMutation>;
export type SubmitMatchSettleRequestLiveMutationResult = Apollo.MutationResult<SubmitMatchSettleRequestLiveMutation>;
export type SubmitMatchSettleRequestLiveMutationOptions = Apollo.BaseMutationOptions<SubmitMatchSettleRequestLiveMutation, SubmitMatchSettleRequestLiveMutationVariables>;
export const SubmitAdminMatchSettleRequestLiveDocument = gql`
    mutation submitAdminMatchSettleRequestLive($input: SubmitAdminMatchSettleRequestLiveInput!) {
  submitAdminMatchSettleRequestLive(input: $input) {
    success
    errors
    match {
      ...RefetchMatchFragment
    }
  }
}
    ${RefetchMatchFragmentFragmentDoc}`;
export type SubmitAdminMatchSettleRequestLiveMutationFn = Apollo.MutationFunction<SubmitAdminMatchSettleRequestLiveMutation, SubmitAdminMatchSettleRequestLiveMutationVariables>;

/**
 * __useSubmitAdminMatchSettleRequestLiveMutation__
 *
 * To run a mutation, you first call `useSubmitAdminMatchSettleRequestLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAdminMatchSettleRequestLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAdminMatchSettleRequestLiveMutation, { data, loading, error }] = useSubmitAdminMatchSettleRequestLiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitAdminMatchSettleRequestLiveMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAdminMatchSettleRequestLiveMutation, SubmitAdminMatchSettleRequestLiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAdminMatchSettleRequestLiveMutation, SubmitAdminMatchSettleRequestLiveMutationVariables>(SubmitAdminMatchSettleRequestLiveDocument, options);
      }
export type SubmitAdminMatchSettleRequestLiveMutationHookResult = ReturnType<typeof useSubmitAdminMatchSettleRequestLiveMutation>;
export type SubmitAdminMatchSettleRequestLiveMutationResult = Apollo.MutationResult<SubmitAdminMatchSettleRequestLiveMutation>;
export type SubmitAdminMatchSettleRequestLiveMutationOptions = Apollo.BaseMutationOptions<SubmitAdminMatchSettleRequestLiveMutation, SubmitAdminMatchSettleRequestLiveMutationVariables>;
export const MatchSettleRequestSubmittedDocument = gql`
    subscription matchSettleRequestSubmitted($input: MatchSettleRequestSubmittedSubscribeInput) {
  matchSettleRequestSubmitted(input: $input) {
    success
    errors
  }
}
    `;

/**
 * __useMatchSettleRequestSubmittedSubscription__
 *
 * To run a query within a React component, call `useMatchSettleRequestSubmittedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMatchSettleRequestSubmittedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchSettleRequestSubmittedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchSettleRequestSubmittedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MatchSettleRequestSubmittedSubscription, MatchSettleRequestSubmittedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MatchSettleRequestSubmittedSubscription, MatchSettleRequestSubmittedSubscriptionVariables>(MatchSettleRequestSubmittedDocument, options);
      }
export type MatchSettleRequestSubmittedSubscriptionHookResult = ReturnType<typeof useMatchSettleRequestSubmittedSubscription>;
export type MatchSettleRequestSubmittedSubscriptionResult = Apollo.SubscriptionResult<MatchSettleRequestSubmittedSubscription>;
export const DeleteSlotExclusionWindowDocument = gql`
    mutation deleteSlotExclusionWindow($id: UUID!) {
  deleteSlotExclusionWindow(id: $id) {
    slotExclusionWindow {
      id
    }
  }
}
    `;
export type DeleteSlotExclusionWindowMutationFn = Apollo.MutationFunction<DeleteSlotExclusionWindowMutation, DeleteSlotExclusionWindowMutationVariables>;

/**
 * __useDeleteSlotExclusionWindowMutation__
 *
 * To run a mutation, you first call `useDeleteSlotExclusionWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSlotExclusionWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSlotExclusionWindowMutation, { data, loading, error }] = useDeleteSlotExclusionWindowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSlotExclusionWindowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSlotExclusionWindowMutation, DeleteSlotExclusionWindowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSlotExclusionWindowMutation, DeleteSlotExclusionWindowMutationVariables>(DeleteSlotExclusionWindowDocument, options);
      }
export type DeleteSlotExclusionWindowMutationHookResult = ReturnType<typeof useDeleteSlotExclusionWindowMutation>;
export type DeleteSlotExclusionWindowMutationResult = Apollo.MutationResult<DeleteSlotExclusionWindowMutation>;
export type DeleteSlotExclusionWindowMutationOptions = Apollo.BaseMutationOptions<DeleteSlotExclusionWindowMutation, DeleteSlotExclusionWindowMutationVariables>;
export const CreateSlotExclusionWindowDocument = gql`
    mutation createSlotExclusionWindow($input: SlotExclusionWindowInput!) {
  createSlotExclusionWindow(input: $input) {
    slotExclusionWindow {
      id
      hash
      resourceId
      resourceType
      seasonId
      createdAt
      updatedAt
      startsAt
      endsAt
    }
  }
}
    `;
export type CreateSlotExclusionWindowMutationFn = Apollo.MutationFunction<CreateSlotExclusionWindowMutation, CreateSlotExclusionWindowMutationVariables>;

/**
 * __useCreateSlotExclusionWindowMutation__
 *
 * To run a mutation, you first call `useCreateSlotExclusionWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlotExclusionWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlotExclusionWindowMutation, { data, loading, error }] = useCreateSlotExclusionWindowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSlotExclusionWindowMutation(baseOptions?: Apollo.MutationHookOptions<CreateSlotExclusionWindowMutation, CreateSlotExclusionWindowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSlotExclusionWindowMutation, CreateSlotExclusionWindowMutationVariables>(CreateSlotExclusionWindowDocument, options);
      }
export type CreateSlotExclusionWindowMutationHookResult = ReturnType<typeof useCreateSlotExclusionWindowMutation>;
export type CreateSlotExclusionWindowMutationResult = Apollo.MutationResult<CreateSlotExclusionWindowMutation>;
export type CreateSlotExclusionWindowMutationOptions = Apollo.BaseMutationOptions<CreateSlotExclusionWindowMutation, CreateSlotExclusionWindowMutationVariables>;
export const UpdateSlotExclusionWindowDocument = gql`
    mutation updateSlotExclusionWindow($id: UUID!, $attributes: SlotExclusionWindowAttributes!) {
  updateSlotExclusionWindow(id: $id, attributes: $attributes) {
    slotExclusionWindow {
      id
    }
  }
}
    `;
export type UpdateSlotExclusionWindowMutationFn = Apollo.MutationFunction<UpdateSlotExclusionWindowMutation, UpdateSlotExclusionWindowMutationVariables>;

/**
 * __useUpdateSlotExclusionWindowMutation__
 *
 * To run a mutation, you first call `useUpdateSlotExclusionWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlotExclusionWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlotExclusionWindowMutation, { data, loading, error }] = useUpdateSlotExclusionWindowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateSlotExclusionWindowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSlotExclusionWindowMutation, UpdateSlotExclusionWindowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSlotExclusionWindowMutation, UpdateSlotExclusionWindowMutationVariables>(UpdateSlotExclusionWindowDocument, options);
      }
export type UpdateSlotExclusionWindowMutationHookResult = ReturnType<typeof useUpdateSlotExclusionWindowMutation>;
export type UpdateSlotExclusionWindowMutationResult = Apollo.MutationResult<UpdateSlotExclusionWindowMutation>;
export type UpdateSlotExclusionWindowMutationOptions = Apollo.BaseMutationOptions<UpdateSlotExclusionWindowMutation, UpdateSlotExclusionWindowMutationVariables>;
export const SlotExclusionRangeConfigurationsDocument = gql`
    query slotExclusionRangeConfigurations($input: FindSlotExclusionRangeConfigurationsInput!) {
  slotExclusionRangeConfigurations(input: $input) {
    results {
      id
      minSlotExclusions
      maxSlotExclusions
      range {
        startsAt
        endsAt
      }
      defaultsAppliedAt
      suggestions {
        isDefault
        template {
          startsAt
          endsAt
          hash
        }
      }
      defaults {
        startsAt
        endsAt
      }
    }
  }
}
    `;

/**
 * __useSlotExclusionRangeConfigurationsQuery__
 *
 * To run a query within a React component, call `useSlotExclusionRangeConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlotExclusionRangeConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlotExclusionRangeConfigurationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSlotExclusionRangeConfigurationsQuery(baseOptions: Apollo.QueryHookOptions<SlotExclusionRangeConfigurationsQuery, SlotExclusionRangeConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlotExclusionRangeConfigurationsQuery, SlotExclusionRangeConfigurationsQueryVariables>(SlotExclusionRangeConfigurationsDocument, options);
      }
export function useSlotExclusionRangeConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlotExclusionRangeConfigurationsQuery, SlotExclusionRangeConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlotExclusionRangeConfigurationsQuery, SlotExclusionRangeConfigurationsQueryVariables>(SlotExclusionRangeConfigurationsDocument, options);
        }
export type SlotExclusionRangeConfigurationsQueryHookResult = ReturnType<typeof useSlotExclusionRangeConfigurationsQuery>;
export type SlotExclusionRangeConfigurationsLazyQueryHookResult = ReturnType<typeof useSlotExclusionRangeConfigurationsLazyQuery>;
export type SlotExclusionRangeConfigurationsQueryResult = Apollo.QueryResult<SlotExclusionRangeConfigurationsQuery, SlotExclusionRangeConfigurationsQueryVariables>;
export function refetchSlotExclusionRangeConfigurationsQuery(variables: SlotExclusionRangeConfigurationsQueryVariables) {
      return { query: SlotExclusionRangeConfigurationsDocument, variables: variables }
    }
export const CreateSlotExclusionRangeConfigurationDocument = gql`
    mutation createSlotExclusionRangeConfiguration($input: CreateSlotExclusionRangeConfigurationInput!) {
  createSlotExclusionRangeConfiguration(input: $input) {
    configuration {
      id
      minSlotExclusions
      maxSlotExclusions
      range {
        startsAt
        endsAt
      }
      defaultsAppliedAt
      suggestions {
        isDefault
        template {
          startsAt
          endsAt
          hash
        }
      }
      defaults {
        startsAt
        endsAt
      }
    }
  }
}
    `;
export type CreateSlotExclusionRangeConfigurationMutationFn = Apollo.MutationFunction<CreateSlotExclusionRangeConfigurationMutation, CreateSlotExclusionRangeConfigurationMutationVariables>;

/**
 * __useCreateSlotExclusionRangeConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateSlotExclusionRangeConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlotExclusionRangeConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlotExclusionRangeConfigurationMutation, { data, loading, error }] = useCreateSlotExclusionRangeConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSlotExclusionRangeConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSlotExclusionRangeConfigurationMutation, CreateSlotExclusionRangeConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSlotExclusionRangeConfigurationMutation, CreateSlotExclusionRangeConfigurationMutationVariables>(CreateSlotExclusionRangeConfigurationDocument, options);
      }
export type CreateSlotExclusionRangeConfigurationMutationHookResult = ReturnType<typeof useCreateSlotExclusionRangeConfigurationMutation>;
export type CreateSlotExclusionRangeConfigurationMutationResult = Apollo.MutationResult<CreateSlotExclusionRangeConfigurationMutation>;
export type CreateSlotExclusionRangeConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateSlotExclusionRangeConfigurationMutation, CreateSlotExclusionRangeConfigurationMutationVariables>;
export const UpdateSlotExclusionRangeConfigurationDocument = gql`
    mutation updateSlotExclusionRangeConfiguration($input: UpdateSlotExclusionRangeConfigurationInput!) {
  updateSlotExclusionRangeConfiguration(input: $input) {
    configuration {
      id
      minSlotExclusions
      maxSlotExclusions
      range {
        startsAt
        endsAt
      }
      defaultsAppliedAt
      suggestions {
        isDefault
        template {
          startsAt
          endsAt
          hash
        }
      }
      defaults {
        startsAt
        endsAt
      }
    }
  }
}
    `;
export type UpdateSlotExclusionRangeConfigurationMutationFn = Apollo.MutationFunction<UpdateSlotExclusionRangeConfigurationMutation, UpdateSlotExclusionRangeConfigurationMutationVariables>;

/**
 * __useUpdateSlotExclusionRangeConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateSlotExclusionRangeConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlotExclusionRangeConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlotExclusionRangeConfigurationMutation, { data, loading, error }] = useUpdateSlotExclusionRangeConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSlotExclusionRangeConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSlotExclusionRangeConfigurationMutation, UpdateSlotExclusionRangeConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSlotExclusionRangeConfigurationMutation, UpdateSlotExclusionRangeConfigurationMutationVariables>(UpdateSlotExclusionRangeConfigurationDocument, options);
      }
export type UpdateSlotExclusionRangeConfigurationMutationHookResult = ReturnType<typeof useUpdateSlotExclusionRangeConfigurationMutation>;
export type UpdateSlotExclusionRangeConfigurationMutationResult = Apollo.MutationResult<UpdateSlotExclusionRangeConfigurationMutation>;
export type UpdateSlotExclusionRangeConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateSlotExclusionRangeConfigurationMutation, UpdateSlotExclusionRangeConfigurationMutationVariables>;
export const GetTeamSlotExclusionWindowsDocument = gql`
    query getTeamSlotExclusionWindows($id: UUID!) {
  team(id: $id) {
    id
    name
    slotExclusionWindows {
      id
      resourceType
      resourceId
      startsAt
      endsAt
    }
  }
}
    `;

/**
 * __useGetTeamSlotExclusionWindowsQuery__
 *
 * To run a query within a React component, call `useGetTeamSlotExclusionWindowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamSlotExclusionWindowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamSlotExclusionWindowsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamSlotExclusionWindowsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamSlotExclusionWindowsQuery, GetTeamSlotExclusionWindowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamSlotExclusionWindowsQuery, GetTeamSlotExclusionWindowsQueryVariables>(GetTeamSlotExclusionWindowsDocument, options);
      }
export function useGetTeamSlotExclusionWindowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamSlotExclusionWindowsQuery, GetTeamSlotExclusionWindowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamSlotExclusionWindowsQuery, GetTeamSlotExclusionWindowsQueryVariables>(GetTeamSlotExclusionWindowsDocument, options);
        }
export type GetTeamSlotExclusionWindowsQueryHookResult = ReturnType<typeof useGetTeamSlotExclusionWindowsQuery>;
export type GetTeamSlotExclusionWindowsLazyQueryHookResult = ReturnType<typeof useGetTeamSlotExclusionWindowsLazyQuery>;
export type GetTeamSlotExclusionWindowsQueryResult = Apollo.QueryResult<GetTeamSlotExclusionWindowsQuery, GetTeamSlotExclusionWindowsQueryVariables>;
export function refetchGetTeamSlotExclusionWindowsQuery(variables: GetTeamSlotExclusionWindowsQueryVariables) {
      return { query: GetTeamSlotExclusionWindowsDocument, variables: variables }
    }
export const SetSlotExclusionRangeDefaultWindowsDocument = gql`
    mutation setSlotExclusionRangeDefaultWindows($input: SetSlotExclusionRangeDefaultWindowsInput!) {
  setSlotExclusionRangeDefaultWindows(input: $input) {
    success
    slotExclusionRangeDefaultWindowsIds
  }
}
    `;
export type SetSlotExclusionRangeDefaultWindowsMutationFn = Apollo.MutationFunction<SetSlotExclusionRangeDefaultWindowsMutation, SetSlotExclusionRangeDefaultWindowsMutationVariables>;

/**
 * __useSetSlotExclusionRangeDefaultWindowsMutation__
 *
 * To run a mutation, you first call `useSetSlotExclusionRangeDefaultWindowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSlotExclusionRangeDefaultWindowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSlotExclusionRangeDefaultWindowsMutation, { data, loading, error }] = useSetSlotExclusionRangeDefaultWindowsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSlotExclusionRangeDefaultWindowsMutation(baseOptions?: Apollo.MutationHookOptions<SetSlotExclusionRangeDefaultWindowsMutation, SetSlotExclusionRangeDefaultWindowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSlotExclusionRangeDefaultWindowsMutation, SetSlotExclusionRangeDefaultWindowsMutationVariables>(SetSlotExclusionRangeDefaultWindowsDocument, options);
      }
export type SetSlotExclusionRangeDefaultWindowsMutationHookResult = ReturnType<typeof useSetSlotExclusionRangeDefaultWindowsMutation>;
export type SetSlotExclusionRangeDefaultWindowsMutationResult = Apollo.MutationResult<SetSlotExclusionRangeDefaultWindowsMutation>;
export type SetSlotExclusionRangeDefaultWindowsMutationOptions = Apollo.BaseMutationOptions<SetSlotExclusionRangeDefaultWindowsMutation, SetSlotExclusionRangeDefaultWindowsMutationVariables>;
export const LeagueSeasonSlotExclusionWindowDocument = gql`
    query leagueSeasonSlotExclusionWindow($leagueId: UUID!, $metaseasonId: UUID!) {
  league(id: $leagueId) {
    id
    seasonByMetaseasonId(metaseasonId: $metaseasonId) {
      slotExclusionRangeConfigurations {
        id
        maxSlotExclusions
        range {
          startsAt
          endsAt
        }
      }
    }
  }
}
    `;

/**
 * __useLeagueSeasonSlotExclusionWindowQuery__
 *
 * To run a query within a React component, call `useLeagueSeasonSlotExclusionWindowQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeagueSeasonSlotExclusionWindowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeagueSeasonSlotExclusionWindowQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useLeagueSeasonSlotExclusionWindowQuery(baseOptions: Apollo.QueryHookOptions<LeagueSeasonSlotExclusionWindowQuery, LeagueSeasonSlotExclusionWindowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeagueSeasonSlotExclusionWindowQuery, LeagueSeasonSlotExclusionWindowQueryVariables>(LeagueSeasonSlotExclusionWindowDocument, options);
      }
export function useLeagueSeasonSlotExclusionWindowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeagueSeasonSlotExclusionWindowQuery, LeagueSeasonSlotExclusionWindowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeagueSeasonSlotExclusionWindowQuery, LeagueSeasonSlotExclusionWindowQueryVariables>(LeagueSeasonSlotExclusionWindowDocument, options);
        }
export type LeagueSeasonSlotExclusionWindowQueryHookResult = ReturnType<typeof useLeagueSeasonSlotExclusionWindowQuery>;
export type LeagueSeasonSlotExclusionWindowLazyQueryHookResult = ReturnType<typeof useLeagueSeasonSlotExclusionWindowLazyQuery>;
export type LeagueSeasonSlotExclusionWindowQueryResult = Apollo.QueryResult<LeagueSeasonSlotExclusionWindowQuery, LeagueSeasonSlotExclusionWindowQueryVariables>;
export function refetchLeagueSeasonSlotExclusionWindowQuery(variables: LeagueSeasonSlotExclusionWindowQueryVariables) {
      return { query: LeagueSeasonSlotExclusionWindowDocument, variables: variables }
    }
export const SlotLobbyStatusDocument = gql`
    query slotLobbyStatus($slotId: UUID!) {
  slotLobbyStatus(slotId: $slotId) {
    id
    status
    success
    errors {
      message
    }
    details {
      ... on UnopenedSlotLobbyDetails {
        lobbyOpensAt
      }
      ... on OpenSlotLobbyDetails {
        nextPairingAt
        lobbyClosesAt
      }
      ... on ClosedSlotLobbyDetails {
        lobbyClosedAt
      }
    }
  }
}
    `;

/**
 * __useSlotLobbyStatusQuery__
 *
 * To run a query within a React component, call `useSlotLobbyStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlotLobbyStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlotLobbyStatusQuery({
 *   variables: {
 *      slotId: // value for 'slotId'
 *   },
 * });
 */
export function useSlotLobbyStatusQuery(baseOptions: Apollo.QueryHookOptions<SlotLobbyStatusQuery, SlotLobbyStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlotLobbyStatusQuery, SlotLobbyStatusQueryVariables>(SlotLobbyStatusDocument, options);
      }
export function useSlotLobbyStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlotLobbyStatusQuery, SlotLobbyStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlotLobbyStatusQuery, SlotLobbyStatusQueryVariables>(SlotLobbyStatusDocument, options);
        }
export type SlotLobbyStatusQueryHookResult = ReturnType<typeof useSlotLobbyStatusQuery>;
export type SlotLobbyStatusLazyQueryHookResult = ReturnType<typeof useSlotLobbyStatusLazyQuery>;
export type SlotLobbyStatusQueryResult = Apollo.QueryResult<SlotLobbyStatusQuery, SlotLobbyStatusQueryVariables>;
export function refetchSlotLobbyStatusQuery(variables: SlotLobbyStatusQueryVariables) {
      return { query: SlotLobbyStatusDocument, variables: variables }
    }
export const GetSlotsForSeasonDocument = gql`
    query getSlotsForSeason($seasonId: UUID!) {
  season(id: $seasonId) {
    id
    phases {
      id
      slots {
        id
        bestOf
        order
        startsAt
        status
        phase {
          id
          name
          bestOf
        }
      }
    }
  }
}
    `;

/**
 * __useGetSlotsForSeasonQuery__
 *
 * To run a query within a React component, call `useGetSlotsForSeasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlotsForSeasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlotsForSeasonQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useGetSlotsForSeasonQuery(baseOptions: Apollo.QueryHookOptions<GetSlotsForSeasonQuery, GetSlotsForSeasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlotsForSeasonQuery, GetSlotsForSeasonQueryVariables>(GetSlotsForSeasonDocument, options);
      }
export function useGetSlotsForSeasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlotsForSeasonQuery, GetSlotsForSeasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlotsForSeasonQuery, GetSlotsForSeasonQueryVariables>(GetSlotsForSeasonDocument, options);
        }
export type GetSlotsForSeasonQueryHookResult = ReturnType<typeof useGetSlotsForSeasonQuery>;
export type GetSlotsForSeasonLazyQueryHookResult = ReturnType<typeof useGetSlotsForSeasonLazyQuery>;
export type GetSlotsForSeasonQueryResult = Apollo.QueryResult<GetSlotsForSeasonQuery, GetSlotsForSeasonQueryVariables>;
export function refetchGetSlotsForSeasonQuery(variables: GetSlotsForSeasonQueryVariables) {
      return { query: GetSlotsForSeasonDocument, variables: variables }
    }
export const GetSlotDocument = gql`
    query getSlot($id: UUID!) {
  slot(id: $id) {
    id
    name
    status
    bestOf
    seriesBestOf
    scheduleMatchesAt
    startsAt
    isStartsAtHidden
    fortniteEventWindowId
    phase {
      id
      type
    }
  }
}
    `;

/**
 * __useGetSlotQuery__
 *
 * To run a query within a React component, call `useGetSlotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlotQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSlotQuery(baseOptions: Apollo.QueryHookOptions<GetSlotQuery, GetSlotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSlotQuery, GetSlotQueryVariables>(GetSlotDocument, options);
      }
export function useGetSlotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSlotQuery, GetSlotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSlotQuery, GetSlotQueryVariables>(GetSlotDocument, options);
        }
export type GetSlotQueryHookResult = ReturnType<typeof useGetSlotQuery>;
export type GetSlotLazyQueryHookResult = ReturnType<typeof useGetSlotLazyQuery>;
export type GetSlotQueryResult = Apollo.QueryResult<GetSlotQuery, GetSlotQueryVariables>;
export function refetchGetSlotQuery(variables: GetSlotQueryVariables) {
      return { query: GetSlotDocument, variables: variables }
    }
export const SlotTimezoneDocument = gql`
    query slotTimezone($slotId: UUID!) {
  slot(id: $slotId) {
    id
    timezone
  }
}
    `;

/**
 * __useSlotTimezoneQuery__
 *
 * To run a query within a React component, call `useSlotTimezoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlotTimezoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlotTimezoneQuery({
 *   variables: {
 *      slotId: // value for 'slotId'
 *   },
 * });
 */
export function useSlotTimezoneQuery(baseOptions: Apollo.QueryHookOptions<SlotTimezoneQuery, SlotTimezoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlotTimezoneQuery, SlotTimezoneQueryVariables>(SlotTimezoneDocument, options);
      }
export function useSlotTimezoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlotTimezoneQuery, SlotTimezoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlotTimezoneQuery, SlotTimezoneQueryVariables>(SlotTimezoneDocument, options);
        }
export type SlotTimezoneQueryHookResult = ReturnType<typeof useSlotTimezoneQuery>;
export type SlotTimezoneLazyQueryHookResult = ReturnType<typeof useSlotTimezoneLazyQuery>;
export type SlotTimezoneQueryResult = Apollo.QueryResult<SlotTimezoneQuery, SlotTimezoneQueryVariables>;
export function refetchSlotTimezoneQuery(variables: SlotTimezoneQueryVariables) {
      return { query: SlotTimezoneDocument, variables: variables }
    }
export const RescheduleSlotDocument = gql`
    mutation rescheduleSlot($input: RescheduleSlotInput!) {
  rescheduleSlot(input: $input) {
    success
    slot {
      id
      startsAt
      scheduleMatchesAt
    }
  }
}
    `;
export type RescheduleSlotMutationFn = Apollo.MutationFunction<RescheduleSlotMutation, RescheduleSlotMutationVariables>;

/**
 * __useRescheduleSlotMutation__
 *
 * To run a mutation, you first call `useRescheduleSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleSlotMutation, { data, loading, error }] = useRescheduleSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleSlotMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleSlotMutation, RescheduleSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleSlotMutation, RescheduleSlotMutationVariables>(RescheduleSlotDocument, options);
      }
export type RescheduleSlotMutationHookResult = ReturnType<typeof useRescheduleSlotMutation>;
export type RescheduleSlotMutationResult = Apollo.MutationResult<RescheduleSlotMutation>;
export type RescheduleSlotMutationOptions = Apollo.BaseMutationOptions<RescheduleSlotMutation, RescheduleSlotMutationVariables>;
export const CreateBracketSlotsDocument = gql`
    mutation createBracketSlots($phaseId: UUID!) {
  createBracketSlots(phaseId: $phaseId) {
    id
  }
}
    `;
export type CreateBracketSlotsMutationFn = Apollo.MutationFunction<CreateBracketSlotsMutation, CreateBracketSlotsMutationVariables>;

/**
 * __useCreateBracketSlotsMutation__
 *
 * To run a mutation, you first call `useCreateBracketSlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBracketSlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBracketSlotsMutation, { data, loading, error }] = useCreateBracketSlotsMutation({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useCreateBracketSlotsMutation(baseOptions?: Apollo.MutationHookOptions<CreateBracketSlotsMutation, CreateBracketSlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBracketSlotsMutation, CreateBracketSlotsMutationVariables>(CreateBracketSlotsDocument, options);
      }
export type CreateBracketSlotsMutationHookResult = ReturnType<typeof useCreateBracketSlotsMutation>;
export type CreateBracketSlotsMutationResult = Apollo.MutationResult<CreateBracketSlotsMutation>;
export type CreateBracketSlotsMutationOptions = Apollo.BaseMutationOptions<CreateBracketSlotsMutation, CreateBracketSlotsMutationVariables>;
export const CreateSlotDocument = gql`
    mutation createSlot($input: CreateSlotInput!) {
  createSlot(input: $input) {
    slot {
      id
    }
  }
}
    `;
export type CreateSlotMutationFn = Apollo.MutationFunction<CreateSlotMutation, CreateSlotMutationVariables>;

/**
 * __useCreateSlotMutation__
 *
 * To run a mutation, you first call `useCreateSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlotMutation, { data, loading, error }] = useCreateSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSlotMutation(baseOptions?: Apollo.MutationHookOptions<CreateSlotMutation, CreateSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSlotMutation, CreateSlotMutationVariables>(CreateSlotDocument, options);
      }
export type CreateSlotMutationHookResult = ReturnType<typeof useCreateSlotMutation>;
export type CreateSlotMutationResult = Apollo.MutationResult<CreateSlotMutation>;
export type CreateSlotMutationOptions = Apollo.BaseMutationOptions<CreateSlotMutation, CreateSlotMutationVariables>;
export const UpdateSlotDocument = gql`
    mutation updateSlot($input: UpdateSlotInput!) {
  updateSlot(input: $input) {
    slot {
      id
    }
  }
}
    `;
export type UpdateSlotMutationFn = Apollo.MutationFunction<UpdateSlotMutation, UpdateSlotMutationVariables>;

/**
 * __useUpdateSlotMutation__
 *
 * To run a mutation, you first call `useUpdateSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlotMutation, { data, loading, error }] = useUpdateSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSlotMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSlotMutation, UpdateSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSlotMutation, UpdateSlotMutationVariables>(UpdateSlotDocument, options);
      }
export type UpdateSlotMutationHookResult = ReturnType<typeof useUpdateSlotMutation>;
export type UpdateSlotMutationResult = Apollo.MutationResult<UpdateSlotMutation>;
export type UpdateSlotMutationOptions = Apollo.BaseMutationOptions<UpdateSlotMutation, UpdateSlotMutationVariables>;
export const CancelSlotDocument = gql`
    mutation cancelSlot($input: CancelSlotInput!) {
  cancelSlot(input: $input) {
    success
  }
}
    `;
export type CancelSlotMutationFn = Apollo.MutationFunction<CancelSlotMutation, CancelSlotMutationVariables>;

/**
 * __useCancelSlotMutation__
 *
 * To run a mutation, you first call `useCancelSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSlotMutation, { data, loading, error }] = useCancelSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSlotMutation(baseOptions?: Apollo.MutationHookOptions<CancelSlotMutation, CancelSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSlotMutation, CancelSlotMutationVariables>(CancelSlotDocument, options);
      }
export type CancelSlotMutationHookResult = ReturnType<typeof useCancelSlotMutation>;
export type CancelSlotMutationResult = Apollo.MutationResult<CancelSlotMutation>;
export type CancelSlotMutationOptions = Apollo.BaseMutationOptions<CancelSlotMutation, CancelSlotMutationVariables>;
export const SponsorshipImagesDocument = gql`
    query sponsorshipImages($entityId: UUID!, $entityType: SponsorshipEntityType!) {
  sponsorshipImages(entityId: $entityId, entityType: $entityType) {
    id
    entityId
    entityType
    name
    url
    updatedAt
  }
}
    `;

/**
 * __useSponsorshipImagesQuery__
 *
 * To run a query within a React component, call `useSponsorshipImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorshipImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorshipImagesQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useSponsorshipImagesQuery(baseOptions: Apollo.QueryHookOptions<SponsorshipImagesQuery, SponsorshipImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsorshipImagesQuery, SponsorshipImagesQueryVariables>(SponsorshipImagesDocument, options);
      }
export function useSponsorshipImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsorshipImagesQuery, SponsorshipImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsorshipImagesQuery, SponsorshipImagesQueryVariables>(SponsorshipImagesDocument, options);
        }
export type SponsorshipImagesQueryHookResult = ReturnType<typeof useSponsorshipImagesQuery>;
export type SponsorshipImagesLazyQueryHookResult = ReturnType<typeof useSponsorshipImagesLazyQuery>;
export type SponsorshipImagesQueryResult = Apollo.QueryResult<SponsorshipImagesQuery, SponsorshipImagesQueryVariables>;
export function refetchSponsorshipImagesQuery(variables: SponsorshipImagesQueryVariables) {
      return { query: SponsorshipImagesDocument, variables: variables }
    }
export const SeasonSponsorshipImagesDocument = gql`
    query seasonSponsorshipImages($seasonId: UUID!) {
  season(id: $seasonId) {
    id
    sponsorshipImages {
      id
      entityId
      entityType
      name
      url
      updatedAt
    }
  }
}
    `;

/**
 * __useSeasonSponsorshipImagesQuery__
 *
 * To run a query within a React component, call `useSeasonSponsorshipImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeasonSponsorshipImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeasonSponsorshipImagesQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useSeasonSponsorshipImagesQuery(baseOptions: Apollo.QueryHookOptions<SeasonSponsorshipImagesQuery, SeasonSponsorshipImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeasonSponsorshipImagesQuery, SeasonSponsorshipImagesQueryVariables>(SeasonSponsorshipImagesDocument, options);
      }
export function useSeasonSponsorshipImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeasonSponsorshipImagesQuery, SeasonSponsorshipImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeasonSponsorshipImagesQuery, SeasonSponsorshipImagesQueryVariables>(SeasonSponsorshipImagesDocument, options);
        }
export type SeasonSponsorshipImagesQueryHookResult = ReturnType<typeof useSeasonSponsorshipImagesQuery>;
export type SeasonSponsorshipImagesLazyQueryHookResult = ReturnType<typeof useSeasonSponsorshipImagesLazyQuery>;
export type SeasonSponsorshipImagesQueryResult = Apollo.QueryResult<SeasonSponsorshipImagesQuery, SeasonSponsorshipImagesQueryVariables>;
export function refetchSeasonSponsorshipImagesQuery(variables: SeasonSponsorshipImagesQueryVariables) {
      return { query: SeasonSponsorshipImagesDocument, variables: variables }
    }
export const SponsorshipCampaignsDocument = gql`
    query sponsorshipCampaigns($input: SponsorshipCampaignSearchInput!) {
  sponsorshipCampaigns(input: $input) {
    result {
      id
      title
      startDate
      endDate
      status
      sponsorshipImages {
        id
        entityId
        entityType
        name
        url
        updatedAt
      }
    }
    total
  }
}
    `;

/**
 * __useSponsorshipCampaignsQuery__
 *
 * To run a query within a React component, call `useSponsorshipCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorshipCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorshipCampaignsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSponsorshipCampaignsQuery(baseOptions: Apollo.QueryHookOptions<SponsorshipCampaignsQuery, SponsorshipCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsorshipCampaignsQuery, SponsorshipCampaignsQueryVariables>(SponsorshipCampaignsDocument, options);
      }
export function useSponsorshipCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsorshipCampaignsQuery, SponsorshipCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsorshipCampaignsQuery, SponsorshipCampaignsQueryVariables>(SponsorshipCampaignsDocument, options);
        }
export type SponsorshipCampaignsQueryHookResult = ReturnType<typeof useSponsorshipCampaignsQuery>;
export type SponsorshipCampaignsLazyQueryHookResult = ReturnType<typeof useSponsorshipCampaignsLazyQuery>;
export type SponsorshipCampaignsQueryResult = Apollo.QueryResult<SponsorshipCampaignsQuery, SponsorshipCampaignsQueryVariables>;
export function refetchSponsorshipCampaignsQuery(variables: SponsorshipCampaignsQueryVariables) {
      return { query: SponsorshipCampaignsDocument, variables: variables }
    }
export const SponsorshipCampaignDocument = gql`
    query sponsorshipCampaign($id: UUID!) {
  sponsorshipCampaign(id: $id) {
    id
    partnerId
    title
    startDate
    endDate
    status
    sponsorshipImages {
      id
      entityId
      entityType
      name
      url
      updatedAt
    }
    sponsorshipComponents {
      id
      entityId
      entityType
      name
      title
      subtitle
      url
      callToAction
      sponsorshipImages {
        id
        entityId
        entityType
        name
        url
        updatedAt
      }
    }
    schools {
      id
      name
    }
  }
}
    `;

/**
 * __useSponsorshipCampaignQuery__
 *
 * To run a query within a React component, call `useSponsorshipCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorshipCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorshipCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSponsorshipCampaignQuery(baseOptions: Apollo.QueryHookOptions<SponsorshipCampaignQuery, SponsorshipCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SponsorshipCampaignQuery, SponsorshipCampaignQueryVariables>(SponsorshipCampaignDocument, options);
      }
export function useSponsorshipCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SponsorshipCampaignQuery, SponsorshipCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SponsorshipCampaignQuery, SponsorshipCampaignQueryVariables>(SponsorshipCampaignDocument, options);
        }
export type SponsorshipCampaignQueryHookResult = ReturnType<typeof useSponsorshipCampaignQuery>;
export type SponsorshipCampaignLazyQueryHookResult = ReturnType<typeof useSponsorshipCampaignLazyQuery>;
export type SponsorshipCampaignQueryResult = Apollo.QueryResult<SponsorshipCampaignQuery, SponsorshipCampaignQueryVariables>;
export function refetchSponsorshipCampaignQuery(variables: SponsorshipCampaignQueryVariables) {
      return { query: SponsorshipCampaignDocument, variables: variables }
    }
export const UploadSponsorshipImageDocument = gql`
    mutation uploadSponsorshipImage($entityId: UUID!, $entityType: SponsorshipEntityType!, $name: String!, $file: Upload!) {
  uploadSponsorshipImage(
    entityId: $entityId
    entityType: $entityType
    name: $name
    file: $file
  ) {
    id
    url
  }
}
    `;
export type UploadSponsorshipImageMutationFn = Apollo.MutationFunction<UploadSponsorshipImageMutation, UploadSponsorshipImageMutationVariables>;

/**
 * __useUploadSponsorshipImageMutation__
 *
 * To run a mutation, you first call `useUploadSponsorshipImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSponsorshipImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSponsorshipImageMutation, { data, loading, error }] = useUploadSponsorshipImageMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      name: // value for 'name'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadSponsorshipImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadSponsorshipImageMutation, UploadSponsorshipImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadSponsorshipImageMutation, UploadSponsorshipImageMutationVariables>(UploadSponsorshipImageDocument, options);
      }
export type UploadSponsorshipImageMutationHookResult = ReturnType<typeof useUploadSponsorshipImageMutation>;
export type UploadSponsorshipImageMutationResult = Apollo.MutationResult<UploadSponsorshipImageMutation>;
export type UploadSponsorshipImageMutationOptions = Apollo.BaseMutationOptions<UploadSponsorshipImageMutation, UploadSponsorshipImageMutationVariables>;
export const RemoveSponsorshipImageDocument = gql`
    mutation removeSponsorshipImage($id: UUID!) {
  removeSponsorshipImage(id: $id) {
    success
  }
}
    `;
export type RemoveSponsorshipImageMutationFn = Apollo.MutationFunction<RemoveSponsorshipImageMutation, RemoveSponsorshipImageMutationVariables>;

/**
 * __useRemoveSponsorshipImageMutation__
 *
 * To run a mutation, you first call `useRemoveSponsorshipImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSponsorshipImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSponsorshipImageMutation, { data, loading, error }] = useRemoveSponsorshipImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSponsorshipImageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSponsorshipImageMutation, RemoveSponsorshipImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSponsorshipImageMutation, RemoveSponsorshipImageMutationVariables>(RemoveSponsorshipImageDocument, options);
      }
export type RemoveSponsorshipImageMutationHookResult = ReturnType<typeof useRemoveSponsorshipImageMutation>;
export type RemoveSponsorshipImageMutationResult = Apollo.MutationResult<RemoveSponsorshipImageMutation>;
export type RemoveSponsorshipImageMutationOptions = Apollo.BaseMutationOptions<RemoveSponsorshipImageMutation, RemoveSponsorshipImageMutationVariables>;
export const UpsertSponsorshipImageDocument = gql`
    mutation upsertSponsorshipImage($entityId: UUID!, $entityType: SponsorshipEntityType!, $name: String!, $url: String!) {
  upsertSponsorshipImage(
    entityId: $entityId
    entityType: $entityType
    name: $name
    url: $url
  ) {
    id
    url
  }
}
    `;
export type UpsertSponsorshipImageMutationFn = Apollo.MutationFunction<UpsertSponsorshipImageMutation, UpsertSponsorshipImageMutationVariables>;

/**
 * __useUpsertSponsorshipImageMutation__
 *
 * To run a mutation, you first call `useUpsertSponsorshipImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSponsorshipImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSponsorshipImageMutation, { data, loading, error }] = useUpsertSponsorshipImageMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useUpsertSponsorshipImageMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSponsorshipImageMutation, UpsertSponsorshipImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSponsorshipImageMutation, UpsertSponsorshipImageMutationVariables>(UpsertSponsorshipImageDocument, options);
      }
export type UpsertSponsorshipImageMutationHookResult = ReturnType<typeof useUpsertSponsorshipImageMutation>;
export type UpsertSponsorshipImageMutationResult = Apollo.MutationResult<UpsertSponsorshipImageMutation>;
export type UpsertSponsorshipImageMutationOptions = Apollo.BaseMutationOptions<UpsertSponsorshipImageMutation, UpsertSponsorshipImageMutationVariables>;
export const CreateSponsorshipCampaignDocument = gql`
    mutation createSponsorshipCampaign($input: SponsorshipCampaignInput!) {
  createSponsorshipCampaign(input: $input) {
    id
    partnerId
    title
    startDate
    endDate
    status
    sponsorshipImages {
      id
      entityId
      entityType
      name
      url
      updatedAt
    }
  }
}
    `;
export type CreateSponsorshipCampaignMutationFn = Apollo.MutationFunction<CreateSponsorshipCampaignMutation, CreateSponsorshipCampaignMutationVariables>;

/**
 * __useCreateSponsorshipCampaignMutation__
 *
 * To run a mutation, you first call `useCreateSponsorshipCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSponsorshipCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSponsorshipCampaignMutation, { data, loading, error }] = useCreateSponsorshipCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSponsorshipCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateSponsorshipCampaignMutation, CreateSponsorshipCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSponsorshipCampaignMutation, CreateSponsorshipCampaignMutationVariables>(CreateSponsorshipCampaignDocument, options);
      }
export type CreateSponsorshipCampaignMutationHookResult = ReturnType<typeof useCreateSponsorshipCampaignMutation>;
export type CreateSponsorshipCampaignMutationResult = Apollo.MutationResult<CreateSponsorshipCampaignMutation>;
export type CreateSponsorshipCampaignMutationOptions = Apollo.BaseMutationOptions<CreateSponsorshipCampaignMutation, CreateSponsorshipCampaignMutationVariables>;
export const UpdateSponsorshipCampaignDocument = gql`
    mutation updateSponsorshipCampaign($id: UUID!, $input: SponsorshipCampaignUpdateInput!) {
  updateSponsorshipCampaign(id: $id, input: $input) {
    id
    partnerId
    title
    startDate
    endDate
    status
    sponsorshipImages {
      id
      entityId
      entityType
      name
      url
      updatedAt
    }
  }
}
    `;
export type UpdateSponsorshipCampaignMutationFn = Apollo.MutationFunction<UpdateSponsorshipCampaignMutation, UpdateSponsorshipCampaignMutationVariables>;

/**
 * __useUpdateSponsorshipCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateSponsorshipCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSponsorshipCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSponsorshipCampaignMutation, { data, loading, error }] = useUpdateSponsorshipCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSponsorshipCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSponsorshipCampaignMutation, UpdateSponsorshipCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSponsorshipCampaignMutation, UpdateSponsorshipCampaignMutationVariables>(UpdateSponsorshipCampaignDocument, options);
      }
export type UpdateSponsorshipCampaignMutationHookResult = ReturnType<typeof useUpdateSponsorshipCampaignMutation>;
export type UpdateSponsorshipCampaignMutationResult = Apollo.MutationResult<UpdateSponsorshipCampaignMutation>;
export type UpdateSponsorshipCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateSponsorshipCampaignMutation, UpdateSponsorshipCampaignMutationVariables>;
export const DeleteSponsorshipCampaignDocument = gql`
    mutation deleteSponsorshipCampaign($id: UUID!) {
  deleteSponsorshipCampaign(id: $id) {
    success
  }
}
    `;
export type DeleteSponsorshipCampaignMutationFn = Apollo.MutationFunction<DeleteSponsorshipCampaignMutation, DeleteSponsorshipCampaignMutationVariables>;

/**
 * __useDeleteSponsorshipCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteSponsorshipCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSponsorshipCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSponsorshipCampaignMutation, { data, loading, error }] = useDeleteSponsorshipCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSponsorshipCampaignMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSponsorshipCampaignMutation, DeleteSponsorshipCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSponsorshipCampaignMutation, DeleteSponsorshipCampaignMutationVariables>(DeleteSponsorshipCampaignDocument, options);
      }
export type DeleteSponsorshipCampaignMutationHookResult = ReturnType<typeof useDeleteSponsorshipCampaignMutation>;
export type DeleteSponsorshipCampaignMutationResult = Apollo.MutationResult<DeleteSponsorshipCampaignMutation>;
export type DeleteSponsorshipCampaignMutationOptions = Apollo.BaseMutationOptions<DeleteSponsorshipCampaignMutation, DeleteSponsorshipCampaignMutationVariables>;
export const SetSchoolsForCampaignDocument = gql`
    mutation setSchoolsForCampaign($input: SetSponsorshipCampaignSchoolsInput!) {
  setSchoolsForCampaign(input: $input) {
    success
  }
}
    `;
export type SetSchoolsForCampaignMutationFn = Apollo.MutationFunction<SetSchoolsForCampaignMutation, SetSchoolsForCampaignMutationVariables>;

/**
 * __useSetSchoolsForCampaignMutation__
 *
 * To run a mutation, you first call `useSetSchoolsForCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSchoolsForCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSchoolsForCampaignMutation, { data, loading, error }] = useSetSchoolsForCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSchoolsForCampaignMutation(baseOptions?: Apollo.MutationHookOptions<SetSchoolsForCampaignMutation, SetSchoolsForCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSchoolsForCampaignMutation, SetSchoolsForCampaignMutationVariables>(SetSchoolsForCampaignDocument, options);
      }
export type SetSchoolsForCampaignMutationHookResult = ReturnType<typeof useSetSchoolsForCampaignMutation>;
export type SetSchoolsForCampaignMutationResult = Apollo.MutationResult<SetSchoolsForCampaignMutation>;
export type SetSchoolsForCampaignMutationOptions = Apollo.BaseMutationOptions<SetSchoolsForCampaignMutation, SetSchoolsForCampaignMutationVariables>;
export const CreateSponsorshipComponentDocument = gql`
    mutation createSponsorshipComponent($input: SponsorshipComponentInput!) {
  createSponsorshipComponent(input: $input) {
    id
  }
}
    `;
export type CreateSponsorshipComponentMutationFn = Apollo.MutationFunction<CreateSponsorshipComponentMutation, CreateSponsorshipComponentMutationVariables>;

/**
 * __useCreateSponsorshipComponentMutation__
 *
 * To run a mutation, you first call `useCreateSponsorshipComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSponsorshipComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSponsorshipComponentMutation, { data, loading, error }] = useCreateSponsorshipComponentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSponsorshipComponentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSponsorshipComponentMutation, CreateSponsorshipComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSponsorshipComponentMutation, CreateSponsorshipComponentMutationVariables>(CreateSponsorshipComponentDocument, options);
      }
export type CreateSponsorshipComponentMutationHookResult = ReturnType<typeof useCreateSponsorshipComponentMutation>;
export type CreateSponsorshipComponentMutationResult = Apollo.MutationResult<CreateSponsorshipComponentMutation>;
export type CreateSponsorshipComponentMutationOptions = Apollo.BaseMutationOptions<CreateSponsorshipComponentMutation, CreateSponsorshipComponentMutationVariables>;
export const UpdateSponsorshipComponentDocument = gql`
    mutation updateSponsorshipComponent($id: UUID!, $input: SponsorshipComponentUpdateInput!) {
  updateSponsorshipComponent(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateSponsorshipComponentMutationFn = Apollo.MutationFunction<UpdateSponsorshipComponentMutation, UpdateSponsorshipComponentMutationVariables>;

/**
 * __useUpdateSponsorshipComponentMutation__
 *
 * To run a mutation, you first call `useUpdateSponsorshipComponentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSponsorshipComponentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSponsorshipComponentMutation, { data, loading, error }] = useUpdateSponsorshipComponentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSponsorshipComponentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSponsorshipComponentMutation, UpdateSponsorshipComponentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSponsorshipComponentMutation, UpdateSponsorshipComponentMutationVariables>(UpdateSponsorshipComponentDocument, options);
      }
export type UpdateSponsorshipComponentMutationHookResult = ReturnType<typeof useUpdateSponsorshipComponentMutation>;
export type UpdateSponsorshipComponentMutationResult = Apollo.MutationResult<UpdateSponsorshipComponentMutation>;
export type UpdateSponsorshipComponentMutationOptions = Apollo.BaseMutationOptions<UpdateSponsorshipComponentMutation, UpdateSponsorshipComponentMutationVariables>;
export const GetMatchDataForActionAndInfoSectionDocument = gql`
    query getMatchDataForActionAndInfoSection($matchId: UUID!) {
  match(id: $matchId) {
    id
    status
    scheduledStartsAt
    bestOf
    isScrimmage
    esport {
      id
      slug
    }
    teamContext {
      matchId
      teams {
        id
        name
        isMyTeam
      }
    }
    matchRescheduleRequests {
      id
      proposedTimes
      status
      teamId
      matchId
    }
    slot {
      id
      phase {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useGetMatchDataForActionAndInfoSectionQuery__
 *
 * To run a query within a React component, call `useGetMatchDataForActionAndInfoSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchDataForActionAndInfoSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchDataForActionAndInfoSectionQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchDataForActionAndInfoSectionQuery(baseOptions: Apollo.QueryHookOptions<GetMatchDataForActionAndInfoSectionQuery, GetMatchDataForActionAndInfoSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchDataForActionAndInfoSectionQuery, GetMatchDataForActionAndInfoSectionQueryVariables>(GetMatchDataForActionAndInfoSectionDocument, options);
      }
export function useGetMatchDataForActionAndInfoSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchDataForActionAndInfoSectionQuery, GetMatchDataForActionAndInfoSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchDataForActionAndInfoSectionQuery, GetMatchDataForActionAndInfoSectionQueryVariables>(GetMatchDataForActionAndInfoSectionDocument, options);
        }
export type GetMatchDataForActionAndInfoSectionQueryHookResult = ReturnType<typeof useGetMatchDataForActionAndInfoSectionQuery>;
export type GetMatchDataForActionAndInfoSectionLazyQueryHookResult = ReturnType<typeof useGetMatchDataForActionAndInfoSectionLazyQuery>;
export type GetMatchDataForActionAndInfoSectionQueryResult = Apollo.QueryResult<GetMatchDataForActionAndInfoSectionQuery, GetMatchDataForActionAndInfoSectionQueryVariables>;
export function refetchGetMatchDataForActionAndInfoSectionQuery(variables: GetMatchDataForActionAndInfoSectionQueryVariables) {
      return { query: GetMatchDataForActionAndInfoSectionDocument, variables: variables }
    }
export const GetMatchRescheduleRequestDataForMenuDocument = gql`
    query getMatchRescheduleRequestDataForMenu($matchId: UUID!) {
  match(id: $matchId) {
    id
    matchRescheduleRequests {
      id
      status
      teamId
      matchId
      rescheduleNotes
    }
  }
}
    `;

/**
 * __useGetMatchRescheduleRequestDataForMenuQuery__
 *
 * To run a query within a React component, call `useGetMatchRescheduleRequestDataForMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchRescheduleRequestDataForMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchRescheduleRequestDataForMenuQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchRescheduleRequestDataForMenuQuery(baseOptions: Apollo.QueryHookOptions<GetMatchRescheduleRequestDataForMenuQuery, GetMatchRescheduleRequestDataForMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchRescheduleRequestDataForMenuQuery, GetMatchRescheduleRequestDataForMenuQueryVariables>(GetMatchRescheduleRequestDataForMenuDocument, options);
      }
export function useGetMatchRescheduleRequestDataForMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchRescheduleRequestDataForMenuQuery, GetMatchRescheduleRequestDataForMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchRescheduleRequestDataForMenuQuery, GetMatchRescheduleRequestDataForMenuQueryVariables>(GetMatchRescheduleRequestDataForMenuDocument, options);
        }
export type GetMatchRescheduleRequestDataForMenuQueryHookResult = ReturnType<typeof useGetMatchRescheduleRequestDataForMenuQuery>;
export type GetMatchRescheduleRequestDataForMenuLazyQueryHookResult = ReturnType<typeof useGetMatchRescheduleRequestDataForMenuLazyQuery>;
export type GetMatchRescheduleRequestDataForMenuQueryResult = Apollo.QueryResult<GetMatchRescheduleRequestDataForMenuQuery, GetMatchRescheduleRequestDataForMenuQueryVariables>;
export function refetchGetMatchRescheduleRequestDataForMenuQuery(variables: GetMatchRescheduleRequestDataForMenuQueryVariables) {
      return { query: GetMatchRescheduleRequestDataForMenuDocument, variables: variables }
    }
export const GetMatchFormatByUuidDocument = gql`
    query getMatchFormatByUUID($matchId: UUID!) {
  match(id: $matchId) {
    id
    format
  }
}
    `;

/**
 * __useGetMatchFormatByUuidQuery__
 *
 * To run a query within a React component, call `useGetMatchFormatByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchFormatByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchFormatByUuidQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchFormatByUuidQuery(baseOptions: Apollo.QueryHookOptions<GetMatchFormatByUuidQuery, GetMatchFormatByUuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchFormatByUuidQuery, GetMatchFormatByUuidQueryVariables>(GetMatchFormatByUuidDocument, options);
      }
export function useGetMatchFormatByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchFormatByUuidQuery, GetMatchFormatByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchFormatByUuidQuery, GetMatchFormatByUuidQueryVariables>(GetMatchFormatByUuidDocument, options);
        }
export type GetMatchFormatByUuidQueryHookResult = ReturnType<typeof useGetMatchFormatByUuidQuery>;
export type GetMatchFormatByUuidLazyQueryHookResult = ReturnType<typeof useGetMatchFormatByUuidLazyQuery>;
export type GetMatchFormatByUuidQueryResult = Apollo.QueryResult<GetMatchFormatByUuidQuery, GetMatchFormatByUuidQueryVariables>;
export function refetchGetMatchFormatByUuidQuery(variables: GetMatchFormatByUuidQueryVariables) {
      return { query: GetMatchFormatByUuidDocument, variables: variables }
    }
export const GetTopLevelMatchDataDocument = gql`
    query getTopLevelMatchData($matchId: UUID!) {
  match(id: $matchId) {
    id
    status
    isScrimmage
    scheduledStartsAt
    matchAssistantEnabled
    slot {
      id
      phase {
        id
        format
      }
    }
    esport {
      id
      slug
      rating
    }
    bestOf
    seriesBestOf
    teamContext {
      matchId
      myTeams {
        id
        schoolId
        name
        avatarUrl
        competitionGroup
        school {
          id
          name
          slug
        }
      }
      otherTeams {
        id
        schoolId
        name
        avatarUrl
        competitionGroup
        school {
          id
          name
          slug
        }
      }
      teams {
        isMyTeam
        id
        competitionGroup
        name
        avatarUrl
        schoolId
        school {
          id
          name
          slug
        }
      }
    }
    winningTeamId
    team1Score
    team2Score
    format
    league {
      sponsorshipComponents {
        id
        entityId
        entityType
        name
        title
        subtitle
        url
        callToAction
        sponsorshipImages {
          id
          entityId
          entityType
          name
          updatedAt
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetTopLevelMatchDataQuery__
 *
 * To run a query within a React component, call `useGetTopLevelMatchDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopLevelMatchDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopLevelMatchDataQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetTopLevelMatchDataQuery(baseOptions: Apollo.QueryHookOptions<GetTopLevelMatchDataQuery, GetTopLevelMatchDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopLevelMatchDataQuery, GetTopLevelMatchDataQueryVariables>(GetTopLevelMatchDataDocument, options);
      }
export function useGetTopLevelMatchDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopLevelMatchDataQuery, GetTopLevelMatchDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopLevelMatchDataQuery, GetTopLevelMatchDataQueryVariables>(GetTopLevelMatchDataDocument, options);
        }
export type GetTopLevelMatchDataQueryHookResult = ReturnType<typeof useGetTopLevelMatchDataQuery>;
export type GetTopLevelMatchDataLazyQueryHookResult = ReturnType<typeof useGetTopLevelMatchDataLazyQuery>;
export type GetTopLevelMatchDataQueryResult = Apollo.QueryResult<GetTopLevelMatchDataQuery, GetTopLevelMatchDataQueryVariables>;
export function refetchGetTopLevelMatchDataQuery(variables: GetTopLevelMatchDataQueryVariables) {
      return { query: GetTopLevelMatchDataDocument, variables: variables }
    }
export const GetOnMatchQueueRedirectDataDocument = gql`
    query getOnMatchQueueRedirectData($matchId: UUID!) {
  match(id: $matchId) {
    id
    matchResults {
      id
      placing
      teamId
    }
  }
}
    `;

/**
 * __useGetOnMatchQueueRedirectDataQuery__
 *
 * To run a query within a React component, call `useGetOnMatchQueueRedirectDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnMatchQueueRedirectDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnMatchQueueRedirectDataQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetOnMatchQueueRedirectDataQuery(baseOptions: Apollo.QueryHookOptions<GetOnMatchQueueRedirectDataQuery, GetOnMatchQueueRedirectDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnMatchQueueRedirectDataQuery, GetOnMatchQueueRedirectDataQueryVariables>(GetOnMatchQueueRedirectDataDocument, options);
      }
export function useGetOnMatchQueueRedirectDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnMatchQueueRedirectDataQuery, GetOnMatchQueueRedirectDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnMatchQueueRedirectDataQuery, GetOnMatchQueueRedirectDataQueryVariables>(GetOnMatchQueueRedirectDataDocument, options);
        }
export type GetOnMatchQueueRedirectDataQueryHookResult = ReturnType<typeof useGetOnMatchQueueRedirectDataQuery>;
export type GetOnMatchQueueRedirectDataLazyQueryHookResult = ReturnType<typeof useGetOnMatchQueueRedirectDataLazyQuery>;
export type GetOnMatchQueueRedirectDataQueryResult = Apollo.QueryResult<GetOnMatchQueueRedirectDataQuery, GetOnMatchQueueRedirectDataQueryVariables>;
export function refetchGetOnMatchQueueRedirectDataQuery(variables: GetOnMatchQueueRedirectDataQueryVariables) {
      return { query: GetOnMatchQueueRedirectDataDocument, variables: variables }
    }
export const GetMatchPhaseTypeAndScheduleStartsAtDocument = gql`
    query getMatchPhaseTypeAndScheduleStartsAt($matchId: UUID!) {
  match(id: $matchId) {
    id
    scheduledStartsAt
    isScrimmage
    esport {
      id
      slug
    }
    games {
      id
      status
      gameResults {
        id
        placing
        teamId
      }
    }
    slot {
      id
      phase {
        id
        type
        season {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetMatchPhaseTypeAndScheduleStartsAtQuery__
 *
 * To run a query within a React component, call `useGetMatchPhaseTypeAndScheduleStartsAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchPhaseTypeAndScheduleStartsAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchPhaseTypeAndScheduleStartsAtQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchPhaseTypeAndScheduleStartsAtQuery(baseOptions: Apollo.QueryHookOptions<GetMatchPhaseTypeAndScheduleStartsAtQuery, GetMatchPhaseTypeAndScheduleStartsAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchPhaseTypeAndScheduleStartsAtQuery, GetMatchPhaseTypeAndScheduleStartsAtQueryVariables>(GetMatchPhaseTypeAndScheduleStartsAtDocument, options);
      }
export function useGetMatchPhaseTypeAndScheduleStartsAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchPhaseTypeAndScheduleStartsAtQuery, GetMatchPhaseTypeAndScheduleStartsAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchPhaseTypeAndScheduleStartsAtQuery, GetMatchPhaseTypeAndScheduleStartsAtQueryVariables>(GetMatchPhaseTypeAndScheduleStartsAtDocument, options);
        }
export type GetMatchPhaseTypeAndScheduleStartsAtQueryHookResult = ReturnType<typeof useGetMatchPhaseTypeAndScheduleStartsAtQuery>;
export type GetMatchPhaseTypeAndScheduleStartsAtLazyQueryHookResult = ReturnType<typeof useGetMatchPhaseTypeAndScheduleStartsAtLazyQuery>;
export type GetMatchPhaseTypeAndScheduleStartsAtQueryResult = Apollo.QueryResult<GetMatchPhaseTypeAndScheduleStartsAtQuery, GetMatchPhaseTypeAndScheduleStartsAtQueryVariables>;
export function refetchGetMatchPhaseTypeAndScheduleStartsAtQuery(variables: GetMatchPhaseTypeAndScheduleStartsAtQueryVariables) {
      return { query: GetMatchPhaseTypeAndScheduleStartsAtDocument, variables: variables }
    }
export const GetDataForMatchFaceoffSeriesDocument = gql`
    query getDataForMatchFaceoffSeries($matchId: UUID!) {
  match(id: $matchId) {
    id
    series {
      id
      teamContext {
        seriesId
        teams {
          id
          seriesId
          result {
            id
            placing
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDataForMatchFaceoffSeriesQuery__
 *
 * To run a query within a React component, call `useGetDataForMatchFaceoffSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForMatchFaceoffSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForMatchFaceoffSeriesQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetDataForMatchFaceoffSeriesQuery(baseOptions: Apollo.QueryHookOptions<GetDataForMatchFaceoffSeriesQuery, GetDataForMatchFaceoffSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataForMatchFaceoffSeriesQuery, GetDataForMatchFaceoffSeriesQueryVariables>(GetDataForMatchFaceoffSeriesDocument, options);
      }
export function useGetDataForMatchFaceoffSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataForMatchFaceoffSeriesQuery, GetDataForMatchFaceoffSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataForMatchFaceoffSeriesQuery, GetDataForMatchFaceoffSeriesQueryVariables>(GetDataForMatchFaceoffSeriesDocument, options);
        }
export type GetDataForMatchFaceoffSeriesQueryHookResult = ReturnType<typeof useGetDataForMatchFaceoffSeriesQuery>;
export type GetDataForMatchFaceoffSeriesLazyQueryHookResult = ReturnType<typeof useGetDataForMatchFaceoffSeriesLazyQuery>;
export type GetDataForMatchFaceoffSeriesQueryResult = Apollo.QueryResult<GetDataForMatchFaceoffSeriesQuery, GetDataForMatchFaceoffSeriesQueryVariables>;
export function refetchGetDataForMatchFaceoffSeriesQuery(variables: GetDataForMatchFaceoffSeriesQueryVariables) {
      return { query: GetDataForMatchFaceoffSeriesDocument, variables: variables }
    }
export const GetCurrentStepGamesScoreDocument = gql`
    query getCurrentStepGamesScore($input: CurrentGameAssistantStateInput!) {
  currentGameAssistantStateByMatchId(input: $input) {
    matchDetails {
      games {
        scores {
          teamId
          score
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentStepGamesScoreQuery__
 *
 * To run a query within a React component, call `useGetCurrentStepGamesScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentStepGamesScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentStepGamesScoreQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCurrentStepGamesScoreQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentStepGamesScoreQuery, GetCurrentStepGamesScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentStepGamesScoreQuery, GetCurrentStepGamesScoreQueryVariables>(GetCurrentStepGamesScoreDocument, options);
      }
export function useGetCurrentStepGamesScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentStepGamesScoreQuery, GetCurrentStepGamesScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentStepGamesScoreQuery, GetCurrentStepGamesScoreQueryVariables>(GetCurrentStepGamesScoreDocument, options);
        }
export type GetCurrentStepGamesScoreQueryHookResult = ReturnType<typeof useGetCurrentStepGamesScoreQuery>;
export type GetCurrentStepGamesScoreLazyQueryHookResult = ReturnType<typeof useGetCurrentStepGamesScoreLazyQuery>;
export type GetCurrentStepGamesScoreQueryResult = Apollo.QueryResult<GetCurrentStepGamesScoreQuery, GetCurrentStepGamesScoreQueryVariables>;
export function refetchGetCurrentStepGamesScoreQuery(variables: GetCurrentStepGamesScoreQueryVariables) {
      return { query: GetCurrentStepGamesScoreDocument, variables: variables }
    }
export const GetMatchScoreForHeaderDocument = gql`
    query getMatchScoreForHeader($matchId: UUID!, $includeHeadToHead: Boolean!) {
  match(id: $matchId) {
    id
    matchResults @include(if: $includeHeadToHead) {
      id
      teamId
      teamSide
    }
    headToHeadMatchScores @include(if: $includeHeadToHead) {
      matchId
      team1Score
      team2Score
    }
    teamContext @skip(if: $includeHeadToHead) {
      matchId
      myTeamMatchResults {
        id
        placing
      }
      otherTeamMatchResults {
        id
        placing
      }
    }
    winningTeamId
    status
  }
}
    `;

/**
 * __useGetMatchScoreForHeaderQuery__
 *
 * To run a query within a React component, call `useGetMatchScoreForHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchScoreForHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchScoreForHeaderQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *      includeHeadToHead: // value for 'includeHeadToHead'
 *   },
 * });
 */
export function useGetMatchScoreForHeaderQuery(baseOptions: Apollo.QueryHookOptions<GetMatchScoreForHeaderQuery, GetMatchScoreForHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchScoreForHeaderQuery, GetMatchScoreForHeaderQueryVariables>(GetMatchScoreForHeaderDocument, options);
      }
export function useGetMatchScoreForHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchScoreForHeaderQuery, GetMatchScoreForHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchScoreForHeaderQuery, GetMatchScoreForHeaderQueryVariables>(GetMatchScoreForHeaderDocument, options);
        }
export type GetMatchScoreForHeaderQueryHookResult = ReturnType<typeof useGetMatchScoreForHeaderQuery>;
export type GetMatchScoreForHeaderLazyQueryHookResult = ReturnType<typeof useGetMatchScoreForHeaderLazyQuery>;
export type GetMatchScoreForHeaderQueryResult = Apollo.QueryResult<GetMatchScoreForHeaderQuery, GetMatchScoreForHeaderQueryVariables>;
export function refetchGetMatchScoreForHeaderQuery(variables: GetMatchScoreForHeaderQueryVariables) {
      return { query: GetMatchScoreForHeaderDocument, variables: variables }
    }
export const GetMatchPhaseDocument = gql`
    query getMatchPhase($matchId: UUID!) {
  match(id: $matchId) {
    id
    slot {
      id
      phase {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useGetMatchPhaseQuery__
 *
 * To run a query within a React component, call `useGetMatchPhaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchPhaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchPhaseQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchPhaseQuery(baseOptions: Apollo.QueryHookOptions<GetMatchPhaseQuery, GetMatchPhaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchPhaseQuery, GetMatchPhaseQueryVariables>(GetMatchPhaseDocument, options);
      }
export function useGetMatchPhaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchPhaseQuery, GetMatchPhaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchPhaseQuery, GetMatchPhaseQueryVariables>(GetMatchPhaseDocument, options);
        }
export type GetMatchPhaseQueryHookResult = ReturnType<typeof useGetMatchPhaseQuery>;
export type GetMatchPhaseLazyQueryHookResult = ReturnType<typeof useGetMatchPhaseLazyQuery>;
export type GetMatchPhaseQueryResult = Apollo.QueryResult<GetMatchPhaseQuery, GetMatchPhaseQueryVariables>;
export function refetchGetMatchPhaseQuery(variables: GetMatchPhaseQueryVariables) {
      return { query: GetMatchPhaseDocument, variables: variables }
    }
export const GetMatchRostersContainerDataDocument = gql`
    query getMatchRostersContainerData($matchId: UUID!) {
  match(id: $matchId) {
    id
    metaseasonId
    scheduledStartsAt
    slot {
      id
      phase {
        id
        season {
          id
        }
      }
    }
    teamContext {
      matchId
      myTeams {
        id
        name
        competitionGroup
        deletedAt
        isMyTeam
        regularSeasonTeamPhaseStandings {
          winLossRecord {
            matchesWon
            matchesLost
          }
          ranking
          hasClinchedPlayoffs
        }
      }
      teams {
        id
        name
        competitionGroup
        deletedAt
        isMyTeam
        regularSeasonTeamPhaseStandings {
          winLossRecord {
            matchesWon
            matchesLost
          }
          ranking
          hasClinchedPlayoffs
        }
      }
      otherTeams {
        id
        name
        competitionGroup
        deletedAt
        isMyTeam
        regularSeasonTeamPhaseStandings {
          winLossRecord {
            matchesWon
            matchesLost
          }
          ranking
          hasClinchedPlayoffs
        }
      }
    }
  }
}
    `;

/**
 * __useGetMatchRostersContainerDataQuery__
 *
 * To run a query within a React component, call `useGetMatchRostersContainerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchRostersContainerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchRostersContainerDataQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchRostersContainerDataQuery(baseOptions: Apollo.QueryHookOptions<GetMatchRostersContainerDataQuery, GetMatchRostersContainerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchRostersContainerDataQuery, GetMatchRostersContainerDataQueryVariables>(GetMatchRostersContainerDataDocument, options);
      }
export function useGetMatchRostersContainerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchRostersContainerDataQuery, GetMatchRostersContainerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchRostersContainerDataQuery, GetMatchRostersContainerDataQueryVariables>(GetMatchRostersContainerDataDocument, options);
        }
export type GetMatchRostersContainerDataQueryHookResult = ReturnType<typeof useGetMatchRostersContainerDataQuery>;
export type GetMatchRostersContainerDataLazyQueryHookResult = ReturnType<typeof useGetMatchRostersContainerDataLazyQuery>;
export type GetMatchRostersContainerDataQueryResult = Apollo.QueryResult<GetMatchRostersContainerDataQuery, GetMatchRostersContainerDataQueryVariables>;
export function refetchGetMatchRostersContainerDataQuery(variables: GetMatchRostersContainerDataQueryVariables) {
      return { query: GetMatchRostersContainerDataDocument, variables: variables }
    }
export const RegisterUserWithUsernameDocument = gql`
    mutation registerUserWithUsername($input: RegisterUserWithUsernameInput!, $options: RegisterUserOptions!) {
  registerUserWithUsername(input: $input, options: $options) {
    user {
      id
      email
      username
    }
  }
}
    `;
export type RegisterUserWithUsernameMutationFn = Apollo.MutationFunction<RegisterUserWithUsernameMutation, RegisterUserWithUsernameMutationVariables>;

/**
 * __useRegisterUserWithUsernameMutation__
 *
 * To run a mutation, you first call `useRegisterUserWithUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserWithUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserWithUsernameMutation, { data, loading, error }] = useRegisterUserWithUsernameMutation({
 *   variables: {
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useRegisterUserWithUsernameMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserWithUsernameMutation, RegisterUserWithUsernameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserWithUsernameMutation, RegisterUserWithUsernameMutationVariables>(RegisterUserWithUsernameDocument, options);
      }
export type RegisterUserWithUsernameMutationHookResult = ReturnType<typeof useRegisterUserWithUsernameMutation>;
export type RegisterUserWithUsernameMutationResult = Apollo.MutationResult<RegisterUserWithUsernameMutation>;
export type RegisterUserWithUsernameMutationOptions = Apollo.BaseMutationOptions<RegisterUserWithUsernameMutation, RegisterUserWithUsernameMutationVariables>;
export const GetUserEventSeasonsDocument = gql`
    query getUserEventSeasons($esportId: UUID) {
  listUserSeasons(esportId: $esportId) {
    upcomingSeasons {
      ...UserSeasonResults
    }
    ongoingSeasons {
      ...UserSeasonResults
    }
    enrolledSeasons {
      ...UserSeasonResults
    }
    pastSeasons {
      ...UserSeasonResults
    }
  }
}
    ${UserSeasonResultsFragmentDoc}`;

/**
 * __useGetUserEventSeasonsQuery__
 *
 * To run a query within a React component, call `useGetUserEventSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEventSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEventSeasonsQuery({
 *   variables: {
 *      esportId: // value for 'esportId'
 *   },
 * });
 */
export function useGetUserEventSeasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserEventSeasonsQuery, GetUserEventSeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEventSeasonsQuery, GetUserEventSeasonsQueryVariables>(GetUserEventSeasonsDocument, options);
      }
export function useGetUserEventSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEventSeasonsQuery, GetUserEventSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEventSeasonsQuery, GetUserEventSeasonsQueryVariables>(GetUserEventSeasonsDocument, options);
        }
export type GetUserEventSeasonsQueryHookResult = ReturnType<typeof useGetUserEventSeasonsQuery>;
export type GetUserEventSeasonsLazyQueryHookResult = ReturnType<typeof useGetUserEventSeasonsLazyQuery>;
export type GetUserEventSeasonsQueryResult = Apollo.QueryResult<GetUserEventSeasonsQuery, GetUserEventSeasonsQueryVariables>;
export function refetchGetUserEventSeasonsQuery(variables?: GetUserEventSeasonsQueryVariables) {
      return { query: GetUserEventSeasonsDocument, variables: variables }
    }
export const GetEventSeasonDocument = gql`
    query getEventSeason($seasonId: UUID!, $isSignedIn: Boolean!) {
  season(id: $seasonId) {
    ...EventSeasonWithConfig
    ...EventSeasonTeamWithConfig @include(if: $isSignedIn)
  }
}
    ${EventSeasonWithConfigFragmentDoc}
${EventSeasonTeamWithConfigFragmentDoc}`;

/**
 * __useGetEventSeasonQuery__
 *
 * To run a query within a React component, call `useGetEventSeasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventSeasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventSeasonQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *      isSignedIn: // value for 'isSignedIn'
 *   },
 * });
 */
export function useGetEventSeasonQuery(baseOptions: Apollo.QueryHookOptions<GetEventSeasonQuery, GetEventSeasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventSeasonQuery, GetEventSeasonQueryVariables>(GetEventSeasonDocument, options);
      }
export function useGetEventSeasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventSeasonQuery, GetEventSeasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventSeasonQuery, GetEventSeasonQueryVariables>(GetEventSeasonDocument, options);
        }
export type GetEventSeasonQueryHookResult = ReturnType<typeof useGetEventSeasonQuery>;
export type GetEventSeasonLazyQueryHookResult = ReturnType<typeof useGetEventSeasonLazyQuery>;
export type GetEventSeasonQueryResult = Apollo.QueryResult<GetEventSeasonQuery, GetEventSeasonQueryVariables>;
export function refetchGetEventSeasonQuery(variables: GetEventSeasonQueryVariables) {
      return { query: GetEventSeasonDocument, variables: variables }
    }
export const GetMyEventsDataDocument = gql`
    query getMyEventsData {
  me {
    id
    dateOfBirth
    emails {
      id
      email
      isVerified
    }
  }
}
    `;

/**
 * __useGetMyEventsDataQuery__
 *
 * To run a query within a React component, call `useGetMyEventsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyEventsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyEventsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyEventsDataQuery(baseOptions?: Apollo.QueryHookOptions<GetMyEventsDataQuery, GetMyEventsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyEventsDataQuery, GetMyEventsDataQueryVariables>(GetMyEventsDataDocument, options);
      }
export function useGetMyEventsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyEventsDataQuery, GetMyEventsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyEventsDataQuery, GetMyEventsDataQueryVariables>(GetMyEventsDataDocument, options);
        }
export type GetMyEventsDataQueryHookResult = ReturnType<typeof useGetMyEventsDataQuery>;
export type GetMyEventsDataLazyQueryHookResult = ReturnType<typeof useGetMyEventsDataLazyQuery>;
export type GetMyEventsDataQueryResult = Apollo.QueryResult<GetMyEventsDataQuery, GetMyEventsDataQueryVariables>;
export function refetchGetMyEventsDataQuery(variables?: GetMyEventsDataQueryVariables) {
      return { query: GetMyEventsDataDocument, variables: variables }
    }
export const GetTeamAvatarDocument = gql`
    query getTeamAvatar($id: UUID!) {
  team(id: $id) {
    id
    name
    avatarUrl
  }
}
    `;

/**
 * __useGetTeamAvatarQuery__
 *
 * To run a query within a React component, call `useGetTeamAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamAvatarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamAvatarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamAvatarQuery(baseOptions: Apollo.QueryHookOptions<GetTeamAvatarQuery, GetTeamAvatarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamAvatarQuery, GetTeamAvatarQueryVariables>(GetTeamAvatarDocument, options);
      }
export function useGetTeamAvatarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamAvatarQuery, GetTeamAvatarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamAvatarQuery, GetTeamAvatarQueryVariables>(GetTeamAvatarDocument, options);
        }
export type GetTeamAvatarQueryHookResult = ReturnType<typeof useGetTeamAvatarQuery>;
export type GetTeamAvatarLazyQueryHookResult = ReturnType<typeof useGetTeamAvatarLazyQuery>;
export type GetTeamAvatarQueryResult = Apollo.QueryResult<GetTeamAvatarQuery, GetTeamAvatarQueryVariables>;
export function refetchGetTeamAvatarQuery(variables: GetTeamAvatarQueryVariables) {
      return { query: GetTeamAvatarDocument, variables: variables }
    }
export const CreateTeamForEventDocument = gql`
    mutation createTeamForEvent($input: CreateTeamForEventInput!) {
  createTeamForEvent(input: $input) {
    team {
      id
      name
      eventSeasonId
      createdByUser {
        id
        roles {
          userId
          roleName
          resourceId
          resourceType
          status
        }
      }
    }
  }
}
    `;
export type CreateTeamForEventMutationFn = Apollo.MutationFunction<CreateTeamForEventMutation, CreateTeamForEventMutationVariables>;

/**
 * __useCreateTeamForEventMutation__
 *
 * To run a mutation, you first call `useCreateTeamForEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamForEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamForEventMutation, { data, loading, error }] = useCreateTeamForEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamForEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamForEventMutation, CreateTeamForEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamForEventMutation, CreateTeamForEventMutationVariables>(CreateTeamForEventDocument, options);
      }
export type CreateTeamForEventMutationHookResult = ReturnType<typeof useCreateTeamForEventMutation>;
export type CreateTeamForEventMutationResult = Apollo.MutationResult<CreateTeamForEventMutation>;
export type CreateTeamForEventMutationOptions = Apollo.BaseMutationOptions<CreateTeamForEventMutation, CreateTeamForEventMutationVariables>;
export const UploadTeamAvatarDocument = gql`
    mutation uploadTeamAvatar($input: UploadTeamAvatarInput!) {
  uploadTeamAvatar(input: $input) {
    team {
      id
      avatarUrl
    }
  }
}
    `;
export type UploadTeamAvatarMutationFn = Apollo.MutationFunction<UploadTeamAvatarMutation, UploadTeamAvatarMutationVariables>;

/**
 * __useUploadTeamAvatarMutation__
 *
 * To run a mutation, you first call `useUploadTeamAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadTeamAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadTeamAvatarMutation, { data, loading, error }] = useUploadTeamAvatarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadTeamAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UploadTeamAvatarMutation, UploadTeamAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadTeamAvatarMutation, UploadTeamAvatarMutationVariables>(UploadTeamAvatarDocument, options);
      }
export type UploadTeamAvatarMutationHookResult = ReturnType<typeof useUploadTeamAvatarMutation>;
export type UploadTeamAvatarMutationResult = Apollo.MutationResult<UploadTeamAvatarMutation>;
export type UploadTeamAvatarMutationOptions = Apollo.BaseMutationOptions<UploadTeamAvatarMutation, UploadTeamAvatarMutationVariables>;
export const DeleteStadiumTeamDocument = gql`
    mutation deleteStadiumTeam($teamId: UUID!) {
  deleteStadiumTeam(teamId: $teamId) {
    success
    deletedTeamId
  }
}
    `;
export type DeleteStadiumTeamMutationFn = Apollo.MutationFunction<DeleteStadiumTeamMutation, DeleteStadiumTeamMutationVariables>;

/**
 * __useDeleteStadiumTeamMutation__
 *
 * To run a mutation, you first call `useDeleteStadiumTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStadiumTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStadiumTeamMutation, { data, loading, error }] = useDeleteStadiumTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteStadiumTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStadiumTeamMutation, DeleteStadiumTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStadiumTeamMutation, DeleteStadiumTeamMutationVariables>(DeleteStadiumTeamDocument, options);
      }
export type DeleteStadiumTeamMutationHookResult = ReturnType<typeof useDeleteStadiumTeamMutation>;
export type DeleteStadiumTeamMutationResult = Apollo.MutationResult<DeleteStadiumTeamMutation>;
export type DeleteStadiumTeamMutationOptions = Apollo.BaseMutationOptions<DeleteStadiumTeamMutation, DeleteStadiumTeamMutationVariables>;
export const SchoolEnrollableSeasonsDocument = gql`
    query schoolEnrollableSeasons($schoolId: UUID!, $metaseasonId: UUID) {
  schoolEnrollableSeasons(schoolId: $schoolId, metaseasonId: $metaseasonId) {
    seasons {
      id
      leagueId
      teamRegistrationEndsAt
      suggestedRegistrationEndsAt
      rostersLockAt
      league {
        id
        displayName
        name
        esport {
          id
          name
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useSchoolEnrollableSeasonsQuery__
 *
 * To run a query within a React component, call `useSchoolEnrollableSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolEnrollableSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolEnrollableSeasonsQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useSchoolEnrollableSeasonsQuery(baseOptions: Apollo.QueryHookOptions<SchoolEnrollableSeasonsQuery, SchoolEnrollableSeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolEnrollableSeasonsQuery, SchoolEnrollableSeasonsQueryVariables>(SchoolEnrollableSeasonsDocument, options);
      }
export function useSchoolEnrollableSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolEnrollableSeasonsQuery, SchoolEnrollableSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolEnrollableSeasonsQuery, SchoolEnrollableSeasonsQueryVariables>(SchoolEnrollableSeasonsDocument, options);
        }
export type SchoolEnrollableSeasonsQueryHookResult = ReturnType<typeof useSchoolEnrollableSeasonsQuery>;
export type SchoolEnrollableSeasonsLazyQueryHookResult = ReturnType<typeof useSchoolEnrollableSeasonsLazyQuery>;
export type SchoolEnrollableSeasonsQueryResult = Apollo.QueryResult<SchoolEnrollableSeasonsQuery, SchoolEnrollableSeasonsQueryVariables>;
export function refetchSchoolEnrollableSeasonsQuery(variables: SchoolEnrollableSeasonsQueryVariables) {
      return { query: SchoolEnrollableSeasonsDocument, variables: variables }
    }
export const GetPhaseResultsDocument = gql`
    query getPhaseResults($phaseId: UUID!) {
  phase(id: $phaseId) {
    id
    name
    type
    startsAt
    phaseResults {
      id
      phaseTiebreakerPoints
      gamesWon
      gamesLost
      matchesWon
      matchesLost
      seriesWon
      seriesLost
      cumulativeScore
      cumulativeScoreOfOpposition
      hasClinchedPlayoffs
      avgPlacement
      numOfFirstPlace
      numOfTopFourPlace
      team {
        id
        name
        esport {
          id
          slug
          rating
        }
        school {
          id
          name
          logoUrl
          slug
        }
      }
      record {
        won
        lost
        streak
        winPercentage
        compoundRankingScore
      }
      rankingPoints
    }
  }
}
    `;

/**
 * __useGetPhaseResultsQuery__
 *
 * To run a query within a React component, call `useGetPhaseResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhaseResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhaseResultsQuery({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useGetPhaseResultsQuery(baseOptions: Apollo.QueryHookOptions<GetPhaseResultsQuery, GetPhaseResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhaseResultsQuery, GetPhaseResultsQueryVariables>(GetPhaseResultsDocument, options);
      }
export function useGetPhaseResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhaseResultsQuery, GetPhaseResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhaseResultsQuery, GetPhaseResultsQueryVariables>(GetPhaseResultsDocument, options);
        }
export type GetPhaseResultsQueryHookResult = ReturnType<typeof useGetPhaseResultsQuery>;
export type GetPhaseResultsLazyQueryHookResult = ReturnType<typeof useGetPhaseResultsLazyQuery>;
export type GetPhaseResultsQueryResult = Apollo.QueryResult<GetPhaseResultsQuery, GetPhaseResultsQueryVariables>;
export function refetchGetPhaseResultsQuery(variables: GetPhaseResultsQueryVariables) {
      return { query: GetPhaseResultsDocument, variables: variables }
    }
export const GetSeasonStandingsColumnsDocument = gql`
    query getSeasonStandingsColumns($seasonId: UUID!) {
  season(id: $seasonId) {
    id
    playvsScoreEnabled
  }
}
    `;

/**
 * __useGetSeasonStandingsColumnsQuery__
 *
 * To run a query within a React component, call `useGetSeasonStandingsColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonStandingsColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonStandingsColumnsQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useGetSeasonStandingsColumnsQuery(baseOptions: Apollo.QueryHookOptions<GetSeasonStandingsColumnsQuery, GetSeasonStandingsColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeasonStandingsColumnsQuery, GetSeasonStandingsColumnsQueryVariables>(GetSeasonStandingsColumnsDocument, options);
      }
export function useGetSeasonStandingsColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeasonStandingsColumnsQuery, GetSeasonStandingsColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeasonStandingsColumnsQuery, GetSeasonStandingsColumnsQueryVariables>(GetSeasonStandingsColumnsDocument, options);
        }
export type GetSeasonStandingsColumnsQueryHookResult = ReturnType<typeof useGetSeasonStandingsColumnsQuery>;
export type GetSeasonStandingsColumnsLazyQueryHookResult = ReturnType<typeof useGetSeasonStandingsColumnsLazyQuery>;
export type GetSeasonStandingsColumnsQueryResult = Apollo.QueryResult<GetSeasonStandingsColumnsQuery, GetSeasonStandingsColumnsQueryVariables>;
export function refetchGetSeasonStandingsColumnsQuery(variables: GetSeasonStandingsColumnsQueryVariables) {
      return { query: GetSeasonStandingsColumnsDocument, variables: variables }
    }
export const FnTeamMatchStandingsDocument = gql`
    query fnTeamMatchStandings($limit: Int!, $offset: Int!, $phaseId: UUID!, $schoolId: UUID) {
  phase(id: $phaseId) {
    id
    season {
      id
      metaseasonId
    }
    slots {
      id
      order
      name
      matches {
        id
        status
        fortniteTeamMatchStats(limit: $limit, offset: $offset, schoolId: $schoolId) {
          leaderboard {
            team {
              id
              name
              roster {
                id
                players {
                  user {
                    id
                    name
                    avatarUrl
                    userProviderAccounts {
                      id
                      userId
                      providerName
                      providerAccountId
                      providerDisplayName
                      providerIntegrationType
                    }
                  }
                  effectiveAt
                  isCaptain
                }
              }
              school {
                id
                name
                logoUrl
                slug
                state
              }
            }
            stats {
              ... on FortniteTeamMatchStats {
                id
                rank
                clutched
                totalPoints
                placementPoints
                eliminationPoints
                totalSecondsSurvived
                avgPointsPerSession
                avgPlacementPerSession
                avgEliminationsPerSession
                sessionsPlayed
              }
            }
          }
          schoolTeams {
            team {
              id
              name
              roster {
                id
                players {
                  user {
                    id
                    name
                    avatarUrl
                    userProviderAccounts {
                      id
                      userId
                      providerName
                      providerAccountId
                      providerDisplayName
                      providerIntegrationType
                    }
                  }
                  effectiveAt
                  isCaptain
                }
              }
              school {
                id
                name
                logoUrl
                state
                slug
              }
            }
            stats {
              ... on FortniteTeamMatchStats {
                id
                rank
                clutched
                totalPoints
                placementPoints
                eliminationPoints
                totalSecondsSurvived
                avgPointsPerSession
                avgPlacementPerSession
                avgEliminationsPerSession
                sessionsPlayed
              }
            }
          }
          myTeams {
            team {
              id
              name
              roster {
                id
                players {
                  user {
                    id
                    name
                    avatarUrl
                    userProviderAccounts {
                      id
                      userId
                      providerName
                      providerAccountId
                      providerDisplayName
                      providerIntegrationType
                    }
                  }
                  effectiveAt
                  isCaptain
                }
              }
              school {
                id
                name
                logoUrl
                state
                slug
              }
            }
            stats {
              ... on FortniteTeamMatchStats {
                id
                rank
                clutched
                totalPoints
                placementPoints
                eliminationPoints
                totalSecondsSurvived
                avgPointsPerSession
                avgPlacementPerSession
                avgEliminationsPerSession
                sessionsPlayed
              }
            }
          }
          updatedAt
          total
        }
      }
    }
  }
}
    `;

/**
 * __useFnTeamMatchStandingsQuery__
 *
 * To run a query within a React component, call `useFnTeamMatchStandingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFnTeamMatchStandingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFnTeamMatchStandingsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      phaseId: // value for 'phaseId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useFnTeamMatchStandingsQuery(baseOptions: Apollo.QueryHookOptions<FnTeamMatchStandingsQuery, FnTeamMatchStandingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FnTeamMatchStandingsQuery, FnTeamMatchStandingsQueryVariables>(FnTeamMatchStandingsDocument, options);
      }
export function useFnTeamMatchStandingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FnTeamMatchStandingsQuery, FnTeamMatchStandingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FnTeamMatchStandingsQuery, FnTeamMatchStandingsQueryVariables>(FnTeamMatchStandingsDocument, options);
        }
export type FnTeamMatchStandingsQueryHookResult = ReturnType<typeof useFnTeamMatchStandingsQuery>;
export type FnTeamMatchStandingsLazyQueryHookResult = ReturnType<typeof useFnTeamMatchStandingsLazyQuery>;
export type FnTeamMatchStandingsQueryResult = Apollo.QueryResult<FnTeamMatchStandingsQuery, FnTeamMatchStandingsQueryVariables>;
export function refetchFnTeamMatchStandingsQuery(variables: FnTeamMatchStandingsQueryVariables) {
      return { query: FnTeamMatchStandingsDocument, variables: variables }
    }
export const FnTeamPhaseStandingsDocument = gql`
    query fnTeamPhaseStandings($limit: Int!, $offset: Int!, $phaseId: UUID!, $schoolId: UUID) {
  phase(id: $phaseId) {
    id
    format
    survivalAdvancementPercentage
    survivalAdvancementCount
    season {
      id
      metaseasonId
      league {
        id
        competitionGroup
      }
    }
    slots {
      id
      order
      name
      matches {
        id
        status
      }
    }
    fortniteTeamPhaseStats(limit: $limit, offset: $offset, schoolId: $schoolId) {
      leaderboard {
        team {
          id
          name
          roster {
            id
            players {
              user {
                id
                name
                avatarUrl
                userProviderAccounts {
                  id
                  userId
                  providerName
                  providerAccountId
                  providerDisplayName
                  providerIntegrationType
                }
              }
              effectiveAt
              isCaptain
            }
          }
          school {
            id
            name
            logoUrl
            state
            slug
          }
        }
        stats {
          ... on FortniteTeamPhaseStats {
            id
            rank
            clutched
            totalPoints
            placementPoints
            eliminationPoints
            totalSecondsSurvived
            avgPointsPerSession
            avgPlacementPerSession
            avgEliminationsPerSession
            sessionsPlayed
          }
        }
      }
      schoolTeams {
        team {
          id
          name
          roster {
            id
            players {
              user {
                id
                name
                avatarUrl
                userProviderAccounts {
                  id
                  userId
                  providerName
                  providerAccountId
                  providerDisplayName
                  providerIntegrationType
                }
              }
              effectiveAt
              isCaptain
            }
          }
          school {
            id
            name
            logoUrl
            state
            slug
          }
        }
        stats {
          ... on FortniteTeamPhaseStats {
            id
            rank
            clutched
            totalPoints
            placementPoints
            eliminationPoints
            totalSecondsSurvived
            avgPointsPerSession
            avgPlacementPerSession
            avgEliminationsPerSession
            sessionsPlayed
          }
        }
      }
      myTeams {
        team {
          id
          name
          roster {
            id
            players {
              user {
                id
                name
                avatarUrl
                userProviderAccounts {
                  id
                  userId
                  providerName
                  providerAccountId
                  providerDisplayName
                  providerIntegrationType
                }
              }
              effectiveAt
              isCaptain
            }
          }
          school {
            id
            name
            logoUrl
            slug
            state
          }
        }
        stats {
          ... on FortniteTeamPhaseStats {
            id
            rank
            clutched
            totalPoints
            placementPoints
            eliminationPoints
            totalSecondsSurvived
            avgPointsPerSession
            avgPlacementPerSession
            avgEliminationsPerSession
            sessionsPlayed
          }
        }
      }
      updatedAt
      total
    }
  }
}
    `;

/**
 * __useFnTeamPhaseStandingsQuery__
 *
 * To run a query within a React component, call `useFnTeamPhaseStandingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFnTeamPhaseStandingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFnTeamPhaseStandingsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      phaseId: // value for 'phaseId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useFnTeamPhaseStandingsQuery(baseOptions: Apollo.QueryHookOptions<FnTeamPhaseStandingsQuery, FnTeamPhaseStandingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FnTeamPhaseStandingsQuery, FnTeamPhaseStandingsQueryVariables>(FnTeamPhaseStandingsDocument, options);
      }
export function useFnTeamPhaseStandingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FnTeamPhaseStandingsQuery, FnTeamPhaseStandingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FnTeamPhaseStandingsQuery, FnTeamPhaseStandingsQueryVariables>(FnTeamPhaseStandingsDocument, options);
        }
export type FnTeamPhaseStandingsQueryHookResult = ReturnType<typeof useFnTeamPhaseStandingsQuery>;
export type FnTeamPhaseStandingsLazyQueryHookResult = ReturnType<typeof useFnTeamPhaseStandingsLazyQuery>;
export type FnTeamPhaseStandingsQueryResult = Apollo.QueryResult<FnTeamPhaseStandingsQuery, FnTeamPhaseStandingsQueryVariables>;
export function refetchFnTeamPhaseStandingsQuery(variables: FnTeamPhaseStandingsQueryVariables) {
      return { query: FnTeamPhaseStandingsDocument, variables: variables }
    }
export const BracketResultsDocument = gql`
    query bracketResults($phaseId: UUID!) {
  phase(id: $phaseId) {
    id
    type
    format
    esport {
      id
      rating
    }
    slots {
      id
      startsAt
      matches {
        id
        status
        matchResults {
          id
          matchId
          placing
          teamId
        }
      }
    }
    teams {
      id
      name
      seed
      school {
        id
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useBracketResultsQuery__
 *
 * To run a query within a React component, call `useBracketResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBracketResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBracketResultsQuery({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useBracketResultsQuery(baseOptions: Apollo.QueryHookOptions<BracketResultsQuery, BracketResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BracketResultsQuery, BracketResultsQueryVariables>(BracketResultsDocument, options);
      }
export function useBracketResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BracketResultsQuery, BracketResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BracketResultsQuery, BracketResultsQueryVariables>(BracketResultsDocument, options);
        }
export type BracketResultsQueryHookResult = ReturnType<typeof useBracketResultsQuery>;
export type BracketResultsLazyQueryHookResult = ReturnType<typeof useBracketResultsLazyQuery>;
export type BracketResultsQueryResult = Apollo.QueryResult<BracketResultsQuery, BracketResultsQueryVariables>;
export function refetchBracketResultsQuery(variables: BracketResultsQueryVariables) {
      return { query: BracketResultsDocument, variables: variables }
    }
export const DoubleEliminationResultsDocument = gql`
    query doubleEliminationResults($phaseId: UUID!) {
  phase(id: $phaseId) {
    id
    esport {
      id
      rating
    }
    slots {
      id
      startsAt
      label
      ordinal
      matchSlots {
        id
        slotId
        ordinal
        match {
          id
          status
          matchResults {
            id
            placing
            teamId
          }
        }
        teamSlots {
          id
          matchSlotId
          type
          sourceSeed
          sourceMatchSlotId
          sourceTeamPlacing
          team {
            id
            name
            seed
            school {
              id
              logoUrl
            }
            result {
              matchId
              placing
            }
          }
          isUnfilledForBye
        }
      }
    }
  }
}
    `;

/**
 * __useDoubleEliminationResultsQuery__
 *
 * To run a query within a React component, call `useDoubleEliminationResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoubleEliminationResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoubleEliminationResultsQuery({
 *   variables: {
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useDoubleEliminationResultsQuery(baseOptions: Apollo.QueryHookOptions<DoubleEliminationResultsQuery, DoubleEliminationResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoubleEliminationResultsQuery, DoubleEliminationResultsQueryVariables>(DoubleEliminationResultsDocument, options);
      }
export function useDoubleEliminationResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoubleEliminationResultsQuery, DoubleEliminationResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoubleEliminationResultsQuery, DoubleEliminationResultsQueryVariables>(DoubleEliminationResultsDocument, options);
        }
export type DoubleEliminationResultsQueryHookResult = ReturnType<typeof useDoubleEliminationResultsQuery>;
export type DoubleEliminationResultsLazyQueryHookResult = ReturnType<typeof useDoubleEliminationResultsLazyQuery>;
export type DoubleEliminationResultsQueryResult = Apollo.QueryResult<DoubleEliminationResultsQuery, DoubleEliminationResultsQueryVariables>;
export function refetchDoubleEliminationResultsQuery(variables: DoubleEliminationResultsQueryVariables) {
      return { query: DoubleEliminationResultsDocument, variables: variables }
    }
export const GetLeagueMetadataBySchoolIdDocument = gql`
    query getLeagueMetadataBySchoolId($input: GetLeagueMetadataBySchoolIdInput!) {
  getLeagueMetadataBySchoolId(input: $input) {
    success
    error
    payload {
      id
      displayName
      name
      competitionModel
      enrollmentStatus
      esport {
        id
        name
        slug
      }
      seasons {
        id
        name
        startsAt
        metaseason {
          id
          name
          startsAt
          endsAt
          promotionStartsAt
          promotionEndsAt
          hasMatches
        }
        phases {
          id
          name
          startsAt
          endsAt
          format
          hasMatches
          status
        }
      }
    }
  }
}
    `;

/**
 * __useGetLeagueMetadataBySchoolIdQuery__
 *
 * To run a query within a React component, call `useGetLeagueMetadataBySchoolIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueMetadataBySchoolIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueMetadataBySchoolIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLeagueMetadataBySchoolIdQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueMetadataBySchoolIdQuery, GetLeagueMetadataBySchoolIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueMetadataBySchoolIdQuery, GetLeagueMetadataBySchoolIdQueryVariables>(GetLeagueMetadataBySchoolIdDocument, options);
      }
export function useGetLeagueMetadataBySchoolIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueMetadataBySchoolIdQuery, GetLeagueMetadataBySchoolIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueMetadataBySchoolIdQuery, GetLeagueMetadataBySchoolIdQueryVariables>(GetLeagueMetadataBySchoolIdDocument, options);
        }
export type GetLeagueMetadataBySchoolIdQueryHookResult = ReturnType<typeof useGetLeagueMetadataBySchoolIdQuery>;
export type GetLeagueMetadataBySchoolIdLazyQueryHookResult = ReturnType<typeof useGetLeagueMetadataBySchoolIdLazyQuery>;
export type GetLeagueMetadataBySchoolIdQueryResult = Apollo.QueryResult<GetLeagueMetadataBySchoolIdQuery, GetLeagueMetadataBySchoolIdQueryVariables>;
export function refetchGetLeagueMetadataBySchoolIdQuery(variables: GetLeagueMetadataBySchoolIdQueryVariables) {
      return { query: GetLeagueMetadataBySchoolIdDocument, variables: variables }
    }
export const GetLeagueMetadataByTeamIdsDocument = gql`
    query getLeagueMetadataByTeamIds($input: GetLeagueMetadataByTeamIdsInput!) {
  getLeagueMetadataByTeamIds(input: $input) {
    success
    error
    payload {
      id
      displayName
      name
      competitionModel
      enrollmentStatus
      esport {
        id
        name
        slug
      }
      seasons {
        id
        name
        startsAt
        metaseason {
          id
          name
          startsAt
          endsAt
          promotionStartsAt
          promotionEndsAt
          hasMatches
        }
        phases {
          id
          name
          startsAt
          endsAt
          status
          format
          hasMatches
        }
      }
    }
  }
}
    `;

/**
 * __useGetLeagueMetadataByTeamIdsQuery__
 *
 * To run a query within a React component, call `useGetLeagueMetadataByTeamIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueMetadataByTeamIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueMetadataByTeamIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLeagueMetadataByTeamIdsQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueMetadataByTeamIdsQuery, GetLeagueMetadataByTeamIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueMetadataByTeamIdsQuery, GetLeagueMetadataByTeamIdsQueryVariables>(GetLeagueMetadataByTeamIdsDocument, options);
      }
export function useGetLeagueMetadataByTeamIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueMetadataByTeamIdsQuery, GetLeagueMetadataByTeamIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueMetadataByTeamIdsQuery, GetLeagueMetadataByTeamIdsQueryVariables>(GetLeagueMetadataByTeamIdsDocument, options);
        }
export type GetLeagueMetadataByTeamIdsQueryHookResult = ReturnType<typeof useGetLeagueMetadataByTeamIdsQuery>;
export type GetLeagueMetadataByTeamIdsLazyQueryHookResult = ReturnType<typeof useGetLeagueMetadataByTeamIdsLazyQuery>;
export type GetLeagueMetadataByTeamIdsQueryResult = Apollo.QueryResult<GetLeagueMetadataByTeamIdsQuery, GetLeagueMetadataByTeamIdsQueryVariables>;
export function refetchGetLeagueMetadataByTeamIdsQuery(variables: GetLeagueMetadataByTeamIdsQueryVariables) {
      return { query: GetLeagueMetadataByTeamIdsDocument, variables: variables }
    }
export const GameStatsDocument = gql`
    query gameStats($gameId: UUID!) {
  game(id: $gameId) {
    id
    status
    playerGameStats {
      id
      player {
        id
        avatarUrl
        name
        userProviderAccounts {
          id
          userId
          providerName
          providerAccountId
          providerDisplayName
          providerIntegrationType
        }
      }
      teamId
      leagueOfLegendsStats {
        id
        champion {
          id
          name
          image {
            src
          }
          loadScreenImage {
            src
          }
        }
      }
    }
    teamGameStats {
      id
      teamId
      leagueOfLegendsStats {
        id
        detail {
          bans {
            championId
            champion {
              id
              name
              image {
                src
              }
            }
          }
        }
      }
      stats {
        ... on LeagueOfLegendsTeamGameStats {
          id
          creepScore
          averageGoldPerMinute
          eliminationRespawnRatio
          towersDestroyed
          inhibitorsDestroyed
          dragonEliminations
          baronEliminations
          eliminations
          respawns
          assists
        }
        ... on RocketLeagueTeamGameStats {
          id
          score
          goals
          saves
          assists
          shots
        }
        ... on SmiteTeamGameStats {
          id
          eliminations
          respawns
          assists
          averageGoldPerMinute
          eliminationRespawnRatio
        }
      }
    }
  }
}
    `;

/**
 * __useGameStatsQuery__
 *
 * To run a query within a React component, call `useGameStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameStatsQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useGameStatsQuery(baseOptions: Apollo.QueryHookOptions<GameStatsQuery, GameStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameStatsQuery, GameStatsQueryVariables>(GameStatsDocument, options);
      }
export function useGameStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameStatsQuery, GameStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameStatsQuery, GameStatsQueryVariables>(GameStatsDocument, options);
        }
export type GameStatsQueryHookResult = ReturnType<typeof useGameStatsQuery>;
export type GameStatsLazyQueryHookResult = ReturnType<typeof useGameStatsLazyQuery>;
export type GameStatsQueryResult = Apollo.QueryResult<GameStatsQuery, GameStatsQueryVariables>;
export function refetchGameStatsQuery(variables: GameStatsQueryVariables) {
      return { query: GameStatsDocument, variables: variables }
    }
export const MatchStatsDocument = gql`
    query matchStats($matchId: UUID!) {
  match(id: $matchId) {
    id
    status
    scheduledStartsAt
    bestOf
    teamMatchStats {
      id
      teamId
      stats {
        ... on LeagueOfLegendsTeamMatchStats {
          averageCreepScore
          averageGoldEarned
          averageGoldPerMinute
          eliminationRespawnRatio
          towersDestroyed
          inhibitorsDestroyed
          dragonEliminations
          baronEliminations
          eliminations
          respawns
          assists
        }
        ... on RocketLeagueTeamMatchStats {
          id
          score
          goals
          saves
          assists
          shots
        }
        ... on SmiteTeamMatchStats {
          id
          eliminations
          respawns
          assists
          averageGoldPerMinute
          eliminationRespawnRatio
        }
      }
    }
  }
}
    `;

/**
 * __useMatchStatsQuery__
 *
 * To run a query within a React component, call `useMatchStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchStatsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useMatchStatsQuery(baseOptions: Apollo.QueryHookOptions<MatchStatsQuery, MatchStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchStatsQuery, MatchStatsQueryVariables>(MatchStatsDocument, options);
      }
export function useMatchStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchStatsQuery, MatchStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchStatsQuery, MatchStatsQueryVariables>(MatchStatsDocument, options);
        }
export type MatchStatsQueryHookResult = ReturnType<typeof useMatchStatsQuery>;
export type MatchStatsLazyQueryHookResult = ReturnType<typeof useMatchStatsLazyQuery>;
export type MatchStatsQueryResult = Apollo.QueryResult<MatchStatsQuery, MatchStatsQueryVariables>;
export function refetchMatchStatsQuery(variables: MatchStatsQueryVariables) {
      return { query: MatchStatsDocument, variables: variables }
    }
export const GetMatchGamesForStatsDocument = gql`
    query getMatchGamesForStats($matchId: UUID!) {
  match(id: $matchId) {
    id
    games {
      id
      status
      seriesId
      gameResults {
        id
        teamId
        sidePlayed
        placing
        score
      }
    }
  }
}
    `;

/**
 * __useGetMatchGamesForStatsQuery__
 *
 * To run a query within a React component, call `useGetMatchGamesForStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchGamesForStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchGamesForStatsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchGamesForStatsQuery(baseOptions: Apollo.QueryHookOptions<GetMatchGamesForStatsQuery, GetMatchGamesForStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchGamesForStatsQuery, GetMatchGamesForStatsQueryVariables>(GetMatchGamesForStatsDocument, options);
      }
export function useGetMatchGamesForStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchGamesForStatsQuery, GetMatchGamesForStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchGamesForStatsQuery, GetMatchGamesForStatsQueryVariables>(GetMatchGamesForStatsDocument, options);
        }
export type GetMatchGamesForStatsQueryHookResult = ReturnType<typeof useGetMatchGamesForStatsQuery>;
export type GetMatchGamesForStatsLazyQueryHookResult = ReturnType<typeof useGetMatchGamesForStatsLazyQuery>;
export type GetMatchGamesForStatsQueryResult = Apollo.QueryResult<GetMatchGamesForStatsQuery, GetMatchGamesForStatsQueryVariables>;
export function refetchGetMatchGamesForStatsQuery(variables: GetMatchGamesForStatsQueryVariables) {
      return { query: GetMatchGamesForStatsDocument, variables: variables }
    }
export const GetMatchAndGameStatsDocument = gql`
    query getMatchAndGameStats($matchId: UUID!) {
  match(id: $matchId) {
    id
    status
    scheduledStartsAt
    bestOf
    teamMatchStats {
      id
      teamId
      stats {
        ... on LeagueOfLegendsTeamMatchStats {
          averageCreepScore
          averageGoldEarned
          averageGoldPerMinute
          eliminationRespawnRatio
          towersDestroyed
          inhibitorsDestroyed
          dragonEliminations
          baronEliminations
          eliminations
          respawns
          assists
        }
        ... on RocketLeagueTeamMatchStats {
          id
          score
          goals
          saves
          assists
          shots
        }
        ... on SmiteTeamMatchStats {
          id
          eliminations
          respawns
          assists
          averageGoldPerMinute
          eliminationRespawnRatio
        }
      }
    }
    games {
      id
      status
      playerGameStats {
        id
        player {
          id
          avatarUrl
          name
          userProviderAccounts {
            id
            userId
            providerName
            providerAccountId
            providerDisplayName
            providerIntegrationType
          }
        }
        teamId
        rocketLeagueStats {
          id
          score
          shots
          goals
          saves
          assists
        }
        leagueOfLegendsStats {
          id
          champion {
            id
            name
            image {
              src
            }
            loadScreenImage {
              src
            }
          }
        }
      }
      teamGameStats {
        id
        teamId
        leagueOfLegendsStats {
          id
          detail {
            bans {
              championId
              champion {
                id
                name
                image {
                  src
                }
              }
            }
          }
        }
        stats {
          ... on LeagueOfLegendsTeamGameStats {
            id
            creepScore
            averageGoldPerMinute
            eliminationRespawnRatio
            towersDestroyed
            inhibitorsDestroyed
            dragonEliminations
            baronEliminations
            eliminations
            respawns
            assists
          }
          ... on RocketLeagueTeamGameStats {
            id
            score
            goals
            saves
            assists
            shots
          }
          ... on SmiteTeamGameStats {
            id
            eliminations
            respawns
            assists
            averageGoldPerMinute
            eliminationRespawnRatio
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMatchAndGameStatsQuery__
 *
 * To run a query within a React component, call `useGetMatchAndGameStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchAndGameStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchAndGameStatsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetMatchAndGameStatsQuery(baseOptions: Apollo.QueryHookOptions<GetMatchAndGameStatsQuery, GetMatchAndGameStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchAndGameStatsQuery, GetMatchAndGameStatsQueryVariables>(GetMatchAndGameStatsDocument, options);
      }
export function useGetMatchAndGameStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchAndGameStatsQuery, GetMatchAndGameStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchAndGameStatsQuery, GetMatchAndGameStatsQueryVariables>(GetMatchAndGameStatsDocument, options);
        }
export type GetMatchAndGameStatsQueryHookResult = ReturnType<typeof useGetMatchAndGameStatsQuery>;
export type GetMatchAndGameStatsLazyQueryHookResult = ReturnType<typeof useGetMatchAndGameStatsLazyQuery>;
export type GetMatchAndGameStatsQueryResult = Apollo.QueryResult<GetMatchAndGameStatsQuery, GetMatchAndGameStatsQueryVariables>;
export function refetchGetMatchAndGameStatsQuery(variables: GetMatchAndGameStatsQueryVariables) {
      return { query: GetMatchAndGameStatsDocument, variables: variables }
    }
export const GetPlayerGameStatsDocument = gql`
    query getPlayerGameStats($gameId: UUID!) {
  game(id: $gameId) {
    id
    playerGameStats {
      id
      team {
        id
        name
        school {
          id
          logoUrl
        }
      }
      player {
        id
        avatarUrl
        name
        userProviderAccounts {
          id
          userId
          providerName
          providerAccountId
          providerDisplayName
          providerIntegrationType
        }
      }
      teamId
      stats {
        ... on LeagueOfLegendsPlayerGameStats {
          id
          player {
            name
            summonerName
          }
          champion {
            id
            name
            image {
              src
            }
          }
          eliminations
          respawns
          assists
          goldPerMinute
          creepScore
          wardsPlaced
          championDamageDealt
          detail {
            items {
              id
              image {
                src
              }
            }
          }
        }
        ... on RocketLeaguePlayerGameStats {
          id
          shootingPercentage
          goals
          saves
          assists
          shots
          score
        }
        ... on SmitePlayerGameStats {
          id
          eliminations
          respawns
          assists
          eliminationParticipation
          goldEarned
          towersDestroyed
        }
      }
    }
  }
}
    `;

/**
 * __useGetPlayerGameStatsQuery__
 *
 * To run a query within a React component, call `useGetPlayerGameStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerGameStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerGameStatsQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useGetPlayerGameStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerGameStatsQuery, GetPlayerGameStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerGameStatsQuery, GetPlayerGameStatsQueryVariables>(GetPlayerGameStatsDocument, options);
      }
export function useGetPlayerGameStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerGameStatsQuery, GetPlayerGameStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerGameStatsQuery, GetPlayerGameStatsQueryVariables>(GetPlayerGameStatsDocument, options);
        }
export type GetPlayerGameStatsQueryHookResult = ReturnType<typeof useGetPlayerGameStatsQuery>;
export type GetPlayerGameStatsLazyQueryHookResult = ReturnType<typeof useGetPlayerGameStatsLazyQuery>;
export type GetPlayerGameStatsQueryResult = Apollo.QueryResult<GetPlayerGameStatsQuery, GetPlayerGameStatsQueryVariables>;
export function refetchGetPlayerGameStatsQuery(variables: GetPlayerGameStatsQueryVariables) {
      return { query: GetPlayerGameStatsDocument, variables: variables }
    }
export const GetPlayerMatchStatsDocument = gql`
    query getPlayerMatchStats($matchId: UUID!) {
  match(id: $matchId) {
    id
    playerMatchStats {
      id
      player {
        id
        avatarUrl
        name
        userProviderAccounts {
          id
          userId
          providerName
          providerAccountId
          providerDisplayName
          providerIntegrationType
        }
      }
      teamId
      stats {
        ... on LeagueOfLegendsPlayerMatchStats {
          id
          champions {
            id
            name
            image {
              src
            }
          }
          eliminations
          respawns
          assists
          averageGoldPerMinute
          creepScore
          wardsPlaced
          championDamageDealt
        }
        ... on RocketLeaguePlayerMatchStats {
          id
          shootingPercentage
          goals
          saves
          assists
          shots
          score
        }
        ... on SmitePlayerMatchStats {
          id
          eliminations
          respawns
          assists
          eliminationParticipation
          averageGoldPerMinute
          towersDestroyed
        }
      }
    }
  }
}
    `;

/**
 * __useGetPlayerMatchStatsQuery__
 *
 * To run a query within a React component, call `useGetPlayerMatchStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerMatchStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerMatchStatsQuery({
 *   variables: {
 *      matchId: // value for 'matchId'
 *   },
 * });
 */
export function useGetPlayerMatchStatsQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerMatchStatsQuery, GetPlayerMatchStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerMatchStatsQuery, GetPlayerMatchStatsQueryVariables>(GetPlayerMatchStatsDocument, options);
      }
export function useGetPlayerMatchStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerMatchStatsQuery, GetPlayerMatchStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerMatchStatsQuery, GetPlayerMatchStatsQueryVariables>(GetPlayerMatchStatsDocument, options);
        }
export type GetPlayerMatchStatsQueryHookResult = ReturnType<typeof useGetPlayerMatchStatsQuery>;
export type GetPlayerMatchStatsLazyQueryHookResult = ReturnType<typeof useGetPlayerMatchStatsLazyQuery>;
export type GetPlayerMatchStatsQueryResult = Apollo.QueryResult<GetPlayerMatchStatsQuery, GetPlayerMatchStatsQueryVariables>;
export function refetchGetPlayerMatchStatsQuery(variables: GetPlayerMatchStatsQueryVariables) {
      return { query: GetPlayerMatchStatsDocument, variables: variables }
    }
export const GetTopPerformersStatsByGameIdDocument = gql`
    query getTopPerformersStatsByGameId($gameId: UUID!) {
  game(id: $gameId) {
    id
    status
    playerGameStats {
      player {
        id
        name
        avatarUrl
        userProviderAccounts {
          id
          userId
          providerName
          providerAccountId
          providerDisplayName
          providerIntegrationType
        }
      }
      teamId
      stats {
        ... on LeagueOfLegendsPlayerGameStats {
          id
          eliminationRespawnRatio
          eliminations
          assists
          goldPerMinute
        }
        ... on RocketLeaguePlayerGameStats {
          id
          shootingPercentage
          goals
          saves
          assists
        }
        ... on SmitePlayerGameStats {
          id
          eliminationRespawnRatio
          eliminations
          assists
          goldEarned
        }
      }
      team {
        id
        school {
          id
          logoUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetTopPerformersStatsByGameIdQuery__
 *
 * To run a query within a React component, call `useGetTopPerformersStatsByGameIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopPerformersStatsByGameIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopPerformersStatsByGameIdQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useGetTopPerformersStatsByGameIdQuery(baseOptions: Apollo.QueryHookOptions<GetTopPerformersStatsByGameIdQuery, GetTopPerformersStatsByGameIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopPerformersStatsByGameIdQuery, GetTopPerformersStatsByGameIdQueryVariables>(GetTopPerformersStatsByGameIdDocument, options);
      }
export function useGetTopPerformersStatsByGameIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopPerformersStatsByGameIdQuery, GetTopPerformersStatsByGameIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopPerformersStatsByGameIdQuery, GetTopPerformersStatsByGameIdQueryVariables>(GetTopPerformersStatsByGameIdDocument, options);
        }
export type GetTopPerformersStatsByGameIdQueryHookResult = ReturnType<typeof useGetTopPerformersStatsByGameIdQuery>;
export type GetTopPerformersStatsByGameIdLazyQueryHookResult = ReturnType<typeof useGetTopPerformersStatsByGameIdLazyQuery>;
export type GetTopPerformersStatsByGameIdQueryResult = Apollo.QueryResult<GetTopPerformersStatsByGameIdQuery, GetTopPerformersStatsByGameIdQueryVariables>;
export function refetchGetTopPerformersStatsByGameIdQuery(variables: GetTopPerformersStatsByGameIdQueryVariables) {
      return { query: GetTopPerformersStatsByGameIdDocument, variables: variables }
    }
export const FindSurveyByTriggerDocument = gql`
    query findSurveyByTrigger($trigger: SurveyTrigger!, $entityType: SurveyTriggerEntityType!, $entityId: UUID!) {
  findSurveyByTrigger(
    trigger: $trigger
    entityType: $entityType
    entityId: $entityId
  ) {
    id
    schemaJson
  }
}
    `;

/**
 * __useFindSurveyByTriggerQuery__
 *
 * To run a query within a React component, call `useFindSurveyByTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSurveyByTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSurveyByTriggerQuery({
 *   variables: {
 *      trigger: // value for 'trigger'
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useFindSurveyByTriggerQuery(baseOptions: Apollo.QueryHookOptions<FindSurveyByTriggerQuery, FindSurveyByTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSurveyByTriggerQuery, FindSurveyByTriggerQueryVariables>(FindSurveyByTriggerDocument, options);
      }
export function useFindSurveyByTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSurveyByTriggerQuery, FindSurveyByTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSurveyByTriggerQuery, FindSurveyByTriggerQueryVariables>(FindSurveyByTriggerDocument, options);
        }
export type FindSurveyByTriggerQueryHookResult = ReturnType<typeof useFindSurveyByTriggerQuery>;
export type FindSurveyByTriggerLazyQueryHookResult = ReturnType<typeof useFindSurveyByTriggerLazyQuery>;
export type FindSurveyByTriggerQueryResult = Apollo.QueryResult<FindSurveyByTriggerQuery, FindSurveyByTriggerQueryVariables>;
export function refetchFindSurveyByTriggerQuery(variables: FindSurveyByTriggerQueryVariables) {
      return { query: FindSurveyByTriggerDocument, variables: variables }
    }
export const SaveSurveySchemaDocument = gql`
    mutation saveSurveySchema($input: SaveSurveySchemaInput!) {
  saveSurveySchema(input: $input) {
    id
    success
  }
}
    `;
export type SaveSurveySchemaMutationFn = Apollo.MutationFunction<SaveSurveySchemaMutation, SaveSurveySchemaMutationVariables>;

/**
 * __useSaveSurveySchemaMutation__
 *
 * To run a mutation, you first call `useSaveSurveySchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSurveySchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSurveySchemaMutation, { data, loading, error }] = useSaveSurveySchemaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSurveySchemaMutation(baseOptions?: Apollo.MutationHookOptions<SaveSurveySchemaMutation, SaveSurveySchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSurveySchemaMutation, SaveSurveySchemaMutationVariables>(SaveSurveySchemaDocument, options);
      }
export type SaveSurveySchemaMutationHookResult = ReturnType<typeof useSaveSurveySchemaMutation>;
export type SaveSurveySchemaMutationResult = Apollo.MutationResult<SaveSurveySchemaMutation>;
export type SaveSurveySchemaMutationOptions = Apollo.BaseMutationOptions<SaveSurveySchemaMutation, SaveSurveySchemaMutationVariables>;
export const DeleteSurveySchemaDocument = gql`
    mutation deleteSurveySchema($id: UUID!) {
  deleteSurveySchema(id: $id) {
    id
    success
  }
}
    `;
export type DeleteSurveySchemaMutationFn = Apollo.MutationFunction<DeleteSurveySchemaMutation, DeleteSurveySchemaMutationVariables>;

/**
 * __useDeleteSurveySchemaMutation__
 *
 * To run a mutation, you first call `useDeleteSurveySchemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveySchemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveySchemaMutation, { data, loading, error }] = useDeleteSurveySchemaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSurveySchemaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurveySchemaMutation, DeleteSurveySchemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurveySchemaMutation, DeleteSurveySchemaMutationVariables>(DeleteSurveySchemaDocument, options);
      }
export type DeleteSurveySchemaMutationHookResult = ReturnType<typeof useDeleteSurveySchemaMutation>;
export type DeleteSurveySchemaMutationResult = Apollo.MutationResult<DeleteSurveySchemaMutation>;
export type DeleteSurveySchemaMutationOptions = Apollo.BaseMutationOptions<DeleteSurveySchemaMutation, DeleteSurveySchemaMutationVariables>;
export const SaveGeneralSurveyResponseDocument = gql`
    mutation saveGeneralSurveyResponse($surveySchemaId: UUID!, $responseJson: String!) {
  saveSurveyResponse(surveySchemaId: $surveySchemaId, responseJson: $responseJson) {
    id
    success
  }
}
    `;
export type SaveGeneralSurveyResponseMutationFn = Apollo.MutationFunction<SaveGeneralSurveyResponseMutation, SaveGeneralSurveyResponseMutationVariables>;

/**
 * __useSaveGeneralSurveyResponseMutation__
 *
 * To run a mutation, you first call `useSaveGeneralSurveyResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGeneralSurveyResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGeneralSurveyResponseMutation, { data, loading, error }] = useSaveGeneralSurveyResponseMutation({
 *   variables: {
 *      surveySchemaId: // value for 'surveySchemaId'
 *      responseJson: // value for 'responseJson'
 *   },
 * });
 */
export function useSaveGeneralSurveyResponseMutation(baseOptions?: Apollo.MutationHookOptions<SaveGeneralSurveyResponseMutation, SaveGeneralSurveyResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGeneralSurveyResponseMutation, SaveGeneralSurveyResponseMutationVariables>(SaveGeneralSurveyResponseDocument, options);
      }
export type SaveGeneralSurveyResponseMutationHookResult = ReturnType<typeof useSaveGeneralSurveyResponseMutation>;
export type SaveGeneralSurveyResponseMutationResult = Apollo.MutationResult<SaveGeneralSurveyResponseMutation>;
export type SaveGeneralSurveyResponseMutationOptions = Apollo.BaseMutationOptions<SaveGeneralSurveyResponseMutation, SaveGeneralSurveyResponseMutationVariables>;
export const SaveSurveyDocument = gql`
    mutation saveSurvey($input: SaveSurveyInput!) {
  saveSurvey(input: $input) {
    id
  }
}
    `;
export type SaveSurveyMutationFn = Apollo.MutationFunction<SaveSurveyMutation, SaveSurveyMutationVariables>;

/**
 * __useSaveSurveyMutation__
 *
 * To run a mutation, you first call `useSaveSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSurveyMutation, { data, loading, error }] = useSaveSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSurveyMutation(baseOptions?: Apollo.MutationHookOptions<SaveSurveyMutation, SaveSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSurveyMutation, SaveSurveyMutationVariables>(SaveSurveyDocument, options);
      }
export type SaveSurveyMutationHookResult = ReturnType<typeof useSaveSurveyMutation>;
export type SaveSurveyMutationResult = Apollo.MutationResult<SaveSurveyMutation>;
export type SaveSurveyMutationOptions = Apollo.BaseMutationOptions<SaveSurveyMutation, SaveSurveyMutationVariables>;
export const ResurrectDuplicateTeamDocument = gql`
    mutation resurrectDuplicateTeam($teamToReplaceId: UUID!, $deletedTeamMemberIds: [UUID!]!) {
  resurrectDuplicateDeletedTeam(
    teamToReplaceId: $teamToReplaceId
    deletedTeamMemberIds: $deletedTeamMemberIds
  ) {
    team {
      id
    }
  }
}
    `;
export type ResurrectDuplicateTeamMutationFn = Apollo.MutationFunction<ResurrectDuplicateTeamMutation, ResurrectDuplicateTeamMutationVariables>;

/**
 * __useResurrectDuplicateTeamMutation__
 *
 * To run a mutation, you first call `useResurrectDuplicateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResurrectDuplicateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resurrectDuplicateTeamMutation, { data, loading, error }] = useResurrectDuplicateTeamMutation({
 *   variables: {
 *      teamToReplaceId: // value for 'teamToReplaceId'
 *      deletedTeamMemberIds: // value for 'deletedTeamMemberIds'
 *   },
 * });
 */
export function useResurrectDuplicateTeamMutation(baseOptions?: Apollo.MutationHookOptions<ResurrectDuplicateTeamMutation, ResurrectDuplicateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResurrectDuplicateTeamMutation, ResurrectDuplicateTeamMutationVariables>(ResurrectDuplicateTeamDocument, options);
      }
export type ResurrectDuplicateTeamMutationHookResult = ReturnType<typeof useResurrectDuplicateTeamMutation>;
export type ResurrectDuplicateTeamMutationResult = Apollo.MutationResult<ResurrectDuplicateTeamMutation>;
export type ResurrectDuplicateTeamMutationOptions = Apollo.BaseMutationOptions<ResurrectDuplicateTeamMutation, ResurrectDuplicateTeamMutationVariables>;
export const ResurrectTeamDocument = gql`
    mutation resurrectTeam($teamId: UUID!) {
  resurrectTeam(teamId: $teamId) {
    team {
      id
      deletedById
      deletedAt
    }
  }
}
    `;
export type ResurrectTeamMutationFn = Apollo.MutationFunction<ResurrectTeamMutation, ResurrectTeamMutationVariables>;

/**
 * __useResurrectTeamMutation__
 *
 * To run a mutation, you first call `useResurrectTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResurrectTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resurrectTeamMutation, { data, loading, error }] = useResurrectTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useResurrectTeamMutation(baseOptions?: Apollo.MutationHookOptions<ResurrectTeamMutation, ResurrectTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResurrectTeamMutation, ResurrectTeamMutationVariables>(ResurrectTeamDocument, options);
      }
export type ResurrectTeamMutationHookResult = ReturnType<typeof useResurrectTeamMutation>;
export type ResurrectTeamMutationResult = Apollo.MutationResult<ResurrectTeamMutation>;
export type ResurrectTeamMutationOptions = Apollo.BaseMutationOptions<ResurrectTeamMutation, ResurrectTeamMutationVariables>;
export const UpdateTeamNameDocument = gql`
    mutation updateTeamName($teamId: UUID!, $input: UpdateTeamInput!) {
  updateTeam(teamId: $teamId, input: $input) {
    team {
      id
      name
    }
  }
}
    `;
export type UpdateTeamNameMutationFn = Apollo.MutationFunction<UpdateTeamNameMutation, UpdateTeamNameMutationVariables>;

/**
 * __useUpdateTeamNameMutation__
 *
 * To run a mutation, you first call `useUpdateTeamNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamNameMutation, { data, loading, error }] = useUpdateTeamNameMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamNameMutation, UpdateTeamNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamNameMutation, UpdateTeamNameMutationVariables>(UpdateTeamNameDocument, options);
      }
export type UpdateTeamNameMutationHookResult = ReturnType<typeof useUpdateTeamNameMutation>;
export type UpdateTeamNameMutationResult = Apollo.MutationResult<UpdateTeamNameMutation>;
export type UpdateTeamNameMutationOptions = Apollo.BaseMutationOptions<UpdateTeamNameMutation, UpdateTeamNameMutationVariables>;
export const DeactivateTeamFromLeagueDocument = gql`
    mutation deactivateTeamFromLeague($teamId: UUID!, $leagueId: UUID!, $metaseasonId: UUID!) {
  removeTeamFromLeague(
    teamId: $teamId
    leagueId: $leagueId
    metaseasonId: $metaseasonId
  ) {
    success
    team {
      id
      leagues {
        id
      }
    }
  }
}
    `;
export type DeactivateTeamFromLeagueMutationFn = Apollo.MutationFunction<DeactivateTeamFromLeagueMutation, DeactivateTeamFromLeagueMutationVariables>;

/**
 * __useDeactivateTeamFromLeagueMutation__
 *
 * To run a mutation, you first call `useDeactivateTeamFromLeagueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateTeamFromLeagueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateTeamFromLeagueMutation, { data, loading, error }] = useDeactivateTeamFromLeagueMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      leagueId: // value for 'leagueId'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useDeactivateTeamFromLeagueMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateTeamFromLeagueMutation, DeactivateTeamFromLeagueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateTeamFromLeagueMutation, DeactivateTeamFromLeagueMutationVariables>(DeactivateTeamFromLeagueDocument, options);
      }
export type DeactivateTeamFromLeagueMutationHookResult = ReturnType<typeof useDeactivateTeamFromLeagueMutation>;
export type DeactivateTeamFromLeagueMutationResult = Apollo.MutationResult<DeactivateTeamFromLeagueMutation>;
export type DeactivateTeamFromLeagueMutationOptions = Apollo.BaseMutationOptions<DeactivateTeamFromLeagueMutation, DeactivateTeamFromLeagueMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation deleteTeam($teamId: UUID!) {
  deleteTeam(teamId: $teamId) {
    success
    deletedTeamId
  }
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const CreateRoleInviteCodeDocument = gql`
    mutation createRoleInviteCode($userId: UUID!, $resourceId: UUID!, $resourceType: String!, $roleName: UserRoleName!) {
  createRoleInviteCode(
    input: {resourceId: $resourceId, resourceType: $resourceType, roleName: $roleName, userId: $userId}
  ) {
    id
    code
  }
}
    `;
export type CreateRoleInviteCodeMutationFn = Apollo.MutationFunction<CreateRoleInviteCodeMutation, CreateRoleInviteCodeMutationVariables>;

/**
 * __useCreateRoleInviteCodeMutation__
 *
 * To run a mutation, you first call `useCreateRoleInviteCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleInviteCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleInviteCodeMutation, { data, loading, error }] = useCreateRoleInviteCodeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      resourceId: // value for 'resourceId'
 *      resourceType: // value for 'resourceType'
 *      roleName: // value for 'roleName'
 *   },
 * });
 */
export function useCreateRoleInviteCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleInviteCodeMutation, CreateRoleInviteCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleInviteCodeMutation, CreateRoleInviteCodeMutationVariables>(CreateRoleInviteCodeDocument, options);
      }
export type CreateRoleInviteCodeMutationHookResult = ReturnType<typeof useCreateRoleInviteCodeMutation>;
export type CreateRoleInviteCodeMutationResult = Apollo.MutationResult<CreateRoleInviteCodeMutation>;
export type CreateRoleInviteCodeMutationOptions = Apollo.BaseMutationOptions<CreateRoleInviteCodeMutation, CreateRoleInviteCodeMutationVariables>;
export const GenerateReferralLinkDocument = gql`
    mutation generateReferralLink($resourceId: UUID, $resourceType: ResourceType!, $roleName: UserRoleName!, $source: String!, $medium: String!, $competitionGroup: CompetitionGroup) {
  generateReferralLink(
    attributes: {resourceId: $resourceId, resourceType: $resourceType, roleName: $roleName, source: $source, medium: $medium, competitionGroup: $competitionGroup}
  )
}
    `;
export type GenerateReferralLinkMutationFn = Apollo.MutationFunction<GenerateReferralLinkMutation, GenerateReferralLinkMutationVariables>;

/**
 * __useGenerateReferralLinkMutation__
 *
 * To run a mutation, you first call `useGenerateReferralLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReferralLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReferralLinkMutation, { data, loading, error }] = useGenerateReferralLinkMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      resourceType: // value for 'resourceType'
 *      roleName: // value for 'roleName'
 *      source: // value for 'source'
 *      medium: // value for 'medium'
 *      competitionGroup: // value for 'competitionGroup'
 *   },
 * });
 */
export function useGenerateReferralLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReferralLinkMutation, GenerateReferralLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReferralLinkMutation, GenerateReferralLinkMutationVariables>(GenerateReferralLinkDocument, options);
      }
export type GenerateReferralLinkMutationHookResult = ReturnType<typeof useGenerateReferralLinkMutation>;
export type GenerateReferralLinkMutationResult = Apollo.MutationResult<GenerateReferralLinkMutation>;
export type GenerateReferralLinkMutationOptions = Apollo.BaseMutationOptions<GenerateReferralLinkMutation, GenerateReferralLinkMutationVariables>;
export const AssignTeamCaptainRoleDocument = gql`
    mutation assignTeamCaptainRole($teamId: UUID!, $userId: UUID!) {
  assignTeamCaptainRole(teamId: $teamId, userId: $userId) {
    team {
      id
      roster {
        id
        players {
          isCaptain
          user {
            id
          }
        }
        formats {
          starters {
            player {
              isCaptain
              user {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type AssignTeamCaptainRoleMutationFn = Apollo.MutationFunction<AssignTeamCaptainRoleMutation, AssignTeamCaptainRoleMutationVariables>;

/**
 * __useAssignTeamCaptainRoleMutation__
 *
 * To run a mutation, you first call `useAssignTeamCaptainRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTeamCaptainRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTeamCaptainRoleMutation, { data, loading, error }] = useAssignTeamCaptainRoleMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssignTeamCaptainRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignTeamCaptainRoleMutation, AssignTeamCaptainRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignTeamCaptainRoleMutation, AssignTeamCaptainRoleMutationVariables>(AssignTeamCaptainRoleDocument, options);
      }
export type AssignTeamCaptainRoleMutationHookResult = ReturnType<typeof useAssignTeamCaptainRoleMutation>;
export type AssignTeamCaptainRoleMutationResult = Apollo.MutationResult<AssignTeamCaptainRoleMutation>;
export type AssignTeamCaptainRoleMutationOptions = Apollo.BaseMutationOptions<AssignTeamCaptainRoleMutation, AssignTeamCaptainRoleMutationVariables>;
export const UnassignTeamCaptainRoleDocument = gql`
    mutation unassignTeamCaptainRole($teamId: UUID!, $userId: UUID!) {
  unassignTeamCaptainRole(teamId: $teamId, userId: $userId) {
    team {
      id
      roster {
        id
        players {
          isCaptain
          user {
            id
          }
        }
        formats {
          starters {
            player {
              isCaptain
              user {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type UnassignTeamCaptainRoleMutationFn = Apollo.MutationFunction<UnassignTeamCaptainRoleMutation, UnassignTeamCaptainRoleMutationVariables>;

/**
 * __useUnassignTeamCaptainRoleMutation__
 *
 * To run a mutation, you first call `useUnassignTeamCaptainRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignTeamCaptainRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignTeamCaptainRoleMutation, { data, loading, error }] = useUnassignTeamCaptainRoleMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnassignTeamCaptainRoleMutation(baseOptions?: Apollo.MutationHookOptions<UnassignTeamCaptainRoleMutation, UnassignTeamCaptainRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignTeamCaptainRoleMutation, UnassignTeamCaptainRoleMutationVariables>(UnassignTeamCaptainRoleDocument, options);
      }
export type UnassignTeamCaptainRoleMutationHookResult = ReturnType<typeof useUnassignTeamCaptainRoleMutation>;
export type UnassignTeamCaptainRoleMutationResult = Apollo.MutationResult<UnassignTeamCaptainRoleMutation>;
export type UnassignTeamCaptainRoleMutationOptions = Apollo.BaseMutationOptions<UnassignTeamCaptainRoleMutation, UnassignTeamCaptainRoleMutationVariables>;
export const SetTeamIsPlayerLedDocument = gql`
    mutation setTeamIsPlayerLed($teamId: UUID!, $isPlayerLed: Boolean!) {
  setTeamIsPlayerLed(teamId: $teamId, isPlayerLed: $isPlayerLed) {
    team {
      id
      isPlayerLed
    }
  }
}
    `;
export type SetTeamIsPlayerLedMutationFn = Apollo.MutationFunction<SetTeamIsPlayerLedMutation, SetTeamIsPlayerLedMutationVariables>;

/**
 * __useSetTeamIsPlayerLedMutation__
 *
 * To run a mutation, you first call `useSetTeamIsPlayerLedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeamIsPlayerLedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeamIsPlayerLedMutation, { data, loading, error }] = useSetTeamIsPlayerLedMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      isPlayerLed: // value for 'isPlayerLed'
 *   },
 * });
 */
export function useSetTeamIsPlayerLedMutation(baseOptions?: Apollo.MutationHookOptions<SetTeamIsPlayerLedMutation, SetTeamIsPlayerLedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeamIsPlayerLedMutation, SetTeamIsPlayerLedMutationVariables>(SetTeamIsPlayerLedDocument, options);
      }
export type SetTeamIsPlayerLedMutationHookResult = ReturnType<typeof useSetTeamIsPlayerLedMutation>;
export type SetTeamIsPlayerLedMutationResult = Apollo.MutationResult<SetTeamIsPlayerLedMutation>;
export type SetTeamIsPlayerLedMutationOptions = Apollo.BaseMutationOptions<SetTeamIsPlayerLedMutation, SetTeamIsPlayerLedMutationVariables>;
export const SwapSubstitutesBetweenTeamsDocument = gql`
    mutation swapSubstitutesBetweenTeams($input: TransferSubstituteToTeamInput!) {
  transferSubstituteToTeam(input: $input) {
    originTeam {
      id
      roster {
        id
        teamId
        numPlayers
        maxNumPlayers
        isFull
        players {
          isCaptain
          effectiveAt
          user {
            id
            roles {
              userId
              roleName
              resourceType
              resourceId
            }
          }
        }
        formats {
          teamSize
          starters {
            position {
              id
              index
              name
              abbreviation
              colloquial
            }
            player {
              effectiveAt
              isCaptain
              user {
                id
                roles {
                  userId
                  roleName
                  resourceType
                  resourceId
                }
              }
            }
          }
          substitutes {
            isCaptain
            user {
              id
              roles {
                userId
                roleName
                resourceType
                resourceId
              }
            }
          }
        }
      }
    }
    destinationTeam {
      id
      roster {
        id
        teamId
        numPlayers
        maxNumPlayers
        isFull
        players {
          isCaptain
          effectiveAt
          user {
            id
            lastSeen
            name
            avatarUrl
            roles {
              userId
              roleName
              resourceType
              resourceId
            }
          }
        }
        formats {
          teamSize
          starters {
            position {
              id
              index
              name
              abbreviation
              colloquial
            }
            player {
              effectiveAt
              isCaptain
              user {
                id
                roles {
                  userId
                  roleName
                  resourceType
                  resourceId
                }
              }
            }
          }
          substitutes {
            isCaptain
            user {
              id
              roles {
                userId
                roleName
                resourceType
                resourceId
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type SwapSubstitutesBetweenTeamsMutationFn = Apollo.MutationFunction<SwapSubstitutesBetweenTeamsMutation, SwapSubstitutesBetweenTeamsMutationVariables>;

/**
 * __useSwapSubstitutesBetweenTeamsMutation__
 *
 * To run a mutation, you first call `useSwapSubstitutesBetweenTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapSubstitutesBetweenTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapSubstitutesBetweenTeamsMutation, { data, loading, error }] = useSwapSubstitutesBetweenTeamsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwapSubstitutesBetweenTeamsMutation(baseOptions?: Apollo.MutationHookOptions<SwapSubstitutesBetweenTeamsMutation, SwapSubstitutesBetweenTeamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwapSubstitutesBetweenTeamsMutation, SwapSubstitutesBetweenTeamsMutationVariables>(SwapSubstitutesBetweenTeamsDocument, options);
      }
export type SwapSubstitutesBetweenTeamsMutationHookResult = ReturnType<typeof useSwapSubstitutesBetweenTeamsMutation>;
export type SwapSubstitutesBetweenTeamsMutationResult = Apollo.MutationResult<SwapSubstitutesBetweenTeamsMutation>;
export type SwapSubstitutesBetweenTeamsMutationOptions = Apollo.BaseMutationOptions<SwapSubstitutesBetweenTeamsMutation, SwapSubstitutesBetweenTeamsMutationVariables>;
export const AssignTeamCoachDocument = gql`
    mutation assignTeamCoach($teamId: UUID!, $coachUserId: UUID!) {
  assignTeamCoach(teamId: $teamId, coachUserId: $coachUserId) {
    success
  }
}
    `;
export type AssignTeamCoachMutationFn = Apollo.MutationFunction<AssignTeamCoachMutation, AssignTeamCoachMutationVariables>;

/**
 * __useAssignTeamCoachMutation__
 *
 * To run a mutation, you first call `useAssignTeamCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTeamCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTeamCoachMutation, { data, loading, error }] = useAssignTeamCoachMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      coachUserId: // value for 'coachUserId'
 *   },
 * });
 */
export function useAssignTeamCoachMutation(baseOptions?: Apollo.MutationHookOptions<AssignTeamCoachMutation, AssignTeamCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignTeamCoachMutation, AssignTeamCoachMutationVariables>(AssignTeamCoachDocument, options);
      }
export type AssignTeamCoachMutationHookResult = ReturnType<typeof useAssignTeamCoachMutation>;
export type AssignTeamCoachMutationResult = Apollo.MutationResult<AssignTeamCoachMutation>;
export type AssignTeamCoachMutationOptions = Apollo.BaseMutationOptions<AssignTeamCoachMutation, AssignTeamCoachMutationVariables>;
export const RemoveTeamCoachDocument = gql`
    mutation removeTeamCoach($teamId: UUID!, $coachUserId: UUID!) {
  removeTeamCoach(teamId: $teamId, coachUserId: $coachUserId) {
    success
  }
}
    `;
export type RemoveTeamCoachMutationFn = Apollo.MutationFunction<RemoveTeamCoachMutation, RemoveTeamCoachMutationVariables>;

/**
 * __useRemoveTeamCoachMutation__
 *
 * To run a mutation, you first call `useRemoveTeamCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamCoachMutation, { data, loading, error }] = useRemoveTeamCoachMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      coachUserId: // value for 'coachUserId'
 *   },
 * });
 */
export function useRemoveTeamCoachMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamCoachMutation, RemoveTeamCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamCoachMutation, RemoveTeamCoachMutationVariables>(RemoveTeamCoachDocument, options);
      }
export type RemoveTeamCoachMutationHookResult = ReturnType<typeof useRemoveTeamCoachMutation>;
export type RemoveTeamCoachMutationResult = Apollo.MutationResult<RemoveTeamCoachMutation>;
export type RemoveTeamCoachMutationOptions = Apollo.BaseMutationOptions<RemoveTeamCoachMutation, RemoveTeamCoachMutationVariables>;
export const ReplaceTeamCoachDocument = gql`
    mutation replaceTeamCoach($teamId: UUID!, $existingCoachUserId: UUID!, $newCoachUserId: UUID!) {
  replaceTeamCoach(
    teamId: $teamId
    existingCoachUserId: $existingCoachUserId
    newCoachUserId: $newCoachUserId
  ) {
    success
  }
}
    `;
export type ReplaceTeamCoachMutationFn = Apollo.MutationFunction<ReplaceTeamCoachMutation, ReplaceTeamCoachMutationVariables>;

/**
 * __useReplaceTeamCoachMutation__
 *
 * To run a mutation, you first call `useReplaceTeamCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceTeamCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceTeamCoachMutation, { data, loading, error }] = useReplaceTeamCoachMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      existingCoachUserId: // value for 'existingCoachUserId'
 *      newCoachUserId: // value for 'newCoachUserId'
 *   },
 * });
 */
export function useReplaceTeamCoachMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceTeamCoachMutation, ReplaceTeamCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceTeamCoachMutation, ReplaceTeamCoachMutationVariables>(ReplaceTeamCoachDocument, options);
      }
export type ReplaceTeamCoachMutationHookResult = ReturnType<typeof useReplaceTeamCoachMutation>;
export type ReplaceTeamCoachMutationResult = Apollo.MutationResult<ReplaceTeamCoachMutation>;
export type ReplaceTeamCoachMutationOptions = Apollo.BaseMutationOptions<ReplaceTeamCoachMutation, ReplaceTeamCoachMutationVariables>;
export const EnrollTeamInSeasonDocument = gql`
    mutation enrollTeamInSeason($teamId: UUID!, $seasonId: UUID!, $options: TeamEnrollmentOptions) {
  enrollTeamInSeason(teamId: $teamId, seasonId: $seasonId, options: $options) {
    success
  }
}
    `;
export type EnrollTeamInSeasonMutationFn = Apollo.MutationFunction<EnrollTeamInSeasonMutation, EnrollTeamInSeasonMutationVariables>;

/**
 * __useEnrollTeamInSeasonMutation__
 *
 * To run a mutation, you first call `useEnrollTeamInSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollTeamInSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollTeamInSeasonMutation, { data, loading, error }] = useEnrollTeamInSeasonMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      seasonId: // value for 'seasonId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useEnrollTeamInSeasonMutation(baseOptions?: Apollo.MutationHookOptions<EnrollTeamInSeasonMutation, EnrollTeamInSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollTeamInSeasonMutation, EnrollTeamInSeasonMutationVariables>(EnrollTeamInSeasonDocument, options);
      }
export type EnrollTeamInSeasonMutationHookResult = ReturnType<typeof useEnrollTeamInSeasonMutation>;
export type EnrollTeamInSeasonMutationResult = Apollo.MutationResult<EnrollTeamInSeasonMutation>;
export type EnrollTeamInSeasonMutationOptions = Apollo.BaseMutationOptions<EnrollTeamInSeasonMutation, EnrollTeamInSeasonMutationVariables>;
export const UnenrollTeamFromSeasonDocument = gql`
    mutation unenrollTeamFromSeason($teamId: UUID!, $seasonId: UUID!) {
  unenrollTeamFromSeason(teamId: $teamId, seasonId: $seasonId) {
    success
  }
}
    `;
export type UnenrollTeamFromSeasonMutationFn = Apollo.MutationFunction<UnenrollTeamFromSeasonMutation, UnenrollTeamFromSeasonMutationVariables>;

/**
 * __useUnenrollTeamFromSeasonMutation__
 *
 * To run a mutation, you first call `useUnenrollTeamFromSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollTeamFromSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unenrollTeamFromSeasonMutation, { data, loading, error }] = useUnenrollTeamFromSeasonMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useUnenrollTeamFromSeasonMutation(baseOptions?: Apollo.MutationHookOptions<UnenrollTeamFromSeasonMutation, UnenrollTeamFromSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnenrollTeamFromSeasonMutation, UnenrollTeamFromSeasonMutationVariables>(UnenrollTeamFromSeasonDocument, options);
      }
export type UnenrollTeamFromSeasonMutationHookResult = ReturnType<typeof useUnenrollTeamFromSeasonMutation>;
export type UnenrollTeamFromSeasonMutationResult = Apollo.MutationResult<UnenrollTeamFromSeasonMutation>;
export type UnenrollTeamFromSeasonMutationOptions = Apollo.BaseMutationOptions<UnenrollTeamFromSeasonMutation, UnenrollTeamFromSeasonMutationVariables>;
export const TransferTeamToSeasonDocument = gql`
    mutation transferTeamToSeason($teamId: UUID!, $originSeasonId: UUID!, $destinationSeasonId: UUID!, $options: TeamEnrollmentOptions) {
  transferTeamToSeason(
    teamId: $teamId
    originSeasonId: $originSeasonId
    destinationSeasonId: $destinationSeasonId
    options: $options
  ) {
    success
  }
}
    `;
export type TransferTeamToSeasonMutationFn = Apollo.MutationFunction<TransferTeamToSeasonMutation, TransferTeamToSeasonMutationVariables>;

/**
 * __useTransferTeamToSeasonMutation__
 *
 * To run a mutation, you first call `useTransferTeamToSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferTeamToSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferTeamToSeasonMutation, { data, loading, error }] = useTransferTeamToSeasonMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      originSeasonId: // value for 'originSeasonId'
 *      destinationSeasonId: // value for 'destinationSeasonId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useTransferTeamToSeasonMutation(baseOptions?: Apollo.MutationHookOptions<TransferTeamToSeasonMutation, TransferTeamToSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferTeamToSeasonMutation, TransferTeamToSeasonMutationVariables>(TransferTeamToSeasonDocument, options);
      }
export type TransferTeamToSeasonMutationHookResult = ReturnType<typeof useTransferTeamToSeasonMutation>;
export type TransferTeamToSeasonMutationResult = Apollo.MutationResult<TransferTeamToSeasonMutation>;
export type TransferTeamToSeasonMutationOptions = Apollo.BaseMutationOptions<TransferTeamToSeasonMutation, TransferTeamToSeasonMutationVariables>;
export const UnenrollTeamsFromSeasonDocument = gql`
    mutation unenrollTeamsFromSeason($input: UnenrollTeamsFromSeasonInput!) {
  unenrollTeamsFromSeason(input: $input) {
    jobId
  }
}
    `;
export type UnenrollTeamsFromSeasonMutationFn = Apollo.MutationFunction<UnenrollTeamsFromSeasonMutation, UnenrollTeamsFromSeasonMutationVariables>;

/**
 * __useUnenrollTeamsFromSeasonMutation__
 *
 * To run a mutation, you first call `useUnenrollTeamsFromSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnenrollTeamsFromSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unenrollTeamsFromSeasonMutation, { data, loading, error }] = useUnenrollTeamsFromSeasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnenrollTeamsFromSeasonMutation(baseOptions?: Apollo.MutationHookOptions<UnenrollTeamsFromSeasonMutation, UnenrollTeamsFromSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnenrollTeamsFromSeasonMutation, UnenrollTeamsFromSeasonMutationVariables>(UnenrollTeamsFromSeasonDocument, options);
      }
export type UnenrollTeamsFromSeasonMutationHookResult = ReturnType<typeof useUnenrollTeamsFromSeasonMutation>;
export type UnenrollTeamsFromSeasonMutationResult = Apollo.MutationResult<UnenrollTeamsFromSeasonMutation>;
export type UnenrollTeamsFromSeasonMutationOptions = Apollo.BaseMutationOptions<UnenrollTeamsFromSeasonMutation, UnenrollTeamsFromSeasonMutationVariables>;
export const TransferTeamsToSeasonDocument = gql`
    mutation transferTeamsToSeason($input: TransferTeamsToSeasonInput!) {
  transferTeamsToSeason(input: $input) {
    jobId
  }
}
    `;
export type TransferTeamsToSeasonMutationFn = Apollo.MutationFunction<TransferTeamsToSeasonMutation, TransferTeamsToSeasonMutationVariables>;

/**
 * __useTransferTeamsToSeasonMutation__
 *
 * To run a mutation, you first call `useTransferTeamsToSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferTeamsToSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferTeamsToSeasonMutation, { data, loading, error }] = useTransferTeamsToSeasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferTeamsToSeasonMutation(baseOptions?: Apollo.MutationHookOptions<TransferTeamsToSeasonMutation, TransferTeamsToSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferTeamsToSeasonMutation, TransferTeamsToSeasonMutationVariables>(TransferTeamsToSeasonDocument, options);
      }
export type TransferTeamsToSeasonMutationHookResult = ReturnType<typeof useTransferTeamsToSeasonMutation>;
export type TransferTeamsToSeasonMutationResult = Apollo.MutationResult<TransferTeamsToSeasonMutation>;
export type TransferTeamsToSeasonMutationOptions = Apollo.BaseMutationOptions<TransferTeamsToSeasonMutation, TransferTeamsToSeasonMutationVariables>;
export const GetPlayerPhaseStatsByTeamDocument = gql`
    query getPlayerPhaseStatsByTeam($id: UUID!, $metaseasonId: UUID!, $phaseId: UUID!, $date: DateTime!) {
  team(id: $id) {
    id
    name
    leagues(metaseasonId: $metaseasonId) {
      id
      esport {
        id
        slug
      }
      teamFormat
    }
    roster(effectiveAt: $date) {
      id
      players {
        user {
          id
          name
          avatarUrl
          userProviderAccounts {
            id
            userId
            providerName
            providerAccountId
            providerDisplayName
            providerIntegrationType
          }
          phaseStats(phaseId: $phaseId) {
            stats {
              ... on LeagueOfLegendsPlayerPhaseStats {
                id
                averageEliminations
                averageAssists
                averageRespawns
                averageGoldPerMinute
                averageCreepScore
                averageTowersDestroyed
                eliminationRespawnRatio
                mostPickedChampionId
                mostPickedChampion {
                  id
                  image {
                    src
                  }
                }
                eliminationParticipation
              }
              ... on RocketLeaguePlayerPhaseStats {
                id
                shootingPercentage
                averageGoals
                averageSaves
                averageAssists
                averageShots
              }
              ... on SmitePlayerPhaseStats {
                id
                eliminations
                respawns
                assists
                eliminationParticipation
                averageGoldPerMinute
                towersDestroyed
              }
            }
          }
        }
        effectiveAt
        teamId
      }
    }
  }
}
    `;

/**
 * __useGetPlayerPhaseStatsByTeamQuery__
 *
 * To run a query within a React component, call `useGetPlayerPhaseStatsByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayerPhaseStatsByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayerPhaseStatsByTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *      phaseId: // value for 'phaseId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetPlayerPhaseStatsByTeamQuery(baseOptions: Apollo.QueryHookOptions<GetPlayerPhaseStatsByTeamQuery, GetPlayerPhaseStatsByTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayerPhaseStatsByTeamQuery, GetPlayerPhaseStatsByTeamQueryVariables>(GetPlayerPhaseStatsByTeamDocument, options);
      }
export function useGetPlayerPhaseStatsByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayerPhaseStatsByTeamQuery, GetPlayerPhaseStatsByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayerPhaseStatsByTeamQuery, GetPlayerPhaseStatsByTeamQueryVariables>(GetPlayerPhaseStatsByTeamDocument, options);
        }
export type GetPlayerPhaseStatsByTeamQueryHookResult = ReturnType<typeof useGetPlayerPhaseStatsByTeamQuery>;
export type GetPlayerPhaseStatsByTeamLazyQueryHookResult = ReturnType<typeof useGetPlayerPhaseStatsByTeamLazyQuery>;
export type GetPlayerPhaseStatsByTeamQueryResult = Apollo.QueryResult<GetPlayerPhaseStatsByTeamQuery, GetPlayerPhaseStatsByTeamQueryVariables>;
export function refetchGetPlayerPhaseStatsByTeamQuery(variables: GetPlayerPhaseStatsByTeamQueryVariables) {
      return { query: GetPlayerPhaseStatsByTeamDocument, variables: variables }
    }
export const GetTopPerformersStatsByTeamIdDocument = gql`
    query getTopPerformersStatsByTeamId($id: UUID!, $metaseasonId: UUID!, $phaseId: UUID!, $date: DateTime!) {
  team(id: $id) {
    id
    leagues(metaseasonId: $metaseasonId) {
      id
      esport {
        id
        slug
      }
      teamFormat
    }
    roster(effectiveAt: $date) {
      id
      players {
        effectiveAt
        teamId
        user {
          id
          name
          avatarUrl
          school {
            id
            logoUrl
          }
          userProviderAccounts {
            id
            userId
            providerName
            providerAccountId
            providerDisplayName
            providerIntegrationType
          }
          phaseStats(phaseId: $phaseId) {
            stats {
              ... on LeagueOfLegendsPlayerPhaseStats {
                id
                eliminationRespawnRatio
                averageEliminations
                averageAssists
                averageGoldPerMinute
              }
              ... on RocketLeaguePlayerPhaseStats {
                id
                shootingPercentage
                averageGoals
                averageSaves
                averageAssists
              }
              ... on SmitePlayerPhaseStats {
                id
                eliminationRespawnRatio
                averageEliminations
                averageAssists
                averageGoldEarned
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTopPerformersStatsByTeamIdQuery__
 *
 * To run a query within a React component, call `useGetTopPerformersStatsByTeamIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopPerformersStatsByTeamIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopPerformersStatsByTeamIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *      phaseId: // value for 'phaseId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetTopPerformersStatsByTeamIdQuery(baseOptions: Apollo.QueryHookOptions<GetTopPerformersStatsByTeamIdQuery, GetTopPerformersStatsByTeamIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopPerformersStatsByTeamIdQuery, GetTopPerformersStatsByTeamIdQueryVariables>(GetTopPerformersStatsByTeamIdDocument, options);
      }
export function useGetTopPerformersStatsByTeamIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopPerformersStatsByTeamIdQuery, GetTopPerformersStatsByTeamIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopPerformersStatsByTeamIdQuery, GetTopPerformersStatsByTeamIdQueryVariables>(GetTopPerformersStatsByTeamIdDocument, options);
        }
export type GetTopPerformersStatsByTeamIdQueryHookResult = ReturnType<typeof useGetTopPerformersStatsByTeamIdQuery>;
export type GetTopPerformersStatsByTeamIdLazyQueryHookResult = ReturnType<typeof useGetTopPerformersStatsByTeamIdLazyQuery>;
export type GetTopPerformersStatsByTeamIdQueryResult = Apollo.QueryResult<GetTopPerformersStatsByTeamIdQuery, GetTopPerformersStatsByTeamIdQueryVariables>;
export function refetchGetTopPerformersStatsByTeamIdQuery(variables: GetTopPerformersStatsByTeamIdQueryVariables) {
      return { query: GetTopPerformersStatsByTeamIdDocument, variables: variables }
    }
export const GetTeamsUserAccountConnectionsDocument = gql`
    query getTeamsUserAccountConnections($filters: TeamFiltersInput) {
  getTeams(filters: $filters) {
    teams {
      id
      esport {
        id
        slug
      }
      roster {
        teamId
        players {
          user {
            id
            userProviderAccounts {
              id
              providerName
            }
            userEsportPlatforms {
              id
              platform
              esportId
            }
          }
        }
        formats {
          starters {
            player {
              user {
                id
              }
            }
          }
        }
      }
      enrolledSeasons {
        id
        startsAt
        endsAt
      }
    }
  }
}
    `;

/**
 * __useGetTeamsUserAccountConnectionsQuery__
 *
 * To run a query within a React component, call `useGetTeamsUserAccountConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsUserAccountConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsUserAccountConnectionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTeamsUserAccountConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamsUserAccountConnectionsQuery, GetTeamsUserAccountConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsUserAccountConnectionsQuery, GetTeamsUserAccountConnectionsQueryVariables>(GetTeamsUserAccountConnectionsDocument, options);
      }
export function useGetTeamsUserAccountConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsUserAccountConnectionsQuery, GetTeamsUserAccountConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsUserAccountConnectionsQuery, GetTeamsUserAccountConnectionsQueryVariables>(GetTeamsUserAccountConnectionsDocument, options);
        }
export type GetTeamsUserAccountConnectionsQueryHookResult = ReturnType<typeof useGetTeamsUserAccountConnectionsQuery>;
export type GetTeamsUserAccountConnectionsLazyQueryHookResult = ReturnType<typeof useGetTeamsUserAccountConnectionsLazyQuery>;
export type GetTeamsUserAccountConnectionsQueryResult = Apollo.QueryResult<GetTeamsUserAccountConnectionsQuery, GetTeamsUserAccountConnectionsQueryVariables>;
export function refetchGetTeamsUserAccountConnectionsQuery(variables?: GetTeamsUserAccountConnectionsQueryVariables) {
      return { query: GetTeamsUserAccountConnectionsDocument, variables: variables }
    }
export const FindEligibleMoveTeamsDocument = gql`
    query findEligibleMoveTeams($input: FindEligibleTeamsForSubstituteTransferInput!, $id: UUID!) {
  findEligibleTeamsForSubstituteTransfer(input: $input) {
    destinations {
      team {
        id
        name
        school {
          id
          logoUrl
        }
      }
      requiresTrade
      tradablePlayers {
        user {
          id
          name
          userProviderAccounts {
            id
            userId
            providerName
            providerAccountId
            providerDisplayName
            providerIntegrationType
          }
        }
      }
    }
  }
  team(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useFindEligibleMoveTeamsQuery__
 *
 * To run a query within a React component, call `useFindEligibleMoveTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindEligibleMoveTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindEligibleMoveTeamsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindEligibleMoveTeamsQuery(baseOptions: Apollo.QueryHookOptions<FindEligibleMoveTeamsQuery, FindEligibleMoveTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindEligibleMoveTeamsQuery, FindEligibleMoveTeamsQueryVariables>(FindEligibleMoveTeamsDocument, options);
      }
export function useFindEligibleMoveTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindEligibleMoveTeamsQuery, FindEligibleMoveTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindEligibleMoveTeamsQuery, FindEligibleMoveTeamsQueryVariables>(FindEligibleMoveTeamsDocument, options);
        }
export type FindEligibleMoveTeamsQueryHookResult = ReturnType<typeof useFindEligibleMoveTeamsQuery>;
export type FindEligibleMoveTeamsLazyQueryHookResult = ReturnType<typeof useFindEligibleMoveTeamsLazyQuery>;
export type FindEligibleMoveTeamsQueryResult = Apollo.QueryResult<FindEligibleMoveTeamsQuery, FindEligibleMoveTeamsQueryVariables>;
export function refetchFindEligibleMoveTeamsQuery(variables: FindEligibleMoveTeamsQueryVariables) {
      return { query: FindEligibleMoveTeamsDocument, variables: variables }
    }
export const GetAllTeamsDocument = gql`
    query getAllTeams($offset: Int, $limit: Int, $filters: TeamFiltersInput) {
  getTeams(limit: $limit, offset: $offset, filters: $filters) {
    teams {
      id
      name
      school {
        id
        name
        logoUrl
      }
      esport {
        id
        name
        slug
      }
      league {
        id
      }
      seasons {
        id
        metaseason {
          id
          name
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetAllTeamsQuery__
 *
 * To run a query within a React component, call `useGetAllTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTeamsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAllTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTeamsQuery, GetAllTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTeamsQuery, GetAllTeamsQueryVariables>(GetAllTeamsDocument, options);
      }
export function useGetAllTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTeamsQuery, GetAllTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTeamsQuery, GetAllTeamsQueryVariables>(GetAllTeamsDocument, options);
        }
export type GetAllTeamsQueryHookResult = ReturnType<typeof useGetAllTeamsQuery>;
export type GetAllTeamsLazyQueryHookResult = ReturnType<typeof useGetAllTeamsLazyQuery>;
export type GetAllTeamsQueryResult = Apollo.QueryResult<GetAllTeamsQuery, GetAllTeamsQueryVariables>;
export function refetchGetAllTeamsQuery(variables?: GetAllTeamsQueryVariables) {
      return { query: GetAllTeamsDocument, variables: variables }
    }
export const GetTeamsForScheduleMatchesWithSlotsDocument = gql`
    query getTeamsForScheduleMatchesWithSlots($teamIds: [UUID!], $minStartsAt: DateTime, $maxStartsAt: DateTime) {
  teamsByIds(ids: $teamIds) {
    id
    name
    competitionGroup
    esport {
      id
      name
      slug
      rating
    }
    school {
      id
      name
      logoUrl
    }
    slotExclusionWindows {
      id
      resourceId
      startsAt
      endsAt
    }
    seasonTeams {
      seasonId
      season {
        id
        metaseasonId
        league {
          id
          competitionGroup
          competitionModel
        }
        activePhases {
          id
          bestOf
          format
          type
          startsAt
          endsAt
          defaultSlots(minStartsAt: $minStartsAt, maxStartsAt: $maxStartsAt) {
            id
            startsAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamsForScheduleMatchesWithSlotsQuery__
 *
 * To run a query within a React component, call `useGetTeamsForScheduleMatchesWithSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsForScheduleMatchesWithSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsForScheduleMatchesWithSlotsQuery({
 *   variables: {
 *      teamIds: // value for 'teamIds'
 *      minStartsAt: // value for 'minStartsAt'
 *      maxStartsAt: // value for 'maxStartsAt'
 *   },
 * });
 */
export function useGetTeamsForScheduleMatchesWithSlotsQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamsForScheduleMatchesWithSlotsQuery, GetTeamsForScheduleMatchesWithSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsForScheduleMatchesWithSlotsQuery, GetTeamsForScheduleMatchesWithSlotsQueryVariables>(GetTeamsForScheduleMatchesWithSlotsDocument, options);
      }
export function useGetTeamsForScheduleMatchesWithSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsForScheduleMatchesWithSlotsQuery, GetTeamsForScheduleMatchesWithSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsForScheduleMatchesWithSlotsQuery, GetTeamsForScheduleMatchesWithSlotsQueryVariables>(GetTeamsForScheduleMatchesWithSlotsDocument, options);
        }
export type GetTeamsForScheduleMatchesWithSlotsQueryHookResult = ReturnType<typeof useGetTeamsForScheduleMatchesWithSlotsQuery>;
export type GetTeamsForScheduleMatchesWithSlotsLazyQueryHookResult = ReturnType<typeof useGetTeamsForScheduleMatchesWithSlotsLazyQuery>;
export type GetTeamsForScheduleMatchesWithSlotsQueryResult = Apollo.QueryResult<GetTeamsForScheduleMatchesWithSlotsQuery, GetTeamsForScheduleMatchesWithSlotsQueryVariables>;
export function refetchGetTeamsForScheduleMatchesWithSlotsQuery(variables?: GetTeamsForScheduleMatchesWithSlotsQueryVariables) {
      return { query: GetTeamsForScheduleMatchesWithSlotsDocument, variables: variables }
    }
export const GetTeamsForScheduleMatchesDocument = gql`
    query getTeamsForScheduleMatches($teamIds: [UUID!]) {
  teamsByIds(ids: $teamIds) {
    id
    name
    school {
      id
      logoUrl
    }
    slotExclusionWindows {
      id
      resourceId
      startsAt
      endsAt
    }
    esport {
      id
      name
      slug
      rating
    }
    seasons {
      id
      league {
        id
        competitionGroup
        competitionModel
      }
      activePhases {
        id
        type
        startsAt
        endsAt
        slots {
          id
          startsAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamsForScheduleMatchesQuery__
 *
 * To run a query within a React component, call `useGetTeamsForScheduleMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsForScheduleMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsForScheduleMatchesQuery({
 *   variables: {
 *      teamIds: // value for 'teamIds'
 *   },
 * });
 */
export function useGetTeamsForScheduleMatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamsForScheduleMatchesQuery, GetTeamsForScheduleMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsForScheduleMatchesQuery, GetTeamsForScheduleMatchesQueryVariables>(GetTeamsForScheduleMatchesDocument, options);
      }
export function useGetTeamsForScheduleMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsForScheduleMatchesQuery, GetTeamsForScheduleMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsForScheduleMatchesQuery, GetTeamsForScheduleMatchesQueryVariables>(GetTeamsForScheduleMatchesDocument, options);
        }
export type GetTeamsForScheduleMatchesQueryHookResult = ReturnType<typeof useGetTeamsForScheduleMatchesQuery>;
export type GetTeamsForScheduleMatchesLazyQueryHookResult = ReturnType<typeof useGetTeamsForScheduleMatchesLazyQuery>;
export type GetTeamsForScheduleMatchesQueryResult = Apollo.QueryResult<GetTeamsForScheduleMatchesQuery, GetTeamsForScheduleMatchesQueryVariables>;
export function refetchGetTeamsForScheduleMatchesQuery(variables?: GetTeamsForScheduleMatchesQueryVariables) {
      return { query: GetTeamsForScheduleMatchesDocument, variables: variables }
    }
export const GetTeamOverviewDocument = gql`
    query getTeamOverview($teamId: UUID!) {
  team(id: $teamId) {
    id
    name
    competitionGroup
    esport {
      id
      name
      slug
      rating
    }
    roster {
      id
      formats {
        teamSize
        starters {
          player {
            ...TeamPlayer
          }
        }
        substitutes {
          ...TeamPlayer
        }
      }
    }
    school {
      id
      name
      slug
      logoUrl
    }
  }
}
    ${TeamPlayerFragmentDoc}`;

/**
 * __useGetTeamOverviewQuery__
 *
 * To run a query within a React component, call `useGetTeamOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamOverviewQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetTeamOverviewQuery, GetTeamOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamOverviewQuery, GetTeamOverviewQueryVariables>(GetTeamOverviewDocument, options);
      }
export function useGetTeamOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamOverviewQuery, GetTeamOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamOverviewQuery, GetTeamOverviewQueryVariables>(GetTeamOverviewDocument, options);
        }
export type GetTeamOverviewQueryHookResult = ReturnType<typeof useGetTeamOverviewQuery>;
export type GetTeamOverviewLazyQueryHookResult = ReturnType<typeof useGetTeamOverviewLazyQuery>;
export type GetTeamOverviewQueryResult = Apollo.QueryResult<GetTeamOverviewQuery, GetTeamOverviewQueryVariables>;
export function refetchGetTeamOverviewQuery(variables: GetTeamOverviewQueryVariables) {
      return { query: GetTeamOverviewDocument, variables: variables }
    }
export const GetDecodedInviteCodeDocument = gql`
    query getDecodedInviteCode($code: String!) {
  roleInviteCodeByCode(code: $code) {
    id
    userId
    resourceId
    roleName
    resourceType
    code
  }
}
    `;

/**
 * __useGetDecodedInviteCodeQuery__
 *
 * To run a query within a React component, call `useGetDecodedInviteCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDecodedInviteCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDecodedInviteCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetDecodedInviteCodeQuery(baseOptions: Apollo.QueryHookOptions<GetDecodedInviteCodeQuery, GetDecodedInviteCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDecodedInviteCodeQuery, GetDecodedInviteCodeQueryVariables>(GetDecodedInviteCodeDocument, options);
      }
export function useGetDecodedInviteCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDecodedInviteCodeQuery, GetDecodedInviteCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDecodedInviteCodeQuery, GetDecodedInviteCodeQueryVariables>(GetDecodedInviteCodeDocument, options);
        }
export type GetDecodedInviteCodeQueryHookResult = ReturnType<typeof useGetDecodedInviteCodeQuery>;
export type GetDecodedInviteCodeLazyQueryHookResult = ReturnType<typeof useGetDecodedInviteCodeLazyQuery>;
export type GetDecodedInviteCodeQueryResult = Apollo.QueryResult<GetDecodedInviteCodeQuery, GetDecodedInviteCodeQueryVariables>;
export function refetchGetDecodedInviteCodeQuery(variables: GetDecodedInviteCodeQueryVariables) {
      return { query: GetDecodedInviteCodeDocument, variables: variables }
    }
export const FindTeamsDocument = gql`
    query findTeams($ids: [UUID!], $schoolId: UUID) {
  teamsByIdsSchoolId(ids: $ids, schoolId: $schoolId) {
    id
    name
    competitionGroup
    esportId
    esport {
      slug
    }
    school {
      logoUrl
    }
    coaches {
      id
      name
    }
  }
}
    `;

/**
 * __useFindTeamsQuery__
 *
 * To run a query within a React component, call `useFindTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTeamsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useFindTeamsQuery(baseOptions?: Apollo.QueryHookOptions<FindTeamsQuery, FindTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTeamsQuery, FindTeamsQueryVariables>(FindTeamsDocument, options);
      }
export function useFindTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTeamsQuery, FindTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTeamsQuery, FindTeamsQueryVariables>(FindTeamsDocument, options);
        }
export type FindTeamsQueryHookResult = ReturnType<typeof useFindTeamsQuery>;
export type FindTeamsLazyQueryHookResult = ReturnType<typeof useFindTeamsLazyQuery>;
export type FindTeamsQueryResult = Apollo.QueryResult<FindTeamsQuery, FindTeamsQueryVariables>;
export function refetchFindTeamsQuery(variables?: FindTeamsQueryVariables) {
      return { query: FindTeamsDocument, variables: variables }
    }
export const GetTeamEsportDetailsDocument = gql`
    query getTeamEsportDetails($teamId: UUID!) {
  team(id: $teamId) {
    esport {
      id
      name
      slug
      description
      platform
      details {
        esportId
        abbreviation
        gameType
        platforms
      }
      leagueDefaults {
        teamFormat
      }
    }
  }
}
    `;

/**
 * __useGetTeamEsportDetailsQuery__
 *
 * To run a query within a React component, call `useGetTeamEsportDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamEsportDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamEsportDetailsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamEsportDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamEsportDetailsQuery, GetTeamEsportDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamEsportDetailsQuery, GetTeamEsportDetailsQueryVariables>(GetTeamEsportDetailsDocument, options);
      }
export function useGetTeamEsportDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamEsportDetailsQuery, GetTeamEsportDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamEsportDetailsQuery, GetTeamEsportDetailsQueryVariables>(GetTeamEsportDetailsDocument, options);
        }
export type GetTeamEsportDetailsQueryHookResult = ReturnType<typeof useGetTeamEsportDetailsQuery>;
export type GetTeamEsportDetailsLazyQueryHookResult = ReturnType<typeof useGetTeamEsportDetailsLazyQuery>;
export type GetTeamEsportDetailsQueryResult = Apollo.QueryResult<GetTeamEsportDetailsQuery, GetTeamEsportDetailsQueryVariables>;
export function refetchGetTeamEsportDetailsQuery(variables: GetTeamEsportDetailsQueryVariables) {
      return { query: GetTeamEsportDetailsDocument, variables: variables }
    }
export const GetTeamInviteDetailsDocument = gql`
    query getTeamInviteDetails($teamId: UUID!, $userId: UUID!) {
  me {
    id
  }
  user(id: $userId) {
    id
    firstName
    lastName
    name
    avatarUrl
  }
  team(id: $teamId) {
    id
    name
    competitionGroup
    inviteUrl
    esport {
      id
      name
      slug
      description
      platform
      details {
        esportId
        abbreviation
        gameType
        platforms
      }
      leagueDefaults {
        teamFormat
      }
    }
    school {
      id
      name
      slug
      logoUrl
    }
    enrolledSeasons {
      id
      metaseasonId
      description
      startsAt
      endsAt
      metaseason {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetTeamInviteDetailsQuery__
 *
 * To run a query within a React component, call `useGetTeamInviteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamInviteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamInviteDetailsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetTeamInviteDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamInviteDetailsQuery, GetTeamInviteDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamInviteDetailsQuery, GetTeamInviteDetailsQueryVariables>(GetTeamInviteDetailsDocument, options);
      }
export function useGetTeamInviteDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamInviteDetailsQuery, GetTeamInviteDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamInviteDetailsQuery, GetTeamInviteDetailsQueryVariables>(GetTeamInviteDetailsDocument, options);
        }
export type GetTeamInviteDetailsQueryHookResult = ReturnType<typeof useGetTeamInviteDetailsQuery>;
export type GetTeamInviteDetailsLazyQueryHookResult = ReturnType<typeof useGetTeamInviteDetailsLazyQuery>;
export type GetTeamInviteDetailsQueryResult = Apollo.QueryResult<GetTeamInviteDetailsQuery, GetTeamInviteDetailsQueryVariables>;
export function refetchGetTeamInviteDetailsQuery(variables: GetTeamInviteDetailsQueryVariables) {
      return { query: GetTeamInviteDetailsDocument, variables: variables }
    }
export const GetTeamPhaseRecentGamesDocument = gql`
    query getTeamPhaseRecentGames($teamId: UUID!, $phaseId: UUID!) {
  team(id: $teamId) {
    id
    teamPhaseSummary(phaseId: $phaseId) {
      recentGames {
        id
        status
        placing(teamId: $teamId)
        match {
          id
          name
          week
        }
        ordinalNumber
        winningTeam {
          id
          gameId
          name
        }
        losingTeam {
          id
          gameId
          name
        }
        leagueOfLegendsTeamStats(teamId: $teamId) {
          id
          goldEarned
          eliminationRespawnRatio
          creepScore
          champions {
            id
            name
            image {
              src
            }
          }
          detail {
            bans {
              champion {
                id
                name
                image {
                  src
                }
              }
            }
          }
        }
        smiteTeamStats(teamId: $teamId) {
          id
          goldEarned
          eliminationRespawnRatio
        }
        rocketLeagueTeamStats(teamId: $teamId) {
          id
          score
          shootingPercentage
          goals
          shots
          assists
          saves
        }
      }
      recentFortniteMatches {
        id
        status
        week
        name
        scheduledStartsAt
        teamMatchStats {
          teamId
          fortniteStats {
            rank
            totalPoints
            eliminationPoints
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamPhaseRecentGamesQuery__
 *
 * To run a query within a React component, call `useGetTeamPhaseRecentGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamPhaseRecentGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamPhaseRecentGamesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useGetTeamPhaseRecentGamesQuery(baseOptions: Apollo.QueryHookOptions<GetTeamPhaseRecentGamesQuery, GetTeamPhaseRecentGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamPhaseRecentGamesQuery, GetTeamPhaseRecentGamesQueryVariables>(GetTeamPhaseRecentGamesDocument, options);
      }
export function useGetTeamPhaseRecentGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamPhaseRecentGamesQuery, GetTeamPhaseRecentGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamPhaseRecentGamesQuery, GetTeamPhaseRecentGamesQueryVariables>(GetTeamPhaseRecentGamesDocument, options);
        }
export type GetTeamPhaseRecentGamesQueryHookResult = ReturnType<typeof useGetTeamPhaseRecentGamesQuery>;
export type GetTeamPhaseRecentGamesLazyQueryHookResult = ReturnType<typeof useGetTeamPhaseRecentGamesLazyQuery>;
export type GetTeamPhaseRecentGamesQueryResult = Apollo.QueryResult<GetTeamPhaseRecentGamesQuery, GetTeamPhaseRecentGamesQueryVariables>;
export function refetchGetTeamPhaseRecentGamesQuery(variables: GetTeamPhaseRecentGamesQueryVariables) {
      return { query: GetTeamPhaseRecentGamesDocument, variables: variables }
    }
export const GetCoachSchoolTeamsDocument = gql`
    query getCoachSchoolTeams($orgId: UUID!) {
  school(id: $orgId) {
    id
    teams {
      id
      name
      enrolledSeasons {
        id
        startsAt
        endsAt
      }
      roster {
        id
        formats {
          teamSize
          starters {
            player {
              user {
                id
              }
            }
          }
        }
      }
      esport {
        id
        slug
      }
    }
  }
}
    `;

/**
 * __useGetCoachSchoolTeamsQuery__
 *
 * To run a query within a React component, call `useGetCoachSchoolTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachSchoolTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachSchoolTeamsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetCoachSchoolTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetCoachSchoolTeamsQuery, GetCoachSchoolTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachSchoolTeamsQuery, GetCoachSchoolTeamsQueryVariables>(GetCoachSchoolTeamsDocument, options);
      }
export function useGetCoachSchoolTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachSchoolTeamsQuery, GetCoachSchoolTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachSchoolTeamsQuery, GetCoachSchoolTeamsQueryVariables>(GetCoachSchoolTeamsDocument, options);
        }
export type GetCoachSchoolTeamsQueryHookResult = ReturnType<typeof useGetCoachSchoolTeamsQuery>;
export type GetCoachSchoolTeamsLazyQueryHookResult = ReturnType<typeof useGetCoachSchoolTeamsLazyQuery>;
export type GetCoachSchoolTeamsQueryResult = Apollo.QueryResult<GetCoachSchoolTeamsQuery, GetCoachSchoolTeamsQueryVariables>;
export function refetchGetCoachSchoolTeamsQuery(variables: GetCoachSchoolTeamsQueryVariables) {
      return { query: GetCoachSchoolTeamsDocument, variables: variables }
    }
export const GetTeamMembersAtNowDocument = gql`
    query getTeamMembersAtNow($teamId: UUID!) {
  team(id: $teamId) {
    id
    name
    esport {
      id
      slug
      leagueDefaults {
        teamFormat
        teamMaxSize
      }
    }
    enrolledSeasons {
      id
      metaseason {
        id
        isPromoted
        startsAt
        name
        endsAt
      }
    }
    roster {
      id
      formats {
        starters {
          player {
            user {
              id
              name
              avatarUrl
              userProviderAccounts {
                id
                userId
                providerName
                providerAccountId
                providerDisplayName
                providerIntegrationType
              }
            }
            isCaptain
          }
          position {
            id
            index
          }
        }
        substitutes {
          user {
            id
            name
            avatarUrl
            userProviderAccounts {
              id
              userId
              providerName
              providerAccountId
              providerDisplayName
              providerIntegrationType
            }
          }
          isCaptain
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamMembersAtNowQuery__
 *
 * To run a query within a React component, call `useGetTeamMembersAtNowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMembersAtNowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMembersAtNowQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamMembersAtNowQuery(baseOptions: Apollo.QueryHookOptions<GetTeamMembersAtNowQuery, GetTeamMembersAtNowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamMembersAtNowQuery, GetTeamMembersAtNowQueryVariables>(GetTeamMembersAtNowDocument, options);
      }
export function useGetTeamMembersAtNowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamMembersAtNowQuery, GetTeamMembersAtNowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamMembersAtNowQuery, GetTeamMembersAtNowQueryVariables>(GetTeamMembersAtNowDocument, options);
        }
export type GetTeamMembersAtNowQueryHookResult = ReturnType<typeof useGetTeamMembersAtNowQuery>;
export type GetTeamMembersAtNowLazyQueryHookResult = ReturnType<typeof useGetTeamMembersAtNowLazyQuery>;
export type GetTeamMembersAtNowQueryResult = Apollo.QueryResult<GetTeamMembersAtNowQuery, GetTeamMembersAtNowQueryVariables>;
export function refetchGetTeamMembersAtNowQuery(variables: GetTeamMembersAtNowQueryVariables) {
      return { query: GetTeamMembersAtNowDocument, variables: variables }
    }
export const GetMatchesForSeasonByTeamIdsDocument = gql`
    query getMatchesForSeasonByTeamIds($teamIds: [UUID!]!, $metaseasonId: UUID!, $limit: Int = 25) {
  matchesForSeasonByTeamIds(
    teamIds: $teamIds
    metaseasonId: $metaseasonId
    limit: $limit
  ) {
    id
    status
    scheduledStartsAt
    isScrimmage
    slot {
      id
      phase {
        id
      }
    }
    matchResults {
      id
      matchId
      gamesWon
      gamesLost
      gamesTied
      seriesWon
      seriesLost
      seriesTied
      placing
      team {
        id
        name
        school {
          id
          name
          logoUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetMatchesForSeasonByTeamIdsQuery__
 *
 * To run a query within a React component, call `useGetMatchesForSeasonByTeamIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchesForSeasonByTeamIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchesForSeasonByTeamIdsQuery({
 *   variables: {
 *      teamIds: // value for 'teamIds'
 *      metaseasonId: // value for 'metaseasonId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMatchesForSeasonByTeamIdsQuery(baseOptions: Apollo.QueryHookOptions<GetMatchesForSeasonByTeamIdsQuery, GetMatchesForSeasonByTeamIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchesForSeasonByTeamIdsQuery, GetMatchesForSeasonByTeamIdsQueryVariables>(GetMatchesForSeasonByTeamIdsDocument, options);
      }
export function useGetMatchesForSeasonByTeamIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchesForSeasonByTeamIdsQuery, GetMatchesForSeasonByTeamIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchesForSeasonByTeamIdsQuery, GetMatchesForSeasonByTeamIdsQueryVariables>(GetMatchesForSeasonByTeamIdsDocument, options);
        }
export type GetMatchesForSeasonByTeamIdsQueryHookResult = ReturnType<typeof useGetMatchesForSeasonByTeamIdsQuery>;
export type GetMatchesForSeasonByTeamIdsLazyQueryHookResult = ReturnType<typeof useGetMatchesForSeasonByTeamIdsLazyQuery>;
export type GetMatchesForSeasonByTeamIdsQueryResult = Apollo.QueryResult<GetMatchesForSeasonByTeamIdsQuery, GetMatchesForSeasonByTeamIdsQueryVariables>;
export function refetchGetMatchesForSeasonByTeamIdsQuery(variables: GetMatchesForSeasonByTeamIdsQueryVariables) {
      return { query: GetMatchesForSeasonByTeamIdsDocument, variables: variables }
    }
export const GetPhaseResultByTeamIdAndPhaseIdDocument = gql`
    query getPhaseResultByTeamIdAndPhaseId($teamId: UUID!, $phaseId: UUID!) {
  phaseResultByTeamIdAndPhaseId(teamId: $teamId, phaseId: $phaseId) {
    id
    gamesWon
    gamesLost
    rank
    matchStreak
  }
}
    `;

/**
 * __useGetPhaseResultByTeamIdAndPhaseIdQuery__
 *
 * To run a query within a React component, call `useGetPhaseResultByTeamIdAndPhaseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhaseResultByTeamIdAndPhaseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhaseResultByTeamIdAndPhaseIdQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      phaseId: // value for 'phaseId'
 *   },
 * });
 */
export function useGetPhaseResultByTeamIdAndPhaseIdQuery(baseOptions: Apollo.QueryHookOptions<GetPhaseResultByTeamIdAndPhaseIdQuery, GetPhaseResultByTeamIdAndPhaseIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhaseResultByTeamIdAndPhaseIdQuery, GetPhaseResultByTeamIdAndPhaseIdQueryVariables>(GetPhaseResultByTeamIdAndPhaseIdDocument, options);
      }
export function useGetPhaseResultByTeamIdAndPhaseIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhaseResultByTeamIdAndPhaseIdQuery, GetPhaseResultByTeamIdAndPhaseIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhaseResultByTeamIdAndPhaseIdQuery, GetPhaseResultByTeamIdAndPhaseIdQueryVariables>(GetPhaseResultByTeamIdAndPhaseIdDocument, options);
        }
export type GetPhaseResultByTeamIdAndPhaseIdQueryHookResult = ReturnType<typeof useGetPhaseResultByTeamIdAndPhaseIdQuery>;
export type GetPhaseResultByTeamIdAndPhaseIdLazyQueryHookResult = ReturnType<typeof useGetPhaseResultByTeamIdAndPhaseIdLazyQuery>;
export type GetPhaseResultByTeamIdAndPhaseIdQueryResult = Apollo.QueryResult<GetPhaseResultByTeamIdAndPhaseIdQuery, GetPhaseResultByTeamIdAndPhaseIdQueryVariables>;
export function refetchGetPhaseResultByTeamIdAndPhaseIdQuery(variables: GetPhaseResultByTeamIdAndPhaseIdQueryVariables) {
      return { query: GetPhaseResultByTeamIdAndPhaseIdDocument, variables: variables }
    }
export const GetTeamSeasonsDocument = gql`
    query getTeamSeasons($teamId: UUID!) {
  team(id: $teamId) {
    id
    league {
      id
      name
    }
    allSeasons {
      id
      name
    }
  }
}
    `;

/**
 * __useGetTeamSeasonsQuery__
 *
 * To run a query within a React component, call `useGetTeamSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamSeasonsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamSeasonsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamSeasonsQuery, GetTeamSeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamSeasonsQuery, GetTeamSeasonsQueryVariables>(GetTeamSeasonsDocument, options);
      }
export function useGetTeamSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamSeasonsQuery, GetTeamSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamSeasonsQuery, GetTeamSeasonsQueryVariables>(GetTeamSeasonsDocument, options);
        }
export type GetTeamSeasonsQueryHookResult = ReturnType<typeof useGetTeamSeasonsQuery>;
export type GetTeamSeasonsLazyQueryHookResult = ReturnType<typeof useGetTeamSeasonsLazyQuery>;
export type GetTeamSeasonsQueryResult = Apollo.QueryResult<GetTeamSeasonsQuery, GetTeamSeasonsQueryVariables>;
export function refetchGetTeamSeasonsQuery(variables: GetTeamSeasonsQueryVariables) {
      return { query: GetTeamSeasonsDocument, variables: variables }
    }
export const GetTeamsByUserDocument = gql`
    query getTeamsByUser($userId: UUID!) {
  user(id: $userId) {
    id
    teams {
      id
      name
      esport {
        id
        name
        slug
      }
    }
    school {
      id
      teams {
        id
        esport {
          id
          name
          slug
        }
      }
      coaches {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetTeamsByUserQuery__
 *
 * To run a query within a React component, call `useGetTeamsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetTeamsByUserQuery(baseOptions: Apollo.QueryHookOptions<GetTeamsByUserQuery, GetTeamsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsByUserQuery, GetTeamsByUserQueryVariables>(GetTeamsByUserDocument, options);
      }
export function useGetTeamsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsByUserQuery, GetTeamsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsByUserQuery, GetTeamsByUserQueryVariables>(GetTeamsByUserDocument, options);
        }
export type GetTeamsByUserQueryHookResult = ReturnType<typeof useGetTeamsByUserQuery>;
export type GetTeamsByUserLazyQueryHookResult = ReturnType<typeof useGetTeamsByUserLazyQuery>;
export type GetTeamsByUserQueryResult = Apollo.QueryResult<GetTeamsByUserQuery, GetTeamsByUserQueryVariables>;
export function refetchGetTeamsByUserQuery(variables: GetTeamsByUserQueryVariables) {
      return { query: GetTeamsByUserDocument, variables: variables }
    }
export const GetTeamsLeaguesTableDocument = gql`
    query getTeamsLeaguesTable($input: FindTeamsInSeasonInput!, $isStadium: Boolean!, $seasonId: UUID!) {
  findTeamsInSeason(input: $input) {
    teams {
      ...LeagueTeam
    }
    totalCount
  }
}
    ${LeagueTeamFragmentDoc}`;

/**
 * __useGetTeamsLeaguesTableQuery__
 *
 * To run a query within a React component, call `useGetTeamsLeaguesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsLeaguesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsLeaguesTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *      isStadium: // value for 'isStadium'
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useGetTeamsLeaguesTableQuery(baseOptions: Apollo.QueryHookOptions<GetTeamsLeaguesTableQuery, GetTeamsLeaguesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsLeaguesTableQuery, GetTeamsLeaguesTableQueryVariables>(GetTeamsLeaguesTableDocument, options);
      }
export function useGetTeamsLeaguesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsLeaguesTableQuery, GetTeamsLeaguesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsLeaguesTableQuery, GetTeamsLeaguesTableQueryVariables>(GetTeamsLeaguesTableDocument, options);
        }
export type GetTeamsLeaguesTableQueryHookResult = ReturnType<typeof useGetTeamsLeaguesTableQuery>;
export type GetTeamsLeaguesTableLazyQueryHookResult = ReturnType<typeof useGetTeamsLeaguesTableLazyQuery>;
export type GetTeamsLeaguesTableQueryResult = Apollo.QueryResult<GetTeamsLeaguesTableQuery, GetTeamsLeaguesTableQueryVariables>;
export function refetchGetTeamsLeaguesTableQuery(variables: GetTeamsLeaguesTableQueryVariables) {
      return { query: GetTeamsLeaguesTableDocument, variables: variables }
    }
export const GetTeamInfoDocument = gql`
    query getTeamInfo($id: UUID!) {
  team(id: $id) {
    id
    name
    competitionGroup
    school {
      id
      name
    }
    esport {
      id
      name
      slug
    }
    leagues {
      id
      seasons {
        id
        metaseasonId
        name
        rostersLockAt
        teamRegistrationEndsAt
        phases {
          id
          startsAt
          endsAt
          name
          type
          seasonId
          status
          format
          survivalAdvancementPercentage
          survivalAdvancementCount
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamInfoQuery__
 *
 * To run a query within a React component, call `useGetTeamInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamInfoQuery(baseOptions: Apollo.QueryHookOptions<GetTeamInfoQuery, GetTeamInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamInfoQuery, GetTeamInfoQueryVariables>(GetTeamInfoDocument, options);
      }
export function useGetTeamInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamInfoQuery, GetTeamInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamInfoQuery, GetTeamInfoQueryVariables>(GetTeamInfoDocument, options);
        }
export type GetTeamInfoQueryHookResult = ReturnType<typeof useGetTeamInfoQuery>;
export type GetTeamInfoLazyQueryHookResult = ReturnType<typeof useGetTeamInfoLazyQuery>;
export type GetTeamInfoQueryResult = Apollo.QueryResult<GetTeamInfoQuery, GetTeamInfoQueryVariables>;
export function refetchGetTeamInfoQuery(variables: GetTeamInfoQueryVariables) {
      return { query: GetTeamInfoDocument, variables: variables }
    }
export const GetTeamUnenrollInfoDocument = gql`
    query getTeamUnenrollInfo($id: UUID!, $metaseasonId: UUID!) {
  team(id: $id) {
    id
    name
    leagues(metaseasonId: $metaseasonId) {
      id
      competitionModel
      competitionGroup
    }
    enrolledSeasons {
      id
      metaseasonId
      teamRegistrationEndsAt
    }
  }
}
    `;

/**
 * __useGetTeamUnenrollInfoQuery__
 *
 * To run a query within a React component, call `useGetTeamUnenrollInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamUnenrollInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamUnenrollInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetTeamUnenrollInfoQuery(baseOptions: Apollo.QueryHookOptions<GetTeamUnenrollInfoQuery, GetTeamUnenrollInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamUnenrollInfoQuery, GetTeamUnenrollInfoQueryVariables>(GetTeamUnenrollInfoDocument, options);
      }
export function useGetTeamUnenrollInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamUnenrollInfoQuery, GetTeamUnenrollInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamUnenrollInfoQuery, GetTeamUnenrollInfoQueryVariables>(GetTeamUnenrollInfoDocument, options);
        }
export type GetTeamUnenrollInfoQueryHookResult = ReturnType<typeof useGetTeamUnenrollInfoQuery>;
export type GetTeamUnenrollInfoLazyQueryHookResult = ReturnType<typeof useGetTeamUnenrollInfoLazyQuery>;
export type GetTeamUnenrollInfoQueryResult = Apollo.QueryResult<GetTeamUnenrollInfoQuery, GetTeamUnenrollInfoQueryVariables>;
export function refetchGetTeamUnenrollInfoQuery(variables: GetTeamUnenrollInfoQueryVariables) {
      return { query: GetTeamUnenrollInfoDocument, variables: variables }
    }
export const GetTeamDeleteInfoDocument = gql`
    query getTeamDeleteInfo($id: UUID!) {
  team(id: $id) {
    id
    name
    isFixedRoster
    competitionGroup
  }
}
    `;

/**
 * __useGetTeamDeleteInfoQuery__
 *
 * To run a query within a React component, call `useGetTeamDeleteInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamDeleteInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamDeleteInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamDeleteInfoQuery(baseOptions: Apollo.QueryHookOptions<GetTeamDeleteInfoQuery, GetTeamDeleteInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamDeleteInfoQuery, GetTeamDeleteInfoQueryVariables>(GetTeamDeleteInfoDocument, options);
      }
export function useGetTeamDeleteInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamDeleteInfoQuery, GetTeamDeleteInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamDeleteInfoQuery, GetTeamDeleteInfoQueryVariables>(GetTeamDeleteInfoDocument, options);
        }
export type GetTeamDeleteInfoQueryHookResult = ReturnType<typeof useGetTeamDeleteInfoQuery>;
export type GetTeamDeleteInfoLazyQueryHookResult = ReturnType<typeof useGetTeamDeleteInfoLazyQuery>;
export type GetTeamDeleteInfoQueryResult = Apollo.QueryResult<GetTeamDeleteInfoQuery, GetTeamDeleteInfoQueryVariables>;
export function refetchGetTeamDeleteInfoQuery(variables: GetTeamDeleteInfoQueryVariables) {
      return { query: GetTeamDeleteInfoDocument, variables: variables }
    }
export const GetTeamInfoTableDocument = gql`
    query getTeamInfoTable($id: UUID!, $metaseasonId: UUID, $hasMetaseasonId: Boolean!) {
  team(id: $id) {
    id
    name
    createdAt
    updatedAt
    createdBy
    createdByUser {
      id
      name
      avatarUrl
      roles {
        roleName
        userId
        resourceId
      }
    }
    deletedAt
    isPlayerLed
    deletedBy {
      id
      firstName
      lastName
      roles {
        roleName
        resourceId
        userId
      }
    }
    roster {
      id
      players {
        user {
          id
        }
        effectiveAt
      }
    }
    leagues(metaseasonId: $metaseasonId) @include(if: $hasMetaseasonId) {
      id
      name
      competitionModel
    }
    slotExclusionWindows {
      id
      resourceType
      resourceId
      seasonId
      startsAt
      endsAt
    }
    school {
      id
      name
      logoUrl
      city
      competitionGroup
      state
      varsityAssociations {
        name
        abbreviation
      }
    }
    esport {
      id
      name
      slug
      rating
      details {
        esportId
        abbreviation
        gameType
        assets {
          avatarLogoUrl
        }
      }
      leagueDefaults {
        teamFormat
        teamMaxSize
      }
    }
    teamHistory {
      triggeredById
      triggeredAt
      triggeredBy {
        id
        name
      }
      ... on TeamEnrollmentEvent {
        metaseason {
          id
          name
          competitionGroup
        }
        league {
          id
          displayName
          name
        }
      }
      ... on TeamUnEnrollmentEvent {
        metaseason {
          id
          name
          competitionGroup
        }
        league {
          id
          displayName
          name
        }
      }
    }
    enrolledSeasons {
      id
      metaseasonId
    }
  }
}
    `;

/**
 * __useGetTeamInfoTableQuery__
 *
 * To run a query within a React component, call `useGetTeamInfoTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamInfoTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamInfoTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *      hasMetaseasonId: // value for 'hasMetaseasonId'
 *   },
 * });
 */
export function useGetTeamInfoTableQuery(baseOptions: Apollo.QueryHookOptions<GetTeamInfoTableQuery, GetTeamInfoTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamInfoTableQuery, GetTeamInfoTableQueryVariables>(GetTeamInfoTableDocument, options);
      }
export function useGetTeamInfoTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamInfoTableQuery, GetTeamInfoTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamInfoTableQuery, GetTeamInfoTableQueryVariables>(GetTeamInfoTableDocument, options);
        }
export type GetTeamInfoTableQueryHookResult = ReturnType<typeof useGetTeamInfoTableQuery>;
export type GetTeamInfoTableLazyQueryHookResult = ReturnType<typeof useGetTeamInfoTableLazyQuery>;
export type GetTeamInfoTableQueryResult = Apollo.QueryResult<GetTeamInfoTableQuery, GetTeamInfoTableQueryVariables>;
export function refetchGetTeamInfoTableQuery(variables: GetTeamInfoTableQueryVariables) {
      return { query: GetTeamInfoTableDocument, variables: variables }
    }
export const GetTeamRecordDocument = gql`
    query getTeamRecord($id: UUID!) {
  team(id: $id) {
    id
    leagues {
      id
      varsityAssociation {
        name
      }
      seasons {
        id
        name
        metaseasonId
        startsAt
        phases {
          id
          name
          startsAt
          phaseResults {
            id
            teamId
            gamesPlayed
            gamesWon
            gamesLost
            matchesWon
            matchesLost
            matchesTied
            matchesWonByForfeit
            matchesLostByForfeit
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamRecordQuery__
 *
 * To run a query within a React component, call `useGetTeamRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamRecordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamRecordQuery(baseOptions: Apollo.QueryHookOptions<GetTeamRecordQuery, GetTeamRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamRecordQuery, GetTeamRecordQueryVariables>(GetTeamRecordDocument, options);
      }
export function useGetTeamRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamRecordQuery, GetTeamRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamRecordQuery, GetTeamRecordQueryVariables>(GetTeamRecordDocument, options);
        }
export type GetTeamRecordQueryHookResult = ReturnType<typeof useGetTeamRecordQuery>;
export type GetTeamRecordLazyQueryHookResult = ReturnType<typeof useGetTeamRecordLazyQuery>;
export type GetTeamRecordQueryResult = Apollo.QueryResult<GetTeamRecordQuery, GetTeamRecordQueryVariables>;
export function refetchGetTeamRecordQuery(variables: GetTeamRecordQueryVariables) {
      return { query: GetTeamRecordDocument, variables: variables }
    }
export const GetTeamClusterInfoDocument = gql`
    query getTeamClusterInfo($id: UUID!) {
  team(id: $id) {
    id
    name
    createdAt
    updatedAt
    schoolId
    school {
      id
      name
      logoUrl
    }
    esport {
      id
      name
      slug
    }
  }
}
    `;

/**
 * __useGetTeamClusterInfoQuery__
 *
 * To run a query within a React component, call `useGetTeamClusterInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamClusterInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamClusterInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamClusterInfoQuery(baseOptions: Apollo.QueryHookOptions<GetTeamClusterInfoQuery, GetTeamClusterInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamClusterInfoQuery, GetTeamClusterInfoQueryVariables>(GetTeamClusterInfoDocument, options);
      }
export function useGetTeamClusterInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamClusterInfoQuery, GetTeamClusterInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamClusterInfoQuery, GetTeamClusterInfoQueryVariables>(GetTeamClusterInfoDocument, options);
        }
export type GetTeamClusterInfoQueryHookResult = ReturnType<typeof useGetTeamClusterInfoQuery>;
export type GetTeamClusterInfoLazyQueryHookResult = ReturnType<typeof useGetTeamClusterInfoLazyQuery>;
export type GetTeamClusterInfoQueryResult = Apollo.QueryResult<GetTeamClusterInfoQuery, GetTeamClusterInfoQueryVariables>;
export function refetchGetTeamClusterInfoQuery(variables: GetTeamClusterInfoQueryVariables) {
      return { query: GetTeamClusterInfoDocument, variables: variables }
    }
export const FindTeamEnrollmentsByUserDocument = gql`
    query findTeamEnrollmentsByUser($schoolId: UUID!, $userId: UUID!, $effectiveAt: DateTime) {
  findTeamEnrollmentsByUser(
    input: {schoolId: $schoolId, userId: $userId, effectiveAt: $effectiveAt}
  ) {
    effectiveAt
    teamEnrollments {
      team {
        id
        name
        owners {
          id
        }
        esport {
          id
          slug
          rating
          details {
            esportId
            abbreviation
            teamMinStarterSize
          }
          rating
        }
        school {
          id
          logoUrl
        }
        roster {
          teamId
          numPlayers
        }
        competitionGroup
        enrolledSeasons {
          id
          metaseason {
            id
          }
        }
      }
      enrollableSeasons {
        id
        name
        registrationStartsAt
        suggestedRegistrationEndsAt
        teamRegistrationEndsAt
        league {
          id
          name
          displayName
          competitionModel
          competitionGroup
        }
        metaseasonId
      }
      enrolledSeasons {
        id
        name
        metaseasonId
        league {
          id
          name
          displayName
          competitionModel
          competitionGroup
        }
        teamRegistrationEndsAt
        suggestedRegistrationEndsAt
      }
      activePhaseRanks {
        phase {
          name
        }
        rank
        effectiveAt
      }
    }
  }
}
    `;

/**
 * __useFindTeamEnrollmentsByUserQuery__
 *
 * To run a query within a React component, call `useFindTeamEnrollmentsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindTeamEnrollmentsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindTeamEnrollmentsByUserQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      userId: // value for 'userId'
 *      effectiveAt: // value for 'effectiveAt'
 *   },
 * });
 */
export function useFindTeamEnrollmentsByUserQuery(baseOptions: Apollo.QueryHookOptions<FindTeamEnrollmentsByUserQuery, FindTeamEnrollmentsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindTeamEnrollmentsByUserQuery, FindTeamEnrollmentsByUserQueryVariables>(FindTeamEnrollmentsByUserDocument, options);
      }
export function useFindTeamEnrollmentsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindTeamEnrollmentsByUserQuery, FindTeamEnrollmentsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindTeamEnrollmentsByUserQuery, FindTeamEnrollmentsByUserQueryVariables>(FindTeamEnrollmentsByUserDocument, options);
        }
export type FindTeamEnrollmentsByUserQueryHookResult = ReturnType<typeof useFindTeamEnrollmentsByUserQuery>;
export type FindTeamEnrollmentsByUserLazyQueryHookResult = ReturnType<typeof useFindTeamEnrollmentsByUserLazyQuery>;
export type FindTeamEnrollmentsByUserQueryResult = Apollo.QueryResult<FindTeamEnrollmentsByUserQuery, FindTeamEnrollmentsByUserQueryVariables>;
export function refetchFindTeamEnrollmentsByUserQuery(variables: FindTeamEnrollmentsByUserQueryVariables) {
      return { query: FindTeamEnrollmentsByUserDocument, variables: variables }
    }
export const TeamsForMatchDocument = gql`
    query teamsForMatch($id: UUID!) {
  match(id: $id) {
    id
    games {
      id
      playerGameStats {
        id
        playerId
        player {
          id
          name
          avatarUrl
        }
        isKnown
        publisherAccountId
      }
    }
  }
}
    `;

/**
 * __useTeamsForMatchQuery__
 *
 * To run a query within a React component, call `useTeamsForMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsForMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsForMatchQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamsForMatchQuery(baseOptions: Apollo.QueryHookOptions<TeamsForMatchQuery, TeamsForMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsForMatchQuery, TeamsForMatchQueryVariables>(TeamsForMatchDocument, options);
      }
export function useTeamsForMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsForMatchQuery, TeamsForMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsForMatchQuery, TeamsForMatchQueryVariables>(TeamsForMatchDocument, options);
        }
export type TeamsForMatchQueryHookResult = ReturnType<typeof useTeamsForMatchQuery>;
export type TeamsForMatchLazyQueryHookResult = ReturnType<typeof useTeamsForMatchLazyQuery>;
export type TeamsForMatchQueryResult = Apollo.QueryResult<TeamsForMatchQuery, TeamsForMatchQueryVariables>;
export function refetchTeamsForMatchQuery(variables: TeamsForMatchQueryVariables) {
      return { query: TeamsForMatchDocument, variables: variables }
    }
export const TeamRosterHistoryDocument = gql`
    query teamRosterHistory($id: UUID!, $dateRange: DateRangeInput!) {
  team(id: $id) {
    id
    rosterHistory(dateRange: $dateRange) {
      triggeredById
      triggeredBy {
        id
        name
      }
      triggeredAt
      teamId
      ... on AddedToRosterEvent {
        player {
          id
          name
        }
      }
      ... on AddedToBenchEvent {
        player {
          id
          name
        }
      }
      ... on MovedToRosterEvent {
        player {
          id
          name
        }
      }
      ... on MovedToBenchEvent {
        player {
          id
          name
        }
      }
      ... on RemovedFromTeamEvent {
        player {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useTeamRosterHistoryQuery__
 *
 * To run a query within a React component, call `useTeamRosterHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamRosterHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamRosterHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useTeamRosterHistoryQuery(baseOptions: Apollo.QueryHookOptions<TeamRosterHistoryQuery, TeamRosterHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamRosterHistoryQuery, TeamRosterHistoryQueryVariables>(TeamRosterHistoryDocument, options);
      }
export function useTeamRosterHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamRosterHistoryQuery, TeamRosterHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamRosterHistoryQuery, TeamRosterHistoryQueryVariables>(TeamRosterHistoryDocument, options);
        }
export type TeamRosterHistoryQueryHookResult = ReturnType<typeof useTeamRosterHistoryQuery>;
export type TeamRosterHistoryLazyQueryHookResult = ReturnType<typeof useTeamRosterHistoryLazyQuery>;
export type TeamRosterHistoryQueryResult = Apollo.QueryResult<TeamRosterHistoryQuery, TeamRosterHistoryQueryVariables>;
export function refetchTeamRosterHistoryQuery(variables: TeamRosterHistoryQueryVariables) {
      return { query: TeamRosterHistoryDocument, variables: variables }
    }
export const GetTeamLeaguesByMetaseasonIdDocument = gql`
    query getTeamLeaguesByMetaseasonId($ids: [UUID!], $metaseasonId: UUID!) {
  teamsByIds(ids: $ids) {
    id
    name
    schoolId
    leagues(metaseasonId: $metaseasonId) {
      id
      displayName
      name
      esport {
        id
        slug
      }
      publicSlug
    }
    enrolledSeasons {
      id
      metaseasonId
    }
  }
}
    `;

/**
 * __useGetTeamLeaguesByMetaseasonIdQuery__
 *
 * To run a query within a React component, call `useGetTeamLeaguesByMetaseasonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamLeaguesByMetaseasonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamLeaguesByMetaseasonIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetTeamLeaguesByMetaseasonIdQuery(baseOptions: Apollo.QueryHookOptions<GetTeamLeaguesByMetaseasonIdQuery, GetTeamLeaguesByMetaseasonIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamLeaguesByMetaseasonIdQuery, GetTeamLeaguesByMetaseasonIdQueryVariables>(GetTeamLeaguesByMetaseasonIdDocument, options);
      }
export function useGetTeamLeaguesByMetaseasonIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamLeaguesByMetaseasonIdQuery, GetTeamLeaguesByMetaseasonIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamLeaguesByMetaseasonIdQuery, GetTeamLeaguesByMetaseasonIdQueryVariables>(GetTeamLeaguesByMetaseasonIdDocument, options);
        }
export type GetTeamLeaguesByMetaseasonIdQueryHookResult = ReturnType<typeof useGetTeamLeaguesByMetaseasonIdQuery>;
export type GetTeamLeaguesByMetaseasonIdLazyQueryHookResult = ReturnType<typeof useGetTeamLeaguesByMetaseasonIdLazyQuery>;
export type GetTeamLeaguesByMetaseasonIdQueryResult = Apollo.QueryResult<GetTeamLeaguesByMetaseasonIdQuery, GetTeamLeaguesByMetaseasonIdQueryVariables>;
export function refetchGetTeamLeaguesByMetaseasonIdQuery(variables: GetTeamLeaguesByMetaseasonIdQueryVariables) {
      return { query: GetTeamLeaguesByMetaseasonIdDocument, variables: variables }
    }
export const GetTeamsSearchDocument = gql`
    query getTeamsSearch($offset: Int, $limit: Int, $filters: TeamFiltersInput) {
  getTeams(limit: $limit, offset: $offset, filters: $filters) {
    teams {
      id
      name
      school {
        id
        name
        logoUrl
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetTeamsSearchQuery__
 *
 * To run a query within a React component, call `useGetTeamsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsSearchQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetTeamsSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamsSearchQuery, GetTeamsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsSearchQuery, GetTeamsSearchQueryVariables>(GetTeamsSearchDocument, options);
      }
export function useGetTeamsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsSearchQuery, GetTeamsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsSearchQuery, GetTeamsSearchQueryVariables>(GetTeamsSearchDocument, options);
        }
export type GetTeamsSearchQueryHookResult = ReturnType<typeof useGetTeamsSearchQuery>;
export type GetTeamsSearchLazyQueryHookResult = ReturnType<typeof useGetTeamsSearchLazyQuery>;
export type GetTeamsSearchQueryResult = Apollo.QueryResult<GetTeamsSearchQuery, GetTeamsSearchQueryVariables>;
export function refetchGetTeamsSearchQuery(variables?: GetTeamsSearchQueryVariables) {
      return { query: GetTeamsSearchDocument, variables: variables }
    }
export const GetTeamReputationDocument = gql`
    query getTeamReputation($teamId: UUID!, $seasonId: UUID!) {
  findSeasonReputationByTeamId(teamId: $teamId, seasonId: $seasonId) {
    reputations {
      id
      reputationScore
    }
  }
}
    `;

/**
 * __useGetTeamReputationQuery__
 *
 * To run a query within a React component, call `useGetTeamReputationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamReputationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamReputationQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useGetTeamReputationQuery(baseOptions: Apollo.QueryHookOptions<GetTeamReputationQuery, GetTeamReputationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamReputationQuery, GetTeamReputationQueryVariables>(GetTeamReputationDocument, options);
      }
export function useGetTeamReputationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamReputationQuery, GetTeamReputationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamReputationQuery, GetTeamReputationQueryVariables>(GetTeamReputationDocument, options);
        }
export type GetTeamReputationQueryHookResult = ReturnType<typeof useGetTeamReputationQuery>;
export type GetTeamReputationLazyQueryHookResult = ReturnType<typeof useGetTeamReputationLazyQuery>;
export type GetTeamReputationQueryResult = Apollo.QueryResult<GetTeamReputationQuery, GetTeamReputationQueryVariables>;
export function refetchGetTeamReputationQuery(variables: GetTeamReputationQueryVariables) {
      return { query: GetTeamReputationDocument, variables: variables }
    }
export const GetManagePageTeamsDocument = gql`
    query getManagePageTeams($offset: Int, $limit: Int, $filters: TeamFiltersInput) {
  getTeams(limit: $limit, offset: $offset, filters: $filters) {
    teams {
      id
      enrolledSeasons {
        id
        metaseason {
          id
          isPromoted
        }
        league {
          id
          name
        }
      }
      esport {
        id
        leagueDefaults {
          teamMaxSize
          teamFormat
        }
      }
    }
  }
}
    `;

/**
 * __useGetManagePageTeamsQuery__
 *
 * To run a query within a React component, call `useGetManagePageTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagePageTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagePageTeamsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetManagePageTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetManagePageTeamsQuery, GetManagePageTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagePageTeamsQuery, GetManagePageTeamsQueryVariables>(GetManagePageTeamsDocument, options);
      }
export function useGetManagePageTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagePageTeamsQuery, GetManagePageTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagePageTeamsQuery, GetManagePageTeamsQueryVariables>(GetManagePageTeamsDocument, options);
        }
export type GetManagePageTeamsQueryHookResult = ReturnType<typeof useGetManagePageTeamsQuery>;
export type GetManagePageTeamsLazyQueryHookResult = ReturnType<typeof useGetManagePageTeamsLazyQuery>;
export type GetManagePageTeamsQueryResult = Apollo.QueryResult<GetManagePageTeamsQuery, GetManagePageTeamsQueryVariables>;
export function refetchGetManagePageTeamsQuery(variables?: GetManagePageTeamsQueryVariables) {
      return { query: GetManagePageTeamsDocument, variables: variables }
    }
export const SetTeamReputationDocument = gql`
    mutation setTeamReputation($input: SetReputationForTeamInput!) {
  setSeasonReputationForTeam(input: $input) {
    reputations {
      id
      reputationScore
    }
  }
}
    `;
export type SetTeamReputationMutationFn = Apollo.MutationFunction<SetTeamReputationMutation, SetTeamReputationMutationVariables>;

/**
 * __useSetTeamReputationMutation__
 *
 * To run a mutation, you first call `useSetTeamReputationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeamReputationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeamReputationMutation, { data, loading, error }] = useSetTeamReputationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTeamReputationMutation(baseOptions?: Apollo.MutationHookOptions<SetTeamReputationMutation, SetTeamReputationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeamReputationMutation, SetTeamReputationMutationVariables>(SetTeamReputationDocument, options);
      }
export type SetTeamReputationMutationHookResult = ReturnType<typeof useSetTeamReputationMutation>;
export type SetTeamReputationMutationResult = Apollo.MutationResult<SetTeamReputationMutation>;
export type SetTeamReputationMutationOptions = Apollo.BaseMutationOptions<SetTeamReputationMutation, SetTeamReputationMutationVariables>;
export const GetTourDocument = gql`
    query getTour($tour: Tour!) {
  getTour(tour: $tour) {
    userId
    tour
    viewedAt
  }
}
    `;

/**
 * __useGetTourQuery__
 *
 * To run a query within a React component, call `useGetTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTourQuery({
 *   variables: {
 *      tour: // value for 'tour'
 *   },
 * });
 */
export function useGetTourQuery(baseOptions: Apollo.QueryHookOptions<GetTourQuery, GetTourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTourQuery, GetTourQueryVariables>(GetTourDocument, options);
      }
export function useGetTourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTourQuery, GetTourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTourQuery, GetTourQueryVariables>(GetTourDocument, options);
        }
export type GetTourQueryHookResult = ReturnType<typeof useGetTourQuery>;
export type GetTourLazyQueryHookResult = ReturnType<typeof useGetTourLazyQuery>;
export type GetTourQueryResult = Apollo.QueryResult<GetTourQuery, GetTourQueryVariables>;
export function refetchGetTourQuery(variables: GetTourQueryVariables) {
      return { query: GetTourDocument, variables: variables }
    }
export const SetTourViewedDocument = gql`
    mutation setTourViewed($tour: Tour!) {
  tourViewed(tour: $tour) {
    success
  }
}
    `;
export type SetTourViewedMutationFn = Apollo.MutationFunction<SetTourViewedMutation, SetTourViewedMutationVariables>;

/**
 * __useSetTourViewedMutation__
 *
 * To run a mutation, you first call `useSetTourViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTourViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTourViewedMutation, { data, loading, error }] = useSetTourViewedMutation({
 *   variables: {
 *      tour: // value for 'tour'
 *   },
 * });
 */
export function useSetTourViewedMutation(baseOptions?: Apollo.MutationHookOptions<SetTourViewedMutation, SetTourViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTourViewedMutation, SetTourViewedMutationVariables>(SetTourViewedDocument, options);
      }
export type SetTourViewedMutationHookResult = ReturnType<typeof useSetTourViewedMutation>;
export type SetTourViewedMutationResult = Apollo.MutationResult<SetTourViewedMutation>;
export type SetTourViewedMutationOptions = Apollo.BaseMutationOptions<SetTourViewedMutation, SetTourViewedMutationVariables>;
export const GetUserAttrsDocument = gql`
    query getUserAttrs($id: UUID, $metaseasonId: UUID) {
  userAttributes(id: $id) {
    id
    isParticipatingInMetaseason(metaseasonId: $metaseasonId)
    hasEverParticipated
    hasCompletedOnboardingSurvey
    hasManageTeams
  }
}
    `;

/**
 * __useGetUserAttrsQuery__
 *
 * To run a query within a React component, call `useGetUserAttrsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAttrsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAttrsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetUserAttrsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAttrsQuery, GetUserAttrsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAttrsQuery, GetUserAttrsQueryVariables>(GetUserAttrsDocument, options);
      }
export function useGetUserAttrsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAttrsQuery, GetUserAttrsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAttrsQuery, GetUserAttrsQueryVariables>(GetUserAttrsDocument, options);
        }
export type GetUserAttrsQueryHookResult = ReturnType<typeof useGetUserAttrsQuery>;
export type GetUserAttrsLazyQueryHookResult = ReturnType<typeof useGetUserAttrsLazyQuery>;
export type GetUserAttrsQueryResult = Apollo.QueryResult<GetUserAttrsQuery, GetUserAttrsQueryVariables>;
export function refetchGetUserAttrsQuery(variables?: GetUserAttrsQueryVariables) {
      return { query: GetUserAttrsDocument, variables: variables }
    }
export const MarkContentAsReadDocument = gql`
    mutation markContentAsRead($slugs: ContentSlugs!) {
  markContentAsRead(slugs: $slugs) {
    success
  }
}
    `;
export type MarkContentAsReadMutationFn = Apollo.MutationFunction<MarkContentAsReadMutation, MarkContentAsReadMutationVariables>;

/**
 * __useMarkContentAsReadMutation__
 *
 * To run a mutation, you first call `useMarkContentAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkContentAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markContentAsReadMutation, { data, loading, error }] = useMarkContentAsReadMutation({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useMarkContentAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkContentAsReadMutation, MarkContentAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkContentAsReadMutation, MarkContentAsReadMutationVariables>(MarkContentAsReadDocument, options);
      }
export type MarkContentAsReadMutationHookResult = ReturnType<typeof useMarkContentAsReadMutation>;
export type MarkContentAsReadMutationResult = Apollo.MutationResult<MarkContentAsReadMutation>;
export type MarkContentAsReadMutationOptions = Apollo.BaseMutationOptions<MarkContentAsReadMutation, MarkContentAsReadMutationVariables>;
export const UserContentDocument = gql`
    query userContent {
  me {
    id
    content {
      features {
        slug
        variant
      }
    }
  }
}
    `;

/**
 * __useUserContentQuery__
 *
 * To run a query within a React component, call `useUserContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserContentQuery(baseOptions?: Apollo.QueryHookOptions<UserContentQuery, UserContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserContentQuery, UserContentQueryVariables>(UserContentDocument, options);
      }
export function useUserContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserContentQuery, UserContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserContentQuery, UserContentQueryVariables>(UserContentDocument, options);
        }
export type UserContentQueryHookResult = ReturnType<typeof useUserContentQuery>;
export type UserContentLazyQueryHookResult = ReturnType<typeof useUserContentLazyQuery>;
export type UserContentQueryResult = Apollo.QueryResult<UserContentQuery, UserContentQueryVariables>;
export function refetchUserContentQuery(variables?: UserContentQueryVariables) {
      return { query: UserContentDocument, variables: variables }
    }
export const GetAllUserContentDocument = gql`
    query getAllUserContent {
  me {
    id
    content {
      features {
        slug
        variant
        sections {
          slug
          items {
            slug
            read
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllUserContentQuery__
 *
 * To run a query within a React component, call `useGetAllUserContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUserContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUserContentQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUserContentQuery, GetAllUserContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUserContentQuery, GetAllUserContentQueryVariables>(GetAllUserContentDocument, options);
      }
export function useGetAllUserContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUserContentQuery, GetAllUserContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUserContentQuery, GetAllUserContentQueryVariables>(GetAllUserContentDocument, options);
        }
export type GetAllUserContentQueryHookResult = ReturnType<typeof useGetAllUserContentQuery>;
export type GetAllUserContentLazyQueryHookResult = ReturnType<typeof useGetAllUserContentLazyQuery>;
export type GetAllUserContentQueryResult = Apollo.QueryResult<GetAllUserContentQuery, GetAllUserContentQueryVariables>;
export function refetchGetAllUserContentQuery(variables?: GetAllUserContentQueryVariables) {
      return { query: GetAllUserContentDocument, variables: variables }
    }
export const GetUsersEsportDocument = gql`
    query getUsersEsport($metaseasonId: UUID!) {
  me {
    id
    league(metaseasonId: $metaseasonId) {
      id
      esport {
        id
        slug
      }
    }
  }
}
    `;

/**
 * __useGetUsersEsportQuery__
 *
 * To run a query within a React component, call `useGetUsersEsportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersEsportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersEsportQuery({
 *   variables: {
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetUsersEsportQuery(baseOptions: Apollo.QueryHookOptions<GetUsersEsportQuery, GetUsersEsportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersEsportQuery, GetUsersEsportQueryVariables>(GetUsersEsportDocument, options);
      }
export function useGetUsersEsportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersEsportQuery, GetUsersEsportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersEsportQuery, GetUsersEsportQueryVariables>(GetUsersEsportDocument, options);
        }
export type GetUsersEsportQueryHookResult = ReturnType<typeof useGetUsersEsportQuery>;
export type GetUsersEsportLazyQueryHookResult = ReturnType<typeof useGetUsersEsportLazyQuery>;
export type GetUsersEsportQueryResult = Apollo.QueryResult<GetUsersEsportQuery, GetUsersEsportQueryVariables>;
export function refetchGetUsersEsportQuery(variables: GetUsersEsportQueryVariables) {
      return { query: GetUsersEsportDocument, variables: variables }
    }
export const GetReferralSchoolsDocument = gql`
    query getReferralSchools($limit: Int!) {
  getReferralSchools(limit: $limit) {
    referralSchools {
      schoolId
      school {
        name
        state
        city
        phone
        competitionGroup
      }
      referredAt
    }
  }
}
    `;

/**
 * __useGetReferralSchoolsQuery__
 *
 * To run a query within a React component, call `useGetReferralSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralSchoolsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetReferralSchoolsQuery(baseOptions: Apollo.QueryHookOptions<GetReferralSchoolsQuery, GetReferralSchoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferralSchoolsQuery, GetReferralSchoolsQueryVariables>(GetReferralSchoolsDocument, options);
      }
export function useGetReferralSchoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferralSchoolsQuery, GetReferralSchoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferralSchoolsQuery, GetReferralSchoolsQueryVariables>(GetReferralSchoolsDocument, options);
        }
export type GetReferralSchoolsQueryHookResult = ReturnType<typeof useGetReferralSchoolsQuery>;
export type GetReferralSchoolsLazyQueryHookResult = ReturnType<typeof useGetReferralSchoolsLazyQuery>;
export type GetReferralSchoolsQueryResult = Apollo.QueryResult<GetReferralSchoolsQuery, GetReferralSchoolsQueryVariables>;
export function refetchGetReferralSchoolsQuery(variables: GetReferralSchoolsQueryVariables) {
      return { query: GetReferralSchoolsDocument, variables: variables }
    }
export const CreateUserLeadDocument = gql`
    mutation createUserLead($input: UserLeadInput!) {
  createUserLead(input: $input) {
    success
  }
}
    `;
export type CreateUserLeadMutationFn = Apollo.MutationFunction<CreateUserLeadMutation, CreateUserLeadMutationVariables>;

/**
 * __useCreateUserLeadMutation__
 *
 * To run a mutation, you first call `useCreateUserLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserLeadMutation, { data, loading, error }] = useCreateUserLeadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserLeadMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserLeadMutation, CreateUserLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserLeadMutation, CreateUserLeadMutationVariables>(CreateUserLeadDocument, options);
      }
export type CreateUserLeadMutationHookResult = ReturnType<typeof useCreateUserLeadMutation>;
export type CreateUserLeadMutationResult = Apollo.MutationResult<CreateUserLeadMutation>;
export type CreateUserLeadMutationOptions = Apollo.BaseMutationOptions<CreateUserLeadMutation, CreateUserLeadMutationVariables>;
export const ReferCoachEmailDocument = gql`
    mutation referCoachEmail {
  referCoachEmail {
    success
  }
}
    `;
export type ReferCoachEmailMutationFn = Apollo.MutationFunction<ReferCoachEmailMutation, ReferCoachEmailMutationVariables>;

/**
 * __useReferCoachEmailMutation__
 *
 * To run a mutation, you first call `useReferCoachEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReferCoachEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [referCoachEmailMutation, { data, loading, error }] = useReferCoachEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useReferCoachEmailMutation(baseOptions?: Apollo.MutationHookOptions<ReferCoachEmailMutation, ReferCoachEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReferCoachEmailMutation, ReferCoachEmailMutationVariables>(ReferCoachEmailDocument, options);
      }
export type ReferCoachEmailMutationHookResult = ReturnType<typeof useReferCoachEmailMutation>;
export type ReferCoachEmailMutationResult = Apollo.MutationResult<ReferCoachEmailMutation>;
export type ReferCoachEmailMutationOptions = Apollo.BaseMutationOptions<ReferCoachEmailMutation, ReferCoachEmailMutationVariables>;
export const GetUsersOnlineStatusDocument = gql`
    query getUsersOnlineStatus($input: GetUsersOnlineStatusInput!) {
  getUsersOnlineStatus(input: $input) {
    success
    errors
    usersOnlineStatus {
      userId
      onlineStatus
    }
  }
}
    `;

/**
 * __useGetUsersOnlineStatusQuery__
 *
 * To run a query within a React component, call `useGetUsersOnlineStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersOnlineStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersOnlineStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUsersOnlineStatusQuery(baseOptions: Apollo.QueryHookOptions<GetUsersOnlineStatusQuery, GetUsersOnlineStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersOnlineStatusQuery, GetUsersOnlineStatusQueryVariables>(GetUsersOnlineStatusDocument, options);
      }
export function useGetUsersOnlineStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersOnlineStatusQuery, GetUsersOnlineStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersOnlineStatusQuery, GetUsersOnlineStatusQueryVariables>(GetUsersOnlineStatusDocument, options);
        }
export type GetUsersOnlineStatusQueryHookResult = ReturnType<typeof useGetUsersOnlineStatusQuery>;
export type GetUsersOnlineStatusLazyQueryHookResult = ReturnType<typeof useGetUsersOnlineStatusLazyQuery>;
export type GetUsersOnlineStatusQueryResult = Apollo.QueryResult<GetUsersOnlineStatusQuery, GetUsersOnlineStatusQueryVariables>;
export function refetchGetUsersOnlineStatusQuery(variables: GetUsersOnlineStatusQueryVariables) {
      return { query: GetUsersOnlineStatusDocument, variables: variables }
    }
export const GetTeamsByUserIdDocument = gql`
    query getTeamsByUserId($id: UUID!, $metaseasonId: UUID!, $isStadium: Boolean!) {
  user(id: $id) {
    id
    roles @skip(if: $isStadium) {
      roleName
      resourceId
      resourceType
      userId
    }
    schoolRoleStatus @skip(if: $isStadium) {
      role {
        userId
        roleName
        resourceType
        resourceId
      }
      status
    }
    teams(metaseasonId: $metaseasonId) {
      id
      name
      competitionGroup
      esport {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetTeamsByUserIdQuery__
 *
 * To run a query within a React component, call `useGetTeamsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *      isStadium: // value for 'isStadium'
 *   },
 * });
 */
export function useGetTeamsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetTeamsByUserIdQuery, GetTeamsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsByUserIdQuery, GetTeamsByUserIdQueryVariables>(GetTeamsByUserIdDocument, options);
      }
export function useGetTeamsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsByUserIdQuery, GetTeamsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsByUserIdQuery, GetTeamsByUserIdQueryVariables>(GetTeamsByUserIdDocument, options);
        }
export type GetTeamsByUserIdQueryHookResult = ReturnType<typeof useGetTeamsByUserIdQuery>;
export type GetTeamsByUserIdLazyQueryHookResult = ReturnType<typeof useGetTeamsByUserIdLazyQuery>;
export type GetTeamsByUserIdQueryResult = Apollo.QueryResult<GetTeamsByUserIdQuery, GetTeamsByUserIdQueryVariables>;
export function refetchGetTeamsByUserIdQuery(variables: GetTeamsByUserIdQueryVariables) {
      return { query: GetTeamsByUserIdDocument, variables: variables }
    }
export const GetManagedTeamsByUserIdAtSchoolDocument = gql`
    query getManagedTeamsByUserIdAtSchool($id: UUID!, $schoolId: UUID!) {
  user(id: $id) {
    id
    managedTeams(schoolId: $schoolId) {
      id
      name
      competitionGroup
      esport {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetManagedTeamsByUserIdAtSchoolQuery__
 *
 * To run a query within a React component, call `useGetManagedTeamsByUserIdAtSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedTeamsByUserIdAtSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedTeamsByUserIdAtSchoolQuery({
 *   variables: {
 *      id: // value for 'id'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetManagedTeamsByUserIdAtSchoolQuery(baseOptions: Apollo.QueryHookOptions<GetManagedTeamsByUserIdAtSchoolQuery, GetManagedTeamsByUserIdAtSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagedTeamsByUserIdAtSchoolQuery, GetManagedTeamsByUserIdAtSchoolQueryVariables>(GetManagedTeamsByUserIdAtSchoolDocument, options);
      }
export function useGetManagedTeamsByUserIdAtSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagedTeamsByUserIdAtSchoolQuery, GetManagedTeamsByUserIdAtSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagedTeamsByUserIdAtSchoolQuery, GetManagedTeamsByUserIdAtSchoolQueryVariables>(GetManagedTeamsByUserIdAtSchoolDocument, options);
        }
export type GetManagedTeamsByUserIdAtSchoolQueryHookResult = ReturnType<typeof useGetManagedTeamsByUserIdAtSchoolQuery>;
export type GetManagedTeamsByUserIdAtSchoolLazyQueryHookResult = ReturnType<typeof useGetManagedTeamsByUserIdAtSchoolLazyQuery>;
export type GetManagedTeamsByUserIdAtSchoolQueryResult = Apollo.QueryResult<GetManagedTeamsByUserIdAtSchoolQuery, GetManagedTeamsByUserIdAtSchoolQueryVariables>;
export function refetchGetManagedTeamsByUserIdAtSchoolQuery(variables: GetManagedTeamsByUserIdAtSchoolQueryVariables) {
      return { query: GetManagedTeamsByUserIdAtSchoolDocument, variables: variables }
    }
export const GetUserDetailsToAddToTeamDocument = gql`
    query getUserDetailsToAddToTeam($id: UUID!, $metaseasonId: UUID!) {
  user(id: $id) {
    id
    name
    avatarUrl
    leagues(metaseasonId: $metaseasonId) {
      id
    }
    userProviderAccounts {
      id
      userId
      providerName
      providerAccountId
      providerDisplayName
      providerIntegrationType
    }
  }
}
    `;

/**
 * __useGetUserDetailsToAddToTeamQuery__
 *
 * To run a query within a React component, call `useGetUserDetailsToAddToTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDetailsToAddToTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDetailsToAddToTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useGetUserDetailsToAddToTeamQuery(baseOptions: Apollo.QueryHookOptions<GetUserDetailsToAddToTeamQuery, GetUserDetailsToAddToTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDetailsToAddToTeamQuery, GetUserDetailsToAddToTeamQueryVariables>(GetUserDetailsToAddToTeamDocument, options);
      }
export function useGetUserDetailsToAddToTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDetailsToAddToTeamQuery, GetUserDetailsToAddToTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDetailsToAddToTeamQuery, GetUserDetailsToAddToTeamQueryVariables>(GetUserDetailsToAddToTeamDocument, options);
        }
export type GetUserDetailsToAddToTeamQueryHookResult = ReturnType<typeof useGetUserDetailsToAddToTeamQuery>;
export type GetUserDetailsToAddToTeamLazyQueryHookResult = ReturnType<typeof useGetUserDetailsToAddToTeamLazyQuery>;
export type GetUserDetailsToAddToTeamQueryResult = Apollo.QueryResult<GetUserDetailsToAddToTeamQuery, GetUserDetailsToAddToTeamQueryVariables>;
export function refetchGetUserDetailsToAddToTeamQuery(variables: GetUserDetailsToAddToTeamQueryVariables) {
      return { query: GetUserDetailsToAddToTeamDocument, variables: variables }
    }
export const GetUserByRoleDocument = gql`
    query getUserByRole($role: RoleDescriptor!) {
  users(role: $role) {
    id
    name
    avatarUrl
    phone
    email
    userProviderAccounts {
      id
      userId
      providerName
      providerAccountId
      providerDisplayName
      providerIntegrationType
    }
  }
}
    `;

/**
 * __useGetUserByRoleQuery__
 *
 * To run a query within a React component, call `useGetUserByRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByRoleQuery({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetUserByRoleQuery(baseOptions: Apollo.QueryHookOptions<GetUserByRoleQuery, GetUserByRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByRoleQuery, GetUserByRoleQueryVariables>(GetUserByRoleDocument, options);
      }
export function useGetUserByRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByRoleQuery, GetUserByRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByRoleQuery, GetUserByRoleQueryVariables>(GetUserByRoleDocument, options);
        }
export type GetUserByRoleQueryHookResult = ReturnType<typeof useGetUserByRoleQuery>;
export type GetUserByRoleLazyQueryHookResult = ReturnType<typeof useGetUserByRoleLazyQuery>;
export type GetUserByRoleQueryResult = Apollo.QueryResult<GetUserByRoleQuery, GetUserByRoleQueryVariables>;
export function refetchGetUserByRoleQuery(variables: GetUserByRoleQueryVariables) {
      return { query: GetUserByRoleDocument, variables: variables }
    }
export const GetUserAccountInfoDocument = gql`
    query getUserAccountInfo($id: UUID!) {
  user(id: $id) {
    id
    schoolId
    firstName
    lastName
    dateOfBirth
    username
    name
    email
    emails {
      isSchoolEmail
      email
      isVerified
      oauthProviders {
        provider
        email
      }
    }
    banned
    gradYear
    avatarUrl
    createdAt
    updatedAt
    lastSeen
    phone
    timeZone
    state
    country
    roles {
      userId
      roleName
      resourceType
      resourceId
      status
    }
    teams {
      seasons {
        metaseason {
          competitionGroup
        }
      }
    }
    isParent
    isUnderage
    parent {
      id
      name
      avatarUrl
    }
  }
}
    `;

/**
 * __useGetUserAccountInfoQuery__
 *
 * To run a query within a React component, call `useGetUserAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccountInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserAccountInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUserAccountInfoQuery, GetUserAccountInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAccountInfoQuery, GetUserAccountInfoQueryVariables>(GetUserAccountInfoDocument, options);
      }
export function useGetUserAccountInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAccountInfoQuery, GetUserAccountInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAccountInfoQuery, GetUserAccountInfoQueryVariables>(GetUserAccountInfoDocument, options);
        }
export type GetUserAccountInfoQueryHookResult = ReturnType<typeof useGetUserAccountInfoQuery>;
export type GetUserAccountInfoLazyQueryHookResult = ReturnType<typeof useGetUserAccountInfoLazyQuery>;
export type GetUserAccountInfoQueryResult = Apollo.QueryResult<GetUserAccountInfoQuery, GetUserAccountInfoQueryVariables>;
export function refetchGetUserAccountInfoQuery(variables: GetUserAccountInfoQueryVariables) {
      return { query: GetUserAccountInfoDocument, variables: variables }
    }
export const GetTosAcceptanceDocument = gql`
    query getTosAcceptance {
  me {
    id
    tosAcceptedAt
  }
}
    `;

/**
 * __useGetTosAcceptanceQuery__
 *
 * To run a query within a React component, call `useGetTosAcceptanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTosAcceptanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTosAcceptanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTosAcceptanceQuery(baseOptions?: Apollo.QueryHookOptions<GetTosAcceptanceQuery, GetTosAcceptanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTosAcceptanceQuery, GetTosAcceptanceQueryVariables>(GetTosAcceptanceDocument, options);
      }
export function useGetTosAcceptanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTosAcceptanceQuery, GetTosAcceptanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTosAcceptanceQuery, GetTosAcceptanceQueryVariables>(GetTosAcceptanceDocument, options);
        }
export type GetTosAcceptanceQueryHookResult = ReturnType<typeof useGetTosAcceptanceQuery>;
export type GetTosAcceptanceLazyQueryHookResult = ReturnType<typeof useGetTosAcceptanceLazyQuery>;
export type GetTosAcceptanceQueryResult = Apollo.QueryResult<GetTosAcceptanceQuery, GetTosAcceptanceQueryVariables>;
export function refetchGetTosAcceptanceQuery(variables?: GetTosAcceptanceQueryVariables) {
      return { query: GetTosAcceptanceDocument, variables: variables }
    }
export const AcceptTosDocument = gql`
    mutation acceptTos {
  acceptTos
}
    `;
export type AcceptTosMutationFn = Apollo.MutationFunction<AcceptTosMutation, AcceptTosMutationVariables>;

/**
 * __useAcceptTosMutation__
 *
 * To run a mutation, you first call `useAcceptTosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTosMutation, { data, loading, error }] = useAcceptTosMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptTosMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTosMutation, AcceptTosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTosMutation, AcceptTosMutationVariables>(AcceptTosDocument, options);
      }
export type AcceptTosMutationHookResult = ReturnType<typeof useAcceptTosMutation>;
export type AcceptTosMutationResult = Apollo.MutationResult<AcceptTosMutation>;
export type AcceptTosMutationOptions = Apollo.BaseMutationOptions<AcceptTosMutation, AcceptTosMutationVariables>;
export const AcceptTosPrivacyPolicyDocument = gql`
    mutation acceptTosPrivacyPolicy($metaseasonId: UUID!, $schoolId: UUID!) {
  acceptTosPrivacyPolicy(metaseasonId: $metaseasonId, schoolId: $schoolId) {
    success
  }
}
    `;
export type AcceptTosPrivacyPolicyMutationFn = Apollo.MutationFunction<AcceptTosPrivacyPolicyMutation, AcceptTosPrivacyPolicyMutationVariables>;

/**
 * __useAcceptTosPrivacyPolicyMutation__
 *
 * To run a mutation, you first call `useAcceptTosPrivacyPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTosPrivacyPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTosPrivacyPolicyMutation, { data, loading, error }] = useAcceptTosPrivacyPolicyMutation({
 *   variables: {
 *      metaseasonId: // value for 'metaseasonId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useAcceptTosPrivacyPolicyMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTosPrivacyPolicyMutation, AcceptTosPrivacyPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTosPrivacyPolicyMutation, AcceptTosPrivacyPolicyMutationVariables>(AcceptTosPrivacyPolicyDocument, options);
      }
export type AcceptTosPrivacyPolicyMutationHookResult = ReturnType<typeof useAcceptTosPrivacyPolicyMutation>;
export type AcceptTosPrivacyPolicyMutationResult = Apollo.MutationResult<AcceptTosPrivacyPolicyMutation>;
export type AcceptTosPrivacyPolicyMutationOptions = Apollo.BaseMutationOptions<AcceptTosPrivacyPolicyMutation, AcceptTosPrivacyPolicyMutationVariables>;
export const GetSchoolByUserIdDocument = gql`
    query getSchoolByUserId($id: UUID!, $schoolId: UUID!, $hasSchoolId: Boolean!) {
  user(id: $id) {
    id
    hasScholasticTeamsAtSchool(schoolId: $schoolId) @include(if: $hasSchoolId)
    school {
      id
      deletedAt
      name
      logoUrl
      coaches {
        id
        name
      }
    }
    userValidation {
      userId
      verification {
        id
      }
    }
  }
}
    `;

/**
 * __useGetSchoolByUserIdQuery__
 *
 * To run a query within a React component, call `useGetSchoolByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolByUserIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      schoolId: // value for 'schoolId'
 *      hasSchoolId: // value for 'hasSchoolId'
 *   },
 * });
 */
export function useGetSchoolByUserIdQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolByUserIdQuery, GetSchoolByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolByUserIdQuery, GetSchoolByUserIdQueryVariables>(GetSchoolByUserIdDocument, options);
      }
export function useGetSchoolByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolByUserIdQuery, GetSchoolByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolByUserIdQuery, GetSchoolByUserIdQueryVariables>(GetSchoolByUserIdDocument, options);
        }
export type GetSchoolByUserIdQueryHookResult = ReturnType<typeof useGetSchoolByUserIdQuery>;
export type GetSchoolByUserIdLazyQueryHookResult = ReturnType<typeof useGetSchoolByUserIdLazyQuery>;
export type GetSchoolByUserIdQueryResult = Apollo.QueryResult<GetSchoolByUserIdQuery, GetSchoolByUserIdQueryVariables>;
export function refetchGetSchoolByUserIdQuery(variables: GetSchoolByUserIdQueryVariables) {
      return { query: GetSchoolByUserIdDocument, variables: variables }
    }
export const GetSchoolByUserIdBaseDocument = gql`
    query getSchoolByUserIdBase($id: UUID!) {
  user(id: $id) {
    id
    gradYears {
      gradYear
      schoolId
    }
    school {
      id
      deletedAt
    }
  }
}
    `;

/**
 * __useGetSchoolByUserIdBaseQuery__
 *
 * To run a query within a React component, call `useGetSchoolByUserIdBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolByUserIdBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolByUserIdBaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSchoolByUserIdBaseQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolByUserIdBaseQuery, GetSchoolByUserIdBaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolByUserIdBaseQuery, GetSchoolByUserIdBaseQueryVariables>(GetSchoolByUserIdBaseDocument, options);
      }
export function useGetSchoolByUserIdBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolByUserIdBaseQuery, GetSchoolByUserIdBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolByUserIdBaseQuery, GetSchoolByUserIdBaseQueryVariables>(GetSchoolByUserIdBaseDocument, options);
        }
export type GetSchoolByUserIdBaseQueryHookResult = ReturnType<typeof useGetSchoolByUserIdBaseQuery>;
export type GetSchoolByUserIdBaseLazyQueryHookResult = ReturnType<typeof useGetSchoolByUserIdBaseLazyQuery>;
export type GetSchoolByUserIdBaseQueryResult = Apollo.QueryResult<GetSchoolByUserIdBaseQuery, GetSchoolByUserIdBaseQueryVariables>;
export function refetchGetSchoolByUserIdBaseQuery(variables: GetSchoolByUserIdBaseQueryVariables) {
      return { query: GetSchoolByUserIdBaseDocument, variables: variables }
    }
export const GetSchoolTeamsByIdDocument = gql`
    query getSchoolTeamsById($id: UUID!) {
  school(id: $id) {
    id
    teams {
      ...SchoolTeam
    }
  }
}
    ${SchoolTeamFragmentDoc}`;

/**
 * __useGetSchoolTeamsByIdQuery__
 *
 * To run a query within a React component, call `useGetSchoolTeamsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolTeamsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolTeamsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSchoolTeamsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolTeamsByIdQuery, GetSchoolTeamsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolTeamsByIdQuery, GetSchoolTeamsByIdQueryVariables>(GetSchoolTeamsByIdDocument, options);
      }
export function useGetSchoolTeamsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolTeamsByIdQuery, GetSchoolTeamsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolTeamsByIdQuery, GetSchoolTeamsByIdQueryVariables>(GetSchoolTeamsByIdDocument, options);
        }
export type GetSchoolTeamsByIdQueryHookResult = ReturnType<typeof useGetSchoolTeamsByIdQuery>;
export type GetSchoolTeamsByIdLazyQueryHookResult = ReturnType<typeof useGetSchoolTeamsByIdLazyQuery>;
export type GetSchoolTeamsByIdQueryResult = Apollo.QueryResult<GetSchoolTeamsByIdQuery, GetSchoolTeamsByIdQueryVariables>;
export function refetchGetSchoolTeamsByIdQuery(variables: GetSchoolTeamsByIdQueryVariables) {
      return { query: GetSchoolTeamsByIdDocument, variables: variables }
    }
export const AddUserRoleDocument = gql`
    mutation addUserRole($userId: UUID!, $role: UserRoleName!, $resourceType: ResourceType, $resourceId: UUID) {
  addUserRole(
    userId: $userId
    role: $role
    resourceType: $resourceType
    resourceId: $resourceId
  ) {
    roleName
  }
}
    `;
export type AddUserRoleMutationFn = Apollo.MutationFunction<AddUserRoleMutation, AddUserRoleMutationVariables>;

/**
 * __useAddUserRoleMutation__
 *
 * To run a mutation, you first call `useAddUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserRoleMutation, { data, loading, error }] = useAddUserRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *      resourceType: // value for 'resourceType'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useAddUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddUserRoleMutation, AddUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserRoleMutation, AddUserRoleMutationVariables>(AddUserRoleDocument, options);
      }
export type AddUserRoleMutationHookResult = ReturnType<typeof useAddUserRoleMutation>;
export type AddUserRoleMutationResult = Apollo.MutationResult<AddUserRoleMutation>;
export type AddUserRoleMutationOptions = Apollo.BaseMutationOptions<AddUserRoleMutation, AddUserRoleMutationVariables>;
export const UpdateUserDetailsDocument = gql`
    mutation updateUserDetails($userId: UUID!, $input: SetAccountSettingsInput!) {
  setUserAccountSettings(userId: $userId, input: $input) {
    success
    userId
  }
}
    `;
export type UpdateUserDetailsMutationFn = Apollo.MutationFunction<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;

/**
 * __useUpdateUserDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailsMutation, { data, loading, error }] = useUpdateUserDetailsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>(UpdateUserDetailsDocument, options);
      }
export type UpdateUserDetailsMutationHookResult = ReturnType<typeof useUpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationResult = Apollo.MutationResult<UpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;
export const SetUserGradYearDocument = gql`
    mutation setUserGradYear($userId: UUID!, $schoolId: UUID!, $gradYear: Int!) {
  setUserGradYear(userId: $userId, schoolId: $schoolId, gradYear: $gradYear) {
    success
  }
}
    `;
export type SetUserGradYearMutationFn = Apollo.MutationFunction<SetUserGradYearMutation, SetUserGradYearMutationVariables>;

/**
 * __useSetUserGradYearMutation__
 *
 * To run a mutation, you first call `useSetUserGradYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserGradYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserGradYearMutation, { data, loading, error }] = useSetUserGradYearMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      schoolId: // value for 'schoolId'
 *      gradYear: // value for 'gradYear'
 *   },
 * });
 */
export function useSetUserGradYearMutation(baseOptions?: Apollo.MutationHookOptions<SetUserGradYearMutation, SetUserGradYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserGradYearMutation, SetUserGradYearMutationVariables>(SetUserGradYearDocument, options);
      }
export type SetUserGradYearMutationHookResult = ReturnType<typeof useSetUserGradYearMutation>;
export type SetUserGradYearMutationResult = Apollo.MutationResult<SetUserGradYearMutation>;
export type SetUserGradYearMutationOptions = Apollo.BaseMutationOptions<SetUserGradYearMutation, SetUserGradYearMutationVariables>;
export const RemoveUserFromSchoolDocument = gql`
    mutation removeUserFromSchool($input: RemoveUserFromSchoolInput!) {
  removeUserFromSchool(input: $input) {
    id
  }
}
    `;
export type RemoveUserFromSchoolMutationFn = Apollo.MutationFunction<RemoveUserFromSchoolMutation, RemoveUserFromSchoolMutationVariables>;

/**
 * __useRemoveUserFromSchoolMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromSchoolMutation, { data, loading, error }] = useRemoveUserFromSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserFromSchoolMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromSchoolMutation, RemoveUserFromSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromSchoolMutation, RemoveUserFromSchoolMutationVariables>(RemoveUserFromSchoolDocument, options);
      }
export type RemoveUserFromSchoolMutationHookResult = ReturnType<typeof useRemoveUserFromSchoolMutation>;
export type RemoveUserFromSchoolMutationResult = Apollo.MutationResult<RemoveUserFromSchoolMutation>;
export type RemoveUserFromSchoolMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromSchoolMutation, RemoveUserFromSchoolMutationVariables>;
export const RemoveUserRoleDocument = gql`
    mutation removeUserRole($userId: UUID!, $role: UserRoleName!, $resourceType: ResourceType, $resourceId: UUID) {
  removeUserRole(
    userId: $userId
    role: $role
    resourceType: $resourceType
    resourceId: $resourceId
  ) {
    userId
  }
}
    `;
export type RemoveUserRoleMutationFn = Apollo.MutationFunction<RemoveUserRoleMutation, RemoveUserRoleMutationVariables>;

/**
 * __useRemoveUserRoleMutation__
 *
 * To run a mutation, you first call `useRemoveUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserRoleMutation, { data, loading, error }] = useRemoveUserRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *      resourceType: // value for 'resourceType'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useRemoveUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserRoleMutation, RemoveUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserRoleMutation, RemoveUserRoleMutationVariables>(RemoveUserRoleDocument, options);
      }
export type RemoveUserRoleMutationHookResult = ReturnType<typeof useRemoveUserRoleMutation>;
export type RemoveUserRoleMutationResult = Apollo.MutationResult<RemoveUserRoleMutation>;
export type RemoveUserRoleMutationOptions = Apollo.BaseMutationOptions<RemoveUserRoleMutation, RemoveUserRoleMutationVariables>;
export const SetUserAccountSettingsDocument = gql`
    mutation setUserAccountSettings($userId: UUID!, $input: SetAccountSettingsInput!) {
  setUserAccountSettings(userId: $userId, input: $input) {
    success
  }
}
    `;
export type SetUserAccountSettingsMutationFn = Apollo.MutationFunction<SetUserAccountSettingsMutation, SetUserAccountSettingsMutationVariables>;

/**
 * __useSetUserAccountSettingsMutation__
 *
 * To run a mutation, you first call `useSetUserAccountSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserAccountSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserAccountSettingsMutation, { data, loading, error }] = useSetUserAccountSettingsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserAccountSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SetUserAccountSettingsMutation, SetUserAccountSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserAccountSettingsMutation, SetUserAccountSettingsMutationVariables>(SetUserAccountSettingsDocument, options);
      }
export type SetUserAccountSettingsMutationHookResult = ReturnType<typeof useSetUserAccountSettingsMutation>;
export type SetUserAccountSettingsMutationResult = Apollo.MutationResult<SetUserAccountSettingsMutation>;
export type SetUserAccountSettingsMutationOptions = Apollo.BaseMutationOptions<SetUserAccountSettingsMutation, SetUserAccountSettingsMutationVariables>;
export const GetUserResetTokenDocument = gql`
    mutation getUserResetToken($userId: UUID!) {
  getPasswordResetToken(userId: $userId)
}
    `;
export type GetUserResetTokenMutationFn = Apollo.MutationFunction<GetUserResetTokenMutation, GetUserResetTokenMutationVariables>;

/**
 * __useGetUserResetTokenMutation__
 *
 * To run a mutation, you first call `useGetUserResetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetUserResetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getUserResetTokenMutation, { data, loading, error }] = useGetUserResetTokenMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserResetTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetUserResetTokenMutation, GetUserResetTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetUserResetTokenMutation, GetUserResetTokenMutationVariables>(GetUserResetTokenDocument, options);
      }
export type GetUserResetTokenMutationHookResult = ReturnType<typeof useGetUserResetTokenMutation>;
export type GetUserResetTokenMutationResult = Apollo.MutationResult<GetUserResetTokenMutation>;
export type GetUserResetTokenMutationOptions = Apollo.BaseMutationOptions<GetUserResetTokenMutation, GetUserResetTokenMutationVariables>;
export const ResetUserForVerificationDocument = gql`
    mutation resetUserForVerification($id: UUID!, $reason: String!) {
  resetUserForVerification(id: $id, reason: $reason) {
    success
    userId
  }
}
    `;
export type ResetUserForVerificationMutationFn = Apollo.MutationFunction<ResetUserForVerificationMutation, ResetUserForVerificationMutationVariables>;

/**
 * __useResetUserForVerificationMutation__
 *
 * To run a mutation, you first call `useResetUserForVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserForVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserForVerificationMutation, { data, loading, error }] = useResetUserForVerificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useResetUserForVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserForVerificationMutation, ResetUserForVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserForVerificationMutation, ResetUserForVerificationMutationVariables>(ResetUserForVerificationDocument, options);
      }
export type ResetUserForVerificationMutationHookResult = ReturnType<typeof useResetUserForVerificationMutation>;
export type ResetUserForVerificationMutationResult = Apollo.MutationResult<ResetUserForVerificationMutation>;
export type ResetUserForVerificationMutationOptions = Apollo.BaseMutationOptions<ResetUserForVerificationMutation, ResetUserForVerificationMutationVariables>;
export const ValidateScholasticRoleDocument = gql`
    mutation validateScholasticRole($userId: UUID, $input: ValidateScholasticRoleAttributes!) {
  validateScholasticRole(userId: $userId, input: $input) {
    userId
    validationStatus
    verification {
      id
      step
      errors
    }
  }
}
    `;
export type ValidateScholasticRoleMutationFn = Apollo.MutationFunction<ValidateScholasticRoleMutation, ValidateScholasticRoleMutationVariables>;

/**
 * __useValidateScholasticRoleMutation__
 *
 * To run a mutation, you first call `useValidateScholasticRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateScholasticRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateScholasticRoleMutation, { data, loading, error }] = useValidateScholasticRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateScholasticRoleMutation(baseOptions?: Apollo.MutationHookOptions<ValidateScholasticRoleMutation, ValidateScholasticRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateScholasticRoleMutation, ValidateScholasticRoleMutationVariables>(ValidateScholasticRoleDocument, options);
      }
export type ValidateScholasticRoleMutationHookResult = ReturnType<typeof useValidateScholasticRoleMutation>;
export type ValidateScholasticRoleMutationResult = Apollo.MutationResult<ValidateScholasticRoleMutation>;
export type ValidateScholasticRoleMutationOptions = Apollo.BaseMutationOptions<ValidateScholasticRoleMutation, ValidateScholasticRoleMutationVariables>;
export const UserSeasonInfoDocument = gql`
    query userSeasonInfo($id: UUID!, $metaseasonId: UUID!) {
  user(id: $id) {
    id
    roles {
      roleName
      userId
      resourceId
    }
    leagues(metaseasonId: $metaseasonId) {
      id
    }
  }
}
    `;

/**
 * __useUserSeasonInfoQuery__
 *
 * To run a query within a React component, call `useUserSeasonInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSeasonInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSeasonInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      metaseasonId: // value for 'metaseasonId'
 *   },
 * });
 */
export function useUserSeasonInfoQuery(baseOptions: Apollo.QueryHookOptions<UserSeasonInfoQuery, UserSeasonInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSeasonInfoQuery, UserSeasonInfoQueryVariables>(UserSeasonInfoDocument, options);
      }
export function useUserSeasonInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSeasonInfoQuery, UserSeasonInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSeasonInfoQuery, UserSeasonInfoQueryVariables>(UserSeasonInfoDocument, options);
        }
export type UserSeasonInfoQueryHookResult = ReturnType<typeof useUserSeasonInfoQuery>;
export type UserSeasonInfoLazyQueryHookResult = ReturnType<typeof useUserSeasonInfoLazyQuery>;
export type UserSeasonInfoQueryResult = Apollo.QueryResult<UserSeasonInfoQuery, UserSeasonInfoQueryVariables>;
export function refetchUserSeasonInfoQuery(variables: UserSeasonInfoQueryVariables) {
      return { query: UserSeasonInfoDocument, variables: variables }
    }
export const UserSeasonPassesDocument = gql`
    query userSeasonPasses($id: UUID!) {
  user(id: $id) {
    id
    seasonPasses {
      id
      leagueId
      league {
        id
        name
      }
      redeemed
      metaseason {
        id
        name
      }
      productInstance {
        id
        acquisitionMethod
        createdAt
      }
    }
  }
}
    `;

/**
 * __useUserSeasonPassesQuery__
 *
 * To run a query within a React component, call `useUserSeasonPassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSeasonPassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSeasonPassesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserSeasonPassesQuery(baseOptions: Apollo.QueryHookOptions<UserSeasonPassesQuery, UserSeasonPassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSeasonPassesQuery, UserSeasonPassesQueryVariables>(UserSeasonPassesDocument, options);
      }
export function useUserSeasonPassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSeasonPassesQuery, UserSeasonPassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSeasonPassesQuery, UserSeasonPassesQueryVariables>(UserSeasonPassesDocument, options);
        }
export type UserSeasonPassesQueryHookResult = ReturnType<typeof useUserSeasonPassesQuery>;
export type UserSeasonPassesLazyQueryHookResult = ReturnType<typeof useUserSeasonPassesLazyQuery>;
export type UserSeasonPassesQueryResult = Apollo.QueryResult<UserSeasonPassesQuery, UserSeasonPassesQueryVariables>;
export function refetchUserSeasonPassesQuery(variables: UserSeasonPassesQueryVariables) {
      return { query: UserSeasonPassesDocument, variables: variables }
    }
export const GetAllUsersDocument = gql`
    query getAllUsers($offset: Int, $limit: Int, $filters: SearchAllUsersInput!) {
  getUsers(offset: $offset, limit: $limit, filters: $filters) {
    totalCount
    users {
      id
      avatarUrl
      name
      username
      email
      emails {
        isSchoolEmail
        email
        isVerified
      }
      phone
      roles {
        roleName
        userId
        resourceId
      }
      roleRequests {
        status
        createdAt
      }
      state
      school {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export function refetchGetAllUsersQuery(variables: GetAllUsersQueryVariables) {
      return { query: GetAllUsersDocument, variables: variables }
    }
export const GetUsersWithPendingRolesDocument = gql`
    query getUsersWithPendingRoles($offset: Int, $limit: Int, $filters: PendingUserRolesFilterInput) {
  getUsersWithPendingRoles(offset: $offset, limit: $limit, filters: $filters) {
    totalCount
    users {
      id
      avatarUrl
      name
      email
      emails {
        email
        isSchoolEmail
        isVerified
      }
      phone
      roleRequests {
        roleName
        resourceId
        resourceType
        status
        createdAt
      }
      state
      school {
        id
        name
      }
      createdAt
    }
  }
}
    `;

/**
 * __useGetUsersWithPendingRolesQuery__
 *
 * To run a query within a React component, call `useGetUsersWithPendingRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWithPendingRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWithPendingRolesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUsersWithPendingRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersWithPendingRolesQuery, GetUsersWithPendingRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersWithPendingRolesQuery, GetUsersWithPendingRolesQueryVariables>(GetUsersWithPendingRolesDocument, options);
      }
export function useGetUsersWithPendingRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersWithPendingRolesQuery, GetUsersWithPendingRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersWithPendingRolesQuery, GetUsersWithPendingRolesQueryVariables>(GetUsersWithPendingRolesDocument, options);
        }
export type GetUsersWithPendingRolesQueryHookResult = ReturnType<typeof useGetUsersWithPendingRolesQuery>;
export type GetUsersWithPendingRolesLazyQueryHookResult = ReturnType<typeof useGetUsersWithPendingRolesLazyQuery>;
export type GetUsersWithPendingRolesQueryResult = Apollo.QueryResult<GetUsersWithPendingRolesQuery, GetUsersWithPendingRolesQueryVariables>;
export function refetchGetUsersWithPendingRolesQuery(variables?: GetUsersWithPendingRolesQueryVariables) {
      return { query: GetUsersWithPendingRolesDocument, variables: variables }
    }
export const GetCxUsersDocument = gql`
    query getCxUsers($filters: SearchAllUsersInput!, $limit: Int) {
  getUsers(filters: $filters, limit: $limit) {
    totalCount
    users {
      id
      avatarUrl
      name
      roles {
        roleName
        userId
        resourceId
        resourceType
      }
    }
  }
}
    `;

/**
 * __useGetCxUsersQuery__
 *
 * To run a query within a React component, call `useGetCxUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCxUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCxUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCxUsersQuery(baseOptions: Apollo.QueryHookOptions<GetCxUsersQuery, GetCxUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCxUsersQuery, GetCxUsersQueryVariables>(GetCxUsersDocument, options);
      }
export function useGetCxUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCxUsersQuery, GetCxUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCxUsersQuery, GetCxUsersQueryVariables>(GetCxUsersDocument, options);
        }
export type GetCxUsersQueryHookResult = ReturnType<typeof useGetCxUsersQuery>;
export type GetCxUsersLazyQueryHookResult = ReturnType<typeof useGetCxUsersLazyQuery>;
export type GetCxUsersQueryResult = Apollo.QueryResult<GetCxUsersQuery, GetCxUsersQueryVariables>;
export function refetchGetCxUsersQuery(variables: GetCxUsersQueryVariables) {
      return { query: GetCxUsersDocument, variables: variables }
    }
export const BanUserDocument = gql`
    mutation banUser($userId: UUID!, $comment: String) {
  banUser(userId: $userId, comment: $comment) {
    success
    user {
      id
      banned
    }
  }
}
    `;
export type BanUserMutationFn = Apollo.MutationFunction<BanUserMutation, BanUserMutationVariables>;

/**
 * __useBanUserMutation__
 *
 * To run a mutation, you first call `useBanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banUserMutation, { data, loading, error }] = useBanUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useBanUserMutation(baseOptions?: Apollo.MutationHookOptions<BanUserMutation, BanUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BanUserMutation, BanUserMutationVariables>(BanUserDocument, options);
      }
export type BanUserMutationHookResult = ReturnType<typeof useBanUserMutation>;
export type BanUserMutationResult = Apollo.MutationResult<BanUserMutation>;
export type BanUserMutationOptions = Apollo.BaseMutationOptions<BanUserMutation, BanUserMutationVariables>;
export const UnbanUserDocument = gql`
    mutation unbanUser($userId: UUID!, $comment: String) {
  unbanUser(userId: $userId, comment: $comment) {
    success
    user {
      id
      banned
    }
  }
}
    `;
export type UnbanUserMutationFn = Apollo.MutationFunction<UnbanUserMutation, UnbanUserMutationVariables>;

/**
 * __useUnbanUserMutation__
 *
 * To run a mutation, you first call `useUnbanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnbanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unbanUserMutation, { data, loading, error }] = useUnbanUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUnbanUserMutation(baseOptions?: Apollo.MutationHookOptions<UnbanUserMutation, UnbanUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnbanUserMutation, UnbanUserMutationVariables>(UnbanUserDocument, options);
      }
export type UnbanUserMutationHookResult = ReturnType<typeof useUnbanUserMutation>;
export type UnbanUserMutationResult = Apollo.MutationResult<UnbanUserMutation>;
export type UnbanUserMutationOptions = Apollo.BaseMutationOptions<UnbanUserMutation, UnbanUserMutationVariables>;
export const GetUserTasksDocument = gql`
    query getUserTasks {
  getUserTasks {
    id
    type
    state
  }
}
    `;

/**
 * __useGetUserTasksQuery__
 *
 * To run a query within a React component, call `useGetUserTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTasksQuery, GetUserTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTasksQuery, GetUserTasksQueryVariables>(GetUserTasksDocument, options);
      }
export function useGetUserTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTasksQuery, GetUserTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTasksQuery, GetUserTasksQueryVariables>(GetUserTasksDocument, options);
        }
export type GetUserTasksQueryHookResult = ReturnType<typeof useGetUserTasksQuery>;
export type GetUserTasksLazyQueryHookResult = ReturnType<typeof useGetUserTasksLazyQuery>;
export type GetUserTasksQueryResult = Apollo.QueryResult<GetUserTasksQuery, GetUserTasksQueryVariables>;
export function refetchGetUserTasksQuery(variables?: GetUserTasksQueryVariables) {
      return { query: GetUserTasksDocument, variables: variables }
    }
export const HandbookViewedDocument = gql`
    mutation handbookViewed {
  handbookViewed {
    success
  }
}
    `;
export type HandbookViewedMutationFn = Apollo.MutationFunction<HandbookViewedMutation, HandbookViewedMutationVariables>;

/**
 * __useHandbookViewedMutation__
 *
 * To run a mutation, you first call `useHandbookViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandbookViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handbookViewedMutation, { data, loading, error }] = useHandbookViewedMutation({
 *   variables: {
 *   },
 * });
 */
export function useHandbookViewedMutation(baseOptions?: Apollo.MutationHookOptions<HandbookViewedMutation, HandbookViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandbookViewedMutation, HandbookViewedMutationVariables>(HandbookViewedDocument, options);
      }
export type HandbookViewedMutationHookResult = ReturnType<typeof useHandbookViewedMutation>;
export type HandbookViewedMutationResult = Apollo.MutationResult<HandbookViewedMutation>;
export type HandbookViewedMutationOptions = Apollo.BaseMutationOptions<HandbookViewedMutation, HandbookViewedMutationVariables>;
export const DeleteUserTaskQueueDocument = gql`
    mutation deleteUserTaskQueue {
  deleteUserTaskQueue {
    success
  }
}
    `;
export type DeleteUserTaskQueueMutationFn = Apollo.MutationFunction<DeleteUserTaskQueueMutation, DeleteUserTaskQueueMutationVariables>;

/**
 * __useDeleteUserTaskQueueMutation__
 *
 * To run a mutation, you first call `useDeleteUserTaskQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTaskQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTaskQueueMutation, { data, loading, error }] = useDeleteUserTaskQueueMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserTaskQueueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserTaskQueueMutation, DeleteUserTaskQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserTaskQueueMutation, DeleteUserTaskQueueMutationVariables>(DeleteUserTaskQueueDocument, options);
      }
export type DeleteUserTaskQueueMutationHookResult = ReturnType<typeof useDeleteUserTaskQueueMutation>;
export type DeleteUserTaskQueueMutationResult = Apollo.MutationResult<DeleteUserTaskQueueMutation>;
export type DeleteUserTaskQueueMutationOptions = Apollo.BaseMutationOptions<DeleteUserTaskQueueMutation, DeleteUserTaskQueueMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($userId: String!, $reason: String!) {
  deleteUser(userId: $userId, reason: $reason) {
    success
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const AddUserToSchoolDocument = gql`
    mutation addUserToSchool($input: AddUserToSchoolInput!) {
  addUserToSchool(input: $input) {
    success
    userId
    schoolId
  }
}
    `;
export type AddUserToSchoolMutationFn = Apollo.MutationFunction<AddUserToSchoolMutation, AddUserToSchoolMutationVariables>;

/**
 * __useAddUserToSchoolMutation__
 *
 * To run a mutation, you first call `useAddUserToSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToSchoolMutation, { data, loading, error }] = useAddUserToSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserToSchoolMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToSchoolMutation, AddUserToSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToSchoolMutation, AddUserToSchoolMutationVariables>(AddUserToSchoolDocument, options);
      }
export type AddUserToSchoolMutationHookResult = ReturnType<typeof useAddUserToSchoolMutation>;
export type AddUserToSchoolMutationResult = Apollo.MutationResult<AddUserToSchoolMutation>;
export type AddUserToSchoolMutationOptions = Apollo.BaseMutationOptions<AddUserToSchoolMutation, AddUserToSchoolMutationVariables>;
export const MoveUserToSchoolDocument = gql`
    mutation moveUserToSchool($input: MoveUserToSchoolInput!) {
  moveUserToSchool(input: $input) {
    success
    userId
    schoolId
  }
}
    `;
export type MoveUserToSchoolMutationFn = Apollo.MutationFunction<MoveUserToSchoolMutation, MoveUserToSchoolMutationVariables>;

/**
 * __useMoveUserToSchoolMutation__
 *
 * To run a mutation, you first call `useMoveUserToSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveUserToSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveUserToSchoolMutation, { data, loading, error }] = useMoveUserToSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveUserToSchoolMutation(baseOptions?: Apollo.MutationHookOptions<MoveUserToSchoolMutation, MoveUserToSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveUserToSchoolMutation, MoveUserToSchoolMutationVariables>(MoveUserToSchoolDocument, options);
      }
export type MoveUserToSchoolMutationHookResult = ReturnType<typeof useMoveUserToSchoolMutation>;
export type MoveUserToSchoolMutationResult = Apollo.MutationResult<MoveUserToSchoolMutation>;
export type MoveUserToSchoolMutationOptions = Apollo.BaseMutationOptions<MoveUserToSchoolMutation, MoveUserToSchoolMutationVariables>;
export const GetEligibleMetaseasonsForUserDocument = gql`
    query getEligibleMetaseasonsForUser($userId: UUID!) {
  eligibleMetaseasons(userId: $userId) {
    id
    name
    startsAt
  }
}
    `;

/**
 * __useGetEligibleMetaseasonsForUserQuery__
 *
 * To run a query within a React component, call `useGetEligibleMetaseasonsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibleMetaseasonsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligibleMetaseasonsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetEligibleMetaseasonsForUserQuery(baseOptions: Apollo.QueryHookOptions<GetEligibleMetaseasonsForUserQuery, GetEligibleMetaseasonsForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEligibleMetaseasonsForUserQuery, GetEligibleMetaseasonsForUserQueryVariables>(GetEligibleMetaseasonsForUserDocument, options);
      }
export function useGetEligibleMetaseasonsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEligibleMetaseasonsForUserQuery, GetEligibleMetaseasonsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEligibleMetaseasonsForUserQuery, GetEligibleMetaseasonsForUserQueryVariables>(GetEligibleMetaseasonsForUserDocument, options);
        }
export type GetEligibleMetaseasonsForUserQueryHookResult = ReturnType<typeof useGetEligibleMetaseasonsForUserQuery>;
export type GetEligibleMetaseasonsForUserLazyQueryHookResult = ReturnType<typeof useGetEligibleMetaseasonsForUserLazyQuery>;
export type GetEligibleMetaseasonsForUserQueryResult = Apollo.QueryResult<GetEligibleMetaseasonsForUserQuery, GetEligibleMetaseasonsForUserQueryVariables>;
export function refetchGetEligibleMetaseasonsForUserQuery(variables: GetEligibleMetaseasonsForUserQueryVariables) {
      return { query: GetEligibleMetaseasonsForUserDocument, variables: variables }
    }
export const GetEligibleMetaseasonsForSchoolDocument = gql`
    query getEligibleMetaseasonsForSchool($schoolId: UUID!) {
  eligibleMetaseasons(schoolId: $schoolId) {
    id
    name
    startsAt
    isPromoted
  }
}
    `;

/**
 * __useGetEligibleMetaseasonsForSchoolQuery__
 *
 * To run a query within a React component, call `useGetEligibleMetaseasonsForSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEligibleMetaseasonsForSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEligibleMetaseasonsForSchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetEligibleMetaseasonsForSchoolQuery(baseOptions: Apollo.QueryHookOptions<GetEligibleMetaseasonsForSchoolQuery, GetEligibleMetaseasonsForSchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEligibleMetaseasonsForSchoolQuery, GetEligibleMetaseasonsForSchoolQueryVariables>(GetEligibleMetaseasonsForSchoolDocument, options);
      }
export function useGetEligibleMetaseasonsForSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEligibleMetaseasonsForSchoolQuery, GetEligibleMetaseasonsForSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEligibleMetaseasonsForSchoolQuery, GetEligibleMetaseasonsForSchoolQueryVariables>(GetEligibleMetaseasonsForSchoolDocument, options);
        }
export type GetEligibleMetaseasonsForSchoolQueryHookResult = ReturnType<typeof useGetEligibleMetaseasonsForSchoolQuery>;
export type GetEligibleMetaseasonsForSchoolLazyQueryHookResult = ReturnType<typeof useGetEligibleMetaseasonsForSchoolLazyQuery>;
export type GetEligibleMetaseasonsForSchoolQueryResult = Apollo.QueryResult<GetEligibleMetaseasonsForSchoolQuery, GetEligibleMetaseasonsForSchoolQueryVariables>;
export function refetchGetEligibleMetaseasonsForSchoolQuery(variables: GetEligibleMetaseasonsForSchoolQueryVariables) {
      return { query: GetEligibleMetaseasonsForSchoolDocument, variables: variables }
    }
export const GetUserTeamsStatsDocument = gql`
    query getUserTeamsStats($userId: UUID!, $metaseasonId: UUID!, $phaseType: PhaseType!) {
  user(id: $userId) {
    id
    enrolledTeamsByMetaseasonId(metaseasonId: $metaseasonId) {
      id
      name
      leagues(metaseasonId: $metaseasonId) {
        id
        name
        displayName
        esport {
          id
          slug
        }
      }
      teamPhaseSummaryByMetaseasonAndPhaseType(
        metaseasonId: $metaseasonId
        phaseType: $phaseType
      ) {
        standings {
          matchesWon
          matchesLost
        }
        fortniteTeamRecord {
          avgPlacementPerSeason
          placementPointRank
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserTeamsStatsQuery__
 *
 * To run a query within a React component, call `useGetUserTeamsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTeamsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTeamsStatsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      metaseasonId: // value for 'metaseasonId'
 *      phaseType: // value for 'phaseType'
 *   },
 * });
 */
export function useGetUserTeamsStatsQuery(baseOptions: Apollo.QueryHookOptions<GetUserTeamsStatsQuery, GetUserTeamsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTeamsStatsQuery, GetUserTeamsStatsQueryVariables>(GetUserTeamsStatsDocument, options);
      }
export function useGetUserTeamsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTeamsStatsQuery, GetUserTeamsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTeamsStatsQuery, GetUserTeamsStatsQueryVariables>(GetUserTeamsStatsDocument, options);
        }
export type GetUserTeamsStatsQueryHookResult = ReturnType<typeof useGetUserTeamsStatsQuery>;
export type GetUserTeamsStatsLazyQueryHookResult = ReturnType<typeof useGetUserTeamsStatsLazyQuery>;
export type GetUserTeamsStatsQueryResult = Apollo.QueryResult<GetUserTeamsStatsQuery, GetUserTeamsStatsQueryVariables>;
export function refetchGetUserTeamsStatsQuery(variables: GetUserTeamsStatsQueryVariables) {
      return { query: GetUserTeamsStatsDocument, variables: variables }
    }
export const UserProfileDocument = gql`
    query userProfile($userId: UUID!) {
  user(id: $userId) {
    id
    name
    gradYear
    avatarUrl
    playerProfileSnapshot {
      matchesPlayed
      seasonsPlayed
      titlesPlayed
    }
    roles {
      resourceId
      roleName
      userId
      resourceType
    }
    school {
      id
      name
      city
      state
    }
    userProviderAccounts {
      id
      userId
      providerName
      providerAccountId
      providerDisplayName
    }
  }
}
    `;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions: Apollo.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export function refetchUserProfileQuery(variables: UserProfileQueryVariables) {
      return { query: UserProfileDocument, variables: variables }
    }
export const GetUserAwardsDocument = gql`
    query getUserAwards($userId: UUID!) {
  user(id: $userId) {
    id
    assignedWeeklyAwards {
      id
      awardWeekOption {
        startDate
        endDate
        beginningOfWeekTime
      }
    }
    assignedSeasonalAwards {
      id
      awardType {
        id
        title
        description
      }
      awardTypeId
      metaseasonId
    }
  }
}
    `;

/**
 * __useGetUserAwardsQuery__
 *
 * To run a query within a React component, call `useGetUserAwardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAwardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAwardsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserAwardsQuery(baseOptions: Apollo.QueryHookOptions<GetUserAwardsQuery, GetUserAwardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAwardsQuery, GetUserAwardsQueryVariables>(GetUserAwardsDocument, options);
      }
export function useGetUserAwardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAwardsQuery, GetUserAwardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAwardsQuery, GetUserAwardsQueryVariables>(GetUserAwardsDocument, options);
        }
export type GetUserAwardsQueryHookResult = ReturnType<typeof useGetUserAwardsQuery>;
export type GetUserAwardsLazyQueryHookResult = ReturnType<typeof useGetUserAwardsLazyQuery>;
export type GetUserAwardsQueryResult = Apollo.QueryResult<GetUserAwardsQuery, GetUserAwardsQueryVariables>;
export function refetchGetUserAwardsQuery(variables: GetUserAwardsQueryVariables) {
      return { query: GetUserAwardsDocument, variables: variables }
    }
export const UpdateSpinAccountDocument = gql`
    mutation updateSpinAccount {
  updateSpinAccount {
    success
  }
}
    `;
export type UpdateSpinAccountMutationFn = Apollo.MutationFunction<UpdateSpinAccountMutation, UpdateSpinAccountMutationVariables>;

/**
 * __useUpdateSpinAccountMutation__
 *
 * To run a mutation, you first call `useUpdateSpinAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpinAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpinAccountMutation, { data, loading, error }] = useUpdateSpinAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateSpinAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpinAccountMutation, UpdateSpinAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpinAccountMutation, UpdateSpinAccountMutationVariables>(UpdateSpinAccountDocument, options);
      }
export type UpdateSpinAccountMutationHookResult = ReturnType<typeof useUpdateSpinAccountMutation>;
export type UpdateSpinAccountMutationResult = Apollo.MutationResult<UpdateSpinAccountMutation>;
export type UpdateSpinAccountMutationOptions = Apollo.BaseMutationOptions<UpdateSpinAccountMutation, UpdateSpinAccountMutationVariables>;
export const SendParentVerificationEmailDocument = gql`
    mutation sendParentVerificationEmail {
  sendParentVerificationEmail {
    success
  }
}
    `;
export type SendParentVerificationEmailMutationFn = Apollo.MutationFunction<SendParentVerificationEmailMutation, SendParentVerificationEmailMutationVariables>;

/**
 * __useSendParentVerificationEmailMutation__
 *
 * To run a mutation, you first call `useSendParentVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendParentVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendParentVerificationEmailMutation, { data, loading, error }] = useSendParentVerificationEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendParentVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendParentVerificationEmailMutation, SendParentVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendParentVerificationEmailMutation, SendParentVerificationEmailMutationVariables>(SendParentVerificationEmailDocument, options);
      }
export type SendParentVerificationEmailMutationHookResult = ReturnType<typeof useSendParentVerificationEmailMutation>;
export type SendParentVerificationEmailMutationResult = Apollo.MutationResult<SendParentVerificationEmailMutation>;
export type SendParentVerificationEmailMutationOptions = Apollo.BaseMutationOptions<SendParentVerificationEmailMutation, SendParentVerificationEmailMutationVariables>;
export const RequestEmailVerificationDocument = gql`
    mutation requestEmailVerification($input: RequestEmailVerificationInput!) {
  requestEmailVerification(input: $input) {
    success
  }
}
    `;
export type RequestEmailVerificationMutationFn = Apollo.MutationFunction<RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables>;

/**
 * __useRequestEmailVerificationMutation__
 *
 * To run a mutation, you first call `useRequestEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailVerificationMutation, { data, loading, error }] = useRequestEmailVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables>(RequestEmailVerificationDocument, options);
      }
export type RequestEmailVerificationMutationHookResult = ReturnType<typeof useRequestEmailVerificationMutation>;
export type RequestEmailVerificationMutationResult = Apollo.MutationResult<RequestEmailVerificationMutation>;
export type RequestEmailVerificationMutationOptions = Apollo.BaseMutationOptions<RequestEmailVerificationMutation, RequestEmailVerificationMutationVariables>;
export const StartPhoneVerificationDocument = gql`
    mutation startPhoneVerification($phone: String!) {
  startPhoneVerification(phone: $phone) {
    success
  }
}
    `;
export type StartPhoneVerificationMutationFn = Apollo.MutationFunction<StartPhoneVerificationMutation, StartPhoneVerificationMutationVariables>;

/**
 * __useStartPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useStartPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPhoneVerificationMutation, { data, loading, error }] = useStartPhoneVerificationMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useStartPhoneVerificationMutation(baseOptions?: Apollo.MutationHookOptions<StartPhoneVerificationMutation, StartPhoneVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPhoneVerificationMutation, StartPhoneVerificationMutationVariables>(StartPhoneVerificationDocument, options);
      }
export type StartPhoneVerificationMutationHookResult = ReturnType<typeof useStartPhoneVerificationMutation>;
export type StartPhoneVerificationMutationResult = Apollo.MutationResult<StartPhoneVerificationMutation>;
export type StartPhoneVerificationMutationOptions = Apollo.BaseMutationOptions<StartPhoneVerificationMutation, StartPhoneVerificationMutationVariables>;
export const ConfirmPhoneVerificationDocument = gql`
    mutation confirmPhoneVerification($code: String!) {
  confirmPhoneVerification(code: $code) {
    success
  }
}
    `;
export type ConfirmPhoneVerificationMutationFn = Apollo.MutationFunction<ConfirmPhoneVerificationMutation, ConfirmPhoneVerificationMutationVariables>;

/**
 * __useConfirmPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useConfirmPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPhoneVerificationMutation, { data, loading, error }] = useConfirmPhoneVerificationMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConfirmPhoneVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPhoneVerificationMutation, ConfirmPhoneVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmPhoneVerificationMutation, ConfirmPhoneVerificationMutationVariables>(ConfirmPhoneVerificationDocument, options);
      }
export type ConfirmPhoneVerificationMutationHookResult = ReturnType<typeof useConfirmPhoneVerificationMutation>;
export type ConfirmPhoneVerificationMutationResult = Apollo.MutationResult<ConfirmPhoneVerificationMutation>;
export type ConfirmPhoneVerificationMutationOptions = Apollo.BaseMutationOptions<ConfirmPhoneVerificationMutation, ConfirmPhoneVerificationMutationVariables>;
export const GetVarsityAssociationsDocument = gql`
    query getVarsityAssociations($input: GetVarsityAssociationsInput!) {
  getVarsityAssociations(input: $input) {
    total
    result {
      name
      abbreviation
      state
      slug
      competitionGroup
    }
  }
}
    `;

/**
 * __useGetVarsityAssociationsQuery__
 *
 * To run a query within a React component, call `useGetVarsityAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVarsityAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVarsityAssociationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVarsityAssociationsQuery(baseOptions: Apollo.QueryHookOptions<GetVarsityAssociationsQuery, GetVarsityAssociationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVarsityAssociationsQuery, GetVarsityAssociationsQueryVariables>(GetVarsityAssociationsDocument, options);
      }
export function useGetVarsityAssociationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVarsityAssociationsQuery, GetVarsityAssociationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVarsityAssociationsQuery, GetVarsityAssociationsQueryVariables>(GetVarsityAssociationsDocument, options);
        }
export type GetVarsityAssociationsQueryHookResult = ReturnType<typeof useGetVarsityAssociationsQuery>;
export type GetVarsityAssociationsLazyQueryHookResult = ReturnType<typeof useGetVarsityAssociationsLazyQuery>;
export type GetVarsityAssociationsQueryResult = Apollo.QueryResult<GetVarsityAssociationsQuery, GetVarsityAssociationsQueryVariables>;
export function refetchGetVarsityAssociationsQuery(variables: GetVarsityAssociationsQueryVariables) {
      return { query: GetVarsityAssociationsDocument, variables: variables }
    }
export const CreateVarsityAssociationDocument = gql`
    mutation createVarsityAssociation($input: CreateVarsityAssociationAttributes!) {
  createVarsityAssociation(attributes: $input) {
    slug
    name
    abbreviation
    state
    competitionGroup
  }
}
    `;
export type CreateVarsityAssociationMutationFn = Apollo.MutationFunction<CreateVarsityAssociationMutation, CreateVarsityAssociationMutationVariables>;

/**
 * __useCreateVarsityAssociationMutation__
 *
 * To run a mutation, you first call `useCreateVarsityAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVarsityAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVarsityAssociationMutation, { data, loading, error }] = useCreateVarsityAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVarsityAssociationMutation(baseOptions?: Apollo.MutationHookOptions<CreateVarsityAssociationMutation, CreateVarsityAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVarsityAssociationMutation, CreateVarsityAssociationMutationVariables>(CreateVarsityAssociationDocument, options);
      }
export type CreateVarsityAssociationMutationHookResult = ReturnType<typeof useCreateVarsityAssociationMutation>;
export type CreateVarsityAssociationMutationResult = Apollo.MutationResult<CreateVarsityAssociationMutation>;
export type CreateVarsityAssociationMutationOptions = Apollo.BaseMutationOptions<CreateVarsityAssociationMutation, CreateVarsityAssociationMutationVariables>;
export const UpdateVarsityAssociationDocument = gql`
    mutation updateVarsityAssociation($slug: String!, $input: UpdateVarsityAssociationInput!) {
  updateVarsityAssociation(slug: $slug, input: $input) {
    slug
    name
    abbreviation
    state
    competitionGroup
  }
}
    `;
export type UpdateVarsityAssociationMutationFn = Apollo.MutationFunction<UpdateVarsityAssociationMutation, UpdateVarsityAssociationMutationVariables>;

/**
 * __useUpdateVarsityAssociationMutation__
 *
 * To run a mutation, you first call `useUpdateVarsityAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVarsityAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVarsityAssociationMutation, { data, loading, error }] = useUpdateVarsityAssociationMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVarsityAssociationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVarsityAssociationMutation, UpdateVarsityAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVarsityAssociationMutation, UpdateVarsityAssociationMutationVariables>(UpdateVarsityAssociationDocument, options);
      }
export type UpdateVarsityAssociationMutationHookResult = ReturnType<typeof useUpdateVarsityAssociationMutation>;
export type UpdateVarsityAssociationMutationResult = Apollo.MutationResult<UpdateVarsityAssociationMutation>;
export type UpdateVarsityAssociationMutationOptions = Apollo.BaseMutationOptions<UpdateVarsityAssociationMutation, UpdateVarsityAssociationMutationVariables>;
export const GetVarsityAssociationDocument = gql`
    query getVarsityAssociation($slug: String!) {
  getVarsityAssociationBySlug(slug: $slug) {
    name
    slug
    competitionGroup
    enrolledSchoolsCount
    abbreviation
    state
  }
}
    `;

/**
 * __useGetVarsityAssociationQuery__
 *
 * To run a query within a React component, call `useGetVarsityAssociationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVarsityAssociationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVarsityAssociationQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetVarsityAssociationQuery(baseOptions: Apollo.QueryHookOptions<GetVarsityAssociationQuery, GetVarsityAssociationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVarsityAssociationQuery, GetVarsityAssociationQueryVariables>(GetVarsityAssociationDocument, options);
      }
export function useGetVarsityAssociationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVarsityAssociationQuery, GetVarsityAssociationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVarsityAssociationQuery, GetVarsityAssociationQueryVariables>(GetVarsityAssociationDocument, options);
        }
export type GetVarsityAssociationQueryHookResult = ReturnType<typeof useGetVarsityAssociationQuery>;
export type GetVarsityAssociationLazyQueryHookResult = ReturnType<typeof useGetVarsityAssociationLazyQuery>;
export type GetVarsityAssociationQueryResult = Apollo.QueryResult<GetVarsityAssociationQuery, GetVarsityAssociationQueryVariables>;
export function refetchGetVarsityAssociationQuery(variables: GetVarsityAssociationQueryVariables) {
      return { query: GetVarsityAssociationDocument, variables: variables }
    }
export const AddSchoolsToVarsityAssociationDocument = gql`
    mutation addSchoolsToVarsityAssociation($input: AddSchoolsToVarsityAssociationInput!) {
  addSchoolsToVarsityAssociation(input: $input) {
    jobId
  }
}
    `;
export type AddSchoolsToVarsityAssociationMutationFn = Apollo.MutationFunction<AddSchoolsToVarsityAssociationMutation, AddSchoolsToVarsityAssociationMutationVariables>;

/**
 * __useAddSchoolsToVarsityAssociationMutation__
 *
 * To run a mutation, you first call `useAddSchoolsToVarsityAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSchoolsToVarsityAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSchoolsToVarsityAssociationMutation, { data, loading, error }] = useAddSchoolsToVarsityAssociationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSchoolsToVarsityAssociationMutation(baseOptions?: Apollo.MutationHookOptions<AddSchoolsToVarsityAssociationMutation, AddSchoolsToVarsityAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSchoolsToVarsityAssociationMutation, AddSchoolsToVarsityAssociationMutationVariables>(AddSchoolsToVarsityAssociationDocument, options);
      }
export type AddSchoolsToVarsityAssociationMutationHookResult = ReturnType<typeof useAddSchoolsToVarsityAssociationMutation>;
export type AddSchoolsToVarsityAssociationMutationResult = Apollo.MutationResult<AddSchoolsToVarsityAssociationMutation>;
export type AddSchoolsToVarsityAssociationMutationOptions = Apollo.BaseMutationOptions<AddSchoolsToVarsityAssociationMutation, AddSchoolsToVarsityAssociationMutationVariables>;